import {
  require_get
} from "./chunk-O4PJFSPJ.js";
import {
  require_camelcase
} from "./chunk-DZIKNQT5.js";
import {
  require_arrayPush,
  require_baseKeys,
  require_getTag,
  require_isArguments,
  require_isArrayLike,
  require_isBuffer,
  require_isEqual,
  require_isPrototype,
  require_isTypedArray
} from "./chunk-5G5NRCK2.js";
import {
  require_Symbol,
  require_isArray
} from "./chunk-3N3MIKLS.js";
import {
  __commonJS,
  __esm,
  __export,
  __require,
  __toCommonJS,
  __toESM
} from "./chunk-TFWDKVI3.js";

// node_modules/zen-observable/lib/Observable.js
var require_Observable = __commonJS({
  "node_modules/zen-observable/lib/Observable.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.Observable = void 0;
    function _classCallCheck2(instance2, Constructor) {
      if (!(instance2 instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _defineProperties3(target, props) {
      for (var i2 = 0; i2 < props.length; i2++) {
        var descriptor = props[i2];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor)
          descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    function _createClass3(Constructor, protoProps, staticProps) {
      if (protoProps)
        _defineProperties3(Constructor.prototype, protoProps);
      if (staticProps)
        _defineProperties3(Constructor, staticProps);
      return Constructor;
    }
    var hasSymbols = function() {
      return typeof Symbol === "function";
    };
    var hasSymbol2 = function(name) {
      return hasSymbols() && Boolean(Symbol[name]);
    };
    var getSymbol = function(name) {
      return hasSymbol2(name) ? Symbol[name] : "@@" + name;
    };
    if (hasSymbols() && !hasSymbol2("observable")) {
      Symbol.observable = Symbol("observable");
    }
    var SymbolIterator = getSymbol("iterator");
    var SymbolObservable = getSymbol("observable");
    var SymbolSpecies = getSymbol("species");
    function getMethod2(obj, key) {
      var value = obj[key];
      if (value == null)
        return void 0;
      if (typeof value !== "function")
        throw new TypeError(value + " is not a function");
      return value;
    }
    function getSpecies(obj) {
      var ctor = obj.constructor;
      if (ctor !== void 0) {
        ctor = ctor[SymbolSpecies];
        if (ctor === null) {
          ctor = void 0;
        }
      }
      return ctor !== void 0 ? ctor : Observable2;
    }
    function isObservable(x2) {
      return x2 instanceof Observable2;
    }
    function hostReportError(e) {
      if (hostReportError.log) {
        hostReportError.log(e);
      } else {
        setTimeout(function() {
          throw e;
        });
      }
    }
    function enqueue(fn2) {
      Promise.resolve().then(function() {
        try {
          fn2();
        } catch (e) {
          hostReportError(e);
        }
      });
    }
    function cleanupSubscription(subscription) {
      var cleanup = subscription._cleanup;
      if (cleanup === void 0)
        return;
      subscription._cleanup = void 0;
      if (!cleanup) {
        return;
      }
      try {
        if (typeof cleanup === "function") {
          cleanup();
        } else {
          var unsubscribe = getMethod2(cleanup, "unsubscribe");
          if (unsubscribe) {
            unsubscribe.call(cleanup);
          }
        }
      } catch (e) {
        hostReportError(e);
      }
    }
    function closeSubscription(subscription) {
      subscription._observer = void 0;
      subscription._queue = void 0;
      subscription._state = "closed";
    }
    function flushSubscription(subscription) {
      var queue = subscription._queue;
      if (!queue) {
        return;
      }
      subscription._queue = void 0;
      subscription._state = "ready";
      for (var i2 = 0; i2 < queue.length; ++i2) {
        notifySubscription(subscription, queue[i2].type, queue[i2].value);
        if (subscription._state === "closed")
          break;
      }
    }
    function notifySubscription(subscription, type, value) {
      subscription._state = "running";
      var observer = subscription._observer;
      try {
        var m2 = getMethod2(observer, type);
        switch (type) {
          case "next":
            if (m2)
              m2.call(observer, value);
            break;
          case "error":
            closeSubscription(subscription);
            if (m2)
              m2.call(observer, value);
            else
              throw value;
            break;
          case "complete":
            closeSubscription(subscription);
            if (m2)
              m2.call(observer);
            break;
        }
      } catch (e) {
        hostReportError(e);
      }
      if (subscription._state === "closed")
        cleanupSubscription(subscription);
      else if (subscription._state === "running")
        subscription._state = "ready";
    }
    function onNotify(subscription, type, value) {
      if (subscription._state === "closed")
        return;
      if (subscription._state === "buffering") {
        subscription._queue.push({
          type,
          value
        });
        return;
      }
      if (subscription._state !== "ready") {
        subscription._state = "buffering";
        subscription._queue = [{
          type,
          value
        }];
        enqueue(function() {
          return flushSubscription(subscription);
        });
        return;
      }
      notifySubscription(subscription, type, value);
    }
    var Subscription = /* @__PURE__ */ function() {
      function Subscription2(observer, subscriber) {
        _classCallCheck2(this, Subscription2);
        this._cleanup = void 0;
        this._observer = observer;
        this._queue = void 0;
        this._state = "initializing";
        var subscriptionObserver = new SubscriptionObserver(this);
        try {
          this._cleanup = subscriber.call(void 0, subscriptionObserver);
        } catch (e) {
          subscriptionObserver.error(e);
        }
        if (this._state === "initializing")
          this._state = "ready";
      }
      _createClass3(Subscription2, [{
        key: "unsubscribe",
        value: function unsubscribe() {
          if (this._state !== "closed") {
            closeSubscription(this);
            cleanupSubscription(this);
          }
        }
      }, {
        key: "closed",
        get: function() {
          return this._state === "closed";
        }
      }]);
      return Subscription2;
    }();
    var SubscriptionObserver = /* @__PURE__ */ function() {
      function SubscriptionObserver2(subscription) {
        _classCallCheck2(this, SubscriptionObserver2);
        this._subscription = subscription;
      }
      _createClass3(SubscriptionObserver2, [{
        key: "next",
        value: function next(value) {
          onNotify(this._subscription, "next", value);
        }
      }, {
        key: "error",
        value: function error(value) {
          onNotify(this._subscription, "error", value);
        }
      }, {
        key: "complete",
        value: function complete() {
          onNotify(this._subscription, "complete");
        }
      }, {
        key: "closed",
        get: function() {
          return this._subscription._state === "closed";
        }
      }]);
      return SubscriptionObserver2;
    }();
    var Observable2 = /* @__PURE__ */ function() {
      function Observable3(subscriber) {
        _classCallCheck2(this, Observable3);
        if (!(this instanceof Observable3))
          throw new TypeError("Observable cannot be called as a function");
        if (typeof subscriber !== "function")
          throw new TypeError("Observable initializer must be a function");
        this._subscriber = subscriber;
      }
      _createClass3(Observable3, [{
        key: "subscribe",
        value: function subscribe(observer) {
          if (typeof observer !== "object" || observer === null) {
            observer = {
              next: observer,
              error: arguments[1],
              complete: arguments[2]
            };
          }
          return new Subscription(observer, this._subscriber);
        }
      }, {
        key: "forEach",
        value: function forEach(fn2) {
          var _this = this;
          return new Promise(function(resolve, reject) {
            if (typeof fn2 !== "function") {
              reject(new TypeError(fn2 + " is not a function"));
              return;
            }
            function done() {
              subscription.unsubscribe();
              resolve();
            }
            var subscription = _this.subscribe({
              next: function(value) {
                try {
                  fn2(value, done);
                } catch (e) {
                  reject(e);
                  subscription.unsubscribe();
                }
              },
              error: reject,
              complete: resolve
            });
          });
        }
      }, {
        key: "map",
        value: function map5(fn2) {
          var _this2 = this;
          if (typeof fn2 !== "function")
            throw new TypeError(fn2 + " is not a function");
          var C = getSpecies(this);
          return new C(function(observer) {
            return _this2.subscribe({
              next: function(value) {
                try {
                  value = fn2(value);
                } catch (e) {
                  return observer.error(e);
                }
                observer.next(value);
              },
              error: function(e) {
                observer.error(e);
              },
              complete: function() {
                observer.complete();
              }
            });
          });
        }
      }, {
        key: "filter",
        value: function filter(fn2) {
          var _this3 = this;
          if (typeof fn2 !== "function")
            throw new TypeError(fn2 + " is not a function");
          var C = getSpecies(this);
          return new C(function(observer) {
            return _this3.subscribe({
              next: function(value) {
                try {
                  if (!fn2(value))
                    return;
                } catch (e) {
                  return observer.error(e);
                }
                observer.next(value);
              },
              error: function(e) {
                observer.error(e);
              },
              complete: function() {
                observer.complete();
              }
            });
          });
        }
      }, {
        key: "reduce",
        value: function reduce(fn2) {
          var _this4 = this;
          if (typeof fn2 !== "function")
            throw new TypeError(fn2 + " is not a function");
          var C = getSpecies(this);
          var hasSeed = arguments.length > 1;
          var hasValue = false;
          var seed = arguments[1];
          var acc = seed;
          return new C(function(observer) {
            return _this4.subscribe({
              next: function(value) {
                var first = !hasValue;
                hasValue = true;
                if (!first || hasSeed) {
                  try {
                    acc = fn2(acc, value);
                  } catch (e) {
                    return observer.error(e);
                  }
                } else {
                  acc = value;
                }
              },
              error: function(e) {
                observer.error(e);
              },
              complete: function() {
                if (!hasValue && !hasSeed)
                  return observer.error(new TypeError("Cannot reduce an empty sequence"));
                observer.next(acc);
                observer.complete();
              }
            });
          });
        }
      }, {
        key: "concat",
        value: function concat() {
          var _this5 = this;
          for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
            sources[_key] = arguments[_key];
          }
          var C = getSpecies(this);
          return new C(function(observer) {
            var subscription;
            var index = 0;
            function startNext(next) {
              subscription = next.subscribe({
                next: function(v2) {
                  observer.next(v2);
                },
                error: function(e) {
                  observer.error(e);
                },
                complete: function() {
                  if (index === sources.length) {
                    subscription = void 0;
                    observer.complete();
                  } else {
                    startNext(C.from(sources[index++]));
                  }
                }
              });
            }
            startNext(_this5);
            return function() {
              if (subscription) {
                subscription.unsubscribe();
                subscription = void 0;
              }
            };
          });
        }
      }, {
        key: "flatMap",
        value: function flatMap(fn2) {
          var _this6 = this;
          if (typeof fn2 !== "function")
            throw new TypeError(fn2 + " is not a function");
          var C = getSpecies(this);
          return new C(function(observer) {
            var subscriptions = [];
            var outer = _this6.subscribe({
              next: function(value) {
                if (fn2) {
                  try {
                    value = fn2(value);
                  } catch (e) {
                    return observer.error(e);
                  }
                }
                var inner = C.from(value).subscribe({
                  next: function(value2) {
                    observer.next(value2);
                  },
                  error: function(e) {
                    observer.error(e);
                  },
                  complete: function() {
                    var i2 = subscriptions.indexOf(inner);
                    if (i2 >= 0)
                      subscriptions.splice(i2, 1);
                    completeIfDone();
                  }
                });
                subscriptions.push(inner);
              },
              error: function(e) {
                observer.error(e);
              },
              complete: function() {
                completeIfDone();
              }
            });
            function completeIfDone() {
              if (outer.closed && subscriptions.length === 0)
                observer.complete();
            }
            return function() {
              subscriptions.forEach(function(s2) {
                return s2.unsubscribe();
              });
              outer.unsubscribe();
            };
          });
        }
      }, {
        key: SymbolObservable,
        value: function() {
          return this;
        }
      }], [{
        key: "from",
        value: function from(x2) {
          var C = typeof this === "function" ? this : Observable3;
          if (x2 == null)
            throw new TypeError(x2 + " is not an object");
          var method = getMethod2(x2, SymbolObservable);
          if (method) {
            var observable = method.call(x2);
            if (Object(observable) !== observable)
              throw new TypeError(observable + " is not an object");
            if (isObservable(observable) && observable.constructor === C)
              return observable;
            return new C(function(observer) {
              return observable.subscribe(observer);
            });
          }
          if (hasSymbol2("iterator")) {
            method = getMethod2(x2, SymbolIterator);
            if (method) {
              return new C(function(observer) {
                enqueue(function() {
                  if (observer.closed)
                    return;
                  var _iteratorNormalCompletion = true;
                  var _didIteratorError = false;
                  var _iteratorError = void 0;
                  try {
                    for (var _iterator = method.call(x2)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                      var _item = _step.value;
                      observer.next(_item);
                      if (observer.closed)
                        return;
                    }
                  } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                      }
                    } finally {
                      if (_didIteratorError) {
                        throw _iteratorError;
                      }
                    }
                  }
                  observer.complete();
                });
              });
            }
          }
          if (Array.isArray(x2)) {
            return new C(function(observer) {
              enqueue(function() {
                if (observer.closed)
                  return;
                for (var i2 = 0; i2 < x2.length; ++i2) {
                  observer.next(x2[i2]);
                  if (observer.closed)
                    return;
                }
                observer.complete();
              });
            });
          }
          throw new TypeError(x2 + " is not observable");
        }
      }, {
        key: "of",
        value: function of() {
          for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            items[_key2] = arguments[_key2];
          }
          var C = typeof this === "function" ? this : Observable3;
          return new C(function(observer) {
            enqueue(function() {
              if (observer.closed)
                return;
              for (var i2 = 0; i2 < items.length; ++i2) {
                observer.next(items[i2]);
                if (observer.closed)
                  return;
              }
              observer.complete();
            });
          });
        }
      }, {
        key: SymbolSpecies,
        get: function() {
          return this;
        }
      }]);
      return Observable3;
    }();
    exports.Observable = Observable2;
    if (hasSymbols()) {
      Object.defineProperty(Observable2, Symbol("extensions"), {
        value: {
          symbol: SymbolObservable,
          hostReportError
        },
        configurable: true
      });
    }
  }
});

// node_modules/zen-observable/index.js
var require_zen_observable = __commonJS({
  "node_modules/zen-observable/index.js"(exports, module) {
    module.exports = require_Observable().Observable;
  }
});

// node_modules/@aws-amplify/core/node_modules/tslib/tslib.js
var require_tslib = __commonJS({
  "node_modules/@aws-amplify/core/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-amplify/core/node_modules/@aws-crypto/sha256-js/build/constants.js
var require_constants = __commonJS({
  "node_modules/@aws-amplify/core/node_modules/@aws-crypto/sha256-js/build/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
    exports.BLOCK_SIZE = 64;
    exports.DIGEST_LENGTH = 32;
    exports.KEY = new Uint32Array([
      1116352408,
      1899447441,
      3049323471,
      3921009573,
      961987163,
      1508970993,
      2453635748,
      2870763221,
      3624381080,
      310598401,
      607225278,
      1426881987,
      1925078388,
      2162078206,
      2614888103,
      3248222580,
      3835390401,
      4022224774,
      264347078,
      604807628,
      770255983,
      1249150122,
      1555081692,
      1996064986,
      2554220882,
      2821834349,
      2952996808,
      3210313671,
      3336571891,
      3584528711,
      113926993,
      338241895,
      666307205,
      773529912,
      1294757372,
      1396182291,
      1695183700,
      1986661051,
      2177026350,
      2456956037,
      2730485921,
      2820302411,
      3259730800,
      3345764771,
      3516065817,
      3600352804,
      4094571909,
      275423344,
      430227734,
      506948616,
      659060556,
      883997877,
      958139571,
      1322822218,
      1537002063,
      1747873779,
      1955562222,
      2024104815,
      2227730452,
      2361852424,
      2428436474,
      2756734187,
      3204031479,
      3329325298
    ]);
    exports.INIT = [
      1779033703,
      3144134277,
      1013904242,
      2773480762,
      1359893119,
      2600822924,
      528734635,
      1541459225
    ];
    exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
  }
});

// node_modules/@aws-amplify/core/node_modules/@aws-crypto/sha256-js/build/RawSha256.js
var require_RawSha256 = __commonJS({
  "node_modules/@aws-amplify/core/node_modules/@aws-crypto/sha256-js/build/RawSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.RawSha256 = void 0;
    var constants_1 = require_constants();
    var RawSha256 = (
      /** @class */
      function() {
        function RawSha2562() {
          this.state = Int32Array.from(constants_1.INIT);
          this.temp = new Int32Array(64);
          this.buffer = new Uint8Array(64);
          this.bufferLength = 0;
          this.bytesHashed = 0;
          this.finished = false;
        }
        RawSha2562.prototype.update = function(data) {
          if (this.finished) {
            throw new Error("Attempted to update an already finished hash.");
          }
          var position = 0;
          var byteLength2 = data.byteLength;
          this.bytesHashed += byteLength2;
          if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) {
            throw new Error("Cannot hash more than 2^53 - 1 bits");
          }
          while (byteLength2 > 0) {
            this.buffer[this.bufferLength++] = data[position++];
            byteLength2--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
              this.hashBuffer();
              this.bufferLength = 0;
            }
          }
        };
        RawSha2562.prototype.digest = function() {
          if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 128);
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
              for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE; i2++) {
                bufferView.setUint8(i2, 0);
              }
              this.hashBuffer();
              this.bufferLength = 0;
            }
            for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE - 8; i2++) {
              bufferView.setUint8(i2, 0);
            }
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 4294967296), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
          }
          var out = new Uint8Array(constants_1.DIGEST_LENGTH);
          for (var i2 = 0; i2 < 8; i2++) {
            out[i2 * 4] = this.state[i2] >>> 24 & 255;
            out[i2 * 4 + 1] = this.state[i2] >>> 16 & 255;
            out[i2 * 4 + 2] = this.state[i2] >>> 8 & 255;
            out[i2 * 4 + 3] = this.state[i2] >>> 0 & 255;
          }
          return out;
        };
        RawSha2562.prototype.hashBuffer = function() {
          var _a2 = this, buffer = _a2.buffer, state = _a2.state;
          var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
          for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
            if (i2 < 16) {
              this.temp[i2] = (buffer[i2 * 4] & 255) << 24 | (buffer[i2 * 4 + 1] & 255) << 16 | (buffer[i2 * 4 + 2] & 255) << 8 | buffer[i2 * 4 + 3] & 255;
            } else {
              var u2 = this.temp[i2 - 2];
              var t1_1 = (u2 >>> 17 | u2 << 15) ^ (u2 >>> 19 | u2 << 13) ^ u2 >>> 10;
              u2 = this.temp[i2 - 15];
              var t2_1 = (u2 >>> 7 | u2 << 25) ^ (u2 >>> 18 | u2 << 14) ^ u2 >>> 3;
              this.temp[i2] = (t1_1 + this.temp[i2 - 7] | 0) + (t2_1 + this.temp[i2 - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i2] + this.temp[i2] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
          }
          state[0] += state0;
          state[1] += state1;
          state[2] += state2;
          state[3] += state3;
          state[4] += state4;
          state[5] += state5;
          state[6] += state6;
          state[7] += state7;
        };
        return RawSha2562;
      }()
    );
    exports.RawSha256 = RawSha256;
  }
});

// node_modules/@aws-sdk/util-utf8-browser/dist-es/pureJs.js
var fromUtf8, toUtf8;
var init_pureJs = __esm({
  "node_modules/@aws-sdk/util-utf8-browser/dist-es/pureJs.js"() {
    fromUtf8 = (input) => {
      const bytes = [];
      for (let i2 = 0, len = input.length; i2 < len; i2++) {
        const value = input.charCodeAt(i2);
        if (value < 128) {
          bytes.push(value);
        } else if (value < 2048) {
          bytes.push(value >> 6 | 192, value & 63 | 128);
        } else if (i2 + 1 < input.length && (value & 64512) === 55296 && (input.charCodeAt(i2 + 1) & 64512) === 56320) {
          const surrogatePair = 65536 + ((value & 1023) << 10) + (input.charCodeAt(++i2) & 1023);
          bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else {
          bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
        }
      }
      return Uint8Array.from(bytes);
    };
    toUtf8 = (input) => {
      let decoded = "";
      for (let i2 = 0, len = input.length; i2 < len; i2++) {
        const byte = input[i2];
        if (byte < 128) {
          decoded += String.fromCharCode(byte);
        } else if (192 <= byte && byte < 224) {
          const nextByte = input[++i2];
          decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
          const surrogatePair = [byte, input[++i2], input[++i2], input[++i2]];
          const encoded = "%" + surrogatePair.map((byteValue) => byteValue.toString(16)).join("%");
          decoded += decodeURIComponent(encoded);
        } else {
          decoded += String.fromCharCode((byte & 15) << 12 | (input[++i2] & 63) << 6 | input[++i2] & 63);
        }
      }
      return decoded;
    };
  }
});

// node_modules/@aws-sdk/util-utf8-browser/dist-es/whatwgEncodingApi.js
function fromUtf82(input) {
  return new TextEncoder().encode(input);
}
function toUtf82(input) {
  return new TextDecoder("utf-8").decode(input);
}
var init_whatwgEncodingApi = __esm({
  "node_modules/@aws-sdk/util-utf8-browser/dist-es/whatwgEncodingApi.js"() {
  }
});

// node_modules/@aws-sdk/util-utf8-browser/dist-es/index.js
var dist_es_exports = {};
__export(dist_es_exports, {
  fromUtf8: () => fromUtf83,
  toUtf8: () => toUtf83
});
var fromUtf83, toUtf83;
var init_dist_es = __esm({
  "node_modules/@aws-sdk/util-utf8-browser/dist-es/index.js"() {
    init_pureJs();
    init_whatwgEncodingApi();
    fromUtf83 = (input) => typeof TextEncoder === "function" ? fromUtf82(input) : fromUtf8(input);
    toUtf83 = (input) => typeof TextDecoder === "function" ? toUtf82(input) : toUtf8(input);
  }
});

// node_modules/@aws-amplify/core/node_modules/@aws-crypto/util/build/convertToBuffer.js
var require_convertToBuffer = __commonJS({
  "node_modules/@aws-amplify/core/node_modules/@aws-crypto/util/build/convertToBuffer.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.convertToBuffer = void 0;
    var util_utf8_browser_1 = (init_dist_es(), __toCommonJS(dist_es_exports));
    var fromUtf831 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
      return Buffer.from(input, "utf8");
    } : util_utf8_browser_1.fromUtf8;
    function convertToBuffer2(data) {
      if (data instanceof Uint8Array)
        return data;
      if (typeof data === "string") {
        return fromUtf831(data);
      }
      if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
      }
      return new Uint8Array(data);
    }
    exports.convertToBuffer = convertToBuffer2;
  }
});

// node_modules/@aws-amplify/core/node_modules/@aws-crypto/util/build/isEmptyData.js
var require_isEmptyData = __commonJS({
  "node_modules/@aws-amplify/core/node_modules/@aws-crypto/util/build/isEmptyData.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isEmptyData = void 0;
    function isEmptyData2(data) {
      if (typeof data === "string") {
        return data.length === 0;
      }
      return data.byteLength === 0;
    }
    exports.isEmptyData = isEmptyData2;
  }
});

// node_modules/@aws-amplify/core/node_modules/@aws-crypto/util/build/numToUint8.js
var require_numToUint8 = __commonJS({
  "node_modules/@aws-amplify/core/node_modules/@aws-crypto/util/build/numToUint8.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.numToUint8 = void 0;
    function numToUint8(num) {
      return new Uint8Array([
        (num & 4278190080) >> 24,
        (num & 16711680) >> 16,
        (num & 65280) >> 8,
        num & 255
      ]);
    }
    exports.numToUint8 = numToUint8;
  }
});

// node_modules/@aws-amplify/core/node_modules/@aws-crypto/util/build/uint32ArrayFrom.js
var require_uint32ArrayFrom = __commonJS({
  "node_modules/@aws-amplify/core/node_modules/@aws-crypto/util/build/uint32ArrayFrom.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = void 0;
    function uint32ArrayFrom(a_lookUpTable) {
      if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while (a_index < a_lookUpTable.length) {
          return_array[a_index] = a_lookUpTable[a_index];
        }
        return return_array;
      }
      return Uint32Array.from(a_lookUpTable);
    }
    exports.uint32ArrayFrom = uint32ArrayFrom;
  }
});

// node_modules/@aws-amplify/core/node_modules/@aws-crypto/util/build/index.js
var require_build = __commonJS({
  "node_modules/@aws-amplify/core/node_modules/@aws-crypto/util/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
    var convertToBuffer_1 = require_convertToBuffer();
    Object.defineProperty(exports, "convertToBuffer", { enumerable: true, get: function() {
      return convertToBuffer_1.convertToBuffer;
    } });
    var isEmptyData_1 = require_isEmptyData();
    Object.defineProperty(exports, "isEmptyData", { enumerable: true, get: function() {
      return isEmptyData_1.isEmptyData;
    } });
    var numToUint8_1 = require_numToUint8();
    Object.defineProperty(exports, "numToUint8", { enumerable: true, get: function() {
      return numToUint8_1.numToUint8;
    } });
    var uint32ArrayFrom_1 = require_uint32ArrayFrom();
    Object.defineProperty(exports, "uint32ArrayFrom", { enumerable: true, get: function() {
      return uint32ArrayFrom_1.uint32ArrayFrom;
    } });
  }
});

// node_modules/@aws-amplify/core/node_modules/@aws-crypto/sha256-js/build/jsSha256.js
var require_jsSha256 = __commonJS({
  "node_modules/@aws-amplify/core/node_modules/@aws-crypto/sha256-js/build/jsSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var tslib_1 = require_tslib();
    var constants_1 = require_constants();
    var RawSha256_1 = require_RawSha256();
    var util_1 = require_build();
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          this.hash = new RawSha256_1.RawSha256();
          if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
              inner[i2] ^= 54;
              outer[i2] ^= 92;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            for (var i2 = 0; i2 < inner.byteLength; i2++) {
              inner[i2] = 0;
            }
          }
        }
        Sha25613.prototype.update = function(toHash) {
          if ((0, util_1.isEmptyData)(toHash) || this.error) {
            return;
          }
          try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
          } catch (e) {
            this.error = e;
          }
        };
        Sha25613.prototype.digestSync = function() {
          if (this.error) {
            throw this.error;
          }
          if (this.outer) {
            if (!this.outer.finished) {
              this.outer.update(this.hash.digest());
            }
            return this.outer.digest();
          }
          return this.hash.digest();
        };
        Sha25613.prototype.digest = function() {
          return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a2) {
              return [2, this.digestSync()];
            });
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
    function bufferFromSecret(secret) {
      var input = (0, util_1.convertToBuffer)(secret);
      if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
      }
      var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
      buffer.set(input);
      return buffer;
    }
  }
});

// node_modules/@aws-amplify/core/node_modules/@aws-crypto/sha256-js/build/index.js
var require_build2 = __commonJS({
  "node_modules/@aws-amplify/core/node_modules/@aws-crypto/sha256-js/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib();
    (0, tslib_1.__exportStar)(require_jsSha256(), exports);
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-browser/node_modules/tslib/tslib.js
var require_tslib2 = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-browser/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-browser/build/isEmptyData.js
var require_isEmptyData2 = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-browser/build/isEmptyData.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isEmptyData = void 0;
    function isEmptyData2(data) {
      if (typeof data === "string") {
        return data.length === 0;
      }
      return data.byteLength === 0;
    }
    exports.isEmptyData = isEmptyData2;
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-browser/build/constants.js
var require_constants2 = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-browser/build/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
    exports.SHA_256_HASH = { name: "SHA-256" };
    exports.SHA_256_HMAC_ALGO = {
      name: "HMAC",
      hash: exports.SHA_256_HASH
    };
    exports.EMPTY_DATA_SHA_256 = new Uint8Array([
      227,
      176,
      196,
      66,
      152,
      252,
      28,
      20,
      154,
      251,
      244,
      200,
      153,
      111,
      185,
      36,
      39,
      174,
      65,
      228,
      100,
      155,
      147,
      76,
      164,
      149,
      153,
      27,
      120,
      82,
      184,
      85
    ]);
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-sdk/util-utf8-browser/dist/es/pureJs.js
var fromUtf84, toUtf84;
var init_pureJs2 = __esm({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-sdk/util-utf8-browser/dist/es/pureJs.js"() {
    fromUtf84 = function(input) {
      var bytes = [];
      for (var i2 = 0, len = input.length; i2 < len; i2++) {
        var value = input.charCodeAt(i2);
        if (value < 128) {
          bytes.push(value);
        } else if (value < 2048) {
          bytes.push(value >> 6 | 192, value & 63 | 128);
        } else if (i2 + 1 < input.length && (value & 64512) === 55296 && (input.charCodeAt(i2 + 1) & 64512) === 56320) {
          var surrogatePair = 65536 + ((value & 1023) << 10) + (input.charCodeAt(++i2) & 1023);
          bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else {
          bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
        }
      }
      return Uint8Array.from(bytes);
    };
    toUtf84 = function(input) {
      var decoded = "";
      for (var i2 = 0, len = input.length; i2 < len; i2++) {
        var byte = input[i2];
        if (byte < 128) {
          decoded += String.fromCharCode(byte);
        } else if (192 <= byte && byte < 224) {
          var nextByte = input[++i2];
          decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
          var surrogatePair = [byte, input[++i2], input[++i2], input[++i2]];
          var encoded = "%" + surrogatePair.map(function(byteValue) {
            return byteValue.toString(16);
          }).join("%");
          decoded += decodeURIComponent(encoded);
        } else {
          decoded += String.fromCharCode((byte & 15) << 12 | (input[++i2] & 63) << 6 | input[++i2] & 63);
        }
      }
      return decoded;
    };
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-sdk/util-utf8-browser/dist/es/whatwgEncodingApi.js
function fromUtf85(input) {
  return new TextEncoder().encode(input);
}
function toUtf85(input) {
  return new TextDecoder("utf-8").decode(input);
}
var init_whatwgEncodingApi2 = __esm({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-sdk/util-utf8-browser/dist/es/whatwgEncodingApi.js"() {
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-sdk/util-utf8-browser/dist/es/index.js
var es_exports = {};
__export(es_exports, {
  fromUtf8: () => fromUtf86,
  toUtf8: () => toUtf86
});
var fromUtf86, toUtf86;
var init_es = __esm({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-sdk/util-utf8-browser/dist/es/index.js"() {
    init_pureJs2();
    init_whatwgEncodingApi2();
    fromUtf86 = function(input) {
      return typeof TextEncoder === "function" ? fromUtf85(input) : fromUtf84(input);
    };
    toUtf86 = function(input) {
      return typeof TextDecoder === "function" ? toUtf85(input) : toUtf84(input);
    };
  }
});

// node_modules/@aws-sdk/util-locate-window/dist-es/index.js
var dist_es_exports2 = {};
__export(dist_es_exports2, {
  locateWindow: () => locateWindow
});
function locateWindow() {
  if (typeof window !== "undefined") {
    return window;
  } else if (typeof self !== "undefined") {
    return self;
  }
  return fallbackWindow;
}
var fallbackWindow;
var init_dist_es2 = __esm({
  "node_modules/@aws-sdk/util-locate-window/dist-es/index.js"() {
    fallbackWindow = {};
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-browser/build/ie11Sha256.js
var require_ie11Sha256 = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-browser/build/ie11Sha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var isEmptyData_1 = require_isEmptyData2();
    var constants_1 = require_constants2();
    var util_utf8_browser_1 = (init_es(), __toCommonJS(es_exports));
    var util_locate_window_1 = (init_dist_es2(), __toCommonJS(dist_es_exports2));
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          if (secret) {
            this.operation = getKeyPromise(secret).then(function(keyData) {
              return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {
            });
          } else {
            this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
          }
        }
        Sha25613.prototype.update = function(toHash) {
          var _this = this;
          if ((0, isEmptyData_1.isEmptyData)(toHash)) {
            return;
          }
          this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
              _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
          });
          this.operation.catch(function() {
          });
        };
        Sha25613.prototype.digest = function() {
          return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
              operation.onerror = function() {
                reject(new Error("Error encountered finalizing hash"));
              };
              operation.oncomplete = function() {
                if (operation.result) {
                  resolve(new Uint8Array(operation.result));
                }
                reject(new Error("Error encountered finalizing hash"));
              };
              operation.finish();
            });
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
    function getKeyPromise(secret) {
      return new Promise(function(resolve, reject) {
        var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, ["sign"]);
        keyOperation.oncomplete = function() {
          if (keyOperation.result) {
            resolve(keyOperation.result);
          }
          reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
          reject(new Error("ImportKey failed to import key."));
        };
      });
    }
    function toArrayBufferView(data) {
      if (typeof data === "string") {
        return (0, util_utf8_browser_1.fromUtf8)(data);
      }
      if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
      }
      return new Uint8Array(data);
    }
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/util/build/convertToBuffer.js
var require_convertToBuffer2 = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/util/build/convertToBuffer.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.convertToBuffer = void 0;
    var util_utf8_browser_1 = (init_es(), __toCommonJS(es_exports));
    var fromUtf831 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
      return Buffer.from(input, "utf8");
    } : util_utf8_browser_1.fromUtf8;
    function convertToBuffer2(data) {
      if (data instanceof Uint8Array)
        return data;
      if (typeof data === "string") {
        return fromUtf831(data);
      }
      if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
      }
      return new Uint8Array(data);
    }
    exports.convertToBuffer = convertToBuffer2;
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/util/build/isEmptyData.js
var require_isEmptyData3 = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/util/build/isEmptyData.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isEmptyData = void 0;
    function isEmptyData2(data) {
      if (typeof data === "string") {
        return data.length === 0;
      }
      return data.byteLength === 0;
    }
    exports.isEmptyData = isEmptyData2;
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/util/build/numToUint8.js
var require_numToUint82 = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/util/build/numToUint8.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.numToUint8 = void 0;
    function numToUint8(num) {
      return new Uint8Array([
        (num & 4278190080) >> 24,
        (num & 16711680) >> 16,
        (num & 65280) >> 8,
        num & 255
      ]);
    }
    exports.numToUint8 = numToUint8;
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/util/build/uint32ArrayFrom.js
var require_uint32ArrayFrom2 = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/util/build/uint32ArrayFrom.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = void 0;
    function uint32ArrayFrom(a_lookUpTable) {
      if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while (a_index < a_lookUpTable.length) {
          return_array[a_index] = a_lookUpTable[a_index];
        }
        return return_array;
      }
      return Uint32Array.from(a_lookUpTable);
    }
    exports.uint32ArrayFrom = uint32ArrayFrom;
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/util/build/index.js
var require_build3 = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/util/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
    var convertToBuffer_1 = require_convertToBuffer2();
    Object.defineProperty(exports, "convertToBuffer", { enumerable: true, get: function() {
      return convertToBuffer_1.convertToBuffer;
    } });
    var isEmptyData_1 = require_isEmptyData3();
    Object.defineProperty(exports, "isEmptyData", { enumerable: true, get: function() {
      return isEmptyData_1.isEmptyData;
    } });
    var numToUint8_1 = require_numToUint82();
    Object.defineProperty(exports, "numToUint8", { enumerable: true, get: function() {
      return numToUint8_1.numToUint8;
    } });
    var uint32ArrayFrom_1 = require_uint32ArrayFrom2();
    Object.defineProperty(exports, "uint32ArrayFrom", { enumerable: true, get: function() {
      return uint32ArrayFrom_1.uint32ArrayFrom;
    } });
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-browser/build/webCryptoSha256.js
var require_webCryptoSha256 = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-browser/build/webCryptoSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var util_1 = require_build3();
    var constants_1 = require_constants2();
    var util_locate_window_1 = (init_dist_es2(), __toCommonJS(dist_es_exports2));
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          this.toHash = new Uint8Array(0);
          if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
              (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(secret), constants_1.SHA_256_HMAC_ALGO, false, ["sign"]).then(resolve, reject);
            });
            this.key.catch(function() {
            });
          }
        }
        Sha25613.prototype.update = function(data) {
          if ((0, util_1.isEmptyData)(data)) {
            return;
          }
          var update = (0, util_1.convertToBuffer)(data);
          var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
          typedArray.set(this.toHash, 0);
          typedArray.set(update, this.toHash.byteLength);
          this.toHash = typedArray;
        };
        Sha25613.prototype.digest = function() {
          var _this = this;
          if (this.key) {
            return this.key.then(function(key) {
              return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
              });
            });
          }
          if ((0, util_1.isEmptyData)(this.toHash)) {
            return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
          }
          return Promise.resolve().then(function() {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
          }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-js/node_modules/tslib/tslib.js
var require_tslib3 = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-js/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-js/build/constants.js
var require_constants3 = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-js/build/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
    exports.BLOCK_SIZE = 64;
    exports.DIGEST_LENGTH = 32;
    exports.KEY = new Uint32Array([
      1116352408,
      1899447441,
      3049323471,
      3921009573,
      961987163,
      1508970993,
      2453635748,
      2870763221,
      3624381080,
      310598401,
      607225278,
      1426881987,
      1925078388,
      2162078206,
      2614888103,
      3248222580,
      3835390401,
      4022224774,
      264347078,
      604807628,
      770255983,
      1249150122,
      1555081692,
      1996064986,
      2554220882,
      2821834349,
      2952996808,
      3210313671,
      3336571891,
      3584528711,
      113926993,
      338241895,
      666307205,
      773529912,
      1294757372,
      1396182291,
      1695183700,
      1986661051,
      2177026350,
      2456956037,
      2730485921,
      2820302411,
      3259730800,
      3345764771,
      3516065817,
      3600352804,
      4094571909,
      275423344,
      430227734,
      506948616,
      659060556,
      883997877,
      958139571,
      1322822218,
      1537002063,
      1747873779,
      1955562222,
      2024104815,
      2227730452,
      2361852424,
      2428436474,
      2756734187,
      3204031479,
      3329325298
    ]);
    exports.INIT = [
      1779033703,
      3144134277,
      1013904242,
      2773480762,
      1359893119,
      2600822924,
      528734635,
      1541459225
    ];
    exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-js/build/RawSha256.js
var require_RawSha2562 = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-js/build/RawSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.RawSha256 = void 0;
    var constants_1 = require_constants3();
    var RawSha256 = (
      /** @class */
      function() {
        function RawSha2562() {
          this.state = Int32Array.from(constants_1.INIT);
          this.temp = new Int32Array(64);
          this.buffer = new Uint8Array(64);
          this.bufferLength = 0;
          this.bytesHashed = 0;
          this.finished = false;
        }
        RawSha2562.prototype.update = function(data) {
          if (this.finished) {
            throw new Error("Attempted to update an already finished hash.");
          }
          var position = 0;
          var byteLength2 = data.byteLength;
          this.bytesHashed += byteLength2;
          if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) {
            throw new Error("Cannot hash more than 2^53 - 1 bits");
          }
          while (byteLength2 > 0) {
            this.buffer[this.bufferLength++] = data[position++];
            byteLength2--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
              this.hashBuffer();
              this.bufferLength = 0;
            }
          }
        };
        RawSha2562.prototype.digest = function() {
          if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 128);
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
              for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE; i2++) {
                bufferView.setUint8(i2, 0);
              }
              this.hashBuffer();
              this.bufferLength = 0;
            }
            for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE - 8; i2++) {
              bufferView.setUint8(i2, 0);
            }
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 4294967296), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
          }
          var out = new Uint8Array(constants_1.DIGEST_LENGTH);
          for (var i2 = 0; i2 < 8; i2++) {
            out[i2 * 4] = this.state[i2] >>> 24 & 255;
            out[i2 * 4 + 1] = this.state[i2] >>> 16 & 255;
            out[i2 * 4 + 2] = this.state[i2] >>> 8 & 255;
            out[i2 * 4 + 3] = this.state[i2] >>> 0 & 255;
          }
          return out;
        };
        RawSha2562.prototype.hashBuffer = function() {
          var _a2 = this, buffer = _a2.buffer, state = _a2.state;
          var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
          for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
            if (i2 < 16) {
              this.temp[i2] = (buffer[i2 * 4] & 255) << 24 | (buffer[i2 * 4 + 1] & 255) << 16 | (buffer[i2 * 4 + 2] & 255) << 8 | buffer[i2 * 4 + 3] & 255;
            } else {
              var u2 = this.temp[i2 - 2];
              var t1_1 = (u2 >>> 17 | u2 << 15) ^ (u2 >>> 19 | u2 << 13) ^ u2 >>> 10;
              u2 = this.temp[i2 - 15];
              var t2_1 = (u2 >>> 7 | u2 << 25) ^ (u2 >>> 18 | u2 << 14) ^ u2 >>> 3;
              this.temp[i2] = (t1_1 + this.temp[i2 - 7] | 0) + (t2_1 + this.temp[i2 - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i2] + this.temp[i2] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
          }
          state[0] += state0;
          state[1] += state1;
          state[2] += state2;
          state[3] += state3;
          state[4] += state4;
          state[5] += state5;
          state[6] += state6;
          state[7] += state7;
        };
        return RawSha2562;
      }()
    );
    exports.RawSha256 = RawSha256;
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-js/build/jsSha256.js
var require_jsSha2562 = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-js/build/jsSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var tslib_1 = require_tslib3();
    var constants_1 = require_constants3();
    var RawSha256_1 = require_RawSha2562();
    var util_1 = require_build3();
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          this.hash = new RawSha256_1.RawSha256();
          if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
              inner[i2] ^= 54;
              outer[i2] ^= 92;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            for (var i2 = 0; i2 < inner.byteLength; i2++) {
              inner[i2] = 0;
            }
          }
        }
        Sha25613.prototype.update = function(toHash) {
          if ((0, util_1.isEmptyData)(toHash) || this.error) {
            return;
          }
          try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
          } catch (e) {
            this.error = e;
          }
        };
        Sha25613.prototype.digestSync = function() {
          if (this.error) {
            throw this.error;
          }
          if (this.outer) {
            if (!this.outer.finished) {
              this.outer.update(this.hash.digest());
            }
            return this.outer.digest();
          }
          return this.hash.digest();
        };
        Sha25613.prototype.digest = function() {
          return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a2) {
              return [2, this.digestSync()];
            });
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
    function bufferFromSecret(secret) {
      var input = (0, util_1.convertToBuffer)(secret);
      if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
      }
      var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
      buffer.set(input);
      return buffer;
    }
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-js/build/index.js
var require_build4 = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-js/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib3();
    (0, tslib_1.__exportStar)(require_jsSha2562(), exports);
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/supports-web-crypto/node_modules/tslib/tslib.js
var require_tslib4 = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/supports-web-crypto/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/supports-web-crypto/build/supportsWebCrypto.js
var require_supportsWebCrypto = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/supports-web-crypto/build/supportsWebCrypto.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
    var tslib_1 = require_tslib4();
    var subtleCryptoMethods = [
      "decrypt",
      "digest",
      "encrypt",
      "exportKey",
      "generateKey",
      "importKey",
      "sign",
      "verify"
    ];
    function supportsWebCrypto(window2) {
      if (supportsSecureRandom(window2) && typeof window2.crypto.subtle === "object") {
        var subtle = window2.crypto.subtle;
        return supportsSubtleCrypto(subtle);
      }
      return false;
    }
    exports.supportsWebCrypto = supportsWebCrypto;
    function supportsSecureRandom(window2) {
      if (typeof window2 === "object" && typeof window2.crypto === "object") {
        var getRandomValues2 = window2.crypto.getRandomValues;
        return typeof getRandomValues2 === "function";
      }
      return false;
    }
    exports.supportsSecureRandom = supportsSecureRandom;
    function supportsSubtleCrypto(subtle) {
      return subtle && subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
      });
    }
    exports.supportsSubtleCrypto = supportsSubtleCrypto;
    function supportsZeroByteGCM(subtle) {
      return tslib_1.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a2;
        return tslib_1.__generator(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              if (!supportsSubtleCrypto(subtle))
                return [2, false];
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 4, , 5]);
              return [4, subtle.generateKey({ name: "AES-GCM", length: 128 }, false, ["encrypt"])];
            case 2:
              key = _b2.sent();
              return [4, subtle.encrypt({
                name: "AES-GCM",
                iv: new Uint8Array(Array(12)),
                additionalData: new Uint8Array(Array(16)),
                tagLength: 128
              }, key, new Uint8Array(0))];
            case 3:
              zeroByteAuthTag = _b2.sent();
              return [2, zeroByteAuthTag.byteLength === 16];
            case 4:
              _a2 = _b2.sent();
              return [2, false];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }
    exports.supportsZeroByteGCM = supportsZeroByteGCM;
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/supports-web-crypto/build/index.js
var require_build5 = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/supports-web-crypto/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib4();
    tslib_1.__exportStar(require_supportsWebCrypto(), exports);
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/ie11-detection/node_modules/tslib/tslib.js
var require_tslib5 = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/ie11-detection/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/ie11-detection/build/CryptoOperation.js
var require_CryptoOperation = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/ie11-detection/build/CryptoOperation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/ie11-detection/build/Key.js
var require_Key = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/ie11-detection/build/Key.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/ie11-detection/build/KeyOperation.js
var require_KeyOperation = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/ie11-detection/build/KeyOperation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/ie11-detection/build/MsSubtleCrypto.js
var require_MsSubtleCrypto = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/ie11-detection/build/MsSubtleCrypto.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/ie11-detection/build/MsWindow.js
var require_MsWindow = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/ie11-detection/build/MsWindow.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isMsWindow = void 0;
    var msSubtleCryptoMethods = [
      "decrypt",
      "digest",
      "encrypt",
      "exportKey",
      "generateKey",
      "importKey",
      "sign",
      "verify"
    ];
    function quacksLikeAnMsWindow(window2) {
      return "MSInputMethodContext" in window2 && "msCrypto" in window2;
    }
    function isMsWindow(window2) {
      if (quacksLikeAnMsWindow(window2) && window2.msCrypto.subtle !== void 0) {
        var _a2 = window2.msCrypto, getRandomValues2 = _a2.getRandomValues, subtle_1 = _a2.subtle;
        return msSubtleCryptoMethods.map(function(methodName) {
          return subtle_1[methodName];
        }).concat(getRandomValues2).every(function(method) {
          return typeof method === "function";
        });
      }
      return false;
    }
    exports.isMsWindow = isMsWindow;
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/ie11-detection/build/index.js
var require_build6 = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/ie11-detection/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib5();
    tslib_1.__exportStar(require_CryptoOperation(), exports);
    tslib_1.__exportStar(require_Key(), exports);
    tslib_1.__exportStar(require_KeyOperation(), exports);
    tslib_1.__exportStar(require_MsSubtleCrypto(), exports);
    tslib_1.__exportStar(require_MsWindow(), exports);
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-browser/build/crossPlatformSha256.js
var require_crossPlatformSha256 = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-browser/build/crossPlatformSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var ie11Sha256_1 = require_ie11Sha256();
    var webCryptoSha256_1 = require_webCryptoSha256();
    var sha256_js_1 = require_build4();
    var supports_web_crypto_1 = require_build5();
    var ie11_detection_1 = require_build6();
    var util_locate_window_1 = (init_dist_es2(), __toCommonJS(dist_es_exports2));
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) {
            this.hash = new webCryptoSha256_1.Sha256(secret);
          } else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) {
            this.hash = new ie11Sha256_1.Sha256(secret);
          } else {
            this.hash = new sha256_js_1.Sha256(secret);
          }
        }
        Sha25613.prototype.update = function(data, encoding) {
          this.hash.update(data, encoding);
        };
        Sha25613.prototype.digest = function() {
          return this.hash.digest();
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
  }
});

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-browser/build/index.js
var require_build7 = __commonJS({
  "node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-crypto/sha256-browser/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
    var tslib_1 = require_tslib2();
    (0, tslib_1.__exportStar)(require_crossPlatformSha256(), exports);
    var ie11Sha256_1 = require_ie11Sha256();
    Object.defineProperty(exports, "Ie11Sha256", { enumerable: true, get: function() {
      return ie11Sha256_1.Sha256;
    } });
    var webCryptoSha256_1 = require_webCryptoSha256();
    Object.defineProperty(exports, "WebCryptoSha256", { enumerable: true, get: function() {
      return webCryptoSha256_1.Sha256;
    } });
  }
});

// node_modules/@aws-sdk/middleware-retry/node_modules/uuid/lib/rng-browser.js
var require_rng_browser = __commonJS({
  "node_modules/@aws-sdk/middleware-retry/node_modules/uuid/lib/rng-browser.js"(exports, module) {
    var getRandomValues2 = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
    if (getRandomValues2) {
      rnds82 = new Uint8Array(16);
      module.exports = function whatwgRNG() {
        getRandomValues2(rnds82);
        return rnds82;
      };
    } else {
      rnds = new Array(16);
      module.exports = function mathRNG() {
        for (var i2 = 0, r2; i2 < 16; i2++) {
          if ((i2 & 3) === 0)
            r2 = Math.random() * 4294967296;
          rnds[i2] = r2 >>> ((i2 & 3) << 3) & 255;
        }
        return rnds;
      };
    }
    var rnds82;
    var rnds;
  }
});

// node_modules/@aws-sdk/middleware-retry/node_modules/uuid/lib/bytesToUuid.js
var require_bytesToUuid = __commonJS({
  "node_modules/@aws-sdk/middleware-retry/node_modules/uuid/lib/bytesToUuid.js"(exports, module) {
    var byteToHex2 = [];
    for (i2 = 0; i2 < 256; ++i2) {
      byteToHex2[i2] = (i2 + 256).toString(16).substr(1);
    }
    var i2;
    function bytesToUuid(buf, offset) {
      var i3 = offset || 0;
      var bth = byteToHex2;
      return [
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        "-",
        bth[buf[i3++]],
        bth[buf[i3++]],
        "-",
        bth[buf[i3++]],
        bth[buf[i3++]],
        "-",
        bth[buf[i3++]],
        bth[buf[i3++]],
        "-",
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]]
      ].join("");
    }
    module.exports = bytesToUuid;
  }
});

// node_modules/@aws-sdk/middleware-retry/node_modules/uuid/v1.js
var require_v1 = __commonJS({
  "node_modules/@aws-sdk/middleware-retry/node_modules/uuid/v1.js"(exports, module) {
    var rng2 = require_rng_browser();
    var bytesToUuid = require_bytesToUuid();
    var _nodeId;
    var _clockseq;
    var _lastMSecs = 0;
    var _lastNSecs = 0;
    function v1(options, buf, offset) {
      var i2 = buf && offset || 0;
      var b2 = buf || [];
      options = options || {};
      var node = options.node || _nodeId;
      var clockseq = options.clockseq !== void 0 ? options.clockseq : _clockseq;
      if (node == null || clockseq == null) {
        var seedBytes = rng2();
        if (node == null) {
          node = _nodeId = [
            seedBytes[0] | 1,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
          ];
        }
        if (clockseq == null) {
          clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 16383;
        }
      }
      var msecs = options.msecs !== void 0 ? options.msecs : (/* @__PURE__ */ new Date()).getTime();
      var nsecs = options.nsecs !== void 0 ? options.nsecs : _lastNSecs + 1;
      var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 1e4;
      if (dt < 0 && options.clockseq === void 0) {
        clockseq = clockseq + 1 & 16383;
      }
      if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === void 0) {
        nsecs = 0;
      }
      if (nsecs >= 1e4) {
        throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
      }
      _lastMSecs = msecs;
      _lastNSecs = nsecs;
      _clockseq = clockseq;
      msecs += 122192928e5;
      var tl = ((msecs & 268435455) * 1e4 + nsecs) % 4294967296;
      b2[i2++] = tl >>> 24 & 255;
      b2[i2++] = tl >>> 16 & 255;
      b2[i2++] = tl >>> 8 & 255;
      b2[i2++] = tl & 255;
      var tmh = msecs / 4294967296 * 1e4 & 268435455;
      b2[i2++] = tmh >>> 8 & 255;
      b2[i2++] = tmh & 255;
      b2[i2++] = tmh >>> 24 & 15 | 16;
      b2[i2++] = tmh >>> 16 & 255;
      b2[i2++] = clockseq >>> 8 | 128;
      b2[i2++] = clockseq & 255;
      for (var n2 = 0; n2 < 6; ++n2) {
        b2[i2 + n2] = node[n2];
      }
      return buf ? buf : bytesToUuid(b2);
    }
    module.exports = v1;
  }
});

// node_modules/@aws-sdk/middleware-retry/node_modules/uuid/v4.js
var require_v4 = __commonJS({
  "node_modules/@aws-sdk/middleware-retry/node_modules/uuid/v4.js"(exports, module) {
    var rng2 = require_rng_browser();
    var bytesToUuid = require_bytesToUuid();
    function v43(options, buf, offset) {
      var i2 = buf && offset || 0;
      if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
      }
      options = options || {};
      var rnds = options.random || (options.rng || rng2)();
      rnds[6] = rnds[6] & 15 | 64;
      rnds[8] = rnds[8] & 63 | 128;
      if (buf) {
        for (var ii2 = 0; ii2 < 16; ++ii2) {
          buf[i2 + ii2] = rnds[ii2];
        }
      }
      return buf || bytesToUuid(rnds);
    }
    module.exports = v43;
  }
});

// node_modules/@aws-sdk/middleware-retry/node_modules/uuid/index.js
var require_uuid = __commonJS({
  "node_modules/@aws-sdk/middleware-retry/node_modules/uuid/index.js"(exports, module) {
    var v1 = require_v1();
    var v43 = require_v4();
    var uuid6 = v43;
    uuid6.v1 = v1;
    uuid6.v4 = v43;
    module.exports = uuid6;
  }
});

// node_modules/unfetch/dist/unfetch.module.js
var unfetch_module_exports = {};
__export(unfetch_module_exports, {
  default: () => unfetch_module_default
});
function unfetch_module_default(e, n2) {
  return n2 = n2 || {}, new Promise(function(t2, r2) {
    var s2 = new XMLHttpRequest(), o2 = [], u2 = [], i2 = {}, a2 = function() {
      return { ok: 2 == (s2.status / 100 | 0), statusText: s2.statusText, status: s2.status, url: s2.responseURL, text: function() {
        return Promise.resolve(s2.responseText);
      }, json: function() {
        return Promise.resolve(s2.responseText).then(JSON.parse);
      }, blob: function() {
        return Promise.resolve(new Blob([s2.response]));
      }, clone: a2, headers: { keys: function() {
        return o2;
      }, entries: function() {
        return u2;
      }, get: function(e2) {
        return i2[e2.toLowerCase()];
      }, has: function(e2) {
        return e2.toLowerCase() in i2;
      } } };
    };
    for (var l2 in s2.open(n2.method || "get", e, true), s2.onload = function() {
      s2.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e2, n3, t3) {
        o2.push(n3 = n3.toLowerCase()), u2.push([n3, t3]), i2[n3] = i2[n3] ? i2[n3] + "," + t3 : t3;
      }), t2(a2());
    }, s2.onerror = r2, s2.withCredentials = "include" == n2.credentials, n2.headers)
      s2.setRequestHeader(l2, n2.headers[l2]);
    s2.send(n2.body || null);
  });
}
var init_unfetch_module = __esm({
  "node_modules/unfetch/dist/unfetch.module.js"() {
  }
});

// node_modules/isomorphic-unfetch/browser.js
var require_browser = __commonJS({
  "node_modules/isomorphic-unfetch/browser.js"(exports, module) {
    module.exports = self.fetch || (self.fetch = (init_unfetch_module(), __toCommonJS(unfetch_module_exports)).default || (init_unfetch_module(), __toCommonJS(unfetch_module_exports)));
  }
});

// node_modules/cookie/index.js
var require_cookie = __commonJS({
  "node_modules/cookie/index.js"(exports) {
    "use strict";
    exports.parse = parse10;
    exports.serialize = serialize2;
    var decode = decodeURIComponent;
    var encode = encodeURIComponent;
    var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
    function parse10(str, options) {
      if (typeof str !== "string") {
        throw new TypeError("argument str must be a string");
      }
      var obj = {};
      var opt = options || {};
      var pairs = str.split(";");
      var dec = opt.decode || decode;
      for (var i2 = 0; i2 < pairs.length; i2++) {
        var pair = pairs[i2];
        var index = pair.indexOf("=");
        if (index < 0) {
          continue;
        }
        var key = pair.substring(0, index).trim();
        if (void 0 == obj[key]) {
          var val2 = pair.substring(index + 1, pair.length).trim();
          if (val2[0] === '"') {
            val2 = val2.slice(1, -1);
          }
          obj[key] = tryDecode(val2, dec);
        }
      }
      return obj;
    }
    function serialize2(name, val2, options) {
      var opt = options || {};
      var enc = opt.encode || encode;
      if (typeof enc !== "function") {
        throw new TypeError("option encode is invalid");
      }
      if (!fieldContentRegExp.test(name)) {
        throw new TypeError("argument name is invalid");
      }
      var value = enc(val2);
      if (value && !fieldContentRegExp.test(value)) {
        throw new TypeError("argument val is invalid");
      }
      var str = name + "=" + value;
      if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) {
          throw new TypeError("option maxAge is invalid");
        }
        str += "; Max-Age=" + Math.floor(maxAge);
      }
      if (opt.domain) {
        if (!fieldContentRegExp.test(opt.domain)) {
          throw new TypeError("option domain is invalid");
        }
        str += "; Domain=" + opt.domain;
      }
      if (opt.path) {
        if (!fieldContentRegExp.test(opt.path)) {
          throw new TypeError("option path is invalid");
        }
        str += "; Path=" + opt.path;
      }
      if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") {
          throw new TypeError("option expires is invalid");
        }
        str += "; Expires=" + opt.expires.toUTCString();
      }
      if (opt.httpOnly) {
        str += "; HttpOnly";
      }
      if (opt.secure) {
        str += "; Secure";
      }
      if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch (sameSite) {
          case true:
            str += "; SameSite=Strict";
            break;
          case "lax":
            str += "; SameSite=Lax";
            break;
          case "strict":
            str += "; SameSite=Strict";
            break;
          case "none":
            str += "; SameSite=None";
            break;
          default:
            throw new TypeError("option sameSite is invalid");
        }
      }
      return str;
    }
    function tryDecode(str, decode2) {
      try {
        return decode2(str);
      } catch (e) {
        return str;
      }
    }
  }
});

// node_modules/@aws-amplify/analytics/node_modules/uuid/lib/rng-browser.js
var require_rng_browser2 = __commonJS({
  "node_modules/@aws-amplify/analytics/node_modules/uuid/lib/rng-browser.js"(exports, module) {
    var getRandomValues2 = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
    if (getRandomValues2) {
      rnds82 = new Uint8Array(16);
      module.exports = function whatwgRNG() {
        getRandomValues2(rnds82);
        return rnds82;
      };
    } else {
      rnds = new Array(16);
      module.exports = function mathRNG() {
        for (var i2 = 0, r2; i2 < 16; i2++) {
          if ((i2 & 3) === 0)
            r2 = Math.random() * 4294967296;
          rnds[i2] = r2 >>> ((i2 & 3) << 3) & 255;
        }
        return rnds;
      };
    }
    var rnds82;
    var rnds;
  }
});

// node_modules/@aws-amplify/analytics/node_modules/uuid/lib/bytesToUuid.js
var require_bytesToUuid2 = __commonJS({
  "node_modules/@aws-amplify/analytics/node_modules/uuid/lib/bytesToUuid.js"(exports, module) {
    var byteToHex2 = [];
    for (i2 = 0; i2 < 256; ++i2) {
      byteToHex2[i2] = (i2 + 256).toString(16).substr(1);
    }
    var i2;
    function bytesToUuid(buf, offset) {
      var i3 = offset || 0;
      var bth = byteToHex2;
      return [
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        "-",
        bth[buf[i3++]],
        bth[buf[i3++]],
        "-",
        bth[buf[i3++]],
        bth[buf[i3++]],
        "-",
        bth[buf[i3++]],
        bth[buf[i3++]],
        "-",
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]]
      ].join("");
    }
    module.exports = bytesToUuid;
  }
});

// node_modules/@aws-amplify/analytics/node_modules/uuid/v1.js
var require_v12 = __commonJS({
  "node_modules/@aws-amplify/analytics/node_modules/uuid/v1.js"(exports, module) {
    var rng2 = require_rng_browser2();
    var bytesToUuid = require_bytesToUuid2();
    var _nodeId;
    var _clockseq;
    var _lastMSecs = 0;
    var _lastNSecs = 0;
    function v1(options, buf, offset) {
      var i2 = buf && offset || 0;
      var b2 = buf || [];
      options = options || {};
      var node = options.node || _nodeId;
      var clockseq = options.clockseq !== void 0 ? options.clockseq : _clockseq;
      if (node == null || clockseq == null) {
        var seedBytes = rng2();
        if (node == null) {
          node = _nodeId = [
            seedBytes[0] | 1,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
          ];
        }
        if (clockseq == null) {
          clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 16383;
        }
      }
      var msecs = options.msecs !== void 0 ? options.msecs : (/* @__PURE__ */ new Date()).getTime();
      var nsecs = options.nsecs !== void 0 ? options.nsecs : _lastNSecs + 1;
      var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 1e4;
      if (dt < 0 && options.clockseq === void 0) {
        clockseq = clockseq + 1 & 16383;
      }
      if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === void 0) {
        nsecs = 0;
      }
      if (nsecs >= 1e4) {
        throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
      }
      _lastMSecs = msecs;
      _lastNSecs = nsecs;
      _clockseq = clockseq;
      msecs += 122192928e5;
      var tl = ((msecs & 268435455) * 1e4 + nsecs) % 4294967296;
      b2[i2++] = tl >>> 24 & 255;
      b2[i2++] = tl >>> 16 & 255;
      b2[i2++] = tl >>> 8 & 255;
      b2[i2++] = tl & 255;
      var tmh = msecs / 4294967296 * 1e4 & 268435455;
      b2[i2++] = tmh >>> 8 & 255;
      b2[i2++] = tmh & 255;
      b2[i2++] = tmh >>> 24 & 15 | 16;
      b2[i2++] = tmh >>> 16 & 255;
      b2[i2++] = clockseq >>> 8 | 128;
      b2[i2++] = clockseq & 255;
      for (var n2 = 0; n2 < 6; ++n2) {
        b2[i2 + n2] = node[n2];
      }
      return buf ? buf : bytesToUuid(b2);
    }
    module.exports = v1;
  }
});

// node_modules/@aws-amplify/analytics/node_modules/uuid/v4.js
var require_v42 = __commonJS({
  "node_modules/@aws-amplify/analytics/node_modules/uuid/v4.js"(exports, module) {
    var rng2 = require_rng_browser2();
    var bytesToUuid = require_bytesToUuid2();
    function v43(options, buf, offset) {
      var i2 = buf && offset || 0;
      if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
      }
      options = options || {};
      var rnds = options.random || (options.rng || rng2)();
      rnds[6] = rnds[6] & 15 | 64;
      rnds[8] = rnds[8] & 63 | 128;
      if (buf) {
        for (var ii2 = 0; ii2 < 16; ++ii2) {
          buf[i2 + ii2] = rnds[ii2];
        }
      }
      return buf || bytesToUuid(rnds);
    }
    module.exports = v43;
  }
});

// node_modules/@aws-amplify/analytics/node_modules/uuid/index.js
var require_uuid2 = __commonJS({
  "node_modules/@aws-amplify/analytics/node_modules/uuid/index.js"(exports, module) {
    var v1 = require_v12();
    var v43 = require_v42();
    var uuid6 = v43;
    uuid6.v1 = v1;
    uuid6.v4 = v43;
    module.exports = uuid6;
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-browser/node_modules/tslib/tslib.js
var require_tslib6 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-browser/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-browser/build/isEmptyData.js
var require_isEmptyData4 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-browser/build/isEmptyData.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isEmptyData = void 0;
    function isEmptyData2(data) {
      if (typeof data === "string") {
        return data.length === 0;
      }
      return data.byteLength === 0;
    }
    exports.isEmptyData = isEmptyData2;
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-browser/build/constants.js
var require_constants4 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-browser/build/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
    exports.SHA_256_HASH = { name: "SHA-256" };
    exports.SHA_256_HMAC_ALGO = {
      name: "HMAC",
      hash: exports.SHA_256_HASH
    };
    exports.EMPTY_DATA_SHA_256 = new Uint8Array([
      227,
      176,
      196,
      66,
      152,
      252,
      28,
      20,
      154,
      251,
      244,
      200,
      153,
      111,
      185,
      36,
      39,
      174,
      65,
      228,
      100,
      155,
      147,
      76,
      164,
      149,
      153,
      27,
      120,
      82,
      184,
      85
    ]);
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-sdk/util-utf8-browser/dist/es/pureJs.js
var fromUtf87, toUtf87;
var init_pureJs3 = __esm({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-sdk/util-utf8-browser/dist/es/pureJs.js"() {
    fromUtf87 = function(input) {
      var bytes = [];
      for (var i2 = 0, len = input.length; i2 < len; i2++) {
        var value = input.charCodeAt(i2);
        if (value < 128) {
          bytes.push(value);
        } else if (value < 2048) {
          bytes.push(value >> 6 | 192, value & 63 | 128);
        } else if (i2 + 1 < input.length && (value & 64512) === 55296 && (input.charCodeAt(i2 + 1) & 64512) === 56320) {
          var surrogatePair = 65536 + ((value & 1023) << 10) + (input.charCodeAt(++i2) & 1023);
          bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else {
          bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
        }
      }
      return Uint8Array.from(bytes);
    };
    toUtf87 = function(input) {
      var decoded = "";
      for (var i2 = 0, len = input.length; i2 < len; i2++) {
        var byte = input[i2];
        if (byte < 128) {
          decoded += String.fromCharCode(byte);
        } else if (192 <= byte && byte < 224) {
          var nextByte = input[++i2];
          decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
          var surrogatePair = [byte, input[++i2], input[++i2], input[++i2]];
          var encoded = "%" + surrogatePair.map(function(byteValue) {
            return byteValue.toString(16);
          }).join("%");
          decoded += decodeURIComponent(encoded);
        } else {
          decoded += String.fromCharCode((byte & 15) << 12 | (input[++i2] & 63) << 6 | input[++i2] & 63);
        }
      }
      return decoded;
    };
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-sdk/util-utf8-browser/dist/es/whatwgEncodingApi.js
function fromUtf88(input) {
  return new TextEncoder().encode(input);
}
function toUtf88(input) {
  return new TextDecoder("utf-8").decode(input);
}
var init_whatwgEncodingApi3 = __esm({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-sdk/util-utf8-browser/dist/es/whatwgEncodingApi.js"() {
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-sdk/util-utf8-browser/dist/es/index.js
var es_exports2 = {};
__export(es_exports2, {
  fromUtf8: () => fromUtf89,
  toUtf8: () => toUtf89
});
var fromUtf89, toUtf89;
var init_es2 = __esm({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-sdk/util-utf8-browser/dist/es/index.js"() {
    init_pureJs3();
    init_whatwgEncodingApi3();
    fromUtf89 = function(input) {
      return typeof TextEncoder === "function" ? fromUtf88(input) : fromUtf87(input);
    };
    toUtf89 = function(input) {
      return typeof TextDecoder === "function" ? toUtf88(input) : toUtf87(input);
    };
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-browser/build/ie11Sha256.js
var require_ie11Sha2562 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-browser/build/ie11Sha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var isEmptyData_1 = require_isEmptyData4();
    var constants_1 = require_constants4();
    var util_utf8_browser_1 = (init_es2(), __toCommonJS(es_exports2));
    var util_locate_window_1 = (init_dist_es2(), __toCommonJS(dist_es_exports2));
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          if (secret) {
            this.operation = getKeyPromise(secret).then(function(keyData) {
              return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {
            });
          } else {
            this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
          }
        }
        Sha25613.prototype.update = function(toHash) {
          var _this = this;
          if ((0, isEmptyData_1.isEmptyData)(toHash)) {
            return;
          }
          this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
              _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
          });
          this.operation.catch(function() {
          });
        };
        Sha25613.prototype.digest = function() {
          return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
              operation.onerror = function() {
                reject(new Error("Error encountered finalizing hash"));
              };
              operation.oncomplete = function() {
                if (operation.result) {
                  resolve(new Uint8Array(operation.result));
                }
                reject(new Error("Error encountered finalizing hash"));
              };
              operation.finish();
            });
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
    function getKeyPromise(secret) {
      return new Promise(function(resolve, reject) {
        var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, ["sign"]);
        keyOperation.oncomplete = function() {
          if (keyOperation.result) {
            resolve(keyOperation.result);
          }
          reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
          reject(new Error("ImportKey failed to import key."));
        };
      });
    }
    function toArrayBufferView(data) {
      if (typeof data === "string") {
        return (0, util_utf8_browser_1.fromUtf8)(data);
      }
      if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
      }
      return new Uint8Array(data);
    }
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/util/build/convertToBuffer.js
var require_convertToBuffer3 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/util/build/convertToBuffer.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.convertToBuffer = void 0;
    var util_utf8_browser_1 = (init_es2(), __toCommonJS(es_exports2));
    var fromUtf831 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
      return Buffer.from(input, "utf8");
    } : util_utf8_browser_1.fromUtf8;
    function convertToBuffer2(data) {
      if (data instanceof Uint8Array)
        return data;
      if (typeof data === "string") {
        return fromUtf831(data);
      }
      if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
      }
      return new Uint8Array(data);
    }
    exports.convertToBuffer = convertToBuffer2;
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/util/build/isEmptyData.js
var require_isEmptyData5 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/util/build/isEmptyData.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isEmptyData = void 0;
    function isEmptyData2(data) {
      if (typeof data === "string") {
        return data.length === 0;
      }
      return data.byteLength === 0;
    }
    exports.isEmptyData = isEmptyData2;
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/util/build/numToUint8.js
var require_numToUint83 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/util/build/numToUint8.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.numToUint8 = void 0;
    function numToUint8(num) {
      return new Uint8Array([
        (num & 4278190080) >> 24,
        (num & 16711680) >> 16,
        (num & 65280) >> 8,
        num & 255
      ]);
    }
    exports.numToUint8 = numToUint8;
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/util/build/uint32ArrayFrom.js
var require_uint32ArrayFrom3 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/util/build/uint32ArrayFrom.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = void 0;
    function uint32ArrayFrom(a_lookUpTable) {
      if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while (a_index < a_lookUpTable.length) {
          return_array[a_index] = a_lookUpTable[a_index];
        }
        return return_array;
      }
      return Uint32Array.from(a_lookUpTable);
    }
    exports.uint32ArrayFrom = uint32ArrayFrom;
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/util/build/index.js
var require_build8 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/util/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
    var convertToBuffer_1 = require_convertToBuffer3();
    Object.defineProperty(exports, "convertToBuffer", { enumerable: true, get: function() {
      return convertToBuffer_1.convertToBuffer;
    } });
    var isEmptyData_1 = require_isEmptyData5();
    Object.defineProperty(exports, "isEmptyData", { enumerable: true, get: function() {
      return isEmptyData_1.isEmptyData;
    } });
    var numToUint8_1 = require_numToUint83();
    Object.defineProperty(exports, "numToUint8", { enumerable: true, get: function() {
      return numToUint8_1.numToUint8;
    } });
    var uint32ArrayFrom_1 = require_uint32ArrayFrom3();
    Object.defineProperty(exports, "uint32ArrayFrom", { enumerable: true, get: function() {
      return uint32ArrayFrom_1.uint32ArrayFrom;
    } });
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-browser/build/webCryptoSha256.js
var require_webCryptoSha2562 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-browser/build/webCryptoSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var util_1 = require_build8();
    var constants_1 = require_constants4();
    var util_locate_window_1 = (init_dist_es2(), __toCommonJS(dist_es_exports2));
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          this.toHash = new Uint8Array(0);
          if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
              (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(secret), constants_1.SHA_256_HMAC_ALGO, false, ["sign"]).then(resolve, reject);
            });
            this.key.catch(function() {
            });
          }
        }
        Sha25613.prototype.update = function(data) {
          if ((0, util_1.isEmptyData)(data)) {
            return;
          }
          var update = (0, util_1.convertToBuffer)(data);
          var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
          typedArray.set(this.toHash, 0);
          typedArray.set(update, this.toHash.byteLength);
          this.toHash = typedArray;
        };
        Sha25613.prototype.digest = function() {
          var _this = this;
          if (this.key) {
            return this.key.then(function(key) {
              return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
              });
            });
          }
          if ((0, util_1.isEmptyData)(this.toHash)) {
            return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
          }
          return Promise.resolve().then(function() {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
          }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-js/node_modules/tslib/tslib.js
var require_tslib7 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-js/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-js/build/constants.js
var require_constants5 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-js/build/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
    exports.BLOCK_SIZE = 64;
    exports.DIGEST_LENGTH = 32;
    exports.KEY = new Uint32Array([
      1116352408,
      1899447441,
      3049323471,
      3921009573,
      961987163,
      1508970993,
      2453635748,
      2870763221,
      3624381080,
      310598401,
      607225278,
      1426881987,
      1925078388,
      2162078206,
      2614888103,
      3248222580,
      3835390401,
      4022224774,
      264347078,
      604807628,
      770255983,
      1249150122,
      1555081692,
      1996064986,
      2554220882,
      2821834349,
      2952996808,
      3210313671,
      3336571891,
      3584528711,
      113926993,
      338241895,
      666307205,
      773529912,
      1294757372,
      1396182291,
      1695183700,
      1986661051,
      2177026350,
      2456956037,
      2730485921,
      2820302411,
      3259730800,
      3345764771,
      3516065817,
      3600352804,
      4094571909,
      275423344,
      430227734,
      506948616,
      659060556,
      883997877,
      958139571,
      1322822218,
      1537002063,
      1747873779,
      1955562222,
      2024104815,
      2227730452,
      2361852424,
      2428436474,
      2756734187,
      3204031479,
      3329325298
    ]);
    exports.INIT = [
      1779033703,
      3144134277,
      1013904242,
      2773480762,
      1359893119,
      2600822924,
      528734635,
      1541459225
    ];
    exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-js/build/RawSha256.js
var require_RawSha2563 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-js/build/RawSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.RawSha256 = void 0;
    var constants_1 = require_constants5();
    var RawSha256 = (
      /** @class */
      function() {
        function RawSha2562() {
          this.state = Int32Array.from(constants_1.INIT);
          this.temp = new Int32Array(64);
          this.buffer = new Uint8Array(64);
          this.bufferLength = 0;
          this.bytesHashed = 0;
          this.finished = false;
        }
        RawSha2562.prototype.update = function(data) {
          if (this.finished) {
            throw new Error("Attempted to update an already finished hash.");
          }
          var position = 0;
          var byteLength2 = data.byteLength;
          this.bytesHashed += byteLength2;
          if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) {
            throw new Error("Cannot hash more than 2^53 - 1 bits");
          }
          while (byteLength2 > 0) {
            this.buffer[this.bufferLength++] = data[position++];
            byteLength2--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
              this.hashBuffer();
              this.bufferLength = 0;
            }
          }
        };
        RawSha2562.prototype.digest = function() {
          if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 128);
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
              for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE; i2++) {
                bufferView.setUint8(i2, 0);
              }
              this.hashBuffer();
              this.bufferLength = 0;
            }
            for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE - 8; i2++) {
              bufferView.setUint8(i2, 0);
            }
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 4294967296), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
          }
          var out = new Uint8Array(constants_1.DIGEST_LENGTH);
          for (var i2 = 0; i2 < 8; i2++) {
            out[i2 * 4] = this.state[i2] >>> 24 & 255;
            out[i2 * 4 + 1] = this.state[i2] >>> 16 & 255;
            out[i2 * 4 + 2] = this.state[i2] >>> 8 & 255;
            out[i2 * 4 + 3] = this.state[i2] >>> 0 & 255;
          }
          return out;
        };
        RawSha2562.prototype.hashBuffer = function() {
          var _a2 = this, buffer = _a2.buffer, state = _a2.state;
          var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
          for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
            if (i2 < 16) {
              this.temp[i2] = (buffer[i2 * 4] & 255) << 24 | (buffer[i2 * 4 + 1] & 255) << 16 | (buffer[i2 * 4 + 2] & 255) << 8 | buffer[i2 * 4 + 3] & 255;
            } else {
              var u2 = this.temp[i2 - 2];
              var t1_1 = (u2 >>> 17 | u2 << 15) ^ (u2 >>> 19 | u2 << 13) ^ u2 >>> 10;
              u2 = this.temp[i2 - 15];
              var t2_1 = (u2 >>> 7 | u2 << 25) ^ (u2 >>> 18 | u2 << 14) ^ u2 >>> 3;
              this.temp[i2] = (t1_1 + this.temp[i2 - 7] | 0) + (t2_1 + this.temp[i2 - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i2] + this.temp[i2] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
          }
          state[0] += state0;
          state[1] += state1;
          state[2] += state2;
          state[3] += state3;
          state[4] += state4;
          state[5] += state5;
          state[6] += state6;
          state[7] += state7;
        };
        return RawSha2562;
      }()
    );
    exports.RawSha256 = RawSha256;
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-js/build/jsSha256.js
var require_jsSha2563 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-js/build/jsSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var tslib_1 = require_tslib7();
    var constants_1 = require_constants5();
    var RawSha256_1 = require_RawSha2563();
    var util_1 = require_build8();
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          this.hash = new RawSha256_1.RawSha256();
          if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
              inner[i2] ^= 54;
              outer[i2] ^= 92;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            for (var i2 = 0; i2 < inner.byteLength; i2++) {
              inner[i2] = 0;
            }
          }
        }
        Sha25613.prototype.update = function(toHash) {
          if ((0, util_1.isEmptyData)(toHash) || this.error) {
            return;
          }
          try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
          } catch (e) {
            this.error = e;
          }
        };
        Sha25613.prototype.digestSync = function() {
          if (this.error) {
            throw this.error;
          }
          if (this.outer) {
            if (!this.outer.finished) {
              this.outer.update(this.hash.digest());
            }
            return this.outer.digest();
          }
          return this.hash.digest();
        };
        Sha25613.prototype.digest = function() {
          return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a2) {
              return [2, this.digestSync()];
            });
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
    function bufferFromSecret(secret) {
      var input = (0, util_1.convertToBuffer)(secret);
      if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
      }
      var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
      buffer.set(input);
      return buffer;
    }
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-js/build/index.js
var require_build9 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-js/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib7();
    (0, tslib_1.__exportStar)(require_jsSha2563(), exports);
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/supports-web-crypto/node_modules/tslib/tslib.js
var require_tslib8 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/supports-web-crypto/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/supports-web-crypto/build/supportsWebCrypto.js
var require_supportsWebCrypto2 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/supports-web-crypto/build/supportsWebCrypto.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
    var tslib_1 = require_tslib8();
    var subtleCryptoMethods = [
      "decrypt",
      "digest",
      "encrypt",
      "exportKey",
      "generateKey",
      "importKey",
      "sign",
      "verify"
    ];
    function supportsWebCrypto(window2) {
      if (supportsSecureRandom(window2) && typeof window2.crypto.subtle === "object") {
        var subtle = window2.crypto.subtle;
        return supportsSubtleCrypto(subtle);
      }
      return false;
    }
    exports.supportsWebCrypto = supportsWebCrypto;
    function supportsSecureRandom(window2) {
      if (typeof window2 === "object" && typeof window2.crypto === "object") {
        var getRandomValues2 = window2.crypto.getRandomValues;
        return typeof getRandomValues2 === "function";
      }
      return false;
    }
    exports.supportsSecureRandom = supportsSecureRandom;
    function supportsSubtleCrypto(subtle) {
      return subtle && subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
      });
    }
    exports.supportsSubtleCrypto = supportsSubtleCrypto;
    function supportsZeroByteGCM(subtle) {
      return tslib_1.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a2;
        return tslib_1.__generator(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              if (!supportsSubtleCrypto(subtle))
                return [2, false];
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 4, , 5]);
              return [4, subtle.generateKey({ name: "AES-GCM", length: 128 }, false, ["encrypt"])];
            case 2:
              key = _b2.sent();
              return [4, subtle.encrypt({
                name: "AES-GCM",
                iv: new Uint8Array(Array(12)),
                additionalData: new Uint8Array(Array(16)),
                tagLength: 128
              }, key, new Uint8Array(0))];
            case 3:
              zeroByteAuthTag = _b2.sent();
              return [2, zeroByteAuthTag.byteLength === 16];
            case 4:
              _a2 = _b2.sent();
              return [2, false];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }
    exports.supportsZeroByteGCM = supportsZeroByteGCM;
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/supports-web-crypto/build/index.js
var require_build10 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/supports-web-crypto/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib8();
    tslib_1.__exportStar(require_supportsWebCrypto2(), exports);
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/ie11-detection/node_modules/tslib/tslib.js
var require_tslib9 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/ie11-detection/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/ie11-detection/build/CryptoOperation.js
var require_CryptoOperation2 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/ie11-detection/build/CryptoOperation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/ie11-detection/build/Key.js
var require_Key2 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/ie11-detection/build/Key.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/ie11-detection/build/KeyOperation.js
var require_KeyOperation2 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/ie11-detection/build/KeyOperation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/ie11-detection/build/MsSubtleCrypto.js
var require_MsSubtleCrypto2 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/ie11-detection/build/MsSubtleCrypto.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/ie11-detection/build/MsWindow.js
var require_MsWindow2 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/ie11-detection/build/MsWindow.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isMsWindow = void 0;
    var msSubtleCryptoMethods = [
      "decrypt",
      "digest",
      "encrypt",
      "exportKey",
      "generateKey",
      "importKey",
      "sign",
      "verify"
    ];
    function quacksLikeAnMsWindow(window2) {
      return "MSInputMethodContext" in window2 && "msCrypto" in window2;
    }
    function isMsWindow(window2) {
      if (quacksLikeAnMsWindow(window2) && window2.msCrypto.subtle !== void 0) {
        var _a2 = window2.msCrypto, getRandomValues2 = _a2.getRandomValues, subtle_1 = _a2.subtle;
        return msSubtleCryptoMethods.map(function(methodName) {
          return subtle_1[methodName];
        }).concat(getRandomValues2).every(function(method) {
          return typeof method === "function";
        });
      }
      return false;
    }
    exports.isMsWindow = isMsWindow;
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/ie11-detection/build/index.js
var require_build11 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/ie11-detection/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib9();
    tslib_1.__exportStar(require_CryptoOperation2(), exports);
    tslib_1.__exportStar(require_Key2(), exports);
    tslib_1.__exportStar(require_KeyOperation2(), exports);
    tslib_1.__exportStar(require_MsSubtleCrypto2(), exports);
    tslib_1.__exportStar(require_MsWindow2(), exports);
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-browser/build/crossPlatformSha256.js
var require_crossPlatformSha2562 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-browser/build/crossPlatformSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var ie11Sha256_1 = require_ie11Sha2562();
    var webCryptoSha256_1 = require_webCryptoSha2562();
    var sha256_js_1 = require_build9();
    var supports_web_crypto_1 = require_build10();
    var ie11_detection_1 = require_build11();
    var util_locate_window_1 = (init_dist_es2(), __toCommonJS(dist_es_exports2));
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) {
            this.hash = new webCryptoSha256_1.Sha256(secret);
          } else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) {
            this.hash = new ie11Sha256_1.Sha256(secret);
          } else {
            this.hash = new sha256_js_1.Sha256(secret);
          }
        }
        Sha25613.prototype.update = function(data, encoding) {
          this.hash.update(data, encoding);
        };
        Sha25613.prototype.digest = function() {
          return this.hash.digest();
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
  }
});

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-browser/build/index.js
var require_build12 = __commonJS({
  "node_modules/@aws-sdk/client-kinesis/node_modules/@aws-crypto/sha256-browser/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
    var tslib_1 = require_tslib6();
    (0, tslib_1.__exportStar)(require_crossPlatformSha2562(), exports);
    var ie11Sha256_1 = require_ie11Sha2562();
    Object.defineProperty(exports, "Ie11Sha256", { enumerable: true, get: function() {
      return ie11Sha256_1.Sha256;
    } });
    var webCryptoSha256_1 = require_webCryptoSha2562();
    Object.defineProperty(exports, "WebCryptoSha256", { enumerable: true, get: function() {
      return webCryptoSha256_1.Sha256;
    } });
  }
});

// node_modules/@aws-sdk/eventstream-marshaller/node_modules/tslib/tslib.js
var require_tslib10 = __commonJS({
  "node_modules/@aws-sdk/eventstream-marshaller/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/eventstream-marshaller/node_modules/@aws-crypto/util/build/convertToBuffer.js
var require_convertToBuffer4 = __commonJS({
  "node_modules/@aws-sdk/eventstream-marshaller/node_modules/@aws-crypto/util/build/convertToBuffer.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.convertToBuffer = void 0;
    var util_utf8_browser_1 = (init_dist_es(), __toCommonJS(dist_es_exports));
    var fromUtf831 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
      return Buffer.from(input, "utf8");
    } : util_utf8_browser_1.fromUtf8;
    function convertToBuffer2(data) {
      if (data instanceof Uint8Array)
        return data;
      if (typeof data === "string") {
        return fromUtf831(data);
      }
      if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
      }
      return new Uint8Array(data);
    }
    exports.convertToBuffer = convertToBuffer2;
  }
});

// node_modules/@aws-sdk/eventstream-marshaller/node_modules/@aws-crypto/util/build/isEmptyData.js
var require_isEmptyData6 = __commonJS({
  "node_modules/@aws-sdk/eventstream-marshaller/node_modules/@aws-crypto/util/build/isEmptyData.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isEmptyData = void 0;
    function isEmptyData2(data) {
      if (typeof data === "string") {
        return data.length === 0;
      }
      return data.byteLength === 0;
    }
    exports.isEmptyData = isEmptyData2;
  }
});

// node_modules/@aws-sdk/eventstream-marshaller/node_modules/@aws-crypto/util/build/numToUint8.js
var require_numToUint84 = __commonJS({
  "node_modules/@aws-sdk/eventstream-marshaller/node_modules/@aws-crypto/util/build/numToUint8.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.numToUint8 = void 0;
    function numToUint8(num) {
      return new Uint8Array([
        (num & 4278190080) >> 24,
        (num & 16711680) >> 16,
        (num & 65280) >> 8,
        num & 255
      ]);
    }
    exports.numToUint8 = numToUint8;
  }
});

// node_modules/@aws-sdk/eventstream-marshaller/node_modules/@aws-crypto/util/build/uint32ArrayFrom.js
var require_uint32ArrayFrom4 = __commonJS({
  "node_modules/@aws-sdk/eventstream-marshaller/node_modules/@aws-crypto/util/build/uint32ArrayFrom.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = void 0;
    function uint32ArrayFrom(a_lookUpTable) {
      if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while (a_index < a_lookUpTable.length) {
          return_array[a_index] = a_lookUpTable[a_index];
        }
        return return_array;
      }
      return Uint32Array.from(a_lookUpTable);
    }
    exports.uint32ArrayFrom = uint32ArrayFrom;
  }
});

// node_modules/@aws-sdk/eventstream-marshaller/node_modules/@aws-crypto/util/build/index.js
var require_build13 = __commonJS({
  "node_modules/@aws-sdk/eventstream-marshaller/node_modules/@aws-crypto/util/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
    var convertToBuffer_1 = require_convertToBuffer4();
    Object.defineProperty(exports, "convertToBuffer", { enumerable: true, get: function() {
      return convertToBuffer_1.convertToBuffer;
    } });
    var isEmptyData_1 = require_isEmptyData6();
    Object.defineProperty(exports, "isEmptyData", { enumerable: true, get: function() {
      return isEmptyData_1.isEmptyData;
    } });
    var numToUint8_1 = require_numToUint84();
    Object.defineProperty(exports, "numToUint8", { enumerable: true, get: function() {
      return numToUint8_1.numToUint8;
    } });
    var uint32ArrayFrom_1 = require_uint32ArrayFrom4();
    Object.defineProperty(exports, "uint32ArrayFrom", { enumerable: true, get: function() {
      return uint32ArrayFrom_1.uint32ArrayFrom;
    } });
  }
});

// node_modules/@aws-sdk/eventstream-marshaller/node_modules/@aws-crypto/crc32/build/aws_crc32.js
var require_aws_crc32 = __commonJS({
  "node_modules/@aws-sdk/eventstream-marshaller/node_modules/@aws-crypto/crc32/build/aws_crc32.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AwsCrc32 = void 0;
    var tslib_1 = require_tslib10();
    var util_1 = require_build13();
    var index_1 = require_build14();
    var AwsCrc32 = (
      /** @class */
      function() {
        function AwsCrc322() {
          this.crc32 = new index_1.Crc32();
        }
        AwsCrc322.prototype.update = function(toHash) {
          if ((0, util_1.isEmptyData)(toHash))
            return;
          this.crc32.update((0, util_1.convertToBuffer)(toHash));
        };
        AwsCrc322.prototype.digest = function() {
          return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a2) {
              return [2, (0, util_1.numToUint8)(this.crc32.digest())];
            });
          });
        };
        return AwsCrc322;
      }()
    );
    exports.AwsCrc32 = AwsCrc32;
  }
});

// node_modules/@aws-sdk/eventstream-marshaller/node_modules/@aws-crypto/crc32/build/index.js
var require_build14 = __commonJS({
  "node_modules/@aws-sdk/eventstream-marshaller/node_modules/@aws-crypto/crc32/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AwsCrc32 = exports.Crc32 = exports.crc32 = void 0;
    var tslib_1 = require_tslib10();
    var util_1 = require_build13();
    function crc32(data) {
      return new Crc323().update(data).digest();
    }
    exports.crc32 = crc32;
    var Crc323 = (
      /** @class */
      function() {
        function Crc324() {
          this.checksum = 4294967295;
        }
        Crc324.prototype.update = function(data) {
          var e_1, _a2;
          try {
            for (var data_1 = (0, tslib_1.__values)(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
              var byte = data_1_1.value;
              this.checksum = this.checksum >>> 8 ^ lookupTable[(this.checksum ^ byte) & 255];
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (data_1_1 && !data_1_1.done && (_a2 = data_1.return))
                _a2.call(data_1);
            } finally {
              if (e_1)
                throw e_1.error;
            }
          }
          return this;
        };
        Crc324.prototype.digest = function() {
          return (this.checksum ^ 4294967295) >>> 0;
        };
        return Crc324;
      }()
    );
    exports.Crc32 = Crc323;
    var a_lookUpTable = [
      0,
      1996959894,
      3993919788,
      2567524794,
      124634137,
      1886057615,
      3915621685,
      2657392035,
      249268274,
      2044508324,
      3772115230,
      2547177864,
      162941995,
      2125561021,
      3887607047,
      2428444049,
      498536548,
      1789927666,
      4089016648,
      2227061214,
      450548861,
      1843258603,
      4107580753,
      2211677639,
      325883990,
      1684777152,
      4251122042,
      2321926636,
      335633487,
      1661365465,
      4195302755,
      2366115317,
      997073096,
      1281953886,
      3579855332,
      2724688242,
      1006888145,
      1258607687,
      3524101629,
      2768942443,
      901097722,
      1119000684,
      3686517206,
      2898065728,
      853044451,
      1172266101,
      3705015759,
      2882616665,
      651767980,
      1373503546,
      3369554304,
      3218104598,
      565507253,
      1454621731,
      3485111705,
      3099436303,
      671266974,
      1594198024,
      3322730930,
      2970347812,
      795835527,
      1483230225,
      3244367275,
      3060149565,
      1994146192,
      31158534,
      2563907772,
      4023717930,
      1907459465,
      112637215,
      2680153253,
      3904427059,
      2013776290,
      251722036,
      2517215374,
      3775830040,
      2137656763,
      141376813,
      2439277719,
      3865271297,
      1802195444,
      476864866,
      2238001368,
      4066508878,
      1812370925,
      453092731,
      2181625025,
      4111451223,
      1706088902,
      314042704,
      2344532202,
      4240017532,
      1658658271,
      366619977,
      2362670323,
      4224994405,
      1303535960,
      984961486,
      2747007092,
      3569037538,
      1256170817,
      1037604311,
      2765210733,
      3554079995,
      1131014506,
      879679996,
      2909243462,
      3663771856,
      1141124467,
      855842277,
      2852801631,
      3708648649,
      1342533948,
      654459306,
      3188396048,
      3373015174,
      1466479909,
      544179635,
      3110523913,
      3462522015,
      1591671054,
      702138776,
      2966460450,
      3352799412,
      1504918807,
      783551873,
      3082640443,
      3233442989,
      3988292384,
      2596254646,
      62317068,
      1957810842,
      3939845945,
      2647816111,
      81470997,
      1943803523,
      3814918930,
      2489596804,
      225274430,
      2053790376,
      3826175755,
      2466906013,
      167816743,
      2097651377,
      4027552580,
      2265490386,
      503444072,
      1762050814,
      4150417245,
      2154129355,
      426522225,
      1852507879,
      4275313526,
      2312317920,
      282753626,
      1742555852,
      4189708143,
      2394877945,
      397917763,
      1622183637,
      3604390888,
      2714866558,
      953729732,
      1340076626,
      3518719985,
      2797360999,
      1068828381,
      1219638859,
      3624741850,
      2936675148,
      906185462,
      1090812512,
      3747672003,
      2825379669,
      829329135,
      1181335161,
      3412177804,
      3160834842,
      628085408,
      1382605366,
      3423369109,
      3138078467,
      570562233,
      1426400815,
      3317316542,
      2998733608,
      733239954,
      1555261956,
      3268935591,
      3050360625,
      752459403,
      1541320221,
      2607071920,
      3965973030,
      1969922972,
      40735498,
      2617837225,
      3943577151,
      1913087877,
      83908371,
      2512341634,
      3803740692,
      2075208622,
      213261112,
      2463272603,
      3855990285,
      2094854071,
      198958881,
      2262029012,
      4057260610,
      1759359992,
      534414190,
      2176718541,
      4139329115,
      1873836001,
      414664567,
      2282248934,
      4279200368,
      1711684554,
      285281116,
      2405801727,
      4167216745,
      1634467795,
      376229701,
      2685067896,
      3608007406,
      1308918612,
      956543938,
      2808555105,
      3495958263,
      1231636301,
      1047427035,
      2932959818,
      3654703836,
      1088359270,
      936918e3,
      2847714899,
      3736837829,
      1202900863,
      817233897,
      3183342108,
      3401237130,
      1404277552,
      615818150,
      3134207493,
      3453421203,
      1423857449,
      601450431,
      3009837614,
      3294710456,
      1567103746,
      711928724,
      3020668471,
      3272380065,
      1510334235,
      755167117
    ];
    var lookupTable = (0, util_1.uint32ArrayFrom)(a_lookUpTable);
    var aws_crc32_1 = require_aws_crc32();
    Object.defineProperty(exports, "AwsCrc32", { enumerable: true, get: function() {
      return aws_crc32_1.AwsCrc32;
    } });
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-browser/node_modules/tslib/tslib.js
var require_tslib11 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-browser/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-browser/build/isEmptyData.js
var require_isEmptyData7 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-browser/build/isEmptyData.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isEmptyData = void 0;
    function isEmptyData2(data) {
      if (typeof data === "string") {
        return data.length === 0;
      }
      return data.byteLength === 0;
    }
    exports.isEmptyData = isEmptyData2;
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-browser/build/constants.js
var require_constants6 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-browser/build/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
    exports.SHA_256_HASH = { name: "SHA-256" };
    exports.SHA_256_HMAC_ALGO = {
      name: "HMAC",
      hash: exports.SHA_256_HASH
    };
    exports.EMPTY_DATA_SHA_256 = new Uint8Array([
      227,
      176,
      196,
      66,
      152,
      252,
      28,
      20,
      154,
      251,
      244,
      200,
      153,
      111,
      185,
      36,
      39,
      174,
      65,
      228,
      100,
      155,
      147,
      76,
      164,
      149,
      153,
      27,
      120,
      82,
      184,
      85
    ]);
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-sdk/util-utf8-browser/dist/es/pureJs.js
var fromUtf813, toUtf812;
var init_pureJs4 = __esm({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-sdk/util-utf8-browser/dist/es/pureJs.js"() {
    fromUtf813 = function(input) {
      var bytes = [];
      for (var i2 = 0, len = input.length; i2 < len; i2++) {
        var value = input.charCodeAt(i2);
        if (value < 128) {
          bytes.push(value);
        } else if (value < 2048) {
          bytes.push(value >> 6 | 192, value & 63 | 128);
        } else if (i2 + 1 < input.length && (value & 64512) === 55296 && (input.charCodeAt(i2 + 1) & 64512) === 56320) {
          var surrogatePair = 65536 + ((value & 1023) << 10) + (input.charCodeAt(++i2) & 1023);
          bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else {
          bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
        }
      }
      return Uint8Array.from(bytes);
    };
    toUtf812 = function(input) {
      var decoded = "";
      for (var i2 = 0, len = input.length; i2 < len; i2++) {
        var byte = input[i2];
        if (byte < 128) {
          decoded += String.fromCharCode(byte);
        } else if (192 <= byte && byte < 224) {
          var nextByte = input[++i2];
          decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
          var surrogatePair = [byte, input[++i2], input[++i2], input[++i2]];
          var encoded = "%" + surrogatePair.map(function(byteValue) {
            return byteValue.toString(16);
          }).join("%");
          decoded += decodeURIComponent(encoded);
        } else {
          decoded += String.fromCharCode((byte & 15) << 12 | (input[++i2] & 63) << 6 | input[++i2] & 63);
        }
      }
      return decoded;
    };
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-sdk/util-utf8-browser/dist/es/whatwgEncodingApi.js
function fromUtf814(input) {
  return new TextEncoder().encode(input);
}
function toUtf813(input) {
  return new TextDecoder("utf-8").decode(input);
}
var init_whatwgEncodingApi4 = __esm({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-sdk/util-utf8-browser/dist/es/whatwgEncodingApi.js"() {
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-sdk/util-utf8-browser/dist/es/index.js
var es_exports3 = {};
__export(es_exports3, {
  fromUtf8: () => fromUtf815,
  toUtf8: () => toUtf814
});
var fromUtf815, toUtf814;
var init_es3 = __esm({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-sdk/util-utf8-browser/dist/es/index.js"() {
    init_pureJs4();
    init_whatwgEncodingApi4();
    fromUtf815 = function(input) {
      return typeof TextEncoder === "function" ? fromUtf814(input) : fromUtf813(input);
    };
    toUtf814 = function(input) {
      return typeof TextDecoder === "function" ? toUtf813(input) : toUtf812(input);
    };
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-browser/build/ie11Sha256.js
var require_ie11Sha2563 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-browser/build/ie11Sha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var isEmptyData_1 = require_isEmptyData7();
    var constants_1 = require_constants6();
    var util_utf8_browser_1 = (init_es3(), __toCommonJS(es_exports3));
    var util_locate_window_1 = (init_dist_es2(), __toCommonJS(dist_es_exports2));
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          if (secret) {
            this.operation = getKeyPromise(secret).then(function(keyData) {
              return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {
            });
          } else {
            this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
          }
        }
        Sha25613.prototype.update = function(toHash) {
          var _this = this;
          if ((0, isEmptyData_1.isEmptyData)(toHash)) {
            return;
          }
          this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
              _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
          });
          this.operation.catch(function() {
          });
        };
        Sha25613.prototype.digest = function() {
          return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
              operation.onerror = function() {
                reject(new Error("Error encountered finalizing hash"));
              };
              operation.oncomplete = function() {
                if (operation.result) {
                  resolve(new Uint8Array(operation.result));
                }
                reject(new Error("Error encountered finalizing hash"));
              };
              operation.finish();
            });
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
    function getKeyPromise(secret) {
      return new Promise(function(resolve, reject) {
        var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, ["sign"]);
        keyOperation.oncomplete = function() {
          if (keyOperation.result) {
            resolve(keyOperation.result);
          }
          reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
          reject(new Error("ImportKey failed to import key."));
        };
      });
    }
    function toArrayBufferView(data) {
      if (typeof data === "string") {
        return (0, util_utf8_browser_1.fromUtf8)(data);
      }
      if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
      }
      return new Uint8Array(data);
    }
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/util/build/convertToBuffer.js
var require_convertToBuffer5 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/util/build/convertToBuffer.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.convertToBuffer = void 0;
    var util_utf8_browser_1 = (init_es3(), __toCommonJS(es_exports3));
    var fromUtf831 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
      return Buffer.from(input, "utf8");
    } : util_utf8_browser_1.fromUtf8;
    function convertToBuffer2(data) {
      if (data instanceof Uint8Array)
        return data;
      if (typeof data === "string") {
        return fromUtf831(data);
      }
      if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
      }
      return new Uint8Array(data);
    }
    exports.convertToBuffer = convertToBuffer2;
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/util/build/isEmptyData.js
var require_isEmptyData8 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/util/build/isEmptyData.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isEmptyData = void 0;
    function isEmptyData2(data) {
      if (typeof data === "string") {
        return data.length === 0;
      }
      return data.byteLength === 0;
    }
    exports.isEmptyData = isEmptyData2;
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/util/build/numToUint8.js
var require_numToUint85 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/util/build/numToUint8.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.numToUint8 = void 0;
    function numToUint8(num) {
      return new Uint8Array([
        (num & 4278190080) >> 24,
        (num & 16711680) >> 16,
        (num & 65280) >> 8,
        num & 255
      ]);
    }
    exports.numToUint8 = numToUint8;
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/util/build/uint32ArrayFrom.js
var require_uint32ArrayFrom5 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/util/build/uint32ArrayFrom.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = void 0;
    function uint32ArrayFrom(a_lookUpTable) {
      if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while (a_index < a_lookUpTable.length) {
          return_array[a_index] = a_lookUpTable[a_index];
        }
        return return_array;
      }
      return Uint32Array.from(a_lookUpTable);
    }
    exports.uint32ArrayFrom = uint32ArrayFrom;
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/util/build/index.js
var require_build15 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/util/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
    var convertToBuffer_1 = require_convertToBuffer5();
    Object.defineProperty(exports, "convertToBuffer", { enumerable: true, get: function() {
      return convertToBuffer_1.convertToBuffer;
    } });
    var isEmptyData_1 = require_isEmptyData8();
    Object.defineProperty(exports, "isEmptyData", { enumerable: true, get: function() {
      return isEmptyData_1.isEmptyData;
    } });
    var numToUint8_1 = require_numToUint85();
    Object.defineProperty(exports, "numToUint8", { enumerable: true, get: function() {
      return numToUint8_1.numToUint8;
    } });
    var uint32ArrayFrom_1 = require_uint32ArrayFrom5();
    Object.defineProperty(exports, "uint32ArrayFrom", { enumerable: true, get: function() {
      return uint32ArrayFrom_1.uint32ArrayFrom;
    } });
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-browser/build/webCryptoSha256.js
var require_webCryptoSha2563 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-browser/build/webCryptoSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var util_1 = require_build15();
    var constants_1 = require_constants6();
    var util_locate_window_1 = (init_dist_es2(), __toCommonJS(dist_es_exports2));
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          this.toHash = new Uint8Array(0);
          if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
              (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(secret), constants_1.SHA_256_HMAC_ALGO, false, ["sign"]).then(resolve, reject);
            });
            this.key.catch(function() {
            });
          }
        }
        Sha25613.prototype.update = function(data) {
          if ((0, util_1.isEmptyData)(data)) {
            return;
          }
          var update = (0, util_1.convertToBuffer)(data);
          var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
          typedArray.set(this.toHash, 0);
          typedArray.set(update, this.toHash.byteLength);
          this.toHash = typedArray;
        };
        Sha25613.prototype.digest = function() {
          var _this = this;
          if (this.key) {
            return this.key.then(function(key) {
              return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
              });
            });
          }
          if ((0, util_1.isEmptyData)(this.toHash)) {
            return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
          }
          return Promise.resolve().then(function() {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
          }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-js/node_modules/tslib/tslib.js
var require_tslib12 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-js/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-js/build/constants.js
var require_constants7 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-js/build/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
    exports.BLOCK_SIZE = 64;
    exports.DIGEST_LENGTH = 32;
    exports.KEY = new Uint32Array([
      1116352408,
      1899447441,
      3049323471,
      3921009573,
      961987163,
      1508970993,
      2453635748,
      2870763221,
      3624381080,
      310598401,
      607225278,
      1426881987,
      1925078388,
      2162078206,
      2614888103,
      3248222580,
      3835390401,
      4022224774,
      264347078,
      604807628,
      770255983,
      1249150122,
      1555081692,
      1996064986,
      2554220882,
      2821834349,
      2952996808,
      3210313671,
      3336571891,
      3584528711,
      113926993,
      338241895,
      666307205,
      773529912,
      1294757372,
      1396182291,
      1695183700,
      1986661051,
      2177026350,
      2456956037,
      2730485921,
      2820302411,
      3259730800,
      3345764771,
      3516065817,
      3600352804,
      4094571909,
      275423344,
      430227734,
      506948616,
      659060556,
      883997877,
      958139571,
      1322822218,
      1537002063,
      1747873779,
      1955562222,
      2024104815,
      2227730452,
      2361852424,
      2428436474,
      2756734187,
      3204031479,
      3329325298
    ]);
    exports.INIT = [
      1779033703,
      3144134277,
      1013904242,
      2773480762,
      1359893119,
      2600822924,
      528734635,
      1541459225
    ];
    exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-js/build/RawSha256.js
var require_RawSha2564 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-js/build/RawSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.RawSha256 = void 0;
    var constants_1 = require_constants7();
    var RawSha256 = (
      /** @class */
      function() {
        function RawSha2562() {
          this.state = Int32Array.from(constants_1.INIT);
          this.temp = new Int32Array(64);
          this.buffer = new Uint8Array(64);
          this.bufferLength = 0;
          this.bytesHashed = 0;
          this.finished = false;
        }
        RawSha2562.prototype.update = function(data) {
          if (this.finished) {
            throw new Error("Attempted to update an already finished hash.");
          }
          var position = 0;
          var byteLength2 = data.byteLength;
          this.bytesHashed += byteLength2;
          if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) {
            throw new Error("Cannot hash more than 2^53 - 1 bits");
          }
          while (byteLength2 > 0) {
            this.buffer[this.bufferLength++] = data[position++];
            byteLength2--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
              this.hashBuffer();
              this.bufferLength = 0;
            }
          }
        };
        RawSha2562.prototype.digest = function() {
          if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 128);
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
              for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE; i2++) {
                bufferView.setUint8(i2, 0);
              }
              this.hashBuffer();
              this.bufferLength = 0;
            }
            for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE - 8; i2++) {
              bufferView.setUint8(i2, 0);
            }
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 4294967296), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
          }
          var out = new Uint8Array(constants_1.DIGEST_LENGTH);
          for (var i2 = 0; i2 < 8; i2++) {
            out[i2 * 4] = this.state[i2] >>> 24 & 255;
            out[i2 * 4 + 1] = this.state[i2] >>> 16 & 255;
            out[i2 * 4 + 2] = this.state[i2] >>> 8 & 255;
            out[i2 * 4 + 3] = this.state[i2] >>> 0 & 255;
          }
          return out;
        };
        RawSha2562.prototype.hashBuffer = function() {
          var _a2 = this, buffer = _a2.buffer, state = _a2.state;
          var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
          for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
            if (i2 < 16) {
              this.temp[i2] = (buffer[i2 * 4] & 255) << 24 | (buffer[i2 * 4 + 1] & 255) << 16 | (buffer[i2 * 4 + 2] & 255) << 8 | buffer[i2 * 4 + 3] & 255;
            } else {
              var u2 = this.temp[i2 - 2];
              var t1_1 = (u2 >>> 17 | u2 << 15) ^ (u2 >>> 19 | u2 << 13) ^ u2 >>> 10;
              u2 = this.temp[i2 - 15];
              var t2_1 = (u2 >>> 7 | u2 << 25) ^ (u2 >>> 18 | u2 << 14) ^ u2 >>> 3;
              this.temp[i2] = (t1_1 + this.temp[i2 - 7] | 0) + (t2_1 + this.temp[i2 - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i2] + this.temp[i2] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
          }
          state[0] += state0;
          state[1] += state1;
          state[2] += state2;
          state[3] += state3;
          state[4] += state4;
          state[5] += state5;
          state[6] += state6;
          state[7] += state7;
        };
        return RawSha2562;
      }()
    );
    exports.RawSha256 = RawSha256;
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-js/build/jsSha256.js
var require_jsSha2564 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-js/build/jsSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var tslib_1 = require_tslib12();
    var constants_1 = require_constants7();
    var RawSha256_1 = require_RawSha2564();
    var util_1 = require_build15();
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          this.hash = new RawSha256_1.RawSha256();
          if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
              inner[i2] ^= 54;
              outer[i2] ^= 92;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            for (var i2 = 0; i2 < inner.byteLength; i2++) {
              inner[i2] = 0;
            }
          }
        }
        Sha25613.prototype.update = function(toHash) {
          if ((0, util_1.isEmptyData)(toHash) || this.error) {
            return;
          }
          try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
          } catch (e) {
            this.error = e;
          }
        };
        Sha25613.prototype.digestSync = function() {
          if (this.error) {
            throw this.error;
          }
          if (this.outer) {
            if (!this.outer.finished) {
              this.outer.update(this.hash.digest());
            }
            return this.outer.digest();
          }
          return this.hash.digest();
        };
        Sha25613.prototype.digest = function() {
          return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a2) {
              return [2, this.digestSync()];
            });
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
    function bufferFromSecret(secret) {
      var input = (0, util_1.convertToBuffer)(secret);
      if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
      }
      var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
      buffer.set(input);
      return buffer;
    }
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-js/build/index.js
var require_build16 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-js/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib12();
    (0, tslib_1.__exportStar)(require_jsSha2564(), exports);
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/supports-web-crypto/node_modules/tslib/tslib.js
var require_tslib13 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/supports-web-crypto/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/supports-web-crypto/build/supportsWebCrypto.js
var require_supportsWebCrypto3 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/supports-web-crypto/build/supportsWebCrypto.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
    var tslib_1 = require_tslib13();
    var subtleCryptoMethods = [
      "decrypt",
      "digest",
      "encrypt",
      "exportKey",
      "generateKey",
      "importKey",
      "sign",
      "verify"
    ];
    function supportsWebCrypto(window2) {
      if (supportsSecureRandom(window2) && typeof window2.crypto.subtle === "object") {
        var subtle = window2.crypto.subtle;
        return supportsSubtleCrypto(subtle);
      }
      return false;
    }
    exports.supportsWebCrypto = supportsWebCrypto;
    function supportsSecureRandom(window2) {
      if (typeof window2 === "object" && typeof window2.crypto === "object") {
        var getRandomValues2 = window2.crypto.getRandomValues;
        return typeof getRandomValues2 === "function";
      }
      return false;
    }
    exports.supportsSecureRandom = supportsSecureRandom;
    function supportsSubtleCrypto(subtle) {
      return subtle && subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
      });
    }
    exports.supportsSubtleCrypto = supportsSubtleCrypto;
    function supportsZeroByteGCM(subtle) {
      return tslib_1.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a2;
        return tslib_1.__generator(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              if (!supportsSubtleCrypto(subtle))
                return [2, false];
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 4, , 5]);
              return [4, subtle.generateKey({ name: "AES-GCM", length: 128 }, false, ["encrypt"])];
            case 2:
              key = _b2.sent();
              return [4, subtle.encrypt({
                name: "AES-GCM",
                iv: new Uint8Array(Array(12)),
                additionalData: new Uint8Array(Array(16)),
                tagLength: 128
              }, key, new Uint8Array(0))];
            case 3:
              zeroByteAuthTag = _b2.sent();
              return [2, zeroByteAuthTag.byteLength === 16];
            case 4:
              _a2 = _b2.sent();
              return [2, false];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }
    exports.supportsZeroByteGCM = supportsZeroByteGCM;
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/supports-web-crypto/build/index.js
var require_build17 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/supports-web-crypto/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib13();
    tslib_1.__exportStar(require_supportsWebCrypto3(), exports);
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/ie11-detection/node_modules/tslib/tslib.js
var require_tslib14 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/ie11-detection/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/ie11-detection/build/CryptoOperation.js
var require_CryptoOperation3 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/ie11-detection/build/CryptoOperation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/ie11-detection/build/Key.js
var require_Key3 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/ie11-detection/build/Key.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/ie11-detection/build/KeyOperation.js
var require_KeyOperation3 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/ie11-detection/build/KeyOperation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/ie11-detection/build/MsSubtleCrypto.js
var require_MsSubtleCrypto3 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/ie11-detection/build/MsSubtleCrypto.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/ie11-detection/build/MsWindow.js
var require_MsWindow3 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/ie11-detection/build/MsWindow.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isMsWindow = void 0;
    var msSubtleCryptoMethods = [
      "decrypt",
      "digest",
      "encrypt",
      "exportKey",
      "generateKey",
      "importKey",
      "sign",
      "verify"
    ];
    function quacksLikeAnMsWindow(window2) {
      return "MSInputMethodContext" in window2 && "msCrypto" in window2;
    }
    function isMsWindow(window2) {
      if (quacksLikeAnMsWindow(window2) && window2.msCrypto.subtle !== void 0) {
        var _a2 = window2.msCrypto, getRandomValues2 = _a2.getRandomValues, subtle_1 = _a2.subtle;
        return msSubtleCryptoMethods.map(function(methodName) {
          return subtle_1[methodName];
        }).concat(getRandomValues2).every(function(method) {
          return typeof method === "function";
        });
      }
      return false;
    }
    exports.isMsWindow = isMsWindow;
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/ie11-detection/build/index.js
var require_build18 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/ie11-detection/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib14();
    tslib_1.__exportStar(require_CryptoOperation3(), exports);
    tslib_1.__exportStar(require_Key3(), exports);
    tslib_1.__exportStar(require_KeyOperation3(), exports);
    tslib_1.__exportStar(require_MsSubtleCrypto3(), exports);
    tslib_1.__exportStar(require_MsWindow3(), exports);
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-browser/build/crossPlatformSha256.js
var require_crossPlatformSha2563 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-browser/build/crossPlatformSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var ie11Sha256_1 = require_ie11Sha2563();
    var webCryptoSha256_1 = require_webCryptoSha2563();
    var sha256_js_1 = require_build16();
    var supports_web_crypto_1 = require_build17();
    var ie11_detection_1 = require_build18();
    var util_locate_window_1 = (init_dist_es2(), __toCommonJS(dist_es_exports2));
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) {
            this.hash = new webCryptoSha256_1.Sha256(secret);
          } else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) {
            this.hash = new ie11Sha256_1.Sha256(secret);
          } else {
            this.hash = new sha256_js_1.Sha256(secret);
          }
        }
        Sha25613.prototype.update = function(data, encoding) {
          this.hash.update(data, encoding);
        };
        Sha25613.prototype.digest = function() {
          return this.hash.digest();
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
  }
});

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-browser/build/index.js
var require_build19 = __commonJS({
  "node_modules/@aws-sdk/client-firehose/node_modules/@aws-crypto/sha256-browser/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
    var tslib_1 = require_tslib11();
    (0, tslib_1.__exportStar)(require_crossPlatformSha2563(), exports);
    var ie11Sha256_1 = require_ie11Sha2563();
    Object.defineProperty(exports, "Ie11Sha256", { enumerable: true, get: function() {
      return ie11Sha256_1.Sha256;
    } });
    var webCryptoSha256_1 = require_webCryptoSha2563();
    Object.defineProperty(exports, "WebCryptoSha256", { enumerable: true, get: function() {
      return webCryptoSha256_1.Sha256;
    } });
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-browser/node_modules/tslib/tslib.js
var require_tslib15 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-browser/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-browser/build/isEmptyData.js
var require_isEmptyData9 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-browser/build/isEmptyData.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isEmptyData = void 0;
    function isEmptyData2(data) {
      if (typeof data === "string") {
        return data.length === 0;
      }
      return data.byteLength === 0;
    }
    exports.isEmptyData = isEmptyData2;
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-browser/build/constants.js
var require_constants8 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-browser/build/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
    exports.SHA_256_HASH = { name: "SHA-256" };
    exports.SHA_256_HMAC_ALGO = {
      name: "HMAC",
      hash: exports.SHA_256_HASH
    };
    exports.EMPTY_DATA_SHA_256 = new Uint8Array([
      227,
      176,
      196,
      66,
      152,
      252,
      28,
      20,
      154,
      251,
      244,
      200,
      153,
      111,
      185,
      36,
      39,
      174,
      65,
      228,
      100,
      155,
      147,
      76,
      164,
      149,
      153,
      27,
      120,
      82,
      184,
      85
    ]);
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-sdk/util-utf8-browser/dist/es/pureJs.js
var fromUtf816, toUtf815;
var init_pureJs5 = __esm({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-sdk/util-utf8-browser/dist/es/pureJs.js"() {
    fromUtf816 = function(input) {
      var bytes = [];
      for (var i2 = 0, len = input.length; i2 < len; i2++) {
        var value = input.charCodeAt(i2);
        if (value < 128) {
          bytes.push(value);
        } else if (value < 2048) {
          bytes.push(value >> 6 | 192, value & 63 | 128);
        } else if (i2 + 1 < input.length && (value & 64512) === 55296 && (input.charCodeAt(i2 + 1) & 64512) === 56320) {
          var surrogatePair = 65536 + ((value & 1023) << 10) + (input.charCodeAt(++i2) & 1023);
          bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else {
          bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
        }
      }
      return Uint8Array.from(bytes);
    };
    toUtf815 = function(input) {
      var decoded = "";
      for (var i2 = 0, len = input.length; i2 < len; i2++) {
        var byte = input[i2];
        if (byte < 128) {
          decoded += String.fromCharCode(byte);
        } else if (192 <= byte && byte < 224) {
          var nextByte = input[++i2];
          decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
          var surrogatePair = [byte, input[++i2], input[++i2], input[++i2]];
          var encoded = "%" + surrogatePair.map(function(byteValue) {
            return byteValue.toString(16);
          }).join("%");
          decoded += decodeURIComponent(encoded);
        } else {
          decoded += String.fromCharCode((byte & 15) << 12 | (input[++i2] & 63) << 6 | input[++i2] & 63);
        }
      }
      return decoded;
    };
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-sdk/util-utf8-browser/dist/es/whatwgEncodingApi.js
function fromUtf817(input) {
  return new TextEncoder().encode(input);
}
function toUtf816(input) {
  return new TextDecoder("utf-8").decode(input);
}
var init_whatwgEncodingApi5 = __esm({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-sdk/util-utf8-browser/dist/es/whatwgEncodingApi.js"() {
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-sdk/util-utf8-browser/dist/es/index.js
var es_exports4 = {};
__export(es_exports4, {
  fromUtf8: () => fromUtf818,
  toUtf8: () => toUtf817
});
var fromUtf818, toUtf817;
var init_es4 = __esm({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-sdk/util-utf8-browser/dist/es/index.js"() {
    init_pureJs5();
    init_whatwgEncodingApi5();
    fromUtf818 = function(input) {
      return typeof TextEncoder === "function" ? fromUtf817(input) : fromUtf816(input);
    };
    toUtf817 = function(input) {
      return typeof TextDecoder === "function" ? toUtf816(input) : toUtf815(input);
    };
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-browser/build/ie11Sha256.js
var require_ie11Sha2564 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-browser/build/ie11Sha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var isEmptyData_1 = require_isEmptyData9();
    var constants_1 = require_constants8();
    var util_utf8_browser_1 = (init_es4(), __toCommonJS(es_exports4));
    var util_locate_window_1 = (init_dist_es2(), __toCommonJS(dist_es_exports2));
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          if (secret) {
            this.operation = getKeyPromise(secret).then(function(keyData) {
              return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {
            });
          } else {
            this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
          }
        }
        Sha25613.prototype.update = function(toHash) {
          var _this = this;
          if ((0, isEmptyData_1.isEmptyData)(toHash)) {
            return;
          }
          this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
              _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
          });
          this.operation.catch(function() {
          });
        };
        Sha25613.prototype.digest = function() {
          return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
              operation.onerror = function() {
                reject(new Error("Error encountered finalizing hash"));
              };
              operation.oncomplete = function() {
                if (operation.result) {
                  resolve(new Uint8Array(operation.result));
                }
                reject(new Error("Error encountered finalizing hash"));
              };
              operation.finish();
            });
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
    function getKeyPromise(secret) {
      return new Promise(function(resolve, reject) {
        var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, ["sign"]);
        keyOperation.oncomplete = function() {
          if (keyOperation.result) {
            resolve(keyOperation.result);
          }
          reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
          reject(new Error("ImportKey failed to import key."));
        };
      });
    }
    function toArrayBufferView(data) {
      if (typeof data === "string") {
        return (0, util_utf8_browser_1.fromUtf8)(data);
      }
      if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
      }
      return new Uint8Array(data);
    }
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/util/build/convertToBuffer.js
var require_convertToBuffer6 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/util/build/convertToBuffer.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.convertToBuffer = void 0;
    var util_utf8_browser_1 = (init_es4(), __toCommonJS(es_exports4));
    var fromUtf831 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
      return Buffer.from(input, "utf8");
    } : util_utf8_browser_1.fromUtf8;
    function convertToBuffer2(data) {
      if (data instanceof Uint8Array)
        return data;
      if (typeof data === "string") {
        return fromUtf831(data);
      }
      if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
      }
      return new Uint8Array(data);
    }
    exports.convertToBuffer = convertToBuffer2;
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/util/build/isEmptyData.js
var require_isEmptyData10 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/util/build/isEmptyData.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isEmptyData = void 0;
    function isEmptyData2(data) {
      if (typeof data === "string") {
        return data.length === 0;
      }
      return data.byteLength === 0;
    }
    exports.isEmptyData = isEmptyData2;
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/util/build/numToUint8.js
var require_numToUint86 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/util/build/numToUint8.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.numToUint8 = void 0;
    function numToUint8(num) {
      return new Uint8Array([
        (num & 4278190080) >> 24,
        (num & 16711680) >> 16,
        (num & 65280) >> 8,
        num & 255
      ]);
    }
    exports.numToUint8 = numToUint8;
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/util/build/uint32ArrayFrom.js
var require_uint32ArrayFrom6 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/util/build/uint32ArrayFrom.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = void 0;
    function uint32ArrayFrom(a_lookUpTable) {
      if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while (a_index < a_lookUpTable.length) {
          return_array[a_index] = a_lookUpTable[a_index];
        }
        return return_array;
      }
      return Uint32Array.from(a_lookUpTable);
    }
    exports.uint32ArrayFrom = uint32ArrayFrom;
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/util/build/index.js
var require_build20 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/util/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
    var convertToBuffer_1 = require_convertToBuffer6();
    Object.defineProperty(exports, "convertToBuffer", { enumerable: true, get: function() {
      return convertToBuffer_1.convertToBuffer;
    } });
    var isEmptyData_1 = require_isEmptyData10();
    Object.defineProperty(exports, "isEmptyData", { enumerable: true, get: function() {
      return isEmptyData_1.isEmptyData;
    } });
    var numToUint8_1 = require_numToUint86();
    Object.defineProperty(exports, "numToUint8", { enumerable: true, get: function() {
      return numToUint8_1.numToUint8;
    } });
    var uint32ArrayFrom_1 = require_uint32ArrayFrom6();
    Object.defineProperty(exports, "uint32ArrayFrom", { enumerable: true, get: function() {
      return uint32ArrayFrom_1.uint32ArrayFrom;
    } });
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-browser/build/webCryptoSha256.js
var require_webCryptoSha2564 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-browser/build/webCryptoSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var util_1 = require_build20();
    var constants_1 = require_constants8();
    var util_locate_window_1 = (init_dist_es2(), __toCommonJS(dist_es_exports2));
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          this.toHash = new Uint8Array(0);
          if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
              (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(secret), constants_1.SHA_256_HMAC_ALGO, false, ["sign"]).then(resolve, reject);
            });
            this.key.catch(function() {
            });
          }
        }
        Sha25613.prototype.update = function(data) {
          if ((0, util_1.isEmptyData)(data)) {
            return;
          }
          var update = (0, util_1.convertToBuffer)(data);
          var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
          typedArray.set(this.toHash, 0);
          typedArray.set(update, this.toHash.byteLength);
          this.toHash = typedArray;
        };
        Sha25613.prototype.digest = function() {
          var _this = this;
          if (this.key) {
            return this.key.then(function(key) {
              return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
              });
            });
          }
          if ((0, util_1.isEmptyData)(this.toHash)) {
            return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
          }
          return Promise.resolve().then(function() {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
          }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-js/node_modules/tslib/tslib.js
var require_tslib16 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-js/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-js/build/constants.js
var require_constants9 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-js/build/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
    exports.BLOCK_SIZE = 64;
    exports.DIGEST_LENGTH = 32;
    exports.KEY = new Uint32Array([
      1116352408,
      1899447441,
      3049323471,
      3921009573,
      961987163,
      1508970993,
      2453635748,
      2870763221,
      3624381080,
      310598401,
      607225278,
      1426881987,
      1925078388,
      2162078206,
      2614888103,
      3248222580,
      3835390401,
      4022224774,
      264347078,
      604807628,
      770255983,
      1249150122,
      1555081692,
      1996064986,
      2554220882,
      2821834349,
      2952996808,
      3210313671,
      3336571891,
      3584528711,
      113926993,
      338241895,
      666307205,
      773529912,
      1294757372,
      1396182291,
      1695183700,
      1986661051,
      2177026350,
      2456956037,
      2730485921,
      2820302411,
      3259730800,
      3345764771,
      3516065817,
      3600352804,
      4094571909,
      275423344,
      430227734,
      506948616,
      659060556,
      883997877,
      958139571,
      1322822218,
      1537002063,
      1747873779,
      1955562222,
      2024104815,
      2227730452,
      2361852424,
      2428436474,
      2756734187,
      3204031479,
      3329325298
    ]);
    exports.INIT = [
      1779033703,
      3144134277,
      1013904242,
      2773480762,
      1359893119,
      2600822924,
      528734635,
      1541459225
    ];
    exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-js/build/RawSha256.js
var require_RawSha2565 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-js/build/RawSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.RawSha256 = void 0;
    var constants_1 = require_constants9();
    var RawSha256 = (
      /** @class */
      function() {
        function RawSha2562() {
          this.state = Int32Array.from(constants_1.INIT);
          this.temp = new Int32Array(64);
          this.buffer = new Uint8Array(64);
          this.bufferLength = 0;
          this.bytesHashed = 0;
          this.finished = false;
        }
        RawSha2562.prototype.update = function(data) {
          if (this.finished) {
            throw new Error("Attempted to update an already finished hash.");
          }
          var position = 0;
          var byteLength2 = data.byteLength;
          this.bytesHashed += byteLength2;
          if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) {
            throw new Error("Cannot hash more than 2^53 - 1 bits");
          }
          while (byteLength2 > 0) {
            this.buffer[this.bufferLength++] = data[position++];
            byteLength2--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
              this.hashBuffer();
              this.bufferLength = 0;
            }
          }
        };
        RawSha2562.prototype.digest = function() {
          if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 128);
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
              for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE; i2++) {
                bufferView.setUint8(i2, 0);
              }
              this.hashBuffer();
              this.bufferLength = 0;
            }
            for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE - 8; i2++) {
              bufferView.setUint8(i2, 0);
            }
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 4294967296), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
          }
          var out = new Uint8Array(constants_1.DIGEST_LENGTH);
          for (var i2 = 0; i2 < 8; i2++) {
            out[i2 * 4] = this.state[i2] >>> 24 & 255;
            out[i2 * 4 + 1] = this.state[i2] >>> 16 & 255;
            out[i2 * 4 + 2] = this.state[i2] >>> 8 & 255;
            out[i2 * 4 + 3] = this.state[i2] >>> 0 & 255;
          }
          return out;
        };
        RawSha2562.prototype.hashBuffer = function() {
          var _a2 = this, buffer = _a2.buffer, state = _a2.state;
          var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
          for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
            if (i2 < 16) {
              this.temp[i2] = (buffer[i2 * 4] & 255) << 24 | (buffer[i2 * 4 + 1] & 255) << 16 | (buffer[i2 * 4 + 2] & 255) << 8 | buffer[i2 * 4 + 3] & 255;
            } else {
              var u2 = this.temp[i2 - 2];
              var t1_1 = (u2 >>> 17 | u2 << 15) ^ (u2 >>> 19 | u2 << 13) ^ u2 >>> 10;
              u2 = this.temp[i2 - 15];
              var t2_1 = (u2 >>> 7 | u2 << 25) ^ (u2 >>> 18 | u2 << 14) ^ u2 >>> 3;
              this.temp[i2] = (t1_1 + this.temp[i2 - 7] | 0) + (t2_1 + this.temp[i2 - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i2] + this.temp[i2] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
          }
          state[0] += state0;
          state[1] += state1;
          state[2] += state2;
          state[3] += state3;
          state[4] += state4;
          state[5] += state5;
          state[6] += state6;
          state[7] += state7;
        };
        return RawSha2562;
      }()
    );
    exports.RawSha256 = RawSha256;
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-js/build/jsSha256.js
var require_jsSha2565 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-js/build/jsSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var tslib_1 = require_tslib16();
    var constants_1 = require_constants9();
    var RawSha256_1 = require_RawSha2565();
    var util_1 = require_build20();
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          this.hash = new RawSha256_1.RawSha256();
          if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
              inner[i2] ^= 54;
              outer[i2] ^= 92;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            for (var i2 = 0; i2 < inner.byteLength; i2++) {
              inner[i2] = 0;
            }
          }
        }
        Sha25613.prototype.update = function(toHash) {
          if ((0, util_1.isEmptyData)(toHash) || this.error) {
            return;
          }
          try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
          } catch (e) {
            this.error = e;
          }
        };
        Sha25613.prototype.digestSync = function() {
          if (this.error) {
            throw this.error;
          }
          if (this.outer) {
            if (!this.outer.finished) {
              this.outer.update(this.hash.digest());
            }
            return this.outer.digest();
          }
          return this.hash.digest();
        };
        Sha25613.prototype.digest = function() {
          return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a2) {
              return [2, this.digestSync()];
            });
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
    function bufferFromSecret(secret) {
      var input = (0, util_1.convertToBuffer)(secret);
      if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
      }
      var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
      buffer.set(input);
      return buffer;
    }
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-js/build/index.js
var require_build21 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-js/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib16();
    (0, tslib_1.__exportStar)(require_jsSha2565(), exports);
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/supports-web-crypto/node_modules/tslib/tslib.js
var require_tslib17 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/supports-web-crypto/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/supports-web-crypto/build/supportsWebCrypto.js
var require_supportsWebCrypto4 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/supports-web-crypto/build/supportsWebCrypto.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
    var tslib_1 = require_tslib17();
    var subtleCryptoMethods = [
      "decrypt",
      "digest",
      "encrypt",
      "exportKey",
      "generateKey",
      "importKey",
      "sign",
      "verify"
    ];
    function supportsWebCrypto(window2) {
      if (supportsSecureRandom(window2) && typeof window2.crypto.subtle === "object") {
        var subtle = window2.crypto.subtle;
        return supportsSubtleCrypto(subtle);
      }
      return false;
    }
    exports.supportsWebCrypto = supportsWebCrypto;
    function supportsSecureRandom(window2) {
      if (typeof window2 === "object" && typeof window2.crypto === "object") {
        var getRandomValues2 = window2.crypto.getRandomValues;
        return typeof getRandomValues2 === "function";
      }
      return false;
    }
    exports.supportsSecureRandom = supportsSecureRandom;
    function supportsSubtleCrypto(subtle) {
      return subtle && subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
      });
    }
    exports.supportsSubtleCrypto = supportsSubtleCrypto;
    function supportsZeroByteGCM(subtle) {
      return tslib_1.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a2;
        return tslib_1.__generator(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              if (!supportsSubtleCrypto(subtle))
                return [2, false];
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 4, , 5]);
              return [4, subtle.generateKey({ name: "AES-GCM", length: 128 }, false, ["encrypt"])];
            case 2:
              key = _b2.sent();
              return [4, subtle.encrypt({
                name: "AES-GCM",
                iv: new Uint8Array(Array(12)),
                additionalData: new Uint8Array(Array(16)),
                tagLength: 128
              }, key, new Uint8Array(0))];
            case 3:
              zeroByteAuthTag = _b2.sent();
              return [2, zeroByteAuthTag.byteLength === 16];
            case 4:
              _a2 = _b2.sent();
              return [2, false];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }
    exports.supportsZeroByteGCM = supportsZeroByteGCM;
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/supports-web-crypto/build/index.js
var require_build22 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/supports-web-crypto/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib17();
    tslib_1.__exportStar(require_supportsWebCrypto4(), exports);
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/ie11-detection/node_modules/tslib/tslib.js
var require_tslib18 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/ie11-detection/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/ie11-detection/build/CryptoOperation.js
var require_CryptoOperation4 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/ie11-detection/build/CryptoOperation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/ie11-detection/build/Key.js
var require_Key4 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/ie11-detection/build/Key.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/ie11-detection/build/KeyOperation.js
var require_KeyOperation4 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/ie11-detection/build/KeyOperation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/ie11-detection/build/MsSubtleCrypto.js
var require_MsSubtleCrypto4 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/ie11-detection/build/MsSubtleCrypto.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/ie11-detection/build/MsWindow.js
var require_MsWindow4 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/ie11-detection/build/MsWindow.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isMsWindow = void 0;
    var msSubtleCryptoMethods = [
      "decrypt",
      "digest",
      "encrypt",
      "exportKey",
      "generateKey",
      "importKey",
      "sign",
      "verify"
    ];
    function quacksLikeAnMsWindow(window2) {
      return "MSInputMethodContext" in window2 && "msCrypto" in window2;
    }
    function isMsWindow(window2) {
      if (quacksLikeAnMsWindow(window2) && window2.msCrypto.subtle !== void 0) {
        var _a2 = window2.msCrypto, getRandomValues2 = _a2.getRandomValues, subtle_1 = _a2.subtle;
        return msSubtleCryptoMethods.map(function(methodName) {
          return subtle_1[methodName];
        }).concat(getRandomValues2).every(function(method) {
          return typeof method === "function";
        });
      }
      return false;
    }
    exports.isMsWindow = isMsWindow;
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/ie11-detection/build/index.js
var require_build23 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/ie11-detection/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib18();
    tslib_1.__exportStar(require_CryptoOperation4(), exports);
    tslib_1.__exportStar(require_Key4(), exports);
    tslib_1.__exportStar(require_KeyOperation4(), exports);
    tslib_1.__exportStar(require_MsSubtleCrypto4(), exports);
    tslib_1.__exportStar(require_MsWindow4(), exports);
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-browser/build/crossPlatformSha256.js
var require_crossPlatformSha2564 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-browser/build/crossPlatformSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var ie11Sha256_1 = require_ie11Sha2564();
    var webCryptoSha256_1 = require_webCryptoSha2564();
    var sha256_js_1 = require_build21();
    var supports_web_crypto_1 = require_build22();
    var ie11_detection_1 = require_build23();
    var util_locate_window_1 = (init_dist_es2(), __toCommonJS(dist_es_exports2));
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) {
            this.hash = new webCryptoSha256_1.Sha256(secret);
          } else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) {
            this.hash = new ie11Sha256_1.Sha256(secret);
          } else {
            this.hash = new sha256_js_1.Sha256(secret);
          }
        }
        Sha25613.prototype.update = function(data, encoding) {
          this.hash.update(data, encoding);
        };
        Sha25613.prototype.digest = function() {
          return this.hash.digest();
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
  }
});

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-browser/build/index.js
var require_build24 = __commonJS({
  "node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-crypto/sha256-browser/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
    var tslib_1 = require_tslib15();
    (0, tslib_1.__exportStar)(require_crossPlatformSha2564(), exports);
    var ie11Sha256_1 = require_ie11Sha2564();
    Object.defineProperty(exports, "Ie11Sha256", { enumerable: true, get: function() {
      return ie11Sha256_1.Sha256;
    } });
    var webCryptoSha256_1 = require_webCryptoSha2564();
    Object.defineProperty(exports, "WebCryptoSha256", { enumerable: true, get: function() {
      return webCryptoSha256_1.Sha256;
    } });
  }
});

// node_modules/lodash/isEmpty.js
var require_isEmpty = __commonJS({
  "node_modules/lodash/isEmpty.js"(exports, module) {
    var baseKeys = require_baseKeys();
    var getTag = require_getTag();
    var isArguments = require_isArguments();
    var isArray = require_isArray();
    var isArrayLike = require_isArrayLike();
    var isBuffer = require_isBuffer();
    var isPrototype = require_isPrototype();
    var isTypedArray = require_isTypedArray();
    var mapTag = "[object Map]";
    var setTag = "[object Set]";
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function isEmpty6(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }
    module.exports = isEmpty6;
  }
});

// node_modules/base64-js/index.js
var require_base64_js = __commonJS({
  "node_modules/base64-js/index.js"(exports) {
    "use strict";
    exports.byteLength = byteLength2;
    exports.toByteArray = toByteArray;
    exports.fromByteArray = fromByteArray;
    var lookup = [];
    var revLookup = [];
    var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
    var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for (i2 = 0, len = code.length; i2 < len; ++i2) {
      lookup[i2] = code[i2];
      revLookup[code.charCodeAt(i2)] = i2;
    }
    var i2;
    var len;
    revLookup["-".charCodeAt(0)] = 62;
    revLookup["_".charCodeAt(0)] = 63;
    function getLens(b64) {
      var len2 = b64.length;
      if (len2 % 4 > 0) {
        throw new Error("Invalid string. Length must be a multiple of 4");
      }
      var validLen = b64.indexOf("=");
      if (validLen === -1)
        validLen = len2;
      var placeHoldersLen = validLen === len2 ? 0 : 4 - validLen % 4;
      return [validLen, placeHoldersLen];
    }
    function byteLength2(b64) {
      var lens = getLens(b64);
      var validLen = lens[0];
      var placeHoldersLen = lens[1];
      return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function _byteLength(b64, validLen, placeHoldersLen) {
      return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function toByteArray(b64) {
      var tmp;
      var lens = getLens(b64);
      var validLen = lens[0];
      var placeHoldersLen = lens[1];
      var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
      var curByte = 0;
      var len2 = placeHoldersLen > 0 ? validLen - 4 : validLen;
      var i3;
      for (i3 = 0; i3 < len2; i3 += 4) {
        tmp = revLookup[b64.charCodeAt(i3)] << 18 | revLookup[b64.charCodeAt(i3 + 1)] << 12 | revLookup[b64.charCodeAt(i3 + 2)] << 6 | revLookup[b64.charCodeAt(i3 + 3)];
        arr[curByte++] = tmp >> 16 & 255;
        arr[curByte++] = tmp >> 8 & 255;
        arr[curByte++] = tmp & 255;
      }
      if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i3)] << 2 | revLookup[b64.charCodeAt(i3 + 1)] >> 4;
        arr[curByte++] = tmp & 255;
      }
      if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i3)] << 10 | revLookup[b64.charCodeAt(i3 + 1)] << 4 | revLookup[b64.charCodeAt(i3 + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 255;
        arr[curByte++] = tmp & 255;
      }
      return arr;
    }
    function tripletToBase64(num) {
      return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
    }
    function encodeChunk(uint8, start, end) {
      var tmp;
      var output = [];
      for (var i3 = start; i3 < end; i3 += 3) {
        tmp = (uint8[i3] << 16 & 16711680) + (uint8[i3 + 1] << 8 & 65280) + (uint8[i3 + 2] & 255);
        output.push(tripletToBase64(tmp));
      }
      return output.join("");
    }
    function fromByteArray(uint8) {
      var tmp;
      var len2 = uint8.length;
      var extraBytes = len2 % 3;
      var parts = [];
      var maxChunkLength = 16383;
      for (var i3 = 0, len22 = len2 - extraBytes; i3 < len22; i3 += maxChunkLength) {
        parts.push(encodeChunk(uint8, i3, i3 + maxChunkLength > len22 ? len22 : i3 + maxChunkLength));
      }
      if (extraBytes === 1) {
        tmp = uint8[len2 - 1];
        parts.push(
          lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "=="
        );
      } else if (extraBytes === 2) {
        tmp = (uint8[len2 - 2] << 8) + uint8[len2 - 1];
        parts.push(
          lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "="
        );
      }
      return parts.join("");
    }
  }
});

// node_modules/ieee754/index.js
var require_ieee754 = __commonJS({
  "node_modules/ieee754/index.js"(exports) {
    exports.read = function(buffer, offset, isLE, mLen, nBytes) {
      var e, m2;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var nBits = -7;
      var i2 = isLE ? nBytes - 1 : 0;
      var d2 = isLE ? -1 : 1;
      var s2 = buffer[offset + i2];
      i2 += d2;
      e = s2 & (1 << -nBits) - 1;
      s2 >>= -nBits;
      nBits += eLen;
      for (; nBits > 0; e = e * 256 + buffer[offset + i2], i2 += d2, nBits -= 8) {
      }
      m2 = e & (1 << -nBits) - 1;
      e >>= -nBits;
      nBits += mLen;
      for (; nBits > 0; m2 = m2 * 256 + buffer[offset + i2], i2 += d2, nBits -= 8) {
      }
      if (e === 0) {
        e = 1 - eBias;
      } else if (e === eMax) {
        return m2 ? NaN : (s2 ? -1 : 1) * Infinity;
      } else {
        m2 = m2 + Math.pow(2, mLen);
        e = e - eBias;
      }
      return (s2 ? -1 : 1) * m2 * Math.pow(2, e - mLen);
    };
    exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
      var e, m2, c2;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
      var i2 = isLE ? 0 : nBytes - 1;
      var d2 = isLE ? 1 : -1;
      var s2 = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
      value = Math.abs(value);
      if (isNaN(value) || value === Infinity) {
        m2 = isNaN(value) ? 1 : 0;
        e = eMax;
      } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c2 = Math.pow(2, -e)) < 1) {
          e--;
          c2 *= 2;
        }
        if (e + eBias >= 1) {
          value += rt / c2;
        } else {
          value += rt * Math.pow(2, 1 - eBias);
        }
        if (value * c2 >= 2) {
          e++;
          c2 /= 2;
        }
        if (e + eBias >= eMax) {
          m2 = 0;
          e = eMax;
        } else if (e + eBias >= 1) {
          m2 = (value * c2 - 1) * Math.pow(2, mLen);
          e = e + eBias;
        } else {
          m2 = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
          e = 0;
        }
      }
      for (; mLen >= 8; buffer[offset + i2] = m2 & 255, i2 += d2, m2 /= 256, mLen -= 8) {
      }
      e = e << mLen | m2;
      eLen += mLen;
      for (; eLen > 0; buffer[offset + i2] = e & 255, i2 += d2, e /= 256, eLen -= 8) {
      }
      buffer[offset + i2 - d2] |= s2 * 128;
    };
  }
});

// node_modules/isarray/index.js
var require_isarray = __commonJS({
  "node_modules/isarray/index.js"(exports, module) {
    var toString = {}.toString;
    module.exports = Array.isArray || function(arr) {
      return toString.call(arr) == "[object Array]";
    };
  }
});

// node_modules/buffer/index.js
var require_buffer = __commonJS({
  "node_modules/buffer/index.js"(exports) {
    "use strict";
    var base64 = require_base64_js();
    var ieee754 = require_ieee754();
    var isArray = require_isarray();
    exports.Buffer = Buffer8;
    exports.SlowBuffer = SlowBuffer;
    exports.INSPECT_MAX_BYTES = 50;
    Buffer8.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== void 0 ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
    exports.kMaxLength = kMaxLength();
    function typedArraySupport() {
      try {
        var arr = new Uint8Array(1);
        arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function() {
          return 42;
        } };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0;
      } catch (e) {
        return false;
      }
    }
    function kMaxLength() {
      return Buffer8.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
    }
    function createBuffer(that, length) {
      if (kMaxLength() < length) {
        throw new RangeError("Invalid typed array length");
      }
      if (Buffer8.TYPED_ARRAY_SUPPORT) {
        that = new Uint8Array(length);
        that.__proto__ = Buffer8.prototype;
      } else {
        if (that === null) {
          that = new Buffer8(length);
        }
        that.length = length;
      }
      return that;
    }
    function Buffer8(arg, encodingOrOffset, length) {
      if (!Buffer8.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer8)) {
        return new Buffer8(arg, encodingOrOffset, length);
      }
      if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") {
          throw new Error(
            "If encoding is specified then the first argument must be a string"
          );
        }
        return allocUnsafe(this, arg);
      }
      return from(this, arg, encodingOrOffset, length);
    }
    Buffer8.poolSize = 8192;
    Buffer8._augment = function(arr) {
      arr.__proto__ = Buffer8.prototype;
      return arr;
    };
    function from(that, value, encodingOrOffset, length) {
      if (typeof value === "number") {
        throw new TypeError('"value" argument must not be a number');
      }
      if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) {
        return fromArrayBuffer(that, value, encodingOrOffset, length);
      }
      if (typeof value === "string") {
        return fromString(that, value, encodingOrOffset);
      }
      return fromObject(that, value);
    }
    Buffer8.from = function(value, encodingOrOffset, length) {
      return from(null, value, encodingOrOffset, length);
    };
    if (Buffer8.TYPED_ARRAY_SUPPORT) {
      Buffer8.prototype.__proto__ = Uint8Array.prototype;
      Buffer8.__proto__ = Uint8Array;
      if (typeof Symbol !== "undefined" && Symbol.species && Buffer8[Symbol.species] === Buffer8) {
        Object.defineProperty(Buffer8, Symbol.species, {
          value: null,
          configurable: true
        });
      }
    }
    function assertSize(size) {
      if (typeof size !== "number") {
        throw new TypeError('"size" argument must be a number');
      } else if (size < 0) {
        throw new RangeError('"size" argument must not be negative');
      }
    }
    function alloc(that, size, fill, encoding) {
      assertSize(size);
      if (size <= 0) {
        return createBuffer(that, size);
      }
      if (fill !== void 0) {
        return typeof encoding === "string" ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
      }
      return createBuffer(that, size);
    }
    Buffer8.alloc = function(size, fill, encoding) {
      return alloc(null, size, fill, encoding);
    };
    function allocUnsafe(that, size) {
      assertSize(size);
      that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
      if (!Buffer8.TYPED_ARRAY_SUPPORT) {
        for (var i2 = 0; i2 < size; ++i2) {
          that[i2] = 0;
        }
      }
      return that;
    }
    Buffer8.allocUnsafe = function(size) {
      return allocUnsafe(null, size);
    };
    Buffer8.allocUnsafeSlow = function(size) {
      return allocUnsafe(null, size);
    };
    function fromString(that, string, encoding) {
      if (typeof encoding !== "string" || encoding === "") {
        encoding = "utf8";
      }
      if (!Buffer8.isEncoding(encoding)) {
        throw new TypeError('"encoding" must be a valid string encoding');
      }
      var length = byteLength2(string, encoding) | 0;
      that = createBuffer(that, length);
      var actual = that.write(string, encoding);
      if (actual !== length) {
        that = that.slice(0, actual);
      }
      return that;
    }
    function fromArrayLike(that, array) {
      var length = array.length < 0 ? 0 : checked(array.length) | 0;
      that = createBuffer(that, length);
      for (var i2 = 0; i2 < length; i2 += 1) {
        that[i2] = array[i2] & 255;
      }
      return that;
    }
    function fromArrayBuffer(that, array, byteOffset, length) {
      array.byteLength;
      if (byteOffset < 0 || array.byteLength < byteOffset) {
        throw new RangeError("'offset' is out of bounds");
      }
      if (array.byteLength < byteOffset + (length || 0)) {
        throw new RangeError("'length' is out of bounds");
      }
      if (byteOffset === void 0 && length === void 0) {
        array = new Uint8Array(array);
      } else if (length === void 0) {
        array = new Uint8Array(array, byteOffset);
      } else {
        array = new Uint8Array(array, byteOffset, length);
      }
      if (Buffer8.TYPED_ARRAY_SUPPORT) {
        that = array;
        that.__proto__ = Buffer8.prototype;
      } else {
        that = fromArrayLike(that, array);
      }
      return that;
    }
    function fromObject(that, obj) {
      if (Buffer8.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);
        if (that.length === 0) {
          return that;
        }
        obj.copy(that, 0, 0, len);
        return that;
      }
      if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
          if (typeof obj.length !== "number" || isnan(obj.length)) {
            return createBuffer(that, 0);
          }
          return fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && isArray(obj.data)) {
          return fromArrayLike(that, obj.data);
        }
      }
      throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
    }
    function checked(length) {
      if (length >= kMaxLength()) {
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
      }
      return length | 0;
    }
    function SlowBuffer(length) {
      if (+length != length) {
        length = 0;
      }
      return Buffer8.alloc(+length);
    }
    Buffer8.isBuffer = function isBuffer(b2) {
      return !!(b2 != null && b2._isBuffer);
    };
    Buffer8.compare = function compare(a2, b2) {
      if (!Buffer8.isBuffer(a2) || !Buffer8.isBuffer(b2)) {
        throw new TypeError("Arguments must be Buffers");
      }
      if (a2 === b2)
        return 0;
      var x2 = a2.length;
      var y2 = b2.length;
      for (var i2 = 0, len = Math.min(x2, y2); i2 < len; ++i2) {
        if (a2[i2] !== b2[i2]) {
          x2 = a2[i2];
          y2 = b2[i2];
          break;
        }
      }
      if (x2 < y2)
        return -1;
      if (y2 < x2)
        return 1;
      return 0;
    };
    Buffer8.isEncoding = function isEncoding(encoding) {
      switch (String(encoding).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return true;
        default:
          return false;
      }
    };
    Buffer8.concat = function concat(list, length) {
      if (!isArray(list)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
      }
      if (list.length === 0) {
        return Buffer8.alloc(0);
      }
      var i2;
      if (length === void 0) {
        length = 0;
        for (i2 = 0; i2 < list.length; ++i2) {
          length += list[i2].length;
        }
      }
      var buffer = Buffer8.allocUnsafe(length);
      var pos = 0;
      for (i2 = 0; i2 < list.length; ++i2) {
        var buf = list[i2];
        if (!Buffer8.isBuffer(buf)) {
          throw new TypeError('"list" argument must be an Array of Buffers');
        }
        buf.copy(buffer, pos);
        pos += buf.length;
      }
      return buffer;
    };
    function byteLength2(string, encoding) {
      if (Buffer8.isBuffer(string)) {
        return string.length;
      }
      if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
        return string.byteLength;
      }
      if (typeof string !== "string") {
        string = "" + string;
      }
      var len = string.length;
      if (len === 0)
        return 0;
      var loweredCase = false;
      for (; ; ) {
        switch (encoding) {
          case "ascii":
          case "latin1":
          case "binary":
            return len;
          case "utf8":
          case "utf-8":
          case void 0:
            return utf8ToBytes(string).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return len * 2;
          case "hex":
            return len >>> 1;
          case "base64":
            return base64ToBytes(string).length;
          default:
            if (loweredCase)
              return utf8ToBytes(string).length;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    }
    Buffer8.byteLength = byteLength2;
    function slowToString(encoding, start, end) {
      var loweredCase = false;
      if (start === void 0 || start < 0) {
        start = 0;
      }
      if (start > this.length) {
        return "";
      }
      if (end === void 0 || end > this.length) {
        end = this.length;
      }
      if (end <= 0) {
        return "";
      }
      end >>>= 0;
      start >>>= 0;
      if (end <= start) {
        return "";
      }
      if (!encoding)
        encoding = "utf8";
      while (true) {
        switch (encoding) {
          case "hex":
            return hexSlice(this, start, end);
          case "utf8":
          case "utf-8":
            return utf8Slice(this, start, end);
          case "ascii":
            return asciiSlice(this, start, end);
          case "latin1":
          case "binary":
            return latin1Slice(this, start, end);
          case "base64":
            return base64Slice(this, start, end);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return utf16leSlice(this, start, end);
          default:
            if (loweredCase)
              throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
        }
      }
    }
    Buffer8.prototype._isBuffer = true;
    function swap(b2, n2, m2) {
      var i2 = b2[n2];
      b2[n2] = b2[m2];
      b2[m2] = i2;
    }
    Buffer8.prototype.swap16 = function swap16() {
      var len = this.length;
      if (len % 2 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      }
      for (var i2 = 0; i2 < len; i2 += 2) {
        swap(this, i2, i2 + 1);
      }
      return this;
    };
    Buffer8.prototype.swap32 = function swap32() {
      var len = this.length;
      if (len % 4 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      }
      for (var i2 = 0; i2 < len; i2 += 4) {
        swap(this, i2, i2 + 3);
        swap(this, i2 + 1, i2 + 2);
      }
      return this;
    };
    Buffer8.prototype.swap64 = function swap64() {
      var len = this.length;
      if (len % 8 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      }
      for (var i2 = 0; i2 < len; i2 += 8) {
        swap(this, i2, i2 + 7);
        swap(this, i2 + 1, i2 + 6);
        swap(this, i2 + 2, i2 + 5);
        swap(this, i2 + 3, i2 + 4);
      }
      return this;
    };
    Buffer8.prototype.toString = function toString() {
      var length = this.length | 0;
      if (length === 0)
        return "";
      if (arguments.length === 0)
        return utf8Slice(this, 0, length);
      return slowToString.apply(this, arguments);
    };
    Buffer8.prototype.equals = function equals(b2) {
      if (!Buffer8.isBuffer(b2))
        throw new TypeError("Argument must be a Buffer");
      if (this === b2)
        return true;
      return Buffer8.compare(this, b2) === 0;
    };
    Buffer8.prototype.inspect = function inspect2() {
      var str = "";
      var max = exports.INSPECT_MAX_BYTES;
      if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max)
          str += " ... ";
      }
      return "<Buffer " + str + ">";
    };
    Buffer8.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
      if (!Buffer8.isBuffer(target)) {
        throw new TypeError("Argument must be a Buffer");
      }
      if (start === void 0) {
        start = 0;
      }
      if (end === void 0) {
        end = target ? target.length : 0;
      }
      if (thisStart === void 0) {
        thisStart = 0;
      }
      if (thisEnd === void 0) {
        thisEnd = this.length;
      }
      if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
        throw new RangeError("out of range index");
      }
      if (thisStart >= thisEnd && start >= end) {
        return 0;
      }
      if (thisStart >= thisEnd) {
        return -1;
      }
      if (start >= end) {
        return 1;
      }
      start >>>= 0;
      end >>>= 0;
      thisStart >>>= 0;
      thisEnd >>>= 0;
      if (this === target)
        return 0;
      var x2 = thisEnd - thisStart;
      var y2 = end - start;
      var len = Math.min(x2, y2);
      var thisCopy = this.slice(thisStart, thisEnd);
      var targetCopy = target.slice(start, end);
      for (var i2 = 0; i2 < len; ++i2) {
        if (thisCopy[i2] !== targetCopy[i2]) {
          x2 = thisCopy[i2];
          y2 = targetCopy[i2];
          break;
        }
      }
      if (x2 < y2)
        return -1;
      if (y2 < x2)
        return 1;
      return 0;
    };
    function bidirectionalIndexOf(buffer, val2, byteOffset, encoding, dir) {
      if (buffer.length === 0)
        return -1;
      if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
      } else if (byteOffset > 2147483647) {
        byteOffset = 2147483647;
      } else if (byteOffset < -2147483648) {
        byteOffset = -2147483648;
      }
      byteOffset = +byteOffset;
      if (isNaN(byteOffset)) {
        byteOffset = dir ? 0 : buffer.length - 1;
      }
      if (byteOffset < 0)
        byteOffset = buffer.length + byteOffset;
      if (byteOffset >= buffer.length) {
        if (dir)
          return -1;
        else
          byteOffset = buffer.length - 1;
      } else if (byteOffset < 0) {
        if (dir)
          byteOffset = 0;
        else
          return -1;
      }
      if (typeof val2 === "string") {
        val2 = Buffer8.from(val2, encoding);
      }
      if (Buffer8.isBuffer(val2)) {
        if (val2.length === 0) {
          return -1;
        }
        return arrayIndexOf(buffer, val2, byteOffset, encoding, dir);
      } else if (typeof val2 === "number") {
        val2 = val2 & 255;
        if (Buffer8.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
          if (dir) {
            return Uint8Array.prototype.indexOf.call(buffer, val2, byteOffset);
          } else {
            return Uint8Array.prototype.lastIndexOf.call(buffer, val2, byteOffset);
          }
        }
        return arrayIndexOf(buffer, [val2], byteOffset, encoding, dir);
      }
      throw new TypeError("val must be string, number or Buffer");
    }
    function arrayIndexOf(arr, val2, byteOffset, encoding, dir) {
      var indexSize = 1;
      var arrLength = arr.length;
      var valLength = val2.length;
      if (encoding !== void 0) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
          if (arr.length < 2 || val2.length < 2) {
            return -1;
          }
          indexSize = 2;
          arrLength /= 2;
          valLength /= 2;
          byteOffset /= 2;
        }
      }
      function read(buf, i3) {
        if (indexSize === 1) {
          return buf[i3];
        } else {
          return buf.readUInt16BE(i3 * indexSize);
        }
      }
      var i2;
      if (dir) {
        var foundIndex = -1;
        for (i2 = byteOffset; i2 < arrLength; i2++) {
          if (read(arr, i2) === read(val2, foundIndex === -1 ? 0 : i2 - foundIndex)) {
            if (foundIndex === -1)
              foundIndex = i2;
            if (i2 - foundIndex + 1 === valLength)
              return foundIndex * indexSize;
          } else {
            if (foundIndex !== -1)
              i2 -= i2 - foundIndex;
            foundIndex = -1;
          }
        }
      } else {
        if (byteOffset + valLength > arrLength)
          byteOffset = arrLength - valLength;
        for (i2 = byteOffset; i2 >= 0; i2--) {
          var found = true;
          for (var j2 = 0; j2 < valLength; j2++) {
            if (read(arr, i2 + j2) !== read(val2, j2)) {
              found = false;
              break;
            }
          }
          if (found)
            return i2;
        }
      }
      return -1;
    }
    Buffer8.prototype.includes = function includes(val2, byteOffset, encoding) {
      return this.indexOf(val2, byteOffset, encoding) !== -1;
    };
    Buffer8.prototype.indexOf = function indexOf(val2, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val2, byteOffset, encoding, true);
    };
    Buffer8.prototype.lastIndexOf = function lastIndexOf(val2, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val2, byteOffset, encoding, false);
    };
    function hexWrite(buf, string, offset, length) {
      offset = Number(offset) || 0;
      var remaining = buf.length - offset;
      if (!length) {
        length = remaining;
      } else {
        length = Number(length);
        if (length > remaining) {
          length = remaining;
        }
      }
      var strLen = string.length;
      if (strLen % 2 !== 0)
        throw new TypeError("Invalid hex string");
      if (length > strLen / 2) {
        length = strLen / 2;
      }
      for (var i2 = 0; i2 < length; ++i2) {
        var parsed = parseInt(string.substr(i2 * 2, 2), 16);
        if (isNaN(parsed))
          return i2;
        buf[offset + i2] = parsed;
      }
      return i2;
    }
    function utf8Write(buf, string, offset, length) {
      return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
    }
    function asciiWrite(buf, string, offset, length) {
      return blitBuffer(asciiToBytes(string), buf, offset, length);
    }
    function latin1Write(buf, string, offset, length) {
      return asciiWrite(buf, string, offset, length);
    }
    function base64Write(buf, string, offset, length) {
      return blitBuffer(base64ToBytes(string), buf, offset, length);
    }
    function ucs2Write(buf, string, offset, length) {
      return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
    }
    Buffer8.prototype.write = function write(string, offset, length, encoding) {
      if (offset === void 0) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
      } else if (length === void 0 && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
      } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
          length = length | 0;
          if (encoding === void 0)
            encoding = "utf8";
        } else {
          encoding = length;
          length = void 0;
        }
      } else {
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      }
      var remaining = this.length - offset;
      if (length === void 0 || length > remaining)
        length = remaining;
      if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
        throw new RangeError("Attempt to write outside buffer bounds");
      }
      if (!encoding)
        encoding = "utf8";
      var loweredCase = false;
      for (; ; ) {
        switch (encoding) {
          case "hex":
            return hexWrite(this, string, offset, length);
          case "utf8":
          case "utf-8":
            return utf8Write(this, string, offset, length);
          case "ascii":
            return asciiWrite(this, string, offset, length);
          case "latin1":
          case "binary":
            return latin1Write(this, string, offset, length);
          case "base64":
            return base64Write(this, string, offset, length);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return ucs2Write(this, string, offset, length);
          default:
            if (loweredCase)
              throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    };
    Buffer8.prototype.toJSON = function toJSON() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function base64Slice(buf, start, end) {
      if (start === 0 && end === buf.length) {
        return base64.fromByteArray(buf);
      } else {
        return base64.fromByteArray(buf.slice(start, end));
      }
    }
    function utf8Slice(buf, start, end) {
      end = Math.min(buf.length, end);
      var res = [];
      var i2 = start;
      while (i2 < end) {
        var firstByte = buf[i2];
        var codePoint = null;
        var bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
        if (i2 + bytesPerSequence <= end) {
          var secondByte, thirdByte, fourthByte, tempCodePoint;
          switch (bytesPerSequence) {
            case 1:
              if (firstByte < 128) {
                codePoint = firstByte;
              }
              break;
            case 2:
              secondByte = buf[i2 + 1];
              if ((secondByte & 192) === 128) {
                tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
                if (tempCodePoint > 127) {
                  codePoint = tempCodePoint;
                }
              }
              break;
            case 3:
              secondByte = buf[i2 + 1];
              thirdByte = buf[i2 + 2];
              if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
                tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
                if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
                  codePoint = tempCodePoint;
                }
              }
              break;
            case 4:
              secondByte = buf[i2 + 1];
              thirdByte = buf[i2 + 2];
              fourthByte = buf[i2 + 3];
              if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
                tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
                if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
                  codePoint = tempCodePoint;
                }
              }
          }
        }
        if (codePoint === null) {
          codePoint = 65533;
          bytesPerSequence = 1;
        } else if (codePoint > 65535) {
          codePoint -= 65536;
          res.push(codePoint >>> 10 & 1023 | 55296);
          codePoint = 56320 | codePoint & 1023;
        }
        res.push(codePoint);
        i2 += bytesPerSequence;
      }
      return decodeCodePointsArray(res);
    }
    var MAX_ARGUMENTS_LENGTH = 4096;
    function decodeCodePointsArray(codePoints) {
      var len = codePoints.length;
      if (len <= MAX_ARGUMENTS_LENGTH) {
        return String.fromCharCode.apply(String, codePoints);
      }
      var res = "";
      var i2 = 0;
      while (i2 < len) {
        res += String.fromCharCode.apply(
          String,
          codePoints.slice(i2, i2 += MAX_ARGUMENTS_LENGTH)
        );
      }
      return res;
    }
    function asciiSlice(buf, start, end) {
      var ret = "";
      end = Math.min(buf.length, end);
      for (var i2 = start; i2 < end; ++i2) {
        ret += String.fromCharCode(buf[i2] & 127);
      }
      return ret;
    }
    function latin1Slice(buf, start, end) {
      var ret = "";
      end = Math.min(buf.length, end);
      for (var i2 = start; i2 < end; ++i2) {
        ret += String.fromCharCode(buf[i2]);
      }
      return ret;
    }
    function hexSlice(buf, start, end) {
      var len = buf.length;
      if (!start || start < 0)
        start = 0;
      if (!end || end < 0 || end > len)
        end = len;
      var out = "";
      for (var i2 = start; i2 < end; ++i2) {
        out += toHex4(buf[i2]);
      }
      return out;
    }
    function utf16leSlice(buf, start, end) {
      var bytes = buf.slice(start, end);
      var res = "";
      for (var i2 = 0; i2 < bytes.length; i2 += 2) {
        res += String.fromCharCode(bytes[i2] + bytes[i2 + 1] * 256);
      }
      return res;
    }
    Buffer8.prototype.slice = function slice(start, end) {
      var len = this.length;
      start = ~~start;
      end = end === void 0 ? len : ~~end;
      if (start < 0) {
        start += len;
        if (start < 0)
          start = 0;
      } else if (start > len) {
        start = len;
      }
      if (end < 0) {
        end += len;
        if (end < 0)
          end = 0;
      } else if (end > len) {
        end = len;
      }
      if (end < start)
        end = start;
      var newBuf;
      if (Buffer8.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer8.prototype;
      } else {
        var sliceLen = end - start;
        newBuf = new Buffer8(sliceLen, void 0);
        for (var i2 = 0; i2 < sliceLen; ++i2) {
          newBuf[i2] = this[i2 + start];
        }
      }
      return newBuf;
    };
    function checkOffset(offset, ext, length) {
      if (offset % 1 !== 0 || offset < 0)
        throw new RangeError("offset is not uint");
      if (offset + ext > length)
        throw new RangeError("Trying to access beyond buffer length");
    }
    Buffer8.prototype.readUIntLE = function readUIntLE(offset, byteLength3, noAssert) {
      offset = offset | 0;
      byteLength3 = byteLength3 | 0;
      if (!noAssert)
        checkOffset(offset, byteLength3, this.length);
      var val2 = this[offset];
      var mul = 1;
      var i2 = 0;
      while (++i2 < byteLength3 && (mul *= 256)) {
        val2 += this[offset + i2] * mul;
      }
      return val2;
    };
    Buffer8.prototype.readUIntBE = function readUIntBE(offset, byteLength3, noAssert) {
      offset = offset | 0;
      byteLength3 = byteLength3 | 0;
      if (!noAssert) {
        checkOffset(offset, byteLength3, this.length);
      }
      var val2 = this[offset + --byteLength3];
      var mul = 1;
      while (byteLength3 > 0 && (mul *= 256)) {
        val2 += this[offset + --byteLength3] * mul;
      }
      return val2;
    };
    Buffer8.prototype.readUInt8 = function readUInt8(offset, noAssert) {
      if (!noAssert)
        checkOffset(offset, 1, this.length);
      return this[offset];
    };
    Buffer8.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      return this[offset] | this[offset + 1] << 8;
    };
    Buffer8.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      return this[offset] << 8 | this[offset + 1];
    };
    Buffer8.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
    };
    Buffer8.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
    };
    Buffer8.prototype.readIntLE = function readIntLE(offset, byteLength3, noAssert) {
      offset = offset | 0;
      byteLength3 = byteLength3 | 0;
      if (!noAssert)
        checkOffset(offset, byteLength3, this.length);
      var val2 = this[offset];
      var mul = 1;
      var i2 = 0;
      while (++i2 < byteLength3 && (mul *= 256)) {
        val2 += this[offset + i2] * mul;
      }
      mul *= 128;
      if (val2 >= mul)
        val2 -= Math.pow(2, 8 * byteLength3);
      return val2;
    };
    Buffer8.prototype.readIntBE = function readIntBE(offset, byteLength3, noAssert) {
      offset = offset | 0;
      byteLength3 = byteLength3 | 0;
      if (!noAssert)
        checkOffset(offset, byteLength3, this.length);
      var i2 = byteLength3;
      var mul = 1;
      var val2 = this[offset + --i2];
      while (i2 > 0 && (mul *= 256)) {
        val2 += this[offset + --i2] * mul;
      }
      mul *= 128;
      if (val2 >= mul)
        val2 -= Math.pow(2, 8 * byteLength3);
      return val2;
    };
    Buffer8.prototype.readInt8 = function readInt8(offset, noAssert) {
      if (!noAssert)
        checkOffset(offset, 1, this.length);
      if (!(this[offset] & 128))
        return this[offset];
      return (255 - this[offset] + 1) * -1;
    };
    Buffer8.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      var val2 = this[offset] | this[offset + 1] << 8;
      return val2 & 32768 ? val2 | 4294901760 : val2;
    };
    Buffer8.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      var val2 = this[offset + 1] | this[offset] << 8;
      return val2 & 32768 ? val2 | 4294901760 : val2;
    };
    Buffer8.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
    };
    Buffer8.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
    };
    Buffer8.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return ieee754.read(this, offset, true, 23, 4);
    };
    Buffer8.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return ieee754.read(this, offset, false, 23, 4);
    };
    Buffer8.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
      if (!noAssert)
        checkOffset(offset, 8, this.length);
      return ieee754.read(this, offset, true, 52, 8);
    };
    Buffer8.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
      if (!noAssert)
        checkOffset(offset, 8, this.length);
      return ieee754.read(this, offset, false, 52, 8);
    };
    function checkInt(buf, value, offset, ext, max, min) {
      if (!Buffer8.isBuffer(buf))
        throw new TypeError('"buffer" argument must be a Buffer instance');
      if (value > max || value < min)
        throw new RangeError('"value" argument is out of bounds');
      if (offset + ext > buf.length)
        throw new RangeError("Index out of range");
    }
    Buffer8.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength3, noAssert) {
      value = +value;
      offset = offset | 0;
      byteLength3 = byteLength3 | 0;
      if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength3) - 1;
        checkInt(this, value, offset, byteLength3, maxBytes, 0);
      }
      var mul = 1;
      var i2 = 0;
      this[offset] = value & 255;
      while (++i2 < byteLength3 && (mul *= 256)) {
        this[offset + i2] = value / mul & 255;
      }
      return offset + byteLength3;
    };
    Buffer8.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength3, noAssert) {
      value = +value;
      offset = offset | 0;
      byteLength3 = byteLength3 | 0;
      if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength3) - 1;
        checkInt(this, value, offset, byteLength3, maxBytes, 0);
      }
      var i2 = byteLength3 - 1;
      var mul = 1;
      this[offset + i2] = value & 255;
      while (--i2 >= 0 && (mul *= 256)) {
        this[offset + i2] = value / mul & 255;
      }
      return offset + byteLength3;
    };
    Buffer8.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert)
        checkInt(this, value, offset, 1, 255, 0);
      if (!Buffer8.TYPED_ARRAY_SUPPORT)
        value = Math.floor(value);
      this[offset] = value & 255;
      return offset + 1;
    };
    function objectWriteUInt16(buf, value, offset, littleEndian) {
      if (value < 0)
        value = 65535 + value + 1;
      for (var i2 = 0, j2 = Math.min(buf.length - offset, 2); i2 < j2; ++i2) {
        buf[offset + i2] = (value & 255 << 8 * (littleEndian ? i2 : 1 - i2)) >>> (littleEndian ? i2 : 1 - i2) * 8;
      }
    }
    Buffer8.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 65535, 0);
      if (Buffer8.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 255;
        this[offset + 1] = value >>> 8;
      } else {
        objectWriteUInt16(this, value, offset, true);
      }
      return offset + 2;
    };
    Buffer8.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 65535, 0);
      if (Buffer8.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 255;
      } else {
        objectWriteUInt16(this, value, offset, false);
      }
      return offset + 2;
    };
    function objectWriteUInt32(buf, value, offset, littleEndian) {
      if (value < 0)
        value = 4294967295 + value + 1;
      for (var i2 = 0, j2 = Math.min(buf.length - offset, 4); i2 < j2; ++i2) {
        buf[offset + i2] = value >>> (littleEndian ? i2 : 3 - i2) * 8 & 255;
      }
    }
    Buffer8.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 4294967295, 0);
      if (Buffer8.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 255;
      } else {
        objectWriteUInt32(this, value, offset, true);
      }
      return offset + 4;
    };
    Buffer8.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 4294967295, 0);
      if (Buffer8.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 255;
      } else {
        objectWriteUInt32(this, value, offset, false);
      }
      return offset + 4;
    };
    Buffer8.prototype.writeIntLE = function writeIntLE(value, offset, byteLength3, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength3 - 1);
        checkInt(this, value, offset, byteLength3, limit - 1, -limit);
      }
      var i2 = 0;
      var mul = 1;
      var sub = 0;
      this[offset] = value & 255;
      while (++i2 < byteLength3 && (mul *= 256)) {
        if (value < 0 && sub === 0 && this[offset + i2 - 1] !== 0) {
          sub = 1;
        }
        this[offset + i2] = (value / mul >> 0) - sub & 255;
      }
      return offset + byteLength3;
    };
    Buffer8.prototype.writeIntBE = function writeIntBE(value, offset, byteLength3, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength3 - 1);
        checkInt(this, value, offset, byteLength3, limit - 1, -limit);
      }
      var i2 = byteLength3 - 1;
      var mul = 1;
      var sub = 0;
      this[offset + i2] = value & 255;
      while (--i2 >= 0 && (mul *= 256)) {
        if (value < 0 && sub === 0 && this[offset + i2 + 1] !== 0) {
          sub = 1;
        }
        this[offset + i2] = (value / mul >> 0) - sub & 255;
      }
      return offset + byteLength3;
    };
    Buffer8.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert)
        checkInt(this, value, offset, 1, 127, -128);
      if (!Buffer8.TYPED_ARRAY_SUPPORT)
        value = Math.floor(value);
      if (value < 0)
        value = 255 + value + 1;
      this[offset] = value & 255;
      return offset + 1;
    };
    Buffer8.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 32767, -32768);
      if (Buffer8.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 255;
        this[offset + 1] = value >>> 8;
      } else {
        objectWriteUInt16(this, value, offset, true);
      }
      return offset + 2;
    };
    Buffer8.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 32767, -32768);
      if (Buffer8.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 255;
      } else {
        objectWriteUInt16(this, value, offset, false);
      }
      return offset + 2;
    };
    Buffer8.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 2147483647, -2147483648);
      if (Buffer8.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 255;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
      } else {
        objectWriteUInt32(this, value, offset, true);
      }
      return offset + 4;
    };
    Buffer8.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 2147483647, -2147483648);
      if (value < 0)
        value = 4294967295 + value + 1;
      if (Buffer8.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 255;
      } else {
        objectWriteUInt32(this, value, offset, false);
      }
      return offset + 4;
    };
    function checkIEEE754(buf, value, offset, ext, max, min) {
      if (offset + ext > buf.length)
        throw new RangeError("Index out of range");
      if (offset < 0)
        throw new RangeError("Index out of range");
    }
    function writeFloat(buf, value, offset, littleEndian, noAssert) {
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 4, 34028234663852886e22, -34028234663852886e22);
      }
      ieee754.write(buf, value, offset, littleEndian, 23, 4);
      return offset + 4;
    }
    Buffer8.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
      return writeFloat(this, value, offset, true, noAssert);
    };
    Buffer8.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
      return writeFloat(this, value, offset, false, noAssert);
    };
    function writeDouble(buf, value, offset, littleEndian, noAssert) {
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 8, 17976931348623157e292, -17976931348623157e292);
      }
      ieee754.write(buf, value, offset, littleEndian, 52, 8);
      return offset + 8;
    }
    Buffer8.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
      return writeDouble(this, value, offset, true, noAssert);
    };
    Buffer8.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
      return writeDouble(this, value, offset, false, noAssert);
    };
    Buffer8.prototype.copy = function copy(target, targetStart, start, end) {
      if (!start)
        start = 0;
      if (!end && end !== 0)
        end = this.length;
      if (targetStart >= target.length)
        targetStart = target.length;
      if (!targetStart)
        targetStart = 0;
      if (end > 0 && end < start)
        end = start;
      if (end === start)
        return 0;
      if (target.length === 0 || this.length === 0)
        return 0;
      if (targetStart < 0) {
        throw new RangeError("targetStart out of bounds");
      }
      if (start < 0 || start >= this.length)
        throw new RangeError("sourceStart out of bounds");
      if (end < 0)
        throw new RangeError("sourceEnd out of bounds");
      if (end > this.length)
        end = this.length;
      if (target.length - targetStart < end - start) {
        end = target.length - targetStart + start;
      }
      var len = end - start;
      var i2;
      if (this === target && start < targetStart && targetStart < end) {
        for (i2 = len - 1; i2 >= 0; --i2) {
          target[i2 + targetStart] = this[i2 + start];
        }
      } else if (len < 1e3 || !Buffer8.TYPED_ARRAY_SUPPORT) {
        for (i2 = 0; i2 < len; ++i2) {
          target[i2 + targetStart] = this[i2 + start];
        }
      } else {
        Uint8Array.prototype.set.call(
          target,
          this.subarray(start, start + len),
          targetStart
        );
      }
      return len;
    };
    Buffer8.prototype.fill = function fill(val2, start, end, encoding) {
      if (typeof val2 === "string") {
        if (typeof start === "string") {
          encoding = start;
          start = 0;
          end = this.length;
        } else if (typeof end === "string") {
          encoding = end;
          end = this.length;
        }
        if (val2.length === 1) {
          var code = val2.charCodeAt(0);
          if (code < 256) {
            val2 = code;
          }
        }
        if (encoding !== void 0 && typeof encoding !== "string") {
          throw new TypeError("encoding must be a string");
        }
        if (typeof encoding === "string" && !Buffer8.isEncoding(encoding)) {
          throw new TypeError("Unknown encoding: " + encoding);
        }
      } else if (typeof val2 === "number") {
        val2 = val2 & 255;
      }
      if (start < 0 || this.length < start || this.length < end) {
        throw new RangeError("Out of range index");
      }
      if (end <= start) {
        return this;
      }
      start = start >>> 0;
      end = end === void 0 ? this.length : end >>> 0;
      if (!val2)
        val2 = 0;
      var i2;
      if (typeof val2 === "number") {
        for (i2 = start; i2 < end; ++i2) {
          this[i2] = val2;
        }
      } else {
        var bytes = Buffer8.isBuffer(val2) ? val2 : utf8ToBytes(new Buffer8(val2, encoding).toString());
        var len = bytes.length;
        for (i2 = 0; i2 < end - start; ++i2) {
          this[i2 + start] = bytes[i2 % len];
        }
      }
      return this;
    };
    var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
    function base64clean(str) {
      str = stringtrim(str).replace(INVALID_BASE64_RE, "");
      if (str.length < 2)
        return "";
      while (str.length % 4 !== 0) {
        str = str + "=";
      }
      return str;
    }
    function stringtrim(str) {
      if (str.trim)
        return str.trim();
      return str.replace(/^\s+|\s+$/g, "");
    }
    function toHex4(n2) {
      if (n2 < 16)
        return "0" + n2.toString(16);
      return n2.toString(16);
    }
    function utf8ToBytes(string, units) {
      units = units || Infinity;
      var codePoint;
      var length = string.length;
      var leadSurrogate = null;
      var bytes = [];
      for (var i2 = 0; i2 < length; ++i2) {
        codePoint = string.charCodeAt(i2);
        if (codePoint > 55295 && codePoint < 57344) {
          if (!leadSurrogate) {
            if (codePoint > 56319) {
              if ((units -= 3) > -1)
                bytes.push(239, 191, 189);
              continue;
            } else if (i2 + 1 === length) {
              if ((units -= 3) > -1)
                bytes.push(239, 191, 189);
              continue;
            }
            leadSurrogate = codePoint;
            continue;
          }
          if (codePoint < 56320) {
            if ((units -= 3) > -1)
              bytes.push(239, 191, 189);
            leadSurrogate = codePoint;
            continue;
          }
          codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
        } else if (leadSurrogate) {
          if ((units -= 3) > -1)
            bytes.push(239, 191, 189);
        }
        leadSurrogate = null;
        if (codePoint < 128) {
          if ((units -= 1) < 0)
            break;
          bytes.push(codePoint);
        } else if (codePoint < 2048) {
          if ((units -= 2) < 0)
            break;
          bytes.push(
            codePoint >> 6 | 192,
            codePoint & 63 | 128
          );
        } else if (codePoint < 65536) {
          if ((units -= 3) < 0)
            break;
          bytes.push(
            codePoint >> 12 | 224,
            codePoint >> 6 & 63 | 128,
            codePoint & 63 | 128
          );
        } else if (codePoint < 1114112) {
          if ((units -= 4) < 0)
            break;
          bytes.push(
            codePoint >> 18 | 240,
            codePoint >> 12 & 63 | 128,
            codePoint >> 6 & 63 | 128,
            codePoint & 63 | 128
          );
        } else {
          throw new Error("Invalid code point");
        }
      }
      return bytes;
    }
    function asciiToBytes(str) {
      var byteArray = [];
      for (var i2 = 0; i2 < str.length; ++i2) {
        byteArray.push(str.charCodeAt(i2) & 255);
      }
      return byteArray;
    }
    function utf16leToBytes(str, units) {
      var c2, hi, lo;
      var byteArray = [];
      for (var i2 = 0; i2 < str.length; ++i2) {
        if ((units -= 2) < 0)
          break;
        c2 = str.charCodeAt(i2);
        hi = c2 >> 8;
        lo = c2 % 256;
        byteArray.push(lo);
        byteArray.push(hi);
      }
      return byteArray;
    }
    function base64ToBytes(str) {
      return base64.toByteArray(base64clean(str));
    }
    function blitBuffer(src, dst, offset, length) {
      for (var i2 = 0; i2 < length; ++i2) {
        if (i2 + offset >= dst.length || i2 >= src.length)
          break;
        dst[i2 + offset] = src[i2];
      }
      return i2;
    }
    function isnan(val2) {
      return val2 !== val2;
    }
  }
});

// browser-external:crypto
var require_crypto = __commonJS({
  "browser-external:crypto"(exports, module) {
    module.exports = {};
  }
});

// node_modules/amazon-cognito-identity-js/node_modules/tslib/tslib.js
var require_tslib19 = __commonJS({
  "node_modules/amazon-cognito-identity-js/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/amazon-cognito-identity-js/node_modules/@aws-crypto/sha256-js/build/constants.js
var require_constants10 = __commonJS({
  "node_modules/amazon-cognito-identity-js/node_modules/@aws-crypto/sha256-js/build/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
    exports.BLOCK_SIZE = 64;
    exports.DIGEST_LENGTH = 32;
    exports.KEY = new Uint32Array([
      1116352408,
      1899447441,
      3049323471,
      3921009573,
      961987163,
      1508970993,
      2453635748,
      2870763221,
      3624381080,
      310598401,
      607225278,
      1426881987,
      1925078388,
      2162078206,
      2614888103,
      3248222580,
      3835390401,
      4022224774,
      264347078,
      604807628,
      770255983,
      1249150122,
      1555081692,
      1996064986,
      2554220882,
      2821834349,
      2952996808,
      3210313671,
      3336571891,
      3584528711,
      113926993,
      338241895,
      666307205,
      773529912,
      1294757372,
      1396182291,
      1695183700,
      1986661051,
      2177026350,
      2456956037,
      2730485921,
      2820302411,
      3259730800,
      3345764771,
      3516065817,
      3600352804,
      4094571909,
      275423344,
      430227734,
      506948616,
      659060556,
      883997877,
      958139571,
      1322822218,
      1537002063,
      1747873779,
      1955562222,
      2024104815,
      2227730452,
      2361852424,
      2428436474,
      2756734187,
      3204031479,
      3329325298
    ]);
    exports.INIT = [
      1779033703,
      3144134277,
      1013904242,
      2773480762,
      1359893119,
      2600822924,
      528734635,
      1541459225
    ];
    exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
  }
});

// node_modules/amazon-cognito-identity-js/node_modules/@aws-crypto/sha256-js/build/RawSha256.js
var require_RawSha2566 = __commonJS({
  "node_modules/amazon-cognito-identity-js/node_modules/@aws-crypto/sha256-js/build/RawSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.RawSha256 = void 0;
    var constants_1 = require_constants10();
    var RawSha256 = (
      /** @class */
      function() {
        function RawSha2562() {
          this.state = Int32Array.from(constants_1.INIT);
          this.temp = new Int32Array(64);
          this.buffer = new Uint8Array(64);
          this.bufferLength = 0;
          this.bytesHashed = 0;
          this.finished = false;
        }
        RawSha2562.prototype.update = function(data) {
          if (this.finished) {
            throw new Error("Attempted to update an already finished hash.");
          }
          var position = 0;
          var byteLength2 = data.byteLength;
          this.bytesHashed += byteLength2;
          if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) {
            throw new Error("Cannot hash more than 2^53 - 1 bits");
          }
          while (byteLength2 > 0) {
            this.buffer[this.bufferLength++] = data[position++];
            byteLength2--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
              this.hashBuffer();
              this.bufferLength = 0;
            }
          }
        };
        RawSha2562.prototype.digest = function() {
          if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 128);
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
              for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE; i2++) {
                bufferView.setUint8(i2, 0);
              }
              this.hashBuffer();
              this.bufferLength = 0;
            }
            for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE - 8; i2++) {
              bufferView.setUint8(i2, 0);
            }
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 4294967296), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
          }
          var out = new Uint8Array(constants_1.DIGEST_LENGTH);
          for (var i2 = 0; i2 < 8; i2++) {
            out[i2 * 4] = this.state[i2] >>> 24 & 255;
            out[i2 * 4 + 1] = this.state[i2] >>> 16 & 255;
            out[i2 * 4 + 2] = this.state[i2] >>> 8 & 255;
            out[i2 * 4 + 3] = this.state[i2] >>> 0 & 255;
          }
          return out;
        };
        RawSha2562.prototype.hashBuffer = function() {
          var _a2 = this, buffer = _a2.buffer, state = _a2.state;
          var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
          for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
            if (i2 < 16) {
              this.temp[i2] = (buffer[i2 * 4] & 255) << 24 | (buffer[i2 * 4 + 1] & 255) << 16 | (buffer[i2 * 4 + 2] & 255) << 8 | buffer[i2 * 4 + 3] & 255;
            } else {
              var u2 = this.temp[i2 - 2];
              var t1_1 = (u2 >>> 17 | u2 << 15) ^ (u2 >>> 19 | u2 << 13) ^ u2 >>> 10;
              u2 = this.temp[i2 - 15];
              var t2_1 = (u2 >>> 7 | u2 << 25) ^ (u2 >>> 18 | u2 << 14) ^ u2 >>> 3;
              this.temp[i2] = (t1_1 + this.temp[i2 - 7] | 0) + (t2_1 + this.temp[i2 - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i2] + this.temp[i2] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
          }
          state[0] += state0;
          state[1] += state1;
          state[2] += state2;
          state[3] += state3;
          state[4] += state4;
          state[5] += state5;
          state[6] += state6;
          state[7] += state7;
        };
        return RawSha2562;
      }()
    );
    exports.RawSha256 = RawSha256;
  }
});

// node_modules/amazon-cognito-identity-js/node_modules/@aws-crypto/util/build/convertToBuffer.js
var require_convertToBuffer7 = __commonJS({
  "node_modules/amazon-cognito-identity-js/node_modules/@aws-crypto/util/build/convertToBuffer.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.convertToBuffer = void 0;
    var util_utf8_browser_1 = (init_dist_es(), __toCommonJS(dist_es_exports));
    var fromUtf831 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
      return Buffer.from(input, "utf8");
    } : util_utf8_browser_1.fromUtf8;
    function convertToBuffer2(data) {
      if (data instanceof Uint8Array)
        return data;
      if (typeof data === "string") {
        return fromUtf831(data);
      }
      if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
      }
      return new Uint8Array(data);
    }
    exports.convertToBuffer = convertToBuffer2;
  }
});

// node_modules/amazon-cognito-identity-js/node_modules/@aws-crypto/util/build/isEmptyData.js
var require_isEmptyData11 = __commonJS({
  "node_modules/amazon-cognito-identity-js/node_modules/@aws-crypto/util/build/isEmptyData.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isEmptyData = void 0;
    function isEmptyData2(data) {
      if (typeof data === "string") {
        return data.length === 0;
      }
      return data.byteLength === 0;
    }
    exports.isEmptyData = isEmptyData2;
  }
});

// node_modules/amazon-cognito-identity-js/node_modules/@aws-crypto/util/build/numToUint8.js
var require_numToUint87 = __commonJS({
  "node_modules/amazon-cognito-identity-js/node_modules/@aws-crypto/util/build/numToUint8.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.numToUint8 = void 0;
    function numToUint8(num) {
      return new Uint8Array([
        (num & 4278190080) >> 24,
        (num & 16711680) >> 16,
        (num & 65280) >> 8,
        num & 255
      ]);
    }
    exports.numToUint8 = numToUint8;
  }
});

// node_modules/amazon-cognito-identity-js/node_modules/@aws-crypto/util/build/uint32ArrayFrom.js
var require_uint32ArrayFrom7 = __commonJS({
  "node_modules/amazon-cognito-identity-js/node_modules/@aws-crypto/util/build/uint32ArrayFrom.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = void 0;
    function uint32ArrayFrom(a_lookUpTable) {
      if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while (a_index < a_lookUpTable.length) {
          return_array[a_index] = a_lookUpTable[a_index];
        }
        return return_array;
      }
      return Uint32Array.from(a_lookUpTable);
    }
    exports.uint32ArrayFrom = uint32ArrayFrom;
  }
});

// node_modules/amazon-cognito-identity-js/node_modules/@aws-crypto/util/build/index.js
var require_build25 = __commonJS({
  "node_modules/amazon-cognito-identity-js/node_modules/@aws-crypto/util/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
    var convertToBuffer_1 = require_convertToBuffer7();
    Object.defineProperty(exports, "convertToBuffer", { enumerable: true, get: function() {
      return convertToBuffer_1.convertToBuffer;
    } });
    var isEmptyData_1 = require_isEmptyData11();
    Object.defineProperty(exports, "isEmptyData", { enumerable: true, get: function() {
      return isEmptyData_1.isEmptyData;
    } });
    var numToUint8_1 = require_numToUint87();
    Object.defineProperty(exports, "numToUint8", { enumerable: true, get: function() {
      return numToUint8_1.numToUint8;
    } });
    var uint32ArrayFrom_1 = require_uint32ArrayFrom7();
    Object.defineProperty(exports, "uint32ArrayFrom", { enumerable: true, get: function() {
      return uint32ArrayFrom_1.uint32ArrayFrom;
    } });
  }
});

// node_modules/amazon-cognito-identity-js/node_modules/@aws-crypto/sha256-js/build/jsSha256.js
var require_jsSha2566 = __commonJS({
  "node_modules/amazon-cognito-identity-js/node_modules/@aws-crypto/sha256-js/build/jsSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var tslib_1 = require_tslib19();
    var constants_1 = require_constants10();
    var RawSha256_1 = require_RawSha2566();
    var util_1 = require_build25();
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          this.hash = new RawSha256_1.RawSha256();
          if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
              inner[i2] ^= 54;
              outer[i2] ^= 92;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            for (var i2 = 0; i2 < inner.byteLength; i2++) {
              inner[i2] = 0;
            }
          }
        }
        Sha25613.prototype.update = function(toHash) {
          if ((0, util_1.isEmptyData)(toHash) || this.error) {
            return;
          }
          try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
          } catch (e) {
            this.error = e;
          }
        };
        Sha25613.prototype.digestSync = function() {
          if (this.error) {
            throw this.error;
          }
          if (this.outer) {
            if (!this.outer.finished) {
              this.outer.update(this.hash.digest());
            }
            return this.outer.digest();
          }
          return this.hash.digest();
        };
        Sha25613.prototype.digest = function() {
          return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a2) {
              return [2, this.digestSync()];
            });
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
    function bufferFromSecret(secret) {
      var input = (0, util_1.convertToBuffer)(secret);
      if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
      }
      var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
      buffer.set(input);
      return buffer;
    }
  }
});

// node_modules/amazon-cognito-identity-js/node_modules/@aws-crypto/sha256-js/build/index.js
var require_build26 = __commonJS({
  "node_modules/amazon-cognito-identity-js/node_modules/@aws-crypto/sha256-js/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib19();
    (0, tslib_1.__exportStar)(require_jsSha2566(), exports);
  }
});

// node_modules/amazon-cognito-identity-js/node_modules/js-cookie/src/js.cookie.js
var require_js_cookie = __commonJS({
  "node_modules/amazon-cognito-identity-js/node_modules/js-cookie/src/js.cookie.js"(exports, module) {
    (function(factory2) {
      var registeredInModuleLoader;
      if (typeof define === "function" && define.amd) {
        define(factory2);
        registeredInModuleLoader = true;
      }
      if (typeof exports === "object") {
        module.exports = factory2();
        registeredInModuleLoader = true;
      }
      if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory2();
        api.noConflict = function() {
          window.Cookies = OldCookies;
          return api;
        };
      }
    })(function() {
      function extend() {
        var i2 = 0;
        var result = {};
        for (; i2 < arguments.length; i2++) {
          var attributes = arguments[i2];
          for (var key in attributes) {
            result[key] = attributes[key];
          }
        }
        return result;
      }
      function decode(s2) {
        return s2.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
      }
      function init(converter) {
        function api() {
        }
        function set2(key, value, attributes) {
          if (typeof document === "undefined") {
            return;
          }
          attributes = extend({
            path: "/"
          }, api.defaults, attributes);
          if (typeof attributes.expires === "number") {
            attributes.expires = new Date(/* @__PURE__ */ new Date() * 1 + attributes.expires * 864e5);
          }
          attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
          try {
            var result = JSON.stringify(value);
            if (/^[\{\[]/.test(result)) {
              value = result;
            }
          } catch (e) {
          }
          value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
          key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
          var stringifiedAttributes = "";
          for (var attributeName in attributes) {
            if (!attributes[attributeName]) {
              continue;
            }
            stringifiedAttributes += "; " + attributeName;
            if (attributes[attributeName] === true) {
              continue;
            }
            stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
          }
          return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get3(key, json) {
          if (typeof document === "undefined") {
            return;
          }
          var jar = {};
          var cookies = document.cookie ? document.cookie.split("; ") : [];
          var i2 = 0;
          for (; i2 < cookies.length; i2++) {
            var parts = cookies[i2].split("=");
            var cookie3 = parts.slice(1).join("=");
            if (!json && cookie3.charAt(0) === '"') {
              cookie3 = cookie3.slice(1, -1);
            }
            try {
              var name = decode(parts[0]);
              cookie3 = (converter.read || converter)(cookie3, name) || decode(cookie3);
              if (json) {
                try {
                  cookie3 = JSON.parse(cookie3);
                } catch (e) {
                }
              }
              jar[name] = cookie3;
              if (key === name) {
                break;
              }
            } catch (e) {
            }
          }
          return key ? jar[key] : jar;
        }
        api.set = set2;
        api.get = function(key) {
          return get3(
            key,
            false
            /* read as raw */
          );
        };
        api.getJSON = function(key) {
          return get3(
            key,
            true
            /* read as json */
          );
        };
        api.remove = function(key, attributes) {
          set2(key, "", extend(attributes, {
            expires: -1
          }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
      }
      return init(function() {
      });
    });
  }
});

// node_modules/url/node_modules/punycode/punycode.js
var require_punycode = __commonJS({
  "node_modules/url/node_modules/punycode/punycode.js"(exports, module) {
    (function(root) {
      var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
      var freeModule = typeof module == "object" && module && !module.nodeType && module;
      var freeGlobal = typeof global == "object" && global;
      if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) {
        root = freeGlobal;
      }
      var punycode, maxInt = 2147483647, base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
      }, baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, key;
      function error(type) {
        throw RangeError(errors[type]);
      }
      function map5(array, fn2) {
        var length = array.length;
        var result = [];
        while (length--) {
          result[length] = fn2(array[length]);
        }
        return result;
      }
      function mapDomain(string, fn2) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
          result = parts[0] + "@";
          string = parts[1];
        }
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map5(labels, fn2).join(".");
        return result + encoded;
      }
      function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while (counter < length) {
          value = string.charCodeAt(counter++);
          if (value >= 55296 && value <= 56319 && counter < length) {
            extra = string.charCodeAt(counter++);
            if ((extra & 64512) == 56320) {
              output.push(((value & 1023) << 10) + (extra & 1023) + 65536);
            } else {
              output.push(value);
              counter--;
            }
          } else {
            output.push(value);
          }
        }
        return output;
      }
      function ucs2encode(array) {
        return map5(array, function(value) {
          var output = "";
          if (value > 65535) {
            value -= 65536;
            output += stringFromCharCode(value >>> 10 & 1023 | 55296);
            value = 56320 | value & 1023;
          }
          output += stringFromCharCode(value);
          return output;
        }).join("");
      }
      function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) {
          return codePoint - 22;
        }
        if (codePoint - 65 < 26) {
          return codePoint - 65;
        }
        if (codePoint - 97 < 26) {
          return codePoint - 97;
        }
        return base;
      }
      function digitToBasic(digit, flag) {
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
      }
      function adapt(delta, numPoints, firstTime) {
        var k2 = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for (; delta > baseMinusTMin * tMax >> 1; k2 += base) {
          delta = floor(delta / baseMinusTMin);
        }
        return floor(k2 + (baseMinusTMin + 1) * delta / (delta + skew));
      }
      function decode(input) {
        var output = [], inputLength = input.length, out, i2 = 0, n2 = initialN, bias = initialBias, basic, j2, index, oldi, w2, k2, digit, t2, baseMinusT;
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) {
          basic = 0;
        }
        for (j2 = 0; j2 < basic; ++j2) {
          if (input.charCodeAt(j2) >= 128) {
            error("not-basic");
          }
          output.push(input.charCodeAt(j2));
        }
        for (index = basic > 0 ? basic + 1 : 0; index < inputLength; ) {
          for (oldi = i2, w2 = 1, k2 = base; ; k2 += base) {
            if (index >= inputLength) {
              error("invalid-input");
            }
            digit = basicToDigit(input.charCodeAt(index++));
            if (digit >= base || digit > floor((maxInt - i2) / w2)) {
              error("overflow");
            }
            i2 += digit * w2;
            t2 = k2 <= bias ? tMin : k2 >= bias + tMax ? tMax : k2 - bias;
            if (digit < t2) {
              break;
            }
            baseMinusT = base - t2;
            if (w2 > floor(maxInt / baseMinusT)) {
              error("overflow");
            }
            w2 *= baseMinusT;
          }
          out = output.length + 1;
          bias = adapt(i2 - oldi, out, oldi == 0);
          if (floor(i2 / out) > maxInt - n2) {
            error("overflow");
          }
          n2 += floor(i2 / out);
          i2 %= out;
          output.splice(i2++, 0, n2);
        }
        return ucs2encode(output);
      }
      function encode(input) {
        var n2, delta, handledCPCount, basicLength, bias, j2, m2, q2, k2, t2, currentValue, output = [], inputLength, handledCPCountPlusOne, baseMinusT, qMinusT;
        input = ucs2decode(input);
        inputLength = input.length;
        n2 = initialN;
        delta = 0;
        bias = initialBias;
        for (j2 = 0; j2 < inputLength; ++j2) {
          currentValue = input[j2];
          if (currentValue < 128) {
            output.push(stringFromCharCode(currentValue));
          }
        }
        handledCPCount = basicLength = output.length;
        if (basicLength) {
          output.push(delimiter);
        }
        while (handledCPCount < inputLength) {
          for (m2 = maxInt, j2 = 0; j2 < inputLength; ++j2) {
            currentValue = input[j2];
            if (currentValue >= n2 && currentValue < m2) {
              m2 = currentValue;
            }
          }
          handledCPCountPlusOne = handledCPCount + 1;
          if (m2 - n2 > floor((maxInt - delta) / handledCPCountPlusOne)) {
            error("overflow");
          }
          delta += (m2 - n2) * handledCPCountPlusOne;
          n2 = m2;
          for (j2 = 0; j2 < inputLength; ++j2) {
            currentValue = input[j2];
            if (currentValue < n2 && ++delta > maxInt) {
              error("overflow");
            }
            if (currentValue == n2) {
              for (q2 = delta, k2 = base; ; k2 += base) {
                t2 = k2 <= bias ? tMin : k2 >= bias + tMax ? tMax : k2 - bias;
                if (q2 < t2) {
                  break;
                }
                qMinusT = q2 - t2;
                baseMinusT = base - t2;
                output.push(
                  stringFromCharCode(digitToBasic(t2 + qMinusT % baseMinusT, 0))
                );
                q2 = floor(qMinusT / baseMinusT);
              }
              output.push(stringFromCharCode(digitToBasic(q2, 0)));
              bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
              delta = 0;
              ++handledCPCount;
            }
          }
          ++delta;
          ++n2;
        }
        return output.join("");
      }
      function toUnicode(input) {
        return mapDomain(input, function(string) {
          return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
      }
      function toASCII(input) {
        return mapDomain(input, function(string) {
          return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
      }
      punycode = {
        /**
         * A string representing the current Punycode.js version number.
         * @memberOf punycode
         * @type String
         */
        "version": "1.3.2",
        /**
         * An object of methods to convert from JavaScript's internal character
         * representation (UCS-2) to Unicode code points, and back.
         * @see <https://mathiasbynens.be/notes/javascript-encoding>
         * @memberOf punycode
         * @type Object
         */
        "ucs2": {
          "decode": ucs2decode,
          "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
      };
      if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        define("punycode", function() {
          return punycode;
        });
      } else if (freeExports && freeModule) {
        if (module.exports == freeExports) {
          freeModule.exports = punycode;
        } else {
          for (key in punycode) {
            punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
          }
        }
      } else {
        root.punycode = punycode;
      }
    })(exports);
  }
});

// node_modules/url/util.js
var require_util = __commonJS({
  "node_modules/url/util.js"(exports, module) {
    "use strict";
    module.exports = {
      isString: function(arg) {
        return typeof arg === "string";
      },
      isObject: function(arg) {
        return typeof arg === "object" && arg !== null;
      },
      isNull: function(arg) {
        return arg === null;
      },
      isNullOrUndefined: function(arg) {
        return arg == null;
      }
    };
  }
});

// node_modules/querystring/decode.js
var require_decode = __commonJS({
  "node_modules/querystring/decode.js"(exports, module) {
    "use strict";
    function hasOwnProperty(obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    }
    module.exports = function(qs, sep, eq, options) {
      sep = sep || "&";
      eq = eq || "=";
      var obj = {};
      if (typeof qs !== "string" || qs.length === 0) {
        return obj;
      }
      var regexp = /\+/g;
      qs = qs.split(sep);
      var maxKeys = 1e3;
      if (options && typeof options.maxKeys === "number") {
        maxKeys = options.maxKeys;
      }
      var len = qs.length;
      if (maxKeys > 0 && len > maxKeys) {
        len = maxKeys;
      }
      for (var i2 = 0; i2 < len; ++i2) {
        var x2 = qs[i2].replace(regexp, "%20"), idx = x2.indexOf(eq), kstr, vstr, k2, v2;
        if (idx >= 0) {
          kstr = x2.substr(0, idx);
          vstr = x2.substr(idx + 1);
        } else {
          kstr = x2;
          vstr = "";
        }
        k2 = decodeURIComponent(kstr);
        v2 = decodeURIComponent(vstr);
        if (!hasOwnProperty(obj, k2)) {
          obj[k2] = v2;
        } else if (Array.isArray(obj[k2])) {
          obj[k2].push(v2);
        } else {
          obj[k2] = [obj[k2], v2];
        }
      }
      return obj;
    };
  }
});

// node_modules/querystring/encode.js
var require_encode = __commonJS({
  "node_modules/querystring/encode.js"(exports, module) {
    "use strict";
    var stringifyPrimitive = function(v2) {
      switch (typeof v2) {
        case "string":
          return v2;
        case "boolean":
          return v2 ? "true" : "false";
        case "number":
          return isFinite(v2) ? v2 : "";
        default:
          return "";
      }
    };
    module.exports = function(obj, sep, eq, name) {
      sep = sep || "&";
      eq = eq || "=";
      if (obj === null) {
        obj = void 0;
      }
      if (typeof obj === "object") {
        return Object.keys(obj).map(function(k2) {
          var ks = encodeURIComponent(stringifyPrimitive(k2)) + eq;
          if (Array.isArray(obj[k2])) {
            return obj[k2].map(function(v2) {
              return ks + encodeURIComponent(stringifyPrimitive(v2));
            }).join(sep);
          } else {
            return ks + encodeURIComponent(stringifyPrimitive(obj[k2]));
          }
        }).join(sep);
      }
      if (!name)
        return "";
      return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
    };
  }
});

// node_modules/querystring/index.js
var require_querystring = __commonJS({
  "node_modules/querystring/index.js"(exports) {
    "use strict";
    exports.decode = exports.parse = require_decode();
    exports.encode = exports.stringify = require_encode();
  }
});

// node_modules/url/url.js
var require_url = __commonJS({
  "node_modules/url/url.js"(exports) {
    "use strict";
    var punycode = require_punycode();
    var util = require_util();
    exports.parse = urlParse;
    exports.resolve = urlResolve;
    exports.resolveObject = urlResolveObject;
    exports.format = urlFormat;
    exports.Url = Url;
    function Url() {
      this.protocol = null;
      this.slashes = null;
      this.auth = null;
      this.host = null;
      this.port = null;
      this.hostname = null;
      this.hash = null;
      this.search = null;
      this.query = null;
      this.pathname = null;
      this.path = null;
      this.href = null;
    }
    var protocolPattern = /^([a-z0-9.+-]+:)/i;
    var portPattern = /:[0-9]*$/;
    var simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/;
    var delims = ["<", ">", '"', "`", " ", "\r", "\n", "	"];
    var unwise = ["{", "}", "|", "\\", "^", "`"].concat(delims);
    var autoEscape = ["'"].concat(unwise);
    var nonHostChars = ["%", "/", "?", ";", "#"].concat(autoEscape);
    var hostEndingChars = ["/", "?", "#"];
    var hostnameMaxLen = 255;
    var hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/;
    var hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/;
    var unsafeProtocol = {
      "javascript": true,
      "javascript:": true
    };
    var hostlessProtocol = {
      "javascript": true,
      "javascript:": true
    };
    var slashedProtocol = {
      "http": true,
      "https": true,
      "ftp": true,
      "gopher": true,
      "file": true,
      "http:": true,
      "https:": true,
      "ftp:": true,
      "gopher:": true,
      "file:": true
    };
    var querystring = require_querystring();
    function urlParse(url2, parseQueryString4, slashesDenoteHost) {
      if (url2 && util.isObject(url2) && url2 instanceof Url)
        return url2;
      var u2 = new Url();
      u2.parse(url2, parseQueryString4, slashesDenoteHost);
      return u2;
    }
    Url.prototype.parse = function(url2, parseQueryString4, slashesDenoteHost) {
      if (!util.isString(url2)) {
        throw new TypeError("Parameter 'url' must be a string, not " + typeof url2);
      }
      var queryIndex = url2.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url2.indexOf("#") ? "?" : "#", uSplit = url2.split(splitter), slashRegex = /\\/g;
      uSplit[0] = uSplit[0].replace(slashRegex, "/");
      url2 = uSplit.join(splitter);
      var rest = url2;
      rest = rest.trim();
      if (!slashesDenoteHost && url2.split("#").length === 1) {
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
          this.path = rest;
          this.href = rest;
          this.pathname = simplePath[1];
          if (simplePath[2]) {
            this.search = simplePath[2];
            if (parseQueryString4) {
              this.query = querystring.parse(this.search.substr(1));
            } else {
              this.query = this.search.substr(1);
            }
          } else if (parseQueryString4) {
            this.search = "";
            this.query = {};
          }
          return this;
        }
      }
      var proto2 = protocolPattern.exec(rest);
      if (proto2) {
        proto2 = proto2[0];
        var lowerProto = proto2.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto2.length);
      }
      if (slashesDenoteHost || proto2 || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto2 && hostlessProtocol[proto2])) {
          rest = rest.substr(2);
          this.slashes = true;
        }
      }
      if (!hostlessProtocol[proto2] && (slashes || proto2 && !slashedProtocol[proto2])) {
        var hostEnd = -1;
        for (var i2 = 0; i2 < hostEndingChars.length; i2++) {
          var hec = rest.indexOf(hostEndingChars[i2]);
          if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
            hostEnd = hec;
        }
        var auth, atSign;
        if (hostEnd === -1) {
          atSign = rest.lastIndexOf("@");
        } else {
          atSign = rest.lastIndexOf("@", hostEnd);
        }
        if (atSign !== -1) {
          auth = rest.slice(0, atSign);
          rest = rest.slice(atSign + 1);
          this.auth = decodeURIComponent(auth);
        }
        hostEnd = -1;
        for (var i2 = 0; i2 < nonHostChars.length; i2++) {
          var hec = rest.indexOf(nonHostChars[i2]);
          if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
            hostEnd = hec;
        }
        if (hostEnd === -1)
          hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        this.parseHost();
        this.hostname = this.hostname || "";
        var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        if (!ipv6Hostname) {
          var hostparts = this.hostname.split(/\./);
          for (var i2 = 0, l2 = hostparts.length; i2 < l2; i2++) {
            var part = hostparts[i2];
            if (!part)
              continue;
            if (!part.match(hostnamePartPattern)) {
              var newpart = "";
              for (var j2 = 0, k2 = part.length; j2 < k2; j2++) {
                if (part.charCodeAt(j2) > 127) {
                  newpart += "x";
                } else {
                  newpart += part[j2];
                }
              }
              if (!newpart.match(hostnamePartPattern)) {
                var validParts = hostparts.slice(0, i2);
                var notHost = hostparts.slice(i2 + 1);
                var bit = part.match(hostnamePartStart);
                if (bit) {
                  validParts.push(bit[1]);
                  notHost.unshift(bit[2]);
                }
                if (notHost.length) {
                  rest = "/" + notHost.join(".") + rest;
                }
                this.hostname = validParts.join(".");
                break;
              }
            }
          }
        }
        if (this.hostname.length > hostnameMaxLen) {
          this.hostname = "";
        } else {
          this.hostname = this.hostname.toLowerCase();
        }
        if (!ipv6Hostname) {
          this.hostname = punycode.toASCII(this.hostname);
        }
        var p2 = this.port ? ":" + this.port : "";
        var h2 = this.hostname || "";
        this.host = h2 + p2;
        this.href += this.host;
        if (ipv6Hostname) {
          this.hostname = this.hostname.substr(1, this.hostname.length - 2);
          if (rest[0] !== "/") {
            rest = "/" + rest;
          }
        }
      }
      if (!unsafeProtocol[lowerProto]) {
        for (var i2 = 0, l2 = autoEscape.length; i2 < l2; i2++) {
          var ae = autoEscape[i2];
          if (rest.indexOf(ae) === -1)
            continue;
          var esc = encodeURIComponent(ae);
          if (esc === ae) {
            esc = escape(ae);
          }
          rest = rest.split(ae).join(esc);
        }
      }
      var hash = rest.indexOf("#");
      if (hash !== -1) {
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
      }
      var qm = rest.indexOf("?");
      if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString4) {
          this.query = querystring.parse(this.query);
        }
        rest = rest.slice(0, qm);
      } else if (parseQueryString4) {
        this.search = "";
        this.query = {};
      }
      if (rest)
        this.pathname = rest;
      if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
        this.pathname = "/";
      }
      if (this.pathname || this.search) {
        var p2 = this.pathname || "";
        var s2 = this.search || "";
        this.path = p2 + s2;
      }
      this.href = this.format();
      return this;
    };
    function urlFormat(obj) {
      if (util.isString(obj))
        obj = urlParse(obj);
      if (!(obj instanceof Url))
        return Url.prototype.format.call(obj);
      return obj.format();
    }
    Url.prototype.format = function() {
      var auth = this.auth || "";
      if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
      }
      var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
      if (this.host) {
        host = auth + this.host;
      } else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) {
          host += ":" + this.port;
        }
      }
      if (this.query && util.isObject(this.query) && Object.keys(this.query).length) {
        query = querystring.stringify(this.query);
      }
      var search = this.search || query && "?" + query || "";
      if (protocol && protocol.substr(-1) !== ":")
        protocol += ":";
      if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/")
          pathname = "/" + pathname;
      } else if (!host) {
        host = "";
      }
      if (hash && hash.charAt(0) !== "#")
        hash = "#" + hash;
      if (search && search.charAt(0) !== "?")
        search = "?" + search;
      pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
      });
      search = search.replace("#", "%23");
      return protocol + host + pathname + search + hash;
    };
    function urlResolve(source, relative) {
      return urlParse(source, false, true).resolve(relative);
    }
    Url.prototype.resolve = function(relative) {
      return this.resolveObject(urlParse(relative, false, true)).format();
    };
    function urlResolveObject(source, relative) {
      if (!source)
        return relative;
      return urlParse(source, false, true).resolveObject(relative);
    }
    Url.prototype.resolveObject = function(relative) {
      if (util.isString(relative)) {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
      }
      var result = new Url();
      var tkeys = Object.keys(this);
      for (var tk = 0; tk < tkeys.length; tk++) {
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
      }
      result.hash = relative.hash;
      if (relative.href === "") {
        result.href = result.format();
        return result;
      }
      if (relative.slashes && !relative.protocol) {
        var rkeys = Object.keys(relative);
        for (var rk = 0; rk < rkeys.length; rk++) {
          var rkey = rkeys[rk];
          if (rkey !== "protocol")
            result[rkey] = relative[rkey];
        }
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
          result.path = result.pathname = "/";
        }
        result.href = result.format();
        return result;
      }
      if (relative.protocol && relative.protocol !== result.protocol) {
        if (!slashedProtocol[relative.protocol]) {
          var keys = Object.keys(relative);
          for (var v2 = 0; v2 < keys.length; v2++) {
            var k2 = keys[v2];
            result[k2] = relative[k2];
          }
          result.href = result.format();
          return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
          var relPath = (relative.pathname || "").split("/");
          while (relPath.length && !(relative.host = relPath.shift()))
            ;
          if (!relative.host)
            relative.host = "";
          if (!relative.hostname)
            relative.hostname = "";
          if (relPath[0] !== "")
            relPath.unshift("");
          if (relPath.length < 2)
            relPath.unshift("");
          result.pathname = relPath.join("/");
        } else {
          result.pathname = relative.pathname;
        }
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        if (result.pathname || result.search) {
          var p2 = result.pathname || "";
          var s2 = result.search || "";
          result.path = p2 + s2;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
      }
      var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
      if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
          if (srcPath[0] === "")
            srcPath[0] = result.host;
          else
            srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
          relative.hostname = null;
          relative.port = null;
          if (relative.host) {
            if (relPath[0] === "")
              relPath[0] = relative.host;
            else
              relPath.unshift(relative.host);
          }
          relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
      }
      if (isRelAbs) {
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
      } else if (relPath.length) {
        if (!srcPath)
          srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
      } else if (!util.isNullOrUndefined(relative.search)) {
        if (psychotic) {
          result.hostname = result.host = srcPath.shift();
          var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
          if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
          }
        }
        result.search = relative.search;
        result.query = relative.query;
        if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
          result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        }
        result.href = result.format();
        return result;
      }
      if (!srcPath.length) {
        result.pathname = null;
        if (result.search) {
          result.path = "/" + result.search;
        } else {
          result.path = null;
        }
        result.href = result.format();
        return result;
      }
      var last = srcPath.slice(-1)[0];
      var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
      var up = 0;
      for (var i2 = srcPath.length; i2 >= 0; i2--) {
        last = srcPath[i2];
        if (last === ".") {
          srcPath.splice(i2, 1);
        } else if (last === "..") {
          srcPath.splice(i2, 1);
          up++;
        } else if (up) {
          srcPath.splice(i2, 1);
          up--;
        }
      }
      if (!mustEndAbs && !removeAllDots) {
        for (; up--; up) {
          srcPath.unshift("..");
        }
      }
      if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) {
        srcPath.unshift("");
      }
      if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") {
        srcPath.push("");
      }
      var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
      if (psychotic) {
        result.hostname = result.host = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
          result.auth = authInHost.shift();
          result.host = result.hostname = authInHost.shift();
        }
      }
      mustEndAbs = mustEndAbs || result.host && srcPath.length;
      if (mustEndAbs && !isAbsolute) {
        srcPath.unshift("");
      }
      if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
      } else {
        result.pathname = srcPath.join("/");
      }
      if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
        result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
      }
      result.auth = relative.auth || result.auth;
      result.slashes = result.slashes || relative.slashes;
      result.href = result.format();
      return result;
    };
    Url.prototype.parseHost = function() {
      var host = this.host;
      var port = portPattern.exec(host);
      if (port) {
        port = port[0];
        if (port !== ":") {
          this.port = port.substr(1);
        }
        host = host.substr(0, host.length - port.length);
      }
      if (host)
        this.hostname = host;
    };
  }
});

// node_modules/@aws-crypto/sha256-js/node_modules/tslib/tslib.js
var require_tslib20 = __commonJS({
  "node_modules/@aws-crypto/sha256-js/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-crypto/sha256-js/build/constants.js
var require_constants11 = __commonJS({
  "node_modules/@aws-crypto/sha256-js/build/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
    exports.BLOCK_SIZE = 64;
    exports.DIGEST_LENGTH = 32;
    exports.KEY = new Uint32Array([
      1116352408,
      1899447441,
      3049323471,
      3921009573,
      961987163,
      1508970993,
      2453635748,
      2870763221,
      3624381080,
      310598401,
      607225278,
      1426881987,
      1925078388,
      2162078206,
      2614888103,
      3248222580,
      3835390401,
      4022224774,
      264347078,
      604807628,
      770255983,
      1249150122,
      1555081692,
      1996064986,
      2554220882,
      2821834349,
      2952996808,
      3210313671,
      3336571891,
      3584528711,
      113926993,
      338241895,
      666307205,
      773529912,
      1294757372,
      1396182291,
      1695183700,
      1986661051,
      2177026350,
      2456956037,
      2730485921,
      2820302411,
      3259730800,
      3345764771,
      3516065817,
      3600352804,
      4094571909,
      275423344,
      430227734,
      506948616,
      659060556,
      883997877,
      958139571,
      1322822218,
      1537002063,
      1747873779,
      1955562222,
      2024104815,
      2227730452,
      2361852424,
      2428436474,
      2756734187,
      3204031479,
      3329325298
    ]);
    exports.INIT = [
      1779033703,
      3144134277,
      1013904242,
      2773480762,
      1359893119,
      2600822924,
      528734635,
      1541459225
    ];
    exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
  }
});

// node_modules/@aws-crypto/sha256-js/build/RawSha256.js
var require_RawSha2567 = __commonJS({
  "node_modules/@aws-crypto/sha256-js/build/RawSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.RawSha256 = void 0;
    var constants_1 = require_constants11();
    var RawSha256 = (
      /** @class */
      function() {
        function RawSha2562() {
          this.state = Int32Array.from(constants_1.INIT);
          this.temp = new Int32Array(64);
          this.buffer = new Uint8Array(64);
          this.bufferLength = 0;
          this.bytesHashed = 0;
          this.finished = false;
        }
        RawSha2562.prototype.update = function(data) {
          if (this.finished) {
            throw new Error("Attempted to update an already finished hash.");
          }
          var position = 0;
          var byteLength2 = data.byteLength;
          this.bytesHashed += byteLength2;
          if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) {
            throw new Error("Cannot hash more than 2^53 - 1 bits");
          }
          while (byteLength2 > 0) {
            this.buffer[this.bufferLength++] = data[position++];
            byteLength2--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
              this.hashBuffer();
              this.bufferLength = 0;
            }
          }
        };
        RawSha2562.prototype.digest = function() {
          if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 128);
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
              for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE; i2++) {
                bufferView.setUint8(i2, 0);
              }
              this.hashBuffer();
              this.bufferLength = 0;
            }
            for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE - 8; i2++) {
              bufferView.setUint8(i2, 0);
            }
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 4294967296), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
          }
          var out = new Uint8Array(constants_1.DIGEST_LENGTH);
          for (var i2 = 0; i2 < 8; i2++) {
            out[i2 * 4] = this.state[i2] >>> 24 & 255;
            out[i2 * 4 + 1] = this.state[i2] >>> 16 & 255;
            out[i2 * 4 + 2] = this.state[i2] >>> 8 & 255;
            out[i2 * 4 + 3] = this.state[i2] >>> 0 & 255;
          }
          return out;
        };
        RawSha2562.prototype.hashBuffer = function() {
          var _a2 = this, buffer = _a2.buffer, state = _a2.state;
          var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
          for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
            if (i2 < 16) {
              this.temp[i2] = (buffer[i2 * 4] & 255) << 24 | (buffer[i2 * 4 + 1] & 255) << 16 | (buffer[i2 * 4 + 2] & 255) << 8 | buffer[i2 * 4 + 3] & 255;
            } else {
              var u2 = this.temp[i2 - 2];
              var t1_1 = (u2 >>> 17 | u2 << 15) ^ (u2 >>> 19 | u2 << 13) ^ u2 >>> 10;
              u2 = this.temp[i2 - 15];
              var t2_1 = (u2 >>> 7 | u2 << 25) ^ (u2 >>> 18 | u2 << 14) ^ u2 >>> 3;
              this.temp[i2] = (t1_1 + this.temp[i2 - 7] | 0) + (t2_1 + this.temp[i2 - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i2] + this.temp[i2] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
          }
          state[0] += state0;
          state[1] += state1;
          state[2] += state2;
          state[3] += state3;
          state[4] += state4;
          state[5] += state5;
          state[6] += state6;
          state[7] += state7;
        };
        return RawSha2562;
      }()
    );
    exports.RawSha256 = RawSha256;
  }
});

// node_modules/@aws-crypto/util/build/convertToBuffer.js
var require_convertToBuffer8 = __commonJS({
  "node_modules/@aws-crypto/util/build/convertToBuffer.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.convertToBuffer = void 0;
    var util_utf8_browser_1 = (init_dist_es(), __toCommonJS(dist_es_exports));
    var fromUtf831 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
      return Buffer.from(input, "utf8");
    } : util_utf8_browser_1.fromUtf8;
    function convertToBuffer2(data) {
      if (data instanceof Uint8Array)
        return data;
      if (typeof data === "string") {
        return fromUtf831(data);
      }
      if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
      }
      return new Uint8Array(data);
    }
    exports.convertToBuffer = convertToBuffer2;
  }
});

// node_modules/@aws-crypto/util/build/isEmptyData.js
var require_isEmptyData12 = __commonJS({
  "node_modules/@aws-crypto/util/build/isEmptyData.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isEmptyData = void 0;
    function isEmptyData2(data) {
      if (typeof data === "string") {
        return data.length === 0;
      }
      return data.byteLength === 0;
    }
    exports.isEmptyData = isEmptyData2;
  }
});

// node_modules/@aws-crypto/util/build/numToUint8.js
var require_numToUint88 = __commonJS({
  "node_modules/@aws-crypto/util/build/numToUint8.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.numToUint8 = void 0;
    function numToUint8(num) {
      return new Uint8Array([
        (num & 4278190080) >> 24,
        (num & 16711680) >> 16,
        (num & 65280) >> 8,
        num & 255
      ]);
    }
    exports.numToUint8 = numToUint8;
  }
});

// node_modules/@aws-crypto/util/build/uint32ArrayFrom.js
var require_uint32ArrayFrom8 = __commonJS({
  "node_modules/@aws-crypto/util/build/uint32ArrayFrom.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = void 0;
    function uint32ArrayFrom(a_lookUpTable) {
      if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while (a_index < a_lookUpTable.length) {
          return_array[a_index] = a_lookUpTable[a_index];
          a_index += 1;
        }
        return return_array;
      }
      return Uint32Array.from(a_lookUpTable);
    }
    exports.uint32ArrayFrom = uint32ArrayFrom;
  }
});

// node_modules/@aws-crypto/util/build/index.js
var require_build27 = __commonJS({
  "node_modules/@aws-crypto/util/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
    var convertToBuffer_1 = require_convertToBuffer8();
    Object.defineProperty(exports, "convertToBuffer", { enumerable: true, get: function() {
      return convertToBuffer_1.convertToBuffer;
    } });
    var isEmptyData_1 = require_isEmptyData12();
    Object.defineProperty(exports, "isEmptyData", { enumerable: true, get: function() {
      return isEmptyData_1.isEmptyData;
    } });
    var numToUint8_1 = require_numToUint88();
    Object.defineProperty(exports, "numToUint8", { enumerable: true, get: function() {
      return numToUint8_1.numToUint8;
    } });
    var uint32ArrayFrom_1 = require_uint32ArrayFrom8();
    Object.defineProperty(exports, "uint32ArrayFrom", { enumerable: true, get: function() {
      return uint32ArrayFrom_1.uint32ArrayFrom;
    } });
  }
});

// node_modules/@aws-crypto/sha256-js/build/jsSha256.js
var require_jsSha2567 = __commonJS({
  "node_modules/@aws-crypto/sha256-js/build/jsSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var tslib_1 = require_tslib20();
    var constants_1 = require_constants11();
    var RawSha256_1 = require_RawSha2567();
    var util_1 = require_build27();
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          this.secret = secret;
          this.hash = new RawSha256_1.RawSha256();
          this.reset();
        }
        Sha25613.prototype.update = function(toHash) {
          if ((0, util_1.isEmptyData)(toHash) || this.error) {
            return;
          }
          try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
          } catch (e) {
            this.error = e;
          }
        };
        Sha25613.prototype.digestSync = function() {
          if (this.error) {
            throw this.error;
          }
          if (this.outer) {
            if (!this.outer.finished) {
              this.outer.update(this.hash.digest());
            }
            return this.outer.digest();
          }
          return this.hash.digest();
        };
        Sha25613.prototype.digest = function() {
          return tslib_1.__awaiter(this, void 0, void 0, function() {
            return tslib_1.__generator(this, function(_a2) {
              return [2, this.digestSync()];
            });
          });
        };
        Sha25613.prototype.reset = function() {
          this.hash = new RawSha256_1.RawSha256();
          if (this.secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(this.secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
              inner[i2] ^= 54;
              outer[i2] ^= 92;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            for (var i2 = 0; i2 < inner.byteLength; i2++) {
              inner[i2] = 0;
            }
          }
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
    function bufferFromSecret(secret) {
      var input = (0, util_1.convertToBuffer)(secret);
      if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
      }
      var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
      buffer.set(input);
      return buffer;
    }
  }
});

// node_modules/@aws-crypto/sha256-js/build/index.js
var require_build28 = __commonJS({
  "node_modules/@aws-crypto/sha256-js/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib20();
    tslib_1.__exportStar(require_jsSha2567(), exports);
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-browser/node_modules/tslib/tslib.js
var require_tslib21 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-browser/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-browser/build/isEmptyData.js
var require_isEmptyData13 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-browser/build/isEmptyData.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isEmptyData = void 0;
    function isEmptyData2(data) {
      if (typeof data === "string") {
        return data.length === 0;
      }
      return data.byteLength === 0;
    }
    exports.isEmptyData = isEmptyData2;
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-browser/build/constants.js
var require_constants12 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-browser/build/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
    exports.SHA_256_HASH = { name: "SHA-256" };
    exports.SHA_256_HMAC_ALGO = {
      name: "HMAC",
      hash: exports.SHA_256_HASH
    };
    exports.EMPTY_DATA_SHA_256 = new Uint8Array([
      227,
      176,
      196,
      66,
      152,
      252,
      28,
      20,
      154,
      251,
      244,
      200,
      153,
      111,
      185,
      36,
      39,
      174,
      65,
      228,
      100,
      155,
      147,
      76,
      164,
      149,
      153,
      27,
      120,
      82,
      184,
      85
    ]);
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-sdk/util-utf8-browser/dist/es/pureJs.js
var fromUtf819, toUtf818;
var init_pureJs6 = __esm({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-sdk/util-utf8-browser/dist/es/pureJs.js"() {
    fromUtf819 = function(input) {
      var bytes = [];
      for (var i2 = 0, len = input.length; i2 < len; i2++) {
        var value = input.charCodeAt(i2);
        if (value < 128) {
          bytes.push(value);
        } else if (value < 2048) {
          bytes.push(value >> 6 | 192, value & 63 | 128);
        } else if (i2 + 1 < input.length && (value & 64512) === 55296 && (input.charCodeAt(i2 + 1) & 64512) === 56320) {
          var surrogatePair = 65536 + ((value & 1023) << 10) + (input.charCodeAt(++i2) & 1023);
          bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else {
          bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
        }
      }
      return Uint8Array.from(bytes);
    };
    toUtf818 = function(input) {
      var decoded = "";
      for (var i2 = 0, len = input.length; i2 < len; i2++) {
        var byte = input[i2];
        if (byte < 128) {
          decoded += String.fromCharCode(byte);
        } else if (192 <= byte && byte < 224) {
          var nextByte = input[++i2];
          decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
          var surrogatePair = [byte, input[++i2], input[++i2], input[++i2]];
          var encoded = "%" + surrogatePair.map(function(byteValue) {
            return byteValue.toString(16);
          }).join("%");
          decoded += decodeURIComponent(encoded);
        } else {
          decoded += String.fromCharCode((byte & 15) << 12 | (input[++i2] & 63) << 6 | input[++i2] & 63);
        }
      }
      return decoded;
    };
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-sdk/util-utf8-browser/dist/es/whatwgEncodingApi.js
function fromUtf820(input) {
  return new TextEncoder().encode(input);
}
function toUtf819(input) {
  return new TextDecoder("utf-8").decode(input);
}
var init_whatwgEncodingApi6 = __esm({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-sdk/util-utf8-browser/dist/es/whatwgEncodingApi.js"() {
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-sdk/util-utf8-browser/dist/es/index.js
var es_exports5 = {};
__export(es_exports5, {
  fromUtf8: () => fromUtf821,
  toUtf8: () => toUtf820
});
var fromUtf821, toUtf820;
var init_es5 = __esm({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-sdk/util-utf8-browser/dist/es/index.js"() {
    init_pureJs6();
    init_whatwgEncodingApi6();
    fromUtf821 = function(input) {
      return typeof TextEncoder === "function" ? fromUtf820(input) : fromUtf819(input);
    };
    toUtf820 = function(input) {
      return typeof TextDecoder === "function" ? toUtf819(input) : toUtf818(input);
    };
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-browser/build/ie11Sha256.js
var require_ie11Sha2565 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-browser/build/ie11Sha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var isEmptyData_1 = require_isEmptyData13();
    var constants_1 = require_constants12();
    var util_utf8_browser_1 = (init_es5(), __toCommonJS(es_exports5));
    var util_locate_window_1 = (init_dist_es2(), __toCommonJS(dist_es_exports2));
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          if (secret) {
            this.operation = getKeyPromise(secret).then(function(keyData) {
              return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {
            });
          } else {
            this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
          }
        }
        Sha25613.prototype.update = function(toHash) {
          var _this = this;
          if ((0, isEmptyData_1.isEmptyData)(toHash)) {
            return;
          }
          this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
              _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
          });
          this.operation.catch(function() {
          });
        };
        Sha25613.prototype.digest = function() {
          return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
              operation.onerror = function() {
                reject(new Error("Error encountered finalizing hash"));
              };
              operation.oncomplete = function() {
                if (operation.result) {
                  resolve(new Uint8Array(operation.result));
                }
                reject(new Error("Error encountered finalizing hash"));
              };
              operation.finish();
            });
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
    function getKeyPromise(secret) {
      return new Promise(function(resolve, reject) {
        var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, ["sign"]);
        keyOperation.oncomplete = function() {
          if (keyOperation.result) {
            resolve(keyOperation.result);
          }
          reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
          reject(new Error("ImportKey failed to import key."));
        };
      });
    }
    function toArrayBufferView(data) {
      if (typeof data === "string") {
        return (0, util_utf8_browser_1.fromUtf8)(data);
      }
      if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
      }
      return new Uint8Array(data);
    }
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/util/build/convertToBuffer.js
var require_convertToBuffer9 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/util/build/convertToBuffer.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.convertToBuffer = void 0;
    var util_utf8_browser_1 = (init_es5(), __toCommonJS(es_exports5));
    var fromUtf831 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
      return Buffer.from(input, "utf8");
    } : util_utf8_browser_1.fromUtf8;
    function convertToBuffer2(data) {
      if (data instanceof Uint8Array)
        return data;
      if (typeof data === "string") {
        return fromUtf831(data);
      }
      if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
      }
      return new Uint8Array(data);
    }
    exports.convertToBuffer = convertToBuffer2;
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/util/build/isEmptyData.js
var require_isEmptyData14 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/util/build/isEmptyData.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isEmptyData = void 0;
    function isEmptyData2(data) {
      if (typeof data === "string") {
        return data.length === 0;
      }
      return data.byteLength === 0;
    }
    exports.isEmptyData = isEmptyData2;
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/util/build/numToUint8.js
var require_numToUint89 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/util/build/numToUint8.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.numToUint8 = void 0;
    function numToUint8(num) {
      return new Uint8Array([
        (num & 4278190080) >> 24,
        (num & 16711680) >> 16,
        (num & 65280) >> 8,
        num & 255
      ]);
    }
    exports.numToUint8 = numToUint8;
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/util/build/uint32ArrayFrom.js
var require_uint32ArrayFrom9 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/util/build/uint32ArrayFrom.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = void 0;
    function uint32ArrayFrom(a_lookUpTable) {
      if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while (a_index < a_lookUpTable.length) {
          return_array[a_index] = a_lookUpTable[a_index];
        }
        return return_array;
      }
      return Uint32Array.from(a_lookUpTable);
    }
    exports.uint32ArrayFrom = uint32ArrayFrom;
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/util/build/index.js
var require_build29 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/util/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
    var convertToBuffer_1 = require_convertToBuffer9();
    Object.defineProperty(exports, "convertToBuffer", { enumerable: true, get: function() {
      return convertToBuffer_1.convertToBuffer;
    } });
    var isEmptyData_1 = require_isEmptyData14();
    Object.defineProperty(exports, "isEmptyData", { enumerable: true, get: function() {
      return isEmptyData_1.isEmptyData;
    } });
    var numToUint8_1 = require_numToUint89();
    Object.defineProperty(exports, "numToUint8", { enumerable: true, get: function() {
      return numToUint8_1.numToUint8;
    } });
    var uint32ArrayFrom_1 = require_uint32ArrayFrom9();
    Object.defineProperty(exports, "uint32ArrayFrom", { enumerable: true, get: function() {
      return uint32ArrayFrom_1.uint32ArrayFrom;
    } });
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-browser/build/webCryptoSha256.js
var require_webCryptoSha2565 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-browser/build/webCryptoSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var util_1 = require_build29();
    var constants_1 = require_constants12();
    var util_locate_window_1 = (init_dist_es2(), __toCommonJS(dist_es_exports2));
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          this.toHash = new Uint8Array(0);
          if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
              (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(secret), constants_1.SHA_256_HMAC_ALGO, false, ["sign"]).then(resolve, reject);
            });
            this.key.catch(function() {
            });
          }
        }
        Sha25613.prototype.update = function(data) {
          if ((0, util_1.isEmptyData)(data)) {
            return;
          }
          var update = (0, util_1.convertToBuffer)(data);
          var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
          typedArray.set(this.toHash, 0);
          typedArray.set(update, this.toHash.byteLength);
          this.toHash = typedArray;
        };
        Sha25613.prototype.digest = function() {
          var _this = this;
          if (this.key) {
            return this.key.then(function(key) {
              return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
              });
            });
          }
          if ((0, util_1.isEmptyData)(this.toHash)) {
            return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
          }
          return Promise.resolve().then(function() {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
          }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-js/node_modules/tslib/tslib.js
var require_tslib22 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-js/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-js/build/constants.js
var require_constants13 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-js/build/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
    exports.BLOCK_SIZE = 64;
    exports.DIGEST_LENGTH = 32;
    exports.KEY = new Uint32Array([
      1116352408,
      1899447441,
      3049323471,
      3921009573,
      961987163,
      1508970993,
      2453635748,
      2870763221,
      3624381080,
      310598401,
      607225278,
      1426881987,
      1925078388,
      2162078206,
      2614888103,
      3248222580,
      3835390401,
      4022224774,
      264347078,
      604807628,
      770255983,
      1249150122,
      1555081692,
      1996064986,
      2554220882,
      2821834349,
      2952996808,
      3210313671,
      3336571891,
      3584528711,
      113926993,
      338241895,
      666307205,
      773529912,
      1294757372,
      1396182291,
      1695183700,
      1986661051,
      2177026350,
      2456956037,
      2730485921,
      2820302411,
      3259730800,
      3345764771,
      3516065817,
      3600352804,
      4094571909,
      275423344,
      430227734,
      506948616,
      659060556,
      883997877,
      958139571,
      1322822218,
      1537002063,
      1747873779,
      1955562222,
      2024104815,
      2227730452,
      2361852424,
      2428436474,
      2756734187,
      3204031479,
      3329325298
    ]);
    exports.INIT = [
      1779033703,
      3144134277,
      1013904242,
      2773480762,
      1359893119,
      2600822924,
      528734635,
      1541459225
    ];
    exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-js/build/RawSha256.js
var require_RawSha2568 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-js/build/RawSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.RawSha256 = void 0;
    var constants_1 = require_constants13();
    var RawSha256 = (
      /** @class */
      function() {
        function RawSha2562() {
          this.state = Int32Array.from(constants_1.INIT);
          this.temp = new Int32Array(64);
          this.buffer = new Uint8Array(64);
          this.bufferLength = 0;
          this.bytesHashed = 0;
          this.finished = false;
        }
        RawSha2562.prototype.update = function(data) {
          if (this.finished) {
            throw new Error("Attempted to update an already finished hash.");
          }
          var position = 0;
          var byteLength2 = data.byteLength;
          this.bytesHashed += byteLength2;
          if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) {
            throw new Error("Cannot hash more than 2^53 - 1 bits");
          }
          while (byteLength2 > 0) {
            this.buffer[this.bufferLength++] = data[position++];
            byteLength2--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
              this.hashBuffer();
              this.bufferLength = 0;
            }
          }
        };
        RawSha2562.prototype.digest = function() {
          if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 128);
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
              for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE; i2++) {
                bufferView.setUint8(i2, 0);
              }
              this.hashBuffer();
              this.bufferLength = 0;
            }
            for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE - 8; i2++) {
              bufferView.setUint8(i2, 0);
            }
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 4294967296), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
          }
          var out = new Uint8Array(constants_1.DIGEST_LENGTH);
          for (var i2 = 0; i2 < 8; i2++) {
            out[i2 * 4] = this.state[i2] >>> 24 & 255;
            out[i2 * 4 + 1] = this.state[i2] >>> 16 & 255;
            out[i2 * 4 + 2] = this.state[i2] >>> 8 & 255;
            out[i2 * 4 + 3] = this.state[i2] >>> 0 & 255;
          }
          return out;
        };
        RawSha2562.prototype.hashBuffer = function() {
          var _a2 = this, buffer = _a2.buffer, state = _a2.state;
          var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
          for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
            if (i2 < 16) {
              this.temp[i2] = (buffer[i2 * 4] & 255) << 24 | (buffer[i2 * 4 + 1] & 255) << 16 | (buffer[i2 * 4 + 2] & 255) << 8 | buffer[i2 * 4 + 3] & 255;
            } else {
              var u2 = this.temp[i2 - 2];
              var t1_1 = (u2 >>> 17 | u2 << 15) ^ (u2 >>> 19 | u2 << 13) ^ u2 >>> 10;
              u2 = this.temp[i2 - 15];
              var t2_1 = (u2 >>> 7 | u2 << 25) ^ (u2 >>> 18 | u2 << 14) ^ u2 >>> 3;
              this.temp[i2] = (t1_1 + this.temp[i2 - 7] | 0) + (t2_1 + this.temp[i2 - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i2] + this.temp[i2] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
          }
          state[0] += state0;
          state[1] += state1;
          state[2] += state2;
          state[3] += state3;
          state[4] += state4;
          state[5] += state5;
          state[6] += state6;
          state[7] += state7;
        };
        return RawSha2562;
      }()
    );
    exports.RawSha256 = RawSha256;
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-js/build/jsSha256.js
var require_jsSha2568 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-js/build/jsSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var tslib_1 = require_tslib22();
    var constants_1 = require_constants13();
    var RawSha256_1 = require_RawSha2568();
    var util_1 = require_build29();
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          this.hash = new RawSha256_1.RawSha256();
          if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
              inner[i2] ^= 54;
              outer[i2] ^= 92;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            for (var i2 = 0; i2 < inner.byteLength; i2++) {
              inner[i2] = 0;
            }
          }
        }
        Sha25613.prototype.update = function(toHash) {
          if ((0, util_1.isEmptyData)(toHash) || this.error) {
            return;
          }
          try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
          } catch (e) {
            this.error = e;
          }
        };
        Sha25613.prototype.digestSync = function() {
          if (this.error) {
            throw this.error;
          }
          if (this.outer) {
            if (!this.outer.finished) {
              this.outer.update(this.hash.digest());
            }
            return this.outer.digest();
          }
          return this.hash.digest();
        };
        Sha25613.prototype.digest = function() {
          return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a2) {
              return [2, this.digestSync()];
            });
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
    function bufferFromSecret(secret) {
      var input = (0, util_1.convertToBuffer)(secret);
      if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
      }
      var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
      buffer.set(input);
      return buffer;
    }
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-js/build/index.js
var require_build30 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-js/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib22();
    (0, tslib_1.__exportStar)(require_jsSha2568(), exports);
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/supports-web-crypto/node_modules/tslib/tslib.js
var require_tslib23 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/supports-web-crypto/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/supports-web-crypto/build/supportsWebCrypto.js
var require_supportsWebCrypto5 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/supports-web-crypto/build/supportsWebCrypto.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
    var tslib_1 = require_tslib23();
    var subtleCryptoMethods = [
      "decrypt",
      "digest",
      "encrypt",
      "exportKey",
      "generateKey",
      "importKey",
      "sign",
      "verify"
    ];
    function supportsWebCrypto(window2) {
      if (supportsSecureRandom(window2) && typeof window2.crypto.subtle === "object") {
        var subtle = window2.crypto.subtle;
        return supportsSubtleCrypto(subtle);
      }
      return false;
    }
    exports.supportsWebCrypto = supportsWebCrypto;
    function supportsSecureRandom(window2) {
      if (typeof window2 === "object" && typeof window2.crypto === "object") {
        var getRandomValues2 = window2.crypto.getRandomValues;
        return typeof getRandomValues2 === "function";
      }
      return false;
    }
    exports.supportsSecureRandom = supportsSecureRandom;
    function supportsSubtleCrypto(subtle) {
      return subtle && subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
      });
    }
    exports.supportsSubtleCrypto = supportsSubtleCrypto;
    function supportsZeroByteGCM(subtle) {
      return tslib_1.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a2;
        return tslib_1.__generator(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              if (!supportsSubtleCrypto(subtle))
                return [2, false];
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 4, , 5]);
              return [4, subtle.generateKey({ name: "AES-GCM", length: 128 }, false, ["encrypt"])];
            case 2:
              key = _b2.sent();
              return [4, subtle.encrypt({
                name: "AES-GCM",
                iv: new Uint8Array(Array(12)),
                additionalData: new Uint8Array(Array(16)),
                tagLength: 128
              }, key, new Uint8Array(0))];
            case 3:
              zeroByteAuthTag = _b2.sent();
              return [2, zeroByteAuthTag.byteLength === 16];
            case 4:
              _a2 = _b2.sent();
              return [2, false];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }
    exports.supportsZeroByteGCM = supportsZeroByteGCM;
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/supports-web-crypto/build/index.js
var require_build31 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/supports-web-crypto/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib23();
    tslib_1.__exportStar(require_supportsWebCrypto5(), exports);
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/ie11-detection/node_modules/tslib/tslib.js
var require_tslib24 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/ie11-detection/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/ie11-detection/build/CryptoOperation.js
var require_CryptoOperation5 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/ie11-detection/build/CryptoOperation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/ie11-detection/build/Key.js
var require_Key5 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/ie11-detection/build/Key.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/ie11-detection/build/KeyOperation.js
var require_KeyOperation5 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/ie11-detection/build/KeyOperation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/ie11-detection/build/MsSubtleCrypto.js
var require_MsSubtleCrypto5 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/ie11-detection/build/MsSubtleCrypto.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/ie11-detection/build/MsWindow.js
var require_MsWindow5 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/ie11-detection/build/MsWindow.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isMsWindow = void 0;
    var msSubtleCryptoMethods = [
      "decrypt",
      "digest",
      "encrypt",
      "exportKey",
      "generateKey",
      "importKey",
      "sign",
      "verify"
    ];
    function quacksLikeAnMsWindow(window2) {
      return "MSInputMethodContext" in window2 && "msCrypto" in window2;
    }
    function isMsWindow(window2) {
      if (quacksLikeAnMsWindow(window2) && window2.msCrypto.subtle !== void 0) {
        var _a2 = window2.msCrypto, getRandomValues2 = _a2.getRandomValues, subtle_1 = _a2.subtle;
        return msSubtleCryptoMethods.map(function(methodName) {
          return subtle_1[methodName];
        }).concat(getRandomValues2).every(function(method) {
          return typeof method === "function";
        });
      }
      return false;
    }
    exports.isMsWindow = isMsWindow;
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/ie11-detection/build/index.js
var require_build32 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/ie11-detection/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib24();
    tslib_1.__exportStar(require_CryptoOperation5(), exports);
    tslib_1.__exportStar(require_Key5(), exports);
    tslib_1.__exportStar(require_KeyOperation5(), exports);
    tslib_1.__exportStar(require_MsSubtleCrypto5(), exports);
    tslib_1.__exportStar(require_MsWindow5(), exports);
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-browser/build/crossPlatformSha256.js
var require_crossPlatformSha2565 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-browser/build/crossPlatformSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var ie11Sha256_1 = require_ie11Sha2565();
    var webCryptoSha256_1 = require_webCryptoSha2565();
    var sha256_js_1 = require_build30();
    var supports_web_crypto_1 = require_build31();
    var ie11_detection_1 = require_build32();
    var util_locate_window_1 = (init_dist_es2(), __toCommonJS(dist_es_exports2));
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) {
            this.hash = new webCryptoSha256_1.Sha256(secret);
          } else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) {
            this.hash = new ie11Sha256_1.Sha256(secret);
          } else {
            this.hash = new sha256_js_1.Sha256(secret);
          }
        }
        Sha25613.prototype.update = function(data, encoding) {
          this.hash.update(data, encoding);
        };
        Sha25613.prototype.digest = function() {
          return this.hash.digest();
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-browser/build/index.js
var require_build33 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/@aws-crypto/sha256-browser/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
    var tslib_1 = require_tslib21();
    (0, tslib_1.__exportStar)(require_crossPlatformSha2565(), exports);
    var ie11Sha256_1 = require_ie11Sha2565();
    Object.defineProperty(exports, "Ie11Sha256", { enumerable: true, get: function() {
      return ie11Sha256_1.Sha256;
    } });
    var webCryptoSha256_1 = require_webCryptoSha2565();
    Object.defineProperty(exports, "WebCryptoSha256", { enumerable: true, get: function() {
      return webCryptoSha256_1.Sha256;
    } });
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/util.js
var require_util2 = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/util.js"(exports) {
    "use strict";
    var nameStartChar = ":A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    var nameChar = nameStartChar + "\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var nameRegexp = "[" + nameStartChar + "][" + nameChar + "]*";
    var regexName = new RegExp("^" + nameRegexp + "$");
    var getAllMatches = function(string, regex) {
      const matches2 = [];
      let match = regex.exec(string);
      while (match) {
        const allmatches = [];
        allmatches.startIndex = regex.lastIndex - match[0].length;
        const len = match.length;
        for (let index = 0; index < len; index++) {
          allmatches.push(match[index]);
        }
        matches2.push(allmatches);
        match = regex.exec(string);
      }
      return matches2;
    };
    var isName = function(string) {
      const match = regexName.exec(string);
      return !(match === null || typeof match === "undefined");
    };
    exports.isExist = function(v2) {
      return typeof v2 !== "undefined";
    };
    exports.isEmptyObject = function(obj) {
      return Object.keys(obj).length === 0;
    };
    exports.merge = function(target, a2, arrayMode) {
      if (a2) {
        const keys = Object.keys(a2);
        const len = keys.length;
        for (let i2 = 0; i2 < len; i2++) {
          if (arrayMode === "strict") {
            target[keys[i2]] = [a2[keys[i2]]];
          } else {
            target[keys[i2]] = a2[keys[i2]];
          }
        }
      }
    };
    exports.getValue = function(v2) {
      if (exports.isExist(v2)) {
        return v2;
      } else {
        return "";
      }
    };
    exports.isName = isName;
    exports.getAllMatches = getAllMatches;
    exports.nameRegexp = nameRegexp;
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/validator.js
var require_validator = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/validator.js"(exports) {
    "use strict";
    var util = require_util2();
    var defaultOptions = {
      allowBooleanAttributes: false,
      //A tag can have attributes without any value
      unpairedTags: []
    };
    exports.validate = function(xmlData, options) {
      options = Object.assign({}, defaultOptions, options);
      const tags = [];
      let tagFound = false;
      let reachedRoot = false;
      if (xmlData[0] === "\uFEFF") {
        xmlData = xmlData.substr(1);
      }
      for (let i2 = 0; i2 < xmlData.length; i2++) {
        if (xmlData[i2] === "<" && xmlData[i2 + 1] === "?") {
          i2 += 2;
          i2 = readPI(xmlData, i2);
          if (i2.err)
            return i2;
        } else if (xmlData[i2] === "<") {
          let tagStartPos = i2;
          i2++;
          if (xmlData[i2] === "!") {
            i2 = readCommentAndCDATA(xmlData, i2);
            continue;
          } else {
            let closingTag = false;
            if (xmlData[i2] === "/") {
              closingTag = true;
              i2++;
            }
            let tagName = "";
            for (; i2 < xmlData.length && xmlData[i2] !== ">" && xmlData[i2] !== " " && xmlData[i2] !== "	" && xmlData[i2] !== "\n" && xmlData[i2] !== "\r"; i2++) {
              tagName += xmlData[i2];
            }
            tagName = tagName.trim();
            if (tagName[tagName.length - 1] === "/") {
              tagName = tagName.substring(0, tagName.length - 1);
              i2--;
            }
            if (!validateTagName(tagName)) {
              let msg;
              if (tagName.trim().length === 0) {
                msg = "Invalid space after '<'.";
              } else {
                msg = "Tag '" + tagName + "' is an invalid name.";
              }
              return getErrorObject("InvalidTag", msg, getLineNumberForPosition(xmlData, i2));
            }
            const result = readAttributeStr(xmlData, i2);
            if (result === false) {
              return getErrorObject("InvalidAttr", "Attributes for '" + tagName + "' have open quote.", getLineNumberForPosition(xmlData, i2));
            }
            let attrStr = result.value;
            i2 = result.index;
            if (attrStr[attrStr.length - 1] === "/") {
              const attrStrStart = i2 - attrStr.length;
              attrStr = attrStr.substring(0, attrStr.length - 1);
              const isValid2 = validateAttributeString(attrStr, options);
              if (isValid2 === true) {
                tagFound = true;
              } else {
                return getErrorObject(isValid2.err.code, isValid2.err.msg, getLineNumberForPosition(xmlData, attrStrStart + isValid2.err.line));
              }
            } else if (closingTag) {
              if (!result.tagClosed) {
                return getErrorObject("InvalidTag", "Closing tag '" + tagName + "' doesn't have proper closing.", getLineNumberForPosition(xmlData, i2));
              } else if (attrStr.trim().length > 0) {
                return getErrorObject("InvalidTag", "Closing tag '" + tagName + "' can't have attributes or invalid starting.", getLineNumberForPosition(xmlData, tagStartPos));
              } else {
                const otg = tags.pop();
                if (tagName !== otg.tagName) {
                  let openPos = getLineNumberForPosition(xmlData, otg.tagStartPos);
                  return getErrorObject(
                    "InvalidTag",
                    "Expected closing tag '" + otg.tagName + "' (opened in line " + openPos.line + ", col " + openPos.col + ") instead of closing tag '" + tagName + "'.",
                    getLineNumberForPosition(xmlData, tagStartPos)
                  );
                }
                if (tags.length == 0) {
                  reachedRoot = true;
                }
              }
            } else {
              const isValid2 = validateAttributeString(attrStr, options);
              if (isValid2 !== true) {
                return getErrorObject(isValid2.err.code, isValid2.err.msg, getLineNumberForPosition(xmlData, i2 - attrStr.length + isValid2.err.line));
              }
              if (reachedRoot === true) {
                return getErrorObject("InvalidXml", "Multiple possible root nodes found.", getLineNumberForPosition(xmlData, i2));
              } else if (options.unpairedTags.indexOf(tagName) !== -1) {
              } else {
                tags.push({ tagName, tagStartPos });
              }
              tagFound = true;
            }
            for (i2++; i2 < xmlData.length; i2++) {
              if (xmlData[i2] === "<") {
                if (xmlData[i2 + 1] === "!") {
                  i2++;
                  i2 = readCommentAndCDATA(xmlData, i2);
                  continue;
                } else if (xmlData[i2 + 1] === "?") {
                  i2 = readPI(xmlData, ++i2);
                  if (i2.err)
                    return i2;
                } else {
                  break;
                }
              } else if (xmlData[i2] === "&") {
                const afterAmp = validateAmpersand(xmlData, i2);
                if (afterAmp == -1)
                  return getErrorObject("InvalidChar", "char '&' is not expected.", getLineNumberForPosition(xmlData, i2));
                i2 = afterAmp;
              } else {
                if (reachedRoot === true && !isWhiteSpace(xmlData[i2])) {
                  return getErrorObject("InvalidXml", "Extra text at the end", getLineNumberForPosition(xmlData, i2));
                }
              }
            }
            if (xmlData[i2] === "<") {
              i2--;
            }
          }
        } else {
          if (isWhiteSpace(xmlData[i2])) {
            continue;
          }
          return getErrorObject("InvalidChar", "char '" + xmlData[i2] + "' is not expected.", getLineNumberForPosition(xmlData, i2));
        }
      }
      if (!tagFound) {
        return getErrorObject("InvalidXml", "Start tag expected.", 1);
      } else if (tags.length == 1) {
        return getErrorObject("InvalidTag", "Unclosed tag '" + tags[0].tagName + "'.", getLineNumberForPosition(xmlData, tags[0].tagStartPos));
      } else if (tags.length > 0) {
        return getErrorObject("InvalidXml", "Invalid '" + JSON.stringify(tags.map((t2) => t2.tagName), null, 4).replace(/\r?\n/g, "") + "' found.", { line: 1, col: 1 });
      }
      return true;
    };
    function isWhiteSpace(char) {
      return char === " " || char === "	" || char === "\n" || char === "\r";
    }
    function readPI(xmlData, i2) {
      const start = i2;
      for (; i2 < xmlData.length; i2++) {
        if (xmlData[i2] == "?" || xmlData[i2] == " ") {
          const tagname = xmlData.substr(start, i2 - start);
          if (i2 > 5 && tagname === "xml") {
            return getErrorObject("InvalidXml", "XML declaration allowed only at the start of the document.", getLineNumberForPosition(xmlData, i2));
          } else if (xmlData[i2] == "?" && xmlData[i2 + 1] == ">") {
            i2++;
            break;
          } else {
            continue;
          }
        }
      }
      return i2;
    }
    function readCommentAndCDATA(xmlData, i2) {
      if (xmlData.length > i2 + 5 && xmlData[i2 + 1] === "-" && xmlData[i2 + 2] === "-") {
        for (i2 += 3; i2 < xmlData.length; i2++) {
          if (xmlData[i2] === "-" && xmlData[i2 + 1] === "-" && xmlData[i2 + 2] === ">") {
            i2 += 2;
            break;
          }
        }
      } else if (xmlData.length > i2 + 8 && xmlData[i2 + 1] === "D" && xmlData[i2 + 2] === "O" && xmlData[i2 + 3] === "C" && xmlData[i2 + 4] === "T" && xmlData[i2 + 5] === "Y" && xmlData[i2 + 6] === "P" && xmlData[i2 + 7] === "E") {
        let angleBracketsCount = 1;
        for (i2 += 8; i2 < xmlData.length; i2++) {
          if (xmlData[i2] === "<") {
            angleBracketsCount++;
          } else if (xmlData[i2] === ">") {
            angleBracketsCount--;
            if (angleBracketsCount === 0) {
              break;
            }
          }
        }
      } else if (xmlData.length > i2 + 9 && xmlData[i2 + 1] === "[" && xmlData[i2 + 2] === "C" && xmlData[i2 + 3] === "D" && xmlData[i2 + 4] === "A" && xmlData[i2 + 5] === "T" && xmlData[i2 + 6] === "A" && xmlData[i2 + 7] === "[") {
        for (i2 += 8; i2 < xmlData.length; i2++) {
          if (xmlData[i2] === "]" && xmlData[i2 + 1] === "]" && xmlData[i2 + 2] === ">") {
            i2 += 2;
            break;
          }
        }
      }
      return i2;
    }
    var doubleQuote = '"';
    var singleQuote = "'";
    function readAttributeStr(xmlData, i2) {
      let attrStr = "";
      let startChar = "";
      let tagClosed = false;
      for (; i2 < xmlData.length; i2++) {
        if (xmlData[i2] === doubleQuote || xmlData[i2] === singleQuote) {
          if (startChar === "") {
            startChar = xmlData[i2];
          } else if (startChar !== xmlData[i2]) {
          } else {
            startChar = "";
          }
        } else if (xmlData[i2] === ">") {
          if (startChar === "") {
            tagClosed = true;
            break;
          }
        }
        attrStr += xmlData[i2];
      }
      if (startChar !== "") {
        return false;
      }
      return {
        value: attrStr,
        index: i2,
        tagClosed
      };
    }
    var validAttrStrRegxp = new RegExp(`(\\s*)([^\\s=]+)(\\s*=)?(\\s*(['"])(([\\s\\S])*?)\\5)?`, "g");
    function validateAttributeString(attrStr, options) {
      const matches2 = util.getAllMatches(attrStr, validAttrStrRegxp);
      const attrNames = {};
      for (let i2 = 0; i2 < matches2.length; i2++) {
        if (matches2[i2][1].length === 0) {
          return getErrorObject("InvalidAttr", "Attribute '" + matches2[i2][2] + "' has no space in starting.", getPositionFromMatch(matches2[i2]));
        } else if (matches2[i2][3] !== void 0 && matches2[i2][4] === void 0) {
          return getErrorObject("InvalidAttr", "Attribute '" + matches2[i2][2] + "' is without value.", getPositionFromMatch(matches2[i2]));
        } else if (matches2[i2][3] === void 0 && !options.allowBooleanAttributes) {
          return getErrorObject("InvalidAttr", "boolean attribute '" + matches2[i2][2] + "' is not allowed.", getPositionFromMatch(matches2[i2]));
        }
        const attrName = matches2[i2][2];
        if (!validateAttrName(attrName)) {
          return getErrorObject("InvalidAttr", "Attribute '" + attrName + "' is an invalid name.", getPositionFromMatch(matches2[i2]));
        }
        if (!attrNames.hasOwnProperty(attrName)) {
          attrNames[attrName] = 1;
        } else {
          return getErrorObject("InvalidAttr", "Attribute '" + attrName + "' is repeated.", getPositionFromMatch(matches2[i2]));
        }
      }
      return true;
    }
    function validateNumberAmpersand(xmlData, i2) {
      let re = /\d/;
      if (xmlData[i2] === "x") {
        i2++;
        re = /[\da-fA-F]/;
      }
      for (; i2 < xmlData.length; i2++) {
        if (xmlData[i2] === ";")
          return i2;
        if (!xmlData[i2].match(re))
          break;
      }
      return -1;
    }
    function validateAmpersand(xmlData, i2) {
      i2++;
      if (xmlData[i2] === ";")
        return -1;
      if (xmlData[i2] === "#") {
        i2++;
        return validateNumberAmpersand(xmlData, i2);
      }
      let count = 0;
      for (; i2 < xmlData.length; i2++, count++) {
        if (xmlData[i2].match(/\w/) && count < 20)
          continue;
        if (xmlData[i2] === ";")
          break;
        return -1;
      }
      return i2;
    }
    function getErrorObject(code, message, lineNumber) {
      return {
        err: {
          code,
          msg: message,
          line: lineNumber.line || lineNumber,
          col: lineNumber.col
        }
      };
    }
    function validateAttrName(attrName) {
      return util.isName(attrName);
    }
    function validateTagName(tagname) {
      return util.isName(tagname);
    }
    function getLineNumberForPosition(xmlData, index) {
      const lines = xmlData.substring(0, index).split(/\r?\n/);
      return {
        line: lines.length,
        // column number is last line's length + 1, because column numbering starts at 1:
        col: lines[lines.length - 1].length + 1
      };
    }
    function getPositionFromMatch(match) {
      return match.startIndex + match[1].length;
    }
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/xmlparser/OptionsBuilder.js
var require_OptionsBuilder = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/xmlparser/OptionsBuilder.js"(exports) {
    var defaultOptions = {
      preserveOrder: false,
      attributeNamePrefix: "@_",
      attributesGroupName: false,
      textNodeName: "#text",
      ignoreAttributes: true,
      removeNSPrefix: false,
      // remove NS from tag name or attribute name if true
      allowBooleanAttributes: false,
      //a tag can have attributes without any value
      //ignoreRootElement : false,
      parseTagValue: true,
      parseAttributeValue: false,
      trimValues: true,
      //Trim string values of tag and attributes
      cdataPropName: false,
      numberParseOptions: {
        hex: true,
        leadingZeros: true,
        eNotation: true
      },
      tagValueProcessor: function(tagName, val2) {
        return val2;
      },
      attributeValueProcessor: function(attrName, val2) {
        return val2;
      },
      stopNodes: [],
      //nested tags will not be parsed even for errors
      alwaysCreateTextNode: false,
      isArray: () => false,
      commentPropName: false,
      unpairedTags: [],
      processEntities: true,
      htmlEntities: false,
      ignoreDeclaration: false,
      ignorePiTags: false,
      transformTagName: false,
      transformAttributeName: false,
      updateTag: function(tagName, jPath, attrs) {
        return tagName;
      }
      // skipEmptyListItem: false
    };
    var buildOptions = function(options) {
      return Object.assign({}, defaultOptions, options);
    };
    exports.buildOptions = buildOptions;
    exports.defaultOptions = defaultOptions;
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/xmlparser/xmlNode.js
var require_xmlNode = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/xmlparser/xmlNode.js"(exports, module) {
    "use strict";
    var XmlNode2 = class {
      constructor(tagname) {
        this.tagname = tagname;
        this.child = [];
        this[":@"] = {};
      }
      add(key, val2) {
        if (key === "__proto__")
          key = "#__proto__";
        this.child.push({ [key]: val2 });
      }
      addChild(node) {
        if (node.tagname === "__proto__")
          node.tagname = "#__proto__";
        if (node[":@"] && Object.keys(node[":@"]).length > 0) {
          this.child.push({ [node.tagname]: node.child, [":@"]: node[":@"] });
        } else {
          this.child.push({ [node.tagname]: node.child });
        }
      }
    };
    module.exports = XmlNode2;
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/xmlparser/DocTypeReader.js
var require_DocTypeReader = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/xmlparser/DocTypeReader.js"(exports, module) {
    function readDocType(xmlData, i2) {
      const entities = {};
      if (xmlData[i2 + 3] === "O" && xmlData[i2 + 4] === "C" && xmlData[i2 + 5] === "T" && xmlData[i2 + 6] === "Y" && xmlData[i2 + 7] === "P" && xmlData[i2 + 8] === "E") {
        i2 = i2 + 9;
        let angleBracketsCount = 1;
        let hasBody = false, comment = false;
        let exp = "";
        for (; i2 < xmlData.length; i2++) {
          if (xmlData[i2] === "<" && !comment) {
            if (hasBody && isEntity(xmlData, i2)) {
              i2 += 7;
              [entityName, val, i2] = readEntityExp(xmlData, i2 + 1);
              if (val.indexOf("&") === -1)
                entities[validateEntityName(entityName)] = {
                  regx: RegExp(`&${entityName};`, "g"),
                  val
                };
            } else if (hasBody && isElement(xmlData, i2))
              i2 += 8;
            else if (hasBody && isAttlist(xmlData, i2))
              i2 += 8;
            else if (hasBody && isNotation(xmlData, i2))
              i2 += 9;
            else if (isComment)
              comment = true;
            else
              throw new Error("Invalid DOCTYPE");
            angleBracketsCount++;
            exp = "";
          } else if (xmlData[i2] === ">") {
            if (comment) {
              if (xmlData[i2 - 1] === "-" && xmlData[i2 - 2] === "-") {
                comment = false;
                angleBracketsCount--;
              }
            } else {
              angleBracketsCount--;
            }
            if (angleBracketsCount === 0) {
              break;
            }
          } else if (xmlData[i2] === "[") {
            hasBody = true;
          } else {
            exp += xmlData[i2];
          }
        }
        if (angleBracketsCount !== 0) {
          throw new Error(`Unclosed DOCTYPE`);
        }
      } else {
        throw new Error(`Invalid Tag instead of DOCTYPE`);
      }
      return { entities, i: i2 };
    }
    function readEntityExp(xmlData, i2) {
      let entityName2 = "";
      for (; i2 < xmlData.length && (xmlData[i2] !== "'" && xmlData[i2] !== '"'); i2++) {
        entityName2 += xmlData[i2];
      }
      entityName2 = entityName2.trim();
      if (entityName2.indexOf(" ") !== -1)
        throw new Error("External entites are not supported");
      const startChar = xmlData[i2++];
      let val2 = "";
      for (; i2 < xmlData.length && xmlData[i2] !== startChar; i2++) {
        val2 += xmlData[i2];
      }
      return [entityName2, val2, i2];
    }
    function isComment(xmlData, i2) {
      if (xmlData[i2 + 1] === "!" && xmlData[i2 + 2] === "-" && xmlData[i2 + 3] === "-")
        return true;
      return false;
    }
    function isEntity(xmlData, i2) {
      if (xmlData[i2 + 1] === "!" && xmlData[i2 + 2] === "E" && xmlData[i2 + 3] === "N" && xmlData[i2 + 4] === "T" && xmlData[i2 + 5] === "I" && xmlData[i2 + 6] === "T" && xmlData[i2 + 7] === "Y")
        return true;
      return false;
    }
    function isElement(xmlData, i2) {
      if (xmlData[i2 + 1] === "!" && xmlData[i2 + 2] === "E" && xmlData[i2 + 3] === "L" && xmlData[i2 + 4] === "E" && xmlData[i2 + 5] === "M" && xmlData[i2 + 6] === "E" && xmlData[i2 + 7] === "N" && xmlData[i2 + 8] === "T")
        return true;
      return false;
    }
    function isAttlist(xmlData, i2) {
      if (xmlData[i2 + 1] === "!" && xmlData[i2 + 2] === "A" && xmlData[i2 + 3] === "T" && xmlData[i2 + 4] === "T" && xmlData[i2 + 5] === "L" && xmlData[i2 + 6] === "I" && xmlData[i2 + 7] === "S" && xmlData[i2 + 8] === "T")
        return true;
      return false;
    }
    function isNotation(xmlData, i2) {
      if (xmlData[i2 + 1] === "!" && xmlData[i2 + 2] === "N" && xmlData[i2 + 3] === "O" && xmlData[i2 + 4] === "T" && xmlData[i2 + 5] === "A" && xmlData[i2 + 6] === "T" && xmlData[i2 + 7] === "I" && xmlData[i2 + 8] === "O" && xmlData[i2 + 9] === "N")
        return true;
      return false;
    }
    var specialChar = "!?\\/[]$%{}^&*()<>|+";
    function validateEntityName(name) {
      for (let i2 = 0; i2 < specialChar.length; i2++) {
        const ch = specialChar[i2];
        if (name.indexOf(ch) !== -1)
          throw new Error(`Invalid character ${ch} in entity name`);
      }
      return name;
    }
    module.exports = readDocType;
  }
});

// node_modules/strnum/strnum.js
var require_strnum = __commonJS({
  "node_modules/strnum/strnum.js"(exports, module) {
    var hexRegex = /^[-+]?0x[a-fA-F0-9]+$/;
    var numRegex = /^([\-\+])?(0*)(\.[0-9]+([eE]\-?[0-9]+)?|[0-9]+(\.[0-9]+([eE]\-?[0-9]+)?)?)$/;
    if (!Number.parseInt && window.parseInt) {
      Number.parseInt = window.parseInt;
    }
    if (!Number.parseFloat && window.parseFloat) {
      Number.parseFloat = window.parseFloat;
    }
    var consider = {
      hex: true,
      leadingZeros: true,
      decimalPoint: ".",
      eNotation: true
      //skipLike: /regex/
    };
    function toNumber(str, options = {}) {
      options = Object.assign({}, consider, options);
      if (!str || typeof str !== "string")
        return str;
      let trimmedStr = str.trim();
      if (options.skipLike !== void 0 && options.skipLike.test(trimmedStr))
        return str;
      else if (options.hex && hexRegex.test(trimmedStr)) {
        return Number.parseInt(trimmedStr, 16);
      } else {
        const match = numRegex.exec(trimmedStr);
        if (match) {
          const sign = match[1];
          const leadingZeros = match[2];
          let numTrimmedByZeros = trimZeros(match[3]);
          const eNotation = match[4] || match[6];
          if (!options.leadingZeros && leadingZeros.length > 0 && sign && trimmedStr[2] !== ".")
            return str;
          else if (!options.leadingZeros && leadingZeros.length > 0 && !sign && trimmedStr[1] !== ".")
            return str;
          else {
            const num = Number(trimmedStr);
            const numStr = "" + num;
            if (numStr.search(/[eE]/) !== -1) {
              if (options.eNotation)
                return num;
              else
                return str;
            } else if (eNotation) {
              if (options.eNotation)
                return num;
              else
                return str;
            } else if (trimmedStr.indexOf(".") !== -1) {
              if (numStr === "0" && numTrimmedByZeros === "")
                return num;
              else if (numStr === numTrimmedByZeros)
                return num;
              else if (sign && numStr === "-" + numTrimmedByZeros)
                return num;
              else
                return str;
            }
            if (leadingZeros) {
              if (numTrimmedByZeros === numStr)
                return num;
              else if (sign + numTrimmedByZeros === numStr)
                return num;
              else
                return str;
            }
            if (trimmedStr === numStr)
              return num;
            else if (trimmedStr === sign + numStr)
              return num;
            return str;
          }
        } else {
          return str;
        }
      }
    }
    function trimZeros(numStr) {
      if (numStr && numStr.indexOf(".") !== -1) {
        numStr = numStr.replace(/0+$/, "");
        if (numStr === ".")
          numStr = "0";
        else if (numStr[0] === ".")
          numStr = "0" + numStr;
        else if (numStr[numStr.length - 1] === ".")
          numStr = numStr.substr(0, numStr.length - 1);
        return numStr;
      }
      return numStr;
    }
    module.exports = toNumber;
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/xmlparser/OrderedObjParser.js
var require_OrderedObjParser = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/xmlparser/OrderedObjParser.js"(exports, module) {
    "use strict";
    var util = require_util2();
    var xmlNode = require_xmlNode();
    var readDocType = require_DocTypeReader();
    var toNumber = require_strnum();
    var regx = "<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)".replace(/NAME/g, util.nameRegexp);
    var OrderedObjParser = class {
      constructor(options) {
        this.options = options;
        this.currentNode = null;
        this.tagsNodeStack = [];
        this.docTypeEntities = {};
        this.lastEntities = {
          "apos": { regex: /&(apos|#39|#x27);/g, val: "'" },
          "gt": { regex: /&(gt|#62|#x3E);/g, val: ">" },
          "lt": { regex: /&(lt|#60|#x3C);/g, val: "<" },
          "quot": { regex: /&(quot|#34|#x22);/g, val: '"' }
        };
        this.ampEntity = { regex: /&(amp|#38|#x26);/g, val: "&" };
        this.htmlEntities = {
          "space": { regex: /&(nbsp|#160);/g, val: " " },
          // "lt" : { regex: /&(lt|#60);/g, val: "<" },
          // "gt" : { regex: /&(gt|#62);/g, val: ">" },
          // "amp" : { regex: /&(amp|#38);/g, val: "&" },
          // "quot" : { regex: /&(quot|#34);/g, val: "\"" },
          // "apos" : { regex: /&(apos|#39);/g, val: "'" },
          "cent": { regex: /&(cent|#162);/g, val: "¢" },
          "pound": { regex: /&(pound|#163);/g, val: "£" },
          "yen": { regex: /&(yen|#165);/g, val: "¥" },
          "euro": { regex: /&(euro|#8364);/g, val: "€" },
          "copyright": { regex: /&(copy|#169);/g, val: "©" },
          "reg": { regex: /&(reg|#174);/g, val: "®" },
          "inr": { regex: /&(inr|#8377);/g, val: "₹" }
        };
        this.addExternalEntities = addExternalEntities;
        this.parseXml = parseXml;
        this.parseTextData = parseTextData;
        this.resolveNameSpace = resolveNameSpace;
        this.buildAttributesMap = buildAttributesMap;
        this.isItStopNode = isItStopNode;
        this.replaceEntitiesValue = replaceEntitiesValue;
        this.readStopNodeData = readStopNodeData;
        this.saveTextToParentTag = saveTextToParentTag;
        this.addChild = addChild;
      }
    };
    function addExternalEntities(externalEntities) {
      const entKeys = Object.keys(externalEntities);
      for (let i2 = 0; i2 < entKeys.length; i2++) {
        const ent = entKeys[i2];
        this.lastEntities[ent] = {
          regex: new RegExp("&" + ent + ";", "g"),
          val: externalEntities[ent]
        };
      }
    }
    function parseTextData(val2, tagName, jPath, dontTrim, hasAttributes, isLeafNode, escapeEntities) {
      if (val2 !== void 0) {
        if (this.options.trimValues && !dontTrim) {
          val2 = val2.trim();
        }
        if (val2.length > 0) {
          if (!escapeEntities)
            val2 = this.replaceEntitiesValue(val2);
          const newval = this.options.tagValueProcessor(tagName, val2, jPath, hasAttributes, isLeafNode);
          if (newval === null || newval === void 0) {
            return val2;
          } else if (typeof newval !== typeof val2 || newval !== val2) {
            return newval;
          } else if (this.options.trimValues) {
            return parseValue2(val2, this.options.parseTagValue, this.options.numberParseOptions);
          } else {
            const trimmedVal = val2.trim();
            if (trimmedVal === val2) {
              return parseValue2(val2, this.options.parseTagValue, this.options.numberParseOptions);
            } else {
              return val2;
            }
          }
        }
      }
    }
    function resolveNameSpace(tagname) {
      if (this.options.removeNSPrefix) {
        const tags = tagname.split(":");
        const prefix = tagname.charAt(0) === "/" ? "/" : "";
        if (tags[0] === "xmlns") {
          return "";
        }
        if (tags.length === 2) {
          tagname = prefix + tags[1];
        }
      }
      return tagname;
    }
    var attrsRegx = new RegExp(`([^\\s=]+)\\s*(=\\s*(['"])([\\s\\S]*?)\\3)?`, "gm");
    function buildAttributesMap(attrStr, jPath, tagName) {
      if (!this.options.ignoreAttributes && typeof attrStr === "string") {
        const matches2 = util.getAllMatches(attrStr, attrsRegx);
        const len = matches2.length;
        const attrs = {};
        for (let i2 = 0; i2 < len; i2++) {
          const attrName = this.resolveNameSpace(matches2[i2][1]);
          let oldVal = matches2[i2][4];
          let aName = this.options.attributeNamePrefix + attrName;
          if (attrName.length) {
            if (this.options.transformAttributeName) {
              aName = this.options.transformAttributeName(aName);
            }
            if (aName === "__proto__")
              aName = "#__proto__";
            if (oldVal !== void 0) {
              if (this.options.trimValues) {
                oldVal = oldVal.trim();
              }
              oldVal = this.replaceEntitiesValue(oldVal);
              const newVal = this.options.attributeValueProcessor(attrName, oldVal, jPath);
              if (newVal === null || newVal === void 0) {
                attrs[aName] = oldVal;
              } else if (typeof newVal !== typeof oldVal || newVal !== oldVal) {
                attrs[aName] = newVal;
              } else {
                attrs[aName] = parseValue2(
                  oldVal,
                  this.options.parseAttributeValue,
                  this.options.numberParseOptions
                );
              }
            } else if (this.options.allowBooleanAttributes) {
              attrs[aName] = true;
            }
          }
        }
        if (!Object.keys(attrs).length) {
          return;
        }
        if (this.options.attributesGroupName) {
          const attrCollection = {};
          attrCollection[this.options.attributesGroupName] = attrs;
          return attrCollection;
        }
        return attrs;
      }
    }
    var parseXml = function(xmlData) {
      xmlData = xmlData.replace(/\r\n?/g, "\n");
      const xmlObj = new xmlNode("!xml");
      let currentNode = xmlObj;
      let textData = "";
      let jPath = "";
      for (let i2 = 0; i2 < xmlData.length; i2++) {
        const ch = xmlData[i2];
        if (ch === "<") {
          if (xmlData[i2 + 1] === "/") {
            const closeIndex = findClosingIndex(xmlData, ">", i2, "Closing Tag is not closed.");
            let tagName = xmlData.substring(i2 + 2, closeIndex).trim();
            if (this.options.removeNSPrefix) {
              const colonIndex = tagName.indexOf(":");
              if (colonIndex !== -1) {
                tagName = tagName.substr(colonIndex + 1);
              }
            }
            if (this.options.transformTagName) {
              tagName = this.options.transformTagName(tagName);
            }
            if (currentNode) {
              textData = this.saveTextToParentTag(textData, currentNode, jPath);
            }
            const lastTagName = jPath.substring(jPath.lastIndexOf(".") + 1);
            if (tagName && this.options.unpairedTags.indexOf(tagName) !== -1) {
              throw new Error(`Unpaired tag can not be used as closing tag: </${tagName}>`);
            }
            let propIndex = 0;
            if (lastTagName && this.options.unpairedTags.indexOf(lastTagName) !== -1) {
              propIndex = jPath.lastIndexOf(".", jPath.lastIndexOf(".") - 1);
              this.tagsNodeStack.pop();
            } else {
              propIndex = jPath.lastIndexOf(".");
            }
            jPath = jPath.substring(0, propIndex);
            currentNode = this.tagsNodeStack.pop();
            textData = "";
            i2 = closeIndex;
          } else if (xmlData[i2 + 1] === "?") {
            let tagData = readTagExp(xmlData, i2, false, "?>");
            if (!tagData)
              throw new Error("Pi Tag is not closed.");
            textData = this.saveTextToParentTag(textData, currentNode, jPath);
            if (this.options.ignoreDeclaration && tagData.tagName === "?xml" || this.options.ignorePiTags) {
            } else {
              const childNode = new xmlNode(tagData.tagName);
              childNode.add(this.options.textNodeName, "");
              if (tagData.tagName !== tagData.tagExp && tagData.attrExpPresent) {
                childNode[":@"] = this.buildAttributesMap(tagData.tagExp, jPath, tagData.tagName);
              }
              this.addChild(currentNode, childNode, jPath);
            }
            i2 = tagData.closeIndex + 1;
          } else if (xmlData.substr(i2 + 1, 3) === "!--") {
            const endIndex = findClosingIndex(xmlData, "-->", i2 + 4, "Comment is not closed.");
            if (this.options.commentPropName) {
              const comment = xmlData.substring(i2 + 4, endIndex - 2);
              textData = this.saveTextToParentTag(textData, currentNode, jPath);
              currentNode.add(this.options.commentPropName, [{ [this.options.textNodeName]: comment }]);
            }
            i2 = endIndex;
          } else if (xmlData.substr(i2 + 1, 2) === "!D") {
            const result = readDocType(xmlData, i2);
            this.docTypeEntities = result.entities;
            i2 = result.i;
          } else if (xmlData.substr(i2 + 1, 2) === "![") {
            const closeIndex = findClosingIndex(xmlData, "]]>", i2, "CDATA is not closed.") - 2;
            const tagExp = xmlData.substring(i2 + 9, closeIndex);
            textData = this.saveTextToParentTag(textData, currentNode, jPath);
            if (this.options.cdataPropName) {
              currentNode.add(this.options.cdataPropName, [{ [this.options.textNodeName]: tagExp }]);
            } else {
              let val2 = this.parseTextData(tagExp, currentNode.tagname, jPath, true, false, true);
              if (val2 == void 0)
                val2 = "";
              currentNode.add(this.options.textNodeName, val2);
            }
            i2 = closeIndex + 2;
          } else {
            let result = readTagExp(xmlData, i2, this.options.removeNSPrefix);
            let tagName = result.tagName;
            let tagExp = result.tagExp;
            let attrExpPresent = result.attrExpPresent;
            let closeIndex = result.closeIndex;
            if (this.options.transformTagName) {
              tagName = this.options.transformTagName(tagName);
            }
            if (currentNode && textData) {
              if (currentNode.tagname !== "!xml") {
                textData = this.saveTextToParentTag(textData, currentNode, jPath, false);
              }
            }
            const lastTag = currentNode;
            if (lastTag && this.options.unpairedTags.indexOf(lastTag.tagname) !== -1) {
              currentNode = this.tagsNodeStack.pop();
              jPath = jPath.substring(0, jPath.lastIndexOf("."));
            }
            if (tagName !== xmlObj.tagname) {
              jPath += jPath ? "." + tagName : tagName;
            }
            if (this.isItStopNode(this.options.stopNodes, jPath, tagName)) {
              let tagContent = "";
              if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
                i2 = result.closeIndex;
              } else if (this.options.unpairedTags.indexOf(tagName) !== -1) {
                i2 = result.closeIndex;
              } else {
                const result2 = this.readStopNodeData(xmlData, tagName, closeIndex + 1);
                if (!result2)
                  throw new Error(`Unexpected end of ${tagName}`);
                i2 = result2.i;
                tagContent = result2.tagContent;
              }
              const childNode = new xmlNode(tagName);
              if (tagName !== tagExp && attrExpPresent) {
                childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
              }
              if (tagContent) {
                tagContent = this.parseTextData(tagContent, tagName, jPath, true, attrExpPresent, true, true);
              }
              jPath = jPath.substr(0, jPath.lastIndexOf("."));
              childNode.add(this.options.textNodeName, tagContent);
              this.addChild(currentNode, childNode, jPath);
            } else {
              if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
                if (tagName[tagName.length - 1] === "/") {
                  tagName = tagName.substr(0, tagName.length - 1);
                  tagExp = tagName;
                } else {
                  tagExp = tagExp.substr(0, tagExp.length - 1);
                }
                if (this.options.transformTagName) {
                  tagName = this.options.transformTagName(tagName);
                }
                const childNode = new xmlNode(tagName);
                if (tagName !== tagExp && attrExpPresent) {
                  childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
                }
                this.addChild(currentNode, childNode, jPath);
                jPath = jPath.substr(0, jPath.lastIndexOf("."));
              } else {
                const childNode = new xmlNode(tagName);
                this.tagsNodeStack.push(currentNode);
                if (tagName !== tagExp && attrExpPresent) {
                  childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
                }
                this.addChild(currentNode, childNode, jPath);
                currentNode = childNode;
              }
              textData = "";
              i2 = closeIndex;
            }
          }
        } else {
          textData += xmlData[i2];
        }
      }
      return xmlObj.child;
    };
    function addChild(currentNode, childNode, jPath) {
      const result = this.options.updateTag(childNode.tagname, jPath, childNode[":@"]);
      if (result === false) {
      } else if (typeof result === "string") {
        childNode.tagname = result;
        currentNode.addChild(childNode);
      } else {
        currentNode.addChild(childNode);
      }
    }
    var replaceEntitiesValue = function(val2) {
      if (this.options.processEntities) {
        for (let entityName2 in this.docTypeEntities) {
          const entity = this.docTypeEntities[entityName2];
          val2 = val2.replace(entity.regx, entity.val);
        }
        for (let entityName2 in this.lastEntities) {
          const entity = this.lastEntities[entityName2];
          val2 = val2.replace(entity.regex, entity.val);
        }
        if (this.options.htmlEntities) {
          for (let entityName2 in this.htmlEntities) {
            const entity = this.htmlEntities[entityName2];
            val2 = val2.replace(entity.regex, entity.val);
          }
        }
        val2 = val2.replace(this.ampEntity.regex, this.ampEntity.val);
      }
      return val2;
    };
    function saveTextToParentTag(textData, currentNode, jPath, isLeafNode) {
      if (textData) {
        if (isLeafNode === void 0)
          isLeafNode = Object.keys(currentNode.child).length === 0;
        textData = this.parseTextData(
          textData,
          currentNode.tagname,
          jPath,
          false,
          currentNode[":@"] ? Object.keys(currentNode[":@"]).length !== 0 : false,
          isLeafNode
        );
        if (textData !== void 0 && textData !== "")
          currentNode.add(this.options.textNodeName, textData);
        textData = "";
      }
      return textData;
    }
    function isItStopNode(stopNodes, jPath, currentTagName) {
      const allNodesExp = "*." + currentTagName;
      for (const stopNodePath in stopNodes) {
        const stopNodeExp = stopNodes[stopNodePath];
        if (allNodesExp === stopNodeExp || jPath === stopNodeExp)
          return true;
      }
      return false;
    }
    function tagExpWithClosingIndex(xmlData, i2, closingChar = ">") {
      let attrBoundary;
      let tagExp = "";
      for (let index = i2; index < xmlData.length; index++) {
        let ch = xmlData[index];
        if (attrBoundary) {
          if (ch === attrBoundary)
            attrBoundary = "";
        } else if (ch === '"' || ch === "'") {
          attrBoundary = ch;
        } else if (ch === closingChar[0]) {
          if (closingChar[1]) {
            if (xmlData[index + 1] === closingChar[1]) {
              return {
                data: tagExp,
                index
              };
            }
          } else {
            return {
              data: tagExp,
              index
            };
          }
        } else if (ch === "	") {
          ch = " ";
        }
        tagExp += ch;
      }
    }
    function findClosingIndex(xmlData, str, i2, errMsg) {
      const closingIndex = xmlData.indexOf(str, i2);
      if (closingIndex === -1) {
        throw new Error(errMsg);
      } else {
        return closingIndex + str.length - 1;
      }
    }
    function readTagExp(xmlData, i2, removeNSPrefix, closingChar = ">") {
      const result = tagExpWithClosingIndex(xmlData, i2 + 1, closingChar);
      if (!result)
        return;
      let tagExp = result.data;
      const closeIndex = result.index;
      const separatorIndex = tagExp.search(/\s/);
      let tagName = tagExp;
      let attrExpPresent = true;
      if (separatorIndex !== -1) {
        tagName = tagExp.substr(0, separatorIndex).replace(/\s\s*$/, "");
        tagExp = tagExp.substr(separatorIndex + 1);
      }
      if (removeNSPrefix) {
        const colonIndex = tagName.indexOf(":");
        if (colonIndex !== -1) {
          tagName = tagName.substr(colonIndex + 1);
          attrExpPresent = tagName !== result.data.substr(colonIndex + 1);
        }
      }
      return {
        tagName,
        tagExp,
        closeIndex,
        attrExpPresent
      };
    }
    function readStopNodeData(xmlData, tagName, i2) {
      const startIndex = i2;
      let openTagCount = 1;
      for (; i2 < xmlData.length; i2++) {
        if (xmlData[i2] === "<") {
          if (xmlData[i2 + 1] === "/") {
            const closeIndex = findClosingIndex(xmlData, ">", i2, `${tagName} is not closed`);
            let closeTagName = xmlData.substring(i2 + 2, closeIndex).trim();
            if (closeTagName === tagName) {
              openTagCount--;
              if (openTagCount === 0) {
                return {
                  tagContent: xmlData.substring(startIndex, i2),
                  i: closeIndex
                };
              }
            }
            i2 = closeIndex;
          } else if (xmlData[i2 + 1] === "?") {
            const closeIndex = findClosingIndex(xmlData, "?>", i2 + 1, "StopNode is not closed.");
            i2 = closeIndex;
          } else if (xmlData.substr(i2 + 1, 3) === "!--") {
            const closeIndex = findClosingIndex(xmlData, "-->", i2 + 3, "StopNode is not closed.");
            i2 = closeIndex;
          } else if (xmlData.substr(i2 + 1, 2) === "![") {
            const closeIndex = findClosingIndex(xmlData, "]]>", i2, "StopNode is not closed.") - 2;
            i2 = closeIndex;
          } else {
            const tagData = readTagExp(xmlData, i2, ">");
            if (tagData) {
              const openTagName = tagData && tagData.tagName;
              if (openTagName === tagName && tagData.tagExp[tagData.tagExp.length - 1] !== "/") {
                openTagCount++;
              }
              i2 = tagData.closeIndex;
            }
          }
        }
      }
    }
    function parseValue2(val2, shouldParse, options) {
      if (shouldParse && typeof val2 === "string") {
        const newval = val2.trim();
        if (newval === "true")
          return true;
        else if (newval === "false")
          return false;
        else
          return toNumber(val2, options);
      } else {
        if (util.isExist(val2)) {
          return val2;
        } else {
          return "";
        }
      }
    }
    module.exports = OrderedObjParser;
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/xmlparser/node2json.js
var require_node2json = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/xmlparser/node2json.js"(exports) {
    "use strict";
    function prettify(node, options) {
      return compress(node, options);
    }
    function compress(arr, options, jPath) {
      let text;
      const compressedObj = {};
      for (let i2 = 0; i2 < arr.length; i2++) {
        const tagObj = arr[i2];
        const property = propName(tagObj);
        let newJpath = "";
        if (jPath === void 0)
          newJpath = property;
        else
          newJpath = jPath + "." + property;
        if (property === options.textNodeName) {
          if (text === void 0)
            text = tagObj[property];
          else
            text += "" + tagObj[property];
        } else if (property === void 0) {
          continue;
        } else if (tagObj[property]) {
          let val2 = compress(tagObj[property], options, newJpath);
          const isLeaf = isLeafTag(val2, options);
          if (tagObj[":@"]) {
            assignAttributes(val2, tagObj[":@"], newJpath, options);
          } else if (Object.keys(val2).length === 1 && val2[options.textNodeName] !== void 0 && !options.alwaysCreateTextNode) {
            val2 = val2[options.textNodeName];
          } else if (Object.keys(val2).length === 0) {
            if (options.alwaysCreateTextNode)
              val2[options.textNodeName] = "";
            else
              val2 = "";
          }
          if (compressedObj[property] !== void 0 && compressedObj.hasOwnProperty(property)) {
            if (!Array.isArray(compressedObj[property])) {
              compressedObj[property] = [compressedObj[property]];
            }
            compressedObj[property].push(val2);
          } else {
            if (options.isArray(property, newJpath, isLeaf)) {
              compressedObj[property] = [val2];
            } else {
              compressedObj[property] = val2;
            }
          }
        }
      }
      if (typeof text === "string") {
        if (text.length > 0)
          compressedObj[options.textNodeName] = text;
      } else if (text !== void 0)
        compressedObj[options.textNodeName] = text;
      return compressedObj;
    }
    function propName(obj) {
      const keys = Object.keys(obj);
      for (let i2 = 0; i2 < keys.length; i2++) {
        const key = keys[i2];
        if (key !== ":@")
          return key;
      }
    }
    function assignAttributes(obj, attrMap, jpath, options) {
      if (attrMap) {
        const keys = Object.keys(attrMap);
        const len = keys.length;
        for (let i2 = 0; i2 < len; i2++) {
          const atrrName = keys[i2];
          if (options.isArray(atrrName, jpath + "." + atrrName, true, true)) {
            obj[atrrName] = [attrMap[atrrName]];
          } else {
            obj[atrrName] = attrMap[atrrName];
          }
        }
      }
    }
    function isLeafTag(obj, options) {
      const { textNodeName } = options;
      const propCount = Object.keys(obj).length;
      if (propCount === 0) {
        return true;
      }
      if (propCount === 1 && (obj[textNodeName] || typeof obj[textNodeName] === "boolean" || obj[textNodeName] === 0)) {
        return true;
      }
      return false;
    }
    exports.prettify = prettify;
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/xmlparser/XMLParser.js
var require_XMLParser = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/xmlparser/XMLParser.js"(exports, module) {
    var { buildOptions } = require_OptionsBuilder();
    var OrderedObjParser = require_OrderedObjParser();
    var { prettify } = require_node2json();
    var validator = require_validator();
    var XMLParser2 = class {
      constructor(options) {
        this.externalEntities = {};
        this.options = buildOptions(options);
      }
      /**
       * Parse XML dats to JS object 
       * @param {string|Buffer} xmlData 
       * @param {boolean|Object} validationOption 
       */
      parse(xmlData, validationOption) {
        if (typeof xmlData === "string") {
        } else if (xmlData.toString) {
          xmlData = xmlData.toString();
        } else {
          throw new Error("XML data is accepted in String or Bytes[] form.");
        }
        if (validationOption) {
          if (validationOption === true)
            validationOption = {};
          const result = validator.validate(xmlData, validationOption);
          if (result !== true) {
            throw Error(`${result.err.msg}:${result.err.line}:${result.err.col}`);
          }
        }
        const orderedObjParser = new OrderedObjParser(this.options);
        orderedObjParser.addExternalEntities(this.externalEntities);
        const orderedResult = orderedObjParser.parseXml(xmlData);
        if (this.options.preserveOrder || orderedResult === void 0)
          return orderedResult;
        else
          return prettify(orderedResult, this.options);
      }
      /**
       * Add Entity which is not by default supported by this library
       * @param {string} key 
       * @param {string} value 
       */
      addEntity(key, value) {
        if (value.indexOf("&") !== -1) {
          throw new Error("Entity value can't have '&'");
        } else if (key.indexOf("&") !== -1 || key.indexOf(";") !== -1) {
          throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'");
        } else if (value === "&") {
          throw new Error("An entity with value '&' is not permitted");
        } else {
          this.externalEntities[key] = value;
        }
      }
    };
    module.exports = XMLParser2;
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/xmlbuilder/orderedJs2Xml.js
var require_orderedJs2Xml = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/xmlbuilder/orderedJs2Xml.js"(exports, module) {
    var EOL = "\n";
    function toXml(jArray, options) {
      let indentation = "";
      if (options.format && options.indentBy.length > 0) {
        indentation = EOL;
      }
      return arrToStr(jArray, options, "", indentation);
    }
    function arrToStr(arr, options, jPath, indentation) {
      let xmlStr = "";
      let isPreviousElementTag = false;
      for (let i2 = 0; i2 < arr.length; i2++) {
        const tagObj = arr[i2];
        const tagName = propName(tagObj);
        let newJPath = "";
        if (jPath.length === 0)
          newJPath = tagName;
        else
          newJPath = `${jPath}.${tagName}`;
        if (tagName === options.textNodeName) {
          let tagText = tagObj[tagName];
          if (!isStopNode(newJPath, options)) {
            tagText = options.tagValueProcessor(tagName, tagText);
            tagText = replaceEntitiesValue(tagText, options);
          }
          if (isPreviousElementTag) {
            xmlStr += indentation;
          }
          xmlStr += tagText;
          isPreviousElementTag = false;
          continue;
        } else if (tagName === options.cdataPropName) {
          if (isPreviousElementTag) {
            xmlStr += indentation;
          }
          xmlStr += `<![CDATA[${tagObj[tagName][0][options.textNodeName]}]]>`;
          isPreviousElementTag = false;
          continue;
        } else if (tagName === options.commentPropName) {
          xmlStr += indentation + `<!--${tagObj[tagName][0][options.textNodeName]}-->`;
          isPreviousElementTag = true;
          continue;
        } else if (tagName[0] === "?") {
          const attStr2 = attr_to_str(tagObj[":@"], options);
          const tempInd = tagName === "?xml" ? "" : indentation;
          let piTextNodeName = tagObj[tagName][0][options.textNodeName];
          piTextNodeName = piTextNodeName.length !== 0 ? " " + piTextNodeName : "";
          xmlStr += tempInd + `<${tagName}${piTextNodeName}${attStr2}?>`;
          isPreviousElementTag = true;
          continue;
        }
        let newIdentation = indentation;
        if (newIdentation !== "") {
          newIdentation += options.indentBy;
        }
        const attStr = attr_to_str(tagObj[":@"], options);
        const tagStart = indentation + `<${tagName}${attStr}`;
        const tagValue = arrToStr(tagObj[tagName], options, newJPath, newIdentation);
        if (options.unpairedTags.indexOf(tagName) !== -1) {
          if (options.suppressUnpairedNode)
            xmlStr += tagStart + ">";
          else
            xmlStr += tagStart + "/>";
        } else if ((!tagValue || tagValue.length === 0) && options.suppressEmptyNode) {
          xmlStr += tagStart + "/>";
        } else if (tagValue && tagValue.endsWith(">")) {
          xmlStr += tagStart + `>${tagValue}${indentation}</${tagName}>`;
        } else {
          xmlStr += tagStart + ">";
          if (tagValue && indentation !== "" && (tagValue.includes("/>") || tagValue.includes("</"))) {
            xmlStr += indentation + options.indentBy + tagValue + indentation;
          } else {
            xmlStr += tagValue;
          }
          xmlStr += `</${tagName}>`;
        }
        isPreviousElementTag = true;
      }
      return xmlStr;
    }
    function propName(obj) {
      const keys = Object.keys(obj);
      for (let i2 = 0; i2 < keys.length; i2++) {
        const key = keys[i2];
        if (key !== ":@")
          return key;
      }
    }
    function attr_to_str(attrMap, options) {
      let attrStr = "";
      if (attrMap && !options.ignoreAttributes) {
        for (let attr in attrMap) {
          let attrVal = options.attributeValueProcessor(attr, attrMap[attr]);
          attrVal = replaceEntitiesValue(attrVal, options);
          if (attrVal === true && options.suppressBooleanAttributes) {
            attrStr += ` ${attr.substr(options.attributeNamePrefix.length)}`;
          } else {
            attrStr += ` ${attr.substr(options.attributeNamePrefix.length)}="${attrVal}"`;
          }
        }
      }
      return attrStr;
    }
    function isStopNode(jPath, options) {
      jPath = jPath.substr(0, jPath.length - options.textNodeName.length - 1);
      let tagName = jPath.substr(jPath.lastIndexOf(".") + 1);
      for (let index in options.stopNodes) {
        if (options.stopNodes[index] === jPath || options.stopNodes[index] === "*." + tagName)
          return true;
      }
      return false;
    }
    function replaceEntitiesValue(textValue, options) {
      if (textValue && textValue.length > 0 && options.processEntities) {
        for (let i2 = 0; i2 < options.entities.length; i2++) {
          const entity = options.entities[i2];
          textValue = textValue.replace(entity.regex, entity.val);
        }
      }
      return textValue;
    }
    module.exports = toXml;
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/xmlbuilder/json2xml.js
var require_json2xml = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/xmlbuilder/json2xml.js"(exports, module) {
    "use strict";
    var buildFromOrderedJs = require_orderedJs2Xml();
    var defaultOptions = {
      attributeNamePrefix: "@_",
      attributesGroupName: false,
      textNodeName: "#text",
      ignoreAttributes: true,
      cdataPropName: false,
      format: false,
      indentBy: "  ",
      suppressEmptyNode: false,
      suppressUnpairedNode: true,
      suppressBooleanAttributes: true,
      tagValueProcessor: function(key, a2) {
        return a2;
      },
      attributeValueProcessor: function(attrName, a2) {
        return a2;
      },
      preserveOrder: false,
      commentPropName: false,
      unpairedTags: [],
      entities: [
        { regex: new RegExp("&", "g"), val: "&amp;" },
        //it must be on top
        { regex: new RegExp(">", "g"), val: "&gt;" },
        { regex: new RegExp("<", "g"), val: "&lt;" },
        { regex: new RegExp("'", "g"), val: "&apos;" },
        { regex: new RegExp('"', "g"), val: "&quot;" }
      ],
      processEntities: true,
      stopNodes: [],
      // transformTagName: false,
      // transformAttributeName: false,
      oneListGroup: false
    };
    function Builder(options) {
      this.options = Object.assign({}, defaultOptions, options);
      if (this.options.ignoreAttributes || this.options.attributesGroupName) {
        this.isAttribute = function() {
          return false;
        };
      } else {
        this.attrPrefixLen = this.options.attributeNamePrefix.length;
        this.isAttribute = isAttribute;
      }
      this.processTextOrObjNode = processTextOrObjNode;
      if (this.options.format) {
        this.indentate = indentate;
        this.tagEndChar = ">\n";
        this.newLine = "\n";
      } else {
        this.indentate = function() {
          return "";
        };
        this.tagEndChar = ">";
        this.newLine = "";
      }
    }
    Builder.prototype.build = function(jObj) {
      if (this.options.preserveOrder) {
        return buildFromOrderedJs(jObj, this.options);
      } else {
        if (Array.isArray(jObj) && this.options.arrayNodeName && this.options.arrayNodeName.length > 1) {
          jObj = {
            [this.options.arrayNodeName]: jObj
          };
        }
        return this.j2x(jObj, 0).val;
      }
    };
    Builder.prototype.j2x = function(jObj, level) {
      let attrStr = "";
      let val2 = "";
      for (let key in jObj) {
        if (typeof jObj[key] === "undefined") {
        } else if (jObj[key] === null) {
          if (key[0] === "?")
            val2 += this.indentate(level) + "<" + key + "?" + this.tagEndChar;
          else
            val2 += this.indentate(level) + "<" + key + "/" + this.tagEndChar;
        } else if (jObj[key] instanceof Date) {
          val2 += this.buildTextValNode(jObj[key], key, "", level);
        } else if (typeof jObj[key] !== "object") {
          const attr = this.isAttribute(key);
          if (attr) {
            attrStr += this.buildAttrPairStr(attr, "" + jObj[key]);
          } else {
            if (key === this.options.textNodeName) {
              let newval = this.options.tagValueProcessor(key, "" + jObj[key]);
              val2 += this.replaceEntitiesValue(newval);
            } else {
              val2 += this.buildTextValNode(jObj[key], key, "", level);
            }
          }
        } else if (Array.isArray(jObj[key])) {
          const arrLen = jObj[key].length;
          let listTagVal = "";
          for (let j2 = 0; j2 < arrLen; j2++) {
            const item = jObj[key][j2];
            if (typeof item === "undefined") {
            } else if (item === null) {
              if (key[0] === "?")
                val2 += this.indentate(level) + "<" + key + "?" + this.tagEndChar;
              else
                val2 += this.indentate(level) + "<" + key + "/" + this.tagEndChar;
            } else if (typeof item === "object") {
              if (this.options.oneListGroup) {
                listTagVal += this.j2x(item, level + 1).val;
              } else {
                listTagVal += this.processTextOrObjNode(item, key, level);
              }
            } else {
              listTagVal += this.buildTextValNode(item, key, "", level);
            }
          }
          if (this.options.oneListGroup) {
            listTagVal = this.buildObjectNode(listTagVal, key, "", level);
          }
          val2 += listTagVal;
        } else {
          if (this.options.attributesGroupName && key === this.options.attributesGroupName) {
            const Ks = Object.keys(jObj[key]);
            const L2 = Ks.length;
            for (let j2 = 0; j2 < L2; j2++) {
              attrStr += this.buildAttrPairStr(Ks[j2], "" + jObj[key][Ks[j2]]);
            }
          } else {
            val2 += this.processTextOrObjNode(jObj[key], key, level);
          }
        }
      }
      return { attrStr, val: val2 };
    };
    Builder.prototype.buildAttrPairStr = function(attrName, val2) {
      val2 = this.options.attributeValueProcessor(attrName, "" + val2);
      val2 = this.replaceEntitiesValue(val2);
      if (this.options.suppressBooleanAttributes && val2 === "true") {
        return " " + attrName;
      } else
        return " " + attrName + '="' + val2 + '"';
    };
    function processTextOrObjNode(object, key, level) {
      const result = this.j2x(object, level + 1);
      if (object[this.options.textNodeName] !== void 0 && Object.keys(object).length === 1) {
        return this.buildTextValNode(object[this.options.textNodeName], key, result.attrStr, level);
      } else {
        return this.buildObjectNode(result.val, key, result.attrStr, level);
      }
    }
    Builder.prototype.buildObjectNode = function(val2, key, attrStr, level) {
      if (val2 === "") {
        if (key[0] === "?")
          return this.indentate(level) + "<" + key + attrStr + "?" + this.tagEndChar;
        else {
          return this.indentate(level) + "<" + key + attrStr + this.closeTag(key) + this.tagEndChar;
        }
      } else {
        let tagEndExp = "</" + key + this.tagEndChar;
        let piClosingChar = "";
        if (key[0] === "?") {
          piClosingChar = "?";
          tagEndExp = "";
        }
        if (attrStr && val2.indexOf("<") === -1) {
          return this.indentate(level) + "<" + key + attrStr + piClosingChar + ">" + val2 + tagEndExp;
        } else if (this.options.commentPropName !== false && key === this.options.commentPropName && piClosingChar.length === 0) {
          return this.indentate(level) + `<!--${val2}-->` + this.newLine;
        } else {
          return this.indentate(level) + "<" + key + attrStr + piClosingChar + this.tagEndChar + val2 + this.indentate(level) + tagEndExp;
        }
      }
    };
    Builder.prototype.closeTag = function(key) {
      let closeTag = "";
      if (this.options.unpairedTags.indexOf(key) !== -1) {
        if (!this.options.suppressUnpairedNode)
          closeTag = "/";
      } else if (this.options.suppressEmptyNode) {
        closeTag = "/";
      } else {
        closeTag = `></${key}`;
      }
      return closeTag;
    };
    Builder.prototype.buildTextValNode = function(val2, key, attrStr, level) {
      if (this.options.cdataPropName !== false && key === this.options.cdataPropName) {
        return this.indentate(level) + `<![CDATA[${val2}]]>` + this.newLine;
      } else if (this.options.commentPropName !== false && key === this.options.commentPropName) {
        return this.indentate(level) + `<!--${val2}-->` + this.newLine;
      } else if (key[0] === "?") {
        return this.indentate(level) + "<" + key + attrStr + "?" + this.tagEndChar;
      } else {
        let textValue = this.options.tagValueProcessor(key, val2);
        textValue = this.replaceEntitiesValue(textValue);
        if (textValue === "") {
          return this.indentate(level) + "<" + key + attrStr + this.closeTag(key) + this.tagEndChar;
        } else {
          return this.indentate(level) + "<" + key + attrStr + ">" + textValue + "</" + key + this.tagEndChar;
        }
      }
    };
    Builder.prototype.replaceEntitiesValue = function(textValue) {
      if (textValue && textValue.length > 0 && this.options.processEntities) {
        for (let i2 = 0; i2 < this.options.entities.length; i2++) {
          const entity = this.options.entities[i2];
          textValue = textValue.replace(entity.regex, entity.val);
        }
      }
      return textValue;
    };
    function indentate(level) {
      return this.options.indentBy.repeat(level);
    }
    function isAttribute(name) {
      if (name.startsWith(this.options.attributeNamePrefix)) {
        return name.substr(this.attrPrefixLen);
      } else {
        return false;
      }
    }
    module.exports = Builder;
  }
});

// node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/fxp.js
var require_fxp = __commonJS({
  "node_modules/@aws-sdk/client-s3/node_modules/fast-xml-parser/src/fxp.js"(exports, module) {
    "use strict";
    var validator = require_validator();
    var XMLParser2 = require_XMLParser();
    var XMLBuilder = require_json2xml();
    module.exports = {
      XMLParser: XMLParser2,
      XMLValidator: validator,
      XMLBuilder
    };
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/bind.js
var require_bind = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/bind.js"(exports, module) {
    "use strict";
    module.exports = function bind(fn2, thisArg) {
      return function wrap3() {
        var args = new Array(arguments.length);
        for (var i2 = 0; i2 < args.length; i2++) {
          args[i2] = arguments[i2];
        }
        return fn2.apply(thisArg, args);
      };
    };
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/utils.js
var require_utils = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/utils.js"(exports, module) {
    "use strict";
    var bind = require_bind();
    var toString = Object.prototype.toString;
    function isArray(val2) {
      return Array.isArray(val2);
    }
    function isUndefined(val2) {
      return typeof val2 === "undefined";
    }
    function isBuffer(val2) {
      return val2 !== null && !isUndefined(val2) && val2.constructor !== null && !isUndefined(val2.constructor) && typeof val2.constructor.isBuffer === "function" && val2.constructor.isBuffer(val2);
    }
    function isArrayBuffer6(val2) {
      return toString.call(val2) === "[object ArrayBuffer]";
    }
    function isFormData(val2) {
      return toString.call(val2) === "[object FormData]";
    }
    function isArrayBufferView(val2) {
      var result;
      if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
        result = ArrayBuffer.isView(val2);
      } else {
        result = val2 && val2.buffer && isArrayBuffer6(val2.buffer);
      }
      return result;
    }
    function isString(val2) {
      return typeof val2 === "string";
    }
    function isNumber2(val2) {
      return typeof val2 === "number";
    }
    function isObject(val2) {
      return val2 !== null && typeof val2 === "object";
    }
    function isPlainObject(val2) {
      if (toString.call(val2) !== "[object Object]") {
        return false;
      }
      var prototype = Object.getPrototypeOf(val2);
      return prototype === null || prototype === Object.prototype;
    }
    function isDate(val2) {
      return toString.call(val2) === "[object Date]";
    }
    function isFile2(val2) {
      return toString.call(val2) === "[object File]";
    }
    function isBlob3(val2) {
      return toString.call(val2) === "[object Blob]";
    }
    function isFunction(val2) {
      return toString.call(val2) === "[object Function]";
    }
    function isStream(val2) {
      return isObject(val2) && isFunction(val2.pipe);
    }
    function isURLSearchParams(val2) {
      return toString.call(val2) === "[object URLSearchParams]";
    }
    function trim(str) {
      return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    function isStandardBrowserEnv() {
      if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
        return false;
      }
      return typeof window !== "undefined" && typeof document !== "undefined";
    }
    function forEach(obj, fn2) {
      if (obj === null || typeof obj === "undefined") {
        return;
      }
      if (typeof obj !== "object") {
        obj = [obj];
      }
      if (isArray(obj)) {
        for (var i2 = 0, l2 = obj.length; i2 < l2; i2++) {
          fn2.call(null, obj[i2], i2, obj);
        }
      } else {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn2.call(null, obj[key], key, obj);
          }
        }
      }
    }
    function merge() {
      var result = {};
      function assignValue(val2, key) {
        if (isPlainObject(result[key]) && isPlainObject(val2)) {
          result[key] = merge(result[key], val2);
        } else if (isPlainObject(val2)) {
          result[key] = merge({}, val2);
        } else if (isArray(val2)) {
          result[key] = val2.slice();
        } else {
          result[key] = val2;
        }
      }
      for (var i2 = 0, l2 = arguments.length; i2 < l2; i2++) {
        forEach(arguments[i2], assignValue);
      }
      return result;
    }
    function extend(a2, b2, thisArg) {
      forEach(b2, function assignValue(val2, key) {
        if (thisArg && typeof val2 === "function") {
          a2[key] = bind(val2, thisArg);
        } else {
          a2[key] = val2;
        }
      });
      return a2;
    }
    function stripBOM(content) {
      if (content.charCodeAt(0) === 65279) {
        content = content.slice(1);
      }
      return content;
    }
    module.exports = {
      isArray,
      isArrayBuffer: isArrayBuffer6,
      isBuffer,
      isFormData,
      isArrayBufferView,
      isString,
      isNumber: isNumber2,
      isObject,
      isPlainObject,
      isUndefined,
      isDate,
      isFile: isFile2,
      isBlob: isBlob3,
      isFunction,
      isStream,
      isURLSearchParams,
      isStandardBrowserEnv,
      forEach,
      merge,
      extend,
      trim,
      stripBOM
    };
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/buildURL.js
var require_buildURL = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/buildURL.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    function encode(val2) {
      return encodeURIComponent(val2).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }
    module.exports = function buildURL(url2, params, paramsSerializer) {
      if (!params) {
        return url2;
      }
      var serializedParams;
      if (paramsSerializer) {
        serializedParams = paramsSerializer(params);
      } else if (utils.isURLSearchParams(params)) {
        serializedParams = params.toString();
      } else {
        var parts = [];
        utils.forEach(params, function serialize2(val2, key) {
          if (val2 === null || typeof val2 === "undefined") {
            return;
          }
          if (utils.isArray(val2)) {
            key = key + "[]";
          } else {
            val2 = [val2];
          }
          utils.forEach(val2, function parseValue2(v2) {
            if (utils.isDate(v2)) {
              v2 = v2.toISOString();
            } else if (utils.isObject(v2)) {
              v2 = JSON.stringify(v2);
            }
            parts.push(encode(key) + "=" + encode(v2));
          });
        });
        serializedParams = parts.join("&");
      }
      if (serializedParams) {
        var hashmarkIndex = url2.indexOf("#");
        if (hashmarkIndex !== -1) {
          url2 = url2.slice(0, hashmarkIndex);
        }
        url2 += (url2.indexOf("?") === -1 ? "?" : "&") + serializedParams;
      }
      return url2;
    };
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/core/InterceptorManager.js
var require_InterceptorManager = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/core/InterceptorManager.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    function InterceptorManager() {
      this.handlers = [];
    }
    InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
      this.handlers.push({
        fulfilled,
        rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
      });
      return this.handlers.length - 1;
    };
    InterceptorManager.prototype.eject = function eject(id) {
      if (this.handlers[id]) {
        this.handlers[id] = null;
      }
    };
    InterceptorManager.prototype.forEach = function forEach(fn2) {
      utils.forEach(this.handlers, function forEachHandler(h2) {
        if (h2 !== null) {
          fn2(h2);
        }
      });
    };
    module.exports = InterceptorManager;
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/normalizeHeaderName.js
var require_normalizeHeaderName = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/normalizeHeaderName.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = function normalizeHeaderName(headers, normalizedName) {
      utils.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
          headers[normalizedName] = value;
          delete headers[name];
        }
      });
    };
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/core/enhanceError.js
var require_enhanceError = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/core/enhanceError.js"(exports, module) {
    "use strict";
    module.exports = function enhanceError(error, config, code, request, response) {
      error.config = config;
      if (code) {
        error.code = code;
      }
      error.request = request;
      error.response = response;
      error.isAxiosError = true;
      error.toJSON = function toJSON() {
        return {
          // Standard
          message: this.message,
          name: this.name,
          // Microsoft
          description: this.description,
          number: this.number,
          // Mozilla
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          // Axios
          config: this.config,
          code: this.code,
          status: this.response && this.response.status ? this.response.status : null
        };
      };
      return error;
    };
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/core/createError.js
var require_createError = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/core/createError.js"(exports, module) {
    "use strict";
    var enhanceError = require_enhanceError();
    module.exports = function createError2(message, config, code, request, response) {
      var error = new Error(message);
      return enhanceError(error, config, code, request, response);
    };
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/core/settle.js
var require_settle = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/core/settle.js"(exports, module) {
    "use strict";
    var createError2 = require_createError();
    module.exports = function settle(resolve, reject, response) {
      var validateStatus = response.config.validateStatus;
      if (!response.status || !validateStatus || validateStatus(response.status)) {
        resolve(response);
      } else {
        reject(createError2(
          "Request failed with status code " + response.status,
          response.config,
          null,
          response.request,
          response
        ));
      }
    };
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/cookies.js
var require_cookies = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/cookies.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = utils.isStandardBrowserEnv() ? (
      // Standard browser envs support document.cookie
      function standardBrowserEnv() {
        return {
          write: function write(name, value, expires, path, domain, secure) {
            var cookie3 = [];
            cookie3.push(name + "=" + encodeURIComponent(value));
            if (utils.isNumber(expires)) {
              cookie3.push("expires=" + new Date(expires).toGMTString());
            }
            if (utils.isString(path)) {
              cookie3.push("path=" + path);
            }
            if (utils.isString(domain)) {
              cookie3.push("domain=" + domain);
            }
            if (secure === true) {
              cookie3.push("secure");
            }
            document.cookie = cookie3.join("; ");
          },
          read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
          },
          remove: function remove2(name) {
            this.write(name, "", Date.now() - 864e5);
          }
        };
      }()
    ) : (
      // Non standard browser env (web workers, react-native) lack needed support.
      function nonStandardBrowserEnv() {
        return {
          write: function write() {
          },
          read: function read() {
            return null;
          },
          remove: function remove2() {
          }
        };
      }()
    );
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/isAbsoluteURL.js
var require_isAbsoluteURL = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/isAbsoluteURL.js"(exports, module) {
    "use strict";
    module.exports = function isAbsoluteURL(url2) {
      return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url2);
    };
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/combineURLs.js
var require_combineURLs = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/combineURLs.js"(exports, module) {
    "use strict";
    module.exports = function combineURLs(baseURL, relativeURL) {
      return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
    };
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/core/buildFullPath.js
var require_buildFullPath = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/core/buildFullPath.js"(exports, module) {
    "use strict";
    var isAbsoluteURL = require_isAbsoluteURL();
    var combineURLs = require_combineURLs();
    module.exports = function buildFullPath(baseURL, requestedURL) {
      if (baseURL && !isAbsoluteURL(requestedURL)) {
        return combineURLs(baseURL, requestedURL);
      }
      return requestedURL;
    };
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/parseHeaders.js
var require_parseHeaders = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/parseHeaders.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var ignoreDuplicateOf = [
      "age",
      "authorization",
      "content-length",
      "content-type",
      "etag",
      "expires",
      "from",
      "host",
      "if-modified-since",
      "if-unmodified-since",
      "last-modified",
      "location",
      "max-forwards",
      "proxy-authorization",
      "referer",
      "retry-after",
      "user-agent"
    ];
    module.exports = function parseHeaders(headers) {
      var parsed = {};
      var key;
      var val2;
      var i2;
      if (!headers) {
        return parsed;
      }
      utils.forEach(headers.split("\n"), function parser2(line) {
        i2 = line.indexOf(":");
        key = utils.trim(line.substr(0, i2)).toLowerCase();
        val2 = utils.trim(line.substr(i2 + 1));
        if (key) {
          if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
            return;
          }
          if (key === "set-cookie") {
            parsed[key] = (parsed[key] ? parsed[key] : []).concat([val2]);
          } else {
            parsed[key] = parsed[key] ? parsed[key] + ", " + val2 : val2;
          }
        }
      });
      return parsed;
    };
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/isURLSameOrigin.js
var require_isURLSameOrigin = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/isURLSameOrigin.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = utils.isStandardBrowserEnv() ? (
      // Standard browser envs have full support of the APIs needed to test
      // whether the request URL is of the same origin as current location.
      function standardBrowserEnv() {
        var msie = /(msie|trident)/i.test(navigator.userAgent);
        var urlParsingNode = document.createElement("a");
        var originURL;
        function resolveURL(url2) {
          var href = url2;
          if (msie) {
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
          }
          urlParsingNode.setAttribute("href", href);
          return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
          };
        }
        originURL = resolveURL(window.location.href);
        return function isURLSameOrigin(requestURL) {
          var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
          return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
        };
      }()
    ) : (
      // Non standard browser envs (web workers, react-native) lack needed support.
      function nonStandardBrowserEnv() {
        return function isURLSameOrigin() {
          return true;
        };
      }()
    );
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/cancel/Cancel.js
var require_Cancel = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/cancel/Cancel.js"(exports, module) {
    "use strict";
    function Cancel(message) {
      this.message = message;
    }
    Cancel.prototype.toString = function toString() {
      return "Cancel" + (this.message ? ": " + this.message : "");
    };
    Cancel.prototype.__CANCEL__ = true;
    module.exports = Cancel;
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/adapters/xhr.js
var require_xhr = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/adapters/xhr.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var settle = require_settle();
    var cookies = require_cookies();
    var buildURL = require_buildURL();
    var buildFullPath = require_buildFullPath();
    var parseHeaders = require_parseHeaders();
    var isURLSameOrigin = require_isURLSameOrigin();
    var createError2 = require_createError();
    var defaults = require_defaults();
    var Cancel = require_Cancel();
    module.exports = function xhrAdapter(config) {
      return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
          if (config.cancelToken) {
            config.cancelToken.unsubscribe(onCanceled);
          }
          if (config.signal) {
            config.signal.removeEventListener("abort", onCanceled);
          }
        }
        if (utils.isFormData(requestData)) {
          delete requestHeaders["Content-Type"];
        }
        var request = new XMLHttpRequest();
        if (config.auth) {
          var username = config.auth.username || "";
          var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
          requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = buildFullPath(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
        request.timeout = config.timeout;
        function onloadend() {
          if (!request) {
            return;
          }
          var responseHeaders = "getAllResponseHeaders" in request ? parseHeaders(request.getAllResponseHeaders()) : null;
          var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
          var response = {
            data: responseData,
            status: request.status,
            statusText: request.statusText,
            headers: responseHeaders,
            config,
            request
          };
          settle(function _resolve(value) {
            resolve(value);
            done();
          }, function _reject(err) {
            reject(err);
            done();
          }, response);
          request = null;
        }
        if ("onloadend" in request) {
          request.onloadend = onloadend;
        } else {
          request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) {
              return;
            }
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
              return;
            }
            setTimeout(onloadend);
          };
        }
        request.onabort = function handleAbort() {
          if (!request) {
            return;
          }
          reject(createError2("Request aborted", config, "ECONNABORTED", request));
          request = null;
        };
        request.onerror = function handleError() {
          reject(createError2("Network Error", config, null, request));
          request = null;
        };
        request.ontimeout = function handleTimeout() {
          var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
          var transitional = config.transitional || defaults.transitional;
          if (config.timeoutErrorMessage) {
            timeoutErrorMessage = config.timeoutErrorMessage;
          }
          reject(createError2(
            timeoutErrorMessage,
            config,
            transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
            request
          ));
          request = null;
        };
        if (utils.isStandardBrowserEnv()) {
          var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;
          if (xsrfValue) {
            requestHeaders[config.xsrfHeaderName] = xsrfValue;
          }
        }
        if ("setRequestHeader" in request) {
          utils.forEach(requestHeaders, function setRequestHeader(val2, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
              delete requestHeaders[key];
            } else {
              request.setRequestHeader(key, val2);
            }
          });
        }
        if (!utils.isUndefined(config.withCredentials)) {
          request.withCredentials = !!config.withCredentials;
        }
        if (responseType && responseType !== "json") {
          request.responseType = config.responseType;
        }
        if (typeof config.onDownloadProgress === "function") {
          request.addEventListener("progress", config.onDownloadProgress);
        }
        if (typeof config.onUploadProgress === "function" && request.upload) {
          request.upload.addEventListener("progress", config.onUploadProgress);
        }
        if (config.cancelToken || config.signal) {
          onCanceled = function(cancel) {
            if (!request) {
              return;
            }
            reject(!cancel || cancel && cancel.type ? new Cancel("canceled") : cancel);
            request.abort();
            request = null;
          };
          config.cancelToken && config.cancelToken.subscribe(onCanceled);
          if (config.signal) {
            config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
          }
        }
        if (!requestData) {
          requestData = null;
        }
        request.send(requestData);
      });
    };
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/defaults.js
var require_defaults = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/defaults.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var normalizeHeaderName = require_normalizeHeaderName();
    var enhanceError = require_enhanceError();
    var DEFAULT_CONTENT_TYPE = {
      "Content-Type": "application/x-www-form-urlencoded"
    };
    function setContentTypeIfUnset(headers, value) {
      if (!utils.isUndefined(headers) && utils.isUndefined(headers["Content-Type"])) {
        headers["Content-Type"] = value;
      }
    }
    function getDefaultAdapter2() {
      var adapter;
      if (typeof XMLHttpRequest !== "undefined") {
        adapter = require_xhr();
      } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
        adapter = require_xhr();
      }
      return adapter;
    }
    function stringifySafely(rawValue, parser2, encoder) {
      if (utils.isString(rawValue)) {
        try {
          (parser2 || JSON.parse)(rawValue);
          return utils.trim(rawValue);
        } catch (e) {
          if (e.name !== "SyntaxError") {
            throw e;
          }
        }
      }
      return (encoder || JSON.stringify)(rawValue);
    }
    var defaults = {
      transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
      },
      adapter: getDefaultAdapter2(),
      transformRequest: [function transformRequest(data, headers) {
        normalizeHeaderName(headers, "Accept");
        normalizeHeaderName(headers, "Content-Type");
        if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
          return data;
        }
        if (utils.isArrayBufferView(data)) {
          return data.buffer;
        }
        if (utils.isURLSearchParams(data)) {
          setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
          return data.toString();
        }
        if (utils.isObject(data) || headers && headers["Content-Type"] === "application/json") {
          setContentTypeIfUnset(headers, "application/json");
          return stringifySafely(data);
        }
        return data;
      }],
      transformResponse: [function transformResponse(data) {
        var transitional = this.transitional || defaults.transitional;
        var silentJSONParsing = transitional && transitional.silentJSONParsing;
        var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
        var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
        if (strictJSONParsing || forcedJSONParsing && utils.isString(data) && data.length) {
          try {
            return JSON.parse(data);
          } catch (e) {
            if (strictJSONParsing) {
              if (e.name === "SyntaxError") {
                throw enhanceError(e, this, "E_JSON_PARSE");
              }
              throw e;
            }
          }
        }
        return data;
      }],
      /**
       * A timeout in milliseconds to abort a request. If set to 0 (default) a
       * timeout is not created.
       */
      timeout: 0,
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
      maxContentLength: -1,
      maxBodyLength: -1,
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      },
      headers: {
        common: {
          "Accept": "application/json, text/plain, */*"
        }
      }
    };
    utils.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
      defaults.headers[method] = {};
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
    });
    module.exports = defaults;
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/core/transformData.js
var require_transformData = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/core/transformData.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var defaults = require_defaults();
    module.exports = function transformData(data, headers, fns) {
      var context = this || defaults;
      utils.forEach(fns, function transform(fn2) {
        data = fn2.call(context, data, headers);
      });
      return data;
    };
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/cancel/isCancel.js
var require_isCancel = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/cancel/isCancel.js"(exports, module) {
    "use strict";
    module.exports = function isCancel(value) {
      return !!(value && value.__CANCEL__);
    };
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/core/dispatchRequest.js
var require_dispatchRequest = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/core/dispatchRequest.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var transformData = require_transformData();
    var isCancel = require_isCancel();
    var defaults = require_defaults();
    var Cancel = require_Cancel();
    function throwIfCancellationRequested(config) {
      if (config.cancelToken) {
        config.cancelToken.throwIfRequested();
      }
      if (config.signal && config.signal.aborted) {
        throw new Cancel("canceled");
      }
    }
    module.exports = function dispatchRequest(config) {
      throwIfCancellationRequested(config);
      config.headers = config.headers || {};
      config.data = transformData.call(
        config,
        config.data,
        config.headers,
        config.transformRequest
      );
      config.headers = utils.merge(
        config.headers.common || {},
        config.headers[config.method] || {},
        config.headers
      );
      utils.forEach(
        ["delete", "get", "head", "post", "put", "patch", "common"],
        function cleanHeaderConfig(method) {
          delete config.headers[method];
        }
      );
      var adapter = config.adapter || defaults.adapter;
      return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        response.data = transformData.call(
          config,
          response.data,
          response.headers,
          config.transformResponse
        );
        return response;
      }, function onAdapterRejection(reason) {
        if (!isCancel(reason)) {
          throwIfCancellationRequested(config);
          if (reason && reason.response) {
            reason.response.data = transformData.call(
              config,
              reason.response.data,
              reason.response.headers,
              config.transformResponse
            );
          }
        }
        return Promise.reject(reason);
      });
    };
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/core/mergeConfig.js
var require_mergeConfig = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/core/mergeConfig.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = function mergeConfig(config1, config2) {
      config2 = config2 || {};
      var config = {};
      function getMergedValue(target, source) {
        if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
          return utils.merge(target, source);
        } else if (utils.isPlainObject(source)) {
          return utils.merge({}, source);
        } else if (utils.isArray(source)) {
          return source.slice();
        }
        return source;
      }
      function mergeDeepProperties(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function valueFromConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(void 0, config2[prop]);
        }
      }
      function defaultToConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(void 0, config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function mergeDirectKeys(prop) {
        if (prop in config2) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (prop in config1) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
      };
      utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        utils.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
      });
      return config;
    };
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/env/data.js
var require_data = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/env/data.js"(exports, module) {
    module.exports = {
      "version": "0.26.0"
    };
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/validator.js
var require_validator2 = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/validator.js"(exports, module) {
    "use strict";
    var VERSION = require_data().version;
    var validators = {};
    ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i2) {
      validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i2 < 1 ? "n " : " ") + type;
      };
    });
    var deprecatedWarnings = {};
    validators.transitional = function transitional(validator, version3, message) {
      function formatMessage(opt, desc) {
        return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
      }
      return function(value, opt, opts) {
        if (validator === false) {
          throw new Error(formatMessage(opt, " has been removed" + (version3 ? " in " + version3 : "")));
        }
        if (version3 && !deprecatedWarnings[opt]) {
          deprecatedWarnings[opt] = true;
          console.warn(
            formatMessage(
              opt,
              " has been deprecated since v" + version3 + " and will be removed in the near future"
            )
          );
        }
        return validator ? validator(value, opt, opts) : true;
      };
    };
    function assertOptions(options, schema2, allowUnknown) {
      if (typeof options !== "object") {
        throw new TypeError("options must be an object");
      }
      var keys = Object.keys(options);
      var i2 = keys.length;
      while (i2-- > 0) {
        var opt = keys[i2];
        var validator = schema2[opt];
        if (validator) {
          var value = options[opt];
          var result = value === void 0 || validator(value, opt, options);
          if (result !== true) {
            throw new TypeError("option " + opt + " must be " + result);
          }
          continue;
        }
        if (allowUnknown !== true) {
          throw Error("Unknown option " + opt);
        }
      }
    }
    module.exports = {
      assertOptions,
      validators
    };
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/core/Axios.js
var require_Axios = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/core/Axios.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var buildURL = require_buildURL();
    var InterceptorManager = require_InterceptorManager();
    var dispatchRequest = require_dispatchRequest();
    var mergeConfig = require_mergeConfig();
    var validator = require_validator2();
    var validators = validator.validators;
    function Axios(instanceConfig) {
      this.defaults = instanceConfig;
      this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
      };
    }
    Axios.prototype.request = function request(configOrUrl, config) {
      if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
      } else {
        config = configOrUrl || {};
      }
      config = mergeConfig(this.defaults, config);
      if (config.method) {
        config.method = config.method.toLowerCase();
      } else if (this.defaults.method) {
        config.method = this.defaults.method.toLowerCase();
      } else {
        config.method = "get";
      }
      var transitional = config.transitional;
      if (transitional !== void 0) {
        validator.assertOptions(transitional, {
          silentJSONParsing: validators.transitional(validators.boolean),
          forcedJSONParsing: validators.transitional(validators.boolean),
          clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
      }
      var requestInterceptorChain = [];
      var synchronousRequestInterceptors = true;
      this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
          return;
        }
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
      });
      var responseInterceptorChain = [];
      this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
      });
      var promise;
      if (!synchronousRequestInterceptors) {
        var chain = [dispatchRequest, void 0];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while (chain.length) {
          promise = promise.then(chain.shift(), chain.shift());
        }
        return promise;
      }
      var newConfig = config;
      while (requestInterceptorChain.length) {
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
          newConfig = onFulfilled(newConfig);
        } catch (error) {
          onRejected(error);
          break;
        }
      }
      try {
        promise = dispatchRequest(newConfig);
      } catch (error) {
        return Promise.reject(error);
      }
      while (responseInterceptorChain.length) {
        promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
      }
      return promise;
    };
    Axios.prototype.getUri = function getUri(config) {
      config = mergeConfig(this.defaults, config);
      return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
    };
    utils.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
      Axios.prototype[method] = function(url2, config) {
        return this.request(mergeConfig(config || {}, {
          method,
          url: url2,
          data: (config || {}).data
        }));
      };
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      Axios.prototype[method] = function(url2, data, config) {
        return this.request(mergeConfig(config || {}, {
          method,
          url: url2,
          data
        }));
      };
    });
    module.exports = Axios;
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/cancel/CancelToken.js
var require_CancelToken = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/cancel/CancelToken.js"(exports, module) {
    "use strict";
    var Cancel = require_Cancel();
    function CancelToken(executor) {
      if (typeof executor !== "function") {
        throw new TypeError("executor must be a function.");
      }
      var resolvePromise;
      this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
      });
      var token = this;
      this.promise.then(function(cancel) {
        if (!token._listeners)
          return;
        var i2;
        var l2 = token._listeners.length;
        for (i2 = 0; i2 < l2; i2++) {
          token._listeners[i2](cancel);
        }
        token._listeners = null;
      });
      this.promise.then = function(onfulfilled) {
        var _resolve;
        var promise = new Promise(function(resolve) {
          token.subscribe(resolve);
          _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
          token.unsubscribe(_resolve);
        };
        return promise;
      };
      executor(function cancel(message) {
        if (token.reason) {
          return;
        }
        token.reason = new Cancel(message);
        resolvePromise(token.reason);
      });
    }
    CancelToken.prototype.throwIfRequested = function throwIfRequested() {
      if (this.reason) {
        throw this.reason;
      }
    };
    CancelToken.prototype.subscribe = function subscribe(listener2) {
      if (this.reason) {
        listener2(this.reason);
        return;
      }
      if (this._listeners) {
        this._listeners.push(listener2);
      } else {
        this._listeners = [listener2];
      }
    };
    CancelToken.prototype.unsubscribe = function unsubscribe(listener2) {
      if (!this._listeners) {
        return;
      }
      var index = this._listeners.indexOf(listener2);
      if (index !== -1) {
        this._listeners.splice(index, 1);
      }
    };
    CancelToken.source = function source() {
      var cancel;
      var token = new CancelToken(function executor(c2) {
        cancel = c2;
      });
      return {
        token,
        cancel
      };
    };
    module.exports = CancelToken;
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/spread.js
var require_spread = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/spread.js"(exports, module) {
    "use strict";
    module.exports = function spread(callback) {
      return function wrap3(arr) {
        return callback.apply(null, arr);
      };
    };
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/isAxiosError.js
var require_isAxiosError = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/helpers/isAxiosError.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = function isAxiosError(payload) {
      return utils.isObject(payload) && payload.isAxiosError === true;
    };
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/lib/axios.js
var require_axios = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/lib/axios.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var bind = require_bind();
    var Axios = require_Axios();
    var mergeConfig = require_mergeConfig();
    var defaults = require_defaults();
    function createInstance(defaultConfig4) {
      var context = new Axios(defaultConfig4);
      var instance2 = bind(Axios.prototype.request, context);
      utils.extend(instance2, Axios.prototype, context);
      utils.extend(instance2, context);
      instance2.create = function create(instanceConfig) {
        return createInstance(mergeConfig(defaultConfig4, instanceConfig));
      };
      return instance2;
    }
    var axios5 = createInstance(defaults);
    axios5.Axios = Axios;
    axios5.Cancel = require_Cancel();
    axios5.CancelToken = require_CancelToken();
    axios5.isCancel = require_isCancel();
    axios5.VERSION = require_data().version;
    axios5.all = function all(promises) {
      return Promise.all(promises);
    };
    axios5.spread = require_spread();
    axios5.isAxiosError = require_isAxiosError();
    module.exports = axios5;
    module.exports.default = axios5;
  }
});

// node_modules/@aws-amplify/storage/node_modules/axios/index.js
var require_axios2 = __commonJS({
  "node_modules/@aws-amplify/storage/node_modules/axios/index.js"(exports, module) {
    module.exports = require_axios();
  }
});

// node_modules/events/events.js
var require_events = __commonJS({
  "node_modules/events/events.js"(exports, module) {
    "use strict";
    var R2 = typeof Reflect === "object" ? Reflect : null;
    var ReflectApply = R2 && typeof R2.apply === "function" ? R2.apply : function ReflectApply2(target, receiver, args) {
      return Function.prototype.apply.call(target, receiver, args);
    };
    var ReflectOwnKeys;
    if (R2 && typeof R2.ownKeys === "function") {
      ReflectOwnKeys = R2.ownKeys;
    } else if (Object.getOwnPropertySymbols) {
      ReflectOwnKeys = function ReflectOwnKeys2(target) {
        return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
      };
    } else {
      ReflectOwnKeys = function ReflectOwnKeys2(target) {
        return Object.getOwnPropertyNames(target);
      };
    }
    function ProcessEmitWarning(warning) {
      if (console && console.warn)
        console.warn(warning);
    }
    var NumberIsNaN = Number.isNaN || function NumberIsNaN2(value) {
      return value !== value;
    };
    function EventEmitter3() {
      EventEmitter3.init.call(this);
    }
    module.exports = EventEmitter3;
    module.exports.once = once;
    EventEmitter3.EventEmitter = EventEmitter3;
    EventEmitter3.prototype._events = void 0;
    EventEmitter3.prototype._eventsCount = 0;
    EventEmitter3.prototype._maxListeners = void 0;
    var defaultMaxListeners = 10;
    function checkListener(listener2) {
      if (typeof listener2 !== "function") {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener2);
      }
    }
    Object.defineProperty(EventEmitter3, "defaultMaxListeners", {
      enumerable: true,
      get: function() {
        return defaultMaxListeners;
      },
      set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) {
          throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        }
        defaultMaxListeners = arg;
      }
    });
    EventEmitter3.init = function() {
      if (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) {
        this._events = /* @__PURE__ */ Object.create(null);
        this._eventsCount = 0;
      }
      this._maxListeners = this._maxListeners || void 0;
    };
    EventEmitter3.prototype.setMaxListeners = function setMaxListeners(n2) {
      if (typeof n2 !== "number" || n2 < 0 || NumberIsNaN(n2)) {
        throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n2 + ".");
      }
      this._maxListeners = n2;
      return this;
    };
    function _getMaxListeners(that) {
      if (that._maxListeners === void 0)
        return EventEmitter3.defaultMaxListeners;
      return that._maxListeners;
    }
    EventEmitter3.prototype.getMaxListeners = function getMaxListeners() {
      return _getMaxListeners(this);
    };
    EventEmitter3.prototype.emit = function emit(type) {
      var args = [];
      for (var i2 = 1; i2 < arguments.length; i2++)
        args.push(arguments[i2]);
      var doError = type === "error";
      var events3 = this._events;
      if (events3 !== void 0)
        doError = doError && events3.error === void 0;
      else if (!doError)
        return false;
      if (doError) {
        var er;
        if (args.length > 0)
          er = args[0];
        if (er instanceof Error) {
          throw er;
        }
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err;
      }
      var handler = events3[type];
      if (handler === void 0)
        return false;
      if (typeof handler === "function") {
        ReflectApply(handler, this, args);
      } else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for (var i2 = 0; i2 < len; ++i2)
          ReflectApply(listeners[i2], this, args);
      }
      return true;
    };
    function _addListener(target, type, listener2, prepend) {
      var m2;
      var events3;
      var existing;
      checkListener(listener2);
      events3 = target._events;
      if (events3 === void 0) {
        events3 = target._events = /* @__PURE__ */ Object.create(null);
        target._eventsCount = 0;
      } else {
        if (events3.newListener !== void 0) {
          target.emit(
            "newListener",
            type,
            listener2.listener ? listener2.listener : listener2
          );
          events3 = target._events;
        }
        existing = events3[type];
      }
      if (existing === void 0) {
        existing = events3[type] = listener2;
        ++target._eventsCount;
      } else {
        if (typeof existing === "function") {
          existing = events3[type] = prepend ? [listener2, existing] : [existing, listener2];
        } else if (prepend) {
          existing.unshift(listener2);
        } else {
          existing.push(listener2);
        }
        m2 = _getMaxListeners(target);
        if (m2 > 0 && existing.length > m2 && !existing.warned) {
          existing.warned = true;
          var w2 = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners added. Use emitter.setMaxListeners() to increase limit");
          w2.name = "MaxListenersExceededWarning";
          w2.emitter = target;
          w2.type = type;
          w2.count = existing.length;
          ProcessEmitWarning(w2);
        }
      }
      return target;
    }
    EventEmitter3.prototype.addListener = function addListener(type, listener2) {
      return _addListener(this, type, listener2, false);
    };
    EventEmitter3.prototype.on = EventEmitter3.prototype.addListener;
    EventEmitter3.prototype.prependListener = function prependListener(type, listener2) {
      return _addListener(this, type, listener2, true);
    };
    function onceWrapper() {
      if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0)
          return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
      }
    }
    function _onceWrap(target, type, listener2) {
      var state = { fired: false, wrapFn: void 0, target, type, listener: listener2 };
      var wrapped = onceWrapper.bind(state);
      wrapped.listener = listener2;
      state.wrapFn = wrapped;
      return wrapped;
    }
    EventEmitter3.prototype.once = function once2(type, listener2) {
      checkListener(listener2);
      this.on(type, _onceWrap(this, type, listener2));
      return this;
    };
    EventEmitter3.prototype.prependOnceListener = function prependOnceListener(type, listener2) {
      checkListener(listener2);
      this.prependListener(type, _onceWrap(this, type, listener2));
      return this;
    };
    EventEmitter3.prototype.removeListener = function removeListener(type, listener2) {
      var list, events3, position, i2, originalListener;
      checkListener(listener2);
      events3 = this._events;
      if (events3 === void 0)
        return this;
      list = events3[type];
      if (list === void 0)
        return this;
      if (list === listener2 || list.listener === listener2) {
        if (--this._eventsCount === 0)
          this._events = /* @__PURE__ */ Object.create(null);
        else {
          delete events3[type];
          if (events3.removeListener)
            this.emit("removeListener", type, list.listener || listener2);
        }
      } else if (typeof list !== "function") {
        position = -1;
        for (i2 = list.length - 1; i2 >= 0; i2--) {
          if (list[i2] === listener2 || list[i2].listener === listener2) {
            originalListener = list[i2].listener;
            position = i2;
            break;
          }
        }
        if (position < 0)
          return this;
        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }
        if (list.length === 1)
          events3[type] = list[0];
        if (events3.removeListener !== void 0)
          this.emit("removeListener", type, originalListener || listener2);
      }
      return this;
    };
    EventEmitter3.prototype.off = EventEmitter3.prototype.removeListener;
    EventEmitter3.prototype.removeAllListeners = function removeAllListeners(type) {
      var listeners, events3, i2;
      events3 = this._events;
      if (events3 === void 0)
        return this;
      if (events3.removeListener === void 0) {
        if (arguments.length === 0) {
          this._events = /* @__PURE__ */ Object.create(null);
          this._eventsCount = 0;
        } else if (events3[type] !== void 0) {
          if (--this._eventsCount === 0)
            this._events = /* @__PURE__ */ Object.create(null);
          else
            delete events3[type];
        }
        return this;
      }
      if (arguments.length === 0) {
        var keys = Object.keys(events3);
        var key;
        for (i2 = 0; i2 < keys.length; ++i2) {
          key = keys[i2];
          if (key === "removeListener")
            continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = /* @__PURE__ */ Object.create(null);
        this._eventsCount = 0;
        return this;
      }
      listeners = events3[type];
      if (typeof listeners === "function") {
        this.removeListener(type, listeners);
      } else if (listeners !== void 0) {
        for (i2 = listeners.length - 1; i2 >= 0; i2--) {
          this.removeListener(type, listeners[i2]);
        }
      }
      return this;
    };
    function _listeners(target, type, unwrap2) {
      var events3 = target._events;
      if (events3 === void 0)
        return [];
      var evlistener = events3[type];
      if (evlistener === void 0)
        return [];
      if (typeof evlistener === "function")
        return unwrap2 ? [evlistener.listener || evlistener] : [evlistener];
      return unwrap2 ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
    }
    EventEmitter3.prototype.listeners = function listeners(type) {
      return _listeners(this, type, true);
    };
    EventEmitter3.prototype.rawListeners = function rawListeners(type) {
      return _listeners(this, type, false);
    };
    EventEmitter3.listenerCount = function(emitter, type) {
      if (typeof emitter.listenerCount === "function") {
        return emitter.listenerCount(type);
      } else {
        return listenerCount.call(emitter, type);
      }
    };
    EventEmitter3.prototype.listenerCount = listenerCount;
    function listenerCount(type) {
      var events3 = this._events;
      if (events3 !== void 0) {
        var evlistener = events3[type];
        if (typeof evlistener === "function") {
          return 1;
        } else if (evlistener !== void 0) {
          return evlistener.length;
        }
      }
      return 0;
    }
    EventEmitter3.prototype.eventNames = function eventNames() {
      return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
    };
    function arrayClone(arr, n2) {
      var copy = new Array(n2);
      for (var i2 = 0; i2 < n2; ++i2)
        copy[i2] = arr[i2];
      return copy;
    }
    function spliceOne(list, index) {
      for (; index + 1 < list.length; index++)
        list[index] = list[index + 1];
      list.pop();
    }
    function unwrapListeners(arr) {
      var ret = new Array(arr.length);
      for (var i2 = 0; i2 < ret.length; ++i2) {
        ret[i2] = arr[i2].listener || arr[i2];
      }
      return ret;
    }
    function once(emitter, name) {
      return new Promise(function(resolve, reject) {
        function errorListener(err) {
          emitter.removeListener(name, resolver);
          reject(err);
        }
        function resolver() {
          if (typeof emitter.removeListener === "function") {
            emitter.removeListener("error", errorListener);
          }
          resolve([].slice.call(arguments));
        }
        ;
        eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
        if (name !== "error") {
          addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
        }
      });
    }
    function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
      if (typeof emitter.on === "function") {
        eventTargetAgnosticAddListener(emitter, "error", handler, flags);
      }
    }
    function eventTargetAgnosticAddListener(emitter, name, listener2, flags) {
      if (typeof emitter.on === "function") {
        if (flags.once) {
          emitter.once(name, listener2);
        } else {
          emitter.on(name, listener2);
        }
      } else if (typeof emitter.addEventListener === "function") {
        emitter.addEventListener(name, function wrapListener(arg) {
          if (flags.once) {
            emitter.removeEventListener(name, wrapListener);
          }
          listener2(arg);
        });
      } else {
        throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
      }
    }
  }
});

// node_modules/@aws-amplify/pubsub/node_modules/uuid/lib/rng-browser.js
var require_rng_browser3 = __commonJS({
  "node_modules/@aws-amplify/pubsub/node_modules/uuid/lib/rng-browser.js"(exports, module) {
    var getRandomValues2 = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
    if (getRandomValues2) {
      rnds82 = new Uint8Array(16);
      module.exports = function whatwgRNG() {
        getRandomValues2(rnds82);
        return rnds82;
      };
    } else {
      rnds = new Array(16);
      module.exports = function mathRNG() {
        for (var i2 = 0, r2; i2 < 16; i2++) {
          if ((i2 & 3) === 0)
            r2 = Math.random() * 4294967296;
          rnds[i2] = r2 >>> ((i2 & 3) << 3) & 255;
        }
        return rnds;
      };
    }
    var rnds82;
    var rnds;
  }
});

// node_modules/@aws-amplify/pubsub/node_modules/uuid/lib/bytesToUuid.js
var require_bytesToUuid3 = __commonJS({
  "node_modules/@aws-amplify/pubsub/node_modules/uuid/lib/bytesToUuid.js"(exports, module) {
    var byteToHex2 = [];
    for (i2 = 0; i2 < 256; ++i2) {
      byteToHex2[i2] = (i2 + 256).toString(16).substr(1);
    }
    var i2;
    function bytesToUuid(buf, offset) {
      var i3 = offset || 0;
      var bth = byteToHex2;
      return [
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        "-",
        bth[buf[i3++]],
        bth[buf[i3++]],
        "-",
        bth[buf[i3++]],
        bth[buf[i3++]],
        "-",
        bth[buf[i3++]],
        bth[buf[i3++]],
        "-",
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]]
      ].join("");
    }
    module.exports = bytesToUuid;
  }
});

// node_modules/@aws-amplify/pubsub/node_modules/uuid/v1.js
var require_v13 = __commonJS({
  "node_modules/@aws-amplify/pubsub/node_modules/uuid/v1.js"(exports, module) {
    var rng2 = require_rng_browser3();
    var bytesToUuid = require_bytesToUuid3();
    var _nodeId;
    var _clockseq;
    var _lastMSecs = 0;
    var _lastNSecs = 0;
    function v1(options, buf, offset) {
      var i2 = buf && offset || 0;
      var b2 = buf || [];
      options = options || {};
      var node = options.node || _nodeId;
      var clockseq = options.clockseq !== void 0 ? options.clockseq : _clockseq;
      if (node == null || clockseq == null) {
        var seedBytes = rng2();
        if (node == null) {
          node = _nodeId = [
            seedBytes[0] | 1,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
          ];
        }
        if (clockseq == null) {
          clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 16383;
        }
      }
      var msecs = options.msecs !== void 0 ? options.msecs : (/* @__PURE__ */ new Date()).getTime();
      var nsecs = options.nsecs !== void 0 ? options.nsecs : _lastNSecs + 1;
      var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 1e4;
      if (dt < 0 && options.clockseq === void 0) {
        clockseq = clockseq + 1 & 16383;
      }
      if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === void 0) {
        nsecs = 0;
      }
      if (nsecs >= 1e4) {
        throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
      }
      _lastMSecs = msecs;
      _lastNSecs = nsecs;
      _clockseq = clockseq;
      msecs += 122192928e5;
      var tl = ((msecs & 268435455) * 1e4 + nsecs) % 4294967296;
      b2[i2++] = tl >>> 24 & 255;
      b2[i2++] = tl >>> 16 & 255;
      b2[i2++] = tl >>> 8 & 255;
      b2[i2++] = tl & 255;
      var tmh = msecs / 4294967296 * 1e4 & 268435455;
      b2[i2++] = tmh >>> 8 & 255;
      b2[i2++] = tmh & 255;
      b2[i2++] = tmh >>> 24 & 15 | 16;
      b2[i2++] = tmh >>> 16 & 255;
      b2[i2++] = clockseq >>> 8 | 128;
      b2[i2++] = clockseq & 255;
      for (var n2 = 0; n2 < 6; ++n2) {
        b2[i2 + n2] = node[n2];
      }
      return buf ? buf : bytesToUuid(b2);
    }
    module.exports = v1;
  }
});

// node_modules/@aws-amplify/pubsub/node_modules/uuid/v4.js
var require_v43 = __commonJS({
  "node_modules/@aws-amplify/pubsub/node_modules/uuid/v4.js"(exports, module) {
    var rng2 = require_rng_browser3();
    var bytesToUuid = require_bytesToUuid3();
    function v43(options, buf, offset) {
      var i2 = buf && offset || 0;
      if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
      }
      options = options || {};
      var rnds = options.random || (options.rng || rng2)();
      rnds[6] = rnds[6] & 15 | 64;
      rnds[8] = rnds[8] & 63 | 128;
      if (buf) {
        for (var ii2 = 0; ii2 < 16; ++ii2) {
          buf[i2 + ii2] = rnds[ii2];
        }
      }
      return buf || bytesToUuid(rnds);
    }
    module.exports = v43;
  }
});

// node_modules/@aws-amplify/pubsub/node_modules/uuid/index.js
var require_uuid3 = __commonJS({
  "node_modules/@aws-amplify/pubsub/node_modules/uuid/index.js"(exports, module) {
    var v1 = require_v13();
    var v43 = require_v43();
    var uuid6 = v43;
    uuid6.v1 = v1;
    uuid6.v4 = v43;
    module.exports = uuid6;
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/bind.js
var require_bind2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/bind.js"(exports, module) {
    "use strict";
    module.exports = function bind(fn2, thisArg) {
      return function wrap3() {
        var args = new Array(arguments.length);
        for (var i2 = 0; i2 < args.length; i2++) {
          args[i2] = arguments[i2];
        }
        return fn2.apply(thisArg, args);
      };
    };
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/utils.js
var require_utils2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/utils.js"(exports, module) {
    "use strict";
    var bind = require_bind2();
    var toString = Object.prototype.toString;
    function isArray(val2) {
      return Array.isArray(val2);
    }
    function isUndefined(val2) {
      return typeof val2 === "undefined";
    }
    function isBuffer(val2) {
      return val2 !== null && !isUndefined(val2) && val2.constructor !== null && !isUndefined(val2.constructor) && typeof val2.constructor.isBuffer === "function" && val2.constructor.isBuffer(val2);
    }
    function isArrayBuffer6(val2) {
      return toString.call(val2) === "[object ArrayBuffer]";
    }
    function isFormData(val2) {
      return toString.call(val2) === "[object FormData]";
    }
    function isArrayBufferView(val2) {
      var result;
      if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
        result = ArrayBuffer.isView(val2);
      } else {
        result = val2 && val2.buffer && isArrayBuffer6(val2.buffer);
      }
      return result;
    }
    function isString(val2) {
      return typeof val2 === "string";
    }
    function isNumber2(val2) {
      return typeof val2 === "number";
    }
    function isObject(val2) {
      return val2 !== null && typeof val2 === "object";
    }
    function isPlainObject(val2) {
      if (toString.call(val2) !== "[object Object]") {
        return false;
      }
      var prototype = Object.getPrototypeOf(val2);
      return prototype === null || prototype === Object.prototype;
    }
    function isDate(val2) {
      return toString.call(val2) === "[object Date]";
    }
    function isFile2(val2) {
      return toString.call(val2) === "[object File]";
    }
    function isBlob3(val2) {
      return toString.call(val2) === "[object Blob]";
    }
    function isFunction(val2) {
      return toString.call(val2) === "[object Function]";
    }
    function isStream(val2) {
      return isObject(val2) && isFunction(val2.pipe);
    }
    function isURLSearchParams(val2) {
      return toString.call(val2) === "[object URLSearchParams]";
    }
    function trim(str) {
      return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    function isStandardBrowserEnv() {
      if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
        return false;
      }
      return typeof window !== "undefined" && typeof document !== "undefined";
    }
    function forEach(obj, fn2) {
      if (obj === null || typeof obj === "undefined") {
        return;
      }
      if (typeof obj !== "object") {
        obj = [obj];
      }
      if (isArray(obj)) {
        for (var i2 = 0, l2 = obj.length; i2 < l2; i2++) {
          fn2.call(null, obj[i2], i2, obj);
        }
      } else {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn2.call(null, obj[key], key, obj);
          }
        }
      }
    }
    function merge() {
      var result = {};
      function assignValue(val2, key) {
        if (isPlainObject(result[key]) && isPlainObject(val2)) {
          result[key] = merge(result[key], val2);
        } else if (isPlainObject(val2)) {
          result[key] = merge({}, val2);
        } else if (isArray(val2)) {
          result[key] = val2.slice();
        } else {
          result[key] = val2;
        }
      }
      for (var i2 = 0, l2 = arguments.length; i2 < l2; i2++) {
        forEach(arguments[i2], assignValue);
      }
      return result;
    }
    function extend(a2, b2, thisArg) {
      forEach(b2, function assignValue(val2, key) {
        if (thisArg && typeof val2 === "function") {
          a2[key] = bind(val2, thisArg);
        } else {
          a2[key] = val2;
        }
      });
      return a2;
    }
    function stripBOM(content) {
      if (content.charCodeAt(0) === 65279) {
        content = content.slice(1);
      }
      return content;
    }
    module.exports = {
      isArray,
      isArrayBuffer: isArrayBuffer6,
      isBuffer,
      isFormData,
      isArrayBufferView,
      isString,
      isNumber: isNumber2,
      isObject,
      isPlainObject,
      isUndefined,
      isDate,
      isFile: isFile2,
      isBlob: isBlob3,
      isFunction,
      isStream,
      isURLSearchParams,
      isStandardBrowserEnv,
      forEach,
      merge,
      extend,
      trim,
      stripBOM
    };
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/buildURL.js
var require_buildURL2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/buildURL.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    function encode(val2) {
      return encodeURIComponent(val2).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }
    module.exports = function buildURL(url2, params, paramsSerializer) {
      if (!params) {
        return url2;
      }
      var serializedParams;
      if (paramsSerializer) {
        serializedParams = paramsSerializer(params);
      } else if (utils.isURLSearchParams(params)) {
        serializedParams = params.toString();
      } else {
        var parts = [];
        utils.forEach(params, function serialize2(val2, key) {
          if (val2 === null || typeof val2 === "undefined") {
            return;
          }
          if (utils.isArray(val2)) {
            key = key + "[]";
          } else {
            val2 = [val2];
          }
          utils.forEach(val2, function parseValue2(v2) {
            if (utils.isDate(v2)) {
              v2 = v2.toISOString();
            } else if (utils.isObject(v2)) {
              v2 = JSON.stringify(v2);
            }
            parts.push(encode(key) + "=" + encode(v2));
          });
        });
        serializedParams = parts.join("&");
      }
      if (serializedParams) {
        var hashmarkIndex = url2.indexOf("#");
        if (hashmarkIndex !== -1) {
          url2 = url2.slice(0, hashmarkIndex);
        }
        url2 += (url2.indexOf("?") === -1 ? "?" : "&") + serializedParams;
      }
      return url2;
    };
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/core/InterceptorManager.js
var require_InterceptorManager2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/core/InterceptorManager.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    function InterceptorManager() {
      this.handlers = [];
    }
    InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
      this.handlers.push({
        fulfilled,
        rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
      });
      return this.handlers.length - 1;
    };
    InterceptorManager.prototype.eject = function eject(id) {
      if (this.handlers[id]) {
        this.handlers[id] = null;
      }
    };
    InterceptorManager.prototype.forEach = function forEach(fn2) {
      utils.forEach(this.handlers, function forEachHandler(h2) {
        if (h2 !== null) {
          fn2(h2);
        }
      });
    };
    module.exports = InterceptorManager;
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/normalizeHeaderName.js
var require_normalizeHeaderName2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/normalizeHeaderName.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    module.exports = function normalizeHeaderName(headers, normalizedName) {
      utils.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
          headers[normalizedName] = value;
          delete headers[name];
        }
      });
    };
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/core/enhanceError.js
var require_enhanceError2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/core/enhanceError.js"(exports, module) {
    "use strict";
    module.exports = function enhanceError(error, config, code, request, response) {
      error.config = config;
      if (code) {
        error.code = code;
      }
      error.request = request;
      error.response = response;
      error.isAxiosError = true;
      error.toJSON = function toJSON() {
        return {
          // Standard
          message: this.message,
          name: this.name,
          // Microsoft
          description: this.description,
          number: this.number,
          // Mozilla
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          // Axios
          config: this.config,
          code: this.code,
          status: this.response && this.response.status ? this.response.status : null
        };
      };
      return error;
    };
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/core/createError.js
var require_createError2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/core/createError.js"(exports, module) {
    "use strict";
    var enhanceError = require_enhanceError2();
    module.exports = function createError2(message, config, code, request, response) {
      var error = new Error(message);
      return enhanceError(error, config, code, request, response);
    };
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/core/settle.js
var require_settle2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/core/settle.js"(exports, module) {
    "use strict";
    var createError2 = require_createError2();
    module.exports = function settle(resolve, reject, response) {
      var validateStatus = response.config.validateStatus;
      if (!response.status || !validateStatus || validateStatus(response.status)) {
        resolve(response);
      } else {
        reject(createError2(
          "Request failed with status code " + response.status,
          response.config,
          null,
          response.request,
          response
        ));
      }
    };
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/cookies.js
var require_cookies2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/cookies.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    module.exports = utils.isStandardBrowserEnv() ? (
      // Standard browser envs support document.cookie
      function standardBrowserEnv() {
        return {
          write: function write(name, value, expires, path, domain, secure) {
            var cookie3 = [];
            cookie3.push(name + "=" + encodeURIComponent(value));
            if (utils.isNumber(expires)) {
              cookie3.push("expires=" + new Date(expires).toGMTString());
            }
            if (utils.isString(path)) {
              cookie3.push("path=" + path);
            }
            if (utils.isString(domain)) {
              cookie3.push("domain=" + domain);
            }
            if (secure === true) {
              cookie3.push("secure");
            }
            document.cookie = cookie3.join("; ");
          },
          read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
          },
          remove: function remove2(name) {
            this.write(name, "", Date.now() - 864e5);
          }
        };
      }()
    ) : (
      // Non standard browser env (web workers, react-native) lack needed support.
      function nonStandardBrowserEnv() {
        return {
          write: function write() {
          },
          read: function read() {
            return null;
          },
          remove: function remove2() {
          }
        };
      }()
    );
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/isAbsoluteURL.js
var require_isAbsoluteURL2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/isAbsoluteURL.js"(exports, module) {
    "use strict";
    module.exports = function isAbsoluteURL(url2) {
      return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url2);
    };
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/combineURLs.js
var require_combineURLs2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/combineURLs.js"(exports, module) {
    "use strict";
    module.exports = function combineURLs(baseURL, relativeURL) {
      return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
    };
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/core/buildFullPath.js
var require_buildFullPath2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/core/buildFullPath.js"(exports, module) {
    "use strict";
    var isAbsoluteURL = require_isAbsoluteURL2();
    var combineURLs = require_combineURLs2();
    module.exports = function buildFullPath(baseURL, requestedURL) {
      if (baseURL && !isAbsoluteURL(requestedURL)) {
        return combineURLs(baseURL, requestedURL);
      }
      return requestedURL;
    };
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/parseHeaders.js
var require_parseHeaders2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/parseHeaders.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    var ignoreDuplicateOf = [
      "age",
      "authorization",
      "content-length",
      "content-type",
      "etag",
      "expires",
      "from",
      "host",
      "if-modified-since",
      "if-unmodified-since",
      "last-modified",
      "location",
      "max-forwards",
      "proxy-authorization",
      "referer",
      "retry-after",
      "user-agent"
    ];
    module.exports = function parseHeaders(headers) {
      var parsed = {};
      var key;
      var val2;
      var i2;
      if (!headers) {
        return parsed;
      }
      utils.forEach(headers.split("\n"), function parser2(line) {
        i2 = line.indexOf(":");
        key = utils.trim(line.substr(0, i2)).toLowerCase();
        val2 = utils.trim(line.substr(i2 + 1));
        if (key) {
          if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
            return;
          }
          if (key === "set-cookie") {
            parsed[key] = (parsed[key] ? parsed[key] : []).concat([val2]);
          } else {
            parsed[key] = parsed[key] ? parsed[key] + ", " + val2 : val2;
          }
        }
      });
      return parsed;
    };
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/isURLSameOrigin.js
var require_isURLSameOrigin2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/isURLSameOrigin.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    module.exports = utils.isStandardBrowserEnv() ? (
      // Standard browser envs have full support of the APIs needed to test
      // whether the request URL is of the same origin as current location.
      function standardBrowserEnv() {
        var msie = /(msie|trident)/i.test(navigator.userAgent);
        var urlParsingNode = document.createElement("a");
        var originURL;
        function resolveURL(url2) {
          var href = url2;
          if (msie) {
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
          }
          urlParsingNode.setAttribute("href", href);
          return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
          };
        }
        originURL = resolveURL(window.location.href);
        return function isURLSameOrigin(requestURL) {
          var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
          return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
        };
      }()
    ) : (
      // Non standard browser envs (web workers, react-native) lack needed support.
      function nonStandardBrowserEnv() {
        return function isURLSameOrigin() {
          return true;
        };
      }()
    );
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/cancel/Cancel.js
var require_Cancel2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/cancel/Cancel.js"(exports, module) {
    "use strict";
    function Cancel(message) {
      this.message = message;
    }
    Cancel.prototype.toString = function toString() {
      return "Cancel" + (this.message ? ": " + this.message : "");
    };
    Cancel.prototype.__CANCEL__ = true;
    module.exports = Cancel;
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/adapters/xhr.js
var require_xhr2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/adapters/xhr.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    var settle = require_settle2();
    var cookies = require_cookies2();
    var buildURL = require_buildURL2();
    var buildFullPath = require_buildFullPath2();
    var parseHeaders = require_parseHeaders2();
    var isURLSameOrigin = require_isURLSameOrigin2();
    var createError2 = require_createError2();
    var defaults = require_defaults2();
    var Cancel = require_Cancel2();
    module.exports = function xhrAdapter(config) {
      return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
          if (config.cancelToken) {
            config.cancelToken.unsubscribe(onCanceled);
          }
          if (config.signal) {
            config.signal.removeEventListener("abort", onCanceled);
          }
        }
        if (utils.isFormData(requestData)) {
          delete requestHeaders["Content-Type"];
        }
        var request = new XMLHttpRequest();
        if (config.auth) {
          var username = config.auth.username || "";
          var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
          requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = buildFullPath(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
        request.timeout = config.timeout;
        function onloadend() {
          if (!request) {
            return;
          }
          var responseHeaders = "getAllResponseHeaders" in request ? parseHeaders(request.getAllResponseHeaders()) : null;
          var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
          var response = {
            data: responseData,
            status: request.status,
            statusText: request.statusText,
            headers: responseHeaders,
            config,
            request
          };
          settle(function _resolve(value) {
            resolve(value);
            done();
          }, function _reject(err) {
            reject(err);
            done();
          }, response);
          request = null;
        }
        if ("onloadend" in request) {
          request.onloadend = onloadend;
        } else {
          request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) {
              return;
            }
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
              return;
            }
            setTimeout(onloadend);
          };
        }
        request.onabort = function handleAbort() {
          if (!request) {
            return;
          }
          reject(createError2("Request aborted", config, "ECONNABORTED", request));
          request = null;
        };
        request.onerror = function handleError() {
          reject(createError2("Network Error", config, null, request));
          request = null;
        };
        request.ontimeout = function handleTimeout() {
          var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
          var transitional = config.transitional || defaults.transitional;
          if (config.timeoutErrorMessage) {
            timeoutErrorMessage = config.timeoutErrorMessage;
          }
          reject(createError2(
            timeoutErrorMessage,
            config,
            transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
            request
          ));
          request = null;
        };
        if (utils.isStandardBrowserEnv()) {
          var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;
          if (xsrfValue) {
            requestHeaders[config.xsrfHeaderName] = xsrfValue;
          }
        }
        if ("setRequestHeader" in request) {
          utils.forEach(requestHeaders, function setRequestHeader(val2, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
              delete requestHeaders[key];
            } else {
              request.setRequestHeader(key, val2);
            }
          });
        }
        if (!utils.isUndefined(config.withCredentials)) {
          request.withCredentials = !!config.withCredentials;
        }
        if (responseType && responseType !== "json") {
          request.responseType = config.responseType;
        }
        if (typeof config.onDownloadProgress === "function") {
          request.addEventListener("progress", config.onDownloadProgress);
        }
        if (typeof config.onUploadProgress === "function" && request.upload) {
          request.upload.addEventListener("progress", config.onUploadProgress);
        }
        if (config.cancelToken || config.signal) {
          onCanceled = function(cancel) {
            if (!request) {
              return;
            }
            reject(!cancel || cancel && cancel.type ? new Cancel("canceled") : cancel);
            request.abort();
            request = null;
          };
          config.cancelToken && config.cancelToken.subscribe(onCanceled);
          if (config.signal) {
            config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
          }
        }
        if (!requestData) {
          requestData = null;
        }
        request.send(requestData);
      });
    };
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/defaults.js
var require_defaults2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/defaults.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    var normalizeHeaderName = require_normalizeHeaderName2();
    var enhanceError = require_enhanceError2();
    var DEFAULT_CONTENT_TYPE = {
      "Content-Type": "application/x-www-form-urlencoded"
    };
    function setContentTypeIfUnset(headers, value) {
      if (!utils.isUndefined(headers) && utils.isUndefined(headers["Content-Type"])) {
        headers["Content-Type"] = value;
      }
    }
    function getDefaultAdapter2() {
      var adapter;
      if (typeof XMLHttpRequest !== "undefined") {
        adapter = require_xhr2();
      } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
        adapter = require_xhr2();
      }
      return adapter;
    }
    function stringifySafely(rawValue, parser2, encoder) {
      if (utils.isString(rawValue)) {
        try {
          (parser2 || JSON.parse)(rawValue);
          return utils.trim(rawValue);
        } catch (e) {
          if (e.name !== "SyntaxError") {
            throw e;
          }
        }
      }
      return (encoder || JSON.stringify)(rawValue);
    }
    var defaults = {
      transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
      },
      adapter: getDefaultAdapter2(),
      transformRequest: [function transformRequest(data, headers) {
        normalizeHeaderName(headers, "Accept");
        normalizeHeaderName(headers, "Content-Type");
        if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
          return data;
        }
        if (utils.isArrayBufferView(data)) {
          return data.buffer;
        }
        if (utils.isURLSearchParams(data)) {
          setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
          return data.toString();
        }
        if (utils.isObject(data) || headers && headers["Content-Type"] === "application/json") {
          setContentTypeIfUnset(headers, "application/json");
          return stringifySafely(data);
        }
        return data;
      }],
      transformResponse: [function transformResponse(data) {
        var transitional = this.transitional || defaults.transitional;
        var silentJSONParsing = transitional && transitional.silentJSONParsing;
        var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
        var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
        if (strictJSONParsing || forcedJSONParsing && utils.isString(data) && data.length) {
          try {
            return JSON.parse(data);
          } catch (e) {
            if (strictJSONParsing) {
              if (e.name === "SyntaxError") {
                throw enhanceError(e, this, "E_JSON_PARSE");
              }
              throw e;
            }
          }
        }
        return data;
      }],
      /**
       * A timeout in milliseconds to abort a request. If set to 0 (default) a
       * timeout is not created.
       */
      timeout: 0,
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
      maxContentLength: -1,
      maxBodyLength: -1,
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      },
      headers: {
        common: {
          "Accept": "application/json, text/plain, */*"
        }
      }
    };
    utils.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
      defaults.headers[method] = {};
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
    });
    module.exports = defaults;
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/core/transformData.js
var require_transformData2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/core/transformData.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    var defaults = require_defaults2();
    module.exports = function transformData(data, headers, fns) {
      var context = this || defaults;
      utils.forEach(fns, function transform(fn2) {
        data = fn2.call(context, data, headers);
      });
      return data;
    };
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/cancel/isCancel.js
var require_isCancel2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/cancel/isCancel.js"(exports, module) {
    "use strict";
    module.exports = function isCancel(value) {
      return !!(value && value.__CANCEL__);
    };
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/core/dispatchRequest.js
var require_dispatchRequest2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/core/dispatchRequest.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    var transformData = require_transformData2();
    var isCancel = require_isCancel2();
    var defaults = require_defaults2();
    var Cancel = require_Cancel2();
    function throwIfCancellationRequested(config) {
      if (config.cancelToken) {
        config.cancelToken.throwIfRequested();
      }
      if (config.signal && config.signal.aborted) {
        throw new Cancel("canceled");
      }
    }
    module.exports = function dispatchRequest(config) {
      throwIfCancellationRequested(config);
      config.headers = config.headers || {};
      config.data = transformData.call(
        config,
        config.data,
        config.headers,
        config.transformRequest
      );
      config.headers = utils.merge(
        config.headers.common || {},
        config.headers[config.method] || {},
        config.headers
      );
      utils.forEach(
        ["delete", "get", "head", "post", "put", "patch", "common"],
        function cleanHeaderConfig(method) {
          delete config.headers[method];
        }
      );
      var adapter = config.adapter || defaults.adapter;
      return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        response.data = transformData.call(
          config,
          response.data,
          response.headers,
          config.transformResponse
        );
        return response;
      }, function onAdapterRejection(reason) {
        if (!isCancel(reason)) {
          throwIfCancellationRequested(config);
          if (reason && reason.response) {
            reason.response.data = transformData.call(
              config,
              reason.response.data,
              reason.response.headers,
              config.transformResponse
            );
          }
        }
        return Promise.reject(reason);
      });
    };
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/core/mergeConfig.js
var require_mergeConfig2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/core/mergeConfig.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    module.exports = function mergeConfig(config1, config2) {
      config2 = config2 || {};
      var config = {};
      function getMergedValue(target, source) {
        if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
          return utils.merge(target, source);
        } else if (utils.isPlainObject(source)) {
          return utils.merge({}, source);
        } else if (utils.isArray(source)) {
          return source.slice();
        }
        return source;
      }
      function mergeDeepProperties(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function valueFromConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(void 0, config2[prop]);
        }
      }
      function defaultToConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(void 0, config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function mergeDirectKeys(prop) {
        if (prop in config2) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (prop in config1) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
      };
      utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        utils.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
      });
      return config;
    };
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/env/data.js
var require_data2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/env/data.js"(exports, module) {
    module.exports = {
      "version": "0.26.0"
    };
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/validator.js
var require_validator3 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/validator.js"(exports, module) {
    "use strict";
    var VERSION = require_data2().version;
    var validators = {};
    ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i2) {
      validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i2 < 1 ? "n " : " ") + type;
      };
    });
    var deprecatedWarnings = {};
    validators.transitional = function transitional(validator, version3, message) {
      function formatMessage(opt, desc) {
        return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
      }
      return function(value, opt, opts) {
        if (validator === false) {
          throw new Error(formatMessage(opt, " has been removed" + (version3 ? " in " + version3 : "")));
        }
        if (version3 && !deprecatedWarnings[opt]) {
          deprecatedWarnings[opt] = true;
          console.warn(
            formatMessage(
              opt,
              " has been deprecated since v" + version3 + " and will be removed in the near future"
            )
          );
        }
        return validator ? validator(value, opt, opts) : true;
      };
    };
    function assertOptions(options, schema2, allowUnknown) {
      if (typeof options !== "object") {
        throw new TypeError("options must be an object");
      }
      var keys = Object.keys(options);
      var i2 = keys.length;
      while (i2-- > 0) {
        var opt = keys[i2];
        var validator = schema2[opt];
        if (validator) {
          var value = options[opt];
          var result = value === void 0 || validator(value, opt, options);
          if (result !== true) {
            throw new TypeError("option " + opt + " must be " + result);
          }
          continue;
        }
        if (allowUnknown !== true) {
          throw Error("Unknown option " + opt);
        }
      }
    }
    module.exports = {
      assertOptions,
      validators
    };
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/core/Axios.js
var require_Axios2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/core/Axios.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    var buildURL = require_buildURL2();
    var InterceptorManager = require_InterceptorManager2();
    var dispatchRequest = require_dispatchRequest2();
    var mergeConfig = require_mergeConfig2();
    var validator = require_validator3();
    var validators = validator.validators;
    function Axios(instanceConfig) {
      this.defaults = instanceConfig;
      this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
      };
    }
    Axios.prototype.request = function request(configOrUrl, config) {
      if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
      } else {
        config = configOrUrl || {};
      }
      config = mergeConfig(this.defaults, config);
      if (config.method) {
        config.method = config.method.toLowerCase();
      } else if (this.defaults.method) {
        config.method = this.defaults.method.toLowerCase();
      } else {
        config.method = "get";
      }
      var transitional = config.transitional;
      if (transitional !== void 0) {
        validator.assertOptions(transitional, {
          silentJSONParsing: validators.transitional(validators.boolean),
          forcedJSONParsing: validators.transitional(validators.boolean),
          clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
      }
      var requestInterceptorChain = [];
      var synchronousRequestInterceptors = true;
      this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
          return;
        }
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
      });
      var responseInterceptorChain = [];
      this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
      });
      var promise;
      if (!synchronousRequestInterceptors) {
        var chain = [dispatchRequest, void 0];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while (chain.length) {
          promise = promise.then(chain.shift(), chain.shift());
        }
        return promise;
      }
      var newConfig = config;
      while (requestInterceptorChain.length) {
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
          newConfig = onFulfilled(newConfig);
        } catch (error) {
          onRejected(error);
          break;
        }
      }
      try {
        promise = dispatchRequest(newConfig);
      } catch (error) {
        return Promise.reject(error);
      }
      while (responseInterceptorChain.length) {
        promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
      }
      return promise;
    };
    Axios.prototype.getUri = function getUri(config) {
      config = mergeConfig(this.defaults, config);
      return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
    };
    utils.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
      Axios.prototype[method] = function(url2, config) {
        return this.request(mergeConfig(config || {}, {
          method,
          url: url2,
          data: (config || {}).data
        }));
      };
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      Axios.prototype[method] = function(url2, data, config) {
        return this.request(mergeConfig(config || {}, {
          method,
          url: url2,
          data
        }));
      };
    });
    module.exports = Axios;
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/cancel/CancelToken.js
var require_CancelToken2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/cancel/CancelToken.js"(exports, module) {
    "use strict";
    var Cancel = require_Cancel2();
    function CancelToken(executor) {
      if (typeof executor !== "function") {
        throw new TypeError("executor must be a function.");
      }
      var resolvePromise;
      this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
      });
      var token = this;
      this.promise.then(function(cancel) {
        if (!token._listeners)
          return;
        var i2;
        var l2 = token._listeners.length;
        for (i2 = 0; i2 < l2; i2++) {
          token._listeners[i2](cancel);
        }
        token._listeners = null;
      });
      this.promise.then = function(onfulfilled) {
        var _resolve;
        var promise = new Promise(function(resolve) {
          token.subscribe(resolve);
          _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
          token.unsubscribe(_resolve);
        };
        return promise;
      };
      executor(function cancel(message) {
        if (token.reason) {
          return;
        }
        token.reason = new Cancel(message);
        resolvePromise(token.reason);
      });
    }
    CancelToken.prototype.throwIfRequested = function throwIfRequested() {
      if (this.reason) {
        throw this.reason;
      }
    };
    CancelToken.prototype.subscribe = function subscribe(listener2) {
      if (this.reason) {
        listener2(this.reason);
        return;
      }
      if (this._listeners) {
        this._listeners.push(listener2);
      } else {
        this._listeners = [listener2];
      }
    };
    CancelToken.prototype.unsubscribe = function unsubscribe(listener2) {
      if (!this._listeners) {
        return;
      }
      var index = this._listeners.indexOf(listener2);
      if (index !== -1) {
        this._listeners.splice(index, 1);
      }
    };
    CancelToken.source = function source() {
      var cancel;
      var token = new CancelToken(function executor(c2) {
        cancel = c2;
      });
      return {
        token,
        cancel
      };
    };
    module.exports = CancelToken;
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/spread.js
var require_spread2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/spread.js"(exports, module) {
    "use strict";
    module.exports = function spread(callback) {
      return function wrap3(arr) {
        return callback.apply(null, arr);
      };
    };
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/isAxiosError.js
var require_isAxiosError2 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/helpers/isAxiosError.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    module.exports = function isAxiosError(payload) {
      return utils.isObject(payload) && payload.isAxiosError === true;
    };
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/lib/axios.js
var require_axios3 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/lib/axios.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    var bind = require_bind2();
    var Axios = require_Axios2();
    var mergeConfig = require_mergeConfig2();
    var defaults = require_defaults2();
    function createInstance(defaultConfig4) {
      var context = new Axios(defaultConfig4);
      var instance2 = bind(Axios.prototype.request, context);
      utils.extend(instance2, Axios.prototype, context);
      utils.extend(instance2, context);
      instance2.create = function create(instanceConfig) {
        return createInstance(mergeConfig(defaultConfig4, instanceConfig));
      };
      return instance2;
    }
    var axios5 = createInstance(defaults);
    axios5.Axios = Axios;
    axios5.Cancel = require_Cancel2();
    axios5.CancelToken = require_CancelToken2();
    axios5.isCancel = require_isCancel2();
    axios5.VERSION = require_data2().version;
    axios5.all = function all(promises) {
      return Promise.all(promises);
    };
    axios5.spread = require_spread2();
    axios5.isAxiosError = require_isAxiosError2();
    module.exports = axios5;
    module.exports.default = axios5;
  }
});

// node_modules/@aws-amplify/api-rest/node_modules/axios/index.js
var require_axios4 = __commonJS({
  "node_modules/@aws-amplify/api-rest/node_modules/axios/index.js"(exports, module) {
    module.exports = require_axios3();
  }
});

// node_modules/@aws-amplify/datastore/node_modules/uuid/lib/rng-browser.js
var require_rng_browser4 = __commonJS({
  "node_modules/@aws-amplify/datastore/node_modules/uuid/lib/rng-browser.js"(exports, module) {
    var getRandomValues2 = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
    if (getRandomValues2) {
      rnds82 = new Uint8Array(16);
      module.exports = function whatwgRNG() {
        getRandomValues2(rnds82);
        return rnds82;
      };
    } else {
      rnds = new Array(16);
      module.exports = function mathRNG() {
        for (var i2 = 0, r2; i2 < 16; i2++) {
          if ((i2 & 3) === 0)
            r2 = Math.random() * 4294967296;
          rnds[i2] = r2 >>> ((i2 & 3) << 3) & 255;
        }
        return rnds;
      };
    }
    var rnds82;
    var rnds;
  }
});

// node_modules/@aws-amplify/datastore/node_modules/uuid/lib/bytesToUuid.js
var require_bytesToUuid4 = __commonJS({
  "node_modules/@aws-amplify/datastore/node_modules/uuid/lib/bytesToUuid.js"(exports, module) {
    var byteToHex2 = [];
    for (i2 = 0; i2 < 256; ++i2) {
      byteToHex2[i2] = (i2 + 256).toString(16).substr(1);
    }
    var i2;
    function bytesToUuid(buf, offset) {
      var i3 = offset || 0;
      var bth = byteToHex2;
      return [
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        "-",
        bth[buf[i3++]],
        bth[buf[i3++]],
        "-",
        bth[buf[i3++]],
        bth[buf[i3++]],
        "-",
        bth[buf[i3++]],
        bth[buf[i3++]],
        "-",
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]]
      ].join("");
    }
    module.exports = bytesToUuid;
  }
});

// node_modules/@aws-amplify/datastore/node_modules/uuid/v1.js
var require_v14 = __commonJS({
  "node_modules/@aws-amplify/datastore/node_modules/uuid/v1.js"(exports, module) {
    var rng2 = require_rng_browser4();
    var bytesToUuid = require_bytesToUuid4();
    var _nodeId;
    var _clockseq;
    var _lastMSecs = 0;
    var _lastNSecs = 0;
    function v1(options, buf, offset) {
      var i2 = buf && offset || 0;
      var b2 = buf || [];
      options = options || {};
      var node = options.node || _nodeId;
      var clockseq = options.clockseq !== void 0 ? options.clockseq : _clockseq;
      if (node == null || clockseq == null) {
        var seedBytes = rng2();
        if (node == null) {
          node = _nodeId = [
            seedBytes[0] | 1,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
          ];
        }
        if (clockseq == null) {
          clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 16383;
        }
      }
      var msecs = options.msecs !== void 0 ? options.msecs : (/* @__PURE__ */ new Date()).getTime();
      var nsecs = options.nsecs !== void 0 ? options.nsecs : _lastNSecs + 1;
      var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 1e4;
      if (dt < 0 && options.clockseq === void 0) {
        clockseq = clockseq + 1 & 16383;
      }
      if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === void 0) {
        nsecs = 0;
      }
      if (nsecs >= 1e4) {
        throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
      }
      _lastMSecs = msecs;
      _lastNSecs = nsecs;
      _clockseq = clockseq;
      msecs += 122192928e5;
      var tl = ((msecs & 268435455) * 1e4 + nsecs) % 4294967296;
      b2[i2++] = tl >>> 24 & 255;
      b2[i2++] = tl >>> 16 & 255;
      b2[i2++] = tl >>> 8 & 255;
      b2[i2++] = tl & 255;
      var tmh = msecs / 4294967296 * 1e4 & 268435455;
      b2[i2++] = tmh >>> 8 & 255;
      b2[i2++] = tmh & 255;
      b2[i2++] = tmh >>> 24 & 15 | 16;
      b2[i2++] = tmh >>> 16 & 255;
      b2[i2++] = clockseq >>> 8 | 128;
      b2[i2++] = clockseq & 255;
      for (var n2 = 0; n2 < 6; ++n2) {
        b2[i2 + n2] = node[n2];
      }
      return buf ? buf : bytesToUuid(b2);
    }
    module.exports = v1;
  }
});

// node_modules/@aws-amplify/datastore/node_modules/uuid/v4.js
var require_v44 = __commonJS({
  "node_modules/@aws-amplify/datastore/node_modules/uuid/v4.js"(exports, module) {
    var rng2 = require_rng_browser4();
    var bytesToUuid = require_bytesToUuid4();
    function v43(options, buf, offset) {
      var i2 = buf && offset || 0;
      if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
      }
      options = options || {};
      var rnds = options.random || (options.rng || rng2)();
      rnds[6] = rnds[6] & 15 | 64;
      rnds[8] = rnds[8] & 63 | 128;
      if (buf) {
        for (var ii2 = 0; ii2 < 16; ++ii2) {
          buf[i2 + ii2] = rnds[ii2];
        }
      }
      return buf || bytesToUuid(rnds);
    }
    module.exports = v43;
  }
});

// node_modules/@aws-amplify/datastore/node_modules/uuid/index.js
var require_uuid4 = __commonJS({
  "node_modules/@aws-amplify/datastore/node_modules/uuid/index.js"(exports, module) {
    var v1 = require_v14();
    var v43 = require_v44();
    var uuid6 = v43;
    uuid6.v1 = v1;
    uuid6.v4 = v43;
    module.exports = uuid6;
  }
});

// node_modules/ulid/stubs/crypto.js
var require_crypto2 = __commonJS({
  "node_modules/ulid/stubs/crypto.js"() {
  }
});

// node_modules/zen-push/node_modules/zen-observable/zen-observable.js
var require_zen_observable2 = __commonJS({
  "node_modules/zen-push/node_modules/zen-observable/zen-observable.js"(exports, module) {
    "use strict";
    (function(fn2, name) {
      if (typeof exports !== "undefined") {
        fn2(exports, module);
      } else if (typeof self !== "undefined") {
        var e = name === "*" ? self : name ? self[name] = {} : {};
        fn2(e, { exports: e });
      }
    })(function(exports2, module2) {
      function hasSymbol2(name) {
        return typeof Symbol === "function" && Boolean(Symbol[name]);
      }
      function getSymbol(name) {
        return hasSymbol2(name) ? Symbol[name] : "@@" + name;
      }
      if (typeof Symbol === "function" && !Symbol.observable) {
        Symbol.observable = Symbol("observable");
      }
      function hostReportError(e) {
        setTimeout(function() {
          throw e;
        });
      }
      function getMethod2(obj, key) {
        var value = obj[key];
        if (value == null)
          return void 0;
        if (typeof value !== "function")
          throw new TypeError(value + " is not a function");
        return value;
      }
      function getSpecies(obj) {
        var ctor = obj.constructor;
        if (ctor !== void 0) {
          ctor = ctor[getSymbol("species")];
          if (ctor === null) {
            ctor = void 0;
          }
        }
        return ctor !== void 0 ? ctor : Observable2;
      }
      function addMethods(target, methods) {
        Object.keys(methods).forEach(function(k2) {
          var desc = Object.getOwnPropertyDescriptor(methods, k2);
          desc.enumerable = false;
          Object.defineProperty(target, k2, desc);
        });
      }
      function cleanupSubscription(subscription) {
        var cleanup = subscription._cleanup;
        if (!cleanup)
          return;
        subscription._cleanup = void 0;
        try {
          cleanup();
        } catch (e) {
          hostReportError(e);
        }
      }
      function subscriptionClosed(subscription) {
        return subscription._observer === void 0;
      }
      function closeSubscription(subscription) {
        if (subscriptionClosed(subscription))
          return;
        subscription._observer = void 0;
        cleanupSubscription(subscription);
      }
      function cleanupFromSubscription(subscription) {
        return function() {
          subscription.unsubscribe();
        };
      }
      function Subscription(observer, subscriber) {
        if (Object(observer) !== observer)
          throw new TypeError("Observer must be an object");
        this._cleanup = void 0;
        this._observer = observer;
        try {
          var start$0 = getMethod2(observer, "start");
          if (start$0)
            start$0.call(observer, this);
        } catch (e) {
          hostReportError(e);
        }
        if (subscriptionClosed(this))
          return;
        observer = new SubscriptionObserver(this);
        try {
          var cleanup$0 = subscriber.call(void 0, observer);
          if (cleanup$0 != null) {
            if (typeof cleanup$0.unsubscribe === "function")
              cleanup$0 = cleanupFromSubscription(cleanup$0);
            else if (typeof cleanup$0 !== "function")
              throw new TypeError(cleanup$0 + " is not a function");
            this._cleanup = cleanup$0;
          }
        } catch (e) {
          observer.error(e);
          return;
        }
        if (subscriptionClosed(this))
          cleanupSubscription(this);
      }
      addMethods(Subscription.prototype = {}, {
        get closed() {
          return subscriptionClosed(this);
        },
        unsubscribe: function() {
          closeSubscription(this);
        }
      });
      function SubscriptionObserver(subscription) {
        this._subscription = subscription;
      }
      addMethods(SubscriptionObserver.prototype = {}, {
        get closed() {
          return subscriptionClosed(this._subscription);
        },
        next: function(value) {
          var subscription = this._subscription;
          if (subscriptionClosed(subscription))
            return;
          var observer = subscription._observer;
          try {
            var m$0 = getMethod2(observer, "next");
            if (m$0)
              m$0.call(observer, value);
          } catch (e) {
            hostReportError(e);
          }
        },
        error: function(value) {
          var subscription = this._subscription;
          if (subscriptionClosed(subscription)) {
            hostReportError(value);
            return;
          }
          var observer = subscription._observer;
          subscription._observer = void 0;
          try {
            var m$1 = getMethod2(observer, "error");
            if (m$1)
              m$1.call(observer, value);
            else
              throw value;
          } catch (e) {
            hostReportError(e);
          }
          cleanupSubscription(subscription);
        },
        complete: function() {
          var subscription = this._subscription;
          if (subscriptionClosed(subscription))
            return;
          var observer = subscription._observer;
          subscription._observer = void 0;
          try {
            var m$2 = getMethod2(observer, "complete");
            if (m$2)
              m$2.call(observer);
          } catch (e) {
            hostReportError(e);
          }
          cleanupSubscription(subscription);
        }
      });
      function Observable2(subscriber) {
        if (!(this instanceof Observable2))
          throw new TypeError("Observable cannot be called as a function");
        if (typeof subscriber !== "function")
          throw new TypeError("Observable initializer must be a function");
        this._subscriber = subscriber;
      }
      addMethods(Observable2.prototype, {
        subscribe: function(observer) {
          for (var args = [], __$0 = 1; __$0 < arguments.length; ++__$0)
            args.push(arguments[__$0]);
          if (typeof observer === "function") {
            observer = {
              next: observer,
              error: args[0],
              complete: args[1]
            };
          } else if (typeof observer !== "object" || observer === null) {
            observer = {};
          }
          return new Subscription(observer, this._subscriber);
        },
        forEach: function(fn2) {
          var __this = this;
          return new Promise(function(resolve, reject) {
            if (typeof fn2 !== "function")
              return Promise.reject(new TypeError(fn2 + " is not a function"));
            __this.subscribe({
              _subscription: null,
              start: function(subscription) {
                if (Object(subscription) !== subscription)
                  throw new TypeError(subscription + " is not an object");
                this._subscription = subscription;
              },
              next: function(value) {
                var subscription = this._subscription;
                if (subscription.closed)
                  return;
                try {
                  fn2(value);
                } catch (err) {
                  reject(err);
                  subscription.unsubscribe();
                }
              },
              error: reject,
              complete: resolve
            });
          });
        },
        map: function(fn2) {
          var __this = this;
          if (typeof fn2 !== "function")
            throw new TypeError(fn2 + " is not a function");
          var C = getSpecies(this);
          return new C(function(observer) {
            return __this.subscribe({
              next: function(value) {
                if (observer.closed)
                  return;
                try {
                  value = fn2(value);
                } catch (e) {
                  return observer.error(e);
                }
                observer.next(value);
              },
              error: function(e) {
                observer.error(e);
              },
              complete: function() {
                observer.complete();
              }
            });
          });
        },
        filter: function(fn2) {
          var __this = this;
          if (typeof fn2 !== "function")
            throw new TypeError(fn2 + " is not a function");
          var C = getSpecies(this);
          return new C(function(observer) {
            return __this.subscribe({
              next: function(value) {
                if (observer.closed)
                  return;
                try {
                  if (!fn2(value))
                    return;
                } catch (e) {
                  return observer.error(e);
                }
                observer.next(value);
              },
              error: function(e) {
                observer.error(e);
              },
              complete: function() {
                observer.complete();
              }
            });
          });
        },
        reduce: function(fn2) {
          var __this = this;
          if (typeof fn2 !== "function")
            throw new TypeError(fn2 + " is not a function");
          var C = getSpecies(this);
          var hasSeed = arguments.length > 1;
          var hasValue = false;
          var seed = arguments[1];
          var acc = seed;
          return new C(function(observer) {
            return __this.subscribe({
              next: function(value) {
                if (observer.closed)
                  return;
                var first = !hasValue;
                hasValue = true;
                if (!first || hasSeed) {
                  try {
                    acc = fn2(acc, value);
                  } catch (e) {
                    return observer.error(e);
                  }
                } else {
                  acc = value;
                }
              },
              error: function(e) {
                observer.error(e);
              },
              complete: function() {
                if (!hasValue && !hasSeed) {
                  return observer.error(new TypeError("Cannot reduce an empty sequence"));
                }
                observer.next(acc);
                observer.complete();
              }
            });
          });
        }
      });
      Object.defineProperty(Observable2.prototype, getSymbol("observable"), {
        value: function() {
          return this;
        },
        writable: true,
        configurable: true
      });
      addMethods(Observable2, {
        from: function(x2) {
          var C = typeof this === "function" ? this : Observable2;
          if (x2 == null)
            throw new TypeError(x2 + " is not an object");
          var method = getMethod2(x2, getSymbol("observable"));
          if (method) {
            var observable$0 = method.call(x2);
            if (Object(observable$0) !== observable$0)
              throw new TypeError(observable$0 + " is not an object");
            if (observable$0.constructor === C)
              return observable$0;
            return new C(function(observer) {
              return observable$0.subscribe(observer);
            });
          }
          if (hasSymbol2("iterator") && (method = getMethod2(x2, getSymbol("iterator")))) {
            return new C(function(observer) {
              for (var __$0 = method.call(x2)[Symbol.iterator](), __$1; __$1 = __$0.next(), !__$1.done; ) {
                var item$0 = __$1.value;
                observer.next(item$0);
                if (observer.closed)
                  return;
              }
              observer.complete();
            });
          }
          if (Array.isArray(x2)) {
            return new C(function(observer) {
              for (var i$0 = 0; i$0 < x2.length; ++i$0) {
                observer.next(x2[i$0]);
                if (observer.closed)
                  return;
              }
              observer.complete();
            });
          }
          throw new TypeError(x2 + " is not observable");
        },
        of: function() {
          for (var items = [], __$0 = 0; __$0 < arguments.length; ++__$0)
            items.push(arguments[__$0]);
          var C = typeof this === "function" ? this : Observable2;
          return new C(function(observer) {
            for (var i$1 = 0; i$1 < items.length; ++i$1) {
              observer.next(items[i$1]);
              if (observer.closed)
                return;
            }
            observer.complete();
          });
        }
      });
      Object.defineProperty(Observable2, getSymbol("species"), {
        get: function() {
          return this;
        },
        configurable: true
      });
      Object.defineProperty(Observable2, "extensions", {
        value: {
          observableSymbol: getSymbol("observable"),
          setHostReportError: function(fn2) {
            hostReportError = fn2;
          }
        }
      });
      exports2.Observable = Observable2;
    }, "*");
  }
});

// node_modules/zen-push/node_modules/zen-observable/index.js
var require_zen_observable3 = __commonJS({
  "node_modules/zen-push/node_modules/zen-observable/index.js"(exports, module) {
    module.exports = require_zen_observable2().Observable;
  }
});

// node_modules/zen-push/index.js
var require_zen_push = __commonJS({
  "node_modules/zen-push/index.js"(exports, module) {
    "use strict";
    var Observable2 = require_zen_observable3();
    function addMethods(target, methods) {
      Object.keys(methods).forEach(function(k2) {
        var desc = Object.getOwnPropertyDescriptor(methods, k2);
        desc.enumerable = false;
        Object.defineProperty(target, k2, desc);
      });
    }
    function send(p2, message, value) {
      if (p2._observer) {
        sendMessage(p2._observer, message, value);
      } else if (p2._observers) {
        var list = [];
        p2._observers.forEach(function(to) {
          list.push(to);
        });
        list.forEach(function(to) {
          sendMessage(to, message, value);
        });
      }
    }
    function sendMessage(observer, message, value) {
      if (observer.closed) {
        return;
      }
      switch (message) {
        case "next":
          return observer.next(value);
        case "error":
          return observer.error(value);
        case "complete":
          return observer.complete(value);
      }
    }
    function hasObserver(p2) {
      return p2._observer || p2._observers && p2._observers.size > 0;
    }
    function addObserver(p2, observer) {
      if (p2._observers) {
        p2._observers.add(observer);
      } else if (!p2._observer) {
        p2._observer = observer;
      } else {
        p2._observers = /* @__PURE__ */ new Set();
        p2._observers.add(p2._observer);
        p2._observers.add(observer);
        p2._observer = null;
      }
    }
    function deleteObserver(p2, observer) {
      if (p2._observers) {
        p2._observers.delete(observer);
      } else if (p2._observer === observer) {
        p2._observer = null;
      }
    }
    function notifyStart(p2, opts) {
      !hasObserver(p2) && opts && opts.start && opts.start();
    }
    function notifyPause(p2, opts) {
      !hasObserver(p2) && opts && opts.pause && opts.pause();
    }
    function PushStream2(opts) {
      var p2 = this;
      this._observer = null;
      this._observers = null;
      this._observable = new Observable2(function(observer) {
        notifyStart(p2, opts);
        addObserver(p2, observer);
        return function() {
          deleteObserver(p2, observer);
          notifyPause(p2, opts);
        };
      });
    }
    addMethods(PushStream2.prototype, {
      get observable() {
        return this._observable;
      },
      get observed() {
        return hasObserver(this);
      },
      next: function(x2) {
        send(this, "next", x2);
      },
      error: function(e) {
        send(this, "error", e);
      },
      complete: function(x2) {
        send(this, "complete", x2);
      }
    });
    module.exports = PushStream2;
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-browser/node_modules/tslib/tslib.js
var require_tslib25 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-browser/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-browser/build/isEmptyData.js
var require_isEmptyData15 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-browser/build/isEmptyData.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isEmptyData = void 0;
    function isEmptyData2(data) {
      if (typeof data === "string") {
        return data.length === 0;
      }
      return data.byteLength === 0;
    }
    exports.isEmptyData = isEmptyData2;
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-browser/build/constants.js
var require_constants14 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-browser/build/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
    exports.SHA_256_HASH = { name: "SHA-256" };
    exports.SHA_256_HMAC_ALGO = {
      name: "HMAC",
      hash: exports.SHA_256_HASH
    };
    exports.EMPTY_DATA_SHA_256 = new Uint8Array([
      227,
      176,
      196,
      66,
      152,
      252,
      28,
      20,
      154,
      251,
      244,
      200,
      153,
      111,
      185,
      36,
      39,
      174,
      65,
      228,
      100,
      155,
      147,
      76,
      164,
      149,
      153,
      27,
      120,
      82,
      184,
      85
    ]);
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/util-utf8-browser/dist-es/pureJs.js
var fromUtf825, toUtf823;
var init_pureJs7 = __esm({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/util-utf8-browser/dist-es/pureJs.js"() {
    fromUtf825 = function(input) {
      var bytes = [];
      for (var i2 = 0, len = input.length; i2 < len; i2++) {
        var value = input.charCodeAt(i2);
        if (value < 128) {
          bytes.push(value);
        } else if (value < 2048) {
          bytes.push(value >> 6 | 192, value & 63 | 128);
        } else if (i2 + 1 < input.length && (value & 64512) === 55296 && (input.charCodeAt(i2 + 1) & 64512) === 56320) {
          var surrogatePair = 65536 + ((value & 1023) << 10) + (input.charCodeAt(++i2) & 1023);
          bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else {
          bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
        }
      }
      return Uint8Array.from(bytes);
    };
    toUtf823 = function(input) {
      var decoded = "";
      for (var i2 = 0, len = input.length; i2 < len; i2++) {
        var byte = input[i2];
        if (byte < 128) {
          decoded += String.fromCharCode(byte);
        } else if (192 <= byte && byte < 224) {
          var nextByte = input[++i2];
          decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
          var surrogatePair = [byte, input[++i2], input[++i2], input[++i2]];
          var encoded = "%" + surrogatePair.map(function(byteValue) {
            return byteValue.toString(16);
          }).join("%");
          decoded += decodeURIComponent(encoded);
        } else {
          decoded += String.fromCharCode((byte & 15) << 12 | (input[++i2] & 63) << 6 | input[++i2] & 63);
        }
      }
      return decoded;
    };
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/util-utf8-browser/dist-es/whatwgEncodingApi.js
function fromUtf826(input) {
  return new TextEncoder().encode(input);
}
function toUtf824(input) {
  return new TextDecoder("utf-8").decode(input);
}
var init_whatwgEncodingApi7 = __esm({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/util-utf8-browser/dist-es/whatwgEncodingApi.js"() {
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/util-utf8-browser/dist-es/index.js
var dist_es_exports3 = {};
__export(dist_es_exports3, {
  fromUtf8: () => fromUtf827,
  toUtf8: () => toUtf825
});
var fromUtf827, toUtf825;
var init_dist_es3 = __esm({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/util-utf8-browser/dist-es/index.js"() {
    init_pureJs7();
    init_whatwgEncodingApi7();
    fromUtf827 = function(input) {
      return typeof TextEncoder === "function" ? fromUtf826(input) : fromUtf825(input);
    };
    toUtf825 = function(input) {
      return typeof TextDecoder === "function" ? toUtf824(input) : toUtf823(input);
    };
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-browser/build/ie11Sha256.js
var require_ie11Sha2566 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-browser/build/ie11Sha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var isEmptyData_1 = require_isEmptyData15();
    var constants_1 = require_constants14();
    var util_utf8_browser_1 = (init_dist_es3(), __toCommonJS(dist_es_exports3));
    var util_locate_window_1 = (init_dist_es2(), __toCommonJS(dist_es_exports2));
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          if (secret) {
            this.operation = getKeyPromise(secret).then(function(keyData) {
              return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {
            });
          } else {
            this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
          }
        }
        Sha25613.prototype.update = function(toHash) {
          var _this = this;
          if ((0, isEmptyData_1.isEmptyData)(toHash)) {
            return;
          }
          this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
              _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
          });
          this.operation.catch(function() {
          });
        };
        Sha25613.prototype.digest = function() {
          return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
              operation.onerror = function() {
                reject(new Error("Error encountered finalizing hash"));
              };
              operation.oncomplete = function() {
                if (operation.result) {
                  resolve(new Uint8Array(operation.result));
                }
                reject(new Error("Error encountered finalizing hash"));
              };
              operation.finish();
            });
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
    function getKeyPromise(secret) {
      return new Promise(function(resolve, reject) {
        var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, ["sign"]);
        keyOperation.oncomplete = function() {
          if (keyOperation.result) {
            resolve(keyOperation.result);
          }
          reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
          reject(new Error("ImportKey failed to import key."));
        };
      });
    }
    function toArrayBufferView(data) {
      if (typeof data === "string") {
        return (0, util_utf8_browser_1.fromUtf8)(data);
      }
      if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
      }
      return new Uint8Array(data);
    }
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/util/build/convertToBuffer.js
var require_convertToBuffer10 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/util/build/convertToBuffer.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.convertToBuffer = void 0;
    var util_utf8_browser_1 = (init_dist_es3(), __toCommonJS(dist_es_exports3));
    var fromUtf831 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
      return Buffer.from(input, "utf8");
    } : util_utf8_browser_1.fromUtf8;
    function convertToBuffer2(data) {
      if (data instanceof Uint8Array)
        return data;
      if (typeof data === "string") {
        return fromUtf831(data);
      }
      if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
      }
      return new Uint8Array(data);
    }
    exports.convertToBuffer = convertToBuffer2;
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/util/build/isEmptyData.js
var require_isEmptyData16 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/util/build/isEmptyData.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isEmptyData = void 0;
    function isEmptyData2(data) {
      if (typeof data === "string") {
        return data.length === 0;
      }
      return data.byteLength === 0;
    }
    exports.isEmptyData = isEmptyData2;
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/util/build/numToUint8.js
var require_numToUint810 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/util/build/numToUint8.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.numToUint8 = void 0;
    function numToUint8(num) {
      return new Uint8Array([
        (num & 4278190080) >> 24,
        (num & 16711680) >> 16,
        (num & 65280) >> 8,
        num & 255
      ]);
    }
    exports.numToUint8 = numToUint8;
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/util/build/uint32ArrayFrom.js
var require_uint32ArrayFrom10 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/util/build/uint32ArrayFrom.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = void 0;
    function uint32ArrayFrom(a_lookUpTable) {
      if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while (a_index < a_lookUpTable.length) {
          return_array[a_index] = a_lookUpTable[a_index];
          a_index += 1;
        }
        return return_array;
      }
      return Uint32Array.from(a_lookUpTable);
    }
    exports.uint32ArrayFrom = uint32ArrayFrom;
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/util/build/index.js
var require_build34 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/util/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
    var convertToBuffer_1 = require_convertToBuffer10();
    Object.defineProperty(exports, "convertToBuffer", { enumerable: true, get: function() {
      return convertToBuffer_1.convertToBuffer;
    } });
    var isEmptyData_1 = require_isEmptyData16();
    Object.defineProperty(exports, "isEmptyData", { enumerable: true, get: function() {
      return isEmptyData_1.isEmptyData;
    } });
    var numToUint8_1 = require_numToUint810();
    Object.defineProperty(exports, "numToUint8", { enumerable: true, get: function() {
      return numToUint8_1.numToUint8;
    } });
    var uint32ArrayFrom_1 = require_uint32ArrayFrom10();
    Object.defineProperty(exports, "uint32ArrayFrom", { enumerable: true, get: function() {
      return uint32ArrayFrom_1.uint32ArrayFrom;
    } });
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-browser/build/webCryptoSha256.js
var require_webCryptoSha2566 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-browser/build/webCryptoSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var util_1 = require_build34();
    var constants_1 = require_constants14();
    var util_locate_window_1 = (init_dist_es2(), __toCommonJS(dist_es_exports2));
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          this.toHash = new Uint8Array(0);
          if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
              (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(secret), constants_1.SHA_256_HMAC_ALGO, false, ["sign"]).then(resolve, reject);
            });
            this.key.catch(function() {
            });
          }
        }
        Sha25613.prototype.update = function(data) {
          if ((0, util_1.isEmptyData)(data)) {
            return;
          }
          var update = (0, util_1.convertToBuffer)(data);
          var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
          typedArray.set(this.toHash, 0);
          typedArray.set(update, this.toHash.byteLength);
          this.toHash = typedArray;
        };
        Sha25613.prototype.digest = function() {
          var _this = this;
          if (this.key) {
            return this.key.then(function(key) {
              return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
              });
            });
          }
          if ((0, util_1.isEmptyData)(this.toHash)) {
            return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
          }
          return Promise.resolve().then(function() {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
          }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-js/node_modules/tslib/tslib.js
var require_tslib26 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-js/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-js/build/constants.js
var require_constants15 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-js/build/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
    exports.BLOCK_SIZE = 64;
    exports.DIGEST_LENGTH = 32;
    exports.KEY = new Uint32Array([
      1116352408,
      1899447441,
      3049323471,
      3921009573,
      961987163,
      1508970993,
      2453635748,
      2870763221,
      3624381080,
      310598401,
      607225278,
      1426881987,
      1925078388,
      2162078206,
      2614888103,
      3248222580,
      3835390401,
      4022224774,
      264347078,
      604807628,
      770255983,
      1249150122,
      1555081692,
      1996064986,
      2554220882,
      2821834349,
      2952996808,
      3210313671,
      3336571891,
      3584528711,
      113926993,
      338241895,
      666307205,
      773529912,
      1294757372,
      1396182291,
      1695183700,
      1986661051,
      2177026350,
      2456956037,
      2730485921,
      2820302411,
      3259730800,
      3345764771,
      3516065817,
      3600352804,
      4094571909,
      275423344,
      430227734,
      506948616,
      659060556,
      883997877,
      958139571,
      1322822218,
      1537002063,
      1747873779,
      1955562222,
      2024104815,
      2227730452,
      2361852424,
      2428436474,
      2756734187,
      3204031479,
      3329325298
    ]);
    exports.INIT = [
      1779033703,
      3144134277,
      1013904242,
      2773480762,
      1359893119,
      2600822924,
      528734635,
      1541459225
    ];
    exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-js/build/RawSha256.js
var require_RawSha2569 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-js/build/RawSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.RawSha256 = void 0;
    var constants_1 = require_constants15();
    var RawSha256 = (
      /** @class */
      function() {
        function RawSha2562() {
          this.state = Int32Array.from(constants_1.INIT);
          this.temp = new Int32Array(64);
          this.buffer = new Uint8Array(64);
          this.bufferLength = 0;
          this.bytesHashed = 0;
          this.finished = false;
        }
        RawSha2562.prototype.update = function(data) {
          if (this.finished) {
            throw new Error("Attempted to update an already finished hash.");
          }
          var position = 0;
          var byteLength2 = data.byteLength;
          this.bytesHashed += byteLength2;
          if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) {
            throw new Error("Cannot hash more than 2^53 - 1 bits");
          }
          while (byteLength2 > 0) {
            this.buffer[this.bufferLength++] = data[position++];
            byteLength2--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
              this.hashBuffer();
              this.bufferLength = 0;
            }
          }
        };
        RawSha2562.prototype.digest = function() {
          if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 128);
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
              for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE; i2++) {
                bufferView.setUint8(i2, 0);
              }
              this.hashBuffer();
              this.bufferLength = 0;
            }
            for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE - 8; i2++) {
              bufferView.setUint8(i2, 0);
            }
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 4294967296), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
          }
          var out = new Uint8Array(constants_1.DIGEST_LENGTH);
          for (var i2 = 0; i2 < 8; i2++) {
            out[i2 * 4] = this.state[i2] >>> 24 & 255;
            out[i2 * 4 + 1] = this.state[i2] >>> 16 & 255;
            out[i2 * 4 + 2] = this.state[i2] >>> 8 & 255;
            out[i2 * 4 + 3] = this.state[i2] >>> 0 & 255;
          }
          return out;
        };
        RawSha2562.prototype.hashBuffer = function() {
          var _a2 = this, buffer = _a2.buffer, state = _a2.state;
          var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
          for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
            if (i2 < 16) {
              this.temp[i2] = (buffer[i2 * 4] & 255) << 24 | (buffer[i2 * 4 + 1] & 255) << 16 | (buffer[i2 * 4 + 2] & 255) << 8 | buffer[i2 * 4 + 3] & 255;
            } else {
              var u2 = this.temp[i2 - 2];
              var t1_1 = (u2 >>> 17 | u2 << 15) ^ (u2 >>> 19 | u2 << 13) ^ u2 >>> 10;
              u2 = this.temp[i2 - 15];
              var t2_1 = (u2 >>> 7 | u2 << 25) ^ (u2 >>> 18 | u2 << 14) ^ u2 >>> 3;
              this.temp[i2] = (t1_1 + this.temp[i2 - 7] | 0) + (t2_1 + this.temp[i2 - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i2] + this.temp[i2] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
          }
          state[0] += state0;
          state[1] += state1;
          state[2] += state2;
          state[3] += state3;
          state[4] += state4;
          state[5] += state5;
          state[6] += state6;
          state[7] += state7;
        };
        return RawSha2562;
      }()
    );
    exports.RawSha256 = RawSha256;
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-js/build/jsSha256.js
var require_jsSha2569 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-js/build/jsSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var tslib_1 = require_tslib26();
    var constants_1 = require_constants15();
    var RawSha256_1 = require_RawSha2569();
    var util_1 = require_build34();
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          this.hash = new RawSha256_1.RawSha256();
          if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
              inner[i2] ^= 54;
              outer[i2] ^= 92;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            for (var i2 = 0; i2 < inner.byteLength; i2++) {
              inner[i2] = 0;
            }
          }
        }
        Sha25613.prototype.update = function(toHash) {
          if ((0, util_1.isEmptyData)(toHash) || this.error) {
            return;
          }
          try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
          } catch (e) {
            this.error = e;
          }
        };
        Sha25613.prototype.digestSync = function() {
          if (this.error) {
            throw this.error;
          }
          if (this.outer) {
            if (!this.outer.finished) {
              this.outer.update(this.hash.digest());
            }
            return this.outer.digest();
          }
          return this.hash.digest();
        };
        Sha25613.prototype.digest = function() {
          return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a2) {
              return [2, this.digestSync()];
            });
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
    function bufferFromSecret(secret) {
      var input = (0, util_1.convertToBuffer)(secret);
      if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
      }
      var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
      buffer.set(input);
      return buffer;
    }
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-js/build/index.js
var require_build35 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-js/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib26();
    (0, tslib_1.__exportStar)(require_jsSha2569(), exports);
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/supports-web-crypto/node_modules/tslib/tslib.js
var require_tslib27 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/supports-web-crypto/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/supports-web-crypto/build/supportsWebCrypto.js
var require_supportsWebCrypto6 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/supports-web-crypto/build/supportsWebCrypto.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
    var tslib_1 = require_tslib27();
    var subtleCryptoMethods = [
      "decrypt",
      "digest",
      "encrypt",
      "exportKey",
      "generateKey",
      "importKey",
      "sign",
      "verify"
    ];
    function supportsWebCrypto(window2) {
      if (supportsSecureRandom(window2) && typeof window2.crypto.subtle === "object") {
        var subtle = window2.crypto.subtle;
        return supportsSubtleCrypto(subtle);
      }
      return false;
    }
    exports.supportsWebCrypto = supportsWebCrypto;
    function supportsSecureRandom(window2) {
      if (typeof window2 === "object" && typeof window2.crypto === "object") {
        var getRandomValues2 = window2.crypto.getRandomValues;
        return typeof getRandomValues2 === "function";
      }
      return false;
    }
    exports.supportsSecureRandom = supportsSecureRandom;
    function supportsSubtleCrypto(subtle) {
      return subtle && subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
      });
    }
    exports.supportsSubtleCrypto = supportsSubtleCrypto;
    function supportsZeroByteGCM(subtle) {
      return tslib_1.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a2;
        return tslib_1.__generator(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              if (!supportsSubtleCrypto(subtle))
                return [2, false];
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 4, , 5]);
              return [4, subtle.generateKey({ name: "AES-GCM", length: 128 }, false, ["encrypt"])];
            case 2:
              key = _b2.sent();
              return [4, subtle.encrypt({
                name: "AES-GCM",
                iv: new Uint8Array(Array(12)),
                additionalData: new Uint8Array(Array(16)),
                tagLength: 128
              }, key, new Uint8Array(0))];
            case 3:
              zeroByteAuthTag = _b2.sent();
              return [2, zeroByteAuthTag.byteLength === 16];
            case 4:
              _a2 = _b2.sent();
              return [2, false];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }
    exports.supportsZeroByteGCM = supportsZeroByteGCM;
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/supports-web-crypto/build/index.js
var require_build36 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/supports-web-crypto/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib27();
    tslib_1.__exportStar(require_supportsWebCrypto6(), exports);
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/ie11-detection/node_modules/tslib/tslib.js
var require_tslib28 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/ie11-detection/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/ie11-detection/build/CryptoOperation.js
var require_CryptoOperation6 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/ie11-detection/build/CryptoOperation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/ie11-detection/build/Key.js
var require_Key6 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/ie11-detection/build/Key.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/ie11-detection/build/KeyOperation.js
var require_KeyOperation6 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/ie11-detection/build/KeyOperation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/ie11-detection/build/MsSubtleCrypto.js
var require_MsSubtleCrypto6 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/ie11-detection/build/MsSubtleCrypto.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/ie11-detection/build/MsWindow.js
var require_MsWindow6 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/ie11-detection/build/MsWindow.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isMsWindow = void 0;
    var msSubtleCryptoMethods = [
      "decrypt",
      "digest",
      "encrypt",
      "exportKey",
      "generateKey",
      "importKey",
      "sign",
      "verify"
    ];
    function quacksLikeAnMsWindow(window2) {
      return "MSInputMethodContext" in window2 && "msCrypto" in window2;
    }
    function isMsWindow(window2) {
      if (quacksLikeAnMsWindow(window2) && window2.msCrypto.subtle !== void 0) {
        var _a2 = window2.msCrypto, getRandomValues2 = _a2.getRandomValues, subtle_1 = _a2.subtle;
        return msSubtleCryptoMethods.map(function(methodName) {
          return subtle_1[methodName];
        }).concat(getRandomValues2).every(function(method) {
          return typeof method === "function";
        });
      }
      return false;
    }
    exports.isMsWindow = isMsWindow;
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/ie11-detection/build/index.js
var require_build37 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/ie11-detection/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib28();
    tslib_1.__exportStar(require_CryptoOperation6(), exports);
    tslib_1.__exportStar(require_Key6(), exports);
    tslib_1.__exportStar(require_KeyOperation6(), exports);
    tslib_1.__exportStar(require_MsSubtleCrypto6(), exports);
    tslib_1.__exportStar(require_MsWindow6(), exports);
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-browser/build/crossPlatformSha256.js
var require_crossPlatformSha2566 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-browser/build/crossPlatformSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var ie11Sha256_1 = require_ie11Sha2566();
    var webCryptoSha256_1 = require_webCryptoSha2566();
    var sha256_js_1 = require_build35();
    var supports_web_crypto_1 = require_build36();
    var ie11_detection_1 = require_build37();
    var util_locate_window_1 = (init_dist_es2(), __toCommonJS(dist_es_exports2));
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) {
            this.hash = new webCryptoSha256_1.Sha256(secret);
          } else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) {
            this.hash = new ie11Sha256_1.Sha256(secret);
          } else {
            this.hash = new sha256_js_1.Sha256(secret);
          }
        }
        Sha25613.prototype.update = function(data, encoding) {
          this.hash.update(data, encoding);
        };
        Sha25613.prototype.digest = function() {
          return this.hash.digest();
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
  }
});

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-browser/build/index.js
var require_build38 = __commonJS({
  "node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-crypto/sha256-browser/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
    var tslib_1 = require_tslib25();
    (0, tslib_1.__exportStar)(require_crossPlatformSha2566(), exports);
    var ie11Sha256_1 = require_ie11Sha2566();
    Object.defineProperty(exports, "Ie11Sha256", { enumerable: true, get: function() {
      return ie11Sha256_1.Sha256;
    } });
    var webCryptoSha256_1 = require_webCryptoSha2566();
    Object.defineProperty(exports, "WebCryptoSha256", { enumerable: true, get: function() {
      return webCryptoSha256_1.Sha256;
    } });
  }
});

// node_modules/lodash/_isFlattenable.js
var require_isFlattenable = __commonJS({
  "node_modules/lodash/_isFlattenable.js"(exports, module) {
    var Symbol2 = require_Symbol();
    var isArguments = require_isArguments();
    var isArray = require_isArray();
    var spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : void 0;
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
    }
    module.exports = isFlattenable;
  }
});

// node_modules/lodash/_baseFlatten.js
var require_baseFlatten = __commonJS({
  "node_modules/lodash/_baseFlatten.js"(exports, module) {
    var arrayPush = require_arrayPush();
    var isFlattenable = require_isFlattenable();
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1, length = array.length;
      predicate || (predicate = isFlattenable);
      result || (result = []);
      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }
    module.exports = baseFlatten;
  }
});

// node_modules/lodash/flatten.js
var require_flatten = __commonJS({
  "node_modules/lodash/flatten.js"(exports, module) {
    var baseFlatten = require_baseFlatten();
    function flatten2(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }
    module.exports = flatten2;
  }
});

// node_modules/@aws-amplify/notifications/node_modules/uuid/lib/rng-browser.js
var require_rng_browser5 = __commonJS({
  "node_modules/@aws-amplify/notifications/node_modules/uuid/lib/rng-browser.js"(exports, module) {
    var getRandomValues2 = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
    if (getRandomValues2) {
      rnds82 = new Uint8Array(16);
      module.exports = function whatwgRNG() {
        getRandomValues2(rnds82);
        return rnds82;
      };
    } else {
      rnds = new Array(16);
      module.exports = function mathRNG() {
        for (var i2 = 0, r2; i2 < 16; i2++) {
          if ((i2 & 3) === 0)
            r2 = Math.random() * 4294967296;
          rnds[i2] = r2 >>> ((i2 & 3) << 3) & 255;
        }
        return rnds;
      };
    }
    var rnds82;
    var rnds;
  }
});

// node_modules/@aws-amplify/notifications/node_modules/uuid/lib/bytesToUuid.js
var require_bytesToUuid5 = __commonJS({
  "node_modules/@aws-amplify/notifications/node_modules/uuid/lib/bytesToUuid.js"(exports, module) {
    var byteToHex2 = [];
    for (i2 = 0; i2 < 256; ++i2) {
      byteToHex2[i2] = (i2 + 256).toString(16).substr(1);
    }
    var i2;
    function bytesToUuid(buf, offset) {
      var i3 = offset || 0;
      var bth = byteToHex2;
      return [
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        "-",
        bth[buf[i3++]],
        bth[buf[i3++]],
        "-",
        bth[buf[i3++]],
        bth[buf[i3++]],
        "-",
        bth[buf[i3++]],
        bth[buf[i3++]],
        "-",
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]],
        bth[buf[i3++]]
      ].join("");
    }
    module.exports = bytesToUuid;
  }
});

// node_modules/@aws-amplify/notifications/node_modules/uuid/v1.js
var require_v15 = __commonJS({
  "node_modules/@aws-amplify/notifications/node_modules/uuid/v1.js"(exports, module) {
    var rng2 = require_rng_browser5();
    var bytesToUuid = require_bytesToUuid5();
    var _nodeId;
    var _clockseq;
    var _lastMSecs = 0;
    var _lastNSecs = 0;
    function v1(options, buf, offset) {
      var i2 = buf && offset || 0;
      var b2 = buf || [];
      options = options || {};
      var node = options.node || _nodeId;
      var clockseq = options.clockseq !== void 0 ? options.clockseq : _clockseq;
      if (node == null || clockseq == null) {
        var seedBytes = rng2();
        if (node == null) {
          node = _nodeId = [
            seedBytes[0] | 1,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
          ];
        }
        if (clockseq == null) {
          clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 16383;
        }
      }
      var msecs = options.msecs !== void 0 ? options.msecs : (/* @__PURE__ */ new Date()).getTime();
      var nsecs = options.nsecs !== void 0 ? options.nsecs : _lastNSecs + 1;
      var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 1e4;
      if (dt < 0 && options.clockseq === void 0) {
        clockseq = clockseq + 1 & 16383;
      }
      if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === void 0) {
        nsecs = 0;
      }
      if (nsecs >= 1e4) {
        throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
      }
      _lastMSecs = msecs;
      _lastNSecs = nsecs;
      _clockseq = clockseq;
      msecs += 122192928e5;
      var tl = ((msecs & 268435455) * 1e4 + nsecs) % 4294967296;
      b2[i2++] = tl >>> 24 & 255;
      b2[i2++] = tl >>> 16 & 255;
      b2[i2++] = tl >>> 8 & 255;
      b2[i2++] = tl & 255;
      var tmh = msecs / 4294967296 * 1e4 & 268435455;
      b2[i2++] = tmh >>> 8 & 255;
      b2[i2++] = tmh & 255;
      b2[i2++] = tmh >>> 24 & 15 | 16;
      b2[i2++] = tmh >>> 16 & 255;
      b2[i2++] = clockseq >>> 8 | 128;
      b2[i2++] = clockseq & 255;
      for (var n2 = 0; n2 < 6; ++n2) {
        b2[i2 + n2] = node[n2];
      }
      return buf ? buf : bytesToUuid(b2);
    }
    module.exports = v1;
  }
});

// node_modules/@aws-amplify/notifications/node_modules/uuid/v4.js
var require_v45 = __commonJS({
  "node_modules/@aws-amplify/notifications/node_modules/uuid/v4.js"(exports, module) {
    var rng2 = require_rng_browser5();
    var bytesToUuid = require_bytesToUuid5();
    function v43(options, buf, offset) {
      var i2 = buf && offset || 0;
      if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
      }
      options = options || {};
      var rnds = options.random || (options.rng || rng2)();
      rnds[6] = rnds[6] & 15 | 64;
      rnds[8] = rnds[8] & 63 | 128;
      if (buf) {
        for (var ii2 = 0; ii2 < 16; ++ii2) {
          buf[i2 + ii2] = rnds[ii2];
        }
      }
      return buf || bytesToUuid(rnds);
    }
    module.exports = v43;
  }
});

// node_modules/@aws-amplify/notifications/node_modules/uuid/index.js
var require_uuid5 = __commonJS({
  "node_modules/@aws-amplify/notifications/node_modules/uuid/index.js"(exports, module) {
    var v1 = require_v15();
    var v43 = require_v45();
    var uuid6 = v43;
    uuid6.v1 = v1;
    uuid6.v4 = v43;
    module.exports = uuid6;
  }
});

// node_modules/lodash/noop.js
var require_noop = __commonJS({
  "node_modules/lodash/noop.js"(exports, module) {
    function noop2() {
    }
    module.exports = noop2;
  }
});

// node_modules/map-obj/index.js
var require_map_obj = __commonJS({
  "node_modules/map-obj/index.js"(exports, module) {
    "use strict";
    var isObject = (value) => typeof value === "object" && value !== null;
    var mapObjectSkip = Symbol("skip");
    var isObjectCustom = (value) => isObject(value) && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
    var mapObject = (object, mapper, options, isSeen = /* @__PURE__ */ new WeakMap()) => {
      options = {
        deep: false,
        target: {},
        ...options
      };
      if (isSeen.has(object)) {
        return isSeen.get(object);
      }
      isSeen.set(object, options.target);
      const { target } = options;
      delete options.target;
      const mapArray = (array) => array.map((element) => isObjectCustom(element) ? mapObject(element, mapper, options, isSeen) : element);
      if (Array.isArray(object)) {
        return mapArray(object);
      }
      for (const [key, value] of Object.entries(object)) {
        const mapResult = mapper(key, value, object);
        if (mapResult === mapObjectSkip) {
          continue;
        }
        let [newKey, newValue, { shouldRecurse = true } = {}] = mapResult;
        if (newKey === "__proto__") {
          continue;
        }
        if (options.deep && shouldRecurse && isObjectCustom(newValue)) {
          newValue = Array.isArray(newValue) ? mapArray(newValue) : mapObject(newValue, mapper, options, isSeen);
        }
        target[newKey] = newValue;
      }
      return target;
    };
    module.exports = (object, mapper, options) => {
      if (!isObject(object)) {
        throw new TypeError(`Expected an object, got \`${object}\` (${typeof object})`);
      }
      return mapObject(object, mapper, options);
    };
    module.exports.mapObjectSkip = mapObjectSkip;
  }
});

// node_modules/quick-lru/index.js
var require_quick_lru = __commonJS({
  "node_modules/quick-lru/index.js"(exports, module) {
    "use strict";
    var QuickLRU = class {
      constructor(options = {}) {
        if (!(options.maxSize && options.maxSize > 0)) {
          throw new TypeError("`maxSize` must be a number greater than 0");
        }
        this.maxSize = options.maxSize;
        this.cache = /* @__PURE__ */ new Map();
        this.oldCache = /* @__PURE__ */ new Map();
        this._size = 0;
      }
      _set(key, value) {
        this.cache.set(key, value);
        this._size++;
        if (this._size >= this.maxSize) {
          this._size = 0;
          this.oldCache = this.cache;
          this.cache = /* @__PURE__ */ new Map();
        }
      }
      get(key) {
        if (this.cache.has(key)) {
          return this.cache.get(key);
        }
        if (this.oldCache.has(key)) {
          const value = this.oldCache.get(key);
          this.oldCache.delete(key);
          this._set(key, value);
          return value;
        }
      }
      set(key, value) {
        if (this.cache.has(key)) {
          this.cache.set(key, value);
        } else {
          this._set(key, value);
        }
        return this;
      }
      has(key) {
        return this.cache.has(key) || this.oldCache.has(key);
      }
      peek(key) {
        if (this.cache.has(key)) {
          return this.cache.get(key);
        }
        if (this.oldCache.has(key)) {
          return this.oldCache.get(key);
        }
      }
      delete(key) {
        const deleted = this.cache.delete(key);
        if (deleted) {
          this._size--;
        }
        return this.oldCache.delete(key) || deleted;
      }
      clear() {
        this.cache.clear();
        this.oldCache.clear();
        this._size = 0;
      }
      *keys() {
        for (const [key] of this) {
          yield key;
        }
      }
      *values() {
        for (const [, value] of this) {
          yield value;
        }
      }
      *[Symbol.iterator]() {
        for (const item of this.cache) {
          yield item;
        }
        for (const item of this.oldCache) {
          const [key] = item;
          if (!this.cache.has(key)) {
            yield item;
          }
        }
      }
      get size() {
        let oldCacheSize = 0;
        for (const key of this.oldCache.keys()) {
          if (!this.cache.has(key)) {
            oldCacheSize++;
          }
        }
        return this._size + oldCacheSize;
      }
    };
    module.exports = QuickLRU;
  }
});

// node_modules/camelcase-keys/index.js
var require_camelcase_keys = __commonJS({
  "node_modules/camelcase-keys/index.js"(exports, module) {
    "use strict";
    var mapObj = require_map_obj();
    var camelCase = require_camelcase();
    var QuickLru = require_quick_lru();
    var has = (array, key) => array.some((x2) => {
      if (typeof x2 === "string") {
        return x2 === key;
      }
      x2.lastIndex = 0;
      return x2.test(key);
    });
    var cache = new QuickLru({ maxSize: 1e5 });
    var isObject = (value) => typeof value === "object" && value !== null && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
    var camelCaseConvert = (input, options) => {
      if (!isObject(input)) {
        return input;
      }
      options = {
        deep: false,
        pascalCase: false,
        ...options
      };
      const { exclude, pascalCase, stopPaths, deep } = options;
      const stopPathsSet = new Set(stopPaths);
      const makeMapper = (parentPath) => (key, value) => {
        if (deep && isObject(value)) {
          const path = parentPath === void 0 ? key : `${parentPath}.${key}`;
          if (!stopPathsSet.has(path)) {
            value = mapObj(value, makeMapper(path));
          }
        }
        if (!(exclude && has(exclude, key))) {
          const cacheKey = pascalCase ? `${key}_` : key;
          if (cache.has(cacheKey)) {
            key = cache.get(cacheKey);
          } else {
            const ret = camelCase(key, { pascalCase });
            if (key.length < 100) {
              cache.set(cacheKey, ret);
            }
            key = ret;
          }
        }
        return [key, value];
      };
      return mapObj(input, makeMapper(void 0));
    };
    module.exports = (input, options) => {
      if (Array.isArray(input)) {
        return Object.keys(input).map((key) => camelCaseConvert(input[key], options));
      }
      return camelCaseConvert(input, options);
    };
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-browser/node_modules/tslib/tslib.js
var require_tslib29 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-browser/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-browser/build/isEmptyData.js
var require_isEmptyData17 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-browser/build/isEmptyData.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isEmptyData = void 0;
    function isEmptyData2(data) {
      if (typeof data === "string") {
        return data.length === 0;
      }
      return data.byteLength === 0;
    }
    exports.isEmptyData = isEmptyData2;
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-browser/build/constants.js
var require_constants16 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-browser/build/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
    exports.SHA_256_HASH = { name: "SHA-256" };
    exports.SHA_256_HMAC_ALGO = {
      name: "HMAC",
      hash: exports.SHA_256_HASH
    };
    exports.EMPTY_DATA_SHA_256 = new Uint8Array([
      227,
      176,
      196,
      66,
      152,
      252,
      28,
      20,
      154,
      251,
      244,
      200,
      153,
      111,
      185,
      36,
      39,
      174,
      65,
      228,
      100,
      155,
      147,
      76,
      164,
      149,
      153,
      27,
      120,
      82,
      184,
      85
    ]);
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/util-utf8-browser/dist-es/pureJs.js
var fromUtf828, toUtf826;
var init_pureJs8 = __esm({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/util-utf8-browser/dist-es/pureJs.js"() {
    fromUtf828 = function(input) {
      var bytes = [];
      for (var i2 = 0, len = input.length; i2 < len; i2++) {
        var value = input.charCodeAt(i2);
        if (value < 128) {
          bytes.push(value);
        } else if (value < 2048) {
          bytes.push(value >> 6 | 192, value & 63 | 128);
        } else if (i2 + 1 < input.length && (value & 64512) === 55296 && (input.charCodeAt(i2 + 1) & 64512) === 56320) {
          var surrogatePair = 65536 + ((value & 1023) << 10) + (input.charCodeAt(++i2) & 1023);
          bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else {
          bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
        }
      }
      return Uint8Array.from(bytes);
    };
    toUtf826 = function(input) {
      var decoded = "";
      for (var i2 = 0, len = input.length; i2 < len; i2++) {
        var byte = input[i2];
        if (byte < 128) {
          decoded += String.fromCharCode(byte);
        } else if (192 <= byte && byte < 224) {
          var nextByte = input[++i2];
          decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
          var surrogatePair = [byte, input[++i2], input[++i2], input[++i2]];
          var encoded = "%" + surrogatePair.map(function(byteValue) {
            return byteValue.toString(16);
          }).join("%");
          decoded += decodeURIComponent(encoded);
        } else {
          decoded += String.fromCharCode((byte & 15) << 12 | (input[++i2] & 63) << 6 | input[++i2] & 63);
        }
      }
      return decoded;
    };
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/util-utf8-browser/dist-es/whatwgEncodingApi.js
function fromUtf829(input) {
  return new TextEncoder().encode(input);
}
function toUtf827(input) {
  return new TextDecoder("utf-8").decode(input);
}
var init_whatwgEncodingApi8 = __esm({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/util-utf8-browser/dist-es/whatwgEncodingApi.js"() {
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/util-utf8-browser/dist-es/index.js
var dist_es_exports4 = {};
__export(dist_es_exports4, {
  fromUtf8: () => fromUtf830,
  toUtf8: () => toUtf828
});
var fromUtf830, toUtf828;
var init_dist_es4 = __esm({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/util-utf8-browser/dist-es/index.js"() {
    init_pureJs8();
    init_whatwgEncodingApi8();
    fromUtf830 = function(input) {
      return typeof TextEncoder === "function" ? fromUtf829(input) : fromUtf828(input);
    };
    toUtf828 = function(input) {
      return typeof TextDecoder === "function" ? toUtf827(input) : toUtf826(input);
    };
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-browser/build/ie11Sha256.js
var require_ie11Sha2567 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-browser/build/ie11Sha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var isEmptyData_1 = require_isEmptyData17();
    var constants_1 = require_constants16();
    var util_utf8_browser_1 = (init_dist_es4(), __toCommonJS(dist_es_exports4));
    var util_locate_window_1 = (init_dist_es2(), __toCommonJS(dist_es_exports2));
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          if (secret) {
            this.operation = getKeyPromise(secret).then(function(keyData) {
              return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {
            });
          } else {
            this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
          }
        }
        Sha25613.prototype.update = function(toHash) {
          var _this = this;
          if ((0, isEmptyData_1.isEmptyData)(toHash)) {
            return;
          }
          this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
              _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
          });
          this.operation.catch(function() {
          });
        };
        Sha25613.prototype.digest = function() {
          return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
              operation.onerror = function() {
                reject(new Error("Error encountered finalizing hash"));
              };
              operation.oncomplete = function() {
                if (operation.result) {
                  resolve(new Uint8Array(operation.result));
                }
                reject(new Error("Error encountered finalizing hash"));
              };
              operation.finish();
            });
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
    function getKeyPromise(secret) {
      return new Promise(function(resolve, reject) {
        var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, ["sign"]);
        keyOperation.oncomplete = function() {
          if (keyOperation.result) {
            resolve(keyOperation.result);
          }
          reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
          reject(new Error("ImportKey failed to import key."));
        };
      });
    }
    function toArrayBufferView(data) {
      if (typeof data === "string") {
        return (0, util_utf8_browser_1.fromUtf8)(data);
      }
      if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
      }
      return new Uint8Array(data);
    }
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/util/build/convertToBuffer.js
var require_convertToBuffer11 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/util/build/convertToBuffer.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.convertToBuffer = void 0;
    var util_utf8_browser_1 = (init_dist_es4(), __toCommonJS(dist_es_exports4));
    var fromUtf831 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
      return Buffer.from(input, "utf8");
    } : util_utf8_browser_1.fromUtf8;
    function convertToBuffer2(data) {
      if (data instanceof Uint8Array)
        return data;
      if (typeof data === "string") {
        return fromUtf831(data);
      }
      if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
      }
      return new Uint8Array(data);
    }
    exports.convertToBuffer = convertToBuffer2;
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/util/build/isEmptyData.js
var require_isEmptyData18 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/util/build/isEmptyData.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isEmptyData = void 0;
    function isEmptyData2(data) {
      if (typeof data === "string") {
        return data.length === 0;
      }
      return data.byteLength === 0;
    }
    exports.isEmptyData = isEmptyData2;
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/util/build/numToUint8.js
var require_numToUint811 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/util/build/numToUint8.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.numToUint8 = void 0;
    function numToUint8(num) {
      return new Uint8Array([
        (num & 4278190080) >> 24,
        (num & 16711680) >> 16,
        (num & 65280) >> 8,
        num & 255
      ]);
    }
    exports.numToUint8 = numToUint8;
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/util/build/uint32ArrayFrom.js
var require_uint32ArrayFrom11 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/util/build/uint32ArrayFrom.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = void 0;
    function uint32ArrayFrom(a_lookUpTable) {
      if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while (a_index < a_lookUpTable.length) {
          return_array[a_index] = a_lookUpTable[a_index];
          a_index += 1;
        }
        return return_array;
      }
      return Uint32Array.from(a_lookUpTable);
    }
    exports.uint32ArrayFrom = uint32ArrayFrom;
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/util/build/index.js
var require_build39 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/util/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
    var convertToBuffer_1 = require_convertToBuffer11();
    Object.defineProperty(exports, "convertToBuffer", { enumerable: true, get: function() {
      return convertToBuffer_1.convertToBuffer;
    } });
    var isEmptyData_1 = require_isEmptyData18();
    Object.defineProperty(exports, "isEmptyData", { enumerable: true, get: function() {
      return isEmptyData_1.isEmptyData;
    } });
    var numToUint8_1 = require_numToUint811();
    Object.defineProperty(exports, "numToUint8", { enumerable: true, get: function() {
      return numToUint8_1.numToUint8;
    } });
    var uint32ArrayFrom_1 = require_uint32ArrayFrom11();
    Object.defineProperty(exports, "uint32ArrayFrom", { enumerable: true, get: function() {
      return uint32ArrayFrom_1.uint32ArrayFrom;
    } });
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-browser/build/webCryptoSha256.js
var require_webCryptoSha2567 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-browser/build/webCryptoSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var util_1 = require_build39();
    var constants_1 = require_constants16();
    var util_locate_window_1 = (init_dist_es2(), __toCommonJS(dist_es_exports2));
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          this.toHash = new Uint8Array(0);
          if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
              (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(secret), constants_1.SHA_256_HMAC_ALGO, false, ["sign"]).then(resolve, reject);
            });
            this.key.catch(function() {
            });
          }
        }
        Sha25613.prototype.update = function(data) {
          if ((0, util_1.isEmptyData)(data)) {
            return;
          }
          var update = (0, util_1.convertToBuffer)(data);
          var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
          typedArray.set(this.toHash, 0);
          typedArray.set(update, this.toHash.byteLength);
          this.toHash = typedArray;
        };
        Sha25613.prototype.digest = function() {
          var _this = this;
          if (this.key) {
            return this.key.then(function(key) {
              return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
              });
            });
          }
          if ((0, util_1.isEmptyData)(this.toHash)) {
            return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
          }
          return Promise.resolve().then(function() {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
          }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-js/node_modules/tslib/tslib.js
var require_tslib30 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-js/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-js/build/constants.js
var require_constants17 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-js/build/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
    exports.BLOCK_SIZE = 64;
    exports.DIGEST_LENGTH = 32;
    exports.KEY = new Uint32Array([
      1116352408,
      1899447441,
      3049323471,
      3921009573,
      961987163,
      1508970993,
      2453635748,
      2870763221,
      3624381080,
      310598401,
      607225278,
      1426881987,
      1925078388,
      2162078206,
      2614888103,
      3248222580,
      3835390401,
      4022224774,
      264347078,
      604807628,
      770255983,
      1249150122,
      1555081692,
      1996064986,
      2554220882,
      2821834349,
      2952996808,
      3210313671,
      3336571891,
      3584528711,
      113926993,
      338241895,
      666307205,
      773529912,
      1294757372,
      1396182291,
      1695183700,
      1986661051,
      2177026350,
      2456956037,
      2730485921,
      2820302411,
      3259730800,
      3345764771,
      3516065817,
      3600352804,
      4094571909,
      275423344,
      430227734,
      506948616,
      659060556,
      883997877,
      958139571,
      1322822218,
      1537002063,
      1747873779,
      1955562222,
      2024104815,
      2227730452,
      2361852424,
      2428436474,
      2756734187,
      3204031479,
      3329325298
    ]);
    exports.INIT = [
      1779033703,
      3144134277,
      1013904242,
      2773480762,
      1359893119,
      2600822924,
      528734635,
      1541459225
    ];
    exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-js/build/RawSha256.js
var require_RawSha25610 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-js/build/RawSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.RawSha256 = void 0;
    var constants_1 = require_constants17();
    var RawSha256 = (
      /** @class */
      function() {
        function RawSha2562() {
          this.state = Int32Array.from(constants_1.INIT);
          this.temp = new Int32Array(64);
          this.buffer = new Uint8Array(64);
          this.bufferLength = 0;
          this.bytesHashed = 0;
          this.finished = false;
        }
        RawSha2562.prototype.update = function(data) {
          if (this.finished) {
            throw new Error("Attempted to update an already finished hash.");
          }
          var position = 0;
          var byteLength2 = data.byteLength;
          this.bytesHashed += byteLength2;
          if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) {
            throw new Error("Cannot hash more than 2^53 - 1 bits");
          }
          while (byteLength2 > 0) {
            this.buffer[this.bufferLength++] = data[position++];
            byteLength2--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
              this.hashBuffer();
              this.bufferLength = 0;
            }
          }
        };
        RawSha2562.prototype.digest = function() {
          if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 128);
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
              for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE; i2++) {
                bufferView.setUint8(i2, 0);
              }
              this.hashBuffer();
              this.bufferLength = 0;
            }
            for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE - 8; i2++) {
              bufferView.setUint8(i2, 0);
            }
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 4294967296), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
          }
          var out = new Uint8Array(constants_1.DIGEST_LENGTH);
          for (var i2 = 0; i2 < 8; i2++) {
            out[i2 * 4] = this.state[i2] >>> 24 & 255;
            out[i2 * 4 + 1] = this.state[i2] >>> 16 & 255;
            out[i2 * 4 + 2] = this.state[i2] >>> 8 & 255;
            out[i2 * 4 + 3] = this.state[i2] >>> 0 & 255;
          }
          return out;
        };
        RawSha2562.prototype.hashBuffer = function() {
          var _a2 = this, buffer = _a2.buffer, state = _a2.state;
          var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
          for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
            if (i2 < 16) {
              this.temp[i2] = (buffer[i2 * 4] & 255) << 24 | (buffer[i2 * 4 + 1] & 255) << 16 | (buffer[i2 * 4 + 2] & 255) << 8 | buffer[i2 * 4 + 3] & 255;
            } else {
              var u2 = this.temp[i2 - 2];
              var t1_1 = (u2 >>> 17 | u2 << 15) ^ (u2 >>> 19 | u2 << 13) ^ u2 >>> 10;
              u2 = this.temp[i2 - 15];
              var t2_1 = (u2 >>> 7 | u2 << 25) ^ (u2 >>> 18 | u2 << 14) ^ u2 >>> 3;
              this.temp[i2] = (t1_1 + this.temp[i2 - 7] | 0) + (t2_1 + this.temp[i2 - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i2] + this.temp[i2] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
          }
          state[0] += state0;
          state[1] += state1;
          state[2] += state2;
          state[3] += state3;
          state[4] += state4;
          state[5] += state5;
          state[6] += state6;
          state[7] += state7;
        };
        return RawSha2562;
      }()
    );
    exports.RawSha256 = RawSha256;
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-js/build/jsSha256.js
var require_jsSha25610 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-js/build/jsSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var tslib_1 = require_tslib30();
    var constants_1 = require_constants17();
    var RawSha256_1 = require_RawSha25610();
    var util_1 = require_build39();
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          this.hash = new RawSha256_1.RawSha256();
          if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
              inner[i2] ^= 54;
              outer[i2] ^= 92;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            for (var i2 = 0; i2 < inner.byteLength; i2++) {
              inner[i2] = 0;
            }
          }
        }
        Sha25613.prototype.update = function(toHash) {
          if ((0, util_1.isEmptyData)(toHash) || this.error) {
            return;
          }
          try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
          } catch (e) {
            this.error = e;
          }
        };
        Sha25613.prototype.digestSync = function() {
          if (this.error) {
            throw this.error;
          }
          if (this.outer) {
            if (!this.outer.finished) {
              this.outer.update(this.hash.digest());
            }
            return this.outer.digest();
          }
          return this.hash.digest();
        };
        Sha25613.prototype.digest = function() {
          return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a2) {
              return [2, this.digestSync()];
            });
          });
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
    function bufferFromSecret(secret) {
      var input = (0, util_1.convertToBuffer)(secret);
      if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
      }
      var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
      buffer.set(input);
      return buffer;
    }
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-js/build/index.js
var require_build40 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-js/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib30();
    (0, tslib_1.__exportStar)(require_jsSha25610(), exports);
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/supports-web-crypto/node_modules/tslib/tslib.js
var require_tslib31 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/supports-web-crypto/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/supports-web-crypto/build/supportsWebCrypto.js
var require_supportsWebCrypto7 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/supports-web-crypto/build/supportsWebCrypto.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
    var tslib_1 = require_tslib31();
    var subtleCryptoMethods = [
      "decrypt",
      "digest",
      "encrypt",
      "exportKey",
      "generateKey",
      "importKey",
      "sign",
      "verify"
    ];
    function supportsWebCrypto(window2) {
      if (supportsSecureRandom(window2) && typeof window2.crypto.subtle === "object") {
        var subtle = window2.crypto.subtle;
        return supportsSubtleCrypto(subtle);
      }
      return false;
    }
    exports.supportsWebCrypto = supportsWebCrypto;
    function supportsSecureRandom(window2) {
      if (typeof window2 === "object" && typeof window2.crypto === "object") {
        var getRandomValues2 = window2.crypto.getRandomValues;
        return typeof getRandomValues2 === "function";
      }
      return false;
    }
    exports.supportsSecureRandom = supportsSecureRandom;
    function supportsSubtleCrypto(subtle) {
      return subtle && subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
      });
    }
    exports.supportsSubtleCrypto = supportsSubtleCrypto;
    function supportsZeroByteGCM(subtle) {
      return tslib_1.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a2;
        return tslib_1.__generator(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              if (!supportsSubtleCrypto(subtle))
                return [2, false];
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 4, , 5]);
              return [4, subtle.generateKey({ name: "AES-GCM", length: 128 }, false, ["encrypt"])];
            case 2:
              key = _b2.sent();
              return [4, subtle.encrypt({
                name: "AES-GCM",
                iv: new Uint8Array(Array(12)),
                additionalData: new Uint8Array(Array(16)),
                tagLength: 128
              }, key, new Uint8Array(0))];
            case 3:
              zeroByteAuthTag = _b2.sent();
              return [2, zeroByteAuthTag.byteLength === 16];
            case 4:
              _a2 = _b2.sent();
              return [2, false];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }
    exports.supportsZeroByteGCM = supportsZeroByteGCM;
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/supports-web-crypto/build/index.js
var require_build41 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/supports-web-crypto/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib31();
    tslib_1.__exportStar(require_supportsWebCrypto7(), exports);
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/ie11-detection/node_modules/tslib/tslib.js
var require_tslib32 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/ie11-detection/node_modules/tslib/tslib.js"(exports, module) {
    var __extends12;
    var __assign47;
    var __rest13;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter70;
    var __generator71;
    var __exportStar;
    var __values16;
    var __read38;
    var __spread16;
    var __spreadArrays;
    var __await3;
    var __asyncGenerator3;
    var __asyncDelegator;
    var __asyncValues3;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory2) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory2(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module === "object" && typeof module.exports === "object") {
        factory2(createExporter(root, createExporter(module.exports)));
      } else {
        factory2(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends12 = function(d2, b2) {
        extendStatics10(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign47 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest13 = function(s2, e) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter70 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator71 = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e) {
              op = [6, e];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values16 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read38 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread16 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read38(arguments[i2]));
        return ar;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await3 = function(v2) {
        return this instanceof __await3 ? (this.v = v2, this) : new __await3(v2);
      };
      __asyncGenerator3 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e) {
            settle(q2[0][3], e);
          }
        }
        function step(r2) {
          r2.value instanceof __await3 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await3(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues3 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values16 === "function" ? __values16(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k2 in mod)
            if (Object.hasOwnProperty.call(mod, k2))
              result[k2] = mod[k2];
        }
        result["default"] = mod;
        return result;
      };
      __importDefault = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends12);
      exporter("__assign", __assign47);
      exporter("__rest", __rest13);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter70);
      exporter("__generator", __generator71);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values16);
      exporter("__read", __read38);
      exporter("__spread", __spread16);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await3);
      exporter("__asyncGenerator", __asyncGenerator3);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues3);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/ie11-detection/build/CryptoOperation.js
var require_CryptoOperation7 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/ie11-detection/build/CryptoOperation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/ie11-detection/build/Key.js
var require_Key7 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/ie11-detection/build/Key.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/ie11-detection/build/KeyOperation.js
var require_KeyOperation7 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/ie11-detection/build/KeyOperation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/ie11-detection/build/MsSubtleCrypto.js
var require_MsSubtleCrypto7 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/ie11-detection/build/MsSubtleCrypto.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/ie11-detection/build/MsWindow.js
var require_MsWindow7 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/ie11-detection/build/MsWindow.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isMsWindow = void 0;
    var msSubtleCryptoMethods = [
      "decrypt",
      "digest",
      "encrypt",
      "exportKey",
      "generateKey",
      "importKey",
      "sign",
      "verify"
    ];
    function quacksLikeAnMsWindow(window2) {
      return "MSInputMethodContext" in window2 && "msCrypto" in window2;
    }
    function isMsWindow(window2) {
      if (quacksLikeAnMsWindow(window2) && window2.msCrypto.subtle !== void 0) {
        var _a2 = window2.msCrypto, getRandomValues2 = _a2.getRandomValues, subtle_1 = _a2.subtle;
        return msSubtleCryptoMethods.map(function(methodName) {
          return subtle_1[methodName];
        }).concat(getRandomValues2).every(function(method) {
          return typeof method === "function";
        });
      }
      return false;
    }
    exports.isMsWindow = isMsWindow;
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/ie11-detection/build/index.js
var require_build42 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/ie11-detection/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var tslib_1 = require_tslib32();
    tslib_1.__exportStar(require_CryptoOperation7(), exports);
    tslib_1.__exportStar(require_Key7(), exports);
    tslib_1.__exportStar(require_KeyOperation7(), exports);
    tslib_1.__exportStar(require_MsSubtleCrypto7(), exports);
    tslib_1.__exportStar(require_MsWindow7(), exports);
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-browser/build/crossPlatformSha256.js
var require_crossPlatformSha2567 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-browser/build/crossPlatformSha256.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Sha256 = void 0;
    var ie11Sha256_1 = require_ie11Sha2567();
    var webCryptoSha256_1 = require_webCryptoSha2567();
    var sha256_js_1 = require_build40();
    var supports_web_crypto_1 = require_build41();
    var ie11_detection_1 = require_build42();
    var util_locate_window_1 = (init_dist_es2(), __toCommonJS(dist_es_exports2));
    var Sha25612 = (
      /** @class */
      function() {
        function Sha25613(secret) {
          if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) {
            this.hash = new webCryptoSha256_1.Sha256(secret);
          } else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) {
            this.hash = new ie11Sha256_1.Sha256(secret);
          } else {
            this.hash = new sha256_js_1.Sha256(secret);
          }
        }
        Sha25613.prototype.update = function(data, encoding) {
          this.hash.update(data, encoding);
        };
        Sha25613.prototype.digest = function() {
          return this.hash.digest();
        };
        return Sha25613;
      }()
    );
    exports.Sha256 = Sha25612;
  }
});

// node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-browser/build/index.js
var require_build43 = __commonJS({
  "node_modules/@aws-sdk/client-location/node_modules/@aws-crypto/sha256-browser/build/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
    var tslib_1 = require_tslib29();
    (0, tslib_1.__exportStar)(require_crossPlatformSha2567(), exports);
    var ie11Sha256_1 = require_ie11Sha2567();
    Object.defineProperty(exports, "Ie11Sha256", { enumerable: true, get: function() {
      return ie11Sha256_1.Sha256;
    } });
    var webCryptoSha256_1 = require_webCryptoSha2567();
    Object.defineProperty(exports, "WebCryptoSha256", { enumerable: true, get: function() {
      return webCryptoSha256_1.Sha256;
    } });
  }
});

// node_modules/@aws-amplify/core/lib-esm/Util/Constants.js
var AWS_CLOUDWATCH_BASE_BUFFER_SIZE = 26;
var AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE = 1048576;
var AWS_CLOUDWATCH_MAX_EVENT_SIZE = 256e3;
var AWS_CLOUDWATCH_CATEGORY = "Logging";
var AWS_CLOUDWATCH_PROVIDER_NAME = "AWSCloudWatch";
var NO_CREDS_ERROR_STRING = "No credentials";
var RETRY_ERROR_CODES = [
  "ResourceNotFoundException",
  "InvalidSequenceTokenException"
];

// node_modules/@aws-amplify/core/lib-esm/Logger/ConsoleLogger.js
var __values = function(o2) {
  var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
  if (m2)
    return m2.call(o2);
  if (o2 && typeof o2.length === "number")
    return {
      next: function() {
        if (o2 && i2 >= o2.length)
          o2 = void 0;
        return { value: o2 && o2[i2++], done: !o2 };
      }
    };
  throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = function(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var __spreadArray = function(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i2 = 0, l2 = from.length, ar; i2 < l2; i2++) {
      if (ar || !(i2 in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i2);
        ar[i2] = from[i2];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var LOG_LEVELS = {
  VERBOSE: 1,
  DEBUG: 2,
  INFO: 3,
  WARN: 4,
  ERROR: 5
};
var LOG_TYPE;
(function(LOG_TYPE2) {
  LOG_TYPE2["DEBUG"] = "DEBUG";
  LOG_TYPE2["ERROR"] = "ERROR";
  LOG_TYPE2["INFO"] = "INFO";
  LOG_TYPE2["WARN"] = "WARN";
  LOG_TYPE2["VERBOSE"] = "VERBOSE";
})(LOG_TYPE || (LOG_TYPE = {}));
var ConsoleLogger = (
  /** @class */
  function() {
    function ConsoleLogger2(name, level) {
      if (level === void 0) {
        level = LOG_TYPE.WARN;
      }
      this.name = name;
      this.level = level;
      this._pluggables = [];
    }
    ConsoleLogger2.prototype._padding = function(n2) {
      return n2 < 10 ? "0" + n2 : "" + n2;
    };
    ConsoleLogger2.prototype._ts = function() {
      var dt = /* @__PURE__ */ new Date();
      return [this._padding(dt.getMinutes()), this._padding(dt.getSeconds())].join(":") + "." + dt.getMilliseconds();
    };
    ConsoleLogger2.prototype.configure = function(config) {
      if (!config)
        return this._config;
      this._config = config;
      return this._config;
    };
    ConsoleLogger2.prototype._log = function(type) {
      var e_1, _a2;
      var msg = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        msg[_i - 1] = arguments[_i];
      }
      var logger_level_name = this.level;
      if (ConsoleLogger2.LOG_LEVEL) {
        logger_level_name = ConsoleLogger2.LOG_LEVEL;
      }
      if (typeof window !== "undefined" && window.LOG_LEVEL) {
        logger_level_name = window.LOG_LEVEL;
      }
      var logger_level = LOG_LEVELS[logger_level_name];
      var type_level = LOG_LEVELS[type];
      if (!(type_level >= logger_level)) {
        return;
      }
      var log = console.log.bind(console);
      if (type === LOG_TYPE.ERROR && console.error) {
        log = console.error.bind(console);
      }
      if (type === LOG_TYPE.WARN && console.warn) {
        log = console.warn.bind(console);
      }
      var prefix = "[".concat(type, "] ").concat(this._ts(), " ").concat(this.name);
      var message = "";
      if (msg.length === 1 && typeof msg[0] === "string") {
        message = "".concat(prefix, " - ").concat(msg[0]);
        log(message);
      } else if (msg.length === 1) {
        message = "".concat(prefix, " ").concat(msg[0]);
        log(prefix, msg[0]);
      } else if (typeof msg[0] === "string") {
        var obj = msg.slice(1);
        if (obj.length === 1) {
          obj = obj[0];
        }
        message = "".concat(prefix, " - ").concat(msg[0], " ").concat(obj);
        log("".concat(prefix, " - ").concat(msg[0]), obj);
      } else {
        message = "".concat(prefix, " ").concat(msg);
        log(prefix, msg);
      }
      try {
        for (var _b2 = __values(this._pluggables), _c = _b2.next(); !_c.done; _c = _b2.next()) {
          var plugin = _c.value;
          var logEvent = { message, timestamp: Date.now() };
          plugin.pushLogs([logEvent]);
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (_c && !_c.done && (_a2 = _b2.return))
            _a2.call(_b2);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
    };
    ConsoleLogger2.prototype.log = function() {
      var msg = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        msg[_i] = arguments[_i];
      }
      this._log.apply(this, __spreadArray([LOG_TYPE.INFO], __read(msg), false));
    };
    ConsoleLogger2.prototype.info = function() {
      var msg = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        msg[_i] = arguments[_i];
      }
      this._log.apply(this, __spreadArray([LOG_TYPE.INFO], __read(msg), false));
    };
    ConsoleLogger2.prototype.warn = function() {
      var msg = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        msg[_i] = arguments[_i];
      }
      this._log.apply(this, __spreadArray([LOG_TYPE.WARN], __read(msg), false));
    };
    ConsoleLogger2.prototype.error = function() {
      var msg = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        msg[_i] = arguments[_i];
      }
      this._log.apply(this, __spreadArray([LOG_TYPE.ERROR], __read(msg), false));
    };
    ConsoleLogger2.prototype.debug = function() {
      var msg = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        msg[_i] = arguments[_i];
      }
      this._log.apply(this, __spreadArray([LOG_TYPE.DEBUG], __read(msg), false));
    };
    ConsoleLogger2.prototype.verbose = function() {
      var msg = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        msg[_i] = arguments[_i];
      }
      this._log.apply(this, __spreadArray([LOG_TYPE.VERBOSE], __read(msg), false));
    };
    ConsoleLogger2.prototype.addPluggable = function(pluggable) {
      if (pluggable && pluggable.getCategoryName() === AWS_CLOUDWATCH_CATEGORY) {
        this._pluggables.push(pluggable);
        pluggable.configure(this._config);
      }
    };
    ConsoleLogger2.prototype.listPluggables = function() {
      return this._pluggables;
    };
    ConsoleLogger2.LOG_LEVEL = null;
    return ConsoleLogger2;
  }()
);

// node_modules/@aws-amplify/core/lib-esm/Amplify.js
var __read2 = function(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var logger = new ConsoleLogger("Amplify");
var AmplifyClass = (
  /** @class */
  function() {
    function AmplifyClass2() {
      this._components = [];
      this._config = {};
      this._modules = {};
      this.Auth = null;
      this.Analytics = null;
      this.API = null;
      this.Credentials = null;
      this.Storage = null;
      this.I18n = null;
      this.Cache = null;
      this.PubSub = null;
      this.Interactions = null;
      this.Pushnotification = null;
      this.UI = null;
      this.XR = null;
      this.Predictions = null;
      this.DataStore = null;
      this.Geo = null;
      this.Notifications = null;
      this.Logger = ConsoleLogger;
      this.ServiceWorker = null;
    }
    AmplifyClass2.prototype.register = function(comp) {
      logger.debug("component registered in amplify", comp);
      this._components.push(comp);
      if (typeof comp.getModuleName === "function") {
        this._modules[comp.getModuleName()] = comp;
        this[comp.getModuleName()] = comp;
      } else {
        logger.debug("no getModuleName method for component", comp);
      }
      comp.configure(this._config);
    };
    AmplifyClass2.prototype.configure = function(config) {
      var _this = this;
      if (!config)
        return this._config;
      this._config = Object.assign(this._config, config);
      logger.debug("amplify config", this._config);
      Object.entries(this._modules).forEach(function(_a2) {
        var _b2 = __read2(_a2, 2), Name2 = _b2[0], comp = _b2[1];
        Object.keys(comp).forEach(function(property) {
          if (_this._modules[property]) {
            comp[property] = _this._modules[property];
          }
        });
      });
      this._components.map(function(comp) {
        comp.configure(_this._config);
      });
      return this._config;
    };
    AmplifyClass2.prototype.addPluggable = function(pluggable) {
      if (pluggable && pluggable["getCategory"] && typeof pluggable["getCategory"] === "function") {
        this._components.map(function(comp) {
          if (comp["addPluggable"] && typeof comp["addPluggable"] === "function") {
            comp.addPluggable(pluggable);
          }
        });
      }
    };
    return AmplifyClass2;
  }()
);
var Amplify = new AmplifyClass();

// node_modules/@aws-amplify/core/lib-esm/Platform/types.js
var Framework;
(function(Framework2) {
  Framework2["WebUnknown"] = "0";
  Framework2["React"] = "1";
  Framework2["NextJs"] = "2";
  Framework2["Angular"] = "3";
  Framework2["VueJs"] = "4";
  Framework2["Nuxt"] = "5";
  Framework2["Svelte"] = "6";
  Framework2["ServerSideUnknown"] = "100";
  Framework2["ReactSSR"] = "101";
  Framework2["NextJsSSR"] = "102";
  Framework2["AngularSSR"] = "103";
  Framework2["VueJsSSR"] = "104";
  Framework2["NuxtSSR"] = "105";
  Framework2["SvelteSSR"] = "106";
  Framework2["ReactNative"] = "201";
  Framework2["Expo"] = "202";
})(Framework || (Framework = {}));
var Category;
(function(Category2) {
  Category2["API"] = "api";
  Category2["Auth"] = "auth";
  Category2["Analytics"] = "analytics";
  Category2["DataStore"] = "datastore";
  Category2["Geo"] = "geo";
  Category2["InAppMessaging"] = "inappmessaging";
  Category2["Interactions"] = "interactions";
  Category2["Predictions"] = "predictions";
  Category2["PubSub"] = "pubsub";
  Category2["PushNotification"] = "pushnotification";
  Category2["Storage"] = "storage";
})(Category || (Category = {}));
var AnalyticsAction;
(function(AnalyticsAction2) {
  AnalyticsAction2["Record"] = "1";
  AnalyticsAction2["UpdateEndpoint"] = "2";
})(AnalyticsAction || (AnalyticsAction = {}));
var ApiAction;
(function(ApiAction2) {
  ApiAction2["GraphQl"] = "1";
  ApiAction2["Get"] = "2";
  ApiAction2["Post"] = "3";
  ApiAction2["Put"] = "4";
  ApiAction2["Patch"] = "5";
  ApiAction2["Del"] = "6";
  ApiAction2["Head"] = "7";
})(ApiAction || (ApiAction = {}));
var AuthAction;
(function(AuthAction2) {
  AuthAction2["FederatedSignIn"] = "30";
})(AuthAction || (AuthAction = {}));
var DataStoreAction;
(function(DataStoreAction2) {
  DataStoreAction2["Subscribe"] = "1";
  DataStoreAction2["GraphQl"] = "2";
})(DataStoreAction || (DataStoreAction = {}));
var GeoAction;
(function(GeoAction2) {
  GeoAction2["None"] = "0";
})(GeoAction || (GeoAction = {}));
var InAppMessagingAction;
(function(InAppMessagingAction2) {
  InAppMessagingAction2["None"] = "0";
})(InAppMessagingAction || (InAppMessagingAction = {}));
var InteractionsAction;
(function(InteractionsAction2) {
  InteractionsAction2["None"] = "0";
})(InteractionsAction || (InteractionsAction = {}));
var PredictionsAction;
(function(PredictionsAction2) {
  PredictionsAction2["Convert"] = "1";
  PredictionsAction2["Identify"] = "2";
  PredictionsAction2["Interpret"] = "3";
})(PredictionsAction || (PredictionsAction = {}));
var PubSubAction;
(function(PubSubAction2) {
  PubSubAction2["Subscribe"] = "1";
})(PubSubAction || (PubSubAction = {}));
var PushNotificationAction;
(function(PushNotificationAction2) {
  PushNotificationAction2["None"] = "0";
})(PushNotificationAction || (PushNotificationAction = {}));
var StorageAction;
(function(StorageAction2) {
  StorageAction2["Put"] = "1";
  StorageAction2["Get"] = "2";
  StorageAction2["List"] = "3";
  StorageAction2["Copy"] = "4";
  StorageAction2["Remove"] = "5";
  StorageAction2["GetProperties"] = "6";
})(StorageAction || (StorageAction = {}));

// node_modules/@aws-amplify/core/lib-esm/Platform/version.js
var version = "5.3.1";

// node_modules/@aws-amplify/core/lib-esm/Platform/detection/helpers.js
var globalExists = function() {
  return typeof global !== "undefined";
};
var windowExists = function() {
  return typeof window !== "undefined";
};
var documentExists = function() {
  return typeof document !== "undefined";
};
var processExists = function() {
  return typeof process !== "undefined";
};
var keyPrefixMatch = function(object, prefix) {
  return !!Object.keys(object).find(function(key) {
    return key.startsWith(prefix);
  });
};

// node_modules/@aws-amplify/core/lib-esm/Platform/detection/React.js
function reactWebDetect() {
  var elementKeyPrefixedWithReact = function(key) {
    return key.startsWith("_react") || key.startsWith("__react");
  };
  var elementIsReactEnabled = function(element) {
    return Object.keys(element).find(elementKeyPrefixedWithReact);
  };
  var allElementsWithId = function() {
    return Array.from(document.querySelectorAll("[id]"));
  };
  return documentExists() && allElementsWithId().some(elementIsReactEnabled);
}
function reactSSRDetect() {
  return processExists() && typeof process.env !== "undefined" && !!Object.keys(process.env).find(function(key) {
    return key.includes("react");
  });
}

// node_modules/@aws-amplify/core/lib-esm/Platform/detection/Vue.js
function vueWebDetect() {
  return windowExists() && keyPrefixMatch(window, "__VUE");
}
function vueSSRDetect() {
  return globalExists() && keyPrefixMatch(global, "__VUE");
}

// node_modules/@aws-amplify/core/lib-esm/Platform/detection/Svelte.js
function svelteWebDetect() {
  return windowExists() && keyPrefixMatch(window, "__SVELTE");
}
function svelteSSRDetect() {
  return processExists() && typeof process.env !== "undefined" && !!Object.keys(process.env).find(function(key) {
    return key.includes("svelte");
  });
}

// node_modules/@aws-amplify/core/lib-esm/Platform/detection/Next.js
function nextWebDetect() {
  return windowExists() && window["next"] && typeof window["next"] === "object";
}
function nextSSRDetect() {
  return globalExists() && (keyPrefixMatch(global, "__next") || keyPrefixMatch(global, "__NEXT"));
}

// node_modules/@aws-amplify/core/lib-esm/Platform/detection/Nuxt.js
function nuxtWebDetect() {
  return windowExists() && // @ts-ignore
  (window["__NUXT__"] !== void 0 || window["$nuxt"] !== void 0);
}
function nuxtSSRDetect() {
  return globalExists() && typeof global["__NUXT_PATHS__"] !== "undefined";
}

// node_modules/@aws-amplify/core/lib-esm/Platform/detection/Angular.js
function angularWebDetect() {
  var angularVersionSetInDocument = Boolean(documentExists() && document.querySelector("[ng-version]"));
  var angularContentSetInWindow = Boolean(
    // @ts-ignore
    windowExists() && typeof window["ng"] !== "undefined"
  );
  return angularVersionSetInDocument || angularContentSetInWindow;
}
function angularSSRDetect() {
  var _a2;
  return processExists() && typeof process.env === "object" && ((_a2 = process.env["npm_lifecycle_script"]) === null || _a2 === void 0 ? void 0 : _a2.startsWith("ng ")) || false;
}

// node_modules/@aws-amplify/core/lib-esm/Platform/detection/ReactNative.js
function reactNativeDetect() {
  return typeof navigator !== "undefined" && typeof navigator.product !== "undefined" && navigator.product === "ReactNative";
}

// node_modules/@aws-amplify/core/lib-esm/Platform/detection/Expo.js
function expoDetect() {
  return globalExists() && typeof global["expo"] !== "undefined";
}

// node_modules/@aws-amplify/core/lib-esm/Platform/detection/Web.js
function webDetect() {
  return windowExists();
}

// node_modules/@aws-amplify/core/lib-esm/Platform/detection/index.js
var detectionMap = [
  // First, detect mobile
  { platform: Framework.Expo, detectionMethod: expoDetect },
  { platform: Framework.ReactNative, detectionMethod: reactNativeDetect },
  // Next, detect web frameworks
  { platform: Framework.NextJs, detectionMethod: nextWebDetect },
  { platform: Framework.Nuxt, detectionMethod: nuxtWebDetect },
  { platform: Framework.Angular, detectionMethod: angularWebDetect },
  { platform: Framework.React, detectionMethod: reactWebDetect },
  { platform: Framework.VueJs, detectionMethod: vueWebDetect },
  { platform: Framework.Svelte, detectionMethod: svelteWebDetect },
  { platform: Framework.WebUnknown, detectionMethod: webDetect },
  // Last, detect ssr frameworks
  { platform: Framework.NextJsSSR, detectionMethod: nextSSRDetect },
  { platform: Framework.NuxtSSR, detectionMethod: nuxtSSRDetect },
  { platform: Framework.ReactSSR, detectionMethod: reactSSRDetect },
  { platform: Framework.VueJsSSR, detectionMethod: vueSSRDetect },
  { platform: Framework.AngularSSR, detectionMethod: angularSSRDetect },
  { platform: Framework.SvelteSSR, detectionMethod: svelteSSRDetect }
];
function detect() {
  var _a2;
  return ((_a2 = detectionMap.find(function(detectionEntry) {
    return detectionEntry.detectionMethod();
  })) === null || _a2 === void 0 ? void 0 : _a2.platform) || Framework.ServerSideUnknown;
}

// node_modules/@aws-amplify/core/lib-esm/Platform/detectFramework.js
var frameworkCache;
var frameworkChangeObservers = [];
var resetTriggered = false;
var SSR_RESET_TIMEOUT = 10;
var WEB_RESET_TIMEOUT = 10;
var PRIME_FRAMEWORK_DELAY = 1e3;
var detectFramework = function() {
  if (!frameworkCache) {
    frameworkCache = detect();
    frameworkChangeObservers.forEach(function(fcn) {
      return fcn();
    });
    resetTimeout(Framework.ServerSideUnknown, SSR_RESET_TIMEOUT);
    resetTimeout(Framework.WebUnknown, WEB_RESET_TIMEOUT);
  }
  return frameworkCache;
};
var observeFrameworkChanges = function(fcn) {
  frameworkChangeObservers.push(fcn);
};
function clearCache() {
  frameworkCache = void 0;
}
function resetTimeout(framework, delay) {
  if (frameworkCache === framework && !resetTriggered) {
    setTimeout(function() {
      clearCache();
      resetTriggered = true;
      setTimeout(detectFramework, PRIME_FRAMEWORK_DELAY);
    }, delay);
  }
}

// node_modules/@aws-amplify/core/lib-esm/Platform/index.js
var __read3 = function(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var BASE_USER_AGENT = "aws-amplify";
var PlatformBuilder = (
  /** @class */
  function() {
    function PlatformBuilder2() {
      this.userAgent = "".concat(BASE_USER_AGENT, "/").concat(version);
    }
    Object.defineProperty(PlatformBuilder2.prototype, "framework", {
      get: function() {
        return detectFramework();
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(PlatformBuilder2.prototype, "isReactNative", {
      get: function() {
        return this.framework === Framework.ReactNative;
      },
      enumerable: false,
      configurable: true
    });
    PlatformBuilder2.prototype.observeFrameworkChanges = function(fcn) {
      observeFrameworkChanges(fcn);
    };
    return PlatformBuilder2;
  }()
);
var Platform = new PlatformBuilder();
var getAmplifyUserAgentObject = function(_a2) {
  var _b2 = _a2 === void 0 ? {} : _a2, category = _b2.category, action = _b2.action, framework = _b2.framework;
  var userAgent2 = [[BASE_USER_AGENT, version]];
  if (category) {
    userAgent2.push([category, action]);
  }
  userAgent2.push(["framework", detectFramework()]);
  return userAgent2;
};
var getAmplifyUserAgent = function(customUserAgentDetails) {
  var userAgent2 = getAmplifyUserAgentObject(customUserAgentDetails);
  var userAgentString = userAgent2.map(function(_a2) {
    var _b2 = __read3(_a2, 2), agentKey = _b2[0], agentValue = _b2[1];
    return "".concat(agentKey, "/").concat(agentValue);
  }).join(" ");
  return userAgentString;
};

// node_modules/@aws-amplify/core/lib-esm/ClientDevice/browser.js
var logger2 = new ConsoleLogger("ClientDevice_Browser");
function clientInfo() {
  if (typeof window === "undefined") {
    return {};
  }
  return browserClientInfo();
}
function browserClientInfo() {
  if (typeof window === "undefined") {
    logger2.warn("No window object available to get browser client info");
    return {};
  }
  var nav = window.navigator;
  if (!nav) {
    logger2.warn("No navigator object available to get browser client info");
    return {};
  }
  var platform = nav.platform, product = nav.product, vendor = nav.vendor, userAgent2 = nav.userAgent, language = nav.language;
  var type = browserType(userAgent2);
  var timezone = browserTimezone();
  return {
    platform,
    make: product || vendor,
    model: type.type,
    version: type.version,
    appVersion: [type.type, type.version].join("/"),
    language,
    timezone
  };
}
function dimension() {
  if (typeof window === "undefined") {
    logger2.warn("No window object available to get browser client info");
    return { width: 320, height: 320 };
  }
  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
}
function browserTimezone() {
  var tzMatch = /\(([A-Za-z\s].*)\)/.exec((/* @__PURE__ */ new Date()).toString());
  return tzMatch ? tzMatch[1] || "" : "";
}
function browserType(userAgent2) {
  var operaMatch = /.+(Opera[\s[A-Z]*|OPR[\sA-Z]*)\/([0-9\.]+).*/i.exec(userAgent2);
  if (operaMatch) {
    return { type: operaMatch[1], version: operaMatch[2] };
  }
  var ieMatch = /.+(Trident|Edge)\/([0-9\.]+).*/i.exec(userAgent2);
  if (ieMatch) {
    return { type: ieMatch[1], version: ieMatch[2] };
  }
  var cfMatch = /.+(Chrome|Firefox|FxiOS)\/([0-9\.]+).*/i.exec(userAgent2);
  if (cfMatch) {
    return { type: cfMatch[1], version: cfMatch[2] };
  }
  var sMatch = /.+(Safari)\/([0-9\.]+).*/i.exec(userAgent2);
  if (sMatch) {
    return { type: sMatch[1], version: sMatch[2] };
  }
  var awkMatch = /.+(AppleWebKit)\/([0-9\.]+).*/i.exec(userAgent2);
  if (awkMatch) {
    return { type: awkMatch[1], version: awkMatch[2] };
  }
  var anyMatch = /.*([A-Z]+)\/([0-9\.]+).*/i.exec(userAgent2);
  if (anyMatch) {
    return { type: anyMatch[1], version: anyMatch[2] };
  }
  return { type: "", version: "" };
}

// node_modules/@aws-amplify/core/lib-esm/ClientDevice/index.js
var ClientDevice = (
  /** @class */
  function() {
    function ClientDevice2() {
    }
    ClientDevice2.clientInfo = function() {
      return clientInfo();
    };
    ClientDevice2.dimension = function() {
      return dimension();
    };
    return ClientDevice2;
  }()
);

// node_modules/@aws-amplify/core/lib-esm/Hub.js
var __assign = function() {
  __assign = Object.assign || function(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
var __read4 = function(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var __spreadArray2 = function(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i2 = 0, l2 = from.length, ar; i2 < l2; i2++) {
      if (ar || !(i2 in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i2);
        ar[i2] = from[i2];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var logger3 = new ConsoleLogger("Hub");
var AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
function isLegacyCallback(callback) {
  return callback.onHubCapsule !== void 0;
}
var HubClass = (
  /** @class */
  function() {
    function HubClass2(name) {
      this.listeners = [];
      this.patterns = [];
      this.protectedChannels = [
        "core",
        "auth",
        "api",
        "analytics",
        "interactions",
        "pubsub",
        "storage",
        "ui",
        "xr"
      ];
      this.name = name;
    }
    HubClass2.prototype._remove = function(channel, listener2) {
      if (channel instanceof RegExp) {
        var pattern_1 = this.patterns.find(function(_a2) {
          var pattern = _a2.pattern;
          return pattern.source === channel.source;
        });
        if (!pattern_1) {
          logger3.warn("No listeners for ".concat(channel));
          return;
        }
        this.patterns = __spreadArray2([], __read4(this.patterns.filter(function(x2) {
          return x2 !== pattern_1;
        })), false);
      } else {
        var holder = this.listeners[channel];
        if (!holder) {
          logger3.warn("No listeners for ".concat(channel));
          return;
        }
        this.listeners[channel] = __spreadArray2([], __read4(holder.filter(function(_a2) {
          var callback = _a2.callback;
          return callback !== listener2;
        })), false);
      }
    };
    HubClass2.prototype.remove = function(channel, listener2) {
      this._remove(channel, listener2);
    };
    HubClass2.prototype.dispatch = function(channel, payload, source, ampSymbol) {
      if (source === void 0) {
        source = "";
      }
      if (this.protectedChannels.indexOf(channel) > -1) {
        var hasAccess = ampSymbol === AMPLIFY_SYMBOL;
        if (!hasAccess) {
          logger3.warn("WARNING: ".concat(channel, " is protected and dispatching on it can have unintended consequences"));
        }
      }
      var capsule = {
        channel,
        payload: __assign({}, payload),
        source,
        patternInfo: []
      };
      try {
        this._toListeners(capsule);
      } catch (e) {
        logger3.error(e);
      }
    };
    HubClass2.prototype.listen = function(channel, callback, listenerName) {
      var _this = this;
      if (listenerName === void 0) {
        listenerName = "noname";
      }
      var cb;
      if (isLegacyCallback(callback)) {
        logger3.warn("WARNING onHubCapsule is Deprecated. Please pass in a callback.");
        cb = callback.onHubCapsule.bind(callback);
      } else if (typeof callback !== "function") {
        throw new Error("No callback supplied to Hub");
      } else {
        cb = callback;
      }
      if (channel instanceof RegExp) {
        this.patterns.push({
          pattern: channel,
          callback: cb
        });
      } else {
        var holder = this.listeners[channel];
        if (!holder) {
          holder = [];
          this.listeners[channel] = holder;
        }
        holder.push({
          name: listenerName,
          callback: cb
        });
      }
      return function() {
        _this._remove(channel, cb);
      };
    };
    HubClass2.prototype._toListeners = function(capsule) {
      var channel = capsule.channel, payload = capsule.payload;
      var holder = this.listeners[channel];
      if (holder) {
        holder.forEach(function(listener2) {
          logger3.debug("Dispatching to ".concat(channel, " with "), payload);
          try {
            listener2.callback(capsule);
          } catch (e) {
            logger3.error(e);
          }
        });
      }
      if (this.patterns.length > 0) {
        if (!payload.message) {
          logger3.warn("Cannot perform pattern matching without a message key");
          return;
        }
        var payloadStr_1 = payload.message;
        this.patterns.forEach(function(pattern) {
          var match = payloadStr_1.match(pattern.pattern);
          if (match) {
            var _a2 = __read4(match), groups = _a2.slice(1);
            var dispatchingCapsule = __assign(__assign({}, capsule), { patternInfo: groups });
            try {
              pattern.callback(dispatchingCapsule);
            } catch (e) {
              logger3.error(e);
            }
          }
        });
      }
    };
    return HubClass2;
  }()
);
var Hub = new HubClass("__default__");

// node_modules/@aws-amplify/core/lib-esm/I18n/I18n.js
var __assign2 = function() {
  __assign2 = Object.assign || function(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign2.apply(this, arguments);
};
var logger4 = new ConsoleLogger("I18n");
var I18n = (
  /** @class */
  function() {
    function I18n3(options) {
      this._options = null;
      this._lang = null;
      this._dict = {};
      this._options = Object.assign({}, options);
      this._lang = this._options.language;
      if (!this._lang && typeof window !== "undefined" && window && window.navigator) {
        this._lang = window.navigator.language;
      }
      logger4.debug(this._lang);
    }
    I18n3.prototype.setLanguage = function(lang) {
      this._lang = lang;
    };
    I18n3.prototype.get = function(key, defVal) {
      if (defVal === void 0) {
        defVal = void 0;
      }
      if (!this._lang) {
        return typeof defVal !== "undefined" ? defVal : key;
      }
      var lang = this._lang;
      var val2 = this.getByLanguage(key, lang);
      if (val2) {
        return val2;
      }
      if (lang.indexOf("-") > 0) {
        val2 = this.getByLanguage(key, lang.split("-")[0]);
      }
      if (val2) {
        return val2;
      }
      return typeof defVal !== "undefined" ? defVal : key;
    };
    I18n3.prototype.getByLanguage = function(key, language, defVal) {
      if (defVal === void 0) {
        defVal = null;
      }
      if (!language) {
        return defVal;
      }
      var lang_dict = this._dict[language];
      if (!lang_dict) {
        return defVal;
      }
      return lang_dict[key];
    };
    I18n3.prototype.putVocabulariesForLanguage = function(language, vocabularies) {
      var lang_dict = this._dict[language];
      if (!lang_dict) {
        lang_dict = this._dict[language] = {};
      }
      this._dict[language] = __assign2(__assign2({}, lang_dict), vocabularies);
    };
    I18n3.prototype.putVocabularies = function(vocabularies) {
      var _this = this;
      Object.keys(vocabularies).map(function(key) {
        _this.putVocabulariesForLanguage(key, vocabularies[key]);
      });
    };
    return I18n3;
  }()
);

// node_modules/@aws-amplify/core/lib-esm/I18n/index.js
var logger5 = new ConsoleLogger("I18n");
var _config = null;
var _i18n = null;
var I18n2 = (
  /** @class */
  function() {
    function I18n3() {
    }
    I18n3.configure = function(config) {
      logger5.debug("configure I18n");
      if (!config) {
        return _config;
      }
      _config = Object.assign({}, _config, config.I18n || config);
      I18n3.createInstance();
      return _config;
    };
    I18n3.getModuleName = function() {
      return "I18n";
    };
    I18n3.createInstance = function() {
      logger5.debug("create I18n instance");
      if (_i18n) {
        return;
      }
      _i18n = new I18n(_config);
    };
    I18n3.setLanguage = function(lang) {
      I18n3.checkConfig();
      return _i18n.setLanguage(lang);
    };
    I18n3.get = function(key, defVal) {
      if (!I18n3.checkConfig()) {
        return typeof defVal === "undefined" ? key : defVal;
      }
      return _i18n.get(key, defVal);
    };
    I18n3.putVocabulariesForLanguage = function(language, vocabularies) {
      I18n3.checkConfig();
      return _i18n.putVocabulariesForLanguage(language, vocabularies);
    };
    I18n3.putVocabularies = function(vocabularies) {
      I18n3.checkConfig();
      return _i18n.putVocabularies(vocabularies);
    };
    I18n3.checkConfig = function() {
      if (!_i18n) {
        _i18n = new I18n(_config);
      }
      return true;
    };
    return I18n3;
  }()
);
Amplify.register(I18n2);

// node_modules/@aws-amplify/core/lib-esm/JS.js
var makeQuerablePromise = function(promise) {
  if (promise.isResolved)
    return promise;
  var isPending = true;
  var isRejected = false;
  var isFullfilled = false;
  var result = promise.then(function(data) {
    isFullfilled = true;
    isPending = false;
    return data;
  }, function(e) {
    isRejected = true;
    isPending = false;
    throw e;
  });
  result.isFullfilled = function() {
    return isFullfilled;
  };
  result.isPending = function() {
    return isPending;
  };
  result.isRejected = function() {
    return isRejected;
  };
  return result;
};
var isWebWorker = function() {
  if (typeof self === "undefined") {
    return false;
  }
  var selfContext = self;
  return typeof selfContext.WorkerGlobalScope !== "undefined" && self instanceof selfContext.WorkerGlobalScope;
};
var browserOrNode = function() {
  var isBrowser3 = typeof window !== "undefined" && typeof window.document !== "undefined";
  var isNode5 = typeof process !== "undefined" && process.versions != null && process.versions.node != null;
  return {
    isBrowser: isBrowser3,
    isNode: isNode5
  };
};
var transferKeyToLowerCase = function(obj, whiteListForItself, whiteListForChildren) {
  if (whiteListForItself === void 0) {
    whiteListForItself = [];
  }
  if (whiteListForChildren === void 0) {
    whiteListForChildren = [];
  }
  if (!isStrictObject(obj))
    return obj;
  var ret = {};
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      var transferedKey = whiteListForItself.includes(key) ? key : key[0].toLowerCase() + key.slice(1);
      ret[transferedKey] = whiteListForChildren.includes(key) ? obj[key] : transferKeyToLowerCase(obj[key], whiteListForItself, whiteListForChildren);
    }
  }
  return ret;
};
var transferKeyToUpperCase = function(obj, whiteListForItself, whiteListForChildren) {
  if (whiteListForItself === void 0) {
    whiteListForItself = [];
  }
  if (whiteListForChildren === void 0) {
    whiteListForChildren = [];
  }
  if (!isStrictObject(obj))
    return obj;
  var ret = {};
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      var transferredKey = whiteListForItself.includes(key) ? key : key[0].toUpperCase() + key.slice(1);
      ret[transferredKey] = whiteListForChildren.includes(key) ? obj[key] : transferKeyToUpperCase(obj[key], whiteListForItself, whiteListForChildren);
    }
  }
  return ret;
};
var isStrictObject = function(obj) {
  return obj instanceof Object && !(obj instanceof Array) && !(obj instanceof Function) && !(obj instanceof Number) && !(obj instanceof String) && !(obj instanceof Boolean);
};

// node_modules/@aws-amplify/core/lib-esm/Util/Retry.js
var __extends = function() {
  var extendStatics10 = function(d2, b2) {
    extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b3) {
      d3.__proto__ = b3;
    } || function(d3, b3) {
      for (var p2 in b3)
        if (Object.prototype.hasOwnProperty.call(b3, p2))
          d3[p2] = b3[p2];
    };
    return extendStatics10(d2, b2);
  };
  return function(d2, b2) {
    if (typeof b2 !== "function" && b2 !== null)
      throw new TypeError("Class extends value " + String(b2) + " is not a constructor or null");
    extendStatics10(d2, b2);
    function __() {
      this.constructor = d2;
    }
    d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
  };
}();
var __awaiter = function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (g2 && (g2 = 0, op[0] && (_2 = 0)), _2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var __read5 = function(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var __spreadArray3 = function(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i2 = 0, l2 = from.length, ar; i2 < l2; i2++) {
      if (ar || !(i2 in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i2);
        ar[i2] = from[i2];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var logger6 = new ConsoleLogger("Util");
var NonRetryableError = (
  /** @class */
  function(_super) {
    __extends(NonRetryableError2, _super);
    function NonRetryableError2(message) {
      var _this = _super.call(this, message) || this;
      _this.nonRetryable = true;
      return _this;
    }
    return NonRetryableError2;
  }(Error)
);
var isNonRetryableError = function(obj) {
  var key = "nonRetryable";
  return obj && obj[key];
};
function retry(functionToRetry, args, delayFn, onTerminate) {
  return __awaiter(this, void 0, void 0, function() {
    var _this = this;
    return __generator(this, function(_a2) {
      if (typeof functionToRetry !== "function") {
        throw Error("functionToRetry must be a function");
      }
      return [2, new Promise(function(resolve, reject) {
        return __awaiter(_this, void 0, void 0, function() {
          var attempt, terminated, timeout, wakeUp, lastError, _loop_1, state_1;
          return __generator(this, function(_a3) {
            switch (_a3.label) {
              case 0:
                attempt = 0;
                terminated = false;
                wakeUp = function() {
                };
                onTerminate && onTerminate.then(function() {
                  terminated = true;
                  clearTimeout(timeout);
                  wakeUp();
                });
                _loop_1 = function() {
                  var _b2, _c, err_1, retryIn_1;
                  return __generator(this, function(_d) {
                    switch (_d.label) {
                      case 0:
                        attempt++;
                        logger6.debug("".concat(functionToRetry.name, " attempt #").concat(attempt, " with this vars: ").concat(JSON.stringify(args)));
                        _d.label = 1;
                      case 1:
                        _d.trys.push([1, 3, , 7]);
                        _b2 = {};
                        _c = resolve;
                        return [4, functionToRetry.apply(void 0, __spreadArray3([], __read5(args), false))];
                      case 2:
                        return [2, (_b2.value = _c.apply(void 0, [_d.sent()]), _b2)];
                      case 3:
                        err_1 = _d.sent();
                        lastError = err_1;
                        logger6.debug("error on ".concat(functionToRetry.name), err_1);
                        if (isNonRetryableError(err_1)) {
                          logger6.debug("".concat(functionToRetry.name, " non retryable error"), err_1);
                          return [2, { value: reject(err_1) }];
                        }
                        retryIn_1 = delayFn(attempt, args, err_1);
                        logger6.debug("".concat(functionToRetry.name, " retrying in ").concat(retryIn_1, " ms"));
                        if (!(retryIn_1 === false || terminated))
                          return [3, 4];
                        return [2, { value: reject(err_1) }];
                      case 4:
                        return [4, new Promise(function(r2) {
                          wakeUp = r2;
                          timeout = setTimeout(wakeUp, retryIn_1);
                        })];
                      case 5:
                        _d.sent();
                        _d.label = 6;
                      case 6:
                        return [3, 7];
                      case 7:
                        return [
                          2
                          /*return*/
                        ];
                    }
                  });
                };
                _a3.label = 1;
              case 1:
                if (!!terminated)
                  return [3, 3];
                return [5, _loop_1()];
              case 2:
                state_1 = _a3.sent();
                if (typeof state_1 === "object")
                  return [2, state_1.value];
                return [3, 1];
              case 3:
                reject(lastError);
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      })];
    });
  });
}
var MAX_DELAY_MS = 5 * 60 * 1e3;
function jitteredBackoff(maxDelayMs) {
  if (maxDelayMs === void 0) {
    maxDelayMs = MAX_DELAY_MS;
  }
  var BASE_TIME_MS = 100;
  var JITTER_FACTOR = 100;
  return function(attempt) {
    var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
    return delay > maxDelayMs ? false : delay;
  };
}
var jitteredExponentialRetry = function(functionToRetry, args, maxDelayMs, onTerminate) {
  if (maxDelayMs === void 0) {
    maxDelayMs = MAX_DELAY_MS;
  }
  return retry(functionToRetry, args, jitteredBackoff(maxDelayMs), onTerminate);
};

// node_modules/@aws-amplify/core/lib-esm/Util/Mutex.js
var Mutex = (
  /** @class */
  function() {
    function Mutex2() {
      this._queue = [];
      this._pending = false;
    }
    Mutex2.prototype.isLocked = function() {
      return this._pending;
    };
    Mutex2.prototype.acquire = function() {
      var _this = this;
      var ticket = new Promise(function(resolve) {
        return _this._queue.push(resolve);
      });
      if (!this._pending) {
        this._dispatchNext();
      }
      return ticket;
    };
    Mutex2.prototype.runExclusive = function(callback) {
      return this.acquire().then(function(release) {
        var result;
        try {
          result = callback();
        } catch (e) {
          release();
          throw e;
        }
        return Promise.resolve(result).then(function(x2) {
          return release(), x2;
        }, function(e) {
          release();
          throw e;
        });
      });
    };
    Mutex2.prototype._dispatchNext = function() {
      if (this._queue.length > 0) {
        this._pending = true;
        this._queue.shift()(this._dispatchNext.bind(this));
      } else {
        this._pending = false;
      }
    };
    return Mutex2;
  }()
);
var Mutex_default = Mutex;

// node_modules/zen-observable-ts/lib/bundle.esm.js
var import_zen_observable = __toESM(require_zen_observable());
var Observable = import_zen_observable.default;
var bundle_esm_default = Observable;

// node_modules/@aws-amplify/core/lib-esm/Util/Reachability.js
var __values2 = function(o2) {
  var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
  if (m2)
    return m2.call(o2);
  if (o2 && typeof o2.length === "number")
    return {
      next: function() {
        if (o2 && i2 >= o2.length)
          o2 = void 0;
        return { value: o2 && o2[i2++], done: !o2 };
      }
    };
  throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var ReachabilityNavigator = (
  /** @class */
  function() {
    function ReachabilityNavigator2() {
    }
    ReachabilityNavigator2.prototype.networkMonitor = function(netInfo) {
      if (browserOrNode().isNode) {
        return bundle_esm_default.from([{ online: true }]);
      }
      var globalObj = isWebWorker() ? self : window;
      return new bundle_esm_default(function(observer) {
        observer.next({ online: globalObj.navigator.onLine });
        var notifyOnline = function() {
          return observer.next({ online: true });
        };
        var notifyOffline = function() {
          return observer.next({ online: false });
        };
        globalObj.addEventListener("online", notifyOnline);
        globalObj.addEventListener("offline", notifyOffline);
        ReachabilityNavigator2._observers.push(observer);
        return function() {
          globalObj.removeEventListener("online", notifyOnline);
          globalObj.removeEventListener("offline", notifyOffline);
          ReachabilityNavigator2._observers = ReachabilityNavigator2._observers.filter(function(_observer) {
            return _observer !== observer;
          });
        };
      });
    };
    ReachabilityNavigator2._observerOverride = function(status) {
      var e_1, _a2;
      var _loop_1 = function(observer2) {
        if (observer2.closed) {
          ReachabilityNavigator2._observers = ReachabilityNavigator2._observers.filter(function(_observer) {
            return _observer !== observer2;
          });
          return "continue";
        }
        observer2.next(status);
      };
      try {
        for (var _b2 = __values2(ReachabilityNavigator2._observers), _c = _b2.next(); !_c.done; _c = _b2.next()) {
          var observer = _c.value;
          _loop_1(observer);
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (_c && !_c.done && (_a2 = _b2.return))
            _a2.call(_b2);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
    };
    ReachabilityNavigator2._observers = [];
    return ReachabilityNavigator2;
  }()
);
var Reachability_default = ReachabilityNavigator;

// node_modules/@aws-amplify/core/lib-esm/Util/DateUtils.js
var __read6 = function(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var FIVE_MINUTES_IN_MS = 1e3 * 60 * 5;
var DateUtils = {
  /**
   * Milliseconds to offset the date to compensate for clock skew between device & services
   */
  clockOffset: 0,
  getDateWithClockOffset: function() {
    if (DateUtils.clockOffset) {
      return new Date((/* @__PURE__ */ new Date()).getTime() + DateUtils.clockOffset);
    } else {
      return /* @__PURE__ */ new Date();
    }
  },
  /**
   * @returns {number} Clock offset in milliseconds
   */
  getClockOffset: function() {
    return DateUtils.clockOffset;
  },
  getHeaderStringFromDate: function(date) {
    if (date === void 0) {
      date = DateUtils.getDateWithClockOffset();
    }
    return date.toISOString().replace(/[:\-]|\.\d{3}/g, "");
  },
  getDateFromHeaderString: function(header) {
    var _a2 = __read6(header.match(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2}).+/), 7), year = _a2[1], month = _a2[2], day = _a2[3], hour = _a2[4], minute = _a2[5], second = _a2[6];
    return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second)));
  },
  isClockSkewed: function(serverDate) {
    return Math.abs(serverDate.getTime() - DateUtils.getDateWithClockOffset().getTime()) >= FIVE_MINUTES_IN_MS;
  },
  isClockSkewError: function(error) {
    if (!error.response || !error.response.headers) {
      return false;
    }
    var headers = error.response.headers;
    return Boolean(["BadRequestException", "InvalidSignatureException"].includes(headers["x-amzn-errortype"]) && (headers.date || headers.Date));
  },
  /**
   * @param {number} offset Clock offset in milliseconds
   */
  setClockOffset: function(offset) {
    DateUtils.clockOffset = offset;
  }
};

// node_modules/@aws-amplify/core/lib-esm/Util/StringUtils.js
function urlSafeEncode(str) {
  return str.split("").map(function(char) {
    return char.charCodeAt(0).toString(16).padStart(2, "0");
  }).join("");
}
function urlSafeDecode(hex) {
  return hex.match(/.{2}/g).map(function(char) {
    return String.fromCharCode(parseInt(char, 16));
  }).join("");
}

// node_modules/@aws-amplify/core/lib-esm/Util/BackgroundProcessManager.js
var __extends2 = function() {
  var extendStatics10 = function(d2, b2) {
    extendStatics10 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b3) {
      d3.__proto__ = b3;
    } || function(d3, b3) {
      for (var p2 in b3)
        if (Object.prototype.hasOwnProperty.call(b3, p2))
          d3[p2] = b3[p2];
    };
    return extendStatics10(d2, b2);
  };
  return function(d2, b2) {
    if (typeof b2 !== "function" && b2 !== null)
      throw new TypeError("Class extends value " + String(b2) + " is not a constructor or null");
    extendStatics10(d2, b2);
    function __() {
      this.constructor = d2;
    }
    d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
  };
}();
var __awaiter2 = function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator2 = function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (g2 && (g2 = 0, op[0] && (_2 = 0)), _2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var __values3 = function(o2) {
  var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
  if (m2)
    return m2.call(o2);
  if (o2 && typeof o2.length === "number")
    return {
      next: function() {
        if (o2 && i2 >= o2.length)
          o2 = void 0;
        return { value: o2 && o2[i2++], done: !o2 };
      }
    };
  throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var BackgroundProcessManager = (
  /** @class */
  function() {
    function BackgroundProcessManager2() {
      this._state = BackgroundProcessManagerState.Open;
      this.jobs = /* @__PURE__ */ new Set();
    }
    BackgroundProcessManager2.prototype.add = function(jobOrDescription, optionalDescription) {
      var job;
      var description;
      if (typeof jobOrDescription === "string") {
        job = void 0;
        description = jobOrDescription;
      } else {
        job = jobOrDescription;
        description = optionalDescription;
      }
      var error = this.closedFailure(description);
      if (error)
        return error;
      if (job === void 0) {
        return this.addHook(description);
      } else if (typeof job === "function") {
        return this.addFunction(job, description);
      } else if (job instanceof BackgroundProcessManager2) {
        return this.addManager(job, description);
      } else {
        throw new Error("If `job` is provided, it must be an Observable, Function, or BackgroundProcessManager.");
      }
    };
    BackgroundProcessManager2.prototype.addCleaner = function(clean, description) {
      var _this = this;
      var _a2 = this.addHook(description), resolve = _a2.resolve, onTerminate = _a2.onTerminate;
      var proxy = function() {
        return __awaiter2(_this, void 0, void 0, function() {
          return __generator2(this, function(_a3) {
            switch (_a3.label) {
              case 0:
                return [4, clean()];
              case 1:
                _a3.sent();
                resolve();
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      onTerminate.then(proxy);
      return proxy;
    };
    BackgroundProcessManager2.prototype.addFunction = function(job, description) {
      var terminate;
      var onTerminate = new Promise(function(resolve) {
        terminate = resolve;
      });
      var jobResult = job(onTerminate);
      if (typeof (jobResult === null || jobResult === void 0 ? void 0 : jobResult.then) === "function") {
        this.registerPromise(jobResult, terminate, description);
      }
      return jobResult;
    };
    BackgroundProcessManager2.prototype.addManager = function(manager, description) {
      var _this = this;
      this.addCleaner(function() {
        return __awaiter2(_this, void 0, void 0, function() {
          return __generator2(this, function(_a2) {
            switch (_a2.label) {
              case 0:
                return [4, manager.close()];
              case 1:
                return [2, _a2.sent()];
            }
          });
        });
      }, description);
    };
    BackgroundProcessManager2.prototype.addHook = function(description) {
      var resolve;
      var reject;
      var promise = new Promise(function(res, rej) {
        resolve = res;
        reject = rej;
      });
      var terminate;
      var onTerminate = new Promise(function(resolveTerminate) {
        terminate = resolveTerminate;
      });
      this.registerPromise(promise, terminate, description);
      return {
        resolve,
        reject,
        onTerminate
      };
    };
    BackgroundProcessManager2.prototype.registerPromise = function(promise, terminate, description) {
      var _this = this;
      var jobEntry = { promise, terminate, description };
      this.jobs.add(jobEntry);
      promise.then(function() {
        _this.jobs.delete(jobEntry);
      }).catch(function() {
        _this.jobs.delete(jobEntry);
      });
    };
    Object.defineProperty(BackgroundProcessManager2.prototype, "length", {
      /**
       * The number of jobs being waited on.
       *
       * We don't use this for anything. It's just informational for the caller,
       * and can be used in logging and testing.
       *
       * @returns the number of jobs.
       */
      get: function() {
        return this.jobs.size;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(BackgroundProcessManager2.prototype, "state", {
      /**
       * The execution state of the manager. One of:
       *
       * 1. "Open" -> Accepting new jobs
       * 1. "Closing" -> Not accepting new work. Waiting for jobs to complete.
       * 1. "Closed" -> Not accepting new work. All submitted jobs are complete.
       */
      get: function() {
        return this._state;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(BackgroundProcessManager2.prototype, "pending", {
      /**
       * The registered `description` of all still-pending jobs.
       *
       * @returns descriptions as an array.
       */
      get: function() {
        return Array.from(this.jobs).map(function(job) {
          return job.description;
        });
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(BackgroundProcessManager2.prototype, "isOpen", {
      /**
       * Whether the manager is accepting new jobs.
       */
      get: function() {
        return this._state === BackgroundProcessManagerState.Open;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(BackgroundProcessManager2.prototype, "isClosing", {
      /**
       * Whether the manager is rejecting new work, but still waiting for
       * submitted work to complete.
       */
      get: function() {
        return this._state === BackgroundProcessManagerState.Closing;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(BackgroundProcessManager2.prototype, "isClosed", {
      /**
       * Whether the manager is rejecting work and done waiting for submitted
       * work to complete.
       */
      get: function() {
        return this._state === BackgroundProcessManagerState.Closed;
      },
      enumerable: false,
      configurable: true
    });
    BackgroundProcessManager2.prototype.closedFailure = function(description) {
      if (!this.isOpen) {
        return Promise.reject(new BackgroundManagerNotOpenError([
          "The manager is ".concat(this.state, "."),
          'You tried to add "'.concat(description, '".'),
          "Pending jobs: [\n".concat(this.pending.map(function(t2) {
            return "    " + t2;
          }).join(",\n"), "\n]")
        ].join("\n")));
      }
    };
    BackgroundProcessManager2.prototype.close = function() {
      return __awaiter2(this, void 0, void 0, function() {
        var _a2, _b2, job;
        var e_1, _c;
        return __generator2(this, function(_d) {
          switch (_d.label) {
            case 0:
              if (!this.isOpen)
                return [3, 2];
              this._state = BackgroundProcessManagerState.Closing;
              try {
                for (_a2 = __values3(Array.from(this.jobs)), _b2 = _a2.next(); !_b2.done; _b2 = _a2.next()) {
                  job = _b2.value;
                  try {
                    job.terminate();
                  } catch (error) {
                    console.warn("Failed to send termination signal to job. Error: ".concat(error.message), job);
                  }
                }
              } catch (e_1_1) {
                e_1 = { error: e_1_1 };
              } finally {
                try {
                  if (_b2 && !_b2.done && (_c = _a2.return))
                    _c.call(_a2);
                } finally {
                  if (e_1)
                    throw e_1.error;
                }
              }
              this._closingPromise = Promise.allSettled(Array.from(this.jobs).map(function(j2) {
                return j2.promise;
              }));
              return [4, this._closingPromise];
            case 1:
              _d.sent();
              this._state = BackgroundProcessManagerState.Closed;
              _d.label = 2;
            case 2:
              return [2, this._closingPromise];
          }
        });
      });
    };
    BackgroundProcessManager2.prototype.open = function() {
      return __awaiter2(this, void 0, void 0, function() {
        return __generator2(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (!this.isClosing)
                return [3, 2];
              return [4, this.close()];
            case 1:
              _a2.sent();
              _a2.label = 2;
            case 2:
              this._state = BackgroundProcessManagerState.Open;
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    return BackgroundProcessManager2;
  }()
);
var BackgroundManagerNotOpenError = (
  /** @class */
  function(_super) {
    __extends2(BackgroundManagerNotOpenError2, _super);
    function BackgroundManagerNotOpenError2(message) {
      return _super.call(this, "BackgroundManagerNotOpenError: ".concat(message)) || this;
    }
    return BackgroundManagerNotOpenError2;
  }(Error)
);
var BackgroundProcessManagerState;
(function(BackgroundProcessManagerState2) {
  BackgroundProcessManagerState2["Open"] = "Open";
  BackgroundProcessManagerState2["Closing"] = "Closing";
  BackgroundProcessManagerState2["Closed"] = "Closed";
})(BackgroundProcessManagerState || (BackgroundProcessManagerState = {}));

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/signer/signatureV4/utils/getSignedHeaders.js
var getSignedHeaders = function(headers) {
  return Object.keys(headers).map(function(key) {
    return key.toLowerCase();
  }).sort().join(";");
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/signer/signatureV4/constants.js
var ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
var AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
var CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
var EXPIRES_QUERY_PARAM = "X-Amz-Expires";
var SIGNATURE_QUERY_PARAM = "X-Amz-Signature";
var SIGNED_HEADERS_QUERY_PARAM = "X-Amz-SignedHeaders";
var TOKEN_QUERY_PARAM = "X-Amz-Security-Token";
var AUTH_HEADER = "authorization";
var HOST_HEADER = "host";
var AMZ_DATE_HEADER = AMZ_DATE_QUERY_PARAM.toLowerCase();
var TOKEN_HEADER = TOKEN_QUERY_PARAM.toLowerCase();
var KEY_TYPE_IDENTIFIER = "aws4_request";
var SHA256_ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";
var SIGNATURE_IDENTIFIER = "AWS4";
var EMPTY_HASH = "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
var UNSIGNED_PAYLOAD = "UNSIGNED-PAYLOAD";

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/signer/signatureV4/utils/getCredentialScope.js
var getCredentialScope = function(date, region, service) {
  return "".concat(date, "/").concat(region, "/").concat(service, "/").concat(KEY_TYPE_IDENTIFIER);
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/signer/signatureV4/utils/getFormattedDates.js
var getFormattedDates = function(date) {
  var longDate = date.toISOString().replace(/[:\-]|\.\d{3}/g, "");
  return {
    longDate,
    shortDate: longDate.slice(0, 8)
  };
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/signer/signatureV4/utils/getSigningValues.js
var getSigningValues = function(_a2) {
  var credentials = _a2.credentials, _b2 = _a2.signingDate, signingDate = _b2 === void 0 ? /* @__PURE__ */ new Date() : _b2, signingRegion = _a2.signingRegion, signingService = _a2.signingService;
  var accessKeyId = credentials.accessKeyId, secretAccessKey = credentials.secretAccessKey, sessionToken = credentials.sessionToken;
  var _c = getFormattedDates(signingDate), longDate = _c.longDate, shortDate = _c.shortDate;
  var credentialScope = getCredentialScope(shortDate, signingRegion, signingService);
  return {
    accessKeyId,
    credentialScope,
    longDate,
    secretAccessKey,
    sessionToken,
    shortDate,
    signingRegion,
    signingService
  };
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/signer/signatureV4/utils/dataHashHelpers.js
var import_sha256_js = __toESM(require_build2());

// node_modules/@aws-sdk/util-hex-encoding/dist/es/index.js
var SHORT_TO_HEX = {};
var HEX_TO_SHORT = {};
for (i2 = 0; i2 < 256; i2++) {
  encodedByte = i2.toString(16).toLowerCase();
  if (encodedByte.length === 1) {
    encodedByte = "0" + encodedByte;
  }
  SHORT_TO_HEX[i2] = encodedByte;
  HEX_TO_SHORT[encodedByte] = i2;
}
var encodedByte;
var i2;
function fromHex(encoded) {
  if (encoded.length % 2 !== 0) {
    throw new Error("Hex encoded strings must have an even number length");
  }
  var out = new Uint8Array(encoded.length / 2);
  for (var i2 = 0; i2 < encoded.length; i2 += 2) {
    var encodedByte = encoded.substr(i2, 2).toLowerCase();
    if (encodedByte in HEX_TO_SHORT) {
      out[i2 / 2] = HEX_TO_SHORT[encodedByte];
    } else {
      throw new Error("Cannot decode unrecognized sequence " + encodedByte + " as hexadecimal");
    }
  }
  return out;
}
function toHex(bytes) {
  var out = "";
  for (var i2 = 0; i2 < bytes.byteLength; i2++) {
    out += SHORT_TO_HEX[bytes[i2]];
  }
  return out;
}

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/signer/signatureV4/utils/dataHashHelpers.js
var getHashedData = function(key, data) {
  var sha256 = new import_sha256_js.Sha256(key);
  sha256.update(data);
  var hashedData = sha256.digestSync();
  return hashedData;
};
var getHashedDataAsHex = function(key, data) {
  var hashedData = getHashedData(key, data);
  return toHex(hashedData);
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/signer/signatureV4/utils/getCanonicalHeaders.js
var __read7 = function(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var getCanonicalHeaders = function(headers) {
  return Object.entries(headers).map(function(_a2) {
    var _b2;
    var _c = __read7(_a2, 2), key = _c[0], value = _c[1];
    return {
      key: key.toLowerCase(),
      value: (_b2 = value === null || value === void 0 ? void 0 : value.trim().replace(/\s+/g, " ")) !== null && _b2 !== void 0 ? _b2 : ""
    };
  }).sort(function(a2, b2) {
    return a2.key < b2.key ? -1 : 1;
  }).map(function(entry) {
    return "".concat(entry.key, ":").concat(entry.value, "\n");
  }).join("");
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/signer/signatureV4/utils/getCanonicalQueryString.js
var __read8 = function(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var getCanonicalQueryString = function(searchParams) {
  return Array.from(searchParams).sort(function(_a2, _b2) {
    var _c = __read8(_a2, 2), keyA = _c[0], valA = _c[1];
    var _d = __read8(_b2, 2), keyB = _d[0], valB = _d[1];
    if (keyA === keyB) {
      return valA < valB ? -1 : 1;
    }
    return keyA < keyB ? -1 : 1;
  }).map(function(_a2) {
    var _b2 = __read8(_a2, 2), key = _b2[0], val2 = _b2[1];
    return "".concat(escapeUri(key), "=").concat(escapeUri(val2));
  }).join("&");
};
var escapeUri = function(uri) {
  return encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
};
var hexEncode = function(c2) {
  return "%".concat(c2.charCodeAt(0).toString(16).toUpperCase());
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/signer/signatureV4/utils/getCanonicalUri.js
var getCanonicalUri = function(pathname) {
  return pathname ? encodeURIComponent(pathname).replace(/%2F/g, "/") : "/";
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/signer/signatureV4/utils/getHashedPayload.js
var getHashedPayload = function(body) {
  if (body == null) {
    return EMPTY_HASH;
  }
  if (isSourceData(body)) {
    var hashedData = getHashedDataAsHex(null, body);
    return hashedData;
  }
  return UNSIGNED_PAYLOAD;
};
var isSourceData = function(body) {
  return typeof body === "string" || ArrayBuffer.isView(body) || isArrayBuffer(body);
};
var isArrayBuffer = function(arg) {
  return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/signer/signatureV4/utils/getCanonicalRequest.js
var getCanonicalRequest = function(_a2) {
  var body = _a2.body, headers = _a2.headers, method = _a2.method, url2 = _a2.url;
  return [
    method,
    getCanonicalUri(url2.pathname),
    getCanonicalQueryString(url2.searchParams),
    getCanonicalHeaders(headers),
    getSignedHeaders(headers),
    getHashedPayload(body)
  ].join("\n");
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/signer/signatureV4/utils/getSigningKey.js
var getSigningKey = function(secretAccessKey, date, region, service) {
  var key = "".concat(SIGNATURE_IDENTIFIER).concat(secretAccessKey);
  var dateKey = getHashedData(key, date);
  var regionKey = getHashedData(dateKey, region);
  var serviceKey = getHashedData(regionKey, service);
  var signingKey = getHashedData(serviceKey, KEY_TYPE_IDENTIFIER);
  return signingKey;
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/signer/signatureV4/utils/getStringToSign.js
var getStringToSign = function(date, credentialScope, hashedRequest) {
  return [SHA256_ALGORITHM_IDENTIFIER, date, credentialScope, hashedRequest].join("\n");
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/signer/signatureV4/utils/getSignature.js
var getSignature = function(request, _a2) {
  var credentialScope = _a2.credentialScope, longDate = _a2.longDate, secretAccessKey = _a2.secretAccessKey, shortDate = _a2.shortDate, signingRegion = _a2.signingRegion, signingService = _a2.signingService;
  var canonicalRequest = getCanonicalRequest(request);
  var hashedRequest = getHashedDataAsHex(null, canonicalRequest);
  var stringToSign = getStringToSign(longDate, credentialScope, hashedRequest);
  var signature = getHashedDataAsHex(getSigningKey(secretAccessKey, shortDate, signingRegion, signingService), stringToSign);
  return signature;
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/signer/signatureV4/signRequest.js
var __assign3 = function() {
  __assign3 = Object.assign || function(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign3.apply(this, arguments);
};
var signRequest = function(request, options) {
  var signingValues = getSigningValues(options);
  var accessKeyId = signingValues.accessKeyId, credentialScope = signingValues.credentialScope, longDate = signingValues.longDate, sessionToken = signingValues.sessionToken;
  var headers = __assign3({}, request.headers);
  headers[HOST_HEADER] = request.url.host;
  headers[AMZ_DATE_HEADER] = longDate;
  if (sessionToken) {
    headers[TOKEN_HEADER] = sessionToken;
  }
  var requestToSign = __assign3(__assign3({}, request), { headers });
  var signature = getSignature(requestToSign, signingValues);
  var credentialEntry = "Credential=".concat(accessKeyId, "/").concat(credentialScope);
  var signedHeadersEntry = "SignedHeaders=".concat(getSignedHeaders(headers));
  var signatureEntry = "Signature=".concat(signature);
  headers[AUTH_HEADER] = "".concat(SHA256_ALGORITHM_IDENTIFIER, " ").concat(credentialEntry, ", ").concat(signedHeadersEntry, ", ").concat(signatureEntry);
  return requestToSign;
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/signer/signatureV4/presignUrl.js
var __assign4 = function() {
  __assign4 = Object.assign || function(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign4.apply(this, arguments);
};
var __rest = function(s2, e) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
var __read9 = function(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var presignUrl = function(_a2, _b2) {
  var _c, _d, _e, _f;
  var body = _a2.body, _g = _a2.method, method = _g === void 0 ? "GET" : _g, url2 = _a2.url;
  var expiration = _b2.expiration, options = __rest(_b2, ["expiration"]);
  var signingValues = getSigningValues(options);
  var accessKeyId = signingValues.accessKeyId, credentialScope = signingValues.credentialScope, longDate = signingValues.longDate, sessionToken = signingValues.sessionToken;
  var presignedUrl = new URL(url2);
  Object.entries(__assign4(__assign4((_c = {}, _c[ALGORITHM_QUERY_PARAM] = SHA256_ALGORITHM_IDENTIFIER, _c[CREDENTIAL_QUERY_PARAM] = "".concat(accessKeyId, "/").concat(credentialScope), _c[AMZ_DATE_QUERY_PARAM] = longDate, _c[SIGNED_HEADERS_QUERY_PARAM] = HOST_HEADER, _c), expiration && (_d = {}, _d[EXPIRES_QUERY_PARAM] = expiration.toString(), _d)), sessionToken && (_e = {}, _e[TOKEN_QUERY_PARAM] = sessionToken, _e))).forEach(function(_a3) {
    var _b3 = __read9(_a3, 2), key = _b3[0], value = _b3[1];
    presignedUrl.searchParams.append(key, value);
  });
  var requestToSign = {
    body,
    headers: (_f = {}, _f[HOST_HEADER] = url2.host, _f),
    method,
    url: presignedUrl
  };
  var signature = getSignature(requestToSign, signingValues);
  presignedUrl.searchParams.append(SIGNATURE_QUERY_PARAM, signature);
  return presignedUrl;
};

// node_modules/@aws-amplify/core/lib-esm/Signer.js
var __assign5 = function() {
  __assign5 = Object.assign || function(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign5.apply(this, arguments);
};
var IOT_SERVICE_NAME = "iotdevicegateway";
var AWS_ENDPOINT_REGEX = /([^\.]+)\.(?:([^\.]*)\.)?amazonaws\.com(.cn)?$/;
var Signer = (
  /** @class */
  function() {
    function Signer2() {
    }
    Signer2.sign = function(request, accessInfo, serviceInfo) {
      request.headers = request.headers || {};
      if (request.body && !request.data) {
        throw new Error('The attribute "body" was found on the request object. Please use the attribute "data" instead.');
      }
      var requestToSign = __assign5(__assign5({}, request), { body: request.data, url: new URL(request.url) });
      var options = getOptions(requestToSign, accessInfo, serviceInfo);
      var signedRequest = signRequest(requestToSign, options);
      signedRequest.url = signedRequest.url.toString();
      signedRequest.headers.Authorization = signedRequest.headers.authorization;
      signedRequest.headers["X-Amz-Security-Token"] = signedRequest.headers["x-amz-security-token"];
      delete signedRequest.headers.authorization;
      delete signedRequest.headers["x-amz-security-token"];
      return signedRequest;
    };
    Signer2.signUrl = function(urlOrRequest, accessInfo, serviceInfo, expiration) {
      var urlToSign = typeof urlOrRequest === "object" ? urlOrRequest.url : urlOrRequest;
      var method = typeof urlOrRequest === "object" ? urlOrRequest.method : "GET";
      var body = typeof urlOrRequest === "object" ? urlOrRequest.body : void 0;
      var presignable = {
        body,
        method,
        url: new URL(urlToSign)
      };
      var options = getOptions(presignable, accessInfo, serviceInfo, expiration);
      var signedUrl = presignUrl(presignable, options);
      if (accessInfo.session_token && !sessionTokenRequiredInSigning(options.signingService)) {
        signedUrl.searchParams.append(TOKEN_QUERY_PARAM, accessInfo.session_token);
      }
      return signedUrl.toString();
    };
    return Signer2;
  }()
);
var getOptions = function(request, accessInfo, serviceInfo, expiration) {
  var _a2 = accessInfo !== null && accessInfo !== void 0 ? accessInfo : {}, access_key = _a2.access_key, secret_key = _a2.secret_key, session_token = _a2.session_token;
  var _b2 = parseServiceInfo(request.url), urlRegion = _b2.region, urlService = _b2.service;
  var _c = serviceInfo !== null && serviceInfo !== void 0 ? serviceInfo : {}, _d = _c.region, region = _d === void 0 ? urlRegion : _d, _e = _c.service, service = _e === void 0 ? urlService : _e;
  var credentials = __assign5({ accessKeyId: access_key, secretAccessKey: secret_key }, sessionTokenRequiredInSigning(service) ? { sessionToken: session_token } : {});
  return __assign5({ credentials, signingDate: DateUtils.getDateWithClockOffset(), signingRegion: region, signingService: service }, expiration && { expiration });
};
var parseServiceInfo = function(url2) {
  var _a2;
  var host = url2.host;
  var matched = (_a2 = host.match(AWS_ENDPOINT_REGEX)) !== null && _a2 !== void 0 ? _a2 : [];
  var parsed = matched.slice(1, 3);
  if (parsed[1] === "es") {
    parsed = parsed.reverse();
  }
  return {
    service: parsed[0],
    region: parsed[1]
  };
};
var sessionTokenRequiredInSigning = function(service) {
  return service !== IOT_SERVICE_NAME;
};

// node_modules/@aws-amplify/core/lib-esm/parseAWSExports.js
var __assign6 = function() {
  __assign6 = Object.assign || function(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign6.apply(this, arguments);
};
var logger7 = new ConsoleLogger("Parser");
var parseAWSExports = function(config) {
  var amplifyConfig = {};
  if (config["aws_mobile_analytics_app_id"]) {
    var Analytics2 = {
      AWSPinpoint: {
        appId: config["aws_mobile_analytics_app_id"],
        region: config["aws_mobile_analytics_app_region"]
      }
    };
    amplifyConfig.Analytics = Analytics2;
  }
  if (config["aws_cognito_identity_pool_id"] || config["aws_user_pools_id"]) {
    amplifyConfig.Auth = {
      userPoolId: config["aws_user_pools_id"],
      userPoolWebClientId: config["aws_user_pools_web_client_id"],
      region: config["aws_cognito_region"],
      identityPoolId: config["aws_cognito_identity_pool_id"],
      identityPoolRegion: config["aws_cognito_region"],
      mandatorySignIn: config["aws_mandatory_sign_in"] === "enable",
      signUpVerificationMethod: config["aws_cognito_sign_up_verification_method"] || "code"
    };
  }
  var storageConfig;
  if (config["aws_user_files_s3_bucket"]) {
    storageConfig = {
      AWSS3: {
        bucket: config["aws_user_files_s3_bucket"],
        region: config["aws_user_files_s3_bucket_region"],
        dangerouslyConnectToHttpEndpointForTesting: config["aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing"]
      }
    };
  } else {
    storageConfig = config ? config.Storage || config : {};
  }
  if (config["Logging"]) {
    amplifyConfig.Logging = __assign6(__assign6({}, config["Logging"]), { region: config["aws_project_region"] });
  }
  if (config["geo"]) {
    amplifyConfig.Geo = Object.assign({}, config.geo);
    if (config.geo["amazon_location_service"]) {
      amplifyConfig.Geo = {
        AmazonLocationService: config.geo["amazon_location_service"]
      };
    }
  }
  amplifyConfig.Analytics = Object.assign({}, amplifyConfig.Analytics, config.Analytics);
  amplifyConfig.Auth = Object.assign({}, amplifyConfig.Auth, config.Auth);
  amplifyConfig.Storage = Object.assign({}, storageConfig);
  amplifyConfig.Logging = Object.assign({}, amplifyConfig.Logging, config.Logging);
  logger7.debug("parse config", config, "to amplifyconfig", amplifyConfig);
  return amplifyConfig;
};

// node_modules/tslib/tslib.es6.mjs
var extendStatics = function(d2, b2) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b3) {
    d3.__proto__ = b3;
  } || function(d3, b3) {
    for (var p2 in b3)
      if (Object.prototype.hasOwnProperty.call(b3, p2))
        d3[p2] = b3[p2];
  };
  return extendStatics(d2, b2);
};
function __extends3(d2, b2) {
  if (typeof b2 !== "function" && b2 !== null)
    throw new TypeError("Class extends value " + String(b2) + " is not a constructor or null");
  extendStatics(d2, b2);
  function __() {
    this.constructor = d2;
  }
  d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
}
var __assign7 = function() {
  __assign7 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign7.apply(this, arguments);
};
function __rest2(s2, e) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
}
function __awaiter3(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator3(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (g2 && (g2 = 0, op[0] && (_2 = 0)), _2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __values4(o2) {
  var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
  if (m2)
    return m2.call(o2);
  if (o2 && typeof o2.length === "number")
    return {
      next: function() {
        if (o2 && i2 >= o2.length)
          o2 = void 0;
        return { value: o2 && o2[i2++], done: !o2 };
      }
    };
  throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read10(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}
function __spread() {
  for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
    ar = ar.concat(__read10(arguments[i2]));
  return ar;
}
function __spreadArray4(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i2 = 0, l2 = from.length, ar; i2 < l2; i2++) {
      if (ar || !(i2 in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i2);
        ar[i2] = from[i2];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
}
function __asyncValues(o2) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var m2 = o2[Symbol.asyncIterator], i2;
  return m2 ? m2.call(o2) : (o2 = typeof __values4 === "function" ? __values4(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
    return this;
  }, i2);
  function verb(n2) {
    i2[n2] = o2[n2] && function(v2) {
      return new Promise(function(resolve, reject) {
        v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
      });
    };
  }
  function settle(resolve, reject, d2, v2) {
    Promise.resolve(v2).then(function(v3) {
      resolve({ value: v3, done: d2 });
    }, reject);
  }
}

// node_modules/@aws-sdk/client-cloudwatch-logs/dist/es/package.json
var package_default = {
  name: "@aws-sdk/client-cloudwatch-logs",
  description: "AWS SDK for JavaScript Cloudwatch Logs Client for Node.js, Browser and React Native",
  version: "3.6.1",
  scripts: {
    clean: "yarn remove-definitions && yarn remove-dist && yarn remove-documentation",
    "build-documentation": "yarn remove-documentation && typedoc ./",
    prepublishOnly: "yarn build",
    pretest: "yarn build:cjs",
    "remove-definitions": "rimraf ./types",
    "remove-dist": "rimraf ./dist",
    "remove-documentation": "rimraf ./docs",
    test: "exit 0",
    "build:cjs": "tsc -p tsconfig.json",
    "build:es": "tsc -p tsconfig.es.json",
    build: "yarn build:cjs && yarn build:es",
    postbuild: "downlevel-dts types types/ts3.4"
  },
  main: "./dist/cjs/index.js",
  types: "./types/index.d.ts",
  module: "./dist/es/index.js",
  browser: {
    "./runtimeConfig": "./runtimeConfig.browser"
  },
  "react-native": {
    "./runtimeConfig": "./runtimeConfig.native"
  },
  sideEffects: false,
  dependencies: {
    "@aws-crypto/sha256-browser": "^1.0.0",
    "@aws-crypto/sha256-js": "^1.0.0",
    "@aws-sdk/config-resolver": "3.6.1",
    "@aws-sdk/credential-provider-node": "3.6.1",
    "@aws-sdk/fetch-http-handler": "3.6.1",
    "@aws-sdk/hash-node": "3.6.1",
    "@aws-sdk/invalid-dependency": "3.6.1",
    "@aws-sdk/middleware-content-length": "3.6.1",
    "@aws-sdk/middleware-host-header": "3.6.1",
    "@aws-sdk/middleware-logger": "3.6.1",
    "@aws-sdk/middleware-retry": "3.6.1",
    "@aws-sdk/middleware-serde": "3.6.1",
    "@aws-sdk/middleware-signing": "3.6.1",
    "@aws-sdk/middleware-stack": "3.6.1",
    "@aws-sdk/middleware-user-agent": "3.6.1",
    "@aws-sdk/node-config-provider": "3.6.1",
    "@aws-sdk/node-http-handler": "3.6.1",
    "@aws-sdk/protocol-http": "3.6.1",
    "@aws-sdk/smithy-client": "3.6.1",
    "@aws-sdk/types": "3.6.1",
    "@aws-sdk/url-parser": "3.6.1",
    "@aws-sdk/url-parser-native": "3.6.1",
    "@aws-sdk/util-base64-browser": "3.6.1",
    "@aws-sdk/util-base64-node": "3.6.1",
    "@aws-sdk/util-body-length-browser": "3.6.1",
    "@aws-sdk/util-body-length-node": "3.6.1",
    "@aws-sdk/util-user-agent-browser": "3.6.1",
    "@aws-sdk/util-user-agent-node": "3.6.1",
    "@aws-sdk/util-utf8-browser": "3.6.1",
    "@aws-sdk/util-utf8-node": "3.6.1",
    tslib: "^2.0.0"
  },
  devDependencies: {
    "@aws-sdk/client-documentation-generator": "3.6.1",
    "@types/node": "^12.7.5",
    "downlevel-dts": "0.7.0",
    jest: "^26.1.0",
    rimraf: "^3.0.0",
    typedoc: "^0.19.2",
    typescript: "~4.1.2"
  },
  engines: {
    node: ">=10.0.0"
  },
  typesVersions: {
    "<4.0": {
      "types/*": [
        "types/ts3.4/*"
      ]
    }
  },
  author: {
    name: "AWS SDK for JavaScript Team",
    url: "https://aws.amazon.com/javascript/"
  },
  license: "Apache-2.0",
  homepage: "https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-cloudwatch-logs",
  repository: {
    type: "git",
    url: "https://github.com/aws/aws-sdk-js-v3.git",
    directory: "clients/client-cloudwatch-logs"
  }
};

// node_modules/@aws-sdk/client-cloudwatch-logs/dist/es/runtimeConfig.browser.js
var import_sha256_browser = __toESM(require_build7());

// node_modules/@aws-sdk/fetch-http-handler/node_modules/tslib/tslib.es6.js
function __awaiter4(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator4(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __values5(o2) {
  var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
  if (m2)
    return m2.call(o2);
  if (o2 && typeof o2.length === "number")
    return {
      next: function() {
        if (o2 && i2 >= o2.length)
          o2 = void 0;
        return { value: o2 && o2[i2++], done: !o2 };
      }
    };
  throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

// node_modules/@aws-sdk/protocol-http/dist/es/httpResponse.js
var HttpResponse = (
  /** @class */
  function() {
    function HttpResponse4(options) {
      this.statusCode = options.statusCode;
      this.headers = options.headers || {};
      this.body = options.body;
    }
    HttpResponse4.isInstance = function(response) {
      if (!response)
        return false;
      var resp = response;
      return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    };
    return HttpResponse4;
  }()
);

// node_modules/@aws-sdk/protocol-http/node_modules/tslib/tslib.es6.js
var __assign8 = function() {
  __assign8 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign8.apply(this, arguments);
};
function __read11(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}
function __spread2() {
  for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
    ar = ar.concat(__read11(arguments[i2]));
  return ar;
}

// node_modules/@aws-sdk/protocol-http/dist/es/httpRequest.js
var HttpRequest = (
  /** @class */
  function() {
    function HttpRequest4(options) {
      this.method = options.method || "GET";
      this.hostname = options.hostname || "localhost";
      this.port = options.port;
      this.query = options.query || {};
      this.headers = options.headers || {};
      this.body = options.body;
      this.protocol = options.protocol ? options.protocol.substr(-1) !== ":" ? options.protocol + ":" : options.protocol : "https:";
      this.path = options.path ? options.path.charAt(0) !== "/" ? "/" + options.path : options.path : "/";
    }
    HttpRequest4.isInstance = function(request) {
      if (!request)
        return false;
      var req = request;
      return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    };
    HttpRequest4.prototype.clone = function() {
      var cloned = new HttpRequest4(__assign8(__assign8({}, this), { headers: __assign8({}, this.headers) }));
      if (cloned.query)
        cloned.query = cloneQuery(cloned.query);
      return cloned;
    };
    return HttpRequest4;
  }()
);
function cloneQuery(query) {
  return Object.keys(query).reduce(function(carry, paramName) {
    var _a2;
    var param = query[paramName];
    return __assign8(__assign8({}, carry), (_a2 = {}, _a2[paramName] = Array.isArray(param) ? __spread2(param) : param, _a2));
  }, {});
}

// node_modules/@aws-sdk/querystring-builder/node_modules/tslib/tslib.es6.js
function __values6(o2) {
  var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
  if (m2)
    return m2.call(o2);
  if (o2 && typeof o2.length === "number")
    return {
      next: function() {
        if (o2 && i2 >= o2.length)
          o2 = void 0;
        return { value: o2 && o2[i2++], done: !o2 };
      }
    };
  throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

// node_modules/@aws-sdk/util-uri-escape/dist/es/escape-uri.js
var escapeUri2 = function(uri) {
  return encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode2);
};
var hexEncode2 = function(c2) {
  return "%" + c2.charCodeAt(0).toString(16).toUpperCase();
};

// node_modules/@aws-sdk/querystring-builder/dist/es/index.js
function buildQueryString(query) {
  var e_1, _a2;
  var parts = [];
  try {
    for (var _b2 = __values6(Object.keys(query).sort()), _c = _b2.next(); !_c.done; _c = _b2.next()) {
      var key = _c.value;
      var value = query[key];
      key = escapeUri2(key);
      if (Array.isArray(value)) {
        for (var i2 = 0, iLen = value.length; i2 < iLen; i2++) {
          parts.push(key + "=" + escapeUri2(value[i2]));
        }
      } else {
        var qsEntry = key;
        if (value || typeof value === "string") {
          qsEntry += "=" + escapeUri2(value);
        }
        parts.push(qsEntry);
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_c && !_c.done && (_a2 = _b2.return))
        _a2.call(_b2);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return parts.join("&");
}

// node_modules/@aws-sdk/fetch-http-handler/dist/es/request-timeout.js
function requestTimeout(timeoutInMs) {
  if (timeoutInMs === void 0) {
    timeoutInMs = 0;
  }
  return new Promise(function(resolve, reject) {
    if (timeoutInMs) {
      setTimeout(function() {
        var timeoutError = new Error("Request did not complete within " + timeoutInMs + " ms");
        timeoutError.name = "TimeoutError";
        reject(timeoutError);
      }, timeoutInMs);
    }
  });
}

// node_modules/@aws-sdk/fetch-http-handler/dist/es/fetch-http-handler.js
var FetchHttpHandler = (
  /** @class */
  function() {
    function FetchHttpHandler4(_a2) {
      var _b2 = _a2 === void 0 ? {} : _a2, requestTimeout5 = _b2.requestTimeout;
      this.requestTimeout = requestTimeout5;
    }
    FetchHttpHandler4.prototype.destroy = function() {
    };
    FetchHttpHandler4.prototype.handle = function(request, _a2) {
      var _b2 = _a2 === void 0 ? {} : _a2, abortSignal = _b2.abortSignal;
      var requestTimeoutInMs = this.requestTimeout;
      if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
        var abortError = new Error("Request aborted");
        abortError.name = "AbortError";
        return Promise.reject(abortError);
      }
      var path = request.path;
      if (request.query) {
        var queryString = buildQueryString(request.query);
        if (queryString) {
          path += "?" + queryString;
        }
      }
      var port = request.port, method = request.method;
      var url2 = request.protocol + "//" + request.hostname + (port ? ":" + port : "") + path;
      var body = method === "GET" || method === "HEAD" ? void 0 : request.body;
      var requestOptions = {
        body,
        headers: new Headers(request.headers),
        method
      };
      if (typeof AbortController !== "undefined") {
        requestOptions["signal"] = abortSignal;
      }
      var fetchRequest = new Request(url2, requestOptions);
      var raceOfPromises = [
        fetch(fetchRequest).then(function(response) {
          var e_1, _a3;
          var fetchHeaders = response.headers;
          var transformedHeaders = {};
          try {
            for (var _b3 = __values5(fetchHeaders.entries()), _c = _b3.next(); !_c.done; _c = _b3.next()) {
              var pair = _c.value;
              transformedHeaders[pair[0]] = pair[1];
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (_c && !_c.done && (_a3 = _b3.return))
                _a3.call(_b3);
            } finally {
              if (e_1)
                throw e_1.error;
            }
          }
          var hasReadableStream = response.body !== void 0;
          if (!hasReadableStream) {
            return response.blob().then(function(body2) {
              return {
                response: new HttpResponse({
                  headers: transformedHeaders,
                  statusCode: response.status,
                  body: body2
                })
              };
            });
          }
          return {
            response: new HttpResponse({
              headers: transformedHeaders,
              statusCode: response.status,
              body: response.body
            })
          };
        }),
        requestTimeout(requestTimeoutInMs)
      ];
      if (abortSignal) {
        raceOfPromises.push(new Promise(function(resolve, reject) {
          abortSignal.onabort = function() {
            var abortError2 = new Error("Request aborted");
            abortError2.name = "AbortError";
            reject(abortError2);
          };
        }));
      }
      return Promise.race(raceOfPromises);
    };
    return FetchHttpHandler4;
  }()
);

// node_modules/@aws-sdk/util-base64-browser/dist/es/index.js
var alphabetByEncoding = {};
var alphabetByValue = new Array(64);
for (i2 = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i2 + start <= limit; i2++) {
  char = String.fromCharCode(i2 + start);
  alphabetByEncoding[char] = i2;
  alphabetByValue[i2] = char;
}
var char;
var i2;
var start;
var limit;
for (i2 = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i2 + start <= limit; i2++) {
  char = String.fromCharCode(i2 + start);
  index = i2 + 26;
  alphabetByEncoding[char] = index;
  alphabetByValue[index] = char;
}
var char;
var index;
var i2;
var start;
var limit;
for (i2 = 0; i2 < 10; i2++) {
  alphabetByEncoding[i2.toString(10)] = i2 + 52;
  char = i2.toString(10);
  index = i2 + 52;
  alphabetByEncoding[char] = index;
  alphabetByValue[index] = char;
}
var char;
var index;
var i2;
alphabetByEncoding["+"] = 62;
alphabetByValue[62] = "+";
alphabetByEncoding["/"] = 63;
alphabetByValue[63] = "/";
var bitsPerLetter = 6;
var bitsPerByte = 8;
var maxLetterValue = 63;
function fromBase64(input) {
  var totalByteLength = input.length / 4 * 3;
  if (input.substr(-2) === "==") {
    totalByteLength -= 2;
  } else if (input.substr(-1) === "=") {
    totalByteLength--;
  }
  var out = new ArrayBuffer(totalByteLength);
  var dataView = new DataView(out);
  for (var i2 = 0; i2 < input.length; i2 += 4) {
    var bits = 0;
    var bitLength = 0;
    for (var j2 = i2, limit = i2 + 3; j2 <= limit; j2++) {
      if (input[j2] !== "=") {
        bits |= alphabetByEncoding[input[j2]] << (limit - j2) * bitsPerLetter;
        bitLength += bitsPerLetter;
      } else {
        bits >>= bitsPerLetter;
      }
    }
    var chunkOffset = i2 / 4 * 3;
    bits >>= bitLength % bitsPerByte;
    var byteLength2 = Math.floor(bitLength / bitsPerByte);
    for (var k2 = 0; k2 < byteLength2; k2++) {
      var offset = (byteLength2 - k2 - 1) * bitsPerByte;
      dataView.setUint8(chunkOffset + k2, (bits & 255 << offset) >> offset);
    }
  }
  return new Uint8Array(out);
}
function toBase64(input) {
  var str = "";
  for (var i2 = 0; i2 < input.length; i2 += 3) {
    var bits = 0;
    var bitLength = 0;
    for (var j2 = i2, limit = Math.min(i2 + 3, input.length); j2 < limit; j2++) {
      bits |= input[j2] << (limit - j2 - 1) * bitsPerByte;
      bitLength += bitsPerByte;
    }
    var bitClusterCount = Math.ceil(bitLength / bitsPerLetter);
    bits <<= bitClusterCount * bitsPerLetter - bitLength;
    for (var k2 = 1; k2 <= bitClusterCount; k2++) {
      var offset = (bitClusterCount - k2) * bitsPerLetter;
      str += alphabetByValue[(bits & maxLetterValue << offset) >> offset];
    }
    str += "==".slice(0, 4 - bitClusterCount);
  }
  return str;
}

// node_modules/@aws-sdk/fetch-http-handler/dist/es/stream-collector.js
var streamCollector = function(stream) {
  if (typeof Blob === "function" && stream instanceof Blob) {
    return collectBlob(stream);
  }
  return collectStream(stream);
};
function collectBlob(blob) {
  return __awaiter4(this, void 0, void 0, function() {
    var base64, arrayBuffer;
    return __generator4(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, readToBase64(blob)];
        case 1:
          base64 = _a2.sent();
          arrayBuffer = fromBase64(base64);
          return [2, new Uint8Array(arrayBuffer)];
      }
    });
  });
}
function collectStream(stream) {
  return __awaiter4(this, void 0, void 0, function() {
    var res, reader, isDone, _a2, done, value, prior;
    return __generator4(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          res = new Uint8Array(0);
          reader = stream.getReader();
          isDone = false;
          _b2.label = 1;
        case 1:
          if (!!isDone)
            return [3, 3];
          return [4, reader.read()];
        case 2:
          _a2 = _b2.sent(), done = _a2.done, value = _a2.value;
          if (value) {
            prior = res;
            res = new Uint8Array(prior.length + value.length);
            res.set(prior);
            res.set(value, prior.length);
          }
          isDone = done;
          return [3, 1];
        case 3:
          return [2, res];
      }
    });
  });
}
function readToBase64(blob) {
  return new Promise(function(resolve, reject) {
    var reader = new FileReader();
    reader.onloadend = function() {
      var _a2;
      if (reader.readyState !== 2) {
        return reject(new Error("Reader aborted too early"));
      }
      var result = (_a2 = reader.result) !== null && _a2 !== void 0 ? _a2 : "";
      var commaIndex = result.indexOf(",");
      var dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
      resolve(result.substring(dataOffset));
    };
    reader.onabort = function() {
      return reject(new Error("Read aborted"));
    };
    reader.onerror = function() {
      return reject(reader.error);
    };
    reader.readAsDataURL(blob);
  });
}

// node_modules/@aws-sdk/invalid-dependency/dist/es/invalidProvider.js
var invalidProvider = function(message) {
  return function() {
    return Promise.reject(message);
  };
};

// node_modules/@aws-sdk/middleware-retry/node_modules/tslib/tslib.es6.js
var __assign9 = function() {
  __assign9 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign9.apply(this, arguments);
};
function __awaiter5(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator5(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __read12(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}
function __spread3() {
  for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
    ar = ar.concat(__read12(arguments[i2]));
  return ar;
}

// node_modules/@aws-sdk/middleware-retry/dist/es/retryMiddleware.js
var retryMiddleware = function(options) {
  return function(next, context) {
    return function(args) {
      return __awaiter5(void 0, void 0, void 0, function() {
        var _a2;
        return __generator5(this, function(_b2) {
          if ((_a2 = options === null || options === void 0 ? void 0 : options.retryStrategy) === null || _a2 === void 0 ? void 0 : _a2.mode)
            context.userAgent = __spread3(context.userAgent || [], [["cfg/retry-mode", options.retryStrategy.mode]]);
          return [2, options.retryStrategy.retry(next, args)];
        });
      });
    };
  };
};
var retryMiddlewareOptions = {
  name: "retryMiddleware",
  tags: ["RETRY"],
  step: "finalizeRequest",
  priority: "high",
  override: true
};
var getRetryPlugin = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(retryMiddleware(options), retryMiddlewareOptions);
    }
  };
};

// node_modules/@aws-sdk/middleware-retry/dist/es/constants.js
var DEFAULT_RETRY_DELAY_BASE = 100;
var MAXIMUM_RETRY_DELAY = 20 * 1e3;
var THROTTLING_RETRY_DELAY_BASE = 500;
var INITIAL_RETRY_TOKENS = 500;
var RETRY_COST = 5;
var TIMEOUT_RETRY_COST = 10;
var NO_RETRY_INCREMENT = 1;
var INVOCATION_ID_HEADER = "amz-sdk-invocation-id";
var REQUEST_HEADER = "amz-sdk-request";

// node_modules/@aws-sdk/service-error-classification/dist/es/constants.js
var CLOCK_SKEW_ERROR_CODES = [
  "AuthFailure",
  "InvalidSignatureException",
  "RequestExpired",
  "RequestInTheFuture",
  "RequestTimeTooSkewed",
  "SignatureDoesNotMatch"
];
var THROTTLING_ERROR_CODES = [
  "BandwidthLimitExceeded",
  "EC2ThrottledException",
  "LimitExceededException",
  "PriorRequestNotComplete",
  "ProvisionedThroughputExceededException",
  "RequestLimitExceeded",
  "RequestThrottled",
  "RequestThrottledException",
  "SlowDown",
  "ThrottledException",
  "Throttling",
  "ThrottlingException",
  "TooManyRequestsException",
  "TransactionInProgressException"
];
var TRANSIENT_ERROR_CODES = ["AbortError", "TimeoutError", "RequestTimeout", "RequestTimeoutException"];
var TRANSIENT_ERROR_STATUS_CODES = [500, 502, 503, 504];

// node_modules/@aws-sdk/service-error-classification/dist/es/index.js
var isRetryableByTrait = function(error) {
  return error.$retryable !== void 0;
};
var isClockSkewError = function(error) {
  return CLOCK_SKEW_ERROR_CODES.includes(error.name);
};
var isThrottlingError = function(error) {
  var _a2, _b2;
  return ((_a2 = error.$metadata) === null || _a2 === void 0 ? void 0 : _a2.httpStatusCode) === 429 || THROTTLING_ERROR_CODES.includes(error.name) || ((_b2 = error.$retryable) === null || _b2 === void 0 ? void 0 : _b2.throttling) == true;
};
var isTransientError = function(error) {
  var _a2;
  return TRANSIENT_ERROR_CODES.includes(error.name) || TRANSIENT_ERROR_STATUS_CODES.includes(((_a2 = error.$metadata) === null || _a2 === void 0 ? void 0 : _a2.httpStatusCode) || 0);
};

// node_modules/@aws-sdk/middleware-retry/dist/es/defaultStrategy.js
var import_uuid = __toESM(require_uuid());

// node_modules/@aws-sdk/middleware-retry/dist/es/defaultRetryQuota.js
var getDefaultRetryQuota = function(initialRetryTokens) {
  var MAX_CAPACITY = initialRetryTokens;
  var availableCapacity = initialRetryTokens;
  var getCapacityAmount = function(error) {
    return error.name === "TimeoutError" ? TIMEOUT_RETRY_COST : RETRY_COST;
  };
  var hasRetryTokens = function(error) {
    return getCapacityAmount(error) <= availableCapacity;
  };
  var retrieveRetryTokens = function(error) {
    if (!hasRetryTokens(error)) {
      throw new Error("No retry token available");
    }
    var capacityAmount = getCapacityAmount(error);
    availableCapacity -= capacityAmount;
    return capacityAmount;
  };
  var releaseRetryTokens = function(capacityReleaseAmount) {
    availableCapacity += capacityReleaseAmount !== null && capacityReleaseAmount !== void 0 ? capacityReleaseAmount : NO_RETRY_INCREMENT;
    availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
  };
  return Object.freeze({
    hasRetryTokens,
    retrieveRetryTokens,
    releaseRetryTokens
  });
};

// node_modules/@aws-sdk/middleware-retry/dist/es/delayDecider.js
var defaultDelayDecider = function(delayBase, attempts) {
  return Math.floor(Math.min(MAXIMUM_RETRY_DELAY, Math.random() * Math.pow(2, attempts) * delayBase));
};

// node_modules/@aws-sdk/middleware-retry/dist/es/retryDecider.js
var defaultRetryDecider = function(error) {
  if (!error) {
    return false;
  }
  return isRetryableByTrait(error) || isClockSkewError(error) || isThrottlingError(error) || isTransientError(error);
};

// node_modules/@aws-sdk/middleware-retry/dist/es/defaultStrategy.js
var DEFAULT_MAX_ATTEMPTS = 3;
var DEFAULT_RETRY_MODE = "standard";
var StandardRetryStrategy = (
  /** @class */
  function() {
    function StandardRetryStrategy4(maxAttemptsProvider, options) {
      var _a2, _b2, _c;
      this.maxAttemptsProvider = maxAttemptsProvider;
      this.mode = DEFAULT_RETRY_MODE;
      this.retryDecider = (_a2 = options === null || options === void 0 ? void 0 : options.retryDecider) !== null && _a2 !== void 0 ? _a2 : defaultRetryDecider;
      this.delayDecider = (_b2 = options === null || options === void 0 ? void 0 : options.delayDecider) !== null && _b2 !== void 0 ? _b2 : defaultDelayDecider;
      this.retryQuota = (_c = options === null || options === void 0 ? void 0 : options.retryQuota) !== null && _c !== void 0 ? _c : getDefaultRetryQuota(INITIAL_RETRY_TOKENS);
    }
    StandardRetryStrategy4.prototype.shouldRetry = function(error, attempts, maxAttempts) {
      return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    };
    StandardRetryStrategy4.prototype.getMaxAttempts = function() {
      return __awaiter5(this, void 0, void 0, function() {
        var maxAttempts, error_1;
        return __generator5(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 2, , 3]);
              return [4, this.maxAttemptsProvider()];
            case 1:
              maxAttempts = _a2.sent();
              return [3, 3];
            case 2:
              error_1 = _a2.sent();
              maxAttempts = DEFAULT_MAX_ATTEMPTS;
              return [3, 3];
            case 3:
              return [2, maxAttempts];
          }
        });
      });
    };
    StandardRetryStrategy4.prototype.retry = function(next, args) {
      return __awaiter5(this, void 0, void 0, function() {
        var retryTokenAmount, attempts, totalDelay, maxAttempts, request, _loop_1, this_1, state_1;
        return __generator5(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              attempts = 0;
              totalDelay = 0;
              return [4, this.getMaxAttempts()];
            case 1:
              maxAttempts = _a2.sent();
              request = args.request;
              if (HttpRequest.isInstance(request)) {
                request.headers[INVOCATION_ID_HEADER] = (0, import_uuid.v4)();
              }
              _loop_1 = function() {
                var _a3, response, output, err_1, delay_1;
                return __generator5(this, function(_b2) {
                  switch (_b2.label) {
                    case 0:
                      _b2.trys.push([0, 2, , 5]);
                      if (HttpRequest.isInstance(request)) {
                        request.headers[REQUEST_HEADER] = "attempt=" + (attempts + 1) + "; max=" + maxAttempts;
                      }
                      return [4, next(args)];
                    case 1:
                      _a3 = _b2.sent(), response = _a3.response, output = _a3.output;
                      this_1.retryQuota.releaseRetryTokens(retryTokenAmount);
                      output.$metadata.attempts = attempts + 1;
                      output.$metadata.totalRetryDelay = totalDelay;
                      return [2, { value: { response, output } }];
                    case 2:
                      err_1 = _b2.sent();
                      attempts++;
                      if (!this_1.shouldRetry(err_1, attempts, maxAttempts))
                        return [3, 4];
                      retryTokenAmount = this_1.retryQuota.retrieveRetryTokens(err_1);
                      delay_1 = this_1.delayDecider(isThrottlingError(err_1) ? THROTTLING_RETRY_DELAY_BASE : DEFAULT_RETRY_DELAY_BASE, attempts);
                      totalDelay += delay_1;
                      return [4, new Promise(function(resolve) {
                        return setTimeout(resolve, delay_1);
                      })];
                    case 3:
                      _b2.sent();
                      return [2, "continue"];
                    case 4:
                      if (!err_1.$metadata) {
                        err_1.$metadata = {};
                      }
                      err_1.$metadata.attempts = attempts;
                      err_1.$metadata.totalRetryDelay = totalDelay;
                      throw err_1;
                    case 5:
                      return [
                        2
                        /*return*/
                      ];
                  }
                });
              };
              this_1 = this;
              _a2.label = 2;
            case 2:
              if (false)
                return [3, 4];
              return [5, _loop_1()];
            case 3:
              state_1 = _a2.sent();
              if (typeof state_1 === "object")
                return [2, state_1.value];
              return [3, 2];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    return StandardRetryStrategy4;
  }()
);

// node_modules/@aws-sdk/middleware-retry/dist/es/configurations.js
var resolveRetryConfig = function(input) {
  var maxAttempts = normalizeMaxAttempts(input.maxAttempts);
  return __assign9(__assign9({}, input), { maxAttempts, retryStrategy: input.retryStrategy || new StandardRetryStrategy(maxAttempts) });
};
var normalizeMaxAttempts = function(maxAttempts) {
  if (maxAttempts === void 0) {
    maxAttempts = DEFAULT_MAX_ATTEMPTS;
  }
  if (typeof maxAttempts === "number") {
    var promisified_1 = Promise.resolve(maxAttempts);
    return function() {
      return promisified_1;
    };
  }
  return maxAttempts;
};

// node_modules/@aws-sdk/util-body-length-browser/dist/es/index.js
function calculateBodyLength(body) {
  if (typeof body === "string") {
    var len = body.length;
    for (var i2 = len - 1; i2 >= 0; i2--) {
      var code = body.charCodeAt(i2);
      if (code > 127 && code <= 2047)
        len++;
      else if (code > 2047 && code <= 65535)
        len += 2;
    }
    return len;
  } else if (typeof body.byteLength === "number") {
    return body.byteLength;
  } else if (typeof body.size === "number") {
    return body.size;
  }
}

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-sdk/util-user-agent-browser/node_modules/tslib/tslib.es6.js
function __awaiter6(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator6(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/bowser/src/constants.js
var BROWSER_ALIASES_MAP = {
  "Amazon Silk": "amazon_silk",
  "Android Browser": "android",
  Bada: "bada",
  BlackBerry: "blackberry",
  Chrome: "chrome",
  Chromium: "chromium",
  Electron: "electron",
  Epiphany: "epiphany",
  Firefox: "firefox",
  Focus: "focus",
  Generic: "generic",
  "Google Search": "google_search",
  Googlebot: "googlebot",
  "Internet Explorer": "ie",
  "K-Meleon": "k_meleon",
  Maxthon: "maxthon",
  "Microsoft Edge": "edge",
  "MZ Browser": "mz",
  "NAVER Whale Browser": "naver",
  Opera: "opera",
  "Opera Coast": "opera_coast",
  PhantomJS: "phantomjs",
  Puffin: "puffin",
  QupZilla: "qupzilla",
  QQ: "qq",
  QQLite: "qqlite",
  Safari: "safari",
  Sailfish: "sailfish",
  "Samsung Internet for Android": "samsung_internet",
  SeaMonkey: "seamonkey",
  Sleipnir: "sleipnir",
  Swing: "swing",
  Tizen: "tizen",
  "UC Browser": "uc",
  Vivaldi: "vivaldi",
  "WebOS Browser": "webos",
  WeChat: "wechat",
  "Yandex Browser": "yandex",
  Roku: "roku"
};
var BROWSER_MAP = {
  amazon_silk: "Amazon Silk",
  android: "Android Browser",
  bada: "Bada",
  blackberry: "BlackBerry",
  chrome: "Chrome",
  chromium: "Chromium",
  electron: "Electron",
  epiphany: "Epiphany",
  firefox: "Firefox",
  focus: "Focus",
  generic: "Generic",
  googlebot: "Googlebot",
  google_search: "Google Search",
  ie: "Internet Explorer",
  k_meleon: "K-Meleon",
  maxthon: "Maxthon",
  edge: "Microsoft Edge",
  mz: "MZ Browser",
  naver: "NAVER Whale Browser",
  opera: "Opera",
  opera_coast: "Opera Coast",
  phantomjs: "PhantomJS",
  puffin: "Puffin",
  qupzilla: "QupZilla",
  qq: "QQ Browser",
  qqlite: "QQ Browser Lite",
  safari: "Safari",
  sailfish: "Sailfish",
  samsung_internet: "Samsung Internet for Android",
  seamonkey: "SeaMonkey",
  sleipnir: "Sleipnir",
  swing: "Swing",
  tizen: "Tizen",
  uc: "UC Browser",
  vivaldi: "Vivaldi",
  webos: "WebOS Browser",
  wechat: "WeChat",
  yandex: "Yandex Browser"
};
var PLATFORMS_MAP = {
  tablet: "tablet",
  mobile: "mobile",
  desktop: "desktop",
  tv: "tv"
};
var OS_MAP = {
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MacOS: "macOS",
  iOS: "iOS",
  Android: "Android",
  WebOS: "WebOS",
  BlackBerry: "BlackBerry",
  Bada: "Bada",
  Tizen: "Tizen",
  Linux: "Linux",
  ChromeOS: "Chrome OS",
  PlayStation4: "PlayStation 4",
  Roku: "Roku"
};
var ENGINE_MAP = {
  EdgeHTML: "EdgeHTML",
  Blink: "Blink",
  Trident: "Trident",
  Presto: "Presto",
  Gecko: "Gecko",
  WebKit: "WebKit"
};

// node_modules/bowser/src/utils.js
var Utils = class {
  /**
   * Get first matched item for a string
   * @param {RegExp} regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */
  static getFirstMatch(regexp, ua) {
    const match = ua.match(regexp);
    return match && match.length > 0 && match[1] || "";
  }
  /**
   * Get second matched item for a string
   * @param regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */
  static getSecondMatch(regexp, ua) {
    const match = ua.match(regexp);
    return match && match.length > 1 && match[2] || "";
  }
  /**
   * Match a regexp and return a constant or undefined
   * @param {RegExp} regexp
   * @param {String} ua
   * @param {*} _const Any const that will be returned if regexp matches the string
   * @return {*}
   */
  static matchAndReturnConst(regexp, ua, _const) {
    if (regexp.test(ua)) {
      return _const;
    }
    return void 0;
  }
  static getWindowsVersionName(version3) {
    switch (version3) {
      case "NT":
        return "NT";
      case "XP":
        return "XP";
      case "NT 5.0":
        return "2000";
      case "NT 5.1":
        return "XP";
      case "NT 5.2":
        return "2003";
      case "NT 6.0":
        return "Vista";
      case "NT 6.1":
        return "7";
      case "NT 6.2":
        return "8";
      case "NT 6.3":
        return "8.1";
      case "NT 10.0":
        return "10";
      default:
        return void 0;
    }
  }
  /**
   * Get macOS version name
   *    10.5 - Leopard
   *    10.6 - Snow Leopard
   *    10.7 - Lion
   *    10.8 - Mountain Lion
   *    10.9 - Mavericks
   *    10.10 - Yosemite
   *    10.11 - El Capitan
   *    10.12 - Sierra
   *    10.13 - High Sierra
   *    10.14 - Mojave
   *    10.15 - Catalina
   *
   * @example
   *   getMacOSVersionName("10.14") // 'Mojave'
   *
   * @param  {string} version
   * @return {string} versionName
   */
  static getMacOSVersionName(version3) {
    const v2 = version3.split(".").splice(0, 2).map((s2) => parseInt(s2, 10) || 0);
    v2.push(0);
    if (v2[0] !== 10)
      return void 0;
    switch (v2[1]) {
      case 5:
        return "Leopard";
      case 6:
        return "Snow Leopard";
      case 7:
        return "Lion";
      case 8:
        return "Mountain Lion";
      case 9:
        return "Mavericks";
      case 10:
        return "Yosemite";
      case 11:
        return "El Capitan";
      case 12:
        return "Sierra";
      case 13:
        return "High Sierra";
      case 14:
        return "Mojave";
      case 15:
        return "Catalina";
      default:
        return void 0;
    }
  }
  /**
   * Get Android version name
   *    1.5 - Cupcake
   *    1.6 - Donut
   *    2.0 - Eclair
   *    2.1 - Eclair
   *    2.2 - Froyo
   *    2.x - Gingerbread
   *    3.x - Honeycomb
   *    4.0 - Ice Cream Sandwich
   *    4.1 - Jelly Bean
   *    4.4 - KitKat
   *    5.x - Lollipop
   *    6.x - Marshmallow
   *    7.x - Nougat
   *    8.x - Oreo
   *    9.x - Pie
   *
   * @example
   *   getAndroidVersionName("7.0") // 'Nougat'
   *
   * @param  {string} version
   * @return {string} versionName
   */
  static getAndroidVersionName(version3) {
    const v2 = version3.split(".").splice(0, 2).map((s2) => parseInt(s2, 10) || 0);
    v2.push(0);
    if (v2[0] === 1 && v2[1] < 5)
      return void 0;
    if (v2[0] === 1 && v2[1] < 6)
      return "Cupcake";
    if (v2[0] === 1 && v2[1] >= 6)
      return "Donut";
    if (v2[0] === 2 && v2[1] < 2)
      return "Eclair";
    if (v2[0] === 2 && v2[1] === 2)
      return "Froyo";
    if (v2[0] === 2 && v2[1] > 2)
      return "Gingerbread";
    if (v2[0] === 3)
      return "Honeycomb";
    if (v2[0] === 4 && v2[1] < 1)
      return "Ice Cream Sandwich";
    if (v2[0] === 4 && v2[1] < 4)
      return "Jelly Bean";
    if (v2[0] === 4 && v2[1] >= 4)
      return "KitKat";
    if (v2[0] === 5)
      return "Lollipop";
    if (v2[0] === 6)
      return "Marshmallow";
    if (v2[0] === 7)
      return "Nougat";
    if (v2[0] === 8)
      return "Oreo";
    if (v2[0] === 9)
      return "Pie";
    return void 0;
  }
  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  static getVersionPrecision(version3) {
    return version3.split(".").length;
  }
  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions('1.10.2.1',  '1.8.2.1.90')    // 1
   *   compareVersions('1.010.2.1', '1.09.2.1.90');  // 1
   *   compareVersions('1.10.2.1',  '1.10.2.1');     // 0
   *   compareVersions('1.10.2.1',  '1.0800.2');     // -1
   *   compareVersions('1.10.2.1',  '1.10',  true);  // 0
   *
   * @param {String} versionA versions versions to compare
   * @param {String} versionB versions versions to compare
   * @param {boolean} [isLoose] enable loose comparison
   * @return {Number} comparison result: -1 when versionA is lower,
   * 1 when versionA is bigger, 0 when both equal
   */
  /* eslint consistent-return: 1 */
  static compareVersions(versionA, versionB, isLoose = false) {
    const versionAPrecision = Utils.getVersionPrecision(versionA);
    const versionBPrecision = Utils.getVersionPrecision(versionB);
    let precision = Math.max(versionAPrecision, versionBPrecision);
    let lastPrecision = 0;
    const chunks = Utils.map([versionA, versionB], (version3) => {
      const delta = precision - Utils.getVersionPrecision(version3);
      const _version = version3 + new Array(delta + 1).join(".0");
      return Utils.map(_version.split("."), (chunk) => new Array(20 - chunk.length).join("0") + chunk).reverse();
    });
    if (isLoose) {
      lastPrecision = precision - Math.min(versionAPrecision, versionBPrecision);
    }
    precision -= 1;
    while (precision >= lastPrecision) {
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === lastPrecision) {
          return 0;
        }
        precision -= 1;
      } else if (chunks[0][precision] < chunks[1][precision]) {
        return -1;
      }
    }
    return void 0;
  }
  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  static map(arr, iterator) {
    const result = [];
    let i2;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i2 = 0; i2 < arr.length; i2 += 1) {
      result.push(iterator(arr[i2]));
    }
    return result;
  }
  /**
   * Array::find polyfill
   *
   * @param  {Array} arr
   * @param  {Function} predicate
   * @return {Array}
   */
  static find(arr, predicate) {
    let i2;
    let l2;
    if (Array.prototype.find) {
      return Array.prototype.find.call(arr, predicate);
    }
    for (i2 = 0, l2 = arr.length; i2 < l2; i2 += 1) {
      const value = arr[i2];
      if (predicate(value, i2)) {
        return value;
      }
    }
    return void 0;
  }
  /**
   * Object::assign polyfill
   *
   * @param  {Object} obj
   * @param  {Object} ...objs
   * @return {Object}
   */
  static assign(obj, ...assigners) {
    const result = obj;
    let i2;
    let l2;
    if (Object.assign) {
      return Object.assign(obj, ...assigners);
    }
    for (i2 = 0, l2 = assigners.length; i2 < l2; i2 += 1) {
      const assigner = assigners[i2];
      if (typeof assigner === "object" && assigner !== null) {
        const keys = Object.keys(assigner);
        keys.forEach((key) => {
          result[key] = assigner[key];
        });
      }
    }
    return obj;
  }
  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('Microsoft Edge') // edge
   *
   * @param  {string} browserName
   * @return {string}
   */
  static getBrowserAlias(browserName) {
    return BROWSER_ALIASES_MAP[browserName];
  }
  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('edge') // Microsoft Edge
   *
   * @param  {string} browserAlias
   * @return {string}
   */
  static getBrowserTypeByAlias(browserAlias) {
    return BROWSER_MAP[browserAlias] || "";
  }
};

// node_modules/bowser/src/parser-browsers.js
var commonVersionIdentifier = /version\/(\d+(\.?_?\d+)+)/i;
var browsersList = [
  /* Googlebot */
  {
    test: [/googlebot/i],
    describe(ua) {
      const browser = {
        name: "Googlebot"
      };
      const version3 = Utils.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  /* Opera < 13.0 */
  {
    test: [/opera/i],
    describe(ua) {
      const browser = {
        name: "Opera"
      };
      const version3 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  /* Opera > 13.0 */
  {
    test: [/opr\/|opios/i],
    describe(ua) {
      const browser = {
        name: "Opera"
      };
      const version3 = Utils.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/SamsungBrowser/i],
    describe(ua) {
      const browser = {
        name: "Samsung Internet for Android"
      };
      const version3 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/Whale/i],
    describe(ua) {
      const browser = {
        name: "NAVER Whale Browser"
      };
      const version3 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/MZBrowser/i],
    describe(ua) {
      const browser = {
        name: "MZ Browser"
      };
      const version3 = Utils.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/focus/i],
    describe(ua) {
      const browser = {
        name: "Focus"
      };
      const version3 = Utils.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/swing/i],
    describe(ua) {
      const browser = {
        name: "Swing"
      };
      const version3 = Utils.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/coast/i],
    describe(ua) {
      const browser = {
        name: "Opera Coast"
      };
      const version3 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/opt\/\d+(?:.?_?\d+)+/i],
    describe(ua) {
      const browser = {
        name: "Opera Touch"
      };
      const version3 = Utils.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/yabrowser/i],
    describe(ua) {
      const browser = {
        name: "Yandex Browser"
      };
      const version3 = Utils.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/ucbrowser/i],
    describe(ua) {
      const browser = {
        name: "UC Browser"
      };
      const version3 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/Maxthon|mxios/i],
    describe(ua) {
      const browser = {
        name: "Maxthon"
      };
      const version3 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/epiphany/i],
    describe(ua) {
      const browser = {
        name: "Epiphany"
      };
      const version3 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/puffin/i],
    describe(ua) {
      const browser = {
        name: "Puffin"
      };
      const version3 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/sleipnir/i],
    describe(ua) {
      const browser = {
        name: "Sleipnir"
      };
      const version3 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/k-meleon/i],
    describe(ua) {
      const browser = {
        name: "K-Meleon"
      };
      const version3 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/micromessenger/i],
    describe(ua) {
      const browser = {
        name: "WeChat"
      };
      const version3 = Utils.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/qqbrowser/i],
    describe(ua) {
      const browser = {
        name: /qqbrowserlite/i.test(ua) ? "QQ Browser Lite" : "QQ Browser"
      };
      const version3 = Utils.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/msie|trident/i],
    describe(ua) {
      const browser = {
        name: "Internet Explorer"
      };
      const version3 = Utils.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/\sedg\//i],
    describe(ua) {
      const browser = {
        name: "Microsoft Edge"
      };
      const version3 = Utils.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/edg([ea]|ios)/i],
    describe(ua) {
      const browser = {
        name: "Microsoft Edge"
      };
      const version3 = Utils.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/vivaldi/i],
    describe(ua) {
      const browser = {
        name: "Vivaldi"
      };
      const version3 = Utils.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/seamonkey/i],
    describe(ua) {
      const browser = {
        name: "SeaMonkey"
      };
      const version3 = Utils.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/sailfish/i],
    describe(ua) {
      const browser = {
        name: "Sailfish"
      };
      const version3 = Utils.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/silk/i],
    describe(ua) {
      const browser = {
        name: "Amazon Silk"
      };
      const version3 = Utils.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/phantom/i],
    describe(ua) {
      const browser = {
        name: "PhantomJS"
      };
      const version3 = Utils.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/slimerjs/i],
    describe(ua) {
      const browser = {
        name: "SlimerJS"
      };
      const version3 = Utils.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(ua) {
      const browser = {
        name: "BlackBerry"
      };
      const version3 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/(web|hpw)[o0]s/i],
    describe(ua) {
      const browser = {
        name: "WebOS Browser"
      };
      const version3 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/bada/i],
    describe(ua) {
      const browser = {
        name: "Bada"
      };
      const version3 = Utils.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/tizen/i],
    describe(ua) {
      const browser = {
        name: "Tizen"
      };
      const version3 = Utils.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/qupzilla/i],
    describe(ua) {
      const browser = {
        name: "QupZilla"
      };
      const version3 = Utils.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/firefox|iceweasel|fxios/i],
    describe(ua) {
      const browser = {
        name: "Firefox"
      };
      const version3 = Utils.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/electron/i],
    describe(ua) {
      const browser = {
        name: "Electron"
      };
      const version3 = Utils.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/MiuiBrowser/i],
    describe(ua) {
      const browser = {
        name: "Miui"
      };
      const version3 = Utils.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/chromium/i],
    describe(ua) {
      const browser = {
        name: "Chromium"
      };
      const version3 = Utils.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/chrome|crios|crmo/i],
    describe(ua) {
      const browser = {
        name: "Chrome"
      };
      const version3 = Utils.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  {
    test: [/GSA/i],
    describe(ua) {
      const browser = {
        name: "Google Search"
      };
      const version3 = Utils.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  /* Android Browser */
  {
    test(parser2) {
      const notLikeAndroid = !parser2.test(/like android/i);
      const butAndroid = parser2.test(/android/i);
      return notLikeAndroid && butAndroid;
    },
    describe(ua) {
      const browser = {
        name: "Android Browser"
      };
      const version3 = Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  /* PlayStation 4 */
  {
    test: [/playstation 4/i],
    describe(ua) {
      const browser = {
        name: "PlayStation 4"
      };
      const version3 = Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  /* Safari */
  {
    test: [/safari|applewebkit/i],
    describe(ua) {
      const browser = {
        name: "Safari"
      };
      const version3 = Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version3) {
        browser.version = version3;
      }
      return browser;
    }
  },
  /* Something else */
  {
    test: [/.*/i],
    describe(ua) {
      const regexpWithoutDeviceSpec = /^(.*)\/(.*) /;
      const regexpWithDeviceSpec = /^(.*)\/(.*)[ \t]\((.*)/;
      const hasDeviceSpec = ua.search("\\(") !== -1;
      const regexp = hasDeviceSpec ? regexpWithDeviceSpec : regexpWithoutDeviceSpec;
      return {
        name: Utils.getFirstMatch(regexp, ua),
        version: Utils.getSecondMatch(regexp, ua)
      };
    }
  }
];
var parser_browsers_default = browsersList;

// node_modules/bowser/src/parser-os.js
var parser_os_default = [
  /* Roku */
  {
    test: [/Roku\/DVP/],
    describe(ua) {
      const version3 = Utils.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, ua);
      return {
        name: OS_MAP.Roku,
        version: version3
      };
    }
  },
  /* Windows Phone */
  {
    test: [/windows phone/i],
    describe(ua) {
      const version3 = Utils.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.WindowsPhone,
        version: version3
      };
    }
  },
  /* Windows */
  {
    test: [/windows /i],
    describe(ua) {
      const version3 = Utils.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, ua);
      const versionName = Utils.getWindowsVersionName(version3);
      return {
        name: OS_MAP.Windows,
        version: version3,
        versionName
      };
    }
  },
  /* Firefox on iPad */
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe(ua) {
      const result = {
        name: OS_MAP.iOS
      };
      const version3 = Utils.getSecondMatch(/(Version\/)(\d[\d.]+)/, ua);
      if (version3) {
        result.version = version3;
      }
      return result;
    }
  },
  /* macOS */
  {
    test: [/macintosh/i],
    describe(ua) {
      const version3 = Utils.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, ua).replace(/[_\s]/g, ".");
      const versionName = Utils.getMacOSVersionName(version3);
      const os = {
        name: OS_MAP.MacOS,
        version: version3
      };
      if (versionName) {
        os.versionName = versionName;
      }
      return os;
    }
  },
  /* iOS */
  {
    test: [/(ipod|iphone|ipad)/i],
    describe(ua) {
      const version3 = Utils.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, ua).replace(/[_\s]/g, ".");
      return {
        name: OS_MAP.iOS,
        version: version3
      };
    }
  },
  /* Android */
  {
    test(parser2) {
      const notLikeAndroid = !parser2.test(/like android/i);
      const butAndroid = parser2.test(/android/i);
      return notLikeAndroid && butAndroid;
    },
    describe(ua) {
      const version3 = Utils.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, ua);
      const versionName = Utils.getAndroidVersionName(version3);
      const os = {
        name: OS_MAP.Android,
        version: version3
      };
      if (versionName) {
        os.versionName = versionName;
      }
      return os;
    }
  },
  /* WebOS */
  {
    test: [/(web|hpw)[o0]s/i],
    describe(ua) {
      const version3 = Utils.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, ua);
      const os = {
        name: OS_MAP.WebOS
      };
      if (version3 && version3.length) {
        os.version = version3;
      }
      return os;
    }
  },
  /* BlackBerry */
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(ua) {
      const version3 = Utils.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, ua) || Utils.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, ua) || Utils.getFirstMatch(/\bbb(\d+)/i, ua);
      return {
        name: OS_MAP.BlackBerry,
        version: version3
      };
    }
  },
  /* Bada */
  {
    test: [/bada/i],
    describe(ua) {
      const version3 = Utils.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.Bada,
        version: version3
      };
    }
  },
  /* Tizen */
  {
    test: [/tizen/i],
    describe(ua) {
      const version3 = Utils.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.Tizen,
        version: version3
      };
    }
  },
  /* Linux */
  {
    test: [/linux/i],
    describe() {
      return {
        name: OS_MAP.Linux
      };
    }
  },
  /* Chrome OS */
  {
    test: [/CrOS/],
    describe() {
      return {
        name: OS_MAP.ChromeOS
      };
    }
  },
  /* Playstation 4 */
  {
    test: [/PlayStation 4/],
    describe(ua) {
      const version3 = Utils.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.PlayStation4,
        version: version3
      };
    }
  }
];

// node_modules/bowser/src/parser-platforms.js
var parser_platforms_default = [
  /* Googlebot */
  {
    test: [/googlebot/i],
    describe() {
      return {
        type: "bot",
        vendor: "Google"
      };
    }
  },
  /* Huawei */
  {
    test: [/huawei/i],
    describe(ua) {
      const model = Utils.getFirstMatch(/(can-l01)/i, ua) && "Nova";
      const platform = {
        type: PLATFORMS_MAP.mobile,
        vendor: "Huawei"
      };
      if (model) {
        platform.model = model;
      }
      return platform;
    }
  },
  /* Nexus Tablet */
  {
    test: [/nexus\s*(?:7|8|9|10).*/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Nexus"
      };
    }
  },
  /* iPad */
  {
    test: [/ipad/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  /* Firefox on iPad */
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  /* Amazon Kindle Fire */
  {
    test: [/kftt build/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Amazon",
        model: "Kindle Fire HD 7"
      };
    }
  },
  /* Another Amazon Tablet with Silk */
  {
    test: [/silk/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Amazon"
      };
    }
  },
  /* Tablet */
  {
    test: [/tablet(?! pc)/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet
      };
    }
  },
  /* iPod/iPhone */
  {
    test(parser2) {
      const iDevice = parser2.test(/ipod|iphone/i);
      const likeIDevice = parser2.test(/like (ipod|iphone)/i);
      return iDevice && !likeIDevice;
    },
    describe(ua) {
      const model = Utils.getFirstMatch(/(ipod|iphone)/i, ua);
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: "Apple",
        model
      };
    }
  },
  /* Nexus Mobile */
  {
    test: [/nexus\s*[0-6].*/i, /galaxy nexus/i],
    describe() {
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: "Nexus"
      };
    }
  },
  /* Mobile */
  {
    test: [/[^-]mobi/i],
    describe() {
      return {
        type: PLATFORMS_MAP.mobile
      };
    }
  },
  /* BlackBerry */
  {
    test(parser2) {
      return parser2.getBrowserName(true) === "blackberry";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: "BlackBerry"
      };
    }
  },
  /* Bada */
  {
    test(parser2) {
      return parser2.getBrowserName(true) === "bada";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile
      };
    }
  },
  /* Windows Phone */
  {
    test(parser2) {
      return parser2.getBrowserName() === "windows phone";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: "Microsoft"
      };
    }
  },
  /* Android Tablet */
  {
    test(parser2) {
      const osMajorVersion = Number(String(parser2.getOSVersion()).split(".")[0]);
      return parser2.getOSName(true) === "android" && osMajorVersion >= 3;
    },
    describe() {
      return {
        type: PLATFORMS_MAP.tablet
      };
    }
  },
  /* Android Mobile */
  {
    test(parser2) {
      return parser2.getOSName(true) === "android";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile
      };
    }
  },
  /* desktop */
  {
    test(parser2) {
      return parser2.getOSName(true) === "macos";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.desktop,
        vendor: "Apple"
      };
    }
  },
  /* Windows */
  {
    test(parser2) {
      return parser2.getOSName(true) === "windows";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.desktop
      };
    }
  },
  /* Linux */
  {
    test(parser2) {
      return parser2.getOSName(true) === "linux";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.desktop
      };
    }
  },
  /* PlayStation 4 */
  {
    test(parser2) {
      return parser2.getOSName(true) === "playstation 4";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.tv
      };
    }
  },
  /* Roku */
  {
    test(parser2) {
      return parser2.getOSName(true) === "roku";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.tv
      };
    }
  }
];

// node_modules/bowser/src/parser-engines.js
var parser_engines_default = [
  /* EdgeHTML */
  {
    test(parser2) {
      return parser2.getBrowserName(true) === "microsoft edge";
    },
    describe(ua) {
      const isBlinkBased = /\sedg\//i.test(ua);
      if (isBlinkBased) {
        return {
          name: ENGINE_MAP.Blink
        };
      }
      const version3 = Utils.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, ua);
      return {
        name: ENGINE_MAP.EdgeHTML,
        version: version3
      };
    }
  },
  /* Trident */
  {
    test: [/trident/i],
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.Trident
      };
      const version3 = Utils.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        engine.version = version3;
      }
      return engine;
    }
  },
  /* Presto */
  {
    test(parser2) {
      return parser2.test(/presto/i);
    },
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.Presto
      };
      const version3 = Utils.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        engine.version = version3;
      }
      return engine;
    }
  },
  /* Gecko */
  {
    test(parser2) {
      const isGecko = parser2.test(/gecko/i);
      const likeGecko = parser2.test(/like gecko/i);
      return isGecko && !likeGecko;
    },
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.Gecko
      };
      const version3 = Utils.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        engine.version = version3;
      }
      return engine;
    }
  },
  /* Blink */
  {
    test: [/(apple)?webkit\/537\.36/i],
    describe() {
      return {
        name: ENGINE_MAP.Blink
      };
    }
  },
  /* WebKit */
  {
    test: [/(apple)?webkit/i],
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.WebKit
      };
      const version3 = Utils.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, ua);
      if (version3) {
        engine.version = version3;
      }
      return engine;
    }
  }
];

// node_modules/bowser/src/parser.js
var Parser = class {
  /**
   * Create instance of Parser
   *
   * @param {String} UA User-Agent string
   * @param {Boolean} [skipParsing=false] parser can skip parsing in purpose of performance
   * improvements if you need to make a more particular parsing
   * like {@link Parser#parseBrowser} or {@link Parser#parsePlatform}
   *
   * @throw {Error} in case of empty UA String
   *
   * @constructor
   */
  constructor(UA, skipParsing = false) {
    if (UA === void 0 || UA === null || UA === "") {
      throw new Error("UserAgent parameter can't be empty");
    }
    this._ua = UA;
    this.parsedResult = {};
    if (skipParsing !== true) {
      this.parse();
    }
  }
  /**
   * Get UserAgent string of current Parser instance
   * @return {String} User-Agent String of the current <Parser> object
   *
   * @public
   */
  getUA() {
    return this._ua;
  }
  /**
   * Test a UA string for a regexp
   * @param {RegExp} regex
   * @return {Boolean}
   */
  test(regex) {
    return regex.test(this._ua);
  }
  /**
   * Get parsed browser object
   * @return {Object}
   */
  parseBrowser() {
    this.parsedResult.browser = {};
    const browserDescriptor = Utils.find(parser_browsers_default, (_browser) => {
      if (typeof _browser.test === "function") {
        return _browser.test(this);
      }
      if (_browser.test instanceof Array) {
        return _browser.test.some((condition) => this.test(condition));
      }
      throw new Error("Browser's test function is not valid");
    });
    if (browserDescriptor) {
      this.parsedResult.browser = browserDescriptor.describe(this.getUA());
    }
    return this.parsedResult.browser;
  }
  /**
   * Get parsed browser object
   * @return {Object}
   *
   * @public
   */
  getBrowser() {
    if (this.parsedResult.browser) {
      return this.parsedResult.browser;
    }
    return this.parseBrowser();
  }
  /**
   * Get browser's name
   * @return {String} Browser's name or an empty string
   *
   * @public
   */
  getBrowserName(toLowerCase) {
    if (toLowerCase) {
      return String(this.getBrowser().name).toLowerCase() || "";
    }
    return this.getBrowser().name || "";
  }
  /**
   * Get browser's version
   * @return {String} version of browser
   *
   * @public
   */
  getBrowserVersion() {
    return this.getBrowser().version;
  }
  /**
   * Get OS
   * @return {Object}
   *
   * @example
   * this.getOS();
   * {
   *   name: 'macOS',
   *   version: '10.11.12'
   * }
   */
  getOS() {
    if (this.parsedResult.os) {
      return this.parsedResult.os;
    }
    return this.parseOS();
  }
  /**
   * Parse OS and save it to this.parsedResult.os
   * @return {*|{}}
   */
  parseOS() {
    this.parsedResult.os = {};
    const os = Utils.find(parser_os_default, (_os) => {
      if (typeof _os.test === "function") {
        return _os.test(this);
      }
      if (_os.test instanceof Array) {
        return _os.test.some((condition) => this.test(condition));
      }
      throw new Error("Browser's test function is not valid");
    });
    if (os) {
      this.parsedResult.os = os.describe(this.getUA());
    }
    return this.parsedResult.os;
  }
  /**
   * Get OS name
   * @param {Boolean} [toLowerCase] return lower-cased value
   * @return {String} name of the OS — macOS, Windows, Linux, etc.
   */
  getOSName(toLowerCase) {
    const { name } = this.getOS();
    if (toLowerCase) {
      return String(name).toLowerCase() || "";
    }
    return name || "";
  }
  /**
   * Get OS version
   * @return {String} full version with dots ('10.11.12', '5.6', etc)
   */
  getOSVersion() {
    return this.getOS().version;
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  getPlatform() {
    if (this.parsedResult.platform) {
      return this.parsedResult.platform;
    }
    return this.parsePlatform();
  }
  /**
   * Get platform name
   * @param {Boolean} [toLowerCase=false]
   * @return {*}
   */
  getPlatformType(toLowerCase = false) {
    const { type } = this.getPlatform();
    if (toLowerCase) {
      return String(type).toLowerCase() || "";
    }
    return type || "";
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  parsePlatform() {
    this.parsedResult.platform = {};
    const platform = Utils.find(parser_platforms_default, (_platform) => {
      if (typeof _platform.test === "function") {
        return _platform.test(this);
      }
      if (_platform.test instanceof Array) {
        return _platform.test.some((condition) => this.test(condition));
      }
      throw new Error("Browser's test function is not valid");
    });
    if (platform) {
      this.parsedResult.platform = platform.describe(this.getUA());
    }
    return this.parsedResult.platform;
  }
  /**
   * Get parsed engine
   * @return {{}}
   */
  getEngine() {
    if (this.parsedResult.engine) {
      return this.parsedResult.engine;
    }
    return this.parseEngine();
  }
  /**
   * Get engines's name
   * @return {String} Engines's name or an empty string
   *
   * @public
   */
  getEngineName(toLowerCase) {
    if (toLowerCase) {
      return String(this.getEngine().name).toLowerCase() || "";
    }
    return this.getEngine().name || "";
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  parseEngine() {
    this.parsedResult.engine = {};
    const engine = Utils.find(parser_engines_default, (_engine) => {
      if (typeof _engine.test === "function") {
        return _engine.test(this);
      }
      if (_engine.test instanceof Array) {
        return _engine.test.some((condition) => this.test(condition));
      }
      throw new Error("Browser's test function is not valid");
    });
    if (engine) {
      this.parsedResult.engine = engine.describe(this.getUA());
    }
    return this.parsedResult.engine;
  }
  /**
   * Parse full information about the browser
   * @returns {Parser}
   */
  parse() {
    this.parseBrowser();
    this.parseOS();
    this.parsePlatform();
    this.parseEngine();
    return this;
  }
  /**
   * Get parsed result
   * @return {ParsedResult}
   */
  getResult() {
    return Utils.assign({}, this.parsedResult);
  }
  /**
   * Check if parsed browser matches certain conditions
   *
   * @param {Object} checkTree It's one or two layered object,
   * which can include a platform or an OS on the first layer
   * and should have browsers specs on the bottom-laying layer
   *
   * @returns {Boolean|undefined} Whether the browser satisfies the set conditions or not.
   * Returns `undefined` when the browser is no described in the checkTree object.
   *
   * @example
   * const browser = Bowser.getParser(window.navigator.userAgent);
   * if (browser.satisfies({chrome: '>118.01.1322' }))
   * // or with os
   * if (browser.satisfies({windows: { chrome: '>118.01.1322' } }))
   * // or with platforms
   * if (browser.satisfies({desktop: { chrome: '>118.01.1322' } }))
   */
  satisfies(checkTree) {
    const platformsAndOSes = {};
    let platformsAndOSCounter = 0;
    const browsers = {};
    let browsersCounter = 0;
    const allDefinitions = Object.keys(checkTree);
    allDefinitions.forEach((key) => {
      const currentDefinition = checkTree[key];
      if (typeof currentDefinition === "string") {
        browsers[key] = currentDefinition;
        browsersCounter += 1;
      } else if (typeof currentDefinition === "object") {
        platformsAndOSes[key] = currentDefinition;
        platformsAndOSCounter += 1;
      }
    });
    if (platformsAndOSCounter > 0) {
      const platformsAndOSNames = Object.keys(platformsAndOSes);
      const OSMatchingDefinition = Utils.find(platformsAndOSNames, (name) => this.isOS(name));
      if (OSMatchingDefinition) {
        const osResult = this.satisfies(platformsAndOSes[OSMatchingDefinition]);
        if (osResult !== void 0) {
          return osResult;
        }
      }
      const platformMatchingDefinition = Utils.find(
        platformsAndOSNames,
        (name) => this.isPlatform(name)
      );
      if (platformMatchingDefinition) {
        const platformResult = this.satisfies(platformsAndOSes[platformMatchingDefinition]);
        if (platformResult !== void 0) {
          return platformResult;
        }
      }
    }
    if (browsersCounter > 0) {
      const browserNames = Object.keys(browsers);
      const matchingDefinition = Utils.find(browserNames, (name) => this.isBrowser(name, true));
      if (matchingDefinition !== void 0) {
        return this.compareVersion(browsers[matchingDefinition]);
      }
    }
    return void 0;
  }
  /**
   * Check if the browser name equals the passed string
   * @param browserName The string to compare with the browser name
   * @param [includingAlias=false] The flag showing whether alias will be included into comparison
   * @returns {boolean}
   */
  isBrowser(browserName, includingAlias = false) {
    const defaultBrowserName = this.getBrowserName().toLowerCase();
    let browserNameLower = browserName.toLowerCase();
    const alias = Utils.getBrowserTypeByAlias(browserNameLower);
    if (includingAlias && alias) {
      browserNameLower = alias.toLowerCase();
    }
    return browserNameLower === defaultBrowserName;
  }
  compareVersion(version3) {
    let expectedResults = [0];
    let comparableVersion = version3;
    let isLoose = false;
    const currentBrowserVersion = this.getBrowserVersion();
    if (typeof currentBrowserVersion !== "string") {
      return void 0;
    }
    if (version3[0] === ">" || version3[0] === "<") {
      comparableVersion = version3.substr(1);
      if (version3[1] === "=") {
        isLoose = true;
        comparableVersion = version3.substr(2);
      } else {
        expectedResults = [];
      }
      if (version3[0] === ">") {
        expectedResults.push(1);
      } else {
        expectedResults.push(-1);
      }
    } else if (version3[0] === "=") {
      comparableVersion = version3.substr(1);
    } else if (version3[0] === "~") {
      isLoose = true;
      comparableVersion = version3.substr(1);
    }
    return expectedResults.indexOf(
      Utils.compareVersions(currentBrowserVersion, comparableVersion, isLoose)
    ) > -1;
  }
  isOS(osName) {
    return this.getOSName(true) === String(osName).toLowerCase();
  }
  isPlatform(platformType) {
    return this.getPlatformType(true) === String(platformType).toLowerCase();
  }
  isEngine(engineName) {
    return this.getEngineName(true) === String(engineName).toLowerCase();
  }
  /**
   * Is anything? Check if the browser is called "anything",
   * the OS called "anything" or the platform called "anything"
   * @param {String} anything
   * @param [includingAlias=false] The flag showing whether alias will be included into comparison
   * @returns {Boolean}
   */
  is(anything, includingAlias = false) {
    return this.isBrowser(anything, includingAlias) || this.isOS(anything) || this.isPlatform(anything);
  }
  /**
   * Check if any of the given values satisfies this.is(anything)
   * @param {String[]} anythings
   * @returns {Boolean}
   */
  some(anythings = []) {
    return anythings.some((anything) => this.is(anything));
  }
};
var parser_default = Parser;

// node_modules/bowser/src/bowser.js
var Bowser = class {
  /**
   * Creates a {@link Parser} instance
   *
   * @param {String} UA UserAgent string
   * @param {Boolean} [skipParsing=false] Will make the Parser postpone parsing until you ask it
   * explicitly. Same as `skipParsing` for {@link Parser}.
   * @returns {Parser}
   * @throws {Error} when UA is not a String
   *
   * @example
   * const parser = Bowser.getParser(window.navigator.userAgent);
   * const result = parser.getResult();
   */
  static getParser(UA, skipParsing = false) {
    if (typeof UA !== "string") {
      throw new Error("UserAgent should be a string");
    }
    return new parser_default(UA, skipParsing);
  }
  /**
   * Creates a {@link Parser} instance and runs {@link Parser.getResult} immediately
   *
   * @param UA
   * @return {ParsedResult}
   *
   * @example
   * const result = Bowser.parse(window.navigator.userAgent);
   */
  static parse(UA) {
    return new parser_default(UA).getResult();
  }
  static get BROWSER_MAP() {
    return BROWSER_MAP;
  }
  static get ENGINE_MAP() {
    return ENGINE_MAP;
  }
  static get OS_MAP() {
    return OS_MAP;
  }
  static get PLATFORMS_MAP() {
    return PLATFORMS_MAP;
  }
};
var bowser_default = Bowser;

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-sdk/util-user-agent-browser/dist/es/index.js
var defaultUserAgent = function(_a2) {
  var serviceId = _a2.serviceId, clientVersion = _a2.clientVersion;
  return function() {
    return __awaiter6(void 0, void 0, void 0, function() {
      var parsedUA, sections;
      var _a3, _b2, _c, _d, _e, _f, _g;
      return __generator6(this, function(_h) {
        parsedUA = ((_a3 = window === null || window === void 0 ? void 0 : window.navigator) === null || _a3 === void 0 ? void 0 : _a3.userAgent) ? bowser_default.parse(window.navigator.userAgent) : void 0;
        sections = [
          // sdk-metadata
          ["aws-sdk-js", clientVersion],
          // os-metadata
          ["os/" + (((_b2 = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b2 === void 0 ? void 0 : _b2.name) || "other"), (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version],
          // language-metadata
          // ECMAScript edition doesn't matter in JS.
          ["lang/js"],
          // browser vendor and version.
          ["md/browser", ((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown") + "_" + ((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")]
        ];
        if (serviceId) {
          sections.push(["api/" + serviceId, clientVersion]);
        }
        return [2, sections];
      });
    });
  };
};

// node_modules/@aws-sdk/client-cloudwatch-logs/dist/es/runtimeConfig.browser.js
init_es();

// node_modules/@aws-sdk/client-cloudwatch-logs/dist/es/endpoints.js
var AWS_TEMPLATE = "logs.{region}.amazonaws.com";
var AWS_CN_TEMPLATE = "logs.{region}.amazonaws.com.cn";
var AWS_ISO_TEMPLATE = "logs.{region}.c2s.ic.gov";
var AWS_ISO_B_TEMPLATE = "logs.{region}.sc2s.sgov.gov";
var AWS_US_GOV_TEMPLATE = "logs.{region}.amazonaws.com";
var AWS_REGIONS = /* @__PURE__ */ new Set([
  "af-south-1",
  "ap-east-1",
  "ap-northeast-1",
  "ap-northeast-2",
  "ap-south-1",
  "ap-southeast-1",
  "ap-southeast-2",
  "ca-central-1",
  "eu-central-1",
  "eu-north-1",
  "eu-south-1",
  "eu-west-1",
  "eu-west-2",
  "eu-west-3",
  "me-south-1",
  "sa-east-1",
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2"
]);
var AWS_CN_REGIONS = /* @__PURE__ */ new Set(["cn-north-1", "cn-northwest-1"]);
var AWS_ISO_REGIONS = /* @__PURE__ */ new Set(["us-iso-east-1"]);
var AWS_ISO_B_REGIONS = /* @__PURE__ */ new Set(["us-isob-east-1"]);
var AWS_US_GOV_REGIONS = /* @__PURE__ */ new Set(["us-gov-east-1", "us-gov-west-1"]);
var defaultRegionInfoProvider = function(region, options) {
  var regionInfo = void 0;
  switch (region) {
    case "af-south-1":
      regionInfo = {
        hostname: "logs.af-south-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-east-1":
      regionInfo = {
        hostname: "logs.ap-east-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-northeast-1":
      regionInfo = {
        hostname: "logs.ap-northeast-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-northeast-2":
      regionInfo = {
        hostname: "logs.ap-northeast-2.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-south-1":
      regionInfo = {
        hostname: "logs.ap-south-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-southeast-1":
      regionInfo = {
        hostname: "logs.ap-southeast-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-southeast-2":
      regionInfo = {
        hostname: "logs.ap-southeast-2.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ca-central-1":
      regionInfo = {
        hostname: "logs.ca-central-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "cn-north-1":
      regionInfo = {
        hostname: "logs.cn-north-1.amazonaws.com.cn",
        partition: "aws-cn"
      };
      break;
    case "cn-northwest-1":
      regionInfo = {
        hostname: "logs.cn-northwest-1.amazonaws.com.cn",
        partition: "aws-cn"
      };
      break;
    case "eu-central-1":
      regionInfo = {
        hostname: "logs.eu-central-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "eu-north-1":
      regionInfo = {
        hostname: "logs.eu-north-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "eu-south-1":
      regionInfo = {
        hostname: "logs.eu-south-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "eu-west-1":
      regionInfo = {
        hostname: "logs.eu-west-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "eu-west-2":
      regionInfo = {
        hostname: "logs.eu-west-2.amazonaws.com",
        partition: "aws"
      };
      break;
    case "eu-west-3":
      regionInfo = {
        hostname: "logs.eu-west-3.amazonaws.com",
        partition: "aws"
      };
      break;
    case "fips-us-east-1":
      regionInfo = {
        hostname: "logs-fips.us-east-1.amazonaws.com",
        partition: "aws",
        signingRegion: "us-east-1"
      };
      break;
    case "fips-us-east-2":
      regionInfo = {
        hostname: "logs-fips.us-east-2.amazonaws.com",
        partition: "aws",
        signingRegion: "us-east-2"
      };
      break;
    case "fips-us-west-1":
      regionInfo = {
        hostname: "logs-fips.us-west-1.amazonaws.com",
        partition: "aws",
        signingRegion: "us-west-1"
      };
      break;
    case "fips-us-west-2":
      regionInfo = {
        hostname: "logs-fips.us-west-2.amazonaws.com",
        partition: "aws",
        signingRegion: "us-west-2"
      };
      break;
    case "me-south-1":
      regionInfo = {
        hostname: "logs.me-south-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "sa-east-1":
      regionInfo = {
        hostname: "logs.sa-east-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "us-east-1":
      regionInfo = {
        hostname: "logs.us-east-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "us-east-2":
      regionInfo = {
        hostname: "logs.us-east-2.amazonaws.com",
        partition: "aws"
      };
      break;
    case "us-gov-east-1":
      regionInfo = {
        hostname: "logs.us-gov-east-1.amazonaws.com",
        partition: "aws-us-gov",
        signingRegion: "us-gov-east-1"
      };
      break;
    case "us-gov-west-1":
      regionInfo = {
        hostname: "logs.us-gov-west-1.amazonaws.com",
        partition: "aws-us-gov",
        signingRegion: "us-gov-west-1"
      };
      break;
    case "us-iso-east-1":
      regionInfo = {
        hostname: "logs.us-iso-east-1.c2s.ic.gov",
        partition: "aws-iso"
      };
      break;
    case "us-isob-east-1":
      regionInfo = {
        hostname: "logs.us-isob-east-1.sc2s.sgov.gov",
        partition: "aws-iso-b"
      };
      break;
    case "us-west-1":
      regionInfo = {
        hostname: "logs.us-west-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "us-west-2":
      regionInfo = {
        hostname: "logs.us-west-2.amazonaws.com",
        partition: "aws"
      };
      break;
    default:
      if (AWS_REGIONS.has(region)) {
        regionInfo = {
          hostname: AWS_TEMPLATE.replace("{region}", region),
          partition: "aws"
        };
      }
      if (AWS_CN_REGIONS.has(region)) {
        regionInfo = {
          hostname: AWS_CN_TEMPLATE.replace("{region}", region),
          partition: "aws-cn"
        };
      }
      if (AWS_ISO_REGIONS.has(region)) {
        regionInfo = {
          hostname: AWS_ISO_TEMPLATE.replace("{region}", region),
          partition: "aws-iso"
        };
      }
      if (AWS_ISO_B_REGIONS.has(region)) {
        regionInfo = {
          hostname: AWS_ISO_B_TEMPLATE.replace("{region}", region),
          partition: "aws-iso-b"
        };
      }
      if (AWS_US_GOV_REGIONS.has(region)) {
        regionInfo = {
          hostname: AWS_US_GOV_TEMPLATE.replace("{region}", region),
          partition: "aws-us-gov"
        };
      }
      if (regionInfo === void 0) {
        regionInfo = {
          hostname: AWS_TEMPLATE.replace("{region}", region),
          partition: "aws"
        };
      }
  }
  return Promise.resolve(__assign7({ signingService: "logs" }, regionInfo));
};

// node_modules/@aws-sdk/querystring-parser/node_modules/tslib/tslib.es6.js
function __values7(o2) {
  var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
  if (m2)
    return m2.call(o2);
  if (o2 && typeof o2.length === "number")
    return {
      next: function() {
        if (o2 && i2 >= o2.length)
          o2 = void 0;
        return { value: o2 && o2[i2++], done: !o2 };
      }
    };
  throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read13(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}

// node_modules/@aws-sdk/querystring-parser/dist/es/index.js
function parseQueryString(querystring) {
  var e_1, _a2;
  var query = {};
  querystring = querystring.replace(/^\?/, "");
  if (querystring) {
    try {
      for (var _b2 = __values7(querystring.split("&")), _c = _b2.next(); !_c.done; _c = _b2.next()) {
        var pair = _c.value;
        var _d = __read13(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
        key = decodeURIComponent(key);
        if (value) {
          value = decodeURIComponent(value);
        }
        if (!(key in query)) {
          query[key] = value;
        } else if (Array.isArray(query[key])) {
          query[key].push(value);
        } else {
          query[key] = [query[key], value];
        }
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (_c && !_c.done && (_a2 = _b2.return))
          _a2.call(_b2);
      } finally {
        if (e_1)
          throw e_1.error;
      }
    }
  }
  return query;
}

// node_modules/@aws-sdk/url-parser/dist/es/index.js
var parseUrl = function(url2) {
  var _a2 = new URL(url2), hostname = _a2.hostname, pathname = _a2.pathname, port = _a2.port, protocol = _a2.protocol, search = _a2.search;
  var query;
  if (search) {
    query = parseQueryString(search);
  }
  return {
    hostname,
    port: port ? parseInt(port) : void 0,
    protocol,
    path: pathname,
    query
  };
};

// node_modules/@aws-sdk/client-cloudwatch-logs/dist/es/runtimeConfig.shared.js
var ClientSharedValues = {
  apiVersion: "2014-03-28",
  disableHostPrefix: false,
  logger: {},
  regionInfoProvider: defaultRegionInfoProvider,
  serviceId: "CloudWatch Logs",
  urlParser: parseUrl
};

// node_modules/@aws-sdk/client-cloudwatch-logs/dist/es/runtimeConfig.browser.js
var ClientDefaultValues = __assign7(__assign7({}, ClientSharedValues), { runtime: "browser", base64Decoder: fromBase64, base64Encoder: toBase64, bodyLengthChecker: calculateBodyLength, credentialDefaultProvider: function(_2) {
  return function() {
    return Promise.reject(new Error("Credential is missing"));
  };
}, defaultUserAgentProvider: defaultUserAgent({
  serviceId: ClientSharedValues.serviceId,
  clientVersion: package_default.version
}), maxAttempts: DEFAULT_MAX_ATTEMPTS, region: invalidProvider("Region is missing"), requestHandler: new FetchHttpHandler(), sha256: import_sha256_browser.Sha256, streamCollector, utf8Decoder: fromUtf86, utf8Encoder: toUtf86 });

// node_modules/@aws-sdk/config-resolver/node_modules/tslib/tslib.es6.js
var __assign10 = function() {
  __assign10 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign10.apply(this, arguments);
};
function __awaiter7(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator7(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/config-resolver/dist/es/EndpointsConfig.js
var resolveEndpointsConfig = function(input) {
  var _a2;
  return __assign10(__assign10({}, input), { tls: (_a2 = input.tls) !== null && _a2 !== void 0 ? _a2 : true, endpoint: input.endpoint ? normalizeEndpoint(input) : function() {
    return getEndPointFromRegion(input);
  }, isCustomEndpoint: input.endpoint ? true : false });
};
var normalizeEndpoint = function(input) {
  var endpoint = input.endpoint, urlParser = input.urlParser;
  if (typeof endpoint === "string") {
    var promisified_1 = Promise.resolve(urlParser(endpoint));
    return function() {
      return promisified_1;
    };
  } else if (typeof endpoint === "object") {
    var promisified_2 = Promise.resolve(endpoint);
    return function() {
      return promisified_2;
    };
  }
  return endpoint;
};
var getEndPointFromRegion = function(input) {
  return __awaiter7(void 0, void 0, void 0, function() {
    var _a2, tls, region, dnsHostRegex, hostname;
    var _b2;
    return __generator7(this, function(_c) {
      switch (_c.label) {
        case 0:
          _a2 = input.tls, tls = _a2 === void 0 ? true : _a2;
          return [4, input.region()];
        case 1:
          region = _c.sent();
          dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
          if (!dnsHostRegex.test(region)) {
            throw new Error("Invalid region in client config");
          }
          return [4, input.regionInfoProvider(region)];
        case 2:
          hostname = ((_b2 = _c.sent()) !== null && _b2 !== void 0 ? _b2 : {}).hostname;
          if (!hostname) {
            throw new Error("Cannot resolve hostname from client config");
          }
          return [2, input.urlParser((tls ? "https:" : "http:") + "//" + hostname)];
      }
    });
  });
};

// node_modules/@aws-sdk/config-resolver/dist/es/RegionConfig.js
var resolveRegionConfig = function(input) {
  if (!input.region) {
    throw new Error("Region is missing");
  }
  return __assign10(__assign10({}, input), { region: normalizeRegion(input.region) });
};
var normalizeRegion = function(region) {
  if (typeof region === "string") {
    var promisified_1 = Promise.resolve(region);
    return function() {
      return promisified_1;
    };
  }
  return region;
};

// node_modules/@aws-sdk/middleware-content-length/node_modules/tslib/tslib.es6.js
var __assign11 = function() {
  __assign11 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign11.apply(this, arguments);
};
function __awaiter8(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator8(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/middleware-content-length/dist/es/index.js
var CONTENT_LENGTH_HEADER = "content-length";
function contentLengthMiddleware(bodyLengthChecker) {
  var _this = this;
  return function(next) {
    return function(args) {
      return __awaiter8(_this, void 0, void 0, function() {
        var request, body, headers, length;
        var _a2;
        return __generator8(this, function(_b2) {
          request = args.request;
          if (HttpRequest.isInstance(request)) {
            body = request.body, headers = request.headers;
            if (body && Object.keys(headers).map(function(str) {
              return str.toLowerCase();
            }).indexOf(CONTENT_LENGTH_HEADER) === -1) {
              length = bodyLengthChecker(body);
              if (length !== void 0) {
                request.headers = __assign11(__assign11({}, request.headers), (_a2 = {}, _a2[CONTENT_LENGTH_HEADER] = String(length), _a2));
              }
            }
          }
          return [2, next(__assign11(__assign11({}, args), { request }))];
        });
      });
    };
  };
}
var contentLengthMiddlewareOptions = {
  step: "build",
  tags: ["SET_CONTENT_LENGTH", "CONTENT_LENGTH"],
  name: "contentLengthMiddleware",
  override: true
};
var getContentLengthPlugin = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(contentLengthMiddleware(options.bodyLengthChecker), contentLengthMiddlewareOptions);
    }
  };
};

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-sdk/middleware-host-header/node_modules/tslib/tslib.es6.js
function __awaiter9(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator9(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-sdk/middleware-host-header/dist/es/index.js
function resolveHostHeaderConfig(input) {
  return input;
}
var hostHeaderMiddleware = function(options) {
  return function(next) {
    return function(args) {
      return __awaiter9(void 0, void 0, void 0, function() {
        var request, _a2, handlerProtocol;
        return __generator9(this, function(_b2) {
          if (!HttpRequest.isInstance(args.request))
            return [2, next(args)];
          request = args.request;
          _a2 = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a2 === void 0 ? "" : _a2;
          if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
            delete request.headers["host"];
            request.headers[":authority"] = "";
          } else if (!request.headers["host"]) {
            request.headers["host"] = request.hostname;
          }
          return [2, next(args)];
        });
      });
    };
  };
};
var hostHeaderMiddlewareOptions = {
  name: "hostHeaderMiddleware",
  step: "build",
  priority: "low",
  tags: ["HOST"],
  override: true
};
var getHostHeaderPlugin = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(hostHeaderMiddleware(options), hostHeaderMiddlewareOptions);
    }
  };
};

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-sdk/middleware-logger/node_modules/tslib/tslib.es6.js
function __rest3(s2, e) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
}
function __awaiter10(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator10(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-sdk/middleware-logger/dist/es/loggerMiddleware.js
var loggerMiddleware = function() {
  return function(next, context) {
    return function(args) {
      return __awaiter10(void 0, void 0, void 0, function() {
        var clientName, commandName, inputFilterSensitiveLog, logger64, outputFilterSensitiveLog, response, _a2, $metadata, outputWithoutMetadata;
        return __generator10(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger64 = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
              return [4, next(args)];
            case 1:
              response = _b2.sent();
              if (!logger64) {
                return [2, response];
              }
              if (typeof logger64.info === "function") {
                _a2 = response.output, $metadata = _a2.$metadata, outputWithoutMetadata = __rest3(_a2, ["$metadata"]);
                logger64.info({
                  clientName,
                  commandName,
                  input: inputFilterSensitiveLog(args.input),
                  output: outputFilterSensitiveLog(outputWithoutMetadata),
                  metadata: $metadata
                });
              }
              return [2, response];
          }
        });
      });
    };
  };
};
var loggerMiddlewareOptions = {
  name: "loggerMiddleware",
  tags: ["LOGGER"],
  step: "initialize",
  override: true
};
var getLoggerPlugin = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(loggerMiddleware(), loggerMiddlewareOptions);
    }
  };
};

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-sdk/middleware-signing/node_modules/tslib/tslib.es6.js
var __assign12 = function() {
  __assign12 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign12.apply(this, arguments);
};
function __awaiter11(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator11(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __read14(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}

// node_modules/@aws-sdk/signature-v4/node_modules/tslib/tslib.es6.js
var __assign13 = function() {
  __assign13 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign13.apply(this, arguments);
};
function __rest4(s2, e) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
}
function __awaiter12(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator12(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __values8(o2) {
  var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
  if (m2)
    return m2.call(o2);
  if (o2 && typeof o2.length === "number")
    return {
      next: function() {
        if (o2 && i2 >= o2.length)
          o2 = void 0;
        return { value: o2 && o2[i2++], done: !o2 };
      }
    };
  throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read15(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}
function __spread4() {
  for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
    ar = ar.concat(__read15(arguments[i2]));
  return ar;
}

// node_modules/@aws-sdk/signature-v4/dist/es/constants.js
var ALGORITHM_QUERY_PARAM2 = "X-Amz-Algorithm";
var CREDENTIAL_QUERY_PARAM2 = "X-Amz-Credential";
var AMZ_DATE_QUERY_PARAM2 = "X-Amz-Date";
var SIGNED_HEADERS_QUERY_PARAM2 = "X-Amz-SignedHeaders";
var EXPIRES_QUERY_PARAM2 = "X-Amz-Expires";
var SIGNATURE_QUERY_PARAM2 = "X-Amz-Signature";
var TOKEN_QUERY_PARAM2 = "X-Amz-Security-Token";
var AUTH_HEADER2 = "authorization";
var AMZ_DATE_HEADER2 = AMZ_DATE_QUERY_PARAM2.toLowerCase();
var DATE_HEADER = "date";
var GENERATED_HEADERS = [AUTH_HEADER2, AMZ_DATE_HEADER2, DATE_HEADER];
var SIGNATURE_HEADER = SIGNATURE_QUERY_PARAM2.toLowerCase();
var SHA256_HEADER = "x-amz-content-sha256";
var TOKEN_HEADER2 = TOKEN_QUERY_PARAM2.toLowerCase();
var ALWAYS_UNSIGNABLE_HEADERS = {
  authorization: true,
  "cache-control": true,
  connection: true,
  expect: true,
  from: true,
  "keep-alive": true,
  "max-forwards": true,
  pragma: true,
  referer: true,
  te: true,
  trailer: true,
  "transfer-encoding": true,
  upgrade: true,
  "user-agent": true,
  "x-amzn-trace-id": true
};
var PROXY_HEADER_PATTERN = /^proxy-/;
var SEC_HEADER_PATTERN = /^sec-/;
var ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";
var EVENT_ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256-PAYLOAD";
var UNSIGNED_PAYLOAD2 = "UNSIGNED-PAYLOAD";
var MAX_CACHE_SIZE = 50;
var KEY_TYPE_IDENTIFIER2 = "aws4_request";
var MAX_PRESIGNED_TTL = 60 * 60 * 24 * 7;

// node_modules/@aws-sdk/signature-v4/dist/es/credentialDerivation.js
var signingKeyCache = {};
var cacheQueue = [];
function createScope(shortDate, region, service) {
  return shortDate + "/" + region + "/" + service + "/" + KEY_TYPE_IDENTIFIER2;
}
var getSigningKey2 = function(sha256Constructor, credentials, shortDate, region, service) {
  return __awaiter12(void 0, void 0, void 0, function() {
    var credsHash, cacheKey, key, _a2, _b2, signable, e_1_1;
    var e_1, _c;
    return __generator12(this, function(_d) {
      switch (_d.label) {
        case 0:
          return [4, hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId)];
        case 1:
          credsHash = _d.sent();
          cacheKey = shortDate + ":" + region + ":" + service + ":" + toHex(credsHash) + ":" + credentials.sessionToken;
          if (cacheKey in signingKeyCache) {
            return [2, signingKeyCache[cacheKey]];
          }
          cacheQueue.push(cacheKey);
          while (cacheQueue.length > MAX_CACHE_SIZE) {
            delete signingKeyCache[cacheQueue.shift()];
          }
          key = "AWS4" + credentials.secretAccessKey;
          _d.label = 2;
        case 2:
          _d.trys.push([2, 7, 8, 9]);
          _a2 = __values8([shortDate, region, service, KEY_TYPE_IDENTIFIER2]), _b2 = _a2.next();
          _d.label = 3;
        case 3:
          if (!!_b2.done)
            return [3, 6];
          signable = _b2.value;
          return [4, hmac(sha256Constructor, key, signable)];
        case 4:
          key = _d.sent();
          _d.label = 5;
        case 5:
          _b2 = _a2.next();
          return [3, 3];
        case 6:
          return [3, 9];
        case 7:
          e_1_1 = _d.sent();
          e_1 = { error: e_1_1 };
          return [3, 9];
        case 8:
          try {
            if (_b2 && !_b2.done && (_c = _a2.return))
              _c.call(_a2);
          } finally {
            if (e_1)
              throw e_1.error;
          }
          return [
            7
            /*endfinally*/
          ];
        case 9:
          return [2, signingKeyCache[cacheKey] = key];
      }
    });
  });
};
function hmac(ctor, secret, data) {
  var hash = new ctor(secret);
  hash.update(data);
  return hash.digest();
}

// node_modules/@aws-sdk/signature-v4/dist/es/getCanonicalHeaders.js
function getCanonicalHeaders2(_a2, unsignableHeaders, signableHeaders) {
  var e_1, _b2;
  var headers = _a2.headers;
  var canonical = {};
  try {
    for (var _c = __values8(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()) {
      var headerName = _d.value;
      var canonicalHeaderName = headerName.toLowerCase();
      if (canonicalHeaderName in ALWAYS_UNSIGNABLE_HEADERS || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || PROXY_HEADER_PATTERN.test(canonicalHeaderName) || SEC_HEADER_PATTERN.test(canonicalHeaderName)) {
        if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) {
          continue;
        }
      }
      canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_d && !_d.done && (_b2 = _c.return))
        _b2.call(_c);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return canonical;
}

// node_modules/@aws-sdk/signature-v4/dist/es/getCanonicalQuery.js
function getCanonicalQuery(_a2) {
  var e_1, _b2;
  var _c = _a2.query, query = _c === void 0 ? {} : _c;
  var keys = [];
  var serialized = {};
  var _loop_1 = function(key2) {
    if (key2.toLowerCase() === SIGNATURE_HEADER) {
      return "continue";
    }
    keys.push(key2);
    var value = query[key2];
    if (typeof value === "string") {
      serialized[key2] = escapeUri2(key2) + "=" + escapeUri2(value);
    } else if (Array.isArray(value)) {
      serialized[key2] = value.slice(0).sort().reduce(function(encoded, value2) {
        return encoded.concat([escapeUri2(key2) + "=" + escapeUri2(value2)]);
      }, []).join("&");
    }
  };
  try {
    for (var _d = __values8(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()) {
      var key = _e.value;
      _loop_1(key);
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_e && !_e.done && (_b2 = _d.return))
        _b2.call(_d);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return keys.map(function(key2) {
    return serialized[key2];
  }).filter(function(serialized2) {
    return serialized2;
  }).join("&");
}

// node_modules/@aws-sdk/is-array-buffer/dist/es/index.js
var isArrayBuffer2 = function(arg) {
  return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};

// node_modules/@aws-sdk/signature-v4/dist/es/getPayloadHash.js
function getPayloadHash(_a2, hashConstructor) {
  var headers = _a2.headers, body = _a2.body;
  return __awaiter12(this, void 0, void 0, function() {
    var _b2, _c, headerName, hashCtor, _d;
    var e_1, _e;
    return __generator12(this, function(_f) {
      switch (_f.label) {
        case 0:
          try {
            for (_b2 = __values8(Object.keys(headers)), _c = _b2.next(); !_c.done; _c = _b2.next()) {
              headerName = _c.value;
              if (headerName.toLowerCase() === SHA256_HEADER) {
                return [2, headers[headerName]];
              }
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (_c && !_c.done && (_e = _b2.return))
                _e.call(_b2);
            } finally {
              if (e_1)
                throw e_1.error;
            }
          }
          if (!(body == void 0))
            return [3, 1];
          return [2, "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"];
        case 1:
          if (!(typeof body === "string" || ArrayBuffer.isView(body) || isArrayBuffer2(body)))
            return [3, 3];
          hashCtor = new hashConstructor();
          hashCtor.update(body);
          _d = toHex;
          return [4, hashCtor.digest()];
        case 2:
          return [2, _d.apply(void 0, [_f.sent()])];
        case 3:
          return [2, UNSIGNED_PAYLOAD2];
      }
    });
  });
}

// node_modules/@aws-sdk/signature-v4/dist/es/hasHeader.js
function hasHeader(soughtHeader, headers) {
  var e_1, _a2;
  soughtHeader = soughtHeader.toLowerCase();
  try {
    for (var _b2 = __values8(Object.keys(headers)), _c = _b2.next(); !_c.done; _c = _b2.next()) {
      var headerName = _c.value;
      if (soughtHeader === headerName.toLowerCase()) {
        return true;
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_c && !_c.done && (_a2 = _b2.return))
        _a2.call(_b2);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return false;
}

// node_modules/@aws-sdk/signature-v4/dist/es/cloneRequest.js
function cloneRequest(_a2) {
  var headers = _a2.headers, query = _a2.query, rest = __rest4(_a2, ["headers", "query"]);
  return __assign13(__assign13({}, rest), { headers: __assign13({}, headers), query: query ? cloneQuery2(query) : void 0 });
}
function cloneQuery2(query) {
  return Object.keys(query).reduce(function(carry, paramName) {
    var _a2;
    var param = query[paramName];
    return __assign13(__assign13({}, carry), (_a2 = {}, _a2[paramName] = Array.isArray(param) ? __spread4(param) : param, _a2));
  }, {});
}

// node_modules/@aws-sdk/signature-v4/dist/es/moveHeadersToQuery.js
function moveHeadersToQuery(request, options) {
  var e_1, _a2;
  var _b2;
  if (options === void 0) {
    options = {};
  }
  var _c = typeof request.clone === "function" ? request.clone() : cloneRequest(request), headers = _c.headers, _d = _c.query, query = _d === void 0 ? {} : _d;
  try {
    for (var _e = __values8(Object.keys(headers)), _f = _e.next(); !_f.done; _f = _e.next()) {
      var name = _f.value;
      var lname = name.toLowerCase();
      if (lname.substr(0, 6) === "x-amz-" && !((_b2 = options.unhoistableHeaders) === null || _b2 === void 0 ? void 0 : _b2.has(lname))) {
        query[name] = headers[name];
        delete headers[name];
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_f && !_f.done && (_a2 = _e.return))
        _a2.call(_e);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return __assign13(__assign13({}, request), {
    headers,
    query
  });
}

// node_modules/@aws-sdk/signature-v4/dist/es/prepareRequest.js
function prepareRequest(request) {
  var e_1, _a2;
  request = typeof request.clone === "function" ? request.clone() : cloneRequest(request);
  try {
    for (var _b2 = __values8(Object.keys(request.headers)), _c = _b2.next(); !_c.done; _c = _b2.next()) {
      var headerName = _c.value;
      if (GENERATED_HEADERS.indexOf(headerName.toLowerCase()) > -1) {
        delete request.headers[headerName];
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_c && !_c.done && (_a2 = _b2.return))
        _a2.call(_b2);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return request;
}

// node_modules/@aws-sdk/signature-v4/dist/es/utilDate.js
function iso8601(time) {
  return toDate(time).toISOString().replace(/\.\d{3}Z$/, "Z");
}
function toDate(time) {
  if (typeof time === "number") {
    return new Date(time * 1e3);
  }
  if (typeof time === "string") {
    if (Number(time)) {
      return new Date(Number(time) * 1e3);
    }
    return new Date(time);
  }
  return time;
}

// node_modules/@aws-sdk/signature-v4/dist/es/SignatureV4.js
var SignatureV4 = (
  /** @class */
  function() {
    function SignatureV44(_a2) {
      var applyChecksum = _a2.applyChecksum, credentials = _a2.credentials, region = _a2.region, service = _a2.service, sha256 = _a2.sha256, _b2 = _a2.uriEscapePath, uriEscapePath = _b2 === void 0 ? true : _b2;
      this.service = service;
      this.sha256 = sha256;
      this.uriEscapePath = uriEscapePath;
      this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
      this.regionProvider = normalizeRegionProvider(region);
      this.credentialProvider = normalizeCredentialsProvider(credentials);
    }
    SignatureV44.prototype.presign = function(originalRequest, options) {
      if (options === void 0) {
        options = {};
      }
      return __awaiter12(this, void 0, void 0, function() {
        var _a2, signingDate, _b2, expiresIn, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
        return __generator12(this, function(_l) {
          switch (_l.label) {
            case 0:
              _a2 = options.signingDate, signingDate = _a2 === void 0 ? /* @__PURE__ */ new Date() : _a2, _b2 = options.expiresIn, expiresIn = _b2 === void 0 ? 3600 : _b2, unsignableHeaders = options.unsignableHeaders, unhoistableHeaders = options.unhoistableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
              return [4, this.credentialProvider()];
            case 1:
              credentials = _l.sent();
              if (!(signingRegion !== null && signingRegion !== void 0))
                return [3, 2];
              _c = signingRegion;
              return [3, 4];
            case 2:
              return [4, this.regionProvider()];
            case 3:
              _c = _l.sent();
              _l.label = 4;
            case 4:
              region = _c;
              _d = formatDate(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
              if (expiresIn > MAX_PRESIGNED_TTL) {
                return [2, Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")];
              }
              scope = createScope(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
              request = moveHeadersToQuery(prepareRequest(originalRequest), { unhoistableHeaders });
              if (credentials.sessionToken) {
                request.query[TOKEN_QUERY_PARAM2] = credentials.sessionToken;
              }
              request.query[ALGORITHM_QUERY_PARAM2] = ALGORITHM_IDENTIFIER;
              request.query[CREDENTIAL_QUERY_PARAM2] = credentials.accessKeyId + "/" + scope;
              request.query[AMZ_DATE_QUERY_PARAM2] = longDate;
              request.query[EXPIRES_QUERY_PARAM2] = expiresIn.toString(10);
              canonicalHeaders = getCanonicalHeaders2(request, unsignableHeaders, signableHeaders);
              request.query[SIGNED_HEADERS_QUERY_PARAM2] = getCanonicalHeaderList(canonicalHeaders);
              _e = request.query;
              _f = SIGNATURE_QUERY_PARAM2;
              _g = this.getSignature;
              _h = [
                longDate,
                scope,
                this.getSigningKey(credentials, region, shortDate, signingService)
              ];
              _j = this.createCanonicalRequest;
              _k = [request, canonicalHeaders];
              return [4, getPayloadHash(originalRequest, this.sha256)];
            case 5:
              return [4, _g.apply(this, _h.concat([_j.apply(this, _k.concat([_l.sent()]))]))];
            case 6:
              _e[_f] = _l.sent();
              return [2, request];
          }
        });
      });
    };
    SignatureV44.prototype.sign = function(toSign, options) {
      return __awaiter12(this, void 0, void 0, function() {
        return __generator12(this, function(_a2) {
          if (typeof toSign === "string") {
            return [2, this.signString(toSign, options)];
          } else if (toSign.headers && toSign.payload) {
            return [2, this.signEvent(toSign, options)];
          } else {
            return [2, this.signRequest(toSign, options)];
          }
          return [
            2
            /*return*/
          ];
        });
      });
    };
    SignatureV44.prototype.signEvent = function(_a2, _b2) {
      var headers = _a2.headers, payload = _a2.payload;
      var _c = _b2.signingDate, signingDate = _c === void 0 ? /* @__PURE__ */ new Date() : _c, priorSignature = _b2.priorSignature, signingRegion = _b2.signingRegion, signingService = _b2.signingService;
      return __awaiter12(this, void 0, void 0, function() {
        var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
        return __generator12(this, function(_g) {
          switch (_g.label) {
            case 0:
              if (!(signingRegion !== null && signingRegion !== void 0))
                return [3, 1];
              _d = signingRegion;
              return [3, 3];
            case 1:
              return [4, this.regionProvider()];
            case 2:
              _d = _g.sent();
              _g.label = 3;
            case 3:
              region = _d;
              _e = formatDate(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
              scope = createScope(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
              return [4, getPayloadHash({ headers: {}, body: payload }, this.sha256)];
            case 4:
              hashedPayload = _g.sent();
              hash = new this.sha256();
              hash.update(headers);
              _f = toHex;
              return [4, hash.digest()];
            case 5:
              hashedHeaders = _f.apply(void 0, [_g.sent()]);
              stringToSign = [
                EVENT_ALGORITHM_IDENTIFIER,
                longDate,
                scope,
                priorSignature,
                hashedHeaders,
                hashedPayload
              ].join("\n");
              return [2, this.signString(stringToSign, { signingDate, signingRegion: region, signingService })];
          }
        });
      });
    };
    SignatureV44.prototype.signString = function(stringToSign, _a2) {
      var _b2 = _a2 === void 0 ? {} : _a2, _c = _b2.signingDate, signingDate = _c === void 0 ? /* @__PURE__ */ new Date() : _c, signingRegion = _b2.signingRegion, signingService = _b2.signingService;
      return __awaiter12(this, void 0, void 0, function() {
        var credentials, region, _d, shortDate, hash, _e, _f, _g;
        return __generator12(this, function(_h) {
          switch (_h.label) {
            case 0:
              return [4, this.credentialProvider()];
            case 1:
              credentials = _h.sent();
              if (!(signingRegion !== null && signingRegion !== void 0))
                return [3, 2];
              _d = signingRegion;
              return [3, 4];
            case 2:
              return [4, this.regionProvider()];
            case 3:
              _d = _h.sent();
              _h.label = 4;
            case 4:
              region = _d;
              shortDate = formatDate(signingDate).shortDate;
              _f = (_e = this.sha256).bind;
              return [4, this.getSigningKey(credentials, region, shortDate, signingService)];
            case 5:
              hash = new (_f.apply(_e, [void 0, _h.sent()]))();
              hash.update(stringToSign);
              _g = toHex;
              return [4, hash.digest()];
            case 6:
              return [2, _g.apply(void 0, [_h.sent()])];
          }
        });
      });
    };
    SignatureV44.prototype.signRequest = function(requestToSign, _a2) {
      var _b2 = _a2 === void 0 ? {} : _a2, _c = _b2.signingDate, signingDate = _c === void 0 ? /* @__PURE__ */ new Date() : _c, signableHeaders = _b2.signableHeaders, unsignableHeaders = _b2.unsignableHeaders, signingRegion = _b2.signingRegion, signingService = _b2.signingService;
      return __awaiter12(this, void 0, void 0, function() {
        var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
        return __generator12(this, function(_f) {
          switch (_f.label) {
            case 0:
              return [4, this.credentialProvider()];
            case 1:
              credentials = _f.sent();
              if (!(signingRegion !== null && signingRegion !== void 0))
                return [3, 2];
              _d = signingRegion;
              return [3, 4];
            case 2:
              return [4, this.regionProvider()];
            case 3:
              _d = _f.sent();
              _f.label = 4;
            case 4:
              region = _d;
              request = prepareRequest(requestToSign);
              _e = formatDate(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
              scope = createScope(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
              request.headers[AMZ_DATE_HEADER2] = longDate;
              if (credentials.sessionToken) {
                request.headers[TOKEN_HEADER2] = credentials.sessionToken;
              }
              return [4, getPayloadHash(request, this.sha256)];
            case 5:
              payloadHash = _f.sent();
              if (!hasHeader(SHA256_HEADER, request.headers) && this.applyChecksum) {
                request.headers[SHA256_HEADER] = payloadHash;
              }
              canonicalHeaders = getCanonicalHeaders2(request, unsignableHeaders, signableHeaders);
              return [4, this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))];
            case 6:
              signature = _f.sent();
              request.headers[AUTH_HEADER2] = ALGORITHM_IDENTIFIER + " " + ("Credential=" + credentials.accessKeyId + "/" + scope + ", ") + ("SignedHeaders=" + getCanonicalHeaderList(canonicalHeaders) + ", ") + ("Signature=" + signature);
              return [2, request];
          }
        });
      });
    };
    SignatureV44.prototype.createCanonicalRequest = function(request, canonicalHeaders, payloadHash) {
      var sortedHeaders = Object.keys(canonicalHeaders).sort();
      return request.method + "\n" + this.getCanonicalPath(request) + "\n" + getCanonicalQuery(request) + "\n" + sortedHeaders.map(function(name) {
        return name + ":" + canonicalHeaders[name];
      }).join("\n") + "\n\n" + sortedHeaders.join(";") + "\n" + payloadHash;
    };
    SignatureV44.prototype.createStringToSign = function(longDate, credentialScope, canonicalRequest) {
      return __awaiter12(this, void 0, void 0, function() {
        var hash, hashedRequest;
        return __generator12(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              hash = new this.sha256();
              hash.update(canonicalRequest);
              return [4, hash.digest()];
            case 1:
              hashedRequest = _a2.sent();
              return [2, ALGORITHM_IDENTIFIER + "\n" + longDate + "\n" + credentialScope + "\n" + toHex(hashedRequest)];
          }
        });
      });
    };
    SignatureV44.prototype.getCanonicalPath = function(_a2) {
      var path = _a2.path;
      if (this.uriEscapePath) {
        var doubleEncoded = encodeURIComponent(path.replace(/^\//, ""));
        return "/" + doubleEncoded.replace(/%2F/g, "/");
      }
      return path;
    };
    SignatureV44.prototype.getSignature = function(longDate, credentialScope, keyPromise, canonicalRequest) {
      return __awaiter12(this, void 0, void 0, function() {
        var stringToSign, hash, _a2, _b2, _c;
        return __generator12(this, function(_d) {
          switch (_d.label) {
            case 0:
              return [4, this.createStringToSign(longDate, credentialScope, canonicalRequest)];
            case 1:
              stringToSign = _d.sent();
              _b2 = (_a2 = this.sha256).bind;
              return [4, keyPromise];
            case 2:
              hash = new (_b2.apply(_a2, [void 0, _d.sent()]))();
              hash.update(stringToSign);
              _c = toHex;
              return [4, hash.digest()];
            case 3:
              return [2, _c.apply(void 0, [_d.sent()])];
          }
        });
      });
    };
    SignatureV44.prototype.getSigningKey = function(credentials, region, shortDate, service) {
      return getSigningKey2(this.sha256, credentials, shortDate, region, service || this.service);
    };
    return SignatureV44;
  }()
);
var formatDate = function(now) {
  var longDate = iso8601(now).replace(/[\-:]/g, "");
  return {
    longDate,
    shortDate: longDate.substr(0, 8)
  };
};
var getCanonicalHeaderList = function(headers) {
  return Object.keys(headers).sort().join(";");
};
var normalizeRegionProvider = function(region) {
  if (typeof region === "string") {
    var promisified_1 = Promise.resolve(region);
    return function() {
      return promisified_1;
    };
  } else {
    return region;
  }
};
var normalizeCredentialsProvider = function(credentials) {
  if (typeof credentials === "object") {
    var promisified_2 = Promise.resolve(credentials);
    return function() {
      return promisified_2;
    };
  } else {
    return credentials;
  }
};

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-sdk/middleware-signing/dist/es/configurations.js
function resolveAwsAuthConfig(input) {
  var _this = this;
  var credentials = input.credentials || input.credentialDefaultProvider(input);
  var normalizedCreds = normalizeProvider(credentials);
  var _a2 = input.signingEscapePath, signingEscapePath = _a2 === void 0 ? true : _a2, _b2 = input.systemClockOffset, systemClockOffset = _b2 === void 0 ? input.systemClockOffset || 0 : _b2, sha256 = input.sha256;
  var signer;
  if (input.signer) {
    signer = normalizeProvider(input.signer);
  } else {
    signer = function() {
      return normalizeProvider(input.region)().then(function(region) {
        return __awaiter11(_this, void 0, void 0, function() {
          return __generator11(this, function(_a3) {
            switch (_a3.label) {
              case 0:
                return [4, input.regionInfoProvider(region)];
              case 1:
                return [2, [_a3.sent() || {}, region]];
            }
          });
        });
      }).then(function(_a3) {
        var _b3 = __read14(_a3, 2), regionInfo = _b3[0], region = _b3[1];
        var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
        input.signingRegion = input.signingRegion || signingRegion || region;
        input.signingName = input.signingName || signingService || input.serviceId;
        return new SignatureV4({
          credentials: normalizedCreds,
          region: input.signingRegion,
          service: input.signingName,
          sha256,
          uriEscapePath: signingEscapePath
        });
      });
    };
  }
  return __assign12(__assign12({}, input), {
    systemClockOffset,
    signingEscapePath,
    credentials: normalizedCreds,
    signer
  });
}
function normalizeProvider(input) {
  if (typeof input === "object") {
    var promisified_1 = Promise.resolve(input);
    return function() {
      return promisified_1;
    };
  }
  return input;
}

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-sdk/middleware-signing/dist/es/middleware.js
var isClockSkewed = function(newServerTime, systemClockOffset) {
  return Math.abs(getSkewCorrectedDate(systemClockOffset).getTime() - newServerTime) >= 3e5;
};
var getSkewCorrectedDate = function(systemClockOffset) {
  return new Date(Date.now() + systemClockOffset);
};
function awsAuthMiddleware(options) {
  return function(next, context) {
    return function(args) {
      return __awaiter11(this, void 0, void 0, function() {
        var signer, _a2, output, _b2, _c, headers, dateHeader, serverTime;
        var _d;
        return __generator11(this, function(_e) {
          switch (_e.label) {
            case 0:
              if (!HttpRequest.isInstance(args.request))
                return [2, next(args)];
              if (!(typeof options.signer === "function"))
                return [3, 2];
              return [4, options.signer()];
            case 1:
              _a2 = _e.sent();
              return [3, 3];
            case 2:
              _a2 = options.signer;
              _e.label = 3;
            case 3:
              signer = _a2;
              _b2 = next;
              _c = [__assign12({}, args)];
              _d = {};
              return [4, signer.sign(args.request, {
                signingDate: new Date(Date.now() + options.systemClockOffset),
                signingRegion: context["signing_region"],
                signingService: context["signing_service"]
              })];
            case 4:
              return [4, _b2.apply(void 0, [__assign12.apply(void 0, _c.concat([(_d.request = _e.sent(), _d)]))])];
            case 5:
              output = _e.sent();
              headers = output.response.headers;
              dateHeader = headers && (headers.date || headers.Date);
              if (dateHeader) {
                serverTime = Date.parse(dateHeader);
                if (isClockSkewed(serverTime, options.systemClockOffset)) {
                  options.systemClockOffset = serverTime - Date.now();
                }
              }
              return [2, output];
          }
        });
      });
    };
  };
}
var awsAuthMiddlewareOptions = {
  name: "awsAuthMiddleware",
  tags: ["SIGNATURE", "AWSAUTH"],
  relation: "after",
  toMiddleware: "retryMiddleware",
  override: true
};
var getAwsAuthPlugin = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.addRelativeTo(awsAuthMiddleware(options), awsAuthMiddlewareOptions);
    }
  };
};

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-sdk/middleware-user-agent/node_modules/tslib/tslib.es6.js
var __assign14 = function() {
  __assign14 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign14.apply(this, arguments);
};
function __awaiter13(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator13(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __read16(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}
function __spread5() {
  for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
    ar = ar.concat(__read16(arguments[i2]));
  return ar;
}

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-sdk/middleware-user-agent/dist/es/configurations.js
function resolveUserAgentConfig(input) {
  return __assign14(__assign14({}, input), { customUserAgent: typeof input.customUserAgent === "string" ? [[input.customUserAgent]] : input.customUserAgent });
}

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-sdk/middleware-user-agent/dist/es/constants.js
var USER_AGENT = "user-agent";
var X_AMZ_USER_AGENT = "x-amz-user-agent";
var SPACE = " ";
var UA_ESCAPE_REGEX = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

// node_modules/@aws-sdk/client-cloudwatch-logs/node_modules/@aws-sdk/middleware-user-agent/dist/es/user-agent-middleware.js
var userAgentMiddleware = function(options) {
  return function(next, context) {
    return function(args) {
      return __awaiter13(void 0, void 0, void 0, function() {
        var request, headers, userAgent2, defaultUserAgent8, customUserAgent, normalUAValue;
        var _a2, _b2;
        return __generator13(this, function(_c) {
          switch (_c.label) {
            case 0:
              request = args.request;
              if (!HttpRequest.isInstance(request))
                return [2, next(args)];
              headers = request.headers;
              userAgent2 = ((_a2 = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a2 === void 0 ? void 0 : _a2.map(escapeUserAgent)) || [];
              return [4, options.defaultUserAgentProvider()];
            case 1:
              defaultUserAgent8 = _c.sent().map(escapeUserAgent);
              customUserAgent = ((_b2 = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b2 === void 0 ? void 0 : _b2.map(escapeUserAgent)) || [];
              headers[X_AMZ_USER_AGENT] = __spread5(defaultUserAgent8, userAgent2, customUserAgent).join(SPACE);
              normalUAValue = __spread5(defaultUserAgent8.filter(function(section) {
                return section.startsWith("aws-sdk-");
              }), customUserAgent).join(SPACE);
              if (options.runtime !== "browser" && normalUAValue) {
                headers[USER_AGENT] = headers[USER_AGENT] ? headers[USER_AGENT] + " " + normalUAValue : normalUAValue;
              }
              return [2, next(__assign14(__assign14({}, args), { request }))];
          }
        });
      });
    };
  };
};
var escapeUserAgent = function(_a2) {
  var _b2 = __read16(_a2, 2), name = _b2[0], version3 = _b2[1];
  var prefixSeparatorIndex = name.indexOf("/");
  var prefix = name.substring(0, prefixSeparatorIndex);
  var uaName = name.substring(prefixSeparatorIndex + 1);
  if (prefix === "api") {
    uaName = uaName.toLowerCase();
  }
  return [prefix, uaName, version3].filter(function(item) {
    return item && item.length > 0;
  }).map(function(item) {
    return item === null || item === void 0 ? void 0 : item.replace(UA_ESCAPE_REGEX, "_");
  }).join("/");
};
var getUserAgentMiddlewareOptions = {
  name: "getUserAgentMiddleware",
  step: "build",
  priority: "low",
  tags: ["SET_USER_AGENT", "USER_AGENT"],
  override: true
};
var getUserAgentPlugin = function(config) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(userAgentMiddleware(config), getUserAgentMiddlewareOptions);
    }
  };
};

// node_modules/@aws-sdk/middleware-stack/node_modules/tslib/tslib.es6.js
var __assign15 = function() {
  __assign15 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign15.apply(this, arguments);
};
function __values9(o2) {
  var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
  if (m2)
    return m2.call(o2);
  if (o2 && typeof o2.length === "number")
    return {
      next: function() {
        if (o2 && i2 >= o2.length)
          o2 = void 0;
        return { value: o2 && o2[i2++], done: !o2 };
      }
    };
  throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read17(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}
function __spread6() {
  for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
    ar = ar.concat(__read17(arguments[i2]));
  return ar;
}

// node_modules/@aws-sdk/middleware-stack/dist/es/MiddlewareStack.js
var constructStack = function() {
  var absoluteEntries = [];
  var relativeEntries = [];
  var entriesNameSet = /* @__PURE__ */ new Set();
  var sort = function(entries) {
    return entries.sort(function(a2, b2) {
      return stepWeights[b2.step] - stepWeights[a2.step] || priorityWeights[b2.priority || "normal"] - priorityWeights[a2.priority || "normal"];
    });
  };
  var removeByName = function(toRemove) {
    var isRemoved = false;
    var filterCb = function(entry) {
      if (entry.name && entry.name === toRemove) {
        isRemoved = true;
        entriesNameSet.delete(toRemove);
        return false;
      }
      return true;
    };
    absoluteEntries = absoluteEntries.filter(filterCb);
    relativeEntries = relativeEntries.filter(filterCb);
    return isRemoved;
  };
  var removeByReference = function(toRemove) {
    var isRemoved = false;
    var filterCb = function(entry) {
      if (entry.middleware === toRemove) {
        isRemoved = true;
        if (entry.name)
          entriesNameSet.delete(entry.name);
        return false;
      }
      return true;
    };
    absoluteEntries = absoluteEntries.filter(filterCb);
    relativeEntries = relativeEntries.filter(filterCb);
    return isRemoved;
  };
  var cloneTo = function(toStack) {
    absoluteEntries.forEach(function(entry) {
      toStack.add(entry.middleware, __assign15({}, entry));
    });
    relativeEntries.forEach(function(entry) {
      toStack.addRelativeTo(entry.middleware, __assign15({}, entry));
    });
    return toStack;
  };
  var expandRelativeMiddlewareList = function(from) {
    var expandedMiddlewareList = [];
    from.before.forEach(function(entry) {
      if (entry.before.length === 0 && entry.after.length === 0) {
        expandedMiddlewareList.push(entry);
      } else {
        expandedMiddlewareList.push.apply(expandedMiddlewareList, __spread6(expandRelativeMiddlewareList(entry)));
      }
    });
    expandedMiddlewareList.push(from);
    from.after.reverse().forEach(function(entry) {
      if (entry.before.length === 0 && entry.after.length === 0) {
        expandedMiddlewareList.push(entry);
      } else {
        expandedMiddlewareList.push.apply(expandedMiddlewareList, __spread6(expandRelativeMiddlewareList(entry)));
      }
    });
    return expandedMiddlewareList;
  };
  var getMiddlewareList = function() {
    var normalizedAbsoluteEntries = [];
    var normalizedRelativeEntries = [];
    var normalizedEntriesNameMap = {};
    absoluteEntries.forEach(function(entry) {
      var normalizedEntry = __assign15(__assign15({}, entry), { before: [], after: [] });
      if (normalizedEntry.name)
        normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
      normalizedAbsoluteEntries.push(normalizedEntry);
    });
    relativeEntries.forEach(function(entry) {
      var normalizedEntry = __assign15(__assign15({}, entry), { before: [], after: [] });
      if (normalizedEntry.name)
        normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
      normalizedRelativeEntries.push(normalizedEntry);
    });
    normalizedRelativeEntries.forEach(function(entry) {
      if (entry.toMiddleware) {
        var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
        if (toMiddleware === void 0) {
          throw new Error(entry.toMiddleware + " is not found when adding " + (entry.name || "anonymous") + " middleware " + entry.relation + " " + entry.toMiddleware);
        }
        if (entry.relation === "after") {
          toMiddleware.after.push(entry);
        }
        if (entry.relation === "before") {
          toMiddleware.before.push(entry);
        }
      }
    });
    var mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce(function(wholeList, expendedMiddlewareList) {
      wholeList.push.apply(wholeList, __spread6(expendedMiddlewareList));
      return wholeList;
    }, []);
    return mainChain.map(function(entry) {
      return entry.middleware;
    });
  };
  var stack = {
    add: function(middleware, options) {
      if (options === void 0) {
        options = {};
      }
      var name = options.name, override = options.override;
      var entry = __assign15({ step: "initialize", priority: "normal", middleware }, options);
      if (name) {
        if (entriesNameSet.has(name)) {
          if (!override)
            throw new Error("Duplicate middleware name '" + name + "'");
          var toOverrideIndex = absoluteEntries.findIndex(function(entry2) {
            return entry2.name === name;
          });
          var toOverride = absoluteEntries[toOverrideIndex];
          if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) {
            throw new Error('"' + name + '" middleware with ' + toOverride.priority + " priority in " + toOverride.step + " step cannot be " + ("overridden by same-name middleware with " + entry.priority + " priority in " + entry.step + " step."));
          }
          absoluteEntries.splice(toOverrideIndex, 1);
        }
        entriesNameSet.add(name);
      }
      absoluteEntries.push(entry);
    },
    addRelativeTo: function(middleware, options) {
      var name = options.name, override = options.override;
      var entry = __assign15({ middleware }, options);
      if (name) {
        if (entriesNameSet.has(name)) {
          if (!override)
            throw new Error("Duplicate middleware name '" + name + "'");
          var toOverrideIndex = relativeEntries.findIndex(function(entry2) {
            return entry2.name === name;
          });
          var toOverride = relativeEntries[toOverrideIndex];
          if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) {
            throw new Error('"' + name + '" middleware ' + toOverride.relation + ' "' + toOverride.toMiddleware + '" middleware cannot be overridden ' + ("by same-name middleware " + entry.relation + ' "' + entry.toMiddleware + '" middleware.'));
          }
          relativeEntries.splice(toOverrideIndex, 1);
        }
        entriesNameSet.add(name);
      }
      relativeEntries.push(entry);
    },
    clone: function() {
      return cloneTo(constructStack());
    },
    use: function(plugin) {
      plugin.applyToStack(stack);
    },
    remove: function(toRemove) {
      if (typeof toRemove === "string")
        return removeByName(toRemove);
      else
        return removeByReference(toRemove);
    },
    removeByTag: function(toRemove) {
      var isRemoved = false;
      var filterCb = function(entry) {
        var tags = entry.tags, name = entry.name;
        if (tags && tags.includes(toRemove)) {
          if (name)
            entriesNameSet.delete(name);
          isRemoved = true;
          return false;
        }
        return true;
      };
      absoluteEntries = absoluteEntries.filter(filterCb);
      relativeEntries = relativeEntries.filter(filterCb);
      return isRemoved;
    },
    concat: function(from) {
      var cloned = cloneTo(constructStack());
      cloned.use(from);
      return cloned;
    },
    applyToStack: cloneTo,
    resolve: function(handler, context) {
      var e_1, _a2;
      try {
        for (var _b2 = __values9(getMiddlewareList().reverse()), _c = _b2.next(); !_c.done; _c = _b2.next()) {
          var middleware = _c.value;
          handler = middleware(handler, context);
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (_c && !_c.done && (_a2 = _b2.return))
            _a2.call(_b2);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
      return handler;
    }
  };
  return stack;
};
var stepWeights = {
  initialize: 5,
  serialize: 4,
  build: 3,
  finalizeRequest: 2,
  deserialize: 1
};
var priorityWeights = {
  high: 3,
  normal: 2,
  low: 1
};

// node_modules/@aws-sdk/smithy-client/dist/es/client.js
var Client = (
  /** @class */
  function() {
    function Client5(config) {
      this.middlewareStack = constructStack();
      this.config = config;
    }
    Client5.prototype.send = function(command, optionsOrCb, cb) {
      var options = typeof optionsOrCb !== "function" ? optionsOrCb : void 0;
      var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
      var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
      if (callback) {
        handler(command).then(function(result) {
          return callback(null, result.output);
        }, function(err) {
          return callback(err);
        }).catch(
          // prevent any errors thrown in the callback from triggering an
          // unhandled promise rejection
          function() {
          }
        );
      } else {
        return handler(command).then(function(result) {
          return result.output;
        });
      }
    };
    Client5.prototype.destroy = function() {
      if (this.config.requestHandler.destroy)
        this.config.requestHandler.destroy();
    };
    return Client5;
  }()
);

// node_modules/@aws-sdk/smithy-client/dist/es/command.js
var Command = (
  /** @class */
  function() {
    function Command4() {
      this.middlewareStack = constructStack();
    }
    return Command4;
  }()
);

// node_modules/@aws-sdk/smithy-client/dist/es/extended-encode-uri-component.js
function extendedEncodeURIComponent(str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function(c2) {
    return "%" + c2.charCodeAt(0).toString(16);
  });
}

// node_modules/@aws-sdk/smithy-client/dist/es/get-array-if-single-item.js
var getArrayIfSingleItem = function(mayBeArray) {
  return Array.isArray(mayBeArray) ? mayBeArray : [mayBeArray];
};

// node_modules/@aws-sdk/smithy-client/dist/es/get-value-from-text-node.js
var getValueFromTextNode = function(obj) {
  var textNodeName = "#text";
  for (var key in obj) {
    if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== void 0) {
      obj[key] = obj[key][textNodeName];
    } else if (typeof obj[key] === "object" && obj[key] !== null) {
      obj[key] = getValueFromTextNode(obj[key]);
    }
  }
  return obj;
};

// node_modules/@aws-sdk/smithy-client/node_modules/tslib/tslib.es6.js
var extendStatics2 = function(d2, b2) {
  extendStatics2 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b3) {
    d3.__proto__ = b3;
  } || function(d3, b3) {
    for (var p2 in b3)
      if (b3.hasOwnProperty(p2))
        d3[p2] = b3[p2];
  };
  return extendStatics2(d2, b2);
};
function __extends4(d2, b2) {
  extendStatics2(d2, b2);
  function __() {
    this.constructor = d2;
  }
  d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
}
function __read18(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}
function __spread7() {
  for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
    ar = ar.concat(__read18(arguments[i2]));
  return ar;
}

// node_modules/@aws-sdk/smithy-client/dist/es/lazy-json.js
var StringWrapper = function() {
  var Class = Object.getPrototypeOf(this).constructor;
  var Constructor = Function.bind.apply(String, __spread7([null], arguments));
  var instance2 = new Constructor();
  Object.setPrototypeOf(instance2, Class.prototype);
  return instance2;
};
StringWrapper.prototype = Object.create(String.prototype, {
  constructor: {
    value: StringWrapper,
    enumerable: false,
    writable: true,
    configurable: true
  }
});
Object.setPrototypeOf(StringWrapper, String);
var LazyJsonString = (
  /** @class */
  function(_super) {
    __extends4(LazyJsonString4, _super);
    function LazyJsonString4() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    LazyJsonString4.prototype.deserializeJSON = function() {
      return JSON.parse(_super.prototype.toString.call(this));
    };
    LazyJsonString4.prototype.toJSON = function() {
      return _super.prototype.toString.call(this);
    };
    LazyJsonString4.fromObject = function(object) {
      if (object instanceof LazyJsonString4) {
        return object;
      } else if (object instanceof String || typeof object === "string") {
        return new LazyJsonString4(object);
      }
      return new LazyJsonString4(JSON.stringify(object));
    };
    return LazyJsonString4;
  }(StringWrapper)
);

// node_modules/@aws-sdk/smithy-client/dist/es/date-utils.js
var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
function dateToUtcString(date) {
  var year = date.getUTCFullYear();
  var month = date.getUTCMonth();
  var dayOfWeek = date.getUTCDay();
  var dayOfMonthInt = date.getUTCDate();
  var hoursInt = date.getUTCHours();
  var minutesInt = date.getUTCMinutes();
  var secondsInt = date.getUTCSeconds();
  var dayOfMonthString = dayOfMonthInt < 10 ? "0" + dayOfMonthInt : "" + dayOfMonthInt;
  var hoursString = hoursInt < 10 ? "0" + hoursInt : "" + hoursInt;
  var minutesString = minutesInt < 10 ? "0" + minutesInt : "" + minutesInt;
  var secondsString = secondsInt < 10 ? "0" + secondsInt : "" + secondsInt;
  return days[dayOfWeek] + ", " + dayOfMonthString + " " + months[month] + " " + year + " " + hoursString + ":" + minutesString + ":" + secondsString + " GMT";
}

// node_modules/@aws-sdk/smithy-client/dist/es/constants.js
var SENSITIVE_STRING = "***SensitiveInformation***";

// node_modules/@aws-sdk/client-cloudwatch-logs/dist/es/CloudWatchLogsClient.js
var CloudWatchLogsClient = (
  /** @class */
  function(_super) {
    __extends3(CloudWatchLogsClient2, _super);
    function CloudWatchLogsClient2(configuration) {
      var _this = this;
      var _config_0 = __assign7(__assign7({}, ClientDefaultValues), configuration);
      var _config_1 = resolveRegionConfig(_config_0);
      var _config_2 = resolveEndpointsConfig(_config_1);
      var _config_3 = resolveAwsAuthConfig(_config_2);
      var _config_4 = resolveRetryConfig(_config_3);
      var _config_5 = resolveHostHeaderConfig(_config_4);
      var _config_6 = resolveUserAgentConfig(_config_5);
      _this = _super.call(this, _config_6) || this;
      _this.config = _config_6;
      _this.middlewareStack.use(getAwsAuthPlugin(_this.config));
      _this.middlewareStack.use(getRetryPlugin(_this.config));
      _this.middlewareStack.use(getContentLengthPlugin(_this.config));
      _this.middlewareStack.use(getHostHeaderPlugin(_this.config));
      _this.middlewareStack.use(getLoggerPlugin(_this.config));
      _this.middlewareStack.use(getUserAgentPlugin(_this.config));
      return _this;
    }
    CloudWatchLogsClient2.prototype.destroy = function() {
      _super.prototype.destroy.call(this);
    };
    return CloudWatchLogsClient2;
  }(Client)
);

// node_modules/@aws-sdk/client-cloudwatch-logs/dist/es/models/models_0.js
var AssociateKmsKeyRequest;
(function(AssociateKmsKeyRequest2) {
  AssociateKmsKeyRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(AssociateKmsKeyRequest || (AssociateKmsKeyRequest = {}));
var InvalidParameterException;
(function(InvalidParameterException2) {
  InvalidParameterException2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(InvalidParameterException || (InvalidParameterException = {}));
var OperationAbortedException;
(function(OperationAbortedException2) {
  OperationAbortedException2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(OperationAbortedException || (OperationAbortedException = {}));
var ResourceNotFoundException;
(function(ResourceNotFoundException6) {
  ResourceNotFoundException6.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
var ServiceUnavailableException;
(function(ServiceUnavailableException3) {
  ServiceUnavailableException3.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ServiceUnavailableException || (ServiceUnavailableException = {}));
var CancelExportTaskRequest;
(function(CancelExportTaskRequest2) {
  CancelExportTaskRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CancelExportTaskRequest || (CancelExportTaskRequest = {}));
var InvalidOperationException;
(function(InvalidOperationException2) {
  InvalidOperationException2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(InvalidOperationException || (InvalidOperationException = {}));
var CreateExportTaskRequest;
(function(CreateExportTaskRequest2) {
  CreateExportTaskRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CreateExportTaskRequest || (CreateExportTaskRequest = {}));
var CreateExportTaskResponse;
(function(CreateExportTaskResponse2) {
  CreateExportTaskResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CreateExportTaskResponse || (CreateExportTaskResponse = {}));
var LimitExceededException;
(function(LimitExceededException5) {
  LimitExceededException5.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(LimitExceededException || (LimitExceededException = {}));
var ResourceAlreadyExistsException;
(function(ResourceAlreadyExistsException2) {
  ResourceAlreadyExistsException2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ResourceAlreadyExistsException || (ResourceAlreadyExistsException = {}));
var CreateLogGroupRequest;
(function(CreateLogGroupRequest2) {
  CreateLogGroupRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CreateLogGroupRequest || (CreateLogGroupRequest = {}));
var CreateLogStreamRequest;
(function(CreateLogStreamRequest2) {
  CreateLogStreamRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CreateLogStreamRequest || (CreateLogStreamRequest = {}));
var DataAlreadyAcceptedException;
(function(DataAlreadyAcceptedException2) {
  DataAlreadyAcceptedException2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DataAlreadyAcceptedException || (DataAlreadyAcceptedException = {}));
var DeleteDestinationRequest;
(function(DeleteDestinationRequest2) {
  DeleteDestinationRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteDestinationRequest || (DeleteDestinationRequest = {}));
var DeleteLogGroupRequest;
(function(DeleteLogGroupRequest2) {
  DeleteLogGroupRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteLogGroupRequest || (DeleteLogGroupRequest = {}));
var DeleteLogStreamRequest;
(function(DeleteLogStreamRequest2) {
  DeleteLogStreamRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteLogStreamRequest || (DeleteLogStreamRequest = {}));
var DeleteMetricFilterRequest;
(function(DeleteMetricFilterRequest2) {
  DeleteMetricFilterRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteMetricFilterRequest || (DeleteMetricFilterRequest = {}));
var DeleteQueryDefinitionRequest;
(function(DeleteQueryDefinitionRequest2) {
  DeleteQueryDefinitionRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteQueryDefinitionRequest || (DeleteQueryDefinitionRequest = {}));
var DeleteQueryDefinitionResponse;
(function(DeleteQueryDefinitionResponse2) {
  DeleteQueryDefinitionResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteQueryDefinitionResponse || (DeleteQueryDefinitionResponse = {}));
var DeleteResourcePolicyRequest;
(function(DeleteResourcePolicyRequest2) {
  DeleteResourcePolicyRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteResourcePolicyRequest || (DeleteResourcePolicyRequest = {}));
var DeleteRetentionPolicyRequest;
(function(DeleteRetentionPolicyRequest2) {
  DeleteRetentionPolicyRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteRetentionPolicyRequest || (DeleteRetentionPolicyRequest = {}));
var DeleteSubscriptionFilterRequest;
(function(DeleteSubscriptionFilterRequest2) {
  DeleteSubscriptionFilterRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteSubscriptionFilterRequest || (DeleteSubscriptionFilterRequest = {}));
var DescribeDestinationsRequest;
(function(DescribeDestinationsRequest2) {
  DescribeDestinationsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeDestinationsRequest || (DescribeDestinationsRequest = {}));
var Destination;
(function(Destination3) {
  Destination3.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Destination || (Destination = {}));
var DescribeDestinationsResponse;
(function(DescribeDestinationsResponse2) {
  DescribeDestinationsResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeDestinationsResponse || (DescribeDestinationsResponse = {}));
var ExportTaskStatusCode;
(function(ExportTaskStatusCode2) {
  ExportTaskStatusCode2["CANCELLED"] = "CANCELLED";
  ExportTaskStatusCode2["COMPLETED"] = "COMPLETED";
  ExportTaskStatusCode2["FAILED"] = "FAILED";
  ExportTaskStatusCode2["PENDING"] = "PENDING";
  ExportTaskStatusCode2["PENDING_CANCEL"] = "PENDING_CANCEL";
  ExportTaskStatusCode2["RUNNING"] = "RUNNING";
})(ExportTaskStatusCode || (ExportTaskStatusCode = {}));
var DescribeExportTasksRequest;
(function(DescribeExportTasksRequest2) {
  DescribeExportTasksRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeExportTasksRequest || (DescribeExportTasksRequest = {}));
var ExportTaskExecutionInfo;
(function(ExportTaskExecutionInfo2) {
  ExportTaskExecutionInfo2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ExportTaskExecutionInfo || (ExportTaskExecutionInfo = {}));
var ExportTaskStatus;
(function(ExportTaskStatus2) {
  ExportTaskStatus2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ExportTaskStatus || (ExportTaskStatus = {}));
var ExportTask;
(function(ExportTask2) {
  ExportTask2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ExportTask || (ExportTask = {}));
var DescribeExportTasksResponse;
(function(DescribeExportTasksResponse2) {
  DescribeExportTasksResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeExportTasksResponse || (DescribeExportTasksResponse = {}));
var DescribeLogGroupsRequest;
(function(DescribeLogGroupsRequest2) {
  DescribeLogGroupsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeLogGroupsRequest || (DescribeLogGroupsRequest = {}));
var LogGroup;
(function(LogGroup2) {
  LogGroup2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(LogGroup || (LogGroup = {}));
var DescribeLogGroupsResponse;
(function(DescribeLogGroupsResponse2) {
  DescribeLogGroupsResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeLogGroupsResponse || (DescribeLogGroupsResponse = {}));
var OrderBy;
(function(OrderBy2) {
  OrderBy2["LastEventTime"] = "LastEventTime";
  OrderBy2["LogStreamName"] = "LogStreamName";
})(OrderBy || (OrderBy = {}));
var DescribeLogStreamsRequest;
(function(DescribeLogStreamsRequest2) {
  DescribeLogStreamsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeLogStreamsRequest || (DescribeLogStreamsRequest = {}));
var LogStream;
(function(LogStream2) {
  LogStream2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(LogStream || (LogStream = {}));
var DescribeLogStreamsResponse;
(function(DescribeLogStreamsResponse2) {
  DescribeLogStreamsResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeLogStreamsResponse || (DescribeLogStreamsResponse = {}));
var DescribeMetricFiltersRequest;
(function(DescribeMetricFiltersRequest2) {
  DescribeMetricFiltersRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeMetricFiltersRequest || (DescribeMetricFiltersRequest = {}));
var MetricTransformation;
(function(MetricTransformation2) {
  MetricTransformation2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(MetricTransformation || (MetricTransformation = {}));
var MetricFilter;
(function(MetricFilter2) {
  MetricFilter2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(MetricFilter || (MetricFilter = {}));
var DescribeMetricFiltersResponse;
(function(DescribeMetricFiltersResponse2) {
  DescribeMetricFiltersResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeMetricFiltersResponse || (DescribeMetricFiltersResponse = {}));
var QueryStatus;
(function(QueryStatus2) {
  QueryStatus2["Cancelled"] = "Cancelled";
  QueryStatus2["Complete"] = "Complete";
  QueryStatus2["Failed"] = "Failed";
  QueryStatus2["Running"] = "Running";
  QueryStatus2["Scheduled"] = "Scheduled";
})(QueryStatus || (QueryStatus = {}));
var DescribeQueriesRequest;
(function(DescribeQueriesRequest2) {
  DescribeQueriesRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeQueriesRequest || (DescribeQueriesRequest = {}));
var QueryInfo;
(function(QueryInfo2) {
  QueryInfo2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(QueryInfo || (QueryInfo = {}));
var DescribeQueriesResponse;
(function(DescribeQueriesResponse2) {
  DescribeQueriesResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeQueriesResponse || (DescribeQueriesResponse = {}));
var DescribeQueryDefinitionsRequest;
(function(DescribeQueryDefinitionsRequest2) {
  DescribeQueryDefinitionsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeQueryDefinitionsRequest || (DescribeQueryDefinitionsRequest = {}));
var QueryDefinition;
(function(QueryDefinition2) {
  QueryDefinition2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(QueryDefinition || (QueryDefinition = {}));
var DescribeQueryDefinitionsResponse;
(function(DescribeQueryDefinitionsResponse2) {
  DescribeQueryDefinitionsResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeQueryDefinitionsResponse || (DescribeQueryDefinitionsResponse = {}));
var DescribeResourcePoliciesRequest;
(function(DescribeResourcePoliciesRequest2) {
  DescribeResourcePoliciesRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeResourcePoliciesRequest || (DescribeResourcePoliciesRequest = {}));
var ResourcePolicy;
(function(ResourcePolicy2) {
  ResourcePolicy2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ResourcePolicy || (ResourcePolicy = {}));
var DescribeResourcePoliciesResponse;
(function(DescribeResourcePoliciesResponse2) {
  DescribeResourcePoliciesResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeResourcePoliciesResponse || (DescribeResourcePoliciesResponse = {}));
var DescribeSubscriptionFiltersRequest;
(function(DescribeSubscriptionFiltersRequest2) {
  DescribeSubscriptionFiltersRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeSubscriptionFiltersRequest || (DescribeSubscriptionFiltersRequest = {}));
var Distribution;
(function(Distribution2) {
  Distribution2["ByLogStream"] = "ByLogStream";
  Distribution2["Random"] = "Random";
})(Distribution || (Distribution = {}));
var SubscriptionFilter;
(function(SubscriptionFilter2) {
  SubscriptionFilter2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(SubscriptionFilter || (SubscriptionFilter = {}));
var DescribeSubscriptionFiltersResponse;
(function(DescribeSubscriptionFiltersResponse2) {
  DescribeSubscriptionFiltersResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeSubscriptionFiltersResponse || (DescribeSubscriptionFiltersResponse = {}));
var DisassociateKmsKeyRequest;
(function(DisassociateKmsKeyRequest2) {
  DisassociateKmsKeyRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DisassociateKmsKeyRequest || (DisassociateKmsKeyRequest = {}));
var FilteredLogEvent;
(function(FilteredLogEvent2) {
  FilteredLogEvent2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(FilteredLogEvent || (FilteredLogEvent = {}));
var FilterLogEventsRequest;
(function(FilterLogEventsRequest2) {
  FilterLogEventsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(FilterLogEventsRequest || (FilterLogEventsRequest = {}));
var SearchedLogStream;
(function(SearchedLogStream2) {
  SearchedLogStream2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(SearchedLogStream || (SearchedLogStream = {}));
var FilterLogEventsResponse;
(function(FilterLogEventsResponse2) {
  FilterLogEventsResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(FilterLogEventsResponse || (FilterLogEventsResponse = {}));
var GetLogEventsRequest;
(function(GetLogEventsRequest2) {
  GetLogEventsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetLogEventsRequest || (GetLogEventsRequest = {}));
var OutputLogEvent;
(function(OutputLogEvent2) {
  OutputLogEvent2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(OutputLogEvent || (OutputLogEvent = {}));
var GetLogEventsResponse;
(function(GetLogEventsResponse2) {
  GetLogEventsResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetLogEventsResponse || (GetLogEventsResponse = {}));
var GetLogGroupFieldsRequest;
(function(GetLogGroupFieldsRequest2) {
  GetLogGroupFieldsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetLogGroupFieldsRequest || (GetLogGroupFieldsRequest = {}));
var LogGroupField;
(function(LogGroupField2) {
  LogGroupField2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(LogGroupField || (LogGroupField = {}));
var GetLogGroupFieldsResponse;
(function(GetLogGroupFieldsResponse2) {
  GetLogGroupFieldsResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetLogGroupFieldsResponse || (GetLogGroupFieldsResponse = {}));
var GetLogRecordRequest;
(function(GetLogRecordRequest2) {
  GetLogRecordRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetLogRecordRequest || (GetLogRecordRequest = {}));
var GetLogRecordResponse;
(function(GetLogRecordResponse2) {
  GetLogRecordResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetLogRecordResponse || (GetLogRecordResponse = {}));
var GetQueryResultsRequest;
(function(GetQueryResultsRequest2) {
  GetQueryResultsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetQueryResultsRequest || (GetQueryResultsRequest = {}));
var ResultField;
(function(ResultField2) {
  ResultField2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ResultField || (ResultField = {}));
var QueryStatistics;
(function(QueryStatistics2) {
  QueryStatistics2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(QueryStatistics || (QueryStatistics = {}));
var GetQueryResultsResponse;
(function(GetQueryResultsResponse2) {
  GetQueryResultsResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetQueryResultsResponse || (GetQueryResultsResponse = {}));
var InputLogEvent;
(function(InputLogEvent2) {
  InputLogEvent2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(InputLogEvent || (InputLogEvent = {}));
var InvalidSequenceTokenException;
(function(InvalidSequenceTokenException2) {
  InvalidSequenceTokenException2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(InvalidSequenceTokenException || (InvalidSequenceTokenException = {}));
var ListTagsLogGroupRequest;
(function(ListTagsLogGroupRequest2) {
  ListTagsLogGroupRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListTagsLogGroupRequest || (ListTagsLogGroupRequest = {}));
var ListTagsLogGroupResponse;
(function(ListTagsLogGroupResponse2) {
  ListTagsLogGroupResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListTagsLogGroupResponse || (ListTagsLogGroupResponse = {}));
var PutDestinationRequest;
(function(PutDestinationRequest2) {
  PutDestinationRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutDestinationRequest || (PutDestinationRequest = {}));
var PutDestinationResponse;
(function(PutDestinationResponse2) {
  PutDestinationResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutDestinationResponse || (PutDestinationResponse = {}));
var PutDestinationPolicyRequest;
(function(PutDestinationPolicyRequest2) {
  PutDestinationPolicyRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutDestinationPolicyRequest || (PutDestinationPolicyRequest = {}));
var PutLogEventsRequest;
(function(PutLogEventsRequest2) {
  PutLogEventsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutLogEventsRequest || (PutLogEventsRequest = {}));
var RejectedLogEventsInfo;
(function(RejectedLogEventsInfo2) {
  RejectedLogEventsInfo2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(RejectedLogEventsInfo || (RejectedLogEventsInfo = {}));
var PutLogEventsResponse;
(function(PutLogEventsResponse2) {
  PutLogEventsResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutLogEventsResponse || (PutLogEventsResponse = {}));
var UnrecognizedClientException;
(function(UnrecognizedClientException2) {
  UnrecognizedClientException2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(UnrecognizedClientException || (UnrecognizedClientException = {}));
var PutMetricFilterRequest;
(function(PutMetricFilterRequest2) {
  PutMetricFilterRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutMetricFilterRequest || (PutMetricFilterRequest = {}));
var PutQueryDefinitionRequest;
(function(PutQueryDefinitionRequest2) {
  PutQueryDefinitionRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutQueryDefinitionRequest || (PutQueryDefinitionRequest = {}));
var PutQueryDefinitionResponse;
(function(PutQueryDefinitionResponse2) {
  PutQueryDefinitionResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutQueryDefinitionResponse || (PutQueryDefinitionResponse = {}));
var PutResourcePolicyRequest;
(function(PutResourcePolicyRequest2) {
  PutResourcePolicyRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutResourcePolicyRequest || (PutResourcePolicyRequest = {}));
var PutResourcePolicyResponse;
(function(PutResourcePolicyResponse2) {
  PutResourcePolicyResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutResourcePolicyResponse || (PutResourcePolicyResponse = {}));
var PutRetentionPolicyRequest;
(function(PutRetentionPolicyRequest2) {
  PutRetentionPolicyRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutRetentionPolicyRequest || (PutRetentionPolicyRequest = {}));
var PutSubscriptionFilterRequest;
(function(PutSubscriptionFilterRequest2) {
  PutSubscriptionFilterRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutSubscriptionFilterRequest || (PutSubscriptionFilterRequest = {}));
var QueryCompileErrorLocation;
(function(QueryCompileErrorLocation2) {
  QueryCompileErrorLocation2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(QueryCompileErrorLocation || (QueryCompileErrorLocation = {}));
var QueryCompileError;
(function(QueryCompileError2) {
  QueryCompileError2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(QueryCompileError || (QueryCompileError = {}));
var MalformedQueryException;
(function(MalformedQueryException2) {
  MalformedQueryException2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(MalformedQueryException || (MalformedQueryException = {}));
var StartQueryRequest;
(function(StartQueryRequest2) {
  StartQueryRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(StartQueryRequest || (StartQueryRequest = {}));
var StartQueryResponse;
(function(StartQueryResponse2) {
  StartQueryResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(StartQueryResponse || (StartQueryResponse = {}));
var StopQueryRequest;
(function(StopQueryRequest2) {
  StopQueryRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(StopQueryRequest || (StopQueryRequest = {}));
var StopQueryResponse;
(function(StopQueryResponse2) {
  StopQueryResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(StopQueryResponse || (StopQueryResponse = {}));
var TagLogGroupRequest;
(function(TagLogGroupRequest2) {
  TagLogGroupRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(TagLogGroupRequest || (TagLogGroupRequest = {}));
var TestMetricFilterRequest;
(function(TestMetricFilterRequest2) {
  TestMetricFilterRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(TestMetricFilterRequest || (TestMetricFilterRequest = {}));
var MetricFilterMatchRecord;
(function(MetricFilterMatchRecord2) {
  MetricFilterMatchRecord2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(MetricFilterMatchRecord || (MetricFilterMatchRecord = {}));
var TestMetricFilterResponse;
(function(TestMetricFilterResponse2) {
  TestMetricFilterResponse2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(TestMetricFilterResponse || (TestMetricFilterResponse = {}));
var UntagLogGroupRequest;
(function(UntagLogGroupRequest2) {
  UntagLogGroupRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(UntagLogGroupRequest || (UntagLogGroupRequest = {}));

// node_modules/@aws-sdk/client-cloudwatch-logs/dist/es/protocols/Aws_json1_1.js
var serializeAws_json1_1CreateLogGroupCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var headers, body;
    return __generator3(this, function(_a2) {
      headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "Logs_20140328.CreateLogGroup"
      };
      body = JSON.stringify(serializeAws_json1_1CreateLogGroupRequest(input, context));
      return [2, buildHttpRpcRequest(context, headers, "/", void 0, body)];
    });
  });
};
var serializeAws_json1_1CreateLogStreamCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var headers, body;
    return __generator3(this, function(_a2) {
      headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "Logs_20140328.CreateLogStream"
      };
      body = JSON.stringify(serializeAws_json1_1CreateLogStreamRequest(input, context));
      return [2, buildHttpRpcRequest(context, headers, "/", void 0, body)];
    });
  });
};
var serializeAws_json1_1DescribeLogGroupsCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var headers, body;
    return __generator3(this, function(_a2) {
      headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "Logs_20140328.DescribeLogGroups"
      };
      body = JSON.stringify(serializeAws_json1_1DescribeLogGroupsRequest(input, context));
      return [2, buildHttpRpcRequest(context, headers, "/", void 0, body)];
    });
  });
};
var serializeAws_json1_1DescribeLogStreamsCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var headers, body;
    return __generator3(this, function(_a2) {
      headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "Logs_20140328.DescribeLogStreams"
      };
      body = JSON.stringify(serializeAws_json1_1DescribeLogStreamsRequest(input, context));
      return [2, buildHttpRpcRequest(context, headers, "/", void 0, body)];
    });
  });
};
var serializeAws_json1_1GetLogEventsCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var headers, body;
    return __generator3(this, function(_a2) {
      headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "Logs_20140328.GetLogEvents"
      };
      body = JSON.stringify(serializeAws_json1_1GetLogEventsRequest(input, context));
      return [2, buildHttpRpcRequest(context, headers, "/", void 0, body)];
    });
  });
};
var serializeAws_json1_1PutLogEventsCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var headers, body;
    return __generator3(this, function(_a2) {
      headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "Logs_20140328.PutLogEvents"
      };
      body = JSON.stringify(serializeAws_json1_1PutLogEventsRequest(input, context));
      return [2, buildHttpRpcRequest(context, headers, "/", void 0, body)];
    });
  });
};
var deserializeAws_json1_1CreateLogGroupCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var response;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (output.statusCode >= 300) {
            return [2, deserializeAws_json1_1CreateLogGroupCommandError(output, context)];
          }
          return [4, collectBody(output.body, context)];
        case 1:
          _a2.sent();
          response = {
            $metadata: deserializeMetadata(output)
          };
          return [2, Promise.resolve(response)];
      }
    });
  });
};
var deserializeAws_json1_1CreateLogGroupCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, response, errorCode, _b2, _c, _d, _e, _f, _g, parsedBody, message;
    var _h;
    return __generator3(this, function(_j) {
      switch (_j.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _h = {};
          return [4, parseBody(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_h.body = _j.sent(), _h)]));
          errorCode = "UnknownError";
          errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "InvalidParameterException":
              return [3, 2];
            case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
              return [3, 2];
            case "LimitExceededException":
              return [3, 4];
            case "com.amazonaws.cloudwatchlogs#LimitExceededException":
              return [3, 4];
            case "OperationAbortedException":
              return [3, 6];
            case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
              return [3, 6];
            case "ResourceAlreadyExistsException":
              return [3, 8];
            case "com.amazonaws.cloudwatchlogs#ResourceAlreadyExistsException":
              return [3, 8];
            case "ServiceUnavailableException":
              return [3, 10];
            case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
              return [3, 10];
          }
          return [3, 12];
        case 2:
          _c = [{}];
          return [4, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
        case 3:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _c.concat([_j.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 13];
        case 4:
          _d = [{}];
          return [4, deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)];
        case 5:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _d.concat([_j.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 13];
        case 6:
          _e = [{}];
          return [4, deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)];
        case 7:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _e.concat([_j.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 13];
        case 8:
          _f = [{}];
          return [4, deserializeAws_json1_1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
        case 9:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _f.concat([_j.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 13];
        case 10:
          _g = [{}];
          return [4, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
        case 11:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _g.concat([_j.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 13];
        case 12:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign7(__assign7({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
          _j.label = 13;
        case 13:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2, Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};
var deserializeAws_json1_1CreateLogStreamCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var response;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (output.statusCode >= 300) {
            return [2, deserializeAws_json1_1CreateLogStreamCommandError(output, context)];
          }
          return [4, collectBody(output.body, context)];
        case 1:
          _a2.sent();
          response = {
            $metadata: deserializeMetadata(output)
          };
          return [2, Promise.resolve(response)];
      }
    });
  });
};
var deserializeAws_json1_1CreateLogStreamCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, response, errorCode, _b2, _c, _d, _e, _f, parsedBody, message;
    var _g;
    return __generator3(this, function(_h) {
      switch (_h.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _g = {};
          return [4, parseBody(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_g.body = _h.sent(), _g)]));
          errorCode = "UnknownError";
          errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "InvalidParameterException":
              return [3, 2];
            case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
              return [3, 2];
            case "ResourceAlreadyExistsException":
              return [3, 4];
            case "com.amazonaws.cloudwatchlogs#ResourceAlreadyExistsException":
              return [3, 4];
            case "ResourceNotFoundException":
              return [3, 6];
            case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
              return [3, 6];
            case "ServiceUnavailableException":
              return [3, 8];
            case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
              return [3, 8];
          }
          return [3, 10];
        case 2:
          _c = [{}];
          return [4, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
        case 3:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _c.concat([_h.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 11];
        case 4:
          _d = [{}];
          return [4, deserializeAws_json1_1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
        case 5:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _d.concat([_h.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 11];
        case 6:
          _e = [{}];
          return [4, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
        case 7:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _e.concat([_h.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 11];
        case 8:
          _f = [{}];
          return [4, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
        case 9:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _f.concat([_h.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 11];
        case 10:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign7(__assign7({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
          _h.label = 11;
        case 11:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2, Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};
var deserializeAws_json1_1DescribeLogGroupsCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var data, contents, response;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (output.statusCode >= 300) {
            return [2, deserializeAws_json1_1DescribeLogGroupsCommandError(output, context)];
          }
          return [4, parseBody(output.body, context)];
        case 1:
          data = _a2.sent();
          contents = {};
          contents = deserializeAws_json1_1DescribeLogGroupsResponse(data, context);
          response = __assign7({ $metadata: deserializeMetadata(output) }, contents);
          return [2, Promise.resolve(response)];
      }
    });
  });
};
var deserializeAws_json1_1DescribeLogGroupsCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, response, errorCode, _b2, _c, _d, parsedBody, message;
    var _e;
    return __generator3(this, function(_f) {
      switch (_f.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _e = {};
          return [4, parseBody(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_e.body = _f.sent(), _e)]));
          errorCode = "UnknownError";
          errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "InvalidParameterException":
              return [3, 2];
            case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
              return [3, 2];
            case "ServiceUnavailableException":
              return [3, 4];
            case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
              return [3, 4];
          }
          return [3, 6];
        case 2:
          _c = [{}];
          return [4, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
        case 3:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _c.concat([_f.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 7];
        case 4:
          _d = [{}];
          return [4, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
        case 5:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _d.concat([_f.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 7];
        case 6:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign7(__assign7({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
          _f.label = 7;
        case 7:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2, Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};
var deserializeAws_json1_1DescribeLogStreamsCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var data, contents, response;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (output.statusCode >= 300) {
            return [2, deserializeAws_json1_1DescribeLogStreamsCommandError(output, context)];
          }
          return [4, parseBody(output.body, context)];
        case 1:
          data = _a2.sent();
          contents = {};
          contents = deserializeAws_json1_1DescribeLogStreamsResponse(data, context);
          response = __assign7({ $metadata: deserializeMetadata(output) }, contents);
          return [2, Promise.resolve(response)];
      }
    });
  });
};
var deserializeAws_json1_1DescribeLogStreamsCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, response, errorCode, _b2, _c, _d, _e, parsedBody, message;
    var _f;
    return __generator3(this, function(_g) {
      switch (_g.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _f = {};
          return [4, parseBody(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_f.body = _g.sent(), _f)]));
          errorCode = "UnknownError";
          errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "InvalidParameterException":
              return [3, 2];
            case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
              return [3, 2];
            case "ResourceNotFoundException":
              return [3, 4];
            case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
              return [3, 4];
            case "ServiceUnavailableException":
              return [3, 6];
            case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
              return [3, 6];
          }
          return [3, 8];
        case 2:
          _c = [{}];
          return [4, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
        case 3:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _c.concat([_g.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 9];
        case 4:
          _d = [{}];
          return [4, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
        case 5:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _d.concat([_g.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 9];
        case 6:
          _e = [{}];
          return [4, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
        case 7:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _e.concat([_g.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 9];
        case 8:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign7(__assign7({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
          _g.label = 9;
        case 9:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2, Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};
var deserializeAws_json1_1GetLogEventsCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var data, contents, response;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (output.statusCode >= 300) {
            return [2, deserializeAws_json1_1GetLogEventsCommandError(output, context)];
          }
          return [4, parseBody(output.body, context)];
        case 1:
          data = _a2.sent();
          contents = {};
          contents = deserializeAws_json1_1GetLogEventsResponse(data, context);
          response = __assign7({ $metadata: deserializeMetadata(output) }, contents);
          return [2, Promise.resolve(response)];
      }
    });
  });
};
var deserializeAws_json1_1GetLogEventsCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, response, errorCode, _b2, _c, _d, _e, parsedBody, message;
    var _f;
    return __generator3(this, function(_g) {
      switch (_g.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _f = {};
          return [4, parseBody(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_f.body = _g.sent(), _f)]));
          errorCode = "UnknownError";
          errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "InvalidParameterException":
              return [3, 2];
            case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
              return [3, 2];
            case "ResourceNotFoundException":
              return [3, 4];
            case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
              return [3, 4];
            case "ServiceUnavailableException":
              return [3, 6];
            case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
              return [3, 6];
          }
          return [3, 8];
        case 2:
          _c = [{}];
          return [4, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
        case 3:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _c.concat([_g.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 9];
        case 4:
          _d = [{}];
          return [4, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
        case 5:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _d.concat([_g.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 9];
        case 6:
          _e = [{}];
          return [4, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
        case 7:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _e.concat([_g.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 9];
        case 8:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign7(__assign7({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
          _g.label = 9;
        case 9:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2, Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};
var deserializeAws_json1_1PutLogEventsCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var data, contents, response;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (output.statusCode >= 300) {
            return [2, deserializeAws_json1_1PutLogEventsCommandError(output, context)];
          }
          return [4, parseBody(output.body, context)];
        case 1:
          data = _a2.sent();
          contents = {};
          contents = deserializeAws_json1_1PutLogEventsResponse(data, context);
          response = __assign7({ $metadata: deserializeMetadata(output) }, contents);
          return [2, Promise.resolve(response)];
      }
    });
  });
};
var deserializeAws_json1_1PutLogEventsCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, response, errorCode, _b2, _c, _d, _e, _f, _g, _h, parsedBody, message;
    var _j;
    return __generator3(this, function(_k) {
      switch (_k.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _j = {};
          return [4, parseBody(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_j.body = _k.sent(), _j)]));
          errorCode = "UnknownError";
          errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "DataAlreadyAcceptedException":
              return [3, 2];
            case "com.amazonaws.cloudwatchlogs#DataAlreadyAcceptedException":
              return [3, 2];
            case "InvalidParameterException":
              return [3, 4];
            case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
              return [3, 4];
            case "InvalidSequenceTokenException":
              return [3, 6];
            case "com.amazonaws.cloudwatchlogs#InvalidSequenceTokenException":
              return [3, 6];
            case "ResourceNotFoundException":
              return [3, 8];
            case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
              return [3, 8];
            case "ServiceUnavailableException":
              return [3, 10];
            case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
              return [3, 10];
            case "UnrecognizedClientException":
              return [3, 12];
            case "com.amazonaws.cloudwatchlogs#UnrecognizedClientException":
              return [3, 12];
          }
          return [3, 14];
        case 2:
          _c = [{}];
          return [4, deserializeAws_json1_1DataAlreadyAcceptedExceptionResponse(parsedOutput, context)];
        case 3:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _c.concat([_k.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 15];
        case 4:
          _d = [{}];
          return [4, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
        case 5:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _d.concat([_k.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 15];
        case 6:
          _e = [{}];
          return [4, deserializeAws_json1_1InvalidSequenceTokenExceptionResponse(parsedOutput, context)];
        case 7:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _e.concat([_k.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 15];
        case 8:
          _f = [{}];
          return [4, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
        case 9:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _f.concat([_k.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 15];
        case 10:
          _g = [{}];
          return [4, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
        case 11:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _g.concat([_k.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 15];
        case 12:
          _h = [{}];
          return [4, deserializeAws_json1_1UnrecognizedClientExceptionResponse(parsedOutput, context)];
        case 13:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _h.concat([_k.sent()])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
          return [3, 15];
        case 14:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign7(__assign7({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
          _k.label = 15;
        case 15:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2, Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};
var deserializeAws_json1_1DataAlreadyAcceptedExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1DataAlreadyAcceptedException(body, context);
      contents = __assign7({ name: "DataAlreadyAcceptedException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var deserializeAws_json1_1InvalidParameterExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1InvalidParameterException(body, context);
      contents = __assign7({ name: "InvalidParameterException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var deserializeAws_json1_1InvalidSequenceTokenExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1InvalidSequenceTokenException(body, context);
      contents = __assign7({ name: "InvalidSequenceTokenException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var deserializeAws_json1_1LimitExceededExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1LimitExceededException(body, context);
      contents = __assign7({ name: "LimitExceededException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var deserializeAws_json1_1OperationAbortedExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1OperationAbortedException(body, context);
      contents = __assign7({ name: "OperationAbortedException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var deserializeAws_json1_1ResourceAlreadyExistsExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1ResourceAlreadyExistsException(body, context);
      contents = __assign7({ name: "ResourceAlreadyExistsException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var deserializeAws_json1_1ResourceNotFoundExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1ResourceNotFoundException(body, context);
      contents = __assign7({ name: "ResourceNotFoundException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var deserializeAws_json1_1ServiceUnavailableExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1ServiceUnavailableException(body, context);
      contents = __assign7({ name: "ServiceUnavailableException", $fault: "server", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var deserializeAws_json1_1UnrecognizedClientExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1UnrecognizedClientException(body, context);
      contents = __assign7({ name: "UnrecognizedClientException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var serializeAws_json1_1CreateLogGroupRequest = function(input, context) {
  return __assign7(__assign7(__assign7({}, input.kmsKeyId !== void 0 && input.kmsKeyId !== null && { kmsKeyId: input.kmsKeyId }), input.logGroupName !== void 0 && input.logGroupName !== null && { logGroupName: input.logGroupName }), input.tags !== void 0 && input.tags !== null && { tags: serializeAws_json1_1Tags(input.tags, context) });
};
var serializeAws_json1_1CreateLogStreamRequest = function(input, context) {
  return __assign7(__assign7({}, input.logGroupName !== void 0 && input.logGroupName !== null && { logGroupName: input.logGroupName }), input.logStreamName !== void 0 && input.logStreamName !== null && { logStreamName: input.logStreamName });
};
var serializeAws_json1_1DescribeLogGroupsRequest = function(input, context) {
  return __assign7(__assign7(__assign7({}, input.limit !== void 0 && input.limit !== null && { limit: input.limit }), input.logGroupNamePrefix !== void 0 && input.logGroupNamePrefix !== null && { logGroupNamePrefix: input.logGroupNamePrefix }), input.nextToken !== void 0 && input.nextToken !== null && { nextToken: input.nextToken });
};
var serializeAws_json1_1DescribeLogStreamsRequest = function(input, context) {
  return __assign7(__assign7(__assign7(__assign7(__assign7(__assign7({}, input.descending !== void 0 && input.descending !== null && { descending: input.descending }), input.limit !== void 0 && input.limit !== null && { limit: input.limit }), input.logGroupName !== void 0 && input.logGroupName !== null && { logGroupName: input.logGroupName }), input.logStreamNamePrefix !== void 0 && input.logStreamNamePrefix !== null && { logStreamNamePrefix: input.logStreamNamePrefix }), input.nextToken !== void 0 && input.nextToken !== null && { nextToken: input.nextToken }), input.orderBy !== void 0 && input.orderBy !== null && { orderBy: input.orderBy });
};
var serializeAws_json1_1GetLogEventsRequest = function(input, context) {
  return __assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7({}, input.endTime !== void 0 && input.endTime !== null && { endTime: input.endTime }), input.limit !== void 0 && input.limit !== null && { limit: input.limit }), input.logGroupName !== void 0 && input.logGroupName !== null && { logGroupName: input.logGroupName }), input.logStreamName !== void 0 && input.logStreamName !== null && { logStreamName: input.logStreamName }), input.nextToken !== void 0 && input.nextToken !== null && { nextToken: input.nextToken }), input.startFromHead !== void 0 && input.startFromHead !== null && { startFromHead: input.startFromHead }), input.startTime !== void 0 && input.startTime !== null && { startTime: input.startTime });
};
var serializeAws_json1_1InputLogEvent = function(input, context) {
  return __assign7(__assign7({}, input.message !== void 0 && input.message !== null && { message: input.message }), input.timestamp !== void 0 && input.timestamp !== null && { timestamp: input.timestamp });
};
var serializeAws_json1_1InputLogEvents = function(input, context) {
  return input.filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return serializeAws_json1_1InputLogEvent(entry, context);
  });
};
var serializeAws_json1_1PutLogEventsRequest = function(input, context) {
  return __assign7(__assign7(__assign7(__assign7({}, input.logEvents !== void 0 && input.logEvents !== null && { logEvents: serializeAws_json1_1InputLogEvents(input.logEvents, context) }), input.logGroupName !== void 0 && input.logGroupName !== null && { logGroupName: input.logGroupName }), input.logStreamName !== void 0 && input.logStreamName !== null && { logStreamName: input.logStreamName }), input.sequenceToken !== void 0 && input.sequenceToken !== null && { sequenceToken: input.sequenceToken });
};
var serializeAws_json1_1Tags = function(input, context) {
  return Object.entries(input).reduce(function(acc, _a2) {
    var _b2;
    var _c = __read10(_a2, 2), key = _c[0], value = _c[1];
    if (value === null) {
      return acc;
    }
    return __assign7(__assign7({}, acc), (_b2 = {}, _b2[key] = value, _b2));
  }, {});
};
var deserializeAws_json1_1DataAlreadyAcceptedException = function(output, context) {
  return {
    expectedSequenceToken: output.expectedSequenceToken !== void 0 && output.expectedSequenceToken !== null ? output.expectedSequenceToken : void 0,
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeAws_json1_1DescribeLogGroupsResponse = function(output, context) {
  return {
    logGroups: output.logGroups !== void 0 && output.logGroups !== null ? deserializeAws_json1_1LogGroups(output.logGroups, context) : void 0,
    nextToken: output.nextToken !== void 0 && output.nextToken !== null ? output.nextToken : void 0
  };
};
var deserializeAws_json1_1DescribeLogStreamsResponse = function(output, context) {
  return {
    logStreams: output.logStreams !== void 0 && output.logStreams !== null ? deserializeAws_json1_1LogStreams(output.logStreams, context) : void 0,
    nextToken: output.nextToken !== void 0 && output.nextToken !== null ? output.nextToken : void 0
  };
};
var deserializeAws_json1_1GetLogEventsResponse = function(output, context) {
  return {
    events: output.events !== void 0 && output.events !== null ? deserializeAws_json1_1OutputLogEvents(output.events, context) : void 0,
    nextBackwardToken: output.nextBackwardToken !== void 0 && output.nextBackwardToken !== null ? output.nextBackwardToken : void 0,
    nextForwardToken: output.nextForwardToken !== void 0 && output.nextForwardToken !== null ? output.nextForwardToken : void 0
  };
};
var deserializeAws_json1_1InvalidParameterException = function(output, context) {
  return {
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeAws_json1_1InvalidSequenceTokenException = function(output, context) {
  return {
    expectedSequenceToken: output.expectedSequenceToken !== void 0 && output.expectedSequenceToken !== null ? output.expectedSequenceToken : void 0,
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeAws_json1_1LimitExceededException = function(output, context) {
  return {
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeAws_json1_1LogGroup = function(output, context) {
  return {
    arn: output.arn !== void 0 && output.arn !== null ? output.arn : void 0,
    creationTime: output.creationTime !== void 0 && output.creationTime !== null ? output.creationTime : void 0,
    kmsKeyId: output.kmsKeyId !== void 0 && output.kmsKeyId !== null ? output.kmsKeyId : void 0,
    logGroupName: output.logGroupName !== void 0 && output.logGroupName !== null ? output.logGroupName : void 0,
    metricFilterCount: output.metricFilterCount !== void 0 && output.metricFilterCount !== null ? output.metricFilterCount : void 0,
    retentionInDays: output.retentionInDays !== void 0 && output.retentionInDays !== null ? output.retentionInDays : void 0,
    storedBytes: output.storedBytes !== void 0 && output.storedBytes !== null ? output.storedBytes : void 0
  };
};
var deserializeAws_json1_1LogGroups = function(output, context) {
  return (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_json1_1LogGroup(entry, context);
  });
};
var deserializeAws_json1_1LogStream = function(output, context) {
  return {
    arn: output.arn !== void 0 && output.arn !== null ? output.arn : void 0,
    creationTime: output.creationTime !== void 0 && output.creationTime !== null ? output.creationTime : void 0,
    firstEventTimestamp: output.firstEventTimestamp !== void 0 && output.firstEventTimestamp !== null ? output.firstEventTimestamp : void 0,
    lastEventTimestamp: output.lastEventTimestamp !== void 0 && output.lastEventTimestamp !== null ? output.lastEventTimestamp : void 0,
    lastIngestionTime: output.lastIngestionTime !== void 0 && output.lastIngestionTime !== null ? output.lastIngestionTime : void 0,
    logStreamName: output.logStreamName !== void 0 && output.logStreamName !== null ? output.logStreamName : void 0,
    storedBytes: output.storedBytes !== void 0 && output.storedBytes !== null ? output.storedBytes : void 0,
    uploadSequenceToken: output.uploadSequenceToken !== void 0 && output.uploadSequenceToken !== null ? output.uploadSequenceToken : void 0
  };
};
var deserializeAws_json1_1LogStreams = function(output, context) {
  return (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_json1_1LogStream(entry, context);
  });
};
var deserializeAws_json1_1OperationAbortedException = function(output, context) {
  return {
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeAws_json1_1OutputLogEvent = function(output, context) {
  return {
    ingestionTime: output.ingestionTime !== void 0 && output.ingestionTime !== null ? output.ingestionTime : void 0,
    message: output.message !== void 0 && output.message !== null ? output.message : void 0,
    timestamp: output.timestamp !== void 0 && output.timestamp !== null ? output.timestamp : void 0
  };
};
var deserializeAws_json1_1OutputLogEvents = function(output, context) {
  return (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_json1_1OutputLogEvent(entry, context);
  });
};
var deserializeAws_json1_1PutLogEventsResponse = function(output, context) {
  return {
    nextSequenceToken: output.nextSequenceToken !== void 0 && output.nextSequenceToken !== null ? output.nextSequenceToken : void 0,
    rejectedLogEventsInfo: output.rejectedLogEventsInfo !== void 0 && output.rejectedLogEventsInfo !== null ? deserializeAws_json1_1RejectedLogEventsInfo(output.rejectedLogEventsInfo, context) : void 0
  };
};
var deserializeAws_json1_1RejectedLogEventsInfo = function(output, context) {
  return {
    expiredLogEventEndIndex: output.expiredLogEventEndIndex !== void 0 && output.expiredLogEventEndIndex !== null ? output.expiredLogEventEndIndex : void 0,
    tooNewLogEventStartIndex: output.tooNewLogEventStartIndex !== void 0 && output.tooNewLogEventStartIndex !== null ? output.tooNewLogEventStartIndex : void 0,
    tooOldLogEventEndIndex: output.tooOldLogEventEndIndex !== void 0 && output.tooOldLogEventEndIndex !== null ? output.tooOldLogEventEndIndex : void 0
  };
};
var deserializeAws_json1_1ResourceAlreadyExistsException = function(output, context) {
  return {
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeAws_json1_1ResourceNotFoundException = function(output, context) {
  return {
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeAws_json1_1ServiceUnavailableException = function(output, context) {
  return {
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeAws_json1_1UnrecognizedClientException = function(output, context) {
  return {
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeMetadata = function(output) {
  var _a2;
  return {
    httpStatusCode: output.statusCode,
    requestId: (_a2 = output.headers["x-amzn-requestid"]) !== null && _a2 !== void 0 ? _a2 : output.headers["x-amzn-request-id"],
    extendedRequestId: output.headers["x-amz-id-2"],
    cfId: output.headers["x-amz-cf-id"]
  };
};
var collectBody = function(streamBody, context) {
  if (streamBody === void 0) {
    streamBody = new Uint8Array();
  }
  if (streamBody instanceof Uint8Array) {
    return Promise.resolve(streamBody);
  }
  return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
var collectBodyString = function(streamBody, context) {
  return collectBody(streamBody, context).then(function(body) {
    return context.utf8Encoder(body);
  });
};
var buildHttpRpcRequest = function(context, headers, path, resolvedHostname, body) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var _a2, hostname, _b2, protocol, port, contents;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port;
          contents = {
            protocol,
            hostname,
            port,
            method: "POST",
            path,
            headers
          };
          if (resolvedHostname !== void 0) {
            contents.hostname = resolvedHostname;
          }
          if (body !== void 0) {
            contents.body = body;
          }
          return [2, new HttpRequest(contents)];
      }
    });
  });
};
var parseBody = function(streamBody, context) {
  return collectBodyString(streamBody, context).then(function(encoded) {
    if (encoded.length) {
      return JSON.parse(encoded);
    }
    return {};
  });
};
var loadRestJsonErrorCode = function(output, data) {
  var findKey = function(object, key) {
    return Object.keys(object).find(function(k2) {
      return k2.toLowerCase() === key.toLowerCase();
    });
  };
  var sanitizeErrorCode = function(rawValue) {
    var cleanValue = rawValue;
    if (cleanValue.indexOf(":") >= 0) {
      cleanValue = cleanValue.split(":")[0];
    }
    if (cleanValue.indexOf("#") >= 0) {
      cleanValue = cleanValue.split("#")[1];
    }
    return cleanValue;
  };
  var headerKey = findKey(output.headers, "x-amzn-errortype");
  if (headerKey !== void 0) {
    return sanitizeErrorCode(output.headers[headerKey]);
  }
  if (data.code !== void 0) {
    return sanitizeErrorCode(data.code);
  }
  if (data["__type"] !== void 0) {
    return sanitizeErrorCode(data["__type"]);
  }
  return "";
};

// node_modules/@aws-sdk/middleware-serde/node_modules/tslib/tslib.es6.js
var __assign16 = function() {
  __assign16 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign16.apply(this, arguments);
};
function __awaiter14(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator14(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/middleware-serde/dist/es/deserializerMiddleware.js
var deserializerMiddleware = function(options, deserializer) {
  return function(next, context) {
    return function(args) {
      return __awaiter14(void 0, void 0, void 0, function() {
        var response, parsed;
        return __generator14(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, next(args)];
            case 1:
              response = _a2.sent().response;
              return [4, deserializer(response, options)];
            case 2:
              parsed = _a2.sent();
              return [2, {
                response,
                output: parsed
              }];
          }
        });
      });
    };
  };
};

// node_modules/@aws-sdk/middleware-serde/dist/es/serializerMiddleware.js
var serializerMiddleware = function(options, serializer) {
  return function(next, context) {
    return function(args) {
      return __awaiter14(void 0, void 0, void 0, function() {
        var request;
        return __generator14(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, serializer(args.input, options)];
            case 1:
              request = _a2.sent();
              return [2, next(__assign16(__assign16({}, args), { request }))];
          }
        });
      });
    };
  };
};

// node_modules/@aws-sdk/middleware-serde/dist/es/serdePlugin.js
var deserializerMiddlewareOption = {
  name: "deserializerMiddleware",
  step: "deserialize",
  tags: ["DESERIALIZER"],
  override: true
};
var serializerMiddlewareOption = {
  name: "serializerMiddleware",
  step: "serialize",
  tags: ["SERIALIZER"],
  override: true
};
function getSerdePlugin(config, serializer, deserializer) {
  return {
    applyToStack: function(commandStack) {
      commandStack.add(deserializerMiddleware(config, deserializer), deserializerMiddlewareOption);
      commandStack.add(serializerMiddleware(config, serializer), serializerMiddlewareOption);
    }
  };
}

// node_modules/@aws-sdk/client-cloudwatch-logs/dist/es/commands/CreateLogGroupCommand.js
var CreateLogGroupCommand = (
  /** @class */
  function(_super) {
    __extends3(CreateLogGroupCommand2, _super);
    function CreateLogGroupCommand2(input) {
      var _this = (
        // Start section: command_constructor
        _super.call(this) || this
      );
      _this.input = input;
      return _this;
    }
    CreateLogGroupCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
      this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
      var stack = clientStack.concat(this.middlewareStack);
      var logger64 = configuration.logger;
      var clientName = "CloudWatchLogsClient";
      var commandName = "CreateLogGroupCommand";
      var handlerExecutionContext = {
        logger: logger64,
        clientName,
        commandName,
        inputFilterSensitiveLog: CreateLogGroupRequest.filterSensitiveLog,
        outputFilterSensitiveLog: function(output) {
          return output;
        }
      };
      var requestHandler = configuration.requestHandler;
      return stack.resolve(function(request) {
        return requestHandler.handle(request.request, options || {});
      }, handlerExecutionContext);
    };
    CreateLogGroupCommand2.prototype.serialize = function(input, context) {
      return serializeAws_json1_1CreateLogGroupCommand(input, context);
    };
    CreateLogGroupCommand2.prototype.deserialize = function(output, context) {
      return deserializeAws_json1_1CreateLogGroupCommand(output, context);
    };
    return CreateLogGroupCommand2;
  }(Command)
);

// node_modules/@aws-sdk/client-cloudwatch-logs/dist/es/commands/CreateLogStreamCommand.js
var CreateLogStreamCommand = (
  /** @class */
  function(_super) {
    __extends3(CreateLogStreamCommand2, _super);
    function CreateLogStreamCommand2(input) {
      var _this = (
        // Start section: command_constructor
        _super.call(this) || this
      );
      _this.input = input;
      return _this;
    }
    CreateLogStreamCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
      this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
      var stack = clientStack.concat(this.middlewareStack);
      var logger64 = configuration.logger;
      var clientName = "CloudWatchLogsClient";
      var commandName = "CreateLogStreamCommand";
      var handlerExecutionContext = {
        logger: logger64,
        clientName,
        commandName,
        inputFilterSensitiveLog: CreateLogStreamRequest.filterSensitiveLog,
        outputFilterSensitiveLog: function(output) {
          return output;
        }
      };
      var requestHandler = configuration.requestHandler;
      return stack.resolve(function(request) {
        return requestHandler.handle(request.request, options || {});
      }, handlerExecutionContext);
    };
    CreateLogStreamCommand2.prototype.serialize = function(input, context) {
      return serializeAws_json1_1CreateLogStreamCommand(input, context);
    };
    CreateLogStreamCommand2.prototype.deserialize = function(output, context) {
      return deserializeAws_json1_1CreateLogStreamCommand(output, context);
    };
    return CreateLogStreamCommand2;
  }(Command)
);

// node_modules/@aws-sdk/client-cloudwatch-logs/dist/es/commands/DescribeLogGroupsCommand.js
var DescribeLogGroupsCommand = (
  /** @class */
  function(_super) {
    __extends3(DescribeLogGroupsCommand2, _super);
    function DescribeLogGroupsCommand2(input) {
      var _this = (
        // Start section: command_constructor
        _super.call(this) || this
      );
      _this.input = input;
      return _this;
    }
    DescribeLogGroupsCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
      this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
      var stack = clientStack.concat(this.middlewareStack);
      var logger64 = configuration.logger;
      var clientName = "CloudWatchLogsClient";
      var commandName = "DescribeLogGroupsCommand";
      var handlerExecutionContext = {
        logger: logger64,
        clientName,
        commandName,
        inputFilterSensitiveLog: DescribeLogGroupsRequest.filterSensitiveLog,
        outputFilterSensitiveLog: DescribeLogGroupsResponse.filterSensitiveLog
      };
      var requestHandler = configuration.requestHandler;
      return stack.resolve(function(request) {
        return requestHandler.handle(request.request, options || {});
      }, handlerExecutionContext);
    };
    DescribeLogGroupsCommand2.prototype.serialize = function(input, context) {
      return serializeAws_json1_1DescribeLogGroupsCommand(input, context);
    };
    DescribeLogGroupsCommand2.prototype.deserialize = function(output, context) {
      return deserializeAws_json1_1DescribeLogGroupsCommand(output, context);
    };
    return DescribeLogGroupsCommand2;
  }(Command)
);

// node_modules/@aws-sdk/client-cloudwatch-logs/dist/es/commands/DescribeLogStreamsCommand.js
var DescribeLogStreamsCommand = (
  /** @class */
  function(_super) {
    __extends3(DescribeLogStreamsCommand2, _super);
    function DescribeLogStreamsCommand2(input) {
      var _this = (
        // Start section: command_constructor
        _super.call(this) || this
      );
      _this.input = input;
      return _this;
    }
    DescribeLogStreamsCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
      this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
      var stack = clientStack.concat(this.middlewareStack);
      var logger64 = configuration.logger;
      var clientName = "CloudWatchLogsClient";
      var commandName = "DescribeLogStreamsCommand";
      var handlerExecutionContext = {
        logger: logger64,
        clientName,
        commandName,
        inputFilterSensitiveLog: DescribeLogStreamsRequest.filterSensitiveLog,
        outputFilterSensitiveLog: DescribeLogStreamsResponse.filterSensitiveLog
      };
      var requestHandler = configuration.requestHandler;
      return stack.resolve(function(request) {
        return requestHandler.handle(request.request, options || {});
      }, handlerExecutionContext);
    };
    DescribeLogStreamsCommand2.prototype.serialize = function(input, context) {
      return serializeAws_json1_1DescribeLogStreamsCommand(input, context);
    };
    DescribeLogStreamsCommand2.prototype.deserialize = function(output, context) {
      return deserializeAws_json1_1DescribeLogStreamsCommand(output, context);
    };
    return DescribeLogStreamsCommand2;
  }(Command)
);

// node_modules/@aws-sdk/client-cloudwatch-logs/dist/es/commands/GetLogEventsCommand.js
var GetLogEventsCommand = (
  /** @class */
  function(_super) {
    __extends3(GetLogEventsCommand2, _super);
    function GetLogEventsCommand2(input) {
      var _this = (
        // Start section: command_constructor
        _super.call(this) || this
      );
      _this.input = input;
      return _this;
    }
    GetLogEventsCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
      this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
      var stack = clientStack.concat(this.middlewareStack);
      var logger64 = configuration.logger;
      var clientName = "CloudWatchLogsClient";
      var commandName = "GetLogEventsCommand";
      var handlerExecutionContext = {
        logger: logger64,
        clientName,
        commandName,
        inputFilterSensitiveLog: GetLogEventsRequest.filterSensitiveLog,
        outputFilterSensitiveLog: GetLogEventsResponse.filterSensitiveLog
      };
      var requestHandler = configuration.requestHandler;
      return stack.resolve(function(request) {
        return requestHandler.handle(request.request, options || {});
      }, handlerExecutionContext);
    };
    GetLogEventsCommand2.prototype.serialize = function(input, context) {
      return serializeAws_json1_1GetLogEventsCommand(input, context);
    };
    GetLogEventsCommand2.prototype.deserialize = function(output, context) {
      return deserializeAws_json1_1GetLogEventsCommand(output, context);
    };
    return GetLogEventsCommand2;
  }(Command)
);

// node_modules/@aws-sdk/client-cloudwatch-logs/dist/es/commands/PutLogEventsCommand.js
var PutLogEventsCommand = (
  /** @class */
  function(_super) {
    __extends3(PutLogEventsCommand2, _super);
    function PutLogEventsCommand2(input) {
      var _this = (
        // Start section: command_constructor
        _super.call(this) || this
      );
      _this.input = input;
      return _this;
    }
    PutLogEventsCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
      this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
      var stack = clientStack.concat(this.middlewareStack);
      var logger64 = configuration.logger;
      var clientName = "CloudWatchLogsClient";
      var commandName = "PutLogEventsCommand";
      var handlerExecutionContext = {
        logger: logger64,
        clientName,
        commandName,
        inputFilterSensitiveLog: PutLogEventsRequest.filterSensitiveLog,
        outputFilterSensitiveLog: PutLogEventsResponse.filterSensitiveLog
      };
      var requestHandler = configuration.requestHandler;
      return stack.resolve(function(request) {
        return requestHandler.handle(request.request, options || {});
      }, handlerExecutionContext);
    };
    PutLogEventsCommand2.prototype.serialize = function(input, context) {
      return serializeAws_json1_1PutLogEventsCommand(input, context);
    };
    PutLogEventsCommand2.prototype.deserialize = function(output, context) {
      return deserializeAws_json1_1PutLogEventsCommand(output, context);
    };
    return PutLogEventsCommand2;
  }(Command)
);

// node_modules/@aws-amplify/core/lib-esm/Providers/AWSCloudWatchProvider.js
var __awaiter15 = function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator15 = function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (g2 && (g2 = 0, op[0] && (_2 = 0)), _2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var __read19 = function(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var __spreadArray5 = function(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i2 = 0, l2 = from.length, ar; i2 < l2; i2++) {
      if (ar || !(i2 in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i2);
        ar[i2] = from[i2];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var logger8 = new ConsoleLogger("AWSCloudWatch");
var AWSCloudWatchProvider = (
  /** @class */
  function() {
    function AWSCloudWatchProvider2(config) {
      this.configure(config);
      this._dataTracker = {
        eventUploadInProgress: false,
        logEvents: []
      };
      this._currentLogBatch = [];
      this._initiateLogPushInterval();
    }
    AWSCloudWatchProvider2.prototype.getProviderName = function() {
      return AWSCloudWatchProvider2.PROVIDER_NAME;
    };
    AWSCloudWatchProvider2.prototype.getCategoryName = function() {
      return AWSCloudWatchProvider2.CATEGORY;
    };
    AWSCloudWatchProvider2.prototype.getLogQueue = function() {
      return this._dataTracker.logEvents;
    };
    AWSCloudWatchProvider2.prototype.configure = function(config) {
      if (!config)
        return this._config || {};
      var conf = Object.assign({}, this._config, parseAWSExports(config).Logging, config);
      this._config = conf;
      return this._config;
    };
    AWSCloudWatchProvider2.prototype.createLogGroup = function(params) {
      return __awaiter15(this, void 0, void 0, function() {
        var cmd, credentialsOK, client, output, error_1;
        return __generator15(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              logger8.debug("creating new log group in CloudWatch - ", params.logGroupName);
              cmd = new CreateLogGroupCommand(params);
              _a2.label = 1;
            case 1:
              _a2.trys.push([1, 4, , 5]);
              return [4, this._ensureCredentials()];
            case 2:
              credentialsOK = _a2.sent();
              if (!credentialsOK) {
                throw new Error(NO_CREDS_ERROR_STRING);
              }
              client = this._initCloudWatchLogs();
              return [4, client.send(cmd)];
            case 3:
              output = _a2.sent();
              return [2, output];
            case 4:
              error_1 = _a2.sent();
              logger8.error("error creating log group - ".concat(error_1));
              throw error_1;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSCloudWatchProvider2.prototype.getLogGroups = function(params) {
      return __awaiter15(this, void 0, void 0, function() {
        var cmd, credentialsOK, client, output, error_2;
        return __generator15(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              logger8.debug("getting list of log groups");
              cmd = new DescribeLogGroupsCommand(params);
              _a2.label = 1;
            case 1:
              _a2.trys.push([1, 4, , 5]);
              return [4, this._ensureCredentials()];
            case 2:
              credentialsOK = _a2.sent();
              if (!credentialsOK) {
                throw new Error(NO_CREDS_ERROR_STRING);
              }
              client = this._initCloudWatchLogs();
              return [4, client.send(cmd)];
            case 3:
              output = _a2.sent();
              return [2, output];
            case 4:
              error_2 = _a2.sent();
              logger8.error("error getting log group - ".concat(error_2));
              throw error_2;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSCloudWatchProvider2.prototype.createLogStream = function(params) {
      return __awaiter15(this, void 0, void 0, function() {
        var cmd, credentialsOK, client, output, error_3;
        return __generator15(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              logger8.debug("creating new log stream in CloudWatch - ", params.logStreamName);
              cmd = new CreateLogStreamCommand(params);
              _a2.label = 1;
            case 1:
              _a2.trys.push([1, 4, , 5]);
              return [4, this._ensureCredentials()];
            case 2:
              credentialsOK = _a2.sent();
              if (!credentialsOK) {
                throw new Error(NO_CREDS_ERROR_STRING);
              }
              client = this._initCloudWatchLogs();
              return [4, client.send(cmd)];
            case 3:
              output = _a2.sent();
              return [2, output];
            case 4:
              error_3 = _a2.sent();
              logger8.error("error creating log stream - ".concat(error_3));
              throw error_3;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSCloudWatchProvider2.prototype.getLogStreams = function(params) {
      return __awaiter15(this, void 0, void 0, function() {
        var cmd, credentialsOK, client, output, error_4;
        return __generator15(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              logger8.debug("getting list of log streams");
              cmd = new DescribeLogStreamsCommand(params);
              _a2.label = 1;
            case 1:
              _a2.trys.push([1, 4, , 5]);
              return [4, this._ensureCredentials()];
            case 2:
              credentialsOK = _a2.sent();
              if (!credentialsOK) {
                throw new Error(NO_CREDS_ERROR_STRING);
              }
              client = this._initCloudWatchLogs();
              return [4, client.send(cmd)];
            case 3:
              output = _a2.sent();
              return [2, output];
            case 4:
              error_4 = _a2.sent();
              logger8.error("error getting log stream - ".concat(error_4));
              throw error_4;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSCloudWatchProvider2.prototype.getLogEvents = function(params) {
      return __awaiter15(this, void 0, void 0, function() {
        var cmd, credentialsOK, client, output, error_5;
        return __generator15(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              logger8.debug("getting log events from stream - ", params.logStreamName);
              cmd = new GetLogEventsCommand(params);
              _a2.label = 1;
            case 1:
              _a2.trys.push([1, 4, , 5]);
              return [4, this._ensureCredentials()];
            case 2:
              credentialsOK = _a2.sent();
              if (!credentialsOK) {
                throw new Error(NO_CREDS_ERROR_STRING);
              }
              client = this._initCloudWatchLogs();
              return [4, client.send(cmd)];
            case 3:
              output = _a2.sent();
              return [2, output];
            case 4:
              error_5 = _a2.sent();
              logger8.error("error getting log events - ".concat(error_5));
              throw error_5;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSCloudWatchProvider2.prototype.pushLogs = function(logs) {
      logger8.debug("pushing log events to Cloudwatch...");
      this._dataTracker.logEvents = __spreadArray5(__spreadArray5([], __read19(this._dataTracker.logEvents), false), __read19(logs), false);
    };
    AWSCloudWatchProvider2.prototype._validateLogGroupExistsAndCreate = function(logGroupName) {
      return __awaiter15(this, void 0, void 0, function() {
        var credentialsOK, currGroups, foundGroups, err_1, errString;
        return __generator15(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (this._dataTracker.verifiedLogGroup) {
                return [2, this._dataTracker.verifiedLogGroup];
              }
              _a2.label = 1;
            case 1:
              _a2.trys.push([1, 5, , 6]);
              return [4, this._ensureCredentials()];
            case 2:
              credentialsOK = _a2.sent();
              if (!credentialsOK) {
                throw new Error(NO_CREDS_ERROR_STRING);
              }
              return [4, this.getLogGroups({
                logGroupNamePrefix: logGroupName
              })];
            case 3:
              currGroups = _a2.sent();
              if (!(typeof currGroups === "string") && currGroups.logGroups) {
                foundGroups = currGroups.logGroups.filter(function(group) {
                  return group.logGroupName === logGroupName;
                });
                if (foundGroups.length > 0) {
                  this._dataTracker.verifiedLogGroup = foundGroups[0];
                  return [2, foundGroups[0]];
                }
              }
              return [4, this.createLogGroup({ logGroupName })];
            case 4:
              _a2.sent();
              return [2, null];
            case 5:
              err_1 = _a2.sent();
              errString = "failure during log group search: ".concat(err_1);
              logger8.error(errString);
              throw err_1;
            case 6:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSCloudWatchProvider2.prototype._validateLogStreamExists = function(logGroupName, logStreamName) {
      return __awaiter15(this, void 0, void 0, function() {
        var credentialsOK, currStreams, foundStreams, err_2, errString;
        return __generator15(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 4, , 5]);
              return [4, this._ensureCredentials()];
            case 1:
              credentialsOK = _a2.sent();
              if (!credentialsOK) {
                throw new Error(NO_CREDS_ERROR_STRING);
              }
              return [4, this.getLogStreams({
                logGroupName,
                logStreamNamePrefix: logStreamName
              })];
            case 2:
              currStreams = _a2.sent();
              if (currStreams.logStreams) {
                foundStreams = currStreams.logStreams.filter(function(stream) {
                  return stream.logStreamName === logStreamName;
                });
                if (foundStreams.length > 0) {
                  this._nextSequenceToken = foundStreams[0].uploadSequenceToken;
                  return [2, foundStreams[0]];
                }
              }
              return [4, this.createLogStream({
                logGroupName,
                logStreamName
              })];
            case 3:
              _a2.sent();
              return [2, null];
            case 4:
              err_2 = _a2.sent();
              errString = "failure during log stream search: ".concat(err_2);
              logger8.error(errString);
              throw err_2;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSCloudWatchProvider2.prototype._sendLogEvents = function(params) {
      return __awaiter15(this, void 0, void 0, function() {
        var credentialsOK, cmd, client, output, err_3, errString;
        return __generator15(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 3, , 4]);
              return [4, this._ensureCredentials()];
            case 1:
              credentialsOK = _a2.sent();
              if (!credentialsOK) {
                throw new Error(NO_CREDS_ERROR_STRING);
              }
              logger8.debug("sending log events to stream - ", params.logStreamName);
              cmd = new PutLogEventsCommand(params);
              client = this._initCloudWatchLogs();
              return [4, client.send(cmd)];
            case 2:
              output = _a2.sent();
              return [2, output];
            case 3:
              err_3 = _a2.sent();
              errString = "failure during log push: ".concat(err_3);
              logger8.error(errString);
              return [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSCloudWatchProvider2.prototype._initCloudWatchLogs = function() {
      return new CloudWatchLogsClient({
        region: this._config.region,
        credentials: this._config.credentials,
        customUserAgent: getAmplifyUserAgentObject(),
        endpoint: this._config.endpoint
      });
    };
    AWSCloudWatchProvider2.prototype._ensureCredentials = function() {
      return __awaiter15(this, void 0, void 0, function() {
        var _this = this;
        return __generator15(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, Credentials.get().then(function(credentials) {
                if (!credentials)
                  return false;
                var cred = Credentials.shear(credentials);
                logger8.debug("set credentials for logging", cred);
                _this._config.credentials = cred;
                return true;
              }).catch(function(error) {
                logger8.warn("ensure credentials error", error);
                return false;
              })];
            case 1:
              return [2, _a2.sent()];
          }
        });
      });
    };
    AWSCloudWatchProvider2.prototype._getNextSequenceToken = function() {
      return __awaiter15(this, void 0, void 0, function() {
        var logStream, err_4;
        return __generator15(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (this._nextSequenceToken && this._nextSequenceToken.length > 0) {
                return [2, this._nextSequenceToken];
              }
              _a2.label = 1;
            case 1:
              _a2.trys.push([1, 4, , 5]);
              return [4, this._validateLogGroupExistsAndCreate(this._config.logGroupName)];
            case 2:
              _a2.sent();
              this._nextSequenceToken = void 0;
              return [4, this._validateLogStreamExists(this._config.logGroupName, this._config.logStreamName)];
            case 3:
              logStream = _a2.sent();
              if (logStream) {
                this._nextSequenceToken = logStream.uploadSequenceToken;
              }
              return [2, this._nextSequenceToken];
            case 4:
              err_4 = _a2.sent();
              logger8.error("failure while getting next sequence token: ".concat(err_4));
              throw err_4;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSCloudWatchProvider2.prototype._safeUploadLogEvents = function() {
      return __awaiter15(this, void 0, void 0, function() {
        var seqToken, logBatch, putLogsPayload, sendLogEventsResponse, err_5;
        return __generator15(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 3, , 4]);
              return [4, this._getNextSequenceToken()];
            case 1:
              seqToken = _a2.sent();
              logBatch = this._currentLogBatch.length === 0 ? this._getBufferedBatchOfLogs() : this._currentLogBatch;
              putLogsPayload = {
                logGroupName: this._config.logGroupName,
                logStreamName: this._config.logStreamName,
                logEvents: logBatch,
                sequenceToken: seqToken
              };
              this._dataTracker.eventUploadInProgress = true;
              return [4, this._sendLogEvents(putLogsPayload)];
            case 2:
              sendLogEventsResponse = _a2.sent();
              this._nextSequenceToken = sendLogEventsResponse.nextSequenceToken;
              this._dataTracker.eventUploadInProgress = false;
              this._currentLogBatch = [];
              return [2, sendLogEventsResponse];
            case 3:
              err_5 = _a2.sent();
              logger8.error("error during _safeUploadLogEvents: ".concat(err_5));
              if (RETRY_ERROR_CODES.includes(err_5.name)) {
                this._getNewSequenceTokenAndSubmit({
                  logEvents: this._currentLogBatch,
                  logGroupName: this._config.logGroupName,
                  logStreamName: this._config.logStreamName
                });
              } else {
                this._dataTracker.eventUploadInProgress = false;
                throw err_5;
              }
              return [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSCloudWatchProvider2.prototype._getBufferedBatchOfLogs = function() {
      var currentEventIdx = 0;
      var totalByteSize = 0;
      while (currentEventIdx < this._dataTracker.logEvents.length) {
        var currentEvent = this._dataTracker.logEvents[currentEventIdx];
        var eventSize = currentEvent ? new TextEncoder().encode(currentEvent.message).length + AWS_CLOUDWATCH_BASE_BUFFER_SIZE : 0;
        if (eventSize > AWS_CLOUDWATCH_MAX_EVENT_SIZE) {
          var errString = "Log entry exceeds maximum size for CloudWatch logs. Log size: ".concat(eventSize, ". Truncating log message.");
          logger8.warn(errString);
          currentEvent.message = currentEvent.message.substring(0, eventSize);
        }
        if (totalByteSize + eventSize > AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE)
          break;
        totalByteSize += eventSize;
        currentEventIdx++;
      }
      this._currentLogBatch = this._dataTracker.logEvents.splice(0, currentEventIdx);
      return this._currentLogBatch;
    };
    AWSCloudWatchProvider2.prototype._getNewSequenceTokenAndSubmit = function(payload) {
      return __awaiter15(this, void 0, void 0, function() {
        var seqToken, sendLogEventsRepsonse, err_6;
        return __generator15(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 3, , 4]);
              this._nextSequenceToken = void 0;
              this._dataTracker.eventUploadInProgress = true;
              return [4, this._getNextSequenceToken()];
            case 1:
              seqToken = _a2.sent();
              payload.sequenceToken = seqToken;
              return [4, this._sendLogEvents(payload)];
            case 2:
              sendLogEventsRepsonse = _a2.sent();
              this._dataTracker.eventUploadInProgress = false;
              this._currentLogBatch = [];
              return [2, sendLogEventsRepsonse];
            case 3:
              err_6 = _a2.sent();
              logger8.error("error when retrying log submission with new sequence token: ".concat(err_6));
              this._dataTracker.eventUploadInProgress = false;
              throw err_6;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSCloudWatchProvider2.prototype._initiateLogPushInterval = function() {
      var _this = this;
      if (this._timer) {
        clearInterval(this._timer);
      }
      this._timer = setInterval(function() {
        return __awaiter15(_this, void 0, void 0, function() {
          var err_7;
          return __generator15(this, function(_a2) {
            switch (_a2.label) {
              case 0:
                _a2.trys.push([0, 3, , 4]);
                if (!this._getDocUploadPermissibility())
                  return [3, 2];
                return [4, this._safeUploadLogEvents()];
              case 1:
                _a2.sent();
                _a2.label = 2;
              case 2:
                return [3, 4];
              case 3:
                err_7 = _a2.sent();
                logger8.error("error when calling _safeUploadLogEvents in the timer interval - ".concat(err_7));
                return [3, 4];
              case 4:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, 2e3);
    };
    AWSCloudWatchProvider2.prototype._getDocUploadPermissibility = function() {
      return (this._dataTracker.logEvents.length !== 0 || this._currentLogBatch.length !== 0) && !this._dataTracker.eventUploadInProgress;
    };
    AWSCloudWatchProvider2.PROVIDER_NAME = AWS_CLOUDWATCH_PROVIDER_NAME;
    AWSCloudWatchProvider2.CATEGORY = AWS_CLOUDWATCH_CATEGORY;
    return AWSCloudWatchProvider2;
  }()
);

// node_modules/@aws-amplify/core/lib-esm/OAuthHelper/GoogleOAuth.js
var __awaiter16 = function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator16 = function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (g2 && (g2 = 0, op[0] && (_2 = 0)), _2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var logger9 = new ConsoleLogger("CognitoCredentials");
var waitForInit = new Promise(function(res, rej) {
  if (!browserOrNode().isBrowser) {
    logger9.debug("not in the browser, directly resolved");
    return res();
  }
  var ga = window["gapi"] && window["gapi"].auth2 ? window["gapi"].auth2 : null;
  if (ga) {
    logger9.debug("google api already loaded");
    return res();
  } else {
    setTimeout(function() {
      return res();
    }, 2e3);
  }
});
var GoogleOAuth = (
  /** @class */
  function() {
    function GoogleOAuth3() {
      this.initialized = false;
      this.refreshGoogleToken = this.refreshGoogleToken.bind(this);
      this._refreshGoogleTokenImpl = this._refreshGoogleTokenImpl.bind(this);
    }
    GoogleOAuth3.prototype.refreshGoogleToken = function() {
      return __awaiter16(this, void 0, void 0, function() {
        return __generator16(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (!!this.initialized)
                return [3, 2];
              logger9.debug("need to wait for the Google SDK loaded");
              return [4, waitForInit];
            case 1:
              _a2.sent();
              this.initialized = true;
              logger9.debug("finish waiting");
              _a2.label = 2;
            case 2:
              return [2, this._refreshGoogleTokenImpl()];
          }
        });
      });
    };
    GoogleOAuth3.prototype._refreshGoogleTokenImpl = function() {
      var ga = null;
      if (browserOrNode().isBrowser)
        ga = window["gapi"] && window["gapi"].auth2 ? window["gapi"].auth2 : null;
      if (!ga) {
        logger9.debug("no gapi auth2 available");
        return Promise.reject("no gapi auth2 available");
      }
      return new Promise(function(res, rej) {
        ga.getAuthInstance().then(function(googleAuth) {
          if (!googleAuth) {
            logger9.debug("google Auth undefined");
            rej(new NonRetryableError("google Auth undefined"));
          }
          var googleUser = googleAuth.currentUser.get();
          if (googleUser.isSignedIn()) {
            logger9.debug("refreshing the google access token");
            googleUser.reloadAuthResponse().then(function(authResponse) {
              var id_token = authResponse.id_token, expires_at = authResponse.expires_at;
              res({ token: id_token, expires_at });
            }).catch(function(err) {
              if (err && err.error === "network_error") {
                rej("Network error reloading google auth response");
              } else {
                rej(new NonRetryableError("Failed to reload google auth response"));
              }
            });
          } else {
            rej(new NonRetryableError("User is not signed in with Google"));
          }
        }).catch(function(err) {
          logger9.debug("Failed to refresh google token", err);
          rej(new NonRetryableError("Failed to refresh google token"));
        });
      });
    };
    return GoogleOAuth3;
  }()
);

// node_modules/@aws-amplify/core/lib-esm/OAuthHelper/FacebookOAuth.js
var __awaiter17 = function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator17 = function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (g2 && (g2 = 0, op[0] && (_2 = 0)), _2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var logger10 = new ConsoleLogger("CognitoCredentials");
var waitForInit2 = new Promise(function(res, rej) {
  if (!browserOrNode().isBrowser) {
    logger10.debug("not in the browser, directly resolved");
    return res();
  }
  var fb = window["FB"];
  if (fb) {
    logger10.debug("FB SDK already loaded");
    return res();
  } else {
    setTimeout(function() {
      return res();
    }, 2e3);
  }
});
var FacebookOAuth = (
  /** @class */
  function() {
    function FacebookOAuth3() {
      this.initialized = false;
      this.refreshFacebookToken = this.refreshFacebookToken.bind(this);
      this._refreshFacebookTokenImpl = this._refreshFacebookTokenImpl.bind(this);
    }
    FacebookOAuth3.prototype.refreshFacebookToken = function() {
      return __awaiter17(this, void 0, void 0, function() {
        return __generator17(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (!!this.initialized)
                return [3, 2];
              logger10.debug("need to wait for the Facebook SDK loaded");
              return [4, waitForInit2];
            case 1:
              _a2.sent();
              this.initialized = true;
              logger10.debug("finish waiting");
              _a2.label = 2;
            case 2:
              return [2, this._refreshFacebookTokenImpl()];
          }
        });
      });
    };
    FacebookOAuth3.prototype._refreshFacebookTokenImpl = function() {
      var fb = null;
      if (browserOrNode().isBrowser)
        fb = window["FB"];
      if (!fb) {
        var errorMessage = "no fb sdk available";
        logger10.debug(errorMessage);
        return Promise.reject(new NonRetryableError(errorMessage));
      }
      return new Promise(function(res, rej) {
        fb.getLoginStatus(function(fbResponse) {
          if (!fbResponse || !fbResponse.authResponse) {
            var errorMessage2 = "no response from facebook when refreshing the jwt token";
            logger10.debug(errorMessage2);
            rej(new NonRetryableError(errorMessage2));
          } else {
            var response = fbResponse.authResponse;
            var accessToken = response.accessToken, expiresIn = response.expiresIn;
            var date = /* @__PURE__ */ new Date();
            var expires_at = expiresIn * 1e3 + date.getTime();
            if (!accessToken) {
              var errorMessage2 = "the jwtToken is undefined";
              logger10.debug(errorMessage2);
              rej(new NonRetryableError(errorMessage2));
            }
            res({
              token: accessToken,
              expires_at
            });
          }
        }, { scope: "public_profile,email" });
      });
    };
    return FacebookOAuth3;
  }()
);

// node_modules/@aws-amplify/core/lib-esm/OAuthHelper/index.js
var GoogleOAuth2 = new GoogleOAuth();
var FacebookOAuth2 = new FacebookOAuth();

// node_modules/@aws-amplify/core/lib-esm/StorageHelper/index.js
var dataMemory = {};
var MemoryStorage = (
  /** @class */
  function() {
    function MemoryStorage3() {
    }
    MemoryStorage3.setItem = function(key, value) {
      dataMemory[key] = value;
      return dataMemory[key];
    };
    MemoryStorage3.getItem = function(key) {
      return Object.prototype.hasOwnProperty.call(dataMemory, key) ? dataMemory[key] : void 0;
    };
    MemoryStorage3.removeItem = function(key) {
      return delete dataMemory[key];
    };
    MemoryStorage3.clear = function() {
      dataMemory = {};
      return dataMemory;
    };
    return MemoryStorage3;
  }()
);
var StorageHelper = (
  /** @class */
  function() {
    function StorageHelper3() {
      try {
        this.storageWindow = window.localStorage;
        this.storageWindow.setItem("aws.amplify.test-ls", 1);
        this.storageWindow.removeItem("aws.amplify.test-ls");
      } catch (exception) {
        this.storageWindow = MemoryStorage;
      }
    }
    StorageHelper3.prototype.getStorage = function() {
      return this.storageWindow;
    };
    return StorageHelper3;
  }()
);

// node_modules/@aws-amplify/core/lib-esm/clients/endpoints/partitions.js
var defaultPartition = {
  id: "aws",
  outputs: {
    dnsSuffix: "amazonaws.com"
  },
  regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
  regions: ["aws-global"]
};
var partitionsInfo = {
  partitions: [
    defaultPartition,
    {
      id: "aws-cn",
      outputs: {
        dnsSuffix: "amazonaws.com.cn"
      },
      regionRegex: "^cn\\-\\w+\\-\\d+$",
      regions: ["aws-cn-global"]
    }
  ]
};

// node_modules/@aws-amplify/core/lib-esm/clients/endpoints/getDnsSuffix.js
var __values10 = function(o2) {
  var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
  if (m2)
    return m2.call(o2);
  if (o2 && typeof o2.length === "number")
    return {
      next: function() {
        if (o2 && i2 >= o2.length)
          o2 = void 0;
        return { value: o2 && o2[i2++], done: !o2 };
      }
    };
  throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var getDnsSuffix = function(region) {
  var e_1, _a2;
  var partitions = partitionsInfo.partitions;
  try {
    for (var partitions_1 = __values10(partitions), partitions_1_1 = partitions_1.next(); !partitions_1_1.done; partitions_1_1 = partitions_1.next()) {
      var _b2 = partitions_1_1.value, regions = _b2.regions, outputs = _b2.outputs, regionRegex = _b2.regionRegex;
      var regex = new RegExp(regionRegex);
      if (regions.includes(region) || regex.test(region)) {
        return outputs.dnsSuffix;
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (partitions_1_1 && !partitions_1_1.done && (_a2 = partitions_1.return))
        _a2.call(partitions_1);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return defaultPartition.outputs.dnsSuffix;
};

// node_modules/@aws-amplify/core/lib-esm/clients/handlers/fetch.js
var import_isomorphic_unfetch = __toESM(require_browser());
var __assign17 = function() {
  __assign17 = Object.assign || function(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign17.apply(this, arguments);
};
var __awaiter18 = function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator18 = function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (g2 && (g2 = 0, op[0] && (_2 = 0)), _2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var shouldSendBody = function(method) {
  return !["HEAD", "GET", "DELETE"].includes(method.toUpperCase());
};
var fetchTransferHandler = function(_a2, _b2) {
  var url2 = _a2.url, method = _a2.method, headers = _a2.headers, body = _a2.body;
  var abortSignal = _b2.abortSignal;
  return __awaiter18(void 0, void 0, void 0, function() {
    var resp, e_1, responseHeaders, httpResponse, bodyWithMixin;
    var _c, _d;
    return __generator18(this, function(_e) {
      switch (_e.label) {
        case 0:
          _e.trys.push([0, 2, , 3]);
          return [4, fetch(url2, {
            method,
            headers,
            body: shouldSendBody(method) ? body : void 0,
            signal: abortSignal
          })];
        case 1:
          resp = _e.sent();
          return [3, 3];
        case 2:
          e_1 = _e.sent();
          if (e_1 instanceof TypeError) {
            throw new Error("Network error");
          }
          throw e_1;
        case 3:
          responseHeaders = {};
          (_c = resp.headers) === null || _c === void 0 ? void 0 : _c.forEach(function(value, key) {
            responseHeaders[key.toLowerCase()] = value;
          });
          httpResponse = {
            statusCode: resp.status,
            headers: responseHeaders,
            body: null
          };
          bodyWithMixin = Object.assign((_d = resp.body) !== null && _d !== void 0 ? _d : {}, {
            text: withMemoization(function() {
              return resp.text();
            }),
            blob: withMemoization(function() {
              return resp.blob();
            }),
            json: withMemoization(function() {
              return resp.json();
            })
          });
          return [2, __assign17(__assign17({}, httpResponse), { body: bodyWithMixin })];
      }
    });
  });
};
var withMemoization = function(payloadAccessor) {
  var cached;
  return function() {
    if (!cached) {
      cached = payloadAccessor();
    }
    return cached;
  };
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/retry/middleware.js
var __awaiter19 = function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator19 = function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (g2 && (g2 = 0, op[0] && (_2 = 0)), _2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var DEFAULT_RETRY_ATTEMPTS = 3;
var retryMiddleware2 = function(_a2) {
  var _b2 = _a2.maxAttempts, maxAttempts = _b2 === void 0 ? DEFAULT_RETRY_ATTEMPTS : _b2, retryDecider = _a2.retryDecider, computeDelay = _a2.computeDelay, abortSignal = _a2.abortSignal;
  if (maxAttempts < 1) {
    throw new Error("maxAttempts must be greater than 0");
  }
  return function(next, context) {
    return function retryMiddleware5(request) {
      var _a3;
      return __awaiter19(this, void 0, void 0, function() {
        var error, attemptsCount, response, e_1, delay;
        return __generator19(this, function(_b3) {
          switch (_b3.label) {
            case 0:
              attemptsCount = (_a3 = context.attemptsCount) !== null && _a3 !== void 0 ? _a3 : 0;
              _b3.label = 1;
            case 1:
              if (!(!(abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) && attemptsCount < maxAttempts))
                return [3, 11];
              error = void 0;
              response = void 0;
              _b3.label = 2;
            case 2:
              _b3.trys.push([2, 4, , 5]);
              return [4, next(request)];
            case 3:
              response = _b3.sent();
              return [3, 5];
            case 4:
              e_1 = _b3.sent();
              error = e_1;
              return [3, 5];
            case 5:
              attemptsCount = context.attemptsCount > attemptsCount ? context.attemptsCount : attemptsCount + 1;
              context.attemptsCount = attemptsCount;
              return [4, retryDecider(response, error)];
            case 6:
              if (!_b3.sent())
                return [3, 9];
              if (!(!(abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) && attemptsCount < maxAttempts))
                return [3, 8];
              delay = computeDelay(attemptsCount);
              return [4, cancellableSleep(delay, abortSignal)];
            case 7:
              _b3.sent();
              _b3.label = 8;
            case 8:
              return [3, 1];
            case 9:
              if (response) {
                updateMetadataAttempts(response, attemptsCount);
                return [2, response];
              } else {
                updateMetadataAttempts(error, attemptsCount);
                throw error;
              }
              _b3.label = 10;
            case 10:
              return [3, 1];
            case 11:
              throw (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) ? new Error("Request aborted") : error !== null && error !== void 0 ? error : new Error("Retry attempts exhausted");
          }
        });
      });
    };
  };
};
var cancellableSleep = function(timeoutMs, abortSignal) {
  if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
    return Promise.resolve();
  }
  var timeoutId;
  var sleepPromiseResolveFn;
  var sleepPromise = new Promise(function(resolve) {
    sleepPromiseResolveFn = resolve;
    timeoutId = setTimeout(resolve, timeoutMs);
  });
  abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.addEventListener("abort", function cancelSleep(event) {
    clearTimeout(timeoutId);
    abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.removeEventListener("abort", cancelSleep);
    sleepPromiseResolveFn();
  });
  return sleepPromise;
};
var isMetadataBearer = function(response) {
  return typeof (response === null || response === void 0 ? void 0 : response["$metadata"]) === "object";
};
var updateMetadataAttempts = function(nextHandlerOutput, attempts) {
  if (isMetadataBearer(nextHandlerOutput)) {
    nextHandlerOutput.$metadata.attempts = attempts;
  }
  nextHandlerOutput["$metadata"] = { attempts };
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/retry/jitteredBackoff.js
var DEFAULT_MAX_DELAY_MS = 5 * 60 * 1e3;
var jitteredBackoff2 = function(attempt) {
  var delayFunction = jitteredBackoff(DEFAULT_MAX_DELAY_MS);
  var delay = delayFunction(attempt);
  return delay === false ? DEFAULT_MAX_DELAY_MS : delay;
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/retry/isClockSkewError.js
var CLOCK_SKEW_ERROR_CODES2 = [
  "AuthFailure",
  "InvalidSignatureException",
  "RequestExpired",
  "RequestInTheFuture",
  "RequestTimeTooSkewed",
  "SignatureDoesNotMatch",
  "BadRequestException"
  // API Gateway
];
var isClockSkewError2 = function(errorCode) {
  return CLOCK_SKEW_ERROR_CODES2.includes(errorCode);
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/retry/defaultRetryDecider.js
var __awaiter20 = function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator20 = function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (g2 && (g2 = 0, op[0] && (_2 = 0)), _2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var getRetryDecider = function(errorParser) {
  return function(response, error) {
    return __awaiter20(void 0, void 0, void 0, function() {
      var errorCode, _a2, statusCode;
      var _b2;
      return __generator20(this, function(_c) {
        switch (_c.label) {
          case 0:
            if (!(error !== null && error !== void 0))
              return [3, 1];
            _a2 = error;
            return [3, 3];
          case 1:
            return [4, errorParser(response)];
          case 2:
            _a2 = _c.sent();
            _c.label = 3;
          case 3:
            errorCode = ((_b2 = _a2) !== null && _b2 !== void 0 ? _b2 : {}).name;
            statusCode = response === null || response === void 0 ? void 0 : response.statusCode;
            return [2, isConnectionError(error) || isThrottlingError2(statusCode, errorCode) || isClockSkewError2(errorCode) || isServerSideError(statusCode, errorCode)];
        }
      });
    });
  };
};
var THROTTLING_ERROR_CODES2 = [
  "BandwidthLimitExceeded",
  "EC2ThrottledException",
  "LimitExceededException",
  "PriorRequestNotComplete",
  "ProvisionedThroughputExceededException",
  "RequestLimitExceeded",
  "RequestThrottled",
  "RequestThrottledException",
  "SlowDown",
  "ThrottledException",
  "Throttling",
  "ThrottlingException",
  "TooManyRequestsException"
];
var TIMEOUT_ERROR_CODES = [
  "TimeoutError",
  "RequestTimeout",
  "RequestTimeoutException"
];
var isThrottlingError2 = function(statusCode, errorCode) {
  return statusCode === 429 || THROTTLING_ERROR_CODES2.includes(errorCode);
};
var isConnectionError = function(error) {
  return (error === null || error === void 0 ? void 0 : error.name) === "Network error";
};
var isServerSideError = function(statusCode, errorCode) {
  return [500, 502, 503, 504].includes(statusCode) || TIMEOUT_ERROR_CODES.includes(errorCode);
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/userAgent/middleware.js
var __awaiter21 = function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator21 = function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (g2 && (g2 = 0, op[0] && (_2 = 0)), _2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var userAgentMiddleware2 = function(_a2) {
  var _b2 = _a2.userAgentHeader, userAgentHeader = _b2 === void 0 ? "x-amz-user-agent" : _b2, _c = _a2.userAgentValue, userAgentValue = _c === void 0 ? "" : _c;
  return function(next) {
    return function userAgentMiddleware9(request) {
      return __awaiter21(this, void 0, void 0, function() {
        var result, headerName, response;
        return __generator21(this, function(_a3) {
          switch (_a3.label) {
            case 0:
              if (!(userAgentValue.trim().length === 0))
                return [3, 2];
              return [4, next(request)];
            case 1:
              result = _a3.sent();
              return [2, result];
            case 2:
              headerName = userAgentHeader.toLowerCase();
              request.headers[headerName] = request.headers[headerName] ? "".concat(request.headers[headerName], " ").concat(userAgentValue) : userAgentValue;
              return [4, next(request)];
            case 3:
              response = _a3.sent();
              return [2, response];
          }
        });
      });
    };
  };
};

// node_modules/@aws-amplify/core/lib-esm/clients/internal/composeTransferHandler.js
var composeTransferHandler = function(coreHandler, middleware) {
  return function(request, options) {
    var context = {};
    var composedHandler = function(request2) {
      return coreHandler(request2, options);
    };
    for (var i2 = middleware.length - 1; i2 >= 0; i2--) {
      var m2 = middleware[i2];
      var resolvedMiddleware = m2(options);
      composedHandler = resolvedMiddleware(composedHandler, context);
    }
    return composedHandler(request);
  };
};

// node_modules/@aws-amplify/core/lib-esm/clients/handlers/unauthenticated.js
var unauthenticatedHandler = composeTransferHandler(fetchTransferHandler, [userAgentMiddleware2, retryMiddleware2]);

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/utils/getSkewCorrectedDate.js
var getSkewCorrectedDate2 = function(systemClockOffset) {
  return new Date(Date.now() + systemClockOffset);
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/utils/isClockSkewed.js
var SKEW_WINDOW = 5 * 60 * 1e3;
var isClockSkewed2 = function(clockTimeInMilliseconds, clockOffsetInMilliseconds) {
  return Math.abs(getSkewCorrectedDate2(clockOffsetInMilliseconds).getTime() - clockTimeInMilliseconds) >= SKEW_WINDOW;
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/utils/getUpdatedSystemClockOffset.js
var getUpdatedSystemClockOffset = function(clockTimeInMilliseconds, currentSystemClockOffset) {
  if (isClockSkewed2(clockTimeInMilliseconds, currentSystemClockOffset)) {
    return clockTimeInMilliseconds - Date.now();
  }
  return currentSystemClockOffset;
};

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/middleware.js
var __awaiter22 = function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator22 = function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (g2 && (g2 = 0, op[0] && (_2 = 0)), _2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var signingMiddleware = function(_a2) {
  var credentials = _a2.credentials, region = _a2.region, service = _a2.service;
  var currentSystemClockOffset;
  return function(next) {
    return function signingMiddleware2(request) {
      return __awaiter22(this, void 0, void 0, function() {
        var signRequestOptions, signedRequest, response, dateString;
        return __generator22(this, function(_a3) {
          switch (_a3.label) {
            case 0:
              currentSystemClockOffset = currentSystemClockOffset !== null && currentSystemClockOffset !== void 0 ? currentSystemClockOffset : 0;
              signRequestOptions = {
                credentials,
                signingDate: getSkewCorrectedDate2(currentSystemClockOffset),
                signingRegion: region,
                signingService: service
              };
              return [4, signRequest(request, signRequestOptions)];
            case 1:
              signedRequest = _a3.sent();
              return [4, next(signedRequest)];
            case 2:
              response = _a3.sent();
              dateString = getDateHeader(response);
              if (dateString) {
                currentSystemClockOffset = getUpdatedSystemClockOffset(Date.parse(dateString), currentSystemClockOffset);
              }
              return [2, response];
          }
        });
      });
    };
  };
};
var getDateHeader = function(_a2) {
  var _b2, _c;
  var _d = _a2 === void 0 ? {} : _a2, headers = _d.headers;
  return (_c = (_b2 = headers === null || headers === void 0 ? void 0 : headers.date) !== null && _b2 !== void 0 ? _b2 : headers === null || headers === void 0 ? void 0 : headers.Date) !== null && _c !== void 0 ? _c : headers === null || headers === void 0 ? void 0 : headers["x-amz-date"];
};

// node_modules/@aws-amplify/core/lib-esm/clients/handlers/authenticated.js
var authenticatedHandler = composeTransferHandler(fetchTransferHandler, [
  userAgentMiddleware2,
  retryMiddleware2,
  signingMiddleware
]);

// node_modules/@aws-amplify/core/lib-esm/clients/internal/composeServiceApi.js
var __assign18 = function() {
  __assign18 = Object.assign || function(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign18.apply(this, arguments);
};
var __awaiter23 = function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator23 = function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (g2 && (g2 = 0, op[0] && (_2 = 0)), _2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var composeServiceApi = function(transferHandler, serializer, deserializer, defaultConfig4) {
  return function(config, input) {
    return __awaiter23(void 0, void 0, void 0, function() {
      var resolvedConfig, endpoint, request, response;
      return __generator23(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            resolvedConfig = __assign18(__assign18({}, defaultConfig4), config);
            return [4, resolvedConfig.endpointResolver({
              region: resolvedConfig.region
            })];
          case 1:
            endpoint = _a2.sent();
            request = serializer(input, endpoint);
            return [4, transferHandler(request, __assign18({}, resolvedConfig))];
          case 2:
            response = _a2.sent();
            return [4, deserializer(response)];
          case 3:
            return [2, _a2.sent()];
        }
      });
    });
  };
};

// node_modules/@aws-amplify/core/lib-esm/clients/serde/responseInfo.js
var __assign19 = function() {
  __assign19 = Object.assign || function(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign19.apply(this, arguments);
};
var parseMetadata = function(response) {
  var _a2, _b2;
  var headers = response.headers, statusCode = response.statusCode;
  return __assign19(__assign19({}, isMetadataBearer(response) ? response.$metadata : {}), { httpStatusCode: statusCode, requestId: (_b2 = (_a2 = headers["x-amzn-requestid"]) !== null && _a2 !== void 0 ? _a2 : headers["x-amzn-request-id"]) !== null && _b2 !== void 0 ? _b2 : headers["x-amz-request-id"], extendedRequestId: headers["x-amz-id-2"], cfId: headers["x-amz-cf-id"] });
};

// node_modules/@aws-amplify/core/lib-esm/clients/serde/json.js
var __awaiter24 = function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator24 = function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (g2 && (g2 = 0, op[0] && (_2 = 0)), _2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var __read20 = function(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var parseJsonError = function(response) {
  return __awaiter24(void 0, void 0, void 0, function() {
    var body, sanitizeErrorCode, code, message, error;
    var _a2, _b2, _c, _d, _e;
    return __generator24(this, function(_f) {
      switch (_f.label) {
        case 0:
          if (!response || response.statusCode < 300) {
            return [
              2
              /*return*/
            ];
          }
          return [4, parseJsonBody(response)];
        case 1:
          body = _f.sent();
          sanitizeErrorCode = function(rawValue) {
            var _a3 = __read20(rawValue.toString().split(/[\,\:]+/), 1), cleanValue = _a3[0];
            if (cleanValue.includes("#")) {
              return cleanValue.split("#")[1];
            }
            return cleanValue;
          };
          code = sanitizeErrorCode((_c = (_b2 = (_a2 = response.headers["x-amzn-errortype"]) !== null && _a2 !== void 0 ? _a2 : body.code) !== null && _b2 !== void 0 ? _b2 : body.__type) !== null && _c !== void 0 ? _c : "UnknownError");
          message = (_e = (_d = body.message) !== null && _d !== void 0 ? _d : body.Message) !== null && _e !== void 0 ? _e : "Unknown error";
          error = new Error(message);
          return [2, Object.assign(error, {
            name: code,
            $metadata: parseMetadata(response)
          })];
      }
    });
  });
};
var parseJsonBody = function(response) {
  return __awaiter24(void 0, void 0, void 0, function() {
    var output;
    return __generator24(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (!response.body) {
            throw new Error("Missing response payload");
          }
          return [4, response.body.json()];
        case 1:
          output = _a2.sent();
          return [2, Object.assign(output, {
            $metadata: parseMetadata(response)
          })];
      }
    });
  });
};

// node_modules/@aws-amplify/core/lib-esm/AwsClients/CognitoIdentity/base.js
var __awaiter25 = function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator25 = function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (g2 && (g2 = 0, op[0] && (_2 = 0)), _2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var SERVICE_NAME = "cognito-identity";
var endpointResolver = function(_a2) {
  var region = _a2.region;
  return {
    url: new URL("https://cognito-identity.".concat(region, ".").concat(getDnsSuffix(region)))
  };
};
var disableCacheMiddleware = function() {
  return function(next, context) {
    return function disableCacheMiddleware2(request) {
      return __awaiter25(this, void 0, void 0, function() {
        return __generator25(this, function(_a2) {
          request.headers["cache-control"] = "no-store";
          return [2, next(request)];
        });
      });
    };
  };
};
var cognitoIdentityTransferHandler = composeTransferHandler(unauthenticatedHandler, [disableCacheMiddleware]);
var defaultConfig = {
  service: SERVICE_NAME,
  endpointResolver,
  retryDecider: getRetryDecider(parseJsonError),
  computeDelay: jitteredBackoff2,
  userAgentValue: getAmplifyUserAgent()
};
observeFrameworkChanges(function() {
  defaultConfig.userAgentValue = getAmplifyUserAgent();
});
var getSharedHeaders = function(operation) {
  return {
    "content-type": "application/x-amz-json-1.1",
    "x-amz-target": "AWSCognitoIdentityService.".concat(operation)
  };
};
var buildHttpRpcRequest2 = function(_a2, headers, body) {
  var url2 = _a2.url;
  return {
    headers,
    url: url2,
    body,
    method: "POST"
  };
};

// node_modules/@aws-amplify/core/lib-esm/AwsClients/CognitoIdentity/getId.js
var __awaiter26 = function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator26 = function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (g2 && (g2 = 0, op[0] && (_2 = 0)), _2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var getIdSerializer = function(input, endpoint) {
  var headers = getSharedHeaders("GetId");
  var body = JSON.stringify(input);
  return buildHttpRpcRequest2(endpoint, headers, body);
};
var getIdDeserializer = function(response) {
  return __awaiter26(void 0, void 0, void 0, function() {
    var error, body;
    return __generator26(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (!(response.statusCode >= 300))
            return [3, 2];
          return [4, parseJsonError(response)];
        case 1:
          error = _a2.sent();
          throw error;
        case 2:
          return [4, parseJsonBody(response)];
        case 3:
          body = _a2.sent();
          return [2, {
            IdentityId: body.IdentityId,
            $metadata: parseMetadata(response)
          }];
      }
    });
  });
};
var getId = composeServiceApi(cognitoIdentityTransferHandler, getIdSerializer, getIdDeserializer, defaultConfig);

// node_modules/@aws-amplify/core/lib-esm/AwsClients/CognitoIdentity/getCredentialsForIdentity.js
var __awaiter27 = function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator27 = function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (g2 && (g2 = 0, op[0] && (_2 = 0)), _2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var getCredentialsForIdentitySerializer = function(input, endpoint) {
  var headers = getSharedHeaders("GetCredentialsForIdentity");
  var body = JSON.stringify(input);
  return buildHttpRpcRequest2(endpoint, headers, body);
};
var getCredentialsForIdentityDeserializer = function(response) {
  return __awaiter27(void 0, void 0, void 0, function() {
    var error, body;
    return __generator27(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (!(response.statusCode >= 300))
            return [3, 2];
          return [4, parseJsonError(response)];
        case 1:
          error = _a2.sent();
          throw error;
        case 2:
          return [4, parseJsonBody(response)];
        case 3:
          body = _a2.sent();
          return [2, {
            IdentityId: body.IdentityId,
            Credentials: deserializeCredentials(body.Credentials),
            $metadata: parseMetadata(response)
          }];
      }
    });
  });
};
var deserializeCredentials = function(output) {
  if (output === void 0) {
    output = {};
  }
  return {
    AccessKeyId: output["AccessKeyId"],
    SecretKey: output["SecretKey"],
    SessionToken: output["SessionToken"],
    Expiration: new Date(output["Expiration"] * 1e3)
  };
};
var getCredentialsForIdentity = composeServiceApi(cognitoIdentityTransferHandler, getCredentialsForIdentitySerializer, getCredentialsForIdentityDeserializer, defaultConfig);

// node_modules/@aws-amplify/core/lib-esm/Credentials.js
var __assign20 = function() {
  __assign20 = Object.assign || function(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign20.apply(this, arguments);
};
var __awaiter28 = function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator28 = function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (g2 && (g2 = 0, op[0] && (_2 = 0)), _2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var logger11 = new ConsoleLogger("Credentials");
var CREDENTIALS_TTL = 50 * 60 * 1e3;
var COGNITO_IDENTITY_KEY_PREFIX = "CognitoIdentityId-";
var AMPLIFY_SYMBOL2 = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var dispatchCredentialsEvent = function(event, data, message) {
  Hub.dispatch("core", { event, data, message }, "Credentials", AMPLIFY_SYMBOL2);
};
var CredentialsClass = (
  /** @class */
  function() {
    function CredentialsClass2(config) {
      this._gettingCredPromise = null;
      this._refreshHandlers = {};
      this.Auth = void 0;
      this.configure(config);
      this._refreshHandlers["google"] = GoogleOAuth2.refreshGoogleToken;
      this._refreshHandlers["facebook"] = FacebookOAuth2.refreshFacebookToken;
    }
    CredentialsClass2.prototype.getModuleName = function() {
      return "Credentials";
    };
    CredentialsClass2.prototype.getCredSource = function() {
      return this._credentials_source;
    };
    CredentialsClass2.prototype.configure = function(config) {
      if (!config)
        return this._config || {};
      this._config = Object.assign({}, this._config, config);
      var refreshHandlers = this._config.refreshHandlers;
      if (refreshHandlers) {
        this._refreshHandlers = __assign20(__assign20({}, this._refreshHandlers), refreshHandlers);
      }
      this._storage = this._config.storage;
      if (!this._storage) {
        this._storage = new StorageHelper().getStorage();
      }
      this._storageSync = Promise.resolve();
      if (typeof this._storage["sync"] === "function") {
        this._storageSync = this._storage["sync"]();
      }
      dispatchCredentialsEvent("credentials_configured", null, "Credentials has been configured successfully");
      return this._config;
    };
    CredentialsClass2.prototype.get = function() {
      logger11.debug("getting credentials");
      return this._pickupCredentials();
    };
    CredentialsClass2.prototype._getCognitoIdentityIdStorageKey = function(identityPoolId) {
      return "".concat(COGNITO_IDENTITY_KEY_PREFIX).concat(identityPoolId);
    };
    CredentialsClass2.prototype._pickupCredentials = function() {
      logger11.debug("picking up credentials");
      if (!this._gettingCredPromise || !this._gettingCredPromise.isPending()) {
        logger11.debug("getting new cred promise");
        this._gettingCredPromise = makeQuerablePromise(this._keepAlive());
      } else {
        logger11.debug("getting old cred promise");
      }
      return this._gettingCredPromise;
    };
    CredentialsClass2.prototype._keepAlive = function() {
      return __awaiter28(this, void 0, void 0, function() {
        var cred, _a2, Auth2, user_1, session, refreshToken_1, refreshRequest, err_1;
        return __generator28(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              logger11.debug("checking if credentials exists and not expired");
              cred = this._credentials;
              if (cred && !this._isExpired(cred) && !this._isPastTTL()) {
                logger11.debug("credentials not changed and not expired, directly return");
                return [2, Promise.resolve(cred)];
              }
              logger11.debug("need to get a new credential or refresh the existing one");
              _a2 = this.Auth, Auth2 = _a2 === void 0 ? Amplify.Auth : _a2;
              if (!Auth2 || typeof Auth2.currentUserCredentials !== "function") {
                return [2, this._setCredentialsForGuest()];
              }
              if (!(!this._isExpired(cred) && this._isPastTTL()))
                return [3, 6];
              logger11.debug("ttl has passed but token is not yet expired");
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 5, , 6]);
              return [4, Auth2.currentUserPoolUser()];
            case 2:
              user_1 = _b2.sent();
              return [4, Auth2.currentSession()];
            case 3:
              session = _b2.sent();
              refreshToken_1 = session.refreshToken;
              refreshRequest = new Promise(function(res, rej) {
                user_1.refreshSession(refreshToken_1, function(err, data) {
                  return err ? rej(err) : res(data);
                });
              });
              return [4, refreshRequest];
            case 4:
              _b2.sent();
              return [3, 6];
            case 5:
              err_1 = _b2.sent();
              logger11.debug("Error attempting to refreshing the session", err_1);
              return [3, 6];
            case 6:
              return [2, Auth2.currentUserCredentials()];
          }
        });
      });
    };
    CredentialsClass2.prototype.refreshFederatedToken = function(federatedInfo) {
      logger11.debug("Getting federated credentials");
      var provider = federatedInfo.provider, user = federatedInfo.user, token = federatedInfo.token, identity_id = federatedInfo.identity_id;
      var expires_at = federatedInfo.expires_at;
      expires_at = new Date(expires_at).getFullYear() === 1970 ? expires_at * 1e3 : expires_at;
      var that = this;
      logger11.debug("checking if federated jwt token expired");
      if (expires_at > (/* @__PURE__ */ new Date()).getTime()) {
        logger11.debug("token not expired");
        return this._setCredentialsFromFederation({
          provider,
          token,
          user,
          identity_id,
          expires_at
        });
      } else {
        if (that._refreshHandlers[provider] && typeof that._refreshHandlers[provider] === "function") {
          logger11.debug("getting refreshed jwt token from federation provider");
          return this._providerRefreshWithRetry({
            refreshHandler: that._refreshHandlers[provider],
            provider,
            user
          });
        } else {
          logger11.debug("no refresh handler for provider:", provider);
          this.clear();
          return Promise.reject("no refresh handler for provider");
        }
      }
    };
    CredentialsClass2.prototype._providerRefreshWithRetry = function(_a2) {
      var _this = this;
      var refreshHandler = _a2.refreshHandler, provider = _a2.provider, user = _a2.user;
      var MAX_DELAY_MS4 = 10 * 1e3;
      return jitteredExponentialRetry(refreshHandler, [], MAX_DELAY_MS4).then(function(data) {
        logger11.debug("refresh federated token sucessfully", data);
        return _this._setCredentialsFromFederation({
          provider,
          token: data.token,
          user,
          identity_id: data.identity_id,
          expires_at: data.expires_at
        });
      }).catch(function(e) {
        var isNetworkError = typeof e === "string" && e.toLowerCase().lastIndexOf("network error", e.length) === 0;
        if (!isNetworkError) {
          _this.clear();
        }
        logger11.debug("refresh federated token failed", e);
        return Promise.reject("refreshing federation token failed: " + e);
      });
    };
    CredentialsClass2.prototype._isExpired = function(credentials) {
      if (!credentials) {
        logger11.debug("no credentials for expiration check");
        return true;
      }
      logger11.debug("are these credentials expired?", credentials);
      var ts = Date.now();
      var expiration = credentials.expiration;
      return expiration.getTime() <= ts;
    };
    CredentialsClass2.prototype._isPastTTL = function() {
      return this._nextCredentialsRefresh <= Date.now();
    };
    CredentialsClass2.prototype._setCredentialsForGuest = function() {
      var _a2;
      return __awaiter28(this, void 0, void 0, function() {
        var _b2, identityPoolId, region, mandatorySignIn, identityPoolRegion, identityId, _c, cognitoConfig, guestCredentialsProvider, credentials;
        var _this = this;
        return __generator28(this, function(_d) {
          switch (_d.label) {
            case 0:
              logger11.debug("setting credentials for guest");
              if (!((_a2 = this._config) === null || _a2 === void 0 ? void 0 : _a2.identityPoolId)) {
                this._config = Object.assign({}, this._config, parseAWSExports(this._config || {}).Auth);
              }
              _b2 = this._config, identityPoolId = _b2.identityPoolId, region = _b2.region, mandatorySignIn = _b2.mandatorySignIn, identityPoolRegion = _b2.identityPoolRegion;
              if (mandatorySignIn) {
                return [2, Promise.reject("cannot get guest credentials when mandatory signin enabled")];
              }
              if (!identityPoolId) {
                logger11.debug("No Cognito Identity pool provided for unauthenticated access");
                return [2, Promise.reject("No Cognito Identity pool provided for unauthenticated access")];
              }
              if (!identityPoolRegion && !region) {
                logger11.debug("region is not configured for getting the credentials");
                return [2, Promise.reject("region is not configured for getting the credentials")];
              }
              _c = this;
              return [4, this._getGuestIdentityId()];
            case 1:
              identityId = _c._identityId = _d.sent();
              cognitoConfig = { region: identityPoolRegion !== null && identityPoolRegion !== void 0 ? identityPoolRegion : region };
              guestCredentialsProvider = function() {
                return __awaiter28(_this, void 0, void 0, function() {
                  var IdentityId, Credentials2;
                  return __generator28(this, function(_a3) {
                    switch (_a3.label) {
                      case 0:
                        if (!!identityId)
                          return [3, 2];
                        return [4, getId(cognitoConfig, {
                          IdentityPoolId: identityPoolId
                        })];
                      case 1:
                        IdentityId = _a3.sent().IdentityId;
                        this._identityId = IdentityId;
                        _a3.label = 2;
                      case 2:
                        return [4, getCredentialsForIdentity(cognitoConfig, {
                          IdentityId: this._identityId
                        })];
                      case 3:
                        Credentials2 = _a3.sent().Credentials;
                        return [2, {
                          identityId: this._identityId,
                          accessKeyId: Credentials2.AccessKeyId,
                          secretAccessKey: Credentials2.SecretKey,
                          sessionToken: Credentials2.SessionToken,
                          expiration: Credentials2.Expiration
                        }];
                    }
                  });
                });
              };
              credentials = guestCredentialsProvider().catch(function(err) {
                return __awaiter28(_this, void 0, void 0, function() {
                  return __generator28(this, function(_a3) {
                    throw err;
                  });
                });
              });
              return [2, this._loadCredentials(credentials, "guest", false, null).then(function(res) {
                return res;
              }).catch(function(e) {
                return __awaiter28(_this, void 0, void 0, function() {
                  var guestCredentialsProvider_1;
                  var _this2 = this;
                  return __generator28(this, function(_a3) {
                    switch (_a3.label) {
                      case 0:
                        if (!(e.name === "ResourceNotFoundException" && e.message === "Identity '".concat(identityId, "' not found.")))
                          return [3, 2];
                        logger11.debug("Failed to load guest credentials");
                        return [4, this._removeGuestIdentityId()];
                      case 1:
                        _a3.sent();
                        guestCredentialsProvider_1 = function() {
                          return __awaiter28(_this2, void 0, void 0, function() {
                            var IdentityId, Credentials2;
                            return __generator28(this, function(_a4) {
                              switch (_a4.label) {
                                case 0:
                                  return [4, getId(cognitoConfig, {
                                    IdentityPoolId: identityPoolId
                                  })];
                                case 1:
                                  IdentityId = _a4.sent().IdentityId;
                                  this._identityId = IdentityId;
                                  return [4, getCredentialsForIdentity(cognitoConfig, {
                                    IdentityId
                                  })];
                                case 2:
                                  Credentials2 = _a4.sent().Credentials;
                                  return [2, {
                                    identityId: IdentityId,
                                    accessKeyId: Credentials2.AccessKeyId,
                                    secretAccessKey: Credentials2.SecretKey,
                                    sessionToken: Credentials2.SessionToken,
                                    expiration: Credentials2.Expiration
                                  }];
                              }
                            });
                          });
                        };
                        credentials = guestCredentialsProvider_1().catch(function(err) {
                          return __awaiter28(_this2, void 0, void 0, function() {
                            return __generator28(this, function(_a4) {
                              throw err;
                            });
                          });
                        });
                        return [2, this._loadCredentials(credentials, "guest", false, null)];
                      case 2:
                        return [2, e];
                    }
                  });
                });
              })];
          }
        });
      });
    };
    CredentialsClass2.prototype._setCredentialsFromFederation = function(params) {
      var _this = this;
      var provider = params.provider, token = params.token;
      var identity_id = params.identity_id;
      var domains = {
        google: "accounts.google.com",
        facebook: "graph.facebook.com",
        amazon: "www.amazon.com",
        developer: "cognito-identity.amazonaws.com"
      };
      var domain = domains[provider] || provider;
      if (!domain) {
        return Promise.reject("You must specify a federated provider");
      }
      var logins = {};
      logins[domain] = token;
      var _a2 = this._config, identityPoolId = _a2.identityPoolId, region = _a2.region, identityPoolRegion = _a2.identityPoolRegion;
      if (!identityPoolId) {
        logger11.debug("No Cognito Federated Identity pool provided");
        return Promise.reject("No Cognito Federated Identity pool provided");
      }
      if (!identityPoolRegion && !region) {
        logger11.debug("region is not configured for getting the credentials");
        return Promise.reject("region is not configured for getting the credentials");
      }
      var cognitoConfig = { region: identityPoolRegion !== null && identityPoolRegion !== void 0 ? identityPoolRegion : region };
      var authenticatedCredentialsProvider = function() {
        return __awaiter28(_this, void 0, void 0, function() {
          var IdentityId, Credentials2;
          return __generator28(this, function(_a3) {
            switch (_a3.label) {
              case 0:
                if (!!identity_id)
                  return [3, 2];
                return [4, getId(cognitoConfig, {
                  IdentityPoolId: identityPoolId,
                  Logins: logins
                })];
              case 1:
                IdentityId = _a3.sent().IdentityId;
                identity_id = IdentityId;
                _a3.label = 2;
              case 2:
                return [4, getCredentialsForIdentity(cognitoConfig, {
                  IdentityId: identity_id,
                  Logins: logins
                })];
              case 3:
                Credentials2 = _a3.sent().Credentials;
                return [2, {
                  identityId: identity_id,
                  accessKeyId: Credentials2.AccessKeyId,
                  secretAccessKey: Credentials2.SecretKey,
                  sessionToken: Credentials2.SessionToken,
                  expiration: Credentials2.Expiration
                }];
            }
          });
        });
      };
      var credentials = authenticatedCredentialsProvider().catch(function(err) {
        return __awaiter28(_this, void 0, void 0, function() {
          return __generator28(this, function(_a3) {
            throw err;
          });
        });
      });
      return this._loadCredentials(credentials, "federated", true, params);
    };
    CredentialsClass2.prototype._setCredentialsFromSession = function(session) {
      var _this = this;
      logger11.debug("set credentials from session");
      var idToken = session.getIdToken().getJwtToken();
      var _a2 = this._config, region = _a2.region, userPoolId = _a2.userPoolId, identityPoolId = _a2.identityPoolId, identityPoolRegion = _a2.identityPoolRegion;
      if (!identityPoolId) {
        logger11.debug("No Cognito Federated Identity pool provided");
        return Promise.reject("No Cognito Federated Identity pool provided");
      }
      if (!identityPoolRegion && !region) {
        logger11.debug("region is not configured for getting the credentials");
        return Promise.reject("region is not configured for getting the credentials");
      }
      var key = "cognito-idp." + region + ".amazonaws.com/" + userPoolId;
      var logins = {};
      logins[key] = idToken;
      var cognitoConfig = { region: identityPoolRegion !== null && identityPoolRegion !== void 0 ? identityPoolRegion : region };
      var credentialsProvider2 = function() {
        return __awaiter28(_this, void 0, void 0, function() {
          var guestIdentityId, generatedOrRetrievedIdentityId, IdentityId, _a3, _b2, AccessKeyId, Expiration, SecretKey, SessionToken, primaryIdentityId;
          return __generator28(this, function(_c) {
            switch (_c.label) {
              case 0:
                return [4, this._getGuestIdentityId()];
              case 1:
                guestIdentityId = _c.sent();
                if (!!guestIdentityId)
                  return [3, 3];
                return [4, getId(cognitoConfig, {
                  IdentityPoolId: identityPoolId,
                  Logins: logins
                })];
              case 2:
                IdentityId = _c.sent().IdentityId;
                generatedOrRetrievedIdentityId = IdentityId;
                _c.label = 3;
              case 3:
                return [4, getCredentialsForIdentity(cognitoConfig, {
                  IdentityId: guestIdentityId || generatedOrRetrievedIdentityId,
                  Logins: logins
                })];
              case 4:
                _a3 = _c.sent(), _b2 = _a3.Credentials, AccessKeyId = _b2.AccessKeyId, Expiration = _b2.Expiration, SecretKey = _b2.SecretKey, SessionToken = _b2.SessionToken, primaryIdentityId = _a3.IdentityId;
                this._identityId = primaryIdentityId;
                if (!guestIdentityId)
                  return [3, 6];
                logger11.debug("The guest identity ".concat(guestIdentityId, " has been successfully linked to the logins"));
                if (guestIdentityId === primaryIdentityId) {
                  logger11.debug("The guest identity ".concat(guestIdentityId, " has become the primary identity"));
                }
                return [4, this._removeGuestIdentityId()];
              case 5:
                _c.sent();
                _c.label = 6;
              case 6:
                return [2, {
                  accessKeyId: AccessKeyId,
                  secretAccessKey: SecretKey,
                  sessionToken: SessionToken,
                  expiration: Expiration,
                  identityId: primaryIdentityId
                }];
            }
          });
        });
      };
      var credentials = credentialsProvider2().catch(function(err) {
        return __awaiter28(_this, void 0, void 0, function() {
          return __generator28(this, function(_a3) {
            throw err;
          });
        });
      });
      return this._loadCredentials(credentials, "userPool", true, null);
    };
    CredentialsClass2.prototype._loadCredentials = function(credentials, source, authenticated, info) {
      var _this = this;
      var that = this;
      return new Promise(function(res, rej) {
        credentials.then(function(credentials2) {
          return __awaiter28(_this, void 0, void 0, function() {
            var user, provider, token, expires_at, identity_id;
            return __generator28(this, function(_a2) {
              switch (_a2.label) {
                case 0:
                  logger11.debug("Load credentials successfully", credentials2);
                  if (this._identityId && !credentials2.identityId) {
                    credentials2["identityId"] = this._identityId;
                  }
                  that._credentials = credentials2;
                  that._credentials.authenticated = authenticated;
                  that._credentials_source = source;
                  that._nextCredentialsRefresh = (/* @__PURE__ */ new Date()).getTime() + CREDENTIALS_TTL;
                  if (source === "federated") {
                    user = Object.assign({ id: this._credentials.identityId }, info.user);
                    provider = info.provider, token = info.token, expires_at = info.expires_at, identity_id = info.identity_id;
                    try {
                      this._storage.setItem("aws-amplify-federatedInfo", JSON.stringify({
                        provider,
                        token,
                        user,
                        expires_at,
                        identity_id
                      }));
                    } catch (e) {
                      logger11.debug("Failed to put federated info into auth storage", e);
                    }
                  }
                  if (!(source === "guest"))
                    return [3, 2];
                  return [4, this._setGuestIdentityId(credentials2.identityId)];
                case 1:
                  _a2.sent();
                  _a2.label = 2;
                case 2:
                  res(that._credentials);
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }).catch(function(err) {
          if (err) {
            logger11.debug("Failed to load credentials", credentials);
            logger11.debug("Error loading credentials", err);
            rej(err);
            return;
          }
        });
      });
    };
    CredentialsClass2.prototype.set = function(params, source) {
      if (source === "session") {
        return this._setCredentialsFromSession(params);
      } else if (source === "federation") {
        return this._setCredentialsFromFederation(params);
      } else if (source === "guest") {
        return this._setCredentialsForGuest();
      } else {
        logger11.debug("no source specified for setting credentials");
        return Promise.reject("invalid source");
      }
    };
    CredentialsClass2.prototype.clear = function() {
      return __awaiter28(this, void 0, void 0, function() {
        return __generator28(this, function(_a2) {
          this._credentials = null;
          this._credentials_source = null;
          logger11.debug("removing aws-amplify-federatedInfo from storage");
          this._storage.removeItem("aws-amplify-federatedInfo");
          return [
            2
            /*return*/
          ];
        });
      });
    };
    CredentialsClass2.prototype._getGuestIdentityId = function() {
      return __awaiter28(this, void 0, void 0, function() {
        var identityPoolId, e_1;
        return __generator28(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              identityPoolId = this._config.identityPoolId;
              _a2.label = 1;
            case 1:
              _a2.trys.push([1, 3, , 4]);
              return [4, this._storageSync];
            case 2:
              _a2.sent();
              return [2, this._storage.getItem(this._getCognitoIdentityIdStorageKey(identityPoolId))];
            case 3:
              e_1 = _a2.sent();
              logger11.debug("Failed to get the cached guest identityId", e_1);
              return [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    CredentialsClass2.prototype._setGuestIdentityId = function(identityId) {
      return __awaiter28(this, void 0, void 0, function() {
        var identityPoolId, e_2;
        return __generator28(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              identityPoolId = this._config.identityPoolId;
              _a2.label = 1;
            case 1:
              _a2.trys.push([1, 3, , 4]);
              return [4, this._storageSync];
            case 2:
              _a2.sent();
              this._storage.setItem(this._getCognitoIdentityIdStorageKey(identityPoolId), identityId);
              return [3, 4];
            case 3:
              e_2 = _a2.sent();
              logger11.debug("Failed to cache guest identityId", e_2);
              return [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    CredentialsClass2.prototype._removeGuestIdentityId = function() {
      return __awaiter28(this, void 0, void 0, function() {
        var identityPoolId;
        return __generator28(this, function(_a2) {
          identityPoolId = this._config.identityPoolId;
          logger11.debug("removing ".concat(this._getCognitoIdentityIdStorageKey(identityPoolId), " from storage"));
          this._storage.removeItem(this._getCognitoIdentityIdStorageKey(identityPoolId));
          return [
            2
            /*return*/
          ];
        });
      });
    };
    CredentialsClass2.prototype.shear = function(credentials) {
      return {
        accessKeyId: credentials.accessKeyId,
        sessionToken: credentials.sessionToken,
        secretAccessKey: credentials.secretAccessKey,
        identityId: credentials.identityId,
        authenticated: credentials.authenticated
      };
    };
    return CredentialsClass2;
  }()
);
var Credentials = new CredentialsClass(null);
Amplify.register(Credentials);

// node_modules/@aws-amplify/core/lib-esm/ServiceWorker/ServiceWorker.js
var ServiceWorkerClass = (
  /** @class */
  function() {
    function ServiceWorkerClass2() {
      this._logger = new ConsoleLogger("ServiceWorker");
    }
    Object.defineProperty(ServiceWorkerClass2.prototype, "serviceWorker", {
      /**
       * Get the currently active service worker
       */
      get: function() {
        return this._serviceWorker;
      },
      enumerable: false,
      configurable: true
    });
    ServiceWorkerClass2.prototype.register = function(filePath, scope) {
      var _this = this;
      if (filePath === void 0) {
        filePath = "/service-worker.js";
      }
      if (scope === void 0) {
        scope = "/";
      }
      this._logger.debug("registering ".concat(filePath));
      this._logger.debug("registering service worker with scope ".concat(scope));
      return new Promise(function(resolve, reject) {
        if (navigator && "serviceWorker" in navigator) {
          navigator.serviceWorker.register(filePath, {
            scope
          }).then(function(registration) {
            if (registration.installing) {
              _this._serviceWorker = registration.installing;
            } else if (registration.waiting) {
              _this._serviceWorker = registration.waiting;
            } else if (registration.active) {
              _this._serviceWorker = registration.active;
            }
            _this._registration = registration;
            _this._setupListeners();
            _this._logger.debug("Service Worker Registration Success: ".concat(registration));
            return resolve(registration);
          }).catch(function(error) {
            _this._logger.debug("Service Worker Registration Failed ".concat(error));
            return reject(error);
          });
        } else {
          return reject(new Error("Service Worker not available"));
        }
      });
    };
    ServiceWorkerClass2.prototype.enablePush = function(publicKey) {
      var _this = this;
      if (!this._registration)
        throw new Error("Service Worker not registered");
      this._publicKey = publicKey;
      return new Promise(function(resolve, reject) {
        if (browserOrNode().isBrowser) {
          _this._registration.pushManager.getSubscription().then(function(subscription) {
            if (subscription) {
              _this._subscription = subscription;
              _this._logger.debug("User is subscribed to push: ".concat(JSON.stringify(subscription)));
              resolve(subscription);
            } else {
              _this._logger.debug("User is NOT subscribed to push");
              return _this._registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: _this._urlB64ToUint8Array(publicKey)
              }).then(function(subscription2) {
                _this._subscription = subscription2;
                _this._logger.debug("User subscribed: ".concat(JSON.stringify(subscription2)));
                resolve(subscription2);
              }).catch(function(error) {
                _this._logger.error(error);
              });
            }
          });
        } else {
          return reject(new Error("Service Worker not available"));
        }
      });
    };
    ServiceWorkerClass2.prototype._urlB64ToUint8Array = function(base64String) {
      var padding = "=".repeat((4 - base64String.length % 4) % 4);
      var base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
      var rawData = window.atob(base64);
      var outputArray = new Uint8Array(rawData.length);
      for (var i2 = 0; i2 < rawData.length; ++i2) {
        outputArray[i2] = rawData.charCodeAt(i2);
      }
      return outputArray;
    };
    ServiceWorkerClass2.prototype.send = function(message) {
      if (this._serviceWorker) {
        this._serviceWorker.postMessage(typeof message === "object" ? JSON.stringify(message) : message);
      }
    };
    ServiceWorkerClass2.prototype._setupListeners = function() {
      var _this = this;
      this._serviceWorker.addEventListener("statechange", function(event) {
        var currentState = _this._serviceWorker.state;
        _this._logger.debug("ServiceWorker statechange: ".concat(currentState));
        if (Amplify.Analytics && typeof Amplify.Analytics.record === "function") {
          Amplify.Analytics.record({
            name: "ServiceWorker",
            attributes: {
              state: currentState
            }
          });
        }
      });
      this._serviceWorker.addEventListener("message", function(event) {
        _this._logger.debug("ServiceWorker message event: ".concat(event));
      });
    };
    return ServiceWorkerClass2;
  }()
);

// node_modules/universal-cookie/es6/Cookies.js
var cookie2 = __toESM(require_cookie());

// node_modules/universal-cookie/es6/utils.js
var cookie = __toESM(require_cookie());
function hasDocumentCookie() {
  return typeof document === "object" && typeof document.cookie === "string";
}
function parseCookies(cookies, options) {
  if (typeof cookies === "string") {
    return cookie.parse(cookies, options);
  } else if (typeof cookies === "object" && cookies !== null) {
    return cookies;
  } else {
    return {};
  }
}
function isParsingCookie(value, doNotParse) {
  if (typeof doNotParse === "undefined") {
    doNotParse = !value || value[0] !== "{" && value[0] !== "[" && value[0] !== '"';
  }
  return !doNotParse;
}
function readCookie(value, options) {
  if (options === void 0) {
    options = {};
  }
  var cleanValue = cleanupCookieValue(value);
  if (isParsingCookie(cleanValue, options.doNotParse)) {
    try {
      return JSON.parse(cleanValue);
    } catch (e) {
    }
  }
  return value;
}
function cleanupCookieValue(value) {
  if (value && value[0] === "j" && value[1] === ":") {
    return value.substr(2);
  }
  return value;
}

// node_modules/universal-cookie/es6/Cookies.js
var __assign21 = function() {
  __assign21 = Object.assign || function(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign21.apply(this, arguments);
};
var Cookies = (
  /** @class */
  function() {
    function Cookies3(cookies, options) {
      var _this = this;
      this.changeListeners = [];
      this.HAS_DOCUMENT_COOKIE = false;
      this.cookies = parseCookies(cookies, options);
      new Promise(function() {
        _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
      }).catch(function() {
      });
    }
    Cookies3.prototype._updateBrowserValues = function(parseOptions) {
      if (!this.HAS_DOCUMENT_COOKIE) {
        return;
      }
      this.cookies = cookie2.parse(document.cookie, parseOptions);
    };
    Cookies3.prototype._emitChange = function(params) {
      for (var i2 = 0; i2 < this.changeListeners.length; ++i2) {
        this.changeListeners[i2](params);
      }
    };
    Cookies3.prototype.get = function(name, options, parseOptions) {
      if (options === void 0) {
        options = {};
      }
      this._updateBrowserValues(parseOptions);
      return readCookie(this.cookies[name], options);
    };
    Cookies3.prototype.getAll = function(options, parseOptions) {
      if (options === void 0) {
        options = {};
      }
      this._updateBrowserValues(parseOptions);
      var result = {};
      for (var name_1 in this.cookies) {
        result[name_1] = readCookie(this.cookies[name_1], options);
      }
      return result;
    };
    Cookies3.prototype.set = function(name, value, options) {
      var _a2;
      if (typeof value === "object") {
        value = JSON.stringify(value);
      }
      this.cookies = __assign21(__assign21({}, this.cookies), (_a2 = {}, _a2[name] = value, _a2));
      if (this.HAS_DOCUMENT_COOKIE) {
        document.cookie = cookie2.serialize(name, value, options);
      }
      this._emitChange({ name, value, options });
    };
    Cookies3.prototype.remove = function(name, options) {
      var finalOptions = options = __assign21(__assign21({}, options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 });
      this.cookies = __assign21({}, this.cookies);
      delete this.cookies[name];
      if (this.HAS_DOCUMENT_COOKIE) {
        document.cookie = cookie2.serialize(name, "", finalOptions);
      }
      this._emitChange({ name, value: void 0, options });
    };
    Cookies3.prototype.addChangeListener = function(callback) {
      this.changeListeners.push(callback);
    };
    Cookies3.prototype.removeChangeListener = function(callback) {
      var idx = this.changeListeners.indexOf(callback);
      if (idx >= 0) {
        this.changeListeners.splice(idx, 1);
      }
    };
    return Cookies3;
  }()
);
var Cookies_default = Cookies;

// node_modules/universal-cookie/es6/index.js
var es6_default = Cookies_default;

// node_modules/@aws-amplify/core/lib-esm/UniversalStorage/index.js
var __assign22 = function() {
  __assign22 = Object.assign || function(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign22.apply(this, arguments);
};
var isBrowser = browserOrNode().isBrowser;
var ONE_YEAR_IN_MS = 365 * 24 * 60 * 60 * 1e3;
var UniversalStorage = (
  /** @class */
  function() {
    function UniversalStorage2(context) {
      if (context === void 0) {
        context = {};
      }
      this.cookies = new es6_default();
      this.store = isBrowser ? window.localStorage : /* @__PURE__ */ Object.create(null);
      this.cookies = context.req ? new es6_default(context.req.headers.cookie) : new es6_default();
      Object.assign(this.store, this.cookies.getAll());
    }
    Object.defineProperty(UniversalStorage2.prototype, "length", {
      get: function() {
        return Object.entries(this.store).length;
      },
      enumerable: false,
      configurable: true
    });
    UniversalStorage2.prototype.clear = function() {
      var _this = this;
      Array.from(new Array(this.length)).map(function(_2, i2) {
        return _this.key(i2);
      }).forEach(function(key) {
        return _this.removeItem(key);
      });
    };
    UniversalStorage2.prototype.getItem = function(key) {
      return this.getLocalItem(key);
    };
    UniversalStorage2.prototype.getLocalItem = function(key) {
      return Object.prototype.hasOwnProperty.call(this.store, key) ? this.store[key] : null;
    };
    UniversalStorage2.prototype.getUniversalItem = function(key) {
      return this.cookies.get(key);
    };
    UniversalStorage2.prototype.key = function(index) {
      return Object.keys(this.store)[index];
    };
    UniversalStorage2.prototype.removeItem = function(key) {
      this.removeLocalItem(key);
      this.removeUniversalItem(key);
    };
    UniversalStorage2.prototype.removeLocalItem = function(key) {
      delete this.store[key];
    };
    UniversalStorage2.prototype.removeUniversalItem = function(key) {
      this.cookies.remove(key, {
        path: "/"
      });
    };
    UniversalStorage2.prototype.setItem = function(key, value) {
      this.setLocalItem(key, value);
      var tokenType = key.split(".").pop();
      var sessionTokenTypes = [
        "LastAuthUser",
        "accessToken",
        // refreshToken originates on the client, but SSR pages won't fail when this expires
        // Note: the new `accessToken` will also be refreshed on the client (since Amplify doesn't set server-side cookies)
        "refreshToken",
        // Required for CognitoUserSession
        "idToken"
        // userData is used when `Auth.currentAuthenticatedUser({ bypassCache: false })`.
        // Can be persisted to speed up calls to `Auth.currentAuthenticatedUser()`
        // 'userData',
        // Ignoring clockDrift on the server for now, but needs testing
        // 'clockDrift',
      ];
      if (sessionTokenTypes.includes(tokenType !== null && tokenType !== void 0 ? tokenType : "")) {
        this.setUniversalItem(key, value, {
          expires: new Date(Date.now() + ONE_YEAR_IN_MS)
        });
      }
    };
    UniversalStorage2.prototype.setLocalItem = function(key, value) {
      this.store[key] = value;
    };
    UniversalStorage2.prototype.setUniversalItem = function(key, value, options) {
      if (options === void 0) {
        options = {};
      }
      this.cookies.set(key, value, __assign22(__assign22({}, options), {
        path: "/",
        // `httpOnly` cannot be set via JavaScript: https://developer.mozilla.org/en-US/docs/Web/HTTP/Cookies#JavaScript_access_using_Document.cookie
        sameSite: true,
        // Allow unsecure requests to http://localhost:3000/ when in development.
        secure: isBrowser && window.location.hostname === "localhost" ? false : true
      }));
    };
    return UniversalStorage2;
  }()
);

// node_modules/@aws-amplify/core/lib-esm/constants.js
var hasSymbol = typeof Symbol !== "undefined" && typeof Symbol.for === "function";
var INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER = hasSymbol ? Symbol.for("INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER") : "@@INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER";
var USER_AGENT_HEADER = "x-amz-user-agent";

// node_modules/@aws-amplify/core/lib-esm/index.js
var Constants = {
  userAgent: Platform.userAgent
};

// node_modules/@aws-amplify/analytics/node_modules/tslib/tslib.es6.js
var extendStatics3 = function(d2, b2) {
  extendStatics3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b3) {
    d3.__proto__ = b3;
  } || function(d3, b3) {
    for (var p2 in b3)
      if (b3.hasOwnProperty(p2))
        d3[p2] = b3[p2];
  };
  return extendStatics3(d2, b2);
};
function __extends5(d2, b2) {
  extendStatics3(d2, b2);
  function __() {
    this.constructor = d2;
  }
  d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
}
var __assign23 = function() {
  __assign23 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign23.apply(this, arguments);
};
function __rest5(s2, e) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
}
function __awaiter29(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator29(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __read21(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}
function __spread8() {
  for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
    ar = ar.concat(__read21(arguments[i2]));
  return ar;
}

// node_modules/@aws-amplify/cache/node_modules/tslib/tslib.es6.js
var extendStatics4 = function(d2, b2) {
  extendStatics4 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b3) {
    d3.__proto__ = b3;
  } || function(d3, b3) {
    for (var p2 in b3)
      if (b3.hasOwnProperty(p2))
        d3[p2] = b3[p2];
  };
  return extendStatics4(d2, b2);
};
function __extends6(d2, b2) {
  extendStatics4(d2, b2);
  function __() {
    this.constructor = d2;
  }
  d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
}

// node_modules/@aws-amplify/cache/lib-esm/Utils/CacheUtils.js
var defaultConfig2 = {
  keyPrefix: "aws-amplify-cache",
  capacityInBytes: 1048576,
  itemMaxSize: 21e4,
  defaultTTL: 2592e5,
  defaultPriority: 5,
  warningThreshold: 0.8,
  // the storage helper will check if localStorage exists,
  // if not, will use a in-memory object instead
  storage: new StorageHelper().getStorage()
};
function getByteLength(str) {
  var ret = 0;
  ret = str.length;
  for (var i2 = str.length; i2 >= 0; i2 -= 1) {
    var charCode = str.charCodeAt(i2);
    if (charCode > 127 && charCode <= 2047) {
      ret += 1;
    } else if (charCode > 2047 && charCode <= 65535) {
      ret += 2;
    }
    if (charCode >= 56320 && charCode <= 57343) {
      i2 -= 1;
    }
  }
  return ret;
}
function getCurrTime() {
  var currTime = /* @__PURE__ */ new Date();
  return currTime.getTime();
}
function isInteger(value) {
  if (Number.isInteger) {
    return Number.isInteger(value);
  }
  return _isInteger(value);
}
function _isInteger(value) {
  return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
}
var store = {};
var CacheObject = (
  /** @class */
  function() {
    function CacheObject2() {
    }
    CacheObject2.clear = function() {
      store = {};
    };
    CacheObject2.getItem = function(key) {
      return store[key] || null;
    };
    CacheObject2.setItem = function(key, value) {
      store[key] = value;
    };
    CacheObject2.removeItem = function(key) {
      delete store[key];
    };
    return CacheObject2;
  }()
);

// node_modules/@aws-amplify/cache/lib-esm/StorageCache.js
var logger12 = new ConsoleLogger("StorageCache");
var StorageCache = (
  /** @class */
  function() {
    function StorageCache2(config) {
      this.config = Object.assign({}, config);
      this.cacheCurSizeKey = this.config.keyPrefix + "CurSize";
      this.checkConfig();
    }
    StorageCache2.prototype.getModuleName = function() {
      return "Cache";
    };
    StorageCache2.prototype.checkConfig = function() {
      if (!isInteger(this.config.capacityInBytes)) {
        logger12.error("Invalid parameter: capacityInBytes. It should be an Integer. Setting back to default.");
        this.config.capacityInBytes = defaultConfig2.capacityInBytes;
      }
      if (!isInteger(this.config.itemMaxSize)) {
        logger12.error("Invalid parameter: itemMaxSize. It should be an Integer. Setting back to default.");
        this.config.itemMaxSize = defaultConfig2.itemMaxSize;
      }
      if (!isInteger(this.config.defaultTTL)) {
        logger12.error("Invalid parameter: defaultTTL. It should be an Integer. Setting back to default.");
        this.config.defaultTTL = defaultConfig2.defaultTTL;
      }
      if (!isInteger(this.config.defaultPriority)) {
        logger12.error("Invalid parameter: defaultPriority. It should be an Integer. Setting back to default.");
        this.config.defaultPriority = defaultConfig2.defaultPriority;
      }
      if (this.config.itemMaxSize > this.config.capacityInBytes) {
        logger12.error("Invalid parameter: itemMaxSize. It should be smaller than capacityInBytes. Setting back to default.");
        this.config.itemMaxSize = defaultConfig2.itemMaxSize;
      }
      if (this.config.defaultPriority > 5 || this.config.defaultPriority < 1) {
        logger12.error("Invalid parameter: defaultPriority. It should be between 1 and 5. Setting back to default.");
        this.config.defaultPriority = defaultConfig2.defaultPriority;
      }
      if (Number(this.config.warningThreshold) > 1 || Number(this.config.warningThreshold) < 0) {
        logger12.error("Invalid parameter: warningThreshold. It should be between 0 and 1. Setting back to default.");
        this.config.warningThreshold = defaultConfig2.warningThreshold;
      }
      var cacheLimit = 5 * 1024 * 1024;
      if (this.config.capacityInBytes > cacheLimit) {
        logger12.error("Cache Capacity should be less than 5MB. Setting back to default. Setting back to default.");
        this.config.capacityInBytes = defaultConfig2.capacityInBytes;
      }
    };
    StorageCache2.prototype.fillCacheItem = function(key, value, options) {
      var ret = {
        key,
        data: value,
        timestamp: getCurrTime(),
        visitedTime: getCurrTime(),
        priority: options.priority,
        expires: options.expires,
        type: typeof value,
        byteSize: 0
      };
      ret.byteSize = getByteLength(JSON.stringify(ret));
      ret.byteSize = getByteLength(JSON.stringify(ret));
      return ret;
    };
    StorageCache2.prototype.configure = function(config) {
      if (!config) {
        return this.config;
      }
      if (config.keyPrefix) {
        logger12.warn("Don't try to configure keyPrefix!");
      }
      this.config = Object.assign({}, this.config, config, config.Cache);
      this.checkConfig();
      return this.config;
    };
    return StorageCache2;
  }()
);

// node_modules/@aws-amplify/cache/lib-esm/BrowserStorageCache.js
var logger13 = new ConsoleLogger("Cache");
var BrowserStorageCacheClass = (
  /** @class */
  function(_super) {
    __extends6(BrowserStorageCacheClass2, _super);
    function BrowserStorageCacheClass2(config) {
      var _this = this;
      var cacheConfig = config ? Object.assign({}, defaultConfig2, config) : defaultConfig2;
      _this = _super.call(this, cacheConfig) || this;
      _this.config.storage = cacheConfig.storage;
      _this.getItem = _this.getItem.bind(_this);
      _this.setItem = _this.setItem.bind(_this);
      _this.removeItem = _this.removeItem.bind(_this);
      return _this;
    }
    BrowserStorageCacheClass2.prototype._decreaseCurSizeInBytes = function(amount) {
      var curSize = this.getCacheCurSize();
      this.config.storage.setItem(this.cacheCurSizeKey, (curSize - amount).toString());
    };
    BrowserStorageCacheClass2.prototype._increaseCurSizeInBytes = function(amount) {
      var curSize = this.getCacheCurSize();
      this.config.storage.setItem(this.cacheCurSizeKey, (curSize + amount).toString());
    };
    BrowserStorageCacheClass2.prototype._refreshItem = function(item, prefixedKey) {
      item.visitedTime = getCurrTime();
      this.config.storage.setItem(prefixedKey, JSON.stringify(item));
      return item;
    };
    BrowserStorageCacheClass2.prototype._isExpired = function(key) {
      var text = this.config.storage.getItem(key);
      var item = JSON.parse(text);
      if (getCurrTime() >= item.expires) {
        return true;
      }
      return false;
    };
    BrowserStorageCacheClass2.prototype._removeItem = function(prefixedKey, size) {
      var itemSize = size ? size : JSON.parse(this.config.storage.getItem(prefixedKey)).byteSize;
      this._decreaseCurSizeInBytes(itemSize);
      this.config.storage.removeItem(prefixedKey);
    };
    BrowserStorageCacheClass2.prototype._setItem = function(prefixedKey, item) {
      this._increaseCurSizeInBytes(item.byteSize);
      try {
        this.config.storage.setItem(prefixedKey, JSON.stringify(item));
      } catch (setItemErr) {
        this._decreaseCurSizeInBytes(item.byteSize);
        logger13.error("Failed to set item " + setItemErr);
      }
    };
    BrowserStorageCacheClass2.prototype._sizeToPop = function(itemSize) {
      var spaceItemNeed = this.getCacheCurSize() + itemSize - this.config.capacityInBytes;
      var cacheThresholdSpace = (1 - this.config.warningThreshold) * this.config.capacityInBytes;
      return spaceItemNeed > cacheThresholdSpace ? spaceItemNeed : cacheThresholdSpace;
    };
    BrowserStorageCacheClass2.prototype._isCacheFull = function(itemSize) {
      return itemSize + this.getCacheCurSize() > this.config.capacityInBytes;
    };
    BrowserStorageCacheClass2.prototype._findValidKeys = function() {
      var keys = [];
      var keyInCache = [];
      for (var i2 = 0; i2 < this.config.storage.length; i2 += 1) {
        keyInCache.push(this.config.storage.key(i2));
      }
      for (var i2 = 0; i2 < keyInCache.length; i2 += 1) {
        var key = keyInCache[i2];
        if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) {
          if (this._isExpired(key)) {
            this._removeItem(key);
          } else {
            keys.push(key);
          }
        }
      }
      return keys;
    };
    BrowserStorageCacheClass2.prototype._popOutItems = function(keys, sizeToPop) {
      var items = [];
      var remainedSize = sizeToPop;
      for (var i2 = 0; i2 < keys.length; i2 += 1) {
        var val2 = this.config.storage.getItem(keys[i2]);
        if (val2 != null) {
          var item = JSON.parse(val2);
          items.push(item);
        }
      }
      items.sort(function(a2, b2) {
        if (a2.priority > b2.priority) {
          return -1;
        } else if (a2.priority < b2.priority) {
          return 1;
        } else {
          if (a2.visitedTime < b2.visitedTime) {
            return -1;
          } else
            return 1;
        }
      });
      for (var i2 = 0; i2 < items.length; i2 += 1) {
        this._removeItem(items[i2].key, items[i2].byteSize);
        remainedSize -= items[i2].byteSize;
        if (remainedSize <= 0) {
          return;
        }
      }
    };
    BrowserStorageCacheClass2.prototype.setItem = function(key, value, options) {
      logger13.log("Set item: key is " + key + ", value is " + value + " with options: " + options);
      var prefixedKey = this.config.keyPrefix + key;
      if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
        logger13.warn("Invalid key: should not be empty or 'CurSize'");
        return;
      }
      if (typeof value === "undefined") {
        logger13.warn("The value of item should not be undefined!");
        return;
      }
      var cacheItemOptions = {
        priority: options && options.priority !== void 0 ? options.priority : this.config.defaultPriority,
        expires: options && options.expires !== void 0 ? options.expires : this.config.defaultTTL + getCurrTime()
      };
      if (cacheItemOptions.priority < 1 || cacheItemOptions.priority > 5) {
        logger13.warn("Invalid parameter: priority due to out or range. It should be within 1 and 5.");
        return;
      }
      var item = this.fillCacheItem(prefixedKey, value, cacheItemOptions);
      if (item.byteSize > this.config.itemMaxSize) {
        logger13.warn("Item with key: " + key + " you are trying to put into is too big!");
        return;
      }
      try {
        var val2 = this.config.storage.getItem(prefixedKey);
        if (val2) {
          this._removeItem(prefixedKey, JSON.parse(val2).byteSize);
        }
        if (this._isCacheFull(item.byteSize)) {
          var validKeys = this._findValidKeys();
          if (this._isCacheFull(item.byteSize)) {
            var sizeToPop = this._sizeToPop(item.byteSize);
            this._popOutItems(validKeys, sizeToPop);
          }
        }
        this._setItem(prefixedKey, item);
      } catch (e) {
        logger13.warn("setItem failed! " + e);
      }
    };
    BrowserStorageCacheClass2.prototype.getItem = function(key, options) {
      logger13.log("Get item: key is " + key + " with options " + options);
      var ret = null;
      var prefixedKey = this.config.keyPrefix + key;
      if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
        logger13.warn("Invalid key: should not be empty or 'CurSize'");
        return null;
      }
      try {
        ret = this.config.storage.getItem(prefixedKey);
        if (ret != null) {
          if (this._isExpired(prefixedKey)) {
            this._removeItem(prefixedKey, JSON.parse(ret).byteSize);
            ret = null;
          } else {
            var item = JSON.parse(ret);
            item = this._refreshItem(item, prefixedKey);
            return item.data;
          }
        }
        if (options && options.callback !== void 0) {
          var val2 = options.callback();
          if (val2 !== null) {
            this.setItem(key, val2, options);
          }
          return val2;
        }
        return null;
      } catch (e) {
        logger13.warn("getItem failed! " + e);
        return null;
      }
    };
    BrowserStorageCacheClass2.prototype.removeItem = function(key) {
      logger13.log("Remove item: key is " + key);
      var prefixedKey = this.config.keyPrefix + key;
      if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
        return;
      }
      try {
        var val2 = this.config.storage.getItem(prefixedKey);
        if (val2) {
          this._removeItem(prefixedKey, JSON.parse(val2).byteSize);
        }
      } catch (e) {
        logger13.warn("removeItem failed! " + e);
      }
    };
    BrowserStorageCacheClass2.prototype.clear = function() {
      logger13.log("Clear Cache");
      var keysToRemove = [];
      for (var i2 = 0; i2 < this.config.storage.length; i2 += 1) {
        var key = this.config.storage.key(i2);
        if (key.indexOf(this.config.keyPrefix) === 0) {
          keysToRemove.push(key);
        }
      }
      try {
        for (var i2 = 0; i2 < keysToRemove.length; i2 += 1) {
          this.config.storage.removeItem(keysToRemove[i2]);
        }
      } catch (e) {
        logger13.warn("clear failed! " + e);
      }
    };
    BrowserStorageCacheClass2.prototype.getAllKeys = function() {
      var keys = [];
      for (var i2 = 0; i2 < this.config.storage.length; i2 += 1) {
        var key = this.config.storage.key(i2);
        if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) {
          keys.push(key.substring(this.config.keyPrefix.length));
        }
      }
      return keys;
    };
    BrowserStorageCacheClass2.prototype.getCacheCurSize = function() {
      var ret = this.config.storage.getItem(this.cacheCurSizeKey);
      if (!ret) {
        this.config.storage.setItem(this.cacheCurSizeKey, "0");
        ret = "0";
      }
      return Number(ret);
    };
    BrowserStorageCacheClass2.prototype.createInstance = function(config) {
      if (!config.keyPrefix || config.keyPrefix === defaultConfig2.keyPrefix) {
        logger13.error("invalid keyPrefix, setting keyPrefix with timeStamp");
        config.keyPrefix = getCurrTime.toString();
      }
      return new BrowserStorageCacheClass2(config);
    };
    return BrowserStorageCacheClass2;
  }(StorageCache)
);
var BrowserStorageCache = new BrowserStorageCacheClass();
Amplify.register(BrowserStorageCache);

// node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/utils/extendedEncodeURIComponent.js
var extendedEncodeURIComponent2 = function(uri) {
  var extendedCharacters = /[!'()*]/g;
  return encodeURIComponent(uri).replace(extendedCharacters, hexEncode3);
};
var hexEncode3 = function(c2) {
  return "%".concat(c2.charCodeAt(0).toString(16).toUpperCase());
};

// node_modules/@aws-amplify/core/lib-esm/AwsClients/Pinpoint/base.js
var SERVICE_NAME2 = "mobiletargeting";
var endpointResolver2 = function(_a2) {
  var region = _a2.region;
  return {
    url: new URL("https://pinpoint.".concat(region, ".").concat(getDnsSuffix(region)))
  };
};
var defaultConfig3 = {
  service: SERVICE_NAME2,
  endpointResolver: endpointResolver2,
  retryDecider: getRetryDecider(parseJsonError),
  computeDelay: jitteredBackoff2,
  userAgentValue: getAmplifyUserAgent()
};
var getSharedHeaders2 = function() {
  return {
    "content-type": "application/json"
  };
};

// node_modules/@aws-amplify/core/lib-esm/AwsClients/Pinpoint/getInAppMessages.js
var __awaiter30 = function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator30 = function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (g2 && (g2 = 0, op[0] && (_2 = 0)), _2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var getInAppMessagesSerializer = function(_a2, endpoint) {
  var ApplicationId = _a2.ApplicationId, EndpointId = _a2.EndpointId;
  var headers = getSharedHeaders2();
  var url2 = new URL(endpoint.url);
  url2.pathname = "v1/apps/".concat(extendedEncodeURIComponent2(ApplicationId), "/endpoints/").concat(extendedEncodeURIComponent2(EndpointId), "/inappmessages");
  return { method: "GET", headers, url: url2 };
};
var getInAppMessagesDeserializer = function(response) {
  return __awaiter30(void 0, void 0, void 0, function() {
    var error, InAppMessageCampaigns;
    return __generator30(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (!(response.statusCode >= 300))
            return [3, 2];
          return [4, parseJsonError(response)];
        case 1:
          error = _a2.sent();
          throw error;
        case 2:
          return [4, parseJsonBody(response)];
        case 3:
          InAppMessageCampaigns = _a2.sent().InAppMessageCampaigns;
          return [2, {
            InAppMessagesResponse: { InAppMessageCampaigns },
            $metadata: parseMetadata(response)
          }];
      }
    });
  });
};
var getInAppMessages = composeServiceApi(authenticatedHandler, getInAppMessagesSerializer, getInAppMessagesDeserializer, defaultConfig3);

// node_modules/@aws-amplify/core/lib-esm/AwsClients/Pinpoint/putEvents.js
var __awaiter31 = function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator31 = function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (g2 && (g2 = 0, op[0] && (_2 = 0)), _2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var putEventsSerializer = function(_a2, endpoint) {
  var ApplicationId = _a2.ApplicationId, EventsRequest = _a2.EventsRequest;
  var headers = getSharedHeaders2();
  var url2 = new URL(endpoint.url);
  url2.pathname = "v1/apps/".concat(extendedEncodeURIComponent2(ApplicationId), "/events");
  var body = JSON.stringify(EventsRequest !== null && EventsRequest !== void 0 ? EventsRequest : {});
  return { method: "POST", headers, url: url2, body };
};
var putEventsDeserializer = function(response) {
  return __awaiter31(void 0, void 0, void 0, function() {
    var error, Results;
    return __generator31(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (!(response.statusCode >= 300))
            return [3, 2];
          return [4, parseJsonError(response)];
        case 1:
          error = _a2.sent();
          throw error;
        case 2:
          return [4, parseJsonBody(response)];
        case 3:
          Results = _a2.sent().Results;
          return [2, {
            EventsResponse: { Results },
            $metadata: parseMetadata(response)
          }];
      }
    });
  });
};
var putEvents = composeServiceApi(authenticatedHandler, putEventsSerializer, putEventsDeserializer, defaultConfig3);

// node_modules/@aws-amplify/core/lib-esm/AwsClients/Pinpoint/updateEndpoint.js
var __awaiter32 = function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator32 = function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (g2 && (g2 = 0, op[0] && (_2 = 0)), _2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var updateEndpointSerializer = function(_a2, endpoint) {
  var ApplicationId = _a2.ApplicationId, EndpointId = _a2.EndpointId, EndpointRequest = _a2.EndpointRequest;
  var headers = getSharedHeaders2();
  var url2 = new URL(endpoint.url);
  url2.pathname = "v1/apps/".concat(extendedEncodeURIComponent2(ApplicationId), "/endpoints/").concat(extendedEncodeURIComponent2(EndpointId));
  var body = JSON.stringify(EndpointRequest !== null && EndpointRequest !== void 0 ? EndpointRequest : {});
  return { method: "PUT", headers, url: url2, body };
};
var updateEndpointDeserializer = function(response) {
  return __awaiter32(void 0, void 0, void 0, function() {
    var error, _a2, Message, RequestID;
    return __generator32(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          if (!(response.statusCode >= 300))
            return [3, 2];
          return [4, parseJsonError(response)];
        case 1:
          error = _b2.sent();
          throw error;
        case 2:
          return [4, parseJsonBody(response)];
        case 3:
          _a2 = _b2.sent(), Message = _a2.Message, RequestID = _a2.RequestID;
          return [2, {
            MessageBody: {
              Message,
              RequestID
            },
            $metadata: parseMetadata(response)
          }];
      }
    });
  });
};
var updateEndpoint = composeServiceApi(authenticatedHandler, updateEndpointSerializer, updateEndpointDeserializer, defaultConfig3);

// node_modules/@aws-amplify/analytics/lib-esm/Providers/AWSPinpointProvider.js
var import_uuid2 = __toESM(require_uuid2());

// node_modules/@aws-amplify/analytics/lib-esm/utils/UserAgent.js
function getAnalyticsUserAgent(action) {
  return getAmplifyUserAgentObject({
    category: Category.Analytics,
    action
  });
}
function getAnalyticsUserAgentString(action) {
  return getAmplifyUserAgent({
    category: Category.Analytics,
    action
  });
}

// node_modules/@aws-amplify/analytics/lib-esm/utils/AppUtils.js
var isAppInForeground = function() {
  return true;
};

// node_modules/@aws-amplify/analytics/lib-esm/Providers/EventBuffer.js
var logger14 = new ConsoleLogger("EventsBuffer");
var RETRYABLE_CODES = [429, 500];
var ACCEPTED_CODES = [202];
var EventsBuffer = (
  /** @class */
  function() {
    function EventsBuffer2(config) {
      this._pause = false;
      this._flush = false;
      logger14.debug("Instantiating buffer with config:", config);
      this._buffer = [];
      this._config = config;
      this._sendBatch = this._sendBatch.bind(this);
      this._startLoop();
    }
    EventsBuffer2.prototype.push = function(event) {
      var _a2;
      if (this._buffer.length >= this._config.bufferSize) {
        logger14.debug("Exceeded analytics events buffer size");
        return event.handlers.reject(new Error("Exceeded the size of analytics events buffer"));
      }
      var eventId = event.params.event.eventId;
      var bufferElement = (_a2 = {}, _a2[eventId] = event, _a2);
      this._buffer.push(bufferElement);
    };
    EventsBuffer2.prototype.pause = function() {
      this._pause = true;
    };
    EventsBuffer2.prototype.resume = function() {
      this._pause = false;
    };
    EventsBuffer2.prototype.flush = function() {
      this._flush = true;
    };
    EventsBuffer2.prototype._startLoop = function() {
      if (this._interval) {
        clearInterval(this._interval);
      }
      var flushInterval = this._config.flushInterval;
      this._interval = setInterval(this._sendBatch, flushInterval);
    };
    EventsBuffer2.prototype._sendBatch = function() {
      var bufferLength = this._buffer.length;
      if (this._flush && !bufferLength) {
        clearInterval(this._interval);
      }
      if (this._pause || !bufferLength || !isAppInForeground()) {
        return;
      }
      var flushSize = this._config.flushSize;
      var batchSize = Math.min(flushSize, bufferLength);
      var bufferSubset = this._buffer.splice(0, batchSize);
      this._putEvents(bufferSubset);
    };
    EventsBuffer2.prototype._putEvents = function(buffer) {
      return __awaiter29(this, void 0, void 0, function() {
        var eventMap, batchEventParams, _a2, credentials, region, data, err_1;
        return __generator29(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              eventMap = this._bufferToMap(buffer);
              batchEventParams = this._generateBatchEventParams(eventMap);
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 3, , 4]);
              _a2 = this._config, credentials = _a2.credentials, region = _a2.region;
              return [4, putEvents({
                credentials,
                region,
                userAgentValue: getAnalyticsUserAgentString(AnalyticsAction.Record)
              }, batchEventParams)];
            case 2:
              data = _b2.sent();
              this._processPutEventsSuccessResponse(data, eventMap);
              return [3, 4];
            case 3:
              err_1 = _b2.sent();
              return [2, this._handlePutEventsFailure(err_1, eventMap)];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    EventsBuffer2.prototype._generateBatchEventParams = function(eventMap) {
      var batchEventParams = {
        ApplicationId: "",
        EventsRequest: {
          BatchItem: {}
        }
      };
      Object.values(eventMap).forEach(function(item) {
        var params = item.params;
        var event = params.event, timestamp = params.timestamp, config = params.config;
        var name = event.name, attributes = event.attributes, metrics = event.metrics, eventId = event.eventId, session = event.session;
        var appId = config.appId, endpointId = config.endpointId;
        var batchItem = batchEventParams.EventsRequest.BatchItem;
        batchEventParams.ApplicationId = batchEventParams.ApplicationId || appId;
        if (!batchItem[endpointId]) {
          batchItem[endpointId] = {
            Endpoint: {},
            Events: {}
          };
        }
        batchItem[endpointId].Events[eventId] = {
          EventType: name,
          Timestamp: new Date(timestamp).toISOString(),
          Attributes: attributes,
          Metrics: metrics,
          Session: session
        };
      });
      return batchEventParams;
    };
    EventsBuffer2.prototype._handlePutEventsFailure = function(err, eventMap) {
      logger14.debug("_putEvents Failed: ", err);
      var statusCode = err.$metadata && err.$metadata.httpStatusCode;
      if (RETRYABLE_CODES.includes(statusCode)) {
        var retryableEvents = Object.values(eventMap);
        this._retry(retryableEvents);
        return;
      }
    };
    EventsBuffer2.prototype._processPutEventsSuccessResponse = function(data, eventMap) {
      var _a2;
      var _b2 = ((_a2 = data.EventsResponse) !== null && _a2 !== void 0 ? _a2 : {}).Results, Results = _b2 === void 0 ? {} : _b2;
      var retryableEvents = [];
      Object.entries(Results).forEach(function(_a3) {
        var _b3 = __read21(_a3, 2), endpointId = _b3[0], endpointValues = _b3[1];
        var _c;
        var responses = (_c = endpointValues.EventsItemResponse) !== null && _c !== void 0 ? _c : {};
        Object.entries(responses).forEach(function(_a4) {
          var _b4, _c2;
          var _d = __read21(_a4, 2), eventId = _d[0], eventValues = _d[1];
          var eventObject = eventMap[eventId];
          if (!eventObject) {
            return;
          }
          var _e = eventValues !== null && eventValues !== void 0 ? eventValues : {}, StatusCode = _e.StatusCode, Message = _e.Message;
          var response = {
            EventsResponse: {
              Results: (_b4 = {}, _b4[endpointId] = {
                EventsItemResponse: (_c2 = {}, _c2[eventId] = { StatusCode, Message }, _c2)
              }, _b4)
            }
          };
          if (StatusCode && ACCEPTED_CODES.includes(StatusCode)) {
            eventObject.handlers.resolve(response);
            return;
          }
          if (StatusCode && RETRYABLE_CODES.includes(StatusCode)) {
            retryableEvents.push(eventObject);
            return;
          }
          var name = eventObject.params.event.name;
          logger14.error("event " + eventId + " : " + name + " failed with error: " + Message);
          return eventObject.handlers.reject(response);
        });
      });
      if (retryableEvents.length) {
        this._retry(retryableEvents);
      }
    };
    EventsBuffer2.prototype._retry = function(retryableEvents) {
      var _a2;
      var eligibleEvents = [];
      retryableEvents.forEach(function(event) {
        var _a3;
        var params = event.params;
        var _b2 = params.event, eventId = _b2.eventId, name = _b2.name;
        if (params.resendLimit-- > 0) {
          logger14.debug("resending event " + eventId + " : " + name + " with " + params.resendLimit + " retry attempts remaining");
          eligibleEvents.push((_a3 = {}, _a3[eventId] = event, _a3));
          return;
        }
        logger14.debug("no retry attempts remaining for event " + eventId + " : " + name);
      });
      (_a2 = this._buffer).unshift.apply(_a2, __spread8(eligibleEvents));
    };
    EventsBuffer2.prototype._bufferToMap = function(buffer) {
      return buffer.reduce(function(acc, curVal) {
        var _a2 = __read21(Object.entries(curVal), 1), _b2 = __read21(_a2[0], 2), key = _b2[0], value = _b2[1];
        acc[key] = value;
        return acc;
      }, {});
    };
    return EventsBuffer2;
  }()
);
var EventBuffer_default = EventsBuffer;

// node_modules/@aws-amplify/analytics/lib-esm/Providers/AWSPinpointProvider.js
var AMPLIFY_SYMBOL3 = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var dispatchAnalyticsEvent = function(event, data) {
  Hub.dispatch("analytics", { event, data }, "Analytics", AMPLIFY_SYMBOL3);
};
var logger15 = new ConsoleLogger("AWSPinpointProvider");
var RETRYABLE_CODES2 = [429, 500];
var ACCEPTED_CODES2 = [202];
var FORBIDDEN_CODE = 403;
var MOBILE_SERVICE_NAME = "mobiletargeting";
var EXPIRED_TOKEN_CODE = "ExpiredTokenException";
var UPDATE_ENDPOINT = "_update_endpoint";
var SESSION_START = "_session.start";
var SESSION_STOP = "_session.stop";
var BEACON_SUPPORTED = typeof navigator !== "undefined" && navigator && typeof navigator.sendBeacon === "function";
var BUFFER_SIZE = 1e3;
var FLUSH_SIZE = 100;
var FLUSH_INTERVAL = 5 * 1e3;
var RESEND_LIMIT = 5;
var AWSPinpointProvider = (
  /** @class */
  function() {
    function AWSPinpointProvider3(config) {
      this._endpointGenerating = true;
      this._endpointUpdateInProgress = false;
      this._buffer = null;
      this._endpointBuffer = [];
      this._config = config ? config : {};
      this._config.bufferSize = this._config.bufferSize || BUFFER_SIZE;
      this._config.flushSize = this._config.flushSize || FLUSH_SIZE;
      this._config.flushInterval = this._config.flushInterval || FLUSH_INTERVAL;
      this._config.resendLimit = this._config.resendLimit || RESEND_LIMIT;
      this._clientInfo = ClientDevice.clientInfo();
    }
    AWSPinpointProvider3.prototype.getCategory = function() {
      return AWSPinpointProvider3.category;
    };
    AWSPinpointProvider3.prototype.getProviderName = function() {
      return AWSPinpointProvider3.providerName;
    };
    AWSPinpointProvider3.prototype.configure = function(config) {
      var _this = this;
      logger15.debug("configure Analytics", config);
      var conf = config || {};
      this._config = Object.assign({}, this._config, conf);
      this._endpointGenerating = !!config["autoSessionRecord"];
      if (this._config.appId && !this._config.disabled) {
        if (!this._config.endpointId) {
          var cacheKey = this.getProviderName() + "_" + this._config.appId;
          this._getEndpointId(cacheKey).then(function(endpointId) {
            logger15.debug("setting endpoint id from the cache", endpointId);
            _this._config.endpointId = endpointId;
            dispatchAnalyticsEvent("pinpointProvider_configured", null);
          }).catch(function(err) {
            logger15.debug("Failed to generate endpointId", err);
          });
        } else {
          dispatchAnalyticsEvent("pinpointProvider_configured", null);
        }
      } else {
        this._flushBuffer();
      }
      return this._config;
    };
    AWSPinpointProvider3.prototype.record = function(params, handlers) {
      return __awaiter29(this, void 0, void 0, function() {
        var credentials, timestamp;
        return __generator29(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              logger15.debug("_public record", params);
              return [4, this._getCredentials()];
            case 1:
              credentials = _a2.sent();
              if (!credentials || !this._config.appId || !this._config.region) {
                logger15.debug("cannot send events without credentials, applicationId or region");
                return [2, handlers.reject(new Error("No credentials, applicationId or region"))];
              }
              this._init(credentials);
              timestamp = (/* @__PURE__ */ new Date()).getTime();
              this._generateSession(params);
              params.event.eventId = (0, import_uuid2.v1)();
              Object.assign(params, { timestamp, config: this._config });
              if (params.event.immediate) {
                return [2, this._send(params, handlers)];
              } else {
                this._putToBuffer(params, handlers);
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSPinpointProvider3.prototype._sendEndpointUpdate = function(endpointObject) {
      return __awaiter29(this, void 0, void 0, function() {
        var next;
        return __generator29(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (this._endpointUpdateInProgress) {
                this._endpointBuffer.push(endpointObject);
                return [
                  2
                  /*return*/
                ];
              }
              this._endpointUpdateInProgress = true;
              return [4, this._updateEndpoint(endpointObject)];
            case 1:
              _a2.sent();
              next = this._endpointBuffer.shift();
              this._endpointUpdateInProgress = false;
              next && this._sendEndpointUpdate(next);
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSPinpointProvider3.prototype._putToBuffer = function(params, handlers) {
      var _a2;
      if (params.event.name === UPDATE_ENDPOINT) {
        this._sendEndpointUpdate({ params, handlers });
        return;
      }
      (_a2 = this._buffer) === null || _a2 === void 0 ? void 0 : _a2.push({ params, handlers });
    };
    AWSPinpointProvider3.prototype._generateSession = function(params) {
      this._sessionId = this._sessionId || (0, import_uuid2.v1)();
      var event = params.event;
      switch (event.name) {
        case SESSION_START:
          this._sessionStartTimestamp = (/* @__PURE__ */ new Date()).getTime();
          this._sessionId = (0, import_uuid2.v1)();
          event.session = {
            Id: this._sessionId,
            StartTimestamp: new Date(this._sessionStartTimestamp).toISOString()
          };
          break;
        case SESSION_STOP:
          var stopTimestamp = (/* @__PURE__ */ new Date()).getTime();
          this._sessionStartTimestamp = this._sessionStartTimestamp || (/* @__PURE__ */ new Date()).getTime();
          this._sessionId = this._sessionId || (0, import_uuid2.v1)();
          event.session = {
            Id: this._sessionId,
            Duration: stopTimestamp - this._sessionStartTimestamp,
            StartTimestamp: new Date(this._sessionStartTimestamp).toISOString(),
            StopTimestamp: new Date(stopTimestamp).toISOString()
          };
          this._sessionId = void 0;
          this._sessionStartTimestamp = void 0;
          break;
        default:
          this._sessionStartTimestamp = this._sessionStartTimestamp || (/* @__PURE__ */ new Date()).getTime();
          this._sessionId = this._sessionId || (0, import_uuid2.v1)();
          event.session = {
            Id: this._sessionId,
            StartTimestamp: new Date(this._sessionStartTimestamp).toISOString()
          };
      }
    };
    AWSPinpointProvider3.prototype._send = function(params, handlers) {
      return __awaiter29(this, void 0, void 0, function() {
        var event;
        return __generator29(this, function(_a2) {
          event = params.event;
          switch (event.name) {
            case UPDATE_ENDPOINT:
              return [2, this._updateEndpoint({ params, handlers })];
            case SESSION_STOP:
              return [2, this._pinpointSendStopSession(params, handlers)];
            default:
              return [2, this._pinpointPutEvents(params, handlers)];
          }
          return [
            2
            /*return*/
          ];
        });
      });
    };
    AWSPinpointProvider3.prototype._generateBatchItemContext = function(params) {
      var _a2, _b2;
      var event = params.event, timestamp = params.timestamp, config = params.config;
      var name = event.name, attributes = event.attributes, metrics = event.metrics, eventId = event.eventId, session = event.session;
      var appId = config.appId, endpointId = config.endpointId;
      var endpointContext = {};
      return {
        ApplicationId: appId,
        EventsRequest: {
          BatchItem: (_a2 = {}, _a2[endpointId] = {
            Endpoint: endpointContext,
            Events: (_b2 = {}, _b2[eventId] = {
              EventType: name,
              Timestamp: new Date(timestamp).toISOString(),
              Attributes: attributes,
              Metrics: metrics,
              Session: session
            }, _b2)
          }, _a2)
        }
      };
    };
    AWSPinpointProvider3.prototype._pinpointPutEvents = function(params, handlers) {
      var _a2, _b2, _c, _d, _e;
      return __awaiter29(this, void 0, void 0, function() {
        var eventId, endpointId, eventParams, _f, credentials, region, data, _g, StatusCode, Message, err_1;
        return __generator29(this, function(_h) {
          switch (_h.label) {
            case 0:
              eventId = params.event.eventId, endpointId = params.config.endpointId;
              eventParams = this._generateBatchItemContext(params);
              _h.label = 1;
            case 1:
              _h.trys.push([1, 3, , 4]);
              _f = this._config, credentials = _f.credentials, region = _f.region;
              return [4, putEvents({
                credentials,
                region,
                userAgentValue: getAnalyticsUserAgentString(AnalyticsAction.Record)
              }, eventParams)];
            case 2:
              data = _h.sent();
              _g = (_e = (_d = (_c = (_b2 = (_a2 = data.EventsResponse) === null || _a2 === void 0 ? void 0 : _a2.Results) === null || _b2 === void 0 ? void 0 : _b2[endpointId]) === null || _c === void 0 ? void 0 : _c.EventsItemResponse) === null || _d === void 0 ? void 0 : _d[eventId]) !== null && _e !== void 0 ? _e : {}, StatusCode = _g.StatusCode, Message = _g.Message;
              if (StatusCode && ACCEPTED_CODES2.includes(StatusCode)) {
                logger15.debug("record event success. ", data);
                return [2, handlers.resolve(data)];
              } else if (StatusCode && RETRYABLE_CODES2.includes(StatusCode)) {
                this._retry(params, handlers);
              } else {
                logger15.error("Event " + eventId + " is not accepted, the error is " + Message);
                return [2, handlers.reject(data)];
              }
              return [3, 4];
            case 3:
              err_1 = _h.sent();
              this._eventError(err_1);
              return [2, handlers.reject(err_1)];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSPinpointProvider3.prototype._pinpointSendStopSession = function(params, handlers) {
      if (!BEACON_SUPPORTED) {
        this._pinpointPutEvents(params, handlers);
        return;
      }
      var eventParams = this._generateBatchItemContext(params);
      var region = this._config.region;
      var ApplicationId = eventParams.ApplicationId, EventsRequest = eventParams.EventsRequest;
      var accessInfo = {
        secret_key: this._config.credentials.secretAccessKey,
        access_key: this._config.credentials.accessKeyId,
        session_token: this._config.credentials.sessionToken
      };
      var url2 = "https://pinpoint." + region + ".amazonaws.com/v1/apps/" + ApplicationId + "/events/legacy";
      var body = JSON.stringify(EventsRequest);
      var method = "POST";
      var request = {
        url: url2,
        body,
        method
      };
      var serviceInfo = { region, service: MOBILE_SERVICE_NAME };
      var requestUrl = Signer.signUrl(request, accessInfo, serviceInfo);
      var success = navigator.sendBeacon(requestUrl, body);
      if (success) {
        return handlers.resolve("sendBeacon success");
      }
      return handlers.reject("sendBeacon failure");
    };
    AWSPinpointProvider3.prototype._retry = function(params, handlers) {
      var resendLimit = params.config.resendLimit;
      params.resendLimit = typeof params.resendLimit === "number" ? params.resendLimit : resendLimit;
      if (params.resendLimit-- > 0) {
        logger15.debug("resending event " + params.eventName + " with " + params.resendLimit + " retry times left");
        this._pinpointPutEvents(params, handlers);
      } else {
        logger15.debug("retry times used up for event " + params.eventName);
      }
    };
    AWSPinpointProvider3.prototype._updateEndpoint = function(endpointObject) {
      return __awaiter29(this, void 0, void 0, function() {
        var params, handlers, config, event, appId, endpointId, request, update_params, _a2, credentials, region, data, err_2, failureData;
        return __generator29(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              params = endpointObject.params, handlers = endpointObject.handlers;
              config = params.config, event = params.event;
              appId = config.appId, endpointId = config.endpointId;
              request = this._endpointRequest(config, transferKeyToLowerCase(event, [], ["attributes", "userAttributes", "Attributes", "UserAttributes"]));
              update_params = {
                ApplicationId: appId,
                EndpointId: endpointId,
                EndpointRequest: request
              };
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 3, , 4]);
              _a2 = this._config, credentials = _a2.credentials, region = _a2.region;
              return [4, updateEndpoint({
                credentials,
                region,
                userAgentValue: getAnalyticsUserAgentString(AnalyticsAction.UpdateEndpoint)
              }, update_params)];
            case 2:
              data = _b2.sent();
              logger15.debug("updateEndpoint success", data);
              this._endpointGenerating = false;
              this._resumeBuffer();
              handlers.resolve(data);
              return [
                2
                /*return*/
              ];
            case 3:
              err_2 = _b2.sent();
              failureData = {
                err: err_2,
                update_params,
                endpointObject
              };
              return [2, this._handleEndpointUpdateFailure(failureData)];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSPinpointProvider3.prototype._handleEndpointUpdateFailure = function(failureData) {
      return __awaiter29(this, void 0, void 0, function() {
        var err, endpointObject, statusCode, exponential;
        return __generator29(this, function(_a2) {
          err = failureData.err, endpointObject = failureData.endpointObject;
          statusCode = err.$metadata && err.$metadata.httpStatusCode;
          logger15.debug("updateEndpoint error", err);
          switch (statusCode) {
            case FORBIDDEN_CODE:
              return [2, this._handleEndpointUpdateForbidden(failureData)];
            default:
              if (RETRYABLE_CODES2.includes(statusCode)) {
                exponential = true;
                return [2, this._retryEndpointUpdate(endpointObject, exponential)];
              }
              logger15.error("updateEndpoint failed", err);
              endpointObject.handlers.reject(err);
          }
          return [
            2
            /*return*/
          ];
        });
      });
    };
    AWSPinpointProvider3.prototype._handleEndpointUpdateForbidden = function(failureData) {
      var err = failureData.err, endpointObject = failureData.endpointObject;
      var code = err.code, retryable = err.retryable;
      if (code !== EXPIRED_TOKEN_CODE && !retryable) {
        return endpointObject.handlers.reject(err);
      }
      this._retryEndpointUpdate(endpointObject);
    };
    AWSPinpointProvider3.prototype._retryEndpointUpdate = function(endpointObject, exponential) {
      if (exponential === void 0) {
        exponential = false;
      }
      logger15.debug("_retryEndpointUpdate", endpointObject);
      var params = endpointObject.params;
      var resendLimit = params.config.resendLimit;
      params.resendLimit = typeof params.resendLimit === "number" ? params.resendLimit : resendLimit;
      if (params.resendLimit-- > 0) {
        logger15.debug("resending endpoint update " + params.event.eventId + " with " + params.resendLimit + " retry attempts remaining");
        this._endpointBuffer.length ? this._endpointBuffer.unshift(endpointObject) : this._updateEndpoint(endpointObject);
        return;
      }
      logger15.warn("resending endpoint update " + params.event.eventId + " failed after " + params.config.resendLimit + " attempts");
      if (this._endpointGenerating) {
        logger15.error("Initial endpoint update failed. ");
      }
    };
    AWSPinpointProvider3.prototype._init = function(credentials) {
      return __awaiter29(this, void 0, void 0, function() {
        var identityId;
        return __generator29(this, function(_a2) {
          logger15.debug("init provider");
          if (this._config.credentials && this._config.credentials.sessionToken === credentials.sessionToken && this._config.credentials.identityId === credentials.identityId) {
            logger15.debug("no change for aws credentials, directly return from init");
            return [
              2
              /*return*/
            ];
          }
          identityId = this._config.credentials ? this._config.credentials.identityId : null;
          this._config.credentials = credentials;
          if (!this._bufferExists() || identityId !== credentials.identityId) {
            this._initBuffer();
          }
          return [
            2
            /*return*/
          ];
        });
      });
    };
    AWSPinpointProvider3.prototype._bufferExists = function() {
      return this._buffer && this._buffer instanceof EventBuffer_default;
    };
    AWSPinpointProvider3.prototype._initBuffer = function() {
      if (this._bufferExists()) {
        this._flushBuffer();
      }
      this._buffer = new EventBuffer_default(this._config);
      if (this._endpointGenerating) {
        this._buffer.pause();
      }
    };
    AWSPinpointProvider3.prototype._flushBuffer = function() {
      var _a2;
      if (this._bufferExists()) {
        (_a2 = this._buffer) === null || _a2 === void 0 ? void 0 : _a2.flush();
        this._buffer = null;
      }
    };
    AWSPinpointProvider3.prototype._resumeBuffer = function() {
      var _a2;
      if (this._bufferExists()) {
        (_a2 = this._buffer) === null || _a2 === void 0 ? void 0 : _a2.resume();
      }
    };
    AWSPinpointProvider3.prototype._getEndpointId = function(cacheKey) {
      return __awaiter29(this, void 0, void 0, function() {
        var endpointId, ttl, expiration;
        return __generator29(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, BrowserStorageCache.getItem(cacheKey)];
            case 1:
              endpointId = _a2.sent();
              logger15.debug("endpointId from cache", endpointId, "type", typeof endpointId);
              if (!endpointId) {
                endpointId = (0, import_uuid2.v1)();
                ttl = 1e3 * 60 * 60 * 24 * 365 * 100;
                expiration = (/* @__PURE__ */ new Date()).getTime() + ttl;
                BrowserStorageCache.setItem(cacheKey, endpointId, {
                  expires: expiration,
                  priority: 1
                });
              }
              return [2, endpointId];
          }
        });
      });
    };
    AWSPinpointProvider3.prototype._endpointRequest = function(config, event) {
      var credentials = config.credentials;
      var clientInfo2 = this._clientInfo || {};
      var clientContext = config.clientContext || {};
      var defaultEndpointConfig = config.endpoint || {};
      var demographicByClientInfo = {
        appVersion: clientInfo2.appVersion,
        make: clientInfo2.make,
        model: clientInfo2.model,
        modelVersion: clientInfo2.version,
        platform: clientInfo2.platform
      };
      var clientId = clientContext.clientId, appTitle = clientContext.appTitle, appVersionName = clientContext.appVersionName, appVersionCode = clientContext.appVersionCode, appPackageName = clientContext.appPackageName, demographicByClientContext = __rest5(clientContext, ["clientId", "appTitle", "appVersionName", "appVersionCode", "appPackageName"]);
      var channelType = event.address ? clientInfo2.platform === "android" ? "GCM" : "APNS" : void 0;
      var tmp = __assign23(__assign23(__assign23({ channelType, requestId: (0, import_uuid2.v1)(), effectiveDate: (/* @__PURE__ */ new Date()).toISOString() }, defaultEndpointConfig), event), { attributes: __assign23(__assign23({}, defaultEndpointConfig.attributes), event.attributes), demographic: __assign23(__assign23(__assign23(__assign23({}, demographicByClientInfo), demographicByClientContext), defaultEndpointConfig.demographic), event.demographic), location: __assign23(__assign23({}, defaultEndpointConfig.location), event.location), metrics: __assign23(__assign23({}, defaultEndpointConfig.metrics), event.metrics), user: {
        userId: event.userId || defaultEndpointConfig.userId || credentials.identityId,
        userAttributes: __assign23(__assign23({}, defaultEndpointConfig.userAttributes), event.userAttributes)
      } });
      var userId = tmp.userId, userAttributes = tmp.userAttributes, name = tmp.name, session = tmp.session, eventId = tmp.eventId, immediate = tmp.immediate, ret = __rest5(tmp, ["userId", "userAttributes", "name", "session", "eventId", "immediate"]);
      return transferKeyToUpperCase(ret, [], ["metrics", "userAttributes", "attributes"]);
    };
    AWSPinpointProvider3.prototype._eventError = function(err) {
      logger15.error("record event failed.", err);
      logger15.warn('Please ensure you have updated your Pinpoint IAM Policy with the Action: "mobiletargeting:PutEvents" in order to record events');
    };
    AWSPinpointProvider3.prototype._getCredentials = function() {
      return __awaiter29(this, void 0, void 0, function() {
        var credentials, err_3;
        return __generator29(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 2, , 3]);
              return [4, Credentials.get()];
            case 1:
              credentials = _a2.sent();
              if (!credentials)
                return [2, null];
              logger15.debug("set credentials for analytics", credentials);
              return [2, Credentials.shear(credentials)];
            case 2:
              err_3 = _a2.sent();
              logger15.debug("ensure credentials error", err_3);
              return [2, null];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSPinpointProvider3.category = "Analytics";
    AWSPinpointProvider3.providerName = "AWSPinpoint";
    return AWSPinpointProvider3;
  }()
);

// node_modules/@aws-amplify/analytics/lib-esm/utils/MethodEmbed.js
var lists = [];
var MethodEmbed = (
  /** @class */
  function() {
    function MethodEmbed2(context, methodName) {
      this.context = context;
      this.methodName = methodName;
      this._originalMethod = context[methodName].bind(context);
    }
    MethodEmbed2.add = function(context, methodName, methodOverride) {
      getInstance(context, methodName).set(methodOverride);
    };
    MethodEmbed2.remove = function(context, methodName) {
      getInstance(context, methodName).remove();
    };
    MethodEmbed2.prototype.set = function(methodOverride) {
      var _this = this;
      this.context[this.methodName] = function() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        return methodOverride(_this._originalMethod.apply(_this, __spread8(args)));
      };
    };
    MethodEmbed2.prototype.remove = function() {
      this.context[this.methodName] = this._originalMethod;
    };
    return MethodEmbed2;
  }()
);
function getInstance(context, methodName) {
  var instance2 = lists.filter(function(h2) {
    return h2.context === context && h2.methodName === methodName;
  })[0];
  if (!instance2) {
    instance2 = new MethodEmbed(context, methodName);
    lists.push(instance2);
  }
  return instance2;
}

// node_modules/@aws-amplify/analytics/lib-esm/trackers/PageViewTracker.js
var logger16 = new ConsoleLogger("PageViewTracker");
var PREV_URL_KEY = "aws-amplify-analytics-prevUrl";
var getUrl = function() {
  if (!browserOrNode().isBrowser)
    return "";
  else
    return window.location.origin + window.location.pathname;
};
var defaultOpts = {
  enable: false,
  provider: "AWSPinpoint",
  getUrl
};
var PageViewTracker = (
  /** @class */
  function() {
    function PageViewTracker2(tracker, opts) {
      logger16.debug("initialize pageview tracker with opts", opts);
      this._config = Object.assign({}, defaultOpts, opts);
      this._tracker = tracker;
      this._hasEnabled = false;
      this._trackFunc = this._trackFunc.bind(this);
      if (this._config.type === "SPA") {
        this._pageViewTrackSPA();
      } else {
        this._pageViewTrackDefault();
      }
    }
    PageViewTracker2.prototype.configure = function(opts) {
      Object.assign(this._config, opts);
      if (this._config.type === "SPA") {
        this._pageViewTrackSPA();
      }
      return this._config;
    };
    PageViewTracker2.prototype._isSameUrl = function() {
      var prevUrl = sessionStorage.getItem(PREV_URL_KEY);
      var curUrl = this._config.getUrl();
      if (prevUrl === curUrl) {
        logger16.debug("the url is same");
        return true;
      } else
        return false;
    };
    PageViewTracker2.prototype._pageViewTrackDefault = function() {
      return __awaiter29(this, void 0, void 0, function() {
        var url2, customAttrs, _a2, attributes;
        return __generator29(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              if (!browserOrNode().isBrowser || !window.addEventListener || !window.sessionStorage) {
                logger16.debug("not in the supported web enviroment");
                return [
                  2
                  /*return*/
                ];
              }
              url2 = this._config.getUrl();
              if (!(typeof this._config.attributes === "function"))
                return [3, 2];
              return [4, this._config.attributes()];
            case 1:
              _a2 = _b2.sent();
              return [3, 3];
            case 2:
              _a2 = this._config.attributes;
              _b2.label = 3;
            case 3:
              customAttrs = _a2;
              attributes = Object.assign({
                url: url2
              }, customAttrs);
              if (this._config.enable && !this._isSameUrl()) {
                this._tracker({
                  name: this._config.eventName || "pageView",
                  attributes
                }, this._config.provider).catch(function(e) {
                  logger16.debug("Failed to record the page view event", e);
                });
                sessionStorage.setItem(PREV_URL_KEY, url2);
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    PageViewTracker2.prototype._trackFunc = function() {
      return __awaiter29(this, void 0, void 0, function() {
        var url2, customAttrs, _a2, attributes;
        return __generator29(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              if (!browserOrNode().isBrowser || !window.addEventListener || !history.pushState || !window.sessionStorage) {
                logger16.debug("not in the supported web enviroment");
                return [
                  2
                  /*return*/
                ];
              }
              url2 = this._config.getUrl();
              if (!(typeof this._config.attributes === "function"))
                return [3, 2];
              return [4, this._config.attributes()];
            case 1:
              _a2 = _b2.sent();
              return [3, 3];
            case 2:
              _a2 = this._config.attributes;
              _b2.label = 3;
            case 3:
              customAttrs = _a2;
              attributes = Object.assign({
                url: url2
              }, customAttrs);
              if (!this._isSameUrl()) {
                this._tracker({
                  name: this._config.eventName || "pageView",
                  attributes
                }, this._config.provider).catch(function(e) {
                  logger16.debug("Failed to record the page view event", e);
                });
                sessionStorage.setItem(PREV_URL_KEY, url2);
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    PageViewTracker2.prototype._pageViewTrackSPA = function() {
      if (!browserOrNode().isBrowser || !window.addEventListener || !history.pushState) {
        logger16.debug("not in the supported web enviroment");
        return;
      }
      if (this._config.enable && !this._hasEnabled) {
        MethodEmbed.add(history, "pushState", this._trackFunc);
        MethodEmbed.add(history, "replaceState", this._trackFunc);
        window.addEventListener("popstate", this._trackFunc);
        this._trackFunc();
        this._hasEnabled = true;
      } else {
        MethodEmbed.remove(history, "pushState");
        MethodEmbed.remove(history, "replaceState");
        window.removeEventListener("popstate", this._trackFunc);
        this._hasEnabled = false;
      }
    };
    return PageViewTracker2;
  }()
);

// node_modules/@aws-amplify/analytics/lib-esm/vendor/dom-utils/matches.js
var proto = browserOrNode().isBrowser && window["Element"] ? window["Element"].prototype : null;
var nativeMatches = proto ? proto.matches || // @ts-ignore
proto.matchesSelector || // @ts-ignore
proto.webkitMatchesSelector || // @ts-ignore
proto.mozMatchesSelector || // @ts-ignore
proto.msMatchesSelector || // @ts-ignore
proto.oMatchesSelector : null;
function matches(element, test) {
  if (element && element.nodeType === 1 && test) {
    if (typeof test === "string" || test.nodeType === 1) {
      return element === test || matchesSelector(
        element,
        /** @type {string} */
        test
      );
    } else if ("length" in test) {
      for (var i2 = 0, item = void 0; item = test[i2]; i2++) {
        if (element === item || matchesSelector(element, item))
          return true;
      }
    }
  }
  return false;
}
function matchesSelector(element, selector) {
  if (typeof selector !== "string")
    return false;
  if (nativeMatches)
    return nativeMatches.call(element, selector);
  var nodes = element.parentNode.querySelectorAll(selector);
  for (var i2 = 0, node = void 0; node = nodes[i2]; i2++) {
    if (node === element)
      return true;
  }
  return false;
}

// node_modules/@aws-amplify/analytics/lib-esm/vendor/dom-utils/parents.js
function parents(ele) {
  var list = [];
  var element = ele;
  while (element && element.parentNode && element.parentNode.nodeType === 1) {
    element = /** @type {!Element} */
    element.parentNode;
    list.push(element);
  }
  return list;
}

// node_modules/@aws-amplify/analytics/lib-esm/vendor/dom-utils/closest.js
function closest(element, selector, shouldCheckSelf) {
  if (shouldCheckSelf === void 0) {
    shouldCheckSelf = false;
  }
  if (!(element && element.nodeType === 1 && selector))
    return;
  var parentElements = (shouldCheckSelf ? [element] : []).concat(parents(element));
  for (var i2 = 0, parent_1; parent_1 = parentElements[i2]; i2++) {
    if (matches(parent_1, selector))
      return parent_1;
  }
}

// node_modules/@aws-amplify/analytics/lib-esm/vendor/dom-utils/delegate.js
function delegate(ancestor, eventType, selector, callback, opts) {
  if (opts === void 0) {
    opts = {};
  }
  var listener2 = function(event) {
    var delegateTarget;
    if (opts["composed"] && typeof event["composedPath"] === "function") {
      var composedPath = event.composedPath();
      for (var i2 = 0, node = void 0; node = composedPath[i2]; i2++) {
        if (node.nodeType === 1 && matches(node, selector)) {
          delegateTarget = node;
        }
      }
    } else {
      delegateTarget = closest(event.target, selector, true);
    }
    if (delegateTarget) {
      callback.call(delegateTarget, event, delegateTarget);
    }
  };
  ancestor.addEventListener(eventType, listener2, opts["useCapture"]);
  return {
    destroy: function() {
      ancestor.removeEventListener(eventType, listener2, opts["useCapture"]);
    }
  };
}

// node_modules/@aws-amplify/analytics/lib-esm/trackers/EventTracker.js
var logger17 = new ConsoleLogger("EventTracker");
var defaultOpts2 = {
  enable: false,
  events: ["click"],
  selectorPrefix: "data-amplify-analytics-",
  provider: "AWSPinpoint"
};
var EventTracker = (
  /** @class */
  function() {
    function EventTracker2(tracker, opts) {
      if (!browserOrNode().isBrowser || !window.addEventListener) {
        logger17.debug("not in the supported web environment");
        return;
      }
      this._config = Object.assign({}, defaultOpts2, opts);
      this._tracker = tracker;
      this._delegates = {};
      this._trackFunc = this._trackFunc.bind(this);
      logger17.debug("initialize pageview tracker with opts", this._config);
      this.configure(this._config);
    }
    EventTracker2.prototype.configure = function(opts) {
      var _this = this;
      Object.assign(this._config, opts);
      if (!this._config.enable) {
        Object.keys(this._delegates).forEach(function(key) {
          if (typeof _this._delegates[key].destroy === "function")
            _this._delegates[key].destroy();
        });
        this._delegates = {};
      } else if (this._config.enable && Object.keys(this._delegates).length === 0) {
        var selector_1 = "[" + this._config.selectorPrefix + "on]";
        this._config.events.forEach(function(evt) {
          _this._delegates[evt] = delegate(document, evt, selector_1, _this._trackFunc, { composed: true, useCapture: true });
        });
      }
      return this._config;
    };
    EventTracker2.prototype._trackFunc = function(event, element) {
      return __awaiter29(this, void 0, void 0, function() {
        var customAttrs, events3, eventName, attrs, defaultAttrs, _a2, attributes;
        return __generator29(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              customAttrs = {};
              events3 = element.getAttribute(this._config.selectorPrefix + "on").split(/\s*,\s*/);
              eventName = element.getAttribute(this._config.selectorPrefix + "name");
              attrs = element.getAttribute(this._config.selectorPrefix + "attrs");
              if (attrs) {
                attrs.split(/\s*,\s*/).forEach(function(attr) {
                  var tmp = attr.trim().split(/\s*:\s*/);
                  customAttrs[tmp[0]] = tmp[1];
                });
              }
              if (!(typeof this._config.attributes === "function"))
                return [3, 2];
              return [4, this._config.attributes()];
            case 1:
              _a2 = _b2.sent();
              return [3, 3];
            case 2:
              _a2 = this._config.attributes;
              _b2.label = 3;
            case 3:
              defaultAttrs = _a2;
              attributes = Object.assign({
                type: event.type,
                target: event.target.localName + " with id " + event.target.id
              }, defaultAttrs, customAttrs);
              logger17.debug("events needed to be recorded", events3);
              logger17.debug("attributes needed to be attached", customAttrs);
              if (events3.indexOf(event.type) < 0) {
                logger17.debug("event " + event.type + " is not selected to be recorded");
                return [
                  2
                  /*return*/
                ];
              }
              this._tracker({
                name: eventName || "event",
                attributes
              }, this._config.provider).catch(function(e) {
                logger17.debug("Failed to record the " + event.type + " event', " + e);
              });
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    return EventTracker2;
  }()
);

// node_modules/@aws-amplify/analytics/lib-esm/trackers/SessionTracker.js
var logger18 = new ConsoleLogger("SessionTracker");
var defaultOpts3 = {
  enable: false,
  provider: "AWSPinpoint"
};
var initialEventSent = false;
var SessionTracker = (
  /** @class */
  function() {
    function SessionTracker3(tracker, opts) {
      this._config = Object.assign({}, defaultOpts3, opts);
      this._tracker = tracker;
      this._hasEnabled = false;
      this._trackFunc = this._trackFunc.bind(this);
      this._trackBeforeUnload = this._trackBeforeUnload.bind(this);
      this.configure(this._config);
    }
    SessionTracker3.prototype._envCheck = function() {
      if (!browserOrNode().isBrowser) {
        return false;
      }
      if (!document || !document.addEventListener) {
        logger18.debug("not in the supported web environment");
        return false;
      }
      if (typeof document.hidden !== "undefined") {
        this._hidden = "hidden";
        this._visibilityChange = "visibilitychange";
      } else if (typeof document["msHidden"] !== "undefined") {
        this._hidden = "msHidden";
        this._visibilityChange = "msvisibilitychange";
      } else if (typeof document["webkitHidden"] !== "undefined") {
        this._hidden = "webkitHidden";
        this._visibilityChange = "webkitvisibilitychange";
      } else {
        logger18.debug("not in the supported web environment");
        return false;
      }
      return true;
    };
    SessionTracker3.prototype._trackFunc = function() {
      return __awaiter29(this, void 0, void 0, function() {
        var customAttrs, _a2, attributes;
        return __generator29(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              if (!(typeof this._config.attributes === "function"))
                return [3, 2];
              return [4, this._config.attributes()];
            case 1:
              _a2 = _b2.sent();
              return [3, 3];
            case 2:
              _a2 = this._config.attributes;
              _b2.label = 3;
            case 3:
              customAttrs = _a2;
              attributes = Object.assign({}, customAttrs);
              if (document.visibilityState === this._hidden) {
                this._tracker({
                  name: "_session.stop",
                  attributes
                }, this._config.provider).catch(function(e) {
                  logger18.debug("record session stop event failed.", e);
                });
              } else {
                this._tracker({
                  name: "_session.start",
                  attributes
                }, this._config.provider).catch(function(e) {
                  logger18.debug("record session start event failed.", e);
                });
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    SessionTracker3.prototype._trackBeforeUnload = function(event) {
      var _this = this;
      var customAttrs = typeof this._config.attributes === "function" ? Promise.resolve(this._config.attributes()) : Promise.resolve(this._config.attributes);
      customAttrs.then(function(custom) {
        var attributes = Object.assign({}, custom);
        _this._tracker({
          name: "_session.stop",
          attributes,
          immediate: true
        }, _this._config.provider).catch(function(e) {
          logger18.debug("record session stop event failed.", e);
        });
      });
    };
    SessionTracker3.prototype._sendInitialEvent = function() {
      return __awaiter29(this, void 0, void 0, function() {
        var customAttrs, _a2, attributes;
        return __generator29(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              if (initialEventSent) {
                logger18.debug("the start session has been sent when the page is loaded");
                return [
                  2
                  /*return*/
                ];
              } else {
                initialEventSent = true;
              }
              if (!(typeof this._config.attributes === "function"))
                return [3, 2];
              return [4, this._config.attributes()];
            case 1:
              _a2 = _b2.sent();
              return [3, 3];
            case 2:
              _a2 = this._config.attributes;
              _b2.label = 3;
            case 3:
              customAttrs = _a2;
              attributes = Object.assign({}, customAttrs);
              this._tracker({
                name: "_session.start",
                attributes
              }, this._config.provider).catch(function(e) {
                logger18.debug("record session start event failed.", e);
              });
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    SessionTracker3.prototype.configure = function(opts) {
      if (!this._envCheck()) {
        return this._config;
      }
      Object.assign(this._config, opts);
      if (this._config.enable && !this._hasEnabled) {
        this._sendInitialEvent();
        document.addEventListener(this._visibilityChange, this._trackFunc, false);
        window.addEventListener("beforeunload", this._trackBeforeUnload, false);
        this._hasEnabled = true;
      } else if (!this._config.enable && this._hasEnabled) {
        document.removeEventListener(this._visibilityChange, this._trackFunc, false);
        window.removeEventListener("beforeunload", this._trackBeforeUnload, false);
        this._hasEnabled = false;
      }
      return this._config;
    };
    return SessionTracker3;
  }()
);

// node_modules/@aws-amplify/analytics/lib-esm/Analytics.js
var logger19 = new ConsoleLogger("AnalyticsClass");
var AMPLIFY_SYMBOL4 = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var dispatchAnalyticsEvent2 = function(event, data, message) {
  Hub.dispatch("analytics", { event, data, message }, "Analytics", AMPLIFY_SYMBOL4);
};
var trackers = {
  pageView: PageViewTracker,
  event: EventTracker,
  session: SessionTracker
};
var _instance = null;
var AnalyticsClass = (
  /** @class */
  function() {
    function AnalyticsClass2() {
      this._config = {};
      this._pluggables = [];
      this._disabled = false;
      this._trackers = {};
      _instance = this;
      this.record = this.record.bind(this);
      Hub.listen("auth", listener);
      Hub.listen("storage", listener);
      Hub.listen("analytics", listener);
      Hub.listen("core", listener);
    }
    AnalyticsClass2.prototype.getModuleName = function() {
      return "Analytics";
    };
    AnalyticsClass2.prototype.configure = function(config) {
      var _this = this;
      if (!config)
        return this._config;
      logger19.debug("configure Analytics", config);
      var amplifyConfig = parseAWSExports(config);
      this._config = Object.assign({}, this._config, amplifyConfig.Analytics, config);
      if (this._config["disabled"]) {
        this._disabled = true;
      }
      if (this._config["autoSessionRecord"] === void 0) {
        this._config["autoSessionRecord"] = true;
      }
      this._pluggables.forEach(function(pluggable) {
        var providerConfig = pluggable.getProviderName() === "AWSPinpoint" && !_this._config["AWSPinpoint"] ? _this._config : _this._config[pluggable.getProviderName()];
        pluggable.configure(__assign23({ disabled: _this._config["disabled"], autoSessionRecord: _this._config["autoSessionRecord"] }, providerConfig));
      });
      if (this._pluggables.length === 0) {
        this.addPluggable(new AWSPinpointProvider());
      }
      dispatchAnalyticsEvent2("configured", null, "The Analytics category has been configured successfully");
      logger19.debug("current configuration", this._config);
      return this._config;
    };
    AnalyticsClass2.prototype.addPluggable = function(pluggable) {
      if (pluggable && pluggable.getCategory() === "Analytics") {
        this._pluggables.push(pluggable);
        var providerConfig = pluggable.getProviderName() === "AWSPinpoint" && !this._config["AWSPinpoint"] ? this._config : this._config[pluggable.getProviderName()];
        var config = __assign23({ disabled: this._config["disabled"] }, providerConfig);
        pluggable.configure(config);
        return config;
      }
    };
    AnalyticsClass2.prototype.getPluggable = function(providerName) {
      for (var i2 = 0; i2 < this._pluggables.length; i2 += 1) {
        var pluggable = this._pluggables[i2];
        if (pluggable.getProviderName() === providerName) {
          return pluggable;
        }
      }
      logger19.debug("No plugin found with providerName", providerName);
      return null;
    };
    AnalyticsClass2.prototype.removePluggable = function(providerName) {
      var idx = 0;
      while (idx < this._pluggables.length) {
        if (this._pluggables[idx].getProviderName() === providerName) {
          break;
        }
        idx += 1;
      }
      if (idx === this._pluggables.length) {
        logger19.debug("No plugin found with providerName", providerName);
        return;
      } else {
        this._pluggables.splice(idx, idx + 1);
        return;
      }
    };
    AnalyticsClass2.prototype.disable = function() {
      this._disabled = true;
    };
    AnalyticsClass2.prototype.enable = function() {
      this._disabled = false;
    };
    AnalyticsClass2.prototype.startSession = function(provider) {
      return __awaiter29(this, void 0, void 0, function() {
        var event, params;
        return __generator29(this, function(_a2) {
          event = { name: "_session.start" };
          params = { event, provider };
          dispatchAnalyticsEvent2("record", event, "Recording Analytics session start event");
          return [2, this._sendEvent(params)];
        });
      });
    };
    AnalyticsClass2.prototype.stopSession = function(provider) {
      return __awaiter29(this, void 0, void 0, function() {
        var event, params;
        return __generator29(this, function(_a2) {
          event = { name: "_session.stop" };
          params = { event, provider };
          dispatchAnalyticsEvent2("record", event, "Recording Analytics session stop event");
          return [2, this._sendEvent(params)];
        });
      });
    };
    AnalyticsClass2.prototype.record = function(event, provider) {
      return __awaiter29(this, void 0, void 0, function() {
        var params;
        return __generator29(this, function(_a2) {
          params = { event, provider };
          dispatchAnalyticsEvent2("record", params.event, "Recording Analytics event");
          return [2, this._sendEvent(params)];
        });
      });
    };
    AnalyticsClass2.prototype.updateEndpoint = function(attrs, provider) {
      return __awaiter29(this, void 0, void 0, function() {
        var event;
        return __generator29(this, function(_a2) {
          event = __assign23(__assign23({}, attrs), { name: "_update_endpoint" });
          return [2, this.record(event, provider)];
        });
      });
    };
    AnalyticsClass2.prototype._sendEvent = function(params) {
      var _this = this;
      if (this._disabled) {
        logger19.debug("Analytics has been disabled");
        return Promise.resolve();
      }
      var provider = params.provider ? params.provider : "AWSPinpoint";
      return new Promise(function(resolve, reject) {
        _this._pluggables.forEach(function(pluggable) {
          if (pluggable.getProviderName() === provider) {
            pluggable.record(params, { resolve, reject });
          }
        });
      });
    };
    AnalyticsClass2.prototype.autoTrack = function(trackerType, opts) {
      if (!trackers[trackerType]) {
        logger19.debug("invalid tracker type");
        return;
      }
      if (trackerType === "session") {
        this._config["autoSessionRecord"] = opts["enable"];
      }
      var tracker = this._trackers[trackerType];
      if (!tracker) {
        this._trackers[trackerType] = new trackers[trackerType](this.record, opts);
      } else {
        tracker.configure(opts);
      }
    };
    return AnalyticsClass2;
  }()
);
var endpointUpdated = false;
var authConfigured = false;
var analyticsConfigured = false;
var credentialsConfigured = false;
var listener = function(capsule) {
  var channel = capsule.channel, payload = capsule.payload;
  logger19.debug("on hub capsule " + channel, payload);
  switch (channel) {
    case "auth":
      authEvent(payload);
      break;
    case "storage":
      storageEvent(payload);
      break;
    case "analytics":
      analyticsEvent(payload);
      break;
    case "core":
      coreEvent(payload);
      break;
    default:
      break;
  }
};
var storageEvent = function(payload) {
  var _a2 = payload.data, attrs = _a2.attrs, metrics = _a2.metrics;
  if (!attrs)
    return;
  if (analyticsConfigured) {
    _instance.record({
      name: "Storage",
      attributes: attrs,
      metrics
    }).catch(function(e) {
      logger19.debug("Failed to send the storage event automatically", e);
    });
  }
};
var authEvent = function(payload) {
  var event = payload.event;
  if (!event) {
    return;
  }
  var recordAuthEvent = function(eventName) {
    return __awaiter29(void 0, void 0, void 0, function() {
      var err_1;
      return __generator29(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            if (!(authConfigured && analyticsConfigured))
              return [3, 4];
            _a2.label = 1;
          case 1:
            _a2.trys.push([1, 3, , 4]);
            return [4, _instance.record({ name: "_userauth." + eventName })];
          case 2:
            return [2, _a2.sent()];
          case 3:
            err_1 = _a2.sent();
            logger19.debug("Failed to send the " + eventName + " event automatically", err_1);
            return [3, 4];
          case 4:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  };
  switch (event) {
    case "signIn":
      return recordAuthEvent("sign_in");
    case "signUp":
      return recordAuthEvent("sign_up");
    case "signOut":
      return recordAuthEvent("sign_out");
    case "signIn_failure":
      return recordAuthEvent("auth_fail");
    case "configured":
      authConfigured = true;
      if (analyticsConfigured) {
        sendEvents();
      }
      break;
  }
};
var analyticsEvent = function(payload) {
  var event = payload.event;
  if (!event)
    return;
  switch (event) {
    case "pinpointProvider_configured":
      analyticsConfigured = true;
      if (authConfigured || credentialsConfigured) {
        sendEvents();
      }
      break;
  }
};
var coreEvent = function(payload) {
  var event = payload.event;
  if (!event)
    return;
  switch (event) {
    case "credentials_configured":
      credentialsConfigured = true;
      if (analyticsConfigured) {
        sendEvents();
      }
      break;
  }
};
var sendEvents = function() {
  var config = _instance.configure();
  if (!endpointUpdated && config["autoSessionRecord"]) {
    _instance.updateEndpoint({ immediate: true }).catch(function(e) {
      logger19.debug("Failed to update the endpoint", e);
    });
    endpointUpdated = true;
  }
  _instance.autoTrack("session", {
    enable: config["autoSessionRecord"]
  });
};
var Analytics = new AnalyticsClass();
Amplify.register(Analytics);

// node_modules/@aws-sdk/client-kinesis/dist/es/package.json
var package_default2 = {
  name: "@aws-sdk/client-kinesis",
  description: "AWS SDK for JavaScript Kinesis Client for Node.js, Browser and React Native",
  version: "3.6.1",
  scripts: {
    clean: "yarn remove-definitions && yarn remove-dist && yarn remove-documentation",
    "build-documentation": "yarn remove-documentation && typedoc ./",
    prepublishOnly: "yarn build",
    pretest: "yarn build:cjs",
    "remove-definitions": "rimraf ./types",
    "remove-dist": "rimraf ./dist",
    "remove-documentation": "rimraf ./docs",
    test: "exit 0",
    "build:cjs": "tsc -p tsconfig.json",
    "build:es": "tsc -p tsconfig.es.json",
    build: "yarn build:cjs && yarn build:es",
    postbuild: "downlevel-dts types types/ts3.4"
  },
  main: "./dist/cjs/index.js",
  types: "./types/index.d.ts",
  module: "./dist/es/index.js",
  browser: {
    "./runtimeConfig": "./runtimeConfig.browser"
  },
  "react-native": {
    "./runtimeConfig": "./runtimeConfig.native"
  },
  sideEffects: false,
  dependencies: {
    "@aws-crypto/sha256-browser": "^1.0.0",
    "@aws-crypto/sha256-js": "^1.0.0",
    "@aws-sdk/config-resolver": "3.6.1",
    "@aws-sdk/credential-provider-node": "3.6.1",
    "@aws-sdk/eventstream-serde-browser": "3.6.1",
    "@aws-sdk/eventstream-serde-config-resolver": "3.6.1",
    "@aws-sdk/eventstream-serde-node": "3.6.1",
    "@aws-sdk/fetch-http-handler": "3.6.1",
    "@aws-sdk/hash-node": "3.6.1",
    "@aws-sdk/invalid-dependency": "3.6.1",
    "@aws-sdk/middleware-content-length": "3.6.1",
    "@aws-sdk/middleware-host-header": "3.6.1",
    "@aws-sdk/middleware-logger": "3.6.1",
    "@aws-sdk/middleware-retry": "3.6.1",
    "@aws-sdk/middleware-serde": "3.6.1",
    "@aws-sdk/middleware-signing": "3.6.1",
    "@aws-sdk/middleware-stack": "3.6.1",
    "@aws-sdk/middleware-user-agent": "3.6.1",
    "@aws-sdk/node-config-provider": "3.6.1",
    "@aws-sdk/node-http-handler": "3.6.1",
    "@aws-sdk/protocol-http": "3.6.1",
    "@aws-sdk/smithy-client": "3.6.1",
    "@aws-sdk/types": "3.6.1",
    "@aws-sdk/url-parser": "3.6.1",
    "@aws-sdk/url-parser-native": "3.6.1",
    "@aws-sdk/util-base64-browser": "3.6.1",
    "@aws-sdk/util-base64-node": "3.6.1",
    "@aws-sdk/util-body-length-browser": "3.6.1",
    "@aws-sdk/util-body-length-node": "3.6.1",
    "@aws-sdk/util-user-agent-browser": "3.6.1",
    "@aws-sdk/util-user-agent-node": "3.6.1",
    "@aws-sdk/util-utf8-browser": "3.6.1",
    "@aws-sdk/util-utf8-node": "3.6.1",
    "@aws-sdk/util-waiter": "3.6.1",
    tslib: "^2.0.0"
  },
  devDependencies: {
    "@aws-sdk/client-documentation-generator": "3.6.1",
    "@types/node": "^12.7.5",
    "downlevel-dts": "0.7.0",
    jest: "^26.1.0",
    rimraf: "^3.0.0",
    typedoc: "^0.19.2",
    typescript: "~4.1.2"
  },
  engines: {
    node: ">=10.0.0"
  },
  typesVersions: {
    "<4.0": {
      "types/*": [
        "types/ts3.4/*"
      ]
    }
  },
  author: {
    name: "AWS SDK for JavaScript Team",
    url: "https://aws.amazon.com/javascript/"
  },
  license: "Apache-2.0",
  homepage: "https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-kinesis",
  repository: {
    type: "git",
    url: "https://github.com/aws/aws-sdk-js-v3.git",
    directory: "clients/client-kinesis"
  }
};

// node_modules/@aws-sdk/client-kinesis/dist/es/runtimeConfig.browser.js
var import_sha256_browser2 = __toESM(require_build12());

// node_modules/@aws-sdk/eventstream-marshaller/dist/es/EventStreamMarshaller.js
var import_crc322 = __toESM(require_build14());

// node_modules/@aws-sdk/eventstream-marshaller/node_modules/tslib/tslib.es6.js
function __values11(o2) {
  var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
  if (m2)
    return m2.call(o2);
  if (o2 && typeof o2.length === "number")
    return {
      next: function() {
        if (o2 && i2 >= o2.length)
          o2 = void 0;
        return { value: o2 && o2[i2++], done: !o2 };
      }
    };
  throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

// node_modules/@aws-sdk/eventstream-marshaller/dist/es/Int64.js
var Int64 = (
  /** @class */
  function() {
    function Int642(bytes) {
      this.bytes = bytes;
      if (bytes.byteLength !== 8) {
        throw new Error("Int64 buffers must be exactly 8 bytes");
      }
    }
    Int642.fromNumber = function(number) {
      if (number > 9223372036854776e3 || number < -9223372036854776e3) {
        throw new Error(number + " is too large (or, if negative, too small) to represent as an Int64");
      }
      var bytes = new Uint8Array(8);
      for (var i2 = 7, remaining = Math.abs(Math.round(number)); i2 > -1 && remaining > 0; i2--, remaining /= 256) {
        bytes[i2] = remaining;
      }
      if (number < 0) {
        negate(bytes);
      }
      return new Int642(bytes);
    };
    Int642.prototype.valueOf = function() {
      var bytes = this.bytes.slice(0);
      var negative = bytes[0] & 128;
      if (negative) {
        negate(bytes);
      }
      return parseInt(toHex(bytes), 16) * (negative ? -1 : 1);
    };
    Int642.prototype.toString = function() {
      return String(this.valueOf());
    };
    return Int642;
  }()
);
function negate(bytes) {
  for (var i2 = 0; i2 < 8; i2++) {
    bytes[i2] ^= 255;
  }
  for (var i2 = 7; i2 > -1; i2--) {
    bytes[i2]++;
    if (bytes[i2] !== 0)
      break;
  }
}

// node_modules/@aws-sdk/eventstream-marshaller/dist/es/HeaderMarshaller.js
var HeaderMarshaller = (
  /** @class */
  function() {
    function HeaderMarshaller2(toUtf829, fromUtf831) {
      this.toUtf8 = toUtf829;
      this.fromUtf8 = fromUtf831;
    }
    HeaderMarshaller2.prototype.format = function(headers) {
      var e_1, _a2, e_2, _b2;
      var chunks = [];
      try {
        for (var _c = __values11(Object.keys(headers)), _d = _c.next(); !_d.done; _d = _c.next()) {
          var headerName = _d.value;
          var bytes = this.fromUtf8(headerName);
          chunks.push(Uint8Array.from([bytes.byteLength]), bytes, this.formatHeaderValue(headers[headerName]));
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (_d && !_d.done && (_a2 = _c.return))
            _a2.call(_c);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
      var out = new Uint8Array(chunks.reduce(function(carry, bytes2) {
        return carry + bytes2.byteLength;
      }, 0));
      var position = 0;
      try {
        for (var chunks_1 = __values11(chunks), chunks_1_1 = chunks_1.next(); !chunks_1_1.done; chunks_1_1 = chunks_1.next()) {
          var chunk = chunks_1_1.value;
          out.set(chunk, position);
          position += chunk.byteLength;
        }
      } catch (e_2_1) {
        e_2 = { error: e_2_1 };
      } finally {
        try {
          if (chunks_1_1 && !chunks_1_1.done && (_b2 = chunks_1.return))
            _b2.call(chunks_1);
        } finally {
          if (e_2)
            throw e_2.error;
        }
      }
      return out;
    };
    HeaderMarshaller2.prototype.formatHeaderValue = function(header) {
      switch (header.type) {
        case "boolean":
          return Uint8Array.from([
            header.value ? 0 : 1
            /* boolFalse */
          ]);
        case "byte":
          return Uint8Array.from([2, header.value]);
        case "short":
          var shortView = new DataView(new ArrayBuffer(3));
          shortView.setUint8(
            0,
            3
            /* short */
          );
          shortView.setInt16(1, header.value, false);
          return new Uint8Array(shortView.buffer);
        case "integer":
          var intView = new DataView(new ArrayBuffer(5));
          intView.setUint8(
            0,
            4
            /* integer */
          );
          intView.setInt32(1, header.value, false);
          return new Uint8Array(intView.buffer);
        case "long":
          var longBytes = new Uint8Array(9);
          longBytes[0] = 5;
          longBytes.set(header.value.bytes, 1);
          return longBytes;
        case "binary":
          var binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
          binView.setUint8(
            0,
            6
            /* byteArray */
          );
          binView.setUint16(1, header.value.byteLength, false);
          var binBytes = new Uint8Array(binView.buffer);
          binBytes.set(header.value, 3);
          return binBytes;
        case "string":
          var utf8Bytes = this.fromUtf8(header.value);
          var strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
          strView.setUint8(
            0,
            7
            /* string */
          );
          strView.setUint16(1, utf8Bytes.byteLength, false);
          var strBytes = new Uint8Array(strView.buffer);
          strBytes.set(utf8Bytes, 3);
          return strBytes;
        case "timestamp":
          var tsBytes = new Uint8Array(9);
          tsBytes[0] = 8;
          tsBytes.set(Int64.fromNumber(header.value.valueOf()).bytes, 1);
          return tsBytes;
        case "uuid":
          if (!UUID_PATTERN.test(header.value)) {
            throw new Error("Invalid UUID received: " + header.value);
          }
          var uuidBytes = new Uint8Array(17);
          uuidBytes[0] = 9;
          uuidBytes.set(fromHex(header.value.replace(/\-/g, "")), 1);
          return uuidBytes;
      }
    };
    HeaderMarshaller2.prototype.parse = function(headers) {
      var out = {};
      var position = 0;
      while (position < headers.byteLength) {
        var nameLength = headers.getUint8(position++);
        var name = this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, nameLength));
        position += nameLength;
        switch (headers.getUint8(position++)) {
          case 0:
            out[name] = {
              type: BOOLEAN_TAG,
              value: true
            };
            break;
          case 1:
            out[name] = {
              type: BOOLEAN_TAG,
              value: false
            };
            break;
          case 2:
            out[name] = {
              type: BYTE_TAG,
              value: headers.getInt8(position++)
            };
            break;
          case 3:
            out[name] = {
              type: SHORT_TAG,
              value: headers.getInt16(position, false)
            };
            position += 2;
            break;
          case 4:
            out[name] = {
              type: INT_TAG,
              value: headers.getInt32(position, false)
            };
            position += 4;
            break;
          case 5:
            out[name] = {
              type: LONG_TAG,
              value: new Int64(new Uint8Array(headers.buffer, headers.byteOffset + position, 8))
            };
            position += 8;
            break;
          case 6:
            var binaryLength = headers.getUint16(position, false);
            position += 2;
            out[name] = {
              type: BINARY_TAG,
              value: new Uint8Array(headers.buffer, headers.byteOffset + position, binaryLength)
            };
            position += binaryLength;
            break;
          case 7:
            var stringLength = headers.getUint16(position, false);
            position += 2;
            out[name] = {
              type: STRING_TAG,
              value: this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, stringLength))
            };
            position += stringLength;
            break;
          case 8:
            out[name] = {
              type: TIMESTAMP_TAG,
              value: new Date(new Int64(new Uint8Array(headers.buffer, headers.byteOffset + position, 8)).valueOf())
            };
            position += 8;
            break;
          case 9:
            var uuidBytes = new Uint8Array(headers.buffer, headers.byteOffset + position, 16);
            position += 16;
            out[name] = {
              type: UUID_TAG,
              value: toHex(uuidBytes.subarray(0, 4)) + "-" + toHex(uuidBytes.subarray(4, 6)) + "-" + toHex(uuidBytes.subarray(6, 8)) + "-" + toHex(uuidBytes.subarray(8, 10)) + "-" + toHex(uuidBytes.subarray(10))
            };
            break;
          default:
            throw new Error("Unrecognized header type tag");
        }
      }
      return out;
    };
    return HeaderMarshaller2;
  }()
);
var HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE2) {
  HEADER_VALUE_TYPE2[HEADER_VALUE_TYPE2["boolTrue"] = 0] = "boolTrue";
  HEADER_VALUE_TYPE2[HEADER_VALUE_TYPE2["boolFalse"] = 1] = "boolFalse";
  HEADER_VALUE_TYPE2[HEADER_VALUE_TYPE2["byte"] = 2] = "byte";
  HEADER_VALUE_TYPE2[HEADER_VALUE_TYPE2["short"] = 3] = "short";
  HEADER_VALUE_TYPE2[HEADER_VALUE_TYPE2["integer"] = 4] = "integer";
  HEADER_VALUE_TYPE2[HEADER_VALUE_TYPE2["long"] = 5] = "long";
  HEADER_VALUE_TYPE2[HEADER_VALUE_TYPE2["byteArray"] = 6] = "byteArray";
  HEADER_VALUE_TYPE2[HEADER_VALUE_TYPE2["string"] = 7] = "string";
  HEADER_VALUE_TYPE2[HEADER_VALUE_TYPE2["timestamp"] = 8] = "timestamp";
  HEADER_VALUE_TYPE2[HEADER_VALUE_TYPE2["uuid"] = 9] = "uuid";
})(HEADER_VALUE_TYPE || (HEADER_VALUE_TYPE = {}));
var BOOLEAN_TAG = "boolean";
var BYTE_TAG = "byte";
var SHORT_TAG = "short";
var INT_TAG = "integer";
var LONG_TAG = "long";
var BINARY_TAG = "binary";
var STRING_TAG = "string";
var TIMESTAMP_TAG = "timestamp";
var UUID_TAG = "uuid";
var UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;

// node_modules/@aws-sdk/eventstream-marshaller/dist/es/splitMessage.js
var import_crc32 = __toESM(require_build14());
var PRELUDE_MEMBER_LENGTH = 4;
var PRELUDE_LENGTH = PRELUDE_MEMBER_LENGTH * 2;
var CHECKSUM_LENGTH = 4;
var MINIMUM_MESSAGE_LENGTH = PRELUDE_LENGTH + CHECKSUM_LENGTH * 2;
function splitMessage(_a2) {
  var byteLength2 = _a2.byteLength, byteOffset = _a2.byteOffset, buffer = _a2.buffer;
  if (byteLength2 < MINIMUM_MESSAGE_LENGTH) {
    throw new Error("Provided message too short to accommodate event stream message overhead");
  }
  var view = new DataView(buffer, byteOffset, byteLength2);
  var messageLength = view.getUint32(0, false);
  if (byteLength2 !== messageLength) {
    throw new Error("Reported message length does not match received message length");
  }
  var headerLength = view.getUint32(PRELUDE_MEMBER_LENGTH, false);
  var expectedPreludeChecksum = view.getUint32(PRELUDE_LENGTH, false);
  var expectedMessageChecksum = view.getUint32(byteLength2 - CHECKSUM_LENGTH, false);
  var checksummer = new import_crc32.Crc32().update(new Uint8Array(buffer, byteOffset, PRELUDE_LENGTH));
  if (expectedPreludeChecksum !== checksummer.digest()) {
    throw new Error("The prelude checksum specified in the message (" + expectedPreludeChecksum + ") does not match the calculated CRC32 checksum (" + checksummer.digest() + ")");
  }
  checksummer.update(new Uint8Array(buffer, byteOffset + PRELUDE_LENGTH, byteLength2 - (PRELUDE_LENGTH + CHECKSUM_LENGTH)));
  if (expectedMessageChecksum !== checksummer.digest()) {
    throw new Error("The message checksum (" + checksummer.digest() + ") did not match the expected value of " + expectedMessageChecksum);
  }
  return {
    headers: new DataView(buffer, byteOffset + PRELUDE_LENGTH + CHECKSUM_LENGTH, headerLength),
    body: new Uint8Array(buffer, byteOffset + PRELUDE_LENGTH + CHECKSUM_LENGTH + headerLength, messageLength - headerLength - (PRELUDE_LENGTH + CHECKSUM_LENGTH + CHECKSUM_LENGTH))
  };
}

// node_modules/@aws-sdk/eventstream-marshaller/dist/es/EventStreamMarshaller.js
var EventStreamMarshaller = (
  /** @class */
  function() {
    function EventStreamMarshaller4(toUtf829, fromUtf831) {
      this.headerMarshaller = new HeaderMarshaller(toUtf829, fromUtf831);
    }
    EventStreamMarshaller4.prototype.marshall = function(_a2) {
      var rawHeaders = _a2.headers, body = _a2.body;
      var headers = this.headerMarshaller.format(rawHeaders);
      var length = headers.byteLength + body.byteLength + 16;
      var out = new Uint8Array(length);
      var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
      var checksum = new import_crc322.Crc32();
      view.setUint32(0, length, false);
      view.setUint32(4, headers.byteLength, false);
      view.setUint32(8, checksum.update(out.subarray(0, 8)).digest(), false);
      out.set(headers, 12);
      out.set(body, headers.byteLength + 12);
      view.setUint32(length - 4, checksum.update(out.subarray(8, length - 4)).digest(), false);
      return out;
    };
    EventStreamMarshaller4.prototype.unmarshall = function(message) {
      var _a2 = splitMessage(message), headers = _a2.headers, body = _a2.body;
      return { headers: this.headerMarshaller.parse(headers), body };
    };
    EventStreamMarshaller4.prototype.formatHeaders = function(rawHeaders) {
      return this.headerMarshaller.format(rawHeaders);
    };
    return EventStreamMarshaller4;
  }()
);

// node_modules/@aws-sdk/eventstream-serde-universal/node_modules/tslib/tslib.es6.js
function __generator33(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __values12(o2) {
  var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
  if (m2)
    return m2.call(o2);
  if (o2 && typeof o2.length === "number")
    return {
      next: function() {
        if (o2 && i2 >= o2.length)
          o2 = void 0;
        return { value: o2 && o2[i2++], done: !o2 };
      }
    };
  throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __await(v2) {
  return this instanceof __await ? (this.v = v2, this) : new __await(v2);
}
function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
  return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
    return this;
  }, i2;
  function verb(n2) {
    if (g2[n2])
      i2[n2] = function(v2) {
        return new Promise(function(a2, b2) {
          q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
        });
      };
  }
  function resume(n2, v2) {
    try {
      step(g2[n2](v2));
    } catch (e) {
      settle(q2[0][3], e);
    }
  }
  function step(r2) {
    r2.value instanceof __await ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
  }
  function fulfill(value) {
    resume("next", value);
  }
  function reject(value) {
    resume("throw", value);
  }
  function settle(f2, v2) {
    if (f2(v2), q2.shift(), q2.length)
      resume(q2[0][0], q2[0][1]);
  }
}
function __asyncValues2(o2) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var m2 = o2[Symbol.asyncIterator], i2;
  return m2 ? m2.call(o2) : (o2 = typeof __values12 === "function" ? __values12(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
    return this;
  }, i2);
  function verb(n2) {
    i2[n2] = o2[n2] && function(v2) {
      return new Promise(function(resolve, reject) {
        v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
      });
    };
  }
  function settle(resolve, reject, d2, v2) {
    Promise.resolve(v2).then(function(v3) {
      resolve({ value: v3, done: d2 });
    }, reject);
  }
}

// node_modules/@aws-sdk/eventstream-serde-universal/dist/es/getChunkedStream.js
function getChunkedStream(source) {
  var _a2;
  var currentMessageTotalLength = 0;
  var currentMessagePendingLength = 0;
  var currentMessage = null;
  var messageLengthBuffer = null;
  var allocateMessage = function(size) {
    if (typeof size !== "number") {
      throw new Error("Attempted to allocate an event message where size was not a number: " + size);
    }
    currentMessageTotalLength = size;
    currentMessagePendingLength = 4;
    currentMessage = new Uint8Array(size);
    var currentMessageView = new DataView(currentMessage.buffer);
    currentMessageView.setUint32(0, size, false);
  };
  var iterator = function() {
    return __asyncGenerator(this, arguments, function() {
      var sourceIterator, _a3, value, done, chunkLength, currentOffset, bytesRemaining, numBytesForTotal, numBytesToWrite;
      return __generator33(this, function(_b2) {
        switch (_b2.label) {
          case 0:
            sourceIterator = source[Symbol.asyncIterator]();
            _b2.label = 1;
          case 1:
            if (false)
              return [3, 16];
            return [4, __await(sourceIterator.next())];
          case 2:
            _a3 = _b2.sent(), value = _a3.value, done = _a3.done;
            if (!done)
              return [3, 10];
            if (!!currentMessageTotalLength)
              return [3, 4];
            return [4, __await(void 0)];
          case 3:
            return [2, _b2.sent()];
          case 4:
            if (!(currentMessageTotalLength === currentMessagePendingLength))
              return [3, 7];
            return [4, __await(currentMessage)];
          case 5:
            return [4, _b2.sent()];
          case 6:
            _b2.sent();
            return [3, 8];
          case 7:
            throw new Error("Truncated event message received.");
          case 8:
            return [4, __await(void 0)];
          case 9:
            return [2, _b2.sent()];
          case 10:
            chunkLength = value.length;
            currentOffset = 0;
            _b2.label = 11;
          case 11:
            if (!(currentOffset < chunkLength))
              return [3, 15];
            if (!currentMessage) {
              bytesRemaining = chunkLength - currentOffset;
              if (!messageLengthBuffer) {
                messageLengthBuffer = new Uint8Array(4);
              }
              numBytesForTotal = Math.min(
                4 - currentMessagePendingLength,
                // remaining bytes to fill the messageLengthBuffer
                bytesRemaining
                // bytes left in chunk
              );
              messageLengthBuffer.set(
                // @ts-ignore error TS2532: Object is possibly 'undefined' for value
                value.slice(currentOffset, currentOffset + numBytesForTotal),
                currentMessagePendingLength
              );
              currentMessagePendingLength += numBytesForTotal;
              currentOffset += numBytesForTotal;
              if (currentMessagePendingLength < 4) {
                return [3, 15];
              }
              allocateMessage(new DataView(messageLengthBuffer.buffer).getUint32(0, false));
              messageLengthBuffer = null;
            }
            numBytesToWrite = Math.min(
              currentMessageTotalLength - currentMessagePendingLength,
              // number of bytes left to complete message
              chunkLength - currentOffset
              // number of bytes left in the original chunk
            );
            currentMessage.set(
              // @ts-ignore error TS2532: Object is possibly 'undefined' for value
              value.slice(currentOffset, currentOffset + numBytesToWrite),
              currentMessagePendingLength
            );
            currentMessagePendingLength += numBytesToWrite;
            currentOffset += numBytesToWrite;
            if (!(currentMessageTotalLength && currentMessageTotalLength === currentMessagePendingLength))
              return [3, 14];
            return [4, __await(currentMessage)];
          case 12:
            return [4, _b2.sent()];
          case 13:
            _b2.sent();
            currentMessage = null;
            currentMessageTotalLength = 0;
            currentMessagePendingLength = 0;
            _b2.label = 14;
          case 14:
            return [3, 11];
          case 15:
            return [3, 1];
          case 16:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  };
  return _a2 = {}, _a2[Symbol.asyncIterator] = iterator, _a2;
}

// node_modules/@aws-sdk/eventstream-serde-universal/dist/es/getUnmarshalledStream.js
function getUnmarshalledStream(source, options) {
  var _a2;
  return _a2 = {}, _a2[Symbol.asyncIterator] = function() {
    return __asyncGenerator(this, arguments, function() {
      var source_1, source_1_1, chunk, message, messageType, unmodeledError, code, exception, deserializedException, error, event, deserialized, e_1_1;
      var _a3, _b2;
      var e_1, _c;
      return __generator33(this, function(_d) {
        switch (_d.label) {
          case 0:
            _d.trys.push([0, 12, 13, 18]);
            source_1 = __asyncValues2(source);
            _d.label = 1;
          case 1:
            return [4, __await(source_1.next())];
          case 2:
            if (!(source_1_1 = _d.sent(), !source_1_1.done))
              return [3, 11];
            chunk = source_1_1.value;
            message = options.eventMarshaller.unmarshall(chunk);
            messageType = message.headers[":message-type"].value;
            if (!(messageType === "error"))
              return [3, 3];
            unmodeledError = new Error(message.headers[":error-message"].value || "UnknownError");
            unmodeledError.name = message.headers[":error-code"].value;
            throw unmodeledError;
          case 3:
            if (!(messageType === "exception"))
              return [3, 5];
            code = message.headers[":exception-type"].value;
            exception = (_a3 = {}, _a3[code] = message, _a3);
            return [4, __await(options.deserializer(exception))];
          case 4:
            deserializedException = _d.sent();
            if (deserializedException.$unknown) {
              error = new Error(options.toUtf8(message.body));
              error.name = code;
              throw error;
            }
            throw deserializedException[code];
          case 5:
            if (!(messageType === "event"))
              return [3, 9];
            event = (_b2 = {}, _b2[message.headers[":event-type"].value] = message, _b2);
            return [4, __await(options.deserializer(event))];
          case 6:
            deserialized = _d.sent();
            if (deserialized.$unknown)
              return [3, 10];
            return [4, __await(deserialized)];
          case 7:
            return [4, _d.sent()];
          case 8:
            _d.sent();
            return [3, 10];
          case 9:
            throw Error("Unrecognizable event type: " + message.headers[":event-type"].value);
          case 10:
            return [3, 1];
          case 11:
            return [3, 18];
          case 12:
            e_1_1 = _d.sent();
            e_1 = { error: e_1_1 };
            return [3, 18];
          case 13:
            _d.trys.push([13, , 16, 17]);
            if (!(source_1_1 && !source_1_1.done && (_c = source_1.return)))
              return [3, 15];
            return [4, __await(_c.call(source_1))];
          case 14:
            _d.sent();
            _d.label = 15;
          case 15:
            return [3, 17];
          case 16:
            if (e_1)
              throw e_1.error;
            return [
              7
              /*endfinally*/
            ];
          case 17:
            return [
              7
              /*endfinally*/
            ];
          case 18:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, _a2;
}

// node_modules/@aws-sdk/eventstream-serde-universal/dist/es/EventStreamMarshaller.js
var EventStreamMarshaller2 = (
  /** @class */
  function() {
    function EventStreamMarshaller4(_a2) {
      var utf8Encoder = _a2.utf8Encoder, utf8Decoder = _a2.utf8Decoder;
      this.eventMarshaller = new EventStreamMarshaller(utf8Encoder, utf8Decoder);
      this.utfEncoder = utf8Encoder;
    }
    EventStreamMarshaller4.prototype.deserialize = function(body, deserializer) {
      var chunkedStream = getChunkedStream(body);
      var unmarshalledStream = getUnmarshalledStream(chunkedStream, {
        eventMarshaller: this.eventMarshaller,
        deserializer,
        toUtf8: this.utfEncoder
      });
      return unmarshalledStream;
    };
    EventStreamMarshaller4.prototype.serialize = function(input, serializer) {
      var _a2;
      var self2 = this;
      var serializedIterator = function() {
        return __asyncGenerator(this, arguments, function() {
          var input_1, input_1_1, chunk, payloadBuf, e_1_1;
          var e_1, _a3;
          return __generator33(this, function(_b2) {
            switch (_b2.label) {
              case 0:
                _b2.trys.push([0, 7, 8, 13]);
                input_1 = __asyncValues2(input);
                _b2.label = 1;
              case 1:
                return [4, __await(input_1.next())];
              case 2:
                if (!(input_1_1 = _b2.sent(), !input_1_1.done))
                  return [3, 6];
                chunk = input_1_1.value;
                payloadBuf = self2.eventMarshaller.marshall(serializer(chunk));
                return [4, __await(payloadBuf)];
              case 3:
                return [4, _b2.sent()];
              case 4:
                _b2.sent();
                _b2.label = 5;
              case 5:
                return [3, 1];
              case 6:
                return [3, 13];
              case 7:
                e_1_1 = _b2.sent();
                e_1 = { error: e_1_1 };
                return [3, 13];
              case 8:
                _b2.trys.push([8, , 11, 12]);
                if (!(input_1_1 && !input_1_1.done && (_a3 = input_1.return)))
                  return [3, 10];
                return [4, __await(_a3.call(input_1))];
              case 9:
                _b2.sent();
                _b2.label = 10;
              case 10:
                return [3, 12];
              case 11:
                if (e_1)
                  throw e_1.error;
                return [
                  7
                  /*endfinally*/
                ];
              case 12:
                return [
                  7
                  /*endfinally*/
                ];
              case 13:
                return [4, __await(new Uint8Array(0))];
              case 14:
                return [4, _b2.sent()];
              case 15:
                _b2.sent();
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      return _a2 = {}, _a2[Symbol.asyncIterator] = serializedIterator, _a2;
    };
    return EventStreamMarshaller4;
  }()
);

// node_modules/@aws-sdk/eventstream-serde-browser/node_modules/tslib/tslib.es6.js
function __awaiter33(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator34(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __await2(v2) {
  return this instanceof __await2 ? (this.v = v2, this) : new __await2(v2);
}
function __asyncGenerator2(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
  return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
    return this;
  }, i2;
  function verb(n2) {
    if (g2[n2])
      i2[n2] = function(v2) {
        return new Promise(function(a2, b2) {
          q2.push([n2, v2, a2, b2]) > 1 || resume(n2, v2);
        });
      };
  }
  function resume(n2, v2) {
    try {
      step(g2[n2](v2));
    } catch (e) {
      settle(q2[0][3], e);
    }
  }
  function step(r2) {
    r2.value instanceof __await2 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
  }
  function fulfill(value) {
    resume("next", value);
  }
  function reject(value) {
    resume("throw", value);
  }
  function settle(f2, v2) {
    if (f2(v2), q2.shift(), q2.length)
      resume(q2[0][0], q2[0][1]);
  }
}

// node_modules/@aws-sdk/eventstream-serde-browser/dist/es/utils.js
var readableStreamtoIterable = function(readableStream) {
  var _a2;
  return _a2 = {}, _a2[Symbol.asyncIterator] = function() {
    return __asyncGenerator2(this, arguments, function() {
      var reader, _a3, done, value;
      return __generator34(this, function(_b2) {
        switch (_b2.label) {
          case 0:
            reader = readableStream.getReader();
            _b2.label = 1;
          case 1:
            _b2.trys.push([1, , 9, 10]);
            _b2.label = 2;
          case 2:
            if (false)
              return [3, 8];
            return [4, __await2(reader.read())];
          case 3:
            _a3 = _b2.sent(), done = _a3.done, value = _a3.value;
            if (!done)
              return [3, 5];
            return [4, __await2(void 0)];
          case 4:
            return [2, _b2.sent()];
          case 5:
            return [4, __await2(value)];
          case 6:
            return [4, _b2.sent()];
          case 7:
            _b2.sent();
            return [3, 2];
          case 8:
            return [3, 10];
          case 9:
            reader.releaseLock();
            return [
              7
              /*endfinally*/
            ];
          case 10:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, _a2;
};
var iterableToReadableStream = function(asyncIterable) {
  var iterator = asyncIterable[Symbol.asyncIterator]();
  return new ReadableStream({
    pull: function(controller) {
      return __awaiter33(this, void 0, void 0, function() {
        var _a2, done, value;
        return __generator34(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              return [4, iterator.next()];
            case 1:
              _a2 = _b2.sent(), done = _a2.done, value = _a2.value;
              if (done) {
                return [2, controller.close()];
              }
              controller.enqueue(value);
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }
  });
};

// node_modules/@aws-sdk/eventstream-serde-browser/dist/es/EventStreamMarshaller.js
var EventStreamMarshaller3 = (
  /** @class */
  function() {
    function EventStreamMarshaller4(_a2) {
      var utf8Encoder = _a2.utf8Encoder, utf8Decoder = _a2.utf8Decoder;
      this.eventMarshaller = new EventStreamMarshaller(utf8Encoder, utf8Decoder);
      this.universalMarshaller = new EventStreamMarshaller2({
        utf8Decoder,
        utf8Encoder
      });
    }
    EventStreamMarshaller4.prototype.deserialize = function(body, deserializer) {
      var bodyIterable = isReadableStream(body) ? readableStreamtoIterable(body) : body;
      return this.universalMarshaller.deserialize(bodyIterable, deserializer);
    };
    EventStreamMarshaller4.prototype.serialize = function(input, serializer) {
      var serialziedIterable = this.universalMarshaller.serialize(input, serializer);
      return typeof ReadableStream === "function" ? iterableToReadableStream(serialziedIterable) : serialziedIterable;
    };
    return EventStreamMarshaller4;
  }()
);
var isReadableStream = function(body) {
  return typeof ReadableStream === "function" && body instanceof ReadableStream;
};

// node_modules/@aws-sdk/eventstream-serde-browser/dist/es/provider.js
var eventStreamSerdeProvider = function(options) {
  return new EventStreamMarshaller3(options);
};

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-sdk/util-user-agent-browser/node_modules/tslib/tslib.es6.js
function __awaiter34(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator35(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-sdk/util-user-agent-browser/dist/es/index.js
var defaultUserAgent2 = function(_a2) {
  var serviceId = _a2.serviceId, clientVersion = _a2.clientVersion;
  return function() {
    return __awaiter34(void 0, void 0, void 0, function() {
      var parsedUA, sections;
      var _a3, _b2, _c, _d, _e, _f, _g;
      return __generator35(this, function(_h) {
        parsedUA = ((_a3 = window === null || window === void 0 ? void 0 : window.navigator) === null || _a3 === void 0 ? void 0 : _a3.userAgent) ? bowser_default.parse(window.navigator.userAgent) : void 0;
        sections = [
          // sdk-metadata
          ["aws-sdk-js", clientVersion],
          // os-metadata
          ["os/" + (((_b2 = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b2 === void 0 ? void 0 : _b2.name) || "other"), (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version],
          // language-metadata
          // ECMAScript edition doesn't matter in JS.
          ["lang/js"],
          // browser vendor and version.
          ["md/browser", ((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown") + "_" + ((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")]
        ];
        if (serviceId) {
          sections.push(["api/" + serviceId, clientVersion]);
        }
        return [2, sections];
      });
    });
  };
};

// node_modules/@aws-sdk/client-kinesis/dist/es/runtimeConfig.browser.js
init_es2();

// node_modules/@aws-sdk/client-kinesis/dist/es/endpoints.js
var AWS_TEMPLATE2 = "kinesis.{region}.amazonaws.com";
var AWS_CN_TEMPLATE2 = "kinesis.{region}.amazonaws.com.cn";
var AWS_ISO_TEMPLATE2 = "kinesis.{region}.c2s.ic.gov";
var AWS_ISO_B_TEMPLATE2 = "kinesis.{region}.sc2s.sgov.gov";
var AWS_US_GOV_TEMPLATE2 = "kinesis.{region}.amazonaws.com";
var AWS_REGIONS2 = /* @__PURE__ */ new Set([
  "af-south-1",
  "ap-east-1",
  "ap-northeast-1",
  "ap-northeast-2",
  "ap-south-1",
  "ap-southeast-1",
  "ap-southeast-2",
  "ca-central-1",
  "eu-central-1",
  "eu-north-1",
  "eu-south-1",
  "eu-west-1",
  "eu-west-2",
  "eu-west-3",
  "me-south-1",
  "sa-east-1",
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2"
]);
var AWS_CN_REGIONS2 = /* @__PURE__ */ new Set(["cn-north-1", "cn-northwest-1"]);
var AWS_ISO_REGIONS2 = /* @__PURE__ */ new Set(["us-iso-east-1"]);
var AWS_ISO_B_REGIONS2 = /* @__PURE__ */ new Set(["us-isob-east-1"]);
var AWS_US_GOV_REGIONS2 = /* @__PURE__ */ new Set(["us-gov-east-1", "us-gov-west-1"]);
var defaultRegionInfoProvider2 = function(region, options) {
  var regionInfo = void 0;
  switch (region) {
    case "af-south-1":
      regionInfo = {
        hostname: "kinesis.af-south-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-east-1":
      regionInfo = {
        hostname: "kinesis.ap-east-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-northeast-1":
      regionInfo = {
        hostname: "kinesis.ap-northeast-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-northeast-2":
      regionInfo = {
        hostname: "kinesis.ap-northeast-2.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-south-1":
      regionInfo = {
        hostname: "kinesis.ap-south-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-southeast-1":
      regionInfo = {
        hostname: "kinesis.ap-southeast-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-southeast-2":
      regionInfo = {
        hostname: "kinesis.ap-southeast-2.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ca-central-1":
      regionInfo = {
        hostname: "kinesis.ca-central-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "cn-north-1":
      regionInfo = {
        hostname: "kinesis.cn-north-1.amazonaws.com.cn",
        partition: "aws-cn"
      };
      break;
    case "cn-northwest-1":
      regionInfo = {
        hostname: "kinesis.cn-northwest-1.amazonaws.com.cn",
        partition: "aws-cn"
      };
      break;
    case "eu-central-1":
      regionInfo = {
        hostname: "kinesis.eu-central-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "eu-north-1":
      regionInfo = {
        hostname: "kinesis.eu-north-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "eu-south-1":
      regionInfo = {
        hostname: "kinesis.eu-south-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "eu-west-1":
      regionInfo = {
        hostname: "kinesis.eu-west-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "eu-west-2":
      regionInfo = {
        hostname: "kinesis.eu-west-2.amazonaws.com",
        partition: "aws"
      };
      break;
    case "eu-west-3":
      regionInfo = {
        hostname: "kinesis.eu-west-3.amazonaws.com",
        partition: "aws"
      };
      break;
    case "fips-us-east-1":
      regionInfo = {
        hostname: "kinesis-fips.us-east-1.amazonaws.com",
        partition: "aws",
        signingRegion: "us-east-1"
      };
      break;
    case "fips-us-east-2":
      regionInfo = {
        hostname: "kinesis-fips.us-east-2.amazonaws.com",
        partition: "aws",
        signingRegion: "us-east-2"
      };
      break;
    case "fips-us-west-1":
      regionInfo = {
        hostname: "kinesis-fips.us-west-1.amazonaws.com",
        partition: "aws",
        signingRegion: "us-west-1"
      };
      break;
    case "fips-us-west-2":
      regionInfo = {
        hostname: "kinesis-fips.us-west-2.amazonaws.com",
        partition: "aws",
        signingRegion: "us-west-2"
      };
      break;
    case "me-south-1":
      regionInfo = {
        hostname: "kinesis.me-south-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "sa-east-1":
      regionInfo = {
        hostname: "kinesis.sa-east-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "us-east-1":
      regionInfo = {
        hostname: "kinesis.us-east-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "us-east-2":
      regionInfo = {
        hostname: "kinesis.us-east-2.amazonaws.com",
        partition: "aws"
      };
      break;
    case "us-gov-east-1":
      regionInfo = {
        hostname: "kinesis.us-gov-east-1.amazonaws.com",
        partition: "aws-us-gov",
        signingRegion: "us-gov-east-1"
      };
      break;
    case "us-gov-west-1":
      regionInfo = {
        hostname: "kinesis.us-gov-west-1.amazonaws.com",
        partition: "aws-us-gov",
        signingRegion: "us-gov-west-1"
      };
      break;
    case "us-iso-east-1":
      regionInfo = {
        hostname: "kinesis.us-iso-east-1.c2s.ic.gov",
        partition: "aws-iso"
      };
      break;
    case "us-isob-east-1":
      regionInfo = {
        hostname: "kinesis.us-isob-east-1.sc2s.sgov.gov",
        partition: "aws-iso-b"
      };
      break;
    case "us-west-1":
      regionInfo = {
        hostname: "kinesis.us-west-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "us-west-2":
      regionInfo = {
        hostname: "kinesis.us-west-2.amazonaws.com",
        partition: "aws"
      };
      break;
    default:
      if (AWS_REGIONS2.has(region)) {
        regionInfo = {
          hostname: AWS_TEMPLATE2.replace("{region}", region),
          partition: "aws"
        };
      }
      if (AWS_CN_REGIONS2.has(region)) {
        regionInfo = {
          hostname: AWS_CN_TEMPLATE2.replace("{region}", region),
          partition: "aws-cn"
        };
      }
      if (AWS_ISO_REGIONS2.has(region)) {
        regionInfo = {
          hostname: AWS_ISO_TEMPLATE2.replace("{region}", region),
          partition: "aws-iso"
        };
      }
      if (AWS_ISO_B_REGIONS2.has(region)) {
        regionInfo = {
          hostname: AWS_ISO_B_TEMPLATE2.replace("{region}", region),
          partition: "aws-iso-b"
        };
      }
      if (AWS_US_GOV_REGIONS2.has(region)) {
        regionInfo = {
          hostname: AWS_US_GOV_TEMPLATE2.replace("{region}", region),
          partition: "aws-us-gov"
        };
      }
      if (regionInfo === void 0) {
        regionInfo = {
          hostname: AWS_TEMPLATE2.replace("{region}", region),
          partition: "aws"
        };
      }
  }
  return Promise.resolve(__assign7({ signingService: "kinesis" }, regionInfo));
};

// node_modules/@aws-sdk/client-kinesis/dist/es/runtimeConfig.shared.js
var ClientSharedValues2 = {
  apiVersion: "2013-12-02",
  disableHostPrefix: false,
  logger: {},
  regionInfoProvider: defaultRegionInfoProvider2,
  serviceId: "Kinesis",
  urlParser: parseUrl
};

// node_modules/@aws-sdk/client-kinesis/dist/es/runtimeConfig.browser.js
var ClientDefaultValues2 = __assign7(__assign7({}, ClientSharedValues2), { runtime: "browser", base64Decoder: fromBase64, base64Encoder: toBase64, bodyLengthChecker: calculateBodyLength, credentialDefaultProvider: function(_2) {
  return function() {
    return Promise.reject(new Error("Credential is missing"));
  };
}, defaultUserAgentProvider: defaultUserAgent2({
  serviceId: ClientSharedValues2.serviceId,
  clientVersion: package_default2.version
}), eventStreamSerdeProvider, maxAttempts: DEFAULT_MAX_ATTEMPTS, region: invalidProvider("Region is missing"), requestHandler: new FetchHttpHandler(), sha256: import_sha256_browser2.Sha256, streamCollector, utf8Decoder: fromUtf89, utf8Encoder: toUtf89 });

// node_modules/@aws-sdk/eventstream-serde-config-resolver/node_modules/tslib/tslib.es6.js
var __assign24 = function() {
  __assign24 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign24.apply(this, arguments);
};

// node_modules/@aws-sdk/eventstream-serde-config-resolver/dist/es/EventStreamSerdeConfig.js
var resolveEventStreamSerdeConfig = function(input) {
  return __assign24(__assign24({}, input), { eventStreamMarshaller: input.eventStreamSerdeProvider(input) });
};

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-sdk/middleware-host-header/node_modules/tslib/tslib.es6.js
function __awaiter35(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator36(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-sdk/middleware-host-header/dist/es/index.js
function resolveHostHeaderConfig2(input) {
  return input;
}
var hostHeaderMiddleware2 = function(options) {
  return function(next) {
    return function(args) {
      return __awaiter35(void 0, void 0, void 0, function() {
        var request, _a2, handlerProtocol;
        return __generator36(this, function(_b2) {
          if (!HttpRequest.isInstance(args.request))
            return [2, next(args)];
          request = args.request;
          _a2 = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a2 === void 0 ? "" : _a2;
          if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
            delete request.headers["host"];
            request.headers[":authority"] = "";
          } else if (!request.headers["host"]) {
            request.headers["host"] = request.hostname;
          }
          return [2, next(args)];
        });
      });
    };
  };
};
var hostHeaderMiddlewareOptions2 = {
  name: "hostHeaderMiddleware",
  step: "build",
  priority: "low",
  tags: ["HOST"],
  override: true
};
var getHostHeaderPlugin2 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(hostHeaderMiddleware2(options), hostHeaderMiddlewareOptions2);
    }
  };
};

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-sdk/middleware-logger/node_modules/tslib/tslib.es6.js
function __rest6(s2, e) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
}
function __awaiter36(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator37(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-sdk/middleware-logger/dist/es/loggerMiddleware.js
var loggerMiddleware2 = function() {
  return function(next, context) {
    return function(args) {
      return __awaiter36(void 0, void 0, void 0, function() {
        var clientName, commandName, inputFilterSensitiveLog, logger64, outputFilterSensitiveLog, response, _a2, $metadata, outputWithoutMetadata;
        return __generator37(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger64 = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
              return [4, next(args)];
            case 1:
              response = _b2.sent();
              if (!logger64) {
                return [2, response];
              }
              if (typeof logger64.info === "function") {
                _a2 = response.output, $metadata = _a2.$metadata, outputWithoutMetadata = __rest6(_a2, ["$metadata"]);
                logger64.info({
                  clientName,
                  commandName,
                  input: inputFilterSensitiveLog(args.input),
                  output: outputFilterSensitiveLog(outputWithoutMetadata),
                  metadata: $metadata
                });
              }
              return [2, response];
          }
        });
      });
    };
  };
};
var loggerMiddlewareOptions2 = {
  name: "loggerMiddleware",
  tags: ["LOGGER"],
  step: "initialize",
  override: true
};
var getLoggerPlugin2 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(loggerMiddleware2(), loggerMiddlewareOptions2);
    }
  };
};

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-sdk/middleware-signing/node_modules/tslib/tslib.es6.js
var __assign25 = function() {
  __assign25 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign25.apply(this, arguments);
};
function __awaiter37(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator38(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __read22(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-sdk/middleware-signing/dist/es/configurations.js
function resolveAwsAuthConfig2(input) {
  var _this = this;
  var credentials = input.credentials || input.credentialDefaultProvider(input);
  var normalizedCreds = normalizeProvider2(credentials);
  var _a2 = input.signingEscapePath, signingEscapePath = _a2 === void 0 ? true : _a2, _b2 = input.systemClockOffset, systemClockOffset = _b2 === void 0 ? input.systemClockOffset || 0 : _b2, sha256 = input.sha256;
  var signer;
  if (input.signer) {
    signer = normalizeProvider2(input.signer);
  } else {
    signer = function() {
      return normalizeProvider2(input.region)().then(function(region) {
        return __awaiter37(_this, void 0, void 0, function() {
          return __generator38(this, function(_a3) {
            switch (_a3.label) {
              case 0:
                return [4, input.regionInfoProvider(region)];
              case 1:
                return [2, [_a3.sent() || {}, region]];
            }
          });
        });
      }).then(function(_a3) {
        var _b3 = __read22(_a3, 2), regionInfo = _b3[0], region = _b3[1];
        var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
        input.signingRegion = input.signingRegion || signingRegion || region;
        input.signingName = input.signingName || signingService || input.serviceId;
        return new SignatureV4({
          credentials: normalizedCreds,
          region: input.signingRegion,
          service: input.signingName,
          sha256,
          uriEscapePath: signingEscapePath
        });
      });
    };
  }
  return __assign25(__assign25({}, input), {
    systemClockOffset,
    signingEscapePath,
    credentials: normalizedCreds,
    signer
  });
}
function normalizeProvider2(input) {
  if (typeof input === "object") {
    var promisified_1 = Promise.resolve(input);
    return function() {
      return promisified_1;
    };
  }
  return input;
}

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-sdk/middleware-signing/dist/es/middleware.js
var isClockSkewed3 = function(newServerTime, systemClockOffset) {
  return Math.abs(getSkewCorrectedDate3(systemClockOffset).getTime() - newServerTime) >= 3e5;
};
var getSkewCorrectedDate3 = function(systemClockOffset) {
  return new Date(Date.now() + systemClockOffset);
};
function awsAuthMiddleware2(options) {
  return function(next, context) {
    return function(args) {
      return __awaiter37(this, void 0, void 0, function() {
        var signer, _a2, output, _b2, _c, headers, dateHeader, serverTime;
        var _d;
        return __generator38(this, function(_e) {
          switch (_e.label) {
            case 0:
              if (!HttpRequest.isInstance(args.request))
                return [2, next(args)];
              if (!(typeof options.signer === "function"))
                return [3, 2];
              return [4, options.signer()];
            case 1:
              _a2 = _e.sent();
              return [3, 3];
            case 2:
              _a2 = options.signer;
              _e.label = 3;
            case 3:
              signer = _a2;
              _b2 = next;
              _c = [__assign25({}, args)];
              _d = {};
              return [4, signer.sign(args.request, {
                signingDate: new Date(Date.now() + options.systemClockOffset),
                signingRegion: context["signing_region"],
                signingService: context["signing_service"]
              })];
            case 4:
              return [4, _b2.apply(void 0, [__assign25.apply(void 0, _c.concat([(_d.request = _e.sent(), _d)]))])];
            case 5:
              output = _e.sent();
              headers = output.response.headers;
              dateHeader = headers && (headers.date || headers.Date);
              if (dateHeader) {
                serverTime = Date.parse(dateHeader);
                if (isClockSkewed3(serverTime, options.systemClockOffset)) {
                  options.systemClockOffset = serverTime - Date.now();
                }
              }
              return [2, output];
          }
        });
      });
    };
  };
}
var awsAuthMiddlewareOptions2 = {
  name: "awsAuthMiddleware",
  tags: ["SIGNATURE", "AWSAUTH"],
  relation: "after",
  toMiddleware: "retryMiddleware",
  override: true
};
var getAwsAuthPlugin2 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.addRelativeTo(awsAuthMiddleware2(options), awsAuthMiddlewareOptions2);
    }
  };
};

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-sdk/middleware-user-agent/node_modules/tslib/tslib.es6.js
var __assign26 = function() {
  __assign26 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign26.apply(this, arguments);
};
function __awaiter38(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator39(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __read23(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}
function __spread9() {
  for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
    ar = ar.concat(__read23(arguments[i2]));
  return ar;
}

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-sdk/middleware-user-agent/dist/es/configurations.js
function resolveUserAgentConfig2(input) {
  return __assign26(__assign26({}, input), { customUserAgent: typeof input.customUserAgent === "string" ? [[input.customUserAgent]] : input.customUserAgent });
}

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-sdk/middleware-user-agent/dist/es/constants.js
var USER_AGENT2 = "user-agent";
var X_AMZ_USER_AGENT2 = "x-amz-user-agent";
var SPACE2 = " ";
var UA_ESCAPE_REGEX2 = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

// node_modules/@aws-sdk/client-kinesis/node_modules/@aws-sdk/middleware-user-agent/dist/es/user-agent-middleware.js
var userAgentMiddleware3 = function(options) {
  return function(next, context) {
    return function(args) {
      return __awaiter38(void 0, void 0, void 0, function() {
        var request, headers, userAgent2, defaultUserAgent8, customUserAgent, normalUAValue;
        var _a2, _b2;
        return __generator39(this, function(_c) {
          switch (_c.label) {
            case 0:
              request = args.request;
              if (!HttpRequest.isInstance(request))
                return [2, next(args)];
              headers = request.headers;
              userAgent2 = ((_a2 = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a2 === void 0 ? void 0 : _a2.map(escapeUserAgent2)) || [];
              return [4, options.defaultUserAgentProvider()];
            case 1:
              defaultUserAgent8 = _c.sent().map(escapeUserAgent2);
              customUserAgent = ((_b2 = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b2 === void 0 ? void 0 : _b2.map(escapeUserAgent2)) || [];
              headers[X_AMZ_USER_AGENT2] = __spread9(defaultUserAgent8, userAgent2, customUserAgent).join(SPACE2);
              normalUAValue = __spread9(defaultUserAgent8.filter(function(section) {
                return section.startsWith("aws-sdk-");
              }), customUserAgent).join(SPACE2);
              if (options.runtime !== "browser" && normalUAValue) {
                headers[USER_AGENT2] = headers[USER_AGENT2] ? headers[USER_AGENT2] + " " + normalUAValue : normalUAValue;
              }
              return [2, next(__assign26(__assign26({}, args), { request }))];
          }
        });
      });
    };
  };
};
var escapeUserAgent2 = function(_a2) {
  var _b2 = __read23(_a2, 2), name = _b2[0], version3 = _b2[1];
  var prefixSeparatorIndex = name.indexOf("/");
  var prefix = name.substring(0, prefixSeparatorIndex);
  var uaName = name.substring(prefixSeparatorIndex + 1);
  if (prefix === "api") {
    uaName = uaName.toLowerCase();
  }
  return [prefix, uaName, version3].filter(function(item) {
    return item && item.length > 0;
  }).map(function(item) {
    return item === null || item === void 0 ? void 0 : item.replace(UA_ESCAPE_REGEX2, "_");
  }).join("/");
};
var getUserAgentMiddlewareOptions2 = {
  name: "getUserAgentMiddleware",
  step: "build",
  priority: "low",
  tags: ["SET_USER_AGENT", "USER_AGENT"],
  override: true
};
var getUserAgentPlugin2 = function(config) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(userAgentMiddleware3(config), getUserAgentMiddlewareOptions2);
    }
  };
};

// node_modules/@aws-sdk/client-kinesis/dist/es/KinesisClient.js
var KinesisClient = (
  /** @class */
  function(_super) {
    __extends3(KinesisClient2, _super);
    function KinesisClient2(configuration) {
      var _this = this;
      var _config_0 = __assign7(__assign7({}, ClientDefaultValues2), configuration);
      var _config_1 = resolveRegionConfig(_config_0);
      var _config_2 = resolveEndpointsConfig(_config_1);
      var _config_3 = resolveAwsAuthConfig2(_config_2);
      var _config_4 = resolveRetryConfig(_config_3);
      var _config_5 = resolveHostHeaderConfig2(_config_4);
      var _config_6 = resolveUserAgentConfig2(_config_5);
      var _config_7 = resolveEventStreamSerdeConfig(_config_6);
      _this = _super.call(this, _config_7) || this;
      _this.config = _config_7;
      _this.middlewareStack.use(getAwsAuthPlugin2(_this.config));
      _this.middlewareStack.use(getRetryPlugin(_this.config));
      _this.middlewareStack.use(getContentLengthPlugin(_this.config));
      _this.middlewareStack.use(getHostHeaderPlugin2(_this.config));
      _this.middlewareStack.use(getLoggerPlugin2(_this.config));
      _this.middlewareStack.use(getUserAgentPlugin2(_this.config));
      return _this;
    }
    KinesisClient2.prototype.destroy = function() {
      _super.prototype.destroy.call(this);
    };
    return KinesisClient2;
  }(Client)
);

// node_modules/@aws-sdk/client-kinesis/dist/es/models/models_0.js
var AddTagsToStreamInput;
(function(AddTagsToStreamInput2) {
  AddTagsToStreamInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(AddTagsToStreamInput || (AddTagsToStreamInput = {}));
var InvalidArgumentException;
(function(InvalidArgumentException3) {
  InvalidArgumentException3.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(InvalidArgumentException || (InvalidArgumentException = {}));
var LimitExceededException2;
(function(LimitExceededException5) {
  LimitExceededException5.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(LimitExceededException2 || (LimitExceededException2 = {}));
var ResourceInUseException;
(function(ResourceInUseException3) {
  ResourceInUseException3.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ResourceInUseException || (ResourceInUseException = {}));
var ResourceNotFoundException2;
(function(ResourceNotFoundException6) {
  ResourceNotFoundException6.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ResourceNotFoundException2 || (ResourceNotFoundException2 = {}));
var HashKeyRange;
(function(HashKeyRange2) {
  HashKeyRange2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(HashKeyRange || (HashKeyRange = {}));
var ChildShard;
(function(ChildShard2) {
  ChildShard2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ChildShard || (ChildShard = {}));
var ConsumerStatus;
(function(ConsumerStatus2) {
  ConsumerStatus2["ACTIVE"] = "ACTIVE";
  ConsumerStatus2["CREATING"] = "CREATING";
  ConsumerStatus2["DELETING"] = "DELETING";
})(ConsumerStatus || (ConsumerStatus = {}));
var Consumer;
(function(Consumer2) {
  Consumer2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Consumer || (Consumer = {}));
var ConsumerDescription;
(function(ConsumerDescription2) {
  ConsumerDescription2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ConsumerDescription || (ConsumerDescription = {}));
var CreateStreamInput;
(function(CreateStreamInput2) {
  CreateStreamInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CreateStreamInput || (CreateStreamInput = {}));
var DecreaseStreamRetentionPeriodInput;
(function(DecreaseStreamRetentionPeriodInput2) {
  DecreaseStreamRetentionPeriodInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DecreaseStreamRetentionPeriodInput || (DecreaseStreamRetentionPeriodInput = {}));
var DeleteStreamInput;
(function(DeleteStreamInput2) {
  DeleteStreamInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteStreamInput || (DeleteStreamInput = {}));
var DeregisterStreamConsumerInput;
(function(DeregisterStreamConsumerInput2) {
  DeregisterStreamConsumerInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeregisterStreamConsumerInput || (DeregisterStreamConsumerInput = {}));
var DescribeLimitsInput;
(function(DescribeLimitsInput2) {
  DescribeLimitsInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeLimitsInput || (DescribeLimitsInput = {}));
var DescribeLimitsOutput;
(function(DescribeLimitsOutput2) {
  DescribeLimitsOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeLimitsOutput || (DescribeLimitsOutput = {}));
var DescribeStreamInput;
(function(DescribeStreamInput2) {
  DescribeStreamInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeStreamInput || (DescribeStreamInput = {}));
var EncryptionType;
(function(EncryptionType2) {
  EncryptionType2["KMS"] = "KMS";
  EncryptionType2["NONE"] = "NONE";
})(EncryptionType || (EncryptionType = {}));
var MetricsName;
(function(MetricsName2) {
  MetricsName2["ALL"] = "ALL";
  MetricsName2["INCOMING_BYTES"] = "IncomingBytes";
  MetricsName2["INCOMING_RECORDS"] = "IncomingRecords";
  MetricsName2["ITERATOR_AGE_MILLISECONDS"] = "IteratorAgeMilliseconds";
  MetricsName2["OUTGOING_BYTES"] = "OutgoingBytes";
  MetricsName2["OUTGOING_RECORDS"] = "OutgoingRecords";
  MetricsName2["READ_PROVISIONED_THROUGHPUT_EXCEEDED"] = "ReadProvisionedThroughputExceeded";
  MetricsName2["WRITE_PROVISIONED_THROUGHPUT_EXCEEDED"] = "WriteProvisionedThroughputExceeded";
})(MetricsName || (MetricsName = {}));
var EnhancedMetrics;
(function(EnhancedMetrics2) {
  EnhancedMetrics2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(EnhancedMetrics || (EnhancedMetrics = {}));
var SequenceNumberRange;
(function(SequenceNumberRange2) {
  SequenceNumberRange2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(SequenceNumberRange || (SequenceNumberRange = {}));
var Shard;
(function(Shard2) {
  Shard2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Shard || (Shard = {}));
var StreamStatus;
(function(StreamStatus2) {
  StreamStatus2["ACTIVE"] = "ACTIVE";
  StreamStatus2["CREATING"] = "CREATING";
  StreamStatus2["DELETING"] = "DELETING";
  StreamStatus2["UPDATING"] = "UPDATING";
})(StreamStatus || (StreamStatus = {}));
var StreamDescription;
(function(StreamDescription2) {
  StreamDescription2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(StreamDescription || (StreamDescription = {}));
var DescribeStreamOutput;
(function(DescribeStreamOutput2) {
  DescribeStreamOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeStreamOutput || (DescribeStreamOutput = {}));
var DescribeStreamConsumerInput;
(function(DescribeStreamConsumerInput2) {
  DescribeStreamConsumerInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeStreamConsumerInput || (DescribeStreamConsumerInput = {}));
var DescribeStreamConsumerOutput;
(function(DescribeStreamConsumerOutput2) {
  DescribeStreamConsumerOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeStreamConsumerOutput || (DescribeStreamConsumerOutput = {}));
var DescribeStreamSummaryInput;
(function(DescribeStreamSummaryInput2) {
  DescribeStreamSummaryInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeStreamSummaryInput || (DescribeStreamSummaryInput = {}));
var StreamDescriptionSummary;
(function(StreamDescriptionSummary2) {
  StreamDescriptionSummary2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(StreamDescriptionSummary || (StreamDescriptionSummary = {}));
var DescribeStreamSummaryOutput;
(function(DescribeStreamSummaryOutput2) {
  DescribeStreamSummaryOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeStreamSummaryOutput || (DescribeStreamSummaryOutput = {}));
var DisableEnhancedMonitoringInput;
(function(DisableEnhancedMonitoringInput2) {
  DisableEnhancedMonitoringInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DisableEnhancedMonitoringInput || (DisableEnhancedMonitoringInput = {}));
var EnhancedMonitoringOutput;
(function(EnhancedMonitoringOutput2) {
  EnhancedMonitoringOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(EnhancedMonitoringOutput || (EnhancedMonitoringOutput = {}));
var EnableEnhancedMonitoringInput;
(function(EnableEnhancedMonitoringInput2) {
  EnableEnhancedMonitoringInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(EnableEnhancedMonitoringInput || (EnableEnhancedMonitoringInput = {}));
var ExpiredIteratorException;
(function(ExpiredIteratorException2) {
  ExpiredIteratorException2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ExpiredIteratorException || (ExpiredIteratorException = {}));
var ExpiredNextTokenException;
(function(ExpiredNextTokenException2) {
  ExpiredNextTokenException2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ExpiredNextTokenException || (ExpiredNextTokenException = {}));
var GetRecordsInput;
(function(GetRecordsInput2) {
  GetRecordsInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetRecordsInput || (GetRecordsInput = {}));
var _Record;
(function(_Record3) {
  _Record3.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(_Record || (_Record = {}));
var GetRecordsOutput;
(function(GetRecordsOutput2) {
  GetRecordsOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetRecordsOutput || (GetRecordsOutput = {}));
var KMSAccessDeniedException;
(function(KMSAccessDeniedException2) {
  KMSAccessDeniedException2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(KMSAccessDeniedException || (KMSAccessDeniedException = {}));
var KMSDisabledException;
(function(KMSDisabledException2) {
  KMSDisabledException2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(KMSDisabledException || (KMSDisabledException = {}));
var KMSInvalidStateException;
(function(KMSInvalidStateException2) {
  KMSInvalidStateException2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(KMSInvalidStateException || (KMSInvalidStateException = {}));
var KMSNotFoundException;
(function(KMSNotFoundException2) {
  KMSNotFoundException2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(KMSNotFoundException || (KMSNotFoundException = {}));
var KMSOptInRequired;
(function(KMSOptInRequired2) {
  KMSOptInRequired2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(KMSOptInRequired || (KMSOptInRequired = {}));
var KMSThrottlingException;
(function(KMSThrottlingException2) {
  KMSThrottlingException2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(KMSThrottlingException || (KMSThrottlingException = {}));
var ProvisionedThroughputExceededException;
(function(ProvisionedThroughputExceededException2) {
  ProvisionedThroughputExceededException2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ProvisionedThroughputExceededException || (ProvisionedThroughputExceededException = {}));
var ShardIteratorType;
(function(ShardIteratorType2) {
  ShardIteratorType2["AFTER_SEQUENCE_NUMBER"] = "AFTER_SEQUENCE_NUMBER";
  ShardIteratorType2["AT_SEQUENCE_NUMBER"] = "AT_SEQUENCE_NUMBER";
  ShardIteratorType2["AT_TIMESTAMP"] = "AT_TIMESTAMP";
  ShardIteratorType2["LATEST"] = "LATEST";
  ShardIteratorType2["TRIM_HORIZON"] = "TRIM_HORIZON";
})(ShardIteratorType || (ShardIteratorType = {}));
var GetShardIteratorInput;
(function(GetShardIteratorInput2) {
  GetShardIteratorInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetShardIteratorInput || (GetShardIteratorInput = {}));
var GetShardIteratorOutput;
(function(GetShardIteratorOutput2) {
  GetShardIteratorOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetShardIteratorOutput || (GetShardIteratorOutput = {}));
var IncreaseStreamRetentionPeriodInput;
(function(IncreaseStreamRetentionPeriodInput2) {
  IncreaseStreamRetentionPeriodInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(IncreaseStreamRetentionPeriodInput || (IncreaseStreamRetentionPeriodInput = {}));
var InternalFailureException;
(function(InternalFailureException3) {
  InternalFailureException3.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(InternalFailureException || (InternalFailureException = {}));
var ShardFilterType;
(function(ShardFilterType2) {
  ShardFilterType2["AFTER_SHARD_ID"] = "AFTER_SHARD_ID";
  ShardFilterType2["AT_LATEST"] = "AT_LATEST";
  ShardFilterType2["AT_TIMESTAMP"] = "AT_TIMESTAMP";
  ShardFilterType2["AT_TRIM_HORIZON"] = "AT_TRIM_HORIZON";
  ShardFilterType2["FROM_TIMESTAMP"] = "FROM_TIMESTAMP";
  ShardFilterType2["FROM_TRIM_HORIZON"] = "FROM_TRIM_HORIZON";
})(ShardFilterType || (ShardFilterType = {}));
var ShardFilter;
(function(ShardFilter2) {
  ShardFilter2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ShardFilter || (ShardFilter = {}));
var ListShardsInput;
(function(ListShardsInput2) {
  ListShardsInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListShardsInput || (ListShardsInput = {}));
var ListShardsOutput;
(function(ListShardsOutput2) {
  ListShardsOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListShardsOutput || (ListShardsOutput = {}));
var ListStreamConsumersInput;
(function(ListStreamConsumersInput2) {
  ListStreamConsumersInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListStreamConsumersInput || (ListStreamConsumersInput = {}));
var ListStreamConsumersOutput;
(function(ListStreamConsumersOutput2) {
  ListStreamConsumersOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListStreamConsumersOutput || (ListStreamConsumersOutput = {}));
var ListStreamsInput;
(function(ListStreamsInput2) {
  ListStreamsInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListStreamsInput || (ListStreamsInput = {}));
var ListStreamsOutput;
(function(ListStreamsOutput2) {
  ListStreamsOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListStreamsOutput || (ListStreamsOutput = {}));
var ListTagsForStreamInput;
(function(ListTagsForStreamInput2) {
  ListTagsForStreamInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListTagsForStreamInput || (ListTagsForStreamInput = {}));
var Tag;
(function(Tag4) {
  Tag4.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Tag || (Tag = {}));
var ListTagsForStreamOutput;
(function(ListTagsForStreamOutput2) {
  ListTagsForStreamOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListTagsForStreamOutput || (ListTagsForStreamOutput = {}));
var MergeShardsInput;
(function(MergeShardsInput2) {
  MergeShardsInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(MergeShardsInput || (MergeShardsInput = {}));
var PutRecordInput;
(function(PutRecordInput3) {
  PutRecordInput3.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutRecordInput || (PutRecordInput = {}));
var PutRecordOutput;
(function(PutRecordOutput3) {
  PutRecordOutput3.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutRecordOutput || (PutRecordOutput = {}));
var PutRecordsRequestEntry;
(function(PutRecordsRequestEntry2) {
  PutRecordsRequestEntry2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutRecordsRequestEntry || (PutRecordsRequestEntry = {}));
var PutRecordsInput;
(function(PutRecordsInput2) {
  PutRecordsInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutRecordsInput || (PutRecordsInput = {}));
var PutRecordsResultEntry;
(function(PutRecordsResultEntry2) {
  PutRecordsResultEntry2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutRecordsResultEntry || (PutRecordsResultEntry = {}));
var PutRecordsOutput;
(function(PutRecordsOutput2) {
  PutRecordsOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutRecordsOutput || (PutRecordsOutput = {}));
var RegisterStreamConsumerInput;
(function(RegisterStreamConsumerInput2) {
  RegisterStreamConsumerInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(RegisterStreamConsumerInput || (RegisterStreamConsumerInput = {}));
var RegisterStreamConsumerOutput;
(function(RegisterStreamConsumerOutput2) {
  RegisterStreamConsumerOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(RegisterStreamConsumerOutput || (RegisterStreamConsumerOutput = {}));
var RemoveTagsFromStreamInput;
(function(RemoveTagsFromStreamInput2) {
  RemoveTagsFromStreamInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(RemoveTagsFromStreamInput || (RemoveTagsFromStreamInput = {}));
var SplitShardInput;
(function(SplitShardInput2) {
  SplitShardInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(SplitShardInput || (SplitShardInput = {}));
var StartStreamEncryptionInput;
(function(StartStreamEncryptionInput2) {
  StartStreamEncryptionInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(StartStreamEncryptionInput || (StartStreamEncryptionInput = {}));
var StopStreamEncryptionInput;
(function(StopStreamEncryptionInput2) {
  StopStreamEncryptionInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(StopStreamEncryptionInput || (StopStreamEncryptionInput = {}));
var StartingPosition;
(function(StartingPosition2) {
  StartingPosition2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(StartingPosition || (StartingPosition = {}));
var SubscribeToShardInput;
(function(SubscribeToShardInput2) {
  SubscribeToShardInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(SubscribeToShardInput || (SubscribeToShardInput = {}));
var SubscribeToShardEvent;
(function(SubscribeToShardEvent2) {
  SubscribeToShardEvent2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(SubscribeToShardEvent || (SubscribeToShardEvent = {}));
var SubscribeToShardEventStream;
(function(SubscribeToShardEventStream2) {
  SubscribeToShardEventStream2.visit = function(value, visitor) {
    if (value.SubscribeToShardEvent !== void 0)
      return visitor.SubscribeToShardEvent(value.SubscribeToShardEvent);
    if (value.ResourceNotFoundException !== void 0)
      return visitor.ResourceNotFoundException(value.ResourceNotFoundException);
    if (value.ResourceInUseException !== void 0)
      return visitor.ResourceInUseException(value.ResourceInUseException);
    if (value.KMSDisabledException !== void 0)
      return visitor.KMSDisabledException(value.KMSDisabledException);
    if (value.KMSInvalidStateException !== void 0)
      return visitor.KMSInvalidStateException(value.KMSInvalidStateException);
    if (value.KMSAccessDeniedException !== void 0)
      return visitor.KMSAccessDeniedException(value.KMSAccessDeniedException);
    if (value.KMSNotFoundException !== void 0)
      return visitor.KMSNotFoundException(value.KMSNotFoundException);
    if (value.KMSOptInRequired !== void 0)
      return visitor.KMSOptInRequired(value.KMSOptInRequired);
    if (value.KMSThrottlingException !== void 0)
      return visitor.KMSThrottlingException(value.KMSThrottlingException);
    if (value.InternalFailureException !== void 0)
      return visitor.InternalFailureException(value.InternalFailureException);
    return visitor._(value.$unknown[0], value.$unknown[1]);
  };
  SubscribeToShardEventStream2.filterSensitiveLog = function(obj) {
    var _a2;
    if (obj.SubscribeToShardEvent !== void 0)
      return { SubscribeToShardEvent: SubscribeToShardEvent.filterSensitiveLog(obj.SubscribeToShardEvent) };
    if (obj.ResourceNotFoundException !== void 0)
      return { ResourceNotFoundException: ResourceNotFoundException2.filterSensitiveLog(obj.ResourceNotFoundException) };
    if (obj.ResourceInUseException !== void 0)
      return { ResourceInUseException: ResourceInUseException.filterSensitiveLog(obj.ResourceInUseException) };
    if (obj.KMSDisabledException !== void 0)
      return { KMSDisabledException: KMSDisabledException.filterSensitiveLog(obj.KMSDisabledException) };
    if (obj.KMSInvalidStateException !== void 0)
      return { KMSInvalidStateException: KMSInvalidStateException.filterSensitiveLog(obj.KMSInvalidStateException) };
    if (obj.KMSAccessDeniedException !== void 0)
      return { KMSAccessDeniedException: KMSAccessDeniedException.filterSensitiveLog(obj.KMSAccessDeniedException) };
    if (obj.KMSNotFoundException !== void 0)
      return { KMSNotFoundException: KMSNotFoundException.filterSensitiveLog(obj.KMSNotFoundException) };
    if (obj.KMSOptInRequired !== void 0)
      return { KMSOptInRequired: KMSOptInRequired.filterSensitiveLog(obj.KMSOptInRequired) };
    if (obj.KMSThrottlingException !== void 0)
      return { KMSThrottlingException: KMSThrottlingException.filterSensitiveLog(obj.KMSThrottlingException) };
    if (obj.InternalFailureException !== void 0)
      return { InternalFailureException: InternalFailureException.filterSensitiveLog(obj.InternalFailureException) };
    if (obj.$unknown !== void 0)
      return _a2 = {}, _a2[obj.$unknown[0]] = "UNKNOWN", _a2;
  };
})(SubscribeToShardEventStream || (SubscribeToShardEventStream = {}));
var SubscribeToShardOutput;
(function(SubscribeToShardOutput2) {
  SubscribeToShardOutput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.EventStream && { EventStream: "STREAMING_CONTENT" });
  };
})(SubscribeToShardOutput || (SubscribeToShardOutput = {}));
var ScalingType;
(function(ScalingType2) {
  ScalingType2["UNIFORM_SCALING"] = "UNIFORM_SCALING";
})(ScalingType || (ScalingType = {}));
var UpdateShardCountInput;
(function(UpdateShardCountInput2) {
  UpdateShardCountInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(UpdateShardCountInput || (UpdateShardCountInput = {}));
var UpdateShardCountOutput;
(function(UpdateShardCountOutput2) {
  UpdateShardCountOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(UpdateShardCountOutput || (UpdateShardCountOutput = {}));

// node_modules/@aws-sdk/client-kinesis/dist/es/protocols/Aws_json1_1.js
var serializeAws_json1_1PutRecordsCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var headers, body;
    return __generator3(this, function(_a2) {
      headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "Kinesis_20131202.PutRecords"
      };
      body = JSON.stringify(serializeAws_json1_1PutRecordsInput(input, context));
      return [2, buildHttpRpcRequest3(context, headers, "/", void 0, body)];
    });
  });
};
var deserializeAws_json1_1PutRecordsCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var data, contents, response;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (output.statusCode >= 300) {
            return [2, deserializeAws_json1_1PutRecordsCommandError(output, context)];
          }
          return [4, parseBody2(output.body, context)];
        case 1:
          data = _a2.sent();
          contents = {};
          contents = deserializeAws_json1_1PutRecordsOutput(data, context);
          response = __assign7({ $metadata: deserializeMetadata2(output) }, contents);
          return [2, Promise.resolve(response)];
      }
    });
  });
};
var deserializeAws_json1_1PutRecordsCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, response, errorCode, _b2, _c, _d, _e, _f, _g, _h, _j, _k, _l, parsedBody, message;
    var _m;
    return __generator3(this, function(_o) {
      switch (_o.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _m = {};
          return [4, parseBody2(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_m.body = _o.sent(), _m)]));
          errorCode = "UnknownError";
          errorCode = loadRestJsonErrorCode2(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "InvalidArgumentException":
              return [3, 2];
            case "com.amazonaws.kinesis#InvalidArgumentException":
              return [3, 2];
            case "KMSAccessDeniedException":
              return [3, 4];
            case "com.amazonaws.kinesis#KMSAccessDeniedException":
              return [3, 4];
            case "KMSDisabledException":
              return [3, 6];
            case "com.amazonaws.kinesis#KMSDisabledException":
              return [3, 6];
            case "KMSInvalidStateException":
              return [3, 8];
            case "com.amazonaws.kinesis#KMSInvalidStateException":
              return [3, 8];
            case "KMSNotFoundException":
              return [3, 10];
            case "com.amazonaws.kinesis#KMSNotFoundException":
              return [3, 10];
            case "KMSOptInRequired":
              return [3, 12];
            case "com.amazonaws.kinesis#KMSOptInRequired":
              return [3, 12];
            case "KMSThrottlingException":
              return [3, 14];
            case "com.amazonaws.kinesis#KMSThrottlingException":
              return [3, 14];
            case "ProvisionedThroughputExceededException":
              return [3, 16];
            case "com.amazonaws.kinesis#ProvisionedThroughputExceededException":
              return [3, 16];
            case "ResourceNotFoundException":
              return [3, 18];
            case "com.amazonaws.kinesis#ResourceNotFoundException":
              return [3, 18];
          }
          return [3, 20];
        case 2:
          _c = [{}];
          return [4, deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)];
        case 3:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _c.concat([_o.sent()])), { name: errorCode, $metadata: deserializeMetadata2(output) }]);
          return [3, 21];
        case 4:
          _d = [{}];
          return [4, deserializeAws_json1_1KMSAccessDeniedExceptionResponse(parsedOutput, context)];
        case 5:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _d.concat([_o.sent()])), { name: errorCode, $metadata: deserializeMetadata2(output) }]);
          return [3, 21];
        case 6:
          _e = [{}];
          return [4, deserializeAws_json1_1KMSDisabledExceptionResponse(parsedOutput, context)];
        case 7:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _e.concat([_o.sent()])), { name: errorCode, $metadata: deserializeMetadata2(output) }]);
          return [3, 21];
        case 8:
          _f = [{}];
          return [4, deserializeAws_json1_1KMSInvalidStateExceptionResponse(parsedOutput, context)];
        case 9:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _f.concat([_o.sent()])), { name: errorCode, $metadata: deserializeMetadata2(output) }]);
          return [3, 21];
        case 10:
          _g = [{}];
          return [4, deserializeAws_json1_1KMSNotFoundExceptionResponse(parsedOutput, context)];
        case 11:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _g.concat([_o.sent()])), { name: errorCode, $metadata: deserializeMetadata2(output) }]);
          return [3, 21];
        case 12:
          _h = [{}];
          return [4, deserializeAws_json1_1KMSOptInRequiredResponse(parsedOutput, context)];
        case 13:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _h.concat([_o.sent()])), { name: errorCode, $metadata: deserializeMetadata2(output) }]);
          return [3, 21];
        case 14:
          _j = [{}];
          return [4, deserializeAws_json1_1KMSThrottlingExceptionResponse(parsedOutput, context)];
        case 15:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _j.concat([_o.sent()])), { name: errorCode, $metadata: deserializeMetadata2(output) }]);
          return [3, 21];
        case 16:
          _k = [{}];
          return [4, deserializeAws_json1_1ProvisionedThroughputExceededExceptionResponse(parsedOutput, context)];
        case 17:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _k.concat([_o.sent()])), { name: errorCode, $metadata: deserializeMetadata2(output) }]);
          return [3, 21];
        case 18:
          _l = [{}];
          return [4, deserializeAws_json1_1ResourceNotFoundExceptionResponse2(parsedOutput, context)];
        case 19:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _l.concat([_o.sent()])), { name: errorCode, $metadata: deserializeMetadata2(output) }]);
          return [3, 21];
        case 20:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign7(__assign7({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata2(output) });
          _o.label = 21;
        case 21:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2, Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};
var deserializeAws_json1_1InvalidArgumentExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1InvalidArgumentException(body, context);
      contents = __assign7({ name: "InvalidArgumentException", $fault: "client", $metadata: deserializeMetadata2(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var deserializeAws_json1_1KMSAccessDeniedExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1KMSAccessDeniedException(body, context);
      contents = __assign7({ name: "KMSAccessDeniedException", $fault: "client", $metadata: deserializeMetadata2(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var deserializeAws_json1_1KMSDisabledExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1KMSDisabledException(body, context);
      contents = __assign7({ name: "KMSDisabledException", $fault: "client", $metadata: deserializeMetadata2(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var deserializeAws_json1_1KMSInvalidStateExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1KMSInvalidStateException(body, context);
      contents = __assign7({ name: "KMSInvalidStateException", $fault: "client", $metadata: deserializeMetadata2(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var deserializeAws_json1_1KMSNotFoundExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1KMSNotFoundException(body, context);
      contents = __assign7({ name: "KMSNotFoundException", $fault: "client", $metadata: deserializeMetadata2(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var deserializeAws_json1_1KMSOptInRequiredResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1KMSOptInRequired(body, context);
      contents = __assign7({ name: "KMSOptInRequired", $fault: "client", $metadata: deserializeMetadata2(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var deserializeAws_json1_1KMSThrottlingExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1KMSThrottlingException(body, context);
      contents = __assign7({ name: "KMSThrottlingException", $fault: "client", $metadata: deserializeMetadata2(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var deserializeAws_json1_1ProvisionedThroughputExceededExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1ProvisionedThroughputExceededException(body, context);
      contents = __assign7({ name: "ProvisionedThroughputExceededException", $fault: "client", $metadata: deserializeMetadata2(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var deserializeAws_json1_1ResourceNotFoundExceptionResponse2 = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1ResourceNotFoundException2(body, context);
      contents = __assign7({ name: "ResourceNotFoundException", $fault: "client", $metadata: deserializeMetadata2(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var serializeAws_json1_1PutRecordsInput = function(input, context) {
  return __assign7(__assign7({}, input.Records !== void 0 && input.Records !== null && { Records: serializeAws_json1_1PutRecordsRequestEntryList(input.Records, context) }), input.StreamName !== void 0 && input.StreamName !== null && { StreamName: input.StreamName });
};
var serializeAws_json1_1PutRecordsRequestEntry = function(input, context) {
  return __assign7(__assign7(__assign7({}, input.Data !== void 0 && input.Data !== null && { Data: context.base64Encoder(input.Data) }), input.ExplicitHashKey !== void 0 && input.ExplicitHashKey !== null && { ExplicitHashKey: input.ExplicitHashKey }), input.PartitionKey !== void 0 && input.PartitionKey !== null && { PartitionKey: input.PartitionKey });
};
var serializeAws_json1_1PutRecordsRequestEntryList = function(input, context) {
  return input.filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return serializeAws_json1_1PutRecordsRequestEntry(entry, context);
  });
};
var deserializeAws_json1_1InvalidArgumentException = function(output, context) {
  return {
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeAws_json1_1KMSAccessDeniedException = function(output, context) {
  return {
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeAws_json1_1KMSDisabledException = function(output, context) {
  return {
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeAws_json1_1KMSInvalidStateException = function(output, context) {
  return {
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeAws_json1_1KMSNotFoundException = function(output, context) {
  return {
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeAws_json1_1KMSOptInRequired = function(output, context) {
  return {
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeAws_json1_1KMSThrottlingException = function(output, context) {
  return {
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeAws_json1_1ProvisionedThroughputExceededException = function(output, context) {
  return {
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeAws_json1_1PutRecordsOutput = function(output, context) {
  return {
    EncryptionType: output.EncryptionType !== void 0 && output.EncryptionType !== null ? output.EncryptionType : void 0,
    FailedRecordCount: output.FailedRecordCount !== void 0 && output.FailedRecordCount !== null ? output.FailedRecordCount : void 0,
    Records: output.Records !== void 0 && output.Records !== null ? deserializeAws_json1_1PutRecordsResultEntryList(output.Records, context) : void 0
  };
};
var deserializeAws_json1_1PutRecordsResultEntry = function(output, context) {
  return {
    ErrorCode: output.ErrorCode !== void 0 && output.ErrorCode !== null ? output.ErrorCode : void 0,
    ErrorMessage: output.ErrorMessage !== void 0 && output.ErrorMessage !== null ? output.ErrorMessage : void 0,
    SequenceNumber: output.SequenceNumber !== void 0 && output.SequenceNumber !== null ? output.SequenceNumber : void 0,
    ShardId: output.ShardId !== void 0 && output.ShardId !== null ? output.ShardId : void 0
  };
};
var deserializeAws_json1_1PutRecordsResultEntryList = function(output, context) {
  return (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_json1_1PutRecordsResultEntry(entry, context);
  });
};
var deserializeAws_json1_1ResourceNotFoundException2 = function(output, context) {
  return {
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeMetadata2 = function(output) {
  var _a2;
  return {
    httpStatusCode: output.statusCode,
    requestId: (_a2 = output.headers["x-amzn-requestid"]) !== null && _a2 !== void 0 ? _a2 : output.headers["x-amzn-request-id"],
    extendedRequestId: output.headers["x-amz-id-2"],
    cfId: output.headers["x-amz-cf-id"]
  };
};
var collectBody2 = function(streamBody, context) {
  if (streamBody === void 0) {
    streamBody = new Uint8Array();
  }
  if (streamBody instanceof Uint8Array) {
    return Promise.resolve(streamBody);
  }
  return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
var collectBodyString2 = function(streamBody, context) {
  return collectBody2(streamBody, context).then(function(body) {
    return context.utf8Encoder(body);
  });
};
var buildHttpRpcRequest3 = function(context, headers, path, resolvedHostname, body) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var _a2, hostname, _b2, protocol, port, contents;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port;
          contents = {
            protocol,
            hostname,
            port,
            method: "POST",
            path,
            headers
          };
          if (resolvedHostname !== void 0) {
            contents.hostname = resolvedHostname;
          }
          if (body !== void 0) {
            contents.body = body;
          }
          return [2, new HttpRequest(contents)];
      }
    });
  });
};
var parseBody2 = function(streamBody, context) {
  return collectBodyString2(streamBody, context).then(function(encoded) {
    if (encoded.length) {
      return JSON.parse(encoded);
    }
    return {};
  });
};
var loadRestJsonErrorCode2 = function(output, data) {
  var findKey = function(object, key) {
    return Object.keys(object).find(function(k2) {
      return k2.toLowerCase() === key.toLowerCase();
    });
  };
  var sanitizeErrorCode = function(rawValue) {
    var cleanValue = rawValue;
    if (cleanValue.indexOf(":") >= 0) {
      cleanValue = cleanValue.split(":")[0];
    }
    if (cleanValue.indexOf("#") >= 0) {
      cleanValue = cleanValue.split("#")[1];
    }
    return cleanValue;
  };
  var headerKey = findKey(output.headers, "x-amzn-errortype");
  if (headerKey !== void 0) {
    return sanitizeErrorCode(output.headers[headerKey]);
  }
  if (data.code !== void 0) {
    return sanitizeErrorCode(data.code);
  }
  if (data["__type"] !== void 0) {
    return sanitizeErrorCode(data["__type"]);
  }
  return "";
};

// node_modules/@aws-sdk/client-kinesis/dist/es/commands/PutRecordsCommand.js
var PutRecordsCommand = (
  /** @class */
  function(_super) {
    __extends3(PutRecordsCommand2, _super);
    function PutRecordsCommand2(input) {
      var _this = (
        // Start section: command_constructor
        _super.call(this) || this
      );
      _this.input = input;
      return _this;
    }
    PutRecordsCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
      this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
      var stack = clientStack.concat(this.middlewareStack);
      var logger64 = configuration.logger;
      var clientName = "KinesisClient";
      var commandName = "PutRecordsCommand";
      var handlerExecutionContext = {
        logger: logger64,
        clientName,
        commandName,
        inputFilterSensitiveLog: PutRecordsInput.filterSensitiveLog,
        outputFilterSensitiveLog: PutRecordsOutput.filterSensitiveLog
      };
      var requestHandler = configuration.requestHandler;
      return stack.resolve(function(request) {
        return requestHandler.handle(request.request, options || {});
      }, handlerExecutionContext);
    };
    PutRecordsCommand2.prototype.serialize = function(input, context) {
      return serializeAws_json1_1PutRecordsCommand(input, context);
    };
    PutRecordsCommand2.prototype.deserialize = function(output, context) {
      return deserializeAws_json1_1PutRecordsCommand(output, context);
    };
    return PutRecordsCommand2;
  }(Command)
);

// node_modules/@aws-amplify/analytics/node_modules/@aws-sdk/util-utf8-browser/dist/es/pureJs.js
var fromUtf810 = function(input) {
  var bytes = [];
  for (var i2 = 0, len = input.length; i2 < len; i2++) {
    var value = input.charCodeAt(i2);
    if (value < 128) {
      bytes.push(value);
    } else if (value < 2048) {
      bytes.push(value >> 6 | 192, value & 63 | 128);
    } else if (i2 + 1 < input.length && (value & 64512) === 55296 && (input.charCodeAt(i2 + 1) & 64512) === 56320) {
      var surrogatePair = 65536 + ((value & 1023) << 10) + (input.charCodeAt(++i2) & 1023);
      bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
    } else {
      bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
  }
  return Uint8Array.from(bytes);
};

// node_modules/@aws-amplify/analytics/node_modules/@aws-sdk/util-utf8-browser/dist/es/whatwgEncodingApi.js
function fromUtf811(input) {
  return new TextEncoder().encode(input);
}

// node_modules/@aws-amplify/analytics/node_modules/@aws-sdk/util-utf8-browser/dist/es/index.js
var fromUtf812 = function(input) {
  return typeof TextEncoder === "function" ? fromUtf811(input) : fromUtf810(input);
};

// node_modules/@aws-amplify/analytics/lib-esm/Providers/AWSKinesisProvider.js
var logger20 = new ConsoleLogger("AWSKinesisProvider");
var BUFFER_SIZE2 = 1e3;
var FLUSH_SIZE2 = 100;
var FLUSH_INTERVAL2 = 5 * 1e3;
var RESEND_LIMIT2 = 5;
var AWSKinesisProvider = (
  /** @class */
  function() {
    function AWSKinesisProvider2(config) {
      this._buffer = [];
      this._config = config || {};
      this._config.bufferSize = this._config.bufferSize || BUFFER_SIZE2;
      this._config.flushSize = this._config.flushSize || FLUSH_SIZE2;
      this._config.flushInterval = this._config.flushInterval || FLUSH_INTERVAL2;
      this._config.resendLimit = this._config.resendLimit || RESEND_LIMIT2;
      this._setupTimer();
    }
    AWSKinesisProvider2.prototype._setupTimer = function() {
      var _this = this;
      if (this._timer) {
        clearInterval(this._timer);
      }
      var _a2 = this._config, flushSize = _a2.flushSize, flushInterval = _a2.flushInterval;
      this._timer = setInterval(function() {
        var size = _this._buffer.length < flushSize ? _this._buffer.length : flushSize;
        var events3 = [];
        for (var i2 = 0; i2 < size; i2 += 1) {
          var params = _this._buffer.shift();
          events3.push(params);
        }
        _this._sendFromBuffer(events3);
      }, flushInterval);
    };
    AWSKinesisProvider2.prototype.getCategory = function() {
      return "Analytics";
    };
    AWSKinesisProvider2.prototype.getProviderName = function() {
      return "AWSKinesis";
    };
    AWSKinesisProvider2.prototype.configure = function(config) {
      logger20.debug("configure Analytics", config);
      var conf = config || {};
      this._config = Object.assign({}, this._config, conf);
      this._setupTimer();
      return this._config;
    };
    AWSKinesisProvider2.prototype.record = function(params) {
      var _a2;
      return __awaiter29(this, void 0, void 0, function() {
        var credentials;
        return __generator29(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              return [4, this._getCredentials()];
            case 1:
              credentials = _b2.sent();
              if (!credentials)
                return [2, Promise.resolve(false)];
              Object.assign(params, { config: this._config, credentials });
              if ((_a2 = params.event) === null || _a2 === void 0 ? void 0 : _a2.immediate) {
                this._sendEvents([params]);
                return [2, Promise.resolve(true)];
              } else {
                return [2, this._putToBuffer(params)];
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSKinesisProvider2.prototype.updateEndpoint = function() {
      logger20.debug("updateEndpoint is not implemented in Kinesis provider");
      return Promise.resolve(true);
    };
    AWSKinesisProvider2.prototype._putToBuffer = function(params) {
      if (this._buffer.length < BUFFER_SIZE2) {
        this._buffer.push(params);
        return Promise.resolve(true);
      } else {
        logger20.debug("exceed analytics events buffer size");
        return Promise.reject(false);
      }
    };
    AWSKinesisProvider2.prototype._sendFromBuffer = function(events3) {
      var _this = this;
      var eventsGroups = [];
      var preCred = null;
      var group = [];
      for (var i2 = 0; i2 < events3.length; i2 += 1) {
        var cred = events3[i2].credentials;
        if (i2 === 0) {
          group.push(events3[i2]);
          preCred = cred;
        } else {
          if (cred.sessionToken === preCred.sessionToken && cred.identityId === preCred.identityId) {
            logger20.debug("no change for cred, put event in the same group");
            group.push(events3[i2]);
          } else {
            eventsGroups.push(group);
            group = [];
            group.push(events3[i2]);
            preCred = cred;
          }
        }
      }
      eventsGroups.push(group);
      eventsGroups.map(function(evts) {
        _this._sendEvents(evts);
      });
    };
    AWSKinesisProvider2.prototype._sendEvents = function(group) {
      var _this = this;
      if (group.length === 0) {
        return;
      }
      var _a2 = group[0], config = _a2.config, credentials = _a2.credentials;
      var initClients = this._init(config, credentials);
      if (!initClients)
        return false;
      var records = {};
      group.map(function(params) {
        var evt = params.event;
        var streamName = evt.streamName;
        if (records[streamName] === void 0) {
          records[streamName] = [];
        }
        var bufferData = evt.data && typeof evt.data !== "string" ? JSON.stringify(evt.data) : evt.data;
        var Data = fromUtf812(bufferData);
        var PartitionKey = evt.partitionKey || "partition-" + credentials.identityId;
        var record = { Data, PartitionKey };
        records[streamName].push(record);
      });
      Object.keys(records).map(function(streamName) {
        return __awaiter29(_this, void 0, void 0, function() {
          var command, err_1;
          return __generator29(this, function(_a3) {
            switch (_a3.label) {
              case 0:
                logger20.debug("putting records to kinesis with records", records[streamName]);
                _a3.label = 1;
              case 1:
                _a3.trys.push([1, 3, , 4]);
                command = new PutRecordsCommand({
                  Records: records[streamName],
                  StreamName: streamName
                });
                return [4, this._kinesis.send(command)];
              case 2:
                _a3.sent();
                logger20.debug("Upload records to stream", streamName);
                return [3, 4];
              case 3:
                err_1 = _a3.sent();
                logger20.debug("Failed to upload records to Kinesis", err_1);
                return [3, 4];
              case 4:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    };
    AWSKinesisProvider2.prototype._init = function(config, credentials) {
      logger20.debug("init clients");
      if (this._kinesis && this._config.credentials && this._config.credentials.sessionToken === credentials.sessionToken && this._config.credentials.identityId === credentials.identityId) {
        logger20.debug("no change for analytics config, directly return from init");
        return true;
      }
      this._config.credentials = credentials;
      var region = config.region, endpoint = config.endpoint;
      return this._initKinesis(region, endpoint, credentials);
    };
    AWSKinesisProvider2.prototype._initKinesis = function(region, endpoint, credentials) {
      logger20.debug("initialize kinesis with credentials", credentials);
      this._kinesis = new KinesisClient({
        region,
        credentials,
        customUserAgent: getAnalyticsUserAgent(AnalyticsAction.Record),
        endpoint
      });
      return true;
    };
    AWSKinesisProvider2.prototype._getCredentials = function() {
      var _this = this;
      return Credentials.get().then(function(credentials) {
        if (!credentials)
          return null;
        logger20.debug("set credentials for analytics", _this._config.credentials);
        return Credentials.shear(credentials);
      }).catch(function(err) {
        logger20.debug("ensure credentials error", err);
        return null;
      });
    };
    return AWSKinesisProvider2;
  }()
);

// node_modules/@aws-sdk/client-firehose/dist/es/package.json
var package_default3 = {
  name: "@aws-sdk/client-firehose",
  description: "AWS SDK for JavaScript Firehose Client for Node.js, Browser and React Native",
  version: "3.6.1",
  scripts: {
    clean: "yarn remove-definitions && yarn remove-dist && yarn remove-documentation",
    "build-documentation": "yarn remove-documentation && typedoc ./",
    prepublishOnly: "yarn build",
    pretest: "yarn build:cjs",
    "remove-definitions": "rimraf ./types",
    "remove-dist": "rimraf ./dist",
    "remove-documentation": "rimraf ./docs",
    test: "exit 0",
    "build:cjs": "tsc -p tsconfig.json",
    "build:es": "tsc -p tsconfig.es.json",
    build: "yarn build:cjs && yarn build:es",
    postbuild: "downlevel-dts types types/ts3.4"
  },
  main: "./dist/cjs/index.js",
  types: "./types/index.d.ts",
  module: "./dist/es/index.js",
  browser: {
    "./runtimeConfig": "./runtimeConfig.browser"
  },
  "react-native": {
    "./runtimeConfig": "./runtimeConfig.native"
  },
  sideEffects: false,
  dependencies: {
    "@aws-crypto/sha256-browser": "^1.0.0",
    "@aws-crypto/sha256-js": "^1.0.0",
    "@aws-sdk/config-resolver": "3.6.1",
    "@aws-sdk/credential-provider-node": "3.6.1",
    "@aws-sdk/fetch-http-handler": "3.6.1",
    "@aws-sdk/hash-node": "3.6.1",
    "@aws-sdk/invalid-dependency": "3.6.1",
    "@aws-sdk/middleware-content-length": "3.6.1",
    "@aws-sdk/middleware-host-header": "3.6.1",
    "@aws-sdk/middleware-logger": "3.6.1",
    "@aws-sdk/middleware-retry": "3.6.1",
    "@aws-sdk/middleware-serde": "3.6.1",
    "@aws-sdk/middleware-signing": "3.6.1",
    "@aws-sdk/middleware-stack": "3.6.1",
    "@aws-sdk/middleware-user-agent": "3.6.1",
    "@aws-sdk/node-config-provider": "3.6.1",
    "@aws-sdk/node-http-handler": "3.6.1",
    "@aws-sdk/protocol-http": "3.6.1",
    "@aws-sdk/smithy-client": "3.6.1",
    "@aws-sdk/types": "3.6.1",
    "@aws-sdk/url-parser": "3.6.1",
    "@aws-sdk/url-parser-native": "3.6.1",
    "@aws-sdk/util-base64-browser": "3.6.1",
    "@aws-sdk/util-base64-node": "3.6.1",
    "@aws-sdk/util-body-length-browser": "3.6.1",
    "@aws-sdk/util-body-length-node": "3.6.1",
    "@aws-sdk/util-user-agent-browser": "3.6.1",
    "@aws-sdk/util-user-agent-node": "3.6.1",
    "@aws-sdk/util-utf8-browser": "3.6.1",
    "@aws-sdk/util-utf8-node": "3.6.1",
    tslib: "^2.0.0"
  },
  devDependencies: {
    "@aws-sdk/client-documentation-generator": "3.6.1",
    "@types/node": "^12.7.5",
    "downlevel-dts": "0.7.0",
    jest: "^26.1.0",
    rimraf: "^3.0.0",
    typedoc: "^0.19.2",
    typescript: "~4.1.2"
  },
  engines: {
    node: ">=10.0.0"
  },
  typesVersions: {
    "<4.0": {
      "types/*": [
        "types/ts3.4/*"
      ]
    }
  },
  author: {
    name: "AWS SDK for JavaScript Team",
    url: "https://aws.amazon.com/javascript/"
  },
  license: "Apache-2.0",
  homepage: "https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-firehose",
  repository: {
    type: "git",
    url: "https://github.com/aws/aws-sdk-js-v3.git",
    directory: "clients/client-firehose"
  }
};

// node_modules/@aws-sdk/client-firehose/dist/es/runtimeConfig.browser.js
var import_sha256_browser3 = __toESM(require_build19());

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-sdk/util-user-agent-browser/node_modules/tslib/tslib.es6.js
function __awaiter39(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator40(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-sdk/util-user-agent-browser/dist/es/index.js
var defaultUserAgent3 = function(_a2) {
  var serviceId = _a2.serviceId, clientVersion = _a2.clientVersion;
  return function() {
    return __awaiter39(void 0, void 0, void 0, function() {
      var parsedUA, sections;
      var _a3, _b2, _c, _d, _e, _f, _g;
      return __generator40(this, function(_h) {
        parsedUA = ((_a3 = window === null || window === void 0 ? void 0 : window.navigator) === null || _a3 === void 0 ? void 0 : _a3.userAgent) ? bowser_default.parse(window.navigator.userAgent) : void 0;
        sections = [
          // sdk-metadata
          ["aws-sdk-js", clientVersion],
          // os-metadata
          ["os/" + (((_b2 = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b2 === void 0 ? void 0 : _b2.name) || "other"), (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version],
          // language-metadata
          // ECMAScript edition doesn't matter in JS.
          ["lang/js"],
          // browser vendor and version.
          ["md/browser", ((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown") + "_" + ((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")]
        ];
        if (serviceId) {
          sections.push(["api/" + serviceId, clientVersion]);
        }
        return [2, sections];
      });
    });
  };
};

// node_modules/@aws-sdk/client-firehose/dist/es/runtimeConfig.browser.js
init_es3();

// node_modules/@aws-sdk/client-firehose/dist/es/endpoints.js
var AWS_TEMPLATE3 = "firehose.{region}.amazonaws.com";
var AWS_CN_TEMPLATE3 = "firehose.{region}.amazonaws.com.cn";
var AWS_ISO_TEMPLATE3 = "firehose.{region}.c2s.ic.gov";
var AWS_ISO_B_TEMPLATE3 = "firehose.{region}.sc2s.sgov.gov";
var AWS_US_GOV_TEMPLATE3 = "firehose.{region}.amazonaws.com";
var AWS_REGIONS3 = /* @__PURE__ */ new Set([
  "af-south-1",
  "ap-east-1",
  "ap-northeast-1",
  "ap-northeast-2",
  "ap-south-1",
  "ap-southeast-1",
  "ap-southeast-2",
  "ca-central-1",
  "eu-central-1",
  "eu-north-1",
  "eu-south-1",
  "eu-west-1",
  "eu-west-2",
  "eu-west-3",
  "me-south-1",
  "sa-east-1",
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2"
]);
var AWS_CN_REGIONS3 = /* @__PURE__ */ new Set(["cn-north-1", "cn-northwest-1"]);
var AWS_ISO_REGIONS3 = /* @__PURE__ */ new Set(["us-iso-east-1"]);
var AWS_ISO_B_REGIONS3 = /* @__PURE__ */ new Set(["us-isob-east-1"]);
var AWS_US_GOV_REGIONS3 = /* @__PURE__ */ new Set(["us-gov-east-1", "us-gov-west-1"]);
var defaultRegionInfoProvider3 = function(region, options) {
  var regionInfo = void 0;
  switch (region) {
    case "af-south-1":
      regionInfo = {
        hostname: "firehose.af-south-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-east-1":
      regionInfo = {
        hostname: "firehose.ap-east-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-northeast-1":
      regionInfo = {
        hostname: "firehose.ap-northeast-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-northeast-2":
      regionInfo = {
        hostname: "firehose.ap-northeast-2.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-south-1":
      regionInfo = {
        hostname: "firehose.ap-south-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-southeast-1":
      regionInfo = {
        hostname: "firehose.ap-southeast-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-southeast-2":
      regionInfo = {
        hostname: "firehose.ap-southeast-2.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ca-central-1":
      regionInfo = {
        hostname: "firehose.ca-central-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "cn-north-1":
      regionInfo = {
        hostname: "firehose.cn-north-1.amazonaws.com.cn",
        partition: "aws-cn"
      };
      break;
    case "cn-northwest-1":
      regionInfo = {
        hostname: "firehose.cn-northwest-1.amazonaws.com.cn",
        partition: "aws-cn"
      };
      break;
    case "eu-central-1":
      regionInfo = {
        hostname: "firehose.eu-central-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "eu-north-1":
      regionInfo = {
        hostname: "firehose.eu-north-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "eu-south-1":
      regionInfo = {
        hostname: "firehose.eu-south-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "eu-west-1":
      regionInfo = {
        hostname: "firehose.eu-west-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "eu-west-2":
      regionInfo = {
        hostname: "firehose.eu-west-2.amazonaws.com",
        partition: "aws"
      };
      break;
    case "eu-west-3":
      regionInfo = {
        hostname: "firehose.eu-west-3.amazonaws.com",
        partition: "aws"
      };
      break;
    case "fips-us-east-1":
      regionInfo = {
        hostname: "firehose-fips.us-east-1.amazonaws.com",
        partition: "aws",
        signingRegion: "us-east-1"
      };
      break;
    case "fips-us-east-2":
      regionInfo = {
        hostname: "firehose-fips.us-east-2.amazonaws.com",
        partition: "aws",
        signingRegion: "us-east-2"
      };
      break;
    case "fips-us-gov-east-1":
      regionInfo = {
        hostname: "firehose-fips.us-gov-east-1.amazonaws.com",
        partition: "aws-us-gov",
        signingRegion: "us-gov-east-1"
      };
      break;
    case "fips-us-gov-west-1":
      regionInfo = {
        hostname: "firehose-fips.us-gov-west-1.amazonaws.com",
        partition: "aws-us-gov",
        signingRegion: "us-gov-west-1"
      };
      break;
    case "fips-us-west-1":
      regionInfo = {
        hostname: "firehose-fips.us-west-1.amazonaws.com",
        partition: "aws",
        signingRegion: "us-west-1"
      };
      break;
    case "fips-us-west-2":
      regionInfo = {
        hostname: "firehose-fips.us-west-2.amazonaws.com",
        partition: "aws",
        signingRegion: "us-west-2"
      };
      break;
    case "me-south-1":
      regionInfo = {
        hostname: "firehose.me-south-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "sa-east-1":
      regionInfo = {
        hostname: "firehose.sa-east-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "us-east-1":
      regionInfo = {
        hostname: "firehose.us-east-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "us-east-2":
      regionInfo = {
        hostname: "firehose.us-east-2.amazonaws.com",
        partition: "aws"
      };
      break;
    case "us-gov-east-1":
      regionInfo = {
        hostname: "firehose.us-gov-east-1.amazonaws.com",
        partition: "aws-us-gov"
      };
      break;
    case "us-gov-west-1":
      regionInfo = {
        hostname: "firehose.us-gov-west-1.amazonaws.com",
        partition: "aws-us-gov"
      };
      break;
    case "us-west-1":
      regionInfo = {
        hostname: "firehose.us-west-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "us-west-2":
      regionInfo = {
        hostname: "firehose.us-west-2.amazonaws.com",
        partition: "aws"
      };
      break;
    default:
      if (AWS_REGIONS3.has(region)) {
        regionInfo = {
          hostname: AWS_TEMPLATE3.replace("{region}", region),
          partition: "aws"
        };
      }
      if (AWS_CN_REGIONS3.has(region)) {
        regionInfo = {
          hostname: AWS_CN_TEMPLATE3.replace("{region}", region),
          partition: "aws-cn"
        };
      }
      if (AWS_ISO_REGIONS3.has(region)) {
        regionInfo = {
          hostname: AWS_ISO_TEMPLATE3.replace("{region}", region),
          partition: "aws-iso"
        };
      }
      if (AWS_ISO_B_REGIONS3.has(region)) {
        regionInfo = {
          hostname: AWS_ISO_B_TEMPLATE3.replace("{region}", region),
          partition: "aws-iso-b"
        };
      }
      if (AWS_US_GOV_REGIONS3.has(region)) {
        regionInfo = {
          hostname: AWS_US_GOV_TEMPLATE3.replace("{region}", region),
          partition: "aws-us-gov"
        };
      }
      if (regionInfo === void 0) {
        regionInfo = {
          hostname: AWS_TEMPLATE3.replace("{region}", region),
          partition: "aws"
        };
      }
  }
  return Promise.resolve(__assign7({ signingService: "firehose" }, regionInfo));
};

// node_modules/@aws-sdk/client-firehose/dist/es/runtimeConfig.shared.js
var ClientSharedValues3 = {
  apiVersion: "2015-08-04",
  disableHostPrefix: false,
  logger: {},
  regionInfoProvider: defaultRegionInfoProvider3,
  serviceId: "Firehose",
  urlParser: parseUrl
};

// node_modules/@aws-sdk/client-firehose/dist/es/runtimeConfig.browser.js
var ClientDefaultValues3 = __assign7(__assign7({}, ClientSharedValues3), { runtime: "browser", base64Decoder: fromBase64, base64Encoder: toBase64, bodyLengthChecker: calculateBodyLength, credentialDefaultProvider: function(_2) {
  return function() {
    return Promise.reject(new Error("Credential is missing"));
  };
}, defaultUserAgentProvider: defaultUserAgent3({
  serviceId: ClientSharedValues3.serviceId,
  clientVersion: package_default3.version
}), maxAttempts: DEFAULT_MAX_ATTEMPTS, region: invalidProvider("Region is missing"), requestHandler: new FetchHttpHandler(), sha256: import_sha256_browser3.Sha256, streamCollector, utf8Decoder: fromUtf815, utf8Encoder: toUtf814 });

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-sdk/middleware-host-header/node_modules/tslib/tslib.es6.js
function __awaiter40(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator41(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-sdk/middleware-host-header/dist/es/index.js
function resolveHostHeaderConfig3(input) {
  return input;
}
var hostHeaderMiddleware3 = function(options) {
  return function(next) {
    return function(args) {
      return __awaiter40(void 0, void 0, void 0, function() {
        var request, _a2, handlerProtocol;
        return __generator41(this, function(_b2) {
          if (!HttpRequest.isInstance(args.request))
            return [2, next(args)];
          request = args.request;
          _a2 = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a2 === void 0 ? "" : _a2;
          if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
            delete request.headers["host"];
            request.headers[":authority"] = "";
          } else if (!request.headers["host"]) {
            request.headers["host"] = request.hostname;
          }
          return [2, next(args)];
        });
      });
    };
  };
};
var hostHeaderMiddlewareOptions3 = {
  name: "hostHeaderMiddleware",
  step: "build",
  priority: "low",
  tags: ["HOST"],
  override: true
};
var getHostHeaderPlugin3 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(hostHeaderMiddleware3(options), hostHeaderMiddlewareOptions3);
    }
  };
};

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-sdk/middleware-logger/node_modules/tslib/tslib.es6.js
function __rest7(s2, e) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
}
function __awaiter41(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator42(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-sdk/middleware-logger/dist/es/loggerMiddleware.js
var loggerMiddleware3 = function() {
  return function(next, context) {
    return function(args) {
      return __awaiter41(void 0, void 0, void 0, function() {
        var clientName, commandName, inputFilterSensitiveLog, logger64, outputFilterSensitiveLog, response, _a2, $metadata, outputWithoutMetadata;
        return __generator42(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger64 = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
              return [4, next(args)];
            case 1:
              response = _b2.sent();
              if (!logger64) {
                return [2, response];
              }
              if (typeof logger64.info === "function") {
                _a2 = response.output, $metadata = _a2.$metadata, outputWithoutMetadata = __rest7(_a2, ["$metadata"]);
                logger64.info({
                  clientName,
                  commandName,
                  input: inputFilterSensitiveLog(args.input),
                  output: outputFilterSensitiveLog(outputWithoutMetadata),
                  metadata: $metadata
                });
              }
              return [2, response];
          }
        });
      });
    };
  };
};
var loggerMiddlewareOptions3 = {
  name: "loggerMiddleware",
  tags: ["LOGGER"],
  step: "initialize",
  override: true
};
var getLoggerPlugin3 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(loggerMiddleware3(), loggerMiddlewareOptions3);
    }
  };
};

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-sdk/middleware-signing/node_modules/tslib/tslib.es6.js
var __assign27 = function() {
  __assign27 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign27.apply(this, arguments);
};
function __awaiter42(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator43(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __read24(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-sdk/middleware-signing/dist/es/configurations.js
function resolveAwsAuthConfig3(input) {
  var _this = this;
  var credentials = input.credentials || input.credentialDefaultProvider(input);
  var normalizedCreds = normalizeProvider3(credentials);
  var _a2 = input.signingEscapePath, signingEscapePath = _a2 === void 0 ? true : _a2, _b2 = input.systemClockOffset, systemClockOffset = _b2 === void 0 ? input.systemClockOffset || 0 : _b2, sha256 = input.sha256;
  var signer;
  if (input.signer) {
    signer = normalizeProvider3(input.signer);
  } else {
    signer = function() {
      return normalizeProvider3(input.region)().then(function(region) {
        return __awaiter42(_this, void 0, void 0, function() {
          return __generator43(this, function(_a3) {
            switch (_a3.label) {
              case 0:
                return [4, input.regionInfoProvider(region)];
              case 1:
                return [2, [_a3.sent() || {}, region]];
            }
          });
        });
      }).then(function(_a3) {
        var _b3 = __read24(_a3, 2), regionInfo = _b3[0], region = _b3[1];
        var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
        input.signingRegion = input.signingRegion || signingRegion || region;
        input.signingName = input.signingName || signingService || input.serviceId;
        return new SignatureV4({
          credentials: normalizedCreds,
          region: input.signingRegion,
          service: input.signingName,
          sha256,
          uriEscapePath: signingEscapePath
        });
      });
    };
  }
  return __assign27(__assign27({}, input), {
    systemClockOffset,
    signingEscapePath,
    credentials: normalizedCreds,
    signer
  });
}
function normalizeProvider3(input) {
  if (typeof input === "object") {
    var promisified_1 = Promise.resolve(input);
    return function() {
      return promisified_1;
    };
  }
  return input;
}

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-sdk/middleware-signing/dist/es/middleware.js
var isClockSkewed4 = function(newServerTime, systemClockOffset) {
  return Math.abs(getSkewCorrectedDate4(systemClockOffset).getTime() - newServerTime) >= 3e5;
};
var getSkewCorrectedDate4 = function(systemClockOffset) {
  return new Date(Date.now() + systemClockOffset);
};
function awsAuthMiddleware3(options) {
  return function(next, context) {
    return function(args) {
      return __awaiter42(this, void 0, void 0, function() {
        var signer, _a2, output, _b2, _c, headers, dateHeader, serverTime;
        var _d;
        return __generator43(this, function(_e) {
          switch (_e.label) {
            case 0:
              if (!HttpRequest.isInstance(args.request))
                return [2, next(args)];
              if (!(typeof options.signer === "function"))
                return [3, 2];
              return [4, options.signer()];
            case 1:
              _a2 = _e.sent();
              return [3, 3];
            case 2:
              _a2 = options.signer;
              _e.label = 3;
            case 3:
              signer = _a2;
              _b2 = next;
              _c = [__assign27({}, args)];
              _d = {};
              return [4, signer.sign(args.request, {
                signingDate: new Date(Date.now() + options.systemClockOffset),
                signingRegion: context["signing_region"],
                signingService: context["signing_service"]
              })];
            case 4:
              return [4, _b2.apply(void 0, [__assign27.apply(void 0, _c.concat([(_d.request = _e.sent(), _d)]))])];
            case 5:
              output = _e.sent();
              headers = output.response.headers;
              dateHeader = headers && (headers.date || headers.Date);
              if (dateHeader) {
                serverTime = Date.parse(dateHeader);
                if (isClockSkewed4(serverTime, options.systemClockOffset)) {
                  options.systemClockOffset = serverTime - Date.now();
                }
              }
              return [2, output];
          }
        });
      });
    };
  };
}
var awsAuthMiddlewareOptions3 = {
  name: "awsAuthMiddleware",
  tags: ["SIGNATURE", "AWSAUTH"],
  relation: "after",
  toMiddleware: "retryMiddleware",
  override: true
};
var getAwsAuthPlugin3 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.addRelativeTo(awsAuthMiddleware3(options), awsAuthMiddlewareOptions3);
    }
  };
};

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-sdk/middleware-user-agent/node_modules/tslib/tslib.es6.js
var __assign28 = function() {
  __assign28 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign28.apply(this, arguments);
};
function __awaiter43(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator44(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __read25(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}
function __spread10() {
  for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
    ar = ar.concat(__read25(arguments[i2]));
  return ar;
}

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-sdk/middleware-user-agent/dist/es/configurations.js
function resolveUserAgentConfig3(input) {
  return __assign28(__assign28({}, input), { customUserAgent: typeof input.customUserAgent === "string" ? [[input.customUserAgent]] : input.customUserAgent });
}

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-sdk/middleware-user-agent/dist/es/constants.js
var USER_AGENT3 = "user-agent";
var X_AMZ_USER_AGENT3 = "x-amz-user-agent";
var SPACE3 = " ";
var UA_ESCAPE_REGEX3 = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

// node_modules/@aws-sdk/client-firehose/node_modules/@aws-sdk/middleware-user-agent/dist/es/user-agent-middleware.js
var userAgentMiddleware4 = function(options) {
  return function(next, context) {
    return function(args) {
      return __awaiter43(void 0, void 0, void 0, function() {
        var request, headers, userAgent2, defaultUserAgent8, customUserAgent, normalUAValue;
        var _a2, _b2;
        return __generator44(this, function(_c) {
          switch (_c.label) {
            case 0:
              request = args.request;
              if (!HttpRequest.isInstance(request))
                return [2, next(args)];
              headers = request.headers;
              userAgent2 = ((_a2 = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a2 === void 0 ? void 0 : _a2.map(escapeUserAgent3)) || [];
              return [4, options.defaultUserAgentProvider()];
            case 1:
              defaultUserAgent8 = _c.sent().map(escapeUserAgent3);
              customUserAgent = ((_b2 = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b2 === void 0 ? void 0 : _b2.map(escapeUserAgent3)) || [];
              headers[X_AMZ_USER_AGENT3] = __spread10(defaultUserAgent8, userAgent2, customUserAgent).join(SPACE3);
              normalUAValue = __spread10(defaultUserAgent8.filter(function(section) {
                return section.startsWith("aws-sdk-");
              }), customUserAgent).join(SPACE3);
              if (options.runtime !== "browser" && normalUAValue) {
                headers[USER_AGENT3] = headers[USER_AGENT3] ? headers[USER_AGENT3] + " " + normalUAValue : normalUAValue;
              }
              return [2, next(__assign28(__assign28({}, args), { request }))];
          }
        });
      });
    };
  };
};
var escapeUserAgent3 = function(_a2) {
  var _b2 = __read25(_a2, 2), name = _b2[0], version3 = _b2[1];
  var prefixSeparatorIndex = name.indexOf("/");
  var prefix = name.substring(0, prefixSeparatorIndex);
  var uaName = name.substring(prefixSeparatorIndex + 1);
  if (prefix === "api") {
    uaName = uaName.toLowerCase();
  }
  return [prefix, uaName, version3].filter(function(item) {
    return item && item.length > 0;
  }).map(function(item) {
    return item === null || item === void 0 ? void 0 : item.replace(UA_ESCAPE_REGEX3, "_");
  }).join("/");
};
var getUserAgentMiddlewareOptions3 = {
  name: "getUserAgentMiddleware",
  step: "build",
  priority: "low",
  tags: ["SET_USER_AGENT", "USER_AGENT"],
  override: true
};
var getUserAgentPlugin3 = function(config) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(userAgentMiddleware4(config), getUserAgentMiddlewareOptions3);
    }
  };
};

// node_modules/@aws-sdk/client-firehose/dist/es/FirehoseClient.js
var FirehoseClient = (
  /** @class */
  function(_super) {
    __extends3(FirehoseClient2, _super);
    function FirehoseClient2(configuration) {
      var _this = this;
      var _config_0 = __assign7(__assign7({}, ClientDefaultValues3), configuration);
      var _config_1 = resolveRegionConfig(_config_0);
      var _config_2 = resolveEndpointsConfig(_config_1);
      var _config_3 = resolveAwsAuthConfig3(_config_2);
      var _config_4 = resolveRetryConfig(_config_3);
      var _config_5 = resolveHostHeaderConfig3(_config_4);
      var _config_6 = resolveUserAgentConfig3(_config_5);
      _this = _super.call(this, _config_6) || this;
      _this.config = _config_6;
      _this.middlewareStack.use(getAwsAuthPlugin3(_this.config));
      _this.middlewareStack.use(getRetryPlugin(_this.config));
      _this.middlewareStack.use(getContentLengthPlugin(_this.config));
      _this.middlewareStack.use(getHostHeaderPlugin3(_this.config));
      _this.middlewareStack.use(getLoggerPlugin3(_this.config));
      _this.middlewareStack.use(getUserAgentPlugin3(_this.config));
      return _this;
    }
    FirehoseClient2.prototype.destroy = function() {
      _super.prototype.destroy.call(this);
    };
    return FirehoseClient2;
  }(Client)
);

// node_modules/@aws-sdk/client-firehose/dist/es/models/models_0.js
var BufferingHints;
(function(BufferingHints2) {
  BufferingHints2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(BufferingHints || (BufferingHints = {}));
var CloudWatchLoggingOptions;
(function(CloudWatchLoggingOptions2) {
  CloudWatchLoggingOptions2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CloudWatchLoggingOptions || (CloudWatchLoggingOptions = {}));
var CompressionFormat;
(function(CompressionFormat2) {
  CompressionFormat2["GZIP"] = "GZIP";
  CompressionFormat2["HADOOP_SNAPPY"] = "HADOOP_SNAPPY";
  CompressionFormat2["SNAPPY"] = "Snappy";
  CompressionFormat2["UNCOMPRESSED"] = "UNCOMPRESSED";
  CompressionFormat2["ZIP"] = "ZIP";
})(CompressionFormat || (CompressionFormat = {}));
var ConcurrentModificationException;
(function(ConcurrentModificationException2) {
  ConcurrentModificationException2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ConcurrentModificationException || (ConcurrentModificationException = {}));
var ContentEncoding;
(function(ContentEncoding2) {
  ContentEncoding2["GZIP"] = "GZIP";
  ContentEncoding2["NONE"] = "NONE";
})(ContentEncoding || (ContentEncoding = {}));
var CopyCommand;
(function(CopyCommand2) {
  CopyCommand2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CopyCommand || (CopyCommand = {}));
var KeyType;
(function(KeyType2) {
  KeyType2["AWS_OWNED_CMK"] = "AWS_OWNED_CMK";
  KeyType2["CUSTOMER_MANAGED_CMK"] = "CUSTOMER_MANAGED_CMK";
})(KeyType || (KeyType = {}));
var DeliveryStreamEncryptionConfigurationInput;
(function(DeliveryStreamEncryptionConfigurationInput2) {
  DeliveryStreamEncryptionConfigurationInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeliveryStreamEncryptionConfigurationInput || (DeliveryStreamEncryptionConfigurationInput = {}));
var ElasticsearchBufferingHints;
(function(ElasticsearchBufferingHints2) {
  ElasticsearchBufferingHints2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ElasticsearchBufferingHints || (ElasticsearchBufferingHints = {}));
var ProcessorParameterName;
(function(ProcessorParameterName2) {
  ProcessorParameterName2["BUFFER_INTERVAL_IN_SECONDS"] = "BufferIntervalInSeconds";
  ProcessorParameterName2["BUFFER_SIZE_IN_MB"] = "BufferSizeInMBs";
  ProcessorParameterName2["LAMBDA_ARN"] = "LambdaArn";
  ProcessorParameterName2["LAMBDA_NUMBER_OF_RETRIES"] = "NumberOfRetries";
  ProcessorParameterName2["ROLE_ARN"] = "RoleArn";
})(ProcessorParameterName || (ProcessorParameterName = {}));
var ProcessorParameter;
(function(ProcessorParameter2) {
  ProcessorParameter2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ProcessorParameter || (ProcessorParameter = {}));
var Processor;
(function(Processor2) {
  Processor2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Processor || (Processor = {}));
var ProcessingConfiguration;
(function(ProcessingConfiguration2) {
  ProcessingConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ProcessingConfiguration || (ProcessingConfiguration = {}));
var ElasticsearchRetryOptions;
(function(ElasticsearchRetryOptions2) {
  ElasticsearchRetryOptions2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ElasticsearchRetryOptions || (ElasticsearchRetryOptions = {}));
var KMSEncryptionConfig;
(function(KMSEncryptionConfig2) {
  KMSEncryptionConfig2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(KMSEncryptionConfig || (KMSEncryptionConfig = {}));
var EncryptionConfiguration;
(function(EncryptionConfiguration3) {
  EncryptionConfiguration3.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(EncryptionConfiguration || (EncryptionConfiguration = {}));
var S3DestinationConfiguration;
(function(S3DestinationConfiguration2) {
  S3DestinationConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(S3DestinationConfiguration || (S3DestinationConfiguration = {}));
var VpcConfiguration;
(function(VpcConfiguration2) {
  VpcConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(VpcConfiguration || (VpcConfiguration = {}));
var ElasticsearchDestinationConfiguration;
(function(ElasticsearchDestinationConfiguration2) {
  ElasticsearchDestinationConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ElasticsearchDestinationConfiguration || (ElasticsearchDestinationConfiguration = {}));
var HiveJsonSerDe;
(function(HiveJsonSerDe2) {
  HiveJsonSerDe2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(HiveJsonSerDe || (HiveJsonSerDe = {}));
var OpenXJsonSerDe;
(function(OpenXJsonSerDe2) {
  OpenXJsonSerDe2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(OpenXJsonSerDe || (OpenXJsonSerDe = {}));
var Deserializer;
(function(Deserializer2) {
  Deserializer2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Deserializer || (Deserializer = {}));
var InputFormatConfiguration;
(function(InputFormatConfiguration2) {
  InputFormatConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(InputFormatConfiguration || (InputFormatConfiguration = {}));
var OrcCompression;
(function(OrcCompression2) {
  OrcCompression2["NONE"] = "NONE";
  OrcCompression2["SNAPPY"] = "SNAPPY";
  OrcCompression2["ZLIB"] = "ZLIB";
})(OrcCompression || (OrcCompression = {}));
var OrcFormatVersion;
(function(OrcFormatVersion2) {
  OrcFormatVersion2["V0_11"] = "V0_11";
  OrcFormatVersion2["V0_12"] = "V0_12";
})(OrcFormatVersion || (OrcFormatVersion = {}));
var OrcSerDe;
(function(OrcSerDe2) {
  OrcSerDe2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(OrcSerDe || (OrcSerDe = {}));
var ParquetCompression;
(function(ParquetCompression2) {
  ParquetCompression2["GZIP"] = "GZIP";
  ParquetCompression2["SNAPPY"] = "SNAPPY";
  ParquetCompression2["UNCOMPRESSED"] = "UNCOMPRESSED";
})(ParquetCompression || (ParquetCompression = {}));
var ParquetWriterVersion;
(function(ParquetWriterVersion2) {
  ParquetWriterVersion2["V1"] = "V1";
  ParquetWriterVersion2["V2"] = "V2";
})(ParquetWriterVersion || (ParquetWriterVersion = {}));
var ParquetSerDe;
(function(ParquetSerDe2) {
  ParquetSerDe2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ParquetSerDe || (ParquetSerDe = {}));
var Serializer;
(function(Serializer2) {
  Serializer2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Serializer || (Serializer = {}));
var OutputFormatConfiguration;
(function(OutputFormatConfiguration2) {
  OutputFormatConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(OutputFormatConfiguration || (OutputFormatConfiguration = {}));
var SchemaConfiguration;
(function(SchemaConfiguration2) {
  SchemaConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(SchemaConfiguration || (SchemaConfiguration = {}));
var DataFormatConversionConfiguration;
(function(DataFormatConversionConfiguration2) {
  DataFormatConversionConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DataFormatConversionConfiguration || (DataFormatConversionConfiguration = {}));
var ExtendedS3DestinationConfiguration;
(function(ExtendedS3DestinationConfiguration2) {
  ExtendedS3DestinationConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ExtendedS3DestinationConfiguration || (ExtendedS3DestinationConfiguration = {}));
var HttpEndpointBufferingHints;
(function(HttpEndpointBufferingHints2) {
  HttpEndpointBufferingHints2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(HttpEndpointBufferingHints || (HttpEndpointBufferingHints = {}));
var HttpEndpointConfiguration;
(function(HttpEndpointConfiguration2) {
  HttpEndpointConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7(__assign7({}, obj), obj.Url && { Url: SENSITIVE_STRING }), obj.AccessKey && { AccessKey: SENSITIVE_STRING });
  };
})(HttpEndpointConfiguration || (HttpEndpointConfiguration = {}));
var HttpEndpointCommonAttribute;
(function(HttpEndpointCommonAttribute2) {
  HttpEndpointCommonAttribute2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7(__assign7({}, obj), obj.AttributeName && { AttributeName: SENSITIVE_STRING }), obj.AttributeValue && { AttributeValue: SENSITIVE_STRING });
  };
})(HttpEndpointCommonAttribute || (HttpEndpointCommonAttribute = {}));
var HttpEndpointRequestConfiguration;
(function(HttpEndpointRequestConfiguration2) {
  HttpEndpointRequestConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.CommonAttributes && {
      CommonAttributes: obj.CommonAttributes.map(function(item) {
        return HttpEndpointCommonAttribute.filterSensitiveLog(item);
      })
    });
  };
})(HttpEndpointRequestConfiguration || (HttpEndpointRequestConfiguration = {}));
var HttpEndpointRetryOptions;
(function(HttpEndpointRetryOptions2) {
  HttpEndpointRetryOptions2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(HttpEndpointRetryOptions || (HttpEndpointRetryOptions = {}));
var HttpEndpointDestinationConfiguration;
(function(HttpEndpointDestinationConfiguration2) {
  HttpEndpointDestinationConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7(__assign7({}, obj), obj.EndpointConfiguration && {
      EndpointConfiguration: HttpEndpointConfiguration.filterSensitiveLog(obj.EndpointConfiguration)
    }), obj.RequestConfiguration && {
      RequestConfiguration: HttpEndpointRequestConfiguration.filterSensitiveLog(obj.RequestConfiguration)
    });
  };
})(HttpEndpointDestinationConfiguration || (HttpEndpointDestinationConfiguration = {}));
var KinesisStreamSourceConfiguration;
(function(KinesisStreamSourceConfiguration2) {
  KinesisStreamSourceConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(KinesisStreamSourceConfiguration || (KinesisStreamSourceConfiguration = {}));
var RedshiftRetryOptions;
(function(RedshiftRetryOptions2) {
  RedshiftRetryOptions2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(RedshiftRetryOptions || (RedshiftRetryOptions = {}));
var RedshiftDestinationConfiguration;
(function(RedshiftDestinationConfiguration2) {
  RedshiftDestinationConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7(__assign7({}, obj), obj.Username && { Username: SENSITIVE_STRING }), obj.Password && { Password: SENSITIVE_STRING });
  };
})(RedshiftDestinationConfiguration || (RedshiftDestinationConfiguration = {}));
var SplunkRetryOptions;
(function(SplunkRetryOptions2) {
  SplunkRetryOptions2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(SplunkRetryOptions || (SplunkRetryOptions = {}));
var SplunkDestinationConfiguration;
(function(SplunkDestinationConfiguration2) {
  SplunkDestinationConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(SplunkDestinationConfiguration || (SplunkDestinationConfiguration = {}));
var Tag2;
(function(Tag4) {
  Tag4.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Tag2 || (Tag2 = {}));
var CreateDeliveryStreamInput;
(function(CreateDeliveryStreamInput2) {
  CreateDeliveryStreamInput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7(__assign7({}, obj), obj.RedshiftDestinationConfiguration && {
      RedshiftDestinationConfiguration: RedshiftDestinationConfiguration.filterSensitiveLog(obj.RedshiftDestinationConfiguration)
    }), obj.HttpEndpointDestinationConfiguration && {
      HttpEndpointDestinationConfiguration: HttpEndpointDestinationConfiguration.filterSensitiveLog(obj.HttpEndpointDestinationConfiguration)
    });
  };
})(CreateDeliveryStreamInput || (CreateDeliveryStreamInput = {}));
var CreateDeliveryStreamOutput;
(function(CreateDeliveryStreamOutput2) {
  CreateDeliveryStreamOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CreateDeliveryStreamOutput || (CreateDeliveryStreamOutput = {}));
var InvalidArgumentException2;
(function(InvalidArgumentException3) {
  InvalidArgumentException3.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(InvalidArgumentException2 || (InvalidArgumentException2 = {}));
var InvalidKMSResourceException;
(function(InvalidKMSResourceException2) {
  InvalidKMSResourceException2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(InvalidKMSResourceException || (InvalidKMSResourceException = {}));
var LimitExceededException3;
(function(LimitExceededException5) {
  LimitExceededException5.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(LimitExceededException3 || (LimitExceededException3 = {}));
var ResourceInUseException2;
(function(ResourceInUseException3) {
  ResourceInUseException3.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ResourceInUseException2 || (ResourceInUseException2 = {}));
var DeleteDeliveryStreamInput;
(function(DeleteDeliveryStreamInput2) {
  DeleteDeliveryStreamInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteDeliveryStreamInput || (DeleteDeliveryStreamInput = {}));
var DeleteDeliveryStreamOutput;
(function(DeleteDeliveryStreamOutput2) {
  DeleteDeliveryStreamOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteDeliveryStreamOutput || (DeleteDeliveryStreamOutput = {}));
var ResourceNotFoundException3;
(function(ResourceNotFoundException6) {
  ResourceNotFoundException6.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ResourceNotFoundException3 || (ResourceNotFoundException3 = {}));
var DeliveryStreamFailureType;
(function(DeliveryStreamFailureType2) {
  DeliveryStreamFailureType2["CREATE_ENI_FAILED"] = "CREATE_ENI_FAILED";
  DeliveryStreamFailureType2["CREATE_KMS_GRANT_FAILED"] = "CREATE_KMS_GRANT_FAILED";
  DeliveryStreamFailureType2["DELETE_ENI_FAILED"] = "DELETE_ENI_FAILED";
  DeliveryStreamFailureType2["DISABLED_KMS_KEY"] = "DISABLED_KMS_KEY";
  DeliveryStreamFailureType2["ENI_ACCESS_DENIED"] = "ENI_ACCESS_DENIED";
  DeliveryStreamFailureType2["INVALID_KMS_KEY"] = "INVALID_KMS_KEY";
  DeliveryStreamFailureType2["KMS_ACCESS_DENIED"] = "KMS_ACCESS_DENIED";
  DeliveryStreamFailureType2["KMS_KEY_NOT_FOUND"] = "KMS_KEY_NOT_FOUND";
  DeliveryStreamFailureType2["KMS_OPT_IN_REQUIRED"] = "KMS_OPT_IN_REQUIRED";
  DeliveryStreamFailureType2["RETIRE_KMS_GRANT_FAILED"] = "RETIRE_KMS_GRANT_FAILED";
  DeliveryStreamFailureType2["SECURITY_GROUP_ACCESS_DENIED"] = "SECURITY_GROUP_ACCESS_DENIED";
  DeliveryStreamFailureType2["SECURITY_GROUP_NOT_FOUND"] = "SECURITY_GROUP_NOT_FOUND";
  DeliveryStreamFailureType2["SUBNET_ACCESS_DENIED"] = "SUBNET_ACCESS_DENIED";
  DeliveryStreamFailureType2["SUBNET_NOT_FOUND"] = "SUBNET_NOT_FOUND";
  DeliveryStreamFailureType2["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(DeliveryStreamFailureType || (DeliveryStreamFailureType = {}));
var FailureDescription;
(function(FailureDescription2) {
  FailureDescription2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(FailureDescription || (FailureDescription = {}));
var DeliveryStreamEncryptionStatus;
(function(DeliveryStreamEncryptionStatus2) {
  DeliveryStreamEncryptionStatus2["DISABLED"] = "DISABLED";
  DeliveryStreamEncryptionStatus2["DISABLING"] = "DISABLING";
  DeliveryStreamEncryptionStatus2["DISABLING_FAILED"] = "DISABLING_FAILED";
  DeliveryStreamEncryptionStatus2["ENABLED"] = "ENABLED";
  DeliveryStreamEncryptionStatus2["ENABLING"] = "ENABLING";
  DeliveryStreamEncryptionStatus2["ENABLING_FAILED"] = "ENABLING_FAILED";
})(DeliveryStreamEncryptionStatus || (DeliveryStreamEncryptionStatus = {}));
var DeliveryStreamEncryptionConfiguration;
(function(DeliveryStreamEncryptionConfiguration2) {
  DeliveryStreamEncryptionConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeliveryStreamEncryptionConfiguration || (DeliveryStreamEncryptionConfiguration = {}));
var DeliveryStreamStatus;
(function(DeliveryStreamStatus2) {
  DeliveryStreamStatus2["ACTIVE"] = "ACTIVE";
  DeliveryStreamStatus2["CREATING"] = "CREATING";
  DeliveryStreamStatus2["CREATING_FAILED"] = "CREATING_FAILED";
  DeliveryStreamStatus2["DELETING"] = "DELETING";
  DeliveryStreamStatus2["DELETING_FAILED"] = "DELETING_FAILED";
})(DeliveryStreamStatus || (DeliveryStreamStatus = {}));
var S3DestinationDescription;
(function(S3DestinationDescription2) {
  S3DestinationDescription2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(S3DestinationDescription || (S3DestinationDescription = {}));
var VpcConfigurationDescription;
(function(VpcConfigurationDescription2) {
  VpcConfigurationDescription2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(VpcConfigurationDescription || (VpcConfigurationDescription = {}));
var ElasticsearchDestinationDescription;
(function(ElasticsearchDestinationDescription2) {
  ElasticsearchDestinationDescription2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ElasticsearchDestinationDescription || (ElasticsearchDestinationDescription = {}));
var ExtendedS3DestinationDescription;
(function(ExtendedS3DestinationDescription2) {
  ExtendedS3DestinationDescription2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ExtendedS3DestinationDescription || (ExtendedS3DestinationDescription = {}));
var HttpEndpointDescription;
(function(HttpEndpointDescription2) {
  HttpEndpointDescription2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.Url && { Url: SENSITIVE_STRING });
  };
})(HttpEndpointDescription || (HttpEndpointDescription = {}));
var HttpEndpointDestinationDescription;
(function(HttpEndpointDestinationDescription2) {
  HttpEndpointDestinationDescription2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7(__assign7({}, obj), obj.EndpointConfiguration && {
      EndpointConfiguration: HttpEndpointDescription.filterSensitiveLog(obj.EndpointConfiguration)
    }), obj.RequestConfiguration && {
      RequestConfiguration: HttpEndpointRequestConfiguration.filterSensitiveLog(obj.RequestConfiguration)
    });
  };
})(HttpEndpointDestinationDescription || (HttpEndpointDestinationDescription = {}));
var RedshiftDestinationDescription;
(function(RedshiftDestinationDescription2) {
  RedshiftDestinationDescription2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.Username && { Username: SENSITIVE_STRING });
  };
})(RedshiftDestinationDescription || (RedshiftDestinationDescription = {}));
var SplunkDestinationDescription;
(function(SplunkDestinationDescription2) {
  SplunkDestinationDescription2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(SplunkDestinationDescription || (SplunkDestinationDescription = {}));
var DestinationDescription;
(function(DestinationDescription2) {
  DestinationDescription2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7(__assign7({}, obj), obj.RedshiftDestinationDescription && {
      RedshiftDestinationDescription: RedshiftDestinationDescription.filterSensitiveLog(obj.RedshiftDestinationDescription)
    }), obj.HttpEndpointDestinationDescription && {
      HttpEndpointDestinationDescription: HttpEndpointDestinationDescription.filterSensitiveLog(obj.HttpEndpointDestinationDescription)
    });
  };
})(DestinationDescription || (DestinationDescription = {}));
var KinesisStreamSourceDescription;
(function(KinesisStreamSourceDescription2) {
  KinesisStreamSourceDescription2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(KinesisStreamSourceDescription || (KinesisStreamSourceDescription = {}));
var SourceDescription;
(function(SourceDescription2) {
  SourceDescription2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(SourceDescription || (SourceDescription = {}));
var DeliveryStreamDescription;
(function(DeliveryStreamDescription2) {
  DeliveryStreamDescription2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.Destinations && {
      Destinations: obj.Destinations.map(function(item) {
        return DestinationDescription.filterSensitiveLog(item);
      })
    });
  };
})(DeliveryStreamDescription || (DeliveryStreamDescription = {}));
var DescribeDeliveryStreamInput;
(function(DescribeDeliveryStreamInput2) {
  DescribeDeliveryStreamInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DescribeDeliveryStreamInput || (DescribeDeliveryStreamInput = {}));
var DescribeDeliveryStreamOutput;
(function(DescribeDeliveryStreamOutput2) {
  DescribeDeliveryStreamOutput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.DeliveryStreamDescription && {
      DeliveryStreamDescription: DeliveryStreamDescription.filterSensitiveLog(obj.DeliveryStreamDescription)
    });
  };
})(DescribeDeliveryStreamOutput || (DescribeDeliveryStreamOutput = {}));
var S3DestinationUpdate;
(function(S3DestinationUpdate2) {
  S3DestinationUpdate2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(S3DestinationUpdate || (S3DestinationUpdate = {}));
var ElasticsearchDestinationUpdate;
(function(ElasticsearchDestinationUpdate2) {
  ElasticsearchDestinationUpdate2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ElasticsearchDestinationUpdate || (ElasticsearchDestinationUpdate = {}));
var ExtendedS3DestinationUpdate;
(function(ExtendedS3DestinationUpdate2) {
  ExtendedS3DestinationUpdate2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ExtendedS3DestinationUpdate || (ExtendedS3DestinationUpdate = {}));
var ListDeliveryStreamsInput;
(function(ListDeliveryStreamsInput2) {
  ListDeliveryStreamsInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListDeliveryStreamsInput || (ListDeliveryStreamsInput = {}));
var ListDeliveryStreamsOutput;
(function(ListDeliveryStreamsOutput2) {
  ListDeliveryStreamsOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListDeliveryStreamsOutput || (ListDeliveryStreamsOutput = {}));
var ListTagsForDeliveryStreamInput;
(function(ListTagsForDeliveryStreamInput2) {
  ListTagsForDeliveryStreamInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListTagsForDeliveryStreamInput || (ListTagsForDeliveryStreamInput = {}));
var ListTagsForDeliveryStreamOutput;
(function(ListTagsForDeliveryStreamOutput2) {
  ListTagsForDeliveryStreamOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListTagsForDeliveryStreamOutput || (ListTagsForDeliveryStreamOutput = {}));
var _Record2;
(function(_Record3) {
  _Record3.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(_Record2 || (_Record2 = {}));
var PutRecordInput2;
(function(PutRecordInput3) {
  PutRecordInput3.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutRecordInput2 || (PutRecordInput2 = {}));
var PutRecordOutput2;
(function(PutRecordOutput3) {
  PutRecordOutput3.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutRecordOutput2 || (PutRecordOutput2 = {}));
var ServiceUnavailableException2;
(function(ServiceUnavailableException3) {
  ServiceUnavailableException3.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ServiceUnavailableException2 || (ServiceUnavailableException2 = {}));
var PutRecordBatchInput;
(function(PutRecordBatchInput2) {
  PutRecordBatchInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutRecordBatchInput || (PutRecordBatchInput = {}));
var PutRecordBatchResponseEntry;
(function(PutRecordBatchResponseEntry2) {
  PutRecordBatchResponseEntry2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutRecordBatchResponseEntry || (PutRecordBatchResponseEntry = {}));
var PutRecordBatchOutput;
(function(PutRecordBatchOutput2) {
  PutRecordBatchOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutRecordBatchOutput || (PutRecordBatchOutput = {}));
var StartDeliveryStreamEncryptionInput;
(function(StartDeliveryStreamEncryptionInput2) {
  StartDeliveryStreamEncryptionInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(StartDeliveryStreamEncryptionInput || (StartDeliveryStreamEncryptionInput = {}));
var StartDeliveryStreamEncryptionOutput;
(function(StartDeliveryStreamEncryptionOutput2) {
  StartDeliveryStreamEncryptionOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(StartDeliveryStreamEncryptionOutput || (StartDeliveryStreamEncryptionOutput = {}));
var StopDeliveryStreamEncryptionInput;
(function(StopDeliveryStreamEncryptionInput2) {
  StopDeliveryStreamEncryptionInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(StopDeliveryStreamEncryptionInput || (StopDeliveryStreamEncryptionInput = {}));
var StopDeliveryStreamEncryptionOutput;
(function(StopDeliveryStreamEncryptionOutput2) {
  StopDeliveryStreamEncryptionOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(StopDeliveryStreamEncryptionOutput || (StopDeliveryStreamEncryptionOutput = {}));
var TagDeliveryStreamInput;
(function(TagDeliveryStreamInput2) {
  TagDeliveryStreamInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(TagDeliveryStreamInput || (TagDeliveryStreamInput = {}));
var TagDeliveryStreamOutput;
(function(TagDeliveryStreamOutput2) {
  TagDeliveryStreamOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(TagDeliveryStreamOutput || (TagDeliveryStreamOutput = {}));
var UntagDeliveryStreamInput;
(function(UntagDeliveryStreamInput2) {
  UntagDeliveryStreamInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(UntagDeliveryStreamInput || (UntagDeliveryStreamInput = {}));
var UntagDeliveryStreamOutput;
(function(UntagDeliveryStreamOutput2) {
  UntagDeliveryStreamOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(UntagDeliveryStreamOutput || (UntagDeliveryStreamOutput = {}));
var HttpEndpointDestinationUpdate;
(function(HttpEndpointDestinationUpdate2) {
  HttpEndpointDestinationUpdate2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7(__assign7({}, obj), obj.EndpointConfiguration && {
      EndpointConfiguration: HttpEndpointConfiguration.filterSensitiveLog(obj.EndpointConfiguration)
    }), obj.RequestConfiguration && {
      RequestConfiguration: HttpEndpointRequestConfiguration.filterSensitiveLog(obj.RequestConfiguration)
    });
  };
})(HttpEndpointDestinationUpdate || (HttpEndpointDestinationUpdate = {}));
var RedshiftDestinationUpdate;
(function(RedshiftDestinationUpdate2) {
  RedshiftDestinationUpdate2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7(__assign7({}, obj), obj.Username && { Username: SENSITIVE_STRING }), obj.Password && { Password: SENSITIVE_STRING });
  };
})(RedshiftDestinationUpdate || (RedshiftDestinationUpdate = {}));
var SplunkDestinationUpdate;
(function(SplunkDestinationUpdate2) {
  SplunkDestinationUpdate2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(SplunkDestinationUpdate || (SplunkDestinationUpdate = {}));
var UpdateDestinationInput;
(function(UpdateDestinationInput2) {
  UpdateDestinationInput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7(__assign7({}, obj), obj.RedshiftDestinationUpdate && {
      RedshiftDestinationUpdate: RedshiftDestinationUpdate.filterSensitiveLog(obj.RedshiftDestinationUpdate)
    }), obj.HttpEndpointDestinationUpdate && {
      HttpEndpointDestinationUpdate: HttpEndpointDestinationUpdate.filterSensitiveLog(obj.HttpEndpointDestinationUpdate)
    });
  };
})(UpdateDestinationInput || (UpdateDestinationInput = {}));
var UpdateDestinationOutput;
(function(UpdateDestinationOutput2) {
  UpdateDestinationOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(UpdateDestinationOutput || (UpdateDestinationOutput = {}));

// node_modules/@aws-sdk/client-firehose/dist/es/protocols/Aws_json1_1.js
var serializeAws_json1_1PutRecordBatchCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var headers, body;
    return __generator3(this, function(_a2) {
      headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "Firehose_20150804.PutRecordBatch"
      };
      body = JSON.stringify(serializeAws_json1_1PutRecordBatchInput(input, context));
      return [2, buildHttpRpcRequest4(context, headers, "/", void 0, body)];
    });
  });
};
var deserializeAws_json1_1PutRecordBatchCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var data, contents, response;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (output.statusCode >= 300) {
            return [2, deserializeAws_json1_1PutRecordBatchCommandError(output, context)];
          }
          return [4, parseBody3(output.body, context)];
        case 1:
          data = _a2.sent();
          contents = {};
          contents = deserializeAws_json1_1PutRecordBatchOutput(data, context);
          response = __assign7({ $metadata: deserializeMetadata3(output) }, contents);
          return [2, Promise.resolve(response)];
      }
    });
  });
};
var deserializeAws_json1_1PutRecordBatchCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, response, errorCode, _b2, _c, _d, _e, _f, parsedBody, message;
    var _g;
    return __generator3(this, function(_h) {
      switch (_h.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _g = {};
          return [4, parseBody3(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_g.body = _h.sent(), _g)]));
          errorCode = "UnknownError";
          errorCode = loadRestJsonErrorCode3(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "InvalidArgumentException":
              return [3, 2];
            case "com.amazonaws.firehose#InvalidArgumentException":
              return [3, 2];
            case "InvalidKMSResourceException":
              return [3, 4];
            case "com.amazonaws.firehose#InvalidKMSResourceException":
              return [3, 4];
            case "ResourceNotFoundException":
              return [3, 6];
            case "com.amazonaws.firehose#ResourceNotFoundException":
              return [3, 6];
            case "ServiceUnavailableException":
              return [3, 8];
            case "com.amazonaws.firehose#ServiceUnavailableException":
              return [3, 8];
          }
          return [3, 10];
        case 2:
          _c = [{}];
          return [4, deserializeAws_json1_1InvalidArgumentExceptionResponse2(parsedOutput, context)];
        case 3:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _c.concat([_h.sent()])), { name: errorCode, $metadata: deserializeMetadata3(output) }]);
          return [3, 11];
        case 4:
          _d = [{}];
          return [4, deserializeAws_json1_1InvalidKMSResourceExceptionResponse(parsedOutput, context)];
        case 5:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _d.concat([_h.sent()])), { name: errorCode, $metadata: deserializeMetadata3(output) }]);
          return [3, 11];
        case 6:
          _e = [{}];
          return [4, deserializeAws_json1_1ResourceNotFoundExceptionResponse3(parsedOutput, context)];
        case 7:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _e.concat([_h.sent()])), { name: errorCode, $metadata: deserializeMetadata3(output) }]);
          return [3, 11];
        case 8:
          _f = [{}];
          return [4, deserializeAws_json1_1ServiceUnavailableExceptionResponse2(parsedOutput, context)];
        case 9:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _f.concat([_h.sent()])), { name: errorCode, $metadata: deserializeMetadata3(output) }]);
          return [3, 11];
        case 10:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign7(__assign7({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata3(output) });
          _h.label = 11;
        case 11:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2, Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};
var deserializeAws_json1_1InvalidArgumentExceptionResponse2 = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1InvalidArgumentException2(body, context);
      contents = __assign7({ name: "InvalidArgumentException", $fault: "client", $metadata: deserializeMetadata3(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var deserializeAws_json1_1InvalidKMSResourceExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1InvalidKMSResourceException(body, context);
      contents = __assign7({ name: "InvalidKMSResourceException", $fault: "client", $metadata: deserializeMetadata3(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var deserializeAws_json1_1ResourceNotFoundExceptionResponse3 = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1ResourceNotFoundException3(body, context);
      contents = __assign7({ name: "ResourceNotFoundException", $fault: "client", $metadata: deserializeMetadata3(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var deserializeAws_json1_1ServiceUnavailableExceptionResponse2 = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var body, deserialized, contents;
    return __generator3(this, function(_a2) {
      body = parsedOutput.body;
      deserialized = deserializeAws_json1_1ServiceUnavailableException2(body, context);
      contents = __assign7({ name: "ServiceUnavailableException", $fault: "server", $metadata: deserializeMetadata3(parsedOutput) }, deserialized);
      return [2, contents];
    });
  });
};
var serializeAws_json1_1PutRecordBatchInput = function(input, context) {
  return __assign7(__assign7({}, input.DeliveryStreamName !== void 0 && input.DeliveryStreamName !== null && { DeliveryStreamName: input.DeliveryStreamName }), input.Records !== void 0 && input.Records !== null && {
    Records: serializeAws_json1_1PutRecordBatchRequestEntryList(input.Records, context)
  });
};
var serializeAws_json1_1PutRecordBatchRequestEntryList = function(input, context) {
  return input.filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return serializeAws_json1_1_Record(entry, context);
  });
};
var serializeAws_json1_1_Record = function(input, context) {
  return __assign7({}, input.Data !== void 0 && input.Data !== null && { Data: context.base64Encoder(input.Data) });
};
var deserializeAws_json1_1InvalidArgumentException2 = function(output, context) {
  return {
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeAws_json1_1InvalidKMSResourceException = function(output, context) {
  return {
    code: output.code !== void 0 && output.code !== null ? output.code : void 0,
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeAws_json1_1PutRecordBatchOutput = function(output, context) {
  return {
    Encrypted: output.Encrypted !== void 0 && output.Encrypted !== null ? output.Encrypted : void 0,
    FailedPutCount: output.FailedPutCount !== void 0 && output.FailedPutCount !== null ? output.FailedPutCount : void 0,
    RequestResponses: output.RequestResponses !== void 0 && output.RequestResponses !== null ? deserializeAws_json1_1PutRecordBatchResponseEntryList(output.RequestResponses, context) : void 0
  };
};
var deserializeAws_json1_1PutRecordBatchResponseEntry = function(output, context) {
  return {
    ErrorCode: output.ErrorCode !== void 0 && output.ErrorCode !== null ? output.ErrorCode : void 0,
    ErrorMessage: output.ErrorMessage !== void 0 && output.ErrorMessage !== null ? output.ErrorMessage : void 0,
    RecordId: output.RecordId !== void 0 && output.RecordId !== null ? output.RecordId : void 0
  };
};
var deserializeAws_json1_1PutRecordBatchResponseEntryList = function(output, context) {
  return (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_json1_1PutRecordBatchResponseEntry(entry, context);
  });
};
var deserializeAws_json1_1ResourceNotFoundException3 = function(output, context) {
  return {
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeAws_json1_1ServiceUnavailableException2 = function(output, context) {
  return {
    message: output.message !== void 0 && output.message !== null ? output.message : void 0
  };
};
var deserializeMetadata3 = function(output) {
  var _a2;
  return {
    httpStatusCode: output.statusCode,
    requestId: (_a2 = output.headers["x-amzn-requestid"]) !== null && _a2 !== void 0 ? _a2 : output.headers["x-amzn-request-id"],
    extendedRequestId: output.headers["x-amz-id-2"],
    cfId: output.headers["x-amz-cf-id"]
  };
};
var collectBody3 = function(streamBody, context) {
  if (streamBody === void 0) {
    streamBody = new Uint8Array();
  }
  if (streamBody instanceof Uint8Array) {
    return Promise.resolve(streamBody);
  }
  return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
var collectBodyString3 = function(streamBody, context) {
  return collectBody3(streamBody, context).then(function(body) {
    return context.utf8Encoder(body);
  });
};
var buildHttpRpcRequest4 = function(context, headers, path, resolvedHostname, body) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var _a2, hostname, _b2, protocol, port, contents;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port;
          contents = {
            protocol,
            hostname,
            port,
            method: "POST",
            path,
            headers
          };
          if (resolvedHostname !== void 0) {
            contents.hostname = resolvedHostname;
          }
          if (body !== void 0) {
            contents.body = body;
          }
          return [2, new HttpRequest(contents)];
      }
    });
  });
};
var parseBody3 = function(streamBody, context) {
  return collectBodyString3(streamBody, context).then(function(encoded) {
    if (encoded.length) {
      return JSON.parse(encoded);
    }
    return {};
  });
};
var loadRestJsonErrorCode3 = function(output, data) {
  var findKey = function(object, key) {
    return Object.keys(object).find(function(k2) {
      return k2.toLowerCase() === key.toLowerCase();
    });
  };
  var sanitizeErrorCode = function(rawValue) {
    var cleanValue = rawValue;
    if (cleanValue.indexOf(":") >= 0) {
      cleanValue = cleanValue.split(":")[0];
    }
    if (cleanValue.indexOf("#") >= 0) {
      cleanValue = cleanValue.split("#")[1];
    }
    return cleanValue;
  };
  var headerKey = findKey(output.headers, "x-amzn-errortype");
  if (headerKey !== void 0) {
    return sanitizeErrorCode(output.headers[headerKey]);
  }
  if (data.code !== void 0) {
    return sanitizeErrorCode(data.code);
  }
  if (data["__type"] !== void 0) {
    return sanitizeErrorCode(data["__type"]);
  }
  return "";
};

// node_modules/@aws-sdk/client-firehose/dist/es/commands/PutRecordBatchCommand.js
var PutRecordBatchCommand = (
  /** @class */
  function(_super) {
    __extends3(PutRecordBatchCommand2, _super);
    function PutRecordBatchCommand2(input) {
      var _this = (
        // Start section: command_constructor
        _super.call(this) || this
      );
      _this.input = input;
      return _this;
    }
    PutRecordBatchCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
      this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
      var stack = clientStack.concat(this.middlewareStack);
      var logger64 = configuration.logger;
      var clientName = "FirehoseClient";
      var commandName = "PutRecordBatchCommand";
      var handlerExecutionContext = {
        logger: logger64,
        clientName,
        commandName,
        inputFilterSensitiveLog: PutRecordBatchInput.filterSensitiveLog,
        outputFilterSensitiveLog: PutRecordBatchOutput.filterSensitiveLog
      };
      var requestHandler = configuration.requestHandler;
      return stack.resolve(function(request) {
        return requestHandler.handle(request.request, options || {});
      }, handlerExecutionContext);
    };
    PutRecordBatchCommand2.prototype.serialize = function(input, context) {
      return serializeAws_json1_1PutRecordBatchCommand(input, context);
    };
    PutRecordBatchCommand2.prototype.deserialize = function(output, context) {
      return deserializeAws_json1_1PutRecordBatchCommand(output, context);
    };
    return PutRecordBatchCommand2;
  }(Command)
);

// node_modules/@aws-amplify/analytics/lib-esm/Providers/AWSKinesisFirehoseProvider.js
var logger21 = new ConsoleLogger("AWSKineisFirehoseProvider");
var AWSKinesisFirehoseProvider = (
  /** @class */
  function(_super) {
    __extends5(AWSKinesisFirehoseProvider2, _super);
    function AWSKinesisFirehoseProvider2(config) {
      return _super.call(this, config) || this;
    }
    AWSKinesisFirehoseProvider2.prototype.getProviderName = function() {
      return "AWSKinesisFirehose";
    };
    AWSKinesisFirehoseProvider2.prototype._sendEvents = function(group) {
      var _this = this;
      if (group.length === 0) {
        return;
      }
      var _a2 = group[0], config = _a2.config, credentials = _a2.credentials;
      var initClients = this._init(config, credentials);
      if (!initClients)
        return false;
      var records = {};
      group.map(function(params) {
        var evt = params.event;
        var streamName = evt.streamName, data = evt.data;
        if (records[streamName] === void 0) {
          records[streamName] = [];
        }
        var bufferData = data && typeof data !== "string" ? JSON.stringify(data) : data;
        var Data = fromUtf812(bufferData);
        var record = { Data };
        records[streamName].push(record);
      });
      Object.keys(records).map(function(streamName) {
        logger21.debug("putting records to kinesis", streamName, "with records", records[streamName]);
        _this._kinesisFirehose.send(new PutRecordBatchCommand({
          Records: records[streamName],
          DeliveryStreamName: streamName
        })).then(function(res) {
          return logger21.debug("Upload records to stream", streamName);
        }).catch(function(err) {
          return logger21.debug("Failed to upload records to Kinesis", err);
        });
      });
    };
    AWSKinesisFirehoseProvider2.prototype._init = function(config, credentials) {
      logger21.debug("init clients");
      if (this._kinesisFirehose && this._config.credentials && this._config.credentials.sessionToken === credentials.sessionToken && this._config.credentials.identityId === credentials.identityId) {
        logger21.debug("no change for analytics config, directly return from init");
        return true;
      }
      this._config.credentials = credentials;
      var region = config.region;
      return this._initFirehose(region, credentials);
    };
    AWSKinesisFirehoseProvider2.prototype._initFirehose = function(region, credentials) {
      logger21.debug("initialize kinesis firehose with credentials", credentials);
      this._kinesisFirehose = new FirehoseClient({
        apiVersion: "2015-08-04",
        region,
        credentials,
        customUserAgent: getAnalyticsUserAgent(AnalyticsAction.Record)
      });
      return true;
    };
    return AWSKinesisFirehoseProvider2;
  }(AWSKinesisProvider)
);

// node_modules/@aws-sdk/client-personalize-events/dist/es/package.json
var package_default4 = {
  name: "@aws-sdk/client-personalize-events",
  description: "AWS SDK for JavaScript Personalize Events Client for Node.js, Browser and React Native",
  version: "3.6.1",
  scripts: {
    clean: "yarn remove-definitions && yarn remove-dist && yarn remove-documentation",
    "build-documentation": "yarn remove-documentation && typedoc ./",
    prepublishOnly: "yarn build",
    pretest: "yarn build:cjs",
    "remove-definitions": "rimraf ./types",
    "remove-dist": "rimraf ./dist",
    "remove-documentation": "rimraf ./docs",
    test: "exit 0",
    "build:cjs": "tsc -p tsconfig.json",
    "build:es": "tsc -p tsconfig.es.json",
    build: "yarn build:cjs && yarn build:es",
    postbuild: "downlevel-dts types types/ts3.4"
  },
  main: "./dist/cjs/index.js",
  types: "./types/index.d.ts",
  module: "./dist/es/index.js",
  browser: {
    "./runtimeConfig": "./runtimeConfig.browser"
  },
  "react-native": {
    "./runtimeConfig": "./runtimeConfig.native"
  },
  sideEffects: false,
  dependencies: {
    "@aws-crypto/sha256-browser": "^1.0.0",
    "@aws-crypto/sha256-js": "^1.0.0",
    "@aws-sdk/config-resolver": "3.6.1",
    "@aws-sdk/credential-provider-node": "3.6.1",
    "@aws-sdk/fetch-http-handler": "3.6.1",
    "@aws-sdk/hash-node": "3.6.1",
    "@aws-sdk/invalid-dependency": "3.6.1",
    "@aws-sdk/middleware-content-length": "3.6.1",
    "@aws-sdk/middleware-host-header": "3.6.1",
    "@aws-sdk/middleware-logger": "3.6.1",
    "@aws-sdk/middleware-retry": "3.6.1",
    "@aws-sdk/middleware-serde": "3.6.1",
    "@aws-sdk/middleware-signing": "3.6.1",
    "@aws-sdk/middleware-stack": "3.6.1",
    "@aws-sdk/middleware-user-agent": "3.6.1",
    "@aws-sdk/node-config-provider": "3.6.1",
    "@aws-sdk/node-http-handler": "3.6.1",
    "@aws-sdk/protocol-http": "3.6.1",
    "@aws-sdk/smithy-client": "3.6.1",
    "@aws-sdk/types": "3.6.1",
    "@aws-sdk/url-parser": "3.6.1",
    "@aws-sdk/url-parser-native": "3.6.1",
    "@aws-sdk/util-base64-browser": "3.6.1",
    "@aws-sdk/util-base64-node": "3.6.1",
    "@aws-sdk/util-body-length-browser": "3.6.1",
    "@aws-sdk/util-body-length-node": "3.6.1",
    "@aws-sdk/util-user-agent-browser": "3.6.1",
    "@aws-sdk/util-user-agent-node": "3.6.1",
    "@aws-sdk/util-utf8-browser": "3.6.1",
    "@aws-sdk/util-utf8-node": "3.6.1",
    tslib: "^2.0.0"
  },
  devDependencies: {
    "@aws-sdk/client-documentation-generator": "3.6.1",
    "@types/node": "^12.7.5",
    "downlevel-dts": "0.7.0",
    jest: "^26.1.0",
    rimraf: "^3.0.0",
    typedoc: "^0.19.2",
    typescript: "~4.1.2"
  },
  engines: {
    node: ">=10.0.0"
  },
  typesVersions: {
    "<4.0": {
      "types/*": [
        "types/ts3.4/*"
      ]
    }
  },
  author: {
    name: "AWS SDK for JavaScript Team",
    url: "https://aws.amazon.com/javascript/"
  },
  license: "Apache-2.0",
  homepage: "https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-personalize-events",
  repository: {
    type: "git",
    url: "https://github.com/aws/aws-sdk-js-v3.git",
    directory: "clients/client-personalize-events"
  }
};

// node_modules/@aws-sdk/client-personalize-events/dist/es/runtimeConfig.browser.js
var import_sha256_browser4 = __toESM(require_build24());

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-sdk/util-user-agent-browser/node_modules/tslib/tslib.es6.js
function __awaiter44(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator45(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-sdk/util-user-agent-browser/dist/es/index.js
var defaultUserAgent4 = function(_a2) {
  var serviceId = _a2.serviceId, clientVersion = _a2.clientVersion;
  return function() {
    return __awaiter44(void 0, void 0, void 0, function() {
      var parsedUA, sections;
      var _a3, _b2, _c, _d, _e, _f, _g;
      return __generator45(this, function(_h) {
        parsedUA = ((_a3 = window === null || window === void 0 ? void 0 : window.navigator) === null || _a3 === void 0 ? void 0 : _a3.userAgent) ? bowser_default.parse(window.navigator.userAgent) : void 0;
        sections = [
          // sdk-metadata
          ["aws-sdk-js", clientVersion],
          // os-metadata
          ["os/" + (((_b2 = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b2 === void 0 ? void 0 : _b2.name) || "other"), (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version],
          // language-metadata
          // ECMAScript edition doesn't matter in JS.
          ["lang/js"],
          // browser vendor and version.
          ["md/browser", ((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown") + "_" + ((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")]
        ];
        if (serviceId) {
          sections.push(["api/" + serviceId, clientVersion]);
        }
        return [2, sections];
      });
    });
  };
};

// node_modules/@aws-sdk/client-personalize-events/dist/es/runtimeConfig.browser.js
init_es4();

// node_modules/@aws-sdk/client-personalize-events/dist/es/endpoints.js
var AWS_TEMPLATE4 = "personalize-events.{region}.amazonaws.com";
var AWS_CN_TEMPLATE4 = "personalize-events.{region}.amazonaws.com.cn";
var AWS_ISO_TEMPLATE4 = "personalize-events.{region}.c2s.ic.gov";
var AWS_ISO_B_TEMPLATE4 = "personalize-events.{region}.sc2s.sgov.gov";
var AWS_US_GOV_TEMPLATE4 = "personalize-events.{region}.amazonaws.com";
var AWS_REGIONS4 = /* @__PURE__ */ new Set([
  "af-south-1",
  "ap-east-1",
  "ap-northeast-1",
  "ap-northeast-2",
  "ap-south-1",
  "ap-southeast-1",
  "ap-southeast-2",
  "ca-central-1",
  "eu-central-1",
  "eu-north-1",
  "eu-south-1",
  "eu-west-1",
  "eu-west-2",
  "eu-west-3",
  "me-south-1",
  "sa-east-1",
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2"
]);
var AWS_CN_REGIONS4 = /* @__PURE__ */ new Set(["cn-north-1", "cn-northwest-1"]);
var AWS_ISO_REGIONS4 = /* @__PURE__ */ new Set(["us-iso-east-1"]);
var AWS_ISO_B_REGIONS4 = /* @__PURE__ */ new Set(["us-isob-east-1"]);
var AWS_US_GOV_REGIONS4 = /* @__PURE__ */ new Set(["us-gov-east-1", "us-gov-west-1"]);
var defaultRegionInfoProvider4 = function(region, options) {
  var regionInfo = void 0;
  switch (region) {
    default:
      if (AWS_REGIONS4.has(region)) {
        regionInfo = {
          hostname: AWS_TEMPLATE4.replace("{region}", region),
          partition: "aws"
        };
      }
      if (AWS_CN_REGIONS4.has(region)) {
        regionInfo = {
          hostname: AWS_CN_TEMPLATE4.replace("{region}", region),
          partition: "aws-cn"
        };
      }
      if (AWS_ISO_REGIONS4.has(region)) {
        regionInfo = {
          hostname: AWS_ISO_TEMPLATE4.replace("{region}", region),
          partition: "aws-iso"
        };
      }
      if (AWS_ISO_B_REGIONS4.has(region)) {
        regionInfo = {
          hostname: AWS_ISO_B_TEMPLATE4.replace("{region}", region),
          partition: "aws-iso-b"
        };
      }
      if (AWS_US_GOV_REGIONS4.has(region)) {
        regionInfo = {
          hostname: AWS_US_GOV_TEMPLATE4.replace("{region}", region),
          partition: "aws-us-gov"
        };
      }
      if (regionInfo === void 0) {
        regionInfo = {
          hostname: AWS_TEMPLATE4.replace("{region}", region),
          partition: "aws"
        };
      }
  }
  return Promise.resolve(__assign7({ signingService: "personalize" }, regionInfo));
};

// node_modules/@aws-sdk/client-personalize-events/dist/es/runtimeConfig.shared.js
var ClientSharedValues4 = {
  apiVersion: "2018-03-22",
  disableHostPrefix: false,
  logger: {},
  regionInfoProvider: defaultRegionInfoProvider4,
  serviceId: "Personalize Events",
  urlParser: parseUrl
};

// node_modules/@aws-sdk/client-personalize-events/dist/es/runtimeConfig.browser.js
var ClientDefaultValues4 = __assign7(__assign7({}, ClientSharedValues4), { runtime: "browser", base64Decoder: fromBase64, base64Encoder: toBase64, bodyLengthChecker: calculateBodyLength, credentialDefaultProvider: function(_2) {
  return function() {
    return Promise.reject(new Error("Credential is missing"));
  };
}, defaultUserAgentProvider: defaultUserAgent4({
  serviceId: ClientSharedValues4.serviceId,
  clientVersion: package_default4.version
}), maxAttempts: DEFAULT_MAX_ATTEMPTS, region: invalidProvider("Region is missing"), requestHandler: new FetchHttpHandler(), sha256: import_sha256_browser4.Sha256, streamCollector, utf8Decoder: fromUtf818, utf8Encoder: toUtf817 });

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-sdk/middleware-host-header/node_modules/tslib/tslib.es6.js
function __awaiter45(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator46(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-sdk/middleware-host-header/dist/es/index.js
function resolveHostHeaderConfig4(input) {
  return input;
}
var hostHeaderMiddleware4 = function(options) {
  return function(next) {
    return function(args) {
      return __awaiter45(void 0, void 0, void 0, function() {
        var request, _a2, handlerProtocol;
        return __generator46(this, function(_b2) {
          if (!HttpRequest.isInstance(args.request))
            return [2, next(args)];
          request = args.request;
          _a2 = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a2 === void 0 ? "" : _a2;
          if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
            delete request.headers["host"];
            request.headers[":authority"] = "";
          } else if (!request.headers["host"]) {
            request.headers["host"] = request.hostname;
          }
          return [2, next(args)];
        });
      });
    };
  };
};
var hostHeaderMiddlewareOptions4 = {
  name: "hostHeaderMiddleware",
  step: "build",
  priority: "low",
  tags: ["HOST"],
  override: true
};
var getHostHeaderPlugin4 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(hostHeaderMiddleware4(options), hostHeaderMiddlewareOptions4);
    }
  };
};

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-sdk/middleware-logger/node_modules/tslib/tslib.es6.js
function __rest8(s2, e) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
}
function __awaiter46(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator47(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-sdk/middleware-logger/dist/es/loggerMiddleware.js
var loggerMiddleware4 = function() {
  return function(next, context) {
    return function(args) {
      return __awaiter46(void 0, void 0, void 0, function() {
        var clientName, commandName, inputFilterSensitiveLog, logger64, outputFilterSensitiveLog, response, _a2, $metadata, outputWithoutMetadata;
        return __generator47(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger64 = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
              return [4, next(args)];
            case 1:
              response = _b2.sent();
              if (!logger64) {
                return [2, response];
              }
              if (typeof logger64.info === "function") {
                _a2 = response.output, $metadata = _a2.$metadata, outputWithoutMetadata = __rest8(_a2, ["$metadata"]);
                logger64.info({
                  clientName,
                  commandName,
                  input: inputFilterSensitiveLog(args.input),
                  output: outputFilterSensitiveLog(outputWithoutMetadata),
                  metadata: $metadata
                });
              }
              return [2, response];
          }
        });
      });
    };
  };
};
var loggerMiddlewareOptions4 = {
  name: "loggerMiddleware",
  tags: ["LOGGER"],
  step: "initialize",
  override: true
};
var getLoggerPlugin4 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(loggerMiddleware4(), loggerMiddlewareOptions4);
    }
  };
};

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-sdk/middleware-signing/node_modules/tslib/tslib.es6.js
var __assign29 = function() {
  __assign29 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign29.apply(this, arguments);
};
function __awaiter47(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator48(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __read26(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-sdk/middleware-signing/dist/es/configurations.js
function resolveAwsAuthConfig4(input) {
  var _this = this;
  var credentials = input.credentials || input.credentialDefaultProvider(input);
  var normalizedCreds = normalizeProvider4(credentials);
  var _a2 = input.signingEscapePath, signingEscapePath = _a2 === void 0 ? true : _a2, _b2 = input.systemClockOffset, systemClockOffset = _b2 === void 0 ? input.systemClockOffset || 0 : _b2, sha256 = input.sha256;
  var signer;
  if (input.signer) {
    signer = normalizeProvider4(input.signer);
  } else {
    signer = function() {
      return normalizeProvider4(input.region)().then(function(region) {
        return __awaiter47(_this, void 0, void 0, function() {
          return __generator48(this, function(_a3) {
            switch (_a3.label) {
              case 0:
                return [4, input.regionInfoProvider(region)];
              case 1:
                return [2, [_a3.sent() || {}, region]];
            }
          });
        });
      }).then(function(_a3) {
        var _b3 = __read26(_a3, 2), regionInfo = _b3[0], region = _b3[1];
        var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
        input.signingRegion = input.signingRegion || signingRegion || region;
        input.signingName = input.signingName || signingService || input.serviceId;
        return new SignatureV4({
          credentials: normalizedCreds,
          region: input.signingRegion,
          service: input.signingName,
          sha256,
          uriEscapePath: signingEscapePath
        });
      });
    };
  }
  return __assign29(__assign29({}, input), {
    systemClockOffset,
    signingEscapePath,
    credentials: normalizedCreds,
    signer
  });
}
function normalizeProvider4(input) {
  if (typeof input === "object") {
    var promisified_1 = Promise.resolve(input);
    return function() {
      return promisified_1;
    };
  }
  return input;
}

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-sdk/middleware-signing/dist/es/middleware.js
var isClockSkewed5 = function(newServerTime, systemClockOffset) {
  return Math.abs(getSkewCorrectedDate5(systemClockOffset).getTime() - newServerTime) >= 3e5;
};
var getSkewCorrectedDate5 = function(systemClockOffset) {
  return new Date(Date.now() + systemClockOffset);
};
function awsAuthMiddleware4(options) {
  return function(next, context) {
    return function(args) {
      return __awaiter47(this, void 0, void 0, function() {
        var signer, _a2, output, _b2, _c, headers, dateHeader, serverTime;
        var _d;
        return __generator48(this, function(_e) {
          switch (_e.label) {
            case 0:
              if (!HttpRequest.isInstance(args.request))
                return [2, next(args)];
              if (!(typeof options.signer === "function"))
                return [3, 2];
              return [4, options.signer()];
            case 1:
              _a2 = _e.sent();
              return [3, 3];
            case 2:
              _a2 = options.signer;
              _e.label = 3;
            case 3:
              signer = _a2;
              _b2 = next;
              _c = [__assign29({}, args)];
              _d = {};
              return [4, signer.sign(args.request, {
                signingDate: new Date(Date.now() + options.systemClockOffset),
                signingRegion: context["signing_region"],
                signingService: context["signing_service"]
              })];
            case 4:
              return [4, _b2.apply(void 0, [__assign29.apply(void 0, _c.concat([(_d.request = _e.sent(), _d)]))])];
            case 5:
              output = _e.sent();
              headers = output.response.headers;
              dateHeader = headers && (headers.date || headers.Date);
              if (dateHeader) {
                serverTime = Date.parse(dateHeader);
                if (isClockSkewed5(serverTime, options.systemClockOffset)) {
                  options.systemClockOffset = serverTime - Date.now();
                }
              }
              return [2, output];
          }
        });
      });
    };
  };
}
var awsAuthMiddlewareOptions4 = {
  name: "awsAuthMiddleware",
  tags: ["SIGNATURE", "AWSAUTH"],
  relation: "after",
  toMiddleware: "retryMiddleware",
  override: true
};
var getAwsAuthPlugin4 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.addRelativeTo(awsAuthMiddleware4(options), awsAuthMiddlewareOptions4);
    }
  };
};

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-sdk/middleware-user-agent/node_modules/tslib/tslib.es6.js
var __assign30 = function() {
  __assign30 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign30.apply(this, arguments);
};
function __awaiter48(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator49(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __read27(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}
function __spread11() {
  for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
    ar = ar.concat(__read27(arguments[i2]));
  return ar;
}

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-sdk/middleware-user-agent/dist/es/configurations.js
function resolveUserAgentConfig4(input) {
  return __assign30(__assign30({}, input), { customUserAgent: typeof input.customUserAgent === "string" ? [[input.customUserAgent]] : input.customUserAgent });
}

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-sdk/middleware-user-agent/dist/es/constants.js
var USER_AGENT4 = "user-agent";
var X_AMZ_USER_AGENT4 = "x-amz-user-agent";
var SPACE4 = " ";
var UA_ESCAPE_REGEX4 = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

// node_modules/@aws-sdk/client-personalize-events/node_modules/@aws-sdk/middleware-user-agent/dist/es/user-agent-middleware.js
var userAgentMiddleware5 = function(options) {
  return function(next, context) {
    return function(args) {
      return __awaiter48(void 0, void 0, void 0, function() {
        var request, headers, userAgent2, defaultUserAgent8, customUserAgent, normalUAValue;
        var _a2, _b2;
        return __generator49(this, function(_c) {
          switch (_c.label) {
            case 0:
              request = args.request;
              if (!HttpRequest.isInstance(request))
                return [2, next(args)];
              headers = request.headers;
              userAgent2 = ((_a2 = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a2 === void 0 ? void 0 : _a2.map(escapeUserAgent4)) || [];
              return [4, options.defaultUserAgentProvider()];
            case 1:
              defaultUserAgent8 = _c.sent().map(escapeUserAgent4);
              customUserAgent = ((_b2 = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b2 === void 0 ? void 0 : _b2.map(escapeUserAgent4)) || [];
              headers[X_AMZ_USER_AGENT4] = __spread11(defaultUserAgent8, userAgent2, customUserAgent).join(SPACE4);
              normalUAValue = __spread11(defaultUserAgent8.filter(function(section) {
                return section.startsWith("aws-sdk-");
              }), customUserAgent).join(SPACE4);
              if (options.runtime !== "browser" && normalUAValue) {
                headers[USER_AGENT4] = headers[USER_AGENT4] ? headers[USER_AGENT4] + " " + normalUAValue : normalUAValue;
              }
              return [2, next(__assign30(__assign30({}, args), { request }))];
          }
        });
      });
    };
  };
};
var escapeUserAgent4 = function(_a2) {
  var _b2 = __read27(_a2, 2), name = _b2[0], version3 = _b2[1];
  var prefixSeparatorIndex = name.indexOf("/");
  var prefix = name.substring(0, prefixSeparatorIndex);
  var uaName = name.substring(prefixSeparatorIndex + 1);
  if (prefix === "api") {
    uaName = uaName.toLowerCase();
  }
  return [prefix, uaName, version3].filter(function(item) {
    return item && item.length > 0;
  }).map(function(item) {
    return item === null || item === void 0 ? void 0 : item.replace(UA_ESCAPE_REGEX4, "_");
  }).join("/");
};
var getUserAgentMiddlewareOptions4 = {
  name: "getUserAgentMiddleware",
  step: "build",
  priority: "low",
  tags: ["SET_USER_AGENT", "USER_AGENT"],
  override: true
};
var getUserAgentPlugin4 = function(config) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(userAgentMiddleware5(config), getUserAgentMiddlewareOptions4);
    }
  };
};

// node_modules/@aws-sdk/client-personalize-events/dist/es/PersonalizeEventsClient.js
var PersonalizeEventsClient = (
  /** @class */
  function(_super) {
    __extends3(PersonalizeEventsClient2, _super);
    function PersonalizeEventsClient2(configuration) {
      var _this = this;
      var _config_0 = __assign7(__assign7({}, ClientDefaultValues4), configuration);
      var _config_1 = resolveRegionConfig(_config_0);
      var _config_2 = resolveEndpointsConfig(_config_1);
      var _config_3 = resolveAwsAuthConfig4(_config_2);
      var _config_4 = resolveRetryConfig(_config_3);
      var _config_5 = resolveHostHeaderConfig4(_config_4);
      var _config_6 = resolveUserAgentConfig4(_config_5);
      _this = _super.call(this, _config_6) || this;
      _this.config = _config_6;
      _this.middlewareStack.use(getAwsAuthPlugin4(_this.config));
      _this.middlewareStack.use(getRetryPlugin(_this.config));
      _this.middlewareStack.use(getContentLengthPlugin(_this.config));
      _this.middlewareStack.use(getHostHeaderPlugin4(_this.config));
      _this.middlewareStack.use(getLoggerPlugin4(_this.config));
      _this.middlewareStack.use(getUserAgentPlugin4(_this.config));
      return _this;
    }
    PersonalizeEventsClient2.prototype.destroy = function() {
      _super.prototype.destroy.call(this);
    };
    return PersonalizeEventsClient2;
  }(Client)
);

// node_modules/@aws-sdk/client-personalize-events/dist/es/models/models_0.js
var InvalidInputException;
(function(InvalidInputException2) {
  InvalidInputException2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(InvalidInputException || (InvalidInputException = {}));
var Event;
(function(Event2) {
  Event2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Event || (Event = {}));
var PutEventsRequest;
(function(PutEventsRequest2) {
  PutEventsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutEventsRequest || (PutEventsRequest = {}));
var Item;
(function(Item2) {
  Item2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Item || (Item = {}));
var PutItemsRequest;
(function(PutItemsRequest2) {
  PutItemsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutItemsRequest || (PutItemsRequest = {}));
var ResourceNotFoundException4;
(function(ResourceNotFoundException6) {
  ResourceNotFoundException6.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ResourceNotFoundException4 || (ResourceNotFoundException4 = {}));
var User;
(function(User2) {
  User2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(User || (User = {}));
var PutUsersRequest;
(function(PutUsersRequest2) {
  PutUsersRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutUsersRequest || (PutUsersRequest = {}));

// node_modules/@aws-sdk/client-personalize-events/dist/es/protocols/Aws_restJson1.js
var serializeAws_restJson1PutEventsCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var headers, resolvedPath3, body, _a2, hostname, _b2, protocol, port;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          headers = {
            "content-type": "application/json"
          };
          resolvedPath3 = "/events";
          body = JSON.stringify(__assign7(__assign7(__assign7(__assign7({}, input.eventList !== void 0 && input.eventList !== null && { eventList: serializeAws_restJson1EventList(input.eventList, context) }), input.sessionId !== void 0 && input.sessionId !== null && { sessionId: input.sessionId }), input.trackingId !== void 0 && input.trackingId !== null && { trackingId: input.trackingId }), input.userId !== void 0 && input.userId !== null && { userId: input.userId }));
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port;
          return [2, new HttpRequest({
            protocol,
            hostname,
            port,
            method: "POST",
            headers,
            path: resolvedPath3,
            body
          })];
      }
    });
  });
};
var deserializeAws_restJson1PutEventsCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2, deserializeAws_restJson1PutEventsCommandError(output, context)];
          }
          contents = {
            $metadata: deserializeMetadata4(output)
          };
          return [4, collectBody4(output.body, context)];
        case 1:
          _a2.sent();
          return [2, Promise.resolve(contents)];
      }
    });
  });
};
var deserializeAws_restJson1PutEventsCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, response, errorCode, _b2, _c, parsedBody, message;
    var _d;
    return __generator3(this, function(_e) {
      switch (_e.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _d = {};
          return [4, parseBody4(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_d.body = _e.sent(), _d)]));
          errorCode = "UnknownError";
          errorCode = loadRestJsonErrorCode4(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "InvalidInputException":
              return [3, 2];
            case "com.amazonaws.personalizeevents#InvalidInputException":
              return [3, 2];
          }
          return [3, 4];
        case 2:
          _c = [{}];
          return [4, deserializeAws_restJson1InvalidInputExceptionResponse(parsedOutput, context)];
        case 3:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _c.concat([_e.sent()])), { name: errorCode, $metadata: deserializeMetadata4(output) }]);
          return [3, 5];
        case 4:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign7(__assign7({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata4(output) });
          _e.label = 5;
        case 5:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2, Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};
var deserializeAws_restJson1InvalidInputExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data;
    return __generator3(this, function(_a2) {
      contents = {
        name: "InvalidInputException",
        $fault: "client",
        $metadata: deserializeMetadata4(parsedOutput),
        message: void 0
      };
      data = parsedOutput.body;
      if (data.message !== void 0 && data.message !== null) {
        contents.message = data.message;
      }
      return [2, contents];
    });
  });
};
var serializeAws_restJson1Event = function(input, context) {
  return __assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7({}, input.eventId !== void 0 && input.eventId !== null && { eventId: input.eventId }), input.eventType !== void 0 && input.eventType !== null && { eventType: input.eventType }), input.eventValue !== void 0 && input.eventValue !== null && { eventValue: input.eventValue }), input.impression !== void 0 && input.impression !== null && { impression: serializeAws_restJson1Impression(input.impression, context) }), input.itemId !== void 0 && input.itemId !== null && { itemId: input.itemId }), input.properties !== void 0 && input.properties !== null && { properties: LazyJsonString.fromObject(input.properties) }), input.recommendationId !== void 0 && input.recommendationId !== null && { recommendationId: input.recommendationId }), input.sentAt !== void 0 && input.sentAt !== null && { sentAt: Math.round(input.sentAt.getTime() / 1e3) });
};
var serializeAws_restJson1EventList = function(input, context) {
  return input.filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return serializeAws_restJson1Event(entry, context);
  });
};
var serializeAws_restJson1Impression = function(input, context) {
  return input.filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return entry;
  });
};
var deserializeMetadata4 = function(output) {
  var _a2;
  return {
    httpStatusCode: output.statusCode,
    requestId: (_a2 = output.headers["x-amzn-requestid"]) !== null && _a2 !== void 0 ? _a2 : output.headers["x-amzn-request-id"],
    extendedRequestId: output.headers["x-amz-id-2"],
    cfId: output.headers["x-amz-cf-id"]
  };
};
var collectBody4 = function(streamBody, context) {
  if (streamBody === void 0) {
    streamBody = new Uint8Array();
  }
  if (streamBody instanceof Uint8Array) {
    return Promise.resolve(streamBody);
  }
  return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
var collectBodyString4 = function(streamBody, context) {
  return collectBody4(streamBody, context).then(function(body) {
    return context.utf8Encoder(body);
  });
};
var parseBody4 = function(streamBody, context) {
  return collectBodyString4(streamBody, context).then(function(encoded) {
    if (encoded.length) {
      return JSON.parse(encoded);
    }
    return {};
  });
};
var loadRestJsonErrorCode4 = function(output, data) {
  var findKey = function(object, key) {
    return Object.keys(object).find(function(k2) {
      return k2.toLowerCase() === key.toLowerCase();
    });
  };
  var sanitizeErrorCode = function(rawValue) {
    var cleanValue = rawValue;
    if (cleanValue.indexOf(":") >= 0) {
      cleanValue = cleanValue.split(":")[0];
    }
    if (cleanValue.indexOf("#") >= 0) {
      cleanValue = cleanValue.split("#")[1];
    }
    return cleanValue;
  };
  var headerKey = findKey(output.headers, "x-amzn-errortype");
  if (headerKey !== void 0) {
    return sanitizeErrorCode(output.headers[headerKey]);
  }
  if (data.code !== void 0) {
    return sanitizeErrorCode(data.code);
  }
  if (data["__type"] !== void 0) {
    return sanitizeErrorCode(data["__type"]);
  }
  return "";
};

// node_modules/@aws-sdk/client-personalize-events/dist/es/commands/PutEventsCommand.js
var PutEventsCommand = (
  /** @class */
  function(_super) {
    __extends3(PutEventsCommand2, _super);
    function PutEventsCommand2(input) {
      var _this = (
        // Start section: command_constructor
        _super.call(this) || this
      );
      _this.input = input;
      return _this;
    }
    PutEventsCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
      this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
      var stack = clientStack.concat(this.middlewareStack);
      var logger64 = configuration.logger;
      var clientName = "PersonalizeEventsClient";
      var commandName = "PutEventsCommand";
      var handlerExecutionContext = {
        logger: logger64,
        clientName,
        commandName,
        inputFilterSensitiveLog: PutEventsRequest.filterSensitiveLog,
        outputFilterSensitiveLog: function(output) {
          return output;
        }
      };
      var requestHandler = configuration.requestHandler;
      return stack.resolve(function(request) {
        return requestHandler.handle(request.request, options || {});
      }, handlerExecutionContext);
    };
    PutEventsCommand2.prototype.serialize = function(input, context) {
      return serializeAws_restJson1PutEventsCommand(input, context);
    };
    PutEventsCommand2.prototype.deserialize = function(output, context) {
      return deserializeAws_restJson1PutEventsCommand(output, context);
    };
    return PutEventsCommand2;
  }(Command)
);

// node_modules/@aws-amplify/analytics/lib-esm/Providers/AmazonPersonalizeHelper/SessionInfoManager.js
var import_isEmpty = __toESM(require_isEmpty());
var import_isEqual = __toESM(require_isEqual());
var import_uuid3 = __toESM(require_uuid2());
var PERSONALIZE_CACHE = "_awsct";
var PERSONALIZE_CACHE_USERID = "_awsct_uid";
var PERSONALIZE_CACHE_SESSIONID = "_awsct_sid";
var DEFAULT_CACHE_PREFIX = "personalize";
var TIMER_INTERVAL = 30 * 1e3;
var DELIMITER = ".";
var CACHE_EXPIRY_IN_DAYS = 7;
var logger22 = new ConsoleLogger("AmazonPersonalizeProvider");
var SessionInfoManager = (
  /** @class */
  function() {
    function SessionInfoManager2(prefixKey) {
      if (prefixKey === void 0) {
        prefixKey = "";
      }
      this._isBrowser = browserOrNode().isBrowser;
      this._timerKey = (0, import_uuid3.v1)().substr(0, 15);
      this._refreshTimer();
    }
    SessionInfoManager2.prototype._refreshTimer = function() {
      if (this._timer) {
        clearInterval(this._timer);
      }
      var that = this;
      this._timer = setInterval(function() {
        that._timerKey = (0, import_uuid3.v1)().substr(0, 15);
      }, TIMER_INTERVAL);
    };
    SessionInfoManager2.prototype.storeValue = function(key, value) {
      var today = /* @__PURE__ */ new Date();
      var expire = /* @__PURE__ */ new Date();
      expire.setTime(today.getTime() + 36e5 * 24 * CACHE_EXPIRY_IN_DAYS);
      BrowserStorageCache.setItem(this._getCachePrefix(key), value, {
        expires: expire.getTime()
      });
    };
    SessionInfoManager2.prototype.retrieveValue = function(key) {
      return BrowserStorageCache.getItem(this._getCachePrefix(key));
    };
    SessionInfoManager2.prototype._getCachePrefix = function(key) {
      if (this._isBrowser) {
        return key + DELIMITER + window.location.host;
      }
      return DEFAULT_CACHE_PREFIX;
    };
    SessionInfoManager2.prototype.getTimerKey = function() {
      return this._timerKey;
    };
    SessionInfoManager2.prototype.updateSessionInfo = function(userId, sessionInfo) {
      var existUserId = sessionInfo.userId;
      var existSessionId = sessionInfo.sessionId;
      if (this._isRequireNewSession(userId, existUserId, existSessionId)) {
        var newSessionId = (0, import_uuid3.v1)();
        this.storeValue(PERSONALIZE_CACHE_USERID, userId);
        this.storeValue(PERSONALIZE_CACHE_SESSIONID, newSessionId);
        sessionInfo.sessionId = newSessionId;
      } else if (this._isRequireUpdateSessionInfo(userId, existUserId, existSessionId)) {
        this.storeValue(PERSONALIZE_CACHE_USERID, userId);
      }
      sessionInfo.userId = userId;
    };
    SessionInfoManager2.prototype._isRequireUpdateSessionInfo = function(userId, cachedSessionUserId, cachedSessionSessionId) {
      var isNoCachedSession = (0, import_isEmpty.default)(cachedSessionSessionId);
      return !isNoCachedSession && (0, import_isEmpty.default)(cachedSessionUserId) && !(0, import_isEmpty.default)(userId);
    };
    SessionInfoManager2.prototype.retrieveSessionInfo = function(trackingId) {
      var sessionInfo = {};
      sessionInfo.trackingId = trackingId;
      sessionInfo.sessionId = this.retrieveValue(PERSONALIZE_CACHE_SESSIONID);
      sessionInfo.userId = this.retrieveValue(PERSONALIZE_CACHE_USERID);
      if ((0, import_isEmpty.default)(sessionInfo.sessionId)) {
        sessionInfo.sessionId = (0, import_uuid3.v1)();
        this.storeValue(PERSONALIZE_CACHE_SESSIONID, sessionInfo.sessionId);
      }
      this.storeValue(PERSONALIZE_CACHE, trackingId);
      return sessionInfo;
    };
    SessionInfoManager2.prototype._isRequireNewSession = function(userId, cachedSessionUserId, cachedSessionSessionId) {
      var isNoCachedSession = (0, import_isEmpty.default)(cachedSessionSessionId);
      var isSignoutCase = (0, import_isEmpty.default)(userId) && !(0, import_isEmpty.default)(cachedSessionUserId);
      var isSwitchUserCase = !(0, import_isEmpty.default)(userId) && !(0, import_isEmpty.default)(cachedSessionUserId) && !(0, import_isEqual.default)(userId, cachedSessionUserId);
      return isNoCachedSession || isSignoutCase || isSwitchUserCase;
    };
    return SessionInfoManager2;
  }()
);

// node_modules/@aws-amplify/analytics/lib-esm/Providers/AmazonPersonalizeHelper/MediaAutoTrack.js
var HTML5_MEDIA_EVENT;
(function(HTML5_MEDIA_EVENT2) {
  HTML5_MEDIA_EVENT2["PLAY"] = "play";
  HTML5_MEDIA_EVENT2["PAUSE"] = "pause";
  HTML5_MEDIA_EVENT2["ENDED"] = "Ended";
})(HTML5_MEDIA_EVENT || (HTML5_MEDIA_EVENT = {}));
var MEDIA_TYPE;
(function(MEDIA_TYPE2) {
  MEDIA_TYPE2["IFRAME"] = "IFRAME";
  MEDIA_TYPE2["VIDEO"] = "VIDEO";
  MEDIA_TYPE2["AUDIO"] = "AUDIO";
})(MEDIA_TYPE || (MEDIA_TYPE = {}));
var EVENT_TYPE;
(function(EVENT_TYPE2) {
  EVENT_TYPE2["PLAY"] = "Play";
  EVENT_TYPE2["ENDED"] = "Ended";
  EVENT_TYPE2["PAUSE"] = "Pause";
  EVENT_TYPE2["TIME_WATCHED"] = "TimeWatched";
})(EVENT_TYPE || (EVENT_TYPE = {}));
var MediaAutoTrack = (
  /** @class */
  function() {
    function MediaAutoTrack2(params, provider) {
      var _a2;
      this.eventActionMapping = (_a2 = {}, _a2[EVENT_TYPE.ENDED] = this.endedEventAction.bind(this), _a2[EVENT_TYPE.PLAY] = this.playEventAction.bind(this), _a2[EVENT_TYPE.PAUSE] = this.pauseEventAction.bind(this), _a2);
      var eventData = params.eventData;
      this._params = params;
      this._mediaElement = document.getElementById(eventData.properties["domElementId"]);
      this._started = false;
      this._provider = provider;
      var mediaTrackFunMapping = {
        IFRAME: this._iframeMediaTracker,
        VIDEO: this._html5MediaTracker,
        AUDIO: this._html5MediaTracker
      };
      mediaTrackFunMapping[this._mediaElement.tagName].bind(this)();
      this._initYoutubeFrame();
    }
    MediaAutoTrack2.prototype._initYoutubeFrame = function() {
      this._youTubeIframeLoader = {
        src: "https://www.youtube.com/iframe_api",
        loading: false,
        loaded: false,
        listeners: [],
        load: function(callback) {
          var _this = this;
          this.listeners.push(callback);
          if (this.loaded) {
            setTimeout(function() {
              _this.done();
            });
            return;
          }
          if (this.loading) {
            return;
          }
          this.loading = true;
          window["onYouTubeIframeAPIReady"] = function() {
            _this.loaded = true;
            _this.done();
          };
          var script = document.createElement("script");
          script.type = "text/javascript";
          script.src = this.src;
          document.body.appendChild(script);
        },
        done: function() {
          delete window["onYouTubeIframeAPIReady"];
          while (this.listeners.length) {
            this.listeners.pop()(window["YT"]);
          }
        }
      };
    };
    MediaAutoTrack2.prototype._iframeMediaTracker = function() {
      var that = this;
      setInterval(function() {
        if (that._started) {
          that.recordEvent(MEDIA_TYPE.IFRAME, EVENT_TYPE.TIME_WATCHED);
        }
      }, 3 * 1e3);
      this._youTubeIframeLoader.load(function(YT) {
        that._iframePlayer = new YT.Player(that._mediaElement.id, {
          events: { onStateChange: that._onPlayerStateChange.bind(that) }
        });
      });
    };
    MediaAutoTrack2.prototype._onPlayerStateChange = function(event) {
      var iframeEventMapping = {
        0: EVENT_TYPE.ENDED,
        1: EVENT_TYPE.PLAY,
        2: EVENT_TYPE.PAUSE
      };
      var eventType = iframeEventMapping[event.data];
      if (eventType) {
        this.eventActionMapping[eventType](MEDIA_TYPE.IFRAME);
      }
    };
    MediaAutoTrack2.prototype._html5MediaTracker = function() {
      var that = this;
      setInterval(function() {
        if (that._started) {
          that.recordEvent(MEDIA_TYPE.VIDEO, EVENT_TYPE.TIME_WATCHED);
        }
      }, 3 * 1e3);
      this._mediaElement.addEventListener(HTML5_MEDIA_EVENT.PLAY, function() {
        that.eventActionMapping[EVENT_TYPE.PLAY](MEDIA_TYPE.VIDEO);
      }, false);
      this._mediaElement.addEventListener(HTML5_MEDIA_EVENT.PAUSE, function() {
        that.eventActionMapping[EVENT_TYPE.PAUSE](MEDIA_TYPE.VIDEO);
      }, false);
      this._mediaElement.addEventListener(HTML5_MEDIA_EVENT.ENDED, function() {
        that.eventActionMapping[EVENT_TYPE.ENDED](MEDIA_TYPE.VIDEO);
      }, false);
    };
    MediaAutoTrack2.prototype.playEventAction = function(mediaType) {
      this._started = true;
      this.recordEvent(mediaType, EVENT_TYPE.PLAY);
    };
    MediaAutoTrack2.prototype.pauseEventAction = function(mediaType) {
      this._started = false;
      this.recordEvent(mediaType, EVENT_TYPE.PAUSE);
    };
    MediaAutoTrack2.prototype.endedEventAction = function(mediaType) {
      this._started = false;
      this.recordEvent(mediaType, EVENT_TYPE.ENDED);
    };
    MediaAutoTrack2.prototype.recordEvent = function(mediaType, eventType) {
      var newParams = Object.assign({}, this._params);
      var eventData = newParams.eventData;
      eventData.eventType = eventType;
      var currentPlayTime;
      if (mediaType === MEDIA_TYPE.VIDEO) {
        currentPlayTime = this._mediaElement.currentTime;
        eventData.properties.duration = this._mediaElement.duration;
      } else {
        currentPlayTime = this._financial(this._iframePlayer.getCurrentTime());
        eventData.properties.duration = this._financial(this._iframePlayer.getDuration());
      }
      var percentage = parseFloat(currentPlayTime) / parseFloat(eventData.properties.duration);
      eventData.properties.eventValue = Number(percentage.toFixed(4));
      delete eventData.properties.domElementId;
      this._provider.putToBuffer(newParams);
    };
    MediaAutoTrack2.prototype._financial = function(x2) {
      return Number.parseFloat(x2).toFixed(4);
    };
    return MediaAutoTrack2;
  }()
);

// node_modules/@aws-amplify/analytics/lib-esm/Providers/AmazonPersonalizeProvider.js
var import_get = __toESM(require_get());
var import_isEmpty2 = __toESM(require_isEmpty());
var import_isEqual2 = __toESM(require_isEqual());
var logger23 = new ConsoleLogger("AmazonPersonalizeProvider");
var FLUSH_SIZE3 = 5;
var FLUSH_SIZE_THRESHHOLD = 10;
var FLUSH_INTERVAL3 = 5 * 1e3;
var IDENTIFY_EVENT = "Identify";
var AmazonPersonalizeProvider = (
  /** @class */
  function() {
    function AmazonPersonalizeProvider2(config) {
      this._buffer = [];
      this._config = config ? config : {};
      this._config.flushSize = this._config.flushSize > 0 && this._config.flushSize <= FLUSH_SIZE_THRESHHOLD ? this._config.flushSize : FLUSH_SIZE3;
      this._config.flushInterval = this._config.flushInterval || FLUSH_INTERVAL3;
      this._sessionManager = new SessionInfoManager();
      if (!(0, import_isEmpty2.default)(this._config.trackingId)) {
        this._sessionInfo = this._sessionManager.retrieveSessionInfo(this._config.trackingId);
      }
      this._isBrowser = browserOrNode().isBrowser;
      this._setupTimer();
    }
    AmazonPersonalizeProvider2.prototype._setupTimer = function() {
      if (this._timer) {
        clearInterval(this._timer);
      }
      var flushInterval = this._config.flushInterval;
      var that = this;
      this._timer = setInterval(function() {
        that._sendFromBuffer();
      }, flushInterval);
    };
    AmazonPersonalizeProvider2.prototype.record = function(params) {
      return __awaiter29(this, void 0, void 0, function() {
        var credentials, _a2, eventType, properties, requestParams, isLoaded;
        return __generator29(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              return [4, this._getCredentials()];
            case 1:
              credentials = _b2.sent();
              if (!credentials)
                return [2, Promise.resolve(false)];
              Object.assign(params, {
                config: this._config,
                credentials,
                sentAt: /* @__PURE__ */ new Date()
              });
              _a2 = params.event, eventType = _a2.eventType, properties = _a2.properties;
              if (eventType === IDENTIFY_EVENT) {
                this._sessionManager.updateSessionInfo(properties && properties.userId ? properties.userId : "", this._sessionInfo);
                return [
                  2
                  /*return*/
                ];
              } else if (!(0, import_isEmpty2.default)(params.event.userId)) {
                this._sessionManager.updateSessionInfo(params.event.userId, this._sessionInfo);
              }
              requestParams = this.generateRequestParams(params, this._sessionInfo);
              if (!(eventType === "MediaAutoTrack"))
                return [3, 7];
              if (!this._isBrowser)
                return [3, 5];
              if (!!(0, import_isEmpty2.default)((0, import_get.default)(requestParams, "eventData.properties.domElementId", null)))
                return [3, 3];
              return [4, this.isElementFullyLoaded(this.loadElement, requestParams.eventData.properties["domElementId"], 500, 5)];
            case 2:
              isLoaded = _b2.sent();
              if (isLoaded) {
                new MediaAutoTrack(requestParams, this);
              } else {
                logger23.debug("Cannot find the media element.");
              }
              return [3, 4];
            case 3:
              logger23.debug("Missing domElementId field in 'properties' for MediaAutoTrack event type.");
              _b2.label = 4;
            case 4:
              return [3, 6];
            case 5:
              logger23.debug("MediaAutoTrack only for browser");
              _b2.label = 6;
            case 6:
              return [
                2
                /*return*/
              ];
            case 7:
              return [2, this.putToBuffer(requestParams)];
          }
        });
      });
    };
    AmazonPersonalizeProvider2.prototype.loadElement = function(domId) {
      return new Promise(function(resolve, reject) {
        if (document.getElementById(domId) && document.getElementById(domId).clientHeight) {
          return resolve(true);
        } else {
          return reject(true);
        }
      });
    };
    AmazonPersonalizeProvider2.prototype.isElementFullyLoaded = function(operation, params, delay, times) {
      var _this = this;
      var wait = function(ms) {
        return new Promise(function(r2) {
          return setTimeout(r2, ms);
        });
      };
      return new Promise(function(resolve, reject) {
        return operation(params).then(resolve).catch(function(reason) {
          if (times - 1 > 0) {
            return wait(delay).then(_this.isElementFullyLoaded.bind(null, operation, params, delay, times - 1)).then(resolve).catch(reject);
          }
          return reject(reason);
        });
      });
    };
    AmazonPersonalizeProvider2.prototype.getCategory = function() {
      return "Analytics";
    };
    AmazonPersonalizeProvider2.prototype.getProviderName = function() {
      return "AmazonPersonalize";
    };
    AmazonPersonalizeProvider2.prototype.configure = function(config) {
      logger23.debug("configure Analytics", config);
      var conf = config ? config : {};
      this._config = Object.assign({}, this._config, conf);
      if (!(0, import_isEmpty2.default)(this._config.trackingId)) {
        this._sessionInfo = this._sessionManager.retrieveSessionInfo(this._config.trackingId);
      }
      this._setupTimer();
      return this._config;
    };
    AmazonPersonalizeProvider2.prototype.generateRequestParams = function(params, sessionInfo) {
      var requestParams = {};
      var _a2 = params.event, eventType = _a2.eventType, properties = _a2.properties;
      requestParams.eventData = { eventType, properties };
      requestParams.sessionInfo = sessionInfo;
      requestParams.sentAt = params.sentAt;
      requestParams.credentials = params.credentials;
      requestParams.config = params.config;
      return requestParams;
    };
    AmazonPersonalizeProvider2.prototype._sendEvents = function(group) {
      var groupLen = group.length;
      if (groupLen === 0) {
        logger23.debug("events array is empty, directly return");
        return;
      }
      var _a2 = group[0], config = _a2.config, credentials = _a2.credentials, sessionInfo = _a2.sessionInfo;
      var initClients = this._init(config, credentials);
      if (!initClients)
        return false;
      if (groupLen > 0) {
        var events3 = [];
        for (var i2 = 0; i2 < groupLen; i2 += 1) {
          var params = group.shift();
          var eventPayload = this._generateSingleRecordPayload(params, sessionInfo);
          events3.push(eventPayload);
        }
        var payload_1 = {};
        payload_1.trackingId = sessionInfo.trackingId;
        payload_1.sessionId = sessionInfo.sessionId;
        payload_1.userId = sessionInfo.userId;
        payload_1.eventList = [];
        events3.forEach(function(event) {
          payload_1.eventList.push(event);
        });
        var command = new PutEventsCommand(payload_1);
        this._personalize.send(command, function(err) {
          if (err)
            logger23.debug("Failed to call putEvents in Personalize", err);
          else
            logger23.debug("Put events");
        });
      }
    };
    AmazonPersonalizeProvider2.prototype.putToBuffer = function(params) {
      if (this._buffer.length < this._config.flushSize) {
        this._buffer.push(params);
      } else {
        this._buffer.push(params);
        this._sendFromBuffer();
      }
      return Promise.resolve(true);
    };
    AmazonPersonalizeProvider2.prototype._sendFromBuffer = function() {
      var _this = this;
      var size = this._buffer.length;
      if (size <= 0)
        return;
      var eventsGroups = [];
      var preCred = null;
      var group = [];
      for (var i2 = 0; i2 < size; i2 += 1) {
        var currRequestParams = this._buffer.shift();
        var cred = currRequestParams.credentials;
        var sessionInfo = currRequestParams.sessionInfo;
        if (i2 === 0) {
          group.push(currRequestParams);
          preCred = cred;
        } else {
          if ((0, import_isEqual2.default)(sessionInfo, this._sessionInfo) && cred.sessionToken === preCred.sessionToken && cred.identityId === preCred.identityId) {
            logger23.debug("no change for cred, put event in the same group");
            group.push(currRequestParams);
          } else {
            eventsGroups.push(group);
            group = [];
            group.push(currRequestParams);
            preCred = cred;
            this._sessionInfo = sessionInfo;
          }
        }
      }
      eventsGroups.push(group);
      eventsGroups.map(function(group2) {
        _this._sendEvents(group2);
      });
    };
    AmazonPersonalizeProvider2.prototype._generateSingleRecordPayload = function(params, sessionInfo) {
      var eventData = params.eventData, sentAt = params.sentAt;
      var trackPayload = {};
      trackPayload.sentAt = sentAt;
      trackPayload.properties = eventData.properties && JSON.stringify(eventData.properties);
      trackPayload.eventId = this._sessionManager.getTimerKey() + sessionInfo.sessionId;
      trackPayload.eventType = eventData.eventType;
      return trackPayload;
    };
    AmazonPersonalizeProvider2.prototype._init = function(config, credentials) {
      logger23.debug("init clients");
      if (this._personalize && this._config.credentials && this._config.credentials.sessionToken === credentials.sessionToken && this._config.credentials.identityId === credentials.identityId) {
        logger23.debug("no change for analytics config, directly return from init");
        return true;
      }
      this._config.credentials = credentials;
      var region = config.region;
      logger23.debug("initialize personalize with credentials", credentials);
      this._personalize = new PersonalizeEventsClient({
        region,
        credentials,
        customUserAgent: getAnalyticsUserAgent(AnalyticsAction.Record)
      });
      return true;
    };
    AmazonPersonalizeProvider2.prototype._getCredentials = function() {
      var that = this;
      return Credentials.get().then(function(credentials) {
        if (!credentials)
          return null;
        logger23.debug("set credentials for analytics", that._config.credentials);
        return Credentials.shear(credentials);
      }).catch(function(err) {
        logger23.debug("ensure credentials error", err);
        return null;
      });
    };
    return AmazonPersonalizeProvider2;
  }()
);

// node_modules/@aws-amplify/auth/node_modules/tslib/tslib.es6.js
var extendStatics5 = function(d2, b2) {
  extendStatics5 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b3) {
    d3.__proto__ = b3;
  } || function(d3, b3) {
    for (var p2 in b3)
      if (b3.hasOwnProperty(p2))
        d3[p2] = b3[p2];
  };
  return extendStatics5(d2, b2);
};
function __extends7(d2, b2) {
  extendStatics5(d2, b2);
  function __() {
    this.constructor = d2;
  }
  d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
}
var __assign31 = function() {
  __assign31 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign31.apply(this, arguments);
};
function __awaiter49(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator50(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __read28(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}

// node_modules/@aws-amplify/auth/lib-esm/types/Auth.js
var CognitoHostedUIIdentityProvider;
(function(CognitoHostedUIIdentityProvider2) {
  CognitoHostedUIIdentityProvider2["Cognito"] = "COGNITO";
  CognitoHostedUIIdentityProvider2["Google"] = "Google";
  CognitoHostedUIIdentityProvider2["Facebook"] = "Facebook";
  CognitoHostedUIIdentityProvider2["Amazon"] = "LoginWithAmazon";
  CognitoHostedUIIdentityProvider2["Apple"] = "SignInWithApple";
})(CognitoHostedUIIdentityProvider || (CognitoHostedUIIdentityProvider = {}));
function isFederatedSignInOptions(obj) {
  var keys = ["provider"];
  return obj && !!keys.find(function(k2) {
    return obj.hasOwnProperty(k2);
  });
}
function isFederatedSignInOptionsCustom(obj) {
  var keys = ["customProvider"];
  return obj && !!keys.find(function(k2) {
    return obj.hasOwnProperty(k2);
  });
}
function hasCustomState(obj) {
  var keys = ["customState"];
  return obj && !!keys.find(function(k2) {
    return obj.hasOwnProperty(k2);
  });
}
function isCognitoHostedOpts(oauth) {
  return oauth.redirectSignIn !== void 0;
}
var AuthErrorTypes;
(function(AuthErrorTypes2) {
  AuthErrorTypes2["NoConfig"] = "noConfig";
  AuthErrorTypes2["MissingAuthConfig"] = "missingAuthConfig";
  AuthErrorTypes2["EmptyUsername"] = "emptyUsername";
  AuthErrorTypes2["InvalidUsername"] = "invalidUsername";
  AuthErrorTypes2["EmptyPassword"] = "emptyPassword";
  AuthErrorTypes2["EmptyCode"] = "emptyCode";
  AuthErrorTypes2["SignUpError"] = "signUpError";
  AuthErrorTypes2["NoMFA"] = "noMFA";
  AuthErrorTypes2["InvalidMFA"] = "invalidMFA";
  AuthErrorTypes2["EmptyChallengeResponse"] = "emptyChallengeResponse";
  AuthErrorTypes2["NoUserSession"] = "noUserSession";
  AuthErrorTypes2["Default"] = "default";
  AuthErrorTypes2["DeviceConfig"] = "deviceConfig";
  AuthErrorTypes2["NetworkError"] = "networkError";
  AuthErrorTypes2["AutoSignInError"] = "autoSignInError";
})(AuthErrorTypes || (AuthErrorTypes = {}));
function isUsernamePasswordOpts(obj) {
  return !!obj.username;
}
var GRAPHQL_AUTH_MODE;
(function(GRAPHQL_AUTH_MODE2) {
  GRAPHQL_AUTH_MODE2["API_KEY"] = "API_KEY";
  GRAPHQL_AUTH_MODE2["AWS_IAM"] = "AWS_IAM";
  GRAPHQL_AUTH_MODE2["OPENID_CONNECT"] = "OPENID_CONNECT";
  GRAPHQL_AUTH_MODE2["AMAZON_COGNITO_USER_POOLS"] = "AMAZON_COGNITO_USER_POOLS";
  GRAPHQL_AUTH_MODE2["AWS_LAMBDA"] = "AWS_LAMBDA";
})(GRAPHQL_AUTH_MODE || (GRAPHQL_AUTH_MODE = {}));

// node_modules/amazon-cognito-identity-js/es/AuthenticationDetails.js
var AuthenticationDetails = /* @__PURE__ */ function() {
  function AuthenticationDetails2(data) {
    var _ref = data || {}, ValidationData = _ref.ValidationData, Username = _ref.Username, Password = _ref.Password, AuthParameters = _ref.AuthParameters, ClientMetadata = _ref.ClientMetadata;
    this.validationData = ValidationData || {};
    this.authParameters = AuthParameters || {};
    this.clientMetadata = ClientMetadata || {};
    this.username = Username;
    this.password = Password;
  }
  var _proto = AuthenticationDetails2.prototype;
  _proto.getUsername = function getUsername() {
    return this.username;
  };
  _proto.getPassword = function getPassword() {
    return this.password;
  };
  _proto.getValidationData = function getValidationData() {
    return this.validationData;
  };
  _proto.getAuthParameters = function getAuthParameters() {
    return this.authParameters;
  };
  _proto.getClientMetadata = function getClientMetadata() {
    return this.clientMetadata;
  };
  return AuthenticationDetails2;
}();

// node_modules/amazon-cognito-identity-js/es/AuthenticationHelper.js
var import_buffer = __toESM(require_buffer());

// node_modules/amazon-cognito-identity-js/es/utils/cryptoSecureRandomInt.js
var crypto2;
if (typeof window !== "undefined" && window.crypto) {
  crypto2 = window.crypto;
}
if (!crypto2 && typeof window !== "undefined" && window.msCrypto) {
  crypto2 = window.msCrypto;
}
if (!crypto2 && typeof global !== "undefined" && global.crypto) {
  crypto2 = global.crypto;
}
if (!crypto2 && typeof __require === "function") {
  try {
    crypto2 = require_crypto();
  } catch (err) {
  }
}
function cryptoSecureRandomInt() {
  if (crypto2) {
    if (typeof crypto2.getRandomValues === "function") {
      try {
        return crypto2.getRandomValues(new Uint32Array(1))[0];
      } catch (err) {
      }
    }
    if (typeof crypto2.randomBytes === "function") {
      try {
        return crypto2.randomBytes(4).readInt32LE();
      } catch (err) {
      }
    }
  }
  throw new Error("Native crypto module could not be used to get secure random number.");
}

// node_modules/amazon-cognito-identity-js/es/utils/WordArray.js
function hexStringify(wordArray) {
  var words = wordArray.words;
  var sigBytes = wordArray.sigBytes;
  var hexChars = [];
  for (var i2 = 0; i2 < sigBytes; i2++) {
    var bite = words[i2 >>> 2] >>> 24 - i2 % 4 * 8 & 255;
    hexChars.push((bite >>> 4).toString(16));
    hexChars.push((bite & 15).toString(16));
  }
  return hexChars.join("");
}
var WordArray = /* @__PURE__ */ function() {
  function WordArray2(words, sigBytes) {
    words = this.words = words || [];
    if (sigBytes != void 0) {
      this.sigBytes = sigBytes;
    } else {
      this.sigBytes = words.length * 4;
    }
  }
  var _proto = WordArray2.prototype;
  _proto.random = function random(nBytes) {
    var words = [];
    for (var i2 = 0; i2 < nBytes; i2 += 4) {
      words.push(cryptoSecureRandomInt());
    }
    return new WordArray2(words, nBytes);
  };
  _proto.toString = function toString() {
    return hexStringify(this);
  };
  return WordArray2;
}();

// node_modules/amazon-cognito-identity-js/es/AuthenticationHelper.js
var import_sha256_js2 = __toESM(require_build26());

// node_modules/amazon-cognito-identity-js/es/BigInteger.js
var BigInteger_default = BigInteger;
function BigInteger(a2, b2) {
  if (a2 != null)
    this.fromString(a2, b2);
}
function nbi() {
  return new BigInteger(null);
}
var dbits;
var canary = 244837814094590;
var j_lm = (canary & 16777215) == 15715070;
function am1(i2, x2, w2, j2, c2, n2) {
  while (--n2 >= 0) {
    var v2 = x2 * this[i2++] + w2[j2] + c2;
    c2 = Math.floor(v2 / 67108864);
    w2[j2++] = v2 & 67108863;
  }
  return c2;
}
function am2(i2, x2, w2, j2, c2, n2) {
  var xl = x2 & 32767, xh = x2 >> 15;
  while (--n2 >= 0) {
    var l2 = this[i2] & 32767;
    var h2 = this[i2++] >> 15;
    var m2 = xh * l2 + h2 * xl;
    l2 = xl * l2 + ((m2 & 32767) << 15) + w2[j2] + (c2 & 1073741823);
    c2 = (l2 >>> 30) + (m2 >>> 15) + xh * h2 + (c2 >>> 30);
    w2[j2++] = l2 & 1073741823;
  }
  return c2;
}
function am3(i2, x2, w2, j2, c2, n2) {
  var xl = x2 & 16383, xh = x2 >> 14;
  while (--n2 >= 0) {
    var l2 = this[i2] & 16383;
    var h2 = this[i2++] >> 14;
    var m2 = xh * l2 + h2 * xl;
    l2 = xl * l2 + ((m2 & 16383) << 14) + w2[j2] + c2;
    c2 = (l2 >> 28) + (m2 >> 14) + xh * h2;
    w2[j2++] = l2 & 268435455;
  }
  return c2;
}
var inBrowser = typeof navigator !== "undefined";
if (inBrowser && j_lm && navigator.appName == "Microsoft Internet Explorer") {
  BigInteger.prototype.am = am2;
  dbits = 30;
} else if (inBrowser && j_lm && navigator.appName != "Netscape") {
  BigInteger.prototype.am = am1;
  dbits = 26;
} else {
  BigInteger.prototype.am = am3;
  dbits = 28;
}
BigInteger.prototype.DB = dbits;
BigInteger.prototype.DM = (1 << dbits) - 1;
BigInteger.prototype.DV = 1 << dbits;
var BI_FP = 52;
BigInteger.prototype.FV = Math.pow(2, BI_FP);
BigInteger.prototype.F1 = BI_FP - dbits;
BigInteger.prototype.F2 = 2 * dbits - BI_FP;
var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var BI_RC = new Array();
var rr;
var vv;
rr = "0".charCodeAt(0);
for (vv = 0; vv <= 9; ++vv)
  BI_RC[rr++] = vv;
rr = "a".charCodeAt(0);
for (vv = 10; vv < 36; ++vv)
  BI_RC[rr++] = vv;
rr = "A".charCodeAt(0);
for (vv = 10; vv < 36; ++vv)
  BI_RC[rr++] = vv;
function int2char(n2) {
  return BI_RM.charAt(n2);
}
function intAt(s2, i2) {
  var c2 = BI_RC[s2.charCodeAt(i2)];
  return c2 == null ? -1 : c2;
}
function bnpCopyTo(r2) {
  for (var i2 = this.t - 1; i2 >= 0; --i2)
    r2[i2] = this[i2];
  r2.t = this.t;
  r2.s = this.s;
}
function bnpFromInt(x2) {
  this.t = 1;
  this.s = x2 < 0 ? -1 : 0;
  if (x2 > 0)
    this[0] = x2;
  else if (x2 < -1)
    this[0] = x2 + this.DV;
  else
    this.t = 0;
}
function nbv(i2) {
  var r2 = nbi();
  r2.fromInt(i2);
  return r2;
}
function bnpFromString(s2, b2) {
  var k2;
  if (b2 == 16)
    k2 = 4;
  else if (b2 == 8)
    k2 = 3;
  else if (b2 == 2)
    k2 = 1;
  else if (b2 == 32)
    k2 = 5;
  else if (b2 == 4)
    k2 = 2;
  else
    throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
  this.t = 0;
  this.s = 0;
  var i2 = s2.length, mi = false, sh = 0;
  while (--i2 >= 0) {
    var x2 = intAt(s2, i2);
    if (x2 < 0) {
      if (s2.charAt(i2) == "-")
        mi = true;
      continue;
    }
    mi = false;
    if (sh == 0)
      this[this.t++] = x2;
    else if (sh + k2 > this.DB) {
      this[this.t - 1] |= (x2 & (1 << this.DB - sh) - 1) << sh;
      this[this.t++] = x2 >> this.DB - sh;
    } else
      this[this.t - 1] |= x2 << sh;
    sh += k2;
    if (sh >= this.DB)
      sh -= this.DB;
  }
  this.clamp();
  if (mi)
    BigInteger.ZERO.subTo(this, this);
}
function bnpClamp() {
  var c2 = this.s & this.DM;
  while (this.t > 0 && this[this.t - 1] == c2)
    --this.t;
}
function bnToString(b2) {
  if (this.s < 0)
    return "-" + this.negate().toString(b2);
  var k2;
  if (b2 == 16)
    k2 = 4;
  else if (b2 == 8)
    k2 = 3;
  else if (b2 == 2)
    k2 = 1;
  else if (b2 == 32)
    k2 = 5;
  else if (b2 == 4)
    k2 = 2;
  else
    throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
  var km = (1 << k2) - 1, d2, m2 = false, r2 = "", i2 = this.t;
  var p2 = this.DB - i2 * this.DB % k2;
  if (i2-- > 0) {
    if (p2 < this.DB && (d2 = this[i2] >> p2) > 0) {
      m2 = true;
      r2 = int2char(d2);
    }
    while (i2 >= 0) {
      if (p2 < k2) {
        d2 = (this[i2] & (1 << p2) - 1) << k2 - p2;
        d2 |= this[--i2] >> (p2 += this.DB - k2);
      } else {
        d2 = this[i2] >> (p2 -= k2) & km;
        if (p2 <= 0) {
          p2 += this.DB;
          --i2;
        }
      }
      if (d2 > 0)
        m2 = true;
      if (m2)
        r2 += int2char(d2);
    }
  }
  return m2 ? r2 : "0";
}
function bnNegate() {
  var r2 = nbi();
  BigInteger.ZERO.subTo(this, r2);
  return r2;
}
function bnAbs() {
  return this.s < 0 ? this.negate() : this;
}
function bnCompareTo(a2) {
  var r2 = this.s - a2.s;
  if (r2 != 0)
    return r2;
  var i2 = this.t;
  r2 = i2 - a2.t;
  if (r2 != 0)
    return this.s < 0 ? -r2 : r2;
  while (--i2 >= 0)
    if ((r2 = this[i2] - a2[i2]) != 0)
      return r2;
  return 0;
}
function nbits(x2) {
  var r2 = 1, t2;
  if ((t2 = x2 >>> 16) != 0) {
    x2 = t2;
    r2 += 16;
  }
  if ((t2 = x2 >> 8) != 0) {
    x2 = t2;
    r2 += 8;
  }
  if ((t2 = x2 >> 4) != 0) {
    x2 = t2;
    r2 += 4;
  }
  if ((t2 = x2 >> 2) != 0) {
    x2 = t2;
    r2 += 2;
  }
  if ((t2 = x2 >> 1) != 0) {
    x2 = t2;
    r2 += 1;
  }
  return r2;
}
function bnBitLength() {
  if (this.t <= 0)
    return 0;
  return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
}
function bnpDLShiftTo(n2, r2) {
  var i2;
  for (i2 = this.t - 1; i2 >= 0; --i2)
    r2[i2 + n2] = this[i2];
  for (i2 = n2 - 1; i2 >= 0; --i2)
    r2[i2] = 0;
  r2.t = this.t + n2;
  r2.s = this.s;
}
function bnpDRShiftTo(n2, r2) {
  for (var i2 = n2; i2 < this.t; ++i2)
    r2[i2 - n2] = this[i2];
  r2.t = Math.max(this.t - n2, 0);
  r2.s = this.s;
}
function bnpLShiftTo(n2, r2) {
  var bs = n2 % this.DB;
  var cbs = this.DB - bs;
  var bm = (1 << cbs) - 1;
  var ds = Math.floor(n2 / this.DB), c2 = this.s << bs & this.DM, i2;
  for (i2 = this.t - 1; i2 >= 0; --i2) {
    r2[i2 + ds + 1] = this[i2] >> cbs | c2;
    c2 = (this[i2] & bm) << bs;
  }
  for (i2 = ds - 1; i2 >= 0; --i2)
    r2[i2] = 0;
  r2[ds] = c2;
  r2.t = this.t + ds + 1;
  r2.s = this.s;
  r2.clamp();
}
function bnpRShiftTo(n2, r2) {
  r2.s = this.s;
  var ds = Math.floor(n2 / this.DB);
  if (ds >= this.t) {
    r2.t = 0;
    return;
  }
  var bs = n2 % this.DB;
  var cbs = this.DB - bs;
  var bm = (1 << bs) - 1;
  r2[0] = this[ds] >> bs;
  for (var i2 = ds + 1; i2 < this.t; ++i2) {
    r2[i2 - ds - 1] |= (this[i2] & bm) << cbs;
    r2[i2 - ds] = this[i2] >> bs;
  }
  if (bs > 0)
    r2[this.t - ds - 1] |= (this.s & bm) << cbs;
  r2.t = this.t - ds;
  r2.clamp();
}
function bnpSubTo(a2, r2) {
  var i2 = 0, c2 = 0, m2 = Math.min(a2.t, this.t);
  while (i2 < m2) {
    c2 += this[i2] - a2[i2];
    r2[i2++] = c2 & this.DM;
    c2 >>= this.DB;
  }
  if (a2.t < this.t) {
    c2 -= a2.s;
    while (i2 < this.t) {
      c2 += this[i2];
      r2[i2++] = c2 & this.DM;
      c2 >>= this.DB;
    }
    c2 += this.s;
  } else {
    c2 += this.s;
    while (i2 < a2.t) {
      c2 -= a2[i2];
      r2[i2++] = c2 & this.DM;
      c2 >>= this.DB;
    }
    c2 -= a2.s;
  }
  r2.s = c2 < 0 ? -1 : 0;
  if (c2 < -1)
    r2[i2++] = this.DV + c2;
  else if (c2 > 0)
    r2[i2++] = c2;
  r2.t = i2;
  r2.clamp();
}
function bnpMultiplyTo(a2, r2) {
  var x2 = this.abs(), y2 = a2.abs();
  var i2 = x2.t;
  r2.t = i2 + y2.t;
  while (--i2 >= 0)
    r2[i2] = 0;
  for (i2 = 0; i2 < y2.t; ++i2)
    r2[i2 + x2.t] = x2.am(0, y2[i2], r2, i2, 0, x2.t);
  r2.s = 0;
  r2.clamp();
  if (this.s != a2.s)
    BigInteger.ZERO.subTo(r2, r2);
}
function bnpSquareTo(r2) {
  var x2 = this.abs();
  var i2 = r2.t = 2 * x2.t;
  while (--i2 >= 0)
    r2[i2] = 0;
  for (i2 = 0; i2 < x2.t - 1; ++i2) {
    var c2 = x2.am(i2, x2[i2], r2, 2 * i2, 0, 1);
    if ((r2[i2 + x2.t] += x2.am(i2 + 1, 2 * x2[i2], r2, 2 * i2 + 1, c2, x2.t - i2 - 1)) >= x2.DV) {
      r2[i2 + x2.t] -= x2.DV;
      r2[i2 + x2.t + 1] = 1;
    }
  }
  if (r2.t > 0)
    r2[r2.t - 1] += x2.am(i2, x2[i2], r2, 2 * i2, 0, 1);
  r2.s = 0;
  r2.clamp();
}
function bnpDivRemTo(m2, q2, r2) {
  var pm = m2.abs();
  if (pm.t <= 0)
    return;
  var pt = this.abs();
  if (pt.t < pm.t) {
    if (q2 != null)
      q2.fromInt(0);
    if (r2 != null)
      this.copyTo(r2);
    return;
  }
  if (r2 == null)
    r2 = nbi();
  var y2 = nbi(), ts = this.s, ms = m2.s;
  var nsh = this.DB - nbits(pm[pm.t - 1]);
  if (nsh > 0) {
    pm.lShiftTo(nsh, y2);
    pt.lShiftTo(nsh, r2);
  } else {
    pm.copyTo(y2);
    pt.copyTo(r2);
  }
  var ys = y2.t;
  var y0 = y2[ys - 1];
  if (y0 == 0)
    return;
  var yt = y0 * (1 << this.F1) + (ys > 1 ? y2[ys - 2] >> this.F2 : 0);
  var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
  var i2 = r2.t, j2 = i2 - ys, t2 = q2 == null ? nbi() : q2;
  y2.dlShiftTo(j2, t2);
  if (r2.compareTo(t2) >= 0) {
    r2[r2.t++] = 1;
    r2.subTo(t2, r2);
  }
  BigInteger.ONE.dlShiftTo(ys, t2);
  t2.subTo(y2, y2);
  while (y2.t < ys)
    y2[y2.t++] = 0;
  while (--j2 >= 0) {
    var qd = r2[--i2] == y0 ? this.DM : Math.floor(r2[i2] * d1 + (r2[i2 - 1] + e) * d2);
    if ((r2[i2] += y2.am(0, qd, r2, j2, 0, ys)) < qd) {
      y2.dlShiftTo(j2, t2);
      r2.subTo(t2, r2);
      while (r2[i2] < --qd)
        r2.subTo(t2, r2);
    }
  }
  if (q2 != null) {
    r2.drShiftTo(ys, q2);
    if (ts != ms)
      BigInteger.ZERO.subTo(q2, q2);
  }
  r2.t = ys;
  r2.clamp();
  if (nsh > 0)
    r2.rShiftTo(nsh, r2);
  if (ts < 0)
    BigInteger.ZERO.subTo(r2, r2);
}
function bnMod(a2) {
  var r2 = nbi();
  this.abs().divRemTo(a2, null, r2);
  if (this.s < 0 && r2.compareTo(BigInteger.ZERO) > 0)
    a2.subTo(r2, r2);
  return r2;
}
function bnpInvDigit() {
  if (this.t < 1)
    return 0;
  var x2 = this[0];
  if ((x2 & 1) == 0)
    return 0;
  var y2 = x2 & 3;
  y2 = y2 * (2 - (x2 & 15) * y2) & 15;
  y2 = y2 * (2 - (x2 & 255) * y2) & 255;
  y2 = y2 * (2 - ((x2 & 65535) * y2 & 65535)) & 65535;
  y2 = y2 * (2 - x2 * y2 % this.DV) % this.DV;
  return y2 > 0 ? this.DV - y2 : -y2;
}
function bnEquals(a2) {
  return this.compareTo(a2) == 0;
}
function bnpAddTo(a2, r2) {
  var i2 = 0, c2 = 0, m2 = Math.min(a2.t, this.t);
  while (i2 < m2) {
    c2 += this[i2] + a2[i2];
    r2[i2++] = c2 & this.DM;
    c2 >>= this.DB;
  }
  if (a2.t < this.t) {
    c2 += a2.s;
    while (i2 < this.t) {
      c2 += this[i2];
      r2[i2++] = c2 & this.DM;
      c2 >>= this.DB;
    }
    c2 += this.s;
  } else {
    c2 += this.s;
    while (i2 < a2.t) {
      c2 += a2[i2];
      r2[i2++] = c2 & this.DM;
      c2 >>= this.DB;
    }
    c2 += a2.s;
  }
  r2.s = c2 < 0 ? -1 : 0;
  if (c2 > 0)
    r2[i2++] = c2;
  else if (c2 < -1)
    r2[i2++] = this.DV + c2;
  r2.t = i2;
  r2.clamp();
}
function bnAdd(a2) {
  var r2 = nbi();
  this.addTo(a2, r2);
  return r2;
}
function bnSubtract(a2) {
  var r2 = nbi();
  this.subTo(a2, r2);
  return r2;
}
function bnMultiply(a2) {
  var r2 = nbi();
  this.multiplyTo(a2, r2);
  return r2;
}
function bnDivide(a2) {
  var r2 = nbi();
  this.divRemTo(a2, r2, null);
  return r2;
}
function Montgomery(m2) {
  this.m = m2;
  this.mp = m2.invDigit();
  this.mpl = this.mp & 32767;
  this.mph = this.mp >> 15;
  this.um = (1 << m2.DB - 15) - 1;
  this.mt2 = 2 * m2.t;
}
function montConvert(x2) {
  var r2 = nbi();
  x2.abs().dlShiftTo(this.m.t, r2);
  r2.divRemTo(this.m, null, r2);
  if (x2.s < 0 && r2.compareTo(BigInteger.ZERO) > 0)
    this.m.subTo(r2, r2);
  return r2;
}
function montRevert(x2) {
  var r2 = nbi();
  x2.copyTo(r2);
  this.reduce(r2);
  return r2;
}
function montReduce(x2) {
  while (x2.t <= this.mt2)
    x2[x2.t++] = 0;
  for (var i2 = 0; i2 < this.m.t; ++i2) {
    var j2 = x2[i2] & 32767;
    var u0 = j2 * this.mpl + ((j2 * this.mph + (x2[i2] >> 15) * this.mpl & this.um) << 15) & x2.DM;
    j2 = i2 + this.m.t;
    x2[j2] += this.m.am(0, u0, x2, i2, 0, this.m.t);
    while (x2[j2] >= x2.DV) {
      x2[j2] -= x2.DV;
      x2[++j2]++;
    }
  }
  x2.clamp();
  x2.drShiftTo(this.m.t, x2);
  if (x2.compareTo(this.m) >= 0)
    x2.subTo(this.m, x2);
}
function montSqrTo(x2, r2) {
  x2.squareTo(r2);
  this.reduce(r2);
}
function montMulTo(x2, y2, r2) {
  x2.multiplyTo(y2, r2);
  this.reduce(r2);
}
Montgomery.prototype.convert = montConvert;
Montgomery.prototype.revert = montRevert;
Montgomery.prototype.reduce = montReduce;
Montgomery.prototype.mulTo = montMulTo;
Montgomery.prototype.sqrTo = montSqrTo;
function bnModPow(e, m2, callback) {
  var i2 = e.bitLength(), k2, r2 = nbv(1), z2 = new Montgomery(m2);
  if (i2 <= 0)
    return r2;
  else if (i2 < 18)
    k2 = 1;
  else if (i2 < 48)
    k2 = 3;
  else if (i2 < 144)
    k2 = 4;
  else if (i2 < 768)
    k2 = 5;
  else
    k2 = 6;
  var g2 = new Array(), n2 = 3, k1 = k2 - 1, km = (1 << k2) - 1;
  g2[1] = z2.convert(this);
  if (k2 > 1) {
    var g22 = nbi();
    z2.sqrTo(g2[1], g22);
    while (n2 <= km) {
      g2[n2] = nbi();
      z2.mulTo(g22, g2[n2 - 2], g2[n2]);
      n2 += 2;
    }
  }
  var j2 = e.t - 1, w2, is1 = true, r22 = nbi(), t2;
  i2 = nbits(e[j2]) - 1;
  while (j2 >= 0) {
    if (i2 >= k1)
      w2 = e[j2] >> i2 - k1 & km;
    else {
      w2 = (e[j2] & (1 << i2 + 1) - 1) << k1 - i2;
      if (j2 > 0)
        w2 |= e[j2 - 1] >> this.DB + i2 - k1;
    }
    n2 = k2;
    while ((w2 & 1) == 0) {
      w2 >>= 1;
      --n2;
    }
    if ((i2 -= n2) < 0) {
      i2 += this.DB;
      --j2;
    }
    if (is1) {
      g2[w2].copyTo(r2);
      is1 = false;
    } else {
      while (n2 > 1) {
        z2.sqrTo(r2, r22);
        z2.sqrTo(r22, r2);
        n2 -= 2;
      }
      if (n2 > 0)
        z2.sqrTo(r2, r22);
      else {
        t2 = r2;
        r2 = r22;
        r22 = t2;
      }
      z2.mulTo(r22, g2[w2], r2);
    }
    while (j2 >= 0 && (e[j2] & 1 << i2) == 0) {
      z2.sqrTo(r2, r22);
      t2 = r2;
      r2 = r22;
      r22 = t2;
      if (--i2 < 0) {
        i2 = this.DB - 1;
        --j2;
      }
    }
  }
  var result = z2.revert(r2);
  callback(null, result);
  return result;
}
BigInteger.prototype.copyTo = bnpCopyTo;
BigInteger.prototype.fromInt = bnpFromInt;
BigInteger.prototype.fromString = bnpFromString;
BigInteger.prototype.clamp = bnpClamp;
BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
BigInteger.prototype.drShiftTo = bnpDRShiftTo;
BigInteger.prototype.lShiftTo = bnpLShiftTo;
BigInteger.prototype.rShiftTo = bnpRShiftTo;
BigInteger.prototype.subTo = bnpSubTo;
BigInteger.prototype.multiplyTo = bnpMultiplyTo;
BigInteger.prototype.squareTo = bnpSquareTo;
BigInteger.prototype.divRemTo = bnpDivRemTo;
BigInteger.prototype.invDigit = bnpInvDigit;
BigInteger.prototype.addTo = bnpAddTo;
BigInteger.prototype.toString = bnToString;
BigInteger.prototype.negate = bnNegate;
BigInteger.prototype.abs = bnAbs;
BigInteger.prototype.compareTo = bnCompareTo;
BigInteger.prototype.bitLength = bnBitLength;
BigInteger.prototype.mod = bnMod;
BigInteger.prototype.equals = bnEquals;
BigInteger.prototype.add = bnAdd;
BigInteger.prototype.subtract = bnSubtract;
BigInteger.prototype.multiply = bnMultiply;
BigInteger.prototype.divide = bnDivide;
BigInteger.prototype.modPow = bnModPow;
BigInteger.ZERO = nbv(0);
BigInteger.ONE = nbv(1);

// node_modules/amazon-cognito-identity-js/es/AuthenticationHelper.js
function randomBytes(nBytes) {
  return import_buffer.Buffer.from(new WordArray().random(nBytes).toString(), "hex");
}
var HEX_MSB_REGEX = /^[89a-f]/i;
var initN = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
var newPasswordRequiredChallengeUserAttributePrefix = "userAttributes.";
var AuthenticationHelper = /* @__PURE__ */ function() {
  function AuthenticationHelper2(PoolName) {
    this.N = new BigInteger_default(initN, 16);
    this.g = new BigInteger_default("2", 16);
    this.k = new BigInteger_default(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16);
    this.smallAValue = this.generateRandomSmallA();
    this.getLargeAValue(function() {
    });
    this.infoBits = import_buffer.Buffer.from("Caldera Derived Key", "utf8");
    this.poolName = PoolName;
  }
  var _proto = AuthenticationHelper2.prototype;
  _proto.getSmallAValue = function getSmallAValue() {
    return this.smallAValue;
  };
  _proto.getLargeAValue = function getLargeAValue(callback) {
    var _this = this;
    if (this.largeAValue) {
      callback(null, this.largeAValue);
    } else {
      this.calculateA(this.smallAValue, function(err, largeAValue) {
        if (err) {
          callback(err, null);
        }
        _this.largeAValue = largeAValue;
        callback(null, _this.largeAValue);
      });
    }
  };
  _proto.generateRandomSmallA = function generateRandomSmallA() {
    var hexRandom = randomBytes(128).toString("hex");
    var randomBigInt = new BigInteger_default(hexRandom, 16);
    return randomBigInt;
  };
  _proto.generateRandomString = function generateRandomString2() {
    return randomBytes(40).toString("base64");
  };
  _proto.getRandomPassword = function getRandomPassword() {
    return this.randomPassword;
  };
  _proto.getSaltDevices = function getSaltDevices() {
    return this.SaltToHashDevices;
  };
  _proto.getVerifierDevices = function getVerifierDevices() {
    return this.verifierDevices;
  };
  _proto.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
    var _this2 = this;
    this.randomPassword = this.generateRandomString();
    var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
    var hashedString = this.hash(combinedString);
    var hexRandom = randomBytes(16).toString("hex");
    this.SaltToHashDevices = this.padHex(new BigInteger_default(hexRandom, 16));
    this.g.modPow(new BigInteger_default(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function(err, verifierDevicesNotPadded) {
      if (err) {
        callback(err, null);
      }
      _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
      callback(null, null);
    });
  };
  _proto.calculateA = function calculateA(a2, callback) {
    var _this3 = this;
    this.g.modPow(a2, this.N, function(err, A2) {
      if (err) {
        callback(err, null);
      }
      if (A2.mod(_this3.N).equals(BigInteger_default.ZERO)) {
        callback(new Error("Illegal paramater. A mod N cannot be 0."), null);
      }
      callback(null, A2);
    });
  };
  _proto.calculateU = function calculateU(A2, B2) {
    this.UHexHash = this.hexHash(this.padHex(A2) + this.padHex(B2));
    var finalU = new BigInteger_default(this.UHexHash, 16);
    return finalU;
  };
  _proto.hash = function hash(buf) {
    var awsCryptoHash = new import_sha256_js2.Sha256();
    awsCryptoHash.update(buf);
    var resultFromAWSCrypto = awsCryptoHash.digestSync();
    var hashHex = import_buffer.Buffer.from(resultFromAWSCrypto).toString("hex");
    return new Array(64 - hashHex.length).join("0") + hashHex;
  };
  _proto.hexHash = function hexHash(hexStr) {
    return this.hash(import_buffer.Buffer.from(hexStr, "hex"));
  };
  _proto.computehkdf = function computehkdf(ikm, salt) {
    var infoBitsBuffer = import_buffer.Buffer.concat([this.infoBits, import_buffer.Buffer.from(String.fromCharCode(1), "utf8")]);
    var awsCryptoHash = new import_sha256_js2.Sha256(salt);
    awsCryptoHash.update(ikm);
    var resultFromAWSCryptoPrk = awsCryptoHash.digestSync();
    var awsCryptoHashHmac = new import_sha256_js2.Sha256(resultFromAWSCryptoPrk);
    awsCryptoHashHmac.update(infoBitsBuffer);
    var resultFromAWSCryptoHmac = awsCryptoHashHmac.digestSync();
    var hashHexFromAWSCrypto = resultFromAWSCryptoHmac;
    var currentHex = hashHexFromAWSCrypto.slice(0, 16);
    return currentHex;
  };
  _proto.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
    var _this4 = this;
    if (serverBValue.mod(this.N).equals(BigInteger_default.ZERO)) {
      throw new Error("B cannot be zero.");
    }
    this.UValue = this.calculateU(this.largeAValue, serverBValue);
    if (this.UValue.equals(BigInteger_default.ZERO)) {
      throw new Error("U cannot be zero.");
    }
    var usernamePassword = "" + this.poolName + username + ":" + password;
    var usernamePasswordHash = this.hash(usernamePassword);
    var xValue = new BigInteger_default(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
    this.calculateS(xValue, serverBValue, function(err, sValue) {
      if (err) {
        callback(err, null);
      }
      var hkdf = _this4.computehkdf(import_buffer.Buffer.from(_this4.padHex(sValue), "hex"), import_buffer.Buffer.from(_this4.padHex(_this4.UValue), "hex"));
      callback(null, hkdf);
    });
  };
  _proto.calculateS = function calculateS(xValue, serverBValue, callback) {
    var _this5 = this;
    this.g.modPow(xValue, this.N, function(err, gModPowXN) {
      if (err) {
        callback(err, null);
      }
      var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
      intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function(err2, result) {
        if (err2) {
          callback(err2, null);
        }
        callback(null, result.mod(_this5.N));
      });
    });
  };
  _proto.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
    return newPasswordRequiredChallengeUserAttributePrefix;
  };
  _proto.padHex = function padHex(bigInt) {
    if (!(bigInt instanceof BigInteger_default)) {
      throw new Error("Not a BigInteger");
    }
    var isNegative = bigInt.compareTo(BigInteger_default.ZERO) < 0;
    var hexStr = bigInt.abs().toString(16);
    hexStr = hexStr.length % 2 !== 0 ? "0" + hexStr : hexStr;
    hexStr = HEX_MSB_REGEX.test(hexStr) ? "00" + hexStr : hexStr;
    if (isNegative) {
      var invertedNibbles = hexStr.split("").map(function(x2) {
        var invertedNibble = ~parseInt(x2, 16) & 15;
        return "0123456789ABCDEF".charAt(invertedNibble);
      }).join("");
      var flippedBitsBI = new BigInteger_default(invertedNibbles, 16).add(BigInteger_default.ONE);
      hexStr = flippedBitsBI.toString(16);
      if (hexStr.toUpperCase().startsWith("FF8")) {
        hexStr = hexStr.substring(2);
      }
    }
    return hexStr;
  };
  return AuthenticationHelper2;
}();

// node_modules/amazon-cognito-identity-js/es/CognitoJwtToken.js
var import_buffer2 = __toESM(require_buffer());
var CognitoJwtToken = /* @__PURE__ */ function() {
  function CognitoJwtToken2(token) {
    this.jwtToken = token || "";
    this.payload = this.decodePayload();
  }
  var _proto = CognitoJwtToken2.prototype;
  _proto.getJwtToken = function getJwtToken() {
    return this.jwtToken;
  };
  _proto.getExpiration = function getExpiration() {
    return this.payload.exp;
  };
  _proto.getIssuedAt = function getIssuedAt() {
    return this.payload.iat;
  };
  _proto.decodePayload = function decodePayload() {
    var payload = this.jwtToken.split(".")[1];
    try {
      return JSON.parse(import_buffer2.Buffer.from(payload, "base64").toString("utf8"));
    } catch (err) {
      return {};
    }
  };
  return CognitoJwtToken2;
}();

// node_modules/amazon-cognito-identity-js/es/CognitoAccessToken.js
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o2, p2) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf5(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf(o2, p2);
}
var CognitoAccessToken = /* @__PURE__ */ function(_CognitoJwtToken) {
  _inheritsLoose(CognitoAccessToken2, _CognitoJwtToken);
  function CognitoAccessToken2(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, AccessToken = _ref.AccessToken;
    return _CognitoJwtToken.call(this, AccessToken || "") || this;
  }
  return CognitoAccessToken2;
}(CognitoJwtToken);

// node_modules/amazon-cognito-identity-js/es/CognitoIdToken.js
function _inheritsLoose2(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf2(subClass, superClass);
}
function _setPrototypeOf2(o2, p2) {
  _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf5(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf2(o2, p2);
}
var CognitoIdToken = /* @__PURE__ */ function(_CognitoJwtToken) {
  _inheritsLoose2(CognitoIdToken2, _CognitoJwtToken);
  function CognitoIdToken2(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken;
    return _CognitoJwtToken.call(this, IdToken || "") || this;
  }
  return CognitoIdToken2;
}(CognitoJwtToken);

// node_modules/amazon-cognito-identity-js/es/CognitoRefreshToken.js
var CognitoRefreshToken = /* @__PURE__ */ function() {
  function CognitoRefreshToken2(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, RefreshToken = _ref.RefreshToken;
    this.token = RefreshToken || "";
  }
  var _proto = CognitoRefreshToken2.prototype;
  _proto.getToken = function getToken() {
    return this.token;
  };
  return CognitoRefreshToken2;
}();

// node_modules/amazon-cognito-identity-js/es/CognitoUser.js
var import_buffer3 = __toESM(require_buffer());
var import_sha256_js3 = __toESM(require_build26());

// node_modules/amazon-cognito-identity-js/es/Platform/version.js
var version2 = "5.0.4";

// node_modules/amazon-cognito-identity-js/es/Platform/index.js
var BASE_USER_AGENT2 = "aws-amplify/" + version2;
var Platform2 = {
  userAgent: BASE_USER_AGENT2,
  isReactNative: typeof navigator !== "undefined" && navigator.product === "ReactNative"
};
var getUserAgent = function getUserAgent2() {
  return Platform2.userAgent;
};

// node_modules/amazon-cognito-identity-js/es/CognitoUserSession.js
var CognitoUserSession = /* @__PURE__ */ function() {
  function CognitoUserSession2(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken, RefreshToken = _ref.RefreshToken, AccessToken = _ref.AccessToken, ClockDrift = _ref.ClockDrift;
    if (AccessToken == null || IdToken == null) {
      throw new Error("Id token and Access Token must be present.");
    }
    this.idToken = IdToken;
    this.refreshToken = RefreshToken;
    this.accessToken = AccessToken;
    this.clockDrift = ClockDrift === void 0 ? this.calculateClockDrift() : ClockDrift;
  }
  var _proto = CognitoUserSession2.prototype;
  _proto.getIdToken = function getIdToken() {
    return this.idToken;
  };
  _proto.getRefreshToken = function getRefreshToken() {
    return this.refreshToken;
  };
  _proto.getAccessToken = function getAccessToken() {
    return this.accessToken;
  };
  _proto.getClockDrift = function getClockDrift() {
    return this.clockDrift;
  };
  _proto.calculateClockDrift = function calculateClockDrift() {
    var now = Math.floor(/* @__PURE__ */ new Date() / 1e3);
    var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
    return now - iat;
  };
  _proto.isValid = function isValid2() {
    var now = Math.floor(/* @__PURE__ */ new Date() / 1e3);
    var adjusted = now - this.clockDrift;
    return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
  };
  return CognitoUserSession2;
}();

// node_modules/amazon-cognito-identity-js/es/DateHelper.js
var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var weekNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
var DateHelper = /* @__PURE__ */ function() {
  function DateHelper2() {
  }
  var _proto = DateHelper2.prototype;
  _proto.getNowString = function getNowString() {
    var now = /* @__PURE__ */ new Date();
    var weekDay = weekNames[now.getUTCDay()];
    var month = monthNames[now.getUTCMonth()];
    var day = now.getUTCDate();
    var hours = now.getUTCHours();
    if (hours < 10) {
      hours = "0" + hours;
    }
    var minutes = now.getUTCMinutes();
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    var seconds = now.getUTCSeconds();
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    var year = now.getUTCFullYear();
    var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
    return dateNow;
  };
  return DateHelper2;
}();

// node_modules/amazon-cognito-identity-js/es/CognitoUserAttribute.js
var CognitoUserAttribute = /* @__PURE__ */ function() {
  function CognitoUserAttribute2(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, Name2 = _ref.Name, Value = _ref.Value;
    this.Name = Name2 || "";
    this.Value = Value || "";
  }
  var _proto = CognitoUserAttribute2.prototype;
  _proto.getValue = function getValue() {
    return this.Value;
  };
  _proto.setValue = function setValue(value) {
    this.Value = value;
    return this;
  };
  _proto.getName = function getName() {
    return this.Name;
  };
  _proto.setName = function setName(name) {
    this.Name = name;
    return this;
  };
  _proto.toString = function toString() {
    return JSON.stringify(this);
  };
  _proto.toJSON = function toJSON() {
    return {
      Name: this.Name,
      Value: this.Value
    };
  };
  return CognitoUserAttribute2;
}();

// node_modules/amazon-cognito-identity-js/es/StorageHelper.js
var dataMemory2 = {};
var MemoryStorage2 = /* @__PURE__ */ function() {
  function MemoryStorage3() {
  }
  MemoryStorage3.setItem = function setItem(key, value) {
    dataMemory2[key] = value;
    return dataMemory2[key];
  };
  MemoryStorage3.getItem = function getItem(key) {
    return Object.prototype.hasOwnProperty.call(dataMemory2, key) ? dataMemory2[key] : void 0;
  };
  MemoryStorage3.removeItem = function removeItem(key) {
    return delete dataMemory2[key];
  };
  MemoryStorage3.clear = function clear() {
    dataMemory2 = {};
    return dataMemory2;
  };
  return MemoryStorage3;
}();
var StorageHelper2 = /* @__PURE__ */ function() {
  function StorageHelper3() {
    try {
      this.storageWindow = window.localStorage;
      this.storageWindow.setItem("aws.cognito.test-ls", 1);
      this.storageWindow.removeItem("aws.cognito.test-ls");
    } catch (exception) {
      this.storageWindow = MemoryStorage2;
    }
  }
  var _proto = StorageHelper3.prototype;
  _proto.getStorage = function getStorage() {
    return this.storageWindow;
  };
  return StorageHelper3;
}();

// node_modules/amazon-cognito-identity-js/es/CognitoUser.js
var isNavigatorAvailable = typeof navigator !== "undefined";
var userAgent = isNavigatorAvailable ? Platform2.isReactNative ? "react-native" : navigator.userAgent : "nodejs";
var CognitoUser = /* @__PURE__ */ function() {
  function CognitoUser2(data) {
    if (data == null || data.Username == null || data.Pool == null) {
      throw new Error("Username and Pool information are required.");
    }
    this.username = data.Username || "";
    this.pool = data.Pool;
    this.Session = null;
    this.client = data.Pool.client;
    this.signInUserSession = null;
    this.authenticationFlowType = "USER_SRP_AUTH";
    this.storage = data.Storage || new StorageHelper2().getStorage();
    this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
    this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
  }
  var _proto = CognitoUser2.prototype;
  _proto.setSignInUserSession = function setSignInUserSession(signInUserSession) {
    this.clearCachedUserData();
    this.signInUserSession = signInUserSession;
    this.cacheTokens();
  };
  _proto.getSignInUserSession = function getSignInUserSession() {
    return this.signInUserSession;
  };
  _proto.getUsername = function getUsername() {
    return this.username;
  };
  _proto.getAuthenticationFlowType = function getAuthenticationFlowType() {
    return this.authenticationFlowType;
  };
  _proto.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
    this.authenticationFlowType = authenticationFlowType;
  };
  _proto.initiateAuth = function initiateAuth(authDetails, callback) {
    var _this = this;
    var authParameters = authDetails.getAuthParameters();
    authParameters.USERNAME = this.username;
    var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
    var jsonReq = {
      AuthFlow: "CUSTOM_AUTH",
      ClientId: this.pool.getClientId(),
      AuthParameters: authParameters,
      ClientMetadata: clientMetaData
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }
    this.client.request("InitiateAuth", jsonReq, function(err, data) {
      if (err) {
        return callback.onFailure(err);
      }
      var challengeName = data.ChallengeName;
      var challengeParameters = data.ChallengeParameters;
      if (challengeName === "CUSTOM_CHALLENGE") {
        _this.Session = data.Session;
        return callback.customChallenge(challengeParameters);
      }
      _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
      _this.cacheTokens();
      return callback.onSuccess(_this.signInUserSession);
    });
  };
  _proto.authenticateUser = function authenticateUser(authDetails, callback) {
    if (this.authenticationFlowType === "USER_PASSWORD_AUTH") {
      return this.authenticateUserPlainUsernamePassword(authDetails, callback);
    } else if (this.authenticationFlowType === "USER_SRP_AUTH" || this.authenticationFlowType === "CUSTOM_AUTH") {
      return this.authenticateUserDefaultAuth(authDetails, callback);
    }
    return callback.onFailure(new Error("Authentication flow type is invalid."));
  };
  _proto.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
    var _this2 = this;
    var authenticationHelper = new AuthenticationHelper(this.pool.getUserPoolName());
    var dateHelper = new DateHelper();
    var serverBValue;
    var salt;
    var authParameters = {};
    if (this.deviceKey != null) {
      authParameters.DEVICE_KEY = this.deviceKey;
    }
    authParameters.USERNAME = this.username;
    authenticationHelper.getLargeAValue(function(errOnAValue, aValue) {
      if (errOnAValue) {
        callback.onFailure(errOnAValue);
      }
      authParameters.SRP_A = aValue.toString(16);
      if (_this2.authenticationFlowType === "CUSTOM_AUTH") {
        authParameters.CHALLENGE_NAME = "SRP_A";
      }
      var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
      var jsonReq = {
        AuthFlow: _this2.authenticationFlowType,
        ClientId: _this2.pool.getClientId(),
        AuthParameters: authParameters,
        ClientMetadata: clientMetaData
      };
      if (_this2.getUserContextData(_this2.username)) {
        jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
      }
      _this2.client.request("InitiateAuth", jsonReq, function(err, data) {
        if (err) {
          return callback.onFailure(err);
        }
        var challengeParameters = data.ChallengeParameters;
        _this2.username = challengeParameters.USER_ID_FOR_SRP;
        _this2.userDataKey = _this2.keyPrefix + "." + _this2.username + ".userData";
        serverBValue = new BigInteger_default(challengeParameters.SRP_B, 16);
        salt = new BigInteger_default(challengeParameters.SALT, 16);
        _this2.getCachedDeviceKeyAndPassword();
        authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function(errOnHkdf, hkdf) {
          if (errOnHkdf) {
            callback.onFailure(errOnHkdf);
          }
          var dateNow = dateHelper.getNowString();
          var concatBuffer = import_buffer3.Buffer.concat([import_buffer3.Buffer.from(_this2.pool.getUserPoolName(), "utf8"), import_buffer3.Buffer.from(_this2.username, "utf8"), import_buffer3.Buffer.from(challengeParameters.SECRET_BLOCK, "base64"), import_buffer3.Buffer.from(dateNow, "utf8")]);
          var awsCryptoHash = new import_sha256_js3.Sha256(hkdf);
          awsCryptoHash.update(concatBuffer);
          var resultFromAWSCrypto = awsCryptoHash.digestSync();
          var signatureString = import_buffer3.Buffer.from(resultFromAWSCrypto).toString("base64");
          var challengeResponses = {};
          challengeResponses.USERNAME = _this2.username;
          challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
          challengeResponses.TIMESTAMP = dateNow;
          challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
          if (_this2.deviceKey != null) {
            challengeResponses.DEVICE_KEY = _this2.deviceKey;
          }
          var respondToAuthChallenge = function respondToAuthChallenge2(challenge, challengeCallback) {
            return _this2.client.request("RespondToAuthChallenge", challenge, function(errChallenge, dataChallenge) {
              if (errChallenge && errChallenge.code === "ResourceNotFoundException" && errChallenge.message.toLowerCase().indexOf("device") !== -1) {
                challengeResponses.DEVICE_KEY = null;
                _this2.deviceKey = null;
                _this2.randomPassword = null;
                _this2.deviceGroupKey = null;
                _this2.clearCachedDeviceKeyAndPassword();
                return respondToAuthChallenge2(challenge, challengeCallback);
              }
              return challengeCallback(errChallenge, dataChallenge);
            });
          };
          var jsonReqResp = {
            ChallengeName: "PASSWORD_VERIFIER",
            ClientId: _this2.pool.getClientId(),
            ChallengeResponses: challengeResponses,
            Session: data.Session,
            ClientMetadata: clientMetaData
          };
          if (_this2.getUserContextData()) {
            jsonReqResp.UserContextData = _this2.getUserContextData();
          }
          respondToAuthChallenge(jsonReqResp, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) {
              return callback.onFailure(errAuthenticate);
            }
            return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
          });
          return void 0;
        });
        return void 0;
      });
    });
  };
  _proto.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
    var _this3 = this;
    var authParameters = {};
    authParameters.USERNAME = this.username;
    authParameters.PASSWORD = authDetails.getPassword();
    if (!authParameters.PASSWORD) {
      callback.onFailure(new Error("PASSWORD parameter is required"));
      return;
    }
    var authenticationHelper = new AuthenticationHelper(this.pool.getUserPoolName());
    this.getCachedDeviceKeyAndPassword();
    if (this.deviceKey != null) {
      authParameters.DEVICE_KEY = this.deviceKey;
    }
    var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
    var jsonReq = {
      AuthFlow: "USER_PASSWORD_AUTH",
      ClientId: this.pool.getClientId(),
      AuthParameters: authParameters,
      ClientMetadata: clientMetaData
    };
    if (this.getUserContextData(this.username)) {
      jsonReq.UserContextData = this.getUserContextData(this.username);
    }
    this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
      if (err) {
        return callback.onFailure(err);
      }
      return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
    });
  };
  _proto.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
    var _this4 = this;
    var challengeName = dataAuthenticate.ChallengeName;
    var challengeParameters = dataAuthenticate.ChallengeParameters;
    if (challengeName === "SMS_MFA") {
      this.Session = dataAuthenticate.Session;
      return callback.mfaRequired(challengeName, challengeParameters);
    }
    if (challengeName === "SELECT_MFA_TYPE") {
      this.Session = dataAuthenticate.Session;
      return callback.selectMFAType(challengeName, challengeParameters);
    }
    if (challengeName === "MFA_SETUP") {
      this.Session = dataAuthenticate.Session;
      return callback.mfaSetup(challengeName, challengeParameters);
    }
    if (challengeName === "SOFTWARE_TOKEN_MFA") {
      this.Session = dataAuthenticate.Session;
      return callback.totpRequired(challengeName, challengeParameters);
    }
    if (challengeName === "CUSTOM_CHALLENGE") {
      this.Session = dataAuthenticate.Session;
      return callback.customChallenge(challengeParameters);
    }
    if (challengeName === "NEW_PASSWORD_REQUIRED") {
      this.Session = dataAuthenticate.Session;
      var userAttributes = null;
      var rawRequiredAttributes = null;
      var requiredAttributes = [];
      var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
      if (challengeParameters) {
        userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
        rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
      }
      if (rawRequiredAttributes) {
        for (var i2 = 0; i2 < rawRequiredAttributes.length; i2++) {
          requiredAttributes[i2] = rawRequiredAttributes[i2].substr(userAttributesPrefix.length);
        }
      }
      return callback.newPasswordRequired(userAttributes, requiredAttributes);
    }
    if (challengeName === "DEVICE_SRP_AUTH") {
      this.Session = dataAuthenticate.Session;
      this.getDeviceResponse(callback);
      return void 0;
    }
    this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
    this.challengeName = challengeName;
    this.cacheTokens();
    var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
    if (newDeviceMetadata == null) {
      return callback.onSuccess(this.signInUserSession);
    }
    authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
      if (errGenHash) {
        return callback.onFailure(errGenHash);
      }
      var deviceSecretVerifierConfig = {
        Salt: import_buffer3.Buffer.from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
        PasswordVerifier: import_buffer3.Buffer.from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
      };
      _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
      _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
      _this4.randomPassword = authenticationHelper.getRandomPassword();
      _this4.client.request("ConfirmDevice", {
        DeviceKey: newDeviceMetadata.DeviceKey,
        AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
        DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
        DeviceName: userAgent
      }, function(errConfirm, dataConfirm) {
        if (errConfirm) {
          return callback.onFailure(errConfirm);
        }
        _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
        _this4.cacheDeviceKeyAndPassword();
        if (dataConfirm.UserConfirmationNecessary === true) {
          return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
        }
        return callback.onSuccess(_this4.signInUserSession);
      });
      return void 0;
    });
    return void 0;
  };
  _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
    var _this5 = this;
    if (!newPassword) {
      return callback.onFailure(new Error("New password is required."));
    }
    var authenticationHelper = new AuthenticationHelper(this.pool.getUserPoolName());
    var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
    var finalUserAttributes = {};
    if (requiredAttributeData) {
      Object.keys(requiredAttributeData).forEach(function(key) {
        finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
      });
    }
    finalUserAttributes.NEW_PASSWORD = newPassword;
    finalUserAttributes.USERNAME = this.username;
    var jsonReq = {
      ChallengeName: "NEW_PASSWORD_REQUIRED",
      ClientId: this.pool.getClientId(),
      ChallengeResponses: finalUserAttributes,
      Session: this.Session,
      ClientMetadata: clientMetadata
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }
    this.client.request("RespondToAuthChallenge", jsonReq, function(errAuthenticate, dataAuthenticate) {
      if (errAuthenticate) {
        return callback.onFailure(errAuthenticate);
      }
      return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
    });
    return void 0;
  };
  _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
    var _this6 = this;
    var authenticationHelper = new AuthenticationHelper(this.deviceGroupKey);
    var dateHelper = new DateHelper();
    var authParameters = {};
    authParameters.USERNAME = this.username;
    authParameters.DEVICE_KEY = this.deviceKey;
    authenticationHelper.getLargeAValue(function(errAValue, aValue) {
      if (errAValue) {
        callback.onFailure(errAValue);
      }
      authParameters.SRP_A = aValue.toString(16);
      var jsonReq = {
        ChallengeName: "DEVICE_SRP_AUTH",
        ClientId: _this6.pool.getClientId(),
        ChallengeResponses: authParameters,
        ClientMetadata: clientMetadata,
        Session: _this6.Session
      };
      if (_this6.getUserContextData()) {
        jsonReq.UserContextData = _this6.getUserContextData();
      }
      _this6.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
        if (err) {
          return callback.onFailure(err);
        }
        var challengeParameters = data.ChallengeParameters;
        var serverBValue = new BigInteger_default(challengeParameters.SRP_B, 16);
        var salt = new BigInteger_default(challengeParameters.SALT, 16);
        authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function(errHkdf, hkdf) {
          if (errHkdf) {
            return callback.onFailure(errHkdf);
          }
          var dateNow = dateHelper.getNowString();
          var concatBuffer = import_buffer3.Buffer.concat([import_buffer3.Buffer.from(_this6.deviceGroupKey, "utf8"), import_buffer3.Buffer.from(_this6.deviceKey, "utf8"), import_buffer3.Buffer.from(challengeParameters.SECRET_BLOCK, "base64"), import_buffer3.Buffer.from(dateNow, "utf8")]);
          var awsCryptoHash = new import_sha256_js3.Sha256(hkdf);
          awsCryptoHash.update(concatBuffer);
          var resultFromAWSCrypto = awsCryptoHash.digestSync();
          var signatureString = import_buffer3.Buffer.from(resultFromAWSCrypto).toString("base64");
          var challengeResponses = {};
          challengeResponses.USERNAME = _this6.username;
          challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
          challengeResponses.TIMESTAMP = dateNow;
          challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
          challengeResponses.DEVICE_KEY = _this6.deviceKey;
          var jsonReqResp = {
            ChallengeName: "DEVICE_PASSWORD_VERIFIER",
            ClientId: _this6.pool.getClientId(),
            ChallengeResponses: challengeResponses,
            Session: data.Session
          };
          if (_this6.getUserContextData()) {
            jsonReqResp.UserContextData = _this6.getUserContextData();
          }
          _this6.client.request("RespondToAuthChallenge", jsonReqResp, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) {
              return callback.onFailure(errAuthenticate);
            }
            _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this6.cacheTokens();
            return callback.onSuccess(_this6.signInUserSession);
          });
          return void 0;
        });
        return void 0;
      });
    });
  };
  _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
    var jsonReq = {
      ClientId: this.pool.getClientId(),
      ConfirmationCode: confirmationCode,
      Username: this.username,
      ForceAliasCreation: forceAliasCreation,
      ClientMetadata: clientMetadata
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }
    this.client.request("ConfirmSignUp", jsonReq, function(err) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, "SUCCESS");
    });
  };
  _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
    var _this7 = this;
    var challengeResponses = {};
    challengeResponses.USERNAME = this.username;
    challengeResponses.ANSWER = answerChallenge;
    var authenticationHelper = new AuthenticationHelper(this.pool.getUserPoolName());
    this.getCachedDeviceKeyAndPassword();
    if (this.deviceKey != null) {
      challengeResponses.DEVICE_KEY = this.deviceKey;
    }
    var jsonReq = {
      ChallengeName: "CUSTOM_CHALLENGE",
      ChallengeResponses: challengeResponses,
      ClientId: this.pool.getClientId(),
      Session: this.Session,
      ClientMetadata: clientMetadata
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }
    this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
      if (err) {
        return callback.onFailure(err);
      }
      return _this7.authenticateUserInternal(data, authenticationHelper, callback);
    });
  };
  _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
    var _this8 = this;
    var challengeResponses = {};
    challengeResponses.USERNAME = this.username;
    challengeResponses.SMS_MFA_CODE = confirmationCode;
    var mfaTypeSelection = mfaType || "SMS_MFA";
    if (mfaTypeSelection === "SOFTWARE_TOKEN_MFA") {
      challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
    }
    if (this.deviceKey != null) {
      challengeResponses.DEVICE_KEY = this.deviceKey;
    }
    var jsonReq = {
      ChallengeName: mfaTypeSelection,
      ChallengeResponses: challengeResponses,
      ClientId: this.pool.getClientId(),
      Session: this.Session,
      ClientMetadata: clientMetadata
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }
    this.client.request("RespondToAuthChallenge", jsonReq, function(err, dataAuthenticate) {
      if (err) {
        return callback.onFailure(err);
      }
      var challengeName = dataAuthenticate.ChallengeName;
      if (challengeName === "DEVICE_SRP_AUTH") {
        _this8.getDeviceResponse(callback);
        return void 0;
      }
      _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
      _this8.cacheTokens();
      if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) {
        return callback.onSuccess(_this8.signInUserSession);
      }
      var authenticationHelper = new AuthenticationHelper(_this8.pool.getUserPoolName());
      authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
        if (errGenHash) {
          return callback.onFailure(errGenHash);
        }
        var deviceSecretVerifierConfig = {
          Salt: import_buffer3.Buffer.from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
          PasswordVerifier: import_buffer3.Buffer.from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
        };
        _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
        _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
        _this8.randomPassword = authenticationHelper.getRandomPassword();
        _this8.client.request("ConfirmDevice", {
          DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
          AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
          DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
          DeviceName: userAgent
        }, function(errConfirm, dataConfirm) {
          if (errConfirm) {
            return callback.onFailure(errConfirm);
          }
          _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
          _this8.cacheDeviceKeyAndPassword();
          if (dataConfirm.UserConfirmationNecessary === true) {
            return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
          }
          return callback.onSuccess(_this8.signInUserSession);
        });
        return void 0;
      });
      return void 0;
    });
  };
  _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      return callback(new Error("User is not authenticated"), null);
    }
    this.client.request("ChangePassword", {
      PreviousPassword: oldUserPassword,
      ProposedPassword: newUserPassword,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      ClientMetadata: clientMetadata
    }, function(err) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, "SUCCESS");
    });
    return void 0;
  };
  _proto.enableMFA = function enableMFA(callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback(new Error("User is not authenticated"), null);
    }
    var mfaOptions = [];
    var mfaEnabled = {
      DeliveryMedium: "SMS",
      AttributeName: "phone_number"
    };
    mfaOptions.push(mfaEnabled);
    this.client.request("SetUserSettings", {
      MFAOptions: mfaOptions,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(err) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, "SUCCESS");
    });
    return void 0;
  };
  _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback(new Error("User is not authenticated"), null);
    }
    this.client.request("SetUserMFAPreference", {
      SMSMfaSettings: smsMfaSettings,
      SoftwareTokenMfaSettings: softwareTokenMfaSettings,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(err) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, "SUCCESS");
    });
    return void 0;
  };
  _proto.disableMFA = function disableMFA(callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback(new Error("User is not authenticated"), null);
    }
    var mfaOptions = [];
    this.client.request("SetUserSettings", {
      MFAOptions: mfaOptions,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(err) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, "SUCCESS");
    });
    return void 0;
  };
  _proto.deleteUser = function deleteUser(callback, clientMetadata) {
    var _this9 = this;
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback(new Error("User is not authenticated"), null);
    }
    this.client.request("DeleteUser", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      ClientMetadata: clientMetadata
    }, function(err) {
      if (err) {
        return callback(err, null);
      }
      _this9.clearCachedUser();
      return callback(null, "SUCCESS");
    });
    return void 0;
  };
  _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
    var _this10 = this;
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback(new Error("User is not authenticated"), null);
    }
    this.client.request("UpdateUserAttributes", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      UserAttributes: attributes,
      ClientMetadata: clientMetadata
    }, function(err, result) {
      if (err) {
        return callback(err, null);
      }
      return _this10.getUserData(function() {
        return callback(null, "SUCCESS", result);
      }, {
        bypassCache: true
      });
    });
    return void 0;
  };
  _proto.getUserAttributes = function getUserAttributes(callback) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      return callback(new Error("User is not authenticated"), null);
    }
    this.client.request("GetUser", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(err, userData) {
      if (err) {
        return callback(err, null);
      }
      var attributeList = [];
      for (var i2 = 0; i2 < userData.UserAttributes.length; i2++) {
        var attribute = {
          Name: userData.UserAttributes[i2].Name,
          Value: userData.UserAttributes[i2].Value
        };
        var userAttribute = new CognitoUserAttribute(attribute);
        attributeList.push(userAttribute);
      }
      return callback(null, attributeList);
    });
    return void 0;
  };
  _proto.getMFAOptions = function getMFAOptions(callback) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      return callback(new Error("User is not authenticated"), null);
    }
    this.client.request("GetUser", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(err, userData) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, userData.MFAOptions);
    });
    return void 0;
  };
  _proto.createGetUserRequest = function createGetUserRequest() {
    return this.client.promisifyRequest("GetUser", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    });
  };
  _proto.refreshSessionIfPossible = function refreshSessionIfPossible(options) {
    var _this11 = this;
    if (options === void 0) {
      options = {};
    }
    return new Promise(function(resolve) {
      var refresh = _this11.signInUserSession.getRefreshToken();
      if (refresh && refresh.getToken()) {
        _this11.refreshSession(refresh, resolve, options.clientMetadata);
      } else {
        resolve();
      }
    });
  };
  _proto.getUserData = function getUserData(callback, params) {
    var _this12 = this;
    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      this.clearCachedUserData();
      return callback(new Error("User is not authenticated"), null);
    }
    var userData = this.getUserDataFromCache();
    if (!userData) {
      this.fetchUserData().then(function(data) {
        callback(null, data);
      })["catch"](callback);
      return;
    }
    if (this.isFetchUserDataAndTokenRequired(params)) {
      this.fetchUserData().then(function(data) {
        return _this12.refreshSessionIfPossible(params).then(function() {
          return data;
        });
      }).then(function(data) {
        return callback(null, data);
      })["catch"](callback);
      return;
    }
    try {
      callback(null, JSON.parse(userData));
      return;
    } catch (err) {
      this.clearCachedUserData();
      callback(err, null);
      return;
    }
  };
  _proto.getUserDataFromCache = function getUserDataFromCache() {
    var userData = this.storage.getItem(this.userDataKey);
    return userData;
  };
  _proto.isFetchUserDataAndTokenRequired = function isFetchUserDataAndTokenRequired(params) {
    var _ref = params || {}, _ref$bypassCache = _ref.bypassCache, bypassCache = _ref$bypassCache === void 0 ? false : _ref$bypassCache;
    return bypassCache;
  };
  _proto.fetchUserData = function fetchUserData() {
    var _this13 = this;
    return this.createGetUserRequest().then(function(data) {
      _this13.cacheUserData(data);
      return data;
    });
  };
  _proto.deleteAttributes = function deleteAttributes(attributeList, callback) {
    var _this14 = this;
    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      return callback(new Error("User is not authenticated"), null);
    }
    this.client.request("DeleteUserAttributes", {
      UserAttributeNames: attributeList,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(err) {
      if (err) {
        return callback(err, null);
      }
      return _this14.getUserData(function() {
        return callback(null, "SUCCESS");
      }, {
        bypassCache: true
      });
    });
    return void 0;
  };
  _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
    var jsonReq = {
      ClientId: this.pool.getClientId(),
      Username: this.username,
      ClientMetadata: clientMetadata
    };
    this.client.request("ResendConfirmationCode", jsonReq, function(err, result) {
      if (err) {
        return callback(err, null);
      }
      return callback(null, result);
    });
  };
  _proto.getSession = function getSession(callback, options) {
    if (options === void 0) {
      options = {};
    }
    if (this.username == null) {
      return callback(new Error("Username is null. Cannot retrieve a new session"), null);
    }
    if (this.signInUserSession != null && this.signInUserSession.isValid()) {
      return callback(null, this.signInUserSession);
    }
    var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
    var idTokenKey = keyPrefix + ".idToken";
    var accessTokenKey = keyPrefix + ".accessToken";
    var refreshTokenKey = keyPrefix + ".refreshToken";
    var clockDriftKey = keyPrefix + ".clockDrift";
    if (this.storage.getItem(idTokenKey)) {
      var idToken = new CognitoIdToken({
        IdToken: this.storage.getItem(idTokenKey)
      });
      var accessToken = new CognitoAccessToken({
        AccessToken: this.storage.getItem(accessTokenKey)
      });
      var refreshToken = new CognitoRefreshToken({
        RefreshToken: this.storage.getItem(refreshTokenKey)
      });
      var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
      var sessionData = {
        IdToken: idToken,
        AccessToken: accessToken,
        RefreshToken: refreshToken,
        ClockDrift: clockDrift
      };
      var cachedSession = new CognitoUserSession(sessionData);
      if (cachedSession.isValid()) {
        this.signInUserSession = cachedSession;
        return callback(null, this.signInUserSession);
      }
      if (!refreshToken.getToken()) {
        return callback(new Error("Cannot retrieve a new session. Please authenticate."), null);
      }
      this.refreshSession(refreshToken, callback, options.clientMetadata);
    } else {
      callback(new Error("Local storage is missing an ID Token, Please authenticate"), null);
    }
    return void 0;
  };
  _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
    var _this15 = this;
    var wrappedCallback = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(callback) : callback;
    var authParameters = {};
    authParameters.REFRESH_TOKEN = refreshToken.getToken();
    var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
    var lastUserKey = keyPrefix + ".LastAuthUser";
    if (this.storage.getItem(lastUserKey)) {
      this.username = this.storage.getItem(lastUserKey);
      var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
      this.deviceKey = this.storage.getItem(deviceKeyKey);
      authParameters.DEVICE_KEY = this.deviceKey;
    }
    var jsonReq = {
      ClientId: this.pool.getClientId(),
      AuthFlow: "REFRESH_TOKEN_AUTH",
      AuthParameters: authParameters,
      ClientMetadata: clientMetadata
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }
    this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
      if (err) {
        if (err.code === "NotAuthorizedException") {
          _this15.clearCachedUser();
        }
        return wrappedCallback(err, null);
      }
      if (authResult) {
        var authenticationResult = authResult.AuthenticationResult;
        if (!Object.prototype.hasOwnProperty.call(authenticationResult, "RefreshToken")) {
          authenticationResult.RefreshToken = refreshToken.getToken();
        }
        _this15.signInUserSession = _this15.getCognitoUserSession(authenticationResult);
        _this15.cacheTokens();
        return wrappedCallback(null, _this15.signInUserSession);
      }
      return void 0;
    });
  };
  _proto.cacheTokens = function cacheTokens() {
    var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
    var idTokenKey = keyPrefix + "." + this.username + ".idToken";
    var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
    var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
    var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
    var lastUserKey = keyPrefix + ".LastAuthUser";
    this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
    this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
    this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
    this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
    this.storage.setItem(lastUserKey, this.username);
  };
  _proto.cacheUserData = function cacheUserData(userData) {
    this.storage.setItem(this.userDataKey, JSON.stringify(userData));
  };
  _proto.clearCachedUserData = function clearCachedUserData() {
    this.storage.removeItem(this.userDataKey);
  };
  _proto.clearCachedUser = function clearCachedUser() {
    this.clearCachedTokens();
    this.clearCachedUserData();
  };
  _proto.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
    var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
    var deviceKeyKey = keyPrefix + ".deviceKey";
    var randomPasswordKey = keyPrefix + ".randomPasswordKey";
    var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
    this.storage.setItem(deviceKeyKey, this.deviceKey);
    this.storage.setItem(randomPasswordKey, this.randomPassword);
    this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
  };
  _proto.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
    var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
    var deviceKeyKey = keyPrefix + ".deviceKey";
    var randomPasswordKey = keyPrefix + ".randomPasswordKey";
    var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
    if (this.storage.getItem(deviceKeyKey)) {
      this.deviceKey = this.storage.getItem(deviceKeyKey);
      this.randomPassword = this.storage.getItem(randomPasswordKey);
      this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
    }
  };
  _proto.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
    var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
    var deviceKeyKey = keyPrefix + ".deviceKey";
    var randomPasswordKey = keyPrefix + ".randomPasswordKey";
    var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
    this.storage.removeItem(deviceKeyKey);
    this.storage.removeItem(randomPasswordKey);
    this.storage.removeItem(deviceGroupKeyKey);
  };
  _proto.clearCachedTokens = function clearCachedTokens() {
    var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
    var idTokenKey = keyPrefix + "." + this.username + ".idToken";
    var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
    var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
    var lastUserKey = keyPrefix + ".LastAuthUser";
    var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
    this.storage.removeItem(idTokenKey);
    this.storage.removeItem(accessTokenKey);
    this.storage.removeItem(refreshTokenKey);
    this.storage.removeItem(lastUserKey);
    this.storage.removeItem(clockDriftKey);
  };
  _proto.getCognitoUserSession = function getCognitoUserSession(authResult) {
    var idToken = new CognitoIdToken(authResult);
    var accessToken = new CognitoAccessToken(authResult);
    var refreshToken = new CognitoRefreshToken(authResult);
    var sessionData = {
      IdToken: idToken,
      AccessToken: accessToken,
      RefreshToken: refreshToken
    };
    return new CognitoUserSession(sessionData);
  };
  _proto.forgotPassword = function forgotPassword(callback, clientMetadata) {
    var jsonReq = {
      ClientId: this.pool.getClientId(),
      Username: this.username,
      ClientMetadata: clientMetadata
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }
    this.client.request("ForgotPassword", jsonReq, function(err, data) {
      if (err) {
        return callback.onFailure(err);
      }
      if (typeof callback.inputVerificationCode === "function") {
        return callback.inputVerificationCode(data);
      }
      return callback.onSuccess(data);
    });
  };
  _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
    var jsonReq = {
      ClientId: this.pool.getClientId(),
      Username: this.username,
      ConfirmationCode: confirmationCode,
      Password: newPassword,
      ClientMetadata: clientMetadata
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }
    this.client.request("ConfirmForgotPassword", jsonReq, function(err) {
      if (err) {
        return callback.onFailure(err);
      }
      return callback.onSuccess("SUCCESS");
    });
  };
  _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error("User is not authenticated"));
    }
    this.client.request("GetUserAttributeVerificationCode", {
      AttributeName: attributeName,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      ClientMetadata: clientMetadata
    }, function(err, data) {
      if (err) {
        return callback.onFailure(err);
      }
      if (typeof callback.inputVerificationCode === "function") {
        return callback.inputVerificationCode(data);
      }
      return callback.onSuccess("SUCCESS");
    });
    return void 0;
  };
  _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error("User is not authenticated"));
    }
    this.client.request("VerifyUserAttribute", {
      AttributeName: attributeName,
      Code: confirmationCode,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(err) {
      if (err) {
        return callback.onFailure(err);
      }
      return callback.onSuccess("SUCCESS");
    });
    return void 0;
  };
  _proto.getDevice = function getDevice(callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error("User is not authenticated"));
    }
    this.client.request("GetDevice", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: this.deviceKey
    }, function(err, data) {
      if (err) {
        return callback.onFailure(err);
      }
      return callback.onSuccess(data);
    });
    return void 0;
  };
  _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error("User is not authenticated"));
    }
    this.client.request("ForgetDevice", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: deviceKey
    }, function(err) {
      if (err) {
        return callback.onFailure(err);
      }
      return callback.onSuccess("SUCCESS");
    });
    return void 0;
  };
  _proto.forgetDevice = function forgetDevice(callback) {
    var _this16 = this;
    this.forgetSpecificDevice(this.deviceKey, {
      onFailure: callback.onFailure,
      onSuccess: function onSuccess(result) {
        _this16.deviceKey = null;
        _this16.deviceGroupKey = null;
        _this16.randomPassword = null;
        _this16.clearCachedDeviceKeyAndPassword();
        return callback.onSuccess(result);
      }
    });
  };
  _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error("User is not authenticated"));
    }
    this.client.request("UpdateDeviceStatus", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: this.deviceKey,
      DeviceRememberedStatus: "remembered"
    }, function(err) {
      if (err) {
        return callback.onFailure(err);
      }
      return callback.onSuccess("SUCCESS");
    });
    return void 0;
  };
  _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error("User is not authenticated"));
    }
    this.client.request("UpdateDeviceStatus", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: this.deviceKey,
      DeviceRememberedStatus: "not_remembered"
    }, function(err) {
      if (err) {
        return callback.onFailure(err);
      }
      return callback.onSuccess("SUCCESS");
    });
    return void 0;
  };
  _proto.listDevices = function listDevices(limit, paginationToken, callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error("User is not authenticated"));
    }
    var requestParams = {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      Limit: limit
    };
    if (paginationToken) {
      requestParams.PaginationToken = paginationToken;
    }
    this.client.request("ListDevices", requestParams, function(err, data) {
      if (err) {
        return callback.onFailure(err);
      }
      return callback.onSuccess(data);
    });
    return void 0;
  };
  _proto.globalSignOut = function globalSignOut(callback) {
    var _this17 = this;
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error("User is not authenticated"));
    }
    this.client.request("GlobalSignOut", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(err) {
      if (err) {
        return callback.onFailure(err);
      }
      _this17.clearCachedUser();
      return callback.onSuccess("SUCCESS");
    });
    return void 0;
  };
  _proto.signOut = function signOut(revokeTokenCallback) {
    var _this18 = this;
    if (!revokeTokenCallback || typeof revokeTokenCallback !== "function") {
      this.cleanClientData();
      return;
    }
    this.getSession(function(error, _session) {
      if (error) {
        return revokeTokenCallback(error);
      }
      _this18.revokeTokens(function(err) {
        _this18.cleanClientData();
        revokeTokenCallback(err);
      });
    });
  };
  _proto.revokeTokens = function revokeTokens(revokeTokenCallback) {
    if (revokeTokenCallback === void 0) {
      revokeTokenCallback = function revokeTokenCallback2() {
      };
    }
    if (typeof revokeTokenCallback !== "function") {
      throw new Error("Invalid revokeTokenCallback. It should be a function.");
    }
    var tokensToBeRevoked = [];
    if (!this.signInUserSession) {
      var error = new Error("User is not authenticated");
      return revokeTokenCallback(error);
    }
    if (!this.signInUserSession.getAccessToken()) {
      var _error = new Error("No Access token available");
      return revokeTokenCallback(_error);
    }
    var refreshToken = this.signInUserSession.getRefreshToken().getToken();
    var accessToken = this.signInUserSession.getAccessToken();
    if (this.isSessionRevocable(accessToken)) {
      if (refreshToken) {
        return this.revokeToken({
          token: refreshToken,
          callback: revokeTokenCallback
        });
      }
    }
    revokeTokenCallback();
  };
  _proto.isSessionRevocable = function isSessionRevocable(token) {
    if (token && typeof token.decodePayload === "function") {
      try {
        var _token$decodePayload = token.decodePayload(), origin_jti = _token$decodePayload.origin_jti;
        return !!origin_jti;
      } catch (err) {
      }
    }
    return false;
  };
  _proto.cleanClientData = function cleanClientData() {
    this.signInUserSession = null;
    this.clearCachedUser();
  };
  _proto.revokeToken = function revokeToken(_ref2) {
    var token = _ref2.token, callback = _ref2.callback;
    this.client.requestWithRetry("RevokeToken", {
      Token: token,
      ClientId: this.pool.getClientId()
    }, function(err) {
      if (err) {
        return callback(err);
      }
      callback();
    });
  };
  _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
    var _this19 = this;
    var challengeResponses = {};
    challengeResponses.USERNAME = this.username;
    challengeResponses.ANSWER = answerChallenge;
    var jsonReq = {
      ChallengeName: "SELECT_MFA_TYPE",
      ChallengeResponses: challengeResponses,
      ClientId: this.pool.getClientId(),
      Session: this.Session
    };
    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }
    this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
      if (err) {
        return callback.onFailure(err);
      }
      _this19.Session = data.Session;
      if (answerChallenge === "SMS_MFA") {
        return callback.mfaRequired(data.ChallengeName, data.ChallengeParameters);
      }
      if (answerChallenge === "SOFTWARE_TOKEN_MFA") {
        return callback.totpRequired(data.ChallengeName, data.ChallengeParameters);
      }
      return void 0;
    });
  };
  _proto.getUserContextData = function getUserContextData() {
    var pool = this.pool;
    return pool.getUserContextData(this.username);
  };
  _proto.associateSoftwareToken = function associateSoftwareToken(callback) {
    var _this20 = this;
    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      this.client.request("AssociateSoftwareToken", {
        Session: this.Session
      }, function(err, data) {
        if (err) {
          return callback.onFailure(err);
        }
        _this20.Session = data.Session;
        return callback.associateSecretCode(data.SecretCode);
      });
    } else {
      this.client.request("AssociateSoftwareToken", {
        AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
      }, function(err, data) {
        if (err) {
          return callback.onFailure(err);
        }
        return callback.associateSecretCode(data.SecretCode);
      });
    }
  };
  _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
    var _this21 = this;
    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      this.client.request("VerifySoftwareToken", {
        Session: this.Session,
        UserCode: totpCode,
        FriendlyDeviceName: friendlyDeviceName
      }, function(err, data) {
        if (err) {
          return callback.onFailure(err);
        }
        _this21.Session = data.Session;
        var challengeResponses = {};
        challengeResponses.USERNAME = _this21.username;
        var jsonReq = {
          ChallengeName: "MFA_SETUP",
          ClientId: _this21.pool.getClientId(),
          ChallengeResponses: challengeResponses,
          Session: _this21.Session
        };
        if (_this21.getUserContextData()) {
          jsonReq.UserContextData = _this21.getUserContextData();
        }
        _this21.client.request("RespondToAuthChallenge", jsonReq, function(errRespond, dataRespond) {
          if (errRespond) {
            return callback.onFailure(errRespond);
          }
          _this21.signInUserSession = _this21.getCognitoUserSession(dataRespond.AuthenticationResult);
          _this21.cacheTokens();
          return callback.onSuccess(_this21.signInUserSession);
        });
        return void 0;
      });
    } else {
      this.client.request("VerifySoftwareToken", {
        AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
        UserCode: totpCode,
        FriendlyDeviceName: friendlyDeviceName
      }, function(err, data) {
        if (err) {
          return callback.onFailure(err);
        }
        return callback.onSuccess(data);
      });
    }
  };
  return CognitoUser2;
}();

// node_modules/amazon-cognito-identity-js/es/Client.js
var import_isomorphic_unfetch2 = __toESM(require_browser());

// node_modules/amazon-cognito-identity-js/es/Platform/constants.js
var AUTH_CATEGORY = "auth";

// node_modules/amazon-cognito-identity-js/es/UserAgent.js
function UserAgent() {
}
UserAgent.prototype.userAgent = getUserAgent();
var addAuthCategoryToCognitoUserAgent = function addAuthCategoryToCognitoUserAgent2() {
  UserAgent.category = AUTH_CATEGORY;
};
var addFrameworkToCognitoUserAgent = function addFrameworkToCognitoUserAgent2(framework) {
  UserAgent.framework = framework;
};
var getAmplifyUserAgent2 = function getAmplifyUserAgent3(action) {
  var uaCategoryAction = UserAgent.category ? " " + UserAgent.category : "";
  var uaFramework = UserAgent.framework ? " framework/" + UserAgent.framework : "";
  var userAgent2 = "" + UserAgent.prototype.userAgent + uaCategoryAction + uaFramework;
  return userAgent2;
};

// node_modules/amazon-cognito-identity-js/es/Client.js
function _inheritsLoose3(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf3(subClass, superClass);
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper3(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class2.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } });
    return _setPrototypeOf3(Wrapper, Class2);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct3(Parent2, args2, Class2) {
      var a2 = [null];
      a2.push.apply(a2, args2);
      var Constructor = Function.bind.apply(Parent2, a2);
      var instance2 = new Constructor();
      if (Class2)
        _setPrototypeOf3(instance2, Class2.prototype);
      return instance2;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn2) {
  return Function.toString.call(fn2).indexOf("[native code]") !== -1;
}
function _setPrototypeOf3(o2, p2) {
  _setPrototypeOf3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf5(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf3(o2, p2);
}
function _getPrototypeOf(o2) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf3(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf(o2);
}
var CognitoError = /* @__PURE__ */ function(_Error2) {
  _inheritsLoose3(CognitoError2, _Error2);
  function CognitoError2(message, code, name, statusCode) {
    var _this;
    _this = _Error2.call(this, message) || this;
    _this.code = code;
    _this.name = name;
    _this.statusCode = statusCode;
    return _this;
  }
  return CognitoError2;
}(/* @__PURE__ */ _wrapNativeSuper(Error));
var Client2 = /* @__PURE__ */ function() {
  function Client5(region, endpoint, fetchOptions) {
    this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";
    var _ref = fetchOptions || {}, credentials = _ref.credentials;
    this.fetchOptions = credentials ? {
      credentials
    } : {};
  }
  var _proto = Client5.prototype;
  _proto.promisifyRequest = function promisifyRequest2(operation, params) {
    var _this2 = this;
    return new Promise(function(resolve, reject) {
      _this2.request(operation, params, function(err, data) {
        if (err) {
          reject(new CognitoError(err.message, err.code, err.name, err.statusCode));
        } else {
          resolve(data);
        }
      });
    });
  };
  _proto.requestWithRetry = function requestWithRetry(operation, params, callback) {
    var _this3 = this;
    var MAX_DELAY_IN_MILLIS = 5 * 1e3;
    jitteredExponentialRetry2(function(p2) {
      return new Promise(function(res, rej) {
        _this3.request(operation, p2, function(error, result) {
          if (error) {
            rej(error);
          } else {
            res(result);
          }
        });
      });
    }, [params], MAX_DELAY_IN_MILLIS).then(function(result) {
      return callback(null, result);
    })["catch"](function(error) {
      return callback(error);
    });
  };
  _proto.request = function request(operation, params, callback) {
    var headers = {
      "Content-Type": "application/x-amz-json-1.1",
      "X-Amz-Target": "AWSCognitoIdentityProviderService." + operation,
      "X-Amz-User-Agent": getAmplifyUserAgent2(),
      "Cache-Control": "no-store"
    };
    var options = Object.assign({}, this.fetchOptions, {
      headers,
      method: "POST",
      mode: "cors",
      body: JSON.stringify(params)
    });
    var response;
    var responseJsonData;
    fetch(this.endpoint, options).then(function(resp) {
      response = resp;
      return resp;
    }, function(err) {
      if (err instanceof TypeError) {
        throw new Error("Network error");
      }
      throw err;
    }).then(function(resp) {
      return resp.json()["catch"](function() {
        return {};
      });
    }).then(function(data) {
      if (response.ok)
        return callback(null, data);
      responseJsonData = data;
      var code = (data.__type || data.code).split("#").pop();
      var error = new Error(data.message || data.Message || null);
      error.name = code;
      error.code = code;
      return callback(error);
    })["catch"](function(err) {
      if (response && response.headers && response.headers.get("x-amzn-errortype")) {
        try {
          var code = response.headers.get("x-amzn-errortype").split(":")[0];
          var error = new Error(response.status ? response.status.toString() : null);
          error.code = code;
          error.name = code;
          error.statusCode = response.status;
          return callback(error);
        } catch (ex) {
          return callback(err);
        }
      } else if (err instanceof Error && err.message === "Network error") {
        err.code = "NetworkError";
      }
      return callback(err);
    });
  };
  return Client5;
}();
var logger24 = {
  debug: function debug() {
  }
};
var isNonRetryableError2 = function isNonRetryableError3(obj) {
  var key = "nonRetryable";
  return obj && obj[key];
};
function retry2(functionToRetry, args, delayFn, attempt) {
  if (attempt === void 0) {
    attempt = 1;
  }
  if (typeof functionToRetry !== "function") {
    throw Error("functionToRetry must be a function");
  }
  logger24.debug(functionToRetry.name + " attempt #" + attempt + " with args: " + JSON.stringify(args));
  return functionToRetry.apply(void 0, args)["catch"](function(err) {
    logger24.debug("error on " + functionToRetry.name, err);
    if (isNonRetryableError2(err)) {
      logger24.debug(functionToRetry.name + " non retryable error", err);
      throw err;
    }
    var retryIn = delayFn(attempt, args, err);
    logger24.debug(functionToRetry.name + " retrying in " + retryIn + " ms");
    if (retryIn !== false) {
      return new Promise(function(res) {
        return setTimeout(res, retryIn);
      }).then(function() {
        return retry2(functionToRetry, args, delayFn, attempt + 1);
      });
    } else {
      throw err;
    }
  });
}
function jitteredBackoff3(maxDelayMs) {
  var BASE_TIME_MS = 100;
  var JITTER_FACTOR = 100;
  return function(attempt) {
    var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
    return delay > maxDelayMs ? false : delay;
  };
}
var MAX_DELAY_MS2 = 5 * 60 * 1e3;
function jitteredExponentialRetry2(functionToRetry, args, maxDelayMs) {
  if (maxDelayMs === void 0) {
    maxDelayMs = MAX_DELAY_MS2;
  }
  return retry2(functionToRetry, args, jitteredBackoff3(maxDelayMs));
}

// node_modules/amazon-cognito-identity-js/es/CognitoUserPool.js
var USER_POOL_ID_MAX_LENGTH = 55;
var CognitoUserPool = /* @__PURE__ */ function() {
  function CognitoUserPool2(data, wrapRefreshSessionCallback) {
    var _ref = data || {}, UserPoolId = _ref.UserPoolId, ClientId = _ref.ClientId, endpoint = _ref.endpoint, fetchOptions = _ref.fetchOptions, AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
    if (!UserPoolId || !ClientId) {
      throw new Error("Both UserPoolId and ClientId are required.");
    }
    if (UserPoolId.length > USER_POOL_ID_MAX_LENGTH || !/^[\w-]+_[0-9a-zA-Z]+$/.test(UserPoolId)) {
      throw new Error("Invalid UserPoolId format.");
    }
    var region = UserPoolId.split("_")[0];
    this.userPoolId = UserPoolId;
    this.clientId = ClientId;
    this.client = new Client2(region, endpoint, fetchOptions);
    this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
    this.storage = data.Storage || new StorageHelper2().getStorage();
    if (wrapRefreshSessionCallback) {
      this.wrapRefreshSessionCallback = wrapRefreshSessionCallback;
    }
  }
  var _proto = CognitoUserPool2.prototype;
  _proto.getUserPoolId = function getUserPoolId() {
    return this.userPoolId;
  };
  _proto.getUserPoolName = function getUserPoolName() {
    return this.getUserPoolId().split("_")[1];
  };
  _proto.getClientId = function getClientId() {
    return this.clientId;
  };
  _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
    var _this = this;
    var jsonReq = {
      ClientId: this.clientId,
      Username: username,
      Password: password,
      UserAttributes: userAttributes,
      ValidationData: validationData,
      ClientMetadata: clientMetadata
    };
    if (this.getUserContextData(username)) {
      jsonReq.UserContextData = this.getUserContextData(username);
    }
    this.client.request("SignUp", jsonReq, function(err, data) {
      if (err) {
        return callback(err, null);
      }
      var cognitoUser = {
        Username: username,
        Pool: _this,
        Storage: _this.storage
      };
      var returnData = {
        user: new CognitoUser(cognitoUser),
        userConfirmed: data.UserConfirmed,
        userSub: data.UserSub,
        codeDeliveryDetails: data.CodeDeliveryDetails
      };
      return callback(null, returnData);
    });
  };
  _proto.getCurrentUser = function getCurrentUser() {
    var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
    var lastAuthUser = this.storage.getItem(lastUserKey);
    if (lastAuthUser) {
      var cognitoUser = {
        Username: lastAuthUser,
        Pool: this,
        Storage: this.storage
      };
      return new CognitoUser(cognitoUser);
    }
    return null;
  };
  _proto.getUserContextData = function getUserContextData(username) {
    if (typeof AmazonCognitoAdvancedSecurityData === "undefined") {
      return void 0;
    }
    var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
    if (this.advancedSecurityDataCollectionFlag) {
      var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
      if (advancedSecurityData) {
        var userContextData = {
          EncodedData: advancedSecurityData
        };
        return userContextData;
      }
    }
    return {};
  };
  return CognitoUserPool2;
}();

// node_modules/amazon-cognito-identity-js/es/CookieStorage.js
var Cookies2 = __toESM(require_js_cookie());
var CookieStorage = /* @__PURE__ */ function() {
  function CookieStorage2(data) {
    if (data === void 0) {
      data = {};
    }
    if (data.domain) {
      this.domain = data.domain;
    }
    if (data.path) {
      this.path = data.path;
    } else {
      this.path = "/";
    }
    if (Object.prototype.hasOwnProperty.call(data, "expires")) {
      this.expires = data.expires;
    } else {
      this.expires = 365;
    }
    if (Object.prototype.hasOwnProperty.call(data, "secure")) {
      this.secure = data.secure;
    } else {
      this.secure = true;
    }
    if (Object.prototype.hasOwnProperty.call(data, "sameSite")) {
      if (!["strict", "lax", "none"].includes(data.sameSite)) {
        throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
      }
      if (data.sameSite === "none" && !this.secure) {
        throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
      }
      this.sameSite = data.sameSite;
    } else {
      this.sameSite = null;
    }
  }
  var _proto = CookieStorage2.prototype;
  _proto.setItem = function setItem(key, value) {
    var options = {
      path: this.path,
      expires: this.expires,
      domain: this.domain,
      secure: this.secure
    };
    if (this.sameSite) {
      options.sameSite = this.sameSite;
    }
    Cookies2.set(key, value, options);
    return Cookies2.get(key);
  };
  _proto.getItem = function getItem(key) {
    return Cookies2.get(key);
  };
  _proto.removeItem = function removeItem(key) {
    var options = {
      path: this.path,
      expires: this.expires,
      domain: this.domain,
      secure: this.secure
    };
    if (this.sameSite) {
      options.sameSite = this.sameSite;
    }
    return Cookies2.remove(key, options);
  };
  _proto.clear = function clear() {
    var cookies = Cookies2.get();
    var numKeys = Object.keys(cookies).length;
    for (var index = 0; index < numKeys; ++index) {
      this.removeItem(Object.keys(cookies)[index]);
    }
    return {};
  };
  return CookieStorage2;
}();

// node_modules/@aws-amplify/auth/lib-esm/Auth.js
var import_url2 = __toESM(require_url());

// node_modules/@aws-amplify/auth/lib-esm/OAuth/OAuth.js
var import_url = __toESM(require_url());

// node_modules/@aws-amplify/auth/lib-esm/OAuth/urlOpener.js
var SELF = "_self";
var launchUri = function(url2) {
  var windowProxy = window.open(url2, SELF);
  if (windowProxy) {
    return Promise.resolve(windowProxy);
  } else {
    return Promise.reject();
  }
};

// node_modules/@aws-amplify/auth/lib-esm/OAuth/oauthStorage.js
var setState = function(state) {
  window.sessionStorage.setItem("oauth_state", state);
};
var getState = function() {
  var oauth_state = window.sessionStorage.getItem("oauth_state");
  window.sessionStorage.removeItem("oauth_state");
  return oauth_state;
};
var setPKCE = function(private_key) {
  window.sessionStorage.setItem("ouath_pkce_key", private_key);
};
var getPKCE = function() {
  var ouath_pkce_key = window.sessionStorage.getItem("ouath_pkce_key");
  window.sessionStorage.removeItem("ouath_pkce_key");
  return ouath_pkce_key;
};

// node_modules/@aws-amplify/auth/lib-esm/OAuth/OAuth.js
var import_buffer4 = __toESM(require_buffer());
var import_sha256_js4 = __toESM(require_build28());
var AMPLIFY_SYMBOL5 = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var dispatchAuthEvent = function(event, data, message) {
  Hub.dispatch("auth", { event, data, message }, "Auth", AMPLIFY_SYMBOL5);
};
var logger25 = new ConsoleLogger("OAuth");
var OAuth = (
  /** @class */
  function() {
    function OAuth2(_a2) {
      var config = _a2.config, cognitoClientId = _a2.cognitoClientId, _b2 = _a2.scopes, scopes = _b2 === void 0 ? [] : _b2;
      this._urlOpener = config.urlOpener || launchUri;
      this._config = config;
      this._cognitoClientId = cognitoClientId;
      if (!this.isValidScopes(scopes))
        throw Error("scopes must be a String Array");
      this._scopes = scopes;
    }
    OAuth2.prototype.isValidScopes = function(scopes) {
      return Array.isArray(scopes) && scopes.every(function(scope) {
        return typeof scope === "string";
      });
    };
    OAuth2.prototype.oauthSignIn = function(responseType, domain, redirectSignIn, clientId, provider, customState) {
      if (responseType === void 0) {
        responseType = "code";
      }
      if (provider === void 0) {
        provider = CognitoHostedUIIdentityProvider.Cognito;
      }
      var generatedState = this._generateState(32);
      var state = customState ? generatedState + "-" + urlSafeEncode(customState) : generatedState;
      setState(state);
      var pkce_key = this._generateRandom(128);
      setPKCE(pkce_key);
      var code_challenge = this._generateChallenge(pkce_key);
      var code_challenge_method = "S256";
      var scopesString = this._scopes.join(" ");
      var queryString = Object.entries(__assign31(__assign31({ redirect_uri: redirectSignIn, response_type: responseType, client_id: clientId, identity_provider: provider, scope: scopesString, state }, responseType === "code" ? { code_challenge } : {}), responseType === "code" ? { code_challenge_method } : {})).map(function(_a2) {
        var _b2 = __read28(_a2, 2), k2 = _b2[0], v2 = _b2[1];
        return encodeURIComponent(k2) + "=" + encodeURIComponent(v2);
      }).join("&");
      var URL2 = "https://" + domain + "/oauth2/authorize?" + queryString;
      logger25.debug("Redirecting to " + URL2);
      this._urlOpener(URL2, redirectSignIn);
    };
    OAuth2.prototype._handleCodeFlow = function(currentUrl) {
      return __awaiter49(this, void 0, void 0, function() {
        var code, currentUrlPathname, redirectSignInPathname, oAuthTokenEndpoint, client_id, redirect_uri, code_verifier, oAuthTokenBody, body, customUserAgentDetails, _a2, access_token, refresh_token, id_token, error;
        var _b2;
        return __generator50(this, function(_c) {
          switch (_c.label) {
            case 0:
              code = ((0, import_url.parse)(currentUrl).query || "").split("&").map(function(pairings) {
                return pairings.split("=");
              }).reduce(function(accum, _a3) {
                var _b3;
                var _c2 = __read28(_a3, 2), k2 = _c2[0], v2 = _c2[1];
                return __assign31(__assign31({}, accum), (_b3 = {}, _b3[k2] = v2, _b3));
              }, { code: void 0 }).code;
              currentUrlPathname = (0, import_url.parse)(currentUrl).pathname || "/";
              redirectSignInPathname = (0, import_url.parse)(this._config.redirectSignIn).pathname || "/";
              if (!code || currentUrlPathname !== redirectSignInPathname) {
                return [
                  2
                  /*return*/
                ];
              }
              oAuthTokenEndpoint = "https://" + this._config.domain + "/oauth2/token";
              dispatchAuthEvent("codeFlow", {}, "Retrieving tokens from " + oAuthTokenEndpoint);
              client_id = isCognitoHostedOpts(this._config) ? this._cognitoClientId : this._config.clientID;
              redirect_uri = isCognitoHostedOpts(this._config) ? this._config.redirectSignIn : this._config.redirectUri;
              code_verifier = getPKCE();
              oAuthTokenBody = __assign31({
                grant_type: "authorization_code",
                code,
                client_id,
                redirect_uri
              }, code_verifier ? { code_verifier } : {});
              logger25.debug("Calling token endpoint: " + oAuthTokenEndpoint + " with", oAuthTokenBody);
              body = Object.entries(oAuthTokenBody).map(function(_a3) {
                var _b3 = __read28(_a3, 2), k2 = _b3[0], v2 = _b3[1];
                return encodeURIComponent(k2) + "=" + encodeURIComponent(v2);
              }).join("&");
              customUserAgentDetails = {
                category: Category.Auth,
                action: AuthAction.FederatedSignIn
              };
              return [4, fetch(oAuthTokenEndpoint, {
                method: "POST",
                headers: (_b2 = {
                  "Content-Type": "application/x-www-form-urlencoded"
                }, _b2[USER_AGENT_HEADER] = getAmplifyUserAgent(customUserAgentDetails), _b2),
                body
              })];
            case 1:
              return [4, _c.sent().json()];
            case 2:
              _a2 = _c.sent(), access_token = _a2.access_token, refresh_token = _a2.refresh_token, id_token = _a2.id_token, error = _a2.error;
              if (error) {
                throw new Error(error);
              }
              return [2, {
                accessToken: access_token,
                refreshToken: refresh_token,
                idToken: id_token
              }];
          }
        });
      });
    };
    OAuth2.prototype._handleImplicitFlow = function(currentUrl) {
      return __awaiter49(this, void 0, void 0, function() {
        var _a2, id_token, access_token;
        return __generator50(this, function(_b2) {
          _a2 = ((0, import_url.parse)(currentUrl).hash || "#").substr(1).split("&").map(function(pairings) {
            return pairings.split("=");
          }).reduce(function(accum, _a3) {
            var _b3;
            var _c = __read28(_a3, 2), k2 = _c[0], v2 = _c[1];
            return __assign31(__assign31({}, accum), (_b3 = {}, _b3[k2] = v2, _b3));
          }, {
            id_token: void 0,
            access_token: void 0
          }), id_token = _a2.id_token, access_token = _a2.access_token;
          dispatchAuthEvent("implicitFlow", {}, "Got tokens from " + currentUrl);
          logger25.debug("Retrieving implicit tokens from " + currentUrl + " with");
          return [2, {
            accessToken: access_token,
            idToken: id_token,
            refreshToken: null
          }];
        });
      });
    };
    OAuth2.prototype.handleAuthResponse = function(currentUrl) {
      return __awaiter49(this, void 0, void 0, function() {
        var urlParams, error, error_description, state, _a2, _b2, e_1;
        return __generator50(this, function(_c) {
          switch (_c.label) {
            case 0:
              _c.trys.push([0, 5, , 6]);
              urlParams = currentUrl ? __assign31(__assign31({}, ((0, import_url.parse)(currentUrl).hash || "#").substr(1).split("&").map(function(entry) {
                return entry.split("=");
              }).reduce(function(acc, _a3) {
                var _b3 = __read28(_a3, 2), k2 = _b3[0], v2 = _b3[1];
                return acc[k2] = v2, acc;
              }, {})), ((0, import_url.parse)(currentUrl).query || "").split("&").map(function(entry) {
                return entry.split("=");
              }).reduce(function(acc, _a3) {
                var _b3 = __read28(_a3, 2), k2 = _b3[0], v2 = _b3[1];
                return acc[k2] = v2, acc;
              }, {})) : {};
              error = urlParams.error, error_description = urlParams.error_description;
              if (error) {
                throw new Error(error_description);
              }
              state = this._validateState(urlParams);
              logger25.debug("Starting " + this._config.responseType + " flow with " + currentUrl);
              if (!(this._config.responseType === "code"))
                return [3, 2];
              _a2 = [{}];
              return [4, this._handleCodeFlow(currentUrl)];
            case 1:
              return [2, __assign31.apply(void 0, [__assign31.apply(void 0, _a2.concat([_c.sent()])), { state }])];
            case 2:
              _b2 = [{}];
              return [4, this._handleImplicitFlow(currentUrl)];
            case 3:
              return [2, __assign31.apply(void 0, [__assign31.apply(void 0, _b2.concat([_c.sent()])), { state }])];
            case 4:
              return [3, 6];
            case 5:
              e_1 = _c.sent();
              logger25.debug("Error handling auth response.", e_1);
              throw e_1;
            case 6:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    OAuth2.prototype._validateState = function(urlParams) {
      if (!urlParams) {
        return;
      }
      var savedState = getState();
      var returnedState = urlParams.state;
      if (savedState && savedState !== returnedState) {
        throw new Error("Invalid state in OAuth flow");
      }
      return returnedState;
    };
    OAuth2.prototype.signOut = function() {
      return __awaiter49(this, void 0, void 0, function() {
        var oAuthLogoutEndpoint, client_id, signout_uri;
        return __generator50(this, function(_a2) {
          oAuthLogoutEndpoint = "https://" + this._config.domain + "/logout?";
          client_id = isCognitoHostedOpts(this._config) ? this._cognitoClientId : this._config.oauth.clientID;
          signout_uri = isCognitoHostedOpts(this._config) ? this._config.redirectSignOut : this._config.returnTo;
          oAuthLogoutEndpoint += Object.entries({
            client_id,
            logout_uri: encodeURIComponent(signout_uri)
          }).map(function(_a3) {
            var _b2 = __read28(_a3, 2), k2 = _b2[0], v2 = _b2[1];
            return k2 + "=" + v2;
          }).join("&");
          dispatchAuthEvent("oAuthSignOut", { oAuth: "signOut" }, "Signing out from " + oAuthLogoutEndpoint);
          logger25.debug("Signing out from " + oAuthLogoutEndpoint);
          return [2, this._urlOpener(oAuthLogoutEndpoint, signout_uri)];
        });
      });
    };
    OAuth2.prototype._generateState = function(length) {
      var result = "";
      var i2 = length;
      var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
      for (; i2 > 0; --i2)
        result += chars[Math.round(Math.random() * (chars.length - 1))];
      return result;
    };
    OAuth2.prototype._generateChallenge = function(code) {
      var awsCryptoHash = new import_sha256_js4.Sha256();
      awsCryptoHash.update(code);
      var resultFromAWSCrypto = awsCryptoHash.digestSync();
      var b64 = import_buffer4.Buffer.from(resultFromAWSCrypto).toString("base64");
      var base64URLFromAWSCrypto = this._base64URL(b64);
      return base64URLFromAWSCrypto;
    };
    OAuth2.prototype._base64URL = function(string) {
      return string.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    };
    OAuth2.prototype._generateRandom = function(size) {
      var CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
      var buffer = new Uint8Array(size);
      if (typeof window !== "undefined" && !!window.crypto) {
        window.crypto.getRandomValues(buffer);
      } else {
        for (var i2 = 0; i2 < size; i2 += 1) {
          buffer[i2] = Math.random() * CHARSET.length | 0;
        }
      }
      return this._bufferToString(buffer);
    };
    OAuth2.prototype._bufferToString = function(buffer) {
      var CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var state = [];
      for (var i2 = 0; i2 < buffer.byteLength; i2 += 1) {
        var index = buffer[i2] % CHARSET.length;
        state.push(CHARSET[index]);
      }
      return state.join("");
    };
    return OAuth2;
  }()
);
var OAuth_default = OAuth;

// node_modules/@aws-amplify/auth/lib-esm/urlListener.js
var urlListener_default = function(callback) {
  if (browserOrNode().isBrowser && window.location) {
    var url2 = window.location.href;
    callback({ url: url2 });
  } else if (browserOrNode().isNode) {
    (function() {
    });
  } else {
    throw new Error("Not supported");
  }
};

// node_modules/@aws-amplify/auth/lib-esm/common/AuthErrorStrings.js
var AuthErrorStrings;
(function(AuthErrorStrings2) {
  AuthErrorStrings2["DEFAULT_MSG"] = "Authentication Error";
  AuthErrorStrings2["EMPTY_EMAIL"] = "Email cannot be empty";
  AuthErrorStrings2["EMPTY_PHONE"] = "Phone number cannot be empty";
  AuthErrorStrings2["EMPTY_USERNAME"] = "Username cannot be empty";
  AuthErrorStrings2["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
  AuthErrorStrings2["EMPTY_PASSWORD"] = "Password cannot be empty";
  AuthErrorStrings2["EMPTY_CODE"] = "Confirmation code cannot be empty";
  AuthErrorStrings2["SIGN_UP_ERROR"] = "Error creating account";
  AuthErrorStrings2["NO_MFA"] = "No valid MFA method provided";
  AuthErrorStrings2["INVALID_MFA"] = "Invalid MFA type";
  AuthErrorStrings2["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
  AuthErrorStrings2["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
  AuthErrorStrings2["NETWORK_ERROR"] = "Network Error";
  AuthErrorStrings2["DEVICE_CONFIG"] = "Device tracking has not been configured in this User Pool";
  AuthErrorStrings2["AUTOSIGNIN_ERROR"] = "Please use your credentials to sign in";
})(AuthErrorStrings || (AuthErrorStrings = {}));

// node_modules/@aws-amplify/auth/lib-esm/Errors.js
var logger26 = new ConsoleLogger("AuthError");
var AuthError = (
  /** @class */
  function(_super) {
    __extends7(AuthError2, _super);
    function AuthError2(type) {
      var _this = this;
      var _a2 = authErrorMessages[type], message = _a2.message, log = _a2.log;
      _this = _super.call(this, message) || this;
      _this.constructor = AuthError2;
      Object.setPrototypeOf(_this, AuthError2.prototype);
      _this.name = "AuthError";
      _this.log = log || message;
      logger26.error(_this.log);
      return _this;
    }
    return AuthError2;
  }(Error)
);
var NoUserPoolError = (
  /** @class */
  function(_super) {
    __extends7(NoUserPoolError2, _super);
    function NoUserPoolError2(type) {
      var _this = _super.call(this, type) || this;
      _this.constructor = NoUserPoolError2;
      Object.setPrototypeOf(_this, NoUserPoolError2.prototype);
      _this.name = "NoUserPoolError";
      return _this;
    }
    return NoUserPoolError2;
  }(AuthError)
);
var authErrorMessages = {
  noConfig: {
    message: AuthErrorStrings.DEFAULT_MSG,
    log: "\n            Error: Amplify has not been configured correctly.\n            This error is typically caused by one of the following scenarios:\n\n            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point\n                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information\n            \n            2. There might be multiple conflicting versions of amplify packages in your node_modules.\n				Refer to our docs site for help upgrading Amplify packages (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js)\n        "
  },
  missingAuthConfig: {
    message: AuthErrorStrings.DEFAULT_MSG,
    log: "\n            Error: Amplify has not been configured correctly. \n            The configuration object is missing required auth properties.\n            This error is typically caused by one of the following scenarios:\n\n            1. Did you run `amplify push` after adding auth via `amplify add auth`?\n                See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information\n\n            2. This could also be caused by multiple conflicting versions of amplify packages, see (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js) for help upgrading Amplify packages.\n        "
  },
  emptyUsername: {
    message: AuthErrorStrings.EMPTY_USERNAME
  },
  // TODO: should include a list of valid sign-in types
  invalidUsername: {
    message: AuthErrorStrings.INVALID_USERNAME
  },
  emptyPassword: {
    message: AuthErrorStrings.EMPTY_PASSWORD
  },
  emptyCode: {
    message: AuthErrorStrings.EMPTY_CODE
  },
  signUpError: {
    message: AuthErrorStrings.SIGN_UP_ERROR,
    log: "The first parameter should either be non-null string or object"
  },
  noMFA: {
    message: AuthErrorStrings.NO_MFA
  },
  invalidMFA: {
    message: AuthErrorStrings.INVALID_MFA
  },
  emptyChallengeResponse: {
    message: AuthErrorStrings.EMPTY_CHALLENGE
  },
  noUserSession: {
    message: AuthErrorStrings.NO_USER_SESSION
  },
  deviceConfig: {
    message: AuthErrorStrings.DEVICE_CONFIG
  },
  networkError: {
    message: AuthErrorStrings.NETWORK_ERROR
  },
  autoSignInError: {
    message: AuthErrorStrings.AUTOSIGNIN_ERROR
  },
  default: {
    message: AuthErrorStrings.DEFAULT_MSG
  }
};

// node_modules/@aws-amplify/auth/lib-esm/Auth.js
var logger27 = new ConsoleLogger("AuthClass");
var USER_ADMIN_SCOPE = "aws.cognito.signin.user.admin";
var OAUTH_FLOW_MS_TIMEOUT = 10 * 1e3;
var AMPLIFY_SYMBOL6 = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var dispatchAuthEvent2 = function(event, data, message) {
  Hub.dispatch("auth", { event, data, message }, "Auth", AMPLIFY_SYMBOL6);
};
var MAX_DEVICES = 60;
var MAX_AUTOSIGNIN_POLLING_MS = 3 * 60 * 1e3;
var AuthClass = (
  /** @class */
  function() {
    function AuthClass2(config) {
      var _this = this;
      this.userPool = null;
      this.user = null;
      this.oAuthFlowInProgress = false;
      this.autoSignInInitiated = false;
      this.inflightSessionPromise = null;
      this.inflightSessionPromiseCounter = 0;
      this.Credentials = Credentials;
      this.wrapRefreshSessionCallback = function(callback) {
        var wrapped = function(error, data) {
          if (data) {
            dispatchAuthEvent2("tokenRefresh", void 0, "New token retrieved");
          } else {
            dispatchAuthEvent2("tokenRefresh_failure", error, "Failed to retrieve new token");
          }
          return callback(error, data);
        };
        return wrapped;
      };
      this.configure(config);
      this.currentCredentials = this.currentCredentials.bind(this);
      this.currentUserCredentials = this.currentUserCredentials.bind(this);
      Hub.listen("auth", function(_a2) {
        var payload = _a2.payload;
        var event = payload.event;
        switch (event) {
          case "verify":
          case "signIn":
            _this._storage.setItem("amplify-signin-with-hostedUI", "false");
            break;
          case "signOut":
            _this._storage.removeItem("amplify-signin-with-hostedUI");
            break;
          case "cognitoHostedUI":
            _this._storage.setItem("amplify-signin-with-hostedUI", "true");
            break;
        }
      });
      addAuthCategoryToCognitoUserAgent();
      addFrameworkToCognitoUserAgent(Platform.framework);
      Platform.observeFrameworkChanges(function() {
        addFrameworkToCognitoUserAgent(Platform.framework);
      });
    }
    AuthClass2.prototype.getModuleName = function() {
      return "Auth";
    };
    AuthClass2.prototype.configure = function(config) {
      var _this = this;
      if (!config)
        return this._config || {};
      logger27.debug("configure Auth");
      var conf = Object.assign({}, this._config, parseAWSExports(config).Auth, config);
      this._config = conf;
      var _a2 = this._config, userPoolId = _a2.userPoolId, userPoolWebClientId = _a2.userPoolWebClientId, cookieStorage = _a2.cookieStorage, oauth = _a2.oauth, region = _a2.region, identityPoolId = _a2.identityPoolId, mandatorySignIn = _a2.mandatorySignIn, refreshHandlers = _a2.refreshHandlers, identityPoolRegion = _a2.identityPoolRegion, clientMetadata = _a2.clientMetadata, endpoint = _a2.endpoint, storage = _a2.storage;
      if (!storage) {
        if (cookieStorage)
          this._storage = new CookieStorage(cookieStorage);
        else {
          this._storage = config.ssr ? new UniversalStorage() : new StorageHelper().getStorage();
        }
      } else {
        if (!this._isValidAuthStorage(storage)) {
          logger27.error("The storage in the Auth config is not valid!");
          throw new Error("Empty storage object");
        }
        this._storage = storage;
      }
      this._storageSync = Promise.resolve();
      if (typeof this._storage["sync"] === "function") {
        this._storageSync = this._storage["sync"]();
      }
      if (userPoolId) {
        var userPoolData = {
          UserPoolId: userPoolId,
          ClientId: userPoolWebClientId,
          endpoint
        };
        userPoolData.Storage = this._storage;
        this.userPool = new CognitoUserPool(userPoolData, this.wrapRefreshSessionCallback);
      }
      this.Credentials.configure({
        mandatorySignIn,
        region,
        userPoolId,
        identityPoolId,
        refreshHandlers,
        storage: this._storage,
        identityPoolRegion
      });
      var cognitoHostedUIConfig = oauth ? isCognitoHostedOpts(this._config.oauth) ? oauth : oauth.awsCognito : void 0;
      if (cognitoHostedUIConfig) {
        var cognitoAuthParams = Object.assign({
          cognitoClientId: userPoolWebClientId,
          UserPoolId: userPoolId,
          domain: cognitoHostedUIConfig["domain"],
          scopes: cognitoHostedUIConfig["scope"],
          redirectSignIn: cognitoHostedUIConfig["redirectSignIn"],
          redirectSignOut: cognitoHostedUIConfig["redirectSignOut"],
          responseType: cognitoHostedUIConfig["responseType"],
          Storage: this._storage,
          urlOpener: cognitoHostedUIConfig["urlOpener"],
          clientMetadata
        }, cognitoHostedUIConfig["options"]);
        this._oAuthHandler = new OAuth_default({
          scopes: cognitoAuthParams.scopes,
          config: cognitoAuthParams,
          cognitoClientId: cognitoAuthParams.cognitoClientId
        });
        var usedResponseUrls_1 = {};
        urlListener_default(function(_a3) {
          var url2 = _a3.url;
          if (usedResponseUrls_1[url2]) {
            return;
          }
          usedResponseUrls_1[url2] = true;
          _this._handleAuthResponse(url2);
        });
      }
      dispatchAuthEvent2("configured", null, "The Auth category has been configured successfully");
      if (!this.autoSignInInitiated && typeof this._storage["getItem"] === "function") {
        var pollingInitiated = this.isTrueStorageValue("amplify-polling-started");
        if (pollingInitiated) {
          dispatchAuthEvent2("autoSignIn_failure", null, AuthErrorTypes.AutoSignInError);
          this._storage.removeItem("amplify-auto-sign-in");
        }
        this._storage.removeItem("amplify-polling-started");
      }
      return this._config;
    };
    AuthClass2.prototype.signUp = function(params) {
      var _this = this;
      var restOfAttrs = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        restOfAttrs[_i - 1] = arguments[_i];
      }
      var _a2, _b2, _c;
      if (!this.userPool) {
        return this.rejectNoUserPool();
      }
      var username = null;
      var password = null;
      var attributes = [];
      var validationData = null;
      var clientMetadata;
      var autoSignIn = { enabled: false };
      var autoSignInValidationData = {};
      var autoSignInClientMetaData = {};
      if (params && typeof params === "string") {
        username = params;
        password = restOfAttrs ? restOfAttrs[0] : null;
        var email = restOfAttrs ? restOfAttrs[1] : null;
        var phone_number = restOfAttrs ? restOfAttrs[2] : null;
        if (email)
          attributes.push(new CognitoUserAttribute({ Name: "email", Value: email }));
        if (phone_number)
          attributes.push(new CognitoUserAttribute({
            Name: "phone_number",
            Value: phone_number
          }));
      } else if (params && typeof params === "object") {
        username = params["username"];
        password = params["password"];
        if (params && params.clientMetadata) {
          clientMetadata = params.clientMetadata;
        } else if (this._config.clientMetadata) {
          clientMetadata = this._config.clientMetadata;
        }
        var attrs_1 = params["attributes"];
        if (attrs_1) {
          Object.keys(attrs_1).map(function(key) {
            attributes.push(new CognitoUserAttribute({ Name: key, Value: attrs_1[key] }));
          });
        }
        var validationDataObject_1 = params["validationData"];
        if (validationDataObject_1) {
          validationData = [];
          Object.keys(validationDataObject_1).map(function(key) {
            validationData.push(new CognitoUserAttribute({
              Name: key,
              Value: validationDataObject_1[key]
            }));
          });
        }
        autoSignIn = (_a2 = params.autoSignIn) !== null && _a2 !== void 0 ? _a2 : { enabled: false };
        if (autoSignIn.enabled) {
          this._storage.setItem("amplify-auto-sign-in", "true");
          autoSignInValidationData = (_b2 = autoSignIn.validationData) !== null && _b2 !== void 0 ? _b2 : {};
          autoSignInClientMetaData = (_c = autoSignIn.clientMetaData) !== null && _c !== void 0 ? _c : {};
        }
      } else {
        return this.rejectAuthError(AuthErrorTypes.SignUpError);
      }
      if (!username) {
        return this.rejectAuthError(AuthErrorTypes.EmptyUsername);
      }
      if (!password) {
        return this.rejectAuthError(AuthErrorTypes.EmptyPassword);
      }
      logger27.debug("signUp attrs:", attributes);
      logger27.debug("signUp validation data:", validationData);
      return new Promise(function(resolve, reject) {
        _this.userPool.signUp(username, password, attributes, validationData, function(err, data) {
          if (err) {
            dispatchAuthEvent2("signUp_failure", err, username + " failed to signup");
            reject(err);
          } else {
            dispatchAuthEvent2("signUp", data, username + " has signed up successfully");
            if (autoSignIn.enabled) {
              _this.handleAutoSignIn(username, password, autoSignInValidationData, autoSignInClientMetaData, data);
            }
            resolve(data);
          }
        }, clientMetadata);
      });
    };
    AuthClass2.prototype.handleAutoSignIn = function(username, password, validationData, clientMetadata, data) {
      this.autoSignInInitiated = true;
      var authDetails = new AuthenticationDetails({
        Username: username,
        Password: password,
        ValidationData: validationData,
        ClientMetadata: clientMetadata
      });
      if (data.userConfirmed) {
        this.signInAfterUserConfirmed(authDetails);
      } else if (this._config.signUpVerificationMethod === "link") {
        this.handleLinkAutoSignIn(authDetails);
      } else {
        this.handleCodeAutoSignIn(authDetails);
      }
    };
    AuthClass2.prototype.handleCodeAutoSignIn = function(authDetails) {
      var _this = this;
      var listenEvent = function(_a2) {
        var payload = _a2.payload;
        if (payload.event === "confirmSignUp") {
          _this.signInAfterUserConfirmed(authDetails, listenEvent);
        }
      };
      Hub.listen("auth", listenEvent);
    };
    AuthClass2.prototype.handleLinkAutoSignIn = function(authDetails) {
      var _this = this;
      this._storage.setItem("amplify-polling-started", "true");
      var start = Date.now();
      var autoSignInPollingIntervalId = setInterval(function() {
        if (Date.now() - start > MAX_AUTOSIGNIN_POLLING_MS) {
          clearInterval(autoSignInPollingIntervalId);
          dispatchAuthEvent2("autoSignIn_failure", null, "Please confirm your account and use your credentials to sign in.");
          _this._storage.removeItem("amplify-auto-sign-in");
        } else {
          _this.signInAfterUserConfirmed(authDetails, null, autoSignInPollingIntervalId);
        }
      }, 5e3);
    };
    AuthClass2.prototype.signInAfterUserConfirmed = function(authDetails, listenEvent, autoSignInPollingIntervalId) {
      return __awaiter49(this, void 0, void 0, function() {
        var user, error_1;
        var _this = this;
        return __generator50(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              user = this.createCognitoUser(authDetails.getUsername());
              _a2.label = 1;
            case 1:
              _a2.trys.push([1, 3, , 4]);
              return [4, user.authenticateUser(authDetails, this.authCallbacks(user, function(value) {
                dispatchAuthEvent2("autoSignIn", value, authDetails.getUsername() + " has signed in successfully");
                if (listenEvent) {
                  Hub.remove("auth", listenEvent);
                }
                if (autoSignInPollingIntervalId) {
                  clearInterval(autoSignInPollingIntervalId);
                  _this._storage.removeItem("amplify-polling-started");
                }
                _this._storage.removeItem("amplify-auto-sign-in");
              }, function(error) {
                logger27.error(error);
                _this._storage.removeItem("amplify-auto-sign-in");
              }))];
            case 2:
              _a2.sent();
              return [3, 4];
            case 3:
              error_1 = _a2.sent();
              logger27.error(error_1);
              return [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AuthClass2.prototype.confirmSignUp = function(username, code, options) {
      var _this = this;
      if (!this.userPool) {
        return this.rejectNoUserPool();
      }
      if (!username) {
        return this.rejectAuthError(AuthErrorTypes.EmptyUsername);
      }
      if (!code) {
        return this.rejectAuthError(AuthErrorTypes.EmptyCode);
      }
      var user = this.createCognitoUser(username);
      var forceAliasCreation = options && typeof options.forceAliasCreation === "boolean" ? options.forceAliasCreation : true;
      var clientMetadata;
      if (options && options.clientMetadata) {
        clientMetadata = options.clientMetadata;
      } else if (this._config.clientMetadata) {
        clientMetadata = this._config.clientMetadata;
      }
      return new Promise(function(resolve, reject) {
        user.confirmRegistration(code, forceAliasCreation, function(err, data) {
          if (err) {
            reject(err);
          } else {
            dispatchAuthEvent2("confirmSignUp", data, username + " has been confirmed successfully");
            var autoSignIn = _this.isTrueStorageValue("amplify-auto-sign-in");
            if (autoSignIn && !_this.autoSignInInitiated) {
              dispatchAuthEvent2("autoSignIn_failure", null, AuthErrorTypes.AutoSignInError);
              _this._storage.removeItem("amplify-auto-sign-in");
            }
            resolve(data);
          }
        }, clientMetadata);
      });
    };
    AuthClass2.prototype.isTrueStorageValue = function(value) {
      var item = this._storage.getItem(value);
      return item ? item === "true" : false;
    };
    AuthClass2.prototype.resendSignUp = function(username, clientMetadata) {
      if (clientMetadata === void 0) {
        clientMetadata = this._config.clientMetadata;
      }
      if (!this.userPool) {
        return this.rejectNoUserPool();
      }
      if (!username) {
        return this.rejectAuthError(AuthErrorTypes.EmptyUsername);
      }
      var user = this.createCognitoUser(username);
      return new Promise(function(resolve, reject) {
        user.resendConfirmationCode(function(err, data) {
          if (err) {
            reject(err);
          } else {
            resolve(data);
          }
        }, clientMetadata);
      });
    };
    AuthClass2.prototype.signIn = function(usernameOrSignInOpts, pw, clientMetadata) {
      if (clientMetadata === void 0) {
        clientMetadata = this._config.clientMetadata;
      }
      if (!this.userPool) {
        return this.rejectNoUserPool();
      }
      var username = null;
      var password = null;
      var validationData = {};
      if (typeof usernameOrSignInOpts === "string") {
        username = usernameOrSignInOpts;
        password = pw;
      } else if (isUsernamePasswordOpts(usernameOrSignInOpts)) {
        if (typeof pw !== "undefined") {
          logger27.warn("The password should be defined under the first parameter object!");
        }
        username = usernameOrSignInOpts.username;
        password = usernameOrSignInOpts.password;
        validationData = usernameOrSignInOpts.validationData;
      } else {
        return this.rejectAuthError(AuthErrorTypes.InvalidUsername);
      }
      if (!username) {
        return this.rejectAuthError(AuthErrorTypes.EmptyUsername);
      }
      var authDetails = new AuthenticationDetails({
        Username: username,
        Password: password,
        ValidationData: validationData,
        ClientMetadata: clientMetadata
      });
      if (password) {
        return this.signInWithPassword(authDetails);
      } else {
        return this.signInWithoutPassword(authDetails);
      }
    };
    AuthClass2.prototype.authCallbacks = function(user, resolve, reject) {
      var _this = this;
      var that = this;
      return {
        onSuccess: function(session) {
          return __awaiter49(_this, void 0, void 0, function() {
            var cred, e_1, currentUser, e_2;
            return __generator50(this, function(_a2) {
              switch (_a2.label) {
                case 0:
                  logger27.debug(session);
                  delete user["challengeName"];
                  delete user["challengeParam"];
                  _a2.label = 1;
                case 1:
                  _a2.trys.push([1, 4, 5, 9]);
                  return [4, this.Credentials.clear()];
                case 2:
                  _a2.sent();
                  return [4, this.Credentials.set(session, "session")];
                case 3:
                  cred = _a2.sent();
                  logger27.debug("succeed to get cognito credentials", cred);
                  return [3, 9];
                case 4:
                  e_1 = _a2.sent();
                  logger27.debug("cannot get cognito credentials", e_1);
                  return [3, 9];
                case 5:
                  _a2.trys.push([5, 7, , 8]);
                  return [4, this.currentUserPoolUser()];
                case 6:
                  currentUser = _a2.sent();
                  that.user = currentUser;
                  dispatchAuthEvent2("signIn", currentUser, "A user " + user.getUsername() + " has been signed in");
                  resolve(currentUser);
                  return [3, 8];
                case 7:
                  e_2 = _a2.sent();
                  logger27.error("Failed to get the signed in user", e_2);
                  reject(e_2);
                  return [3, 8];
                case 8:
                  return [
                    7
                    /*endfinally*/
                  ];
                case 9:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        },
        onFailure: function(err) {
          logger27.debug("signIn failure", err);
          dispatchAuthEvent2("signIn_failure", err, user.getUsername() + " failed to signin");
          reject(err);
        },
        customChallenge: function(challengeParam) {
          logger27.debug("signIn custom challenge answer required");
          user["challengeName"] = "CUSTOM_CHALLENGE";
          user["challengeParam"] = challengeParam;
          resolve(user);
        },
        mfaRequired: function(challengeName, challengeParam) {
          logger27.debug("signIn MFA required");
          user["challengeName"] = challengeName;
          user["challengeParam"] = challengeParam;
          resolve(user);
        },
        mfaSetup: function(challengeName, challengeParam) {
          logger27.debug("signIn mfa setup", challengeName);
          user["challengeName"] = challengeName;
          user["challengeParam"] = challengeParam;
          resolve(user);
        },
        newPasswordRequired: function(userAttributes, requiredAttributes) {
          logger27.debug("signIn new password");
          user["challengeName"] = "NEW_PASSWORD_REQUIRED";
          user["challengeParam"] = {
            userAttributes,
            requiredAttributes
          };
          resolve(user);
        },
        totpRequired: function(challengeName, challengeParam) {
          logger27.debug("signIn totpRequired");
          user["challengeName"] = challengeName;
          user["challengeParam"] = challengeParam;
          resolve(user);
        },
        selectMFAType: function(challengeName, challengeParam) {
          logger27.debug("signIn selectMFAType", challengeName);
          user["challengeName"] = challengeName;
          user["challengeParam"] = challengeParam;
          resolve(user);
        }
      };
    };
    AuthClass2.prototype.signInWithPassword = function(authDetails) {
      var _this = this;
      if (this.pendingSignIn) {
        throw new Error("Pending sign-in attempt already in progress");
      }
      var user = this.createCognitoUser(authDetails.getUsername());
      this.pendingSignIn = new Promise(function(resolve, reject) {
        user.authenticateUser(authDetails, _this.authCallbacks(user, function(value) {
          _this.pendingSignIn = null;
          resolve(value);
        }, function(error) {
          _this.pendingSignIn = null;
          reject(error);
        }));
      });
      return this.pendingSignIn;
    };
    AuthClass2.prototype.signInWithoutPassword = function(authDetails) {
      var _this = this;
      var user = this.createCognitoUser(authDetails.getUsername());
      user.setAuthenticationFlowType("CUSTOM_AUTH");
      return new Promise(function(resolve, reject) {
        user.initiateAuth(authDetails, _this.authCallbacks(user, resolve, reject));
      });
    };
    AuthClass2.prototype.getMFAOptions = function(user) {
      return new Promise(function(res, rej) {
        user.getMFAOptions(function(err, mfaOptions) {
          if (err) {
            logger27.debug("get MFA Options failed", err);
            rej(err);
            return;
          }
          logger27.debug("get MFA options success", mfaOptions);
          res(mfaOptions);
          return;
        });
      });
    };
    AuthClass2.prototype.getPreferredMFA = function(user, params) {
      var _this = this;
      var that = this;
      return new Promise(function(res, rej) {
        var clientMetadata = _this._config.clientMetadata;
        var bypassCache = params ? params.bypassCache : false;
        user.getUserData(function(err, data) {
          return __awaiter49(_this, void 0, void 0, function() {
            var cleanUpError_1, mfaType;
            return __generator50(this, function(_a2) {
              switch (_a2.label) {
                case 0:
                  if (!err)
                    return [3, 5];
                  logger27.debug("getting preferred mfa failed", err);
                  if (!this.isSessionInvalid(err))
                    return [3, 4];
                  _a2.label = 1;
                case 1:
                  _a2.trys.push([1, 3, , 4]);
                  return [4, this.cleanUpInvalidSession(user)];
                case 2:
                  _a2.sent();
                  return [3, 4];
                case 3:
                  cleanUpError_1 = _a2.sent();
                  rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_1.message));
                  return [
                    2
                    /*return*/
                  ];
                case 4:
                  rej(err);
                  return [
                    2
                    /*return*/
                  ];
                case 5:
                  mfaType = that._getMfaTypeFromUserData(data);
                  if (!mfaType) {
                    rej("invalid MFA Type");
                    return [
                      2
                      /*return*/
                    ];
                  } else {
                    res(mfaType);
                    return [
                      2
                      /*return*/
                    ];
                  }
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }, { bypassCache, clientMetadata });
      });
    };
    AuthClass2.prototype._getMfaTypeFromUserData = function(data) {
      var ret = null;
      var preferredMFA = data.PreferredMfaSetting;
      if (preferredMFA) {
        ret = preferredMFA;
      } else {
        var mfaList = data.UserMFASettingList;
        if (!mfaList) {
          var MFAOptions = data.MFAOptions;
          if (MFAOptions) {
            ret = "SMS_MFA";
          } else {
            ret = "NOMFA";
          }
        } else if (mfaList.length === 0) {
          ret = "NOMFA";
        } else {
          logger27.debug("invalid case for getPreferredMFA", data);
        }
      }
      return ret;
    };
    AuthClass2.prototype._getUserData = function(user, params) {
      var _this = this;
      return new Promise(function(res, rej) {
        user.getUserData(function(err, data) {
          return __awaiter49(_this, void 0, void 0, function() {
            var cleanUpError_2;
            return __generator50(this, function(_a2) {
              switch (_a2.label) {
                case 0:
                  if (!err)
                    return [3, 5];
                  logger27.debug("getting user data failed", err);
                  if (!this.isSessionInvalid(err))
                    return [3, 4];
                  _a2.label = 1;
                case 1:
                  _a2.trys.push([1, 3, , 4]);
                  return [4, this.cleanUpInvalidSession(user)];
                case 2:
                  _a2.sent();
                  return [3, 4];
                case 3:
                  cleanUpError_2 = _a2.sent();
                  rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_2.message));
                  return [
                    2
                    /*return*/
                  ];
                case 4:
                  rej(err);
                  return [
                    2
                    /*return*/
                  ];
                case 5:
                  res(data);
                  _a2.label = 6;
                case 6:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }, params);
      });
    };
    AuthClass2.prototype.setPreferredMFA = function(user, mfaMethod) {
      return __awaiter49(this, void 0, void 0, function() {
        var clientMetadata, userData, smsMfaSettings, totpMfaSettings, _a2, mfaList, currentMFAType, that;
        var _this = this;
        return __generator50(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              clientMetadata = this._config.clientMetadata;
              return [4, this._getUserData(user, {
                bypassCache: true,
                clientMetadata
              })];
            case 1:
              userData = _b2.sent();
              smsMfaSettings = null;
              totpMfaSettings = null;
              _a2 = mfaMethod;
              switch (_a2) {
                case "TOTP":
                  return [3, 2];
                case "SOFTWARE_TOKEN_MFA":
                  return [3, 2];
                case "SMS":
                  return [3, 3];
                case "SMS_MFA":
                  return [3, 3];
                case "NOMFA":
                  return [3, 4];
              }
              return [3, 6];
            case 2:
              totpMfaSettings = {
                PreferredMfa: true,
                Enabled: true
              };
              return [3, 7];
            case 3:
              smsMfaSettings = {
                PreferredMfa: true,
                Enabled: true
              };
              return [3, 7];
            case 4:
              mfaList = userData["UserMFASettingList"];
              return [4, this._getMfaTypeFromUserData(userData)];
            case 5:
              currentMFAType = _b2.sent();
              if (currentMFAType === "NOMFA") {
                return [2, Promise.resolve("No change for mfa type")];
              } else if (currentMFAType === "SMS_MFA") {
                smsMfaSettings = {
                  PreferredMfa: false,
                  Enabled: false
                };
              } else if (currentMFAType === "SOFTWARE_TOKEN_MFA") {
                totpMfaSettings = {
                  PreferredMfa: false,
                  Enabled: false
                };
              } else {
                return [2, this.rejectAuthError(AuthErrorTypes.InvalidMFA)];
              }
              if (mfaList && mfaList.length !== 0) {
                mfaList.forEach(function(mfaType) {
                  if (mfaType === "SMS_MFA") {
                    smsMfaSettings = {
                      PreferredMfa: false,
                      Enabled: false
                    };
                  } else if (mfaType === "SOFTWARE_TOKEN_MFA") {
                    totpMfaSettings = {
                      PreferredMfa: false,
                      Enabled: false
                    };
                  }
                });
              }
              return [3, 7];
            case 6:
              logger27.debug("no validmfa method provided");
              return [2, this.rejectAuthError(AuthErrorTypes.NoMFA)];
            case 7:
              that = this;
              return [2, new Promise(function(res, rej) {
                user.setUserMfaPreference(smsMfaSettings, totpMfaSettings, function(err, result) {
                  if (err) {
                    logger27.debug("Set user mfa preference error", err);
                    return rej(err);
                  }
                  logger27.debug("Set user mfa success", result);
                  logger27.debug("Caching the latest user data into local");
                  user.getUserData(function(err2, data) {
                    return __awaiter49(_this, void 0, void 0, function() {
                      var cleanUpError_3;
                      return __generator50(this, function(_a3) {
                        switch (_a3.label) {
                          case 0:
                            if (!err2)
                              return [3, 5];
                            logger27.debug("getting user data failed", err2);
                            if (!this.isSessionInvalid(err2))
                              return [3, 4];
                            _a3.label = 1;
                          case 1:
                            _a3.trys.push([1, 3, , 4]);
                            return [4, this.cleanUpInvalidSession(user)];
                          case 2:
                            _a3.sent();
                            return [3, 4];
                          case 3:
                            cleanUpError_3 = _a3.sent();
                            rej(new Error("Session is invalid due to: " + err2.message + " and failed to clean up invalid session: " + cleanUpError_3.message));
                            return [
                              2
                              /*return*/
                            ];
                          case 4:
                            return [2, rej(err2)];
                          case 5:
                            return [2, res(result)];
                        }
                      });
                    });
                  }, {
                    bypassCache: true,
                    clientMetadata
                  });
                });
              })];
          }
        });
      });
    };
    AuthClass2.prototype.disableSMS = function(user) {
      return new Promise(function(res, rej) {
        user.disableMFA(function(err, data) {
          if (err) {
            logger27.debug("disable mfa failed", err);
            rej(err);
            return;
          }
          logger27.debug("disable mfa succeed", data);
          res(data);
          return;
        });
      });
    };
    AuthClass2.prototype.enableSMS = function(user) {
      return new Promise(function(res, rej) {
        user.enableMFA(function(err, data) {
          if (err) {
            logger27.debug("enable mfa failed", err);
            rej(err);
            return;
          }
          logger27.debug("enable mfa succeed", data);
          res(data);
          return;
        });
      });
    };
    AuthClass2.prototype.setupTOTP = function(user) {
      return new Promise(function(res, rej) {
        user.associateSoftwareToken({
          onFailure: function(err) {
            logger27.debug("associateSoftwareToken failed", err);
            rej(err);
            return;
          },
          associateSecretCode: function(secretCode) {
            logger27.debug("associateSoftwareToken success", secretCode);
            res(secretCode);
            return;
          }
        });
      });
    };
    AuthClass2.prototype.verifyTotpToken = function(user, challengeAnswer) {
      logger27.debug("verification totp token", user, challengeAnswer);
      var signInUserSession;
      if (user && typeof user.getSignInUserSession === "function") {
        signInUserSession = user.getSignInUserSession();
      }
      var isLoggedIn = signInUserSession === null || signInUserSession === void 0 ? void 0 : signInUserSession.isValid();
      return new Promise(function(res, rej) {
        user.verifySoftwareToken(challengeAnswer, "My TOTP device", {
          onFailure: function(err) {
            logger27.debug("verifyTotpToken failed", err);
            rej(err);
            return;
          },
          onSuccess: function(data) {
            if (!isLoggedIn) {
              dispatchAuthEvent2("signIn", user, "A user " + user.getUsername() + " has been signed in");
            }
            dispatchAuthEvent2("verify", user, "A user " + user.getUsername() + " has been verified");
            logger27.debug("verifyTotpToken success", data);
            res(data);
            return;
          }
        });
      });
    };
    AuthClass2.prototype.confirmSignIn = function(user, code, mfaType, clientMetadata) {
      var _this = this;
      if (clientMetadata === void 0) {
        clientMetadata = this._config.clientMetadata;
      }
      if (!code) {
        return this.rejectAuthError(AuthErrorTypes.EmptyCode);
      }
      var that = this;
      return new Promise(function(resolve, reject) {
        user.sendMFACode(code, {
          onSuccess: function(session) {
            return __awaiter49(_this, void 0, void 0, function() {
              var cred, e_3, currentUser, e_4;
              return __generator50(this, function(_a2) {
                switch (_a2.label) {
                  case 0:
                    logger27.debug(session);
                    _a2.label = 1;
                  case 1:
                    _a2.trys.push([1, 4, 5, 10]);
                    return [4, this.Credentials.clear()];
                  case 2:
                    _a2.sent();
                    return [4, this.Credentials.set(session, "session")];
                  case 3:
                    cred = _a2.sent();
                    logger27.debug("succeed to get cognito credentials", cred);
                    return [3, 10];
                  case 4:
                    e_3 = _a2.sent();
                    logger27.debug("cannot get cognito credentials", e_3);
                    return [3, 10];
                  case 5:
                    that.user = user;
                    _a2.label = 6;
                  case 6:
                    _a2.trys.push([6, 8, , 9]);
                    return [4, this.currentUserPoolUser()];
                  case 7:
                    currentUser = _a2.sent();
                    user.attributes = currentUser.attributes;
                    return [3, 9];
                  case 8:
                    e_4 = _a2.sent();
                    logger27.debug("cannot get updated Cognito User", e_4);
                    return [3, 9];
                  case 9:
                    dispatchAuthEvent2("signIn", user, "A user " + user.getUsername() + " has been signed in");
                    resolve(user);
                    return [
                      7
                      /*endfinally*/
                    ];
                  case 10:
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          },
          onFailure: function(err) {
            logger27.debug("confirm signIn failure", err);
            reject(err);
          }
        }, mfaType, clientMetadata);
      });
    };
    AuthClass2.prototype.completeNewPassword = function(user, password, requiredAttributes, clientMetadata) {
      var _this = this;
      if (requiredAttributes === void 0) {
        requiredAttributes = {};
      }
      if (clientMetadata === void 0) {
        clientMetadata = this._config.clientMetadata;
      }
      if (!password) {
        return this.rejectAuthError(AuthErrorTypes.EmptyPassword);
      }
      var that = this;
      return new Promise(function(resolve, reject) {
        user.completeNewPasswordChallenge(password, requiredAttributes, {
          onSuccess: function(session) {
            return __awaiter49(_this, void 0, void 0, function() {
              var cred, e_5;
              return __generator50(this, function(_a2) {
                switch (_a2.label) {
                  case 0:
                    logger27.debug(session);
                    _a2.label = 1;
                  case 1:
                    _a2.trys.push([1, 4, 5, 6]);
                    return [4, this.Credentials.clear()];
                  case 2:
                    _a2.sent();
                    return [4, this.Credentials.set(session, "session")];
                  case 3:
                    cred = _a2.sent();
                    logger27.debug("succeed to get cognito credentials", cred);
                    return [3, 6];
                  case 4:
                    e_5 = _a2.sent();
                    logger27.debug("cannot get cognito credentials", e_5);
                    return [3, 6];
                  case 5:
                    that.user = user;
                    dispatchAuthEvent2("signIn", user, "A user " + user.getUsername() + " has been signed in");
                    resolve(user);
                    return [
                      7
                      /*endfinally*/
                    ];
                  case 6:
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          },
          onFailure: function(err) {
            logger27.debug("completeNewPassword failure", err);
            dispatchAuthEvent2("completeNewPassword_failure", err, _this.user + " failed to complete the new password flow");
            reject(err);
          },
          mfaRequired: function(challengeName, challengeParam) {
            logger27.debug("signIn MFA required");
            user["challengeName"] = challengeName;
            user["challengeParam"] = challengeParam;
            resolve(user);
          },
          mfaSetup: function(challengeName, challengeParam) {
            logger27.debug("signIn mfa setup", challengeName);
            user["challengeName"] = challengeName;
            user["challengeParam"] = challengeParam;
            resolve(user);
          },
          totpRequired: function(challengeName, challengeParam) {
            logger27.debug("signIn mfa setup", challengeName);
            user["challengeName"] = challengeName;
            user["challengeParam"] = challengeParam;
            resolve(user);
          }
        }, clientMetadata);
      });
    };
    AuthClass2.prototype.sendCustomChallengeAnswer = function(user, challengeResponses, clientMetadata) {
      var _this = this;
      if (clientMetadata === void 0) {
        clientMetadata = this._config.clientMetadata;
      }
      if (!this.userPool) {
        return this.rejectNoUserPool();
      }
      if (!challengeResponses) {
        return this.rejectAuthError(AuthErrorTypes.EmptyChallengeResponse);
      }
      var that = this;
      return new Promise(function(resolve, reject) {
        user.sendCustomChallengeAnswer(challengeResponses, _this.authCallbacks(user, resolve, reject), clientMetadata);
      });
    };
    AuthClass2.prototype.deleteUserAttributes = function(user, attributeNames) {
      var that = this;
      return new Promise(function(resolve, reject) {
        that.userSession(user).then(function(session) {
          user.deleteAttributes(attributeNames, function(err, result) {
            if (err) {
              return reject(err);
            } else {
              return resolve(result);
            }
          });
        });
      });
    };
    AuthClass2.prototype.deleteUser = function() {
      return __awaiter49(this, void 0, void 0, function() {
        var e_6, isSignedInHostedUI;
        var _this = this;
        return __generator50(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 2, , 3]);
              return [4, this._storageSync];
            case 1:
              _a2.sent();
              return [3, 3];
            case 2:
              e_6 = _a2.sent();
              logger27.debug("Failed to sync cache info into memory", e_6);
              throw new Error(e_6);
            case 3:
              isSignedInHostedUI = this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
              return [2, new Promise(function(res, rej) {
                return __awaiter49(_this, void 0, void 0, function() {
                  var user_1;
                  var _this2 = this;
                  return __generator50(this, function(_a3) {
                    if (this.userPool) {
                      user_1 = this.userPool.getCurrentUser();
                      if (!user_1) {
                        logger27.debug("Failed to get user from user pool");
                        return [2, rej(new Error("No current user."))];
                      } else {
                        user_1.getSession(function(err, session) {
                          return __awaiter49(_this2, void 0, void 0, function() {
                            var cleanUpError_4;
                            var _this3 = this;
                            return __generator50(this, function(_a4) {
                              switch (_a4.label) {
                                case 0:
                                  if (!err)
                                    return [3, 5];
                                  logger27.debug("Failed to get the user session", err);
                                  if (!this.isSessionInvalid(err))
                                    return [3, 4];
                                  _a4.label = 1;
                                case 1:
                                  _a4.trys.push([1, 3, , 4]);
                                  return [4, this.cleanUpInvalidSession(user_1)];
                                case 2:
                                  _a4.sent();
                                  return [3, 4];
                                case 3:
                                  cleanUpError_4 = _a4.sent();
                                  rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_4.message));
                                  return [
                                    2
                                    /*return*/
                                  ];
                                case 4:
                                  return [2, rej(err)];
                                case 5:
                                  user_1.deleteUser(function(err2, result) {
                                    if (err2) {
                                      rej(err2);
                                    } else {
                                      dispatchAuthEvent2("userDeleted", result, "The authenticated user has been deleted.");
                                      user_1.signOut();
                                      _this3.user = null;
                                      try {
                                        _this3.cleanCachedItems();
                                      } catch (e) {
                                        logger27.debug("failed to clear cached items");
                                      }
                                      if (isSignedInHostedUI) {
                                        _this3.oAuthSignOutRedirect(res, rej);
                                      } else {
                                        dispatchAuthEvent2("signOut", _this3.user, "A user has been signed out");
                                        res(result);
                                      }
                                    }
                                  });
                                  _a4.label = 6;
                                case 6:
                                  return [
                                    2
                                    /*return*/
                                  ];
                              }
                            });
                          });
                        });
                      }
                    } else {
                      logger27.debug("no Congito User pool");
                      rej(new Error("Cognito User pool does not exist"));
                    }
                    return [
                      2
                      /*return*/
                    ];
                  });
                });
              })];
          }
        });
      });
    };
    AuthClass2.prototype.updateUserAttributes = function(user, attributes, clientMetadata) {
      var _this = this;
      if (clientMetadata === void 0) {
        clientMetadata = this._config.clientMetadata;
      }
      var attributeList = [];
      var that = this;
      return new Promise(function(resolve, reject) {
        that.userSession(user).then(function(session) {
          for (var key in attributes) {
            if (key !== "sub" && key.indexOf("_verified") < 0) {
              var attr = {
                Name: key,
                Value: attributes[key]
              };
              attributeList.push(attr);
            }
          }
          user.updateAttributes(attributeList, function(err, result, details) {
            if (err) {
              dispatchAuthEvent2("updateUserAttributes_failure", err, "Failed to update attributes");
              return reject(err);
            } else {
              var attrs = _this.createUpdateAttributesResultList(attributes, details === null || details === void 0 ? void 0 : details.CodeDeliveryDetailsList);
              dispatchAuthEvent2("updateUserAttributes", attrs, "Attributes successfully updated");
              return resolve(result);
            }
          }, clientMetadata);
        });
      });
    };
    AuthClass2.prototype.createUpdateAttributesResultList = function(attributes, codeDeliveryDetailsList) {
      var attrs = {};
      Object.keys(attributes).forEach(function(key) {
        attrs[key] = {
          isUpdated: true
        };
        var codeDeliveryDetails = codeDeliveryDetailsList === null || codeDeliveryDetailsList === void 0 ? void 0 : codeDeliveryDetailsList.find(function(value) {
          return value.AttributeName === key;
        });
        if (codeDeliveryDetails) {
          attrs[key].isUpdated = false;
          attrs[key].codeDeliveryDetails = codeDeliveryDetails;
        }
      });
      return attrs;
    };
    AuthClass2.prototype.userAttributes = function(user) {
      var _this = this;
      return new Promise(function(resolve, reject) {
        _this.userSession(user).then(function(session) {
          user.getUserAttributes(function(err, attributes) {
            if (err) {
              reject(err);
            } else {
              resolve(attributes);
            }
          });
        });
      });
    };
    AuthClass2.prototype.verifiedContact = function(user) {
      var that = this;
      return this.userAttributes(user).then(function(attributes) {
        var attrs = that.attributesToObject(attributes);
        var unverified = {};
        var verified = {};
        if (attrs["email"]) {
          if (attrs["email_verified"]) {
            verified["email"] = attrs["email"];
          } else {
            unverified["email"] = attrs["email"];
          }
        }
        if (attrs["phone_number"]) {
          if (attrs["phone_number_verified"]) {
            verified["phone_number"] = attrs["phone_number"];
          } else {
            unverified["phone_number"] = attrs["phone_number"];
          }
        }
        return {
          verified,
          unverified
        };
      });
    };
    AuthClass2.prototype.isErrorWithMessage = function(err) {
      return typeof err === "object" && Object.prototype.hasOwnProperty.call(err, "message");
    };
    AuthClass2.prototype.isTokenRevokedError = function(err) {
      return this.isErrorWithMessage(err) && err.message === "Access Token has been revoked";
    };
    AuthClass2.prototype.isRefreshTokenRevokedError = function(err) {
      return this.isErrorWithMessage(err) && err.message === "Refresh Token has been revoked";
    };
    AuthClass2.prototype.isUserDisabledError = function(err) {
      return this.isErrorWithMessage(err) && err.message === "User is disabled.";
    };
    AuthClass2.prototype.isUserDoesNotExistError = function(err) {
      return this.isErrorWithMessage(err) && err.message === "User does not exist.";
    };
    AuthClass2.prototype.isRefreshTokenExpiredError = function(err) {
      return this.isErrorWithMessage(err) && err.message === "Refresh Token has expired";
    };
    AuthClass2.prototype.isSignedInHostedUI = function() {
      return this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
    };
    AuthClass2.prototype.isSessionInvalid = function(err) {
      return this.isUserDisabledError(err) || this.isUserDoesNotExistError(err) || this.isTokenRevokedError(err) || this.isRefreshTokenRevokedError(err) || this.isRefreshTokenExpiredError(err);
    };
    AuthClass2.prototype.cleanUpInvalidSession = function(user) {
      return __awaiter49(this, void 0, void 0, function() {
        var e_7;
        var _this = this;
        return __generator50(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              user.signOut();
              this.user = null;
              _a2.label = 1;
            case 1:
              _a2.trys.push([1, 3, , 4]);
              return [4, this.cleanCachedItems()];
            case 2:
              _a2.sent();
              return [3, 4];
            case 3:
              e_7 = _a2.sent();
              logger27.debug("failed to clear cached items");
              return [3, 4];
            case 4:
              if (this.isSignedInHostedUI()) {
                return [2, new Promise(function(res, rej) {
                  _this.oAuthSignOutRedirect(res, rej);
                })];
              } else {
                dispatchAuthEvent2("signOut", this.user, "A user has been signed out");
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AuthClass2.prototype.currentUserPoolUser = function(params) {
      var _this = this;
      if (!this.userPool) {
        return this.rejectNoUserPool();
      }
      return new Promise(function(res, rej) {
        _this._storageSync.then(function() {
          return __awaiter49(_this, void 0, void 0, function() {
            var user, session, bypassCache, clientMetadata, _a2, scope, err_1;
            var _this2 = this;
            return __generator50(this, function(_b2) {
              switch (_b2.label) {
                case 0:
                  if (!this.isOAuthInProgress())
                    return [3, 2];
                  logger27.debug("OAuth signIn in progress, waiting for resolution...");
                  return [4, new Promise(function(res2) {
                    var timeoutId = setTimeout(function() {
                      logger27.debug("OAuth signIn in progress timeout");
                      Hub.remove("auth", hostedUISignCallback);
                      res2();
                    }, OAUTH_FLOW_MS_TIMEOUT);
                    Hub.listen("auth", hostedUISignCallback);
                    function hostedUISignCallback(_a3) {
                      var payload = _a3.payload;
                      var event = payload.event;
                      if (event === "cognitoHostedUI" || event === "cognitoHostedUI_failure") {
                        logger27.debug("OAuth signIn resolved: " + event);
                        clearTimeout(timeoutId);
                        Hub.remove("auth", hostedUISignCallback);
                        res2();
                      }
                    }
                  })];
                case 1:
                  _b2.sent();
                  _b2.label = 2;
                case 2:
                  user = this.userPool.getCurrentUser();
                  if (!user) {
                    logger27.debug("Failed to get user from user pool");
                    rej("No current user");
                    return [
                      2
                      /*return*/
                    ];
                  }
                  _b2.label = 3;
                case 3:
                  _b2.trys.push([3, 7, , 8]);
                  return [4, this._userSession(user)];
                case 4:
                  session = _b2.sent();
                  bypassCache = params ? params.bypassCache : false;
                  if (!bypassCache)
                    return [3, 6];
                  return [4, this.Credentials.clear()];
                case 5:
                  _b2.sent();
                  _b2.label = 6;
                case 6:
                  clientMetadata = this._config.clientMetadata;
                  _a2 = session.getAccessToken().decodePayload().scope, scope = _a2 === void 0 ? "" : _a2;
                  if (scope.split(" ").includes(USER_ADMIN_SCOPE)) {
                    user.getUserData(function(err, data) {
                      return __awaiter49(_this2, void 0, void 0, function() {
                        var cleanUpError_5, preferredMFA, attributeList, i2, attribute, userAttribute, attributes;
                        return __generator50(this, function(_a3) {
                          switch (_a3.label) {
                            case 0:
                              if (!err)
                                return [3, 7];
                              logger27.debug("getting user data failed", err);
                              if (!this.isSessionInvalid(err))
                                return [3, 5];
                              _a3.label = 1;
                            case 1:
                              _a3.trys.push([1, 3, , 4]);
                              return [4, this.cleanUpInvalidSession(user)];
                            case 2:
                              _a3.sent();
                              return [3, 4];
                            case 3:
                              cleanUpError_5 = _a3.sent();
                              rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_5.message));
                              return [
                                2
                                /*return*/
                              ];
                            case 4:
                              rej(err);
                              return [3, 6];
                            case 5:
                              res(user);
                              _a3.label = 6;
                            case 6:
                              return [
                                2
                                /*return*/
                              ];
                            case 7:
                              preferredMFA = data.PreferredMfaSetting || "NOMFA";
                              attributeList = [];
                              for (i2 = 0; i2 < data.UserAttributes.length; i2++) {
                                attribute = {
                                  Name: data.UserAttributes[i2].Name,
                                  Value: data.UserAttributes[i2].Value
                                };
                                userAttribute = new CognitoUserAttribute(attribute);
                                attributeList.push(userAttribute);
                              }
                              attributes = this.attributesToObject(attributeList);
                              Object.assign(user, { attributes, preferredMFA });
                              return [2, res(user)];
                          }
                        });
                      });
                    }, { bypassCache, clientMetadata });
                  } else {
                    logger27.debug("Unable to get the user data because the " + USER_ADMIN_SCOPE + " is not in the scopes of the access token");
                    return [2, res(user)];
                  }
                  return [3, 8];
                case 7:
                  err_1 = _b2.sent();
                  rej(err_1);
                  return [3, 8];
                case 8:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }).catch(function(e) {
          logger27.debug("Failed to sync cache info into memory", e);
          return rej(e);
        });
      });
    };
    AuthClass2.prototype.isOAuthInProgress = function() {
      return this.oAuthFlowInProgress;
    };
    AuthClass2.prototype.currentAuthenticatedUser = function(params) {
      return __awaiter49(this, void 0, void 0, function() {
        var federatedUser, e_8, federatedInfo, user, e_9;
        return __generator50(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              logger27.debug("getting current authenticated user");
              federatedUser = null;
              _a2.label = 1;
            case 1:
              _a2.trys.push([1, 3, , 4]);
              return [4, this._storageSync];
            case 2:
              _a2.sent();
              return [3, 4];
            case 3:
              e_8 = _a2.sent();
              logger27.debug("Failed to sync cache info into memory", e_8);
              throw e_8;
            case 4:
              try {
                federatedInfo = JSON.parse(this._storage.getItem("aws-amplify-federatedInfo"));
                if (federatedInfo) {
                  federatedUser = __assign31(__assign31({}, federatedInfo.user), { token: federatedInfo.token });
                }
              } catch (e) {
                logger27.debug("cannot load federated user from auth storage");
              }
              if (!federatedUser)
                return [3, 5];
              this.user = federatedUser;
              logger27.debug("get current authenticated federated user", this.user);
              return [2, this.user];
            case 5:
              logger27.debug("get current authenticated userpool user");
              user = null;
              _a2.label = 6;
            case 6:
              _a2.trys.push([6, 8, , 9]);
              return [4, this.currentUserPoolUser(params)];
            case 7:
              user = _a2.sent();
              return [3, 9];
            case 8:
              e_9 = _a2.sent();
              if (e_9 === "No userPool") {
                logger27.error("Cannot get the current user because the user pool is missing. Please make sure the Auth module is configured with a valid Cognito User Pool ID");
              }
              logger27.debug("The user is not authenticated by the error", e_9);
              return [2, Promise.reject("The user is not authenticated")];
            case 9:
              this.user = user;
              return [2, this.user];
          }
        });
      });
    };
    AuthClass2.prototype.currentSession = function() {
      var that = this;
      logger27.debug("Getting current session");
      if (!this.userPool) {
        return Promise.reject(new Error("No User Pool in the configuration."));
      }
      return new Promise(function(res, rej) {
        that.currentUserPoolUser().then(function(user) {
          that.userSession(user).then(function(session) {
            res(session);
            return;
          }).catch(function(e) {
            logger27.debug("Failed to get the current session", e);
            rej(e);
            return;
          });
        }).catch(function(e) {
          logger27.debug("Failed to get the current user", e);
          rej(e);
          return;
        });
      });
    };
    AuthClass2.prototype._userSession = function(user) {
      return __awaiter49(this, void 0, void 0, function() {
        var clientMetadata, userSession;
        var _this = this;
        return __generator50(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (!user) {
                logger27.debug("the user is null");
                return [2, this.rejectAuthError(AuthErrorTypes.NoUserSession)];
              }
              clientMetadata = this._config.clientMetadata;
              if (this.inflightSessionPromiseCounter === 0) {
                this.inflightSessionPromise = new Promise(function(res, rej) {
                  user.getSession(function(err, session) {
                    return __awaiter49(_this, void 0, void 0, function() {
                      var cleanUpError_6;
                      return __generator50(this, function(_a3) {
                        switch (_a3.label) {
                          case 0:
                            if (!err)
                              return [3, 5];
                            logger27.debug("Failed to get the session from user", user);
                            if (!this.isSessionInvalid(err))
                              return [3, 4];
                            _a3.label = 1;
                          case 1:
                            _a3.trys.push([1, 3, , 4]);
                            return [4, this.cleanUpInvalidSession(user)];
                          case 2:
                            _a3.sent();
                            return [3, 4];
                          case 3:
                            cleanUpError_6 = _a3.sent();
                            rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_6.message));
                            return [
                              2
                              /*return*/
                            ];
                          case 4:
                            rej(err);
                            return [
                              2
                              /*return*/
                            ];
                          case 5:
                            logger27.debug("Succeed to get the user session", session);
                            res(session);
                            return [
                              2
                              /*return*/
                            ];
                        }
                      });
                    });
                  }, { clientMetadata });
                });
              }
              this.inflightSessionPromiseCounter++;
              _a2.label = 1;
            case 1:
              _a2.trys.push([1, , 3, 4]);
              return [4, this.inflightSessionPromise];
            case 2:
              userSession = _a2.sent();
              user.signInUserSession = userSession;
              return [2, userSession];
            case 3:
              this.inflightSessionPromiseCounter--;
              return [
                7
                /*endfinally*/
              ];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AuthClass2.prototype.userSession = function(user) {
      return this._userSession(user);
    };
    AuthClass2.prototype.currentUserCredentials = function() {
      return __awaiter49(this, void 0, void 0, function() {
        var e_10, federatedInfo;
        var _this = this;
        return __generator50(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              logger27.debug("Getting current user credentials");
              _a2.label = 1;
            case 1:
              _a2.trys.push([1, 3, , 4]);
              return [4, this._storageSync];
            case 2:
              _a2.sent();
              return [3, 4];
            case 3:
              e_10 = _a2.sent();
              logger27.debug("Failed to sync cache info into memory", e_10);
              throw e_10;
            case 4:
              federatedInfo = null;
              try {
                federatedInfo = JSON.parse(this._storage.getItem("aws-amplify-federatedInfo"));
              } catch (e) {
                logger27.debug("failed to get or parse item aws-amplify-federatedInfo", e);
              }
              if (federatedInfo) {
                return [2, this.Credentials.refreshFederatedToken(federatedInfo)];
              } else {
                return [2, this.currentSession().then(function(session) {
                  logger27.debug("getting session success", session);
                  return _this.Credentials.set(session, "session");
                }).catch(function() {
                  logger27.debug("getting guest credentials");
                  return _this.Credentials.set(null, "guest");
                })];
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AuthClass2.prototype.currentCredentials = function() {
      logger27.debug("getting current credentials");
      return this.Credentials.get();
    };
    AuthClass2.prototype.verifyUserAttribute = function(user, attr, clientMetadata) {
      if (clientMetadata === void 0) {
        clientMetadata = this._config.clientMetadata;
      }
      return new Promise(function(resolve, reject) {
        user.getAttributeVerificationCode(attr, {
          onSuccess: function(success) {
            return resolve(success);
          },
          onFailure: function(err) {
            return reject(err);
          }
        }, clientMetadata);
      });
    };
    AuthClass2.prototype.verifyUserAttributeSubmit = function(user, attr, code) {
      if (!code) {
        return this.rejectAuthError(AuthErrorTypes.EmptyCode);
      }
      return new Promise(function(resolve, reject) {
        user.verifyAttribute(attr, code, {
          onSuccess: function(data) {
            resolve(data);
            return;
          },
          onFailure: function(err) {
            reject(err);
            return;
          }
        });
      });
    };
    AuthClass2.prototype.verifyCurrentUserAttribute = function(attr) {
      var that = this;
      return that.currentUserPoolUser().then(function(user) {
        return that.verifyUserAttribute(user, attr);
      });
    };
    AuthClass2.prototype.verifyCurrentUserAttributeSubmit = function(attr, code) {
      var that = this;
      return that.currentUserPoolUser().then(function(user) {
        return that.verifyUserAttributeSubmit(user, attr, code);
      });
    };
    AuthClass2.prototype.cognitoIdentitySignOut = function(opts, user) {
      return __awaiter49(this, void 0, void 0, function() {
        var e_11, isSignedInHostedUI;
        var _this = this;
        return __generator50(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 2, , 3]);
              return [4, this._storageSync];
            case 1:
              _a2.sent();
              return [3, 3];
            case 2:
              e_11 = _a2.sent();
              logger27.debug("Failed to sync cache info into memory", e_11);
              throw e_11;
            case 3:
              isSignedInHostedUI = this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
              return [2, new Promise(function(res, rej) {
                if (opts && opts.global) {
                  logger27.debug("user global sign out", user);
                  var clientMetadata = _this._config.clientMetadata;
                  user.getSession(function(err, result) {
                    return __awaiter49(_this, void 0, void 0, function() {
                      var cleanUpError_7;
                      var _this2 = this;
                      return __generator50(this, function(_a3) {
                        switch (_a3.label) {
                          case 0:
                            if (!err)
                              return [3, 5];
                            logger27.debug("failed to get the user session", err);
                            if (!this.isSessionInvalid(err))
                              return [3, 4];
                            _a3.label = 1;
                          case 1:
                            _a3.trys.push([1, 3, , 4]);
                            return [4, this.cleanUpInvalidSession(user)];
                          case 2:
                            _a3.sent();
                            return [3, 4];
                          case 3:
                            cleanUpError_7 = _a3.sent();
                            rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_7.message));
                            return [
                              2
                              /*return*/
                            ];
                          case 4:
                            return [2, rej(err)];
                          case 5:
                            user.globalSignOut({
                              onSuccess: function(data) {
                                logger27.debug("global sign out success");
                                if (isSignedInHostedUI) {
                                  _this2.oAuthSignOutRedirect(res, rej);
                                } else {
                                  return res();
                                }
                              },
                              onFailure: function(err2) {
                                logger27.debug("global sign out failed", err2);
                                return rej(err2);
                              }
                            });
                            return [
                              2
                              /*return*/
                            ];
                        }
                      });
                    });
                  }, { clientMetadata });
                } else {
                  logger27.debug("user sign out", user);
                  user.signOut(function() {
                    if (isSignedInHostedUI) {
                      _this.oAuthSignOutRedirect(res, rej);
                    } else {
                      return res();
                    }
                  });
                }
              })];
          }
        });
      });
    };
    AuthClass2.prototype.oAuthSignOutRedirect = function(resolve, reject) {
      var isBrowser3 = browserOrNode().isBrowser;
      if (isBrowser3) {
        this.oAuthSignOutRedirectOrReject(reject);
      } else {
        this.oAuthSignOutAndResolve(resolve);
      }
    };
    AuthClass2.prototype.oAuthSignOutAndResolve = function(resolve) {
      this._oAuthHandler.signOut();
      resolve();
    };
    AuthClass2.prototype.oAuthSignOutRedirectOrReject = function(reject) {
      this._oAuthHandler.signOut();
      setTimeout(function() {
        return reject(Error("Signout timeout fail"));
      }, 3e3);
    };
    AuthClass2.prototype.signOut = function(opts) {
      return __awaiter49(this, void 0, void 0, function() {
        var e_12, user;
        return __generator50(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 2, , 3]);
              return [4, this.cleanCachedItems()];
            case 1:
              _a2.sent();
              return [3, 3];
            case 2:
              e_12 = _a2.sent();
              logger27.debug("failed to clear cached items");
              return [3, 3];
            case 3:
              if (!this.userPool)
                return [3, 7];
              user = this.userPool.getCurrentUser();
              if (!user)
                return [3, 5];
              return [4, this.cognitoIdentitySignOut(opts, user)];
            case 4:
              _a2.sent();
              return [3, 6];
            case 5:
              logger27.debug("no current Cognito user");
              _a2.label = 6;
            case 6:
              return [3, 8];
            case 7:
              logger27.debug("no Cognito User pool");
              _a2.label = 8;
            case 8:
              dispatchAuthEvent2("signOut", this.user, "A user has been signed out");
              this.user = null;
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AuthClass2.prototype.cleanCachedItems = function() {
      return __awaiter49(this, void 0, void 0, function() {
        return __generator50(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this.Credentials.clear()];
            case 1:
              _a2.sent();
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AuthClass2.prototype.changePassword = function(user, oldPassword, newPassword, clientMetadata) {
      var _this = this;
      if (clientMetadata === void 0) {
        clientMetadata = this._config.clientMetadata;
      }
      return new Promise(function(resolve, reject) {
        _this.userSession(user).then(function(session) {
          user.changePassword(oldPassword, newPassword, function(err, data) {
            if (err) {
              logger27.debug("change password failure", err);
              return reject(err);
            } else {
              return resolve(data);
            }
          }, clientMetadata);
        });
      });
    };
    AuthClass2.prototype.forgotPassword = function(username, clientMetadata) {
      if (clientMetadata === void 0) {
        clientMetadata = this._config.clientMetadata;
      }
      if (!this.userPool) {
        return this.rejectNoUserPool();
      }
      if (!username) {
        return this.rejectAuthError(AuthErrorTypes.EmptyUsername);
      }
      var user = this.createCognitoUser(username);
      return new Promise(function(resolve, reject) {
        user.forgotPassword({
          onSuccess: function() {
            resolve();
            return;
          },
          onFailure: function(err) {
            logger27.debug("forgot password failure", err);
            dispatchAuthEvent2("forgotPassword_failure", err, username + " forgotPassword failed");
            reject(err);
            return;
          },
          inputVerificationCode: function(data) {
            dispatchAuthEvent2("forgotPassword", user, username + " has initiated forgot password flow");
            resolve(data);
            return;
          }
        }, clientMetadata);
      });
    };
    AuthClass2.prototype.forgotPasswordSubmit = function(username, code, password, clientMetadata) {
      if (clientMetadata === void 0) {
        clientMetadata = this._config.clientMetadata;
      }
      if (!this.userPool) {
        return this.rejectNoUserPool();
      }
      if (!username) {
        return this.rejectAuthError(AuthErrorTypes.EmptyUsername);
      }
      if (!code) {
        return this.rejectAuthError(AuthErrorTypes.EmptyCode);
      }
      if (!password) {
        return this.rejectAuthError(AuthErrorTypes.EmptyPassword);
      }
      var user = this.createCognitoUser(username);
      return new Promise(function(resolve, reject) {
        user.confirmPassword(code, password, {
          onSuccess: function(success) {
            dispatchAuthEvent2("forgotPasswordSubmit", user, username + " forgotPasswordSubmit successful");
            resolve(success);
            return;
          },
          onFailure: function(err) {
            dispatchAuthEvent2("forgotPasswordSubmit_failure", err, username + " forgotPasswordSubmit failed");
            reject(err);
            return;
          }
        }, clientMetadata);
      });
    };
    AuthClass2.prototype.currentUserInfo = function() {
      return __awaiter49(this, void 0, void 0, function() {
        var source, user, attributes, userAttrs, credentials, e_13, info, err_2, user;
        return __generator50(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              source = this.Credentials.getCredSource();
              if (!(!source || source === "aws" || source === "userPool"))
                return [3, 9];
              return [4, this.currentUserPoolUser().catch(function(err) {
                return logger27.error(err);
              })];
            case 1:
              user = _a2.sent();
              if (!user) {
                return [2, null];
              }
              _a2.label = 2;
            case 2:
              _a2.trys.push([2, 8, , 9]);
              return [4, this.userAttributes(user)];
            case 3:
              attributes = _a2.sent();
              userAttrs = this.attributesToObject(attributes);
              credentials = null;
              _a2.label = 4;
            case 4:
              _a2.trys.push([4, 6, , 7]);
              return [4, this.currentCredentials()];
            case 5:
              credentials = _a2.sent();
              return [3, 7];
            case 6:
              e_13 = _a2.sent();
              logger27.debug("Failed to retrieve credentials while getting current user info", e_13);
              return [3, 7];
            case 7:
              info = {
                id: credentials ? credentials.identityId : void 0,
                username: user.getUsername(),
                attributes: userAttrs
              };
              return [2, info];
            case 8:
              err_2 = _a2.sent();
              logger27.error("currentUserInfo error", err_2);
              return [2, {}];
            case 9:
              if (source === "federated") {
                user = this.user;
                return [2, user ? user : {}];
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AuthClass2.prototype.federatedSignIn = function(providerOrOptions, response, user) {
      return __awaiter49(this, void 0, void 0, function() {
        var options, provider, customState, client_id, redirect_uri, provider, loggedInUser, token, identity_id, expires_at, credentials, currentUser;
        return __generator50(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (!this._config.identityPoolId && !this._config.userPoolId) {
                throw new Error("Federation requires either a User Pool or Identity Pool in config");
              }
              if (typeof providerOrOptions === "undefined") {
                if (this._config.identityPoolId && !this._config.userPoolId) {
                  throw new Error("Federation with Identity Pools requires tokens passed as arguments");
                }
              }
              if (!(isFederatedSignInOptions(providerOrOptions) || isFederatedSignInOptionsCustom(providerOrOptions) || hasCustomState(providerOrOptions) || typeof providerOrOptions === "undefined"))
                return [3, 1];
              options = providerOrOptions || {
                provider: CognitoHostedUIIdentityProvider.Cognito
              };
              provider = isFederatedSignInOptions(options) ? options.provider : options.customProvider;
              customState = isFederatedSignInOptions(options) ? options.customState : options.customState;
              if (this._config.userPoolId) {
                client_id = isCognitoHostedOpts(this._config.oauth) ? this._config.userPoolWebClientId : this._config.oauth.clientID;
                redirect_uri = isCognitoHostedOpts(this._config.oauth) ? this._config.oauth.redirectSignIn : this._config.oauth.redirectUri;
                this._oAuthHandler.oauthSignIn(this._config.oauth.responseType, this._config.oauth.domain, redirect_uri, client_id, provider, customState);
              }
              return [3, 4];
            case 1:
              provider = providerOrOptions;
              try {
                loggedInUser = JSON.stringify(JSON.parse(this._storage.getItem("aws-amplify-federatedInfo")).user);
                if (loggedInUser) {
                  logger27.warn("There is already a signed in user: " + loggedInUser + " in your app.\n																	You should not call Auth.federatedSignIn method again as it may cause unexpected behavior.");
                }
              } catch (e) {
              }
              token = response.token, identity_id = response.identity_id, expires_at = response.expires_at;
              return [4, this.Credentials.set({ provider, token, identity_id, user, expires_at }, "federation")];
            case 2:
              credentials = _a2.sent();
              return [4, this.currentAuthenticatedUser()];
            case 3:
              currentUser = _a2.sent();
              dispatchAuthEvent2("signIn", currentUser, "A user " + currentUser.username + " has been signed in");
              logger27.debug("federated sign in credentials", credentials);
              return [2, credentials];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AuthClass2.prototype._handleAuthResponse = function(URL2) {
      return __awaiter49(this, void 0, void 0, function() {
        var currentUrl, hasCodeOrError, hasTokenOrError, _a2, accessToken, idToken, refreshToken, state, session, credentials, isCustomStateIncluded, currentUser, customState, err_3;
        return __generator50(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              if (this.oAuthFlowInProgress) {
                logger27.debug("Skipping URL " + URL2 + " current flow in progress");
                return [
                  2
                  /*return*/
                ];
              }
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, , 8, 9]);
              this.oAuthFlowInProgress = true;
              if (!this._config.userPoolId) {
                throw new Error("OAuth responses require a User Pool defined in config");
              }
              dispatchAuthEvent2("parsingCallbackUrl", { url: URL2 }, "The callback url is being parsed");
              currentUrl = URL2 || (browserOrNode().isBrowser ? window.location.href : "");
              hasCodeOrError = !!((0, import_url2.parse)(currentUrl).query || "").split("&").map(function(entry) {
                return entry.split("=");
              }).find(function(_a3) {
                var _b3 = __read28(_a3, 1), k2 = _b3[0];
                return k2 === "code" || k2 === "error";
              });
              hasTokenOrError = !!((0, import_url2.parse)(currentUrl).hash || "#").substr(1).split("&").map(function(entry) {
                return entry.split("=");
              }).find(function(_a3) {
                var _b3 = __read28(_a3, 1), k2 = _b3[0];
                return k2 === "access_token" || k2 === "error";
              });
              if (!(hasCodeOrError || hasTokenOrError))
                return [3, 7];
              this._storage.setItem("amplify-redirected-from-hosted-ui", "true");
              _b2.label = 2;
            case 2:
              _b2.trys.push([2, 6, , 7]);
              return [4, this._oAuthHandler.handleAuthResponse(currentUrl)];
            case 3:
              _a2 = _b2.sent(), accessToken = _a2.accessToken, idToken = _a2.idToken, refreshToken = _a2.refreshToken, state = _a2.state;
              session = new CognitoUserSession({
                IdToken: new CognitoIdToken({ IdToken: idToken }),
                RefreshToken: new CognitoRefreshToken({
                  RefreshToken: refreshToken
                }),
                AccessToken: new CognitoAccessToken({
                  AccessToken: accessToken
                })
              });
              credentials = void 0;
              if (!this._config.identityPoolId)
                return [3, 5];
              return [4, this.Credentials.set(session, "session")];
            case 4:
              credentials = _b2.sent();
              logger27.debug("AWS credentials", credentials);
              _b2.label = 5;
            case 5:
              isCustomStateIncluded = /-/.test(state);
              currentUser = this.createCognitoUser(session.getIdToken().decodePayload()["cognito:username"]);
              currentUser.setSignInUserSession(session);
              if (window && typeof window.history !== "undefined") {
                window.history.replaceState({}, null, this._config.oauth.redirectSignIn);
              }
              dispatchAuthEvent2("signIn", currentUser, "A user " + currentUser.getUsername() + " has been signed in");
              dispatchAuthEvent2("cognitoHostedUI", currentUser, "A user " + currentUser.getUsername() + " has been signed in via Cognito Hosted UI");
              if (isCustomStateIncluded) {
                customState = state.split("-").splice(1).join("-");
                dispatchAuthEvent2("customOAuthState", urlSafeDecode(customState), "State for user " + currentUser.getUsername());
              }
              return [2, credentials];
            case 6:
              err_3 = _b2.sent();
              logger27.debug("Error in cognito hosted auth response", err_3);
              if (window && typeof window.history !== "undefined") {
                window.history.replaceState({}, null, this._config.oauth.redirectSignIn);
              }
              dispatchAuthEvent2("signIn_failure", err_3, "The OAuth response flow failed");
              dispatchAuthEvent2("cognitoHostedUI_failure", err_3, "A failure occurred when returning to the Cognito Hosted UI");
              dispatchAuthEvent2("customState_failure", err_3, "A failure occurred when returning state");
              return [3, 7];
            case 7:
              return [3, 9];
            case 8:
              this.oAuthFlowInProgress = false;
              return [
                7
                /*endfinally*/
              ];
            case 9:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AuthClass2.prototype.essentialCredentials = function(credentials) {
      return {
        accessKeyId: credentials.accessKeyId,
        sessionToken: credentials.sessionToken,
        secretAccessKey: credentials.secretAccessKey,
        identityId: credentials.identityId,
        authenticated: credentials.authenticated
      };
    };
    AuthClass2.prototype.attributesToObject = function(attributes) {
      var _this = this;
      var obj = {};
      if (attributes) {
        attributes.map(function(attribute) {
          if (attribute.Name === "email_verified" || attribute.Name === "phone_number_verified") {
            obj[attribute.Name] = _this.isTruthyString(attribute.Value) || attribute.Value === true;
          } else {
            obj[attribute.Name] = attribute.Value;
          }
        });
      }
      return obj;
    };
    AuthClass2.prototype.isTruthyString = function(value) {
      return typeof value.toLowerCase === "function" && value.toLowerCase() === "true";
    };
    AuthClass2.prototype.createCognitoUser = function(username) {
      var userData = {
        Username: username,
        Pool: this.userPool
      };
      userData.Storage = this._storage;
      var authenticationFlowType = this._config.authenticationFlowType;
      var user = new CognitoUser(userData);
      if (authenticationFlowType) {
        user.setAuthenticationFlowType(authenticationFlowType);
      }
      return user;
    };
    AuthClass2.prototype._isValidAuthStorage = function(obj) {
      return !!obj && typeof obj.getItem === "function" && typeof obj.setItem === "function" && typeof obj.removeItem === "function" && typeof obj.clear === "function";
    };
    AuthClass2.prototype.noUserPoolErrorHandler = function(config) {
      if (config) {
        if (!config.userPoolId || !config.identityPoolId) {
          return AuthErrorTypes.MissingAuthConfig;
        }
      }
      return AuthErrorTypes.NoConfig;
    };
    AuthClass2.prototype.rejectAuthError = function(type) {
      return Promise.reject(new AuthError(type));
    };
    AuthClass2.prototype.rejectNoUserPool = function() {
      var type = this.noUserPoolErrorHandler(this._config);
      return Promise.reject(new NoUserPoolError(type));
    };
    AuthClass2.prototype.rememberDevice = function() {
      return __awaiter49(this, void 0, void 0, function() {
        var currUser, error_2;
        return __generator50(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 2, , 3]);
              return [4, this.currentUserPoolUser()];
            case 1:
              currUser = _a2.sent();
              return [3, 3];
            case 2:
              error_2 = _a2.sent();
              logger27.debug("The user is not authenticated by the error", error_2);
              return [2, Promise.reject("The user is not authenticated")];
            case 3:
              currUser.getCachedDeviceKeyAndPassword();
              return [2, new Promise(function(res, rej) {
                currUser.setDeviceStatusRemembered({
                  onSuccess: function(data) {
                    res(data);
                  },
                  onFailure: function(err) {
                    if (err.code === "InvalidParameterException") {
                      rej(new AuthError(AuthErrorTypes.DeviceConfig));
                    } else if (err.code === "NetworkError") {
                      rej(new AuthError(AuthErrorTypes.NetworkError));
                    } else {
                      rej(err);
                    }
                  }
                });
              })];
          }
        });
      });
    };
    AuthClass2.prototype.forgetDevice = function() {
      return __awaiter49(this, void 0, void 0, function() {
        var currUser, error_3;
        return __generator50(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 2, , 3]);
              return [4, this.currentUserPoolUser()];
            case 1:
              currUser = _a2.sent();
              return [3, 3];
            case 2:
              error_3 = _a2.sent();
              logger27.debug("The user is not authenticated by the error", error_3);
              return [2, Promise.reject("The user is not authenticated")];
            case 3:
              currUser.getCachedDeviceKeyAndPassword();
              return [2, new Promise(function(res, rej) {
                currUser.forgetDevice({
                  onSuccess: function(data) {
                    res(data);
                  },
                  onFailure: function(err) {
                    if (err.code === "InvalidParameterException") {
                      rej(new AuthError(AuthErrorTypes.DeviceConfig));
                    } else if (err.code === "NetworkError") {
                      rej(new AuthError(AuthErrorTypes.NetworkError));
                    } else {
                      rej(err);
                    }
                  }
                });
              })];
          }
        });
      });
    };
    AuthClass2.prototype.fetchDevices = function() {
      return __awaiter49(this, void 0, void 0, function() {
        var currUser, error_4;
        return __generator50(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 2, , 3]);
              return [4, this.currentUserPoolUser()];
            case 1:
              currUser = _a2.sent();
              return [3, 3];
            case 2:
              error_4 = _a2.sent();
              logger27.debug("The user is not authenticated by the error", error_4);
              throw new Error("The user is not authenticated");
            case 3:
              currUser.getCachedDeviceKeyAndPassword();
              return [2, new Promise(function(res, rej) {
                var cb = {
                  onSuccess: function(data) {
                    var deviceList = data.Devices.map(function(device) {
                      var deviceName = device.DeviceAttributes.find(function(_a3) {
                        var Name2 = _a3.Name;
                        return Name2 === "device_name";
                      }) || {};
                      var deviceInfo = {
                        id: device.DeviceKey,
                        name: deviceName.Value
                      };
                      return deviceInfo;
                    });
                    res(deviceList);
                  },
                  onFailure: function(err) {
                    if (err.code === "InvalidParameterException") {
                      rej(new AuthError(AuthErrorTypes.DeviceConfig));
                    } else if (err.code === "NetworkError") {
                      rej(new AuthError(AuthErrorTypes.NetworkError));
                    } else {
                      rej(err);
                    }
                  }
                };
                currUser.listDevices(MAX_DEVICES, null, cb);
              })];
          }
        });
      });
    };
    return AuthClass2;
  }()
);
var Auth = new AuthClass(null);
Amplify.register(Auth);

// node_modules/@aws-amplify/storage/node_modules/tslib/tslib.es6.js
var __assign32 = function() {
  __assign32 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign32.apply(this, arguments);
};
function __awaiter50(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator51(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __values13(o2) {
  var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
  if (m2)
    return m2.call(o2);
  if (o2 && typeof o2.length === "number")
    return {
      next: function() {
        if (o2 && i2 >= o2.length)
          o2 = void 0;
        return { value: o2 && o2[i2++], done: !o2 };
      }
    };
  throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read29(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}
function __spread12() {
  for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
    ar = ar.concat(__read29(arguments[i2]));
  return ar;
}

// node_modules/@aws-sdk/client-s3/dist/es/package.json
var package_default5 = {
  name: "@aws-sdk/client-s3",
  description: "AWS SDK for JavaScript S3 Client for Node.js, Browser and React Native",
  version: "3.6.3",
  scripts: {
    clean: "yarn remove-definitions && yarn remove-dist && yarn remove-documentation",
    "build-documentation": "yarn remove-documentation && typedoc ./",
    prepublishOnly: "yarn build",
    pretest: "yarn build:cjs",
    "remove-definitions": "rimraf ./types",
    "remove-dist": "rimraf ./dist",
    "remove-documentation": "rimraf ./docs",
    "test:unit": "mocha **/cjs/**/*.spec.js",
    "test:e2e": "mocha **/cjs/**/*.ispec.js && karma start karma.conf.js",
    test: "yarn test:unit",
    "build:cjs": "tsc -p tsconfig.json",
    "build:es": "tsc -p tsconfig.es.json",
    build: "yarn build:cjs && yarn build:es",
    postbuild: "downlevel-dts types types/ts3.4"
  },
  main: "./dist/cjs/index.js",
  types: "./types/index.d.ts",
  module: "./dist/es/index.js",
  browser: {
    "./runtimeConfig": "./runtimeConfig.browser"
  },
  "react-native": {
    "./runtimeConfig": "./runtimeConfig.native"
  },
  sideEffects: false,
  dependencies: {
    "@aws-crypto/sha256-browser": "^1.0.0",
    "@aws-crypto/sha256-js": "^1.0.0",
    "@aws-sdk/config-resolver": "3.6.1",
    "@aws-sdk/credential-provider-node": "3.6.1",
    "@aws-sdk/eventstream-serde-browser": "3.6.1",
    "@aws-sdk/eventstream-serde-config-resolver": "3.6.1",
    "@aws-sdk/eventstream-serde-node": "3.6.1",
    "@aws-sdk/fetch-http-handler": "3.6.1",
    "@aws-sdk/hash-blob-browser": "3.6.1",
    "@aws-sdk/hash-node": "3.6.1",
    "@aws-sdk/hash-stream-node": "3.6.1",
    "@aws-sdk/invalid-dependency": "3.6.1",
    "@aws-sdk/md5-js": "3.6.1",
    "@aws-sdk/middleware-apply-body-checksum": "3.6.1",
    "@aws-sdk/middleware-bucket-endpoint": "3.6.1",
    "@aws-sdk/middleware-content-length": "3.6.1",
    "@aws-sdk/middleware-expect-continue": "3.6.1",
    "@aws-sdk/middleware-host-header": "3.6.1",
    "@aws-sdk/middleware-location-constraint": "3.6.1",
    "@aws-sdk/middleware-logger": "3.6.1",
    "@aws-sdk/middleware-retry": "3.6.1",
    "@aws-sdk/middleware-sdk-s3": "3.6.1",
    "@aws-sdk/middleware-serde": "3.6.1",
    "@aws-sdk/middleware-signing": "3.6.1",
    "@aws-sdk/middleware-ssec": "3.6.1",
    "@aws-sdk/middleware-stack": "3.6.1",
    "@aws-sdk/middleware-user-agent": "3.6.1",
    "@aws-sdk/node-config-provider": "3.6.1",
    "@aws-sdk/node-http-handler": "3.6.1",
    "@aws-sdk/protocol-http": "3.6.1",
    "@aws-sdk/smithy-client": "3.6.1",
    "@aws-sdk/types": "3.6.1",
    "@aws-sdk/url-parser": "3.6.1",
    "@aws-sdk/url-parser-native": "3.6.1",
    "@aws-sdk/util-base64-browser": "3.6.1",
    "@aws-sdk/util-base64-node": "3.6.1",
    "@aws-sdk/util-body-length-browser": "3.6.1",
    "@aws-sdk/util-body-length-node": "3.6.1",
    "@aws-sdk/util-user-agent-browser": "3.6.1",
    "@aws-sdk/util-user-agent-node": "3.6.1",
    "@aws-sdk/util-utf8-browser": "3.6.1",
    "@aws-sdk/util-utf8-node": "3.6.1",
    "@aws-sdk/util-waiter": "3.6.1",
    "@aws-sdk/xml-builder": "3.6.1",
    "fast-xml-parser": "4.2.4",
    tslib: "^2.0.0"
  },
  devDependencies: {
    "@aws-sdk/client-documentation-generator": "3.6.1",
    "@types/chai": "^4.2.11",
    "@types/mocha": "^8.0.4",
    "@types/node": "^12.7.5",
    "downlevel-dts": "0.7.0",
    jest: "^26.1.0",
    rimraf: "^3.0.0",
    typedoc: "^0.19.2",
    typescript: "~4.1.2"
  },
  engines: {
    node: ">=10.0.0"
  },
  typesVersions: {
    "<4.0": {
      "types/*": [
        "types/ts3.4/*"
      ]
    }
  },
  author: {
    name: "AWS SDK for JavaScript Team",
    url: "https://aws.amazon.com/javascript/"
  },
  license: "Apache-2.0",
  homepage: "https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-s3",
  repository: {
    type: "git",
    url: "https://github.com/aws/aws-sdk-js-v3.git",
    directory: "clients/client-s3"
  }
};

// node_modules/@aws-sdk/client-s3/dist/es/runtimeConfig.browser.js
var import_sha256_browser5 = __toESM(require_build33());

// node_modules/@aws-sdk/hash-blob-browser/node_modules/tslib/tslib.es6.js
function __awaiter51(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator52(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/chunked-blob-reader/dist/es/index.js
function blobReader(blob, onChunk, chunkSize) {
  if (chunkSize === void 0) {
    chunkSize = 1024 * 1024;
  }
  return new Promise(function(resolve, reject) {
    var fileReader = new FileReader();
    fileReader.addEventListener("error", reject);
    fileReader.addEventListener("abort", reject);
    var size = blob.size;
    var totalBytesRead = 0;
    function read() {
      if (totalBytesRead >= size) {
        resolve();
        return;
      }
      fileReader.readAsArrayBuffer(blob.slice(totalBytesRead, Math.min(size, totalBytesRead + chunkSize)));
    }
    fileReader.addEventListener("load", function(event) {
      var result = event.target.result;
      onChunk(new Uint8Array(result));
      totalBytesRead += result.byteLength;
      read();
    });
    read();
  });
}

// node_modules/@aws-sdk/hash-blob-browser/dist/es/index.js
var blobHasher = function blobHasher2(hashCtor, blob) {
  return __awaiter51(this, void 0, void 0, function() {
    var hash;
    return __generator52(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          hash = new hashCtor();
          return [4, blobReader(blob, function(chunk) {
            hash.update(chunk);
          })];
        case 1:
          _a2.sent();
          return [2, hash.digest()];
      }
    });
  });
};

// node_modules/@aws-sdk/md5-js/node_modules/tslib/tslib.es6.js
function __awaiter52(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator53(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/md5-js/node_modules/@aws-sdk/util-utf8-browser/dist/es/pureJs.js
var fromUtf822 = function(input) {
  var bytes = [];
  for (var i2 = 0, len = input.length; i2 < len; i2++) {
    var value = input.charCodeAt(i2);
    if (value < 128) {
      bytes.push(value);
    } else if (value < 2048) {
      bytes.push(value >> 6 | 192, value & 63 | 128);
    } else if (i2 + 1 < input.length && (value & 64512) === 55296 && (input.charCodeAt(i2 + 1) & 64512) === 56320) {
      var surrogatePair = 65536 + ((value & 1023) << 10) + (input.charCodeAt(++i2) & 1023);
      bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
    } else {
      bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
  }
  return Uint8Array.from(bytes);
};

// node_modules/@aws-sdk/md5-js/node_modules/@aws-sdk/util-utf8-browser/dist/es/whatwgEncodingApi.js
function fromUtf823(input) {
  return new TextEncoder().encode(input);
}

// node_modules/@aws-sdk/md5-js/node_modules/@aws-sdk/util-utf8-browser/dist/es/index.js
var fromUtf824 = function(input) {
  return typeof TextEncoder === "function" ? fromUtf823(input) : fromUtf822(input);
};

// node_modules/@aws-sdk/md5-js/dist/es/constants.js
var BLOCK_SIZE = 64;
var DIGEST_LENGTH = 16;
var INIT = [1732584193, 4023233417, 2562383102, 271733878];

// node_modules/@aws-sdk/md5-js/dist/es/index.js
var Md5 = (
  /** @class */
  function() {
    function Md52() {
      this.state = Uint32Array.from(INIT);
      this.buffer = new DataView(new ArrayBuffer(BLOCK_SIZE));
      this.bufferLength = 0;
      this.bytesHashed = 0;
      this.finished = false;
    }
    Md52.prototype.update = function(sourceData) {
      if (isEmptyData(sourceData)) {
        return;
      } else if (this.finished) {
        throw new Error("Attempted to update an already finished hash.");
      }
      var data = convertToBuffer(sourceData);
      var position = 0;
      var byteLength2 = data.byteLength;
      this.bytesHashed += byteLength2;
      while (byteLength2 > 0) {
        this.buffer.setUint8(this.bufferLength++, data[position++]);
        byteLength2--;
        if (this.bufferLength === BLOCK_SIZE) {
          this.hashBuffer();
          this.bufferLength = 0;
        }
      }
    };
    Md52.prototype.digest = function() {
      return __awaiter52(this, void 0, void 0, function() {
        var _a2, buffer, undecoratedLength, bytesHashed, bitsHashed, i2, i2, out, i2;
        return __generator53(this, function(_b2) {
          if (!this.finished) {
            _a2 = this, buffer = _a2.buffer, undecoratedLength = _a2.bufferLength, bytesHashed = _a2.bytesHashed;
            bitsHashed = bytesHashed * 8;
            buffer.setUint8(this.bufferLength++, 128);
            if (undecoratedLength % BLOCK_SIZE >= BLOCK_SIZE - 8) {
              for (i2 = this.bufferLength; i2 < BLOCK_SIZE; i2++) {
                buffer.setUint8(i2, 0);
              }
              this.hashBuffer();
              this.bufferLength = 0;
            }
            for (i2 = this.bufferLength; i2 < BLOCK_SIZE - 8; i2++) {
              buffer.setUint8(i2, 0);
            }
            buffer.setUint32(BLOCK_SIZE - 8, bitsHashed >>> 0, true);
            buffer.setUint32(BLOCK_SIZE - 4, Math.floor(bitsHashed / 4294967296), true);
            this.hashBuffer();
            this.finished = true;
          }
          out = new DataView(new ArrayBuffer(DIGEST_LENGTH));
          for (i2 = 0; i2 < 4; i2++) {
            out.setUint32(i2 * 4, this.state[i2], true);
          }
          return [2, new Uint8Array(out.buffer, out.byteOffset, out.byteLength)];
        });
      });
    };
    Md52.prototype.hashBuffer = function() {
      var _a2 = this, buffer = _a2.buffer, state = _a2.state;
      var a2 = state[0], b2 = state[1], c2 = state[2], d2 = state[3];
      a2 = ff(a2, b2, c2, d2, buffer.getUint32(0, true), 7, 3614090360);
      d2 = ff(d2, a2, b2, c2, buffer.getUint32(4, true), 12, 3905402710);
      c2 = ff(c2, d2, a2, b2, buffer.getUint32(8, true), 17, 606105819);
      b2 = ff(b2, c2, d2, a2, buffer.getUint32(12, true), 22, 3250441966);
      a2 = ff(a2, b2, c2, d2, buffer.getUint32(16, true), 7, 4118548399);
      d2 = ff(d2, a2, b2, c2, buffer.getUint32(20, true), 12, 1200080426);
      c2 = ff(c2, d2, a2, b2, buffer.getUint32(24, true), 17, 2821735955);
      b2 = ff(b2, c2, d2, a2, buffer.getUint32(28, true), 22, 4249261313);
      a2 = ff(a2, b2, c2, d2, buffer.getUint32(32, true), 7, 1770035416);
      d2 = ff(d2, a2, b2, c2, buffer.getUint32(36, true), 12, 2336552879);
      c2 = ff(c2, d2, a2, b2, buffer.getUint32(40, true), 17, 4294925233);
      b2 = ff(b2, c2, d2, a2, buffer.getUint32(44, true), 22, 2304563134);
      a2 = ff(a2, b2, c2, d2, buffer.getUint32(48, true), 7, 1804603682);
      d2 = ff(d2, a2, b2, c2, buffer.getUint32(52, true), 12, 4254626195);
      c2 = ff(c2, d2, a2, b2, buffer.getUint32(56, true), 17, 2792965006);
      b2 = ff(b2, c2, d2, a2, buffer.getUint32(60, true), 22, 1236535329);
      a2 = gg(a2, b2, c2, d2, buffer.getUint32(4, true), 5, 4129170786);
      d2 = gg(d2, a2, b2, c2, buffer.getUint32(24, true), 9, 3225465664);
      c2 = gg(c2, d2, a2, b2, buffer.getUint32(44, true), 14, 643717713);
      b2 = gg(b2, c2, d2, a2, buffer.getUint32(0, true), 20, 3921069994);
      a2 = gg(a2, b2, c2, d2, buffer.getUint32(20, true), 5, 3593408605);
      d2 = gg(d2, a2, b2, c2, buffer.getUint32(40, true), 9, 38016083);
      c2 = gg(c2, d2, a2, b2, buffer.getUint32(60, true), 14, 3634488961);
      b2 = gg(b2, c2, d2, a2, buffer.getUint32(16, true), 20, 3889429448);
      a2 = gg(a2, b2, c2, d2, buffer.getUint32(36, true), 5, 568446438);
      d2 = gg(d2, a2, b2, c2, buffer.getUint32(56, true), 9, 3275163606);
      c2 = gg(c2, d2, a2, b2, buffer.getUint32(12, true), 14, 4107603335);
      b2 = gg(b2, c2, d2, a2, buffer.getUint32(32, true), 20, 1163531501);
      a2 = gg(a2, b2, c2, d2, buffer.getUint32(52, true), 5, 2850285829);
      d2 = gg(d2, a2, b2, c2, buffer.getUint32(8, true), 9, 4243563512);
      c2 = gg(c2, d2, a2, b2, buffer.getUint32(28, true), 14, 1735328473);
      b2 = gg(b2, c2, d2, a2, buffer.getUint32(48, true), 20, 2368359562);
      a2 = hh(a2, b2, c2, d2, buffer.getUint32(20, true), 4, 4294588738);
      d2 = hh(d2, a2, b2, c2, buffer.getUint32(32, true), 11, 2272392833);
      c2 = hh(c2, d2, a2, b2, buffer.getUint32(44, true), 16, 1839030562);
      b2 = hh(b2, c2, d2, a2, buffer.getUint32(56, true), 23, 4259657740);
      a2 = hh(a2, b2, c2, d2, buffer.getUint32(4, true), 4, 2763975236);
      d2 = hh(d2, a2, b2, c2, buffer.getUint32(16, true), 11, 1272893353);
      c2 = hh(c2, d2, a2, b2, buffer.getUint32(28, true), 16, 4139469664);
      b2 = hh(b2, c2, d2, a2, buffer.getUint32(40, true), 23, 3200236656);
      a2 = hh(a2, b2, c2, d2, buffer.getUint32(52, true), 4, 681279174);
      d2 = hh(d2, a2, b2, c2, buffer.getUint32(0, true), 11, 3936430074);
      c2 = hh(c2, d2, a2, b2, buffer.getUint32(12, true), 16, 3572445317);
      b2 = hh(b2, c2, d2, a2, buffer.getUint32(24, true), 23, 76029189);
      a2 = hh(a2, b2, c2, d2, buffer.getUint32(36, true), 4, 3654602809);
      d2 = hh(d2, a2, b2, c2, buffer.getUint32(48, true), 11, 3873151461);
      c2 = hh(c2, d2, a2, b2, buffer.getUint32(60, true), 16, 530742520);
      b2 = hh(b2, c2, d2, a2, buffer.getUint32(8, true), 23, 3299628645);
      a2 = ii(a2, b2, c2, d2, buffer.getUint32(0, true), 6, 4096336452);
      d2 = ii(d2, a2, b2, c2, buffer.getUint32(28, true), 10, 1126891415);
      c2 = ii(c2, d2, a2, b2, buffer.getUint32(56, true), 15, 2878612391);
      b2 = ii(b2, c2, d2, a2, buffer.getUint32(20, true), 21, 4237533241);
      a2 = ii(a2, b2, c2, d2, buffer.getUint32(48, true), 6, 1700485571);
      d2 = ii(d2, a2, b2, c2, buffer.getUint32(12, true), 10, 2399980690);
      c2 = ii(c2, d2, a2, b2, buffer.getUint32(40, true), 15, 4293915773);
      b2 = ii(b2, c2, d2, a2, buffer.getUint32(4, true), 21, 2240044497);
      a2 = ii(a2, b2, c2, d2, buffer.getUint32(32, true), 6, 1873313359);
      d2 = ii(d2, a2, b2, c2, buffer.getUint32(60, true), 10, 4264355552);
      c2 = ii(c2, d2, a2, b2, buffer.getUint32(24, true), 15, 2734768916);
      b2 = ii(b2, c2, d2, a2, buffer.getUint32(52, true), 21, 1309151649);
      a2 = ii(a2, b2, c2, d2, buffer.getUint32(16, true), 6, 4149444226);
      d2 = ii(d2, a2, b2, c2, buffer.getUint32(44, true), 10, 3174756917);
      c2 = ii(c2, d2, a2, b2, buffer.getUint32(8, true), 15, 718787259);
      b2 = ii(b2, c2, d2, a2, buffer.getUint32(36, true), 21, 3951481745);
      state[0] = a2 + state[0] & 4294967295;
      state[1] = b2 + state[1] & 4294967295;
      state[2] = c2 + state[2] & 4294967295;
      state[3] = d2 + state[3] & 4294967295;
    };
    return Md52;
  }()
);
function cmn(q2, a2, b2, x2, s2, t2) {
  a2 = (a2 + q2 & 4294967295) + (x2 + t2 & 4294967295) & 4294967295;
  return (a2 << s2 | a2 >>> 32 - s2) + b2 & 4294967295;
}
function ff(a2, b2, c2, d2, x2, s2, t2) {
  return cmn(b2 & c2 | ~b2 & d2, a2, b2, x2, s2, t2);
}
function gg(a2, b2, c2, d2, x2, s2, t2) {
  return cmn(b2 & d2 | c2 & ~d2, a2, b2, x2, s2, t2);
}
function hh(a2, b2, c2, d2, x2, s2, t2) {
  return cmn(b2 ^ c2 ^ d2, a2, b2, x2, s2, t2);
}
function ii(a2, b2, c2, d2, x2, s2, t2) {
  return cmn(c2 ^ (b2 | ~d2), a2, b2, x2, s2, t2);
}
function isEmptyData(data) {
  if (typeof data === "string") {
    return data.length === 0;
  }
  return data.byteLength === 0;
}
function convertToBuffer(data) {
  if (typeof data === "string") {
    return fromUtf824(data);
  }
  if (ArrayBuffer.isView(data)) {
    return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
  }
  return new Uint8Array(data);
}

// node_modules/@aws-sdk/client-s3/node_modules/@aws-sdk/util-user-agent-browser/node_modules/tslib/tslib.es6.js
function __awaiter53(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator54(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/client-s3/node_modules/@aws-sdk/util-user-agent-browser/dist/es/index.js
var defaultUserAgent5 = function(_a2) {
  var serviceId = _a2.serviceId, clientVersion = _a2.clientVersion;
  return function() {
    return __awaiter53(void 0, void 0, void 0, function() {
      var parsedUA, sections;
      var _a3, _b2, _c, _d, _e, _f, _g;
      return __generator54(this, function(_h) {
        parsedUA = ((_a3 = window === null || window === void 0 ? void 0 : window.navigator) === null || _a3 === void 0 ? void 0 : _a3.userAgent) ? bowser_default.parse(window.navigator.userAgent) : void 0;
        sections = [
          // sdk-metadata
          ["aws-sdk-js", clientVersion],
          // os-metadata
          ["os/" + (((_b2 = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b2 === void 0 ? void 0 : _b2.name) || "other"), (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version],
          // language-metadata
          // ECMAScript edition doesn't matter in JS.
          ["lang/js"],
          // browser vendor and version.
          ["md/browser", ((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown") + "_" + ((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")]
        ];
        if (serviceId) {
          sections.push(["api/" + serviceId, clientVersion]);
        }
        return [2, sections];
      });
    });
  };
};

// node_modules/@aws-sdk/client-s3/dist/es/runtimeConfig.browser.js
init_es5();

// node_modules/@aws-sdk/client-s3/dist/es/endpoints.js
var AWS_TEMPLATE5 = "s3.{region}.amazonaws.com";
var AWS_CN_TEMPLATE5 = "s3.{region}.amazonaws.com.cn";
var AWS_ISO_TEMPLATE5 = "s3.{region}.c2s.ic.gov";
var AWS_ISO_B_TEMPLATE5 = "s3.{region}.sc2s.sgov.gov";
var AWS_US_GOV_TEMPLATE5 = "s3.{region}.amazonaws.com";
var AWS_REGIONS5 = /* @__PURE__ */ new Set([
  "af-south-1",
  "ap-east-1",
  "ap-northeast-1",
  "ap-northeast-2",
  "ap-south-1",
  "ap-southeast-1",
  "ap-southeast-2",
  "ca-central-1",
  "eu-central-1",
  "eu-north-1",
  "eu-south-1",
  "eu-west-1",
  "eu-west-2",
  "eu-west-3",
  "me-south-1",
  "sa-east-1",
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2"
]);
var AWS_CN_REGIONS5 = /* @__PURE__ */ new Set(["cn-north-1", "cn-northwest-1"]);
var AWS_ISO_REGIONS5 = /* @__PURE__ */ new Set(["us-iso-east-1"]);
var AWS_ISO_B_REGIONS5 = /* @__PURE__ */ new Set(["us-isob-east-1"]);
var AWS_US_GOV_REGIONS5 = /* @__PURE__ */ new Set(["us-gov-east-1", "us-gov-west-1"]);
var defaultRegionInfoProvider5 = function(region, options) {
  var regionInfo = void 0;
  switch (region) {
    case "af-south-1":
      regionInfo = {
        hostname: "s3.af-south-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-east-1":
      regionInfo = {
        hostname: "s3.ap-east-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-northeast-1":
      regionInfo = {
        hostname: "s3.ap-northeast-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-northeast-2":
      regionInfo = {
        hostname: "s3.ap-northeast-2.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-south-1":
      regionInfo = {
        hostname: "s3.ap-south-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-southeast-1":
      regionInfo = {
        hostname: "s3.ap-southeast-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "ap-southeast-2":
      regionInfo = {
        hostname: "s3.ap-southeast-2.amazonaws.com",
        partition: "aws"
      };
      break;
    case "aws-global":
      regionInfo = {
        hostname: "s3.amazonaws.com",
        partition: "aws",
        signingRegion: "us-east-1"
      };
      break;
    case "ca-central-1":
      regionInfo = {
        hostname: "s3.ca-central-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "cn-north-1":
      regionInfo = {
        hostname: "s3.cn-north-1.amazonaws.com.cn",
        partition: "aws-cn"
      };
      break;
    case "cn-northwest-1":
      regionInfo = {
        hostname: "s3.cn-northwest-1.amazonaws.com.cn",
        partition: "aws-cn"
      };
      break;
    case "eu-central-1":
      regionInfo = {
        hostname: "s3.eu-central-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "eu-north-1":
      regionInfo = {
        hostname: "s3.eu-north-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "eu-south-1":
      regionInfo = {
        hostname: "s3.eu-south-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "eu-west-1":
      regionInfo = {
        hostname: "s3.eu-west-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "eu-west-2":
      regionInfo = {
        hostname: "s3.eu-west-2.amazonaws.com",
        partition: "aws"
      };
      break;
    case "eu-west-3":
      regionInfo = {
        hostname: "s3.eu-west-3.amazonaws.com",
        partition: "aws"
      };
      break;
    case "fips-us-gov-west-1":
      regionInfo = {
        hostname: "s3-fips.us-gov-west-1.amazonaws.com",
        partition: "aws-us-gov",
        signingRegion: "us-gov-west-1"
      };
      break;
    case "me-south-1":
      regionInfo = {
        hostname: "s3.me-south-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "s3-external-1":
      regionInfo = {
        hostname: "s3-external-1.amazonaws.com",
        partition: "aws",
        signingRegion: "us-east-1"
      };
      break;
    case "sa-east-1":
      regionInfo = {
        hostname: "s3.sa-east-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "us-east-1":
      regionInfo = {
        hostname: "s3.us-east-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "us-east-2":
      regionInfo = {
        hostname: "s3.us-east-2.amazonaws.com",
        partition: "aws"
      };
      break;
    case "us-gov-east-1":
      regionInfo = {
        hostname: "s3.us-gov-east-1.amazonaws.com",
        partition: "aws-us-gov"
      };
      break;
    case "us-gov-west-1":
      regionInfo = {
        hostname: "s3.us-gov-west-1.amazonaws.com",
        partition: "aws-us-gov"
      };
      break;
    case "us-iso-east-1":
      regionInfo = {
        hostname: "s3.us-iso-east-1.c2s.ic.gov",
        partition: "aws-iso"
      };
      break;
    case "us-isob-east-1":
      regionInfo = {
        hostname: "s3.us-isob-east-1.sc2s.sgov.gov",
        partition: "aws-iso-b"
      };
      break;
    case "us-west-1":
      regionInfo = {
        hostname: "s3.us-west-1.amazonaws.com",
        partition: "aws"
      };
      break;
    case "us-west-2":
      regionInfo = {
        hostname: "s3.us-west-2.amazonaws.com",
        partition: "aws"
      };
      break;
    default:
      if (AWS_REGIONS5.has(region)) {
        regionInfo = {
          hostname: AWS_TEMPLATE5.replace("{region}", region),
          partition: "aws"
        };
      }
      if (AWS_CN_REGIONS5.has(region)) {
        regionInfo = {
          hostname: AWS_CN_TEMPLATE5.replace("{region}", region),
          partition: "aws-cn"
        };
      }
      if (AWS_ISO_REGIONS5.has(region)) {
        regionInfo = {
          hostname: AWS_ISO_TEMPLATE5.replace("{region}", region),
          partition: "aws-iso"
        };
      }
      if (AWS_ISO_B_REGIONS5.has(region)) {
        regionInfo = {
          hostname: AWS_ISO_B_TEMPLATE5.replace("{region}", region),
          partition: "aws-iso-b"
        };
      }
      if (AWS_US_GOV_REGIONS5.has(region)) {
        regionInfo = {
          hostname: AWS_US_GOV_TEMPLATE5.replace("{region}", region),
          partition: "aws-us-gov"
        };
      }
      if (regionInfo === void 0) {
        regionInfo = {
          hostname: AWS_TEMPLATE5.replace("{region}", region),
          partition: "aws"
        };
      }
  }
  return Promise.resolve(__assign7({ signingService: "s3" }, regionInfo));
};

// node_modules/@aws-sdk/client-s3/dist/es/runtimeConfig.shared.js
var ClientSharedValues5 = {
  apiVersion: "2006-03-01",
  disableHostPrefix: false,
  logger: {},
  regionInfoProvider: defaultRegionInfoProvider5,
  serviceId: "S3",
  signingEscapePath: false,
  urlParser: parseUrl,
  useArnRegion: false
};

// node_modules/@aws-sdk/client-s3/dist/es/runtimeConfig.browser.js
var ClientDefaultValues5 = __assign7(__assign7({}, ClientSharedValues5), {
  runtime: "browser",
  base64Decoder: fromBase64,
  base64Encoder: toBase64,
  bodyLengthChecker: calculateBodyLength,
  credentialDefaultProvider: function(_2) {
    return function() {
      return Promise.reject(new Error("Credential is missing"));
    };
  },
  defaultUserAgentProvider: defaultUserAgent5({
    serviceId: ClientSharedValues5.serviceId,
    clientVersion: package_default5.version
  }),
  eventStreamSerdeProvider,
  maxAttempts: DEFAULT_MAX_ATTEMPTS,
  md5: Md5,
  region: invalidProvider("Region is missing"),
  requestHandler: new FetchHttpHandler(),
  sha256: import_sha256_browser5.Sha256,
  streamCollector,
  streamHasher: blobHasher,
  utf8Decoder: fromUtf821,
  utf8Encoder: toUtf820
});

// node_modules/@aws-sdk/middleware-bucket-endpoint/node_modules/tslib/tslib.es6.js
var __assign33 = function() {
  __assign33 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign33.apply(this, arguments);
};
function __awaiter54(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator55(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __read30(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}

// node_modules/@aws-sdk/util-arn-parser/node_modules/tslib/tslib.es6.js
function __read31(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}

// node_modules/@aws-sdk/util-arn-parser/dist/es/index.js
var validate = function(str) {
  return typeof str === "string" && str.indexOf("arn:") === 0 && str.split(":").length >= 6;
};
var parse5 = function(arn) {
  var segments = arn.split(":");
  if (segments.length < 6 || segments[0] !== "arn")
    throw new Error("Malformed ARN");
  var _a2 = __read31(segments), partition = _a2[1], service = _a2[2], region = _a2[3], accountId = _a2[4], resource = _a2.slice(5);
  return {
    partition,
    service,
    region,
    accountId,
    resource: resource.join(":")
  };
};

// node_modules/@aws-sdk/middleware-bucket-endpoint/dist/es/bucketHostnameUtils.js
var DOMAIN_PATTERN = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
var IP_ADDRESS_PATTERN = /(\d+\.){3}\d+/;
var DOTS_PATTERN = /\.\./;
var DOT_PATTERN = /\./;
var S3_HOSTNAME_PATTERN = /^(.+\.)?s3[.-]([a-z0-9-]+)\./;
var S3_US_EAST_1_ALTNAME_PATTERN = /^s3(-external-1)?\.amazonaws\.com$/;
var AWS_PARTITION_SUFFIX = "amazonaws.com";
var isBucketNameOptions = function(options) {
  return typeof options.bucketName === "string";
};
var getPseudoRegion = function(region) {
  return isFipsRegion(region) ? region.replace(/fips-|-fips/, "") : region;
};
var isDnsCompatibleBucketName = function(bucketName) {
  return DOMAIN_PATTERN.test(bucketName) && !IP_ADDRESS_PATTERN.test(bucketName) && !DOTS_PATTERN.test(bucketName);
};
var getRegionalSuffix = function(hostname) {
  var parts = hostname.match(S3_HOSTNAME_PATTERN);
  return [parts[2], hostname.replace(new RegExp("^" + parts[0]), "")];
};
var getSuffix = function(hostname) {
  return S3_US_EAST_1_ALTNAME_PATTERN.test(hostname) ? ["us-east-1", AWS_PARTITION_SUFFIX] : getRegionalSuffix(hostname);
};
var getSuffixForArnEndpoint = function(hostname) {
  return S3_US_EAST_1_ALTNAME_PATTERN.test(hostname) ? [hostname.replace("." + AWS_PARTITION_SUFFIX, ""), AWS_PARTITION_SUFFIX] : getRegionalSuffix(hostname);
};
var validateArnEndpointOptions = function(options) {
  if (options.pathStyleEndpoint) {
    throw new Error("Path-style S3 endpoint is not supported when bucket is an ARN");
  }
  if (options.accelerateEndpoint) {
    throw new Error("Accelerate endpoint is not supported when bucket is an ARN");
  }
  if (!options.tlsCompatible) {
    throw new Error("HTTPS is required when bucket is an ARN");
  }
};
var validateService = function(service) {
  if (service !== "s3" && service !== "s3-outposts") {
    throw new Error("Expect 's3' or 's3-outposts' in ARN service component");
  }
};
var validateS3Service = function(service) {
  if (service !== "s3") {
    throw new Error("Expect 's3' in Accesspoint ARN service component");
  }
};
var validateOutpostService = function(service) {
  if (service !== "s3-outposts") {
    throw new Error("Expect 's3-posts' in Outpost ARN service component");
  }
};
var validatePartition = function(partition, options) {
  if (partition !== options.clientPartition) {
    throw new Error('Partition in ARN is incompatible, got "' + partition + '" but expected "' + options.clientPartition + '"');
  }
};
var validateRegion = function(region, options) {
  if (region === "") {
    throw new Error("ARN region is empty");
  }
  if (!options.useArnRegion && !isEqualRegions(region, options.clientRegion) && !isEqualRegions(region, options.clientSigningRegion)) {
    throw new Error("Region in ARN is incompatible, got " + region + " but expected " + options.clientRegion);
  }
  if (options.useArnRegion && isFipsRegion(region)) {
    throw new Error("Endpoint does not support FIPS region");
  }
};
var isFipsRegion = function(region) {
  return region.startsWith("fips-") || region.endsWith("-fips");
};
var isEqualRegions = function(regionA, regionB) {
  return regionA === regionB || getPseudoRegion(regionA) === regionB || regionA === getPseudoRegion(regionB);
};
var validateAccountId = function(accountId) {
  if (!/[0-9]{12}/.exec(accountId)) {
    throw new Error("Access point ARN accountID does not match regex '[0-9]{12}'");
  }
};
var validateDNSHostLabel = function(label, options) {
  if (options === void 0) {
    options = { tlsCompatible: true };
  }
  if (label.length >= 64 || !/^[a-z0-9][a-z0-9.-]+[a-z0-9]$/.test(label) || /(\d+\.){3}\d+/.test(label) || /[.-]{2}/.test(label) || (options === null || options === void 0 ? void 0 : options.tlsCompatible) && DOT_PATTERN.test(label)) {
    throw new Error("Invalid DNS label " + label);
  }
};
var getArnResources = function(resource) {
  var delimiter = resource.includes(":") ? ":" : "/";
  var _a2 = __read30(resource.split(delimiter)), resourceType = _a2[0], rest = _a2.slice(1);
  if (resourceType === "accesspoint") {
    if (rest.length !== 1 || rest[0] === "") {
      throw new Error("Access Point ARN should have one resource accesspoint" + delimiter + "{accesspointname}");
    }
    return { accesspointName: rest[0] };
  } else if (resourceType === "outpost") {
    if (!rest[0] || rest[1] !== "accesspoint" || !rest[2] || rest.length !== 3) {
      throw new Error("Outpost ARN should have resource outpost" + delimiter + "{outpostId}" + delimiter + "accesspoint" + delimiter + "{accesspointName}");
    }
    var _b2 = __read30(rest, 3), outpostId = _b2[0], _2 = _b2[1], accesspointName = _b2[2];
    return { outpostId, accesspointName };
  } else {
    throw new Error("ARN resource should begin with 'accesspoint" + delimiter + "' or 'outpost" + delimiter + "'");
  }
};
var validateNoDualstack = function(dualstackEndpoint) {
  if (dualstackEndpoint)
    throw new Error("Dualstack endpoint is not supported with Outpost");
};
var validateNoFIPS = function(region) {
  if (isFipsRegion(region !== null && region !== void 0 ? region : ""))
    throw new Error("FIPS region is not supported with Outpost, got " + region);
};

// node_modules/@aws-sdk/middleware-bucket-endpoint/dist/es/bucketHostname.js
var bucketHostname = function(options) {
  var isCustomEndpoint = options.isCustomEndpoint, baseHostname = options.baseHostname, dualstackEndpoint = options.dualstackEndpoint, accelerateEndpoint = options.accelerateEndpoint;
  if (isCustomEndpoint) {
    if (dualstackEndpoint)
      throw new Error("Dualstack endpoint is not supported with custom endpoint");
    if (accelerateEndpoint)
      throw new Error("Accelerate endpoint is not supported with custom endpoint");
  }
  return isBucketNameOptions(options) ? (
    // Construct endpoint when bucketName is a string referring to a bucket name
    getEndpointFromBucketName(__assign33(__assign33({}, options), { isCustomEndpoint }))
  ) : (
    // Construct endpoint when bucketName is an ARN referring to an S3 resource like Access Point
    getEndpointFromArn(__assign33(__assign33({}, options), { isCustomEndpoint }))
  );
};
var getEndpointFromArn = function(options) {
  var isCustomEndpoint = options.isCustomEndpoint, baseHostname = options.baseHostname;
  var _a2 = __read30(isCustomEndpoint ? [options.clientRegion, baseHostname] : (
    // Infer client region and hostname suffix from hostname from endpoints.json, like `s3.us-west-2.amazonaws.com`
    getSuffixForArnEndpoint(baseHostname)
  ), 2), clientRegion = _a2[0], hostnameSuffix = _a2[1];
  var pathStyleEndpoint = options.pathStyleEndpoint, _b2 = options.dualstackEndpoint, dualstackEndpoint = _b2 === void 0 ? false : _b2, _c = options.accelerateEndpoint, accelerateEndpoint = _c === void 0 ? false : _c, _d = options.tlsCompatible, tlsCompatible = _d === void 0 ? true : _d, useArnRegion = options.useArnRegion, bucketName = options.bucketName, _e = options.clientPartition, clientPartition = _e === void 0 ? "aws" : _e, _f = options.clientSigningRegion, clientSigningRegion = _f === void 0 ? clientRegion : _f;
  validateArnEndpointOptions({ pathStyleEndpoint, accelerateEndpoint, tlsCompatible });
  var service = bucketName.service, partition = bucketName.partition, accountId = bucketName.accountId, region = bucketName.region, resource = bucketName.resource;
  validateService(service);
  validatePartition(partition, { clientPartition });
  validateAccountId(accountId);
  validateRegion(region, { useArnRegion, clientRegion, clientSigningRegion });
  var _g = getArnResources(resource), accesspointName = _g.accesspointName, outpostId = _g.outpostId;
  validateDNSHostLabel(accesspointName + "-" + accountId, { tlsCompatible });
  var endpointRegion = useArnRegion ? region : clientRegion;
  var signingRegion = useArnRegion ? region : clientSigningRegion;
  if (outpostId) {
    validateOutpostService(service);
    validateDNSHostLabel(outpostId, { tlsCompatible });
    validateNoDualstack(dualstackEndpoint);
    validateNoFIPS(endpointRegion);
    var hostnamePrefix_1 = accesspointName + "-" + accountId + "." + outpostId;
    return {
      bucketEndpoint: true,
      hostname: "" + hostnamePrefix_1 + (isCustomEndpoint ? "" : ".s3-outposts." + endpointRegion) + "." + hostnameSuffix,
      signingRegion,
      signingService: "s3-outposts"
    };
  }
  validateS3Service(service);
  var hostnamePrefix = accesspointName + "-" + accountId;
  return {
    bucketEndpoint: true,
    hostname: "" + hostnamePrefix + (isCustomEndpoint ? "" : ".s3-accesspoint" + (dualstackEndpoint ? ".dualstack" : "") + "." + endpointRegion) + "." + hostnameSuffix,
    signingRegion
  };
};
var getEndpointFromBucketName = function(_a2) {
  var _b2 = _a2.accelerateEndpoint, accelerateEndpoint = _b2 === void 0 ? false : _b2, region = _a2.clientRegion, baseHostname = _a2.baseHostname, bucketName = _a2.bucketName, _c = _a2.dualstackEndpoint, dualstackEndpoint = _c === void 0 ? false : _c, _d = _a2.pathStyleEndpoint, pathStyleEndpoint = _d === void 0 ? false : _d, _e = _a2.tlsCompatible, tlsCompatible = _e === void 0 ? true : _e, _f = _a2.isCustomEndpoint, isCustomEndpoint = _f === void 0 ? false : _f;
  var _g = __read30(isCustomEndpoint ? [region, baseHostname] : getSuffix(baseHostname), 2), clientRegion = _g[0], hostnameSuffix = _g[1];
  if (pathStyleEndpoint || !isDnsCompatibleBucketName(bucketName) || tlsCompatible && DOT_PATTERN.test(bucketName)) {
    return {
      bucketEndpoint: false,
      hostname: dualstackEndpoint ? "s3.dualstack." + clientRegion + "." + hostnameSuffix : baseHostname
    };
  }
  if (accelerateEndpoint) {
    baseHostname = "s3-accelerate" + (dualstackEndpoint ? ".dualstack" : "") + "." + hostnameSuffix;
  } else if (dualstackEndpoint) {
    baseHostname = "s3.dualstack." + clientRegion + "." + hostnameSuffix;
  }
  return {
    bucketEndpoint: true,
    hostname: bucketName + "." + baseHostname
  };
};

// node_modules/@aws-sdk/middleware-bucket-endpoint/dist/es/bucketEndpointMiddleware.js
var bucketEndpointMiddleware = function(options) {
  return function(next, context) {
    return function(args) {
      return __awaiter54(void 0, void 0, void 0, function() {
        var bucketName, replaceBucketInPath, request, bucketArn, clientRegion, _a2, _b2, partition, _c, signingRegion, useArnRegion, _d, hostname, bucketEndpoint, modifiedSigningRegion, signingService, clientRegion, _e, _f, hostname, bucketEndpoint;
        return __generator55(this, function(_g) {
          switch (_g.label) {
            case 0:
              bucketName = args.input.Bucket;
              replaceBucketInPath = options.bucketEndpoint;
              request = args.request;
              if (!HttpRequest.isInstance(request))
                return [3, 8];
              if (!options.bucketEndpoint)
                return [3, 1];
              request.hostname = bucketName;
              return [3, 7];
            case 1:
              if (!validate(bucketName))
                return [3, 5];
              bucketArn = parse5(bucketName);
              _a2 = getPseudoRegion;
              return [4, options.region()];
            case 2:
              clientRegion = _a2.apply(void 0, [_g.sent()]);
              return [4, options.regionInfoProvider(clientRegion)];
            case 3:
              _b2 = _g.sent() || {}, partition = _b2.partition, _c = _b2.signingRegion, signingRegion = _c === void 0 ? clientRegion : _c;
              return [4, options.useArnRegion()];
            case 4:
              useArnRegion = _g.sent();
              _d = bucketHostname({
                bucketName: bucketArn,
                baseHostname: request.hostname,
                accelerateEndpoint: options.useAccelerateEndpoint,
                dualstackEndpoint: options.useDualstackEndpoint,
                pathStyleEndpoint: options.forcePathStyle,
                tlsCompatible: request.protocol === "https:",
                useArnRegion,
                clientPartition: partition,
                clientSigningRegion: signingRegion,
                clientRegion,
                isCustomEndpoint: options.isCustomEndpoint
              }), hostname = _d.hostname, bucketEndpoint = _d.bucketEndpoint, modifiedSigningRegion = _d.signingRegion, signingService = _d.signingService;
              if (modifiedSigningRegion && modifiedSigningRegion !== signingRegion) {
                context["signing_region"] = modifiedSigningRegion;
              }
              if (signingService && signingService !== "s3") {
                context["signing_service"] = signingService;
              }
              request.hostname = hostname;
              replaceBucketInPath = bucketEndpoint;
              return [3, 7];
            case 5:
              _e = getPseudoRegion;
              return [4, options.region()];
            case 6:
              clientRegion = _e.apply(void 0, [_g.sent()]);
              _f = bucketHostname({
                bucketName,
                clientRegion,
                baseHostname: request.hostname,
                accelerateEndpoint: options.useAccelerateEndpoint,
                dualstackEndpoint: options.useDualstackEndpoint,
                pathStyleEndpoint: options.forcePathStyle,
                tlsCompatible: request.protocol === "https:",
                isCustomEndpoint: options.isCustomEndpoint
              }), hostname = _f.hostname, bucketEndpoint = _f.bucketEndpoint;
              request.hostname = hostname;
              replaceBucketInPath = bucketEndpoint;
              _g.label = 7;
            case 7:
              if (replaceBucketInPath) {
                request.path = request.path.replace(/^(\/)?[^\/]+/, "");
                if (request.path === "") {
                  request.path = "/";
                }
              }
              _g.label = 8;
            case 8:
              return [2, next(__assign33(__assign33({}, args), { request }))];
          }
        });
      });
    };
  };
};
var bucketEndpointMiddlewareOptions = {
  tags: ["BUCKET_ENDPOINT"],
  name: "bucketEndpointMiddleware",
  relation: "before",
  toMiddleware: "hostHeaderMiddleware",
  override: true
};
var getBucketEndpointPlugin = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.addRelativeTo(bucketEndpointMiddleware(options), bucketEndpointMiddlewareOptions);
    }
  };
};

// node_modules/@aws-sdk/middleware-bucket-endpoint/dist/es/configurations.js
function resolveBucketEndpointConfig(input) {
  var _a2 = input.bucketEndpoint, bucketEndpoint = _a2 === void 0 ? false : _a2, _b2 = input.forcePathStyle, forcePathStyle = _b2 === void 0 ? false : _b2, _c = input.useAccelerateEndpoint, useAccelerateEndpoint = _c === void 0 ? false : _c, _d = input.useDualstackEndpoint, useDualstackEndpoint = _d === void 0 ? false : _d, _e = input.useArnRegion, useArnRegion = _e === void 0 ? false : _e;
  return __assign33(__assign33({}, input), {
    bucketEndpoint,
    forcePathStyle,
    useAccelerateEndpoint,
    useDualstackEndpoint,
    useArnRegion: typeof useArnRegion === "function" ? useArnRegion : function() {
      return Promise.resolve(useArnRegion);
    }
  });
}

// node_modules/@aws-sdk/middleware-expect-continue/node_modules/tslib/tslib.es6.js
var __assign34 = function() {
  __assign34 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign34.apply(this, arguments);
};
function __awaiter55(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator56(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/middleware-expect-continue/dist/es/index.js
function addExpectContinueMiddleware(options) {
  var _this = this;
  return function(next) {
    return function(args) {
      return __awaiter55(_this, void 0, void 0, function() {
        var request;
        return __generator56(this, function(_a2) {
          request = args.request;
          if (HttpRequest.isInstance(request) && request.body && options.runtime === "node") {
            request.headers = __assign34(__assign34({}, request.headers), { Expect: "100-continue" });
          }
          return [2, next(__assign34(__assign34({}, args), { request }))];
        });
      });
    };
  };
}
var addExpectContinueMiddlewareOptions = {
  step: "build",
  tags: ["SET_EXPECT_HEADER", "EXPECT_HEADER"],
  name: "addExpectContinueMiddleware",
  override: true
};
var getAddExpectContinuePlugin = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(addExpectContinueMiddleware(options), addExpectContinueMiddlewareOptions);
    }
  };
};

// node_modules/@aws-sdk/client-s3/node_modules/@aws-sdk/middleware-host-header/node_modules/tslib/tslib.es6.js
function __awaiter56(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator57(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/client-s3/node_modules/@aws-sdk/middleware-host-header/dist/es/index.js
function resolveHostHeaderConfig5(input) {
  return input;
}
var hostHeaderMiddleware5 = function(options) {
  return function(next) {
    return function(args) {
      return __awaiter56(void 0, void 0, void 0, function() {
        var request, _a2, handlerProtocol;
        return __generator57(this, function(_b2) {
          if (!HttpRequest.isInstance(args.request))
            return [2, next(args)];
          request = args.request;
          _a2 = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a2 === void 0 ? "" : _a2;
          if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
            delete request.headers["host"];
            request.headers[":authority"] = "";
          } else if (!request.headers["host"]) {
            request.headers["host"] = request.hostname;
          }
          return [2, next(args)];
        });
      });
    };
  };
};
var hostHeaderMiddlewareOptions5 = {
  name: "hostHeaderMiddleware",
  step: "build",
  priority: "low",
  tags: ["HOST"],
  override: true
};
var getHostHeaderPlugin5 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(hostHeaderMiddleware5(options), hostHeaderMiddlewareOptions5);
    }
  };
};

// node_modules/@aws-sdk/client-s3/node_modules/@aws-sdk/middleware-logger/node_modules/tslib/tslib.es6.js
function __rest9(s2, e) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
}
function __awaiter57(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator58(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/client-s3/node_modules/@aws-sdk/middleware-logger/dist/es/loggerMiddleware.js
var loggerMiddleware5 = function() {
  return function(next, context) {
    return function(args) {
      return __awaiter57(void 0, void 0, void 0, function() {
        var clientName, commandName, inputFilterSensitiveLog, logger64, outputFilterSensitiveLog, response, _a2, $metadata, outputWithoutMetadata;
        return __generator58(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger64 = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
              return [4, next(args)];
            case 1:
              response = _b2.sent();
              if (!logger64) {
                return [2, response];
              }
              if (typeof logger64.info === "function") {
                _a2 = response.output, $metadata = _a2.$metadata, outputWithoutMetadata = __rest9(_a2, ["$metadata"]);
                logger64.info({
                  clientName,
                  commandName,
                  input: inputFilterSensitiveLog(args.input),
                  output: outputFilterSensitiveLog(outputWithoutMetadata),
                  metadata: $metadata
                });
              }
              return [2, response];
          }
        });
      });
    };
  };
};
var loggerMiddlewareOptions5 = {
  name: "loggerMiddleware",
  tags: ["LOGGER"],
  step: "initialize",
  override: true
};
var getLoggerPlugin5 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(loggerMiddleware5(), loggerMiddlewareOptions5);
    }
  };
};

// node_modules/@aws-sdk/middleware-sdk-s3/node_modules/tslib/tslib.es6.js
var __assign35 = function() {
  __assign35 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign35.apply(this, arguments);
};
function __awaiter58(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator59(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/middleware-sdk-s3/dist/es/validate-bucket-name.js
function validateBucketNameMiddleware() {
  var _this = this;
  return function(next) {
    return function(args) {
      return __awaiter58(_this, void 0, void 0, function() {
        var Bucket2, err;
        return __generator59(this, function(_a2) {
          Bucket2 = args.input.Bucket;
          if (typeof Bucket2 === "string" && !validate(Bucket2) && Bucket2.indexOf("/") >= 0) {
            err = new Error("Bucket name shouldn't contain '/', received '" + Bucket2 + "'");
            err.name = "InvalidBucketName";
            throw err;
          }
          return [2, next(__assign35({}, args))];
        });
      });
    };
  };
}
var validateBucketNameMiddlewareOptions = {
  step: "initialize",
  tags: ["VALIDATE_BUCKET_NAME"],
  name: "validateBucketNameMiddleware",
  override: true
};
var getValidateBucketNamePlugin = function(unused) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(validateBucketNameMiddleware(), validateBucketNameMiddlewareOptions);
    }
  };
};

// node_modules/@aws-sdk/middleware-sdk-s3/dist/es/use-regional-endpoint.js
var useRegionalEndpointMiddleware = function(config) {
  return function(next) {
    return function(args) {
      return __awaiter58(void 0, void 0, void 0, function() {
        var request, _a2;
        return __generator59(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              request = args.request;
              if (!HttpRequest.isInstance(request) || config.isCustomEndpoint)
                return [2, next(__assign35({}, args))];
              if (!(request.hostname === "s3.amazonaws.com"))
                return [3, 1];
              request.hostname = "s3.us-east-1.amazonaws.com";
              return [3, 3];
            case 1:
              _a2 = "aws-global";
              return [4, config.region()];
            case 2:
              if (_a2 === _b2.sent()) {
                request.hostname = "s3.amazonaws.com";
              }
              _b2.label = 3;
            case 3:
              return [2, next(__assign35({}, args))];
          }
        });
      });
    };
  };
};
var useRegionalEndpointMiddlewareOptions = {
  step: "build",
  tags: ["USE_REGIONAL_ENDPOINT", "S3"],
  name: "useRegionalEndpointMiddleware",
  override: true
};
var getUseRegionalEndpointPlugin = function(config) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(useRegionalEndpointMiddleware(config), useRegionalEndpointMiddlewareOptions);
    }
  };
};

// node_modules/@aws-sdk/middleware-sdk-s3/dist/es/throw-200-exceptions.js
var throw200ExceptionsMiddleware = function(config) {
  return function(next) {
    return function(args) {
      return __awaiter58(void 0, void 0, void 0, function() {
        var result, response, statusCode, body, bodyBytes, bodyString, err;
        return __generator59(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, next(args)];
            case 1:
              result = _a2.sent();
              response = result.response;
              if (!HttpResponse.isInstance(response))
                return [2, result];
              statusCode = response.statusCode, body = response.body;
              if (statusCode < 200 && statusCode >= 300)
                return [2, result];
              return [4, collectBody5(body, config)];
            case 2:
              bodyBytes = _a2.sent();
              return [4, collectBodyString5(bodyBytes, config)];
            case 3:
              bodyString = _a2.sent();
              if (bodyBytes.length === 0) {
                err = new Error("S3 aborted request");
                err.name = "InternalError";
                throw err;
              }
              if (bodyString && bodyString.match("<Error>")) {
                response.statusCode = 400;
              }
              response.body = bodyBytes;
              return [2, result];
          }
        });
      });
    };
  };
};
var collectBody5 = function(streamBody, context) {
  if (streamBody === void 0) {
    streamBody = new Uint8Array();
  }
  if (streamBody instanceof Uint8Array) {
    return Promise.resolve(streamBody);
  }
  return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
var collectBodyString5 = function(streamBody, context) {
  return collectBody5(streamBody, context).then(function(body) {
    return context.utf8Encoder(body);
  });
};
var throw200ExceptionsMiddlewareOptions = {
  relation: "after",
  toMiddleware: "deserializerMiddleware",
  tags: ["THROW_200_EXCEPTIONS", "S3"],
  name: "throw200ExceptionsMiddleware",
  override: true
};
var getThrow200ExceptionsPlugin = function(config) {
  return {
    applyToStack: function(clientStack) {
      clientStack.addRelativeTo(throw200ExceptionsMiddleware(config), throw200ExceptionsMiddlewareOptions);
    }
  };
};

// node_modules/@aws-sdk/client-s3/node_modules/@aws-sdk/middleware-signing/node_modules/tslib/tslib.es6.js
var __assign36 = function() {
  __assign36 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign36.apply(this, arguments);
};
function __awaiter59(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator60(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __read32(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}

// node_modules/@aws-sdk/client-s3/node_modules/@aws-sdk/middleware-signing/dist/es/configurations.js
function resolveAwsAuthConfig5(input) {
  var _this = this;
  var credentials = input.credentials || input.credentialDefaultProvider(input);
  var normalizedCreds = normalizeProvider5(credentials);
  var _a2 = input.signingEscapePath, signingEscapePath = _a2 === void 0 ? true : _a2, _b2 = input.systemClockOffset, systemClockOffset = _b2 === void 0 ? input.systemClockOffset || 0 : _b2, sha256 = input.sha256;
  var signer;
  if (input.signer) {
    signer = normalizeProvider5(input.signer);
  } else {
    signer = function() {
      return normalizeProvider5(input.region)().then(function(region) {
        return __awaiter59(_this, void 0, void 0, function() {
          return __generator60(this, function(_a3) {
            switch (_a3.label) {
              case 0:
                return [4, input.regionInfoProvider(region)];
              case 1:
                return [2, [_a3.sent() || {}, region]];
            }
          });
        });
      }).then(function(_a3) {
        var _b3 = __read32(_a3, 2), regionInfo = _b3[0], region = _b3[1];
        var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
        input.signingRegion = input.signingRegion || signingRegion || region;
        input.signingName = input.signingName || signingService || input.serviceId;
        return new SignatureV4({
          credentials: normalizedCreds,
          region: input.signingRegion,
          service: input.signingName,
          sha256,
          uriEscapePath: signingEscapePath
        });
      });
    };
  }
  return __assign36(__assign36({}, input), {
    systemClockOffset,
    signingEscapePath,
    credentials: normalizedCreds,
    signer
  });
}
function normalizeProvider5(input) {
  if (typeof input === "object") {
    var promisified_1 = Promise.resolve(input);
    return function() {
      return promisified_1;
    };
  }
  return input;
}

// node_modules/@aws-sdk/client-s3/node_modules/@aws-sdk/middleware-signing/dist/es/middleware.js
var isClockSkewed6 = function(newServerTime, systemClockOffset) {
  return Math.abs(getSkewCorrectedDate6(systemClockOffset).getTime() - newServerTime) >= 3e5;
};
var getSkewCorrectedDate6 = function(systemClockOffset) {
  return new Date(Date.now() + systemClockOffset);
};
function awsAuthMiddleware5(options) {
  return function(next, context) {
    return function(args) {
      return __awaiter59(this, void 0, void 0, function() {
        var signer, _a2, output, _b2, _c, headers, dateHeader, serverTime;
        var _d;
        return __generator60(this, function(_e) {
          switch (_e.label) {
            case 0:
              if (!HttpRequest.isInstance(args.request))
                return [2, next(args)];
              if (!(typeof options.signer === "function"))
                return [3, 2];
              return [4, options.signer()];
            case 1:
              _a2 = _e.sent();
              return [3, 3];
            case 2:
              _a2 = options.signer;
              _e.label = 3;
            case 3:
              signer = _a2;
              _b2 = next;
              _c = [__assign36({}, args)];
              _d = {};
              return [4, signer.sign(args.request, {
                signingDate: new Date(Date.now() + options.systemClockOffset),
                signingRegion: context["signing_region"],
                signingService: context["signing_service"]
              })];
            case 4:
              return [4, _b2.apply(void 0, [__assign36.apply(void 0, _c.concat([(_d.request = _e.sent(), _d)]))])];
            case 5:
              output = _e.sent();
              headers = output.response.headers;
              dateHeader = headers && (headers.date || headers.Date);
              if (dateHeader) {
                serverTime = Date.parse(dateHeader);
                if (isClockSkewed6(serverTime, options.systemClockOffset)) {
                  options.systemClockOffset = serverTime - Date.now();
                }
              }
              return [2, output];
          }
        });
      });
    };
  };
}
var awsAuthMiddlewareOptions5 = {
  name: "awsAuthMiddleware",
  tags: ["SIGNATURE", "AWSAUTH"],
  relation: "after",
  toMiddleware: "retryMiddleware",
  override: true
};
var getAwsAuthPlugin5 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.addRelativeTo(awsAuthMiddleware5(options), awsAuthMiddlewareOptions5);
    }
  };
};

// node_modules/@aws-sdk/client-s3/node_modules/@aws-sdk/middleware-user-agent/node_modules/tslib/tslib.es6.js
var __assign37 = function() {
  __assign37 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign37.apply(this, arguments);
};
function __awaiter60(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator61(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __read33(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}
function __spread13() {
  for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
    ar = ar.concat(__read33(arguments[i2]));
  return ar;
}

// node_modules/@aws-sdk/client-s3/node_modules/@aws-sdk/middleware-user-agent/dist/es/configurations.js
function resolveUserAgentConfig5(input) {
  return __assign37(__assign37({}, input), { customUserAgent: typeof input.customUserAgent === "string" ? [[input.customUserAgent]] : input.customUserAgent });
}

// node_modules/@aws-sdk/client-s3/node_modules/@aws-sdk/middleware-user-agent/dist/es/constants.js
var USER_AGENT5 = "user-agent";
var X_AMZ_USER_AGENT5 = "x-amz-user-agent";
var SPACE5 = " ";
var UA_ESCAPE_REGEX5 = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

// node_modules/@aws-sdk/client-s3/node_modules/@aws-sdk/middleware-user-agent/dist/es/user-agent-middleware.js
var userAgentMiddleware6 = function(options) {
  return function(next, context) {
    return function(args) {
      return __awaiter60(void 0, void 0, void 0, function() {
        var request, headers, userAgent2, defaultUserAgent8, customUserAgent, normalUAValue;
        var _a2, _b2;
        return __generator61(this, function(_c) {
          switch (_c.label) {
            case 0:
              request = args.request;
              if (!HttpRequest.isInstance(request))
                return [2, next(args)];
              headers = request.headers;
              userAgent2 = ((_a2 = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a2 === void 0 ? void 0 : _a2.map(escapeUserAgent5)) || [];
              return [4, options.defaultUserAgentProvider()];
            case 1:
              defaultUserAgent8 = _c.sent().map(escapeUserAgent5);
              customUserAgent = ((_b2 = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b2 === void 0 ? void 0 : _b2.map(escapeUserAgent5)) || [];
              headers[X_AMZ_USER_AGENT5] = __spread13(defaultUserAgent8, userAgent2, customUserAgent).join(SPACE5);
              normalUAValue = __spread13(defaultUserAgent8.filter(function(section) {
                return section.startsWith("aws-sdk-");
              }), customUserAgent).join(SPACE5);
              if (options.runtime !== "browser" && normalUAValue) {
                headers[USER_AGENT5] = headers[USER_AGENT5] ? headers[USER_AGENT5] + " " + normalUAValue : normalUAValue;
              }
              return [2, next(__assign37(__assign37({}, args), { request }))];
          }
        });
      });
    };
  };
};
var escapeUserAgent5 = function(_a2) {
  var _b2 = __read33(_a2, 2), name = _b2[0], version3 = _b2[1];
  var prefixSeparatorIndex = name.indexOf("/");
  var prefix = name.substring(0, prefixSeparatorIndex);
  var uaName = name.substring(prefixSeparatorIndex + 1);
  if (prefix === "api") {
    uaName = uaName.toLowerCase();
  }
  return [prefix, uaName, version3].filter(function(item) {
    return item && item.length > 0;
  }).map(function(item) {
    return item === null || item === void 0 ? void 0 : item.replace(UA_ESCAPE_REGEX5, "_");
  }).join("/");
};
var getUserAgentMiddlewareOptions5 = {
  name: "getUserAgentMiddleware",
  step: "build",
  priority: "low",
  tags: ["SET_USER_AGENT", "USER_AGENT"],
  override: true
};
var getUserAgentPlugin5 = function(config) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(userAgentMiddleware6(config), getUserAgentMiddlewareOptions5);
    }
  };
};

// node_modules/@aws-sdk/client-s3/dist/es/S3Client.js
var S3Client = (
  /** @class */
  function(_super) {
    __extends3(S3Client2, _super);
    function S3Client2(configuration) {
      var _this = this;
      var _config_0 = __assign7(__assign7({}, ClientDefaultValues5), configuration);
      var _config_1 = resolveRegionConfig(_config_0);
      var _config_2 = resolveEndpointsConfig(_config_1);
      var _config_3 = resolveAwsAuthConfig5(_config_2);
      var _config_4 = resolveRetryConfig(_config_3);
      var _config_5 = resolveHostHeaderConfig5(_config_4);
      var _config_6 = resolveBucketEndpointConfig(_config_5);
      var _config_7 = resolveUserAgentConfig5(_config_6);
      var _config_8 = resolveEventStreamSerdeConfig(_config_7);
      _this = _super.call(this, _config_8) || this;
      _this.config = _config_8;
      _this.middlewareStack.use(getAwsAuthPlugin5(_this.config));
      _this.middlewareStack.use(getRetryPlugin(_this.config));
      _this.middlewareStack.use(getContentLengthPlugin(_this.config));
      _this.middlewareStack.use(getHostHeaderPlugin5(_this.config));
      _this.middlewareStack.use(getLoggerPlugin5(_this.config));
      _this.middlewareStack.use(getValidateBucketNamePlugin(_this.config));
      _this.middlewareStack.use(getUseRegionalEndpointPlugin(_this.config));
      _this.middlewareStack.use(getAddExpectContinuePlugin(_this.config));
      _this.middlewareStack.use(getUserAgentPlugin5(_this.config));
      return _this;
    }
    S3Client2.prototype.destroy = function() {
      _super.prototype.destroy.call(this);
    };
    return S3Client2;
  }(Client)
);

// node_modules/@aws-sdk/client-s3/dist/es/models/models_0.js
var AbortIncompleteMultipartUpload;
(function(AbortIncompleteMultipartUpload2) {
  AbortIncompleteMultipartUpload2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(AbortIncompleteMultipartUpload || (AbortIncompleteMultipartUpload = {}));
var AbortMultipartUploadOutput;
(function(AbortMultipartUploadOutput2) {
  AbortMultipartUploadOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(AbortMultipartUploadOutput || (AbortMultipartUploadOutput = {}));
var AbortMultipartUploadRequest;
(function(AbortMultipartUploadRequest2) {
  AbortMultipartUploadRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(AbortMultipartUploadRequest || (AbortMultipartUploadRequest = {}));
var NoSuchUpload;
(function(NoSuchUpload2) {
  NoSuchUpload2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(NoSuchUpload || (NoSuchUpload = {}));
var AccelerateConfiguration;
(function(AccelerateConfiguration2) {
  AccelerateConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(AccelerateConfiguration || (AccelerateConfiguration = {}));
var Grantee;
(function(Grantee2) {
  Grantee2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Grantee || (Grantee = {}));
var Grant;
(function(Grant2) {
  Grant2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Grant || (Grant = {}));
var Owner;
(function(Owner2) {
  Owner2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Owner || (Owner = {}));
var AccessControlPolicy;
(function(AccessControlPolicy2) {
  AccessControlPolicy2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(AccessControlPolicy || (AccessControlPolicy = {}));
var AccessControlTranslation;
(function(AccessControlTranslation2) {
  AccessControlTranslation2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(AccessControlTranslation || (AccessControlTranslation = {}));
var CompleteMultipartUploadOutput;
(function(CompleteMultipartUploadOutput2) {
  CompleteMultipartUploadOutput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING });
  };
})(CompleteMultipartUploadOutput || (CompleteMultipartUploadOutput = {}));
var CompletedPart;
(function(CompletedPart2) {
  CompletedPart2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CompletedPart || (CompletedPart = {}));
var CompletedMultipartUpload;
(function(CompletedMultipartUpload2) {
  CompletedMultipartUpload2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CompletedMultipartUpload || (CompletedMultipartUpload = {}));
var CompleteMultipartUploadRequest;
(function(CompleteMultipartUploadRequest2) {
  CompleteMultipartUploadRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CompleteMultipartUploadRequest || (CompleteMultipartUploadRequest = {}));
var CopyObjectResult;
(function(CopyObjectResult2) {
  CopyObjectResult2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CopyObjectResult || (CopyObjectResult = {}));
var CopyObjectOutput;
(function(CopyObjectOutput2) {
  CopyObjectOutput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7(__assign7({}, obj), obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING }), obj.SSEKMSEncryptionContext && { SSEKMSEncryptionContext: SENSITIVE_STRING });
  };
})(CopyObjectOutput || (CopyObjectOutput = {}));
var CopyObjectRequest;
(function(CopyObjectRequest2) {
  CopyObjectRequest2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7(__assign7(__assign7(__assign7({}, obj), obj.SSECustomerKey && { SSECustomerKey: SENSITIVE_STRING }), obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING }), obj.SSEKMSEncryptionContext && { SSEKMSEncryptionContext: SENSITIVE_STRING }), obj.CopySourceSSECustomerKey && { CopySourceSSECustomerKey: SENSITIVE_STRING });
  };
})(CopyObjectRequest || (CopyObjectRequest = {}));
var ObjectNotInActiveTierError;
(function(ObjectNotInActiveTierError2) {
  ObjectNotInActiveTierError2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ObjectNotInActiveTierError || (ObjectNotInActiveTierError = {}));
var BucketAlreadyExists;
(function(BucketAlreadyExists2) {
  BucketAlreadyExists2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(BucketAlreadyExists || (BucketAlreadyExists = {}));
var BucketAlreadyOwnedByYou;
(function(BucketAlreadyOwnedByYou2) {
  BucketAlreadyOwnedByYou2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(BucketAlreadyOwnedByYou || (BucketAlreadyOwnedByYou = {}));
var CreateBucketOutput;
(function(CreateBucketOutput2) {
  CreateBucketOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CreateBucketOutput || (CreateBucketOutput = {}));
var CreateBucketConfiguration;
(function(CreateBucketConfiguration2) {
  CreateBucketConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CreateBucketConfiguration || (CreateBucketConfiguration = {}));
var CreateBucketRequest;
(function(CreateBucketRequest2) {
  CreateBucketRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CreateBucketRequest || (CreateBucketRequest = {}));
var CreateMultipartUploadOutput;
(function(CreateMultipartUploadOutput2) {
  CreateMultipartUploadOutput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7(__assign7({}, obj), obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING }), obj.SSEKMSEncryptionContext && { SSEKMSEncryptionContext: SENSITIVE_STRING });
  };
})(CreateMultipartUploadOutput || (CreateMultipartUploadOutput = {}));
var CreateMultipartUploadRequest;
(function(CreateMultipartUploadRequest2) {
  CreateMultipartUploadRequest2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7(__assign7(__assign7({}, obj), obj.SSECustomerKey && { SSECustomerKey: SENSITIVE_STRING }), obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING }), obj.SSEKMSEncryptionContext && { SSEKMSEncryptionContext: SENSITIVE_STRING });
  };
})(CreateMultipartUploadRequest || (CreateMultipartUploadRequest = {}));
var DeleteBucketRequest;
(function(DeleteBucketRequest2) {
  DeleteBucketRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteBucketRequest || (DeleteBucketRequest = {}));
var DeleteBucketAnalyticsConfigurationRequest;
(function(DeleteBucketAnalyticsConfigurationRequest2) {
  DeleteBucketAnalyticsConfigurationRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteBucketAnalyticsConfigurationRequest || (DeleteBucketAnalyticsConfigurationRequest = {}));
var DeleteBucketCorsRequest;
(function(DeleteBucketCorsRequest2) {
  DeleteBucketCorsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteBucketCorsRequest || (DeleteBucketCorsRequest = {}));
var DeleteBucketEncryptionRequest;
(function(DeleteBucketEncryptionRequest2) {
  DeleteBucketEncryptionRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteBucketEncryptionRequest || (DeleteBucketEncryptionRequest = {}));
var DeleteBucketIntelligentTieringConfigurationRequest;
(function(DeleteBucketIntelligentTieringConfigurationRequest2) {
  DeleteBucketIntelligentTieringConfigurationRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteBucketIntelligentTieringConfigurationRequest || (DeleteBucketIntelligentTieringConfigurationRequest = {}));
var DeleteBucketInventoryConfigurationRequest;
(function(DeleteBucketInventoryConfigurationRequest2) {
  DeleteBucketInventoryConfigurationRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteBucketInventoryConfigurationRequest || (DeleteBucketInventoryConfigurationRequest = {}));
var DeleteBucketLifecycleRequest;
(function(DeleteBucketLifecycleRequest2) {
  DeleteBucketLifecycleRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteBucketLifecycleRequest || (DeleteBucketLifecycleRequest = {}));
var DeleteBucketMetricsConfigurationRequest;
(function(DeleteBucketMetricsConfigurationRequest2) {
  DeleteBucketMetricsConfigurationRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteBucketMetricsConfigurationRequest || (DeleteBucketMetricsConfigurationRequest = {}));
var DeleteBucketOwnershipControlsRequest;
(function(DeleteBucketOwnershipControlsRequest2) {
  DeleteBucketOwnershipControlsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteBucketOwnershipControlsRequest || (DeleteBucketOwnershipControlsRequest = {}));
var DeleteBucketPolicyRequest;
(function(DeleteBucketPolicyRequest2) {
  DeleteBucketPolicyRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteBucketPolicyRequest || (DeleteBucketPolicyRequest = {}));
var DeleteBucketReplicationRequest;
(function(DeleteBucketReplicationRequest2) {
  DeleteBucketReplicationRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteBucketReplicationRequest || (DeleteBucketReplicationRequest = {}));
var DeleteBucketTaggingRequest;
(function(DeleteBucketTaggingRequest2) {
  DeleteBucketTaggingRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteBucketTaggingRequest || (DeleteBucketTaggingRequest = {}));
var DeleteBucketWebsiteRequest;
(function(DeleteBucketWebsiteRequest2) {
  DeleteBucketWebsiteRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteBucketWebsiteRequest || (DeleteBucketWebsiteRequest = {}));
var DeleteObjectOutput;
(function(DeleteObjectOutput2) {
  DeleteObjectOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteObjectOutput || (DeleteObjectOutput = {}));
var DeleteObjectRequest;
(function(DeleteObjectRequest2) {
  DeleteObjectRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteObjectRequest || (DeleteObjectRequest = {}));
var DeletedObject;
(function(DeletedObject2) {
  DeletedObject2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeletedObject || (DeletedObject = {}));
var _Error;
(function(_Error2) {
  _Error2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(_Error || (_Error = {}));
var DeleteObjectsOutput;
(function(DeleteObjectsOutput2) {
  DeleteObjectsOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteObjectsOutput || (DeleteObjectsOutput = {}));
var ObjectIdentifier;
(function(ObjectIdentifier2) {
  ObjectIdentifier2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ObjectIdentifier || (ObjectIdentifier = {}));
var Delete;
(function(Delete2) {
  Delete2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Delete || (Delete = {}));
var DeleteObjectsRequest;
(function(DeleteObjectsRequest2) {
  DeleteObjectsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteObjectsRequest || (DeleteObjectsRequest = {}));
var DeleteObjectTaggingOutput;
(function(DeleteObjectTaggingOutput2) {
  DeleteObjectTaggingOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteObjectTaggingOutput || (DeleteObjectTaggingOutput = {}));
var DeleteObjectTaggingRequest;
(function(DeleteObjectTaggingRequest2) {
  DeleteObjectTaggingRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteObjectTaggingRequest || (DeleteObjectTaggingRequest = {}));
var DeletePublicAccessBlockRequest;
(function(DeletePublicAccessBlockRequest2) {
  DeletePublicAccessBlockRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeletePublicAccessBlockRequest || (DeletePublicAccessBlockRequest = {}));
var GetBucketAccelerateConfigurationOutput;
(function(GetBucketAccelerateConfigurationOutput2) {
  GetBucketAccelerateConfigurationOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketAccelerateConfigurationOutput || (GetBucketAccelerateConfigurationOutput = {}));
var GetBucketAccelerateConfigurationRequest;
(function(GetBucketAccelerateConfigurationRequest2) {
  GetBucketAccelerateConfigurationRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketAccelerateConfigurationRequest || (GetBucketAccelerateConfigurationRequest = {}));
var GetBucketAclOutput;
(function(GetBucketAclOutput2) {
  GetBucketAclOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketAclOutput || (GetBucketAclOutput = {}));
var GetBucketAclRequest;
(function(GetBucketAclRequest2) {
  GetBucketAclRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketAclRequest || (GetBucketAclRequest = {}));
var Tag3;
(function(Tag4) {
  Tag4.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Tag3 || (Tag3 = {}));
var AnalyticsAndOperator;
(function(AnalyticsAndOperator2) {
  AnalyticsAndOperator2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(AnalyticsAndOperator || (AnalyticsAndOperator = {}));
var AnalyticsFilter;
(function(AnalyticsFilter2) {
  AnalyticsFilter2.visit = function(value, visitor) {
    if (value.Prefix !== void 0)
      return visitor.Prefix(value.Prefix);
    if (value.Tag !== void 0)
      return visitor.Tag(value.Tag);
    if (value.And !== void 0)
      return visitor.And(value.And);
    return visitor._(value.$unknown[0], value.$unknown[1]);
  };
  AnalyticsFilter2.filterSensitiveLog = function(obj) {
    var _a2;
    if (obj.Prefix !== void 0)
      return { Prefix: obj.Prefix };
    if (obj.Tag !== void 0)
      return { Tag: Tag3.filterSensitiveLog(obj.Tag) };
    if (obj.And !== void 0)
      return { And: AnalyticsAndOperator.filterSensitiveLog(obj.And) };
    if (obj.$unknown !== void 0)
      return _a2 = {}, _a2[obj.$unknown[0]] = "UNKNOWN", _a2;
  };
})(AnalyticsFilter || (AnalyticsFilter = {}));
var AnalyticsS3BucketDestination;
(function(AnalyticsS3BucketDestination2) {
  AnalyticsS3BucketDestination2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(AnalyticsS3BucketDestination || (AnalyticsS3BucketDestination = {}));
var AnalyticsExportDestination;
(function(AnalyticsExportDestination2) {
  AnalyticsExportDestination2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(AnalyticsExportDestination || (AnalyticsExportDestination = {}));
var StorageClassAnalysisDataExport;
(function(StorageClassAnalysisDataExport2) {
  StorageClassAnalysisDataExport2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(StorageClassAnalysisDataExport || (StorageClassAnalysisDataExport = {}));
var StorageClassAnalysis;
(function(StorageClassAnalysis2) {
  StorageClassAnalysis2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(StorageClassAnalysis || (StorageClassAnalysis = {}));
var AnalyticsConfiguration;
(function(AnalyticsConfiguration2) {
  AnalyticsConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.Filter && { Filter: AnalyticsFilter.filterSensitiveLog(obj.Filter) });
  };
})(AnalyticsConfiguration || (AnalyticsConfiguration = {}));
var GetBucketAnalyticsConfigurationOutput;
(function(GetBucketAnalyticsConfigurationOutput2) {
  GetBucketAnalyticsConfigurationOutput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.AnalyticsConfiguration && {
      AnalyticsConfiguration: AnalyticsConfiguration.filterSensitiveLog(obj.AnalyticsConfiguration)
    });
  };
})(GetBucketAnalyticsConfigurationOutput || (GetBucketAnalyticsConfigurationOutput = {}));
var GetBucketAnalyticsConfigurationRequest;
(function(GetBucketAnalyticsConfigurationRequest2) {
  GetBucketAnalyticsConfigurationRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketAnalyticsConfigurationRequest || (GetBucketAnalyticsConfigurationRequest = {}));
var CORSRule;
(function(CORSRule2) {
  CORSRule2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CORSRule || (CORSRule = {}));
var GetBucketCorsOutput;
(function(GetBucketCorsOutput2) {
  GetBucketCorsOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketCorsOutput || (GetBucketCorsOutput = {}));
var GetBucketCorsRequest;
(function(GetBucketCorsRequest2) {
  GetBucketCorsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketCorsRequest || (GetBucketCorsRequest = {}));
var ServerSideEncryptionByDefault;
(function(ServerSideEncryptionByDefault2) {
  ServerSideEncryptionByDefault2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.KMSMasterKeyID && { KMSMasterKeyID: SENSITIVE_STRING });
  };
})(ServerSideEncryptionByDefault || (ServerSideEncryptionByDefault = {}));
var ServerSideEncryptionRule;
(function(ServerSideEncryptionRule2) {
  ServerSideEncryptionRule2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.ApplyServerSideEncryptionByDefault && {
      ApplyServerSideEncryptionByDefault: ServerSideEncryptionByDefault.filterSensitiveLog(obj.ApplyServerSideEncryptionByDefault)
    });
  };
})(ServerSideEncryptionRule || (ServerSideEncryptionRule = {}));
var ServerSideEncryptionConfiguration;
(function(ServerSideEncryptionConfiguration2) {
  ServerSideEncryptionConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.Rules && { Rules: obj.Rules.map(function(item) {
      return ServerSideEncryptionRule.filterSensitiveLog(item);
    }) });
  };
})(ServerSideEncryptionConfiguration || (ServerSideEncryptionConfiguration = {}));
var GetBucketEncryptionOutput;
(function(GetBucketEncryptionOutput2) {
  GetBucketEncryptionOutput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.ServerSideEncryptionConfiguration && {
      ServerSideEncryptionConfiguration: ServerSideEncryptionConfiguration.filterSensitiveLog(obj.ServerSideEncryptionConfiguration)
    });
  };
})(GetBucketEncryptionOutput || (GetBucketEncryptionOutput = {}));
var GetBucketEncryptionRequest;
(function(GetBucketEncryptionRequest2) {
  GetBucketEncryptionRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketEncryptionRequest || (GetBucketEncryptionRequest = {}));
var IntelligentTieringAndOperator;
(function(IntelligentTieringAndOperator2) {
  IntelligentTieringAndOperator2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(IntelligentTieringAndOperator || (IntelligentTieringAndOperator = {}));
var IntelligentTieringFilter;
(function(IntelligentTieringFilter2) {
  IntelligentTieringFilter2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(IntelligentTieringFilter || (IntelligentTieringFilter = {}));
var Tiering;
(function(Tiering2) {
  Tiering2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Tiering || (Tiering = {}));
var IntelligentTieringConfiguration;
(function(IntelligentTieringConfiguration2) {
  IntelligentTieringConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(IntelligentTieringConfiguration || (IntelligentTieringConfiguration = {}));
var GetBucketIntelligentTieringConfigurationOutput;
(function(GetBucketIntelligentTieringConfigurationOutput2) {
  GetBucketIntelligentTieringConfigurationOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketIntelligentTieringConfigurationOutput || (GetBucketIntelligentTieringConfigurationOutput = {}));
var GetBucketIntelligentTieringConfigurationRequest;
(function(GetBucketIntelligentTieringConfigurationRequest2) {
  GetBucketIntelligentTieringConfigurationRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketIntelligentTieringConfigurationRequest || (GetBucketIntelligentTieringConfigurationRequest = {}));
var SSEKMS;
(function(SSEKMS2) {
  SSEKMS2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.KeyId && { KeyId: SENSITIVE_STRING });
  };
})(SSEKMS || (SSEKMS = {}));
var SSES3;
(function(SSES32) {
  SSES32.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(SSES3 || (SSES3 = {}));
var InventoryEncryption;
(function(InventoryEncryption2) {
  InventoryEncryption2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.SSEKMS && { SSEKMS: SSEKMS.filterSensitiveLog(obj.SSEKMS) });
  };
})(InventoryEncryption || (InventoryEncryption = {}));
var InventoryS3BucketDestination;
(function(InventoryS3BucketDestination2) {
  InventoryS3BucketDestination2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.Encryption && { Encryption: InventoryEncryption.filterSensitiveLog(obj.Encryption) });
  };
})(InventoryS3BucketDestination || (InventoryS3BucketDestination = {}));
var InventoryDestination;
(function(InventoryDestination2) {
  InventoryDestination2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.S3BucketDestination && {
      S3BucketDestination: InventoryS3BucketDestination.filterSensitiveLog(obj.S3BucketDestination)
    });
  };
})(InventoryDestination || (InventoryDestination = {}));
var InventoryFilter;
(function(InventoryFilter2) {
  InventoryFilter2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(InventoryFilter || (InventoryFilter = {}));
var InventorySchedule;
(function(InventorySchedule2) {
  InventorySchedule2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(InventorySchedule || (InventorySchedule = {}));
var InventoryConfiguration;
(function(InventoryConfiguration2) {
  InventoryConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.Destination && { Destination: InventoryDestination.filterSensitiveLog(obj.Destination) });
  };
})(InventoryConfiguration || (InventoryConfiguration = {}));
var GetBucketInventoryConfigurationOutput;
(function(GetBucketInventoryConfigurationOutput2) {
  GetBucketInventoryConfigurationOutput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.InventoryConfiguration && {
      InventoryConfiguration: InventoryConfiguration.filterSensitiveLog(obj.InventoryConfiguration)
    });
  };
})(GetBucketInventoryConfigurationOutput || (GetBucketInventoryConfigurationOutput = {}));
var GetBucketInventoryConfigurationRequest;
(function(GetBucketInventoryConfigurationRequest2) {
  GetBucketInventoryConfigurationRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketInventoryConfigurationRequest || (GetBucketInventoryConfigurationRequest = {}));
var LifecycleExpiration;
(function(LifecycleExpiration2) {
  LifecycleExpiration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(LifecycleExpiration || (LifecycleExpiration = {}));
var LifecycleRuleAndOperator;
(function(LifecycleRuleAndOperator2) {
  LifecycleRuleAndOperator2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(LifecycleRuleAndOperator || (LifecycleRuleAndOperator = {}));
var LifecycleRuleFilter;
(function(LifecycleRuleFilter2) {
  LifecycleRuleFilter2.visit = function(value, visitor) {
    if (value.Prefix !== void 0)
      return visitor.Prefix(value.Prefix);
    if (value.Tag !== void 0)
      return visitor.Tag(value.Tag);
    if (value.And !== void 0)
      return visitor.And(value.And);
    return visitor._(value.$unknown[0], value.$unknown[1]);
  };
  LifecycleRuleFilter2.filterSensitiveLog = function(obj) {
    var _a2;
    if (obj.Prefix !== void 0)
      return { Prefix: obj.Prefix };
    if (obj.Tag !== void 0)
      return { Tag: Tag3.filterSensitiveLog(obj.Tag) };
    if (obj.And !== void 0)
      return { And: LifecycleRuleAndOperator.filterSensitiveLog(obj.And) };
    if (obj.$unknown !== void 0)
      return _a2 = {}, _a2[obj.$unknown[0]] = "UNKNOWN", _a2;
  };
})(LifecycleRuleFilter || (LifecycleRuleFilter = {}));
var NoncurrentVersionExpiration;
(function(NoncurrentVersionExpiration2) {
  NoncurrentVersionExpiration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(NoncurrentVersionExpiration || (NoncurrentVersionExpiration = {}));
var NoncurrentVersionTransition;
(function(NoncurrentVersionTransition2) {
  NoncurrentVersionTransition2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(NoncurrentVersionTransition || (NoncurrentVersionTransition = {}));
var Transition;
(function(Transition2) {
  Transition2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Transition || (Transition = {}));
var LifecycleRule;
(function(LifecycleRule2) {
  LifecycleRule2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.Filter && { Filter: LifecycleRuleFilter.filterSensitiveLog(obj.Filter) });
  };
})(LifecycleRule || (LifecycleRule = {}));
var GetBucketLifecycleConfigurationOutput;
(function(GetBucketLifecycleConfigurationOutput2) {
  GetBucketLifecycleConfigurationOutput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.Rules && { Rules: obj.Rules.map(function(item) {
      return LifecycleRule.filterSensitiveLog(item);
    }) });
  };
})(GetBucketLifecycleConfigurationOutput || (GetBucketLifecycleConfigurationOutput = {}));
var GetBucketLifecycleConfigurationRequest;
(function(GetBucketLifecycleConfigurationRequest2) {
  GetBucketLifecycleConfigurationRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketLifecycleConfigurationRequest || (GetBucketLifecycleConfigurationRequest = {}));
var GetBucketLocationOutput;
(function(GetBucketLocationOutput2) {
  GetBucketLocationOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketLocationOutput || (GetBucketLocationOutput = {}));
var GetBucketLocationRequest;
(function(GetBucketLocationRequest2) {
  GetBucketLocationRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketLocationRequest || (GetBucketLocationRequest = {}));
var TargetGrant;
(function(TargetGrant2) {
  TargetGrant2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(TargetGrant || (TargetGrant = {}));
var LoggingEnabled;
(function(LoggingEnabled2) {
  LoggingEnabled2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(LoggingEnabled || (LoggingEnabled = {}));
var GetBucketLoggingOutput;
(function(GetBucketLoggingOutput2) {
  GetBucketLoggingOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketLoggingOutput || (GetBucketLoggingOutput = {}));
var GetBucketLoggingRequest;
(function(GetBucketLoggingRequest2) {
  GetBucketLoggingRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketLoggingRequest || (GetBucketLoggingRequest = {}));
var MetricsAndOperator;
(function(MetricsAndOperator2) {
  MetricsAndOperator2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(MetricsAndOperator || (MetricsAndOperator = {}));
var MetricsFilter;
(function(MetricsFilter2) {
  MetricsFilter2.visit = function(value, visitor) {
    if (value.Prefix !== void 0)
      return visitor.Prefix(value.Prefix);
    if (value.Tag !== void 0)
      return visitor.Tag(value.Tag);
    if (value.And !== void 0)
      return visitor.And(value.And);
    return visitor._(value.$unknown[0], value.$unknown[1]);
  };
  MetricsFilter2.filterSensitiveLog = function(obj) {
    var _a2;
    if (obj.Prefix !== void 0)
      return { Prefix: obj.Prefix };
    if (obj.Tag !== void 0)
      return { Tag: Tag3.filterSensitiveLog(obj.Tag) };
    if (obj.And !== void 0)
      return { And: MetricsAndOperator.filterSensitiveLog(obj.And) };
    if (obj.$unknown !== void 0)
      return _a2 = {}, _a2[obj.$unknown[0]] = "UNKNOWN", _a2;
  };
})(MetricsFilter || (MetricsFilter = {}));
var MetricsConfiguration;
(function(MetricsConfiguration2) {
  MetricsConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.Filter && { Filter: MetricsFilter.filterSensitiveLog(obj.Filter) });
  };
})(MetricsConfiguration || (MetricsConfiguration = {}));
var GetBucketMetricsConfigurationOutput;
(function(GetBucketMetricsConfigurationOutput2) {
  GetBucketMetricsConfigurationOutput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.MetricsConfiguration && {
      MetricsConfiguration: MetricsConfiguration.filterSensitiveLog(obj.MetricsConfiguration)
    });
  };
})(GetBucketMetricsConfigurationOutput || (GetBucketMetricsConfigurationOutput = {}));
var GetBucketMetricsConfigurationRequest;
(function(GetBucketMetricsConfigurationRequest2) {
  GetBucketMetricsConfigurationRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketMetricsConfigurationRequest || (GetBucketMetricsConfigurationRequest = {}));
var GetBucketNotificationConfigurationRequest;
(function(GetBucketNotificationConfigurationRequest2) {
  GetBucketNotificationConfigurationRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketNotificationConfigurationRequest || (GetBucketNotificationConfigurationRequest = {}));
var FilterRule;
(function(FilterRule2) {
  FilterRule2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(FilterRule || (FilterRule = {}));
var S3KeyFilter;
(function(S3KeyFilter2) {
  S3KeyFilter2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(S3KeyFilter || (S3KeyFilter = {}));
var NotificationConfigurationFilter;
(function(NotificationConfigurationFilter2) {
  NotificationConfigurationFilter2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(NotificationConfigurationFilter || (NotificationConfigurationFilter = {}));
var LambdaFunctionConfiguration;
(function(LambdaFunctionConfiguration2) {
  LambdaFunctionConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(LambdaFunctionConfiguration || (LambdaFunctionConfiguration = {}));
var QueueConfiguration;
(function(QueueConfiguration2) {
  QueueConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(QueueConfiguration || (QueueConfiguration = {}));
var TopicConfiguration;
(function(TopicConfiguration2) {
  TopicConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(TopicConfiguration || (TopicConfiguration = {}));
var NotificationConfiguration;
(function(NotificationConfiguration2) {
  NotificationConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(NotificationConfiguration || (NotificationConfiguration = {}));
var OwnershipControlsRule;
(function(OwnershipControlsRule2) {
  OwnershipControlsRule2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(OwnershipControlsRule || (OwnershipControlsRule = {}));
var OwnershipControls;
(function(OwnershipControls2) {
  OwnershipControls2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(OwnershipControls || (OwnershipControls = {}));
var GetBucketOwnershipControlsOutput;
(function(GetBucketOwnershipControlsOutput2) {
  GetBucketOwnershipControlsOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketOwnershipControlsOutput || (GetBucketOwnershipControlsOutput = {}));
var GetBucketOwnershipControlsRequest;
(function(GetBucketOwnershipControlsRequest2) {
  GetBucketOwnershipControlsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketOwnershipControlsRequest || (GetBucketOwnershipControlsRequest = {}));
var GetBucketPolicyOutput;
(function(GetBucketPolicyOutput2) {
  GetBucketPolicyOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketPolicyOutput || (GetBucketPolicyOutput = {}));
var GetBucketPolicyRequest;
(function(GetBucketPolicyRequest2) {
  GetBucketPolicyRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketPolicyRequest || (GetBucketPolicyRequest = {}));
var PolicyStatus;
(function(PolicyStatus2) {
  PolicyStatus2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PolicyStatus || (PolicyStatus = {}));
var GetBucketPolicyStatusOutput;
(function(GetBucketPolicyStatusOutput2) {
  GetBucketPolicyStatusOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketPolicyStatusOutput || (GetBucketPolicyStatusOutput = {}));
var GetBucketPolicyStatusRequest;
(function(GetBucketPolicyStatusRequest2) {
  GetBucketPolicyStatusRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketPolicyStatusRequest || (GetBucketPolicyStatusRequest = {}));
var DeleteMarkerReplication;
(function(DeleteMarkerReplication2) {
  DeleteMarkerReplication2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteMarkerReplication || (DeleteMarkerReplication = {}));
var EncryptionConfiguration2;
(function(EncryptionConfiguration3) {
  EncryptionConfiguration3.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(EncryptionConfiguration2 || (EncryptionConfiguration2 = {}));
var ReplicationTimeValue;
(function(ReplicationTimeValue2) {
  ReplicationTimeValue2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ReplicationTimeValue || (ReplicationTimeValue = {}));
var Metrics;
(function(Metrics2) {
  Metrics2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Metrics || (Metrics = {}));
var ReplicationTime;
(function(ReplicationTime2) {
  ReplicationTime2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ReplicationTime || (ReplicationTime = {}));
var Destination2;
(function(Destination3) {
  Destination3.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Destination2 || (Destination2 = {}));
var ExistingObjectReplication;
(function(ExistingObjectReplication2) {
  ExistingObjectReplication2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ExistingObjectReplication || (ExistingObjectReplication = {}));
var ReplicationRuleAndOperator;
(function(ReplicationRuleAndOperator2) {
  ReplicationRuleAndOperator2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ReplicationRuleAndOperator || (ReplicationRuleAndOperator = {}));
var ReplicationRuleFilter;
(function(ReplicationRuleFilter2) {
  ReplicationRuleFilter2.visit = function(value, visitor) {
    if (value.Prefix !== void 0)
      return visitor.Prefix(value.Prefix);
    if (value.Tag !== void 0)
      return visitor.Tag(value.Tag);
    if (value.And !== void 0)
      return visitor.And(value.And);
    return visitor._(value.$unknown[0], value.$unknown[1]);
  };
  ReplicationRuleFilter2.filterSensitiveLog = function(obj) {
    var _a2;
    if (obj.Prefix !== void 0)
      return { Prefix: obj.Prefix };
    if (obj.Tag !== void 0)
      return { Tag: Tag3.filterSensitiveLog(obj.Tag) };
    if (obj.And !== void 0)
      return { And: ReplicationRuleAndOperator.filterSensitiveLog(obj.And) };
    if (obj.$unknown !== void 0)
      return _a2 = {}, _a2[obj.$unknown[0]] = "UNKNOWN", _a2;
  };
})(ReplicationRuleFilter || (ReplicationRuleFilter = {}));
var ReplicaModifications;
(function(ReplicaModifications2) {
  ReplicaModifications2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ReplicaModifications || (ReplicaModifications = {}));
var SseKmsEncryptedObjects;
(function(SseKmsEncryptedObjects2) {
  SseKmsEncryptedObjects2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(SseKmsEncryptedObjects || (SseKmsEncryptedObjects = {}));
var SourceSelectionCriteria;
(function(SourceSelectionCriteria2) {
  SourceSelectionCriteria2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(SourceSelectionCriteria || (SourceSelectionCriteria = {}));
var ReplicationRule;
(function(ReplicationRule2) {
  ReplicationRule2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.Filter && { Filter: ReplicationRuleFilter.filterSensitiveLog(obj.Filter) });
  };
})(ReplicationRule || (ReplicationRule = {}));
var ReplicationConfiguration;
(function(ReplicationConfiguration2) {
  ReplicationConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.Rules && { Rules: obj.Rules.map(function(item) {
      return ReplicationRule.filterSensitiveLog(item);
    }) });
  };
})(ReplicationConfiguration || (ReplicationConfiguration = {}));
var GetBucketReplicationOutput;
(function(GetBucketReplicationOutput2) {
  GetBucketReplicationOutput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.ReplicationConfiguration && {
      ReplicationConfiguration: ReplicationConfiguration.filterSensitiveLog(obj.ReplicationConfiguration)
    });
  };
})(GetBucketReplicationOutput || (GetBucketReplicationOutput = {}));
var GetBucketReplicationRequest;
(function(GetBucketReplicationRequest2) {
  GetBucketReplicationRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketReplicationRequest || (GetBucketReplicationRequest = {}));
var GetBucketRequestPaymentOutput;
(function(GetBucketRequestPaymentOutput2) {
  GetBucketRequestPaymentOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketRequestPaymentOutput || (GetBucketRequestPaymentOutput = {}));
var GetBucketRequestPaymentRequest;
(function(GetBucketRequestPaymentRequest2) {
  GetBucketRequestPaymentRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketRequestPaymentRequest || (GetBucketRequestPaymentRequest = {}));
var GetBucketTaggingOutput;
(function(GetBucketTaggingOutput2) {
  GetBucketTaggingOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketTaggingOutput || (GetBucketTaggingOutput = {}));
var GetBucketTaggingRequest;
(function(GetBucketTaggingRequest2) {
  GetBucketTaggingRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketTaggingRequest || (GetBucketTaggingRequest = {}));
var GetBucketVersioningOutput;
(function(GetBucketVersioningOutput2) {
  GetBucketVersioningOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketVersioningOutput || (GetBucketVersioningOutput = {}));
var GetBucketVersioningRequest;
(function(GetBucketVersioningRequest2) {
  GetBucketVersioningRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketVersioningRequest || (GetBucketVersioningRequest = {}));
var ErrorDocument;
(function(ErrorDocument2) {
  ErrorDocument2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ErrorDocument || (ErrorDocument = {}));
var IndexDocument;
(function(IndexDocument2) {
  IndexDocument2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(IndexDocument || (IndexDocument = {}));
var RedirectAllRequestsTo;
(function(RedirectAllRequestsTo2) {
  RedirectAllRequestsTo2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(RedirectAllRequestsTo || (RedirectAllRequestsTo = {}));
var Condition;
(function(Condition2) {
  Condition2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Condition || (Condition = {}));
var Redirect;
(function(Redirect2) {
  Redirect2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Redirect || (Redirect = {}));
var RoutingRule;
(function(RoutingRule2) {
  RoutingRule2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(RoutingRule || (RoutingRule = {}));
var GetBucketWebsiteOutput;
(function(GetBucketWebsiteOutput2) {
  GetBucketWebsiteOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketWebsiteOutput || (GetBucketWebsiteOutput = {}));
var GetBucketWebsiteRequest;
(function(GetBucketWebsiteRequest2) {
  GetBucketWebsiteRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetBucketWebsiteRequest || (GetBucketWebsiteRequest = {}));
var GetObjectOutput;
(function(GetObjectOutput2) {
  GetObjectOutput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING });
  };
})(GetObjectOutput || (GetObjectOutput = {}));
var GetObjectRequest;
(function(GetObjectRequest2) {
  GetObjectRequest2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.SSECustomerKey && { SSECustomerKey: SENSITIVE_STRING });
  };
})(GetObjectRequest || (GetObjectRequest = {}));
var InvalidObjectState;
(function(InvalidObjectState2) {
  InvalidObjectState2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(InvalidObjectState || (InvalidObjectState = {}));
var NoSuchKey;
(function(NoSuchKey2) {
  NoSuchKey2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(NoSuchKey || (NoSuchKey = {}));
var GetObjectAclOutput;
(function(GetObjectAclOutput2) {
  GetObjectAclOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetObjectAclOutput || (GetObjectAclOutput = {}));
var GetObjectAclRequest;
(function(GetObjectAclRequest2) {
  GetObjectAclRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetObjectAclRequest || (GetObjectAclRequest = {}));
var ObjectLockLegalHold;
(function(ObjectLockLegalHold2) {
  ObjectLockLegalHold2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ObjectLockLegalHold || (ObjectLockLegalHold = {}));
var GetObjectLegalHoldOutput;
(function(GetObjectLegalHoldOutput2) {
  GetObjectLegalHoldOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetObjectLegalHoldOutput || (GetObjectLegalHoldOutput = {}));
var GetObjectLegalHoldRequest;
(function(GetObjectLegalHoldRequest2) {
  GetObjectLegalHoldRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetObjectLegalHoldRequest || (GetObjectLegalHoldRequest = {}));
var DefaultRetention;
(function(DefaultRetention2) {
  DefaultRetention2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DefaultRetention || (DefaultRetention = {}));
var ObjectLockRule;
(function(ObjectLockRule2) {
  ObjectLockRule2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ObjectLockRule || (ObjectLockRule = {}));
var ObjectLockConfiguration;
(function(ObjectLockConfiguration2) {
  ObjectLockConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ObjectLockConfiguration || (ObjectLockConfiguration = {}));
var GetObjectLockConfigurationOutput;
(function(GetObjectLockConfigurationOutput2) {
  GetObjectLockConfigurationOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetObjectLockConfigurationOutput || (GetObjectLockConfigurationOutput = {}));
var GetObjectLockConfigurationRequest;
(function(GetObjectLockConfigurationRequest2) {
  GetObjectLockConfigurationRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetObjectLockConfigurationRequest || (GetObjectLockConfigurationRequest = {}));
var ObjectLockRetention;
(function(ObjectLockRetention2) {
  ObjectLockRetention2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ObjectLockRetention || (ObjectLockRetention = {}));
var GetObjectRetentionOutput;
(function(GetObjectRetentionOutput2) {
  GetObjectRetentionOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetObjectRetentionOutput || (GetObjectRetentionOutput = {}));
var GetObjectRetentionRequest;
(function(GetObjectRetentionRequest2) {
  GetObjectRetentionRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetObjectRetentionRequest || (GetObjectRetentionRequest = {}));
var GetObjectTaggingOutput;
(function(GetObjectTaggingOutput2) {
  GetObjectTaggingOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetObjectTaggingOutput || (GetObjectTaggingOutput = {}));
var GetObjectTaggingRequest;
(function(GetObjectTaggingRequest2) {
  GetObjectTaggingRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetObjectTaggingRequest || (GetObjectTaggingRequest = {}));
var GetObjectTorrentOutput;
(function(GetObjectTorrentOutput2) {
  GetObjectTorrentOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetObjectTorrentOutput || (GetObjectTorrentOutput = {}));
var GetObjectTorrentRequest;
(function(GetObjectTorrentRequest2) {
  GetObjectTorrentRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetObjectTorrentRequest || (GetObjectTorrentRequest = {}));
var PublicAccessBlockConfiguration;
(function(PublicAccessBlockConfiguration2) {
  PublicAccessBlockConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PublicAccessBlockConfiguration || (PublicAccessBlockConfiguration = {}));
var GetPublicAccessBlockOutput;
(function(GetPublicAccessBlockOutput2) {
  GetPublicAccessBlockOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetPublicAccessBlockOutput || (GetPublicAccessBlockOutput = {}));
var GetPublicAccessBlockRequest;
(function(GetPublicAccessBlockRequest2) {
  GetPublicAccessBlockRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GetPublicAccessBlockRequest || (GetPublicAccessBlockRequest = {}));
var HeadBucketRequest;
(function(HeadBucketRequest2) {
  HeadBucketRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(HeadBucketRequest || (HeadBucketRequest = {}));
var NoSuchBucket;
(function(NoSuchBucket2) {
  NoSuchBucket2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(NoSuchBucket || (NoSuchBucket = {}));
var HeadObjectOutput;
(function(HeadObjectOutput2) {
  HeadObjectOutput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING });
  };
})(HeadObjectOutput || (HeadObjectOutput = {}));
var HeadObjectRequest;
(function(HeadObjectRequest2) {
  HeadObjectRequest2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.SSECustomerKey && { SSECustomerKey: SENSITIVE_STRING });
  };
})(HeadObjectRequest || (HeadObjectRequest = {}));
var ListBucketAnalyticsConfigurationsOutput;
(function(ListBucketAnalyticsConfigurationsOutput2) {
  ListBucketAnalyticsConfigurationsOutput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.AnalyticsConfigurationList && {
      AnalyticsConfigurationList: obj.AnalyticsConfigurationList.map(function(item) {
        return AnalyticsConfiguration.filterSensitiveLog(item);
      })
    });
  };
})(ListBucketAnalyticsConfigurationsOutput || (ListBucketAnalyticsConfigurationsOutput = {}));
var ListBucketAnalyticsConfigurationsRequest;
(function(ListBucketAnalyticsConfigurationsRequest2) {
  ListBucketAnalyticsConfigurationsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListBucketAnalyticsConfigurationsRequest || (ListBucketAnalyticsConfigurationsRequest = {}));
var ListBucketIntelligentTieringConfigurationsOutput;
(function(ListBucketIntelligentTieringConfigurationsOutput2) {
  ListBucketIntelligentTieringConfigurationsOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListBucketIntelligentTieringConfigurationsOutput || (ListBucketIntelligentTieringConfigurationsOutput = {}));
var ListBucketIntelligentTieringConfigurationsRequest;
(function(ListBucketIntelligentTieringConfigurationsRequest2) {
  ListBucketIntelligentTieringConfigurationsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListBucketIntelligentTieringConfigurationsRequest || (ListBucketIntelligentTieringConfigurationsRequest = {}));
var ListBucketInventoryConfigurationsOutput;
(function(ListBucketInventoryConfigurationsOutput2) {
  ListBucketInventoryConfigurationsOutput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.InventoryConfigurationList && {
      InventoryConfigurationList: obj.InventoryConfigurationList.map(function(item) {
        return InventoryConfiguration.filterSensitiveLog(item);
      })
    });
  };
})(ListBucketInventoryConfigurationsOutput || (ListBucketInventoryConfigurationsOutput = {}));
var ListBucketInventoryConfigurationsRequest;
(function(ListBucketInventoryConfigurationsRequest2) {
  ListBucketInventoryConfigurationsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListBucketInventoryConfigurationsRequest || (ListBucketInventoryConfigurationsRequest = {}));
var ListBucketMetricsConfigurationsOutput;
(function(ListBucketMetricsConfigurationsOutput2) {
  ListBucketMetricsConfigurationsOutput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.MetricsConfigurationList && {
      MetricsConfigurationList: obj.MetricsConfigurationList.map(function(item) {
        return MetricsConfiguration.filterSensitiveLog(item);
      })
    });
  };
})(ListBucketMetricsConfigurationsOutput || (ListBucketMetricsConfigurationsOutput = {}));
var ListBucketMetricsConfigurationsRequest;
(function(ListBucketMetricsConfigurationsRequest2) {
  ListBucketMetricsConfigurationsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListBucketMetricsConfigurationsRequest || (ListBucketMetricsConfigurationsRequest = {}));
var Bucket;
(function(Bucket2) {
  Bucket2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Bucket || (Bucket = {}));
var ListBucketsOutput;
(function(ListBucketsOutput2) {
  ListBucketsOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListBucketsOutput || (ListBucketsOutput = {}));
var CommonPrefix;
(function(CommonPrefix2) {
  CommonPrefix2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CommonPrefix || (CommonPrefix = {}));
var Initiator;
(function(Initiator2) {
  Initiator2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Initiator || (Initiator = {}));
var MultipartUpload;
(function(MultipartUpload2) {
  MultipartUpload2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(MultipartUpload || (MultipartUpload = {}));
var ListMultipartUploadsOutput;
(function(ListMultipartUploadsOutput2) {
  ListMultipartUploadsOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListMultipartUploadsOutput || (ListMultipartUploadsOutput = {}));
var ListMultipartUploadsRequest;
(function(ListMultipartUploadsRequest2) {
  ListMultipartUploadsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListMultipartUploadsRequest || (ListMultipartUploadsRequest = {}));
var _Object;
(function(_Object2) {
  _Object2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(_Object || (_Object = {}));
var ListObjectsOutput;
(function(ListObjectsOutput2) {
  ListObjectsOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListObjectsOutput || (ListObjectsOutput = {}));
var ListObjectsRequest;
(function(ListObjectsRequest2) {
  ListObjectsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListObjectsRequest || (ListObjectsRequest = {}));
var ListObjectsV2Output;
(function(ListObjectsV2Output2) {
  ListObjectsV2Output2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListObjectsV2Output || (ListObjectsV2Output = {}));
var ListObjectsV2Request;
(function(ListObjectsV2Request2) {
  ListObjectsV2Request2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListObjectsV2Request || (ListObjectsV2Request = {}));
var DeleteMarkerEntry;
(function(DeleteMarkerEntry2) {
  DeleteMarkerEntry2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(DeleteMarkerEntry || (DeleteMarkerEntry = {}));
var ObjectVersion;
(function(ObjectVersion2) {
  ObjectVersion2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ObjectVersion || (ObjectVersion = {}));
var ListObjectVersionsOutput;
(function(ListObjectVersionsOutput2) {
  ListObjectVersionsOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListObjectVersionsOutput || (ListObjectVersionsOutput = {}));
var ListObjectVersionsRequest;
(function(ListObjectVersionsRequest2) {
  ListObjectVersionsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListObjectVersionsRequest || (ListObjectVersionsRequest = {}));
var Part;
(function(Part2) {
  Part2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Part || (Part = {}));
var ListPartsOutput;
(function(ListPartsOutput2) {
  ListPartsOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListPartsOutput || (ListPartsOutput = {}));
var ListPartsRequest;
(function(ListPartsRequest2) {
  ListPartsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ListPartsRequest || (ListPartsRequest = {}));
var PutBucketAccelerateConfigurationRequest;
(function(PutBucketAccelerateConfigurationRequest2) {
  PutBucketAccelerateConfigurationRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutBucketAccelerateConfigurationRequest || (PutBucketAccelerateConfigurationRequest = {}));
var PutBucketAclRequest;
(function(PutBucketAclRequest2) {
  PutBucketAclRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutBucketAclRequest || (PutBucketAclRequest = {}));
var PutBucketAnalyticsConfigurationRequest;
(function(PutBucketAnalyticsConfigurationRequest2) {
  PutBucketAnalyticsConfigurationRequest2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.AnalyticsConfiguration && {
      AnalyticsConfiguration: AnalyticsConfiguration.filterSensitiveLog(obj.AnalyticsConfiguration)
    });
  };
})(PutBucketAnalyticsConfigurationRequest || (PutBucketAnalyticsConfigurationRequest = {}));
var CORSConfiguration;
(function(CORSConfiguration2) {
  CORSConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CORSConfiguration || (CORSConfiguration = {}));
var PutBucketCorsRequest;
(function(PutBucketCorsRequest2) {
  PutBucketCorsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutBucketCorsRequest || (PutBucketCorsRequest = {}));
var PutBucketEncryptionRequest;
(function(PutBucketEncryptionRequest2) {
  PutBucketEncryptionRequest2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.ServerSideEncryptionConfiguration && {
      ServerSideEncryptionConfiguration: ServerSideEncryptionConfiguration.filterSensitiveLog(obj.ServerSideEncryptionConfiguration)
    });
  };
})(PutBucketEncryptionRequest || (PutBucketEncryptionRequest = {}));
var PutBucketIntelligentTieringConfigurationRequest;
(function(PutBucketIntelligentTieringConfigurationRequest2) {
  PutBucketIntelligentTieringConfigurationRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutBucketIntelligentTieringConfigurationRequest || (PutBucketIntelligentTieringConfigurationRequest = {}));
var PutBucketInventoryConfigurationRequest;
(function(PutBucketInventoryConfigurationRequest2) {
  PutBucketInventoryConfigurationRequest2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.InventoryConfiguration && {
      InventoryConfiguration: InventoryConfiguration.filterSensitiveLog(obj.InventoryConfiguration)
    });
  };
})(PutBucketInventoryConfigurationRequest || (PutBucketInventoryConfigurationRequest = {}));
var BucketLifecycleConfiguration;
(function(BucketLifecycleConfiguration2) {
  BucketLifecycleConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.Rules && { Rules: obj.Rules.map(function(item) {
      return LifecycleRule.filterSensitiveLog(item);
    }) });
  };
})(BucketLifecycleConfiguration || (BucketLifecycleConfiguration = {}));
var PutBucketLifecycleConfigurationRequest;
(function(PutBucketLifecycleConfigurationRequest2) {
  PutBucketLifecycleConfigurationRequest2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.LifecycleConfiguration && {
      LifecycleConfiguration: BucketLifecycleConfiguration.filterSensitiveLog(obj.LifecycleConfiguration)
    });
  };
})(PutBucketLifecycleConfigurationRequest || (PutBucketLifecycleConfigurationRequest = {}));
var BucketLoggingStatus;
(function(BucketLoggingStatus2) {
  BucketLoggingStatus2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(BucketLoggingStatus || (BucketLoggingStatus = {}));
var PutBucketLoggingRequest;
(function(PutBucketLoggingRequest2) {
  PutBucketLoggingRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutBucketLoggingRequest || (PutBucketLoggingRequest = {}));
var PutBucketMetricsConfigurationRequest;
(function(PutBucketMetricsConfigurationRequest2) {
  PutBucketMetricsConfigurationRequest2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.MetricsConfiguration && {
      MetricsConfiguration: MetricsConfiguration.filterSensitiveLog(obj.MetricsConfiguration)
    });
  };
})(PutBucketMetricsConfigurationRequest || (PutBucketMetricsConfigurationRequest = {}));
var PutBucketNotificationConfigurationRequest;
(function(PutBucketNotificationConfigurationRequest2) {
  PutBucketNotificationConfigurationRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutBucketNotificationConfigurationRequest || (PutBucketNotificationConfigurationRequest = {}));
var PutBucketOwnershipControlsRequest;
(function(PutBucketOwnershipControlsRequest2) {
  PutBucketOwnershipControlsRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutBucketOwnershipControlsRequest || (PutBucketOwnershipControlsRequest = {}));
var PutBucketPolicyRequest;
(function(PutBucketPolicyRequest2) {
  PutBucketPolicyRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutBucketPolicyRequest || (PutBucketPolicyRequest = {}));
var PutBucketReplicationRequest;
(function(PutBucketReplicationRequest2) {
  PutBucketReplicationRequest2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.ReplicationConfiguration && {
      ReplicationConfiguration: ReplicationConfiguration.filterSensitiveLog(obj.ReplicationConfiguration)
    });
  };
})(PutBucketReplicationRequest || (PutBucketReplicationRequest = {}));
var RequestPaymentConfiguration;
(function(RequestPaymentConfiguration2) {
  RequestPaymentConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(RequestPaymentConfiguration || (RequestPaymentConfiguration = {}));
var PutBucketRequestPaymentRequest;
(function(PutBucketRequestPaymentRequest2) {
  PutBucketRequestPaymentRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutBucketRequestPaymentRequest || (PutBucketRequestPaymentRequest = {}));
var Tagging;
(function(Tagging2) {
  Tagging2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Tagging || (Tagging = {}));
var PutBucketTaggingRequest;
(function(PutBucketTaggingRequest2) {
  PutBucketTaggingRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutBucketTaggingRequest || (PutBucketTaggingRequest = {}));
var VersioningConfiguration;
(function(VersioningConfiguration2) {
  VersioningConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(VersioningConfiguration || (VersioningConfiguration = {}));
var PutBucketVersioningRequest;
(function(PutBucketVersioningRequest2) {
  PutBucketVersioningRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutBucketVersioningRequest || (PutBucketVersioningRequest = {}));
var WebsiteConfiguration;
(function(WebsiteConfiguration2) {
  WebsiteConfiguration2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(WebsiteConfiguration || (WebsiteConfiguration = {}));
var PutBucketWebsiteRequest;
(function(PutBucketWebsiteRequest2) {
  PutBucketWebsiteRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutBucketWebsiteRequest || (PutBucketWebsiteRequest = {}));
var PutObjectOutput;
(function(PutObjectOutput2) {
  PutObjectOutput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7(__assign7({}, obj), obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING }), obj.SSEKMSEncryptionContext && { SSEKMSEncryptionContext: SENSITIVE_STRING });
  };
})(PutObjectOutput || (PutObjectOutput = {}));
var PutObjectRequest;
(function(PutObjectRequest2) {
  PutObjectRequest2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7(__assign7(__assign7({}, obj), obj.SSECustomerKey && { SSECustomerKey: SENSITIVE_STRING }), obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING }), obj.SSEKMSEncryptionContext && { SSEKMSEncryptionContext: SENSITIVE_STRING });
  };
})(PutObjectRequest || (PutObjectRequest = {}));
var PutObjectAclOutput;
(function(PutObjectAclOutput2) {
  PutObjectAclOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutObjectAclOutput || (PutObjectAclOutput = {}));
var PutObjectAclRequest;
(function(PutObjectAclRequest2) {
  PutObjectAclRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutObjectAclRequest || (PutObjectAclRequest = {}));
var PutObjectLegalHoldOutput;
(function(PutObjectLegalHoldOutput2) {
  PutObjectLegalHoldOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutObjectLegalHoldOutput || (PutObjectLegalHoldOutput = {}));
var PutObjectLegalHoldRequest;
(function(PutObjectLegalHoldRequest2) {
  PutObjectLegalHoldRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutObjectLegalHoldRequest || (PutObjectLegalHoldRequest = {}));
var PutObjectLockConfigurationOutput;
(function(PutObjectLockConfigurationOutput2) {
  PutObjectLockConfigurationOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutObjectLockConfigurationOutput || (PutObjectLockConfigurationOutput = {}));
var PutObjectLockConfigurationRequest;
(function(PutObjectLockConfigurationRequest2) {
  PutObjectLockConfigurationRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutObjectLockConfigurationRequest || (PutObjectLockConfigurationRequest = {}));
var PutObjectRetentionOutput;
(function(PutObjectRetentionOutput2) {
  PutObjectRetentionOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutObjectRetentionOutput || (PutObjectRetentionOutput = {}));
var PutObjectRetentionRequest;
(function(PutObjectRetentionRequest2) {
  PutObjectRetentionRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutObjectRetentionRequest || (PutObjectRetentionRequest = {}));
var PutObjectTaggingOutput;
(function(PutObjectTaggingOutput2) {
  PutObjectTaggingOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutObjectTaggingOutput || (PutObjectTaggingOutput = {}));
var PutObjectTaggingRequest;
(function(PutObjectTaggingRequest2) {
  PutObjectTaggingRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutObjectTaggingRequest || (PutObjectTaggingRequest = {}));
var PutPublicAccessBlockRequest;
(function(PutPublicAccessBlockRequest2) {
  PutPublicAccessBlockRequest2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(PutPublicAccessBlockRequest || (PutPublicAccessBlockRequest = {}));
var ObjectAlreadyInActiveTierError;
(function(ObjectAlreadyInActiveTierError2) {
  ObjectAlreadyInActiveTierError2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ObjectAlreadyInActiveTierError || (ObjectAlreadyInActiveTierError = {}));
var RestoreObjectOutput;
(function(RestoreObjectOutput2) {
  RestoreObjectOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(RestoreObjectOutput || (RestoreObjectOutput = {}));
var GlacierJobParameters;
(function(GlacierJobParameters2) {
  GlacierJobParameters2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(GlacierJobParameters || (GlacierJobParameters = {}));
var Encryption;
(function(Encryption2) {
  Encryption2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.KMSKeyId && { KMSKeyId: SENSITIVE_STRING });
  };
})(Encryption || (Encryption = {}));

// node_modules/@aws-sdk/xml-builder/node_modules/tslib/tslib.es6.js
function __values14(o2) {
  var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
  if (m2)
    return m2.call(o2);
  if (o2 && typeof o2.length === "number")
    return {
      next: function() {
        if (o2 && i2 >= o2.length)
          o2 = void 0;
        return { value: o2 && o2[i2++], done: !o2 };
      }
    };
  throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

// node_modules/@aws-sdk/xml-builder/dist/es/escape-attribute.js
function escapeAttribute(value) {
  return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}

// node_modules/@aws-sdk/xml-builder/dist/es/XmlNode.js
var XmlNode = (
  /** @class */
  function() {
    function XmlNode2(name, children) {
      if (children === void 0) {
        children = [];
      }
      this.name = name;
      this.children = children;
      this.attributes = {};
    }
    XmlNode2.prototype.withName = function(name) {
      this.name = name;
      return this;
    };
    XmlNode2.prototype.addAttribute = function(name, value) {
      this.attributes[name] = value;
      return this;
    };
    XmlNode2.prototype.addChildNode = function(child) {
      this.children.push(child);
      return this;
    };
    XmlNode2.prototype.removeAttribute = function(name) {
      delete this.attributes[name];
      return this;
    };
    XmlNode2.prototype.toString = function() {
      var e_1, _a2;
      var hasChildren = Boolean(this.children.length);
      var xmlText = "<" + this.name;
      var attributes = this.attributes;
      try {
        for (var _b2 = __values14(Object.keys(attributes)), _c = _b2.next(); !_c.done; _c = _b2.next()) {
          var attributeName = _c.value;
          var attribute = attributes[attributeName];
          if (typeof attribute !== "undefined" && attribute !== null) {
            xmlText += " " + attributeName + '="' + escapeAttribute("" + attribute) + '"';
          }
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (_c && !_c.done && (_a2 = _b2.return))
            _a2.call(_b2);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
      return xmlText += !hasChildren ? "/>" : ">" + this.children.map(function(c2) {
        return c2.toString();
      }).join("") + "</" + this.name + ">";
    };
    return XmlNode2;
  }()
);

// node_modules/@aws-sdk/xml-builder/dist/es/escape-element.js
function escapeElement(value) {
  return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

// node_modules/@aws-sdk/xml-builder/dist/es/XmlText.js
var XmlText = (
  /** @class */
  function() {
    function XmlText2(value) {
      this.value = value;
    }
    XmlText2.prototype.toString = function() {
      return escapeElement("" + this.value);
    };
    return XmlText2;
  }()
);

// node_modules/@aws-sdk/client-s3/dist/es/xml-parser.js
var import_fast_xml_parser = __toESM(require_fxp());
var parser = new import_fast_xml_parser.XMLParser({
  attributeNamePrefix: "",
  htmlEntities: true,
  ignoreAttributes: false,
  ignoreDeclaration: true,
  parseTagValue: false,
  trimValues: false,
  tagValueProcessor: function(_2, val2) {
    return val2.trim() === "" && val2.includes("\n") ? "" : void 0;
  }
});
parser.addEntity("#xD", "\r");
parser.addEntity("#10", "\n");
var parse6 = function(encoded, ignored) {
  return parser.parse(encoded);
};

// node_modules/@aws-sdk/client-s3/dist/es/protocols/Aws_restXml.js
var serializeAws_restXmlAbortMultipartUploadCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var headers, resolvedPath3, labelValue, labelValue, query, body, _a2, hostname, _b2, protocol, port;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          headers = __assign7(__assign7({}, isSerializableHeaderValue(input.RequestPayer) && { "x-amz-request-payer": input.RequestPayer }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath3 = "/{Bucket}/{Key+}";
          if (input.Bucket !== void 0) {
            labelValue = input.Bucket;
            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }
            resolvedPath3 = resolvedPath3.replace("{Bucket}", extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }
          if (input.Key !== void 0) {
            labelValue = input.Key;
            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }
            resolvedPath3 = resolvedPath3.replace("{Key+}", labelValue.split("/").map(function(segment) {
              return extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }
          query = __assign7({ "x-id": "AbortMultipartUpload" }, input.UploadId !== void 0 && { uploadId: input.UploadId });
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port;
          return [2, new HttpRequest({
            protocol,
            hostname,
            port,
            method: "DELETE",
            headers,
            path: resolvedPath3,
            query,
            body
          })];
      }
    });
  });
};
var serializeAws_restXmlCompleteMultipartUploadCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var headers, resolvedPath3, labelValue, labelValue, query, body, contents, _a2, hostname, _b2, protocol, port;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          headers = __assign7(__assign7({ "content-type": "application/xml" }, isSerializableHeaderValue(input.RequestPayer) && { "x-amz-request-payer": input.RequestPayer }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath3 = "/{Bucket}/{Key+}";
          if (input.Bucket !== void 0) {
            labelValue = input.Bucket;
            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }
            resolvedPath3 = resolvedPath3.replace("{Bucket}", extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }
          if (input.Key !== void 0) {
            labelValue = input.Key;
            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }
            resolvedPath3 = resolvedPath3.replace("{Key+}", labelValue.split("/").map(function(segment) {
              return extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }
          query = __assign7({}, input.UploadId !== void 0 && { uploadId: input.UploadId });
          if (input.MultipartUpload !== void 0) {
            contents = serializeAws_restXmlCompletedMultipartUpload(input.MultipartUpload, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port;
          return [2, new HttpRequest({
            protocol,
            hostname,
            port,
            method: "POST",
            headers,
            path: resolvedPath3,
            query,
            body
          })];
      }
    });
  });
};
var serializeAws_restXmlCopyObjectCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var headers, resolvedPath3, labelValue, labelValue, query, body, _a2, hostname, _b2, protocol, port;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          headers = __assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7({}, isSerializableHeaderValue(input.ACL) && { "x-amz-acl": input.ACL }), isSerializableHeaderValue(input.CacheControl) && { "cache-control": input.CacheControl }), isSerializableHeaderValue(input.ContentDisposition) && { "content-disposition": input.ContentDisposition }), isSerializableHeaderValue(input.ContentEncoding) && { "content-encoding": input.ContentEncoding }), isSerializableHeaderValue(input.ContentLanguage) && { "content-language": input.ContentLanguage }), isSerializableHeaderValue(input.ContentType) && { "content-type": input.ContentType }), isSerializableHeaderValue(input.CopySource) && { "x-amz-copy-source": input.CopySource }), isSerializableHeaderValue(input.CopySourceIfMatch) && {
            "x-amz-copy-source-if-match": input.CopySourceIfMatch
          }), isSerializableHeaderValue(input.CopySourceIfModifiedSince) && {
            "x-amz-copy-source-if-modified-since": dateToUtcString(input.CopySourceIfModifiedSince).toString()
          }), isSerializableHeaderValue(input.CopySourceIfNoneMatch) && {
            "x-amz-copy-source-if-none-match": input.CopySourceIfNoneMatch
          }), isSerializableHeaderValue(input.CopySourceIfUnmodifiedSince) && {
            "x-amz-copy-source-if-unmodified-since": dateToUtcString(input.CopySourceIfUnmodifiedSince).toString()
          }), isSerializableHeaderValue(input.Expires) && { expires: dateToUtcString(input.Expires).toString() }), isSerializableHeaderValue(input.GrantFullControl) && { "x-amz-grant-full-control": input.GrantFullControl }), isSerializableHeaderValue(input.GrantRead) && { "x-amz-grant-read": input.GrantRead }), isSerializableHeaderValue(input.GrantReadACP) && { "x-amz-grant-read-acp": input.GrantReadACP }), isSerializableHeaderValue(input.GrantWriteACP) && { "x-amz-grant-write-acp": input.GrantWriteACP }), isSerializableHeaderValue(input.MetadataDirective) && { "x-amz-metadata-directive": input.MetadataDirective }), isSerializableHeaderValue(input.TaggingDirective) && { "x-amz-tagging-directive": input.TaggingDirective }), isSerializableHeaderValue(input.ServerSideEncryption) && {
            "x-amz-server-side-encryption": input.ServerSideEncryption
          }), isSerializableHeaderValue(input.StorageClass) && { "x-amz-storage-class": input.StorageClass }), isSerializableHeaderValue(input.WebsiteRedirectLocation) && {
            "x-amz-website-redirect-location": input.WebsiteRedirectLocation
          }), isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
            "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
          }), isSerializableHeaderValue(input.SSECustomerKey) && {
            "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
          }), isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
            "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
          }), isSerializableHeaderValue(input.SSEKMSKeyId) && {
            "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId
          }), isSerializableHeaderValue(input.SSEKMSEncryptionContext) && {
            "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext
          }), isSerializableHeaderValue(input.BucketKeyEnabled) && {
            "x-amz-server-side-encryption-bucket-key-enabled": input.BucketKeyEnabled.toString()
          }), isSerializableHeaderValue(input.CopySourceSSECustomerAlgorithm) && {
            "x-amz-copy-source-server-side-encryption-customer-algorithm": input.CopySourceSSECustomerAlgorithm
          }), isSerializableHeaderValue(input.CopySourceSSECustomerKey) && {
            "x-amz-copy-source-server-side-encryption-customer-key": input.CopySourceSSECustomerKey
          }), isSerializableHeaderValue(input.CopySourceSSECustomerKeyMD5) && {
            "x-amz-copy-source-server-side-encryption-customer-key-md5": input.CopySourceSSECustomerKeyMD5
          }), isSerializableHeaderValue(input.RequestPayer) && { "x-amz-request-payer": input.RequestPayer }), isSerializableHeaderValue(input.Tagging) && { "x-amz-tagging": input.Tagging }), isSerializableHeaderValue(input.ObjectLockMode) && { "x-amz-object-lock-mode": input.ObjectLockMode }), isSerializableHeaderValue(input.ObjectLockRetainUntilDate) && {
            "x-amz-object-lock-retain-until-date": (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
          }), isSerializableHeaderValue(input.ObjectLockLegalHoldStatus) && {
            "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.ExpectedSourceBucketOwner) && {
            "x-amz-source-expected-bucket-owner": input.ExpectedSourceBucketOwner
          }), input.Metadata !== void 0 && Object.keys(input.Metadata).reduce(function(acc, suffix) {
            var _a3;
            return __assign7(__assign7({}, acc), (_a3 = {}, _a3["x-amz-meta-" + suffix.toLowerCase()] = input.Metadata[suffix], _a3));
          }, {}));
          resolvedPath3 = "/{Bucket}/{Key+}";
          if (input.Bucket !== void 0) {
            labelValue = input.Bucket;
            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }
            resolvedPath3 = resolvedPath3.replace("{Bucket}", extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }
          if (input.Key !== void 0) {
            labelValue = input.Key;
            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }
            resolvedPath3 = resolvedPath3.replace("{Key+}", labelValue.split("/").map(function(segment) {
              return extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }
          query = {
            "x-id": "CopyObject"
          };
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port;
          return [2, new HttpRequest({
            protocol,
            hostname,
            port,
            method: "PUT",
            headers,
            path: resolvedPath3,
            query,
            body
          })];
      }
    });
  });
};
var serializeAws_restXmlCreateMultipartUploadCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var headers, resolvedPath3, labelValue, labelValue, query, body, _a2, hostname, _b2, protocol, port;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          headers = __assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7({}, isSerializableHeaderValue(input.ACL) && { "x-amz-acl": input.ACL }), isSerializableHeaderValue(input.CacheControl) && { "cache-control": input.CacheControl }), isSerializableHeaderValue(input.ContentDisposition) && { "content-disposition": input.ContentDisposition }), isSerializableHeaderValue(input.ContentEncoding) && { "content-encoding": input.ContentEncoding }), isSerializableHeaderValue(input.ContentLanguage) && { "content-language": input.ContentLanguage }), isSerializableHeaderValue(input.ContentType) && { "content-type": input.ContentType }), isSerializableHeaderValue(input.Expires) && { expires: dateToUtcString(input.Expires).toString() }), isSerializableHeaderValue(input.GrantFullControl) && { "x-amz-grant-full-control": input.GrantFullControl }), isSerializableHeaderValue(input.GrantRead) && { "x-amz-grant-read": input.GrantRead }), isSerializableHeaderValue(input.GrantReadACP) && { "x-amz-grant-read-acp": input.GrantReadACP }), isSerializableHeaderValue(input.GrantWriteACP) && { "x-amz-grant-write-acp": input.GrantWriteACP }), isSerializableHeaderValue(input.ServerSideEncryption) && {
            "x-amz-server-side-encryption": input.ServerSideEncryption
          }), isSerializableHeaderValue(input.StorageClass) && { "x-amz-storage-class": input.StorageClass }), isSerializableHeaderValue(input.WebsiteRedirectLocation) && {
            "x-amz-website-redirect-location": input.WebsiteRedirectLocation
          }), isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
            "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
          }), isSerializableHeaderValue(input.SSECustomerKey) && {
            "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
          }), isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
            "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
          }), isSerializableHeaderValue(input.SSEKMSKeyId) && {
            "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId
          }), isSerializableHeaderValue(input.SSEKMSEncryptionContext) && {
            "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext
          }), isSerializableHeaderValue(input.BucketKeyEnabled) && {
            "x-amz-server-side-encryption-bucket-key-enabled": input.BucketKeyEnabled.toString()
          }), isSerializableHeaderValue(input.RequestPayer) && { "x-amz-request-payer": input.RequestPayer }), isSerializableHeaderValue(input.Tagging) && { "x-amz-tagging": input.Tagging }), isSerializableHeaderValue(input.ObjectLockMode) && { "x-amz-object-lock-mode": input.ObjectLockMode }), isSerializableHeaderValue(input.ObjectLockRetainUntilDate) && {
            "x-amz-object-lock-retain-until-date": (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
          }), isSerializableHeaderValue(input.ObjectLockLegalHoldStatus) && {
            "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), input.Metadata !== void 0 && Object.keys(input.Metadata).reduce(function(acc, suffix) {
            var _a3;
            return __assign7(__assign7({}, acc), (_a3 = {}, _a3["x-amz-meta-" + suffix.toLowerCase()] = input.Metadata[suffix], _a3));
          }, {}));
          resolvedPath3 = "/{Bucket}/{Key+}";
          if (input.Bucket !== void 0) {
            labelValue = input.Bucket;
            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }
            resolvedPath3 = resolvedPath3.replace("{Bucket}", extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }
          if (input.Key !== void 0) {
            labelValue = input.Key;
            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }
            resolvedPath3 = resolvedPath3.replace("{Key+}", labelValue.split("/").map(function(segment) {
              return extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }
          query = {
            uploads: ""
          };
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port;
          return [2, new HttpRequest({
            protocol,
            hostname,
            port,
            method: "POST",
            headers,
            path: resolvedPath3,
            query,
            body
          })];
      }
    });
  });
};
var serializeAws_restXmlDeleteObjectCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var headers, resolvedPath3, labelValue, labelValue, query, body, _a2, hostname, _b2, protocol, port;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          headers = __assign7(__assign7(__assign7(__assign7({}, isSerializableHeaderValue(input.MFA) && { "x-amz-mfa": input.MFA }), isSerializableHeaderValue(input.RequestPayer) && { "x-amz-request-payer": input.RequestPayer }), isSerializableHeaderValue(input.BypassGovernanceRetention) && {
            "x-amz-bypass-governance-retention": input.BypassGovernanceRetention.toString()
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath3 = "/{Bucket}/{Key+}";
          if (input.Bucket !== void 0) {
            labelValue = input.Bucket;
            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }
            resolvedPath3 = resolvedPath3.replace("{Bucket}", extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }
          if (input.Key !== void 0) {
            labelValue = input.Key;
            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }
            resolvedPath3 = resolvedPath3.replace("{Key+}", labelValue.split("/").map(function(segment) {
              return extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }
          query = __assign7({ "x-id": "DeleteObject" }, input.VersionId !== void 0 && { versionId: input.VersionId });
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port;
          return [2, new HttpRequest({
            protocol,
            hostname,
            port,
            method: "DELETE",
            headers,
            path: resolvedPath3,
            query,
            body
          })];
      }
    });
  });
};
var serializeAws_restXmlGetObjectCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var headers, resolvedPath3, labelValue, labelValue, query, body, _a2, hostname, _b2, protocol, port;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          headers = __assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7({}, isSerializableHeaderValue(input.IfMatch) && { "if-match": input.IfMatch }), isSerializableHeaderValue(input.IfModifiedSince) && {
            "if-modified-since": dateToUtcString(input.IfModifiedSince).toString()
          }), isSerializableHeaderValue(input.IfNoneMatch) && { "if-none-match": input.IfNoneMatch }), isSerializableHeaderValue(input.IfUnmodifiedSince) && {
            "if-unmodified-since": dateToUtcString(input.IfUnmodifiedSince).toString()
          }), isSerializableHeaderValue(input.Range) && { range: input.Range }), isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
            "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
          }), isSerializableHeaderValue(input.SSECustomerKey) && {
            "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
          }), isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
            "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
          }), isSerializableHeaderValue(input.RequestPayer) && { "x-amz-request-payer": input.RequestPayer }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath3 = "/{Bucket}/{Key+}";
          if (input.Bucket !== void 0) {
            labelValue = input.Bucket;
            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }
            resolvedPath3 = resolvedPath3.replace("{Bucket}", extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }
          if (input.Key !== void 0) {
            labelValue = input.Key;
            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }
            resolvedPath3 = resolvedPath3.replace("{Key+}", labelValue.split("/").map(function(segment) {
              return extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }
          query = __assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7({ "x-id": "GetObject" }, input.ResponseCacheControl !== void 0 && { "response-cache-control": input.ResponseCacheControl }), input.ResponseContentDisposition !== void 0 && {
            "response-content-disposition": input.ResponseContentDisposition
          }), input.ResponseContentEncoding !== void 0 && { "response-content-encoding": input.ResponseContentEncoding }), input.ResponseContentLanguage !== void 0 && { "response-content-language": input.ResponseContentLanguage }), input.ResponseContentType !== void 0 && { "response-content-type": input.ResponseContentType }), input.ResponseExpires !== void 0 && {
            "response-expires": (input.ResponseExpires.toISOString().split(".")[0] + "Z").toString()
          }), input.VersionId !== void 0 && { versionId: input.VersionId }), input.PartNumber !== void 0 && { partNumber: input.PartNumber.toString() });
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port;
          return [2, new HttpRequest({
            protocol,
            hostname,
            port,
            method: "GET",
            headers,
            path: resolvedPath3,
            query,
            body
          })];
      }
    });
  });
};
var serializeAws_restXmlHeadObjectCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var headers, resolvedPath3, labelValue, labelValue, query, body, _a2, hostname, _b2, protocol, port;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          headers = __assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7({}, isSerializableHeaderValue(input.IfMatch) && { "if-match": input.IfMatch }), isSerializableHeaderValue(input.IfModifiedSince) && {
            "if-modified-since": dateToUtcString(input.IfModifiedSince).toString()
          }), isSerializableHeaderValue(input.IfNoneMatch) && { "if-none-match": input.IfNoneMatch }), isSerializableHeaderValue(input.IfUnmodifiedSince) && {
            "if-unmodified-since": dateToUtcString(input.IfUnmodifiedSince).toString()
          }), isSerializableHeaderValue(input.Range) && { range: input.Range }), isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
            "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
          }), isSerializableHeaderValue(input.SSECustomerKey) && {
            "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
          }), isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
            "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
          }), isSerializableHeaderValue(input.RequestPayer) && { "x-amz-request-payer": input.RequestPayer }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath3 = "/{Bucket}/{Key+}";
          if (input.Bucket !== void 0) {
            labelValue = input.Bucket;
            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }
            resolvedPath3 = resolvedPath3.replace("{Bucket}", extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }
          if (input.Key !== void 0) {
            labelValue = input.Key;
            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }
            resolvedPath3 = resolvedPath3.replace("{Key+}", labelValue.split("/").map(function(segment) {
              return extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }
          query = __assign7(__assign7({}, input.VersionId !== void 0 && { versionId: input.VersionId }), input.PartNumber !== void 0 && { partNumber: input.PartNumber.toString() });
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port;
          return [2, new HttpRequest({
            protocol,
            hostname,
            port,
            method: "HEAD",
            headers,
            path: resolvedPath3,
            query,
            body
          })];
      }
    });
  });
};
var serializeAws_restXmlListObjectsV2Command = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var headers, resolvedPath3, labelValue, query, body, _a2, hostname, _b2, protocol, port;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          headers = __assign7(__assign7({}, isSerializableHeaderValue(input.RequestPayer) && { "x-amz-request-payer": input.RequestPayer }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath3 = "/{Bucket}";
          if (input.Bucket !== void 0) {
            labelValue = input.Bucket;
            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }
            resolvedPath3 = resolvedPath3.replace("{Bucket}", extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }
          query = __assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7({ "list-type": "2" }, input.Delimiter !== void 0 && { delimiter: input.Delimiter }), input.EncodingType !== void 0 && { "encoding-type": input.EncodingType }), input.MaxKeys !== void 0 && { "max-keys": input.MaxKeys.toString() }), input.Prefix !== void 0 && { prefix: input.Prefix }), input.ContinuationToken !== void 0 && { "continuation-token": input.ContinuationToken }), input.FetchOwner !== void 0 && { "fetch-owner": input.FetchOwner.toString() }), input.StartAfter !== void 0 && { "start-after": input.StartAfter });
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port;
          return [2, new HttpRequest({
            protocol,
            hostname,
            port,
            method: "GET",
            headers,
            path: resolvedPath3,
            query,
            body
          })];
      }
    });
  });
};
var serializeAws_restXmlListPartsCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var headers, resolvedPath3, labelValue, labelValue, query, body, _a2, hostname, _b2, protocol, port;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          headers = __assign7(__assign7({}, isSerializableHeaderValue(input.RequestPayer) && { "x-amz-request-payer": input.RequestPayer }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath3 = "/{Bucket}/{Key+}";
          if (input.Bucket !== void 0) {
            labelValue = input.Bucket;
            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }
            resolvedPath3 = resolvedPath3.replace("{Bucket}", extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }
          if (input.Key !== void 0) {
            labelValue = input.Key;
            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }
            resolvedPath3 = resolvedPath3.replace("{Key+}", labelValue.split("/").map(function(segment) {
              return extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }
          query = __assign7(__assign7(__assign7({ "x-id": "ListParts" }, input.MaxParts !== void 0 && { "max-parts": input.MaxParts.toString() }), input.PartNumberMarker !== void 0 && { "part-number-marker": input.PartNumberMarker }), input.UploadId !== void 0 && { uploadId: input.UploadId });
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port;
          return [2, new HttpRequest({
            protocol,
            hostname,
            port,
            method: "GET",
            headers,
            path: resolvedPath3,
            query,
            body
          })];
      }
    });
  });
};
var serializeAws_restXmlPutObjectCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var headers, resolvedPath3, labelValue, labelValue, query, body, contents, _a2, hostname, _b2, protocol, port;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          headers = __assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7({ "content-type": "application/octet-stream" }, isSerializableHeaderValue(input.ACL) && { "x-amz-acl": input.ACL }), isSerializableHeaderValue(input.CacheControl) && { "cache-control": input.CacheControl }), isSerializableHeaderValue(input.ContentDisposition) && { "content-disposition": input.ContentDisposition }), isSerializableHeaderValue(input.ContentEncoding) && { "content-encoding": input.ContentEncoding }), isSerializableHeaderValue(input.ContentLanguage) && { "content-language": input.ContentLanguage }), isSerializableHeaderValue(input.ContentLength) && { "content-length": input.ContentLength.toString() }), isSerializableHeaderValue(input.ContentMD5) && { "content-md5": input.ContentMD5 }), isSerializableHeaderValue(input.ContentType) && { "content-type": input.ContentType }), isSerializableHeaderValue(input.Expires) && { expires: dateToUtcString(input.Expires).toString() }), isSerializableHeaderValue(input.GrantFullControl) && { "x-amz-grant-full-control": input.GrantFullControl }), isSerializableHeaderValue(input.GrantRead) && { "x-amz-grant-read": input.GrantRead }), isSerializableHeaderValue(input.GrantReadACP) && { "x-amz-grant-read-acp": input.GrantReadACP }), isSerializableHeaderValue(input.GrantWriteACP) && { "x-amz-grant-write-acp": input.GrantWriteACP }), isSerializableHeaderValue(input.ServerSideEncryption) && {
            "x-amz-server-side-encryption": input.ServerSideEncryption
          }), isSerializableHeaderValue(input.StorageClass) && { "x-amz-storage-class": input.StorageClass }), isSerializableHeaderValue(input.WebsiteRedirectLocation) && {
            "x-amz-website-redirect-location": input.WebsiteRedirectLocation
          }), isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
            "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
          }), isSerializableHeaderValue(input.SSECustomerKey) && {
            "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
          }), isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
            "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
          }), isSerializableHeaderValue(input.SSEKMSKeyId) && {
            "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId
          }), isSerializableHeaderValue(input.SSEKMSEncryptionContext) && {
            "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext
          }), isSerializableHeaderValue(input.BucketKeyEnabled) && {
            "x-amz-server-side-encryption-bucket-key-enabled": input.BucketKeyEnabled.toString()
          }), isSerializableHeaderValue(input.RequestPayer) && { "x-amz-request-payer": input.RequestPayer }), isSerializableHeaderValue(input.Tagging) && { "x-amz-tagging": input.Tagging }), isSerializableHeaderValue(input.ObjectLockMode) && { "x-amz-object-lock-mode": input.ObjectLockMode }), isSerializableHeaderValue(input.ObjectLockRetainUntilDate) && {
            "x-amz-object-lock-retain-until-date": (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
          }), isSerializableHeaderValue(input.ObjectLockLegalHoldStatus) && {
            "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), input.Metadata !== void 0 && Object.keys(input.Metadata).reduce(function(acc, suffix) {
            var _a3;
            return __assign7(__assign7({}, acc), (_a3 = {}, _a3["x-amz-meta-" + suffix.toLowerCase()] = input.Metadata[suffix], _a3));
          }, {}));
          resolvedPath3 = "/{Bucket}/{Key+}";
          if (input.Bucket !== void 0) {
            labelValue = input.Bucket;
            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }
            resolvedPath3 = resolvedPath3.replace("{Bucket}", extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }
          if (input.Key !== void 0) {
            labelValue = input.Key;
            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }
            resolvedPath3 = resolvedPath3.replace("{Key+}", labelValue.split("/").map(function(segment) {
              return extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }
          query = {
            "x-id": "PutObject"
          };
          if (input.Body !== void 0) {
            contents = input.Body;
            body = contents;
          }
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port;
          return [2, new HttpRequest({
            protocol,
            hostname,
            port,
            method: "PUT",
            headers,
            path: resolvedPath3,
            query,
            body
          })];
      }
    });
  });
};
var serializeAws_restXmlUploadPartCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var headers, resolvedPath3, labelValue, labelValue, query, body, contents, _a2, hostname, _b2, protocol, port;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          headers = __assign7(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7({ "content-type": "application/octet-stream" }, isSerializableHeaderValue(input.ContentLength) && { "content-length": input.ContentLength.toString() }), isSerializableHeaderValue(input.ContentMD5) && { "content-md5": input.ContentMD5 }), isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
            "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
          }), isSerializableHeaderValue(input.SSECustomerKey) && {
            "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
          }), isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
            "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
          }), isSerializableHeaderValue(input.RequestPayer) && { "x-amz-request-payer": input.RequestPayer }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath3 = "/{Bucket}/{Key+}";
          if (input.Bucket !== void 0) {
            labelValue = input.Bucket;
            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }
            resolvedPath3 = resolvedPath3.replace("{Bucket}", extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }
          if (input.Key !== void 0) {
            labelValue = input.Key;
            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }
            resolvedPath3 = resolvedPath3.replace("{Key+}", labelValue.split("/").map(function(segment) {
              return extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }
          query = __assign7(__assign7({ "x-id": "UploadPart" }, input.PartNumber !== void 0 && { partNumber: input.PartNumber.toString() }), input.UploadId !== void 0 && { uploadId: input.UploadId });
          if (input.Body !== void 0) {
            contents = input.Body;
            body = contents;
          }
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port;
          return [2, new HttpRequest({
            protocol,
            hostname,
            port,
            method: "PUT",
            headers,
            path: resolvedPath3,
            query,
            body
          })];
      }
    });
  });
};
var deserializeAws_restXmlAbortMultipartUploadCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (output.statusCode !== 204 && output.statusCode >= 300) {
            return [2, deserializeAws_restXmlAbortMultipartUploadCommandError(output, context)];
          }
          contents = {
            $metadata: deserializeMetadata5(output),
            RequestCharged: void 0
          };
          if (output.headers["x-amz-request-charged"] !== void 0) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }
          return [4, collectBody6(output.body, context)];
        case 1:
          _a2.sent();
          return [2, Promise.resolve(contents)];
      }
    });
  });
};
var deserializeAws_restXmlAbortMultipartUploadCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, response, errorCode, _b2, _c, parsedBody, message;
    var _d;
    return __generator3(this, function(_e) {
      switch (_e.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _d = {};
          return [4, parseBody5(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_d.body = _e.sent(), _d)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "NoSuchUpload":
              return [3, 2];
            case "com.amazonaws.s3#NoSuchUpload":
              return [3, 2];
          }
          return [3, 4];
        case 2:
          _c = [{}];
          return [4, deserializeAws_restXmlNoSuchUploadResponse(parsedOutput, context)];
        case 3:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _c.concat([_e.sent()])), { name: errorCode, $metadata: deserializeMetadata5(output) }]);
          return [3, 5];
        case 4:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign7(__assign7({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata5(output) });
          _e.label = 5;
        case 5:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2, Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};
var deserializeAws_restXmlCompleteMultipartUploadCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2, deserializeAws_restXmlCompleteMultipartUploadCommandError(output, context)];
          }
          contents = {
            $metadata: deserializeMetadata5(output),
            Bucket: void 0,
            BucketKeyEnabled: void 0,
            ETag: void 0,
            Expiration: void 0,
            Key: void 0,
            Location: void 0,
            RequestCharged: void 0,
            SSEKMSKeyId: void 0,
            ServerSideEncryption: void 0,
            VersionId: void 0
          };
          if (output.headers["x-amz-expiration"] !== void 0) {
            contents.Expiration = output.headers["x-amz-expiration"];
          }
          if (output.headers["x-amz-server-side-encryption"] !== void 0) {
            contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
          }
          if (output.headers["x-amz-version-id"] !== void 0) {
            contents.VersionId = output.headers["x-amz-version-id"];
          }
          if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== void 0) {
            contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
          }
          if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== void 0) {
            contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
          }
          if (output.headers["x-amz-request-charged"] !== void 0) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }
          return [4, parseBody5(output.body, context)];
        case 1:
          data = _a2.sent();
          if (data["Bucket"] !== void 0) {
            contents.Bucket = data["Bucket"];
          }
          if (data["ETag"] !== void 0) {
            contents.ETag = data["ETag"];
          }
          if (data["Key"] !== void 0) {
            contents.Key = data["Key"];
          }
          if (data["Location"] !== void 0) {
            contents.Location = data["Location"];
          }
          return [2, Promise.resolve(contents)];
      }
    });
  });
};
var deserializeAws_restXmlCompleteMultipartUploadCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, response, errorCode, parsedBody, message;
    var _b2;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _b2 = {};
          return [4, parseBody5(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_b2.body = _c.sent(), _b2)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign7(__assign7({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata5(output) });
          }
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2, Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};
var deserializeAws_restXmlCopyObjectCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2, deserializeAws_restXmlCopyObjectCommandError(output, context)];
          }
          contents = {
            $metadata: deserializeMetadata5(output),
            BucketKeyEnabled: void 0,
            CopyObjectResult: void 0,
            CopySourceVersionId: void 0,
            Expiration: void 0,
            RequestCharged: void 0,
            SSECustomerAlgorithm: void 0,
            SSECustomerKeyMD5: void 0,
            SSEKMSEncryptionContext: void 0,
            SSEKMSKeyId: void 0,
            ServerSideEncryption: void 0,
            VersionId: void 0
          };
          if (output.headers["x-amz-expiration"] !== void 0) {
            contents.Expiration = output.headers["x-amz-expiration"];
          }
          if (output.headers["x-amz-copy-source-version-id"] !== void 0) {
            contents.CopySourceVersionId = output.headers["x-amz-copy-source-version-id"];
          }
          if (output.headers["x-amz-version-id"] !== void 0) {
            contents.VersionId = output.headers["x-amz-version-id"];
          }
          if (output.headers["x-amz-server-side-encryption"] !== void 0) {
            contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
          }
          if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== void 0) {
            contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
          }
          if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== void 0) {
            contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
          }
          if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== void 0) {
            contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
          }
          if (output.headers["x-amz-server-side-encryption-context"] !== void 0) {
            contents.SSEKMSEncryptionContext = output.headers["x-amz-server-side-encryption-context"];
          }
          if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== void 0) {
            contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
          }
          if (output.headers["x-amz-request-charged"] !== void 0) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }
          return [4, parseBody5(output.body, context)];
        case 1:
          data = _a2.sent();
          contents.CopyObjectResult = deserializeAws_restXmlCopyObjectResult(data, context);
          return [2, Promise.resolve(contents)];
      }
    });
  });
};
var deserializeAws_restXmlCopyObjectCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, response, errorCode, _b2, _c, parsedBody, message;
    var _d;
    return __generator3(this, function(_e) {
      switch (_e.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _d = {};
          return [4, parseBody5(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_d.body = _e.sent(), _d)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "ObjectNotInActiveTierError":
              return [3, 2];
            case "com.amazonaws.s3#ObjectNotInActiveTierError":
              return [3, 2];
          }
          return [3, 4];
        case 2:
          _c = [{}];
          return [4, deserializeAws_restXmlObjectNotInActiveTierErrorResponse(parsedOutput, context)];
        case 3:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _c.concat([_e.sent()])), { name: errorCode, $metadata: deserializeMetadata5(output) }]);
          return [3, 5];
        case 4:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign7(__assign7({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata5(output) });
          _e.label = 5;
        case 5:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2, Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};
var deserializeAws_restXmlCreateMultipartUploadCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2, deserializeAws_restXmlCreateMultipartUploadCommandError(output, context)];
          }
          contents = {
            $metadata: deserializeMetadata5(output),
            AbortDate: void 0,
            AbortRuleId: void 0,
            Bucket: void 0,
            BucketKeyEnabled: void 0,
            Key: void 0,
            RequestCharged: void 0,
            SSECustomerAlgorithm: void 0,
            SSECustomerKeyMD5: void 0,
            SSEKMSEncryptionContext: void 0,
            SSEKMSKeyId: void 0,
            ServerSideEncryption: void 0,
            UploadId: void 0
          };
          if (output.headers["x-amz-abort-date"] !== void 0) {
            contents.AbortDate = new Date(output.headers["x-amz-abort-date"]);
          }
          if (output.headers["x-amz-abort-rule-id"] !== void 0) {
            contents.AbortRuleId = output.headers["x-amz-abort-rule-id"];
          }
          if (output.headers["x-amz-server-side-encryption"] !== void 0) {
            contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
          }
          if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== void 0) {
            contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
          }
          if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== void 0) {
            contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
          }
          if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== void 0) {
            contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
          }
          if (output.headers["x-amz-server-side-encryption-context"] !== void 0) {
            contents.SSEKMSEncryptionContext = output.headers["x-amz-server-side-encryption-context"];
          }
          if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== void 0) {
            contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
          }
          if (output.headers["x-amz-request-charged"] !== void 0) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }
          return [4, parseBody5(output.body, context)];
        case 1:
          data = _a2.sent();
          if (data["Bucket"] !== void 0) {
            contents.Bucket = data["Bucket"];
          }
          if (data["Key"] !== void 0) {
            contents.Key = data["Key"];
          }
          if (data["UploadId"] !== void 0) {
            contents.UploadId = data["UploadId"];
          }
          return [2, Promise.resolve(contents)];
      }
    });
  });
};
var deserializeAws_restXmlCreateMultipartUploadCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, response, errorCode, parsedBody, message;
    var _b2;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _b2 = {};
          return [4, parseBody5(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_b2.body = _c.sent(), _b2)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign7(__assign7({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata5(output) });
          }
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2, Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};
var deserializeAws_restXmlDeleteObjectCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (output.statusCode !== 204 && output.statusCode >= 300) {
            return [2, deserializeAws_restXmlDeleteObjectCommandError(output, context)];
          }
          contents = {
            $metadata: deserializeMetadata5(output),
            DeleteMarker: void 0,
            RequestCharged: void 0,
            VersionId: void 0
          };
          if (output.headers["x-amz-delete-marker"] !== void 0) {
            contents.DeleteMarker = output.headers["x-amz-delete-marker"] === "true";
          }
          if (output.headers["x-amz-version-id"] !== void 0) {
            contents.VersionId = output.headers["x-amz-version-id"];
          }
          if (output.headers["x-amz-request-charged"] !== void 0) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }
          return [4, collectBody6(output.body, context)];
        case 1:
          _a2.sent();
          return [2, Promise.resolve(contents)];
      }
    });
  });
};
var deserializeAws_restXmlDeleteObjectCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, response, errorCode, parsedBody, message;
    var _b2;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _b2 = {};
          return [4, parseBody5(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_b2.body = _c.sent(), _b2)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign7(__assign7({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata5(output) });
          }
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2, Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};
var deserializeAws_restXmlGetObjectCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data;
    return __generator3(this, function(_a2) {
      if (output.statusCode !== 200 && output.statusCode >= 300) {
        return [2, deserializeAws_restXmlGetObjectCommandError(output, context)];
      }
      contents = {
        $metadata: deserializeMetadata5(output),
        AcceptRanges: void 0,
        Body: void 0,
        BucketKeyEnabled: void 0,
        CacheControl: void 0,
        ContentDisposition: void 0,
        ContentEncoding: void 0,
        ContentLanguage: void 0,
        ContentLength: void 0,
        ContentRange: void 0,
        ContentType: void 0,
        DeleteMarker: void 0,
        ETag: void 0,
        Expiration: void 0,
        Expires: void 0,
        LastModified: void 0,
        Metadata: void 0,
        MissingMeta: void 0,
        ObjectLockLegalHoldStatus: void 0,
        ObjectLockMode: void 0,
        ObjectLockRetainUntilDate: void 0,
        PartsCount: void 0,
        ReplicationStatus: void 0,
        RequestCharged: void 0,
        Restore: void 0,
        SSECustomerAlgorithm: void 0,
        SSECustomerKeyMD5: void 0,
        SSEKMSKeyId: void 0,
        ServerSideEncryption: void 0,
        StorageClass: void 0,
        TagCount: void 0,
        VersionId: void 0,
        WebsiteRedirectLocation: void 0
      };
      if (output.headers["x-amz-delete-marker"] !== void 0) {
        contents.DeleteMarker = output.headers["x-amz-delete-marker"] === "true";
      }
      if (output.headers["accept-ranges"] !== void 0) {
        contents.AcceptRanges = output.headers["accept-ranges"];
      }
      if (output.headers["x-amz-expiration"] !== void 0) {
        contents.Expiration = output.headers["x-amz-expiration"];
      }
      if (output.headers["x-amz-restore"] !== void 0) {
        contents.Restore = output.headers["x-amz-restore"];
      }
      if (output.headers["last-modified"] !== void 0) {
        contents.LastModified = new Date(output.headers["last-modified"]);
      }
      if (output.headers["content-length"] !== void 0) {
        contents.ContentLength = parseInt(output.headers["content-length"], 10);
      }
      if (output.headers["etag"] !== void 0) {
        contents.ETag = output.headers["etag"];
      }
      if (output.headers["x-amz-missing-meta"] !== void 0) {
        contents.MissingMeta = parseInt(output.headers["x-amz-missing-meta"], 10);
      }
      if (output.headers["x-amz-version-id"] !== void 0) {
        contents.VersionId = output.headers["x-amz-version-id"];
      }
      if (output.headers["cache-control"] !== void 0) {
        contents.CacheControl = output.headers["cache-control"];
      }
      if (output.headers["content-disposition"] !== void 0) {
        contents.ContentDisposition = output.headers["content-disposition"];
      }
      if (output.headers["content-encoding"] !== void 0) {
        contents.ContentEncoding = output.headers["content-encoding"];
      }
      if (output.headers["content-language"] !== void 0) {
        contents.ContentLanguage = output.headers["content-language"];
      }
      if (output.headers["content-range"] !== void 0) {
        contents.ContentRange = output.headers["content-range"];
      }
      if (output.headers["content-type"] !== void 0) {
        contents.ContentType = output.headers["content-type"];
      }
      if (output.headers["expires"] !== void 0) {
        contents.Expires = new Date(output.headers["expires"]);
      }
      if (output.headers["x-amz-website-redirect-location"] !== void 0) {
        contents.WebsiteRedirectLocation = output.headers["x-amz-website-redirect-location"];
      }
      if (output.headers["x-amz-server-side-encryption"] !== void 0) {
        contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
      }
      if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== void 0) {
        contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
      }
      if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== void 0) {
        contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
      }
      if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== void 0) {
        contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
      }
      if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== void 0) {
        contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
      }
      if (output.headers["x-amz-storage-class"] !== void 0) {
        contents.StorageClass = output.headers["x-amz-storage-class"];
      }
      if (output.headers["x-amz-request-charged"] !== void 0) {
        contents.RequestCharged = output.headers["x-amz-request-charged"];
      }
      if (output.headers["x-amz-replication-status"] !== void 0) {
        contents.ReplicationStatus = output.headers["x-amz-replication-status"];
      }
      if (output.headers["x-amz-mp-parts-count"] !== void 0) {
        contents.PartsCount = parseInt(output.headers["x-amz-mp-parts-count"], 10);
      }
      if (output.headers["x-amz-tagging-count"] !== void 0) {
        contents.TagCount = parseInt(output.headers["x-amz-tagging-count"], 10);
      }
      if (output.headers["x-amz-object-lock-mode"] !== void 0) {
        contents.ObjectLockMode = output.headers["x-amz-object-lock-mode"];
      }
      if (output.headers["x-amz-object-lock-retain-until-date"] !== void 0) {
        contents.ObjectLockRetainUntilDate = new Date(output.headers["x-amz-object-lock-retain-until-date"]);
      }
      if (output.headers["x-amz-object-lock-legal-hold"] !== void 0) {
        contents.ObjectLockLegalHoldStatus = output.headers["x-amz-object-lock-legal-hold"];
      }
      Object.keys(output.headers).forEach(function(header) {
        if (contents.Metadata === void 0) {
          contents.Metadata = {};
        }
        if (header.startsWith("x-amz-meta-")) {
          contents.Metadata[header.substring(11)] = output.headers[header];
        }
      });
      data = output.body;
      contents.Body = data;
      return [2, Promise.resolve(contents)];
    });
  });
};
var deserializeAws_restXmlGetObjectCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, response, errorCode, _b2, _c, _d, parsedBody, message;
    var _e;
    return __generator3(this, function(_f) {
      switch (_f.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _e = {};
          return [4, parseBody5(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_e.body = _f.sent(), _e)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "InvalidObjectState":
              return [3, 2];
            case "com.amazonaws.s3#InvalidObjectState":
              return [3, 2];
            case "NoSuchKey":
              return [3, 4];
            case "com.amazonaws.s3#NoSuchKey":
              return [3, 4];
          }
          return [3, 6];
        case 2:
          _c = [{}];
          return [4, deserializeAws_restXmlInvalidObjectStateResponse(parsedOutput, context)];
        case 3:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _c.concat([_f.sent()])), { name: errorCode, $metadata: deserializeMetadata5(output) }]);
          return [3, 7];
        case 4:
          _d = [{}];
          return [4, deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)];
        case 5:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _d.concat([_f.sent()])), { name: errorCode, $metadata: deserializeMetadata5(output) }]);
          return [3, 7];
        case 6:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign7(__assign7({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata5(output) });
          _f.label = 7;
        case 7:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2, Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};
var deserializeAws_restXmlHeadObjectCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2, deserializeAws_restXmlHeadObjectCommandError(output, context)];
          }
          contents = {
            $metadata: deserializeMetadata5(output),
            AcceptRanges: void 0,
            ArchiveStatus: void 0,
            BucketKeyEnabled: void 0,
            CacheControl: void 0,
            ContentDisposition: void 0,
            ContentEncoding: void 0,
            ContentLanguage: void 0,
            ContentLength: void 0,
            ContentType: void 0,
            DeleteMarker: void 0,
            ETag: void 0,
            Expiration: void 0,
            Expires: void 0,
            LastModified: void 0,
            Metadata: void 0,
            MissingMeta: void 0,
            ObjectLockLegalHoldStatus: void 0,
            ObjectLockMode: void 0,
            ObjectLockRetainUntilDate: void 0,
            PartsCount: void 0,
            ReplicationStatus: void 0,
            RequestCharged: void 0,
            Restore: void 0,
            SSECustomerAlgorithm: void 0,
            SSECustomerKeyMD5: void 0,
            SSEKMSKeyId: void 0,
            ServerSideEncryption: void 0,
            StorageClass: void 0,
            VersionId: void 0,
            WebsiteRedirectLocation: void 0
          };
          if (output.headers["x-amz-delete-marker"] !== void 0) {
            contents.DeleteMarker = output.headers["x-amz-delete-marker"] === "true";
          }
          if (output.headers["accept-ranges"] !== void 0) {
            contents.AcceptRanges = output.headers["accept-ranges"];
          }
          if (output.headers["x-amz-expiration"] !== void 0) {
            contents.Expiration = output.headers["x-amz-expiration"];
          }
          if (output.headers["x-amz-restore"] !== void 0) {
            contents.Restore = output.headers["x-amz-restore"];
          }
          if (output.headers["x-amz-archive-status"] !== void 0) {
            contents.ArchiveStatus = output.headers["x-amz-archive-status"];
          }
          if (output.headers["last-modified"] !== void 0) {
            contents.LastModified = new Date(output.headers["last-modified"]);
          }
          if (output.headers["content-length"] !== void 0) {
            contents.ContentLength = parseInt(output.headers["content-length"], 10);
          }
          if (output.headers["etag"] !== void 0) {
            contents.ETag = output.headers["etag"];
          }
          if (output.headers["x-amz-missing-meta"] !== void 0) {
            contents.MissingMeta = parseInt(output.headers["x-amz-missing-meta"], 10);
          }
          if (output.headers["x-amz-version-id"] !== void 0) {
            contents.VersionId = output.headers["x-amz-version-id"];
          }
          if (output.headers["cache-control"] !== void 0) {
            contents.CacheControl = output.headers["cache-control"];
          }
          if (output.headers["content-disposition"] !== void 0) {
            contents.ContentDisposition = output.headers["content-disposition"];
          }
          if (output.headers["content-encoding"] !== void 0) {
            contents.ContentEncoding = output.headers["content-encoding"];
          }
          if (output.headers["content-language"] !== void 0) {
            contents.ContentLanguage = output.headers["content-language"];
          }
          if (output.headers["content-type"] !== void 0) {
            contents.ContentType = output.headers["content-type"];
          }
          if (output.headers["expires"] !== void 0) {
            contents.Expires = new Date(output.headers["expires"]);
          }
          if (output.headers["x-amz-website-redirect-location"] !== void 0) {
            contents.WebsiteRedirectLocation = output.headers["x-amz-website-redirect-location"];
          }
          if (output.headers["x-amz-server-side-encryption"] !== void 0) {
            contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
          }
          if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== void 0) {
            contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
          }
          if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== void 0) {
            contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
          }
          if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== void 0) {
            contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
          }
          if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== void 0) {
            contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
          }
          if (output.headers["x-amz-storage-class"] !== void 0) {
            contents.StorageClass = output.headers["x-amz-storage-class"];
          }
          if (output.headers["x-amz-request-charged"] !== void 0) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }
          if (output.headers["x-amz-replication-status"] !== void 0) {
            contents.ReplicationStatus = output.headers["x-amz-replication-status"];
          }
          if (output.headers["x-amz-mp-parts-count"] !== void 0) {
            contents.PartsCount = parseInt(output.headers["x-amz-mp-parts-count"], 10);
          }
          if (output.headers["x-amz-object-lock-mode"] !== void 0) {
            contents.ObjectLockMode = output.headers["x-amz-object-lock-mode"];
          }
          if (output.headers["x-amz-object-lock-retain-until-date"] !== void 0) {
            contents.ObjectLockRetainUntilDate = new Date(output.headers["x-amz-object-lock-retain-until-date"]);
          }
          if (output.headers["x-amz-object-lock-legal-hold"] !== void 0) {
            contents.ObjectLockLegalHoldStatus = output.headers["x-amz-object-lock-legal-hold"];
          }
          Object.keys(output.headers).forEach(function(header) {
            if (contents.Metadata === void 0) {
              contents.Metadata = {};
            }
            if (header.startsWith("x-amz-meta-")) {
              contents.Metadata[header.substring(11)] = output.headers[header];
            }
          });
          return [4, collectBody6(output.body, context)];
        case 1:
          _a2.sent();
          return [2, Promise.resolve(contents)];
      }
    });
  });
};
var deserializeAws_restXmlHeadObjectCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, response, errorCode, _b2, _c, parsedBody, message;
    var _d;
    return __generator3(this, function(_e) {
      switch (_e.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _d = {};
          return [4, parseBody5(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_d.body = _e.sent(), _d)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "NoSuchKey":
              return [3, 2];
            case "com.amazonaws.s3#NoSuchKey":
              return [3, 2];
          }
          return [3, 4];
        case 2:
          _c = [{}];
          return [4, deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)];
        case 3:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _c.concat([_e.sent()])), { name: errorCode, $metadata: deserializeMetadata5(output) }]);
          return [3, 5];
        case 4:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign7(__assign7({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata5(output) });
          _e.label = 5;
        case 5:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2, Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};
var deserializeAws_restXmlListObjectsV2Command = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2, deserializeAws_restXmlListObjectsV2CommandError(output, context)];
          }
          contents = {
            $metadata: deserializeMetadata5(output),
            CommonPrefixes: void 0,
            Contents: void 0,
            ContinuationToken: void 0,
            Delimiter: void 0,
            EncodingType: void 0,
            IsTruncated: void 0,
            KeyCount: void 0,
            MaxKeys: void 0,
            Name: void 0,
            NextContinuationToken: void 0,
            Prefix: void 0,
            StartAfter: void 0
          };
          return [4, parseBody5(output.body, context)];
        case 1:
          data = _a2.sent();
          if (data.CommonPrefixes === "") {
            contents.CommonPrefixes = [];
          }
          if (data["CommonPrefixes"] !== void 0) {
            contents.CommonPrefixes = deserializeAws_restXmlCommonPrefixList(getArrayIfSingleItem(data["CommonPrefixes"]), context);
          }
          if (data.Contents === "") {
            contents.Contents = [];
          }
          if (data["Contents"] !== void 0) {
            contents.Contents = deserializeAws_restXmlObjectList(getArrayIfSingleItem(data["Contents"]), context);
          }
          if (data["ContinuationToken"] !== void 0) {
            contents.ContinuationToken = data["ContinuationToken"];
          }
          if (data["Delimiter"] !== void 0) {
            contents.Delimiter = data["Delimiter"];
          }
          if (data["EncodingType"] !== void 0) {
            contents.EncodingType = data["EncodingType"];
          }
          if (data["IsTruncated"] !== void 0) {
            contents.IsTruncated = data["IsTruncated"] == "true";
          }
          if (data["KeyCount"] !== void 0) {
            contents.KeyCount = parseInt(data["KeyCount"]);
          }
          if (data["MaxKeys"] !== void 0) {
            contents.MaxKeys = parseInt(data["MaxKeys"]);
          }
          if (data["Name"] !== void 0) {
            contents.Name = data["Name"];
          }
          if (data["NextContinuationToken"] !== void 0) {
            contents.NextContinuationToken = data["NextContinuationToken"];
          }
          if (data["Prefix"] !== void 0) {
            contents.Prefix = data["Prefix"];
          }
          if (data["StartAfter"] !== void 0) {
            contents.StartAfter = data["StartAfter"];
          }
          return [2, Promise.resolve(contents)];
      }
    });
  });
};
var deserializeAws_restXmlListObjectsV2CommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, response, errorCode, _b2, _c, parsedBody, message;
    var _d;
    return __generator3(this, function(_e) {
      switch (_e.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _d = {};
          return [4, parseBody5(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_d.body = _e.sent(), _d)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "NoSuchBucket":
              return [3, 2];
            case "com.amazonaws.s3#NoSuchBucket":
              return [3, 2];
          }
          return [3, 4];
        case 2:
          _c = [{}];
          return [4, deserializeAws_restXmlNoSuchBucketResponse(parsedOutput, context)];
        case 3:
          response = __assign7.apply(void 0, [__assign7.apply(void 0, _c.concat([_e.sent()])), { name: errorCode, $metadata: deserializeMetadata5(output) }]);
          return [3, 5];
        case 4:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign7(__assign7({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata5(output) });
          _e.label = 5;
        case 5:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2, Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};
var deserializeAws_restXmlListPartsCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2, deserializeAws_restXmlListPartsCommandError(output, context)];
          }
          contents = {
            $metadata: deserializeMetadata5(output),
            AbortDate: void 0,
            AbortRuleId: void 0,
            Bucket: void 0,
            Initiator: void 0,
            IsTruncated: void 0,
            Key: void 0,
            MaxParts: void 0,
            NextPartNumberMarker: void 0,
            Owner: void 0,
            PartNumberMarker: void 0,
            Parts: void 0,
            RequestCharged: void 0,
            StorageClass: void 0,
            UploadId: void 0
          };
          if (output.headers["x-amz-abort-date"] !== void 0) {
            contents.AbortDate = new Date(output.headers["x-amz-abort-date"]);
          }
          if (output.headers["x-amz-abort-rule-id"] !== void 0) {
            contents.AbortRuleId = output.headers["x-amz-abort-rule-id"];
          }
          if (output.headers["x-amz-request-charged"] !== void 0) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }
          return [4, parseBody5(output.body, context)];
        case 1:
          data = _a2.sent();
          if (data["Bucket"] !== void 0) {
            contents.Bucket = data["Bucket"];
          }
          if (data["Initiator"] !== void 0) {
            contents.Initiator = deserializeAws_restXmlInitiator(data["Initiator"], context);
          }
          if (data["IsTruncated"] !== void 0) {
            contents.IsTruncated = data["IsTruncated"] == "true";
          }
          if (data["Key"] !== void 0) {
            contents.Key = data["Key"];
          }
          if (data["MaxParts"] !== void 0) {
            contents.MaxParts = parseInt(data["MaxParts"]);
          }
          if (data["NextPartNumberMarker"] !== void 0) {
            contents.NextPartNumberMarker = data["NextPartNumberMarker"];
          }
          if (data["Owner"] !== void 0) {
            contents.Owner = deserializeAws_restXmlOwner(data["Owner"], context);
          }
          if (data["PartNumberMarker"] !== void 0) {
            contents.PartNumberMarker = data["PartNumberMarker"];
          }
          if (data.Part === "") {
            contents.Parts = [];
          }
          if (data["Part"] !== void 0) {
            contents.Parts = deserializeAws_restXmlParts(getArrayIfSingleItem(data["Part"]), context);
          }
          if (data["StorageClass"] !== void 0) {
            contents.StorageClass = data["StorageClass"];
          }
          if (data["UploadId"] !== void 0) {
            contents.UploadId = data["UploadId"];
          }
          return [2, Promise.resolve(contents)];
      }
    });
  });
};
var deserializeAws_restXmlListPartsCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, response, errorCode, parsedBody, message;
    var _b2;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _b2 = {};
          return [4, parseBody5(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_b2.body = _c.sent(), _b2)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign7(__assign7({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata5(output) });
          }
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2, Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};
var deserializeAws_restXmlPutObjectCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2, deserializeAws_restXmlPutObjectCommandError(output, context)];
          }
          contents = {
            $metadata: deserializeMetadata5(output),
            BucketKeyEnabled: void 0,
            ETag: void 0,
            Expiration: void 0,
            RequestCharged: void 0,
            SSECustomerAlgorithm: void 0,
            SSECustomerKeyMD5: void 0,
            SSEKMSEncryptionContext: void 0,
            SSEKMSKeyId: void 0,
            ServerSideEncryption: void 0,
            VersionId: void 0
          };
          if (output.headers["x-amz-expiration"] !== void 0) {
            contents.Expiration = output.headers["x-amz-expiration"];
          }
          if (output.headers["etag"] !== void 0) {
            contents.ETag = output.headers["etag"];
          }
          if (output.headers["x-amz-server-side-encryption"] !== void 0) {
            contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
          }
          if (output.headers["x-amz-version-id"] !== void 0) {
            contents.VersionId = output.headers["x-amz-version-id"];
          }
          if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== void 0) {
            contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
          }
          if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== void 0) {
            contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
          }
          if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== void 0) {
            contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
          }
          if (output.headers["x-amz-server-side-encryption-context"] !== void 0) {
            contents.SSEKMSEncryptionContext = output.headers["x-amz-server-side-encryption-context"];
          }
          if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== void 0) {
            contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
          }
          if (output.headers["x-amz-request-charged"] !== void 0) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }
          return [4, collectBody6(output.body, context)];
        case 1:
          _a2.sent();
          return [2, Promise.resolve(contents)];
      }
    });
  });
};
var deserializeAws_restXmlPutObjectCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, response, errorCode, parsedBody, message;
    var _b2;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _b2 = {};
          return [4, parseBody5(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_b2.body = _c.sent(), _b2)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign7(__assign7({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata5(output) });
          }
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2, Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};
var deserializeAws_restXmlUploadPartCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2, deserializeAws_restXmlUploadPartCommandError(output, context)];
          }
          contents = {
            $metadata: deserializeMetadata5(output),
            BucketKeyEnabled: void 0,
            ETag: void 0,
            RequestCharged: void 0,
            SSECustomerAlgorithm: void 0,
            SSECustomerKeyMD5: void 0,
            SSEKMSKeyId: void 0,
            ServerSideEncryption: void 0
          };
          if (output.headers["x-amz-server-side-encryption"] !== void 0) {
            contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
          }
          if (output.headers["etag"] !== void 0) {
            contents.ETag = output.headers["etag"];
          }
          if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== void 0) {
            contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
          }
          if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== void 0) {
            contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
          }
          if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== void 0) {
            contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
          }
          if (output.headers["x-amz-server-side-encryption-bucket-key-enabled"] !== void 0) {
            contents.BucketKeyEnabled = output.headers["x-amz-server-side-encryption-bucket-key-enabled"] === "true";
          }
          if (output.headers["x-amz-request-charged"] !== void 0) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }
          return [4, collectBody6(output.body, context)];
        case 1:
          _a2.sent();
          return [2, Promise.resolve(contents)];
      }
    });
  });
};
var deserializeAws_restXmlUploadPartCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, response, errorCode, parsedBody, message;
    var _b2;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _b2 = {};
          return [4, parseBody5(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_b2.body = _c.sent(), _b2)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign7(__assign7({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata5(output) });
          }
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2, Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};
var deserializeAws_restXmlInvalidObjectStateResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data;
    return __generator3(this, function(_a2) {
      contents = {
        name: "InvalidObjectState",
        $fault: "client",
        $metadata: deserializeMetadata5(parsedOutput),
        AccessTier: void 0,
        StorageClass: void 0
      };
      data = parsedOutput.body;
      if (data["AccessTier"] !== void 0) {
        contents.AccessTier = data["AccessTier"];
      }
      if (data["StorageClass"] !== void 0) {
        contents.StorageClass = data["StorageClass"];
      }
      return [2, contents];
    });
  });
};
var deserializeAws_restXmlNoSuchBucketResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data;
    return __generator3(this, function(_a2) {
      contents = {
        name: "NoSuchBucket",
        $fault: "client",
        $metadata: deserializeMetadata5(parsedOutput)
      };
      data = parsedOutput.body;
      return [2, contents];
    });
  });
};
var deserializeAws_restXmlNoSuchKeyResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data;
    return __generator3(this, function(_a2) {
      contents = {
        name: "NoSuchKey",
        $fault: "client",
        $metadata: deserializeMetadata5(parsedOutput)
      };
      data = parsedOutput.body;
      return [2, contents];
    });
  });
};
var deserializeAws_restXmlNoSuchUploadResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data;
    return __generator3(this, function(_a2) {
      contents = {
        name: "NoSuchUpload",
        $fault: "client",
        $metadata: deserializeMetadata5(parsedOutput)
      };
      data = parsedOutput.body;
      return [2, contents];
    });
  });
};
var deserializeAws_restXmlObjectNotInActiveTierErrorResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data;
    return __generator3(this, function(_a2) {
      contents = {
        name: "ObjectNotInActiveTierError",
        $fault: "client",
        $metadata: deserializeMetadata5(parsedOutput)
      };
      data = parsedOutput.body;
      return [2, contents];
    });
  });
};
var serializeAws_restXmlCompletedMultipartUpload = function(input, context) {
  var bodyNode = new XmlNode("CompletedMultipartUpload");
  if (input.Parts !== void 0 && input.Parts !== null) {
    var nodes = serializeAws_restXmlCompletedPartList(input.Parts, context);
    nodes.map(function(node) {
      node = node.withName("Part");
      bodyNode.addChildNode(node);
    });
  }
  return bodyNode;
};
var serializeAws_restXmlCompletedPart = function(input, context) {
  var bodyNode = new XmlNode("CompletedPart");
  if (input.ETag !== void 0 && input.ETag !== null) {
    var node = new XmlNode("ETag").addChildNode(new XmlText(input.ETag)).withName("ETag");
    bodyNode.addChildNode(node);
  }
  if (input.PartNumber !== void 0 && input.PartNumber !== null) {
    var node = new XmlNode("PartNumber").addChildNode(new XmlText(String(input.PartNumber))).withName("PartNumber");
    bodyNode.addChildNode(node);
  }
  return bodyNode;
};
var serializeAws_restXmlCompletedPartList = function(input, context) {
  return input.filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    var node = serializeAws_restXmlCompletedPart(entry, context);
    return node.withName("member");
  });
};
var deserializeAws_restXmlCommonPrefix = function(output, context) {
  var contents = {
    Prefix: void 0
  };
  if (output["Prefix"] !== void 0) {
    contents.Prefix = output["Prefix"];
  }
  return contents;
};
var deserializeAws_restXmlCommonPrefixList = function(output, context) {
  return (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_restXmlCommonPrefix(entry, context);
  });
};
var deserializeAws_restXmlCopyObjectResult = function(output, context) {
  var contents = {
    ETag: void 0,
    LastModified: void 0
  };
  if (output["ETag"] !== void 0) {
    contents.ETag = output["ETag"];
  }
  if (output["LastModified"] !== void 0) {
    contents.LastModified = new Date(output["LastModified"]);
  }
  return contents;
};
var deserializeAws_restXmlInitiator = function(output, context) {
  var contents = {
    ID: void 0,
    DisplayName: void 0
  };
  if (output["ID"] !== void 0) {
    contents.ID = output["ID"];
  }
  if (output["DisplayName"] !== void 0) {
    contents.DisplayName = output["DisplayName"];
  }
  return contents;
};
var deserializeAws_restXml_Object = function(output, context) {
  var contents = {
    Key: void 0,
    LastModified: void 0,
    ETag: void 0,
    Size: void 0,
    StorageClass: void 0,
    Owner: void 0
  };
  if (output["Key"] !== void 0) {
    contents.Key = output["Key"];
  }
  if (output["LastModified"] !== void 0) {
    contents.LastModified = new Date(output["LastModified"]);
  }
  if (output["ETag"] !== void 0) {
    contents.ETag = output["ETag"];
  }
  if (output["Size"] !== void 0) {
    contents.Size = parseInt(output["Size"]);
  }
  if (output["StorageClass"] !== void 0) {
    contents.StorageClass = output["StorageClass"];
  }
  if (output["Owner"] !== void 0) {
    contents.Owner = deserializeAws_restXmlOwner(output["Owner"], context);
  }
  return contents;
};
var deserializeAws_restXmlObjectList = function(output, context) {
  return (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_restXml_Object(entry, context);
  });
};
var deserializeAws_restXmlOwner = function(output, context) {
  var contents = {
    DisplayName: void 0,
    ID: void 0
  };
  if (output["DisplayName"] !== void 0) {
    contents.DisplayName = output["DisplayName"];
  }
  if (output["ID"] !== void 0) {
    contents.ID = output["ID"];
  }
  return contents;
};
var deserializeAws_restXmlPart = function(output, context) {
  var contents = {
    PartNumber: void 0,
    LastModified: void 0,
    ETag: void 0,
    Size: void 0
  };
  if (output["PartNumber"] !== void 0) {
    contents.PartNumber = parseInt(output["PartNumber"]);
  }
  if (output["LastModified"] !== void 0) {
    contents.LastModified = new Date(output["LastModified"]);
  }
  if (output["ETag"] !== void 0) {
    contents.ETag = output["ETag"];
  }
  if (output["Size"] !== void 0) {
    contents.Size = parseInt(output["Size"]);
  }
  return contents;
};
var deserializeAws_restXmlParts = function(output, context) {
  return (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_restXmlPart(entry, context);
  });
};
var deserializeMetadata5 = function(output) {
  var _a2;
  return {
    httpStatusCode: output.statusCode,
    requestId: (_a2 = output.headers["x-amzn-requestid"]) !== null && _a2 !== void 0 ? _a2 : output.headers["x-amzn-request-id"],
    extendedRequestId: output.headers["x-amz-id-2"],
    cfId: output.headers["x-amz-cf-id"]
  };
};
var collectBody6 = function(streamBody, context) {
  if (streamBody === void 0) {
    streamBody = new Uint8Array();
  }
  if (streamBody instanceof Uint8Array) {
    return Promise.resolve(streamBody);
  }
  return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
var collectBodyString6 = function(streamBody, context) {
  return collectBody6(streamBody, context).then(function(body) {
    return context.utf8Encoder(body);
  });
};
var isSerializableHeaderValue = function(value) {
  return value !== void 0 && value !== null && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};
var decodeEscapedXML = function(str) {
  return str.replace(/&amp;/g, "&").replace(/&apos;/g, "'").replace(/&quot;/g, '"').replace(/&gt;/g, ">").replace(/&lt;/g, "<");
};
var parseBody5 = function(streamBody, context) {
  return collectBodyString6(streamBody, context).then(function(encoded) {
    if (encoded.length) {
      var parsedObj = parse6(encoded, {
        attributeNamePrefix: "",
        ignoreAttributes: false,
        parseNodeValue: false,
        tagValueProcessor: function(val2, tagName) {
          return decodeEscapedXML(val2);
        }
      });
      var textNodeName = "#text";
      var key = Object.keys(parsedObj)[0];
      var parsedObjToReturn = parsedObj[key];
      if (parsedObjToReturn[textNodeName]) {
        parsedObjToReturn[key] = parsedObjToReturn[textNodeName];
        delete parsedObjToReturn[textNodeName];
      }
      return getValueFromTextNode(parsedObjToReturn);
    }
    return {};
  });
};
var loadRestXmlErrorCode = function(output, data) {
  if (data.Code !== void 0) {
    return data.Code;
  }
  if (output.statusCode == 404) {
    return "NotFound";
  }
  return "";
};

// node_modules/@aws-sdk/client-s3/dist/es/commands/AbortMultipartUploadCommand.js
var AbortMultipartUploadCommand = (
  /** @class */
  function(_super) {
    __extends3(AbortMultipartUploadCommand2, _super);
    function AbortMultipartUploadCommand2(input) {
      var _this = (
        // Start section: command_constructor
        _super.call(this) || this
      );
      _this.input = input;
      return _this;
    }
    AbortMultipartUploadCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
      this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
      this.middlewareStack.use(getBucketEndpointPlugin(configuration));
      var stack = clientStack.concat(this.middlewareStack);
      var logger64 = configuration.logger;
      var clientName = "S3Client";
      var commandName = "AbortMultipartUploadCommand";
      var handlerExecutionContext = {
        logger: logger64,
        clientName,
        commandName,
        inputFilterSensitiveLog: AbortMultipartUploadRequest.filterSensitiveLog,
        outputFilterSensitiveLog: AbortMultipartUploadOutput.filterSensitiveLog
      };
      var requestHandler = configuration.requestHandler;
      return stack.resolve(function(request) {
        return requestHandler.handle(request.request, options || {});
      }, handlerExecutionContext);
    };
    AbortMultipartUploadCommand2.prototype.serialize = function(input, context) {
      return serializeAws_restXmlAbortMultipartUploadCommand(input, context);
    };
    AbortMultipartUploadCommand2.prototype.deserialize = function(output, context) {
      return deserializeAws_restXmlAbortMultipartUploadCommand(output, context);
    };
    return AbortMultipartUploadCommand2;
  }(Command)
);

// node_modules/@aws-sdk/client-s3/dist/es/commands/CompleteMultipartUploadCommand.js
var CompleteMultipartUploadCommand = (
  /** @class */
  function(_super) {
    __extends3(CompleteMultipartUploadCommand2, _super);
    function CompleteMultipartUploadCommand2(input) {
      var _this = (
        // Start section: command_constructor
        _super.call(this) || this
      );
      _this.input = input;
      return _this;
    }
    CompleteMultipartUploadCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
      this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
      this.middlewareStack.use(getThrow200ExceptionsPlugin(configuration));
      this.middlewareStack.use(getBucketEndpointPlugin(configuration));
      var stack = clientStack.concat(this.middlewareStack);
      var logger64 = configuration.logger;
      var clientName = "S3Client";
      var commandName = "CompleteMultipartUploadCommand";
      var handlerExecutionContext = {
        logger: logger64,
        clientName,
        commandName,
        inputFilterSensitiveLog: CompleteMultipartUploadRequest.filterSensitiveLog,
        outputFilterSensitiveLog: CompleteMultipartUploadOutput.filterSensitiveLog
      };
      var requestHandler = configuration.requestHandler;
      return stack.resolve(function(request) {
        return requestHandler.handle(request.request, options || {});
      }, handlerExecutionContext);
    };
    CompleteMultipartUploadCommand2.prototype.serialize = function(input, context) {
      return serializeAws_restXmlCompleteMultipartUploadCommand(input, context);
    };
    CompleteMultipartUploadCommand2.prototype.deserialize = function(output, context) {
      return deserializeAws_restXmlCompleteMultipartUploadCommand(output, context);
    };
    return CompleteMultipartUploadCommand2;
  }(Command)
);

// node_modules/@aws-sdk/middleware-ssec/node_modules/tslib/tslib.es6.js
var __assign38 = function() {
  __assign38 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign38.apply(this, arguments);
};
function __awaiter61(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator62(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __values15(o2) {
  var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
  if (m2)
    return m2.call(o2);
  if (o2 && typeof o2.length === "number")
    return {
      next: function() {
        if (o2 && i2 >= o2.length)
          o2 = void 0;
        return { value: o2 && o2[i2++], done: !o2 };
      }
    };
  throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

// node_modules/@aws-sdk/middleware-ssec/dist/es/index.js
function ssecMiddleware(options) {
  var _this = this;
  return function(next) {
    return function(args) {
      return __awaiter61(_this, void 0, void 0, function() {
        var input, properties, properties_1, properties_1_1, prop, value, valueView, encoded, hash, _a2, _b2, _c, _d, e_1_1;
        var e_1, _e, _f;
        return __generator62(this, function(_g) {
          switch (_g.label) {
            case 0:
              input = __assign38({}, args.input);
              properties = [
                {
                  target: "SSECustomerKey",
                  hash: "SSECustomerKeyMD5"
                },
                {
                  target: "CopySourceSSECustomerKey",
                  hash: "CopySourceSSECustomerKeyMD5"
                }
              ];
              _g.label = 1;
            case 1:
              _g.trys.push([1, 6, 7, 8]);
              properties_1 = __values15(properties), properties_1_1 = properties_1.next();
              _g.label = 2;
            case 2:
              if (!!properties_1_1.done)
                return [3, 5];
              prop = properties_1_1.value;
              value = input[prop.target];
              if (!value)
                return [3, 4];
              valueView = ArrayBuffer.isView(value) ? new Uint8Array(value.buffer, value.byteOffset, value.byteLength) : typeof value === "string" ? options.utf8Decoder(value) : new Uint8Array(value);
              encoded = options.base64Encoder(valueView);
              hash = new options.md5();
              hash.update(valueView);
              _a2 = [__assign38({}, input)];
              _f = {}, _f[prop.target] = encoded;
              _b2 = prop.hash;
              _d = (_c = options).base64Encoder;
              return [4, hash.digest()];
            case 3:
              input = __assign38.apply(void 0, _a2.concat([(_f[_b2] = _d.apply(_c, [_g.sent()]), _f)]));
              _g.label = 4;
            case 4:
              properties_1_1 = properties_1.next();
              return [3, 2];
            case 5:
              return [3, 8];
            case 6:
              e_1_1 = _g.sent();
              e_1 = { error: e_1_1 };
              return [3, 8];
            case 7:
              try {
                if (properties_1_1 && !properties_1_1.done && (_e = properties_1.return))
                  _e.call(properties_1);
              } finally {
                if (e_1)
                  throw e_1.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 8:
              return [2, next(__assign38(__assign38({}, args), { input }))];
          }
        });
      });
    };
  };
}
var ssecMiddlewareOptions = {
  name: "ssecMiddleware",
  step: "initialize",
  tags: ["SSE"],
  override: true
};
var getSsecPlugin = function(config) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(ssecMiddleware(config), ssecMiddlewareOptions);
    }
  };
};

// node_modules/@aws-sdk/client-s3/dist/es/commands/CopyObjectCommand.js
var CopyObjectCommand = (
  /** @class */
  function(_super) {
    __extends3(CopyObjectCommand2, _super);
    function CopyObjectCommand2(input) {
      var _this = (
        // Start section: command_constructor
        _super.call(this) || this
      );
      _this.input = input;
      return _this;
    }
    CopyObjectCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
      this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
      this.middlewareStack.use(getThrow200ExceptionsPlugin(configuration));
      this.middlewareStack.use(getSsecPlugin(configuration));
      this.middlewareStack.use(getBucketEndpointPlugin(configuration));
      var stack = clientStack.concat(this.middlewareStack);
      var logger64 = configuration.logger;
      var clientName = "S3Client";
      var commandName = "CopyObjectCommand";
      var handlerExecutionContext = {
        logger: logger64,
        clientName,
        commandName,
        inputFilterSensitiveLog: CopyObjectRequest.filterSensitiveLog,
        outputFilterSensitiveLog: CopyObjectOutput.filterSensitiveLog
      };
      var requestHandler = configuration.requestHandler;
      return stack.resolve(function(request) {
        return requestHandler.handle(request.request, options || {});
      }, handlerExecutionContext);
    };
    CopyObjectCommand2.prototype.serialize = function(input, context) {
      return serializeAws_restXmlCopyObjectCommand(input, context);
    };
    CopyObjectCommand2.prototype.deserialize = function(output, context) {
      return deserializeAws_restXmlCopyObjectCommand(output, context);
    };
    return CopyObjectCommand2;
  }(Command)
);

// node_modules/@aws-sdk/client-s3/dist/es/commands/CreateMultipartUploadCommand.js
var CreateMultipartUploadCommand = (
  /** @class */
  function(_super) {
    __extends3(CreateMultipartUploadCommand2, _super);
    function CreateMultipartUploadCommand2(input) {
      var _this = (
        // Start section: command_constructor
        _super.call(this) || this
      );
      _this.input = input;
      return _this;
    }
    CreateMultipartUploadCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
      this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
      this.middlewareStack.use(getSsecPlugin(configuration));
      this.middlewareStack.use(getBucketEndpointPlugin(configuration));
      var stack = clientStack.concat(this.middlewareStack);
      var logger64 = configuration.logger;
      var clientName = "S3Client";
      var commandName = "CreateMultipartUploadCommand";
      var handlerExecutionContext = {
        logger: logger64,
        clientName,
        commandName,
        inputFilterSensitiveLog: CreateMultipartUploadRequest.filterSensitiveLog,
        outputFilterSensitiveLog: CreateMultipartUploadOutput.filterSensitiveLog
      };
      var requestHandler = configuration.requestHandler;
      return stack.resolve(function(request) {
        return requestHandler.handle(request.request, options || {});
      }, handlerExecutionContext);
    };
    CreateMultipartUploadCommand2.prototype.serialize = function(input, context) {
      return serializeAws_restXmlCreateMultipartUploadCommand(input, context);
    };
    CreateMultipartUploadCommand2.prototype.deserialize = function(output, context) {
      return deserializeAws_restXmlCreateMultipartUploadCommand(output, context);
    };
    return CreateMultipartUploadCommand2;
  }(Command)
);

// node_modules/@aws-sdk/client-s3/dist/es/commands/DeleteObjectCommand.js
var DeleteObjectCommand = (
  /** @class */
  function(_super) {
    __extends3(DeleteObjectCommand2, _super);
    function DeleteObjectCommand2(input) {
      var _this = (
        // Start section: command_constructor
        _super.call(this) || this
      );
      _this.input = input;
      return _this;
    }
    DeleteObjectCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
      this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
      this.middlewareStack.use(getBucketEndpointPlugin(configuration));
      var stack = clientStack.concat(this.middlewareStack);
      var logger64 = configuration.logger;
      var clientName = "S3Client";
      var commandName = "DeleteObjectCommand";
      var handlerExecutionContext = {
        logger: logger64,
        clientName,
        commandName,
        inputFilterSensitiveLog: DeleteObjectRequest.filterSensitiveLog,
        outputFilterSensitiveLog: DeleteObjectOutput.filterSensitiveLog
      };
      var requestHandler = configuration.requestHandler;
      return stack.resolve(function(request) {
        return requestHandler.handle(request.request, options || {});
      }, handlerExecutionContext);
    };
    DeleteObjectCommand2.prototype.serialize = function(input, context) {
      return serializeAws_restXmlDeleteObjectCommand(input, context);
    };
    DeleteObjectCommand2.prototype.deserialize = function(output, context) {
      return deserializeAws_restXmlDeleteObjectCommand(output, context);
    };
    return DeleteObjectCommand2;
  }(Command)
);

// node_modules/@aws-sdk/client-s3/dist/es/commands/GetObjectCommand.js
var GetObjectCommand = (
  /** @class */
  function(_super) {
    __extends3(GetObjectCommand2, _super);
    function GetObjectCommand2(input) {
      var _this = (
        // Start section: command_constructor
        _super.call(this) || this
      );
      _this.input = input;
      return _this;
    }
    GetObjectCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
      this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
      this.middlewareStack.use(getSsecPlugin(configuration));
      this.middlewareStack.use(getBucketEndpointPlugin(configuration));
      var stack = clientStack.concat(this.middlewareStack);
      var logger64 = configuration.logger;
      var clientName = "S3Client";
      var commandName = "GetObjectCommand";
      var handlerExecutionContext = {
        logger: logger64,
        clientName,
        commandName,
        inputFilterSensitiveLog: GetObjectRequest.filterSensitiveLog,
        outputFilterSensitiveLog: GetObjectOutput.filterSensitiveLog
      };
      var requestHandler = configuration.requestHandler;
      return stack.resolve(function(request) {
        return requestHandler.handle(request.request, options || {});
      }, handlerExecutionContext);
    };
    GetObjectCommand2.prototype.serialize = function(input, context) {
      return serializeAws_restXmlGetObjectCommand(input, context);
    };
    GetObjectCommand2.prototype.deserialize = function(output, context) {
      return deserializeAws_restXmlGetObjectCommand(output, context);
    };
    return GetObjectCommand2;
  }(Command)
);

// node_modules/@aws-sdk/client-s3/dist/es/commands/HeadObjectCommand.js
var HeadObjectCommand = (
  /** @class */
  function(_super) {
    __extends3(HeadObjectCommand2, _super);
    function HeadObjectCommand2(input) {
      var _this = (
        // Start section: command_constructor
        _super.call(this) || this
      );
      _this.input = input;
      return _this;
    }
    HeadObjectCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
      this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
      this.middlewareStack.use(getSsecPlugin(configuration));
      this.middlewareStack.use(getBucketEndpointPlugin(configuration));
      var stack = clientStack.concat(this.middlewareStack);
      var logger64 = configuration.logger;
      var clientName = "S3Client";
      var commandName = "HeadObjectCommand";
      var handlerExecutionContext = {
        logger: logger64,
        clientName,
        commandName,
        inputFilterSensitiveLog: HeadObjectRequest.filterSensitiveLog,
        outputFilterSensitiveLog: HeadObjectOutput.filterSensitiveLog
      };
      var requestHandler = configuration.requestHandler;
      return stack.resolve(function(request) {
        return requestHandler.handle(request.request, options || {});
      }, handlerExecutionContext);
    };
    HeadObjectCommand2.prototype.serialize = function(input, context) {
      return serializeAws_restXmlHeadObjectCommand(input, context);
    };
    HeadObjectCommand2.prototype.deserialize = function(output, context) {
      return deserializeAws_restXmlHeadObjectCommand(output, context);
    };
    return HeadObjectCommand2;
  }(Command)
);

// node_modules/@aws-sdk/client-s3/dist/es/commands/ListObjectsV2Command.js
var ListObjectsV2Command = (
  /** @class */
  function(_super) {
    __extends3(ListObjectsV2Command2, _super);
    function ListObjectsV2Command2(input) {
      var _this = (
        // Start section: command_constructor
        _super.call(this) || this
      );
      _this.input = input;
      return _this;
    }
    ListObjectsV2Command2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
      this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
      this.middlewareStack.use(getBucketEndpointPlugin(configuration));
      var stack = clientStack.concat(this.middlewareStack);
      var logger64 = configuration.logger;
      var clientName = "S3Client";
      var commandName = "ListObjectsV2Command";
      var handlerExecutionContext = {
        logger: logger64,
        clientName,
        commandName,
        inputFilterSensitiveLog: ListObjectsV2Request.filterSensitiveLog,
        outputFilterSensitiveLog: ListObjectsV2Output.filterSensitiveLog
      };
      var requestHandler = configuration.requestHandler;
      return stack.resolve(function(request) {
        return requestHandler.handle(request.request, options || {});
      }, handlerExecutionContext);
    };
    ListObjectsV2Command2.prototype.serialize = function(input, context) {
      return serializeAws_restXmlListObjectsV2Command(input, context);
    };
    ListObjectsV2Command2.prototype.deserialize = function(output, context) {
      return deserializeAws_restXmlListObjectsV2Command(output, context);
    };
    return ListObjectsV2Command2;
  }(Command)
);

// node_modules/@aws-sdk/client-s3/dist/es/commands/ListPartsCommand.js
var ListPartsCommand = (
  /** @class */
  function(_super) {
    __extends3(ListPartsCommand2, _super);
    function ListPartsCommand2(input) {
      var _this = (
        // Start section: command_constructor
        _super.call(this) || this
      );
      _this.input = input;
      return _this;
    }
    ListPartsCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
      this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
      this.middlewareStack.use(getBucketEndpointPlugin(configuration));
      var stack = clientStack.concat(this.middlewareStack);
      var logger64 = configuration.logger;
      var clientName = "S3Client";
      var commandName = "ListPartsCommand";
      var handlerExecutionContext = {
        logger: logger64,
        clientName,
        commandName,
        inputFilterSensitiveLog: ListPartsRequest.filterSensitiveLog,
        outputFilterSensitiveLog: ListPartsOutput.filterSensitiveLog
      };
      var requestHandler = configuration.requestHandler;
      return stack.resolve(function(request) {
        return requestHandler.handle(request.request, options || {});
      }, handlerExecutionContext);
    };
    ListPartsCommand2.prototype.serialize = function(input, context) {
      return serializeAws_restXmlListPartsCommand(input, context);
    };
    ListPartsCommand2.prototype.deserialize = function(output, context) {
      return deserializeAws_restXmlListPartsCommand(output, context);
    };
    return ListPartsCommand2;
  }(Command)
);

// node_modules/@aws-sdk/client-s3/dist/es/commands/PutObjectCommand.js
var PutObjectCommand = (
  /** @class */
  function(_super) {
    __extends3(PutObjectCommand2, _super);
    function PutObjectCommand2(input) {
      var _this = (
        // Start section: command_constructor
        _super.call(this) || this
      );
      _this.input = input;
      return _this;
    }
    PutObjectCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
      this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
      this.middlewareStack.use(getSsecPlugin(configuration));
      this.middlewareStack.use(getBucketEndpointPlugin(configuration));
      var stack = clientStack.concat(this.middlewareStack);
      var logger64 = configuration.logger;
      var clientName = "S3Client";
      var commandName = "PutObjectCommand";
      var handlerExecutionContext = {
        logger: logger64,
        clientName,
        commandName,
        inputFilterSensitiveLog: PutObjectRequest.filterSensitiveLog,
        outputFilterSensitiveLog: PutObjectOutput.filterSensitiveLog
      };
      var requestHandler = configuration.requestHandler;
      return stack.resolve(function(request) {
        return requestHandler.handle(request.request, options || {});
      }, handlerExecutionContext);
    };
    PutObjectCommand2.prototype.serialize = function(input, context) {
      return serializeAws_restXmlPutObjectCommand(input, context);
    };
    PutObjectCommand2.prototype.deserialize = function(output, context) {
      return deserializeAws_restXmlPutObjectCommand(output, context);
    };
    return PutObjectCommand2;
  }(Command)
);

// node_modules/@aws-sdk/client-s3/dist/es/models/models_1.js
var MetadataEntry;
(function(MetadataEntry2) {
  MetadataEntry2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(MetadataEntry || (MetadataEntry = {}));
var S3Location;
(function(S3Location2) {
  S3Location2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.Encryption && { Encryption: Encryption.filterSensitiveLog(obj.Encryption) });
  };
})(S3Location || (S3Location = {}));
var OutputLocation;
(function(OutputLocation2) {
  OutputLocation2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.S3 && { S3: S3Location.filterSensitiveLog(obj.S3) });
  };
})(OutputLocation || (OutputLocation = {}));
var FileHeaderInfo;
(function(FileHeaderInfo2) {
  FileHeaderInfo2["IGNORE"] = "IGNORE";
  FileHeaderInfo2["NONE"] = "NONE";
  FileHeaderInfo2["USE"] = "USE";
})(FileHeaderInfo || (FileHeaderInfo = {}));
var CSVInput;
(function(CSVInput2) {
  CSVInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CSVInput || (CSVInput = {}));
var JSONType;
(function(JSONType2) {
  JSONType2["DOCUMENT"] = "DOCUMENT";
  JSONType2["LINES"] = "LINES";
})(JSONType || (JSONType = {}));
var JSONInput;
(function(JSONInput2) {
  JSONInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(JSONInput || (JSONInput = {}));
var ParquetInput;
(function(ParquetInput2) {
  ParquetInput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ParquetInput || (ParquetInput = {}));
var InputSerialization;
(function(InputSerialization2) {
  InputSerialization2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(InputSerialization || (InputSerialization = {}));
var QuoteFields;
(function(QuoteFields2) {
  QuoteFields2["ALWAYS"] = "ALWAYS";
  QuoteFields2["ASNEEDED"] = "ASNEEDED";
})(QuoteFields || (QuoteFields = {}));
var CSVOutput;
(function(CSVOutput2) {
  CSVOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CSVOutput || (CSVOutput = {}));
var JSONOutput;
(function(JSONOutput2) {
  JSONOutput2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(JSONOutput || (JSONOutput = {}));
var OutputSerialization;
(function(OutputSerialization2) {
  OutputSerialization2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(OutputSerialization || (OutputSerialization = {}));
var SelectParameters;
(function(SelectParameters2) {
  SelectParameters2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(SelectParameters || (SelectParameters = {}));
var RestoreRequestType;
(function(RestoreRequestType2) {
  RestoreRequestType2["SELECT"] = "SELECT";
})(RestoreRequestType || (RestoreRequestType = {}));
var RestoreRequest;
(function(RestoreRequest2) {
  RestoreRequest2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.OutputLocation && { OutputLocation: OutputLocation.filterSensitiveLog(obj.OutputLocation) });
  };
})(RestoreRequest || (RestoreRequest = {}));
var RestoreObjectRequest;
(function(RestoreObjectRequest2) {
  RestoreObjectRequest2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.RestoreRequest && { RestoreRequest: RestoreRequest.filterSensitiveLog(obj.RestoreRequest) });
  };
})(RestoreObjectRequest || (RestoreObjectRequest = {}));
var ContinuationEvent;
(function(ContinuationEvent2) {
  ContinuationEvent2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ContinuationEvent || (ContinuationEvent = {}));
var EndEvent;
(function(EndEvent2) {
  EndEvent2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(EndEvent || (EndEvent = {}));
var Progress;
(function(Progress2) {
  Progress2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Progress || (Progress = {}));
var ProgressEvent;
(function(ProgressEvent2) {
  ProgressEvent2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ProgressEvent || (ProgressEvent = {}));
var RecordsEvent;
(function(RecordsEvent2) {
  RecordsEvent2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(RecordsEvent || (RecordsEvent = {}));
var Stats;
(function(Stats2) {
  Stats2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(Stats || (Stats = {}));
var StatsEvent;
(function(StatsEvent2) {
  StatsEvent2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(StatsEvent || (StatsEvent = {}));
var SelectObjectContentEventStream;
(function(SelectObjectContentEventStream2) {
  SelectObjectContentEventStream2.visit = function(value, visitor) {
    if (value.Records !== void 0)
      return visitor.Records(value.Records);
    if (value.Stats !== void 0)
      return visitor.Stats(value.Stats);
    if (value.Progress !== void 0)
      return visitor.Progress(value.Progress);
    if (value.Cont !== void 0)
      return visitor.Cont(value.Cont);
    if (value.End !== void 0)
      return visitor.End(value.End);
    return visitor._(value.$unknown[0], value.$unknown[1]);
  };
  SelectObjectContentEventStream2.filterSensitiveLog = function(obj) {
    var _a2;
    if (obj.Records !== void 0)
      return { Records: RecordsEvent.filterSensitiveLog(obj.Records) };
    if (obj.Stats !== void 0)
      return { Stats: StatsEvent.filterSensitiveLog(obj.Stats) };
    if (obj.Progress !== void 0)
      return { Progress: ProgressEvent.filterSensitiveLog(obj.Progress) };
    if (obj.Cont !== void 0)
      return { Cont: ContinuationEvent.filterSensitiveLog(obj.Cont) };
    if (obj.End !== void 0)
      return { End: EndEvent.filterSensitiveLog(obj.End) };
    if (obj.$unknown !== void 0)
      return _a2 = {}, _a2[obj.$unknown[0]] = "UNKNOWN", _a2;
  };
})(SelectObjectContentEventStream || (SelectObjectContentEventStream = {}));
var SelectObjectContentOutput;
(function(SelectObjectContentOutput2) {
  SelectObjectContentOutput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.Payload && { Payload: "STREAMING_CONTENT" });
  };
})(SelectObjectContentOutput || (SelectObjectContentOutput = {}));
var RequestProgress;
(function(RequestProgress2) {
  RequestProgress2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(RequestProgress || (RequestProgress = {}));
var ScanRange;
(function(ScanRange2) {
  ScanRange2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(ScanRange || (ScanRange = {}));
var SelectObjectContentRequest;
(function(SelectObjectContentRequest2) {
  SelectObjectContentRequest2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.SSECustomerKey && { SSECustomerKey: SENSITIVE_STRING });
  };
})(SelectObjectContentRequest || (SelectObjectContentRequest = {}));
var UploadPartOutput;
(function(UploadPartOutput2) {
  UploadPartOutput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING });
  };
})(UploadPartOutput || (UploadPartOutput = {}));
var UploadPartRequest;
(function(UploadPartRequest2) {
  UploadPartRequest2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.SSECustomerKey && { SSECustomerKey: SENSITIVE_STRING });
  };
})(UploadPartRequest || (UploadPartRequest = {}));
var CopyPartResult;
(function(CopyPartResult2) {
  CopyPartResult2.filterSensitiveLog = function(obj) {
    return __assign7({}, obj);
  };
})(CopyPartResult || (CopyPartResult = {}));
var UploadPartCopyOutput;
(function(UploadPartCopyOutput2) {
  UploadPartCopyOutput2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7({}, obj), obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING });
  };
})(UploadPartCopyOutput || (UploadPartCopyOutput = {}));
var UploadPartCopyRequest;
(function(UploadPartCopyRequest2) {
  UploadPartCopyRequest2.filterSensitiveLog = function(obj) {
    return __assign7(__assign7(__assign7({}, obj), obj.SSECustomerKey && { SSECustomerKey: SENSITIVE_STRING }), obj.CopySourceSSECustomerKey && { CopySourceSSECustomerKey: SENSITIVE_STRING });
  };
})(UploadPartCopyRequest || (UploadPartCopyRequest = {}));

// node_modules/@aws-sdk/client-s3/dist/es/commands/UploadPartCommand.js
var UploadPartCommand = (
  /** @class */
  function(_super) {
    __extends3(UploadPartCommand2, _super);
    function UploadPartCommand2(input) {
      var _this = (
        // Start section: command_constructor
        _super.call(this) || this
      );
      _this.input = input;
      return _this;
    }
    UploadPartCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
      this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
      this.middlewareStack.use(getSsecPlugin(configuration));
      this.middlewareStack.use(getBucketEndpointPlugin(configuration));
      var stack = clientStack.concat(this.middlewareStack);
      var logger64 = configuration.logger;
      var clientName = "S3Client";
      var commandName = "UploadPartCommand";
      var handlerExecutionContext = {
        logger: logger64,
        clientName,
        commandName,
        inputFilterSensitiveLog: UploadPartRequest.filterSensitiveLog,
        outputFilterSensitiveLog: UploadPartOutput.filterSensitiveLog
      };
      var requestHandler = configuration.requestHandler;
      return stack.resolve(function(request) {
        return requestHandler.handle(request.request, options || {});
      }, handlerExecutionContext);
    };
    UploadPartCommand2.prototype.serialize = function(input, context) {
      return serializeAws_restXmlUploadPartCommand(input, context);
    };
    UploadPartCommand2.prototype.deserialize = function(output, context) {
      return deserializeAws_restXmlUploadPartCommand(output, context);
    };
    return UploadPartCommand2;
  }(Command)
);

// node_modules/@aws-sdk/util-format-url/dist/es/index.js
function formatUrl(request) {
  var port = request.port, query = request.query;
  var protocol = request.protocol, path = request.path, hostname = request.hostname;
  if (protocol && protocol.substr(-1) !== ":") {
    protocol += ":";
  }
  if (port) {
    hostname += ":" + port;
  }
  if (path && path.charAt(0) !== "/") {
    path = "/" + path;
  }
  var queryString = query ? buildQueryString(query) : "";
  if (queryString && queryString[0] !== "?") {
    queryString = "?" + queryString;
  }
  return protocol + "//" + hostname + path + queryString;
}

// node_modules/@aws-sdk/util-create-request/node_modules/tslib/tslib.es6.js
function __awaiter62(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator63(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/util-create-request/dist/es/index.js
function createRequest(client, command) {
  return __awaiter62(this, void 0, void 0, function() {
    var interceptMiddleware, clientStack, handler;
    var _this = this;
    return __generator63(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          interceptMiddleware = function(next) {
            return function(args) {
              return __awaiter62(_this, void 0, void 0, function() {
                return __generator63(this, function(_a3) {
                  return [2, { output: { request: args.request }, response: void 0 }];
                });
              });
            };
          };
          clientStack = client.middlewareStack.clone();
          clientStack.add(interceptMiddleware, {
            step: "build",
            priority: "low"
          });
          handler = command.resolveMiddleware(clientStack, client.config, void 0);
          return [4, handler(command).then(function(output) {
            return output.output.request;
          })];
        case 1:
          return [2, _a2.sent()];
      }
    });
  });
}

// node_modules/@aws-sdk/s3-request-presigner/node_modules/tslib/tslib.es6.js
var __assign39 = function() {
  __assign39 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign39.apply(this, arguments);
};
function __rest10(s2, e) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
}
function __awaiter63(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator64(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-sdk/s3-request-presigner/dist/es/constants.js
var UNSIGNED_PAYLOAD3 = "UNSIGNED-PAYLOAD";
var SHA256_HEADER2 = "X-Amz-Content-Sha256";

// node_modules/@aws-sdk/s3-request-presigner/dist/es/presigner.js
var S3RequestPresigner = (
  /** @class */
  function() {
    function S3RequestPresigner2(options) {
      var resolvedOptions = __assign39({
        // Allow `signingName` because we want to support usecase of supply client's resolved config
        // directly. Where service equals signingName.
        service: options.signingName || options.service || "s3",
        uriEscapePath: options.uriEscapePath || false
      }, options);
      this.signer = new SignatureV4(resolvedOptions);
    }
    S3RequestPresigner2.prototype.presign = function(requestToSign, _a2) {
      if (_a2 === void 0) {
        _a2 = {};
      }
      var _b2 = _a2.unsignableHeaders, unsignableHeaders = _b2 === void 0 ? /* @__PURE__ */ new Set() : _b2, _c = _a2.unhoistableHeaders, unhoistableHeaders = _c === void 0 ? /* @__PURE__ */ new Set() : _c, options = __rest10(_a2, ["unsignableHeaders", "unhoistableHeaders"]);
      return __awaiter63(this, void 0, void 0, function() {
        return __generator64(this, function(_d) {
          unsignableHeaders.add("content-type");
          Object.keys(requestToSign.headers).map(function(header) {
            return header.toLowerCase();
          }).filter(function(header) {
            return header.startsWith("x-amz-server-side-encryption");
          }).forEach(function(header) {
            unhoistableHeaders.add(header);
          });
          requestToSign.headers[SHA256_HEADER2] = UNSIGNED_PAYLOAD3;
          if (!requestToSign.headers["host"]) {
            requestToSign.headers.host = requestToSign.hostname;
          }
          return [2, this.signer.presign(requestToSign, __assign39({
            expiresIn: 900,
            unsignableHeaders,
            unhoistableHeaders
          }, options))];
        });
      });
    };
    return S3RequestPresigner2;
  }()
);

// node_modules/@aws-amplify/storage/lib-esm/providers/axios-http-handler.js
var import_axios = __toESM(require_axios2());

// node_modules/@aws-amplify/storage/lib-esm/common/StorageErrorStrings.js
var StorageErrorStrings;
(function(StorageErrorStrings2) {
  StorageErrorStrings2["NO_CREDENTIALS"] = "No credentials";
  StorageErrorStrings2["NO_SRC_KEY"] = 'source param should be an object with the property "key" with value of type string';
  StorageErrorStrings2["NO_DEST_KEY"] = 'destination param should be an object with the property "key" with value of type string';
  StorageErrorStrings2["INVALID_BLOB"] = "Object must be an instance of Blob";
})(StorageErrorStrings || (StorageErrorStrings = {}));
var AWSS3ProviderMultipartCopierErrors;
(function(AWSS3ProviderMultipartCopierErrors2) {
  AWSS3ProviderMultipartCopierErrors2["CLEANUP_FAILED"] = "Multipart copy clean up failed";
  AWSS3ProviderMultipartCopierErrors2["NO_OBJECT_FOUND"] = "Object does not exist";
  AWSS3ProviderMultipartCopierErrors2["INVALID_QUEUESIZE"] = "Queue size must be a positive number";
  AWSS3ProviderMultipartCopierErrors2["NO_COPYSOURCE"] = "You must specify a copy source";
  AWSS3ProviderMultipartCopierErrors2["MAX_NUM_PARTS_EXCEEDED"] = "Only a maximum of 10000 parts are allowed";
})(AWSS3ProviderMultipartCopierErrors || (AWSS3ProviderMultipartCopierErrors = {}));
var AWSS3ProviderUploadErrorStrings;
(function(AWSS3ProviderUploadErrorStrings2) {
  AWSS3ProviderUploadErrorStrings2["UPLOAD_PAUSED_MESSAGE"] = "paused";
})(AWSS3ProviderUploadErrorStrings || (AWSS3ProviderUploadErrorStrings = {}));

// node_modules/@aws-amplify/storage/lib-esm/providers/axios-http-handler.js
var logger28 = new ConsoleLogger("axios-http-handler");
var SEND_UPLOAD_PROGRESS_EVENT = "sendUploadProgress";
var SEND_DOWNLOAD_PROGRESS_EVENT = "sendDownloadProgress";
function isBlob(body) {
  return typeof Blob !== "undefined" && body instanceof Blob;
}
function hasErrorResponse(error) {
  return typeof error !== "undefined" && Object.prototype.hasOwnProperty.call(error, "response") && typeof error.response !== "undefined" && Object.prototype.hasOwnProperty.call(error.response, "status") && typeof error.response.status === "number";
}
var normalizeHeaders = function(headers, normalizedName) {
  var e_1, _a2;
  try {
    for (var _b2 = __values13(Object.entries(headers)), _c = _b2.next(); !_c.done; _c = _b2.next()) {
      var _d = __read29(_c.value, 2), k2 = _d[0], v2 = _d[1];
      if (k2 !== normalizedName && k2.toUpperCase() === normalizedName.toUpperCase()) {
        headers[normalizedName] = v2;
        delete headers[k2];
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_c && !_c.done && (_a2 = _b2.return))
        _a2.call(_b2);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
};
var reactNativeRequestTransformer = [
  function(data, headers) {
    if (isBlob(data)) {
      normalizeHeaders(headers, "Content-Type");
      normalizeHeaders(headers, "Accept");
      return data;
    }
    return import_axios.default.defaults.transformRequest[0].call(null, data, headers);
  }
];
var AxiosHttpHandler = (
  /** @class */
  function() {
    function AxiosHttpHandler2(httpOptions, emitter, cancelTokenSource) {
      if (httpOptions === void 0) {
        httpOptions = {};
      }
      this.httpOptions = httpOptions;
      this.emitter = emitter;
      this.cancelTokenSource = cancelTokenSource;
    }
    AxiosHttpHandler2.prototype.destroy = function() {
    };
    AxiosHttpHandler2.prototype.handle = function(request, options) {
      var requestTimeoutInMs = this.httpOptions.requestTimeout;
      var emitter = options.emitter || this.emitter;
      var path = request.path;
      if (request.query) {
        var queryString = buildQueryString(request.query);
        if (queryString) {
          path += "?" + queryString;
        }
      }
      var port = request.port;
      var url2 = request.protocol + "//" + request.hostname + (port ? ":" + port : "") + path;
      var axiosRequest = {};
      axiosRequest.url = url2;
      axiosRequest.method = request.method;
      axiosRequest.headers = request.headers;
      delete axiosRequest.headers["host"];
      if (request.body) {
        axiosRequest.data = request.body;
      } else {
        if (axiosRequest.headers[Object.keys(axiosRequest.headers).find(function(key) {
          return key.toLowerCase() === "content-type";
        })]) {
          axiosRequest.data = null;
        }
      }
      if (emitter) {
        axiosRequest.onUploadProgress = function(event) {
          emitter.emit(SEND_UPLOAD_PROGRESS_EVENT, event);
          logger28.debug(event);
        };
        axiosRequest.onDownloadProgress = function(event) {
          emitter.emit(SEND_DOWNLOAD_PROGRESS_EVENT, event);
          logger28.debug(event);
        };
      }
      if (this.cancelTokenSource) {
        axiosRequest.cancelToken = this.cancelTokenSource.token;
      }
      if (options.cancelTokenSource) {
        axiosRequest.cancelToken = options.cancelTokenSource.token;
      }
      axiosRequest.responseType = "blob";
      if (Platform.isReactNative) {
        axiosRequest.transformRequest = reactNativeRequestTransformer;
      }
      var raceOfPromises = [
        import_axios.default.request(axiosRequest).then(function(response) {
          return {
            response: new HttpResponse({
              headers: response.headers,
              statusCode: response.status,
              body: response.data
            })
          };
        }).catch(function(error) {
          var _a2, _b2;
          if (error.message !== AWSS3ProviderUploadErrorStrings.UPLOAD_PAUSED_MESSAGE) {
            logger28.error(error.message);
          }
          if (import_axios.default.isCancel(error) || !hasErrorResponse(error)) {
            throw error;
          }
          return {
            response: new HttpResponse({
              statusCode: error.response.status,
              body: (_a2 = error.response) === null || _a2 === void 0 ? void 0 : _a2.data,
              headers: (_b2 = error.response) === null || _b2 === void 0 ? void 0 : _b2.headers
            })
          };
        }),
        requestTimeout2(requestTimeoutInMs)
      ];
      return Promise.race(raceOfPromises);
    };
    return AxiosHttpHandler2;
  }()
);
function requestTimeout2(timeoutInMs) {
  if (timeoutInMs === void 0) {
    timeoutInMs = 0;
  }
  return new Promise(function(resolve, reject) {
    if (timeoutInMs) {
      setTimeout(function() {
        var timeoutError = new Error("Request did not complete within " + timeoutInMs + " ms");
        timeoutError.name = "TimeoutError";
        reject(timeoutError);
      }, timeoutInMs);
    }
  });
}

// node_modules/@aws-amplify/storage/lib-esm/common/StorageConstants.js
var AMPLIFY_SYMBOL7 = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var SET_CONTENT_LENGTH_HEADER = "contentLengthMiddleware";
var localTestingStorageEndpoint = "http://localhost:20005";
var UPLOADS_STORAGE_KEY = "__uploadInProgress";

// node_modules/@aws-amplify/storage/lib-esm/common/StorageUtils.js
var byteLength = function(x2) {
  if (typeof x2 === "string") {
    return x2.length;
  } else if (isArrayBuffer3(x2)) {
    return x2.byteLength;
  } else if (isBlob2(x2)) {
    return x2.size;
  } else {
    throw new Error("Cannot determine byte length of " + x2);
  }
};
var dispatchStorageEvent = function(track, event, attrs, metrics, message) {
  if (track) {
    var data = { attrs };
    if (metrics) {
      data["metrics"] = metrics;
    }
    Hub.dispatch("storage", {
      event,
      data,
      message
    }, "Storage", AMPLIFY_SYMBOL7);
  }
};
var isFile = function(x2) {
  return typeof x2 !== "undefined" && x2 instanceof File;
};
var isBlob2 = function(x2) {
  return typeof x2 !== "undefined" && x2 instanceof Blob;
};
var isArrayBuffer3 = function(x2) {
  return typeof x2 !== "undefined" && x2 instanceof ArrayBuffer;
};

// node_modules/@aws-amplify/storage/lib-esm/common/S3ClientUtils.js
var logger29 = new ConsoleLogger("S3ClientUtils");
var INVALID_CRED = { accessKeyId: "", secretAccessKey: "" };
var getPrefix = function(config) {
  var credentials = config.credentials, level = config.level, customPrefix = config.customPrefix, identityId = config.identityId;
  var resolvedCustomPrefix = customPrefix || {};
  var resolvedIdentityId = identityId || credentials.identityId;
  var privatePath = (resolvedCustomPrefix.private !== void 0 ? resolvedCustomPrefix.private : "private/") + resolvedIdentityId + "/";
  var protectedPath = (resolvedCustomPrefix.protected !== void 0 ? resolvedCustomPrefix.protected : "protected/") + resolvedIdentityId + "/";
  var publicPath = resolvedCustomPrefix.public !== void 0 ? resolvedCustomPrefix.public : "public/";
  switch (level) {
    case "private":
      return privatePath;
    case "protected":
      return protectedPath;
    default:
      return publicPath;
  }
};
var createPrefixMiddleware = function(opt, key) {
  return function(next, _context) {
    return function(args) {
      return __awaiter50(void 0, void 0, void 0, function() {
        var credentials, cred, prefix, clonedInput, result;
        return __generator51(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, Credentials.get()];
            case 1:
              credentials = _a2.sent();
              cred = Credentials.shear(credentials);
              prefix = getPrefix(__assign32(__assign32({}, opt), { credentials: cred }));
              clonedInput = Object.assign({}, args.input);
              if (Object.prototype.hasOwnProperty.call(args.input, "Key")) {
                clonedInput.Key = prefix + key;
                args.input = clonedInput;
              } else if (Object.prototype.hasOwnProperty.call(args.input, "Prefix")) {
                clonedInput.Prefix = prefix + key;
                args.input = clonedInput;
              }
              result = next(args);
              return [2, result];
          }
        });
      });
    };
  };
};
var isTimeSkewedError = function(err) {
  return err.ServerTime && typeof err.Code === "string" && err.Code === "RequestTimeTooSkewed";
};
var autoAdjustClockskewMiddleware = function(config) {
  return function(next, _context) {
    return function(args) {
      return __awaiter50(void 0, void 0, void 0, function() {
        var err_1, serverDate;
        return __generator51(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 2, , 3]);
              return [4, next(args)];
            case 1:
              return [2, _a2.sent()];
            case 2:
              err_1 = _a2.sent();
              if (isTimeSkewedError(err_1)) {
                serverDate = new Date(err_1.ServerTime);
                config.systemClockOffset = serverDate.getTime() - Date.now();
              }
              throw err_1;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
  };
};
var autoAdjustClockskewMiddlewareOptions = {
  step: "finalizeRequest",
  name: "autoAdjustClockskewMiddleware"
};
var prefixMiddlewareOptions = {
  step: "initialize",
  name: "addPrefixMiddleware"
};
var credentialsProvider = function() {
  return __awaiter50(void 0, void 0, void 0, function() {
    var credentials, cred, error_1;
    return __generator51(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          _a2.trys.push([0, 2, , 3]);
          return [4, Credentials.get()];
        case 1:
          credentials = _a2.sent();
          if (!credentials)
            return [2, INVALID_CRED];
          cred = Credentials.shear(credentials);
          logger29.debug("credentials provider get credentials", cred);
          return [2, cred];
        case 2:
          error_1 = _a2.sent();
          logger29.warn("credentials provider error", error_1);
          return [2, INVALID_CRED];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
};
var createS3Client = function(config, storageAction, emitter) {
  var region = config.region, cancelTokenSource = config.cancelTokenSource, dangerouslyConnectToHttpEndpointForTesting = config.dangerouslyConnectToHttpEndpointForTesting, useAccelerateEndpoint = config.useAccelerateEndpoint;
  var localTestingConfig = {};
  if (dangerouslyConnectToHttpEndpointForTesting) {
    localTestingConfig = {
      endpoint: localTestingStorageEndpoint,
      tls: false,
      bucketEndpoint: false,
      forcePathStyle: true
    };
  }
  var s3client = new S3Client(__assign32(__assign32({
    region,
    // Using provider instead of a static credentials, so that if an upload task was in progress, but credentials gets
    // changed or invalidated (e.g user signed out), the subsequent requests will fail.
    credentials: credentialsProvider,
    customUserAgent: getAmplifyUserAgentObject({
      category: Category.Storage,
      action: storageAction
    })
  }, localTestingConfig), { requestHandler: new AxiosHttpHandler({}, emitter, cancelTokenSource), useAccelerateEndpoint }));
  s3client.middlewareStack.remove(SET_CONTENT_LENGTH_HEADER);
  return s3client;
};
var MB = 1024 * 1024;
var GB = 1024 * MB;
var TB = 1024 * GB;
var DEFAULT_PART_SIZE = 5 * MB;
var MAX_OBJECT_SIZE = 5 * TB;
var MAX_PARTS_COUNT = 1e4;
var DEFAULT_QUEUE_SIZE = 4;
var calculatePartSize = function(totalSize) {
  var partSize = DEFAULT_PART_SIZE;
  var partsCount = Math.ceil(totalSize / partSize);
  while (partsCount > MAX_PARTS_COUNT) {
    partSize *= 2;
    partsCount = Math.ceil(totalSize / partSize);
  }
  return partSize;
};

// node_modules/@aws-amplify/storage/lib-esm/providers/AWSS3ProviderManagedUpload.js
var events = __toESM(require_events());
var logger30 = new ConsoleLogger("AWSS3ProviderManagedUpload");
var AWSS3ProviderManagedUpload = (
  /** @class */
  function() {
    function AWSS3ProviderManagedUpload2(params, opts, emitter) {
      this.opts = null;
      this.completedParts = [];
      this.partSize = DEFAULT_PART_SIZE;
      this.bytesUploaded = 0;
      this.totalBytesToUpload = 0;
      this.emitter = null;
      this.params = params;
      this.opts = opts;
      this.emitter = emitter;
      this.s3client = this._createNewS3Client(opts, emitter);
    }
    AWSS3ProviderManagedUpload2.prototype.upload = function() {
      return __awaiter50(this, void 0, void 0, function() {
        var putObjectCommand, _a2, numberOfPartsToUpload, parts, start, error_1;
        var _this = this;
        return __generator51(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              _b2.trys.push([0, 9, , 11]);
              this.body = this.validateAndSanitizeBody(this.params.Body);
              this.totalBytesToUpload = this.byteLength(this.body);
              if (!(this.totalBytesToUpload <= DEFAULT_PART_SIZE))
                return [3, 1];
              this.params.Body = this.body;
              putObjectCommand = new PutObjectCommand(this.params);
              return [2, this.s3client.send(putObjectCommand)];
            case 1:
              this.partSize = calculatePartSize(this.totalBytesToUpload);
              _a2 = this;
              return [4, this.createMultiPartUpload()];
            case 2:
              _a2.uploadId = _b2.sent();
              numberOfPartsToUpload = Math.ceil(this.totalBytesToUpload / this.partSize);
              parts = this.createParts();
              start = 0;
              _b2.label = 3;
            case 3:
              if (!(start < numberOfPartsToUpload))
                return [3, 6];
              return [4, this.uploadParts(this.uploadId, parts.slice(start, start + DEFAULT_QUEUE_SIZE))];
            case 4:
              _b2.sent();
              _b2.label = 5;
            case 5:
              start += DEFAULT_QUEUE_SIZE;
              return [3, 3];
            case 6:
              parts.map(function(part) {
                _this.removeEventListener(part);
              });
              return [4, this.finishMultiPartUpload(this.uploadId)];
            case 7:
              return [2, _b2.sent()];
            case 8:
              return [3, 11];
            case 9:
              error_1 = _b2.sent();
              return [4, this.cleanup(this.uploadId)];
            case 10:
              _b2.sent();
              logger30.error("Error. Cancelling the multipart upload.");
              throw error_1;
            case 11:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSS3ProviderManagedUpload2.prototype.createParts = function() {
      try {
        var parts = [];
        for (var bodyStart = 0; bodyStart < this.totalBytesToUpload; ) {
          var bodyEnd = Math.min(bodyStart + this.partSize, this.totalBytesToUpload);
          parts.push({
            bodyPart: this.body.slice(bodyStart, bodyEnd),
            partNumber: parts.length + 1,
            emitter: new events.EventEmitter(),
            _lastUploadedBytes: 0
          });
          bodyStart += this.partSize;
        }
        return parts;
      } catch (error) {
        logger30.error(error);
        throw error;
      }
    };
    AWSS3ProviderManagedUpload2.prototype.createMultiPartUpload = function() {
      return __awaiter50(this, void 0, void 0, function() {
        var createMultiPartUploadCommand, response, error_2;
        return __generator51(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 2, , 3]);
              createMultiPartUploadCommand = new CreateMultipartUploadCommand(this.params);
              return [4, this.s3client.send(createMultiPartUploadCommand)];
            case 1:
              response = _a2.sent();
              logger30.debug(response.UploadId);
              return [2, response.UploadId];
            case 2:
              error_2 = _a2.sent();
              logger30.error(error_2);
              throw error_2;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSS3ProviderManagedUpload2.prototype.uploadParts = function(uploadId, parts) {
      return __awaiter50(this, void 0, void 0, function() {
        var allResults, i2, error_3;
        var _this = this;
        return __generator51(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 2, , 3]);
              return [4, Promise.all(parts.map(function(part) {
                return __awaiter50(_this, void 0, void 0, function() {
                  var options, _a3, Key, Bucket2, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, res;
                  return __generator51(this, function(_b2) {
                    switch (_b2.label) {
                      case 0:
                        this.setupEventListener(part);
                        options = { emitter: part.emitter };
                        _a3 = this.params, Key = _a3.Key, Bucket2 = _a3.Bucket, SSECustomerAlgorithm = _a3.SSECustomerAlgorithm, SSECustomerKey = _a3.SSECustomerKey, SSECustomerKeyMD5 = _a3.SSECustomerKeyMD5;
                        return [4, this.s3client.send(new UploadPartCommand(__assign32(__assign32(__assign32({
                          PartNumber: part.partNumber,
                          Body: part.bodyPart,
                          UploadId: uploadId,
                          Key,
                          Bucket: Bucket2
                        }, SSECustomerAlgorithm && { SSECustomerAlgorithm }), SSECustomerKey && { SSECustomerKey }), SSECustomerKeyMD5 && { SSECustomerKeyMD5 })), options)];
                      case 1:
                        res = _b2.sent();
                        return [2, res];
                    }
                  });
                });
              }))];
            case 1:
              allResults = _a2.sent();
              for (i2 = 0; i2 < allResults.length; i2++) {
                this.completedParts.push({
                  PartNumber: parts[i2].partNumber,
                  ETag: allResults[i2].ETag
                });
              }
              return [3, 3];
            case 2:
              error_3 = _a2.sent();
              logger30.error("Error happened while uploading a part. Cancelling the multipart upload");
              throw error_3;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSS3ProviderManagedUpload2.prototype.finishMultiPartUpload = function(uploadId) {
      return __awaiter50(this, void 0, void 0, function() {
        var input, completeUploadCommand, data, error_4;
        return __generator51(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              input = {
                Bucket: this.params.Bucket,
                Key: this.params.Key,
                UploadId: uploadId,
                MultipartUpload: { Parts: this.completedParts }
              };
              completeUploadCommand = new CompleteMultipartUploadCommand(input);
              _a2.label = 1;
            case 1:
              _a2.trys.push([1, 3, , 4]);
              return [4, this.s3client.send(completeUploadCommand)];
            case 2:
              data = _a2.sent();
              return [2, data.Key];
            case 3:
              error_4 = _a2.sent();
              logger30.error("Error happened while finishing the upload.");
              throw error_4;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSS3ProviderManagedUpload2.prototype.cleanup = function(uploadId) {
      return __awaiter50(this, void 0, void 0, function() {
        var input, data;
        return __generator51(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              this.body = null;
              this.completedParts = [];
              this.bytesUploaded = 0;
              this.totalBytesToUpload = 0;
              if (!uploadId) {
                return [
                  2
                  /*return*/
                ];
              }
              input = {
                Bucket: this.params.Bucket,
                Key: this.params.Key,
                UploadId: uploadId
              };
              return [4, this.s3client.send(new AbortMultipartUploadCommand(input))];
            case 1:
              _a2.sent();
              return [4, this.s3client.send(new ListPartsCommand(input))];
            case 2:
              data = _a2.sent();
              if (data && data.Parts && data.Parts.length > 0) {
                throw new Error("Multipart upload clean up failed.");
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSS3ProviderManagedUpload2.prototype.removeEventListener = function(part) {
      part.emitter.removeAllListeners(SEND_UPLOAD_PROGRESS_EVENT);
      part.emitter.removeAllListeners(SEND_DOWNLOAD_PROGRESS_EVENT);
    };
    AWSS3ProviderManagedUpload2.prototype.setupEventListener = function(part) {
      var _this = this;
      part.emitter.on(SEND_UPLOAD_PROGRESS_EVENT, function(progress) {
        _this.progressChanged(part.partNumber, progress.loaded - part._lastUploadedBytes);
        part._lastUploadedBytes = progress.loaded;
      });
    };
    AWSS3ProviderManagedUpload2.prototype.progressChanged = function(partNumber, incrementalUpdate) {
      this.bytesUploaded += incrementalUpdate;
      this.emitter.emit(SEND_UPLOAD_PROGRESS_EVENT, {
        loaded: this.bytesUploaded,
        total: this.totalBytesToUpload,
        part: partNumber,
        key: this.params.Key
      });
    };
    AWSS3ProviderManagedUpload2.prototype.byteLength = function(input) {
      if (input === null || input === void 0)
        return 0;
      if (typeof input.byteLength === "number") {
        return input.byteLength;
      } else if (typeof input.length === "number") {
        return input.length;
      } else if (typeof input.size === "number") {
        return input.size;
      } else if (typeof input.path === "string") {
      } else {
        throw new Error("Cannot determine length of " + input);
      }
    };
    AWSS3ProviderManagedUpload2.prototype.validateAndSanitizeBody = function(body) {
      var sanitizedBody = this.isGenericObject(body) ? JSON.stringify(body) : body;
      if (this.byteLength(sanitizedBody) > MAX_OBJECT_SIZE) {
        throw new Error("File size bigger than S3 Object limit of 5TB, got " + this.totalBytesToUpload + " Bytes");
      }
      return sanitizedBody;
    };
    AWSS3ProviderManagedUpload2.prototype.isGenericObject = function(body) {
      if (body !== null && typeof body === "object") {
        try {
          return !(this.byteLength(body) >= 0);
        } catch (error) {
          return true;
        }
      }
      return false;
    };
    AWSS3ProviderManagedUpload2.prototype._createNewS3Client = function(config, emitter) {
      var s3client = createS3Client(config, StorageAction.Put, emitter);
      s3client.middlewareStack.add(createPrefixMiddleware(this.opts, this.params.Key), prefixMiddlewareOptions);
      s3client.middlewareStack.add(autoAdjustClockskewMiddleware(s3client.config), autoAdjustClockskewMiddlewareOptions);
      return s3client;
    };
    return AWSS3ProviderManagedUpload2;
  }()
);

// node_modules/@aws-amplify/storage/lib-esm/providers/AWSS3UploadTask.js
var import_axios2 = __toESM(require_axios2());
var logger31 = new ConsoleLogger("AWSS3UploadTask");
var AWSS3UploadTaskState;
(function(AWSS3UploadTaskState2) {
  AWSS3UploadTaskState2[AWSS3UploadTaskState2["INIT"] = 0] = "INIT";
  AWSS3UploadTaskState2[AWSS3UploadTaskState2["IN_PROGRESS"] = 1] = "IN_PROGRESS";
  AWSS3UploadTaskState2[AWSS3UploadTaskState2["PAUSED"] = 2] = "PAUSED";
  AWSS3UploadTaskState2[AWSS3UploadTaskState2["CANCELLED"] = 3] = "CANCELLED";
  AWSS3UploadTaskState2[AWSS3UploadTaskState2["COMPLETED"] = 4] = "COMPLETED";
})(AWSS3UploadTaskState || (AWSS3UploadTaskState = {}));
var TaskEvents;
(function(TaskEvents2) {
  TaskEvents2["CANCEL"] = "cancel";
  TaskEvents2["UPLOAD_COMPLETE"] = "uploadComplete";
  TaskEvents2["UPLOAD_PROGRESS"] = "uploadPartProgress";
  TaskEvents2["ERROR"] = "error";
})(TaskEvents || (TaskEvents = {}));
function comparePartNumber(a2, b2) {
  return a2.PartNumber - b2.PartNumber;
}
var AWSS3UploadTask = (
  /** @class */
  function() {
    function AWSS3UploadTask2(_a2) {
      var s3Client = _a2.s3Client, file = _a2.file, emitter = _a2.emitter, storage = _a2.storage, params = _a2.params, level = _a2.level, prefixPromise = _a2.prefixPromise;
      this.queueSize = DEFAULT_QUEUE_SIZE;
      this.partSize = DEFAULT_PART_SIZE;
      this.inProgress = [];
      this.completedParts = [];
      this.queued = [];
      this.bytesUploaded = 0;
      this.totalBytes = 0;
      this.state = AWSS3UploadTaskState.INIT;
      this.prefixPromise = prefixPromise;
      this.s3client = s3Client;
      this.s3client.middlewareStack.remove(SET_CONTENT_LENGTH_HEADER);
      this.storage = storage;
      this.storageSync = Promise.resolve();
      if (typeof this.storage["sync"] === "function") {
        this.storageSync = this.storage["sync"]();
      }
      this.params = params;
      this.file = file;
      this.totalBytes = this.file.size;
      this.bytesUploaded = 0;
      this.emitter = emitter;
      this.queued = [];
      this.fileId = this._getFileId(level);
      this._validateParams();
      this.emitter.on(TaskEvents.ERROR, function() {
      });
    }
    Object.defineProperty(AWSS3UploadTask2.prototype, "percent", {
      get: function() {
        return this.bytesUploaded / this.totalBytes * 100;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(AWSS3UploadTask2.prototype, "isInProgress", {
      get: function() {
        return this.state === AWSS3UploadTaskState.IN_PROGRESS;
      },
      enumerable: true,
      configurable: true
    });
    AWSS3UploadTask2.prototype._listSingleFile = function(_a2) {
      var key = _a2.key, bucket = _a2.bucket;
      return __awaiter50(this, void 0, void 0, function() {
        var listObjectRes, _b2, Contents, prefix, obj;
        return __generator51(this, function(_c) {
          switch (_c.label) {
            case 0:
              return [4, this.s3client.send(new ListObjectsV2Command({
                Bucket: bucket,
                Prefix: key
              }))];
            case 1:
              listObjectRes = _c.sent();
              _b2 = listObjectRes.Contents, Contents = _b2 === void 0 ? [] : _b2;
              return [4, this.prefixPromise];
            case 2:
              prefix = _c.sent();
              obj = Contents.find(function(o2) {
                return o2.Key === "" + prefix + key;
              });
              return [2, obj];
          }
        });
      });
    };
    AWSS3UploadTask2.prototype._getFileId = function(level) {
      if (isFile(this.file)) {
        return [
          this.file.name,
          this.file.lastModified,
          this.file.size,
          this.file.type,
          this.params.Bucket,
          level,
          this.params.Key
        ].join("-");
      } else {
        return [
          this.file.size,
          this.file.type,
          this.params.Bucket,
          level,
          this.params.Key
        ].join("-");
      }
    };
    AWSS3UploadTask2.prototype._findCachedUploadParts = function() {
      return __awaiter50(this, void 0, void 0, function() {
        var uploadRequests, cachedUploadFileData, listPartsOutput;
        return __generator51(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this._listCachedUploadTasks()];
            case 1:
              uploadRequests = _a2.sent();
              if (Object.keys(uploadRequests).length === 0 || !Object.prototype.hasOwnProperty.call(uploadRequests, this.fileId)) {
                return [2, { parts: [], uploadId: null }];
              }
              cachedUploadFileData = uploadRequests[this.fileId];
              cachedUploadFileData.lastTouched = Date.now();
              this.storage.setItem(UPLOADS_STORAGE_KEY, JSON.stringify(uploadRequests));
              return [4, this.s3client.send(new ListPartsCommand({
                Bucket: this.params.Bucket,
                Key: this.params.Key,
                UploadId: cachedUploadFileData.uploadId
              }))];
            case 2:
              listPartsOutput = _a2.sent();
              return [2, {
                parts: listPartsOutput.Parts || [],
                uploadId: cachedUploadFileData.uploadId
              }];
          }
        });
      });
    };
    AWSS3UploadTask2.prototype._emitEvent = function(event, payload) {
      this.emitter.emit(event, payload);
    };
    AWSS3UploadTask2.prototype._validateParams = function() {
      if (this.totalBytes > MAX_OBJECT_SIZE) {
        throw new Error("File size bigger than S3 Object limit of 5TB, got " + this.totalBytes + " Bytes");
      }
    };
    AWSS3UploadTask2.prototype._listCachedUploadTasks = function() {
      return __awaiter50(this, void 0, void 0, function() {
        var tasks;
        return __generator51(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this.storageSync];
            case 1:
              _a2.sent();
              tasks = this.storage.getItem(UPLOADS_STORAGE_KEY) || "{}";
              return [2, JSON.parse(tasks)];
          }
        });
      });
    };
    AWSS3UploadTask2.prototype._cache = function(fileMetadata) {
      return __awaiter50(this, void 0, void 0, function() {
        var uploadRequests;
        return __generator51(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this._listCachedUploadTasks()];
            case 1:
              uploadRequests = _a2.sent();
              uploadRequests[this.fileId] = fileMetadata;
              this.storage.setItem(UPLOADS_STORAGE_KEY, JSON.stringify(uploadRequests));
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSS3UploadTask2.prototype._isCached = function() {
      return __awaiter50(this, void 0, void 0, function() {
        var _a2, _b2;
        return __generator51(this, function(_c) {
          switch (_c.label) {
            case 0:
              _b2 = (_a2 = Object.prototype.hasOwnProperty).call;
              return [4, this._listCachedUploadTasks()];
            case 1:
              return [2, _b2.apply(_a2, [
                _c.sent(),
                this.fileId
              ])];
          }
        });
      });
    };
    AWSS3UploadTask2.prototype._removeFromCache = function() {
      return __awaiter50(this, void 0, void 0, function() {
        var uploadRequests;
        return __generator51(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this._listCachedUploadTasks()];
            case 1:
              uploadRequests = _a2.sent();
              delete uploadRequests[this.fileId];
              this.storage.setItem(UPLOADS_STORAGE_KEY, JSON.stringify(uploadRequests));
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSS3UploadTask2.prototype._onPartUploadCompletion = function(_a2) {
      var eTag = _a2.eTag, partNumber = _a2.partNumber, chunk = _a2.chunk;
      return __awaiter50(this, void 0, void 0, function() {
        return __generator51(this, function(_b2) {
          this.completedParts.push({
            ETag: eTag,
            PartNumber: partNumber
          });
          this.bytesUploaded += byteLength(chunk);
          this._emitEvent(TaskEvents.UPLOAD_PROGRESS, {
            loaded: this.bytesUploaded,
            total: this.totalBytes
          });
          this.inProgress = this.inProgress.filter(function(job) {
            return job.uploadPartInput.PartNumber !== partNumber;
          });
          if (this.queued.length && this.state !== AWSS3UploadTaskState.PAUSED)
            this._startNextPart();
          if (this._isDone())
            this._completeUpload();
          return [
            2
            /*return*/
          ];
        });
      });
    };
    AWSS3UploadTask2.prototype._completeUpload = function() {
      return __awaiter50(this, void 0, void 0, function() {
        var err_1;
        return __generator51(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 3, , 4]);
              return [4, this.s3client.send(new CompleteMultipartUploadCommand({
                Bucket: this.params.Bucket,
                Key: this.params.Key,
                UploadId: this.uploadId,
                MultipartUpload: {
                  // Parts are not always completed in order, we need to manually sort them
                  Parts: this.completedParts.sort(comparePartNumber)
                }
              }))];
            case 1:
              _a2.sent();
              return [4, this._verifyFileSize()];
            case 2:
              _a2.sent();
              this._emitEvent(TaskEvents.UPLOAD_COMPLETE, {
                key: this.params.Key
              });
              this._removeFromCache();
              this.state = AWSS3UploadTaskState.COMPLETED;
              return [3, 4];
            case 3:
              err_1 = _a2.sent();
              logger31.error("error completing upload", err_1);
              this._emitEvent(TaskEvents.ERROR, err_1);
              return [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSS3UploadTask2.prototype._makeUploadPartRequest = function(input, cancelTokenSource) {
      return __awaiter50(this, void 0, void 0, function() {
        var res, err_2;
        return __generator51(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 3, , 4]);
              return [4, this.s3client.send(new UploadPartCommand(input), {
                cancelTokenSource
              })];
            case 1:
              res = _a2.sent();
              return [4, this._onPartUploadCompletion({
                eTag: res.ETag,
                partNumber: input.PartNumber,
                chunk: input.Body
              })];
            case 2:
              _a2.sent();
              return [3, 4];
            case 3:
              err_2 = _a2.sent();
              if (this.state === AWSS3UploadTaskState.PAUSED) {
                logger31.log("upload paused");
              } else if (this.state === AWSS3UploadTaskState.CANCELLED) {
                logger31.log("upload aborted");
              } else {
                logger31.error("error starting next part of upload: ", err_2);
              }
              if (!import_axios2.default.isCancel(err_2) && err_2.message !== AWSS3ProviderUploadErrorStrings.UPLOAD_PAUSED_MESSAGE) {
                this._emitEvent(TaskEvents.ERROR, err_2);
                this.pause();
              }
              return [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSS3UploadTask2.prototype._startNextPart = function() {
      if (this.queued.length > 0 && this.state !== AWSS3UploadTaskState.PAUSED) {
        var cancelTokenSource = import_axios2.default.CancelToken.source();
        var nextPart = this.queued.shift();
        this.inProgress.push({
          uploadPartInput: nextPart,
          s3Request: this._makeUploadPartRequest(nextPart, cancelTokenSource),
          cancel: cancelTokenSource.cancel
        });
      }
    };
    AWSS3UploadTask2.prototype._verifyFileSize = function() {
      return __awaiter50(this, void 0, void 0, function() {
        var valid, obj, e_1;
        return __generator51(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 2, , 3]);
              return [4, this._listSingleFile({
                key: this.params.Key,
                bucket: this.params.Bucket
              })];
            case 1:
              obj = _a2.sent();
              valid = Boolean(obj && obj.Size === this.file.size);
              return [3, 3];
            case 2:
              e_1 = _a2.sent();
              logger31.log("Could not get file on s3 for size matching: ", e_1);
              return [
                2
                /*return*/
              ];
            case 3:
              if (!valid) {
                throw new Error("File size does not match between local file and file on s3");
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSS3UploadTask2.prototype._isDone = function() {
      return !this.queued.length && !this.inProgress.length && this.bytesUploaded === this.totalBytes;
    };
    AWSS3UploadTask2.prototype._createParts = function() {
      var size = this.file.size;
      var parts = [];
      for (var bodyStart = 0; bodyStart < size; ) {
        var bodyEnd = Math.min(bodyStart + this.partSize, size);
        parts.push({
          Body: this.file.slice(bodyStart, bodyEnd),
          Key: this.params.Key,
          Bucket: this.params.Bucket,
          PartNumber: parts.length + 1,
          UploadId: this.uploadId
        });
        bodyStart += this.partSize;
      }
      return parts;
    };
    AWSS3UploadTask2.prototype._initCachedUploadParts = function(cachedParts) {
      this.bytesUploaded += cachedParts.reduce(function(acc, part) {
        return acc + part.Size;
      }, 0);
      var uploadedPartNumSet = new Set(cachedParts.map(function(part) {
        return part.PartNumber;
      }));
      this.queued = this.queued.filter(function(part) {
        return !uploadedPartNumSet.has(part.PartNumber);
      });
      this.completedParts = cachedParts.map(function(part) {
        return {
          PartNumber: part.PartNumber,
          ETag: part.ETag
        };
      });
      this._emitEvent(TaskEvents.UPLOAD_PROGRESS, {
        loaded: this.bytesUploaded,
        total: this.totalBytes
      });
    };
    AWSS3UploadTask2.prototype._initMultipartUpload = function() {
      return __awaiter50(this, void 0, void 0, function() {
        var res;
        return __generator51(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this.s3client.send(new CreateMultipartUploadCommand(this.params))];
            case 1:
              res = _a2.sent();
              this._cache({
                uploadId: res.UploadId,
                lastTouched: Date.now(),
                bucket: this.params.Bucket,
                key: this.params.Key,
                fileName: this.file instanceof File ? this.file.name : ""
              });
              return [2, res.UploadId];
          }
        });
      });
    };
    AWSS3UploadTask2.prototype._initializeUploadTask = function() {
      return __awaiter50(this, void 0, void 0, function() {
        var _a2, parts, uploadId, uploadId, err_3;
        return __generator51(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              this.state = AWSS3UploadTaskState.IN_PROGRESS;
              this.partSize = calculatePartSize(this.totalBytes);
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 7, , 8]);
              return [4, this._isCached()];
            case 2:
              if (!_b2.sent())
                return [3, 4];
              return [4, this._findCachedUploadParts()];
            case 3:
              _a2 = _b2.sent(), parts = _a2.parts, uploadId = _a2.uploadId;
              this.uploadId = uploadId;
              this.queued = this._createParts();
              this._initCachedUploadParts(parts);
              this._startUpload();
              return [3, 6];
            case 4:
              if (!!this.uploadId)
                return [3, 6];
              return [4, this._initMultipartUpload()];
            case 5:
              uploadId = _b2.sent();
              this.uploadId = uploadId;
              this.queued = this._createParts();
              this._startUpload();
              _b2.label = 6;
            case 6:
              return [3, 8];
            case 7:
              err_3 = _b2.sent();
              if (!import_axios2.default.isCancel(err_3)) {
                logger31.error("Error initializing the upload task", err_3);
                this._emitEvent(TaskEvents.ERROR, err_3);
              }
              return [3, 8];
            case 8:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSS3UploadTask2.prototype.resume = function() {
      if (this.state === AWSS3UploadTaskState.CANCELLED) {
        logger31.warn("This task has already been cancelled");
      } else if (this.state === AWSS3UploadTaskState.COMPLETED) {
        logger31.warn("This task has already been completed");
      } else if (this.state === AWSS3UploadTaskState.IN_PROGRESS) {
        logger31.warn("Upload task already in progress");
      } else if (!this.uploadId) {
        this._initializeUploadTask();
      } else {
        this._startUpload();
      }
    };
    AWSS3UploadTask2.prototype._startUpload = function() {
      this.state = AWSS3UploadTaskState.IN_PROGRESS;
      for (var i2 = 0; i2 < this.queueSize; i2++) {
        this._startNextPart();
      }
    };
    AWSS3UploadTask2.prototype._cancel = function() {
      return __awaiter50(this, void 0, void 0, function() {
        var err_4;
        return __generator51(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (!(this.state === AWSS3UploadTaskState.CANCELLED))
                return [3, 1];
              logger31.warn("This task has already been cancelled");
              return [2, false];
            case 1:
              if (!(this.state === AWSS3UploadTaskState.COMPLETED))
                return [3, 2];
              logger31.warn("This task has already been completed");
              return [2, false];
            case 2:
              this.pause();
              this.queued = [];
              this.completedParts = [];
              this.bytesUploaded = 0;
              this.state = AWSS3UploadTaskState.CANCELLED;
              _a2.label = 3;
            case 3:
              _a2.trys.push([3, 6, , 7]);
              return [4, this.s3client.send(new AbortMultipartUploadCommand({
                Bucket: this.params.Bucket,
                Key: this.params.Key,
                UploadId: this.uploadId
              }))];
            case 4:
              _a2.sent();
              return [4, this._removeFromCache()];
            case 5:
              _a2.sent();
              return [2, true];
            case 6:
              err_4 = _a2.sent();
              logger31.error("Error cancelling upload task", err_4);
              return [2, false];
            case 7:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSS3UploadTask2.prototype.pause = function() {
      var _a2;
      if (this.state === AWSS3UploadTaskState.CANCELLED) {
        logger31.warn("This task has already been cancelled");
      } else if (this.state === AWSS3UploadTaskState.COMPLETED) {
        logger31.warn("This task has already been completed");
      } else if (this.state === AWSS3UploadTaskState.PAUSED) {
        logger31.warn("This task is already paused");
      }
      this.state = AWSS3UploadTaskState.PAUSED;
      var removedInProgressReq = this.inProgress.splice(0, this.inProgress.length);
      removedInProgressReq.forEach(function(req) {
        req.cancel(AWSS3ProviderUploadErrorStrings.UPLOAD_PAUSED_MESSAGE);
      });
      (_a2 = this.queued).unshift.apply(_a2, __spread12(removedInProgressReq.map(function(req) {
        return req.uploadPartInput;
      })));
    };
    return AWSS3UploadTask2;
  }()
);

// node_modules/@aws-amplify/storage/lib-esm/providers/AWSS3Provider.js
var events2 = __toESM(require_events());
var logger32 = new ConsoleLogger("AWSS3Provider");
var DEFAULT_STORAGE_LEVEL = "public";
var DEFAULT_PRESIGN_EXPIRATION = 900;
var AWSS3Provider = (
  /** @class */
  function() {
    function AWSS3Provider2(config) {
      var _this = this;
      this._config = config ? config : {};
      this._storage = new StorageHelper().getStorage();
      Hub.listen("auth", function(data) {
        var payload = data.payload;
        if (payload.event === "signOut" || payload.event === "signIn") {
          _this._storage.removeItem(UPLOADS_STORAGE_KEY);
        }
      });
      logger32.debug("Storage Options", this._config);
    }
    AWSS3Provider2.prototype.getCategory = function() {
      return AWSS3Provider2.CATEGORY;
    };
    AWSS3Provider2.prototype.getProviderName = function() {
      return AWSS3Provider2.PROVIDER_NAME;
    };
    AWSS3Provider2.prototype.configure = function(config) {
      logger32.debug("configure Storage", config);
      if (!config)
        return this._config;
      var amplifyConfig = parseAWSExports(config);
      this._config = Object.assign({}, this._config, amplifyConfig.Storage);
      if (!this._config.bucket) {
        logger32.debug("Do not have bucket yet");
      }
      return this._config;
    };
    AWSS3Provider2.prototype.startResumableUpload = function(addTaskInput, config) {
      var s3Client = addTaskInput.s3Client, emitter = addTaskInput.emitter, key = addTaskInput.key, file = addTaskInput.file, params = addTaskInput.params;
      var progressCallback = config.progressCallback, completeCallback = config.completeCallback, errorCallback = config.errorCallback, _a2 = config.track, track = _a2 === void 0 ? false : _a2;
      if (!(file instanceof Blob)) {
        throw new Error(StorageErrorStrings.INVALID_BLOB);
      }
      emitter.on(TaskEvents.UPLOAD_PROGRESS, function(event) {
        if (progressCallback) {
          if (typeof progressCallback === "function") {
            progressCallback(event);
          } else {
            logger32.warn("progressCallback should be a function, not a " + typeof progressCallback);
          }
        }
      });
      emitter.on(TaskEvents.UPLOAD_COMPLETE, function(event) {
        if (completeCallback) {
          if (typeof completeCallback === "function") {
            completeCallback(event);
          } else {
            logger32.warn("completeCallback should be a function, not a " + typeof completeCallback);
          }
        }
      });
      emitter.on(TaskEvents.ERROR, function(err) {
        if (errorCallback) {
          if (typeof errorCallback === "function") {
            errorCallback(err);
          } else {
            logger32.warn("errorCallback should be a function, not a " + typeof errorCallback);
          }
        }
      });
      var prefixPromise = Credentials.get().then(function(credentials) {
        var cred = Credentials.shear(credentials);
        return getPrefix(__assign32(__assign32({}, config), { credentials: cred }));
      });
      var task = new AWSS3UploadTask({
        s3Client,
        file,
        emitter,
        level: config.level,
        storage: this._storage,
        params,
        prefixPromise
      });
      dispatchStorageEvent(track, "upload", { method: "put", result: "success" }, null, "Upload Task created successfully for " + key);
      task.resume();
      return task;
    };
    AWSS3Provider2.prototype.copy = function(src, dest, config) {
      return __awaiter50(this, void 0, void 0, function() {
        var credentialsOK, opt, acl, bucket, cacheControl, expires, track, serverSideEncryption, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, SSEKMSKeyId, _a2, srcLevel, srcIdentityId, srcKey, _b2, destLevel, destKey, srcPrefix, destPrefix, finalSrcKey, finalDestKey, params, s3, error_1;
        return __generator51(this, function(_c) {
          switch (_c.label) {
            case 0:
              return [4, this._ensureCredentials()];
            case 1:
              credentialsOK = _c.sent();
              if (!credentialsOK || !this._isWithCredentials(this._config)) {
                throw new Error(StorageErrorStrings.NO_CREDENTIALS);
              }
              opt = Object.assign({}, this._config, config);
              acl = opt.acl, bucket = opt.bucket, cacheControl = opt.cacheControl, expires = opt.expires, track = opt.track, serverSideEncryption = opt.serverSideEncryption, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, SSEKMSKeyId = opt.SSEKMSKeyId;
              _a2 = src.level, srcLevel = _a2 === void 0 ? DEFAULT_STORAGE_LEVEL : _a2, srcIdentityId = src.identityId, srcKey = src.key;
              _b2 = dest.level, destLevel = _b2 === void 0 ? DEFAULT_STORAGE_LEVEL : _b2, destKey = dest.key;
              if (!srcKey || typeof srcKey !== "string") {
                throw new Error(StorageErrorStrings.NO_SRC_KEY);
              }
              if (!destKey || typeof destKey !== "string") {
                throw new Error(StorageErrorStrings.NO_DEST_KEY);
              }
              if (srcLevel !== "protected" && srcIdentityId) {
                logger32.warn(`You may copy files from another user if the source level is "protected", currently it's ` + srcLevel);
              }
              srcPrefix = this._prefix(__assign32(__assign32(__assign32({}, opt), { level: srcLevel }), srcIdentityId && { identityId: srcIdentityId }));
              destPrefix = this._prefix(__assign32(__assign32({}, opt), { level: destLevel }));
              finalSrcKey = bucket + "/" + srcPrefix + srcKey;
              finalDestKey = "" + destPrefix + destKey;
              logger32.debug("copying " + finalSrcKey + " to " + finalDestKey);
              params = {
                Bucket: bucket,
                CopySource: finalSrcKey,
                Key: finalDestKey,
                // Copies over metadata like contentType as well
                MetadataDirective: "COPY"
              };
              if (cacheControl)
                params.CacheControl = cacheControl;
              if (expires)
                params.Expires = expires;
              if (serverSideEncryption) {
                params.ServerSideEncryption = serverSideEncryption;
              }
              if (SSECustomerAlgorithm) {
                params.SSECustomerAlgorithm = SSECustomerAlgorithm;
              }
              if (SSECustomerKey) {
                params.SSECustomerKey = SSECustomerKey;
              }
              if (SSECustomerKeyMD5) {
                params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
              }
              if (SSEKMSKeyId) {
                params.SSEKMSKeyId = SSEKMSKeyId;
              }
              if (acl)
                params.ACL = acl;
              s3 = this._createNewS3Client(opt, StorageAction.Copy);
              _c.label = 2;
            case 2:
              _c.trys.push([2, 4, , 5]);
              return [4, s3.send(new CopyObjectCommand(params))];
            case 3:
              _c.sent();
              dispatchStorageEvent(track, "copy", {
                method: "copy",
                result: "success"
              }, null, "Copy success from " + srcKey + " to " + destKey);
              return [2, {
                key: destKey
              }];
            case 4:
              error_1 = _c.sent();
              dispatchStorageEvent(track, "copy", {
                method: "copy",
                result: "failed"
              }, null, "Copy failed from " + srcKey + " to " + destKey);
              throw error_1;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSS3Provider2.prototype.get = function(key, config) {
      var _a2;
      return __awaiter50(this, void 0, void 0, function() {
        var credentialsOK, opt, bucket, download, cacheControl, contentDisposition, contentEncoding, contentLanguage, contentType, expires, track, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, progressCallback, _b2, validateObjectExistence, prefix, final_key, emitter, s3, params, getObjectCommand, response, error_2, headObjectCommand, error_3, signer, request, url2, _c, error_4;
        return __generator51(this, function(_d) {
          switch (_d.label) {
            case 0:
              return [4, this._ensureCredentials()];
            case 1:
              credentialsOK = _d.sent();
              if (!credentialsOK || !this._isWithCredentials(this._config)) {
                throw new Error(StorageErrorStrings.NO_CREDENTIALS);
              }
              opt = Object.assign({}, this._config, config);
              bucket = opt.bucket, download = opt.download, cacheControl = opt.cacheControl, contentDisposition = opt.contentDisposition, contentEncoding = opt.contentEncoding, contentLanguage = opt.contentLanguage, contentType = opt.contentType, expires = opt.expires, track = opt.track, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, progressCallback = opt.progressCallback, _b2 = opt.validateObjectExistence, validateObjectExistence = _b2 === void 0 ? false : _b2;
              prefix = this._prefix(opt);
              final_key = prefix + key;
              emitter = new events2.EventEmitter();
              s3 = this._createNewS3Client(opt, StorageAction.Get, emitter);
              logger32.debug("get " + key + " from " + final_key);
              params = {
                Bucket: bucket,
                Key: final_key
              };
              if (cacheControl)
                params.ResponseCacheControl = cacheControl;
              if (contentDisposition)
                params.ResponseContentDisposition = contentDisposition;
              if (contentEncoding)
                params.ResponseContentEncoding = contentEncoding;
              if (contentLanguage)
                params.ResponseContentLanguage = contentLanguage;
              if (contentType)
                params.ResponseContentType = contentType;
              if (SSECustomerAlgorithm) {
                params.SSECustomerAlgorithm = SSECustomerAlgorithm;
              }
              if (SSECustomerKey) {
                params.SSECustomerKey = SSECustomerKey;
              }
              if (SSECustomerKeyMD5) {
                params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
              }
              if (!(download === true))
                return [3, 5];
              getObjectCommand = new GetObjectCommand(params);
              _d.label = 2;
            case 2:
              _d.trys.push([2, 4, , 5]);
              if (progressCallback) {
                if (typeof progressCallback === "function") {
                  emitter.on(SEND_DOWNLOAD_PROGRESS_EVENT, function(progress) {
                    progressCallback(progress);
                  });
                } else {
                  logger32.warn("progressCallback should be a function, not a " + typeof progressCallback);
                }
              }
              return [4, s3.send(getObjectCommand)];
            case 3:
              response = _d.sent();
              emitter.removeAllListeners(SEND_DOWNLOAD_PROGRESS_EVENT);
              dispatchStorageEvent(track, "download", { method: "get", result: "success" }, {
                fileSize: Number(response.Body["size"] || response.Body["length"])
              }, "Download success for " + key);
              return [2, response];
            case 4:
              error_2 = _d.sent();
              dispatchStorageEvent(track, "download", {
                method: "get",
                result: "failed"
              }, null, "Download failed with " + error_2.message);
              throw error_2;
            case 5:
              if (!validateObjectExistence)
                return [3, 9];
              headObjectCommand = new HeadObjectCommand(params);
              _d.label = 6;
            case 6:
              _d.trys.push([6, 8, , 9]);
              return [4, s3.send(headObjectCommand)];
            case 7:
              _d.sent();
              return [3, 9];
            case 8:
              error_3 = _d.sent();
              if (((_a2 = error_3.$metadata) === null || _a2 === void 0 ? void 0 : _a2.httpStatusCode) === 404) {
                dispatchStorageEvent(track, "getSignedUrl", {
                  method: "get",
                  result: "failed"
                }, null, key + " not found");
              }
              throw error_3;
            case 9:
              _d.trys.push([9, 12, , 13]);
              signer = new S3RequestPresigner(__assign32({}, s3.config));
              return [4, createRequest(s3, new GetObjectCommand(params))];
            case 10:
              request = _d.sent();
              _c = formatUrl;
              return [4, signer.presign(request, {
                expiresIn: expires || DEFAULT_PRESIGN_EXPIRATION
              })];
            case 11:
              url2 = _c.apply(void 0, [_d.sent()]);
              dispatchStorageEvent(track, "getSignedUrl", { method: "get", result: "success" }, null, "Signed URL: " + url2);
              return [2, url2];
            case 12:
              error_4 = _d.sent();
              logger32.warn("get signed url error", error_4);
              dispatchStorageEvent(track, "getSignedUrl", { method: "get", result: "failed" }, null, "Could not get a signed URL for " + key);
              throw error_4;
            case 13:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSS3Provider2.prototype.getProperties = function(key, config) {
      var _a2;
      return __awaiter50(this, void 0, void 0, function() {
        var credentialsOK, opt, bucket, _b2, track, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, prefix, final_key, emitter, s3, params, headObjectCommand, response, getPropertiesResponse, error_5;
        return __generator51(this, function(_c) {
          switch (_c.label) {
            case 0:
              return [4, this._ensureCredentials()];
            case 1:
              credentialsOK = _c.sent();
              if (!credentialsOK || !this._isWithCredentials(this._config)) {
                throw new Error(StorageErrorStrings.NO_CREDENTIALS);
              }
              opt = Object.assign({}, this._config, config);
              bucket = opt.bucket, _b2 = opt.track, track = _b2 === void 0 ? false : _b2, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5;
              prefix = this._prefix(opt);
              final_key = prefix + key;
              emitter = new events2.EventEmitter();
              s3 = this._createNewS3Client(opt, StorageAction.GetProperties, emitter);
              logger32.debug("getProperties " + key + " from " + final_key);
              params = {
                Bucket: bucket,
                Key: final_key
              };
              if (SSECustomerAlgorithm) {
                params.SSECustomerAlgorithm = SSECustomerAlgorithm;
              }
              if (SSECustomerKey) {
                params.SSECustomerKey = SSECustomerKey;
              }
              if (SSECustomerKeyMD5) {
                params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
              }
              headObjectCommand = new HeadObjectCommand(params);
              _c.label = 2;
            case 2:
              _c.trys.push([2, 4, , 5]);
              return [4, s3.send(headObjectCommand)];
            case 3:
              response = _c.sent();
              getPropertiesResponse = {
                contentLength: response.ContentLength,
                contentType: response.ContentType,
                eTag: response.ETag,
                lastModified: response.LastModified,
                metadata: response.Metadata
              };
              dispatchStorageEvent(track, "getProperties", { method: "getProperties", result: "success" }, null, "getProperties successful for " + key);
              return [2, getPropertiesResponse];
            case 4:
              error_5 = _c.sent();
              if (((_a2 = error_5.$metadata) === null || _a2 === void 0 ? void 0 : _a2.httpStatusCode) === 404) {
                dispatchStorageEvent(track, "getProperties", {
                  method: "getProperties",
                  result: "failed"
                }, null, key + " not found");
              }
              throw error_5;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSS3Provider2.prototype.put = function(key, object, config) {
      var opt = Object.assign({}, this._config, config);
      var bucket = opt.bucket, track = opt.track, progressCallback = opt.progressCallback, level = opt.level, resumable = opt.resumable;
      var contentType = opt.contentType, contentDisposition = opt.contentDisposition, contentEncoding = opt.contentEncoding, cacheControl = opt.cacheControl, expires = opt.expires, metadata = opt.metadata, tagging = opt.tagging, acl = opt.acl;
      var serverSideEncryption = opt.serverSideEncryption, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, SSEKMSKeyId = opt.SSEKMSKeyId;
      var type = contentType ? contentType : "binary/octet-stream";
      var params = {
        Bucket: bucket,
        Key: key,
        Body: object,
        ContentType: type
      };
      if (cacheControl) {
        params.CacheControl = cacheControl;
      }
      if (contentDisposition) {
        params.ContentDisposition = contentDisposition;
      }
      if (contentEncoding) {
        params.ContentEncoding = contentEncoding;
      }
      if (expires) {
        params.Expires = expires;
      }
      if (metadata) {
        params.Metadata = metadata;
      }
      if (tagging) {
        params.Tagging = tagging;
      }
      if (serverSideEncryption) {
        params.ServerSideEncryption = serverSideEncryption;
      }
      if (SSECustomerAlgorithm) {
        params.SSECustomerAlgorithm = SSECustomerAlgorithm;
      }
      if (SSECustomerKey) {
        params.SSECustomerKey = SSECustomerKey;
      }
      if (SSECustomerKeyMD5) {
        params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
      }
      if (SSEKMSKeyId) {
        params.SSEKMSKeyId = SSEKMSKeyId;
      }
      var emitter = new events2.EventEmitter();
      var uploader = new AWSS3ProviderManagedUpload(params, opt, emitter);
      if (acl) {
        params.ACL = acl;
      }
      if (resumable === true) {
        var s3Client = this._createNewS3Client(opt, StorageAction.Put);
        s3Client.middlewareStack.add(createPrefixMiddleware(opt, key), prefixMiddlewareOptions);
        var addTaskInput = {
          bucket,
          key,
          s3Client,
          file: object,
          emitter,
          accessLevel: level,
          params
        };
        return this.startResumableUpload(addTaskInput, config);
      }
      try {
        if (progressCallback) {
          if (typeof progressCallback === "function") {
            emitter.on(SEND_UPLOAD_PROGRESS_EVENT, function(progress) {
              progressCallback(progress);
            });
          } else {
            logger32.warn("progressCallback should be a function, not a " + typeof progressCallback);
          }
        }
        return uploader.upload().then(function(response) {
          logger32.debug("upload result", response);
          dispatchStorageEvent(track, "upload", { method: "put", result: "success" }, null, "Upload success for " + key);
          return { key };
        });
      } catch (error) {
        logger32.warn("error uploading", error);
        dispatchStorageEvent(track, "upload", { method: "put", result: "failed" }, null, "Error uploading " + key);
        throw error;
      }
    };
    AWSS3Provider2.prototype.remove = function(key, config) {
      return __awaiter50(this, void 0, void 0, function() {
        var credentialsOK, opt, bucket, track, prefix, final_key, s3, params, deleteObjectCommand, response, error_6;
        return __generator51(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this._ensureCredentials()];
            case 1:
              credentialsOK = _a2.sent();
              if (!credentialsOK || !this._isWithCredentials(this._config)) {
                throw new Error(StorageErrorStrings.NO_CREDENTIALS);
              }
              opt = Object.assign({}, this._config, config);
              bucket = opt.bucket, track = opt.track;
              prefix = this._prefix(opt);
              final_key = prefix + key;
              s3 = this._createNewS3Client(opt, StorageAction.Remove);
              logger32.debug("remove " + key + " from " + final_key);
              params = {
                Bucket: bucket,
                Key: final_key
              };
              deleteObjectCommand = new DeleteObjectCommand(params);
              _a2.label = 2;
            case 2:
              _a2.trys.push([2, 4, , 5]);
              return [4, s3.send(deleteObjectCommand)];
            case 3:
              response = _a2.sent();
              dispatchStorageEvent(track, "delete", { method: "remove", result: "success" }, null, "Deleted " + key + " successfully");
              return [2, response];
            case 4:
              error_6 = _a2.sent();
              dispatchStorageEvent(track, "delete", { method: "remove", result: "failed" }, null, "Deletion of " + key + " failed with " + error_6);
              throw error_6;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSS3Provider2.prototype._list = function(params, opt, prefix) {
      return __awaiter50(this, void 0, void 0, function() {
        var list, s3, listObjectsV2Command, response;
        return __generator51(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              list = {
                results: [],
                hasNextToken: false
              };
              s3 = this._createNewS3Client(opt, StorageAction.List);
              listObjectsV2Command = new ListObjectsV2Command(__assign32({}, params));
              return [4, s3.send(listObjectsV2Command)];
            case 1:
              response = _a2.sent();
              if (response && response.Contents) {
                list.results = response.Contents.map(function(item) {
                  return {
                    key: item.Key.substr(prefix.length),
                    eTag: item.ETag,
                    lastModified: item.LastModified,
                    size: item.Size
                  };
                });
                list.nextToken = response.NextContinuationToken;
                list.hasNextToken = response.IsTruncated;
              }
              return [2, list];
          }
        });
      });
    };
    AWSS3Provider2.prototype.list = function(path, config) {
      var _a2;
      return __awaiter50(this, void 0, void 0, function() {
        var credentialsOK, opt, bucket, track, pageSize, nextToken, prefix, final_path, list, MAX_PAGE_SIZE, listResult, params, error_7;
        var _b2, _c;
        return __generator51(this, function(_d) {
          switch (_d.label) {
            case 0:
              return [4, this._ensureCredentials()];
            case 1:
              credentialsOK = _d.sent();
              if (!credentialsOK || !this._isWithCredentials(this._config)) {
                throw new Error(StorageErrorStrings.NO_CREDENTIALS);
              }
              opt = Object.assign({}, this._config, config);
              bucket = opt.bucket, track = opt.track, pageSize = opt.pageSize, nextToken = opt.nextToken;
              prefix = this._prefix(opt);
              final_path = prefix + path;
              logger32.debug("list " + path + " from " + final_path);
              _d.label = 2;
            case 2:
              _d.trys.push([2, 10, , 11]);
              list = {
                results: [],
                hasNextToken: false
              };
              MAX_PAGE_SIZE = 1e3;
              listResult = void 0;
              params = {
                Bucket: bucket,
                Prefix: final_path,
                MaxKeys: MAX_PAGE_SIZE,
                ContinuationToken: nextToken
              };
              params.ContinuationToken = nextToken;
              if (!(pageSize === "ALL"))
                return [3, 7];
              _d.label = 3;
            case 3:
              return [4, this._list(params, opt, prefix)];
            case 4:
              listResult = _d.sent();
              (_b2 = list.results).push.apply(_b2, __spread12(listResult.results));
              if (listResult.nextToken)
                params.ContinuationToken = listResult.nextToken;
              _d.label = 5;
            case 5:
              if (listResult.nextToken)
                return [3, 3];
              _d.label = 6;
            case 6:
              return [3, 9];
            case 7:
              if (pageSize && pageSize <= MAX_PAGE_SIZE && typeof pageSize === "number")
                params.MaxKeys = pageSize;
              else
                logger32.warn("pageSize should be from 0 - " + MAX_PAGE_SIZE + ".");
              return [4, this._list(params, opt, prefix)];
            case 8:
              listResult = _d.sent();
              (_c = list.results).push.apply(_c, __spread12(listResult.results));
              list.hasNextToken = listResult.hasNextToken;
              list.nextToken = (_a2 = null) !== null && _a2 !== void 0 ? _a2 : listResult.nextToken;
              _d.label = 9;
            case 9:
              dispatchStorageEvent(track, "list", { method: "list", result: "success" }, null, list.results.length + " items returned from list operation");
              logger32.debug("list", list);
              return [2, list];
            case 10:
              error_7 = _d.sent();
              logger32.error("list InvalidArgument", error_7);
              dispatchStorageEvent(track, "list", { method: "list", result: "failed" }, null, "Listing items failed: " + error_7.message);
              throw error_7;
            case 11:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSS3Provider2.prototype._ensureCredentials = function() {
      return __awaiter50(this, void 0, void 0, function() {
        var credentials, cred, error_8;
        return __generator51(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 2, , 3]);
              return [4, Credentials.get()];
            case 1:
              credentials = _a2.sent();
              if (!credentials)
                return [2, false];
              cred = Credentials.shear(credentials);
              logger32.debug("set credentials for storage", cred);
              this._config.credentials = cred;
              return [2, true];
            case 2:
              error_8 = _a2.sent();
              logger32.warn("ensure credentials error", error_8);
              return [2, false];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSS3Provider2.prototype._isWithCredentials = function(config) {
      return typeof config === "object" && config.hasOwnProperty("credentials");
    };
    AWSS3Provider2.prototype._prefix = function(config) {
      var credentials = config.credentials, level = config.level;
      var customPrefix = config.customPrefix || {};
      var identityId = config.identityId || credentials.identityId;
      var privatePath = (customPrefix.private !== void 0 ? customPrefix.private : "private/") + identityId + "/";
      var protectedPath = (customPrefix.protected !== void 0 ? customPrefix.protected : "protected/") + identityId + "/";
      var publicPath = customPrefix.public !== void 0 ? customPrefix.public : "public/";
      switch (level) {
        case "private":
          return privatePath;
        case "protected":
          return protectedPath;
        default:
          return publicPath;
      }
    };
    AWSS3Provider2.prototype._createNewS3Client = function(config, storageAction, emitter) {
      var s3client = createS3Client(config, storageAction, emitter);
      s3client.middlewareStack.add(autoAdjustClockskewMiddleware(s3client.config), autoAdjustClockskewMiddlewareOptions);
      return s3client;
    };
    AWSS3Provider2.CATEGORY = "Storage";
    AWSS3Provider2.PROVIDER_NAME = "AWSS3";
    return AWSS3Provider2;
  }()
);

// node_modules/@aws-amplify/storage/lib-esm/Storage.js
var import_axios3 = __toESM(require_axios2());
var logger33 = new ConsoleLogger("StorageClass");
var loggerStorageInstance = new ConsoleLogger("Storage");
var DEFAULT_PROVIDER = "AWSS3";
var Storage = (
  /** @class */
  function() {
    function Storage2() {
      this._config = {};
      this._pluggables = [];
      this._cancelTokenSourceMap = /* @__PURE__ */ new WeakMap();
      logger33.debug("Storage Options", this._config);
      this.get = this.get.bind(this);
      this.put = this.put.bind(this);
      this.remove = this.remove.bind(this);
      this.list = this.list.bind(this);
    }
    Storage2.prototype.getModuleName = function() {
      return "Storage";
    };
    Storage2.prototype.addPluggable = function(pluggable) {
      if (pluggable && pluggable.getCategory() === "Storage") {
        this._pluggables.push(pluggable);
        var config = {};
        config = pluggable.configure(this._config[pluggable.getProviderName()]);
        return config;
      }
    };
    Storage2.prototype.getPluggable = function(providerName) {
      var pluggable = this._pluggables.find(function(pluggable2) {
        return pluggable2.getProviderName() === providerName;
      });
      if (pluggable === void 0) {
        logger33.debug("No plugin found with providerName", providerName);
        return null;
      } else
        return pluggable;
    };
    Storage2.prototype.removePluggable = function(providerName) {
      this._pluggables = this._pluggables.filter(function(pluggable) {
        return pluggable.getProviderName() !== providerName;
      });
      return;
    };
    Storage2.prototype.configure = function(config) {
      var _this = this;
      var _a2;
      logger33.debug("configure Storage");
      if (!config)
        return this._config;
      var amplifyConfig = parseAWSExports(config);
      var storageConfig = (_a2 = amplifyConfig.Storage) !== null && _a2 !== void 0 ? _a2 : {};
      var defaultProviderConfigKeys = [
        "bucket",
        "region",
        "level",
        "track",
        "customPrefix",
        "serverSideEncryption",
        "SSECustomerAlgorithm",
        "SSECustomerKey",
        "SSECustomerKeyMD5",
        "SSEKMSKeyId"
      ];
      var hasDefaultProviderConfigKeys = function(config2) {
        return Object.keys(config2).find(function(key) {
          return defaultProviderConfigKeys.includes(key);
        });
      };
      if (hasDefaultProviderConfigKeys(storageConfig) && !storageConfig[DEFAULT_PROVIDER]) {
        storageConfig[DEFAULT_PROVIDER] = {};
      }
      Object.entries(storageConfig).forEach(function(_a3) {
        var _b2 = __read29(_a3, 2), key = _b2[0], value = _b2[1];
        if (key && defaultProviderConfigKeys.includes(key) && value !== void 0) {
          storageConfig[DEFAULT_PROVIDER][key] = value;
          delete storageConfig[key];
        }
      });
      Object.keys(storageConfig).forEach(function(providerName) {
        if (typeof storageConfig[providerName] !== "string") {
          _this._config[providerName] = __assign32(__assign32({}, _this._config[providerName]), storageConfig[providerName]);
        }
      });
      this._pluggables.forEach(function(pluggable) {
        pluggable.configure(_this._config[pluggable.getProviderName()]);
      });
      if (this._pluggables.length === 0) {
        this.addPluggable(new AWSS3Provider());
      }
      return this._config;
    };
    Storage2.prototype.getCancellableTokenSource = function() {
      return import_axios3.default.CancelToken.source();
    };
    Storage2.prototype.updateRequestToBeCancellable = function(request, cancelTokenSource) {
      this._cancelTokenSourceMap.set(request, cancelTokenSource);
    };
    Storage2.prototype.isUploadTask = function(x2) {
      return typeof x2 !== "undefined" && typeof x2["pause"] === "function" && typeof x2["resume"] === "function";
    };
    Storage2.prototype.cancel = function(request, message) {
      if (request instanceof AWSS3UploadTask) {
        return request._cancel();
      }
      var cancelTokenSource = this._cancelTokenSourceMap.get(request);
      if (cancelTokenSource) {
        cancelTokenSource.cancel(message);
      } else {
        logger33.debug("The request does not map to any cancel token");
      }
    };
    Storage2.prototype.copy = function(src, dest, config) {
      var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
      var plugin = this._pluggables.find(function(pluggable) {
        return pluggable.getProviderName() === provider;
      });
      if (plugin === void 0) {
        logger33.debug("No plugin found with providerName", provider);
        return Promise.reject("No plugin found in Storage for the provider");
      }
      var cancelTokenSource = this.getCancellableTokenSource();
      if (typeof plugin.copy !== "function") {
        return Promise.reject(".copy is not implemented on provider " + plugin.getProviderName());
      }
      var responsePromise = plugin.copy(src, dest, __assign32(__assign32({}, config), { cancelTokenSource }));
      this.updateRequestToBeCancellable(responsePromise, cancelTokenSource);
      return responsePromise;
    };
    Storage2.prototype.get = function(key, config) {
      var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
      var plugin = this._pluggables.find(function(pluggable) {
        return pluggable.getProviderName() === provider;
      });
      if (plugin === void 0) {
        logger33.debug("No plugin found with providerName", provider);
        return Promise.reject("No plugin found in Storage for the provider");
      }
      var cancelTokenSource = this.getCancellableTokenSource();
      var responsePromise = plugin.get(key, __assign32(__assign32({}, config), { cancelTokenSource }));
      this.updateRequestToBeCancellable(responsePromise, cancelTokenSource);
      return responsePromise;
    };
    Storage2.prototype.isCancelError = function(error) {
      return import_axios3.default.isCancel(error);
    };
    Storage2.prototype.getProperties = function(key, config) {
      var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
      var plugin = this._pluggables.find(function(pluggable) {
        return pluggable.getProviderName() === provider;
      });
      if (plugin === void 0) {
        logger33.debug("No plugin found with providerName", provider);
        throw new Error("No plugin found with providerName");
      }
      var cancelTokenSource = this.getCancellableTokenSource();
      if (typeof plugin.getProperties !== "function") {
        return Promise.reject(".getProperties is not implemented on provider " + plugin.getProviderName());
      }
      var responsePromise = plugin === null || plugin === void 0 ? void 0 : plugin.getProperties(key, __assign32({}, config));
      this.updateRequestToBeCancellable(responsePromise, cancelTokenSource);
      return responsePromise;
    };
    Storage2.prototype.put = function(key, object, config) {
      var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
      var plugin = this._pluggables.find(function(pluggable) {
        return pluggable.getProviderName() === provider;
      });
      if (plugin === void 0) {
        logger33.debug("No plugin found with providerName", provider);
        return Promise.reject("No plugin found in Storage for the provider");
      }
      var cancelTokenSource = this.getCancellableTokenSource();
      var response = plugin.put(key, object, __assign32(__assign32({}, config), { cancelTokenSource }));
      if (!this.isUploadTask(response)) {
        this.updateRequestToBeCancellable(response, cancelTokenSource);
      }
      return response;
    };
    Storage2.prototype.remove = function(key, config) {
      var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
      var plugin = this._pluggables.find(function(pluggable) {
        return pluggable.getProviderName() === provider;
      });
      if (plugin === void 0) {
        logger33.debug("No plugin found with providerName", provider);
        return Promise.reject("No plugin found in Storage for the provider");
      }
      return plugin.remove(key, config);
    };
    Storage2.prototype.list = function(path, config) {
      var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
      var plugin = this._pluggables.find(function(pluggable) {
        return pluggable.getProviderName() === provider;
      });
      if (plugin === void 0) {
        logger33.debug("No plugin found with providerName", provider);
        return Promise.reject("No plugin found in Storage for the provider");
      }
      return plugin.list(path, config);
    };
    return Storage2;
  }()
);
var _instance2 = null;
var getInstance2 = function() {
  if (_instance2) {
    return _instance2;
  }
  loggerStorageInstance.debug("Create Storage Instance, debug");
  _instance2 = new Storage();
  _instance2.vault = new Storage();
  var old_configure = _instance2.configure;
  _instance2.configure = function(options) {
    loggerStorageInstance.debug("storage configure called");
    var vaultConfig = __assign32({}, old_configure.call(_instance2, options));
    Object.keys(vaultConfig).forEach(function(providerName) {
      if (typeof vaultConfig[providerName] !== "string") {
        vaultConfig[providerName] = __assign32(__assign32({}, vaultConfig[providerName]), { level: "private" });
      }
    });
    loggerStorageInstance.debug("storage vault configure called");
    _instance2.vault.configure(vaultConfig);
  };
  return _instance2;
};
var StorageInstance = getInstance2();
Amplify.register(StorageInstance);

// node_modules/@aws-amplify/api/node_modules/tslib/tslib.es6.js
var extendStatics6 = function(d2, b2) {
  extendStatics6 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b3) {
    d3.__proto__ = b3;
  } || function(d3, b3) {
    for (var p2 in b3)
      if (b3.hasOwnProperty(p2))
        d3[p2] = b3[p2];
  };
  return extendStatics6(d2, b2);
};
function __extends8(d2, b2) {
  extendStatics6(d2, b2);
  function __() {
    this.constructor = d2;
  }
  d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
}
var __assign40 = function() {
  __assign40 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign40.apply(this, arguments);
};
function __awaiter64(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator65(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-amplify/api-graphql/node_modules/tslib/tslib.es6.js
var extendStatics7 = function(d2, b2) {
  extendStatics7 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b3) {
    d3.__proto__ = b3;
  } || function(d3, b3) {
    for (var p2 in b3)
      if (b3.hasOwnProperty(p2))
        d3[p2] = b3[p2];
  };
  return extendStatics7(d2, b2);
};
function __extends9(d2, b2) {
  extendStatics7(d2, b2);
  function __() {
    this.constructor = d2;
  }
  d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
}
var __assign41 = function() {
  __assign41 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign41.apply(this, arguments);
};
function __rest11(s2, e) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
}
function __awaiter65(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator66(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __read34(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}

// node_modules/graphql/jsutils/isObjectLike.mjs
function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof5(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function _typeof5(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
function isObjectLike(value) {
  return _typeof(value) == "object" && value !== null;
}

// node_modules/graphql/polyfills/symbols.mjs
var SYMBOL_ITERATOR = typeof Symbol === "function" && Symbol.iterator != null ? Symbol.iterator : "@@iterator";
var SYMBOL_ASYNC_ITERATOR = typeof Symbol === "function" && Symbol.asyncIterator != null ? Symbol.asyncIterator : "@@asyncIterator";
var SYMBOL_TO_STRING_TAG = typeof Symbol === "function" && Symbol.toStringTag != null ? Symbol.toStringTag : "@@toStringTag";

// node_modules/graphql/language/location.mjs
function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match;
  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }
  return {
    line,
    column
  };
}

// node_modules/graphql/language/printLocation.mjs
function printLocation(location) {
  return printSourceLocation(location.source, getLocation(location.source, location.start));
}
function printSourceLocation(source, sourceLocation) {
  var firstLineColumnOffset = source.locationOffset.column - 1;
  var body = whitespace(firstLineColumnOffset) + source.body;
  var lineIndex = sourceLocation.line - 1;
  var lineOffset = source.locationOffset.line - 1;
  var lineNum = sourceLocation.line + lineOffset;
  var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  var columnNum = sourceLocation.column + columnOffset;
  var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
  var lines = body.split(/\r\n|[\n\r]/g);
  var locationLine = lines[lineIndex];
  if (locationLine.length > 120) {
    var subLineIndex = Math.floor(columnNum / 80);
    var subLineColumnNum = columnNum % 80;
    var subLines = [];
    for (var i2 = 0; i2 < locationLine.length; i2 += 80) {
      subLines.push(locationLine.slice(i2, i2 + 80));
    }
    return locationStr + printPrefixedLines([["".concat(lineNum), subLines[0]]].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
      return ["", subLine];
    }), [[" ", whitespace(subLineColumnNum - 1) + "^"], ["", subLines[subLineIndex + 1]]]));
  }
  return locationStr + printPrefixedLines([
    // Lines specified like this: ["prefix", "string"],
    ["".concat(lineNum - 1), lines[lineIndex - 1]],
    ["".concat(lineNum), locationLine],
    ["", whitespace(columnNum - 1) + "^"],
    ["".concat(lineNum + 1), lines[lineIndex + 1]]
  ]);
}
function printPrefixedLines(lines) {
  var existingLines = lines.filter(function(_ref) {
    var _2 = _ref[0], line = _ref[1];
    return line !== void 0;
  });
  var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
    var prefix = _ref2[0];
    return prefix.length;
  }));
  return existingLines.map(function(_ref3) {
    var prefix = _ref3[0], line = _ref3[1];
    return leftPad(padLen, prefix) + (line ? " | " + line : " |");
  }).join("\n");
}
function whitespace(len) {
  return Array(len + 1).join(" ");
}
function leftPad(len, str) {
  return whitespace(len - str.length) + str;
}

// node_modules/graphql/error/GraphQLError.mjs
function _typeof2(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof2 = function _typeof5(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof2 = function _typeof5(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof2(obj);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  if (superClass)
    _setPrototypeOf4(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct2();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf2(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf2(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof2(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self2);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _wrapNativeSuper2(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper2 = function _wrapNativeSuper3(Class2) {
    if (Class2 === null || !_isNativeFunction2(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct2(Class2, arguments, _getPrototypeOf2(this).constructor);
    }
    Wrapper.prototype = Object.create(Class2.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } });
    return _setPrototypeOf4(Wrapper, Class2);
  };
  return _wrapNativeSuper2(Class);
}
function _construct2(Parent, args, Class) {
  if (_isNativeReflectConstruct2()) {
    _construct2 = Reflect.construct;
  } else {
    _construct2 = function _construct3(Parent2, args2, Class2) {
      var a2 = [null];
      a2.push.apply(a2, args2);
      var Constructor = Function.bind.apply(Parent2, a2);
      var instance2 = new Constructor();
      if (Class2)
        _setPrototypeOf4(instance2, Class2.prototype);
      return instance2;
    };
  }
  return _construct2.apply(null, arguments);
}
function _isNativeReflectConstruct2() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction2(fn2) {
  return Function.toString.call(fn2).indexOf("[native code]") !== -1;
}
function _setPrototypeOf4(o2, p2) {
  _setPrototypeOf4 = Object.setPrototypeOf || function _setPrototypeOf5(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf4(o2, p2);
}
function _getPrototypeOf2(o2) {
  _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf3(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf2(o2);
}
var GraphQLError = /* @__PURE__ */ function(_Error2) {
  _inherits(GraphQLError2, _Error2);
  var _super = _createSuper(GraphQLError2);
  function GraphQLError2(message, nodes, source, positions, path, originalError, extensions) {
    var _nodeLocations, _nodeLocations2, _nodeLocations3;
    var _this;
    _classCallCheck(this, GraphQLError2);
    _this = _super.call(this, message);
    _this.name = "GraphQLError";
    _this.originalError = originalError !== null && originalError !== void 0 ? originalError : void 0;
    _this.nodes = undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [nodes] : void 0);
    var nodeLocations = [];
    for (var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++) {
      var _this$nodes;
      var _ref4 = _ref3[_i2];
      var loc = _ref4.loc;
      if (loc != null) {
        nodeLocations.push(loc);
      }
    }
    nodeLocations = undefinedIfEmpty(nodeLocations);
    _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
    _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc2) {
      return loc2.start;
    });
    _this.locations = positions && source ? positions.map(function(pos) {
      return getLocation(source, pos);
    }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc2) {
      return getLocation(loc2.source, loc2.start);
    });
    _this.path = path !== null && path !== void 0 ? path : void 0;
    var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
    if (extensions == null && isObjectLike(originalExtensions)) {
      _this.extensions = _objectSpread({}, originalExtensions);
    } else {
      _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
    }
    Object.defineProperties(_assertThisInitialized(_this), {
      message: {
        enumerable: true
      },
      locations: {
        enumerable: _this.locations != null
      },
      path: {
        enumerable: _this.path != null
      },
      extensions: {
        enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
      },
      name: {
        enumerable: false
      },
      nodes: {
        enumerable: false
      },
      source: {
        enumerable: false
      },
      positions: {
        enumerable: false
      },
      originalError: {
        enumerable: false
      }
    });
    if (originalError !== null && originalError !== void 0 && originalError.stack) {
      Object.defineProperty(_assertThisInitialized(_this), "stack", {
        value: originalError.stack,
        writable: true,
        configurable: true
      });
      return _possibleConstructorReturn(_this);
    }
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), GraphQLError2);
    } else {
      Object.defineProperty(_assertThisInitialized(_this), "stack", {
        value: Error().stack,
        writable: true,
        configurable: true
      });
    }
    return _this;
  }
  _createClass(GraphQLError2, [{
    key: "toString",
    value: function toString() {
      return printError(this);
    }
    // FIXME: workaround to not break chai comparisons, should be remove in v16
    // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
  }, {
    key: SYMBOL_TO_STRING_TAG,
    get: function get3() {
      return "Object";
    }
  }]);
  return GraphQLError2;
}(/* @__PURE__ */ _wrapNativeSuper2(Error));
function undefinedIfEmpty(array) {
  return array === void 0 || array.length === 0 ? void 0 : array;
}
function printError(error) {
  var output = error.message;
  if (error.nodes) {
    for (var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++) {
      var node = _error$nodes2[_i4];
      if (node.loc) {
        output += "\n\n" + printLocation(node.loc);
      }
    }
  } else if (error.source && error.locations) {
    for (var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++) {
      var location = _error$locations2[_i6];
      output += "\n\n" + printSourceLocation(error.source, location);
    }
  }
  return output;
}

// node_modules/graphql/error/syntaxError.mjs
function syntaxError(source, position, description) {
  return new GraphQLError("Syntax Error: ".concat(description), void 0, source, [position]);
}

// node_modules/graphql/language/kinds.mjs
var Kind = Object.freeze({
  // Name
  NAME: "Name",
  // Document
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  // Fragments
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  // Values
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  // Directives
  DIRECTIVE: "Directive",
  // Types
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType",
  // Type System Definitions
  SCHEMA_DEFINITION: "SchemaDefinition",
  OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
  // Type Definitions
  SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
  OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
  FIELD_DEFINITION: "FieldDefinition",
  INPUT_VALUE_DEFINITION: "InputValueDefinition",
  INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
  UNION_TYPE_DEFINITION: "UnionTypeDefinition",
  ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
  ENUM_VALUE_DEFINITION: "EnumValueDefinition",
  INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
  // Directive Definitions
  DIRECTIVE_DEFINITION: "DirectiveDefinition",
  // Type System Extensions
  SCHEMA_EXTENSION: "SchemaExtension",
  // Type Extensions
  SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
  OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
  INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
  UNION_TYPE_EXTENSION: "UnionTypeExtension",
  ENUM_TYPE_EXTENSION: "EnumTypeExtension",
  INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
});

// node_modules/graphql/jsutils/invariant.mjs
function invariant(condition, message) {
  var booleanCondition = Boolean(condition);
  if (!booleanCondition) {
    throw new Error(message != null ? message : "Unexpected invariant triggered.");
  }
}

// node_modules/graphql/jsutils/nodejsCustomInspectSymbol.mjs
var nodejsCustomInspectSymbol = typeof Symbol === "function" && typeof Symbol.for === "function" ? Symbol.for("nodejs.util.inspect.custom") : void 0;
var nodejsCustomInspectSymbol_default = nodejsCustomInspectSymbol;

// node_modules/graphql/jsutils/defineInspect.mjs
function defineInspect(classObject) {
  var fn2 = classObject.prototype.toJSON;
  typeof fn2 === "function" || invariant(0);
  classObject.prototype.inspect = fn2;
  if (nodejsCustomInspectSymbol_default) {
    classObject.prototype[nodejsCustomInspectSymbol_default] = fn2;
  }
}

// node_modules/graphql/language/ast.mjs
var Location = /* @__PURE__ */ function() {
  function Location2(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }
  var _proto = Location2.prototype;
  _proto.toJSON = function toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  };
  return Location2;
}();
defineInspect(Location);
var Token = /* @__PURE__ */ function() {
  function Token2(kind, start, end, line, column, prev, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column;
    this.value = value;
    this.prev = prev;
    this.next = null;
  }
  var _proto2 = Token2.prototype;
  _proto2.toJSON = function toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  };
  return Token2;
}();
defineInspect(Token);
function isNode(maybeNode) {
  return maybeNode != null && typeof maybeNode.kind === "string";
}

// node_modules/graphql/language/tokenKind.mjs
var TokenKind = Object.freeze({
  SOF: "<SOF>",
  EOF: "<EOF>",
  BANG: "!",
  DOLLAR: "$",
  AMP: "&",
  PAREN_L: "(",
  PAREN_R: ")",
  SPREAD: "...",
  COLON: ":",
  EQUALS: "=",
  AT: "@",
  BRACKET_L: "[",
  BRACKET_R: "]",
  BRACE_L: "{",
  PIPE: "|",
  BRACE_R: "}",
  NAME: "Name",
  INT: "Int",
  FLOAT: "Float",
  STRING: "String",
  BLOCK_STRING: "BlockString",
  COMMENT: "Comment"
});

// node_modules/graphql/jsutils/inspect.mjs
function _typeof3(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof3 = function _typeof5(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof3 = function _typeof5(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof3(obj);
}
var MAX_ARRAY_LENGTH = 10;
var MAX_RECURSIVE_DEPTH = 2;
function inspect(value) {
  return formatValue(value, []);
}
function formatValue(value, seenValues) {
  switch (_typeof3(value)) {
    case "string":
      return JSON.stringify(value);
    case "function":
      return value.name ? "[function ".concat(value.name, "]") : "[function]";
    case "object":
      if (value === null) {
        return "null";
      }
      return formatObjectValue(value, seenValues);
    default:
      return String(value);
  }
}
function formatObjectValue(value, previouslySeenValues) {
  if (previouslySeenValues.indexOf(value) !== -1) {
    return "[Circular]";
  }
  var seenValues = [].concat(previouslySeenValues, [value]);
  var customInspectFn = getCustomFn(value);
  if (customInspectFn !== void 0) {
    var customValue = customInspectFn.call(value);
    if (customValue !== value) {
      return typeof customValue === "string" ? customValue : formatValue(customValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }
  return formatObject(value, seenValues);
}
function formatObject(object, seenValues) {
  var keys = Object.keys(object);
  if (keys.length === 0) {
    return "{}";
  }
  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return "[" + getObjectTag(object) + "]";
  }
  var properties = keys.map(function(key) {
    var value = formatValue(object[key], seenValues);
    return key + ": " + value;
  });
  return "{ " + properties.join(", ") + " }";
}
function formatArray(array, seenValues) {
  if (array.length === 0) {
    return "[]";
  }
  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return "[Array]";
  }
  var len = Math.min(MAX_ARRAY_LENGTH, array.length);
  var remaining = array.length - len;
  var items = [];
  for (var i2 = 0; i2 < len; ++i2) {
    items.push(formatValue(array[i2], seenValues));
  }
  if (remaining === 1) {
    items.push("... 1 more item");
  } else if (remaining > 1) {
    items.push("... ".concat(remaining, " more items"));
  }
  return "[" + items.join(", ") + "]";
}
function getCustomFn(object) {
  var customInspectFn = object[String(nodejsCustomInspectSymbol_default)];
  if (typeof customInspectFn === "function") {
    return customInspectFn;
  }
  if (typeof object.inspect === "function") {
    return object.inspect;
  }
}
function getObjectTag(object) {
  var tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
  if (tag === "Object" && typeof object.constructor === "function") {
    var name = object.constructor.name;
    if (typeof name === "string" && name !== "") {
      return name;
    }
  }
  return tag;
}

// node_modules/graphql/jsutils/devAssert.mjs
function devAssert(condition, message) {
  var booleanCondition = Boolean(condition);
  if (!booleanCondition) {
    throw new Error(message);
  }
}

// node_modules/graphql/jsutils/instanceOf.mjs
function _typeof4(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof4 = function _typeof5(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof4 = function _typeof5(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof4(obj);
}
var instanceOf_default = __vite_process_env_NODE_ENV === "production" ? (
  // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
  // eslint-disable-next-line no-shadow
  function instanceOf(value, constructor) {
    return value instanceof constructor;
  }
) : (
  // eslint-disable-next-line no-shadow
  function instanceOf2(value, constructor) {
    if (value instanceof constructor) {
      return true;
    }
    if (_typeof4(value) === "object" && value !== null) {
      var _value$constructor;
      var className = constructor.prototype[Symbol.toStringTag];
      var valueClassName = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in value ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name
      );
      if (className === valueClassName) {
        var stringifiedValue = inspect(value);
        throw new Error("Cannot use ".concat(className, ' "').concat(stringifiedValue, '" from another module or realm.\n\nEnsure that there is only one instance of "graphql" in the node_modules\ndirectory. If different versions of "graphql" are the dependencies of other\nrelied on modules, use "resolutions" to ensure only one version is installed.\n\nhttps://yarnpkg.com/en/docs/selective-version-resolutions\n\nDuplicate "graphql" modules cannot be used at the same time since different\nversions may have different capabilities and behavior. The data from one\nversion used in the function from another could produce confusing and\nspurious results.'));
      }
    }
    return false;
  }
);

// node_modules/graphql/language/source.mjs
function _defineProperties2(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass2(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties2(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties2(Constructor, staticProps);
  return Constructor;
}
var Source = /* @__PURE__ */ function() {
  function Source2(body) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "GraphQL request";
    var locationOffset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
      line: 1,
      column: 1
    };
    typeof body === "string" || devAssert(0, "Body must be a string. Received: ".concat(inspect(body), "."));
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 || devAssert(0, "line in locationOffset is 1-indexed and must be positive.");
    this.locationOffset.column > 0 || devAssert(0, "column in locationOffset is 1-indexed and must be positive.");
  }
  _createClass2(Source2, [{
    key: SYMBOL_TO_STRING_TAG,
    get: function get3() {
      return "Source";
    }
  }]);
  return Source2;
}();
function isSource(source) {
  return instanceOf_default(source, Source);
}

// node_modules/graphql/language/directiveLocation.mjs
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: "QUERY",
  MUTATION: "MUTATION",
  SUBSCRIPTION: "SUBSCRIPTION",
  FIELD: "FIELD",
  FRAGMENT_DEFINITION: "FRAGMENT_DEFINITION",
  FRAGMENT_SPREAD: "FRAGMENT_SPREAD",
  INLINE_FRAGMENT: "INLINE_FRAGMENT",
  VARIABLE_DEFINITION: "VARIABLE_DEFINITION",
  // Type System Definitions
  SCHEMA: "SCHEMA",
  SCALAR: "SCALAR",
  OBJECT: "OBJECT",
  FIELD_DEFINITION: "FIELD_DEFINITION",
  ARGUMENT_DEFINITION: "ARGUMENT_DEFINITION",
  INTERFACE: "INTERFACE",
  UNION: "UNION",
  ENUM: "ENUM",
  ENUM_VALUE: "ENUM_VALUE",
  INPUT_OBJECT: "INPUT_OBJECT",
  INPUT_FIELD_DEFINITION: "INPUT_FIELD_DEFINITION"
});

// node_modules/graphql/language/blockString.mjs
function dedentBlockStringValue(rawString) {
  var lines = rawString.split(/\r\n|[\n\r]/g);
  var commonIndent = getBlockStringIndentation(rawString);
  if (commonIndent !== 0) {
    for (var i2 = 1; i2 < lines.length; i2++) {
      lines[i2] = lines[i2].slice(commonIndent);
    }
  }
  var startLine = 0;
  while (startLine < lines.length && isBlank(lines[startLine])) {
    ++startLine;
  }
  var endLine = lines.length;
  while (endLine > startLine && isBlank(lines[endLine - 1])) {
    --endLine;
  }
  return lines.slice(startLine, endLine).join("\n");
}
function isBlank(str) {
  for (var i2 = 0; i2 < str.length; ++i2) {
    if (str[i2] !== " " && str[i2] !== "	") {
      return false;
    }
  }
  return true;
}
function getBlockStringIndentation(value) {
  var _commonIndent;
  var isFirstLine = true;
  var isEmptyLine = true;
  var indent2 = 0;
  var commonIndent = null;
  for (var i2 = 0; i2 < value.length; ++i2) {
    switch (value.charCodeAt(i2)) {
      case 13:
        if (value.charCodeAt(i2 + 1) === 10) {
          ++i2;
        }
      case 10:
        isFirstLine = false;
        isEmptyLine = true;
        indent2 = 0;
        break;
      case 9:
      case 32:
        ++indent2;
        break;
      default:
        if (isEmptyLine && !isFirstLine && (commonIndent === null || indent2 < commonIndent)) {
          commonIndent = indent2;
        }
        isEmptyLine = false;
    }
  }
  return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function printBlockString(value) {
  var indentation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  var preferMultipleLines = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  var isSingleLine = value.indexOf("\n") === -1;
  var hasLeadingSpace = value[0] === " " || value[0] === "	";
  var hasTrailingQuote = value[value.length - 1] === '"';
  var hasTrailingSlash = value[value.length - 1] === "\\";
  var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
  var result = "";
  if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) {
    result += "\n" + indentation;
  }
  result += indentation ? value.replace(/\n/g, "\n" + indentation) : value;
  if (printAsMultipleLines) {
    result += "\n";
  }
  return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

// node_modules/graphql/language/lexer.mjs
var Lexer = /* @__PURE__ */ function() {
  function Lexer2(source) {
    var startOfFileToken = new Token(TokenKind.SOF, 0, 0, 0, 0, null);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }
  var _proto = Lexer2.prototype;
  _proto.advance = function advance() {
    this.lastToken = this.token;
    var token = this.token = this.lookahead();
    return token;
  };
  _proto.lookahead = function lookahead() {
    var token = this.token;
    if (token.kind !== TokenKind.EOF) {
      do {
        var _token$next;
        token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = readToken(this, token);
      } while (token.kind === TokenKind.COMMENT);
    }
    return token;
  };
  return Lexer2;
}();
function isPunctuatorTokenKind(kind) {
  return kind === TokenKind.BANG || kind === TokenKind.DOLLAR || kind === TokenKind.AMP || kind === TokenKind.PAREN_L || kind === TokenKind.PAREN_R || kind === TokenKind.SPREAD || kind === TokenKind.COLON || kind === TokenKind.EQUALS || kind === TokenKind.AT || kind === TokenKind.BRACKET_L || kind === TokenKind.BRACKET_R || kind === TokenKind.BRACE_L || kind === TokenKind.PIPE || kind === TokenKind.BRACE_R;
}
function printCharCode(code) {
  return (
    // NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? TokenKind.EOF : (
      // Trust JSON for ASCII.
      code < 127 ? JSON.stringify(String.fromCharCode(code)) : (
        // Otherwise print the escaped form.
        '"\\u'.concat(("00" + code.toString(16).toUpperCase()).slice(-4), '"')
      )
    )
  );
}
function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;
  var pos = prev.end;
  while (pos < bodyLength) {
    var code = body.charCodeAt(pos);
    var _line = lexer.line;
    var _col = 1 + pos - lexer.lineStart;
    switch (code) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++pos;
        continue;
      case 10:
        ++pos;
        ++lexer.line;
        lexer.lineStart = pos;
        continue;
      case 13:
        if (body.charCodeAt(pos + 1) === 10) {
          pos += 2;
        } else {
          ++pos;
        }
        ++lexer.line;
        lexer.lineStart = pos;
        continue;
      case 33:
        return new Token(TokenKind.BANG, pos, pos + 1, _line, _col, prev);
      case 35:
        return readComment(source, pos, _line, _col, prev);
      case 36:
        return new Token(TokenKind.DOLLAR, pos, pos + 1, _line, _col, prev);
      case 38:
        return new Token(TokenKind.AMP, pos, pos + 1, _line, _col, prev);
      case 40:
        return new Token(TokenKind.PAREN_L, pos, pos + 1, _line, _col, prev);
      case 41:
        return new Token(TokenKind.PAREN_R, pos, pos + 1, _line, _col, prev);
      case 46:
        if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) {
          return new Token(TokenKind.SPREAD, pos, pos + 3, _line, _col, prev);
        }
        break;
      case 58:
        return new Token(TokenKind.COLON, pos, pos + 1, _line, _col, prev);
      case 61:
        return new Token(TokenKind.EQUALS, pos, pos + 1, _line, _col, prev);
      case 64:
        return new Token(TokenKind.AT, pos, pos + 1, _line, _col, prev);
      case 91:
        return new Token(TokenKind.BRACKET_L, pos, pos + 1, _line, _col, prev);
      case 93:
        return new Token(TokenKind.BRACKET_R, pos, pos + 1, _line, _col, prev);
      case 123:
        return new Token(TokenKind.BRACE_L, pos, pos + 1, _line, _col, prev);
      case 124:
        return new Token(TokenKind.PIPE, pos, pos + 1, _line, _col, prev);
      case 125:
        return new Token(TokenKind.BRACE_R, pos, pos + 1, _line, _col, prev);
      case 34:
        if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) {
          return readBlockString(source, pos, _line, _col, prev, lexer);
        }
        return readString(source, pos, _line, _col, prev);
      case 45:
      case 48:
      case 49:
      case 50:
      case 51:
      case 52:
      case 53:
      case 54:
      case 55:
      case 56:
      case 57:
        return readNumber(source, pos, code, _line, _col, prev);
      case 65:
      case 66:
      case 67:
      case 68:
      case 69:
      case 70:
      case 71:
      case 72:
      case 73:
      case 74:
      case 75:
      case 76:
      case 77:
      case 78:
      case 79:
      case 80:
      case 81:
      case 82:
      case 83:
      case 84:
      case 85:
      case 86:
      case 87:
      case 88:
      case 89:
      case 90:
      case 95:
      case 97:
      case 98:
      case 99:
      case 100:
      case 101:
      case 102:
      case 103:
      case 104:
      case 105:
      case 106:
      case 107:
      case 108:
      case 109:
      case 110:
      case 111:
      case 112:
      case 113:
      case 114:
      case 115:
      case 116:
      case 117:
      case 118:
      case 119:
      case 120:
      case 121:
      case 122:
        return readName(source, pos, _line, _col, prev);
    }
    throw syntaxError(source, pos, unexpectedCharacterMessage(code));
  }
  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;
  return new Token(TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
}
function unexpectedCharacterMessage(code) {
  if (code < 32 && code !== 9 && code !== 10 && code !== 13) {
    return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
  }
  if (code === 39) {
    return `Unexpected single quote character ('), did you mean to use a double quote (")?`;
  }
  return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code;
  var position = start;
  do {
    code = body.charCodeAt(++position);
  } while (!isNaN(code) && // SourceCharacter but not LineTerminator
  (code > 31 || code === 9));
  return new Token(TokenKind.COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;
  if (code === 45) {
    code = body.charCodeAt(++position);
  }
  if (code === 48) {
    code = body.charCodeAt(++position);
    if (code >= 48 && code <= 57) {
      throw syntaxError(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    }
  } else {
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }
  if (code === 46) {
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }
  if (code === 69 || code === 101) {
    isFloat = true;
    code = body.charCodeAt(++position);
    if (code === 43 || code === 45) {
      code = body.charCodeAt(++position);
    }
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }
  if (code === 46 || isNameStart(code)) {
    throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
  }
  return new Token(isFloat ? TokenKind.FLOAT : TokenKind.INT, start, position, line, col, prev, body.slice(start, position));
}
function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;
  if (code >= 48 && code <= 57) {
    do {
      code = body.charCodeAt(++position);
    } while (code >= 48 && code <= 57);
    return position;
  }
  throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = "";
  while (position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
  code !== 10 && code !== 13) {
    if (code === 34) {
      value += body.slice(chunkStart, position);
      return new Token(TokenKind.STRING, start, position + 1, line, col, prev, value);
    }
    if (code < 32 && code !== 9) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }
    ++position;
    if (code === 92) {
      value += body.slice(chunkStart, position - 1);
      code = body.charCodeAt(position);
      switch (code) {
        case 34:
          value += '"';
          break;
        case 47:
          value += "/";
          break;
        case 92:
          value += "\\";
          break;
        case 98:
          value += "\b";
          break;
        case 102:
          value += "\f";
          break;
        case 110:
          value += "\n";
          break;
        case 114:
          value += "\r";
          break;
        case 116:
          value += "	";
          break;
        case 117: {
          var charCode = uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
          if (charCode < 0) {
            var invalidSequence = body.slice(position + 1, position + 5);
            throw syntaxError(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
          }
          value += String.fromCharCode(charCode);
          position += 4;
          break;
        }
        default:
          throw syntaxError(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
      }
      ++position;
      chunkStart = position;
    }
  }
  throw syntaxError(source, position, "Unterminated string.");
}
function readBlockString(source, start, line, col, prev, lexer) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = "";
  while (position < body.length && !isNaN(code = body.charCodeAt(position))) {
    if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
      rawValue += body.slice(chunkStart, position);
      return new Token(TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, dedentBlockStringValue(rawValue));
    }
    if (code < 32 && code !== 9 && code !== 10 && code !== 13) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }
    if (code === 10) {
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      if (body.charCodeAt(position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }
      ++lexer.line;
      lexer.lineStart = position;
    } else if (
      // Escape Triple-Quote (\""")
      code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34
    ) {
      rawValue += body.slice(chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }
  throw syntaxError(source, position, "Unterminated string.");
}
function uniCharCode(a2, b2, c2, d2) {
  return char2hex(a2) << 12 | char2hex(b2) << 8 | char2hex(c2) << 4 | char2hex(d2);
}
function char2hex(a2) {
  return a2 >= 48 && a2 <= 57 ? a2 - 48 : a2 >= 65 && a2 <= 70 ? a2 - 55 : a2 >= 97 && a2 <= 102 ? a2 - 87 : -1;
}
function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;
  while (position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122)) {
    ++position;
  }
  return new Token(TokenKind.NAME, start, position, line, col, prev, body.slice(start, position));
}
function isNameStart(code) {
  return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

// node_modules/graphql/language/parser.mjs
function parse7(source, options) {
  var parser2 = new Parser2(source, options);
  return parser2.parseDocument();
}
var Parser2 = /* @__PURE__ */ function() {
  function Parser3(source, options) {
    var sourceObj = isSource(source) ? source : new Source(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options;
  }
  var _proto = Parser3.prototype;
  _proto.parseName = function parseName() {
    var token = this.expectToken(TokenKind.NAME);
    return {
      kind: Kind.NAME,
      value: token.value,
      loc: this.loc(token)
    };
  };
  _proto.parseDocument = function parseDocument() {
    var start = this._lexer.token;
    return {
      kind: Kind.DOCUMENT,
      definitions: this.many(TokenKind.SOF, this.parseDefinition, TokenKind.EOF),
      loc: this.loc(start)
    };
  };
  _proto.parseDefinition = function parseDefinition() {
    if (this.peek(TokenKind.NAME)) {
      switch (this._lexer.token.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "schema":
        case "scalar":
        case "type":
        case "interface":
        case "union":
        case "enum":
        case "input":
        case "directive":
          return this.parseTypeSystemDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    } else if (this.peek(TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } else if (this.peekDescription()) {
      return this.parseTypeSystemDefinition();
    }
    throw this.unexpected();
  };
  _proto.parseOperationDefinition = function parseOperationDefinition() {
    var start = this._lexer.token;
    if (this.peek(TokenKind.BRACE_L)) {
      return {
        kind: Kind.OPERATION_DEFINITION,
        operation: "query",
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }
    var operation = this.parseOperationType();
    var name;
    if (this.peek(TokenKind.NAME)) {
      name = this.parseName();
    }
    return {
      kind: Kind.OPERATION_DEFINITION,
      operation,
      name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  };
  _proto.parseOperationType = function parseOperationType() {
    var operationToken = this.expectToken(TokenKind.NAME);
    switch (operationToken.value) {
      case "query":
        return "query";
      case "mutation":
        return "mutation";
      case "subscription":
        return "subscription";
    }
    throw this.unexpected(operationToken);
  };
  _proto.parseVariableDefinitions = function parseVariableDefinitions() {
    return this.optionalMany(TokenKind.PAREN_L, this.parseVariableDefinition, TokenKind.PAREN_R);
  };
  _proto.parseVariableDefinition = function parseVariableDefinition() {
    var start = this._lexer.token;
    return {
      kind: Kind.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(TokenKind.EQUALS) ? this.parseValueLiteral(true) : void 0,
      directives: this.parseDirectives(true),
      loc: this.loc(start)
    };
  };
  _proto.parseVariable = function parseVariable() {
    var start = this._lexer.token;
    this.expectToken(TokenKind.DOLLAR);
    return {
      kind: Kind.VARIABLE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  };
  _proto.parseSelectionSet = function parseSelectionSet() {
    var start = this._lexer.token;
    return {
      kind: Kind.SELECTION_SET,
      selections: this.many(TokenKind.BRACE_L, this.parseSelection, TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  };
  _proto.parseSelection = function parseSelection() {
    return this.peek(TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
  };
  _proto.parseField = function parseField() {
    var start = this._lexer.token;
    var nameOrAlias = this.parseName();
    var alias;
    var name;
    if (this.expectOptionalToken(TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }
    return {
      kind: Kind.FIELD,
      alias,
      name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(TokenKind.BRACE_L) ? this.parseSelectionSet() : void 0,
      loc: this.loc(start)
    };
  };
  _proto.parseArguments = function parseArguments(isConst) {
    var item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(TokenKind.PAREN_L, item, TokenKind.PAREN_R);
  };
  _proto.parseArgument = function parseArgument() {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return {
      kind: Kind.ARGUMENT,
      name,
      value: this.parseValueLiteral(false),
      loc: this.loc(start)
    };
  };
  _proto.parseConstArgument = function parseConstArgument() {
    var start = this._lexer.token;
    return {
      kind: Kind.ARGUMENT,
      name: this.parseName(),
      value: (this.expectToken(TokenKind.COLON), this.parseValueLiteral(true)),
      loc: this.loc(start)
    };
  };
  _proto.parseFragment = function parseFragment() {
    var start = this._lexer.token;
    this.expectToken(TokenKind.SPREAD);
    var hasTypeCondition = this.expectOptionalKeyword("on");
    if (!hasTypeCondition && this.peek(TokenKind.NAME)) {
      return {
        kind: Kind.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
        loc: this.loc(start)
      };
    }
    return {
      kind: Kind.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  };
  _proto.parseFragmentDefinition = function parseFragmentDefinition() {
    var _this$_options;
    var start = this._lexer.token;
    this.expectKeyword("fragment");
    if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) {
      return {
        kind: Kind.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }
    return {
      kind: Kind.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  };
  _proto.parseFragmentName = function parseFragmentName() {
    if (this._lexer.token.value === "on") {
      throw this.unexpected();
    }
    return this.parseName();
  };
  _proto.parseValueLiteral = function parseValueLiteral(isConst) {
    var token = this._lexer.token;
    switch (token.kind) {
      case TokenKind.BRACKET_L:
        return this.parseList(isConst);
      case TokenKind.BRACE_L:
        return this.parseObject(isConst);
      case TokenKind.INT:
        this._lexer.advance();
        return {
          kind: Kind.INT,
          value: token.value,
          loc: this.loc(token)
        };
      case TokenKind.FLOAT:
        this._lexer.advance();
        return {
          kind: Kind.FLOAT,
          value: token.value,
          loc: this.loc(token)
        };
      case TokenKind.STRING:
      case TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();
      case TokenKind.NAME:
        this._lexer.advance();
        switch (token.value) {
          case "true":
            return {
              kind: Kind.BOOLEAN,
              value: true,
              loc: this.loc(token)
            };
          case "false":
            return {
              kind: Kind.BOOLEAN,
              value: false,
              loc: this.loc(token)
            };
          case "null":
            return {
              kind: Kind.NULL,
              loc: this.loc(token)
            };
          default:
            return {
              kind: Kind.ENUM,
              value: token.value,
              loc: this.loc(token)
            };
        }
      case TokenKind.DOLLAR:
        if (!isConst) {
          return this.parseVariable();
        }
        break;
    }
    throw this.unexpected();
  };
  _proto.parseStringLiteral = function parseStringLiteral() {
    var token = this._lexer.token;
    this._lexer.advance();
    return {
      kind: Kind.STRING,
      value: token.value,
      block: token.kind === TokenKind.BLOCK_STRING,
      loc: this.loc(token)
    };
  };
  _proto.parseList = function parseList(isConst) {
    var _this = this;
    var start = this._lexer.token;
    var item = function item2() {
      return _this.parseValueLiteral(isConst);
    };
    return {
      kind: Kind.LIST,
      values: this.any(TokenKind.BRACKET_L, item, TokenKind.BRACKET_R),
      loc: this.loc(start)
    };
  };
  _proto.parseObject = function parseObject(isConst) {
    var _this2 = this;
    var start = this._lexer.token;
    var item = function item2() {
      return _this2.parseObjectField(isConst);
    };
    return {
      kind: Kind.OBJECT,
      fields: this.any(TokenKind.BRACE_L, item, TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  };
  _proto.parseObjectField = function parseObjectField(isConst) {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return {
      kind: Kind.OBJECT_FIELD,
      name,
      value: this.parseValueLiteral(isConst),
      loc: this.loc(start)
    };
  };
  _proto.parseDirectives = function parseDirectives(isConst) {
    var directives = [];
    while (this.peek(TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }
    return directives;
  };
  _proto.parseDirective = function parseDirective(isConst) {
    var start = this._lexer.token;
    this.expectToken(TokenKind.AT);
    return {
      kind: Kind.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
      loc: this.loc(start)
    };
  };
  _proto.parseTypeReference = function parseTypeReference() {
    var start = this._lexer.token;
    var type;
    if (this.expectOptionalToken(TokenKind.BRACKET_L)) {
      type = this.parseTypeReference();
      this.expectToken(TokenKind.BRACKET_R);
      type = {
        kind: Kind.LIST_TYPE,
        type,
        loc: this.loc(start)
      };
    } else {
      type = this.parseNamedType();
    }
    if (this.expectOptionalToken(TokenKind.BANG)) {
      return {
        kind: Kind.NON_NULL_TYPE,
        type,
        loc: this.loc(start)
      };
    }
    return type;
  };
  _proto.parseNamedType = function parseNamedType() {
    var start = this._lexer.token;
    return {
      kind: Kind.NAMED_TYPE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  };
  _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
    var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
    }
    throw this.unexpected(keywordToken);
  };
  _proto.peekDescription = function peekDescription() {
    return this.peek(TokenKind.STRING) || this.peek(TokenKind.BLOCK_STRING);
  };
  _proto.parseDescription = function parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  };
  _proto.parseSchemaDefinition = function parseSchemaDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword("schema");
    var directives = this.parseDirectives(true);
    var operationTypes = this.many(TokenKind.BRACE_L, this.parseOperationTypeDefinition, TokenKind.BRACE_R);
    return {
      kind: Kind.SCHEMA_DEFINITION,
      description,
      directives,
      operationTypes,
      loc: this.loc(start)
    };
  };
  _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
    var start = this._lexer.token;
    var operation = this.parseOperationType();
    this.expectToken(TokenKind.COLON);
    var type = this.parseNamedType();
    return {
      kind: Kind.OPERATION_TYPE_DEFINITION,
      operation,
      type,
      loc: this.loc(start)
    };
  };
  _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword("scalar");
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: Kind.SCALAR_TYPE_DEFINITION,
      description,
      name,
      directives,
      loc: this.loc(start)
    };
  };
  _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword("type");
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: Kind.OBJECT_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
      loc: this.loc(start)
    };
  };
  _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
    var _this$_options2;
    if (!this.expectOptionalKeyword("implements")) {
      return [];
    }
    if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
      var types = [];
      this.expectOptionalToken(TokenKind.AMP);
      do {
        types.push(this.parseNamedType());
      } while (this.expectOptionalToken(TokenKind.AMP) || this.peek(TokenKind.NAME));
      return types;
    }
    return this.delimitedMany(TokenKind.AMP, this.parseNamedType);
  };
  _proto.parseFieldsDefinition = function parseFieldsDefinition() {
    var _this$_options3;
    if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek(TokenKind.BRACE_L) && this._lexer.lookahead().kind === TokenKind.BRACE_R) {
      this._lexer.advance();
      this._lexer.advance();
      return [];
    }
    return this.optionalMany(TokenKind.BRACE_L, this.parseFieldDefinition, TokenKind.BRACE_R);
  };
  _proto.parseFieldDefinition = function parseFieldDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    this.expectToken(TokenKind.COLON);
    var type = this.parseTypeReference();
    var directives = this.parseDirectives(true);
    return {
      kind: Kind.FIELD_DEFINITION,
      description,
      name,
      arguments: args,
      type,
      directives,
      loc: this.loc(start)
    };
  };
  _proto.parseArgumentDefs = function parseArgumentDefs() {
    return this.optionalMany(TokenKind.PAREN_L, this.parseInputValueDef, TokenKind.PAREN_R);
  };
  _proto.parseInputValueDef = function parseInputValueDef() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    this.expectToken(TokenKind.COLON);
    var type = this.parseTypeReference();
    var defaultValue;
    if (this.expectOptionalToken(TokenKind.EQUALS)) {
      defaultValue = this.parseValueLiteral(true);
    }
    var directives = this.parseDirectives(true);
    return {
      kind: Kind.INPUT_VALUE_DEFINITION,
      description,
      name,
      type,
      defaultValue,
      directives,
      loc: this.loc(start)
    };
  };
  _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword("interface");
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: Kind.INTERFACE_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
      loc: this.loc(start)
    };
  };
  _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword("union");
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();
    return {
      kind: Kind.UNION_TYPE_DEFINITION,
      description,
      name,
      directives,
      types,
      loc: this.loc(start)
    };
  };
  _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
    return this.expectOptionalToken(TokenKind.EQUALS) ? this.delimitedMany(TokenKind.PIPE, this.parseNamedType) : [];
  };
  _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword("enum");
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();
    return {
      kind: Kind.ENUM_TYPE_DEFINITION,
      description,
      name,
      directives,
      values,
      loc: this.loc(start)
    };
  };
  _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
    return this.optionalMany(TokenKind.BRACE_L, this.parseEnumValueDefinition, TokenKind.BRACE_R);
  };
  _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: Kind.ENUM_VALUE_DEFINITION,
      description,
      name,
      directives,
      loc: this.loc(start)
    };
  };
  _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword("input");
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();
    return {
      kind: Kind.INPUT_OBJECT_TYPE_DEFINITION,
      description,
      name,
      directives,
      fields,
      loc: this.loc(start)
    };
  };
  _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
    return this.optionalMany(TokenKind.BRACE_L, this.parseInputValueDef, TokenKind.BRACE_R);
  };
  _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
    var keywordToken = this._lexer.lookahead();
    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    }
    throw this.unexpected(keywordToken);
  };
  _proto.parseSchemaExtension = function parseSchemaExtension() {
    var start = this._lexer.token;
    this.expectKeyword("extend");
    this.expectKeyword("schema");
    var directives = this.parseDirectives(true);
    var operationTypes = this.optionalMany(TokenKind.BRACE_L, this.parseOperationTypeDefinition, TokenKind.BRACE_R);
    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }
    return {
      kind: Kind.SCHEMA_EXTENSION,
      directives,
      operationTypes,
      loc: this.loc(start)
    };
  };
  _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword("extend");
    this.expectKeyword("scalar");
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    if (directives.length === 0) {
      throw this.unexpected();
    }
    return {
      kind: Kind.SCALAR_TYPE_EXTENSION,
      name,
      directives,
      loc: this.loc(start)
    };
  };
  _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword("extend");
    this.expectKeyword("type");
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }
    return {
      kind: Kind.OBJECT_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
      loc: this.loc(start)
    };
  };
  _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword("extend");
    this.expectKeyword("interface");
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }
    return {
      kind: Kind.INTERFACE_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
      loc: this.loc(start)
    };
  };
  _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword("extend");
    this.expectKeyword("union");
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();
    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }
    return {
      kind: Kind.UNION_TYPE_EXTENSION,
      name,
      directives,
      types,
      loc: this.loc(start)
    };
  };
  _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword("extend");
    this.expectKeyword("enum");
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();
    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }
    return {
      kind: Kind.ENUM_TYPE_EXTENSION,
      name,
      directives,
      values,
      loc: this.loc(start)
    };
  };
  _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword("extend");
    this.expectKeyword("input");
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();
    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }
    return {
      kind: Kind.INPUT_OBJECT_TYPE_EXTENSION,
      name,
      directives,
      fields,
      loc: this.loc(start)
    };
  };
  _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword("directive");
    this.expectToken(TokenKind.AT);
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    var repeatable = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    var locations = this.parseDirectiveLocations();
    return {
      kind: Kind.DIRECTIVE_DEFINITION,
      description,
      name,
      arguments: args,
      repeatable,
      locations,
      loc: this.loc(start)
    };
  };
  _proto.parseDirectiveLocations = function parseDirectiveLocations() {
    return this.delimitedMany(TokenKind.PIPE, this.parseDirectiveLocation);
  };
  _proto.parseDirectiveLocation = function parseDirectiveLocation() {
    var start = this._lexer.token;
    var name = this.parseName();
    if (DirectiveLocation[name.value] !== void 0) {
      return name;
    }
    throw this.unexpected(start);
  };
  _proto.loc = function loc(startToken) {
    var _this$_options4;
    if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) {
      return new Location(startToken, this._lexer.lastToken, this._lexer.source);
    }
  };
  _proto.peek = function peek(kind) {
    return this._lexer.token.kind === kind;
  };
  _proto.expectToken = function expectToken(kind) {
    var token = this._lexer.token;
    if (token.kind === kind) {
      this._lexer.advance();
      return token;
    }
    throw syntaxError(this._lexer.source, token.start, "Expected ".concat(getTokenKindDesc(kind), ", found ").concat(getTokenDesc(token), "."));
  };
  _proto.expectOptionalToken = function expectOptionalToken(kind) {
    var token = this._lexer.token;
    if (token.kind === kind) {
      this._lexer.advance();
      return token;
    }
    return void 0;
  };
  _proto.expectKeyword = function expectKeyword(value) {
    var token = this._lexer.token;
    if (token.kind === TokenKind.NAME && token.value === value) {
      this._lexer.advance();
    } else {
      throw syntaxError(this._lexer.source, token.start, 'Expected "'.concat(value, '", found ').concat(getTokenDesc(token), "."));
    }
  };
  _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
    var token = this._lexer.token;
    if (token.kind === TokenKind.NAME && token.value === value) {
      this._lexer.advance();
      return true;
    }
    return false;
  };
  _proto.unexpected = function unexpected(atToken) {
    var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(this._lexer.source, token.start, "Unexpected ".concat(getTokenDesc(token), "."));
  };
  _proto.any = function any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];
    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }
    return nodes;
  };
  _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      var nodes = [];
      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));
      return nodes;
    }
    return [];
  };
  _proto.many = function many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];
    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));
    return nodes;
  };
  _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    var nodes = [];
    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));
    return nodes;
  };
  return Parser3;
}();
function getTokenDesc(token) {
  var value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? ' "'.concat(value, '"') : "");
}
function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? '"'.concat(kind, '"') : kind;
}

// node_modules/graphql/language/visitor.mjs
var QueryDocumentKeys = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: ["name", "variableDefinitions", "directives", "selectionSet"],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: ["description", "name", "type", "defaultValue", "directives"],
  InterfaceTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
};
var BREAK = Object.freeze({});
function visit(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : QueryDocumentKeys;
  var stack = void 0;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = void 0;
  var key = void 0;
  var parent = void 0;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;
    if (isLeaving) {
      key = ancestors.length === 0 ? void 0 : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();
      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};
          for (var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++) {
            var k2 = _Object$keys2[_i2];
            clone[k2] = node[k2];
          }
          node = clone;
        }
        var editOffset = 0;
        for (var ii2 = 0; ii2 < edits.length; ii2++) {
          var editKey = edits[ii2][0];
          var editValue = edits[ii2][1];
          if (inArray) {
            editKey -= editOffset;
          }
          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }
      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : void 0;
      node = parent ? parent[key] : newRoot;
      if (node === null || node === void 0) {
        continue;
      }
      if (parent) {
        path.push(key);
      }
    }
    var result = void 0;
    if (!Array.isArray(node)) {
      if (!isNode(node)) {
        throw new Error("Invalid AST Node: ".concat(inspect(node), "."));
      }
      var visitFn = getVisitFn(visitor, node.kind, isLeaving);
      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);
        if (result === BREAK) {
          break;
        }
        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== void 0) {
          edits.push([key, result]);
          if (!isLeaving) {
            if (isNode(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }
    if (result === void 0 && isEdited) {
      edits.push([key, node]);
    }
    if (isLeaving) {
      path.pop();
    } else {
      var _visitorKeys$node$kin;
      stack = {
        inArray,
        index,
        keys,
        edits,
        prev: stack
      };
      inArray = Array.isArray(node);
      keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
      index = -1;
      edits = [];
      if (parent) {
        ancestors.push(parent);
      }
      parent = node;
    }
  } while (stack !== void 0);
  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }
  return newRoot;
}
function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];
  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === "function") {
      return kindVisitor;
    }
    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
    if (typeof kindSpecificVisitor === "function") {
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
    if (specificVisitor) {
      if (typeof specificVisitor === "function") {
        return specificVisitor;
      }
      var specificKindVisitor = specificVisitor[kind];
      if (typeof specificKindVisitor === "function") {
        return specificKindVisitor;
      }
    }
  }
}

// node_modules/graphql/language/printer.mjs
function print(ast) {
  return visit(ast, {
    leave: printDocASTReducer
  });
}
var MAX_LINE_LENGTH = 80;
var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return "$" + node.name;
  },
  // Document
  Document: function Document(node) {
    return join(node.definitions, "\n\n") + "\n";
  },
  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = wrap("(", join(node.variableDefinitions, ", "), ")");
    var directives = join(node.directives, " ");
    var selectionSet = node.selectionSet;
    return !name && !directives && !varDefs && op === "query" ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], " ");
  },
  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
    return variable + ": " + type + wrap(" = ", defaultValue) + wrap(" ", join(directives, " "));
  },
  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },
  Field: function Field(_ref3) {
    var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
    var prefix = wrap("", alias, ": ") + name;
    var argsLine = prefix + wrap("(", join(args, ", "), ")");
    if (argsLine.length > MAX_LINE_LENGTH) {
      argsLine = prefix + wrap("(\n", indent(join(args, "\n")), "\n)");
    }
    return join([argsLine, join(directives, " "), selectionSet], " ");
  },
  Argument: function Argument(_ref4) {
    var name = _ref4.name, value = _ref4.value;
    return name + ": " + value;
  },
  // Fragments
  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name, directives = _ref5.directives;
    return "..." + name + wrap(" ", join(directives, " "));
  },
  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
    return join(["...", wrap("on ", typeCondition), join(directives, " "), selectionSet], " ");
  },
  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
    return (
      // Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(name).concat(wrap("(", join(variableDefinitions, ", "), ")"), " ") + "on ".concat(typeCondition, " ").concat(wrap("", join(directives, " "), " ")) + selectionSet
    );
  },
  // Value
  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value, isBlockString = _ref10.block;
    return isBlockString ? printBlockString(value, key === "description" ? "" : "  ") : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? "true" : "false";
  },
  NullValue: function NullValue() {
    return "null";
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return "[" + join(values, ", ") + "]";
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return "{" + join(fields, ", ") + "}";
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name, value = _ref15.value;
    return name + ": " + value;
  },
  // Directive
  Directive: function Directive(_ref16) {
    var name = _ref16.name, args = _ref16.arguments;
    return "@" + name + wrap("(", join(args, ", "), ")");
  },
  // Type
  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return "[" + type + "]";
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + "!";
  },
  // Type System Definitions
  SchemaDefinition: addDescription(function(_ref20) {
    var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
    return join(["schema", join(directives, " "), block(operationTypes)], " ");
  }),
  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation, type = _ref21.type;
    return operation + ": " + type;
  },
  ScalarTypeDefinition: addDescription(function(_ref22) {
    var name = _ref22.name, directives = _ref22.directives;
    return join(["scalar", name, join(directives, " ")], " ");
  }),
  ObjectTypeDefinition: addDescription(function(_ref23) {
    var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
    return join(["type", name, wrap("implements ", join(interfaces, " & ")), join(directives, " "), block(fields)], " ");
  }),
  FieldDefinition: addDescription(function(_ref24) {
    var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
    return name + (hasMultilineItems(args) ? wrap("(\n", indent(join(args, "\n")), "\n)") : wrap("(", join(args, ", "), ")")) + ": " + type + wrap(" ", join(directives, " "));
  }),
  InputValueDefinition: addDescription(function(_ref25) {
    var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
    return join([name + ": " + type, wrap("= ", defaultValue), join(directives, " ")], " ");
  }),
  InterfaceTypeDefinition: addDescription(function(_ref26) {
    var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
    return join(["interface", name, wrap("implements ", join(interfaces, " & ")), join(directives, " "), block(fields)], " ");
  }),
  UnionTypeDefinition: addDescription(function(_ref27) {
    var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
    return join(["union", name, join(directives, " "), types && types.length !== 0 ? "= " + join(types, " | ") : ""], " ");
  }),
  EnumTypeDefinition: addDescription(function(_ref28) {
    var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
    return join(["enum", name, join(directives, " "), block(values)], " ");
  }),
  EnumValueDefinition: addDescription(function(_ref29) {
    var name = _ref29.name, directives = _ref29.directives;
    return join([name, join(directives, " ")], " ");
  }),
  InputObjectTypeDefinition: addDescription(function(_ref30) {
    var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
    return join(["input", name, join(directives, " "), block(fields)], " ");
  }),
  DirectiveDefinition: addDescription(function(_ref31) {
    var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
    return "directive @" + name + (hasMultilineItems(args) ? wrap("(\n", indent(join(args, "\n")), "\n)") : wrap("(", join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + join(locations, " | ");
  }),
  SchemaExtension: function SchemaExtension(_ref32) {
    var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
    return join(["extend schema", join(directives, " "), block(operationTypes)], " ");
  },
  ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
    var name = _ref33.name, directives = _ref33.directives;
    return join(["extend scalar", name, join(directives, " ")], " ");
  },
  ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
    var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
    return join(["extend type", name, wrap("implements ", join(interfaces, " & ")), join(directives, " "), block(fields)], " ");
  },
  InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
    var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
    return join(["extend interface", name, wrap("implements ", join(interfaces, " & ")), join(directives, " "), block(fields)], " ");
  },
  UnionTypeExtension: function UnionTypeExtension(_ref36) {
    var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
    return join(["extend union", name, join(directives, " "), types && types.length !== 0 ? "= " + join(types, " | ") : ""], " ");
  },
  EnumTypeExtension: function EnumTypeExtension(_ref37) {
    var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
    return join(["extend enum", name, join(directives, " "), block(values)], " ");
  },
  InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
    var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
    return join(["extend input", name, join(directives, " "), block(fields)], " ");
  }
};
function addDescription(cb) {
  return function(node) {
    return join([node.description, cb(node)], "\n");
  };
}
function join(maybeArray) {
  var _maybeArray$filter$jo;
  var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x2) {
    return x2;
  }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
function block(array) {
  return wrap("{\n", indent(join(array, "\n")), "\n}");
}
function wrap(start, maybeString) {
  var end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function indent(str) {
  return wrap("  ", str.replace(/\n/g, "\n  "));
}
function isMultiline(str) {
  return str.indexOf("\n") !== -1;
}
function hasMultilineItems(maybeArray) {
  return maybeArray != null && maybeArray.some(isMultiline);
}

// node_modules/@aws-amplify/pubsub/node_modules/tslib/tslib.es6.js
var extendStatics8 = function(d2, b2) {
  extendStatics8 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b3) {
    d3.__proto__ = b3;
  } || function(d3, b3) {
    for (var p2 in b3)
      if (b3.hasOwnProperty(p2))
        d3[p2] = b3[p2];
  };
  return extendStatics8(d2, b2);
};
function __extends10(d2, b2) {
  extendStatics8(d2, b2);
  function __() {
    this.constructor = d2;
  }
  d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
}
var __assign42 = function() {
  __assign42 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign42.apply(this, arguments);
};
function __awaiter66(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator67(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __read35(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}

// node_modules/@aws-amplify/pubsub/lib-esm/Providers/PubSubProvider.js
var logger34 = new ConsoleLogger("AbstractPubSubProvider");
var AbstractPubSubProvider = (
  /** @class */
  function() {
    function AbstractPubSubProvider2(options) {
      this._config = options;
    }
    AbstractPubSubProvider2.prototype.configure = function(config) {
      this._config = __assign42(__assign42({}, config), this._config);
      logger34.debug("configure " + this.getProviderName(), this._config);
      return this.options;
    };
    AbstractPubSubProvider2.prototype.getCategory = function() {
      return "PubSub";
    };
    Object.defineProperty(AbstractPubSubProvider2.prototype, "options", {
      get: function() {
        return __assign42({}, this._config);
      },
      enumerable: true,
      configurable: true
    });
    return AbstractPubSubProvider2;
  }()
);

// node_modules/@aws-amplify/pubsub/lib-esm/Providers/AWSAppSyncRealTimeProvider/index.js
var url = __toESM(require_url());
var import_uuid4 = __toESM(require_uuid3());
var import_buffer5 = __toESM(require_buffer());

// node_modules/@aws-amplify/pubsub/lib-esm/types/PubSub.js
var CONTROL_MSG;
(function(CONTROL_MSG3) {
  CONTROL_MSG3["CONNECTION_CLOSED"] = "Connection closed";
  CONTROL_MSG3["CONNECTION_FAILED"] = "Connection failed";
  CONTROL_MSG3["REALTIME_SUBSCRIPTION_INIT_ERROR"] = "AppSync Realtime subscription init error";
  CONTROL_MSG3["SUBSCRIPTION_ACK"] = "Subscription ack";
  CONTROL_MSG3["TIMEOUT_DISCONNECT"] = "Timeout disconnect";
})(CONTROL_MSG || (CONTROL_MSG = {}));
var ConnectionState;
(function(ConnectionState2) {
  ConnectionState2["Connected"] = "Connected";
  ConnectionState2["ConnectedPendingNetwork"] = "ConnectedPendingNetwork";
  ConnectionState2["ConnectionDisrupted"] = "ConnectionDisrupted";
  ConnectionState2["ConnectionDisruptedPendingNetwork"] = "ConnectionDisruptedPendingNetwork";
  ConnectionState2["Connecting"] = "Connecting";
  ConnectionState2["ConnectedPendingDisconnect"] = "ConnectedPendingDisconnect";
  ConnectionState2["Disconnected"] = "Disconnected";
  ConnectionState2["ConnectedPendingKeepAlive"] = "ConnectedPendingKeepAlive";
})(ConnectionState || (ConnectionState = {}));

// node_modules/@aws-amplify/pubsub/lib-esm/Providers/constants.js
var MAX_DELAY_MS3 = 5e3;
var NON_RETRYABLE_CODES = [400, 401, 403];
var CONNECTION_STATE_CHANGE = "ConnectionStateChange";
var MESSAGE_TYPES;
(function(MESSAGE_TYPES2) {
  MESSAGE_TYPES2["GQL_CONNECTION_INIT"] = "connection_init";
  MESSAGE_TYPES2["GQL_CONNECTION_ERROR"] = "connection_error";
  MESSAGE_TYPES2["GQL_CONNECTION_ACK"] = "connection_ack";
  MESSAGE_TYPES2["GQL_START"] = "start";
  MESSAGE_TYPES2["GQL_START_ACK"] = "start_ack";
  MESSAGE_TYPES2["GQL_DATA"] = "data";
  MESSAGE_TYPES2["GQL_CONNECTION_KEEP_ALIVE"] = "ka";
  MESSAGE_TYPES2["GQL_STOP"] = "stop";
  MESSAGE_TYPES2["GQL_COMPLETE"] = "complete";
  MESSAGE_TYPES2["GQL_ERROR"] = "error";
})(MESSAGE_TYPES || (MESSAGE_TYPES = {}));
var SUBSCRIPTION_STATUS;
(function(SUBSCRIPTION_STATUS2) {
  SUBSCRIPTION_STATUS2[SUBSCRIPTION_STATUS2["PENDING"] = 0] = "PENDING";
  SUBSCRIPTION_STATUS2[SUBSCRIPTION_STATUS2["CONNECTED"] = 1] = "CONNECTED";
  SUBSCRIPTION_STATUS2[SUBSCRIPTION_STATUS2["FAILED"] = 2] = "FAILED";
})(SUBSCRIPTION_STATUS || (SUBSCRIPTION_STATUS = {}));
var SOCKET_STATUS;
(function(SOCKET_STATUS2) {
  SOCKET_STATUS2[SOCKET_STATUS2["CLOSED"] = 0] = "CLOSED";
  SOCKET_STATUS2[SOCKET_STATUS2["READY"] = 1] = "READY";
  SOCKET_STATUS2[SOCKET_STATUS2["CONNECTING"] = 2] = "CONNECTING";
})(SOCKET_STATUS || (SOCKET_STATUS = {}));
var AMPLIFY_SYMBOL8 = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var AWS_APPSYNC_REALTIME_HEADERS = {
  accept: "application/json, text/javascript",
  "content-encoding": "amz-1.0",
  "content-type": "application/json; charset=UTF-8"
};
var CONNECTION_INIT_TIMEOUT = 15e3;
var START_ACK_TIMEOUT = 15e3;
var DEFAULT_KEEP_ALIVE_TIMEOUT = 5 * 60 * 1e3;
var DEFAULT_KEEP_ALIVE_ALERT_TIMEOUT = 65 * 1e3;
var RECONNECT_DELAY = 5 * 1e3;
var RECONNECT_INTERVAL = 60 * 1e3;

// node_modules/@aws-amplify/pubsub/lib-esm/utils/ReachabilityMonitor/index.js
var ReachabilityMonitor = function() {
  return new Reachability_default().networkMonitor();
};

// node_modules/@aws-amplify/pubsub/lib-esm/utils/ConnectionStateMonitor.js
var CONNECTION_CHANGE = {
  KEEP_ALIVE_MISSED: { keepAliveState: "unhealthy" },
  KEEP_ALIVE: { keepAliveState: "healthy" },
  CONNECTION_ESTABLISHED: { connectionState: "connected" },
  CONNECTION_FAILED: {
    intendedConnectionState: "disconnected",
    connectionState: "disconnected"
  },
  CLOSING_CONNECTION: { intendedConnectionState: "disconnected" },
  OPENING_CONNECTION: {
    intendedConnectionState: "connected",
    connectionState: "connecting"
  },
  CLOSED: { connectionState: "disconnected" },
  ONLINE: { networkState: "connected" },
  OFFLINE: { networkState: "disconnected" }
};
var ConnectionStateMonitor = (
  /** @class */
  function() {
    function ConnectionStateMonitor2() {
      var _this = this;
      this._networkMonitoringSubscription = void 0;
      this._linkedConnectionState = {
        networkState: "connected",
        connectionState: "disconnected",
        intendedConnectionState: "disconnected",
        keepAliveState: "healthy"
      };
      this._initialNetworkStateSubscription = ReachabilityMonitor().subscribe(function(_a2) {
        var online = _a2.online;
        var _b2;
        _this.record(online ? CONNECTION_CHANGE.ONLINE : CONNECTION_CHANGE.OFFLINE);
        (_b2 = _this._initialNetworkStateSubscription) === null || _b2 === void 0 ? void 0 : _b2.unsubscribe();
      });
      this._linkedConnectionStateObservable = new bundle_esm_default(function(connectionStateObserver) {
        connectionStateObserver.next(_this._linkedConnectionState);
        _this._linkedConnectionStateObserver = connectionStateObserver;
      });
    }
    ConnectionStateMonitor2.prototype.enableNetworkMonitoring = function() {
      var _this = this;
      var _a2;
      (_a2 = this._initialNetworkStateSubscription) === null || _a2 === void 0 ? void 0 : _a2.unsubscribe();
      if (this._networkMonitoringSubscription === void 0) {
        this._networkMonitoringSubscription = ReachabilityMonitor().subscribe(function(_a3) {
          var online = _a3.online;
          _this.record(online ? CONNECTION_CHANGE.ONLINE : CONNECTION_CHANGE.OFFLINE);
        });
      }
    };
    ConnectionStateMonitor2.prototype.disableNetworkMonitoring = function() {
      var _a2;
      (_a2 = this._networkMonitoringSubscription) === null || _a2 === void 0 ? void 0 : _a2.unsubscribe();
      this._networkMonitoringSubscription = void 0;
    };
    Object.defineProperty(ConnectionStateMonitor2.prototype, "connectionStateObservable", {
      /**
       * Get the observable that allows us to monitor the connection state
       *
       * @returns {Observable<ConnectionState>} - The observable that emits ConnectionState updates
       */
      get: function() {
        var _this = this;
        var previous;
        return this._linkedConnectionStateObservable.map(function(value) {
          return _this.connectionStatesTranslator(value);
        }).filter(function(current) {
          var toInclude = current !== previous;
          previous = current;
          return toInclude;
        });
      },
      enumerable: true,
      configurable: true
    });
    ConnectionStateMonitor2.prototype.record = function(statusUpdates) {
      if (statusUpdates.intendedConnectionState === "connected") {
        this.enableNetworkMonitoring();
      } else if (statusUpdates.intendedConnectionState === "disconnected") {
        this.disableNetworkMonitoring();
      }
      var newSocketStatus = __assign42(__assign42({}, this._linkedConnectionState), statusUpdates);
      this._linkedConnectionState = __assign42({}, newSocketStatus);
      this._linkedConnectionStateObserver.next(this._linkedConnectionState);
    };
    ConnectionStateMonitor2.prototype.connectionStatesTranslator = function(_a2) {
      var connectionState = _a2.connectionState, networkState = _a2.networkState, intendedConnectionState = _a2.intendedConnectionState, keepAliveState = _a2.keepAliveState;
      if (connectionState === "connected" && networkState === "disconnected")
        return ConnectionState.ConnectedPendingNetwork;
      if (connectionState === "connected" && intendedConnectionState === "disconnected")
        return ConnectionState.ConnectedPendingDisconnect;
      if (connectionState === "disconnected" && intendedConnectionState === "connected" && networkState === "disconnected")
        return ConnectionState.ConnectionDisruptedPendingNetwork;
      if (connectionState === "disconnected" && intendedConnectionState === "connected")
        return ConnectionState.ConnectionDisrupted;
      if (connectionState === "connected" && keepAliveState === "unhealthy")
        return ConnectionState.ConnectedPendingKeepAlive;
      if (connectionState === "connecting")
        return ConnectionState.Connecting;
      if (connectionState === "disconnected")
        return ConnectionState.Disconnected;
      return ConnectionState.Connected;
    };
    return ConnectionStateMonitor2;
  }()
);

// node_modules/@aws-amplify/pubsub/lib-esm/utils/ReconnectionMonitor.js
var ReconnectEvent;
(function(ReconnectEvent2) {
  ReconnectEvent2["START_RECONNECT"] = "START_RECONNECT";
  ReconnectEvent2["HALT_RECONNECT"] = "HALT_RECONNECT";
})(ReconnectEvent || (ReconnectEvent = {}));
var ReconnectionMonitor = (
  /** @class */
  function() {
    function ReconnectionMonitor2() {
      this.reconnectObservers = [];
    }
    ReconnectionMonitor2.prototype.addObserver = function(reconnectObserver) {
      this.reconnectObservers.push(reconnectObserver);
    };
    ReconnectionMonitor2.prototype.record = function(event) {
      var _this = this;
      if (event === ReconnectEvent.START_RECONNECT) {
        if (this.reconnectSetTimeoutId === void 0 && this.reconnectIntervalId === void 0) {
          this.reconnectSetTimeoutId = setTimeout(function() {
            _this._triggerReconnect();
            _this.reconnectIntervalId = setInterval(function() {
              _this._triggerReconnect();
            }, RECONNECT_INTERVAL);
          }, RECONNECT_DELAY);
        }
      }
      if (event === ReconnectEvent.HALT_RECONNECT) {
        if (this.reconnectIntervalId) {
          clearInterval(this.reconnectIntervalId);
          this.reconnectIntervalId = void 0;
        }
        if (this.reconnectSetTimeoutId) {
          clearTimeout(this.reconnectSetTimeoutId);
          this.reconnectSetTimeoutId = void 0;
        }
      }
    };
    ReconnectionMonitor2.prototype.close = function() {
      this.reconnectObservers.forEach(function(reconnectObserver) {
        var _a2;
        (_a2 = reconnectObserver.complete) === null || _a2 === void 0 ? void 0 : _a2.call(reconnectObserver);
      });
    };
    ReconnectionMonitor2.prototype._triggerReconnect = function() {
      this.reconnectObservers.forEach(function(reconnectObserver) {
        var _a2;
        (_a2 = reconnectObserver.next) === null || _a2 === void 0 ? void 0 : _a2.call(reconnectObserver);
      });
    };
    return ReconnectionMonitor2;
  }()
);

// node_modules/@aws-amplify/pubsub/lib-esm/Providers/AWSAppSyncRealTimeProvider/index.js
var logger35 = new ConsoleLogger("AWSAppSyncRealTimeProvider");
var dispatchApiEvent = function(event, data, message) {
  Hub.dispatch("api", { event, data, message }, "PubSub", AMPLIFY_SYMBOL8);
};
var standardDomainPattern = /^https:\/\/\w{26}\.appsync\-api\.\w{2}(?:(?:\-\w{2,})+)\-\d\.amazonaws.com(?:\.cn)?\/graphql$/i;
var customDomainPath = "/realtime";
var AWSAppSyncRealTimeProvider = (
  /** @class */
  function(_super) {
    __extends10(AWSAppSyncRealTimeProvider2, _super);
    function AWSAppSyncRealTimeProvider2(options) {
      if (options === void 0) {
        options = {};
      }
      var _this = _super.call(this, options) || this;
      _this.socketStatus = SOCKET_STATUS.CLOSED;
      _this.keepAliveTimeout = DEFAULT_KEEP_ALIVE_TIMEOUT;
      _this.subscriptionObserverMap = /* @__PURE__ */ new Map();
      _this.promiseArray = [];
      _this.connectionStateMonitor = new ConnectionStateMonitor();
      _this.reconnectionMonitor = new ReconnectionMonitor();
      _this.connectionStateMonitorSubscription = _this.connectionStateMonitor.connectionStateObservable.subscribe(function(connectionState) {
        dispatchApiEvent(CONNECTION_STATE_CHANGE, {
          provider: _this,
          connectionState
        }, "Connection state is " + connectionState);
        _this.connectionState = connectionState;
        if (connectionState === ConnectionState.ConnectionDisrupted) {
          _this.reconnectionMonitor.record(ReconnectEvent.START_RECONNECT);
        }
        if ([
          ConnectionState.Connected,
          ConnectionState.ConnectedPendingDisconnect,
          ConnectionState.ConnectedPendingKeepAlive,
          ConnectionState.ConnectedPendingNetwork,
          ConnectionState.ConnectedPendingNetwork,
          ConnectionState.ConnectionDisruptedPendingNetwork,
          ConnectionState.Disconnected
        ].includes(connectionState)) {
          _this.reconnectionMonitor.record(ReconnectEvent.HALT_RECONNECT);
        }
      });
      return _this;
    }
    AWSAppSyncRealTimeProvider2.prototype.close = function() {
      this.socketStatus = SOCKET_STATUS.CLOSED;
      this.connectionStateMonitor.record(CONNECTION_CHANGE.CONNECTION_FAILED);
      this.connectionStateMonitorSubscription.unsubscribe();
      this.reconnectionMonitor.close();
    };
    AWSAppSyncRealTimeProvider2.prototype.getNewWebSocket = function(url2, protocol) {
      return new WebSocket(url2, protocol);
    };
    AWSAppSyncRealTimeProvider2.prototype.getProviderName = function() {
      return "AWSAppSyncRealTimeProvider";
    };
    AWSAppSyncRealTimeProvider2.prototype.newClient = function() {
      throw new Error("Not used here");
    };
    AWSAppSyncRealTimeProvider2.prototype.publish = function(_topics, _msg, _options) {
      return __awaiter66(this, void 0, void 0, function() {
        return __generator67(this, function(_a2) {
          throw new Error("Operation not supported");
        });
      });
    };
    AWSAppSyncRealTimeProvider2.prototype.isCustomDomain = function(url2) {
      return url2.match(standardDomainPattern) === null;
    };
    AWSAppSyncRealTimeProvider2.prototype.subscribe = function(_topics, options, customUserAgentDetails) {
      var _this = this;
      var appSyncGraphqlEndpoint = options === null || options === void 0 ? void 0 : options.appSyncGraphqlEndpoint;
      return new bundle_esm_default(function(observer) {
        if (!options || !appSyncGraphqlEndpoint) {
          observer.error({
            errors: [
              __assign42({}, new GraphQLError("Subscribe only available for AWS AppSync endpoint"))
            ]
          });
          observer.complete();
        } else {
          var subscriptionStartActive_1 = false;
          var subscriptionId_1 = (0, import_uuid4.v4)();
          var startSubscription_1 = function() {
            if (!subscriptionStartActive_1) {
              subscriptionStartActive_1 = true;
              var startSubscriptionPromise = _this._startSubscriptionWithAWSAppSyncRealTime({
                options,
                observer,
                subscriptionId: subscriptionId_1,
                customUserAgentDetails
              }).catch(function(err) {
                logger35.debug(CONTROL_MSG.REALTIME_SUBSCRIPTION_INIT_ERROR + ": " + err);
                _this.connectionStateMonitor.record(CONNECTION_CHANGE.CLOSED);
              });
              startSubscriptionPromise.finally(function() {
                subscriptionStartActive_1 = false;
              });
            }
          };
          var reconnectSubscription_1;
          reconnectSubscription_1 = new bundle_esm_default(function(observer2) {
            _this.reconnectionMonitor.addObserver(observer2);
          }).subscribe(function() {
            startSubscription_1();
          });
          startSubscription_1();
          return function() {
            return __awaiter66(_this, void 0, void 0, function() {
              var subscriptionState, err_1;
              return __generator67(this, function(_a2) {
                switch (_a2.label) {
                  case 0:
                    reconnectSubscription_1 === null || reconnectSubscription_1 === void 0 ? void 0 : reconnectSubscription_1.unsubscribe();
                    _a2.label = 1;
                  case 1:
                    _a2.trys.push([1, 3, 4, 5]);
                    return [4, this._waitForSubscriptionToBeConnected(subscriptionId_1)];
                  case 2:
                    _a2.sent();
                    subscriptionState = (this.subscriptionObserverMap.get(subscriptionId_1) || {}).subscriptionState;
                    if (!subscriptionState) {
                      return [
                        2
                        /*return*/
                      ];
                    }
                    if (subscriptionState === SUBSCRIPTION_STATUS.CONNECTED) {
                      this._sendUnsubscriptionMessage(subscriptionId_1);
                    } else {
                      throw new Error("Subscription never connected");
                    }
                    return [3, 5];
                  case 3:
                    err_1 = _a2.sent();
                    logger35.debug("Error while unsubscribing " + err_1);
                    return [3, 5];
                  case 4:
                    this._removeSubscriptionObserver(subscriptionId_1);
                    return [
                      7
                      /*endfinally*/
                    ];
                  case 5:
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          };
        }
      });
    };
    Object.defineProperty(AWSAppSyncRealTimeProvider2.prototype, "isSSLEnabled", {
      get: function() {
        return !this.options["aws_appsync_dangerously_connect_to_http_endpoint_for_testing"];
      },
      enumerable: true,
      configurable: true
    });
    AWSAppSyncRealTimeProvider2.prototype._startSubscriptionWithAWSAppSyncRealTime = function(_a2) {
      var options = _a2.options, observer = _a2.observer, subscriptionId = _a2.subscriptionId, customUserAgentDetails = _a2.customUserAgentDetails;
      var _b2;
      return __awaiter66(this, void 0, void 0, function() {
        var appSyncGraphqlEndpoint, authenticationType, query, variables, apiKey, region, _c, graphql_headers, _d, additionalHeaders, subscriptionState, data, dataString, headerObj, _e, _f, subscriptionMessage, stringToAWSRealTime, err_2, _g, subscriptionFailedCallback, subscriptionReadyCallback;
        var _h;
        var _this = this;
        return __generator67(this, function(_j) {
          switch (_j.label) {
            case 0:
              appSyncGraphqlEndpoint = options.appSyncGraphqlEndpoint, authenticationType = options.authenticationType, query = options.query, variables = options.variables, apiKey = options.apiKey, region = options.region, _c = options.graphql_headers, graphql_headers = _c === void 0 ? function() {
                return {};
              } : _c, _d = options.additionalHeaders, additionalHeaders = _d === void 0 ? {} : _d;
              subscriptionState = SUBSCRIPTION_STATUS.PENDING;
              data = {
                query,
                variables
              };
              this.subscriptionObserverMap.set(subscriptionId, {
                observer,
                query: query !== null && query !== void 0 ? query : "",
                variables: variables !== null && variables !== void 0 ? variables : {},
                subscriptionState,
                startAckTimeoutId: void 0
              });
              dataString = JSON.stringify(data);
              _e = [{}];
              return [4, this._awsRealTimeHeaderBasedAuth({
                apiKey,
                appSyncGraphqlEndpoint,
                authenticationType,
                payload: dataString,
                canonicalUri: "",
                region,
                additionalHeaders
              })];
            case 1:
              _f = [__assign42.apply(void 0, _e.concat([_j.sent()]))];
              return [4, graphql_headers()];
            case 2:
              headerObj = __assign42.apply(void 0, [__assign42.apply(void 0, [__assign42.apply(void 0, _f.concat([_j.sent()])), additionalHeaders]), (_h = {}, _h[USER_AGENT_HEADER] = getAmplifyUserAgent(customUserAgentDetails), _h)]);
              subscriptionMessage = {
                id: subscriptionId,
                payload: {
                  data: dataString,
                  extensions: {
                    authorization: __assign42({}, headerObj)
                  }
                },
                type: MESSAGE_TYPES.GQL_START
              };
              stringToAWSRealTime = JSON.stringify(subscriptionMessage);
              _j.label = 3;
            case 3:
              _j.trys.push([3, 5, , 6]);
              this.connectionStateMonitor.record(CONNECTION_CHANGE.OPENING_CONNECTION);
              return [4, this._initializeWebSocketConnection({
                apiKey,
                appSyncGraphqlEndpoint,
                authenticationType,
                region,
                additionalHeaders
              })];
            case 4:
              _j.sent();
              return [3, 6];
            case 5:
              err_2 = _j.sent();
              this._logStartSubscriptionError(subscriptionId, observer, err_2);
              return [
                2
                /*return*/
              ];
            case 6:
              _g = (_b2 = this.subscriptionObserverMap.get(subscriptionId)) !== null && _b2 !== void 0 ? _b2 : {}, subscriptionFailedCallback = _g.subscriptionFailedCallback, subscriptionReadyCallback = _g.subscriptionReadyCallback;
              this.subscriptionObserverMap.set(subscriptionId, {
                observer,
                subscriptionState,
                query: query !== null && query !== void 0 ? query : "",
                variables: variables !== null && variables !== void 0 ? variables : {},
                subscriptionReadyCallback,
                subscriptionFailedCallback,
                startAckTimeoutId: setTimeout(function() {
                  _this._timeoutStartSubscriptionAck.call(_this, subscriptionId);
                }, START_ACK_TIMEOUT)
              });
              if (this.awsRealTimeSocket) {
                this.awsRealTimeSocket.send(stringToAWSRealTime);
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSAppSyncRealTimeProvider2.prototype._logStartSubscriptionError = function(subscriptionId, observer, err) {
      var _a2;
      logger35.debug({ err });
      var message = String((_a2 = err.message) !== null && _a2 !== void 0 ? _a2 : "");
      Promise.resolve(this.connectionStateMonitor.record(CONNECTION_CHANGE.CLOSED));
      if (this.connectionState !== ConnectionState.ConnectionDisruptedPendingNetwork) {
        if (isNonRetryableError(err)) {
          observer.error({
            errors: [
              __assign42({}, new GraphQLError(CONTROL_MSG.CONNECTION_FAILED + ": " + message))
            ]
          });
        } else {
          logger35.debug(CONTROL_MSG.CONNECTION_FAILED + ": " + message);
        }
        var subscriptionFailedCallback = (this.subscriptionObserverMap.get(subscriptionId) || {}).subscriptionFailedCallback;
        if (typeof subscriptionFailedCallback === "function") {
          subscriptionFailedCallback();
        }
      }
    };
    AWSAppSyncRealTimeProvider2.prototype._waitForSubscriptionToBeConnected = function(subscriptionId) {
      return __awaiter66(this, void 0, void 0, function() {
        var subscriptionObserver, subscriptionState;
        var _this = this;
        return __generator67(this, function(_a2) {
          subscriptionObserver = this.subscriptionObserverMap.get(subscriptionId);
          if (subscriptionObserver) {
            subscriptionState = subscriptionObserver.subscriptionState;
            if (subscriptionState === SUBSCRIPTION_STATUS.PENDING) {
              return [2, new Promise(function(res, rej) {
                var observer = subscriptionObserver.observer, subscriptionState2 = subscriptionObserver.subscriptionState, variables = subscriptionObserver.variables, query = subscriptionObserver.query;
                _this.subscriptionObserverMap.set(subscriptionId, {
                  observer,
                  subscriptionState: subscriptionState2,
                  variables,
                  query,
                  subscriptionReadyCallback: res,
                  subscriptionFailedCallback: rej
                });
              })];
            }
          }
          return [
            2
            /*return*/
          ];
        });
      });
    };
    AWSAppSyncRealTimeProvider2.prototype._sendUnsubscriptionMessage = function(subscriptionId) {
      try {
        if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN && this.socketStatus === SOCKET_STATUS.READY) {
          var unsubscribeMessage = {
            id: subscriptionId,
            type: MESSAGE_TYPES.GQL_STOP
          };
          var stringToAWSRealTime = JSON.stringify(unsubscribeMessage);
          this.awsRealTimeSocket.send(stringToAWSRealTime);
        }
      } catch (err) {
        logger35.debug({ err });
      }
    };
    AWSAppSyncRealTimeProvider2.prototype._removeSubscriptionObserver = function(subscriptionId) {
      this.subscriptionObserverMap.delete(subscriptionId);
      setTimeout(this._closeSocketIfRequired.bind(this), 1e3);
    };
    AWSAppSyncRealTimeProvider2.prototype._closeSocketIfRequired = function() {
      if (this.subscriptionObserverMap.size > 0) {
        return;
      }
      if (!this.awsRealTimeSocket) {
        this.socketStatus = SOCKET_STATUS.CLOSED;
        return;
      }
      this.connectionStateMonitor.record(CONNECTION_CHANGE.CLOSING_CONNECTION);
      if (this.awsRealTimeSocket.bufferedAmount > 0) {
        setTimeout(this._closeSocketIfRequired.bind(this), 1e3);
      } else {
        logger35.debug("closing WebSocket...");
        if (this.keepAliveTimeoutId) {
          clearTimeout(this.keepAliveTimeoutId);
        }
        if (this.keepAliveAlertTimeoutId) {
          clearTimeout(this.keepAliveAlertTimeoutId);
        }
        var tempSocket = this.awsRealTimeSocket;
        tempSocket.onclose = null;
        tempSocket.onerror = null;
        tempSocket.close(1e3);
        this.awsRealTimeSocket = void 0;
        this.socketStatus = SOCKET_STATUS.CLOSED;
        this.connectionStateMonitor.record(CONNECTION_CHANGE.CLOSED);
      }
    };
    AWSAppSyncRealTimeProvider2.prototype._handleIncomingSubscriptionMessage = function(message) {
      var _this = this;
      if (typeof message.data !== "string") {
        return;
      }
      logger35.debug("subscription message from AWS AppSync RealTime: " + message.data);
      var _a2 = JSON.parse(String(message.data)), _b2 = _a2.id, id = _b2 === void 0 ? "" : _b2, payload = _a2.payload, type = _a2.type;
      var _c = this.subscriptionObserverMap.get(id) || {}, _d = _c.observer, observer = _d === void 0 ? null : _d, _e = _c.query, query = _e === void 0 ? "" : _e, _f = _c.variables, variables = _f === void 0 ? {} : _f, startAckTimeoutId = _c.startAckTimeoutId, subscriptionReadyCallback = _c.subscriptionReadyCallback, subscriptionFailedCallback = _c.subscriptionFailedCallback;
      logger35.debug({ id, observer, query, variables });
      if (type === MESSAGE_TYPES.GQL_DATA && payload && payload.data) {
        if (observer) {
          observer.next(payload);
        } else {
          logger35.debug("observer not found for id: " + id);
        }
        return;
      }
      if (type === MESSAGE_TYPES.GQL_START_ACK) {
        logger35.debug("subscription ready for " + JSON.stringify({ query, variables }));
        if (typeof subscriptionReadyCallback === "function") {
          subscriptionReadyCallback();
        }
        if (startAckTimeoutId)
          clearTimeout(startAckTimeoutId);
        dispatchApiEvent(CONTROL_MSG.SUBSCRIPTION_ACK, { query, variables }, "Connection established for subscription");
        var subscriptionState = SUBSCRIPTION_STATUS.CONNECTED;
        if (observer) {
          this.subscriptionObserverMap.set(id, {
            observer,
            query,
            variables,
            startAckTimeoutId: void 0,
            subscriptionState,
            subscriptionReadyCallback,
            subscriptionFailedCallback
          });
        }
        this.connectionStateMonitor.record(CONNECTION_CHANGE.CONNECTION_ESTABLISHED);
        return;
      }
      if (type === MESSAGE_TYPES.GQL_CONNECTION_KEEP_ALIVE) {
        if (this.keepAliveTimeoutId)
          clearTimeout(this.keepAliveTimeoutId);
        if (this.keepAliveAlertTimeoutId)
          clearTimeout(this.keepAliveAlertTimeoutId);
        this.keepAliveTimeoutId = setTimeout(function() {
          return _this._errorDisconnect(CONTROL_MSG.TIMEOUT_DISCONNECT);
        }, this.keepAliveTimeout);
        this.keepAliveAlertTimeoutId = setTimeout(function() {
          _this.connectionStateMonitor.record(CONNECTION_CHANGE.KEEP_ALIVE_MISSED);
        }, DEFAULT_KEEP_ALIVE_ALERT_TIMEOUT);
        this.connectionStateMonitor.record(CONNECTION_CHANGE.KEEP_ALIVE);
        return;
      }
      if (type === MESSAGE_TYPES.GQL_ERROR) {
        var subscriptionState = SUBSCRIPTION_STATUS.FAILED;
        if (observer) {
          this.subscriptionObserverMap.set(id, {
            observer,
            query,
            variables,
            startAckTimeoutId,
            subscriptionReadyCallback,
            subscriptionFailedCallback,
            subscriptionState
          });
          logger35.debug(CONTROL_MSG.CONNECTION_FAILED + ": " + JSON.stringify(payload));
          observer.error({
            errors: [
              __assign42({}, new GraphQLError(CONTROL_MSG.CONNECTION_FAILED + ": " + JSON.stringify(payload)))
            ]
          });
          if (startAckTimeoutId)
            clearTimeout(startAckTimeoutId);
          if (typeof subscriptionFailedCallback === "function") {
            subscriptionFailedCallback();
          }
        }
      }
    };
    AWSAppSyncRealTimeProvider2.prototype._errorDisconnect = function(msg) {
      logger35.debug("Disconnect error: " + msg);
      if (this.awsRealTimeSocket) {
        this.connectionStateMonitor.record(CONNECTION_CHANGE.CLOSED);
        this.awsRealTimeSocket.close();
      }
      this.socketStatus = SOCKET_STATUS.CLOSED;
    };
    AWSAppSyncRealTimeProvider2.prototype._timeoutStartSubscriptionAck = function(subscriptionId) {
      var subscriptionObserver = this.subscriptionObserverMap.get(subscriptionId);
      if (subscriptionObserver) {
        var observer = subscriptionObserver.observer, query = subscriptionObserver.query, variables = subscriptionObserver.variables;
        if (!observer) {
          return;
        }
        this.subscriptionObserverMap.set(subscriptionId, {
          observer,
          query,
          variables,
          subscriptionState: SUBSCRIPTION_STATUS.FAILED
        });
        this.connectionStateMonitor.record(CONNECTION_CHANGE.CLOSED);
        logger35.debug("timeoutStartSubscription", JSON.stringify({ query, variables }));
      }
    };
    AWSAppSyncRealTimeProvider2.prototype._initializeWebSocketConnection = function(_a2) {
      var _this = this;
      var appSyncGraphqlEndpoint = _a2.appSyncGraphqlEndpoint, authenticationType = _a2.authenticationType, apiKey = _a2.apiKey, region = _a2.region, additionalHeaders = _a2.additionalHeaders;
      if (this.socketStatus === SOCKET_STATUS.READY) {
        return;
      }
      return new Promise(function(res, rej) {
        return __awaiter66(_this, void 0, void 0, function() {
          var payloadString, authHeader, headerString, headerQs, payloadQs, discoverableEndpoint, protocol, awsRealTimeUrl, err_3;
          return __generator67(this, function(_a3) {
            switch (_a3.label) {
              case 0:
                this.promiseArray.push({ res, rej });
                if (!(this.socketStatus === SOCKET_STATUS.CLOSED))
                  return [3, 5];
                _a3.label = 1;
              case 1:
                _a3.trys.push([1, 4, , 5]);
                this.socketStatus = SOCKET_STATUS.CONNECTING;
                payloadString = "{}";
                return [4, this._awsRealTimeHeaderBasedAuth({
                  authenticationType,
                  payload: payloadString,
                  canonicalUri: "/connect",
                  apiKey,
                  appSyncGraphqlEndpoint,
                  region,
                  additionalHeaders
                })];
              case 2:
                authHeader = _a3.sent();
                headerString = authHeader ? JSON.stringify(authHeader) : "";
                headerQs = import_buffer5.Buffer.from(headerString).toString("base64");
                payloadQs = import_buffer5.Buffer.from(payloadString).toString("base64");
                discoverableEndpoint = appSyncGraphqlEndpoint !== null && appSyncGraphqlEndpoint !== void 0 ? appSyncGraphqlEndpoint : "";
                if (this.isCustomDomain(discoverableEndpoint)) {
                  discoverableEndpoint = discoverableEndpoint.concat(customDomainPath);
                } else {
                  discoverableEndpoint = discoverableEndpoint.replace("appsync-api", "appsync-realtime-api").replace("gogi-beta", "grt-beta");
                }
                protocol = this.isSSLEnabled ? "wss://" : "ws://";
                discoverableEndpoint = discoverableEndpoint.replace("https://", protocol).replace("http://", protocol);
                awsRealTimeUrl = discoverableEndpoint + "?header=" + headerQs + "&payload=" + payloadQs;
                return [4, this._initializeRetryableHandshake(awsRealTimeUrl)];
              case 3:
                _a3.sent();
                this.promiseArray.forEach(function(_a4) {
                  var res2 = _a4.res;
                  logger35.debug("Notifying connection successful");
                  res2();
                });
                this.socketStatus = SOCKET_STATUS.READY;
                this.promiseArray = [];
                return [3, 5];
              case 4:
                err_3 = _a3.sent();
                logger35.debug("Connection exited with", err_3);
                this.promiseArray.forEach(function(_a4) {
                  var rej2 = _a4.rej;
                  return rej2(err_3);
                });
                this.promiseArray = [];
                if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN) {
                  this.awsRealTimeSocket.close(3001);
                }
                this.awsRealTimeSocket = void 0;
                this.socketStatus = SOCKET_STATUS.CLOSED;
                return [3, 5];
              case 5:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    };
    AWSAppSyncRealTimeProvider2.prototype._initializeRetryableHandshake = function(awsRealTimeUrl) {
      return __awaiter66(this, void 0, void 0, function() {
        return __generator67(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              logger35.debug("Initializaling retryable Handshake");
              return [4, jitteredExponentialRetry(this._initializeHandshake.bind(this), [awsRealTimeUrl], MAX_DELAY_MS3)];
            case 1:
              _a2.sent();
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSAppSyncRealTimeProvider2.prototype._initializeHandshake = function(awsRealTimeUrl) {
      return __awaiter66(this, void 0, void 0, function() {
        var err_4, _a2, errorType, errorCode;
        var _this = this;
        return __generator67(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              logger35.debug("Initializing handshake " + awsRealTimeUrl);
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 4, , 5]);
              return [4, function() {
                return new Promise(function(res, rej) {
                  var newSocket = _this.getNewWebSocket(awsRealTimeUrl, "graphql-ws");
                  newSocket.onerror = function() {
                    logger35.debug("WebSocket connection error");
                  };
                  newSocket.onclose = function() {
                    rej(new Error("Connection handshake error"));
                  };
                  newSocket.onopen = function() {
                    _this.awsRealTimeSocket = newSocket;
                    return res();
                  };
                });
              }()];
            case 2:
              _b2.sent();
              return [4, function() {
                return new Promise(function(res, rej) {
                  if (_this.awsRealTimeSocket) {
                    var ackOk_1 = false;
                    _this.awsRealTimeSocket.onerror = function(error) {
                      logger35.debug("WebSocket error " + JSON.stringify(error));
                    };
                    _this.awsRealTimeSocket.onclose = function(event) {
                      logger35.debug("WebSocket closed " + event.reason);
                      rej(new Error(JSON.stringify(event)));
                    };
                    _this.awsRealTimeSocket.onmessage = function(message) {
                      if (typeof message.data !== "string") {
                        return;
                      }
                      logger35.debug("subscription message from AWS AppSyncRealTime: " + message.data + " ");
                      var data = JSON.parse(message.data);
                      var type = data.type, _a3 = data.payload, _b3 = (_a3 === void 0 ? {} : _a3).connectionTimeoutMs, connectionTimeoutMs = _b3 === void 0 ? DEFAULT_KEEP_ALIVE_TIMEOUT : _b3;
                      if (type === MESSAGE_TYPES.GQL_CONNECTION_ACK) {
                        ackOk_1 = true;
                        if (_this.awsRealTimeSocket) {
                          _this.keepAliveTimeout = connectionTimeoutMs;
                          _this.awsRealTimeSocket.onmessage = _this._handleIncomingSubscriptionMessage.bind(_this);
                          _this.awsRealTimeSocket.onerror = function(err) {
                            logger35.debug(err);
                            _this._errorDisconnect(CONTROL_MSG.CONNECTION_CLOSED);
                          };
                          _this.awsRealTimeSocket.onclose = function(event) {
                            logger35.debug("WebSocket closed " + event.reason);
                            _this._errorDisconnect(CONTROL_MSG.CONNECTION_CLOSED);
                          };
                        }
                        res("Cool, connected to AWS AppSyncRealTime");
                        return;
                      }
                      if (type === MESSAGE_TYPES.GQL_CONNECTION_ERROR) {
                        var _c = data.payload, _d = (_c === void 0 ? {} : _c).errors, _e = __read35(_d === void 0 ? [] : _d, 1), _f = _e[0], _g = _f === void 0 ? {} : _f, _h = _g.errorType, errorType2 = _h === void 0 ? "" : _h, _j = _g.errorCode, errorCode2 = _j === void 0 ? 0 : _j;
                        rej({ errorType: errorType2, errorCode: errorCode2 });
                      }
                    };
                    var gqlInit = {
                      type: MESSAGE_TYPES.GQL_CONNECTION_INIT
                    };
                    _this.awsRealTimeSocket.send(JSON.stringify(gqlInit));
                    var checkAckOk_1 = function(ackOk) {
                      if (!ackOk) {
                        _this.connectionStateMonitor.record(CONNECTION_CHANGE.CONNECTION_FAILED);
                        rej(new Error("Connection timeout: ack from AWSAppSyncRealTime was not received after " + CONNECTION_INIT_TIMEOUT + " ms"));
                      }
                    };
                    setTimeout(function() {
                      return checkAckOk_1(ackOk_1);
                    }, CONNECTION_INIT_TIMEOUT);
                  }
                });
              }()];
            case 3:
              _b2.sent();
              return [3, 5];
            case 4:
              err_4 = _b2.sent();
              _a2 = err_4, errorType = _a2.errorType, errorCode = _a2.errorCode;
              if (NON_RETRYABLE_CODES.includes(errorCode)) {
                throw new NonRetryableError(errorType);
              } else if (errorType) {
                throw new Error(errorType);
              } else {
                throw err_4;
              }
              return [3, 5];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSAppSyncRealTimeProvider2.prototype._awsRealTimeHeaderBasedAuth = function(_a2) {
      var authenticationType = _a2.authenticationType, payload = _a2.payload, canonicalUri = _a2.canonicalUri, appSyncGraphqlEndpoint = _a2.appSyncGraphqlEndpoint, apiKey = _a2.apiKey, region = _a2.region, additionalHeaders = _a2.additionalHeaders;
      return __awaiter66(this, void 0, void 0, function() {
        var headerHandler, handler, host, result;
        return __generator67(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              headerHandler = {
                API_KEY: this._awsRealTimeApiKeyHeader.bind(this),
                AWS_IAM: this._awsRealTimeIAMHeader.bind(this),
                OPENID_CONNECT: this._awsRealTimeOPENIDHeader.bind(this),
                AMAZON_COGNITO_USER_POOLS: this._awsRealTimeCUPHeader.bind(this),
                AWS_LAMBDA: this._customAuthHeader
              };
              if (!(!authenticationType || !headerHandler[authenticationType]))
                return [3, 1];
              logger35.debug("Authentication type " + authenticationType + " not supported");
              return [2, void 0];
            case 1:
              handler = headerHandler[authenticationType];
              host = url.parse(appSyncGraphqlEndpoint !== null && appSyncGraphqlEndpoint !== void 0 ? appSyncGraphqlEndpoint : "").host;
              logger35.debug("Authenticating with " + authenticationType);
              return [4, handler({
                payload,
                canonicalUri,
                appSyncGraphqlEndpoint,
                apiKey,
                region,
                host,
                additionalHeaders
              })];
            case 2:
              result = _b2.sent();
              return [2, result];
          }
        });
      });
    };
    AWSAppSyncRealTimeProvider2.prototype._awsRealTimeCUPHeader = function(_a2) {
      var host = _a2.host;
      return __awaiter66(this, void 0, void 0, function() {
        var session;
        return __generator67(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              return [4, Auth.currentSession()];
            case 1:
              session = _b2.sent();
              return [2, {
                Authorization: session.getAccessToken().getJwtToken(),
                host
              }];
          }
        });
      });
    };
    AWSAppSyncRealTimeProvider2.prototype._awsRealTimeOPENIDHeader = function(_a2) {
      var host = _a2.host;
      return __awaiter66(this, void 0, void 0, function() {
        var token, federatedInfo, currentUser;
        return __generator67(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              return [4, BrowserStorageCache.getItem("federatedInfo")];
            case 1:
              federatedInfo = _b2.sent();
              if (!federatedInfo)
                return [3, 2];
              token = federatedInfo.token;
              return [3, 4];
            case 2:
              return [4, Auth.currentAuthenticatedUser()];
            case 3:
              currentUser = _b2.sent();
              if (currentUser) {
                token = currentUser.token;
              }
              _b2.label = 4;
            case 4:
              if (!token) {
                throw new Error("No federated jwt");
              }
              return [2, {
                Authorization: token,
                host
              }];
          }
        });
      });
    };
    AWSAppSyncRealTimeProvider2.prototype._awsRealTimeApiKeyHeader = function(_a2) {
      var apiKey = _a2.apiKey, host = _a2.host;
      return __awaiter66(this, void 0, void 0, function() {
        var dt, dtStr;
        return __generator67(this, function(_b2) {
          dt = /* @__PURE__ */ new Date();
          dtStr = dt.toISOString().replace(/[:\-]|\.\d{3}/g, "");
          return [2, {
            host,
            "x-amz-date": dtStr,
            "x-api-key": apiKey
          }];
        });
      });
    };
    AWSAppSyncRealTimeProvider2.prototype._awsRealTimeIAMHeader = function(_a2) {
      var payload = _a2.payload, canonicalUri = _a2.canonicalUri, appSyncGraphqlEndpoint = _a2.appSyncGraphqlEndpoint, region = _a2.region;
      return __awaiter66(this, void 0, void 0, function() {
        var endpointInfo, credentialsOK, creds, request, signed_params;
        return __generator67(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              endpointInfo = {
                region,
                service: "appsync"
              };
              return [4, this._ensureCredentials()];
            case 1:
              credentialsOK = _b2.sent();
              if (!credentialsOK) {
                throw new Error("No credentials");
              }
              return [4, Credentials.get().then(function(credentials) {
                var _a3 = credentials, secretAccessKey = _a3.secretAccessKey, accessKeyId = _a3.accessKeyId, sessionToken = _a3.sessionToken;
                return {
                  secret_key: secretAccessKey,
                  access_key: accessKeyId,
                  session_token: sessionToken
                };
              })];
            case 2:
              creds = _b2.sent();
              request = {
                url: "" + appSyncGraphqlEndpoint + canonicalUri,
                data: payload,
                method: "POST",
                headers: __assign42({}, AWS_APPSYNC_REALTIME_HEADERS)
              };
              signed_params = Signer.sign(request, creds, endpointInfo);
              return [2, signed_params.headers];
          }
        });
      });
    };
    AWSAppSyncRealTimeProvider2.prototype._customAuthHeader = function(_a2) {
      var host = _a2.host, additionalHeaders = _a2.additionalHeaders;
      if (!additionalHeaders || !additionalHeaders["Authorization"]) {
        throw new Error("No auth token specified");
      }
      return {
        Authorization: additionalHeaders.Authorization,
        host
      };
    };
    AWSAppSyncRealTimeProvider2.prototype._ensureCredentials = function() {
      return Credentials.get().then(function(credentials) {
        if (!credentials)
          return false;
        var cred = Credentials.shear(credentials);
        logger35.debug("set credentials for AWSAppSyncRealTimeProvider", cred);
        return true;
      }).catch(function(err) {
        logger35.warn("ensure credentials error", err);
        return false;
      });
    };
    return AWSAppSyncRealTimeProvider2;
  }(AbstractPubSubProvider)
);

// node_modules/@aws-amplify/pubsub/lib-esm/internals/InternalPubSub.js
var isNode2 = browserOrNode().isNode;
var logger36 = new ConsoleLogger("PubSub");
var InternalPubSubClass = (
  /** @class */
  function() {
    function InternalPubSubClass2(options) {
      this._options = options !== null && options !== void 0 ? options : {};
      logger36.debug("PubSub Options", this._options);
      this._pluggables = [];
      this.subscribe = this.subscribe.bind(this);
    }
    Object.defineProperty(InternalPubSubClass2.prototype, "awsAppSyncRealTimeProvider", {
      /**
       * Lazy instantiate AWSAppSyncRealTimeProvider when it is required by the API category
       */
      get: function() {
        if (!this._awsAppSyncRealTimeProvider) {
          this._awsAppSyncRealTimeProvider = new AWSAppSyncRealTimeProvider(this._options);
        }
        return this._awsAppSyncRealTimeProvider;
      },
      enumerable: true,
      configurable: true
    });
    InternalPubSubClass2.prototype.getModuleName = function() {
      return "InternalPubSub";
    };
    InternalPubSubClass2.prototype.configure = function(options) {
      var _this = this;
      var opt = options ? options.PubSub || options : {};
      logger36.debug("configure PubSub", { opt });
      this._options = Object.assign({}, this._options, opt);
      this._pluggables.map(function(pluggable) {
        return pluggable.configure(_this._options);
      });
      return this._options;
    };
    InternalPubSubClass2.prototype.addPluggable = function(pluggable) {
      return __awaiter66(this, void 0, void 0, function() {
        var config;
        return __generator67(this, function(_a2) {
          if (pluggable && pluggable.getCategory() === "PubSub") {
            this._pluggables.push(pluggable);
            config = pluggable.configure(this._options);
            return [2, config];
          }
          return [
            2
            /*return*/
          ];
        });
      });
    };
    InternalPubSubClass2.prototype.removePluggable = function(providerName) {
      this._pluggables = this._pluggables.filter(function(pluggable) {
        return pluggable.getProviderName() !== providerName;
      });
    };
    InternalPubSubClass2.prototype.getProviderByName = function(providerName) {
      if (providerName === INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER) {
        return this.awsAppSyncRealTimeProvider;
      }
      return this._pluggables.find(function(pluggable) {
        return pluggable.getProviderName() === providerName;
      });
    };
    InternalPubSubClass2.prototype.getProviders = function(options) {
      if (options === void 0) {
        options = {};
      }
      var providerName = options.provider;
      if (!providerName) {
        return this._pluggables;
      }
      var provider = this.getProviderByName(providerName);
      if (!provider) {
        throw new Error("Could not find provider named " + String(providerName));
      }
      return [provider];
    };
    InternalPubSubClass2.prototype.publish = function(topics, msg, options) {
      return __awaiter66(this, void 0, void 0, function() {
        return __generator67(this, function(_a2) {
          return [2, Promise.all(this.getProviders(options).map(function(provider) {
            return provider.publish(topics, msg, options);
          }))];
        });
      });
    };
    InternalPubSubClass2.prototype.subscribe = function(topics, options, customUserAgentDetails) {
      if (isNode2 && this._options && this._options.ssr) {
        throw new Error("Subscriptions are not supported for Server-Side Rendering (SSR)");
      }
      logger36.debug("subscribe options", options);
      var providers = this.getProviders(options);
      var pubSubUserAgentDetails = __assign42({ category: Category.PubSub, action: PubSubAction.Subscribe }, customUserAgentDetails);
      return new bundle_esm_default(function(observer) {
        var observables = providers.map(function(provider) {
          return {
            provider,
            observable: provider.subscribe(topics, options, pubSubUserAgentDetails)
          };
        });
        var subscriptions = observables.map(function(_a2) {
          var provider = _a2.provider, observable = _a2.observable;
          return observable.subscribe({
            start: console.error,
            next: function(value) {
              return observer.next({ provider, value });
            },
            error: function(error) {
              return observer.error({ provider, error });
            }
          });
        });
        return function() {
          return subscriptions.forEach(function(subscription) {
            return subscription.unsubscribe();
          });
        };
      });
    };
    return InternalPubSubClass2;
  }()
);
var InternalPubSub = new InternalPubSubClass();
Amplify.register(InternalPubSub);

// node_modules/@aws-amplify/api-graphql/lib-esm/types/index.js
var GraphQLAuthError;
(function(GraphQLAuthError2) {
  GraphQLAuthError2["NO_API_KEY"] = "No api-key configured";
  GraphQLAuthError2["NO_CURRENT_USER"] = "No current user";
  GraphQLAuthError2["NO_CREDENTIALS"] = "No credentials";
  GraphQLAuthError2["NO_FEDERATED_JWT"] = "No federated jwt";
  GraphQLAuthError2["NO_AUTH_TOKEN"] = "No auth token specified";
})(GraphQLAuthError || (GraphQLAuthError = {}));

// node_modules/@aws-amplify/api-rest/node_modules/tslib/tslib.es6.js
var __assign43 = function() {
  __assign43 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign43.apply(this, arguments);
};
function __rest12(s2, e) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
}
function __awaiter67(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator68(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-amplify/api-rest/lib-esm/RestClient.js
var import_axios4 = __toESM(require_axios4());
var import_url3 = __toESM(require_url());
var logger37 = new ConsoleLogger("RestClient");
var RestClient = (
  /** @class */
  function() {
    function RestClient2(options) {
      this._region = "us-east-1";
      this._service = "execute-api";
      this._custom_header = void 0;
      this._cancelTokenMap = null;
      this.Credentials = Credentials;
      this._options = options;
      logger37.debug("API Options", this._options);
      if (this._cancelTokenMap == null) {
        this._cancelTokenMap = /* @__PURE__ */ new WeakMap();
      }
    }
    RestClient2.prototype.ajax = function(urlOrApiInfo, method, init) {
      return __awaiter67(this, void 0, void 0, function() {
        var parsed_url, url2, region, service, custom_header, params, libraryHeaders, initParams, isAllResponse, custom_header_obj, _a2, _b2, search, parsedUrl;
        var _this = this;
        return __generator68(this, function(_c) {
          switch (_c.label) {
            case 0:
              logger37.debug(method, urlOrApiInfo);
              region = "us-east-1";
              service = "execute-api";
              custom_header = void 0;
              if (typeof urlOrApiInfo === "string") {
                parsed_url = this._parseUrl(urlOrApiInfo);
                url2 = urlOrApiInfo;
              } else {
                url2 = urlOrApiInfo.endpoint, custom_header = urlOrApiInfo.custom_header, region = urlOrApiInfo.region, service = urlOrApiInfo.service;
                parsed_url = this._parseUrl(urlOrApiInfo.endpoint);
              }
              params = {
                method,
                url: url2,
                host: parsed_url.host,
                path: parsed_url.path,
                headers: {},
                data: null,
                responseType: "json",
                timeout: 0,
                cancelToken: null
              };
              libraryHeaders = {};
              initParams = Object.assign({}, init);
              isAllResponse = initParams.response;
              if (initParams.body) {
                if (typeof FormData === "function" && initParams.body instanceof FormData) {
                  libraryHeaders["Content-Type"] = "multipart/form-data";
                  params.data = initParams.body;
                } else {
                  libraryHeaders["Content-Type"] = "application/json; charset=UTF-8";
                  params.data = JSON.stringify(initParams.body);
                }
              }
              if (initParams.responseType) {
                params.responseType = initParams.responseType;
              }
              if (initParams.withCredentials) {
                params["withCredentials"] = initParams.withCredentials;
              }
              if (initParams.timeout) {
                params.timeout = initParams.timeout;
              }
              if (initParams.cancellableToken) {
                params.cancelToken = initParams.cancellableToken.token;
              }
              params["signerServiceInfo"] = initParams.signerServiceInfo;
              if (!(typeof custom_header === "function"))
                return [3, 2];
              return [4, custom_header()];
            case 1:
              _a2 = _c.sent();
              return [3, 3];
            case 2:
              _a2 = void 0;
              _c.label = 3;
            case 3:
              custom_header_obj = _a2;
              params.headers = __assign43(__assign43(__assign43({}, libraryHeaders), custom_header_obj), initParams.headers);
              _b2 = (0, import_url3.parse)(url2, true, true), search = _b2.search, parsedUrl = __rest12(_b2, ["search"]);
              params.url = (0, import_url3.format)(__assign43(__assign43({}, parsedUrl), { query: __assign43(__assign43({}, parsedUrl.query), initParams.queryStringParameters || {}) }));
              if (typeof params.headers["Authorization"] !== "undefined") {
                params.headers = Object.keys(params.headers).reduce(function(acc, k2) {
                  if (params.headers[k2]) {
                    acc[k2] = params.headers[k2];
                  }
                  return acc;
                }, {});
                return [2, this._request(params, isAllResponse)];
              }
              return [2, this.Credentials.get().then(function(credentials) {
                return _this._signed(__assign43({}, params), credentials, isAllResponse, {
                  region,
                  service
                }).catch(function(error) {
                  if (DateUtils.isClockSkewError(error)) {
                    var headers = error.response.headers;
                    var dateHeader = headers && (headers.date || headers.Date);
                    var responseDate = new Date(dateHeader);
                    var requestDate = DateUtils.getDateFromHeaderString(params.headers["x-amz-date"]);
                    if (DateUtils.isClockSkewed(responseDate)) {
                      DateUtils.setClockOffset(responseDate.getTime() - requestDate.getTime());
                      return _this.ajax(urlOrApiInfo, method, init);
                    }
                  }
                  throw error;
                });
              }, function(err) {
                logger37.debug("No credentials available, the request will be unsigned");
                return _this._request(params, isAllResponse);
              })];
          }
        });
      });
    };
    RestClient2.prototype.get = function(urlOrApiInfo, init) {
      return this.ajax(urlOrApiInfo, "GET", init);
    };
    RestClient2.prototype.put = function(urlOrApiInfo, init) {
      return this.ajax(urlOrApiInfo, "PUT", init);
    };
    RestClient2.prototype.patch = function(urlOrApiInfo, init) {
      return this.ajax(urlOrApiInfo, "PATCH", init);
    };
    RestClient2.prototype.post = function(urlOrApiInfo, init) {
      return this.ajax(urlOrApiInfo, "POST", init);
    };
    RestClient2.prototype.del = function(urlOrApiInfo, init) {
      return this.ajax(urlOrApiInfo, "DELETE", init);
    };
    RestClient2.prototype.head = function(urlOrApiInfo, init) {
      return this.ajax(urlOrApiInfo, "HEAD", init);
    };
    RestClient2.prototype.cancel = function(request, message) {
      var source = this._cancelTokenMap.get(request);
      if (source) {
        source.cancel(message);
        return true;
      }
      return false;
    };
    RestClient2.prototype.hasCancelToken = function(request) {
      return this._cancelTokenMap.has(request);
    };
    RestClient2.prototype.isCancel = function(error) {
      return import_axios4.default.isCancel(error);
    };
    RestClient2.prototype.getCancellableToken = function() {
      return import_axios4.default.CancelToken.source();
    };
    RestClient2.prototype.updateRequestToBeCancellable = function(promise, cancelTokenSource) {
      this._cancelTokenMap.set(promise, cancelTokenSource);
    };
    RestClient2.prototype.endpoint = function(apiName) {
      var _this = this;
      var cloud_logic_array = this._options.endpoints;
      var response = "";
      if (!Array.isArray(cloud_logic_array)) {
        return response;
      }
      cloud_logic_array.forEach(function(v2) {
        if (v2.name === apiName) {
          response = v2.endpoint;
          if (typeof v2.region === "string") {
            _this._region = v2.region;
          } else if (typeof _this._options.region === "string") {
            _this._region = _this._options.region;
          }
          if (typeof v2.service === "string") {
            _this._service = v2.service || "execute-api";
          } else {
            _this._service = "execute-api";
          }
          if (typeof v2.custom_header === "function") {
            _this._custom_header = v2.custom_header;
          } else {
            _this._custom_header = void 0;
          }
        }
      });
      return response;
    };
    RestClient2.prototype._signed = function(params, credentials, isAllResponse, _a2) {
      var service = _a2.service, region = _a2.region;
      var signerServiceInfoParams = params.signerServiceInfo, otherParams = __rest12(params, ["signerServiceInfo"]);
      var endpoint_region = region || this._region || this._options.region;
      var endpoint_service = service || this._service || this._options.service;
      var creds = {
        secret_key: credentials.secretAccessKey,
        access_key: credentials.accessKeyId,
        session_token: credentials.sessionToken
      };
      var endpointInfo = {
        region: endpoint_region,
        service: endpoint_service
      };
      var signerServiceInfo = Object.assign(endpointInfo, signerServiceInfoParams);
      var signed_params = Signer.sign(otherParams, creds, signerServiceInfo);
      if (signed_params.data) {
        signed_params.body = signed_params.data;
      }
      logger37.debug("Signed Request: ", signed_params);
      delete signed_params.headers["host"];
      return (0, import_axios4.default)(signed_params).then(function(response) {
        return isAllResponse ? response : response.data;
      }).catch(function(error) {
        logger37.debug(error);
        throw error;
      });
    };
    RestClient2.prototype._request = function(params, isAllResponse) {
      if (isAllResponse === void 0) {
        isAllResponse = false;
      }
      return (0, import_axios4.default)(params).then(function(response) {
        return isAllResponse ? response : response.data;
      }).catch(function(error) {
        logger37.debug(error);
        throw error;
      });
    };
    RestClient2.prototype._parseUrl = function(url2) {
      var parts = url2.split("/");
      return {
        host: parts[2],
        path: "/" + parts.slice(3).join("/")
      };
    };
    return RestClient2;
  }()
);

// node_modules/@aws-amplify/api-rest/lib-esm/RestAPI.js
var logger38 = new ConsoleLogger("RestAPI");
var RestAPIClass = (
  /** @class */
  function() {
    function RestAPIClass2(options) {
      this._api = null;
      this.Credentials = Credentials;
      this._options = options;
      logger38.debug("API Options", this._options);
    }
    RestAPIClass2.prototype.getModuleName = function() {
      return "RestAPI";
    };
    RestAPIClass2.prototype.configure = function(options) {
      var _a2 = options || {}, _b2 = _a2.API, API2 = _b2 === void 0 ? {} : _b2, otherOptions = __rest12(_a2, ["API"]);
      var opt = __assign43(__assign43({}, otherOptions), API2);
      logger38.debug("configure Rest API", { opt });
      if (opt["aws_project_region"]) {
        if (opt["aws_cloud_logic_custom"]) {
          var custom = opt["aws_cloud_logic_custom"];
          opt.endpoints = typeof custom === "string" ? JSON.parse(custom) : custom;
        }
        opt = Object.assign({}, opt, {
          region: opt["aws_project_region"],
          header: {}
        });
      }
      if (Array.isArray(opt.endpoints)) {
        opt.endpoints.forEach(function(endpoint) {
          if (typeof endpoint.custom_header !== "undefined" && typeof endpoint.custom_header !== "function") {
            logger38.warn("Rest API " + endpoint.name + ", custom_header should be a function");
            endpoint.custom_header = void 0;
          }
        });
      } else if (this._options && Array.isArray(this._options.endpoints)) {
        opt.endpoints = this._options.endpoints;
      } else {
        opt.endpoints = [];
      }
      this._options = Object.assign({}, this._options, opt);
      this.createInstance();
      return this._options;
    };
    RestAPIClass2.prototype.createInstance = function() {
      logger38.debug("create Rest API instance");
      this._api = new RestClient(this._options);
      this._api.Credentials = this.Credentials;
      return true;
    };
    RestAPIClass2.prototype.get = function(apiName, path, init) {
      try {
        var apiInfo = this.getEndpointInfo(apiName, path);
        var cancellableToken = this._api.getCancellableToken();
        var initParams = Object.assign({}, init);
        initParams.cancellableToken = cancellableToken;
        var responsePromise = this._api.get(apiInfo, initParams);
        this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
        return responsePromise;
      } catch (err) {
        return Promise.reject(err.message);
      }
    };
    RestAPIClass2.prototype.post = function(apiName, path, init) {
      try {
        var apiInfo = this.getEndpointInfo(apiName, path);
        var cancellableToken = this._api.getCancellableToken();
        var initParams = Object.assign({}, init);
        initParams.cancellableToken = cancellableToken;
        var responsePromise = this._api.post(apiInfo, initParams);
        this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
        return responsePromise;
      } catch (err) {
        return Promise.reject(err.message);
      }
    };
    RestAPIClass2.prototype.put = function(apiName, path, init) {
      try {
        var apiInfo = this.getEndpointInfo(apiName, path);
        var cancellableToken = this._api.getCancellableToken();
        var initParams = Object.assign({}, init);
        initParams.cancellableToken = cancellableToken;
        var responsePromise = this._api.put(apiInfo, initParams);
        this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
        return responsePromise;
      } catch (err) {
        return Promise.reject(err.message);
      }
    };
    RestAPIClass2.prototype.patch = function(apiName, path, init) {
      try {
        var apiInfo = this.getEndpointInfo(apiName, path);
        var cancellableToken = this._api.getCancellableToken();
        var initParams = Object.assign({}, init);
        initParams.cancellableToken = cancellableToken;
        var responsePromise = this._api.patch(apiInfo, initParams);
        this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
        return responsePromise;
      } catch (err) {
        return Promise.reject(err.message);
      }
    };
    RestAPIClass2.prototype.del = function(apiName, path, init) {
      try {
        var apiInfo = this.getEndpointInfo(apiName, path);
        var cancellableToken = this._api.getCancellableToken();
        var initParams = Object.assign({}, init);
        initParams.cancellableToken = cancellableToken;
        var responsePromise = this._api.del(apiInfo, initParams);
        this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
        return responsePromise;
      } catch (err) {
        return Promise.reject(err.message);
      }
    };
    RestAPIClass2.prototype.head = function(apiName, path, init) {
      try {
        var apiInfo = this.getEndpointInfo(apiName, path);
        var cancellableToken = this._api.getCancellableToken();
        var initParams = Object.assign({}, init);
        initParams.cancellableToken = cancellableToken;
        var responsePromise = this._api.head(apiInfo, initParams);
        this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
        return responsePromise;
      } catch (err) {
        return Promise.reject(err.message);
      }
    };
    RestAPIClass2.prototype.isCancel = function(error) {
      return this._api.isCancel(error);
    };
    RestAPIClass2.prototype.cancel = function(request, message) {
      return this._api.cancel(request, message);
    };
    RestAPIClass2.prototype.hasCancelToken = function(request) {
      return this._api.hasCancelToken(request);
    };
    RestAPIClass2.prototype.endpoint = function(apiName) {
      return __awaiter67(this, void 0, void 0, function() {
        return __generator68(this, function(_a2) {
          return [2, this._api.endpoint(apiName)];
        });
      });
    };
    RestAPIClass2.prototype.getEndpointInfo = function(apiName, path) {
      var cloud_logic_array = this._options.endpoints;
      if (!Array.isArray(cloud_logic_array)) {
        throw new Error("API category not configured");
      }
      var apiConfig = cloud_logic_array.find(function(api) {
        return api.name === apiName;
      });
      if (!apiConfig) {
        throw new Error("API " + apiName + " does not exist");
      }
      var response = {
        endpoint: apiConfig.endpoint + path
      };
      if (typeof apiConfig.region === "string") {
        response.region = apiConfig.region;
      } else if (typeof this._options.region === "string") {
        response.region = this._options.region;
      }
      if (typeof apiConfig.service === "string") {
        response.service = apiConfig.service || "execute-api";
      } else {
        response.service = "execute-api";
      }
      if (typeof apiConfig.custom_header === "function") {
        response.custom_header = apiConfig.custom_header;
      } else {
        response.custom_header = void 0;
      }
      return response;
    };
    return RestAPIClass2;
  }()
);
var RestAPI = new RestAPIClass(null);
Amplify.register(RestAPI);

// node_modules/@aws-amplify/api-graphql/lib-esm/internals/InternalGraphQLAPI.js
var USER_AGENT_HEADER2 = "x-amz-user-agent";
var logger39 = new ConsoleLogger("GraphQLAPI");
var InternalGraphQLAPIClass = (
  /** @class */
  function() {
    function InternalGraphQLAPIClass2(options) {
      this._api = null;
      this.Auth = Auth;
      this.Cache = BrowserStorageCache;
      this.Credentials = Credentials;
      this._options = options;
      logger39.debug("API Options", this._options);
    }
    InternalGraphQLAPIClass2.prototype.getModuleName = function() {
      return "InternalGraphQLAPI";
    };
    InternalGraphQLAPIClass2.prototype.configure = function(options) {
      var _a2 = options || {}, _b2 = _a2.API, API2 = _b2 === void 0 ? {} : _b2, otherOptions = __rest11(_a2, ["API"]);
      var opt = __assign41(__assign41({}, otherOptions), API2);
      logger39.debug("configure GraphQL API", { opt });
      if (opt["aws_project_region"]) {
        opt = Object.assign({}, opt, {
          region: opt["aws_project_region"],
          header: {}
        });
      }
      if (typeof opt.graphql_headers !== "undefined" && typeof opt.graphql_headers !== "function") {
        logger39.warn("graphql_headers should be a function");
        opt.graphql_headers = void 0;
      }
      this._options = Object.assign({}, this._options, opt);
      this.createInstance();
      return this._options;
    };
    InternalGraphQLAPIClass2.prototype.createInstance = function() {
      logger39.debug("create Rest instance");
      if (this._options) {
        this._api = new RestClient(this._options);
        this._api.Credentials = this.Credentials;
        return true;
      } else {
        return Promise.reject("API not configured");
      }
    };
    InternalGraphQLAPIClass2.prototype._headerBasedAuth = function(defaultAuthenticationType, additionalHeaders) {
      if (additionalHeaders === void 0) {
        additionalHeaders = {};
      }
      return __awaiter65(this, void 0, void 0, function() {
        var _a2, aws_appsync_authenticationType, apiKey, authenticationType, headers, _b2, credentialsOK, token, federatedInfo, currentUser, e_1, session, e_2;
        return __generator66(this, function(_c) {
          switch (_c.label) {
            case 0:
              _a2 = this._options, aws_appsync_authenticationType = _a2.aws_appsync_authenticationType, apiKey = _a2.aws_appsync_apiKey;
              authenticationType = defaultAuthenticationType || aws_appsync_authenticationType || "AWS_IAM";
              headers = {};
              _b2 = authenticationType;
              switch (_b2) {
                case "API_KEY":
                  return [3, 1];
                case "AWS_IAM":
                  return [3, 2];
                case "OPENID_CONNECT":
                  return [3, 4];
                case "AMAZON_COGNITO_USER_POOLS":
                  return [3, 11];
                case "AWS_LAMBDA":
                  return [3, 15];
              }
              return [3, 16];
            case 1:
              if (!apiKey) {
                throw new Error(GraphQLAuthError.NO_API_KEY);
              }
              headers = {
                Authorization: null,
                "X-Api-Key": apiKey
              };
              return [3, 17];
            case 2:
              return [4, this._ensureCredentials()];
            case 3:
              credentialsOK = _c.sent();
              if (!credentialsOK) {
                throw new Error(GraphQLAuthError.NO_CREDENTIALS);
              }
              return [3, 17];
            case 4:
              _c.trys.push([4, 9, , 10]);
              token = void 0;
              return [4, BrowserStorageCache.getItem("federatedInfo")];
            case 5:
              federatedInfo = _c.sent();
              if (!federatedInfo)
                return [3, 6];
              token = federatedInfo.token;
              return [3, 8];
            case 6:
              return [4, Auth.currentAuthenticatedUser()];
            case 7:
              currentUser = _c.sent();
              if (currentUser) {
                token = currentUser.token;
              }
              _c.label = 8;
            case 8:
              if (!token) {
                throw new Error(GraphQLAuthError.NO_FEDERATED_JWT);
              }
              headers = {
                Authorization: token
              };
              return [3, 10];
            case 9:
              e_1 = _c.sent();
              throw new Error(GraphQLAuthError.NO_CURRENT_USER);
            case 10:
              return [3, 17];
            case 11:
              _c.trys.push([11, 13, , 14]);
              return [4, this.Auth.currentSession()];
            case 12:
              session = _c.sent();
              headers = {
                Authorization: session.getAccessToken().getJwtToken()
              };
              return [3, 14];
            case 13:
              e_2 = _c.sent();
              throw new Error(GraphQLAuthError.NO_CURRENT_USER);
            case 14:
              return [3, 17];
            case 15:
              if (!additionalHeaders.Authorization) {
                throw new Error(GraphQLAuthError.NO_AUTH_TOKEN);
              }
              headers = {
                Authorization: additionalHeaders.Authorization
              };
              return [3, 17];
            case 16:
              headers = {
                Authorization: null
              };
              return [3, 17];
            case 17:
              return [2, headers];
          }
        });
      });
    };
    InternalGraphQLAPIClass2.prototype.getGraphqlOperationType = function(operation) {
      var doc = parse7(operation);
      var definitions = doc.definitions;
      var _a2 = __read34(definitions, 1), operationType = _a2[0].operation;
      return operationType;
    };
    InternalGraphQLAPIClass2.prototype.graphql = function(_a2, additionalHeaders, customUserAgentDetails) {
      var paramQuery = _a2.query, _b2 = _a2.variables, variables = _b2 === void 0 ? {} : _b2, authMode = _a2.authMode, authToken = _a2.authToken;
      var query = typeof paramQuery === "string" ? parse7(paramQuery) : parse7(print(paramQuery));
      var _c = __read34(query.definitions.filter(function(def) {
        return def.kind === "OperationDefinition";
      }), 1), _d = _c[0], operationDef = _d === void 0 ? {} : _d;
      var operationType = operationDef.operation;
      var headers = additionalHeaders || {};
      if (authToken) {
        headers.Authorization = authToken;
      }
      switch (operationType) {
        case "query":
        case "mutation":
          this.createInstanceIfNotCreated();
          var cancellableToken = this._api.getCancellableToken();
          var initParams = {
            cancellableToken,
            withCredentials: this._options.withCredentials
          };
          var responsePromise = this._graphql({ query, variables, authMode }, headers, initParams, customUserAgentDetails);
          this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
          return responsePromise;
        case "subscription":
          return this._graphqlSubscribe({ query, variables, authMode }, headers, customUserAgentDetails);
        default:
          throw new Error("invalid operation type: " + operationType);
      }
    };
    InternalGraphQLAPIClass2.prototype._graphql = function(_a2, additionalHeaders, initParams, customUserAgentDetails) {
      var query = _a2.query, variables = _a2.variables, authMode = _a2.authMode;
      if (additionalHeaders === void 0) {
        additionalHeaders = {};
      }
      if (initParams === void 0) {
        initParams = {};
      }
      return __awaiter65(this, void 0, void 0, function() {
        var _b2, region, appSyncGraphqlEndpoint, _c, graphql_headers, customGraphqlEndpoint, customEndpointRegion, headers, _d, _e, _f, _g, _h, _j, body, init, endpoint, error, response, err_1, errors;
        var _k;
        return __generator66(this, function(_l) {
          switch (_l.label) {
            case 0:
              this.createInstanceIfNotCreated();
              _b2 = this._options, region = _b2.aws_appsync_region, appSyncGraphqlEndpoint = _b2.aws_appsync_graphqlEndpoint, _c = _b2.graphql_headers, graphql_headers = _c === void 0 ? function() {
                return {};
              } : _c, customGraphqlEndpoint = _b2.graphql_endpoint, customEndpointRegion = _b2.graphql_endpoint_iam_region;
              _d = [{}];
              _e = !customGraphqlEndpoint;
              if (!_e)
                return [3, 2];
              return [4, this._headerBasedAuth(authMode, additionalHeaders)];
            case 1:
              _e = _l.sent();
              _l.label = 2;
            case 2:
              _f = [__assign41.apply(void 0, _d.concat([_e]))];
              _g = customGraphqlEndpoint;
              if (!_g)
                return [3, 6];
              if (!customEndpointRegion)
                return [3, 4];
              return [4, this._headerBasedAuth(authMode, additionalHeaders)];
            case 3:
              _h = _l.sent();
              return [3, 5];
            case 4:
              _h = { Authorization: null };
              _l.label = 5;
            case 5:
              _g = _h;
              _l.label = 6;
            case 6:
              _j = [__assign41.apply(void 0, _f.concat([_g]))];
              return [4, graphql_headers({ query, variables })];
            case 7:
              headers = __assign41.apply(void 0, [__assign41.apply(void 0, [__assign41.apply(void 0, _j.concat([_l.sent()])), additionalHeaders]), !customGraphqlEndpoint && (_k = {}, _k[USER_AGENT_HEADER2] = getAmplifyUserAgent(customUserAgentDetails), _k)]);
              body = {
                query: print(query),
                variables
              };
              init = Object.assign({
                headers,
                body,
                signerServiceInfo: {
                  service: !customGraphqlEndpoint ? "appsync" : "execute-api",
                  region: !customGraphqlEndpoint ? region : customEndpointRegion
                }
              }, initParams);
              endpoint = customGraphqlEndpoint || appSyncGraphqlEndpoint;
              if (!endpoint) {
                error = new GraphQLError("No graphql endpoint provided.");
                throw {
                  data: {},
                  errors: [error]
                };
              }
              _l.label = 8;
            case 8:
              _l.trys.push([8, 10, , 11]);
              return [4, this._api.post(endpoint, init)];
            case 9:
              response = _l.sent();
              return [3, 11];
            case 10:
              err_1 = _l.sent();
              if (this._api.isCancel(err_1)) {
                throw err_1;
              }
              response = {
                data: {},
                errors: [new GraphQLError(err_1.message, null, null, null, null, err_1)]
              };
              return [3, 11];
            case 11:
              errors = response.errors;
              if (errors && errors.length) {
                throw response;
              }
              return [2, response];
          }
        });
      });
    };
    InternalGraphQLAPIClass2.prototype.createInstanceIfNotCreated = function() {
      return __awaiter65(this, void 0, void 0, function() {
        return __generator66(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (!!this._api)
                return [3, 2];
              return [4, this.createInstance()];
            case 1:
              _a2.sent();
              _a2.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    InternalGraphQLAPIClass2.prototype.isCancel = function(error) {
      return this._api.isCancel(error);
    };
    InternalGraphQLAPIClass2.prototype.cancel = function(request, message) {
      return this._api.cancel(request, message);
    };
    InternalGraphQLAPIClass2.prototype.hasCancelToken = function(request) {
      return this._api.hasCancelToken(request);
    };
    InternalGraphQLAPIClass2.prototype._graphqlSubscribe = function(_a2, additionalHeaders, customUserAgentDetails) {
      var query = _a2.query, variables = _a2.variables, defaultAuthenticationType = _a2.authMode, authToken = _a2.authToken;
      if (additionalHeaders === void 0) {
        additionalHeaders = {};
      }
      var _b2 = this._options, region = _b2.aws_appsync_region, appSyncGraphqlEndpoint = _b2.aws_appsync_graphqlEndpoint, aws_appsync_authenticationType = _b2.aws_appsync_authenticationType, apiKey = _b2.aws_appsync_apiKey, _c = _b2.graphql_headers, graphql_headers = _c === void 0 ? function() {
        return {};
      } : _c;
      var authenticationType = defaultAuthenticationType || aws_appsync_authenticationType || "AWS_IAM";
      if (InternalPubSub && typeof InternalPubSub.subscribe === "function") {
        return InternalPubSub.subscribe("", {
          provider: INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER,
          appSyncGraphqlEndpoint,
          authenticationType,
          apiKey,
          query: print(query),
          region,
          variables,
          graphql_headers,
          additionalHeaders,
          authToken
        }, customUserAgentDetails);
      } else {
        logger39.debug("No pubsub module applied for subscription");
        throw new Error("No pubsub module applied for subscription");
      }
    };
    InternalGraphQLAPIClass2.prototype._ensureCredentials = function() {
      var _this = this;
      return this.Credentials.get().then(function(credentials) {
        if (!credentials)
          return false;
        var cred = _this.Credentials.shear(credentials);
        logger39.debug("set credentials for api", cred);
        return true;
      }).catch(function(err) {
        logger39.warn("ensure credentials error", err);
        return false;
      });
    };
    return InternalGraphQLAPIClass2;
  }()
);
var InternalGraphQLAPI = new InternalGraphQLAPIClass(null);
Amplify.register(InternalGraphQLAPI);

// node_modules/@aws-amplify/api/lib-esm/internals/InternalAPI.js
var logger40 = new ConsoleLogger("API");
var InternalAPIClass = (
  /** @class */
  function() {
    function InternalAPIClass2(options) {
      this.Auth = Auth;
      this.Cache = BrowserStorageCache;
      this.Credentials = Credentials;
      this._options = options;
      this._restApi = new RestAPIClass(options);
      this._graphqlApi = new InternalGraphQLAPIClass(options);
      logger40.debug("API Options", this._options);
    }
    InternalAPIClass2.prototype.getModuleName = function() {
      return "InternalAPI";
    };
    InternalAPIClass2.prototype.configure = function(options) {
      this._options = Object.assign({}, this._options, options);
      this._restApi.Credentials = this.Credentials;
      this._graphqlApi.Auth = this.Auth;
      this._graphqlApi.Cache = this.Cache;
      this._graphqlApi.Credentials = this.Credentials;
      var restAPIConfig = this._restApi.configure(this._options);
      var graphQLAPIConfig = this._graphqlApi.configure(this._options);
      return __assign40(__assign40({}, restAPIConfig), graphQLAPIConfig);
    };
    InternalAPIClass2.prototype.get = function(apiName, path, init) {
      return this._restApi.get(apiName, path, this.getInitWithCustomUserAgentDetails(init, ApiAction.Get));
    };
    InternalAPIClass2.prototype.post = function(apiName, path, init) {
      return this._restApi.post(apiName, path, this.getInitWithCustomUserAgentDetails(init, ApiAction.Post));
    };
    InternalAPIClass2.prototype.put = function(apiName, path, init) {
      return this._restApi.put(apiName, path, this.getInitWithCustomUserAgentDetails(init, ApiAction.Put));
    };
    InternalAPIClass2.prototype.patch = function(apiName, path, init) {
      return this._restApi.patch(apiName, path, this.getInitWithCustomUserAgentDetails(init, ApiAction.Patch));
    };
    InternalAPIClass2.prototype.del = function(apiName, path, init) {
      return this._restApi.del(apiName, path, this.getInitWithCustomUserAgentDetails(init, ApiAction.Del));
    };
    InternalAPIClass2.prototype.head = function(apiName, path, init) {
      return this._restApi.head(apiName, path, this.getInitWithCustomUserAgentDetails(init, ApiAction.Head));
    };
    InternalAPIClass2.prototype.isCancel = function(error) {
      return this._restApi.isCancel(error);
    };
    InternalAPIClass2.prototype.cancel = function(request, message) {
      if (this._restApi.hasCancelToken(request)) {
        return this._restApi.cancel(request, message);
      } else if (this._graphqlApi.hasCancelToken(request)) {
        return this._graphqlApi.cancel(request, message);
      }
      return false;
    };
    InternalAPIClass2.prototype.getInitWithCustomUserAgentDetails = function(init, action) {
      var customUserAgentDetails = {
        category: Category.API,
        action
      };
      var initParams = __assign40(__assign40({}, init), { customUserAgentDetails });
      return initParams;
    };
    InternalAPIClass2.prototype.endpoint = function(apiName) {
      return __awaiter64(this, void 0, void 0, function() {
        return __generator65(this, function(_a2) {
          return [2, this._restApi.endpoint(apiName)];
        });
      });
    };
    InternalAPIClass2.prototype.getGraphqlOperationType = function(operation) {
      return this._graphqlApi.getGraphqlOperationType(operation);
    };
    InternalAPIClass2.prototype.graphql = function(options, additionalHeaders, customUserAgentDetails) {
      var apiUserAgentDetails = __assign40({ category: Category.API, action: ApiAction.GraphQl }, customUserAgentDetails);
      return this._graphqlApi.graphql(options, additionalHeaders, apiUserAgentDetails);
    };
    return InternalAPIClass2;
  }()
);
var InternalAPI = new InternalAPIClass(null);
Amplify.register(InternalAPI);

// node_modules/@aws-amplify/api/lib-esm/API.js
var logger41 = new ConsoleLogger("API");
var APIClass = (
  /** @class */
  function(_super) {
    __extends8(APIClass2, _super);
    function APIClass2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    APIClass2.prototype.getModuleName = function() {
      return "API";
    };
    APIClass2.prototype.graphql = function(options, additionalHeaders) {
      return _super.prototype.graphql.call(this, options, additionalHeaders);
    };
    return APIClass2;
  }(InternalAPIClass)
);
var API = new APIClass(null);
Amplify.register(API);

// node_modules/@aws-amplify/api-graphql/lib-esm/GraphQLAPI.js
var graphqlOperation = function(query, variables, authToken) {
  if (variables === void 0) {
    variables = {};
  }
  return {
    query,
    variables,
    authToken
  };
};
var GraphQLAPIClass = (
  /** @class */
  function(_super) {
    __extends9(GraphQLAPIClass2, _super);
    function GraphQLAPIClass2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    GraphQLAPIClass2.prototype.getModuleName = function() {
      return "GraphQLAPI";
    };
    GraphQLAPIClass2.prototype.graphql = function(options, additionalHeaders) {
      return _super.prototype.graphql.call(this, options, additionalHeaders);
    };
    return GraphQLAPIClass2;
  }(InternalGraphQLAPIClass)
);
var GraphQLAPI = new GraphQLAPIClass(null);
Amplify.register(GraphQLAPI);

// node_modules/@aws-amplify/datastore/node_modules/immer/dist/immer.esm.js
function n(n2) {
  for (var t2 = arguments.length, r2 = Array(t2 > 1 ? t2 - 1 : 0), e = 1; e < t2; e++)
    r2[e - 1] = arguments[e];
  if ("production" !== __vite_process_env_NODE_ENV) {
    var i2 = Y[n2], o2 = i2 ? "function" == typeof i2 ? i2.apply(null, r2) : i2 : "unknown error nr: " + n2;
    throw Error("[Immer] " + o2);
  }
  throw Error("[Immer] minified error nr: " + n2 + (r2.length ? " " + r2.map(function(n3) {
    return "'" + n3 + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function t(n2) {
  return !!n2 && !!n2[Q];
}
function r(n2) {
  return !!n2 && (function(n3) {
    if (!n3 || "object" != typeof n3)
      return false;
    var t2 = Object.getPrototypeOf(n3);
    if (null === t2)
      return true;
    var r2 = Object.hasOwnProperty.call(t2, "constructor") && t2.constructor;
    return r2 === Object || "function" == typeof r2 && Function.toString.call(r2) === Z;
  }(n2) || Array.isArray(n2) || !!n2[L] || !!n2.constructor[L] || s(n2) || v(n2));
}
function i(n2, t2, r2) {
  void 0 === r2 && (r2 = false), 0 === o(n2) ? (r2 ? Object.keys : nn)(n2).forEach(function(e) {
    r2 && "symbol" == typeof e || t2(e, n2[e], n2);
  }) : n2.forEach(function(r3, e) {
    return t2(e, r3, n2);
  });
}
function o(n2) {
  var t2 = n2[Q];
  return t2 ? t2.i > 3 ? t2.i - 4 : t2.i : Array.isArray(n2) ? 1 : s(n2) ? 2 : v(n2) ? 3 : 0;
}
function u(n2, t2) {
  return 2 === o(n2) ? n2.has(t2) : Object.prototype.hasOwnProperty.call(n2, t2);
}
function a(n2, t2) {
  return 2 === o(n2) ? n2.get(t2) : n2[t2];
}
function f(n2, t2, r2) {
  var e = o(n2);
  2 === e ? n2.set(t2, r2) : 3 === e ? (n2.delete(t2), n2.add(r2)) : n2[t2] = r2;
}
function c(n2, t2) {
  return n2 === t2 ? 0 !== n2 || 1 / n2 == 1 / t2 : n2 != n2 && t2 != t2;
}
function s(n2) {
  return X && n2 instanceof Map;
}
function v(n2) {
  return q && n2 instanceof Set;
}
function p(n2) {
  return n2.o || n2.t;
}
function l(n2) {
  if (Array.isArray(n2))
    return Array.prototype.slice.call(n2);
  var t2 = tn(n2);
  delete t2[Q];
  for (var r2 = nn(t2), e = 0; e < r2.length; e++) {
    var i2 = r2[e], o2 = t2[i2];
    false === o2.writable && (o2.writable = true, o2.configurable = true), (o2.get || o2.set) && (t2[i2] = { configurable: true, writable: true, enumerable: o2.enumerable, value: n2[i2] });
  }
  return Object.create(Object.getPrototypeOf(n2), t2);
}
function d(n2, e) {
  return void 0 === e && (e = false), y(n2) || t(n2) || !r(n2) ? n2 : (o(n2) > 1 && (n2.set = n2.add = n2.clear = n2.delete = h), Object.freeze(n2), e && i(n2, function(n3, t2) {
    return d(t2, true);
  }, true), n2);
}
function h() {
  n(2);
}
function y(n2) {
  return null == n2 || "object" != typeof n2 || Object.isFrozen(n2);
}
function b(t2) {
  var r2 = rn[t2];
  return r2 || n(18, t2), r2;
}
function m(n2, t2) {
  rn[n2] || (rn[n2] = t2);
}
function _() {
  return "production" === __vite_process_env_NODE_ENV || U || n(0), U;
}
function j(n2, t2) {
  t2 && (b("Patches"), n2.u = [], n2.s = [], n2.v = t2);
}
function O(n2) {
  g(n2), n2.p.forEach(S), n2.p = null;
}
function g(n2) {
  n2 === U && (U = n2.l);
}
function w(n2) {
  return U = { p: [], l: U, h: n2, m: true, _: 0 };
}
function S(n2) {
  var t2 = n2[Q];
  0 === t2.i || 1 === t2.i ? t2.j() : t2.O = true;
}
function P(t2, e) {
  e._ = e.p.length;
  var i2 = e.p[0], o2 = void 0 !== t2 && t2 !== i2;
  return e.h.g || b("ES5").S(e, t2, o2), o2 ? (i2[Q].P && (O(e), n(4)), r(t2) && (t2 = M(e, t2), e.l || x(e, t2)), e.u && b("Patches").M(i2[Q], t2, e.u, e.s)) : t2 = M(e, i2, []), O(e), e.u && e.v(e.u, e.s), t2 !== H ? t2 : void 0;
}
function M(n2, t2, r2) {
  if (y(t2))
    return t2;
  var e = t2[Q];
  if (!e)
    return i(t2, function(i2, o3) {
      return A(n2, e, t2, i2, o3, r2);
    }, true), t2;
  if (e.A !== n2)
    return t2;
  if (!e.P)
    return x(n2, e.t, true), e.t;
  if (!e.I) {
    e.I = true, e.A._--;
    var o2 = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o;
    i(3 === e.i ? new Set(o2) : o2, function(t3, i2) {
      return A(n2, e, o2, t3, i2, r2);
    }), x(n2, o2, false), r2 && n2.u && b("Patches").R(e, r2, n2.u, n2.s);
  }
  return e.o;
}
function A(e, i2, o2, a2, c2, s2) {
  if ("production" !== __vite_process_env_NODE_ENV && c2 === o2 && n(5), t(c2)) {
    var v2 = M(e, c2, s2 && i2 && 3 !== i2.i && !u(i2.D, a2) ? s2.concat(a2) : void 0);
    if (f(o2, a2, v2), !t(v2))
      return;
    e.m = false;
  }
  if (r(c2) && !y(c2)) {
    if (!e.h.F && e._ < 1)
      return;
    M(e, c2), i2 && i2.A.l || x(e, c2);
  }
}
function x(n2, t2, r2) {
  void 0 === r2 && (r2 = false), n2.h.F && n2.m && d(t2, r2);
}
function z(n2, t2) {
  var r2 = n2[Q];
  return (r2 ? p(r2) : n2)[t2];
}
function I(n2, t2) {
  if (t2 in n2)
    for (var r2 = Object.getPrototypeOf(n2); r2; ) {
      var e = Object.getOwnPropertyDescriptor(r2, t2);
      if (e)
        return e;
      r2 = Object.getPrototypeOf(r2);
    }
}
function k(n2) {
  n2.P || (n2.P = true, n2.l && k(n2.l));
}
function E(n2) {
  n2.o || (n2.o = l(n2.t));
}
function R(n2, t2, r2) {
  var e = s(t2) ? b("MapSet").N(t2, r2) : v(t2) ? b("MapSet").T(t2, r2) : n2.g ? function(n3, t3) {
    var r3 = Array.isArray(n3), e2 = { i: r3 ? 1 : 0, A: t3 ? t3.A : _(), P: false, I: false, D: {}, l: t3, t: n3, k: null, o: null, j: null, C: false }, i2 = e2, o2 = en;
    r3 && (i2 = [e2], o2 = on);
    var u2 = Proxy.revocable(i2, o2), a2 = u2.revoke, f2 = u2.proxy;
    return e2.k = f2, e2.j = a2, f2;
  }(t2, r2) : b("ES5").J(t2, r2);
  return (r2 ? r2.A : _()).p.push(e), e;
}
function D(e) {
  return t(e) || n(22, e), function n2(t2) {
    if (!r(t2))
      return t2;
    var e2, u2 = t2[Q], c2 = o(t2);
    if (u2) {
      if (!u2.P && (u2.i < 4 || !b("ES5").K(u2)))
        return u2.t;
      u2.I = true, e2 = F(t2, c2), u2.I = false;
    } else
      e2 = F(t2, c2);
    return i(e2, function(t3, r2) {
      u2 && a(u2.t, t3) === r2 || f(e2, t3, n2(r2));
    }), 3 === c2 ? new Set(e2) : e2;
  }(e);
}
function F(n2, t2) {
  switch (t2) {
    case 2:
      return new Map(n2);
    case 3:
      return Array.from(n2);
  }
  return l(n2);
}
function T() {
  function e(n2) {
    if (!r(n2))
      return n2;
    if (Array.isArray(n2))
      return n2.map(e);
    if (s(n2))
      return new Map(Array.from(n2.entries()).map(function(n3) {
        return [n3[0], e(n3[1])];
      }));
    if (v(n2))
      return new Set(Array.from(n2).map(e));
    var t2 = Object.create(Object.getPrototypeOf(n2));
    for (var i2 in n2)
      t2[i2] = e(n2[i2]);
    return u(n2, L) && (t2[L] = n2[L]), t2;
  }
  function f2(n2) {
    return t(n2) ? e(n2) : n2;
  }
  var c2 = "add";
  m("Patches", { $: function(t2, r2) {
    return r2.forEach(function(r3) {
      for (var i2 = r3.path, u2 = r3.op, f3 = t2, s2 = 0; s2 < i2.length - 1; s2++) {
        var v2 = o(f3), p2 = "" + i2[s2];
        0 !== v2 && 1 !== v2 || "__proto__" !== p2 && "constructor" !== p2 || n(24), "function" == typeof f3 && "prototype" === p2 && n(24), "object" != typeof (f3 = a(f3, p2)) && n(15, i2.join("/"));
      }
      var l2 = o(f3), d2 = e(r3.value), h2 = i2[i2.length - 1];
      switch (u2) {
        case "replace":
          switch (l2) {
            case 2:
              return f3.set(h2, d2);
            case 3:
              n(16);
            default:
              return f3[h2] = d2;
          }
        case c2:
          switch (l2) {
            case 1:
              return f3.splice(h2, 0, d2);
            case 2:
              return f3.set(h2, d2);
            case 3:
              return f3.add(d2);
            default:
              return f3[h2] = d2;
          }
        case "remove":
          switch (l2) {
            case 1:
              return f3.splice(h2, 1);
            case 2:
              return f3.delete(h2);
            case 3:
              return f3.delete(r3.value);
            default:
              return delete f3[h2];
          }
        default:
          n(17, u2);
      }
    }), t2;
  }, R: function(n2, t2, r2, e2) {
    switch (n2.i) {
      case 0:
      case 4:
      case 2:
        return function(n3, t3, r3, e3) {
          var o2 = n3.t, s2 = n3.o;
          i(n3.D, function(n4, i2) {
            var v2 = a(o2, n4), p2 = a(s2, n4), l2 = i2 ? u(o2, n4) ? "replace" : c2 : "remove";
            if (v2 !== p2 || "replace" !== l2) {
              var d2 = t3.concat(n4);
              r3.push("remove" === l2 ? { op: l2, path: d2 } : { op: l2, path: d2, value: p2 }), e3.push(l2 === c2 ? { op: "remove", path: d2 } : "remove" === l2 ? { op: c2, path: d2, value: f2(v2) } : { op: "replace", path: d2, value: f2(v2) });
            }
          });
        }(n2, t2, r2, e2);
      case 5:
      case 1:
        return function(n3, t3, r3, e3) {
          var i2 = n3.t, o2 = n3.D, u2 = n3.o;
          if (u2.length < i2.length) {
            var a2 = [u2, i2];
            i2 = a2[0], u2 = a2[1];
            var s2 = [e3, r3];
            r3 = s2[0], e3 = s2[1];
          }
          for (var v2 = 0; v2 < i2.length; v2++)
            if (o2[v2] && u2[v2] !== i2[v2]) {
              var p2 = t3.concat([v2]);
              r3.push({ op: "replace", path: p2, value: f2(u2[v2]) }), e3.push({ op: "replace", path: p2, value: f2(i2[v2]) });
            }
          for (var l2 = i2.length; l2 < u2.length; l2++) {
            var d2 = t3.concat([l2]);
            r3.push({ op: c2, path: d2, value: f2(u2[l2]) });
          }
          i2.length < u2.length && e3.push({ op: "replace", path: t3.concat(["length"]), value: i2.length });
        }(n2, t2, r2, e2);
      case 3:
        return function(n3, t3, r3, e3) {
          var i2 = n3.t, o2 = n3.o, u2 = 0;
          i2.forEach(function(n4) {
            if (!o2.has(n4)) {
              var i3 = t3.concat([u2]);
              r3.push({ op: "remove", path: i3, value: n4 }), e3.unshift({ op: c2, path: i3, value: n4 });
            }
            u2++;
          }), u2 = 0, o2.forEach(function(n4) {
            if (!i2.has(n4)) {
              var o3 = t3.concat([u2]);
              r3.push({ op: c2, path: o3, value: n4 }), e3.unshift({ op: "remove", path: o3, value: n4 });
            }
            u2++;
          });
        }(n2, t2, r2, e2);
    }
  }, M: function(n2, t2, r2, e2) {
    r2.push({ op: "replace", path: [], value: t2 === H ? void 0 : t2 }), e2.push({ op: "replace", path: [], value: n2.t });
  } });
}
var G;
var U;
var W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x");
var X = "undefined" != typeof Map;
var q = "undefined" != typeof Set;
var B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect;
var H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = true, G);
var L = W ? Symbol.for("immer-draftable") : "__$immer_draftable";
var Q = W ? Symbol.for("immer-state") : "__$immer_state";
var Y = { 0: "Illegal state", 1: "Immer drafts cannot have computed properties", 2: "This object has been frozen and should not be mutated", 3: function(n2) {
  return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n2;
}, 4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", 5: "Immer forbids circular references", 6: "The first or second argument to `produce` must be a function", 7: "The third argument to `produce` must be a function or undefined", 8: "First argument to `createDraft` must be a plain object, an array, or an immerable object", 9: "First argument to `finishDraft` must be a draft returned by `createDraft`", 10: "The given draft is already finalized", 11: "Object.defineProperty() cannot be used on an Immer draft", 12: "Object.setPrototypeOf() cannot be used on an Immer draft", 13: "Immer only supports deleting array indices", 14: "Immer only supports setting array indices and the 'length' property", 15: function(n2) {
  return "Cannot apply patch, path doesn't resolve: " + n2;
}, 16: 'Sets cannot have "replace" patches.', 17: function(n2) {
  return "Unsupported patch operation: " + n2;
}, 18: function(n2) {
  return "The plugin for '" + n2 + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n2 + "()` when initializing your application.";
}, 20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available", 21: function(n2) {
  return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n2 + "'";
}, 22: function(n2) {
  return "'current' expects a draft, got: " + n2;
}, 23: function(n2) {
  return "'original' expects a draft, got: " + n2;
}, 24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed" };
var Z = "" + Object.prototype.constructor;
var nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n2) {
  return Object.getOwnPropertyNames(n2).concat(Object.getOwnPropertySymbols(n2));
} : Object.getOwnPropertyNames;
var tn = Object.getOwnPropertyDescriptors || function(n2) {
  var t2 = {};
  return nn(n2).forEach(function(r2) {
    t2[r2] = Object.getOwnPropertyDescriptor(n2, r2);
  }), t2;
};
var rn = {};
var en = { get: function(n2, t2) {
  if (t2 === Q)
    return n2;
  var e = p(n2);
  if (!u(e, t2))
    return function(n3, t3, r2) {
      var e2, i3 = I(t3, r2);
      return i3 ? "value" in i3 ? i3.value : null === (e2 = i3.get) || void 0 === e2 ? void 0 : e2.call(n3.k) : void 0;
    }(n2, e, t2);
  var i2 = e[t2];
  return n2.I || !r(i2) ? i2 : i2 === z(n2.t, t2) ? (E(n2), n2.o[t2] = R(n2.A.h, i2, n2)) : i2;
}, has: function(n2, t2) {
  return t2 in p(n2);
}, ownKeys: function(n2) {
  return Reflect.ownKeys(p(n2));
}, set: function(n2, t2, r2) {
  var e = I(p(n2), t2);
  if (null == e ? void 0 : e.set)
    return e.set.call(n2.k, r2), true;
  if (!n2.P) {
    var i2 = z(p(n2), t2), o2 = null == i2 ? void 0 : i2[Q];
    if (o2 && o2.t === r2)
      return n2.o[t2] = r2, n2.D[t2] = false, true;
    if (c(r2, i2) && (void 0 !== r2 || u(n2.t, t2)))
      return true;
    E(n2), k(n2);
  }
  return n2.o[t2] === r2 && "number" != typeof r2 && (void 0 !== r2 || t2 in n2.o) || (n2.o[t2] = r2, n2.D[t2] = true, true);
}, deleteProperty: function(n2, t2) {
  return void 0 !== z(n2.t, t2) || t2 in n2.t ? (n2.D[t2] = false, E(n2), k(n2)) : delete n2.D[t2], n2.o && delete n2.o[t2], true;
}, getOwnPropertyDescriptor: function(n2, t2) {
  var r2 = p(n2), e = Reflect.getOwnPropertyDescriptor(r2, t2);
  return e ? { writable: true, configurable: 1 !== n2.i || "length" !== t2, enumerable: e.enumerable, value: r2[t2] } : e;
}, defineProperty: function() {
  n(11);
}, getPrototypeOf: function(n2) {
  return Object.getPrototypeOf(n2.t);
}, setPrototypeOf: function() {
  n(12);
} };
var on = {};
i(en, function(n2, t2) {
  on[n2] = function() {
    return arguments[0] = arguments[0][0], t2.apply(this, arguments);
  };
}), on.deleteProperty = function(t2, r2) {
  return "production" !== __vite_process_env_NODE_ENV && isNaN(parseInt(r2)) && n(13), en.deleteProperty.call(this, t2[0], r2);
}, on.set = function(t2, r2, e) {
  return "production" !== __vite_process_env_NODE_ENV && "length" !== r2 && isNaN(parseInt(r2)) && n(14), en.set.call(this, t2[0], r2, e, t2[0]);
};
var un = function() {
  function e(t2) {
    var e2 = this;
    this.g = B, this.F = true, this.produce = function(t3, i3, o2) {
      if ("function" == typeof t3 && "function" != typeof i3) {
        var u2 = i3;
        i3 = t3;
        var a2 = e2;
        return function(n2) {
          var t4 = this;
          void 0 === n2 && (n2 = u2);
          for (var r2 = arguments.length, e3 = Array(r2 > 1 ? r2 - 1 : 0), o3 = 1; o3 < r2; o3++)
            e3[o3 - 1] = arguments[o3];
          return a2.produce(n2, function(n3) {
            var r3;
            return (r3 = i3).call.apply(r3, [t4, n3].concat(e3));
          });
        };
      }
      var f2;
      if ("function" != typeof i3 && n(6), void 0 !== o2 && "function" != typeof o2 && n(7), r(t3)) {
        var c2 = w(e2), s2 = R(e2, t3, void 0), v2 = true;
        try {
          f2 = i3(s2), v2 = false;
        } finally {
          v2 ? O(c2) : g(c2);
        }
        return "undefined" != typeof Promise && f2 instanceof Promise ? f2.then(function(n2) {
          return j(c2, o2), P(n2, c2);
        }, function(n2) {
          throw O(c2), n2;
        }) : (j(c2, o2), P(f2, c2));
      }
      if (!t3 || "object" != typeof t3) {
        if ((f2 = i3(t3)) === H)
          return;
        return void 0 === f2 && (f2 = t3), e2.F && d(f2, true), f2;
      }
      n(21, t3);
    }, this.produceWithPatches = function(n2, t3) {
      return "function" == typeof n2 ? function(t4) {
        for (var r3 = arguments.length, i4 = Array(r3 > 1 ? r3 - 1 : 0), o2 = 1; o2 < r3; o2++)
          i4[o2 - 1] = arguments[o2];
        return e2.produceWithPatches(t4, function(t5) {
          return n2.apply(void 0, [t5].concat(i4));
        });
      } : [e2.produce(n2, t3, function(n3, t4) {
        r2 = n3, i3 = t4;
      }), r2, i3];
      var r2, i3;
    }, "boolean" == typeof (null == t2 ? void 0 : t2.useProxies) && this.setUseProxies(t2.useProxies), "boolean" == typeof (null == t2 ? void 0 : t2.autoFreeze) && this.setAutoFreeze(t2.autoFreeze);
  }
  var i2 = e.prototype;
  return i2.createDraft = function(e2) {
    r(e2) || n(8), t(e2) && (e2 = D(e2));
    var i3 = w(this), o2 = R(this, e2, void 0);
    return o2[Q].C = true, g(i3), o2;
  }, i2.finishDraft = function(t2, r2) {
    var e2 = t2 && t2[Q];
    "production" !== __vite_process_env_NODE_ENV && (e2 && e2.C || n(9), e2.I && n(10));
    var i3 = e2.A;
    return j(i3, r2), P(void 0, i3);
  }, i2.setAutoFreeze = function(n2) {
    this.F = n2;
  }, i2.setUseProxies = function(t2) {
    t2 && !B && n(20), this.g = t2;
  }, i2.applyPatches = function(n2, r2) {
    var e2;
    for (e2 = r2.length - 1; e2 >= 0; e2--) {
      var i3 = r2[e2];
      if (0 === i3.path.length && "replace" === i3.op) {
        n2 = i3.value;
        break;
      }
    }
    var o2 = b("Patches").$;
    return t(n2) ? o2(n2, r2) : this.produce(n2, function(n3) {
      return o2(n3, r2.slice(e2 + 1));
    });
  }, e;
}();
var an = new un();
var fn = an.produce;
var cn = an.produceWithPatches.bind(an);
var sn = an.setAutoFreeze.bind(an);
var vn = an.setUseProxies.bind(an);
var pn = an.applyPatches.bind(an);
var ln = an.createDraft.bind(an);
var dn = an.finishDraft.bind(an);

// node_modules/@aws-amplify/datastore/lib-esm/datastore/datastore.js
var import_uuid6 = __toESM(require_uuid4());

// node_modules/@aws-amplify/datastore/lib-esm/authModeStrategies/defaultAuthStrategy.js
var defaultAuthStrategy = function() {
  return [];
};

// node_modules/@aws-amplify/datastore/lib-esm/util.js
var import_buffer6 = __toESM(require_buffer());

// node_modules/ulid/dist/index.esm.js
function createError(message) {
  var err = new Error(message);
  err.source = "ulid";
  return err;
}
var ENCODING = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
var ENCODING_LEN = ENCODING.length;
var TIME_MAX = Math.pow(2, 48) - 1;
var TIME_LEN = 10;
var RANDOM_LEN = 16;
function replaceCharAt(str, index, char) {
  if (index > str.length - 1) {
    return str;
  }
  return str.substr(0, index) + char + str.substr(index + 1);
}
function incrementBase32(str) {
  var done = void 0;
  var index = str.length;
  var char = void 0;
  var charIndex = void 0;
  var maxCharIndex = ENCODING_LEN - 1;
  while (!done && index-- >= 0) {
    char = str[index];
    charIndex = ENCODING.indexOf(char);
    if (charIndex === -1) {
      throw createError("incorrectly encoded string");
    }
    if (charIndex === maxCharIndex) {
      str = replaceCharAt(str, index, ENCODING[0]);
      continue;
    }
    done = replaceCharAt(str, index, ENCODING[charIndex + 1]);
  }
  if (typeof done === "string") {
    return done;
  }
  throw createError("cannot increment this string");
}
function randomChar(prng2) {
  var rand = Math.floor(prng2() * ENCODING_LEN);
  if (rand === ENCODING_LEN) {
    rand = ENCODING_LEN - 1;
  }
  return ENCODING.charAt(rand);
}
function encodeTime(now, len) {
  if (isNaN(now)) {
    throw new Error(now + " must be a number");
  }
  if (now > TIME_MAX) {
    throw createError("cannot encode time greater than " + TIME_MAX);
  }
  if (now < 0) {
    throw createError("time must be positive");
  }
  if (Number.isInteger(now) === false) {
    throw createError("time must be an integer");
  }
  var mod = void 0;
  var str = "";
  for (; len > 0; len--) {
    mod = now % ENCODING_LEN;
    str = ENCODING.charAt(mod) + str;
    now = (now - mod) / ENCODING_LEN;
  }
  return str;
}
function encodeRandom(len, prng2) {
  var str = "";
  for (; len > 0; len--) {
    str = randomChar(prng2) + str;
  }
  return str;
}
function detectPrng() {
  var allowInsecure = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
  var root = arguments[1];
  if (!root) {
    root = typeof window !== "undefined" ? window : null;
  }
  var browserCrypto = root && (root.crypto || root.msCrypto);
  if (browserCrypto) {
    return function() {
      var buffer = new Uint8Array(1);
      browserCrypto.getRandomValues(buffer);
      return buffer[0] / 255;
    };
  } else {
    try {
      var nodeCrypto = require_crypto2();
      return function() {
        return nodeCrypto.randomBytes(1).readUInt8() / 255;
      };
    } catch (e) {
    }
  }
  if (allowInsecure) {
    try {
      console.error("secure crypto unusable, falling back to insecure Math.random()!");
    } catch (e) {
    }
    return function() {
      return Math.random();
    };
  }
  throw createError("secure crypto unusable, insecure Math.random not allowed");
}
function factory(currPrng) {
  if (!currPrng) {
    currPrng = detectPrng();
  }
  return function ulid3(seedTime) {
    if (isNaN(seedTime)) {
      seedTime = Date.now();
    }
    return encodeTime(seedTime, TIME_LEN) + encodeRandom(RANDOM_LEN, currPrng);
  };
}
function monotonicFactory(currPrng) {
  if (!currPrng) {
    currPrng = detectPrng();
  }
  var lastTime = 0;
  var lastRandom = void 0;
  return function ulid3(seedTime) {
    if (isNaN(seedTime)) {
      seedTime = Date.now();
    }
    if (seedTime <= lastTime) {
      var incrementedRandom = lastRandom = incrementBase32(lastRandom);
      return encodeTime(lastTime, TIME_LEN) + incrementedRandom;
    }
    lastTime = seedTime;
    var newRandom = lastRandom = encodeRandom(RANDOM_LEN, currPrng);
    return encodeTime(seedTime, TIME_LEN) + newRandom;
  };
}
var ulid = factory();

// node_modules/@aws-amplify/datastore/lib-esm/util.js
var import_uuid5 = __toESM(require_uuid4());

// node_modules/@aws-amplify/datastore/lib-esm/predicates/sort.js
var ModelSortPredicateCreator = (
  /** @class */
  function() {
    function ModelSortPredicateCreator2() {
    }
    ModelSortPredicateCreator2.createPredicateBuilder = function(modelDefinition) {
      var modelName = modelDefinition.name;
      var fieldNames = new Set(Object.keys(modelDefinition.fields));
      var handler;
      var predicate = new Proxy({}, handler = {
        get: function(_target, propertyKey, receiver) {
          var field = propertyKey;
          if (!fieldNames.has(field)) {
            throw new Error("Invalid field for model. field: " + field + ", model: " + modelName);
          }
          var result = function(sortDirection) {
            var _a2;
            (_a2 = ModelSortPredicateCreator2.sortPredicateGroupsMap.get(receiver)) === null || _a2 === void 0 ? void 0 : _a2.push({ field, sortDirection });
            return receiver;
          };
          return result;
        }
      });
      ModelSortPredicateCreator2.sortPredicateGroupsMap.set(predicate, []);
      return predicate;
    };
    ModelSortPredicateCreator2.isValidPredicate = function(predicate) {
      return ModelSortPredicateCreator2.sortPredicateGroupsMap.has(predicate);
    };
    ModelSortPredicateCreator2.getPredicates = function(predicate, throwOnInvalid) {
      if (throwOnInvalid === void 0) {
        throwOnInvalid = true;
      }
      if (throwOnInvalid && !ModelSortPredicateCreator2.isValidPredicate(predicate)) {
        throw new Error("The predicate is not valid");
      }
      var predicateGroup = ModelSortPredicateCreator2.sortPredicateGroupsMap.get(predicate);
      if (predicateGroup) {
        return predicateGroup;
      } else {
        throw new Error("Predicate group not found");
      }
    };
    ModelSortPredicateCreator2.createFromExisting = function(modelDefinition, existing) {
      if (!existing || !modelDefinition) {
        return void 0;
      }
      return existing(ModelSortPredicateCreator2.createPredicateBuilder(modelDefinition));
    };
    ModelSortPredicateCreator2.sortPredicateGroupsMap = /* @__PURE__ */ new WeakMap();
    return ModelSortPredicateCreator2;
  }()
);

// node_modules/@aws-amplify/datastore/lib-esm/predicates/index.js
var predicatesAllSet = /* @__PURE__ */ new WeakSet();
function isPredicatesAll(predicate) {
  return predicatesAllSet.has(predicate);
}
var groupKeys = /* @__PURE__ */ new Set(["and", "or", "not"]);
var isGroup = function(o2) {
  var keys = __spread(Object.keys(o2));
  return keys.length === 1 && groupKeys.has(keys[0]);
};
var isEmpty4 = function(o2) {
  return !Array.isArray(o2) && Object.keys(o2).length === 0;
};
var comparisonKeys = /* @__PURE__ */ new Set([
  "eq",
  "ne",
  "gt",
  "lt",
  "ge",
  "le",
  "contains",
  "notContains",
  "beginsWith",
  "between"
]);
var isComparison = function(o2) {
  var keys = __spread(Object.keys(o2));
  return !Array.isArray(o2) && keys.length === 1 && comparisonKeys.has(keys[0]);
};
var isValid = function(o2) {
  if (Array.isArray(o2)) {
    return o2.every(function(v2) {
      return isValid(v2);
    });
  } else {
    return Object.keys(o2).length <= 1;
  }
};
var PredicateAll = Symbol("A predicate that matches all records");
var Predicates = (
  /** @class */
  function() {
    function Predicates2() {
    }
    Object.defineProperty(Predicates2, "ALL", {
      get: function() {
        var predicate = function(c2) {
          return c2;
        };
        predicatesAllSet.add(predicate);
        return predicate;
      },
      enumerable: true,
      configurable: true
    });
    return Predicates2;
  }()
);
var ModelPredicateCreator = (
  /** @class */
  function() {
    function ModelPredicateCreator2() {
    }
    ModelPredicateCreator2.isValidPredicate = function(predicate) {
      return ModelPredicateCreator2.predicateGroupsMap.has(predicate);
    };
    ModelPredicateCreator2.getPredicates = function(predicate, throwOnInvalid) {
      if (throwOnInvalid === void 0) {
        throwOnInvalid = true;
      }
      if (throwOnInvalid && !ModelPredicateCreator2.isValidPredicate(predicate)) {
        throw new Error("The predicate is not valid");
      }
      return ModelPredicateCreator2.predicateGroupsMap.get(predicate);
    };
    ModelPredicateCreator2.createForPk = function(modelDefinition, model) {
      var keyFields = extractPrimaryKeyFieldNames(modelDefinition);
      var keyValues = extractPrimaryKeyValues(model, keyFields);
      var predicate = this.createFromAST(modelDefinition, {
        and: keyFields.map(function(field, idx) {
          var _a2;
          var operand = keyValues[idx];
          return _a2 = {}, _a2[field] = { eq: operand }, _a2;
        })
      });
      return predicate;
    };
    ModelPredicateCreator2.createFromFlatEqualities = function(modelDefinition, flatEqualities) {
      var ast = {
        and: Object.entries(flatEqualities).map(function(_a2) {
          var _b2;
          var _c = __read10(_a2, 2), k2 = _c[0], v2 = _c[1];
          return _b2 = {}, _b2[k2] = { eq: v2 }, _b2;
        })
      };
      return this.createFromAST(modelDefinition, ast);
    };
    ModelPredicateCreator2.transformGraphQLFilterNodeToPredicateAST = function(gql) {
      var _this = this;
      if (!isValid(gql)) {
        throw new Error("Invalid GraphQL Condition or subtree: " + JSON.stringify(gql));
      }
      if (isEmpty4(gql)) {
        return {
          type: "and",
          predicates: []
        };
      } else if (isGroup(gql)) {
        var groupkey = Object.keys(gql)[0];
        var children = this.transformGraphQLFilterNodeToPredicateAST(gql[groupkey]);
        return {
          type: groupkey,
          predicates: Array.isArray(children) ? children : [children]
        };
      } else if (isComparison(gql)) {
        var operatorKey = Object.keys(gql)[0];
        return {
          operator: operatorKey,
          operand: gql[operatorKey]
        };
      } else {
        if (Array.isArray(gql)) {
          return gql.map(function(o2) {
            return _this.transformGraphQLFilterNodeToPredicateAST(o2);
          });
        } else {
          var fieldKey = Object.keys(gql)[0];
          return __assign7({ field: fieldKey }, this.transformGraphQLFilterNodeToPredicateAST(gql[fieldKey]));
        }
      }
    };
    ModelPredicateCreator2.createFromAST = function(modelDefinition, ast) {
      var key = {};
      ModelPredicateCreator2.predicateGroupsMap.set(key, this.transformGraphQLFilterNodeToPredicateAST(ast));
      return key;
    };
    ModelPredicateCreator2.predicateGroupsMap = /* @__PURE__ */ new WeakMap();
    return ModelPredicateCreator2;
  }()
);

// node_modules/@aws-amplify/datastore/lib-esm/util.js
var ID = "id";
var DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR = "#";
var IDENTIFIER_KEY_SEPARATOR = "-";
var errorMessages = {
  idEmptyString: "An index field cannot contain an empty string value",
  queryByPkWithCompositeKeyPresent: "Models with composite primary keys cannot be queried by a single key value. Use object literal syntax for composite keys instead: https://docs.amplify.aws/lib/datastore/advanced-workflows/q/platform/js/#querying-records-with-custom-primary-keys",
  deleteByPkWithCompositeKeyPresent: "Models with composite primary keys cannot be deleted by a single key value, unless using a predicate. Use object literal syntax for composite keys instead: https://docs.amplify.aws/lib/datastore/advanced-workflows/q/platform/js/#querying-records-with-custom-primary-keys",
  observeWithObjectLiteral: "Object literal syntax cannot be used with observe. Use a predicate instead: https://docs.amplify.aws/lib/datastore/data-access/q/platform/js/#predicates"
};
var NAMESPACES;
(function(NAMESPACES2) {
  NAMESPACES2["DATASTORE"] = "datastore";
  NAMESPACES2["USER"] = "user";
  NAMESPACES2["SYNC"] = "sync";
  NAMESPACES2["STORAGE"] = "storage";
})(NAMESPACES || (NAMESPACES = {}));
var DATASTORE = NAMESPACES.DATASTORE;
var USER = NAMESPACES.USER;
var SYNC = NAMESPACES.SYNC;
var STORAGE = NAMESPACES.STORAGE;
var isNullOrUndefined = function(val2) {
  return typeof val2 === "undefined" || val2 === void 0 || val2 === null;
};
var validatePredicate = function(model, groupType, predicatesOrGroups) {
  var filterType;
  var isNegation = false;
  if (predicatesOrGroups.length === 0) {
    return true;
  }
  switch (groupType) {
    case "not":
      filterType = "every";
      isNegation = true;
      break;
    case "and":
      filterType = "every";
      break;
    case "or":
      filterType = "some";
      break;
    default:
      throw new Error("Invalid " + groupType);
  }
  var result = predicatesOrGroups[filterType](function(predicateOrGroup) {
    if (isPredicateObj(predicateOrGroup)) {
      var field = predicateOrGroup.field, operator = predicateOrGroup.operator, operand = predicateOrGroup.operand;
      var value = model[field];
      return validatePredicateField(value, operator, operand);
    }
    if (isPredicateGroup(predicateOrGroup)) {
      var type = predicateOrGroup.type, predicates = predicateOrGroup.predicates;
      return validatePredicate(model, type, predicates);
    }
    throw new Error("Not a predicate or group");
  });
  return isNegation ? !result : result;
};
var validatePredicateField = function(value, operator, operand) {
  switch (operator) {
    case "ne":
      return value !== operand;
    case "eq":
      return value === operand;
    case "le":
      return value <= operand;
    case "lt":
      return value < operand;
    case "ge":
      return value >= operand;
    case "gt":
      return value > operand;
    case "between":
      var _c = __read10(operand, 2), min = _c[0], max = _c[1];
      return value >= min && value <= max;
    case "beginsWith":
      return !isNullOrUndefined(value) && value.startsWith(operand);
    case "contains":
      return !isNullOrUndefined(value) && value.indexOf(operand) > -1;
    case "notContains":
      return isNullOrUndefined(value) || value.indexOf(operand) === -1;
    default:
      return false;
  }
};
var isModelConstructor = function(obj) {
  return obj && typeof obj.copyOf === "function";
};
var topologicallySortedModels = /* @__PURE__ */ new WeakMap();
var traverseModel = function(srcModelName, instance2, namespace, modelInstanceCreator2, getModelConstructorByModelName2) {
  var modelConstructor = getModelConstructorByModelName2(namespace.name, srcModelName);
  var result = [];
  var newInstance = modelConstructor.copyOf(instance2, function() {
  });
  result.unshift({
    modelName: srcModelName,
    item: newInstance,
    instance: newInstance
  });
  if (!topologicallySortedModels.has(namespace)) {
    topologicallySortedModels.set(namespace, Array.from(namespace.modelTopologicalOrdering.keys()));
  }
  var sortedModels = topologicallySortedModels.get(namespace);
  result.sort(function(a2, b2) {
    return sortedModels.indexOf(a2.modelName) - sortedModels.indexOf(b2.modelName);
  });
  return result;
};
var privateModeCheckResult;
var isPrivateMode = function() {
  return new Promise(function(resolve) {
    var dbname = (0, import_uuid5.v4)();
    var db;
    var isPrivate = function() {
      privateModeCheckResult = false;
      resolve(true);
    };
    var isNotPrivate = function() {
      return __awaiter3(void 0, void 0, void 0, function() {
        return __generator3(this, function(_c) {
          switch (_c.label) {
            case 0:
              if (!(db && db.result && typeof db.result.close === "function"))
                return [3, 2];
              return [4, db.result.close()];
            case 1:
              _c.sent();
              _c.label = 2;
            case 2:
              return [4, indexedDB.deleteDatabase(dbname)];
            case 3:
              _c.sent();
              privateModeCheckResult = true;
              return [2, resolve(false)];
          }
        });
      });
    };
    if (privateModeCheckResult === true) {
      return isNotPrivate();
    }
    if (privateModeCheckResult === false) {
      return isPrivate();
    }
    if (indexedDB === null)
      return isPrivate();
    db = indexedDB.open(dbname);
    db.onerror = isPrivate;
    db.onsuccess = isNotPrivate;
  });
};
var safariCompatabilityModeResult;
var isSafariCompatabilityMode = function() {
  return __awaiter3(void 0, void 0, void 0, function() {
    var dbName_1, storeName_1, indexName_1, db_1, rwTx, rwStore, result, error_1;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          _c.trys.push([0, 6, , 7]);
          dbName_1 = (0, import_uuid5.v4)();
          storeName_1 = "indexedDBFeatureProbeStore";
          indexName_1 = "idx";
          if (indexedDB === null)
            return [2, false];
          if (safariCompatabilityModeResult !== void 0) {
            return [2, safariCompatabilityModeResult];
          }
          return [4, new Promise(function(resolve) {
            var dbOpenRequest = indexedDB.open(dbName_1);
            dbOpenRequest.onerror = function() {
              return resolve(false);
            };
            dbOpenRequest.onsuccess = function() {
              var db = dbOpenRequest.result;
              resolve(db);
            };
            dbOpenRequest.onupgradeneeded = function(event) {
              var _c2;
              var db = (_c2 = event === null || event === void 0 ? void 0 : event.target) === null || _c2 === void 0 ? void 0 : _c2.result;
              db.onerror = function() {
                return resolve(false);
              };
              var store2 = db.createObjectStore(storeName_1, {
                autoIncrement: true
              });
              store2.createIndex(indexName_1, ["id"]);
            };
          })];
        case 1:
          db_1 = _c.sent();
          if (!db_1) {
            throw new Error("Could not open probe DB");
          }
          rwTx = db_1.transaction(storeName_1, "readwrite");
          rwStore = rwTx.objectStore(storeName_1);
          rwStore.add({
            id: 1
          });
          rwTx.commit();
          return [4, new Promise(function(resolve) {
            var tx = db_1.transaction(storeName_1, "readonly");
            var store2 = tx.objectStore(storeName_1);
            var index = store2.index(indexName_1);
            var getRequest = index.get([1]);
            getRequest.onerror = function() {
              return resolve(false);
            };
            getRequest.onsuccess = function(event) {
              var _c2;
              resolve((_c2 = event === null || event === void 0 ? void 0 : event.target) === null || _c2 === void 0 ? void 0 : _c2.result);
            };
          })];
        case 2:
          result = _c.sent();
          if (!(db_1 && typeof db_1.close === "function"))
            return [3, 4];
          return [4, db_1.close()];
        case 3:
          _c.sent();
          _c.label = 4;
        case 4:
          return [4, indexedDB.deleteDatabase(dbName_1)];
        case 5:
          _c.sent();
          if (result === void 0) {
            safariCompatabilityModeResult = true;
          } else {
            safariCompatabilityModeResult = false;
          }
          return [3, 7];
        case 6:
          error_1 = _c.sent();
          safariCompatabilityModeResult = false;
          return [3, 7];
        case 7:
          return [2, safariCompatabilityModeResult];
      }
    });
  });
};
var randomBytes2 = function(nBytes) {
  return import_buffer6.Buffer.from(new WordArray().random(nBytes).toString(), "hex");
};
var prng = function() {
  return randomBytes2(1).readUInt8(0) / 255;
};
function monotonicUlidFactory(seed) {
  var ulid3 = monotonicFactory(prng);
  return function() {
    return ulid3(seed);
  };
}
function getNow() {
  if (typeof performance !== "undefined" && performance && typeof performance.now === "function") {
    return performance.now() | 0;
  } else {
    return Date.now();
  }
}
function sortCompareFunction(sortPredicates) {
  return function compareFunction(a2, b2) {
    var e_1, _c;
    try {
      for (var sortPredicates_1 = __values4(sortPredicates), sortPredicates_1_1 = sortPredicates_1.next(); !sortPredicates_1_1.done; sortPredicates_1_1 = sortPredicates_1.next()) {
        var predicate = sortPredicates_1_1.value;
        var field = predicate.field, sortDirection = predicate.sortDirection;
        var sortMultiplier = sortDirection === SortDirection.ASCENDING ? 1 : -1;
        if (a2[field] < b2[field]) {
          return -1 * sortMultiplier;
        }
        if (a2[field] > b2[field]) {
          return 1 * sortMultiplier;
        }
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (sortPredicates_1_1 && !sortPredicates_1_1.done && (_c = sortPredicates_1.return))
          _c.call(sortPredicates_1);
      } finally {
        if (e_1)
          throw e_1.error;
      }
    }
    return 0;
  };
}
function valuesEqual(valA, valB, nullish) {
  var e_2, _c;
  if (nullish === void 0) {
    nullish = false;
  }
  var a2 = valA;
  var b2 = valB;
  var nullishCompare = function(_a2, _b2) {
    return (_a2 === void 0 || _a2 === null) && (_b2 === void 0 || _b2 === null);
  };
  if (a2 instanceof Object && !(b2 instanceof Object) || !(a2 instanceof Object) && b2 instanceof Object) {
    return false;
  }
  if (!(a2 instanceof Object)) {
    if (nullish && nullishCompare(a2, b2)) {
      return true;
    }
    return a2 === b2;
  }
  if (Array.isArray(a2) && !Array.isArray(b2) || Array.isArray(b2) && !Array.isArray(a2)) {
    return false;
  }
  if (a2 instanceof Set && b2 instanceof Set) {
    a2 = __spread(a2);
    b2 = __spread(b2);
  }
  if (a2 instanceof Map && b2 instanceof Map) {
    a2 = Object.fromEntries(a2);
    b2 = Object.fromEntries(b2);
  }
  var aKeys = Object.keys(a2);
  var bKeys = Object.keys(b2);
  if (aKeys.length !== bKeys.length && (!nullish || Array.isArray(a2))) {
    return false;
  }
  var keys = aKeys.length >= bKeys.length ? aKeys : bKeys;
  try {
    for (var keys_1 = __values4(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
      var key = keys_1_1.value;
      var aVal = a2[key];
      var bVal = b2[key];
      if (!valuesEqual(aVal, bVal, nullish)) {
        return false;
      }
    }
  } catch (e_2_1) {
    e_2 = { error: e_2_1 };
  } finally {
    try {
      if (keys_1_1 && !keys_1_1.done && (_c = keys_1.return))
        _c.call(keys_1);
    } finally {
      if (e_2)
        throw e_2.error;
    }
  }
  return true;
}
function inMemoryPagination(records, pagination) {
  if (pagination && records.length > 1) {
    if (pagination.sort) {
      var sortPredicates = ModelSortPredicateCreator.getPredicates(pagination.sort);
      if (sortPredicates.length) {
        var compareFn = sortCompareFunction(sortPredicates);
        records.sort(compareFn);
      }
    }
    var _c = pagination.page, page = _c === void 0 ? 0 : _c, _d = pagination.limit, limit = _d === void 0 ? 0 : _d;
    var start = Math.max(0, page * limit) || 0;
    var end = limit > 0 ? start + limit : records.length;
    return records.slice(start, end);
  }
  return records;
}
function asyncSome(items, matches2) {
  return __awaiter3(this, void 0, void 0, function() {
    var items_1, items_1_1, item, e_3_1;
    var e_3, _c;
    return __generator3(this, function(_d) {
      switch (_d.label) {
        case 0:
          _d.trys.push([0, 5, 6, 7]);
          items_1 = __values4(items), items_1_1 = items_1.next();
          _d.label = 1;
        case 1:
          if (!!items_1_1.done)
            return [3, 4];
          item = items_1_1.value;
          return [4, matches2(item)];
        case 2:
          if (_d.sent()) {
            return [2, true];
          }
          _d.label = 3;
        case 3:
          items_1_1 = items_1.next();
          return [3, 1];
        case 4:
          return [3, 7];
        case 5:
          e_3_1 = _d.sent();
          e_3 = { error: e_3_1 };
          return [3, 7];
        case 6:
          try {
            if (items_1_1 && !items_1_1.done && (_c = items_1.return))
              _c.call(items_1);
          } finally {
            if (e_3)
              throw e_3.error;
          }
          return [
            7
            /*endfinally*/
          ];
        case 7:
          return [2, false];
      }
    });
  });
}
function asyncEvery(items, matches2) {
  return __awaiter3(this, void 0, void 0, function() {
    var items_2, items_2_1, item, e_4_1;
    var e_4, _c;
    return __generator3(this, function(_d) {
      switch (_d.label) {
        case 0:
          _d.trys.push([0, 5, 6, 7]);
          items_2 = __values4(items), items_2_1 = items_2.next();
          _d.label = 1;
        case 1:
          if (!!items_2_1.done)
            return [3, 4];
          item = items_2_1.value;
          return [4, matches2(item)];
        case 2:
          if (!_d.sent()) {
            return [2, false];
          }
          _d.label = 3;
        case 3:
          items_2_1 = items_2.next();
          return [3, 1];
        case 4:
          return [3, 7];
        case 5:
          e_4_1 = _d.sent();
          e_4 = { error: e_4_1 };
          return [3, 7];
        case 6:
          try {
            if (items_2_1 && !items_2_1.done && (_c = items_2.return))
              _c.call(items_2);
          } finally {
            if (e_4)
              throw e_4.error;
          }
          return [
            7
            /*endfinally*/
          ];
        case 7:
          return [2, true];
      }
    });
  });
}
var isAWSDate = function(val2) {
  return !!/^\d{4}-\d{2}-\d{2}(Z|[+-]\d{2}:\d{2}($|:\d{2}))?$/.exec(val2);
};
var isAWSTime = function(val2) {
  return !!/^\d{2}:\d{2}(:\d{2}(.\d+)?)?(Z|[+-]\d{2}:\d{2}($|:\d{2}))?$/.exec(val2);
};
var isAWSDateTime = function(val2) {
  return !!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(.\d+)?)?(Z|[+-]\d{2}:\d{2}($|:\d{2}))?$/.exec(val2);
};
var isAWSTimestamp = function(val2) {
  return !!/^\d+$/.exec(String(val2));
};
var isAWSEmail = function(val2) {
  return !!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.exec(val2);
};
var isAWSJSON = function(val2) {
  try {
    JSON.parse(val2);
    return true;
  } catch (_c) {
    return false;
  }
};
var isAWSURL = function(val2) {
  try {
    return !!new URL(val2);
  } catch (_c) {
    return false;
  }
};
var isAWSPhone = function(val2) {
  return !!/^\+?\d[\d\s-]+$/.exec(val2);
};
var isAWSIPAddress = function(val2) {
  return !!/((^((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))$)|(^((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?$))$/.exec(val2);
};
var DeferredPromise = (
  /** @class */
  function() {
    function DeferredPromise2() {
      var self2 = this;
      this.promise = new Promise(function(resolve, reject) {
        self2.resolve = resolve;
        self2.reject = reject;
      });
    }
    return DeferredPromise2;
  }()
);
var DeferredCallbackResolver = (
  /** @class */
  function() {
    function DeferredCallbackResolver2(options) {
      this.limitPromise = new DeferredPromise();
      this.raceInFlight = false;
      this.callback = function() {
      };
      this.defaultErrorHandler = function(msg) {
        if (msg === void 0) {
          msg = "DeferredCallbackResolver error";
        }
        throw new Error(msg);
      };
      this.callback = options.callback;
      this.errorHandler = options.errorHandler || this.defaultErrorHandler;
      this.maxInterval = options.maxInterval || 2e3;
    }
    DeferredCallbackResolver2.prototype.startTimer = function() {
      var _this = this;
      this.timerPromise = new Promise(function(resolve, reject) {
        _this.timer = setTimeout(function() {
          resolve(LimitTimerRaceResolvedValues.TIMER);
        }, _this.maxInterval);
      });
    };
    DeferredCallbackResolver2.prototype.racePromises = function() {
      return __awaiter3(this, void 0, void 0, function() {
        var winner, err_1;
        return __generator3(this, function(_c) {
          switch (_c.label) {
            case 0:
              _c.trys.push([0, 2, 3, 4]);
              this.raceInFlight = true;
              this.startTimer();
              return [4, Promise.race([
                this.timerPromise,
                this.limitPromise.promise
              ])];
            case 1:
              winner = _c.sent();
              this.callback();
              return [3, 4];
            case 2:
              err_1 = _c.sent();
              this.errorHandler(err_1);
              return [3, 4];
            case 3:
              this.clear();
              this.raceInFlight = false;
              this.limitPromise = new DeferredPromise();
              return [2, winner];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    DeferredCallbackResolver2.prototype.start = function() {
      if (!this.raceInFlight)
        this.racePromises();
    };
    DeferredCallbackResolver2.prototype.clear = function() {
      clearTimeout(this.timer);
    };
    DeferredCallbackResolver2.prototype.resolve = function() {
      this.limitPromise.resolve(LimitTimerRaceResolvedValues.LIMIT);
    };
    return DeferredCallbackResolver2;
  }()
);
var getStorename = function(namespace, modelName) {
  var storeName = namespace + "_" + modelName;
  return storeName;
};
var processCompositeKeys = function(attributes) {
  var extractCompositeSortKey = function(_c) {
    var _d = __read10(_c.properties.fields), sortKeyFields = _d.slice(1);
    return sortKeyFields;
  };
  var compositeKeyFields = attributes.filter(isModelAttributeCompositeKey).map(extractCompositeSortKey);
  var combineIntersecting = function(fields) {
    return fields.reduce(function(combined2, sortKeyFields) {
      var sortKeyFieldsSet = new Set(sortKeyFields);
      if (combined2.length === 0) {
        combined2.push(sortKeyFieldsSet);
        return combined2;
      }
      var intersectingSetIdx = combined2.findIndex(function(existingSet) {
        return __spread(existingSet).some(function(f2) {
          return sortKeyFieldsSet.has(f2);
        });
      });
      if (intersectingSetIdx > -1) {
        var union = new Set(__spread(combined2[intersectingSetIdx], sortKeyFieldsSet));
        combined2[intersectingSetIdx] = union;
      } else {
        combined2.push(sortKeyFieldsSet);
      }
      return combined2;
    }, []);
  };
  var initial = combineIntersecting(compositeKeyFields);
  var combined = combineIntersecting(initial);
  return combined;
};
var extractKeyIfExists = function(modelDefinition) {
  var _c;
  var keyAttribute = (_c = modelDefinition === null || modelDefinition === void 0 ? void 0 : modelDefinition.attributes) === null || _c === void 0 ? void 0 : _c.find(isModelAttributeKey);
  return keyAttribute;
};
var extractPrimaryKeyFieldNames = function(modelDefinition) {
  var keyAttribute = extractKeyIfExists(modelDefinition);
  if (keyAttribute && isModelAttributePrimaryKey(keyAttribute)) {
    return keyAttribute.properties.fields;
  }
  return [ID];
};
var extractPrimaryKeyValues = function(model, keyFields) {
  return keyFields.map(function(key) {
    return model[key];
  });
};
var extractPrimaryKeysAndValues = function(model, keyFields) {
  var primaryKeysAndValues = {};
  keyFields.forEach(function(key) {
    return primaryKeysAndValues[key] = model[key];
  });
  return primaryKeysAndValues;
};
var establishRelationAndKeys = function(namespace) {
  var relationship = {};
  var keys = {};
  Object.keys(namespace.models).forEach(function(mKey) {
    var e_6, _c;
    relationship[mKey] = { indexes: [], relationTypes: [] };
    keys[mKey] = {};
    var model = namespace.models[mKey];
    Object.keys(model.fields).forEach(function(attr) {
      var fieldAttribute = model.fields[attr];
      if (typeof fieldAttribute.type === "object" && "model" in fieldAttribute.type) {
        var connectionType = fieldAttribute.association.connectionType;
        relationship[mKey].relationTypes.push({
          fieldName: fieldAttribute.name,
          modelName: fieldAttribute.type.model,
          relationType: connectionType,
          targetName: fieldAttribute.association["targetName"],
          targetNames: fieldAttribute.association["targetNames"],
          associatedWith: fieldAttribute.association["associatedWith"]
        });
        if (connectionType === "BELONGS_TO") {
          var targetNames = extractTargetNamesFromSrc(fieldAttribute.association);
          if (targetNames) {
            var idxName_1 = indexNameFromKeys(targetNames);
            var idxExists = relationship[mKey].indexes.find(function(_c2) {
              var _d2 = __read10(_c2, 1), index = _d2[0];
              return index === idxName_1;
            });
            if (!idxExists) {
              relationship[mKey].indexes.push([idxName_1, targetNames]);
            }
          }
        }
      }
    });
    if (model.attributes) {
      keys[mKey].compositeKeys = processCompositeKeys(model.attributes);
      var _loop_1 = function(attribute2) {
        if (!isModelAttributeKey(attribute2)) {
          return "continue";
        }
        var fields = attribute2.properties.fields;
        if (isModelAttributePrimaryKey(attribute2)) {
          keys[mKey].primaryKey = fields;
          return "continue";
        }
        var idxName = indexNameFromKeys(fields);
        var idxExists = relationship[mKey].indexes.find(function(_c2) {
          var _d2 = __read10(_c2, 1), index = _d2[0];
          return index === idxName;
        });
        if (!idxExists) {
          relationship[mKey].indexes.push([idxName, fields]);
        }
      };
      try {
        for (var _d = __values4(model.attributes), _e = _d.next(); !_e.done; _e = _d.next()) {
          var attribute = _e.value;
          _loop_1(attribute);
        }
      } catch (e_6_1) {
        e_6 = { error: e_6_1 };
      } finally {
        try {
          if (_e && !_e.done && (_c = _d.return))
            _c.call(_d);
        } finally {
          if (e_6)
            throw e_6.error;
        }
      }
    }
    if (!keys[mKey].primaryKey) {
      keys[mKey].primaryKey = [ID];
    }
    relationship[mKey].indexes.push([
      "byPk",
      keys[mKey].primaryKey,
      { unique: true }
    ]);
  });
  return [relationship, keys];
};
var extractTargetNamesFromSrc = function(src) {
  var targetName = src === null || src === void 0 ? void 0 : src.targetName;
  var targetNames = src === null || src === void 0 ? void 0 : src.targetNames;
  if (Array.isArray(targetNames)) {
    return targetNames;
  } else if (typeof targetName === "string") {
    return [targetName];
  } else {
    return void 0;
  }
};
var indexNameFromKeys = function(keys) {
  return keys.reduce(function(prev, cur, idx) {
    if (idx === 0) {
      return cur;
    }
    return "" + prev + IDENTIFIER_KEY_SEPARATOR + cur;
  }, "");
};
var keysEqual = function(keysA, keysB) {
  if (keysA.length !== keysB.length) {
    return false;
  }
  return keysA.every(function(key, idx) {
    return key === keysB[idx];
  });
};
var getIndexKeys = function(namespace, modelName) {
  var _c, _d;
  var keyPath = (_d = (_c = namespace === null || namespace === void 0 ? void 0 : namespace.keys) === null || _c === void 0 ? void 0 : _c[modelName]) === null || _d === void 0 ? void 0 : _d.primaryKey;
  if (keyPath) {
    return keyPath;
  }
  return [ID];
};

// node_modules/@aws-amplify/datastore/lib-esm/types.js
function isSchemaModel(obj) {
  return obj && obj.pluralName !== void 0;
}
function isSchemaModelWithAttributes(m2) {
  return isSchemaModel(m2) && m2.attributes !== void 0;
}
function isTargetNameAssociation(obj) {
  return (obj === null || obj === void 0 ? void 0 : obj.targetName) || (obj === null || obj === void 0 ? void 0 : obj.targetNames);
}
function isFieldAssociation(obj, fieldName) {
  var _a2, _b2;
  return (_b2 = (_a2 = obj === null || obj === void 0 ? void 0 : obj.fields[fieldName]) === null || _a2 === void 0 ? void 0 : _a2.association) === null || _b2 === void 0 ? void 0 : _b2.connectionType;
}
function isModelAttributeKey(attr) {
  return attr.type === "key" && attr.properties && attr.properties.fields && attr.properties.fields.length > 0;
}
function isModelAttributePrimaryKey(attr) {
  return isModelAttributeKey(attr) && attr.properties.name === void 0;
}
function isModelAttributeCompositeKey(attr) {
  return isModelAttributeKey(attr) && attr.properties.name !== void 0 && attr.properties.fields.length > 2;
}
var ModelAttributeAuthAllow;
(function(ModelAttributeAuthAllow2) {
  ModelAttributeAuthAllow2["CUSTOM"] = "custom";
  ModelAttributeAuthAllow2["OWNER"] = "owner";
  ModelAttributeAuthAllow2["GROUPS"] = "groups";
  ModelAttributeAuthAllow2["PRIVATE"] = "private";
  ModelAttributeAuthAllow2["PUBLIC"] = "public";
})(ModelAttributeAuthAllow || (ModelAttributeAuthAllow = {}));
var ModelAttributeAuthProvider;
(function(ModelAttributeAuthProvider2) {
  ModelAttributeAuthProvider2["FUNCTION"] = "function";
  ModelAttributeAuthProvider2["USER_POOLS"] = "userPools";
  ModelAttributeAuthProvider2["OIDC"] = "oidc";
  ModelAttributeAuthProvider2["IAM"] = "iam";
  ModelAttributeAuthProvider2["API_KEY"] = "apiKey";
})(ModelAttributeAuthProvider || (ModelAttributeAuthProvider = {}));
var GraphQLScalarType;
(function(GraphQLScalarType2) {
  GraphQLScalarType2[GraphQLScalarType2["ID"] = 0] = "ID";
  GraphQLScalarType2[GraphQLScalarType2["String"] = 1] = "String";
  GraphQLScalarType2[GraphQLScalarType2["Int"] = 2] = "Int";
  GraphQLScalarType2[GraphQLScalarType2["Float"] = 3] = "Float";
  GraphQLScalarType2[GraphQLScalarType2["Boolean"] = 4] = "Boolean";
  GraphQLScalarType2[GraphQLScalarType2["AWSDate"] = 5] = "AWSDate";
  GraphQLScalarType2[GraphQLScalarType2["AWSTime"] = 6] = "AWSTime";
  GraphQLScalarType2[GraphQLScalarType2["AWSDateTime"] = 7] = "AWSDateTime";
  GraphQLScalarType2[GraphQLScalarType2["AWSTimestamp"] = 8] = "AWSTimestamp";
  GraphQLScalarType2[GraphQLScalarType2["AWSEmail"] = 9] = "AWSEmail";
  GraphQLScalarType2[GraphQLScalarType2["AWSJSON"] = 10] = "AWSJSON";
  GraphQLScalarType2[GraphQLScalarType2["AWSURL"] = 11] = "AWSURL";
  GraphQLScalarType2[GraphQLScalarType2["AWSPhone"] = 12] = "AWSPhone";
  GraphQLScalarType2[GraphQLScalarType2["AWSIPAddress"] = 13] = "AWSIPAddress";
})(GraphQLScalarType || (GraphQLScalarType = {}));
(function(GraphQLScalarType2) {
  function getJSType(scalar) {
    switch (scalar) {
      case "Boolean":
        return "boolean";
      case "ID":
      case "String":
      case "AWSDate":
      case "AWSTime":
      case "AWSDateTime":
      case "AWSEmail":
      case "AWSURL":
      case "AWSPhone":
      case "AWSIPAddress":
        return "string";
      case "Int":
      case "Float":
      case "AWSTimestamp":
        return "number";
      case "AWSJSON":
        return "object";
      default:
        throw new Error("Invalid scalar type");
    }
  }
  GraphQLScalarType2.getJSType = getJSType;
  function getValidationFunction(scalar) {
    switch (scalar) {
      case "AWSDate":
        return isAWSDate;
      case "AWSTime":
        return isAWSTime;
      case "AWSDateTime":
        return isAWSDateTime;
      case "AWSTimestamp":
        return isAWSTimestamp;
      case "AWSEmail":
        return isAWSEmail;
      case "AWSJSON":
        return isAWSJSON;
      case "AWSURL":
        return isAWSURL;
      case "AWSPhone":
        return isAWSPhone;
      case "AWSIPAddress":
        return isAWSIPAddress;
      default:
        return void 0;
    }
  }
  GraphQLScalarType2.getValidationFunction = getValidationFunction;
})(GraphQLScalarType || (GraphQLScalarType = {}));
function isGraphQLScalarType(obj) {
  return obj && GraphQLScalarType[obj] !== void 0;
}
function isModelFieldType(obj) {
  var modelField = "model";
  if (obj && obj[modelField])
    return true;
  return false;
}
function isNonModelFieldType(obj) {
  var typeField = "nonModel";
  if (obj && obj[typeField])
    return true;
  return false;
}
function isEnumFieldType(obj) {
  var modelField = "enum";
  if (obj && obj[modelField])
    return true;
  return false;
}
function isIdentifierObject(obj, modelDefinition) {
  var keys = extractPrimaryKeyFieldNames(modelDefinition);
  return typeof obj === "object" && obj && keys.every(function(k2) {
    return obj[k2] !== void 0;
  });
}
var OpType;
(function(OpType2) {
  OpType2["INSERT"] = "INSERT";
  OpType2["UPDATE"] = "UPDATE";
  OpType2["DELETE"] = "DELETE";
})(OpType || (OpType = {}));
function isPredicateObj(obj) {
  return obj && obj.field !== void 0;
}
function isPredicateGroup(obj) {
  return obj && obj.type !== void 0;
}
var QueryOne;
(function(QueryOne2) {
  QueryOne2[QueryOne2["FIRST"] = 0] = "FIRST";
  QueryOne2[QueryOne2["LAST"] = 1] = "LAST";
})(QueryOne || (QueryOne = {}));
var SortDirection;
(function(SortDirection2) {
  SortDirection2["ASCENDING"] = "ASCENDING";
  SortDirection2["DESCENDING"] = "DESCENDING";
})(SortDirection || (SortDirection = {}));
var AuthModeStrategyType;
(function(AuthModeStrategyType2) {
  AuthModeStrategyType2["DEFAULT"] = "DEFAULT";
  AuthModeStrategyType2["MULTI_AUTH"] = "MULTI_AUTH";
})(AuthModeStrategyType || (AuthModeStrategyType = {}));
var ModelOperation;
(function(ModelOperation2) {
  ModelOperation2["CREATE"] = "CREATE";
  ModelOperation2["READ"] = "READ";
  ModelOperation2["UPDATE"] = "UPDATE";
  ModelOperation2["DELETE"] = "DELETE";
})(ModelOperation || (ModelOperation = {}));
function syncExpression(modelConstructor, conditionProducer) {
  return __awaiter3(this, void 0, void 0, function() {
    return __generator3(this, function(_a2) {
      return [2, {
        modelConstructor,
        conditionProducer
      }];
    });
  });
}
var ProcessName;
(function(ProcessName2) {
  ProcessName2["sync"] = "sync";
  ProcessName2["mutate"] = "mutate";
  ProcessName2["subscribe"] = "subscribe";
})(ProcessName || (ProcessName = {}));
var DISCARD = Symbol("DISCARD");
var LimitTimerRaceResolvedValues;
(function(LimitTimerRaceResolvedValues2) {
  LimitTimerRaceResolvedValues2["LIMIT"] = "LIMIT";
  LimitTimerRaceResolvedValues2["TIMER"] = "TIMER";
})(LimitTimerRaceResolvedValues || (LimitTimerRaceResolvedValues = {}));
var PredicateInternalsKey = (
  /** @class */
  function() {
    function PredicateInternalsKey2() {
      this.__isPredicateInternalsKeySentinel = true;
    }
    return PredicateInternalsKey2;
  }()
);

// node_modules/@aws-amplify/datastore/lib-esm/authModeStrategies/multiAuthStrategy.js
function getProviderFromRule(rule) {
  if (rule.allow === "private" && !rule.provider) {
    return ModelAttributeAuthProvider.USER_POOLS;
  }
  if (rule.allow === "public" && !rule.provider) {
    return ModelAttributeAuthProvider.API_KEY;
  }
  return rule.provider;
}
function sortAuthRulesWithPriority(rules) {
  var allowSortPriority = [
    ModelAttributeAuthAllow.CUSTOM,
    ModelAttributeAuthAllow.OWNER,
    ModelAttributeAuthAllow.GROUPS,
    ModelAttributeAuthAllow.PRIVATE,
    ModelAttributeAuthAllow.PUBLIC
  ];
  var providerSortPriority = [
    ModelAttributeAuthProvider.FUNCTION,
    ModelAttributeAuthProvider.USER_POOLS,
    ModelAttributeAuthProvider.OIDC,
    ModelAttributeAuthProvider.IAM,
    ModelAttributeAuthProvider.API_KEY
  ];
  return __spread(rules).sort(function(a2, b2) {
    if (a2.allow === b2.allow) {
      return providerSortPriority.indexOf(getProviderFromRule(a2)) - providerSortPriority.indexOf(getProviderFromRule(b2));
    }
    return allowSortPriority.indexOf(a2.allow) - allowSortPriority.indexOf(b2.allow);
  });
}
function getAuthRules(_a2) {
  var rules = _a2.rules, currentUser = _a2.currentUser;
  var authModes = /* @__PURE__ */ new Set();
  rules.forEach(function(rule) {
    switch (rule.allow) {
      case ModelAttributeAuthAllow.CUSTOM:
        if (!rule.provider || rule.provider === ModelAttributeAuthProvider.FUNCTION) {
          authModes.add(GRAPHQL_AUTH_MODE.AWS_LAMBDA);
        }
        break;
      case ModelAttributeAuthAllow.GROUPS:
      case ModelAttributeAuthAllow.OWNER: {
        if (currentUser) {
          if (rule.provider === ModelAttributeAuthProvider.USER_POOLS) {
            authModes.add(GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS);
          } else if (rule.provider === ModelAttributeAuthProvider.OIDC) {
            authModes.add(GRAPHQL_AUTH_MODE.OPENID_CONNECT);
          }
        }
        break;
      }
      case ModelAttributeAuthAllow.PRIVATE: {
        if (currentUser) {
          if (!rule.provider || rule.provider === ModelAttributeAuthProvider.USER_POOLS) {
            authModes.add(GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS);
          } else if (rule.provider === ModelAttributeAuthProvider.IAM) {
            authModes.add(GRAPHQL_AUTH_MODE.AWS_IAM);
          }
        }
        break;
      }
      case ModelAttributeAuthAllow.PUBLIC: {
        if (rule.provider === ModelAttributeAuthProvider.IAM) {
          authModes.add(GRAPHQL_AUTH_MODE.AWS_IAM);
        } else if (!rule.provider || rule.provider === ModelAttributeAuthProvider.API_KEY) {
          authModes.add(GRAPHQL_AUTH_MODE.API_KEY);
        }
        break;
      }
      default:
        break;
    }
  });
  return Array.from(authModes);
}
var multiAuthStrategy = function(amplifyContext) {
  return function(_a2) {
    var schema2 = _a2.schema, modelName = _a2.modelName;
    return __awaiter3(void 0, void 0, void 0, function() {
      var currentUser, e_1, attributes, authAttribute, sortedRules;
      var _b2;
      return __generator3(this, function(_c) {
        switch (_c.label) {
          case 0:
            amplifyContext.Auth = amplifyContext.Auth || Auth;
            _c.label = 1;
          case 1:
            _c.trys.push([1, 3, , 4]);
            return [4, amplifyContext.Auth.currentAuthenticatedUser()];
          case 2:
            currentUser = _c.sent();
            return [3, 4];
          case 3:
            e_1 = _c.sent();
            return [3, 4];
          case 4:
            attributes = schema2.namespaces.user.models[modelName].attributes;
            if (attributes) {
              authAttribute = attributes.find(function(attr) {
                return attr.type === "auth";
              });
              if ((_b2 = authAttribute === null || authAttribute === void 0 ? void 0 : authAttribute.properties) === null || _b2 === void 0 ? void 0 : _b2.rules) {
                sortedRules = sortAuthRulesWithPriority(authAttribute.properties.rules);
                return [2, getAuthRules({ currentUser, rules: sortedRules })];
              }
            }
            return [2, []];
        }
      });
    });
  };
};

// node_modules/@aws-amplify/datastore/lib-esm/storage/storage.js
var import_zen_push = __toESM(require_zen_push());

// node_modules/@aws-amplify/datastore/lib-esm/sync/utils.js
var logger42 = new ConsoleLogger("DataStore");
var GraphQLOperationType;
(function(GraphQLOperationType2) {
  GraphQLOperationType2["LIST"] = "query";
  GraphQLOperationType2["CREATE"] = "mutation";
  GraphQLOperationType2["UPDATE"] = "mutation";
  GraphQLOperationType2["DELETE"] = "mutation";
  GraphQLOperationType2["GET"] = "query";
})(GraphQLOperationType || (GraphQLOperationType = {}));
var TransformerMutationType;
(function(TransformerMutationType2) {
  TransformerMutationType2["CREATE"] = "Create";
  TransformerMutationType2["UPDATE"] = "Update";
  TransformerMutationType2["DELETE"] = "Delete";
  TransformerMutationType2["GET"] = "Get";
})(TransformerMutationType || (TransformerMutationType = {}));
var dummyMetadata = {
  _version: void 0,
  _lastChangedAt: void 0,
  _deleted: void 0
};
var metadataFields = Object.keys(dummyMetadata);
function getMetadataFields() {
  return metadataFields;
}
function generateSelectionSet(namespace, modelDefinition) {
  var scalarFields = getScalarFields(modelDefinition);
  var nonModelFields = getNonModelFields(namespace, modelDefinition);
  var implicitOwnerField = getImplicitOwnerField(modelDefinition, scalarFields);
  var scalarAndMetadataFields = Object.values(scalarFields).map(function(_a2) {
    var name = _a2.name;
    return name;
  }).concat(implicitOwnerField).concat(nonModelFields);
  if (isSchemaModel(modelDefinition)) {
    scalarAndMetadataFields = scalarAndMetadataFields.concat(getMetadataFields()).concat(getConnectionFields(modelDefinition, namespace));
  }
  var result = scalarAndMetadataFields.join("\n");
  return result;
}
function getImplicitOwnerField(modelDefinition, scalarFields) {
  var ownerFields = getOwnerFields(modelDefinition);
  if (!scalarFields.owner && ownerFields.includes("owner")) {
    return ["owner"];
  }
  return [];
}
function getOwnerFields(modelDefinition) {
  var ownerFields = [];
  if (isSchemaModelWithAttributes(modelDefinition)) {
    modelDefinition.attributes.forEach(function(attr) {
      if (attr.properties && attr.properties.rules) {
        var rule = attr.properties.rules.find(function(rule2) {
          return rule2.allow === "owner";
        });
        if (rule && rule.ownerField) {
          ownerFields.push(rule.ownerField);
        }
      }
    });
  }
  return ownerFields;
}
function getScalarFields(modelDefinition) {
  var fields = modelDefinition.fields;
  var result = Object.values(fields).filter(function(field) {
    if (isGraphQLScalarType(field.type) || isEnumFieldType(field.type)) {
      return true;
    }
    return false;
  }).reduce(function(acc, field) {
    acc[field.name] = field;
    return acc;
  }, {});
  return result;
}
function getConnectionFields(modelDefinition, namespace) {
  var result = [];
  Object.values(modelDefinition.fields).filter(function(_a2) {
    var association = _a2.association;
    return association && Object.keys(association).length;
  }).forEach(function(_a2) {
    var name = _a2.name, association = _a2.association;
    var connectionType = (association || {}).connectionType;
    switch (connectionType) {
      case "HAS_ONE":
      case "HAS_MANY":
        break;
      case "BELONGS_TO":
        if (isTargetNameAssociation(association)) {
          if (association.targetNames && association.targetNames.length > 0) {
            var _b2 = __read10(establishRelationAndKeys(namespace), 1), relations = _b2[0];
            var connectedModelName = modelDefinition.fields[name].type["model"];
            var byPkIndex = relations[connectedModelName].indexes.find(function(_a3) {
              var _b3 = __read10(_a3, 1), name2 = _b3[0];
              return name2 === "byPk";
            });
            var keyFields = byPkIndex && byPkIndex[1];
            var keyFieldSelectionSet = keyFields === null || keyFields === void 0 ? void 0 : keyFields.join(" ");
            result.push(name + " { " + keyFieldSelectionSet + " _deleted }");
          } else {
            result.push(name + " { id _deleted }");
          }
        }
        break;
      default:
        throw new Error("Invalid connection type " + connectionType);
    }
  });
  return result;
}
function getNonModelFields(namespace, modelDefinition) {
  var result = [];
  Object.values(modelDefinition.fields).forEach(function(_a2) {
    var name = _a2.name, type = _a2.type;
    if (isNonModelFieldType(type)) {
      var typeDefinition = namespace.nonModels[type.nonModel];
      var scalarFields = Object.values(getScalarFields(typeDefinition)).map(function(_a3) {
        var name2 = _a3.name;
        return name2;
      });
      var nested_1 = [];
      Object.values(typeDefinition.fields).forEach(function(field) {
        var type2 = field.type, name2 = field.name;
        if (isNonModelFieldType(type2)) {
          var typeDefinition_1 = namespace.nonModels[type2.nonModel];
          nested_1.push(name2 + " { " + generateSelectionSet(namespace, typeDefinition_1) + " }");
        }
      });
      result.push(name + " { " + scalarFields.join(" ") + " " + nested_1.join(" ") + " }");
    }
  });
  return result;
}
function getAuthorizationRules(modelDefinition) {
  var authConfig = [].concat(modelDefinition.attributes || []).find(function(attr) {
    return attr && attr.type === "auth";
  });
  var _a2 = (authConfig || {}).properties, _b2 = (_a2 === void 0 ? {} : _a2).rules, rules = _b2 === void 0 ? [] : _b2;
  var resultRules = [];
  rules.forEach(function(rule) {
    var _a3 = rule.identityClaim, identityClaim = _a3 === void 0 ? "cognito:username" : _a3, _b3 = rule.ownerField, ownerField = _b3 === void 0 ? "owner" : _b3, _c = rule.operations, operations = _c === void 0 ? ["create", "update", "delete", "read"] : _c, _d = rule.provider, provider = _d === void 0 ? "userPools" : _d, _e = rule.groupClaim, groupClaim = _e === void 0 ? "cognito:groups" : _e, _f = rule.allow, authStrategy = _f === void 0 ? "iam" : _f, _g = rule.groups, groups = _g === void 0 ? [] : _g, _h = rule.groupsField, groupsField = _h === void 0 ? "" : _h;
    var isReadAuthorized = operations.includes("read");
    var isOwnerAuth = authStrategy === "owner";
    if (!isReadAuthorized && !isOwnerAuth) {
      return;
    }
    var authRule = {
      identityClaim,
      ownerField,
      provider,
      groupClaim,
      authStrategy,
      groups,
      groupsField,
      areSubscriptionsPublic: false
    };
    if (isOwnerAuth) {
      var modelConfig = [].concat(modelDefinition.attributes || []).find(function(attr) {
        return attr && attr.type === "model";
      });
      var _j = (modelConfig || {}).properties, _k = (_j === void 0 ? {} : _j).subscriptions, _l = (_k === void 0 ? {} : _k).level, level = _l === void 0 ? "on" : _l;
      authRule.areSubscriptionsPublic = !operations.includes("read") || level === "public";
    }
    if (isOwnerAuth) {
      resultRules.push(authRule);
      return;
    }
    resultRules.unshift(authRule);
  });
  return resultRules;
}
function buildSubscriptionGraphQLOperation(namespace, modelDefinition, transformerMutationType, isOwnerAuthorization, ownerField, filterArg) {
  if (filterArg === void 0) {
    filterArg = false;
  }
  var selectionSet = generateSelectionSet(namespace, modelDefinition);
  var typeName = modelDefinition.name;
  var opName = "on" + transformerMutationType + typeName;
  var docArgs = [];
  var opArgs = [];
  if (filterArg) {
    docArgs.push("$filter: ModelSubscription" + typeName + "FilterInput");
    opArgs.push("filter: $filter");
  }
  if (isOwnerAuthorization) {
    docArgs.push("$" + ownerField + ": String!");
    opArgs.push(ownerField + ": $" + ownerField);
  }
  var docStr = docArgs.length ? "(" + docArgs.join(",") + ")" : "";
  var opStr = opArgs.length ? "(" + opArgs.join(",") + ")" : "";
  return [
    transformerMutationType,
    opName,
    "subscription operation" + docStr + "{\n			" + opName + opStr + "{\n				" + selectionSet + "\n			}\n		}"
  ];
}
function buildGraphQLOperation(namespace, modelDefinition, graphQLOpType) {
  var selectionSet = generateSelectionSet(namespace, modelDefinition);
  var typeName = modelDefinition.name, pluralTypeName = modelDefinition.pluralName;
  var operation;
  var documentArgs;
  var operationArgs;
  var transformerMutationType;
  switch (graphQLOpType) {
    case "LIST":
      operation = "sync" + pluralTypeName;
      documentArgs = "($limit: Int, $nextToken: String, $lastSync: AWSTimestamp, $filter: Model" + typeName + "FilterInput)";
      operationArgs = "(limit: $limit, nextToken: $nextToken, lastSync: $lastSync, filter: $filter)";
      selectionSet = "items {\n							" + selectionSet + "\n						}\n						nextToken\n						startedAt";
      break;
    case "CREATE":
      operation = "create" + typeName;
      documentArgs = "($input: Create" + typeName + "Input!)";
      operationArgs = "(input: $input)";
      transformerMutationType = TransformerMutationType.CREATE;
      break;
    case "UPDATE":
      operation = "update" + typeName;
      documentArgs = "($input: Update" + typeName + "Input!, $condition: Model" + typeName + "ConditionInput)";
      operationArgs = "(input: $input, condition: $condition)";
      transformerMutationType = TransformerMutationType.UPDATE;
      break;
    case "DELETE":
      operation = "delete" + typeName;
      documentArgs = "($input: Delete" + typeName + "Input!, $condition: Model" + typeName + "ConditionInput)";
      operationArgs = "(input: $input, condition: $condition)";
      transformerMutationType = TransformerMutationType.DELETE;
      break;
    case "GET":
      operation = "get" + typeName;
      documentArgs = "($id: ID!)";
      operationArgs = "(id: $id)";
      transformerMutationType = TransformerMutationType.GET;
      break;
    default:
      throw new Error("Invalid graphQlOpType " + graphQLOpType);
  }
  return [
    [
      transformerMutationType,
      operation,
      GraphQLOperationType[graphQLOpType] + " operation" + documentArgs + "{\n		" + operation + operationArgs + "{\n			" + selectionSet + "\n		}\n	}"
    ]
  ];
}
function createMutationInstanceFromModelOperation(relationships, modelDefinition, opType, model, element, condition, MutationEventConstructor, modelInstanceCreator2, id) {
  var operation;
  switch (opType) {
    case OpType.INSERT:
      operation = TransformerMutationType.CREATE;
      break;
    case OpType.UPDATE:
      operation = TransformerMutationType.UPDATE;
      break;
    case OpType.DELETE:
      operation = TransformerMutationType.DELETE;
      break;
    default:
      throw new Error("Invalid opType " + opType);
  }
  var replacer = function(k2, v2) {
    var isAWSJSON2 = k2 && v2 !== null && typeof v2 === "object" && modelDefinition.fields[k2] && modelDefinition.fields[k2].type === "AWSJSON";
    if (isAWSJSON2) {
      return JSON.stringify(v2);
    }
    return v2;
  };
  var modelId = getIdentifierValue(modelDefinition, element);
  var optionalId = OpType.INSERT && id ? { id } : {};
  var mutationEvent = modelInstanceCreator2(MutationEventConstructor, __assign7(__assign7({}, optionalId), { data: JSON.stringify(element, replacer), modelId, model: model.name, operation, condition: JSON.stringify(condition) }));
  return mutationEvent;
}
function predicateToGraphQLCondition(predicate, modelDefinition) {
  var result = {};
  if (!predicate || !Array.isArray(predicate.predicates)) {
    return result;
  }
  var keyFields = extractPrimaryKeyFieldNames(modelDefinition);
  return predicateToGraphQLFilter(predicate, keyFields);
}
function predicateToGraphQLFilter(predicatesGroup, fieldsToOmit, root) {
  if (fieldsToOmit === void 0) {
    fieldsToOmit = [];
  }
  if (root === void 0) {
    root = true;
  }
  var result = {};
  if (!predicatesGroup || !Array.isArray(predicatesGroup.predicates)) {
    return result;
  }
  var type = predicatesGroup.type, predicates = predicatesGroup.predicates;
  var isList = type === "and" || type === "or";
  result[type] = isList ? [] : {};
  var children = [];
  predicates.forEach(function(predicate) {
    var _a3, _b2;
    if (isPredicateObj(predicate)) {
      var field = predicate.field, operator = predicate.operator, operand = predicate.operand;
      if (fieldsToOmit.includes(field))
        return;
      var gqlField = (_a3 = {}, _a3[field] = (_b2 = {}, _b2[operator] = operand, _b2), _a3);
      children.push(gqlField);
      return;
    }
    var child2 = predicateToGraphQLFilter(predicate, fieldsToOmit, false);
    if (Object.keys(child2).length > 0) {
      children.push(child2);
    }
  });
  if (children.length === 1) {
    var _a2 = __read10(children, 1), child = _a2[0];
    if (
      // any nested list node
      isList && !root || // root list node where the only child is also a list node
      isList && root && ("and" in child || "or" in child)
    ) {
      delete result[type];
      Object.assign(result, child);
      return result;
    }
  }
  children.forEach(function(child2) {
    if (isList) {
      result[type].push(child2);
    } else {
      result[type] = child2;
    }
  });
  if (isList) {
    if (result[type].length === 0)
      return {};
  } else {
    if (Object.keys(result[type]).length === 0)
      return {};
  }
  return result;
}
function filterFields(group) {
  var fields = /* @__PURE__ */ new Set();
  if (!group || !Array.isArray(group.predicates))
    return fields;
  var predicates = group.predicates;
  var stack = __spread(predicates);
  while (stack.length > 0) {
    var current = stack.pop();
    if (isPredicateObj(current)) {
      fields.add(current.field);
    } else if (isPredicateGroup(current)) {
      stack.push.apply(stack, __spread(current.predicates));
    }
  }
  return fields;
}
function dynamicAuthFields(modelDefinition) {
  var e_1, _a2;
  var rules = getAuthorizationRules(modelDefinition);
  var fields = /* @__PURE__ */ new Set();
  try {
    for (var rules_1 = __values4(rules), rules_1_1 = rules_1.next(); !rules_1_1.done; rules_1_1 = rules_1.next()) {
      var rule = rules_1_1.value;
      if (rule.groupsField && !rule.groups.length) {
        fields.add(rule.groupsField);
      } else if (rule.ownerField) {
        fields.add(rule.ownerField);
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (rules_1_1 && !rules_1_1.done && (_a2 = rules_1.return))
        _a2.call(rules_1);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return fields;
}
function countFilterCombinations(group) {
  if (!group || !Array.isArray(group.predicates))
    return 0;
  var count = 0;
  var stack = [group];
  while (stack.length > 0) {
    var current = stack.pop();
    if (isPredicateGroup(current)) {
      var predicates = current.predicates, type = current.type;
      if (type === "or" && predicates.length > 1) {
        count += predicates.length;
      }
      stack.push.apply(stack, __spread(predicates));
    }
  }
  return count || 1;
}
function repeatedFieldInGroup(group) {
  if (!group || !Array.isArray(group.predicates))
    return null;
  var gqlFilter = predicateToGraphQLFilter(group);
  var stack = [gqlFilter];
  var hasGroupRepeatedFields = function(fields) {
    var e_2, _a3;
    var seen = {};
    try {
      for (var fields_1 = __values4(fields), fields_1_1 = fields_1.next(); !fields_1_1.done; fields_1_1 = fields_1.next()) {
        var f2 = fields_1_1.value;
        var _b2 = __read10(Object.keys(f2), 1), fieldName = _b2[0];
        if (seen[fieldName]) {
          return fieldName;
        }
        seen[fieldName] = true;
      }
    } catch (e_2_1) {
      e_2 = { error: e_2_1 };
    } finally {
      try {
        if (fields_1_1 && !fields_1_1.done && (_a3 = fields_1.return))
          _a3.call(fields_1);
      } finally {
        if (e_2)
          throw e_2.error;
      }
    }
    return null;
  };
  while (stack.length > 0) {
    var current = stack.pop();
    var _a2 = __read10(Object.keys(current), 1), key = _a2[0];
    var values = current[key];
    if (!Array.isArray(values)) {
      return null;
    }
    var predicateObjects = values.filter(function(v2) {
      return !Array.isArray(Object.values(v2)[0]);
    });
    var predicateGroups = values.filter(function(v2) {
      return Array.isArray(Object.values(v2)[0]);
    });
    if (key === "and") {
      var repeatedField = hasGroupRepeatedFields(predicateObjects);
      if (repeatedField) {
        return repeatedField;
      }
    }
    stack.push.apply(stack, __spread(predicateGroups));
  }
  return null;
}
var RTFError;
(function(RTFError2) {
  RTFError2[RTFError2["UnknownField"] = 0] = "UnknownField";
  RTFError2[RTFError2["MaxAttributes"] = 1] = "MaxAttributes";
  RTFError2[RTFError2["MaxCombinations"] = 2] = "MaxCombinations";
  RTFError2[RTFError2["RepeatedFieldname"] = 3] = "RepeatedFieldname";
  RTFError2[RTFError2["NotGroup"] = 4] = "NotGroup";
  RTFError2[RTFError2["FieldNotInType"] = 5] = "FieldNotInType";
})(RTFError || (RTFError = {}));
function generateRTFRemediation(errorType, modelDefinition, predicatesGroup) {
  var selSyncFields = filterFields(predicatesGroup);
  var selSyncFieldStr = __spread(selSyncFields).join(", ");
  var dynamicAuthModeFields = dynamicAuthFields(modelDefinition);
  var dynamicAuthFieldsStr = __spread(dynamicAuthModeFields).join(", ");
  var filterCombinations = countFilterCombinations(predicatesGroup);
  var repeatedField = repeatedFieldInGroup(predicatesGroup);
  switch (errorType) {
    case RTFError.UnknownField:
      return "Your API was generated with an older version of the CLI that doesn't support backend subscription filtering.To enable backend subscription filtering, upgrade your Amplify CLI to the latest version and push your app by running `amplify upgrade` followed by `amplify push`";
    case RTFError.MaxAttributes: {
      var message = "Your selective sync expression for " + modelDefinition.name + " contains " + selSyncFields.size + " different model fields: " + selSyncFieldStr + ".\n\n";
      if (dynamicAuthModeFields.size > 0) {
        message += "Note: the number of fields you can use with selective sync is affected by @auth rules configured on the model.\n\nDynamic auth modes, such as owner auth and dynamic group auth each utilize 1 field.\n" + ("You currently have " + dynamicAuthModeFields.size + " dynamic auth mode(s) configured on this model: " + dynamicAuthFieldsStr + ".");
      }
      return message;
    }
    case RTFError.MaxCombinations: {
      var message = "Your selective sync expression for " + modelDefinition.name + " contains " + filterCombinations + " field combinations (total number of predicates in an OR expression).\n\n";
      if (dynamicAuthModeFields.size > 0) {
        message += "Note: the number of fields you can use with selective sync is affected by @auth rules configured on the model.\n\nDynamic auth modes, such as owner auth and dynamic group auth factor in to the number of combinations you're using.\n" + ("You currently have " + dynamicAuthModeFields.size + " dynamic auth mode(s) configured on this model: " + dynamicAuthFieldsStr + ".");
      }
      return message;
    }
    case RTFError.RepeatedFieldname:
      return "Your selective sync expression for " + modelDefinition.name + " contains multiple entries for " + repeatedField + " in the same AND group.";
    case RTFError.NotGroup:
      return "Your selective sync expression for " + modelDefinition.name + " uses a `not` group. If you'd like to filter subscriptions in the backend, rewrite your expression using `ne` or `notContains` operators.";
    case RTFError.FieldNotInType:
      return "";
  }
}
function getUserGroupsFromToken(token, rule) {
  var userGroups = token[rule.groupClaim] || [];
  if (typeof userGroups === "string") {
    var parsedGroups = void 0;
    try {
      parsedGroups = JSON.parse(userGroups);
    } catch (e) {
      parsedGroups = userGroups;
    }
    userGroups = [].concat(parsedGroups);
  }
  return userGroups;
}
function getModelAuthModes(_a2) {
  var authModeStrategy = _a2.authModeStrategy, defaultAuthMode = _a2.defaultAuthMode, modelName = _a2.modelName, schema2 = _a2.schema;
  return __awaiter3(this, void 0, void 0, function() {
    var operations, modelAuthModes, error_1;
    var _this = this;
    return __generator3(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          operations = Object.values(ModelOperation);
          modelAuthModes = {
            CREATE: [],
            READ: [],
            UPDATE: [],
            DELETE: []
          };
          _b2.label = 1;
        case 1:
          _b2.trys.push([1, 3, , 4]);
          return [4, Promise.all(operations.map(function(operation) {
            return __awaiter3(_this, void 0, void 0, function() {
              var authModes;
              return __generator3(this, function(_a3) {
                switch (_a3.label) {
                  case 0:
                    return [4, authModeStrategy({
                      schema: schema2,
                      modelName,
                      operation
                    })];
                  case 1:
                    authModes = _a3.sent();
                    if (typeof authModes === "string") {
                      modelAuthModes[operation] = [authModes];
                    } else if (Array.isArray(authModes) && authModes.length) {
                      modelAuthModes[operation] = authModes;
                    } else {
                      modelAuthModes[operation] = [defaultAuthMode];
                    }
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          }))];
        case 2:
          _b2.sent();
          return [3, 4];
        case 3:
          error_1 = _b2.sent();
          logger42.debug("Error getting auth modes for model: " + modelName, error_1);
          return [3, 4];
        case 4:
          return [2, modelAuthModes];
      }
    });
  });
}
function getForbiddenError(error) {
  var forbiddenErrorMessages = [
    "Request failed with status code 401",
    "Request failed with status code 403"
  ];
  var forbiddenError;
  if (error && error.errors) {
    forbiddenError = error.errors.find(function(err) {
      return forbiddenErrorMessages.includes(err.message);
    });
  } else if (error && error.message) {
    forbiddenError = error;
  }
  if (forbiddenError) {
    return forbiddenError.message;
  }
  return null;
}
function getClientSideAuthError(error) {
  var clientSideAuthErrors = Object.values(GraphQLAuthError);
  var clientSideError = error && error.message && clientSideAuthErrors.find(function(clientError) {
    return error.message.includes(clientError);
  });
  return clientSideError || null;
}
function getTokenForCustomAuth(authMode, amplifyConfig) {
  if (amplifyConfig === void 0) {
    amplifyConfig = {};
  }
  return __awaiter3(this, void 0, void 0, function() {
    var _a2, functionAuthProvider, token, error_2;
    return __generator3(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          if (!(authMode === GRAPHQL_AUTH_MODE.AWS_LAMBDA))
            return [3, 6];
          _a2 = amplifyConfig.authProviders, functionAuthProvider = (_a2 === void 0 ? { functionAuthProvider: null } : _a2).functionAuthProvider;
          if (!(functionAuthProvider && typeof functionAuthProvider === "function"))
            return [3, 5];
          _b2.label = 1;
        case 1:
          _b2.trys.push([1, 3, , 4]);
          return [4, functionAuthProvider()];
        case 2:
          token = _b2.sent().token;
          return [2, token];
        case 3:
          error_2 = _b2.sent();
          throw new Error("Error retrieving token from `functionAuthProvider`: " + error_2);
        case 4:
          return [3, 6];
        case 5:
          throw new Error("You must provide a `functionAuthProvider` function to `DataStore.configure` when using " + GRAPHQL_AUTH_MODE.AWS_LAMBDA);
        case 6:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function getIdentifierValue(modelDefinition, model) {
  var pkFieldNames = extractPrimaryKeyFieldNames(modelDefinition);
  var idOrPk = pkFieldNames.map(function(f2) {
    return model[f2];
  }).join(IDENTIFIER_KEY_SEPARATOR);
  return idOrPk;
}

// node_modules/idb/build/esm/wrap-idb-value.js
var instanceOfAny = (object, constructors) => constructors.some((c2) => object instanceof c2);
var idbProxyableTypes;
var cursorAdvanceMethods;
function getIdbProxyableTypes() {
  return idbProxyableTypes || (idbProxyableTypes = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function getCursorAdvanceMethods() {
  return cursorAdvanceMethods || (cursorAdvanceMethods = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
var cursorRequestMap = /* @__PURE__ */ new WeakMap();
var transactionDoneMap = /* @__PURE__ */ new WeakMap();
var transactionStoreNamesMap = /* @__PURE__ */ new WeakMap();
var transformCache = /* @__PURE__ */ new WeakMap();
var reverseTransformCache = /* @__PURE__ */ new WeakMap();
function promisifyRequest(request) {
  const promise = new Promise((resolve, reject) => {
    const unlisten = () => {
      request.removeEventListener("success", success);
      request.removeEventListener("error", error);
    };
    const success = () => {
      resolve(wrap2(request.result));
      unlisten();
    };
    const error = () => {
      reject(request.error);
      unlisten();
    };
    request.addEventListener("success", success);
    request.addEventListener("error", error);
  });
  promise.then((value) => {
    if (value instanceof IDBCursor) {
      cursorRequestMap.set(value, request);
    }
  }).catch(() => {
  });
  reverseTransformCache.set(promise, request);
  return promise;
}
function cacheDonePromiseForTransaction(tx) {
  if (transactionDoneMap.has(tx))
    return;
  const done = new Promise((resolve, reject) => {
    const unlisten = () => {
      tx.removeEventListener("complete", complete);
      tx.removeEventListener("error", error);
      tx.removeEventListener("abort", error);
    };
    const complete = () => {
      resolve();
      unlisten();
    };
    const error = () => {
      reject(tx.error || new DOMException("AbortError", "AbortError"));
      unlisten();
    };
    tx.addEventListener("complete", complete);
    tx.addEventListener("error", error);
    tx.addEventListener("abort", error);
  });
  transactionDoneMap.set(tx, done);
}
var idbProxyTraps = {
  get(target, prop, receiver) {
    if (target instanceof IDBTransaction) {
      if (prop === "done")
        return transactionDoneMap.get(target);
      if (prop === "objectStoreNames") {
        return target.objectStoreNames || transactionStoreNamesMap.get(target);
      }
      if (prop === "store") {
        return receiver.objectStoreNames[1] ? void 0 : receiver.objectStore(receiver.objectStoreNames[0]);
      }
    }
    return wrap2(target[prop]);
  },
  set(target, prop, value) {
    target[prop] = value;
    return true;
  },
  has(target, prop) {
    if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) {
      return true;
    }
    return prop in target;
  }
};
function replaceTraps(callback) {
  idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
  if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) {
    return function(storeNames, ...args) {
      const tx = func.call(unwrap(this), storeNames, ...args);
      transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [storeNames]);
      return wrap2(tx);
    };
  }
  if (getCursorAdvanceMethods().includes(func)) {
    return function(...args) {
      func.apply(unwrap(this), args);
      return wrap2(cursorRequestMap.get(this));
    };
  }
  return function(...args) {
    return wrap2(func.apply(unwrap(this), args));
  };
}
function transformCachableValue(value) {
  if (typeof value === "function")
    return wrapFunction(value);
  if (value instanceof IDBTransaction)
    cacheDonePromiseForTransaction(value);
  if (instanceOfAny(value, getIdbProxyableTypes()))
    return new Proxy(value, idbProxyTraps);
  return value;
}
function wrap2(value) {
  if (value instanceof IDBRequest)
    return promisifyRequest(value);
  if (transformCache.has(value))
    return transformCache.get(value);
  const newValue = transformCachableValue(value);
  if (newValue !== value) {
    transformCache.set(value, newValue);
    reverseTransformCache.set(newValue, value);
  }
  return newValue;
}
var unwrap = (value) => reverseTransformCache.get(value);

// node_modules/idb/build/esm/index.js
function openDB(name, version3, { blocked, upgrade, blocking, terminated } = {}) {
  const request = indexedDB.open(name, version3);
  const openPromise = wrap2(request);
  if (upgrade) {
    request.addEventListener("upgradeneeded", (event) => {
      upgrade(wrap2(request.result), event.oldVersion, event.newVersion, wrap2(request.transaction));
    });
  }
  if (blocked)
    request.addEventListener("blocked", () => blocked());
  openPromise.then((db) => {
    if (terminated)
      db.addEventListener("close", () => terminated());
    if (blocking)
      db.addEventListener("versionchange", () => blocking());
  }).catch(() => {
  });
  return openPromise;
}
function deleteDB(name, { blocked } = {}) {
  const request = indexedDB.deleteDatabase(name);
  if (blocked)
    request.addEventListener("blocked", () => blocked());
  return wrap2(request).then(() => void 0);
}
var readMethods = ["get", "getKey", "getAll", "getAllKeys", "count"];
var writeMethods = ["put", "add", "delete", "clear"];
var cachedMethods = /* @__PURE__ */ new Map();
function getMethod(target, prop) {
  if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) {
    return;
  }
  if (cachedMethods.get(prop))
    return cachedMethods.get(prop);
  const targetFuncName = prop.replace(/FromIndex$/, "");
  const useIndex = prop !== targetFuncName;
  const isWrite = writeMethods.includes(targetFuncName);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || readMethods.includes(targetFuncName))
  ) {
    return;
  }
  const method = async function(storeName, ...args) {
    const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
    let target2 = tx.store;
    if (useIndex)
      target2 = target2.index(args.shift());
    const returnVal = await target2[targetFuncName](...args);
    if (isWrite)
      await tx.done;
    return returnVal;
  };
  cachedMethods.set(prop, method);
  return method;
}
replaceTraps((oldTraps) => ({
  ...oldTraps,
  get: (target, prop, receiver) => getMethod(target, prop) || oldTraps.get(target, prop, receiver),
  has: (target, prop) => !!getMethod(target, prop) || oldTraps.has(target, prop)
}));

// node_modules/@aws-amplify/datastore/lib-esm/storage/relationship.js
var ModelRelationship = (
  /** @class */
  function() {
    function ModelRelationship2(model, field) {
      if (!isFieldAssociation(model.schema, field)) {
        throw new Error(model.schema.name + "." + field + " is not a relationship.");
      }
      this.localModel = model;
      this._field = field;
    }
    ModelRelationship2.from = function(model, field) {
      if (isFieldAssociation(model.schema, field)) {
        return new this(model, field);
      } else {
        return null;
      }
    };
    ModelRelationship2.allFrom = function(model) {
      var e_1, _a2;
      var relationships = [];
      try {
        for (var _b2 = __values4(Object.keys(model.schema.fields)), _c = _b2.next(); !_c.done; _c = _b2.next()) {
          var field = _c.value;
          var relationship = ModelRelationship2.from(model, field);
          relationship && relationships.push(relationship);
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (_c && !_c.done && (_a2 = _b2.return))
            _a2.call(_b2);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
      return relationships;
    };
    Object.defineProperty(ModelRelationship2.prototype, "localDefinition", {
      get: function() {
        return this.localModel.schema;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ModelRelationship2.prototype, "field", {
      /**
       * The virtual/computed field on the local model that should contain
       * the related model.
       */
      get: function() {
        return this._field;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ModelRelationship2.prototype, "localConstructor", {
      /**
       * The constructor that can be used to query DataStore or create instance for
       * the local model.
       */
      get: function() {
        return this.localModel.builder;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ModelRelationship2.prototype, "type", {
      /**
       * The name/type of the relationship the local model has with the remote model
       * via the defined local model field.
       */
      get: function() {
        return this.localAssocation.connectionType;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ModelRelationship2.prototype, "localAssocation", {
      /**
       * Raw details about the local FK as-is from the local model's field definition in
       * the schema. This field requires interpretation.
       *
       * @see localJoinFields
       * @see localAssociatedWith
       */
      get: function() {
        return this.localDefinition.fields[this.field].association;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ModelRelationship2.prototype, "localJoinFields", {
      /**
       * The field names on the local model that can be used to query or queried to match
       * with instances of the remote model.
       *
       * Fields are returned in-order to match the order of `this.remoteKeyFields`.
       */
      get: function() {
        if (this.localAssocation.targetName) {
          return [this.localAssocation.targetName];
        } else if (this.localAssocation.targetNames) {
          return this.localAssocation.targetNames;
        } else {
          return this.localPKFields;
        }
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ModelRelationship2.prototype, "localPKFields", {
      /**
       * The field names on the local model that uniquely identify it.
       *
       * These fields may or may not be relevant to the join fields.
       */
      get: function() {
        return this.localModel.pkField;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ModelRelationship2.prototype, "remoteDefinition", {
      get: function() {
        var _a2;
        return (_a2 = this.remoteModelType.modelConstructor) === null || _a2 === void 0 ? void 0 : _a2.schema;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ModelRelationship2.prototype, "remoteModelType", {
      get: function() {
        return this.localDefinition.fields[this.field].type;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ModelRelationship2.prototype, "remoteModelConstructor", {
      /**
       * Constructor that can be used to query DataStore or create instances for
       * the remote model.
       */
      get: function() {
        return this.remoteModelType.modelConstructor.builder;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ModelRelationship2.prototype, "remotePKFields", {
      /**
       * The field names on the remote model that uniquely identify it.
       *
       * These fields may or may not be relevant to the join fields.
       */
      get: function() {
        var _a2;
        return ((_a2 = this.remoteModelType.modelConstructor) === null || _a2 === void 0 ? void 0 : _a2.pkField) || ["id"];
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ModelRelationship2.prototype, "localAssociatedWith", {
      /**
       * The `associatedWith` fields from the local perspective.
       *
       * When present, these fields indicate which fields on the remote model to use
       * when looking for a remote association and/or determining the final remote
       * key fields.
       */
      get: function() {
        if (this.localAssocation.connectionType === "HAS_MANY" || this.localAssocation.connectionType === "HAS_ONE") {
          return Array.isArray(this.localAssocation.associatedWith) ? this.localAssocation.associatedWith : [this.localAssocation.associatedWith];
        } else {
          return void 0;
        }
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ModelRelationship2.prototype, "explicitRemoteAssociation", {
      /**
       * The `remote` model's associated field's `assocation` metadata, if
       * present.
       *
       * This is used when determining if the remote model's associated field
       * specifies which FK fields to use. If this value is `undefined`, the
       * name of the remote field (`this.localAssociatedWith`) *is* the remote
       * key field.
       */
      get: function() {
        var _a2;
        if (this.localAssociatedWith) {
          if (this.localAssociatedWith.length === 1) {
            return (_a2 = this.remoteDefinition.fields[this.localAssociatedWith[0]]) === null || _a2 === void 0 ? void 0 : _a2.association;
          } else {
            return void 0;
          }
        }
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ModelRelationship2.prototype, "remoteJoinFields", {
      /**
       * The field names on the remote model that can used to query or queried to match
       * with instances of the local model.
       *
       * Fields are returned in-order to match the order of `this.localKeyFields`.
       */
      get: function() {
        var _a2, _b2, _c;
        if ((_a2 = this.explicitRemoteAssociation) === null || _a2 === void 0 ? void 0 : _a2.targetName) {
          return [this.explicitRemoteAssociation.targetName];
        } else if ((_b2 = this.explicitRemoteAssociation) === null || _b2 === void 0 ? void 0 : _b2.targetNames) {
          return (_c = this.explicitRemoteAssociation) === null || _c === void 0 ? void 0 : _c.targetNames;
        } else if (this.localAssociatedWith) {
          return this.localAssociatedWith;
        } else {
          return this.remotePKFields;
        }
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(ModelRelationship2.prototype, "isComplete", {
      /**
       * Whether this relationship everything necessary to get, set, and query from
       * the perspective of the local model provided at instantiation.
       */
      get: function() {
        return this.localJoinFields.length > 0 && this.remoteJoinFields.length > 0;
      },
      enumerable: true,
      configurable: true
    });
    ModelRelationship2.prototype.createLocalFKObject = function(remote) {
      var fk = {};
      for (var i2 = 0; i2 < this.localJoinFields.length; i2++) {
        fk[this.localJoinFields[i2]] = remote[this.remoteJoinFields[i2]];
      }
      return fk;
    };
    ModelRelationship2.prototype.createRemoteQueryObject = function(local) {
      var query = {};
      for (var i2 = 0; i2 < this.remoteJoinFields.length; i2++) {
        var localValue = local[this.localJoinFields[i2]];
        if (localValue === null || localValue === void 0)
          return null;
        query[this.remoteJoinFields[i2]] = local[this.localJoinFields[i2]];
      }
      return query;
    };
    return ModelRelationship2;
  }()
);

// node_modules/@aws-amplify/datastore/lib-esm/storage/adapter/StorageAdapterBase.js
var logger43 = new ConsoleLogger("DataStore");
var DB_NAME = "amplify-datastore";
var StorageAdapterBase = (
  /** @class */
  function() {
    function StorageAdapterBase2() {
      this.dbName = DB_NAME;
    }
    StorageAdapterBase2.prototype.setUp = function(theSchema, namespaceResolver2, modelInstanceCreator2, getModelConstructorByModelName2, sessionId) {
      return __awaiter3(this, void 0, void 0, function() {
        var _a2, error_1;
        var _this = this;
        return __generator3(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              return [4, this.preSetUpChecks()];
            case 1:
              _b2.sent();
              if (!!this.initPromise)
                return [3, 2];
              this.initPromise = new Promise(function(res, rej) {
                _this.resolve = res;
                _this.reject = rej;
              });
              return [3, 4];
            case 2:
              return [4, this.initPromise];
            case 3:
              _b2.sent();
              return [
                2
                /*return*/
              ];
            case 4:
              if (sessionId) {
                this.dbName = DB_NAME + "-" + sessionId;
              }
              this.schema = theSchema;
              this.namespaceResolver = namespaceResolver2;
              this.modelInstanceCreator = modelInstanceCreator2;
              this.getModelConstructorByModelName = getModelConstructorByModelName2;
              _b2.label = 5;
            case 5:
              _b2.trys.push([5, 8, , 9]);
              if (!!this.db)
                return [3, 7];
              _a2 = this;
              return [4, this.initDb()];
            case 6:
              _a2.db = _b2.sent();
              this.resolve();
              _b2.label = 7;
            case 7:
              return [3, 9];
            case 8:
              error_1 = _b2.sent();
              this.reject(error_1);
              return [3, 9];
            case 9:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    StorageAdapterBase2.prototype.getStorenameForModel = function(modelConstructor) {
      var namespace = this.namespaceResolver(modelConstructor);
      var modelName = modelConstructor.name;
      return getStorename(namespace, modelName);
    };
    StorageAdapterBase2.prototype.getIndexKeyValuesFromModel = function(model) {
      var modelConstructor = Object.getPrototypeOf(model).constructor;
      var namespaceName = this.namespaceResolver(modelConstructor);
      var keys = getIndexKeys(this.schema.namespaces[namespaceName], modelConstructor.name);
      return extractPrimaryKeyValues(model, keys);
    };
    StorageAdapterBase2.prototype.saveMetadata = function(model) {
      var _this = this;
      var modelConstructor = Object.getPrototypeOf(model).constructor;
      var storeName = this.getStorenameForModel(modelConstructor);
      var namespaceName = this.namespaceResolver(modelConstructor);
      var connectedModels = traverseModel(modelConstructor.name, model, this.schema.namespaces[namespaceName], this.modelInstanceCreator, this.getModelConstructorByModelName);
      var set2 = /* @__PURE__ */ new Set();
      var connectionStoreNames = Object.values(connectedModels).map(function(_a2) {
        var modelName = _a2.modelName, item = _a2.item, instance2 = _a2.instance;
        var storeName2 = getStorename(namespaceName, modelName);
        set2.add(storeName2);
        var keys = getIndexKeys(_this.schema.namespaces[namespaceName], modelName);
        return { storeName: storeName2, item, instance: instance2, keys };
      });
      var modelKeyValues = this.getIndexKeyValuesFromModel(model);
      return { storeName, set: set2, connectionStoreNames, modelKeyValues };
    };
    StorageAdapterBase2.prototype.validateSaveCondition = function(condition, fromDB) {
      if (!(condition && fromDB)) {
        return;
      }
      var predicates = ModelPredicateCreator.getPredicates(condition);
      var _a2 = predicates, predicateObjs = _a2.predicates, type = _a2.type;
      var isValid2 = validatePredicate(fromDB, type, predicateObjs);
      if (!isValid2) {
        var msg = "Conditional update failed";
        logger43.error(msg, { model: fromDB, condition: predicateObjs });
        throw new Error(msg);
      }
    };
    StorageAdapterBase2.prototype.load = function(namespaceName, srcModelName, records) {
      return __awaiter3(this, void 0, void 0, function() {
        var namespace, relations, connectionStoreNames, modelConstructor;
        var _this = this;
        return __generator3(this, function(_a2) {
          namespace = this.schema.namespaces[namespaceName];
          relations = namespace.relationships[srcModelName].relationTypes;
          connectionStoreNames = relations.map(function(_a3) {
            var modelName = _a3.modelName;
            return getStorename(namespaceName, modelName);
          });
          modelConstructor = this.getModelConstructorByModelName(namespaceName, srcModelName);
          if (connectionStoreNames.length === 0) {
            return [2, records.map(function(record) {
              return _this.modelInstanceCreator(modelConstructor, record);
            })];
          }
          return [2, records.map(function(record) {
            return _this.modelInstanceCreator(modelConstructor, record);
          })];
        });
      });
    };
    StorageAdapterBase2.prototype.keyValueFromPredicate = function(predicates, keyPath) {
      var e_1, _a2;
      var predicateObjs = predicates.predicates;
      if (predicateObjs.length !== keyPath.length) {
        return;
      }
      var keyValues = [];
      var _loop_1 = function(key2) {
        var predicateObj = predicateObjs.find(function(p2) {
          return isPredicateObj(p2) && p2.field === key2 && p2.operator === "eq" && p2.operand !== null && p2.operand !== void 0;
        });
        predicateObj && keyValues.push(predicateObj.operand);
      };
      try {
        for (var keyPath_1 = __values4(keyPath), keyPath_1_1 = keyPath_1.next(); !keyPath_1_1.done; keyPath_1_1 = keyPath_1.next()) {
          var key = keyPath_1_1.value;
          _loop_1(key);
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (keyPath_1_1 && !keyPath_1_1.done && (_a2 = keyPath_1.return))
            _a2.call(keyPath_1);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
      return keyValues.length === keyPath.length ? keyValues : void 0;
    };
    StorageAdapterBase2.prototype.queryMetadata = function(modelConstructor, predicate, pagination) {
      var storeName = this.getStorenameForModel(modelConstructor);
      var namespaceName = this.namespaceResolver(modelConstructor);
      var predicates = predicate && ModelPredicateCreator.getPredicates(predicate);
      var keyPath = getIndexKeys(this.schema.namespaces[namespaceName], modelConstructor.name);
      var queryByKey = predicates && this.keyValueFromPredicate(predicates, keyPath);
      var hasSort = pagination && pagination.sort;
      var hasPagination = pagination && pagination.limit;
      return {
        storeName,
        namespaceName,
        queryByKey,
        predicates,
        hasSort,
        hasPagination
      };
    };
    StorageAdapterBase2.prototype.delete = function(modelOrModelConstructor, condition) {
      return __awaiter3(this, void 0, void 0, function() {
        var deleteQueue, modelConstructor, namespace, models, deletedModels, deletedModels, model, modelConstructor, namespaceName, storeName, keyValues, fromDB, msg, predicates, _a2, predicateObjs, type, isValid2, msg, deletedModels;
        return __generator3(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              return [4, this.preOpCheck()];
            case 1:
              _b2.sent();
              deleteQueue = [];
              if (!isModelConstructor(modelOrModelConstructor))
                return [3, 9];
              modelConstructor = modelOrModelConstructor;
              namespace = this.namespaceResolver(modelConstructor);
              return [4, this.query(modelConstructor, condition)];
            case 2:
              models = _b2.sent();
              if (!(condition !== void 0))
                return [3, 5];
              return [4, this.deleteTraverse(models, modelConstructor, namespace, deleteQueue)];
            case 3:
              _b2.sent();
              return [4, this.deleteItem(deleteQueue)];
            case 4:
              _b2.sent();
              deletedModels = deleteQueue.reduce(function(acc, _a3) {
                var items = _a3.items;
                return acc.concat(items);
              }, []);
              return [2, [models, deletedModels]];
            case 5:
              return [4, this.deleteTraverse(models, modelConstructor, namespace, deleteQueue)];
            case 6:
              _b2.sent();
              return [4, this.deleteItem(deleteQueue)];
            case 7:
              _b2.sent();
              deletedModels = deleteQueue.reduce(function(acc, _a3) {
                var items = _a3.items;
                return acc.concat(items);
              }, []);
              return [2, [models, deletedModels]];
            case 8:
              return [3, 16];
            case 9:
              model = modelOrModelConstructor;
              modelConstructor = Object.getPrototypeOf(model).constructor;
              namespaceName = this.namespaceResolver(modelConstructor);
              storeName = this.getStorenameForModel(modelConstructor);
              if (!condition)
                return [3, 12];
              keyValues = this.getIndexKeyValuesFromModel(model);
              return [4, this._get(storeName, keyValues)];
            case 10:
              fromDB = _b2.sent();
              if (fromDB === void 0) {
                msg = "Model instance not found in storage";
                logger43.warn(msg, { model });
                return [2, [[model], []]];
              }
              predicates = ModelPredicateCreator.getPredicates(condition);
              _a2 = predicates, predicateObjs = _a2.predicates, type = _a2.type;
              isValid2 = validatePredicate(fromDB, type, predicateObjs);
              if (!isValid2) {
                msg = "Conditional update failed";
                logger43.error(msg, { model: fromDB, condition: predicateObjs });
                throw new Error(msg);
              }
              return [4, this.deleteTraverse([model], modelConstructor, namespaceName, deleteQueue)];
            case 11:
              _b2.sent();
              return [3, 14];
            case 12:
              return [4, this.deleteTraverse([model], modelConstructor, namespaceName, deleteQueue)];
            case 13:
              _b2.sent();
              _b2.label = 14;
            case 14:
              return [4, this.deleteItem(deleteQueue)];
            case 15:
              _b2.sent();
              deletedModels = deleteQueue.reduce(function(acc, _a3) {
                var items = _a3.items;
                return acc.concat(items);
              }, []);
              return [2, [[model], deletedModels]];
            case 16:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    StorageAdapterBase2.prototype.deleteTraverse = function(models, modelConstructor, namespace, deleteQueue) {
      var models_1, models_1_1;
      var e_2, _a2, e_3, _b2;
      return __awaiter3(this, void 0, void 0, function() {
        var cascadingRelationTypes, model, modelDefinition, modelMeta, relationships, relationships_1, relationships_1_1, r2, queryObject, relatedRecords, e_3_1, e_2_1;
        return __generator3(this, function(_c) {
          switch (_c.label) {
            case 0:
              cascadingRelationTypes = ["HAS_ONE", "HAS_MANY"];
              _c.label = 1;
            case 1:
              _c.trys.push([1, 19, 20, 25]);
              models_1 = __asyncValues(models);
              _c.label = 2;
            case 2:
              return [4, models_1.next()];
            case 3:
              if (!(models_1_1 = _c.sent(), !models_1_1.done))
                return [3, 18];
              model = models_1_1.value;
              modelDefinition = this.schema.namespaces[namespace].models[modelConstructor.name];
              modelMeta = {
                builder: modelConstructor,
                schema: modelDefinition,
                pkField: extractPrimaryKeyFieldNames(modelDefinition)
              };
              relationships = ModelRelationship.allFrom(modelMeta).filter(function(r3) {
                return cascadingRelationTypes.includes(r3.type);
              });
              _c.label = 4;
            case 4:
              _c.trys.push([4, 11, 12, 17]);
              relationships_1 = __asyncValues(relationships);
              _c.label = 5;
            case 5:
              return [4, relationships_1.next()];
            case 6:
              if (!(relationships_1_1 = _c.sent(), !relationships_1_1.done))
                return [3, 10];
              r2 = relationships_1_1.value;
              queryObject = r2.createRemoteQueryObject(model);
              if (!(queryObject !== null))
                return [3, 9];
              return [4, this.query(r2.remoteModelConstructor, ModelPredicateCreator.createFromFlatEqualities(r2.remoteDefinition, queryObject))];
            case 7:
              relatedRecords = _c.sent();
              return [4, this.deleteTraverse(relatedRecords, r2.remoteModelConstructor, namespace, deleteQueue)];
            case 8:
              _c.sent();
              _c.label = 9;
            case 9:
              return [3, 5];
            case 10:
              return [3, 17];
            case 11:
              e_3_1 = _c.sent();
              e_3 = { error: e_3_1 };
              return [3, 17];
            case 12:
              _c.trys.push([12, , 15, 16]);
              if (!(relationships_1_1 && !relationships_1_1.done && (_b2 = relationships_1.return)))
                return [3, 14];
              return [4, _b2.call(relationships_1)];
            case 13:
              _c.sent();
              _c.label = 14;
            case 14:
              return [3, 16];
            case 15:
              if (e_3)
                throw e_3.error;
              return [
                7
                /*endfinally*/
              ];
            case 16:
              return [
                7
                /*endfinally*/
              ];
            case 17:
              return [3, 2];
            case 18:
              return [3, 25];
            case 19:
              e_2_1 = _c.sent();
              e_2 = { error: e_2_1 };
              return [3, 25];
            case 20:
              _c.trys.push([20, , 23, 24]);
              if (!(models_1_1 && !models_1_1.done && (_a2 = models_1.return)))
                return [3, 22];
              return [4, _a2.call(models_1)];
            case 21:
              _c.sent();
              _c.label = 22;
            case 22:
              return [3, 24];
            case 23:
              if (e_2)
                throw e_2.error;
              return [
                7
                /*endfinally*/
              ];
            case 24:
              return [
                7
                /*endfinally*/
              ];
            case 25:
              deleteQueue.push({
                storeName: getStorename(namespace, modelConstructor.name),
                items: models
              });
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    return StorageAdapterBase2;
  }()
);

// node_modules/@aws-amplify/datastore/lib-esm/storage/adapter/IndexedDBAdapter.js
var logger44 = new ConsoleLogger("DataStore");
var MULTI_OR_CONDITION_SCAN_BREAKPOINT = 7;
var DB_VERSION = 3;
var IndexedDBAdapter = (
  /** @class */
  function(_super) {
    __extends3(IndexedDBAdapter2, _super);
    function IndexedDBAdapter2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.safariCompatabilityMode = false;
      _this.canonicalKeyPath = function(keyArr) {
        if (_this.safariCompatabilityMode) {
          return keyArr.length > 1 ? keyArr : keyArr[0];
        }
        return keyArr;
      };
      return _this;
    }
    IndexedDBAdapter2.prototype.preSetUpChecks = function() {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this.checkPrivate()];
            case 1:
              _a2.sent();
              return [4, this.setSafariCompatabilityMode()];
            case 2:
              _a2.sent();
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    IndexedDBAdapter2.prototype.preOpCheck = function() {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this.checkPrivate()];
            case 1:
              _a2.sent();
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    IndexedDBAdapter2.prototype.initDb = function() {
      return __awaiter3(this, void 0, void 0, function() {
        var _this = this;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, openDB(this.dbName, DB_VERSION, {
                upgrade: function(db, oldVersion, newVersion, txn) {
                  return __awaiter3(_this, void 0, void 0, function() {
                    var _a3, _b2, storeName, origStore, tmpName, _c, namespaceName, modelName, modelInCurrentSchema, newStore, cursor, count, e_1_1, error_1;
                    var e_1, _d;
                    var _this2 = this;
                    return __generator3(this, function(_e) {
                      switch (_e.label) {
                        case 0:
                          if (oldVersion === 0) {
                            Object.keys(this.schema.namespaces).forEach(function(namespaceName2) {
                              var namespace = _this2.schema.namespaces[namespaceName2];
                              Object.keys(namespace.models).forEach(function(modelName2) {
                                var storeName2 = getStorename(namespaceName2, modelName2);
                                _this2.createObjectStoreForModel(db, namespaceName2, storeName2, modelName2);
                              });
                            });
                            return [
                              2
                              /*return*/
                            ];
                          }
                          if (!((oldVersion === 1 || oldVersion === 2) && newVersion === 3))
                            return [3, 16];
                          _e.label = 1;
                        case 1:
                          _e.trys.push([1, 14, , 15]);
                          _e.label = 2;
                        case 2:
                          _e.trys.push([2, 11, 12, 13]);
                          _a3 = __values4(txn.objectStoreNames), _b2 = _a3.next();
                          _e.label = 3;
                        case 3:
                          if (!!_b2.done)
                            return [3, 10];
                          storeName = _b2.value;
                          origStore = txn.objectStore(storeName);
                          tmpName = "tmp_" + storeName;
                          origStore.name = tmpName;
                          _c = this.getNamespaceAndModelFromStorename(storeName), namespaceName = _c.namespaceName, modelName = _c.modelName;
                          modelInCurrentSchema = modelName in this.schema.namespaces[namespaceName].models;
                          if (!modelInCurrentSchema) {
                            db.deleteObjectStore(tmpName);
                            return [3, 9];
                          }
                          newStore = this.createObjectStoreForModel(db, namespaceName, storeName, modelName);
                          return [4, origStore.openCursor()];
                        case 4:
                          cursor = _e.sent();
                          count = 0;
                          _e.label = 5;
                        case 5:
                          if (!(cursor && cursor.value))
                            return [3, 8];
                          return [4, newStore.put(cursor.value)];
                        case 6:
                          _e.sent();
                          return [4, cursor.continue()];
                        case 7:
                          cursor = _e.sent();
                          count++;
                          return [3, 5];
                        case 8:
                          db.deleteObjectStore(tmpName);
                          logger44.debug(count + " " + storeName + " records migrated");
                          _e.label = 9;
                        case 9:
                          _b2 = _a3.next();
                          return [3, 3];
                        case 10:
                          return [3, 13];
                        case 11:
                          e_1_1 = _e.sent();
                          e_1 = { error: e_1_1 };
                          return [3, 13];
                        case 12:
                          try {
                            if (_b2 && !_b2.done && (_d = _a3.return))
                              _d.call(_a3);
                          } finally {
                            if (e_1)
                              throw e_1.error;
                          }
                          return [
                            7
                            /*endfinally*/
                          ];
                        case 13:
                          Object.keys(this.schema.namespaces).forEach(function(namespaceName2) {
                            var namespace = _this2.schema.namespaces[namespaceName2];
                            var objectStoreNames = new Set(txn.objectStoreNames);
                            Object.keys(namespace.models).map(function(modelName2) {
                              return [modelName2, getStorename(namespaceName2, modelName2)];
                            }).filter(function(_a4) {
                              var _b3 = __read10(_a4, 2), storeName2 = _b3[1];
                              return !objectStoreNames.has(storeName2);
                            }).forEach(function(_a4) {
                              var _b3 = __read10(_a4, 2), modelName2 = _b3[0], storeName2 = _b3[1];
                              _this2.createObjectStoreForModel(db, namespaceName2, storeName2, modelName2);
                            });
                          });
                          return [3, 15];
                        case 14:
                          error_1 = _e.sent();
                          logger44.error("Error migrating IndexedDB data", error_1);
                          txn.abort();
                          throw error_1;
                        case 15:
                          return [
                            2
                            /*return*/
                          ];
                        case 16:
                          return [
                            2
                            /*return*/
                          ];
                      }
                    });
                  });
                }
              })];
            case 1:
              return [2, _a2.sent()];
          }
        });
      });
    };
    IndexedDBAdapter2.prototype._get = function(storeOrStoreName, keyArr) {
      return __awaiter3(this, void 0, void 0, function() {
        var index, storeName, store2, result;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (typeof storeOrStoreName === "string") {
                storeName = storeOrStoreName;
                index = this.db.transaction(storeName, "readonly").store.index("byPk");
              } else {
                store2 = storeOrStoreName;
                index = store2.index("byPk");
              }
              return [4, index.get(this.canonicalKeyPath(keyArr))];
            case 1:
              result = _a2.sent();
              return [2, result];
          }
        });
      });
    };
    IndexedDBAdapter2.prototype.clear = function() {
      var _a2;
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              return [4, this.checkPrivate()];
            case 1:
              _b2.sent();
              (_a2 = this.db) === null || _a2 === void 0 ? void 0 : _a2.close();
              return [4, deleteDB(this.dbName)];
            case 2:
              _b2.sent();
              this.db = void 0;
              this.initPromise = void 0;
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    IndexedDBAdapter2.prototype.save = function(model, condition) {
      var e_2, _a2;
      return __awaiter3(this, void 0, void 0, function() {
        var _b2, storeName, set2, connectionStoreNames, modelKeyValues, tx, store2, fromDB, result, connectionStoreNames_1, connectionStoreNames_1_1, resItem, storeName_1, item, instance2, keys, store_1, itemKeyValues, fromDB_1, opType, key, e_2_1;
        return __generator3(this, function(_c) {
          switch (_c.label) {
            case 0:
              return [4, this.checkPrivate()];
            case 1:
              _c.sent();
              _b2 = this.saveMetadata(model), storeName = _b2.storeName, set2 = _b2.set, connectionStoreNames = _b2.connectionStoreNames, modelKeyValues = _b2.modelKeyValues;
              tx = this.db.transaction(__spread([storeName], Array.from(set2.values())), "readwrite");
              store2 = tx.objectStore(storeName);
              return [4, this._get(store2, modelKeyValues)];
            case 2:
              fromDB = _c.sent();
              this.validateSaveCondition(condition, fromDB);
              result = [];
              _c.label = 3;
            case 3:
              _c.trys.push([3, 11, 12, 17]);
              connectionStoreNames_1 = __asyncValues(connectionStoreNames);
              _c.label = 4;
            case 4:
              return [4, connectionStoreNames_1.next()];
            case 5:
              if (!(connectionStoreNames_1_1 = _c.sent(), !connectionStoreNames_1_1.done))
                return [3, 10];
              resItem = connectionStoreNames_1_1.value;
              storeName_1 = resItem.storeName, item = resItem.item, instance2 = resItem.instance, keys = resItem.keys;
              store_1 = tx.objectStore(storeName_1);
              itemKeyValues = keys.map(function(key2) {
                return item[key2];
              });
              return [4, this._get(store_1, itemKeyValues)];
            case 6:
              fromDB_1 = _c.sent();
              opType = fromDB_1 ? OpType.UPDATE : OpType.INSERT;
              if (!(keysEqual(itemKeyValues, modelKeyValues) || opType === OpType.INSERT))
                return [3, 9];
              return [4, store_1.index("byPk").getKey(this.canonicalKeyPath(itemKeyValues))];
            case 7:
              key = _c.sent();
              return [4, store_1.put(item, key)];
            case 8:
              _c.sent();
              result.push([instance2, opType]);
              _c.label = 9;
            case 9:
              return [3, 4];
            case 10:
              return [3, 17];
            case 11:
              e_2_1 = _c.sent();
              e_2 = { error: e_2_1 };
              return [3, 17];
            case 12:
              _c.trys.push([12, , 15, 16]);
              if (!(connectionStoreNames_1_1 && !connectionStoreNames_1_1.done && (_a2 = connectionStoreNames_1.return)))
                return [3, 14];
              return [4, _a2.call(connectionStoreNames_1)];
            case 13:
              _c.sent();
              _c.label = 14;
            case 14:
              return [3, 16];
            case 15:
              if (e_2)
                throw e_2.error;
              return [
                7
                /*endfinally*/
              ];
            case 16:
              return [
                7
                /*endfinally*/
              ];
            case 17:
              return [4, tx.done];
            case 18:
              _c.sent();
              return [2, result];
          }
        });
      });
    };
    IndexedDBAdapter2.prototype.query = function(modelConstructor, predicate, pagination) {
      return __awaiter3(this, void 0, void 0, function() {
        var _a2, storeName, namespaceName, queryByKey, predicates, hasSort, hasPagination, records;
        var _this = this;
        return __generator3(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              return [4, this.checkPrivate()];
            case 1:
              _b2.sent();
              _a2 = this.queryMetadata(modelConstructor, predicate, pagination), storeName = _a2.storeName, namespaceName = _a2.namespaceName, queryByKey = _a2.queryByKey, predicates = _a2.predicates, hasSort = _a2.hasSort, hasPagination = _a2.hasPagination;
              return [4, function() {
                return __awaiter3(_this, void 0, void 0, function() {
                  var record, filtered, all;
                  return __generator3(this, function(_a3) {
                    switch (_a3.label) {
                      case 0:
                        if (!queryByKey)
                          return [3, 2];
                        return [4, this.getByKey(storeName, queryByKey)];
                      case 1:
                        record = _a3.sent();
                        return [2, record ? [record] : []];
                      case 2:
                        if (!predicates)
                          return [3, 4];
                        return [4, this.filterOnPredicate(storeName, predicates)];
                      case 3:
                        filtered = _a3.sent();
                        return [2, this.inMemoryPagination(filtered, pagination)];
                      case 4:
                        if (!hasSort)
                          return [3, 6];
                        return [4, this.getAll(storeName)];
                      case 5:
                        all = _a3.sent();
                        return [2, this.inMemoryPagination(all, pagination)];
                      case 6:
                        if (hasPagination) {
                          return [2, this.enginePagination(storeName, pagination)];
                        }
                        return [2, this.getAll(storeName)];
                    }
                  });
                });
              }()];
            case 2:
              records = _b2.sent();
              return [4, this.load(namespaceName, modelConstructor.name, records)];
            case 3:
              return [2, _b2.sent()];
          }
        });
      });
    };
    IndexedDBAdapter2.prototype.queryOne = function(modelConstructor, firstOrLast) {
      if (firstOrLast === void 0) {
        firstOrLast = QueryOne.FIRST;
      }
      return __awaiter3(this, void 0, void 0, function() {
        var storeName, cursor, result;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this.checkPrivate()];
            case 1:
              _a2.sent();
              storeName = this.getStorenameForModel(modelConstructor);
              return [4, this.db.transaction([storeName], "readonly").objectStore(storeName).openCursor(void 0, firstOrLast === QueryOne.FIRST ? "next" : "prev")];
            case 2:
              cursor = _a2.sent();
              result = cursor ? cursor.value : void 0;
              return [2, result && this.modelInstanceCreator(modelConstructor, result)];
          }
        });
      });
    };
    IndexedDBAdapter2.prototype.batchSave = function(modelConstructor, items) {
      return __awaiter3(this, void 0, void 0, function() {
        var modelName, namespaceName, storeName, result, txn, store2, _loop_1, this_1, items_1, items_1_1, item, e_3_1;
        var e_3, _a2;
        var _this = this;
        return __generator3(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              return [4, this.checkPrivate()];
            case 1:
              _b2.sent();
              if (items.length === 0) {
                return [2, []];
              }
              modelName = modelConstructor.name;
              namespaceName = this.namespaceResolver(modelConstructor);
              storeName = this.getStorenameForModel(modelConstructor);
              result = [];
              txn = this.db.transaction(storeName, "readwrite");
              store2 = txn.store;
              _loop_1 = function(item2) {
                var model, connectedModels, keyValues, _deleted, index, key, instance2;
                return __generator3(this, function(_a3) {
                  switch (_a3.label) {
                    case 0:
                      model = this_1.modelInstanceCreator(modelConstructor, item2);
                      connectedModels = traverseModel(modelName, model, this_1.schema.namespaces[namespaceName], this_1.modelInstanceCreator, this_1.getModelConstructorByModelName);
                      keyValues = this_1.getIndexKeyValuesFromModel(model);
                      _deleted = item2._deleted;
                      index = store2.index("byPk");
                      return [4, index.getKey(this_1.canonicalKeyPath(keyValues))];
                    case 1:
                      key = _a3.sent();
                      if (!!_deleted)
                        return [3, 3];
                      instance2 = connectedModels.find(function(_a4) {
                        var instance3 = _a4.instance;
                        var instanceKeyValues = _this.getIndexKeyValuesFromModel(instance3);
                        return keysEqual(instanceKeyValues, keyValues);
                      }).instance;
                      result.push([
                        instance2,
                        key ? OpType.UPDATE : OpType.INSERT
                      ]);
                      return [4, store2.put(instance2, key)];
                    case 2:
                      _a3.sent();
                      return [3, 5];
                    case 3:
                      result.push([item2, OpType.DELETE]);
                      if (!key)
                        return [3, 5];
                      return [4, store2.delete(key)];
                    case 4:
                      _a3.sent();
                      _a3.label = 5;
                    case 5:
                      return [
                        2
                        /*return*/
                      ];
                  }
                });
              };
              this_1 = this;
              _b2.label = 2;
            case 2:
              _b2.trys.push([2, 7, 8, 9]);
              items_1 = __values4(items), items_1_1 = items_1.next();
              _b2.label = 3;
            case 3:
              if (!!items_1_1.done)
                return [3, 6];
              item = items_1_1.value;
              return [5, _loop_1(item)];
            case 4:
              _b2.sent();
              _b2.label = 5;
            case 5:
              items_1_1 = items_1.next();
              return [3, 3];
            case 6:
              return [3, 9];
            case 7:
              e_3_1 = _b2.sent();
              e_3 = { error: e_3_1 };
              return [3, 9];
            case 8:
              try {
                if (items_1_1 && !items_1_1.done && (_a2 = items_1.return))
                  _a2.call(items_1);
              } finally {
                if (e_3)
                  throw e_3.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 9:
              return [4, txn.done];
            case 10:
              _b2.sent();
              return [2, result];
          }
        });
      });
    };
    IndexedDBAdapter2.prototype.deleteItem = function(deleteQueue) {
      var e_4, _a2, e_5, _b2;
      return __awaiter3(this, void 0, void 0, function() {
        var connectionStoreNames, tx, _c, _d, deleteItem, storeName, items, store2, items_2, items_2_1, item, key, keyValues, itemKey, e_5_1, e_4_1;
        return __generator3(this, function(_e) {
          switch (_e.label) {
            case 0:
              connectionStoreNames = deleteQueue.map(function(_a3) {
                var storeName2 = _a3.storeName;
                return storeName2;
              });
              tx = this.db.transaction(__spread(connectionStoreNames), "readwrite");
              _e.label = 1;
            case 1:
              _e.trys.push([1, 22, 23, 28]);
              _c = __asyncValues(deleteQueue);
              _e.label = 2;
            case 2:
              return [4, _c.next()];
            case 3:
              if (!(_d = _e.sent(), !_d.done))
                return [3, 21];
              deleteItem = _d.value;
              storeName = deleteItem.storeName, items = deleteItem.items;
              store2 = tx.objectStore(storeName);
              _e.label = 4;
            case 4:
              _e.trys.push([4, 14, 15, 20]);
              items_2 = __asyncValues(items);
              _e.label = 5;
            case 5:
              return [4, items_2.next()];
            case 6:
              if (!(items_2_1 = _e.sent(), !items_2_1.done))
                return [3, 13];
              item = items_2_1.value;
              if (!item)
                return [3, 12];
              key = void 0;
              if (!(typeof item === "object"))
                return [3, 8];
              keyValues = this.getIndexKeyValuesFromModel(item);
              return [4, store2.index("byPk").getKey(this.canonicalKeyPath(keyValues))];
            case 7:
              key = _e.sent();
              return [3, 10];
            case 8:
              itemKey = item.toString();
              return [4, store2.index("byPk").getKey(itemKey)];
            case 9:
              key = _e.sent();
              _e.label = 10;
            case 10:
              if (!(key !== void 0))
                return [3, 12];
              return [4, store2.delete(key)];
            case 11:
              _e.sent();
              _e.label = 12;
            case 12:
              return [3, 5];
            case 13:
              return [3, 20];
            case 14:
              e_5_1 = _e.sent();
              e_5 = { error: e_5_1 };
              return [3, 20];
            case 15:
              _e.trys.push([15, , 18, 19]);
              if (!(items_2_1 && !items_2_1.done && (_b2 = items_2.return)))
                return [3, 17];
              return [4, _b2.call(items_2)];
            case 16:
              _e.sent();
              _e.label = 17;
            case 17:
              return [3, 19];
            case 18:
              if (e_5)
                throw e_5.error;
              return [
                7
                /*endfinally*/
              ];
            case 19:
              return [
                7
                /*endfinally*/
              ];
            case 20:
              return [3, 2];
            case 21:
              return [3, 28];
            case 22:
              e_4_1 = _e.sent();
              e_4 = { error: e_4_1 };
              return [3, 28];
            case 23:
              _e.trys.push([23, , 26, 27]);
              if (!(_d && !_d.done && (_a2 = _c.return)))
                return [3, 25];
              return [4, _a2.call(_c)];
            case 24:
              _e.sent();
              _e.label = 25;
            case 25:
              return [3, 27];
            case 26:
              if (e_4)
                throw e_4.error;
              return [
                7
                /*endfinally*/
              ];
            case 27:
              return [
                7
                /*endfinally*/
              ];
            case 28:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    IndexedDBAdapter2.prototype.checkPrivate = function() {
      return __awaiter3(this, void 0, void 0, function() {
        var isPrivate;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, isPrivateMode().then(function(isPrivate2) {
                return isPrivate2;
              })];
            case 1:
              isPrivate = _a2.sent();
              if (isPrivate) {
                logger44.error("IndexedDB not supported in this browser's private mode");
                return [2, Promise.reject("IndexedDB not supported in this browser's private mode")];
              } else {
                return [2, Promise.resolve()];
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    IndexedDBAdapter2.prototype.setSafariCompatabilityMode = function() {
      return __awaiter3(this, void 0, void 0, function() {
        var _a2;
        return __generator3(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              _a2 = this;
              return [4, isSafariCompatabilityMode()];
            case 1:
              _a2.safariCompatabilityMode = _b2.sent();
              if (this.safariCompatabilityMode === true) {
                logger44.debug("IndexedDB Adapter is running in Safari Compatability Mode");
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    IndexedDBAdapter2.prototype.getNamespaceAndModelFromStorename = function(storeName) {
      var _a2 = __read10(storeName.split("_")), namespaceName = _a2[0], modelNameArr = _a2.slice(1);
      return {
        namespaceName,
        modelName: modelNameArr.join("_")
      };
    };
    IndexedDBAdapter2.prototype.createObjectStoreForModel = function(db, namespaceName, storeName, modelName) {
      var store2 = db.createObjectStore(storeName, {
        autoIncrement: true
      });
      var indexes = this.schema.namespaces[namespaceName].relationships[modelName].indexes;
      indexes.forEach(function(_a2) {
        var _b2 = __read10(_a2, 3), idxName = _b2[0], keyPath = _b2[1], options = _b2[2];
        store2.createIndex(idxName, keyPath, options);
      });
      return store2;
    };
    IndexedDBAdapter2.prototype.getByKey = function(storeName, keyValue) {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this._get(storeName, keyValue)];
            case 1:
              return [2, _a2.sent()];
          }
        });
      });
    };
    IndexedDBAdapter2.prototype.getAll = function(storeName) {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this.db.getAll(storeName)];
            case 1:
              return [2, _a2.sent()];
          }
        });
      });
    };
    IndexedDBAdapter2.prototype.matchingIndexQueries = function(storeName, predicates, transaction) {
      var e_6, _a2, e_7, _b2;
      var _this = this;
      var queries = [];
      var predicateIndex = /* @__PURE__ */ new Map();
      try {
        for (var predicates_1 = __values4(predicates), predicates_1_1 = predicates_1.next(); !predicates_1_1.done; predicates_1_1 = predicates_1.next()) {
          var predicate = predicates_1_1.value;
          predicateIndex.set(String(predicate.field), predicate);
        }
      } catch (e_6_1) {
        e_6 = { error: e_6_1 };
      } finally {
        try {
          if (predicates_1_1 && !predicates_1_1.done && (_a2 = predicates_1.return))
            _a2.call(predicates_1);
        } finally {
          if (e_6)
            throw e_6.error;
        }
      }
      var store2 = transaction.objectStore(storeName);
      var _loop_2 = function(name_12) {
        var e_8, _a3;
        var idx = store2.index(name_12);
        var keypath = Array.isArray(idx.keyPath) ? idx.keyPath : [idx.keyPath];
        var matchingPredicateValues = [];
        try {
          for (var keypath_1 = (e_8 = void 0, __values4(keypath)), keypath_1_1 = keypath_1.next(); !keypath_1_1.done; keypath_1_1 = keypath_1.next()) {
            var field = keypath_1_1.value;
            var p2 = predicateIndex.get(field);
            if (p2 && p2.operand !== null && p2.operand !== void 0) {
              matchingPredicateValues.push(p2.operand);
            } else {
              break;
            }
          }
        } catch (e_8_1) {
          e_8 = { error: e_8_1 };
        } finally {
          try {
            if (keypath_1_1 && !keypath_1_1.done && (_a3 = keypath_1.return))
              _a3.call(keypath_1);
          } finally {
            if (e_8)
              throw e_8.error;
          }
        }
        if (matchingPredicateValues.length === keypath.length) {
          queries.push(function() {
            return _this.db.transaction(storeName).objectStore(storeName).index(name_12).getAll(_this.canonicalKeyPath(matchingPredicateValues));
          });
        }
      };
      try {
        for (var _c = __values4(store2.indexNames), _d = _c.next(); !_d.done; _d = _c.next()) {
          var name_1 = _d.value;
          _loop_2(name_1);
        }
      } catch (e_7_1) {
        e_7 = { error: e_7_1 };
      } finally {
        try {
          if (_d && !_d.done && (_b2 = _c.return))
            _b2.call(_c);
        } finally {
          if (e_7)
            throw e_7.error;
        }
      }
      return queries;
    };
    IndexedDBAdapter2.prototype.baseQueryIndex = function(storeName, predicates, transaction) {
      return __awaiter3(this, void 0, void 0, function() {
        var predicateObjs, type, fieldPredicates, txn, result, groupQueries, objectQueries, indexedQueries;
        var _this = this;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              predicateObjs = predicates.predicates, type = predicates.type;
              while (predicateObjs.length === 1 && isPredicateGroup(predicateObjs[0]) && predicateObjs[0].type !== "not") {
                type = predicateObjs[0].type;
                predicateObjs = predicateObjs[0].predicates;
              }
              fieldPredicates = predicateObjs.filter(function(p2) {
                return isPredicateObj(p2) && p2.operator === "eq";
              });
              txn = transaction || this.db.transaction(storeName);
              result = {};
              if (!(type === "or"))
                return [3, 2];
              return [4, Promise.all(predicateObjs.filter(function(o2) {
                return isPredicateGroup(o2) && o2.type === "and";
              }).map(function(o2) {
                return _this.baseQueryIndex(storeName, o2, txn);
              })).then(function(queries) {
                return queries.filter(function(q2) {
                  return q2.indexedQueries.length === 1;
                }).map(function(i2) {
                  return i2.indexedQueries;
                });
              })];
            case 1:
              groupQueries = _a2.sent();
              objectQueries = predicateObjs.filter(function(o2) {
                return isPredicateObj(o2);
              }).map(function(o2) {
                return _this.matchingIndexQueries(storeName, [o2], txn);
              });
              indexedQueries = __spread(groupQueries, objectQueries).map(function(q2) {
                return q2[0];
              }).filter(function(i2) {
                return i2;
              });
              if (predicateObjs.length > indexedQueries.length) {
                result = {
                  groupType: null,
                  indexedQueries: []
                };
              } else {
                result = {
                  groupType: "or",
                  indexedQueries
                };
              }
              return [3, 3];
            case 2:
              if (type === "and") {
                result = {
                  groupType: type,
                  indexedQueries: this.matchingIndexQueries(storeName, fieldPredicates, txn)
                };
              } else {
                result = {
                  groupType: null,
                  indexedQueries: []
                };
              }
              _a2.label = 3;
            case 3:
              if (!!transaction)
                return [3, 5];
              return [4, txn.done];
            case 4:
              _a2.sent();
              _a2.label = 5;
            case 5:
              return [2, result];
          }
        });
      });
    };
    IndexedDBAdapter2.prototype.filterOnPredicate = function(storeName, predicates) {
      return __awaiter3(this, void 0, void 0, function() {
        var predicateObjs, type, _a2, groupType, indexedQueries, candidateResults, distinctResults, indexedQueries_1, indexedQueries_1_1, query, resultGroup, resultGroup_1, resultGroup_1_1, item, distinctificationString, e_9_1, filtered;
        var e_9, _b2, e_10, _c;
        return __generator3(this, function(_d) {
          switch (_d.label) {
            case 0:
              predicateObjs = predicates.predicates, type = predicates.type;
              return [4, this.baseQueryIndex(storeName, predicates)];
            case 1:
              _a2 = _d.sent(), groupType = _a2.groupType, indexedQueries = _a2.indexedQueries;
              if (!(groupType === "and" && indexedQueries.length > 0))
                return [3, 3];
              return [4, indexedQueries[0]()];
            case 2:
              candidateResults = _d.sent();
              return [3, 14];
            case 3:
              if (!(groupType === "or" && indexedQueries.length > 0 && indexedQueries.length <= MULTI_OR_CONDITION_SCAN_BREAKPOINT))
                return [3, 12];
              distinctResults = /* @__PURE__ */ new Map();
              _d.label = 4;
            case 4:
              _d.trys.push([4, 9, 10, 11]);
              indexedQueries_1 = __values4(indexedQueries), indexedQueries_1_1 = indexedQueries_1.next();
              _d.label = 5;
            case 5:
              if (!!indexedQueries_1_1.done)
                return [3, 8];
              query = indexedQueries_1_1.value;
              return [4, query()];
            case 6:
              resultGroup = _d.sent();
              try {
                for (resultGroup_1 = (e_10 = void 0, __values4(resultGroup)), resultGroup_1_1 = resultGroup_1.next(); !resultGroup_1_1.done; resultGroup_1_1 = resultGroup_1.next()) {
                  item = resultGroup_1_1.value;
                  distinctificationString = JSON.stringify(item);
                  distinctResults.set(distinctificationString, item);
                }
              } catch (e_10_1) {
                e_10 = { error: e_10_1 };
              } finally {
                try {
                  if (resultGroup_1_1 && !resultGroup_1_1.done && (_c = resultGroup_1.return))
                    _c.call(resultGroup_1);
                } finally {
                  if (e_10)
                    throw e_10.error;
                }
              }
              _d.label = 7;
            case 7:
              indexedQueries_1_1 = indexedQueries_1.next();
              return [3, 5];
            case 8:
              return [3, 11];
            case 9:
              e_9_1 = _d.sent();
              e_9 = { error: e_9_1 };
              return [3, 11];
            case 10:
              try {
                if (indexedQueries_1_1 && !indexedQueries_1_1.done && (_b2 = indexedQueries_1.return))
                  _b2.call(indexedQueries_1);
              } finally {
                if (e_9)
                  throw e_9.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 11:
              candidateResults = Array.from(distinctResults.values());
              return [3, 14];
            case 12:
              return [4, this.getAll(storeName)];
            case 13:
              candidateResults = _d.sent();
              _d.label = 14;
            case 14:
              filtered = predicateObjs ? candidateResults.filter(function(m2) {
                return validatePredicate(m2, type, predicateObjs);
              }) : candidateResults;
              return [2, filtered];
          }
        });
      });
    };
    IndexedDBAdapter2.prototype.inMemoryPagination = function(records, pagination) {
      return inMemoryPagination(records, pagination);
    };
    IndexedDBAdapter2.prototype.enginePagination = function(storeName, pagination) {
      return __awaiter3(this, void 0, void 0, function() {
        var result, _a2, page, _b2, limit, initialRecord, cursor, pageResults, hasLimit;
        return __generator3(this, function(_c) {
          switch (_c.label) {
            case 0:
              if (!pagination)
                return [3, 7];
              _a2 = pagination.page, page = _a2 === void 0 ? 0 : _a2, _b2 = pagination.limit, limit = _b2 === void 0 ? 0 : _b2;
              initialRecord = Math.max(0, page * limit) || 0;
              return [4, this.db.transaction(storeName).objectStore(storeName).openCursor()];
            case 1:
              cursor = _c.sent();
              if (!(cursor && initialRecord > 0))
                return [3, 3];
              return [4, cursor.advance(initialRecord)];
            case 2:
              _c.sent();
              _c.label = 3;
            case 3:
              pageResults = [];
              hasLimit = typeof limit === "number" && limit > 0;
              _c.label = 4;
            case 4:
              if (!(cursor && cursor.value))
                return [3, 6];
              pageResults.push(cursor.value);
              if (hasLimit && pageResults.length === limit) {
                return [3, 6];
              }
              return [4, cursor.continue()];
            case 5:
              cursor = _c.sent();
              return [3, 4];
            case 6:
              result = pageResults;
              return [3, 9];
            case 7:
              return [4, this.db.getAll(storeName)];
            case 8:
              result = _c.sent();
              _c.label = 9;
            case 9:
              return [2, result];
          }
        });
      });
    };
    return IndexedDBAdapter2;
  }(StorageAdapterBase)
);
var IndexedDBAdapter_default = new IndexedDBAdapter();

// node_modules/@aws-amplify/datastore/lib-esm/storage/adapter/InMemoryStore.js
var InMemoryStore = (
  /** @class */
  function() {
    function InMemoryStore2() {
      var _this = this;
      this.db = /* @__PURE__ */ new Map();
      this.getAllKeys = function() {
        return __awaiter3(_this, void 0, void 0, function() {
          return __generator3(this, function(_a2) {
            return [2, Array.from(this.db.keys())];
          });
        });
      };
      this.multiGet = function(keys) {
        return __awaiter3(_this, void 0, void 0, function() {
          var _this2 = this;
          return __generator3(this, function(_a2) {
            return [2, keys.reduce(function(res, k2) {
              return res.push([k2, _this2.db.get(k2)]), res;
            }, [])];
          });
        });
      };
      this.multiRemove = function(keys, callback) {
        return __awaiter3(_this, void 0, void 0, function() {
          var _this2 = this;
          return __generator3(this, function(_a2) {
            keys.forEach(function(k2) {
              return _this2.db.delete(k2);
            });
            typeof callback === "function" && callback();
            return [
              2
              /*return*/
            ];
          });
        });
      };
      this.multiSet = function(entries, callback) {
        return __awaiter3(_this, void 0, void 0, function() {
          var _this2 = this;
          return __generator3(this, function(_a2) {
            entries.forEach(function(_a3) {
              var _b2 = __read10(_a3, 2), key = _b2[0], value = _b2[1];
              _this2.setItem(key, value);
            });
            typeof callback === "function" && callback();
            return [
              2
              /*return*/
            ];
          });
        });
      };
      this.setItem = function(key, value) {
        return __awaiter3(_this, void 0, void 0, function() {
          return __generator3(this, function(_a2) {
            return [2, this.db.set(key, value)];
          });
        });
      };
      this.removeItem = function(key) {
        return __awaiter3(_this, void 0, void 0, function() {
          return __generator3(this, function(_a2) {
            return [2, this.db.delete(key)];
          });
        });
      };
      this.getItem = function(key) {
        return __awaiter3(_this, void 0, void 0, function() {
          return __generator3(this, function(_a2) {
            return [2, this.db.get(key)];
          });
        });
      };
    }
    return InMemoryStore2;
  }()
);
function createInMemoryStore() {
  return new InMemoryStore();
}

// node_modules/@aws-amplify/datastore/lib-esm/storage/adapter/AsyncStorageDatabase.js
var DB_NAME2 = "@AmplifyDatastore";
var COLLECTION = "Collection";
var DATA = "Data";
var monotonicFactoriesMap = /* @__PURE__ */ new Map();
var AsyncStorageDatabase = (
  /** @class */
  function() {
    function AsyncStorageDatabase2() {
      this._collectionInMemoryIndex = /* @__PURE__ */ new Map();
      this.storage = createInMemoryStore();
    }
    AsyncStorageDatabase2.prototype.getCollectionIndex = function(storeName) {
      if (!this._collectionInMemoryIndex.has(storeName)) {
        this._collectionInMemoryIndex.set(storeName, /* @__PURE__ */ new Map());
      }
      return this._collectionInMemoryIndex.get(storeName);
    };
    AsyncStorageDatabase2.prototype.getMonotonicFactory = function(storeName) {
      if (!monotonicFactoriesMap.has(storeName)) {
        monotonicFactoriesMap.set(storeName, monotonicUlidFactory());
      }
      return monotonicFactoriesMap.get(storeName);
    };
    AsyncStorageDatabase2.prototype.init = function() {
      return __awaiter3(this, void 0, void 0, function() {
        var allKeys, keysForCollectionEntries, allKeys_1, allKeys_1_1, key, _a2, dbName, storeName, recordType, ulidOrId, id, ulid3, id_1, newUlid, oldKey, newKey, item, e_1_1;
        var e_1, _b2;
        return __generator3(this, function(_c) {
          switch (_c.label) {
            case 0:
              this._collectionInMemoryIndex.clear();
              return [4, this.storage.getAllKeys()];
            case 1:
              allKeys = _c.sent();
              keysForCollectionEntries = [];
              _c.label = 2;
            case 2:
              _c.trys.push([2, 12, 13, 14]);
              allKeys_1 = __values4(allKeys), allKeys_1_1 = allKeys_1.next();
              _c.label = 3;
            case 3:
              if (!!allKeys_1_1.done)
                return [3, 11];
              key = allKeys_1_1.value;
              _a2 = __read10(key.split("::"), 5), dbName = _a2[0], storeName = _a2[1], recordType = _a2[2], ulidOrId = _a2[3], id = _a2[4];
              if (!(dbName === DB_NAME2))
                return [3, 10];
              if (!(recordType === DATA))
                return [3, 9];
              ulid3 = void 0;
              if (!(id === void 0))
                return [3, 7];
              id_1 = ulidOrId;
              newUlid = this.getMonotonicFactory(storeName)();
              oldKey = this.getLegacyKeyForItem(storeName, id_1);
              newKey = this.getKeyForItem(storeName, id_1, newUlid);
              return [4, this.storage.getItem(oldKey)];
            case 4:
              item = _c.sent();
              return [4, this.storage.setItem(newKey, item)];
            case 5:
              _c.sent();
              return [4, this.storage.removeItem(oldKey)];
            case 6:
              _c.sent();
              ulid3 = newUlid;
              return [3, 8];
            case 7:
              ulid3 = ulidOrId;
              _c.label = 8;
            case 8:
              this.getCollectionIndex(storeName).set(id, ulid3);
              return [3, 10];
            case 9:
              if (recordType === COLLECTION) {
                keysForCollectionEntries.push(key);
              }
              _c.label = 10;
            case 10:
              allKeys_1_1 = allKeys_1.next();
              return [3, 3];
            case 11:
              return [3, 14];
            case 12:
              e_1_1 = _c.sent();
              e_1 = { error: e_1_1 };
              return [3, 14];
            case 13:
              try {
                if (allKeys_1_1 && !allKeys_1_1.done && (_b2 = allKeys_1.return))
                  _b2.call(allKeys_1);
              } finally {
                if (e_1)
                  throw e_1.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 14:
              if (!(keysForCollectionEntries.length > 0))
                return [3, 16];
              return [4, this.storage.multiRemove(keysForCollectionEntries)];
            case 15:
              _c.sent();
              _c.label = 16;
            case 16:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AsyncStorageDatabase2.prototype.save = function(item, storeName, keys, keyValuesPath) {
      var _a2, _b2;
      return __awaiter3(this, void 0, void 0, function() {
        var idxName, ulid3, itemKey;
        return __generator3(this, function(_c) {
          switch (_c.label) {
            case 0:
              idxName = indexNameFromKeys(keys);
              ulid3 = ((_a2 = this.getCollectionIndex(storeName)) === null || _a2 === void 0 ? void 0 : _a2.get(idxName)) || this.getMonotonicFactory(storeName)();
              itemKey = this.getKeyForItem(storeName, keyValuesPath, ulid3);
              (_b2 = this.getCollectionIndex(storeName)) === null || _b2 === void 0 ? void 0 : _b2.set(keyValuesPath, ulid3);
              return [4, this.storage.setItem(itemKey, JSON.stringify(item))];
            case 1:
              _c.sent();
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AsyncStorageDatabase2.prototype.batchSave = function(storeName, items, keys) {
      return __awaiter3(this, void 0, void 0, function() {
        var result, collection, keysToDelete, keysToSave, allItemsKeys, itemsMap, _loop_1, this_1, items_1, items_1_1, item, existingRecordsMap, existingRecordsKeys, allItemsKeys_1, allItemsKeys_1_1, key;
        var e_2, _a2, e_3, _b2;
        var _this = this;
        return __generator3(this, function(_c) {
          switch (_c.label) {
            case 0:
              if (items.length === 0) {
                return [2, []];
              }
              result = [];
              collection = this.getCollectionIndex(storeName);
              keysToDelete = /* @__PURE__ */ new Set();
              keysToSave = /* @__PURE__ */ new Set();
              allItemsKeys = [];
              itemsMap = {};
              _loop_1 = function(item2) {
                var keyValues = keys.map(function(field) {
                  return item2[field];
                });
                var _deleted = item2._deleted;
                var ulid3 = collection.get(keyValues.join(DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR)) || this_1.getMonotonicFactory(storeName)();
                var key2 = this_1.getKeyForItem(storeName, keyValues.join(DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR), ulid3);
                allItemsKeys.push(key2);
                itemsMap[key2] = { ulid: ulid3, model: item2 };
                if (_deleted) {
                  keysToDelete.add(key2);
                } else {
                  keysToSave.add(key2);
                }
              };
              this_1 = this;
              try {
                for (items_1 = __values4(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                  item = items_1_1.value;
                  _loop_1(item);
                }
              } catch (e_2_1) {
                e_2 = { error: e_2_1 };
              } finally {
                try {
                  if (items_1_1 && !items_1_1.done && (_a2 = items_1.return))
                    _a2.call(items_1);
                } finally {
                  if (e_2)
                    throw e_2.error;
                }
              }
              return [4, this.storage.multiGet(allItemsKeys)];
            case 1:
              existingRecordsMap = _c.sent();
              existingRecordsKeys = existingRecordsMap.filter(function(_a3) {
                var _b3 = __read10(_a3, 2), v2 = _b3[1];
                return !!v2;
              }).reduce(function(set2, _a3) {
                var _b3 = __read10(_a3, 1), k2 = _b3[0];
                return set2.add(k2);
              }, /* @__PURE__ */ new Set());
              return [4, new Promise(function(resolve, reject) {
                if (keysToDelete.size === 0) {
                  resolve();
                  return;
                }
                var keysToDeleteArray = Array.from(keysToDelete);
                keysToDeleteArray.forEach(function(key2) {
                  var primaryKeyValues = keys.map(function(field) {
                    return itemsMap[key2].model[field];
                  }).join(DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR);
                  collection.delete(primaryKeyValues);
                });
                _this.storage.multiRemove(keysToDeleteArray, function(errors) {
                  if (errors && errors.length > 0) {
                    reject(errors);
                  } else {
                    resolve();
                  }
                });
              })];
            case 2:
              _c.sent();
              return [4, new Promise(function(resolve, reject) {
                if (keysToSave.size === 0) {
                  resolve();
                  return;
                }
                var entriesToSet = Array.from(keysToSave).map(function(key2) {
                  return [
                    key2,
                    JSON.stringify(itemsMap[key2].model)
                  ];
                });
                keysToSave.forEach(function(key2) {
                  var _a3 = itemsMap[key2], model = _a3.model, ulid3 = _a3.ulid;
                  var keyValues = keys.map(function(field) {
                    return model[field];
                  }).join(DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR);
                  collection.set(keyValues, ulid3);
                });
                _this.storage.multiSet(entriesToSet, function(errors) {
                  if (errors && errors.length > 0) {
                    reject(errors);
                  } else {
                    resolve();
                  }
                });
              })];
            case 3:
              _c.sent();
              try {
                for (allItemsKeys_1 = __values4(allItemsKeys), allItemsKeys_1_1 = allItemsKeys_1.next(); !allItemsKeys_1_1.done; allItemsKeys_1_1 = allItemsKeys_1.next()) {
                  key = allItemsKeys_1_1.value;
                  if (keysToDelete.has(key) && existingRecordsKeys.has(key)) {
                    result.push([itemsMap[key].model, OpType.DELETE]);
                  } else if (keysToSave.has(key)) {
                    result.push([
                      itemsMap[key].model,
                      existingRecordsKeys.has(key) ? OpType.UPDATE : OpType.INSERT
                    ]);
                  }
                }
              } catch (e_3_1) {
                e_3 = { error: e_3_1 };
              } finally {
                try {
                  if (allItemsKeys_1_1 && !allItemsKeys_1_1.done && (_b2 = allItemsKeys_1.return))
                    _b2.call(allItemsKeys_1);
                } finally {
                  if (e_3)
                    throw e_3.error;
                }
              }
              return [2, result];
          }
        });
      });
    };
    AsyncStorageDatabase2.prototype.get = function(keyValuePath, storeName) {
      return __awaiter3(this, void 0, void 0, function() {
        var ulid3, itemKey, recordAsString, record;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              ulid3 = this.getCollectionIndex(storeName).get(keyValuePath);
              itemKey = this.getKeyForItem(storeName, keyValuePath, ulid3);
              return [4, this.storage.getItem(itemKey)];
            case 1:
              recordAsString = _a2.sent();
              record = recordAsString && JSON.parse(recordAsString);
              return [2, record];
          }
        });
      });
    };
    AsyncStorageDatabase2.prototype.getOne = function(firstOrLast, storeName) {
      return __awaiter3(this, void 0, void 0, function() {
        var collection, _a2, itemId, ulid3, itemKey, itemString, _b2, result;
        return __generator3(this, function(_c) {
          switch (_c.label) {
            case 0:
              collection = this.getCollectionIndex(storeName);
              _a2 = __read10(firstOrLast === QueryOne.FIRST ? function() {
                var e_4, _a3, _b3;
                var id, ulid4;
                try {
                  for (var collection_1 = __values4(collection), collection_1_1 = collection_1.next(); !collection_1_1.done; collection_1_1 = collection_1.next()) {
                    _b3 = __read10(collection_1_1.value, 2), id = _b3[0], ulid4 = _b3[1];
                    break;
                  }
                } catch (e_4_1) {
                  e_4 = { error: e_4_1 };
                } finally {
                  try {
                    if (collection_1_1 && !collection_1_1.done && (_a3 = collection_1.return))
                      _a3.call(collection_1);
                  } finally {
                    if (e_4)
                      throw e_4.error;
                  }
                }
                return [id, ulid4];
              }() : function() {
                var e_5, _a3, _b3;
                var id, ulid4;
                try {
                  for (var collection_2 = __values4(collection), collection_2_1 = collection_2.next(); !collection_2_1.done; collection_2_1 = collection_2.next()) {
                    _b3 = __read10(collection_2_1.value, 2), id = _b3[0], ulid4 = _b3[1];
                    ;
                  }
                } catch (e_5_1) {
                  e_5 = { error: e_5_1 };
                } finally {
                  try {
                    if (collection_2_1 && !collection_2_1.done && (_a3 = collection_2.return))
                      _a3.call(collection_2);
                  } finally {
                    if (e_5)
                      throw e_5.error;
                  }
                }
                return [id, ulid4];
              }(), 2), itemId = _a2[0], ulid3 = _a2[1];
              itemKey = this.getKeyForItem(storeName, itemId, ulid3);
              _b2 = itemKey;
              if (!_b2)
                return [3, 2];
              return [4, this.storage.getItem(itemKey)];
            case 1:
              _b2 = _c.sent();
              _c.label = 2;
            case 2:
              itemString = _b2;
              result = itemString ? JSON.parse(itemString) || void 0 : void 0;
              return [2, result];
          }
        });
      });
    };
    AsyncStorageDatabase2.prototype.getAll = function(storeName, pagination) {
      return __awaiter3(this, void 0, void 0, function() {
        var collection, _a2, _b2, page, _c, limit, start, end, keysForStore, count, collection_3, collection_3_1, _d, id, ulid3, storeRecordStrings, records;
        var e_6, _e;
        return __generator3(this, function(_f) {
          switch (_f.label) {
            case 0:
              collection = this.getCollectionIndex(storeName);
              _a2 = pagination || {}, _b2 = _a2.page, page = _b2 === void 0 ? 0 : _b2, _c = _a2.limit, limit = _c === void 0 ? 0 : _c;
              start = Math.max(0, page * limit) || 0;
              end = limit > 0 ? start + limit : void 0;
              keysForStore = [];
              count = 0;
              try {
                for (collection_3 = __values4(collection), collection_3_1 = collection_3.next(); !collection_3_1.done; collection_3_1 = collection_3.next()) {
                  _d = __read10(collection_3_1.value, 2), id = _d[0], ulid3 = _d[1];
                  count++;
                  if (count <= start) {
                    continue;
                  }
                  keysForStore.push(this.getKeyForItem(storeName, id, ulid3));
                  if (count === end) {
                    break;
                  }
                }
              } catch (e_6_1) {
                e_6 = { error: e_6_1 };
              } finally {
                try {
                  if (collection_3_1 && !collection_3_1.done && (_e = collection_3.return))
                    _e.call(collection_3);
                } finally {
                  if (e_6)
                    throw e_6.error;
                }
              }
              return [4, this.storage.multiGet(keysForStore)];
            case 1:
              storeRecordStrings = _f.sent();
              records = storeRecordStrings.filter(function(_a3) {
                var _b3 = __read10(_a3, 2), value = _b3[1];
                return value;
              }).map(function(_a3) {
                var _b3 = __read10(_a3, 2), value = _b3[1];
                return JSON.parse(value);
              });
              return [2, records];
          }
        });
      });
    };
    AsyncStorageDatabase2.prototype.delete = function(key, storeName) {
      return __awaiter3(this, void 0, void 0, function() {
        var ulid3, itemKey;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              ulid3 = this.getCollectionIndex(storeName).get(key);
              itemKey = this.getKeyForItem(storeName, key, ulid3);
              this.getCollectionIndex(storeName).delete(key);
              return [4, this.storage.removeItem(itemKey)];
            case 1:
              _a2.sent();
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AsyncStorageDatabase2.prototype.clear = function() {
      return __awaiter3(this, void 0, void 0, function() {
        var allKeys, allDataStoreKeys;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this.storage.getAllKeys()];
            case 1:
              allKeys = _a2.sent();
              allDataStoreKeys = allKeys.filter(function(key) {
                return key.startsWith(DB_NAME2);
              });
              return [4, this.storage.multiRemove(allDataStoreKeys)];
            case 2:
              _a2.sent();
              this._collectionInMemoryIndex.clear();
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AsyncStorageDatabase2.prototype.getKeyForItem = function(storeName, id, ulid3) {
      return this.getKeyPrefixForStoreItems(storeName) + "::" + ulid3 + "::" + id;
    };
    AsyncStorageDatabase2.prototype.getLegacyKeyForItem = function(storeName, id) {
      return this.getKeyPrefixForStoreItems(storeName) + "::" + id;
    };
    AsyncStorageDatabase2.prototype.getKeyPrefixForStoreItems = function(storeName) {
      return DB_NAME2 + "::" + storeName + "::" + DATA;
    };
    return AsyncStorageDatabase2;
  }()
);
var AsyncStorageDatabase_default = AsyncStorageDatabase;

// node_modules/@aws-amplify/datastore/lib-esm/storage/adapter/AsyncStorageAdapter.js
var AsyncStorageAdapter = (
  /** @class */
  function(_super) {
    __extends3(AsyncStorageAdapter2, _super);
    function AsyncStorageAdapter2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    AsyncStorageAdapter2.prototype.preSetUpChecks = function() {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          return [
            2
            /*return*/
          ];
        });
      });
    };
    AsyncStorageAdapter2.prototype.preOpCheck = function() {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          return [
            2
            /*return*/
          ];
        });
      });
    };
    AsyncStorageAdapter2.prototype.initDb = function() {
      return __awaiter3(this, void 0, void 0, function() {
        var db;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              db = new AsyncStorageDatabase_default();
              return [4, db.init()];
            case 1:
              _a2.sent();
              return [2, db];
          }
        });
      });
    };
    AsyncStorageAdapter2.prototype.clear = function() {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this.db.clear()];
            case 1:
              _a2.sent();
              this.db = void 0;
              this.initPromise = void 0;
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AsyncStorageAdapter2.prototype.batchSave = function(modelConstructor, items) {
      return __awaiter3(this, void 0, void 0, function() {
        var modelName, namespaceName, storeName, keys, batch, _loop_1, this_1, items_1, items_1_1, item;
        var e_1, _a2;
        var _this = this;
        return __generator3(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              if (items.length === 0) {
                return [2, []];
              }
              modelName = modelConstructor.name;
              namespaceName = this.namespaceResolver(modelConstructor);
              storeName = getStorename(namespaceName, modelName);
              keys = getIndexKeys(this.schema.namespaces[namespaceName], modelName);
              batch = [];
              _loop_1 = function(item2) {
                var model = this_1.modelInstanceCreator(modelConstructor, item2);
                var connectedModels = traverseModel(modelName, model, this_1.schema.namespaces[namespaceName], this_1.modelInstanceCreator, this_1.getModelConstructorByModelName);
                var keyValuesPath = this_1.getIndexKeyValuesPath(model);
                var instance2 = connectedModels.find(function(_a3) {
                  var instance3 = _a3.instance;
                  var instanceKeyValuesPath = _this.getIndexKeyValuesPath(instance3);
                  return keysEqual([instanceKeyValuesPath], [keyValuesPath]);
                }).instance;
                batch.push(instance2);
              };
              this_1 = this;
              try {
                for (items_1 = __values4(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                  item = items_1_1.value;
                  _loop_1(item);
                }
              } catch (e_1_1) {
                e_1 = { error: e_1_1 };
              } finally {
                try {
                  if (items_1_1 && !items_1_1.done && (_a2 = items_1.return))
                    _a2.call(items_1);
                } finally {
                  if (e_1)
                    throw e_1.error;
                }
              }
              return [4, this.db.batchSave(storeName, batch, keys)];
            case 1:
              return [2, _b2.sent()];
          }
        });
      });
    };
    AsyncStorageAdapter2.prototype._get = function(storeName, keyArr) {
      return __awaiter3(this, void 0, void 0, function() {
        var itemKeyValuesPath;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              itemKeyValuesPath = keyArr.join(DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR);
              return [4, this.db.get(itemKeyValuesPath, storeName)];
            case 1:
              return [2, _a2.sent()];
          }
        });
      });
    };
    AsyncStorageAdapter2.prototype.save = function(model, condition) {
      var e_2, _a2;
      return __awaiter3(this, void 0, void 0, function() {
        var _b2, storeName, connectionStoreNames, modelKeyValues, fromDB, result, connectionStoreNames_1, connectionStoreNames_1_1, resItem, storeName_1, item, instance2, keys, itemKeyValues, fromDB_1, opType, e_2_1;
        return __generator3(this, function(_c) {
          switch (_c.label) {
            case 0:
              _b2 = this.saveMetadata(model), storeName = _b2.storeName, connectionStoreNames = _b2.connectionStoreNames, modelKeyValues = _b2.modelKeyValues;
              return [4, this._get(storeName, modelKeyValues)];
            case 1:
              fromDB = _c.sent();
              this.validateSaveCondition(condition, fromDB);
              result = [];
              _c.label = 2;
            case 2:
              _c.trys.push([2, 9, 10, 15]);
              connectionStoreNames_1 = __asyncValues(connectionStoreNames);
              _c.label = 3;
            case 3:
              return [4, connectionStoreNames_1.next()];
            case 4:
              if (!(connectionStoreNames_1_1 = _c.sent(), !connectionStoreNames_1_1.done))
                return [3, 8];
              resItem = connectionStoreNames_1_1.value;
              storeName_1 = resItem.storeName, item = resItem.item, instance2 = resItem.instance, keys = resItem.keys;
              itemKeyValues = keys.map(function(key) {
                return item[key];
              });
              return [4, this._get(storeName_1, itemKeyValues)];
            case 5:
              fromDB_1 = _c.sent();
              opType = fromDB_1 ? OpType.UPDATE : OpType.INSERT;
              if (!(keysEqual(itemKeyValues, modelKeyValues) || opType === OpType.INSERT))
                return [3, 7];
              return [4, this.db.save(item, storeName_1, keys, itemKeyValues.join(DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR))];
            case 6:
              _c.sent();
              result.push([instance2, opType]);
              _c.label = 7;
            case 7:
              return [3, 3];
            case 8:
              return [3, 15];
            case 9:
              e_2_1 = _c.sent();
              e_2 = { error: e_2_1 };
              return [3, 15];
            case 10:
              _c.trys.push([10, , 13, 14]);
              if (!(connectionStoreNames_1_1 && !connectionStoreNames_1_1.done && (_a2 = connectionStoreNames_1.return)))
                return [3, 12];
              return [4, _a2.call(connectionStoreNames_1)];
            case 11:
              _c.sent();
              _c.label = 12;
            case 12:
              return [3, 14];
            case 13:
              if (e_2)
                throw e_2.error;
              return [
                7
                /*endfinally*/
              ];
            case 14:
              return [
                7
                /*endfinally*/
              ];
            case 15:
              return [2, result];
          }
        });
      });
    };
    AsyncStorageAdapter2.prototype.query = function(modelConstructor, predicate, pagination) {
      return __awaiter3(this, void 0, void 0, function() {
        var _a2, storeName, namespaceName, queryByKey, predicates, hasSort, hasPagination, records;
        var _this = this;
        return __generator3(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              _a2 = this.queryMetadata(modelConstructor, predicate, pagination), storeName = _a2.storeName, namespaceName = _a2.namespaceName, queryByKey = _a2.queryByKey, predicates = _a2.predicates, hasSort = _a2.hasSort, hasPagination = _a2.hasPagination;
              return [4, function() {
                return __awaiter3(_this, void 0, void 0, function() {
                  var keyValues, record, filtered, all;
                  return __generator3(this, function(_a3) {
                    switch (_a3.label) {
                      case 0:
                        if (!queryByKey)
                          return [3, 2];
                        keyValues = queryByKey.join(DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR);
                        return [4, this.getByKey(storeName, keyValues)];
                      case 1:
                        record = _a3.sent();
                        return [2, record ? [record] : []];
                      case 2:
                        if (!predicates)
                          return [3, 4];
                        return [4, this.filterOnPredicate(storeName, predicates)];
                      case 3:
                        filtered = _a3.sent();
                        return [2, this.inMemoryPagination(filtered, pagination)];
                      case 4:
                        if (!(hasSort || hasPagination))
                          return [3, 6];
                        return [4, this.getAll(storeName)];
                      case 5:
                        all = _a3.sent();
                        return [2, this.inMemoryPagination(all, pagination)];
                      case 6:
                        return [2, this.getAll(storeName)];
                    }
                  });
                });
              }()];
            case 1:
              records = _b2.sent();
              return [4, this.load(namespaceName, modelConstructor.name, records)];
            case 2:
              return [2, _b2.sent()];
          }
        });
      });
    };
    AsyncStorageAdapter2.prototype.getByKey = function(storeName, keyValuePath) {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this.db.get(keyValuePath, storeName)];
            case 1:
              return [2, _a2.sent()];
          }
        });
      });
    };
    AsyncStorageAdapter2.prototype.getAll = function(storeName) {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this.db.getAll(storeName)];
            case 1:
              return [2, _a2.sent()];
          }
        });
      });
    };
    AsyncStorageAdapter2.prototype.filterOnPredicate = function(storeName, predicates) {
      return __awaiter3(this, void 0, void 0, function() {
        var predicateObjs, type, all, filtered;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              predicateObjs = predicates.predicates, type = predicates.type;
              return [4, this.getAll(storeName)];
            case 1:
              all = _a2.sent();
              filtered = predicateObjs ? all.filter(function(m2) {
                return validatePredicate(m2, type, predicateObjs);
              }) : all;
              return [2, filtered];
          }
        });
      });
    };
    AsyncStorageAdapter2.prototype.inMemoryPagination = function(records, pagination) {
      return inMemoryPagination(records, pagination);
    };
    AsyncStorageAdapter2.prototype.queryOne = function(modelConstructor, firstOrLast) {
      if (firstOrLast === void 0) {
        firstOrLast = QueryOne.FIRST;
      }
      return __awaiter3(this, void 0, void 0, function() {
        var storeName, result;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              storeName = this.getStorenameForModel(modelConstructor);
              return [4, this.db.getOne(firstOrLast, storeName)];
            case 1:
              result = _a2.sent();
              return [2, result && this.modelInstanceCreator(modelConstructor, result)];
          }
        });
      });
    };
    AsyncStorageAdapter2.prototype.deleteItem = function(deleteQueue) {
      var e_3, _a2, e_4, _b2;
      return __awaiter3(this, void 0, void 0, function() {
        var _c, _d, deleteItem, storeName, items, items_2, items_2_1, item, keyValuesPath, e_4_1, e_3_1;
        return __generator3(this, function(_e) {
          switch (_e.label) {
            case 0:
              _e.trys.push([0, 17, 18, 23]);
              _c = __asyncValues(deleteQueue);
              _e.label = 1;
            case 1:
              return [4, _c.next()];
            case 2:
              if (!(_d = _e.sent(), !_d.done))
                return [3, 16];
              deleteItem = _d.value;
              storeName = deleteItem.storeName, items = deleteItem.items;
              _e.label = 3;
            case 3:
              _e.trys.push([3, 9, 10, 15]);
              items_2 = __asyncValues(items);
              _e.label = 4;
            case 4:
              return [4, items_2.next()];
            case 5:
              if (!(items_2_1 = _e.sent(), !items_2_1.done))
                return [3, 8];
              item = items_2_1.value;
              if (!item)
                return [3, 7];
              if (!(typeof item === "object"))
                return [3, 7];
              keyValuesPath = this.getIndexKeyValuesPath(item);
              return [4, this.db.delete(keyValuesPath, storeName)];
            case 6:
              _e.sent();
              _e.label = 7;
            case 7:
              return [3, 4];
            case 8:
              return [3, 15];
            case 9:
              e_4_1 = _e.sent();
              e_4 = { error: e_4_1 };
              return [3, 15];
            case 10:
              _e.trys.push([10, , 13, 14]);
              if (!(items_2_1 && !items_2_1.done && (_b2 = items_2.return)))
                return [3, 12];
              return [4, _b2.call(items_2)];
            case 11:
              _e.sent();
              _e.label = 12;
            case 12:
              return [3, 14];
            case 13:
              if (e_4)
                throw e_4.error;
              return [
                7
                /*endfinally*/
              ];
            case 14:
              return [
                7
                /*endfinally*/
              ];
            case 15:
              return [3, 1];
            case 16:
              return [3, 23];
            case 17:
              e_3_1 = _e.sent();
              e_3 = { error: e_3_1 };
              return [3, 23];
            case 18:
              _e.trys.push([18, , 21, 22]);
              if (!(_d && !_d.done && (_a2 = _c.return)))
                return [3, 20];
              return [4, _a2.call(_c)];
            case 19:
              _e.sent();
              _e.label = 20;
            case 20:
              return [3, 22];
            case 21:
              if (e_3)
                throw e_3.error;
              return [
                7
                /*endfinally*/
              ];
            case 22:
              return [
                7
                /*endfinally*/
              ];
            case 23:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AsyncStorageAdapter2.prototype.getIndexKeyValuesPath = function(model) {
      return this.getIndexKeyValuesFromModel(model).join(DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR);
    };
    return AsyncStorageAdapter2;
  }(StorageAdapterBase)
);
var AsyncStorageAdapter_default = new AsyncStorageAdapter();

// node_modules/@aws-amplify/datastore/lib-esm/storage/adapter/getDefaultAdapter/index.js
var getDefaultAdapter = function() {
  var isBrowser3 = browserOrNode().isBrowser;
  if (isBrowser3 && window.indexedDB || isWebWorker() && self.indexedDB) {
    return IndexedDBAdapter_default;
  }
  return AsyncStorageAdapter_default;
};
var getDefaultAdapter_default = getDefaultAdapter;

// node_modules/@aws-amplify/datastore/lib-esm/storage/storage.js
var logger45 = new ConsoleLogger("DataStore");
var StorageClass = (
  /** @class */
  function() {
    function StorageClass2(schema2, namespaceResolver2, getModelConstructorByModelName2, modelInstanceCreator2, adapter, sessionId) {
      this.schema = schema2;
      this.namespaceResolver = namespaceResolver2;
      this.getModelConstructorByModelName = getModelConstructorByModelName2;
      this.modelInstanceCreator = modelInstanceCreator2;
      this.adapter = adapter;
      this.sessionId = sessionId;
      this.adapter = this.adapter || getDefaultAdapter_default();
      this.pushStream = new import_zen_push.default();
    }
    StorageClass2.getNamespace = function() {
      var namespace = {
        name: STORAGE,
        relationships: {},
        enums: {},
        models: {},
        nonModels: {}
      };
      return namespace;
    };
    StorageClass2.prototype.init = function() {
      return __awaiter3(this, void 0, void 0, function() {
        var resolve, reject;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (!(this.initialized !== void 0))
                return [3, 2];
              return [4, this.initialized];
            case 1:
              _a2.sent();
              return [
                2
                /*return*/
              ];
            case 2:
              logger45.debug("Starting Storage");
              this.initialized = new Promise(function(res, rej) {
                resolve = res;
                reject = rej;
              });
              this.adapter.setUp(this.schema, this.namespaceResolver, this.modelInstanceCreator, this.getModelConstructorByModelName, this.sessionId).then(resolve, reject);
              return [4, this.initialized];
            case 3:
              _a2.sent();
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    StorageClass2.prototype.save = function(model, condition, mutator, patchesTuple) {
      return __awaiter3(this, void 0, void 0, function() {
        var result;
        var _this = this;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this.init()];
            case 1:
              _a2.sent();
              if (!this.adapter) {
                throw new Error("Storage adapter is missing");
              }
              return [4, this.adapter.save(model, condition)];
            case 2:
              result = _a2.sent();
              result.forEach(function(r2) {
                var _a3 = __read10(r2, 2), savedElement = _a3[0], opType = _a3[1];
                var syncResponse = !!mutator;
                var updateMutationInput;
                if ((opType === OpType.UPDATE || opType === OpType.INSERT) && !syncResponse) {
                  updateMutationInput = _this.getChangedFieldsInput(model, savedElement, patchesTuple);
                  if (updateMutationInput === null) {
                    return result;
                  }
                }
                var element = updateMutationInput || savedElement;
                var modelConstructor = Object.getPrototypeOf(savedElement).constructor;
                _this.pushStream.next({
                  model: modelConstructor,
                  opType,
                  element,
                  mutator,
                  condition: condition && ModelPredicateCreator.getPredicates(condition, false) || null,
                  savedElement
                });
              });
              return [2, result];
          }
        });
      });
    };
    StorageClass2.prototype.delete = function(modelOrModelConstructor, condition, mutator) {
      return __awaiter3(this, void 0, void 0, function() {
        var models, deleted, modelConstructor, namespaceName, modelDefinition, modelIds;
        var _a2;
        var _this = this;
        return __generator3(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              return [4, this.init()];
            case 1:
              _b2.sent();
              if (!this.adapter) {
                throw new Error("Storage adapter is missing");
              }
              return [4, this.adapter.delete(modelOrModelConstructor, condition)];
            case 2:
              _a2 = __read10.apply(void 0, [_b2.sent(), 2]), models = _a2[0], deleted = _a2[1];
              modelConstructor = isModelConstructor(modelOrModelConstructor) ? modelOrModelConstructor : Object.getPrototypeOf(modelOrModelConstructor || {}).constructor;
              namespaceName = this.namespaceResolver(modelConstructor);
              modelDefinition = this.schema.namespaces[namespaceName].models[modelConstructor.name];
              modelIds = new Set(models.map(function(model) {
                var modelId = getIdentifierValue(modelDefinition, model);
                return modelId;
              }));
              if (!isModelConstructor(modelOrModelConstructor) && !Array.isArray(deleted)) {
                deleted = [deleted];
              }
              deleted.forEach(function(model) {
                var modelConstructor2 = Object.getPrototypeOf(model).constructor;
                var theCondition;
                if (!isModelConstructor(modelOrModelConstructor)) {
                  var modelId = getIdentifierValue(modelDefinition, model);
                  theCondition = modelIds.has(modelId) ? ModelPredicateCreator.getPredicates(condition, false) : void 0;
                }
                _this.pushStream.next({
                  model: modelConstructor2,
                  opType: OpType.DELETE,
                  element: model,
                  mutator,
                  condition: theCondition || null
                });
              });
              return [2, [models, deleted]];
          }
        });
      });
    };
    StorageClass2.prototype.query = function(modelConstructor, predicate, pagination) {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this.init()];
            case 1:
              _a2.sent();
              if (!this.adapter) {
                throw new Error("Storage adapter is missing");
              }
              return [4, this.adapter.query(modelConstructor, predicate, pagination)];
            case 2:
              return [2, _a2.sent()];
          }
        });
      });
    };
    StorageClass2.prototype.queryOne = function(modelConstructor, firstOrLast) {
      if (firstOrLast === void 0) {
        firstOrLast = QueryOne.FIRST;
      }
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this.init()];
            case 1:
              _a2.sent();
              if (!this.adapter) {
                throw new Error("Storage adapter is missing");
              }
              return [4, this.adapter.queryOne(modelConstructor, firstOrLast)];
            case 2:
              return [2, _a2.sent()];
          }
        });
      });
    };
    StorageClass2.prototype.observe = function(modelConstructor, predicate, skipOwn) {
      var listenToAll = !modelConstructor;
      var _a2 = predicate && ModelPredicateCreator.getPredicates(predicate, false) || {}, predicates = _a2.predicates, type = _a2.type;
      var result = this.pushStream.observable.filter(function(_a3) {
        var mutator = _a3.mutator;
        return !skipOwn || mutator !== skipOwn;
      }).map(function(_a3) {
        var _mutator = _a3.mutator, message = __rest2(_a3, ["mutator"]);
        return message;
      });
      if (!listenToAll) {
        result = result.filter(function(_a3) {
          var model = _a3.model, element = _a3.element;
          if (modelConstructor !== model) {
            return false;
          }
          if (!!predicates && !!type) {
            return validatePredicate(element, type, predicates);
          }
          return true;
        });
      }
      return result;
    };
    StorageClass2.prototype.clear = function(completeObservable) {
      if (completeObservable === void 0) {
        completeObservable = true;
      }
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              this.initialized = void 0;
              if (!this.adapter) {
                throw new Error("Storage adapter is missing");
              }
              return [4, this.adapter.clear()];
            case 1:
              _a2.sent();
              if (completeObservable) {
                this.pushStream.complete();
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    StorageClass2.prototype.batchSave = function(modelConstructor, items, mutator) {
      return __awaiter3(this, void 0, void 0, function() {
        var result;
        var _this = this;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this.init()];
            case 1:
              _a2.sent();
              if (!this.adapter) {
                throw new Error("Storage adapter is missing");
              }
              return [4, this.adapter.batchSave(modelConstructor, items)];
            case 2:
              result = _a2.sent();
              result.forEach(function(_a3) {
                var _b2 = __read10(_a3, 2), element = _b2[0], opType = _b2[1];
                _this.pushStream.next({
                  model: modelConstructor,
                  opType,
                  element,
                  mutator,
                  condition: null
                });
              });
              return [2, result];
          }
        });
      });
    };
    StorageClass2.prototype.getChangedFieldsInput = function(model, originalElement, patchesTuple) {
      var e_1, _a2;
      var _b2;
      var containsPatches = patchesTuple && patchesTuple.length;
      if (!containsPatches) {
        return null;
      }
      var _c = __read10(patchesTuple, 2), patches = _c[0], source = _c[1];
      var updatedElement = {};
      var updatedFields = patches.map(function(patch) {
        return patch.path && patch.path[0];
      });
      var modelConstructor = Object.getPrototypeOf(model).constructor;
      var namespace = this.namespaceResolver(modelConstructor);
      var fields = this.schema.namespaces[namespace].models[modelConstructor.name].fields;
      var _d = ((_b2 = this.schema.namespaces[namespace].keys) === null || _b2 === void 0 ? void 0 : _b2[modelConstructor.name]) || {}, primaryKey = _d.primaryKey, _e = _d.compositeKeys, compositeKeys = _e === void 0 ? [] : _e;
      updatedFields.forEach(function(field) {
        var e_2, _a3, e_3, _b3, e_4, _c2, e_5, _d2, e_6, _e2;
        var _f;
        var targetNames = isTargetNameAssociation((_f = fields[field]) === null || _f === void 0 ? void 0 : _f.association);
        if (Array.isArray(targetNames)) {
          try {
            for (var targetNames_1 = __values4(targetNames), targetNames_1_1 = targetNames_1.next(); !targetNames_1_1.done; targetNames_1_1 = targetNames_1.next()) {
              var targetName = targetNames_1_1.value;
              if (!valuesEqual(source[targetName], originalElement[targetName])) {
                updatedElement[targetName] = originalElement[targetName] === void 0 ? null : originalElement[targetName];
                try {
                  for (var compositeKeys_1 = (e_3 = void 0, __values4(compositeKeys)), compositeKeys_1_1 = compositeKeys_1.next(); !compositeKeys_1_1.done; compositeKeys_1_1 = compositeKeys_1.next()) {
                    var fieldSet = compositeKeys_1_1.value;
                    if (fieldSet.has(targetName)) {
                      try {
                        for (var fieldSet_1 = (e_4 = void 0, __values4(fieldSet)), fieldSet_1_1 = fieldSet_1.next(); !fieldSet_1_1.done; fieldSet_1_1 = fieldSet_1.next()) {
                          var compositeField = fieldSet_1_1.value;
                          updatedElement[compositeField] = originalElement[compositeField];
                        }
                      } catch (e_4_1) {
                        e_4 = { error: e_4_1 };
                      } finally {
                        try {
                          if (fieldSet_1_1 && !fieldSet_1_1.done && (_c2 = fieldSet_1.return))
                            _c2.call(fieldSet_1);
                        } finally {
                          if (e_4)
                            throw e_4.error;
                        }
                      }
                    }
                  }
                } catch (e_3_1) {
                  e_3 = { error: e_3_1 };
                } finally {
                  try {
                    if (compositeKeys_1_1 && !compositeKeys_1_1.done && (_b3 = compositeKeys_1.return))
                      _b3.call(compositeKeys_1);
                  } finally {
                    if (e_3)
                      throw e_3.error;
                  }
                }
              }
            }
          } catch (e_2_1) {
            e_2 = { error: e_2_1 };
          } finally {
            try {
              if (targetNames_1_1 && !targetNames_1_1.done && (_a3 = targetNames_1.return))
                _a3.call(targetNames_1);
            } finally {
              if (e_2)
                throw e_2.error;
            }
          }
        } else {
          var key = targetNames || field;
          if (!valuesEqual(source[key], originalElement[key])) {
            updatedElement[key] = originalElement[key] === void 0 ? null : originalElement[key];
            try {
              for (var compositeKeys_2 = __values4(compositeKeys), compositeKeys_2_1 = compositeKeys_2.next(); !compositeKeys_2_1.done; compositeKeys_2_1 = compositeKeys_2.next()) {
                var fieldSet = compositeKeys_2_1.value;
                if (fieldSet.has(key)) {
                  try {
                    for (var fieldSet_2 = (e_6 = void 0, __values4(fieldSet)), fieldSet_2_1 = fieldSet_2.next(); !fieldSet_2_1.done; fieldSet_2_1 = fieldSet_2.next()) {
                      var compositeField = fieldSet_2_1.value;
                      updatedElement[compositeField] = originalElement[compositeField];
                    }
                  } catch (e_6_1) {
                    e_6 = { error: e_6_1 };
                  } finally {
                    try {
                      if (fieldSet_2_1 && !fieldSet_2_1.done && (_e2 = fieldSet_2.return))
                        _e2.call(fieldSet_2);
                    } finally {
                      if (e_6)
                        throw e_6.error;
                    }
                  }
                }
              }
            } catch (e_5_1) {
              e_5 = { error: e_5_1 };
            } finally {
              try {
                if (compositeKeys_2_1 && !compositeKeys_2_1.done && (_d2 = compositeKeys_2.return))
                  _d2.call(compositeKeys_2);
              } finally {
                if (e_5)
                  throw e_5.error;
              }
            }
          }
        }
      });
      if (Object.keys(updatedElement).length === 0) {
        return null;
      }
      if (primaryKey && primaryKey.length) {
        try {
          for (var primaryKey_1 = __values4(primaryKey), primaryKey_1_1 = primaryKey_1.next(); !primaryKey_1_1.done; primaryKey_1_1 = primaryKey_1.next()) {
            var pkField = primaryKey_1_1.value;
            updatedElement[pkField] = originalElement[pkField];
          }
        } catch (e_1_1) {
          e_1 = { error: e_1_1 };
        } finally {
          try {
            if (primaryKey_1_1 && !primaryKey_1_1.done && (_a2 = primaryKey_1.return))
              _a2.call(primaryKey_1);
          } finally {
            if (e_1)
              throw e_1.error;
          }
        }
      }
      var id = originalElement.id, _version = originalElement._version, _lastChangedAt = originalElement._lastChangedAt, _deleted = originalElement._deleted;
      return __assign7(__assign7({}, updatedElement), {
        id,
        _version,
        _lastChangedAt,
        _deleted
      });
    };
    return StorageClass2;
  }()
);
var ExclusiveStorage = (
  /** @class */
  function() {
    function ExclusiveStorage2(schema2, namespaceResolver2, getModelConstructorByModelName2, modelInstanceCreator2, adapter, sessionId) {
      this.mutex = new Mutex_default();
      this.storage = new StorageClass(schema2, namespaceResolver2, getModelConstructorByModelName2, modelInstanceCreator2, adapter, sessionId);
    }
    ExclusiveStorage2.prototype.runExclusive = function(fn2) {
      return this.mutex.runExclusive(fn2.bind(this, this.storage));
    };
    ExclusiveStorage2.prototype.save = function(model, condition, mutator, patchesTuple) {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          return [2, this.runExclusive(function(storage) {
            return storage.save(model, condition, mutator, patchesTuple);
          })];
        });
      });
    };
    ExclusiveStorage2.prototype.delete = function(modelOrModelConstructor, condition, mutator) {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          return [2, this.runExclusive(function(storage) {
            if (isModelConstructor(modelOrModelConstructor)) {
              var modelConstructor = modelOrModelConstructor;
              return storage.delete(modelConstructor, condition, mutator);
            } else {
              var model = modelOrModelConstructor;
              return storage.delete(model, condition, mutator);
            }
          })];
        });
      });
    };
    ExclusiveStorage2.prototype.query = function(modelConstructor, predicate, pagination) {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          return [2, this.runExclusive(function(storage) {
            return storage.query(modelConstructor, predicate, pagination);
          })];
        });
      });
    };
    ExclusiveStorage2.prototype.queryOne = function(modelConstructor, firstOrLast) {
      if (firstOrLast === void 0) {
        firstOrLast = QueryOne.FIRST;
      }
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          return [2, this.runExclusive(function(storage) {
            return storage.queryOne(modelConstructor, firstOrLast);
          })];
        });
      });
    };
    ExclusiveStorage2.getNamespace = function() {
      return StorageClass.getNamespace();
    };
    ExclusiveStorage2.prototype.observe = function(modelConstructor, predicate, skipOwn) {
      return this.storage.observe(modelConstructor, predicate, skipOwn);
    };
    ExclusiveStorage2.prototype.clear = function() {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this.runExclusive(function(storage) {
                return storage.clear();
              })];
            case 1:
              _a2.sent();
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    ExclusiveStorage2.prototype.batchSave = function(modelConstructor, items) {
      return this.storage.batchSave(modelConstructor, items);
    };
    ExclusiveStorage2.prototype.init = function() {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          return [2, this.storage.init()];
        });
      });
    };
    return ExclusiveStorage2;
  }()
);

// node_modules/@aws-amplify/pubsub/lib-esm/PubSub.js
var PubSubClass = (
  /** @class */
  function(_super) {
    __extends10(PubSubClass2, _super);
    function PubSubClass2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    PubSubClass2.prototype.getModuleName = function() {
      return "PubSub";
    };
    PubSubClass2.prototype.subscribe = function(topics, options) {
      return _super.prototype.subscribe.call(this, topics, options);
    };
    return PubSubClass2;
  }(InternalPubSubClass)
);
var PubSub = new PubSubClass();
Amplify.register(PubSub);

// node_modules/@aws-amplify/datastore/lib-esm/sync/datastoreReachability/index.js
var ReachabilityMonitor2 = new Reachability_default().networkMonitor();

// node_modules/@aws-amplify/datastore/lib-esm/sync/datastoreConnectivity.js
var logger46 = new ConsoleLogger("DataStore");
var RECONNECTING_IN = 5e3;
var DataStoreConnectivity = (
  /** @class */
  function() {
    function DataStoreConnectivity2() {
      this.connectionStatus = {
        online: false
      };
    }
    DataStoreConnectivity2.prototype.status = function() {
      var _this = this;
      if (this.observer) {
        throw new Error("Subscriber already exists");
      }
      return new bundle_esm_default(function(observer) {
        _this.observer = observer;
        _this.subscription = ReachabilityMonitor2.subscribe(function(_a2) {
          var online = _a2.online;
          _this.connectionStatus.online = online;
          var observerResult = __assign7({}, _this.connectionStatus);
          observer.next(observerResult);
        });
        return function() {
          clearTimeout(_this.timeout);
          _this.unsubscribe();
        };
      });
    };
    DataStoreConnectivity2.prototype.unsubscribe = function() {
      if (this.subscription) {
        clearTimeout(this.timeout);
        this.subscription.unsubscribe();
      }
    };
    DataStoreConnectivity2.prototype.stop = function() {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          this.unsubscribe();
          return [
            2
            /*return*/
          ];
        });
      });
    };
    DataStoreConnectivity2.prototype.socketDisconnected = function() {
      var _this = this;
      if (this.observer && typeof this.observer.next === "function") {
        this.observer.next({ online: false });
        this.timeout = setTimeout(function() {
          var observerResult = __assign7({}, _this.connectionStatus);
          _this.observer.next(observerResult);
        }, RECONNECTING_IN);
      }
    };
    return DataStoreConnectivity2;
  }()
);
var datastoreConnectivity_default = DataStoreConnectivity;

// node_modules/@aws-amplify/datastore/lib-esm/sync/merger.js
var ModelMerger = (
  /** @class */
  function() {
    function ModelMerger2(outbox, ownSymbol2) {
      this.outbox = outbox;
      this.ownSymbol = ownSymbol2;
    }
    ModelMerger2.prototype.merge = function(storage, model, modelDefinition) {
      return __awaiter3(this, void 0, void 0, function() {
        var result, mutationsForModel, isDelete;
        var _a2, _b2;
        return __generator3(this, function(_c) {
          switch (_c.label) {
            case 0:
              return [4, this.outbox.getForModel(storage, model, modelDefinition)];
            case 1:
              mutationsForModel = _c.sent();
              isDelete = model._deleted;
              if (!(mutationsForModel.length === 0))
                return [3, 5];
              if (!isDelete)
                return [3, 3];
              result = OpType.DELETE;
              return [4, storage.delete(model, void 0, this.ownSymbol)];
            case 2:
              _c.sent();
              return [3, 5];
            case 3:
              return [4, storage.save(model, void 0, this.ownSymbol)];
            case 4:
              _a2 = __read10.apply(void 0, [_c.sent(), 1]), _b2 = __read10(_a2[0], 2), result = _b2[1];
              _c.label = 5;
            case 5:
              return [2, result];
          }
        });
      });
    };
    ModelMerger2.prototype.mergePage = function(storage, modelConstructor, items, modelDefinition) {
      return __awaiter3(this, void 0, void 0, function() {
        var itemsMap, items_1, items_1_1, item, modelId, page;
        var e_1, _a2;
        return __generator3(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              itemsMap = /* @__PURE__ */ new Map();
              try {
                for (items_1 = __values4(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                  item = items_1_1.value;
                  modelId = getIdentifierValue(modelDefinition, item);
                  itemsMap.set(modelId, item);
                }
              } catch (e_1_1) {
                e_1 = { error: e_1_1 };
              } finally {
                try {
                  if (items_1_1 && !items_1_1.done && (_a2 = items_1.return))
                    _a2.call(items_1);
                } finally {
                  if (e_1)
                    throw e_1.error;
                }
              }
              page = __spread(itemsMap.values());
              return [4, storage.batchSave(modelConstructor, page, this.ownSymbol)];
            case 1:
              return [2, _b2.sent()];
          }
        });
      });
    };
    return ModelMerger2;
  }()
);

// node_modules/@aws-amplify/datastore/lib-esm/sync/outbox.js
var MutationEventOutbox = (
  /** @class */
  function() {
    function MutationEventOutbox2(schema2, MutationEvent, modelInstanceCreator2, ownSymbol2) {
      this.schema = schema2;
      this.MutationEvent = MutationEvent;
      this.modelInstanceCreator = modelInstanceCreator2;
      this.ownSymbol = ownSymbol2;
    }
    MutationEventOutbox2.prototype.enqueue = function(storage, mutationEvent) {
      return __awaiter3(this, void 0, void 0, function() {
        var _this = this;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, storage.runExclusive(function(s2) {
                return __awaiter3(_this, void 0, void 0, function() {
                  var mutationEventModelDefinition, predicate, _a3, first, incomingMutationType, merged_1, incomingConditionJSON, incomingCondition, merged;
                  return __generator3(this, function(_b2) {
                    switch (_b2.label) {
                      case 0:
                        mutationEventModelDefinition = this.schema.namespaces[SYNC].models["MutationEvent"];
                        predicate = ModelPredicateCreator.createFromAST(mutationEventModelDefinition, {
                          and: [
                            { modelId: { eq: mutationEvent.modelId } },
                            { id: { ne: this.inProgressMutationEventId } }
                          ]
                        });
                        return [4, s2.query(this.MutationEvent, predicate)];
                      case 1:
                        _a3 = __read10.apply(void 0, [_b2.sent(), 1]), first = _a3[0];
                        if (!(first === void 0))
                          return [3, 3];
                        return [4, s2.save(mutationEvent, void 0, this.ownSymbol)];
                      case 2:
                        _b2.sent();
                        return [
                          2
                          /*return*/
                        ];
                      case 3:
                        incomingMutationType = mutationEvent.operation;
                        if (!(first.operation === TransformerMutationType.CREATE))
                          return [3, 8];
                        if (!(incomingMutationType === TransformerMutationType.DELETE))
                          return [3, 5];
                        return [4, s2.delete(this.MutationEvent, predicate)];
                      case 4:
                        _b2.sent();
                        return [3, 7];
                      case 5:
                        merged_1 = this.mergeUserFields(first, mutationEvent);
                        return [4, s2.save(this.MutationEvent.copyOf(first, function(draft) {
                          draft.data = merged_1.data;
                        }), void 0, this.ownSymbol)];
                      case 6:
                        _b2.sent();
                        _b2.label = 7;
                      case 7:
                        return [3, 12];
                      case 8:
                        incomingConditionJSON = mutationEvent.condition;
                        incomingCondition = JSON.parse(incomingConditionJSON);
                        merged = void 0;
                        if (!(Object.keys(incomingCondition).length === 0))
                          return [3, 10];
                        merged = this.mergeUserFields(first, mutationEvent);
                        return [4, s2.delete(this.MutationEvent, predicate)];
                      case 9:
                        _b2.sent();
                        _b2.label = 10;
                      case 10:
                        merged = merged || mutationEvent;
                        return [4, s2.save(merged, void 0, this.ownSymbol)];
                      case 11:
                        _b2.sent();
                        _b2.label = 12;
                      case 12:
                        return [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              })];
            case 1:
              _a2.sent();
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    MutationEventOutbox2.prototype.dequeue = function(storage, record, recordOp) {
      return __awaiter3(this, void 0, void 0, function() {
        var head;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this.peek(storage)];
            case 1:
              head = _a2.sent();
              if (!record)
                return [3, 3];
              return [4, this.syncOutboxVersionsOnDequeue(storage, record, head, recordOp)];
            case 2:
              _a2.sent();
              _a2.label = 3;
            case 3:
              return [4, storage.delete(head)];
            case 4:
              _a2.sent();
              this.inProgressMutationEventId = void 0;
              return [2, head];
          }
        });
      });
    };
    MutationEventOutbox2.prototype.peek = function(storage) {
      return __awaiter3(this, void 0, void 0, function() {
        var head;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, storage.queryOne(this.MutationEvent, QueryOne.FIRST)];
            case 1:
              head = _a2.sent();
              this.inProgressMutationEventId = head ? head.id : void 0;
              return [2, head];
          }
        });
      });
    };
    MutationEventOutbox2.prototype.getForModel = function(storage, model, userModelDefinition) {
      return __awaiter3(this, void 0, void 0, function() {
        var mutationEventModelDefinition, modelId, mutationEvents;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              mutationEventModelDefinition = this.schema.namespaces[SYNC].models.MutationEvent;
              modelId = getIdentifierValue(userModelDefinition, model);
              return [4, storage.query(this.MutationEvent, ModelPredicateCreator.createFromAST(mutationEventModelDefinition, {
                and: { modelId: { eq: modelId } }
              }))];
            case 1:
              mutationEvents = _a2.sent();
              return [2, mutationEvents];
          }
        });
      });
    };
    MutationEventOutbox2.prototype.getModelIds = function(storage) {
      return __awaiter3(this, void 0, void 0, function() {
        var mutationEvents, result;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, storage.query(this.MutationEvent)];
            case 1:
              mutationEvents = _a2.sent();
              result = /* @__PURE__ */ new Set();
              mutationEvents.forEach(function(_a3) {
                var modelId = _a3.modelId;
                return result.add(modelId);
              });
              return [2, result];
          }
        });
      });
    };
    MutationEventOutbox2.prototype.syncOutboxVersionsOnDequeue = function(storage, record, head, recordOp) {
      return __awaiter3(this, void 0, void 0, function() {
        var _version, _lastChangedAt, _deleted, _incomingData, incomingData, data, __version, __lastChangedAt, __deleted, _outgoingData, outgoingData, mutationEventModelDefinition, userModelDefinition, recordId, predicate, outdatedMutations, reconciledMutations;
        var _this = this;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (head.operation !== recordOp) {
                return [
                  2
                  /*return*/
                ];
              }
              _version = record._version, _lastChangedAt = record._lastChangedAt, _deleted = record._deleted, _incomingData = __rest2(record, ["_version", "_lastChangedAt", "_deleted"]);
              incomingData = this.removeTimestampFields(head.model, _incomingData);
              data = JSON.parse(head.data);
              if (!data) {
                return [
                  2
                  /*return*/
                ];
              }
              __version = data._version, __lastChangedAt = data._lastChangedAt, __deleted = data._deleted, _outgoingData = __rest2(data, ["_version", "_lastChangedAt", "_deleted"]);
              outgoingData = this.removeTimestampFields(head.model, _outgoingData);
              if (!valuesEqual(incomingData, outgoingData, true)) {
                return [
                  2
                  /*return*/
                ];
              }
              mutationEventModelDefinition = this.schema.namespaces[SYNC].models["MutationEvent"];
              userModelDefinition = this.schema.namespaces["user"].models[head.model];
              recordId = getIdentifierValue(userModelDefinition, record);
              predicate = ModelPredicateCreator.createFromAST(mutationEventModelDefinition, {
                and: [
                  { modelId: { eq: recordId } },
                  { id: { ne: this.inProgressMutationEventId } }
                ]
              });
              return [4, storage.query(this.MutationEvent, predicate)];
            case 1:
              outdatedMutations = _a2.sent();
              if (!outdatedMutations.length) {
                return [
                  2
                  /*return*/
                ];
              }
              reconciledMutations = outdatedMutations.map(function(m2) {
                var oldData = JSON.parse(m2.data);
                var newData = __assign7(__assign7({}, oldData), { _version, _lastChangedAt });
                return _this.MutationEvent.copyOf(m2, function(draft) {
                  draft.data = JSON.stringify(newData);
                });
              });
              return [4, storage.delete(this.MutationEvent, predicate)];
            case 2:
              _a2.sent();
              return [4, Promise.all(reconciledMutations.map(function(m2) {
                return __awaiter3(_this, void 0, void 0, function() {
                  return __generator3(this, function(_a3) {
                    switch (_a3.label) {
                      case 0:
                        return [4, storage.save(m2, void 0, this.ownSymbol)];
                      case 1:
                        return [2, _a3.sent()];
                    }
                  });
                });
              }))];
            case 3:
              _a2.sent();
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    MutationEventOutbox2.prototype.mergeUserFields = function(previous, current) {
      var _a2 = JSON.parse(previous.data), _version = _a2._version, _lastChangedAt = _a2._lastChangedAt, _deleted = _a2._deleted, previousData = __rest2(_a2, ["_version", "_lastChangedAt", "_deleted"]);
      var _b2 = JSON.parse(current.data), __version = _b2._version, __lastChangedAt = _b2._lastChangedAt, __deleted = _b2._deleted, currentData = __rest2(_b2, ["_version", "_lastChangedAt", "_deleted"]);
      var data = JSON.stringify(__assign7(__assign7({
        _version,
        _lastChangedAt,
        _deleted
      }, previousData), currentData));
      return this.modelInstanceCreator(this.MutationEvent, __assign7(__assign7({}, current), { data }));
    };
    MutationEventOutbox2.prototype.removeTimestampFields = function(model, record) {
      var _a2, _b2;
      var CREATED_AT_DEFAULT_KEY = "createdAt";
      var UPDATED_AT_DEFAULT_KEY = "updatedAt";
      var createdTimestampKey = CREATED_AT_DEFAULT_KEY;
      var updatedTimestampKey = UPDATED_AT_DEFAULT_KEY;
      var modelAttributes = (_a2 = this.schema.namespaces[USER].models[model].attributes) === null || _a2 === void 0 ? void 0 : _a2.find(function(attr) {
        return attr.type === "model";
      });
      var timestampFieldsMap = (_b2 = modelAttributes === null || modelAttributes === void 0 ? void 0 : modelAttributes.properties) === null || _b2 === void 0 ? void 0 : _b2.timestamps;
      if (timestampFieldsMap) {
        createdTimestampKey = timestampFieldsMap[CREATED_AT_DEFAULT_KEY];
        updatedTimestampKey = timestampFieldsMap[UPDATED_AT_DEFAULT_KEY];
      }
      delete record[createdTimestampKey];
      delete record[updatedTimestampKey];
      return record;
    };
    return MutationEventOutbox2;
  }()
);

// node_modules/@aws-amplify/datastore/lib-esm/sync/processors/errorMaps.js
var connectionTimeout = function(error) {
  return /^Connection failed: Connection Timeout/.test(error.message);
};
var serverError = function(error) {
  return /^Error: Request failed with status code 5\d\d/.test(error.message);
};
var mutationErrorMap = {
  BadModel: function() {
    return false;
  },
  BadRecord: function(error) {
    var message = error.message;
    return /^Cannot return \w+ for [\w-_]+ type/.test(message) || /^Variable '.+' has coerced Null value for NonNull type/.test(message);
  },
  ConfigError: function() {
    return false;
  },
  Transient: function(error) {
    return connectionTimeout(error) || serverError(error);
  },
  Unauthorized: function(error) {
    return error.message === "Unauthorized" || /^Request failed with status code 401/.test(error.message);
  }
};
var subscriptionErrorMap = {
  BadModel: function() {
    return false;
  },
  BadRecord: function() {
    return false;
  },
  ConfigError: function() {
    return false;
  },
  Transient: function(observableError) {
    var error = unwrapObservableError(observableError);
    return connectionTimeout(error) || serverError(error);
  },
  Unauthorized: function(observableError) {
    var error = unwrapObservableError(observableError);
    return /Connection failed.+Unauthorized/.test(error.message);
  }
};
var syncErrorMap = {
  BadModel: function() {
    return false;
  },
  BadRecord: function(error) {
    return /^Cannot return \w+ for [\w-_]+ type/.test(error.message);
  },
  ConfigError: function() {
    return false;
  },
  Transient: function(error) {
    return connectionTimeout(error) || serverError(error);
  },
  Unauthorized: function(error) {
    return error.errorType === "Unauthorized";
  }
};
function unwrapObservableError(observableError) {
  var _a2 = observableError.error, _b2 = __read10((_a2 === void 0 ? {
    errors: []
  } : _a2).errors, 1), error = _b2[0];
  return error;
}
function getMutationErrorType(error) {
  return mapErrorToType(mutationErrorMap, error);
}
function getSubscriptionErrorType(error) {
  return mapErrorToType(subscriptionErrorMap, error);
}
function getSyncErrorType(error) {
  return mapErrorToType(syncErrorMap, error);
}
function mapErrorToType(errorMap, error) {
  var e_1, _a2;
  var errorTypes = __spread(Object.keys(errorMap));
  try {
    for (var errorTypes_1 = __values4(errorTypes), errorTypes_1_1 = errorTypes_1.next(); !errorTypes_1_1.done; errorTypes_1_1 = errorTypes_1.next()) {
      var errorType = errorTypes_1_1.value;
      var matcher = errorMap[errorType];
      if (matcher === null || matcher === void 0 ? void 0 : matcher(error)) {
        return errorType;
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (errorTypes_1_1 && !errorTypes_1_1.done && (_a2 = errorTypes_1.return))
        _a2.call(errorTypes_1);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return "Unknown";
}

// node_modules/@aws-amplify/datastore/lib-esm/sync/processors/mutation.js
var MAX_ATTEMPTS = 10;
var logger47 = new ConsoleLogger("DataStore");
var MutationProcessor = (
  /** @class */
  function() {
    function MutationProcessor2(schema2, storage, userClasses2, outbox, modelInstanceCreator2, MutationEvent, amplifyConfig, authModeStrategy, errorHandler, conflictHandler, amplifyContext) {
      if (amplifyConfig === void 0) {
        amplifyConfig = {};
      }
      this.schema = schema2;
      this.storage = storage;
      this.userClasses = userClasses2;
      this.outbox = outbox;
      this.modelInstanceCreator = modelInstanceCreator2;
      this.MutationEvent = MutationEvent;
      this.amplifyConfig = amplifyConfig;
      this.authModeStrategy = authModeStrategy;
      this.errorHandler = errorHandler;
      this.conflictHandler = conflictHandler;
      this.amplifyContext = amplifyContext;
      this.typeQuery = /* @__PURE__ */ new WeakMap();
      this.processing = false;
      this.runningProcesses = new BackgroundProcessManager();
      this.amplifyContext.InternalAPI = this.amplifyContext.InternalAPI || InternalAPI;
      this.generateQueries();
    }
    MutationProcessor2.prototype.generateQueries = function() {
      var _this = this;
      Object.values(this.schema.namespaces).forEach(function(namespace) {
        Object.values(namespace.models).filter(function(_a2) {
          var syncable = _a2.syncable;
          return syncable;
        }).forEach(function(model) {
          var _a2 = __read10(buildGraphQLOperation(namespace, model, "CREATE"), 1), createMutation = _a2[0];
          var _b2 = __read10(buildGraphQLOperation(namespace, model, "UPDATE"), 1), updateMutation = _b2[0];
          var _c = __read10(buildGraphQLOperation(namespace, model, "DELETE"), 1), deleteMutation = _c[0];
          _this.typeQuery.set(model, [
            createMutation,
            updateMutation,
            deleteMutation
          ]);
        });
      });
    };
    MutationProcessor2.prototype.isReady = function() {
      return this.observer !== void 0;
    };
    MutationProcessor2.prototype.start = function() {
      var _this = this;
      this.runningProcesses = new BackgroundProcessManager();
      var observable = new bundle_esm_default(function(observer) {
        _this.observer = observer;
        try {
          _this.resume();
        } catch (error) {
          logger47.error("mutations processor start error", error);
          throw error;
        }
        return _this.runningProcesses.addCleaner(function() {
          return __awaiter3(_this, void 0, void 0, function() {
            return __generator3(this, function(_a2) {
              this.removeObserver();
              this.pause();
              return [
                2
                /*return*/
              ];
            });
          });
        });
      });
      return observable;
    };
    MutationProcessor2.prototype.stop = function() {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              this.removeObserver();
              return [4, this.runningProcesses.close()];
            case 1:
              _a2.sent();
              return [4, this.runningProcesses.open()];
            case 2:
              _a2.sent();
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    MutationProcessor2.prototype.removeObserver = function() {
      var _a2, _b2;
      (_b2 = (_a2 = this.observer) === null || _a2 === void 0 ? void 0 : _a2.complete) === null || _b2 === void 0 ? void 0 : _b2.call(_a2);
      this.observer = void 0;
    };
    MutationProcessor2.prototype.resume = function() {
      return __awaiter3(this, void 0, void 0, function() {
        var _this = this;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this.runningProcesses.isOpen && this.runningProcesses.add(function(onTerminate) {
                return __awaiter3(_this, void 0, void 0, function() {
                  var head, namespaceName, _loop_1, this_1, _a3;
                  var _this2 = this;
                  var _b2, _c;
                  return __generator3(this, function(_d) {
                    switch (_d.label) {
                      case 0:
                        if (this.processing || !this.isReady() || !this.runningProcesses.isOpen) {
                          return [
                            2
                            /*return*/
                          ];
                        }
                        this.processing = true;
                        namespaceName = USER;
                        _loop_1 = function() {
                          var model, operation, data, condition, modelConstructor, result, opName, modelDefinition, modelAuthModes, operationAuthModes_1, authModeAttempts_1, authModeRetry_1, error_1, record, hasMore;
                          var _a4;
                          return __generator3(this, function(_b3) {
                            switch (_b3.label) {
                              case 0:
                                model = head.model, operation = head.operation, data = head.data, condition = head.condition;
                                modelConstructor = this_1.userClasses[model];
                                result = void 0;
                                opName = void 0;
                                modelDefinition = void 0;
                                _b3.label = 1;
                              case 1:
                                _b3.trys.push([1, 4, , 5]);
                                return [4, getModelAuthModes({
                                  authModeStrategy: this_1.authModeStrategy,
                                  defaultAuthMode: this_1.amplifyConfig.aws_appsync_authenticationType,
                                  modelName: model,
                                  schema: this_1.schema
                                })];
                              case 2:
                                modelAuthModes = _b3.sent();
                                operationAuthModes_1 = modelAuthModes[operation.toUpperCase()];
                                authModeAttempts_1 = 0;
                                authModeRetry_1 = function() {
                                  return __awaiter3(_this2, void 0, void 0, function() {
                                    var response, error_2, e_1;
                                    return __generator3(this, function(_a5) {
                                      switch (_a5.label) {
                                        case 0:
                                          _a5.trys.push([0, 2, , 9]);
                                          logger47.debug("Attempting mutation with authMode: " + operationAuthModes_1[authModeAttempts_1]);
                                          return [4, this.jitteredRetry(namespaceName, model, operation, data, condition, modelConstructor, this.MutationEvent, head, operationAuthModes_1[authModeAttempts_1], onTerminate)];
                                        case 1:
                                          response = _a5.sent();
                                          logger47.debug("Mutation sent successfully with authMode: " + operationAuthModes_1[authModeAttempts_1]);
                                          return [2, response];
                                        case 2:
                                          error_2 = _a5.sent();
                                          authModeAttempts_1++;
                                          if (!(authModeAttempts_1 >= operationAuthModes_1.length))
                                            return [3, 7];
                                          logger47.debug("Mutation failed with authMode: " + operationAuthModes_1[authModeAttempts_1 - 1]);
                                          _a5.label = 3;
                                        case 3:
                                          _a5.trys.push([3, 5, , 6]);
                                          return [4, this.errorHandler({
                                            recoverySuggestion: "Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues",
                                            localModel: null,
                                            message: error_2.message,
                                            model: modelConstructor.name,
                                            operation: opName,
                                            errorType: getMutationErrorType(error_2),
                                            process: ProcessName.sync,
                                            remoteModel: null,
                                            cause: error_2
                                          })];
                                        case 4:
                                          _a5.sent();
                                          return [3, 6];
                                        case 5:
                                          e_1 = _a5.sent();
                                          logger47.error("Mutation error handler failed with:", e_1);
                                          return [3, 6];
                                        case 6:
                                          throw error_2;
                                        case 7:
                                          logger47.debug("Mutation failed with authMode: " + operationAuthModes_1[authModeAttempts_1 - 1] + ". Retrying with authMode: " + operationAuthModes_1[authModeAttempts_1]);
                                          return [4, authModeRetry_1()];
                                        case 8:
                                          return [2, _a5.sent()];
                                        case 9:
                                          return [
                                            2
                                            /*return*/
                                          ];
                                      }
                                    });
                                  });
                                };
                                return [4, authModeRetry_1()];
                              case 3:
                                _a4 = __read10.apply(void 0, [_b3.sent(), 3]), result = _a4[0], opName = _a4[1], modelDefinition = _a4[2];
                                return [3, 5];
                              case 4:
                                error_1 = _b3.sent();
                                if (error_1.message === "Offline" || error_1.message === "RetryMutation") {
                                  return [2, "continue"];
                                }
                                return [3, 5];
                              case 5:
                                if (!(result === void 0))
                                  return [3, 7];
                                logger47.debug("done retrying");
                                return [4, this_1.storage.runExclusive(function(storage) {
                                  return __awaiter3(_this2, void 0, void 0, function() {
                                    return __generator3(this, function(_a5) {
                                      switch (_a5.label) {
                                        case 0:
                                          return [4, this.outbox.dequeue(storage)];
                                        case 1:
                                          _a5.sent();
                                          return [
                                            2
                                            /*return*/
                                          ];
                                      }
                                    });
                                  });
                                })];
                              case 6:
                                _b3.sent();
                                return [2, "continue"];
                              case 7:
                                record = result.data[opName];
                                hasMore = false;
                                return [4, this_1.storage.runExclusive(function(storage) {
                                  return __awaiter3(_this2, void 0, void 0, function() {
                                    return __generator3(this, function(_a5) {
                                      switch (_a5.label) {
                                        case 0:
                                          return [4, this.outbox.dequeue(storage, record, operation)];
                                        case 1:
                                          _a5.sent();
                                          return [4, this.outbox.peek(storage)];
                                        case 2:
                                          hasMore = _a5.sent() !== void 0;
                                          return [
                                            2
                                            /*return*/
                                          ];
                                      }
                                    });
                                  });
                                })];
                              case 8:
                                _b3.sent();
                                (_c = (_b3 = this_1.observer) === null || _b3 === void 0 ? void 0 : _b3.next) === null || _c === void 0 ? void 0 : _c.call(_b3, {
                                  operation,
                                  modelDefinition,
                                  model: record,
                                  hasMore
                                });
                                return [
                                  2
                                  /*return*/
                                ];
                            }
                          });
                        };
                        this_1 = this;
                        _d.label = 1;
                      case 1:
                        _a3 = this.processing && this.runningProcesses.isOpen;
                        if (!_a3)
                          return [3, 3];
                        return [4, this.outbox.peek(this.storage)];
                      case 2:
                        _a3 = (head = _d.sent()) !== void 0;
                        _d.label = 3;
                      case 3:
                        if (!_a3)
                          return [3, 5];
                        return [5, _loop_1()];
                      case 4:
                        _d.sent();
                        return [3, 1];
                      case 5:
                        this.pause();
                        return [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }, "mutation resume loop")];
            case 1:
              _a2.sent();
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    MutationProcessor2.prototype.jitteredRetry = function(namespaceName, model, operation, data, condition, modelConstructor, MutationEvent, mutationEvent, authMode, onTerminate) {
      return __awaiter3(this, void 0, void 0, function() {
        var _this = this;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, retry(function(model2, operation2, data2, condition2, modelConstructor2, MutationEvent2, mutationEvent2) {
                return __awaiter3(_this, void 0, void 0, function() {
                  var _a3, query, variables, graphQLCondition, opName, modelDefinition, authToken, tryWith, attempt, opType, customUserAgentDetails, result, err_1, _b2, error, _c, _d, code, retryWith, err_2, _e, _f, opName_1, query_1, authToken_1, serverData, namespace, updatedMutation;
                  var _g;
                  return __generator3(this, function(_h) {
                    switch (_h.label) {
                      case 0:
                        _a3 = __read10(this.createQueryVariables(namespaceName, model2, operation2, data2, condition2), 5), query = _a3[0], variables = _a3[1], graphQLCondition = _a3[2], opName = _a3[3], modelDefinition = _a3[4];
                        return [4, getTokenForCustomAuth(authMode, this.amplifyConfig)];
                      case 1:
                        authToken = _h.sent();
                        tryWith = {
                          query,
                          variables,
                          authMode,
                          authToken
                        };
                        attempt = 0;
                        opType = this.opTypeFromTransformerOperation(operation2);
                        customUserAgentDetails = {
                          category: Category.DataStore,
                          action: DataStoreAction.GraphQl
                        };
                        _h.label = 2;
                      case 2:
                        _h.trys.push([2, 4, , 17]);
                        return [4, this.amplifyContext.InternalAPI.graphql(tryWith, void 0, customUserAgentDetails)];
                      case 3:
                        result = _h.sent();
                        return [2, [result, opName, modelDefinition]];
                      case 4:
                        err_1 = _h.sent();
                        if (!(err_1.errors && err_1.errors.length > 0))
                          return [3, 15];
                        _b2 = __read10(err_1.errors, 1), error = _b2[0];
                        _c = error.originalError, _d = (_c === void 0 ? {} : _c).code, code = _d === void 0 ? null : _d;
                        if (error.errorType === "Unauthorized") {
                          throw new NonRetryableError("Unauthorized");
                        }
                        if (error.message === "Network Error" || code === "ECONNABORTED") {
                          if (!this.processing) {
                            throw new NonRetryableError("Offline");
                          }
                          throw new Error("Network Error");
                        }
                        if (!(error.errorType === "ConflictUnhandled"))
                          return [3, 13];
                        attempt++;
                        retryWith = void 0;
                        if (!(attempt > MAX_ATTEMPTS))
                          return [3, 5];
                        retryWith = DISCARD;
                        return [3, 8];
                      case 5:
                        _h.trys.push([5, 7, , 8]);
                        return [4, this.conflictHandler({
                          modelConstructor: modelConstructor2,
                          localModel: this.modelInstanceCreator(modelConstructor2, variables.input),
                          remoteModel: this.modelInstanceCreator(modelConstructor2, error.data),
                          operation: opType,
                          attempts: attempt
                        })];
                      case 6:
                        retryWith = _h.sent();
                        return [3, 8];
                      case 7:
                        err_2 = _h.sent();
                        logger47.warn("conflict trycatch", err_2);
                        return [3, 17];
                      case 8:
                        if (!(retryWith === DISCARD))
                          return [3, 11];
                        _e = __read10(buildGraphQLOperation(this.schema.namespaces[namespaceName], modelDefinition, "GET"), 1), _f = __read10(_e[0], 3), opName_1 = _f[1], query_1 = _f[2];
                        return [4, getTokenForCustomAuth(authMode, this.amplifyConfig)];
                      case 9:
                        authToken_1 = _h.sent();
                        return [4, this.amplifyContext.InternalAPI.graphql({
                          query: query_1,
                          variables: { id: variables.input.id },
                          authMode,
                          authToken: authToken_1
                        }, void 0, customUserAgentDetails)];
                      case 10:
                        serverData = _h.sent();
                        return [2, [serverData, opName_1, modelDefinition]];
                      case 11:
                        namespace = this.schema.namespaces[namespaceName];
                        updatedMutation = createMutationInstanceFromModelOperation(namespace.relationships, modelDefinition, opType, modelConstructor2, retryWith, graphQLCondition, MutationEvent2, this.modelInstanceCreator, mutationEvent2.id);
                        return [4, this.storage.save(updatedMutation)];
                      case 12:
                        _h.sent();
                        throw new NonRetryableError("RetryMutation");
                      case 13:
                        try {
                          this.errorHandler({
                            recoverySuggestion: "Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues",
                            localModel: variables.input,
                            message: error.message,
                            operation: operation2,
                            errorType: getMutationErrorType(error),
                            errorInfo: error.errorInfo,
                            process: ProcessName.mutate,
                            cause: error,
                            remoteModel: error.data ? this.modelInstanceCreator(modelConstructor2, error.data) : null
                          });
                        } catch (err) {
                          logger47.warn("Mutation error handler failed with:", err);
                        } finally {
                          return [2, error.data ? [
                            { data: (_g = {}, _g[opName] = error.data, _g) },
                            opName,
                            modelDefinition
                          ] : []];
                        }
                        _h.label = 14;
                      case 14:
                        return [3, 16];
                      case 15:
                        throw new NonRetryableError(err_1);
                      case 16:
                        return [3, 17];
                      case 17:
                        if (tryWith)
                          return [3, 2];
                        _h.label = 18;
                      case 18:
                        return [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }, [
                model,
                operation,
                data,
                condition,
                modelConstructor,
                MutationEvent,
                mutationEvent
              ], safeJitteredBackoff, onTerminate)];
            case 1:
              return [2, _a2.sent()];
          }
        });
      });
    };
    MutationProcessor2.prototype.createQueryVariables = function(namespaceName, model, operation, data, condition) {
      var e_2, _a2, e_3, _b2, e_4, _c;
      var _d, _e;
      var modelDefinition = this.schema.namespaces[namespaceName].models[model];
      var primaryKey = this.schema.namespaces[namespaceName].keys[model].primaryKey;
      var auth = (_d = modelDefinition.attributes) === null || _d === void 0 ? void 0 : _d.find(function(a2) {
        return a2.type === "auth";
      });
      var ownerFields = ((_e = auth === null || auth === void 0 ? void 0 : auth.properties) === null || _e === void 0 ? void 0 : _e.rules.map(function(rule) {
        return rule.ownerField;
      }).filter(function(f2) {
        return f2;
      })) || ["owner"];
      var queriesTuples = this.typeQuery.get(modelDefinition);
      var _f = __read10(queriesTuples.find(function(_a3) {
        var _b3 = __read10(_a3, 1), transformerMutationType = _b3[0];
        return transformerMutationType === operation;
      }), 3), opName = _f[1], query = _f[2];
      var _g = JSON.parse(data), _version = _g._version, parsedData = __rest2(_g, ["_version"]);
      var deleteInput = {};
      if (primaryKey === null || primaryKey === void 0 ? void 0 : primaryKey.length) {
        try {
          for (var primaryKey_1 = __values4(primaryKey), primaryKey_1_1 = primaryKey_1.next(); !primaryKey_1_1.done; primaryKey_1_1 = primaryKey_1.next()) {
            var pkField = primaryKey_1_1.value;
            deleteInput[pkField] = parsedData[pkField];
          }
        } catch (e_2_1) {
          e_2 = { error: e_2_1 };
        } finally {
          try {
            if (primaryKey_1_1 && !primaryKey_1_1.done && (_a2 = primaryKey_1.return))
              _a2.call(primaryKey_1);
          } finally {
            if (e_2)
              throw e_2.error;
          }
        }
      } else {
        deleteInput[ID] = parsedData.id;
      }
      var mutationInput;
      if (operation === TransformerMutationType.DELETE) {
        mutationInput = deleteInput;
      } else {
        mutationInput = {};
        var modelFields = Object.values(modelDefinition.fields);
        try {
          for (var modelFields_1 = __values4(modelFields), modelFields_1_1 = modelFields_1.next(); !modelFields_1_1.done; modelFields_1_1 = modelFields_1.next()) {
            var _h = modelFields_1_1.value, name_1 = _h.name, type = _h.type, association = _h.association, isReadOnly = _h.isReadOnly;
            if (isReadOnly) {
              continue;
            }
            if (ownerFields.includes(name_1) && parsedData[name_1] === null) {
              continue;
            }
            if (isModelFieldType(type)) {
              if (isTargetNameAssociation(association) && association.connectionType === "BELONGS_TO") {
                var targetNames = extractTargetNamesFromSrc(association);
                if (targetNames) {
                  try {
                    for (var targetNames_1 = (e_4 = void 0, __values4(targetNames)), targetNames_1_1 = targetNames_1.next(); !targetNames_1_1.done; targetNames_1_1 = targetNames_1.next()) {
                      var targetName = targetNames_1_1.value;
                      mutationInput[targetName] = parsedData[targetName];
                    }
                  } catch (e_4_1) {
                    e_4 = { error: e_4_1 };
                  } finally {
                    try {
                      if (targetNames_1_1 && !targetNames_1_1.done && (_c = targetNames_1.return))
                        _c.call(targetNames_1);
                    } finally {
                      if (e_4)
                        throw e_4.error;
                    }
                  }
                }
              }
              continue;
            }
            if (operation === TransformerMutationType.UPDATE) {
              if (!parsedData.hasOwnProperty(name_1)) {
                continue;
              }
            }
            mutationInput[name_1] = parsedData[name_1];
          }
        } catch (e_3_1) {
          e_3 = { error: e_3_1 };
        } finally {
          try {
            if (modelFields_1_1 && !modelFields_1_1.done && (_b2 = modelFields_1.return))
              _b2.call(modelFields_1);
          } finally {
            if (e_3)
              throw e_3.error;
          }
        }
      }
      var input = __assign7(__assign7({}, mutationInput), { _version });
      var graphQLCondition = JSON.parse(condition);
      var variables = __assign7({ input }, operation === TransformerMutationType.CREATE ? {} : {
        condition: Object.keys(graphQLCondition).length > 0 ? graphQLCondition : null
      });
      return [query, variables, graphQLCondition, opName, modelDefinition];
    };
    MutationProcessor2.prototype.opTypeFromTransformerOperation = function(operation) {
      switch (operation) {
        case TransformerMutationType.CREATE:
          return OpType.INSERT;
        case TransformerMutationType.DELETE:
          return OpType.DELETE;
        case TransformerMutationType.UPDATE:
          return OpType.UPDATE;
        case TransformerMutationType.GET:
          break;
        default:
          throw new Error("Invalid operation " + operation);
      }
      return void 0;
    };
    MutationProcessor2.prototype.pause = function() {
      this.processing = false;
    };
    return MutationProcessor2;
  }()
);
var MAX_RETRY_DELAY_MS = 5 * 60 * 1e3;
var originalJitteredBackoff = jitteredBackoff(MAX_RETRY_DELAY_MS);
var safeJitteredBackoff = function(attempt, _args, error) {
  var attemptResult = originalJitteredBackoff(attempt);
  if (attemptResult === false && (error === null || error === void 0 ? void 0 : error.message) === "Network Error") {
    return MAX_RETRY_DELAY_MS;
  }
  return attemptResult;
};

// node_modules/@aws-amplify/datastore/lib-esm/sync/processors/subscription.js
var logger48 = new ConsoleLogger("DataStore");
var CONTROL_MSG2;
(function(CONTROL_MSG3) {
  CONTROL_MSG3["CONNECTED"] = "CONNECTED";
})(CONTROL_MSG2 || (CONTROL_MSG2 = {}));
var USER_CREDENTIALS;
(function(USER_CREDENTIALS2) {
  USER_CREDENTIALS2[USER_CREDENTIALS2["none"] = 0] = "none";
  USER_CREDENTIALS2[USER_CREDENTIALS2["unauth"] = 1] = "unauth";
  USER_CREDENTIALS2[USER_CREDENTIALS2["auth"] = 2] = "auth";
})(USER_CREDENTIALS || (USER_CREDENTIALS = {}));
var SubscriptionProcessor = (
  /** @class */
  function() {
    function SubscriptionProcessor2(schema2, syncPredicates, amplifyConfig, authModeStrategy, errorHandler, amplifyContext) {
      if (amplifyConfig === void 0) {
        amplifyConfig = {};
      }
      if (amplifyContext === void 0) {
        amplifyContext = {
          Auth,
          InternalAPI,
          Cache: BrowserStorageCache
        };
      }
      this.schema = schema2;
      this.syncPredicates = syncPredicates;
      this.amplifyConfig = amplifyConfig;
      this.authModeStrategy = authModeStrategy;
      this.errorHandler = errorHandler;
      this.amplifyContext = amplifyContext;
      this.typeQuery = /* @__PURE__ */ new WeakMap();
      this.buffer = [];
      this.runningProcesses = new BackgroundProcessManager();
    }
    SubscriptionProcessor2.prototype.buildSubscription = function(namespace, model, transformerMutationType, userCredentials, cognitoTokenPayload, oidcTokenPayload, authMode, filterArg) {
      if (filterArg === void 0) {
        filterArg = false;
      }
      var aws_appsync_authenticationType = this.amplifyConfig.aws_appsync_authenticationType;
      var _a2 = this.getAuthorizationInfo(model, userCredentials, aws_appsync_authenticationType, cognitoTokenPayload, oidcTokenPayload, authMode) || {}, isOwner = _a2.isOwner, ownerField = _a2.ownerField, ownerValue = _a2.ownerValue;
      var _b2 = __read10(buildSubscriptionGraphQLOperation(namespace, model, transformerMutationType, isOwner, ownerField, filterArg), 3), opType = _b2[0], opName = _b2[1], query = _b2[2];
      return { authMode, opType, opName, query, isOwner, ownerField, ownerValue };
    };
    SubscriptionProcessor2.prototype.getAuthorizationInfo = function(model, userCredentials, defaultAuthType, cognitoTokenPayload, oidcTokenPayload, authMode) {
      if (cognitoTokenPayload === void 0) {
        cognitoTokenPayload = {};
      }
      if (oidcTokenPayload === void 0) {
        oidcTokenPayload = {};
      }
      var rules = getAuthorizationRules(model);
      var iamPrivateAuth = authMode === GRAPHQL_AUTH_MODE.AWS_IAM && rules.find(function(rule) {
        return rule.authStrategy === "private" && rule.provider === "iam";
      });
      if (iamPrivateAuth && userCredentials === USER_CREDENTIALS.unauth) {
        return null;
      }
      var groupAuthRules = rules.filter(function(rule) {
        return rule.authStrategy === "groups" && ["userPools", "oidc"].includes(rule.provider);
      });
      var validGroup = (authMode === GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS || authMode === GRAPHQL_AUTH_MODE.OPENID_CONNECT) && groupAuthRules.find(function(groupAuthRule) {
        var cognitoUserGroups = getUserGroupsFromToken(cognitoTokenPayload, groupAuthRule);
        var oidcUserGroups = getUserGroupsFromToken(oidcTokenPayload, groupAuthRule);
        return __spread(cognitoUserGroups, oidcUserGroups).find(function(userGroup) {
          return groupAuthRule.groups.find(function(group) {
            return group === userGroup;
          });
        });
      });
      if (validGroup) {
        return {
          authMode,
          isOwner: false
        };
      }
      var cognitoOwnerAuthRules = authMode === GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS ? rules.filter(function(rule) {
        return rule.authStrategy === "owner" && rule.provider === "userPools";
      }) : [];
      var ownerAuthInfo;
      cognitoOwnerAuthRules.forEach(function(ownerAuthRule) {
        var _a2;
        var ownerValue = cognitoTokenPayload[ownerAuthRule.identityClaim];
        var singleOwner = ((_a2 = model.fields[ownerAuthRule.ownerField]) === null || _a2 === void 0 ? void 0 : _a2.isArray) !== true;
        var isOwnerArgRequired = singleOwner && !ownerAuthRule.areSubscriptionsPublic;
        if (ownerValue) {
          ownerAuthInfo = {
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            isOwner: isOwnerArgRequired,
            ownerField: ownerAuthRule.ownerField,
            ownerValue
          };
        }
      });
      if (ownerAuthInfo) {
        return ownerAuthInfo;
      }
      var oidcOwnerAuthRules = authMode === GRAPHQL_AUTH_MODE.OPENID_CONNECT ? rules.filter(function(rule) {
        return rule.authStrategy === "owner" && rule.provider === "oidc";
      }) : [];
      oidcOwnerAuthRules.forEach(function(ownerAuthRule) {
        var _a2;
        var ownerValue = oidcTokenPayload[ownerAuthRule.identityClaim];
        var singleOwner = ((_a2 = model.fields[ownerAuthRule.ownerField]) === null || _a2 === void 0 ? void 0 : _a2.isArray) !== true;
        var isOwnerArgRequired = singleOwner && !ownerAuthRule.areSubscriptionsPublic;
        if (ownerValue) {
          ownerAuthInfo = {
            authMode: GRAPHQL_AUTH_MODE.OPENID_CONNECT,
            isOwner: isOwnerArgRequired,
            ownerField: ownerAuthRule.ownerField,
            ownerValue
          };
        }
      });
      if (ownerAuthInfo) {
        return ownerAuthInfo;
      }
      return {
        authMode: authMode || defaultAuthType,
        isOwner: false
      };
    };
    SubscriptionProcessor2.prototype.hubQueryCompletionListener = function(completed, capsule) {
      var event = capsule.payload.event;
      if (event === CONTROL_MSG.SUBSCRIPTION_ACK) {
        completed();
      }
    };
    SubscriptionProcessor2.prototype.start = function() {
      var _this = this;
      this.runningProcesses = this.runningProcesses || new BackgroundProcessManager();
      var ctlObservable = new bundle_esm_default(function(observer) {
        var promises = [];
        var subscriptions = {};
        var cognitoTokenPayload, oidcTokenPayload;
        var userCredentials = USER_CREDENTIALS.none;
        _this.runningProcesses.add(function() {
          return __awaiter3(_this, void 0, void 0, function() {
            var credentials, err_1, session, err_2, _a2, aws_cognito_region, AuthConfig, token, federatedInfo, currentUser, payload, err_3;
            var _this2 = this;
            return __generator3(this, function(_b2) {
              switch (_b2.label) {
                case 0:
                  _b2.trys.push([0, 2, , 3]);
                  return [4, this.amplifyContext.Auth.currentCredentials()];
                case 1:
                  credentials = _b2.sent();
                  userCredentials = credentials.authenticated ? USER_CREDENTIALS.auth : USER_CREDENTIALS.unauth;
                  return [3, 3];
                case 2:
                  err_1 = _b2.sent();
                  return [3, 3];
                case 3:
                  _b2.trys.push([3, 5, , 6]);
                  return [4, this.amplifyContext.Auth.currentSession()];
                case 4:
                  session = _b2.sent();
                  cognitoTokenPayload = session.getIdToken().decodePayload();
                  return [3, 6];
                case 5:
                  err_2 = _b2.sent();
                  return [3, 6];
                case 6:
                  _b2.trys.push([6, 11, , 12]);
                  _a2 = this.amplifyConfig, aws_cognito_region = _a2.aws_cognito_region, AuthConfig = _a2.Auth;
                  if (!aws_cognito_region || AuthConfig && !AuthConfig.region) {
                    throw "Auth is not configured";
                  }
                  token = void 0;
                  return [4, this.amplifyContext.Cache.getItem("federatedInfo")];
                case 7:
                  federatedInfo = _b2.sent();
                  if (!federatedInfo)
                    return [3, 8];
                  token = federatedInfo.token;
                  return [3, 10];
                case 8:
                  return [4, this.amplifyContext.Auth.currentAuthenticatedUser()];
                case 9:
                  currentUser = _b2.sent();
                  if (currentUser) {
                    token = currentUser.token;
                  }
                  _b2.label = 10;
                case 10:
                  if (token) {
                    payload = token.split(".")[1];
                    oidcTokenPayload = JSON.parse(Buffer.from(payload, "base64").toString("utf8"));
                  }
                  return [3, 12];
                case 11:
                  err_3 = _b2.sent();
                  logger48.debug("error getting OIDC JWT", err_3);
                  return [3, 12];
                case 12:
                  Object.values(this.schema.namespaces).forEach(function(namespace) {
                    Object.values(namespace.models).filter(function(_a3) {
                      var syncable = _a3.syncable;
                      return syncable;
                    }).forEach(function(modelDefinition) {
                      return _this2.runningProcesses.isOpen && _this2.runningProcesses.add(function() {
                        return __awaiter3(_this2, void 0, void 0, function() {
                          var modelAuthModes, readAuthModes, operations, operationAuthModeAttempts, predicatesGroup, addFilterArg, subscriptionRetry;
                          var _a3, _b3, _c;
                          var _this3 = this;
                          return __generator3(this, function(_d) {
                            switch (_d.label) {
                              case 0:
                                return [4, getModelAuthModes({
                                  authModeStrategy: this.authModeStrategy,
                                  defaultAuthMode: this.amplifyConfig.aws_appsync_authenticationType,
                                  modelName: modelDefinition.name,
                                  schema: this.schema
                                })];
                              case 1:
                                modelAuthModes = _d.sent();
                                readAuthModes = modelAuthModes.READ;
                                subscriptions = __assign7(__assign7({}, subscriptions), (_a3 = {}, _a3[modelDefinition.name] = (_b3 = {}, _b3[TransformerMutationType.CREATE] = [], _b3[TransformerMutationType.UPDATE] = [], _b3[TransformerMutationType.DELETE] = [], _b3), _a3));
                                operations = [
                                  TransformerMutationType.CREATE,
                                  TransformerMutationType.UPDATE,
                                  TransformerMutationType.DELETE
                                ];
                                operationAuthModeAttempts = (_c = {}, _c[TransformerMutationType.CREATE] = 0, _c[TransformerMutationType.UPDATE] = 0, _c[TransformerMutationType.DELETE] = 0, _c);
                                predicatesGroup = ModelPredicateCreator.getPredicates(this.syncPredicates.get(modelDefinition), false);
                                addFilterArg = predicatesGroup !== void 0;
                                subscriptionRetry = function(operation, addFilter) {
                                  if (addFilter === void 0) {
                                    addFilter = addFilterArg;
                                  }
                                  return __awaiter3(_this3, void 0, void 0, function() {
                                    var _a4, transformerMutationType, opName, query, isOwner, ownerField, ownerValue, authMode, authToken, variables, customUserAgentDetails, queryObservable, subscriptionReadyCallback;
                                    var _this4 = this;
                                    return __generator3(this, function(_b4) {
                                      switch (_b4.label) {
                                        case 0:
                                          _a4 = this.buildSubscription(namespace, modelDefinition, operation, userCredentials, cognitoTokenPayload, oidcTokenPayload, readAuthModes[operationAuthModeAttempts[operation]], addFilter), transformerMutationType = _a4.opType, opName = _a4.opName, query = _a4.query, isOwner = _a4.isOwner, ownerField = _a4.ownerField, ownerValue = _a4.ownerValue, authMode = _a4.authMode;
                                          return [4, getTokenForCustomAuth(authMode, this.amplifyConfig)];
                                        case 1:
                                          authToken = _b4.sent();
                                          variables = {};
                                          customUserAgentDetails = {
                                            category: Category.DataStore,
                                            action: DataStoreAction.Subscribe
                                          };
                                          if (addFilter && predicatesGroup) {
                                            variables["filter"] = predicateToGraphQLFilter(predicatesGroup);
                                          }
                                          if (isOwner) {
                                            if (!ownerValue) {
                                              observer.error("Owner field required, sign in is needed in order to perform this operation");
                                              return [
                                                2
                                                /*return*/
                                              ];
                                            }
                                            variables[ownerField] = ownerValue;
                                          }
                                          logger48.debug("Attempting " + operation + " subscription with authMode: " + readAuthModes[operationAuthModeAttempts[operation]]);
                                          queryObservable = this.amplifyContext.InternalAPI.graphql(__assign7(__assign7({
                                            query,
                                            variables
                                          }, { authMode }), { authToken }), void 0, customUserAgentDetails);
                                          subscriptions[modelDefinition.name][transformerMutationType].push(queryObservable.map(function(_a5) {
                                            var value = _a5.value;
                                            return value;
                                          }).subscribe({
                                            next: function(_a5) {
                                              var data = _a5.data, errors = _a5.errors;
                                              if (Array.isArray(errors) && errors.length > 0) {
                                                var messages = errors.map(function(_a6) {
                                                  var message = _a6.message;
                                                  return message;
                                                });
                                                logger48.warn("Skipping incoming subscription. Messages: " + messages.join("\n"));
                                                _this4.drainBuffer();
                                                return;
                                              }
                                              var predicatesGroup2 = ModelPredicateCreator.getPredicates(_this4.syncPredicates.get(modelDefinition), false);
                                              var _b5 = data, _c2 = opName, record = _b5[_c2];
                                              if (_this4.passesPredicateValidation(record, predicatesGroup2)) {
                                                _this4.pushToBuffer(transformerMutationType, modelDefinition, record);
                                              }
                                              _this4.drainBuffer();
                                            },
                                            error: function(subscriptionError) {
                                              return __awaiter3(_this4, void 0, void 0, function() {
                                                var _a5, _b5, _c2, _d2, message, isRTFError, e_1;
                                                return __generator3(this, function(_e) {
                                                  switch (_e.label) {
                                                    case 0:
                                                      _a5 = subscriptionError.error, _b5 = __read10((_a5 === void 0 ? {
                                                        errors: []
                                                      } : _a5).errors, 1), _c2 = _b5[0], _d2 = (_c2 === void 0 ? {} : _c2).message, message = _d2 === void 0 ? "" : _d2;
                                                      isRTFError = // only attempt catch if a filter variable was added to the subscription query
                                                      addFilter && this.catchRTFError(message, modelDefinition, predicatesGroup);
                                                      if (isRTFError) {
                                                        subscriptions[modelDefinition.name][transformerMutationType].forEach(function(subscription) {
                                                          return subscription.unsubscribe();
                                                        });
                                                        subscriptions[modelDefinition.name][transformerMutationType] = [];
                                                        subscriptionRetry(operation, false);
                                                        return [
                                                          2
                                                          /*return*/
                                                        ];
                                                      }
                                                      if (message.includes(CONTROL_MSG.REALTIME_SUBSCRIPTION_INIT_ERROR) || message.includes(CONTROL_MSG.CONNECTION_FAILED)) {
                                                        subscriptions[modelDefinition.name][transformerMutationType].forEach(function(subscription) {
                                                          return subscription.unsubscribe();
                                                        });
                                                        subscriptions[modelDefinition.name][transformerMutationType] = [];
                                                        operationAuthModeAttempts[operation]++;
                                                        if (operationAuthModeAttempts[operation] >= readAuthModes.length) {
                                                          logger48.debug(operation + " subscription failed with authMode: " + readAuthModes[operationAuthModeAttempts[operation] - 1]);
                                                        } else {
                                                          logger48.debug(operation + " subscription failed with authMode: " + readAuthModes[operationAuthModeAttempts[operation] - 1] + ". Retrying with authMode: " + readAuthModes[operationAuthModeAttempts[operation]]);
                                                          subscriptionRetry(operation);
                                                          return [
                                                            2
                                                            /*return*/
                                                          ];
                                                        }
                                                      }
                                                      logger48.warn("subscriptionError", message);
                                                      _e.label = 1;
                                                    case 1:
                                                      _e.trys.push([1, 3, , 4]);
                                                      return [4, this.errorHandler({
                                                        recoverySuggestion: "Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues",
                                                        localModel: null,
                                                        message,
                                                        model: modelDefinition.name,
                                                        operation,
                                                        errorType: getSubscriptionErrorType(subscriptionError),
                                                        process: ProcessName.subscribe,
                                                        remoteModel: null,
                                                        cause: subscriptionError
                                                      })];
                                                    case 2:
                                                      _e.sent();
                                                      return [3, 4];
                                                    case 3:
                                                      e_1 = _e.sent();
                                                      logger48.error("Subscription error handler failed with:", e_1);
                                                      return [3, 4];
                                                    case 4:
                                                      if (typeof subscriptionReadyCallback === "function") {
                                                        subscriptionReadyCallback();
                                                      }
                                                      if (message.includes('"errorType":"Unauthorized"') || message.includes('"errorType":"OperationDisabled"')) {
                                                        return [
                                                          2
                                                          /*return*/
                                                        ];
                                                      }
                                                      observer.error(message);
                                                      return [
                                                        2
                                                        /*return*/
                                                      ];
                                                  }
                                                });
                                              });
                                            }
                                          }));
                                          promises.push(function() {
                                            return __awaiter3(_this4, void 0, void 0, function() {
                                              var boundFunction;
                                              var _this5 = this;
                                              return __generator3(this, function(_a5) {
                                                switch (_a5.label) {
                                                  case 0:
                                                    return [4, new Promise(function(res) {
                                                      subscriptionReadyCallback = res;
                                                      boundFunction = _this5.hubQueryCompletionListener.bind(_this5, res);
                                                      Hub.listen("api", boundFunction);
                                                    })];
                                                  case 1:
                                                    _a5.sent();
                                                    Hub.remove("api", boundFunction);
                                                    return [
                                                      2
                                                      /*return*/
                                                    ];
                                                }
                                              });
                                            });
                                          }());
                                          return [
                                            2
                                            /*return*/
                                          ];
                                      }
                                    });
                                  });
                                };
                                operations.forEach(function(op) {
                                  return subscriptionRetry(op);
                                });
                                return [
                                  2
                                  /*return*/
                                ];
                            }
                          });
                        });
                      });
                    });
                  });
                  this.runningProcesses.isOpen && this.runningProcesses.add(function() {
                    return Promise.all(promises).then(function() {
                      observer.next(CONTROL_MSG2.CONNECTED);
                    });
                  });
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }, "subscription processor new subscriber");
        return _this.runningProcesses.addCleaner(function() {
          return __awaiter3(_this, void 0, void 0, function() {
            return __generator3(this, function(_a2) {
              Object.keys(subscriptions).forEach(function(modelName) {
                subscriptions[modelName][TransformerMutationType.CREATE].forEach(function(subscription) {
                  return subscription.unsubscribe();
                });
                subscriptions[modelName][TransformerMutationType.UPDATE].forEach(function(subscription) {
                  return subscription.unsubscribe();
                });
                subscriptions[modelName][TransformerMutationType.DELETE].forEach(function(subscription) {
                  return subscription.unsubscribe();
                });
              });
              return [
                2
                /*return*/
              ];
            });
          });
        });
      });
      var dataObservable = new bundle_esm_default(function(observer) {
        _this.dataObserver = observer;
        _this.drainBuffer();
        return _this.runningProcesses.addCleaner(function() {
          return __awaiter3(_this, void 0, void 0, function() {
            return __generator3(this, function(_a2) {
              this.dataObserver = null;
              return [
                2
                /*return*/
              ];
            });
          });
        });
      });
      return [ctlObservable, dataObservable];
    };
    SubscriptionProcessor2.prototype.stop = function() {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this.runningProcesses.close()];
            case 1:
              _a2.sent();
              return [4, this.runningProcesses.open()];
            case 2:
              _a2.sent();
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    SubscriptionProcessor2.prototype.passesPredicateValidation = function(record, predicatesGroup) {
      if (!predicatesGroup) {
        return true;
      }
      var predicates = predicatesGroup.predicates, type = predicatesGroup.type;
      return validatePredicate(record, type, predicates);
    };
    SubscriptionProcessor2.prototype.pushToBuffer = function(transformerMutationType, modelDefinition, data) {
      this.buffer.push([transformerMutationType, modelDefinition, data]);
    };
    SubscriptionProcessor2.prototype.drainBuffer = function() {
      var _this = this;
      if (this.dataObserver) {
        this.buffer.forEach(function(data) {
          return _this.dataObserver.next(data);
        });
        this.buffer = [];
      }
    };
    SubscriptionProcessor2.prototype.catchRTFError = function(message, modelDefinition, predicatesGroup) {
      var header = "Backend subscriptions filtering error.\nSubscriptions filtering will be applied clientside.\n";
      var messageErrorTypeMap = {
        "UnknownArgument: Unknown field argument filter": RTFError.UnknownField,
        "Filters exceed maximum attributes limit": RTFError.MaxAttributes,
        "Filters combination exceed maximum limit": RTFError.MaxCombinations,
        "filter uses same fieldName multiple time": RTFError.RepeatedFieldname,
        "The variables input contains a field name 'not'": RTFError.NotGroup,
        "The variables input contains a field that is not defined for input object type": RTFError.FieldNotInType
      };
      var _a2 = __read10(Object.entries(messageErrorTypeMap).find(function(_a3) {
        var _b2 = __read10(_a3, 1), errorMsg = _b2[0];
        return message.includes(errorMsg);
      }) || [], 2), _errorMsg = _a2[0], errorType = _a2[1];
      if (errorType !== void 0) {
        var remediationMessage = generateRTFRemediation(errorType, modelDefinition, predicatesGroup);
        logger48.warn(header + "\n" + message + "\n" + remediationMessage);
        return true;
      }
      return false;
    };
    return SubscriptionProcessor2;
  }()
);

// node_modules/@aws-amplify/datastore/lib-esm/sync/processors/sync.js
var opResultDefaults = {
  items: [],
  nextToken: null,
  startedAt: null
};
var logger49 = new ConsoleLogger("DataStore");
var SyncProcessor = (
  /** @class */
  function() {
    function SyncProcessor2(schema2, syncPredicates, amplifyConfig, authModeStrategy, errorHandler, amplifyContext) {
      if (amplifyConfig === void 0) {
        amplifyConfig = {};
      }
      this.schema = schema2;
      this.syncPredicates = syncPredicates;
      this.amplifyConfig = amplifyConfig;
      this.authModeStrategy = authModeStrategy;
      this.errorHandler = errorHandler;
      this.amplifyContext = amplifyContext;
      this.typeQuery = /* @__PURE__ */ new WeakMap();
      this.runningProcesses = new BackgroundProcessManager();
      amplifyContext.InternalAPI = amplifyContext.InternalAPI || InternalAPI;
      this.generateQueries();
    }
    SyncProcessor2.prototype.generateQueries = function() {
      var _this = this;
      Object.values(this.schema.namespaces).forEach(function(namespace) {
        Object.values(namespace.models).filter(function(_a2) {
          var syncable = _a2.syncable;
          return syncable;
        }).forEach(function(model) {
          var _a2 = __read10(buildGraphQLOperation(namespace, model, "LIST"), 1), _b2 = __read10(_a2[0]), opNameQuery = _b2.slice(1);
          _this.typeQuery.set(model, opNameQuery);
        });
      });
    };
    SyncProcessor2.prototype.graphqlFilterFromPredicate = function(model) {
      if (!this.syncPredicates) {
        return null;
      }
      var predicatesGroup = ModelPredicateCreator.getPredicates(this.syncPredicates.get(model), false);
      if (!predicatesGroup) {
        return null;
      }
      return predicateToGraphQLFilter(predicatesGroup);
    };
    SyncProcessor2.prototype.retrievePage = function(modelDefinition, lastSync, nextToken, limit, filter, onTerminate) {
      if (limit === void 0) {
        limit = null;
      }
      return __awaiter3(this, void 0, void 0, function() {
        var _a2, opName, query, variables, modelAuthModes, readAuthModes, authModeAttempts, authModeRetry, data, _b2, _c, opResult, items, newNextToken, startedAt;
        var _this = this;
        return __generator3(this, function(_d) {
          switch (_d.label) {
            case 0:
              _a2 = __read10(this.typeQuery.get(modelDefinition), 2), opName = _a2[0], query = _a2[1];
              variables = {
                limit,
                nextToken,
                lastSync,
                filter
              };
              return [4, getModelAuthModes({
                authModeStrategy: this.authModeStrategy,
                defaultAuthMode: this.amplifyConfig.aws_appsync_authenticationType,
                modelName: modelDefinition.name,
                schema: this.schema
              })];
            case 1:
              modelAuthModes = _d.sent();
              readAuthModes = modelAuthModes.READ;
              authModeAttempts = 0;
              authModeRetry = function() {
                return __awaiter3(_this, void 0, void 0, function() {
                  var response, error_1, authMode;
                  var _a3;
                  return __generator3(this, function(_b3) {
                    switch (_b3.label) {
                      case 0:
                        if (!this.runningProcesses.isOpen) {
                          throw new Error("sync.retreievePage termination was requested. Exiting.");
                        }
                        _b3.label = 1;
                      case 1:
                        _b3.trys.push([1, 3, , 5]);
                        logger49.debug("Attempting sync with authMode: " + readAuthModes[authModeAttempts]);
                        return [4, this.jitteredRetry({
                          query,
                          variables,
                          opName,
                          modelDefinition,
                          authMode: readAuthModes[authModeAttempts],
                          onTerminate
                        })];
                      case 2:
                        response = _b3.sent();
                        logger49.debug("Sync successful with authMode: " + readAuthModes[authModeAttempts]);
                        return [2, response];
                      case 3:
                        error_1 = _b3.sent();
                        authModeAttempts++;
                        if (authModeAttempts >= readAuthModes.length) {
                          authMode = readAuthModes[authModeAttempts - 1];
                          logger49.debug("Sync failed with authMode: " + authMode, error_1);
                          if (getClientSideAuthError(error_1) || getForbiddenError(error_1)) {
                            logger49.warn("User is unauthorized to query " + opName + " with auth mode " + authMode + ". No data could be returned.");
                            return [2, {
                              data: (_a3 = {}, _a3[opName] = opResultDefaults, _a3)
                            }];
                          }
                          throw error_1;
                        }
                        logger49.debug("Sync failed with authMode: " + readAuthModes[authModeAttempts - 1] + ". Retrying with authMode: " + readAuthModes[authModeAttempts]);
                        return [4, authModeRetry()];
                      case 4:
                        return [2, _b3.sent()];
                      case 5:
                        return [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              };
              return [4, authModeRetry()];
            case 2:
              data = _d.sent().data;
              _b2 = data, _c = opName, opResult = _b2[_c];
              items = opResult.items, newNextToken = opResult.nextToken, startedAt = opResult.startedAt;
              return [2, {
                nextToken: newNextToken,
                startedAt,
                items
              }];
          }
        });
      });
    };
    SyncProcessor2.prototype.jitteredRetry = function(_a2) {
      var query = _a2.query, variables = _a2.variables, opName = _a2.opName, modelDefinition = _a2.modelDefinition, authMode = _a2.authMode, onTerminate = _a2.onTerminate;
      return __awaiter3(this, void 0, void 0, function() {
        var _this = this;
        return __generator3(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              return [4, jitteredExponentialRetry(function(query2, variables2) {
                return __awaiter3(_this, void 0, void 0, function() {
                  var authToken, customUserAgentDetails, error_2, clientOrForbiddenErrorMessage, hasItems, unauthorized, otherErrors, result;
                  var _this2 = this;
                  var _a3, _b3, _c, _d;
                  return __generator3(this, function(_e) {
                    switch (_e.label) {
                      case 0:
                        _e.trys.push([0, 3, , 6]);
                        return [4, getTokenForCustomAuth(authMode, this.amplifyConfig)];
                      case 1:
                        authToken = _e.sent();
                        customUserAgentDetails = {
                          category: Category.DataStore,
                          action: DataStoreAction.GraphQl
                        };
                        return [4, this.amplifyContext.InternalAPI.graphql({
                          query: query2,
                          variables: variables2,
                          authMode,
                          authToken
                        }, void 0, customUserAgentDetails)];
                      case 2:
                        return [2, _e.sent()];
                      case 3:
                        error_2 = _e.sent();
                        clientOrForbiddenErrorMessage = getClientSideAuthError(error_2) || getForbiddenError(error_2);
                        if (clientOrForbiddenErrorMessage) {
                          logger49.error("Sync processor retry error:", error_2);
                          throw new NonRetryableError(clientOrForbiddenErrorMessage);
                        }
                        hasItems = Boolean((_b3 = (_a3 = error_2 === null || error_2 === void 0 ? void 0 : error_2.data) === null || _a3 === void 0 ? void 0 : _a3[opName]) === null || _b3 === void 0 ? void 0 : _b3.items);
                        unauthorized = (error_2 === null || error_2 === void 0 ? void 0 : error_2.errors) && error_2.errors.some(function(err) {
                          return err.errorType === "Unauthorized";
                        });
                        otherErrors = (error_2 === null || error_2 === void 0 ? void 0 : error_2.errors) && error_2.errors.filter(function(err) {
                          return err.errorType !== "Unauthorized";
                        });
                        result = error_2;
                        if (hasItems) {
                          result.data[opName].items = result.data[opName].items.filter(function(item) {
                            return item !== null;
                          });
                        }
                        if (!(hasItems && (otherErrors === null || otherErrors === void 0 ? void 0 : otherErrors.length)))
                          return [3, 5];
                        return [4, Promise.all(otherErrors.map(function(err) {
                          return __awaiter3(_this2, void 0, void 0, function() {
                            var e_1;
                            return __generator3(this, function(_a4) {
                              switch (_a4.label) {
                                case 0:
                                  _a4.trys.push([0, 2, , 3]);
                                  return [4, this.errorHandler({
                                    recoverySuggestion: "Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues",
                                    localModel: null,
                                    message: err.message,
                                    model: modelDefinition.name,
                                    operation: opName,
                                    errorType: getSyncErrorType(err),
                                    process: ProcessName.sync,
                                    remoteModel: null,
                                    cause: err
                                  })];
                                case 1:
                                  _a4.sent();
                                  return [3, 3];
                                case 2:
                                  e_1 = _a4.sent();
                                  logger49.error("Sync error handler failed with:", e_1);
                                  return [3, 3];
                                case 3:
                                  return [
                                    2
                                    /*return*/
                                  ];
                              }
                            });
                          });
                        }))];
                      case 4:
                        _e.sent();
                        Hub.dispatch("datastore", {
                          event: "nonApplicableDataReceived",
                          data: {
                            errors: otherErrors,
                            modelName: modelDefinition.name
                          }
                        });
                        _e.label = 5;
                      case 5:
                        if (unauthorized) {
                          this.errorHandler({
                            recoverySuggestion: "Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues",
                            localModel: null,
                            message: error_2.message,
                            model: modelDefinition.name,
                            operation: opName,
                            errorType: getSyncErrorType(error_2.errors[0]),
                            process: ProcessName.sync,
                            remoteModel: null,
                            cause: error_2
                          });
                          throw new NonRetryableError(error_2);
                        }
                        if ((_d = (_c = result.data) === null || _c === void 0 ? void 0 : _c[opName].items) === null || _d === void 0 ? void 0 : _d.length) {
                          return [2, result];
                        }
                        throw error_2;
                      case 6:
                        return [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }, [query, variables], void 0, onTerminate)];
            case 1:
              return [2, _b2.sent()];
          }
        });
      });
    };
    SyncProcessor2.prototype.start = function(typesLastSync) {
      var _this = this;
      var _a2 = this.amplifyConfig, maxRecordsToSync = _a2.maxRecordsToSync, syncPageSize = _a2.syncPageSize;
      var parentPromises = /* @__PURE__ */ new Map();
      var observable = new bundle_esm_default(function(observer) {
        var sortedTypesLastSyncs = Object.values(_this.schema.namespaces).reduce(function(map5, namespace) {
          var e_2, _a3;
          try {
            for (var _b2 = __values4(Array.from(namespace.modelTopologicalOrdering.keys())), _c = _b2.next(); !_c.done; _c = _b2.next()) {
              var modelName = _c.value;
              var typeLastSync = typesLastSync.get(namespace.models[modelName]);
              map5.set(namespace.models[modelName], typeLastSync);
            }
          } catch (e_2_1) {
            e_2 = { error: e_2_1 };
          } finally {
            try {
              if (_c && !_c.done && (_a3 = _b2.return))
                _a3.call(_b2);
            } finally {
              if (e_2)
                throw e_2.error;
            }
          }
          return map5;
        }, /* @__PURE__ */ new Map());
        var allModelsReady = Array.from(sortedTypesLastSyncs.entries()).filter(function(_a3) {
          var _b2 = __read10(_a3, 1), syncable = _b2[0].syncable;
          return syncable;
        }).map(function(_a3) {
          var _b2 = __read10(_a3, 2), modelDefinition = _b2[0], _c = __read10(_b2[1], 2), namespace = _c[0], lastSync = _c[1];
          return _this.runningProcesses.isOpen && _this.runningProcesses.add(function(onTerminate) {
            return __awaiter3(_this, void 0, void 0, function() {
              var done, nextToken, startedAt, items, recordsReceived, filter, parents2, promises, promise;
              var _this2 = this;
              return __generator3(this, function(_a4) {
                switch (_a4.label) {
                  case 0:
                    done = false;
                    nextToken = null;
                    startedAt = null;
                    items = null;
                    recordsReceived = 0;
                    filter = this.graphqlFilterFromPredicate(modelDefinition);
                    parents2 = this.schema.namespaces[namespace].modelTopologicalOrdering.get(modelDefinition.name);
                    promises = parents2.map(function(parent) {
                      return parentPromises.get(namespace + "_" + parent);
                    });
                    promise = new Promise(function(res) {
                      return __awaiter3(_this2, void 0, void 0, function() {
                        var limit, error_3, e_3;
                        var _a5;
                        return __generator3(this, function(_b3) {
                          switch (_b3.label) {
                            case 0:
                              return [4, Promise.all(promises)];
                            case 1:
                              _b3.sent();
                              _b3.label = 2;
                            case 2:
                              if (!this.runningProcesses.isOpen) {
                                logger49.debug("Sync processor has been stopped, terminating sync for " + modelDefinition.name);
                                return [2, res()];
                              }
                              limit = Math.min(maxRecordsToSync - recordsReceived, syncPageSize);
                              _b3.label = 3;
                            case 3:
                              _b3.trys.push([3, 5, , 10]);
                              return [4, this.retrievePage(modelDefinition, lastSync, nextToken, limit, filter, onTerminate)];
                            case 4:
                              _a5 = _b3.sent(), items = _a5.items, nextToken = _a5.nextToken, startedAt = _a5.startedAt;
                              return [3, 10];
                            case 5:
                              error_3 = _b3.sent();
                              _b3.label = 6;
                            case 6:
                              _b3.trys.push([6, 8, , 9]);
                              return [4, this.errorHandler({
                                recoverySuggestion: "Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues",
                                localModel: null,
                                message: error_3.message,
                                model: modelDefinition.name,
                                operation: null,
                                errorType: getSyncErrorType(error_3),
                                process: ProcessName.sync,
                                remoteModel: null,
                                cause: error_3
                              })];
                            case 7:
                              _b3.sent();
                              return [3, 9];
                            case 8:
                              e_3 = _b3.sent();
                              logger49.error("Sync error handler failed with:", e_3);
                              return [3, 9];
                            case 9:
                              done = true;
                              items = [];
                              return [3, 10];
                            case 10:
                              recordsReceived += items.length;
                              done = nextToken === null || recordsReceived >= maxRecordsToSync;
                              observer.next({
                                namespace,
                                modelDefinition,
                                items,
                                done,
                                startedAt,
                                isFullSync: !lastSync
                              });
                              _b3.label = 11;
                            case 11:
                              if (!done)
                                return [3, 2];
                              _b3.label = 12;
                            case 12:
                              res();
                              return [
                                2
                                /*return*/
                              ];
                          }
                        });
                      });
                    });
                    parentPromises.set(namespace + "_" + modelDefinition.name, promise);
                    return [4, promise];
                  case 1:
                    _a4.sent();
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          }, "adding model " + modelDefinition.name);
        });
        Promise.all(allModelsReady).then(function() {
          observer.complete();
        });
      });
      return observable;
    };
    SyncProcessor2.prototype.stop = function() {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              logger49.debug("stopping sync processor");
              return [4, this.runningProcesses.close()];
            case 1:
              _a2.sent();
              return [4, this.runningProcesses.open()];
            case 2:
              _a2.sent();
              logger49.debug("sync processor stopped");
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    return SyncProcessor2;
  }()
);

// node_modules/@aws-amplify/datastore/lib-esm/sync/index.js
var isNode3 = browserOrNode().isNode;
var logger50 = new ConsoleLogger("DataStore");
var ownSymbol = Symbol("sync");
var ControlMessage;
(function(ControlMessage2) {
  ControlMessage2["SYNC_ENGINE_STORAGE_SUBSCRIBED"] = "storageSubscribed";
  ControlMessage2["SYNC_ENGINE_SUBSCRIPTIONS_ESTABLISHED"] = "subscriptionsEstablished";
  ControlMessage2["SYNC_ENGINE_SYNC_QUERIES_STARTED"] = "syncQueriesStarted";
  ControlMessage2["SYNC_ENGINE_SYNC_QUERIES_READY"] = "syncQueriesReady";
  ControlMessage2["SYNC_ENGINE_MODEL_SYNCED"] = "modelSynced";
  ControlMessage2["SYNC_ENGINE_OUTBOX_MUTATION_ENQUEUED"] = "outboxMutationEnqueued";
  ControlMessage2["SYNC_ENGINE_OUTBOX_MUTATION_PROCESSED"] = "outboxMutationProcessed";
  ControlMessage2["SYNC_ENGINE_OUTBOX_STATUS"] = "outboxStatus";
  ControlMessage2["SYNC_ENGINE_NETWORK_STATUS"] = "networkStatus";
  ControlMessage2["SYNC_ENGINE_READY"] = "ready";
})(ControlMessage || (ControlMessage = {}));
var SyncEngine = (
  /** @class */
  function() {
    function SyncEngine2(schema2, namespaceResolver2, modelClasses, userModelClasses, storage, modelInstanceCreator2, conflictHandler, errorHandler, syncPredicates, amplifyConfig, authModeStrategy, amplifyContext, connectivityMonitor) {
      var _this = this;
      if (amplifyConfig === void 0) {
        amplifyConfig = {};
      }
      this.schema = schema2;
      this.namespaceResolver = namespaceResolver2;
      this.modelClasses = modelClasses;
      this.userModelClasses = userModelClasses;
      this.storage = storage;
      this.modelInstanceCreator = modelInstanceCreator2;
      this.syncPredicates = syncPredicates;
      this.amplifyConfig = amplifyConfig;
      this.authModeStrategy = authModeStrategy;
      this.amplifyContext = amplifyContext;
      this.connectivityMonitor = connectivityMonitor;
      this.online = false;
      this.modelSyncedStatus = /* @__PURE__ */ new WeakMap();
      this.connectionDisrupted = false;
      this.runningProcesses = new BackgroundProcessManager();
      this.waitForSleepState = new Promise(function(resolve) {
        _this.syncQueriesObservableStartSleeping = resolve;
      });
      var MutationEvent = this.modelClasses["MutationEvent"];
      this.outbox = new MutationEventOutbox(this.schema, MutationEvent, modelInstanceCreator2, ownSymbol);
      this.modelMerger = new ModelMerger(this.outbox, ownSymbol);
      this.syncQueriesProcessor = new SyncProcessor(this.schema, this.syncPredicates, this.amplifyConfig, this.authModeStrategy, errorHandler, this.amplifyContext);
      this.subscriptionsProcessor = new SubscriptionProcessor(this.schema, this.syncPredicates, this.amplifyConfig, this.authModeStrategy, errorHandler, this.amplifyContext);
      this.mutationsProcessor = new MutationProcessor(this.schema, this.storage, this.userModelClasses, this.outbox, this.modelInstanceCreator, MutationEvent, this.amplifyConfig, this.authModeStrategy, errorHandler, conflictHandler, this.amplifyContext);
      this.datastoreConnectivity = this.connectivityMonitor || new datastoreConnectivity_default();
    }
    SyncEngine2.prototype.getModelSyncedStatus = function(modelConstructor) {
      return this.modelSyncedStatus.get(modelConstructor);
    };
    SyncEngine2.prototype.start = function(params) {
      var _this = this;
      return new bundle_esm_default(function(observer) {
        logger50.log("starting sync engine...");
        var subscriptions = [];
        _this.runningProcesses.add(function() {
          return __awaiter3(_this, void 0, void 0, function() {
            var err_1, startPromise, hasMutationsInOutbox;
            var _this2 = this;
            return __generator3(this, function(_a2) {
              switch (_a2.label) {
                case 0:
                  _a2.trys.push([0, 2, , 3]);
                  return [4, this.setupModels(params)];
                case 1:
                  _a2.sent();
                  return [3, 3];
                case 2:
                  err_1 = _a2.sent();
                  observer.error(err_1);
                  return [
                    2
                    /*return*/
                  ];
                case 3:
                  startPromise = new Promise(function(doneStarting, failedStarting) {
                    _this2.datastoreConnectivity.status().subscribe(function(_a3) {
                      var online = _a3.online;
                      return __awaiter3(_this2, void 0, void 0, function() {
                        var _this3 = this;
                        return __generator3(this, function(_b2) {
                          return [2, this.runningProcesses.isOpen && this.runningProcesses.add(function(onTerminate) {
                            return __awaiter3(_this3, void 0, void 0, function() {
                              var ctlSubsObservable_1, dataSubsObservable, err_2, error_1;
                              var _a4;
                              var _this4 = this;
                              return __generator3(this, function(_b3) {
                                switch (_b3.label) {
                                  case 0:
                                    if (!(online && !this.online))
                                      return [3, 10];
                                    this.online = online;
                                    observer.next({
                                      type: ControlMessage.SYNC_ENGINE_NETWORK_STATUS,
                                      data: {
                                        active: this.online
                                      }
                                    });
                                    dataSubsObservable = void 0;
                                    if (!isNode3)
                                      return [3, 1];
                                    logger50.warn("Realtime disabled when in a server-side environment");
                                    return [3, 6];
                                  case 1:
                                    this.stopDisruptionListener = this.startDisruptionListener();
                                    _a4 = __read10(this.subscriptionsProcessor.start(), 2), ctlSubsObservable_1 = _a4[0], dataSubsObservable = _a4[1];
                                    _b3.label = 2;
                                  case 2:
                                    _b3.trys.push([2, 4, , 5]);
                                    return [4, new Promise(function(resolve, reject) {
                                      onTerminate.then(reject);
                                      var ctlSubsSubscription = ctlSubsObservable_1.subscribe({
                                        next: function(msg) {
                                          if (msg === CONTROL_MSG2.CONNECTED) {
                                            resolve();
                                          }
                                        },
                                        error: function(err) {
                                          reject(err);
                                          var handleDisconnect = _this4.disconnectionHandler();
                                          handleDisconnect(err);
                                        }
                                      });
                                      subscriptions.push(ctlSubsSubscription);
                                    })];
                                  case 3:
                                    _b3.sent();
                                    return [3, 5];
                                  case 4:
                                    err_2 = _b3.sent();
                                    observer.error(err_2);
                                    failedStarting();
                                    return [
                                      2
                                      /*return*/
                                    ];
                                  case 5:
                                    logger50.log("Realtime ready");
                                    observer.next({
                                      type: ControlMessage.SYNC_ENGINE_SUBSCRIPTIONS_ESTABLISHED
                                    });
                                    _b3.label = 6;
                                  case 6:
                                    _b3.trys.push([6, 8, , 9]);
                                    return [4, new Promise(function(resolve, reject) {
                                      var syncQuerySubscription = _this4.syncQueriesObservable().subscribe({
                                        next: function(message) {
                                          var type = message.type;
                                          if (type === ControlMessage.SYNC_ENGINE_SYNC_QUERIES_READY) {
                                            resolve();
                                          }
                                          observer.next(message);
                                        },
                                        complete: function() {
                                          resolve();
                                        },
                                        error: function(error) {
                                          reject(error);
                                        }
                                      });
                                      if (syncQuerySubscription) {
                                        subscriptions.push(syncQuerySubscription);
                                      }
                                    })];
                                  case 7:
                                    _b3.sent();
                                    return [3, 9];
                                  case 8:
                                    error_1 = _b3.sent();
                                    observer.error(error_1);
                                    failedStarting();
                                    return [
                                      2
                                      /*return*/
                                    ];
                                  case 9:
                                    subscriptions.push(this.mutationsProcessor.start().subscribe(function(_a5) {
                                      var modelDefinition = _a5.modelDefinition, item = _a5.model, hasMore = _a5.hasMore;
                                      return _this4.runningProcesses.add(function() {
                                        return __awaiter3(_this4, void 0, void 0, function() {
                                          var modelConstructor, model;
                                          var _this5 = this;
                                          return __generator3(this, function(_a6) {
                                            switch (_a6.label) {
                                              case 0:
                                                modelConstructor = this.userModelClasses[modelDefinition.name];
                                                model = this.modelInstanceCreator(modelConstructor, item);
                                                return [4, this.storage.runExclusive(function(storage) {
                                                  return _this5.modelMerger.merge(storage, model, modelDefinition);
                                                })];
                                              case 1:
                                                _a6.sent();
                                                observer.next({
                                                  type: ControlMessage.SYNC_ENGINE_OUTBOX_MUTATION_PROCESSED,
                                                  data: {
                                                    model: modelConstructor,
                                                    element: model
                                                  }
                                                });
                                                observer.next({
                                                  type: ControlMessage.SYNC_ENGINE_OUTBOX_STATUS,
                                                  data: {
                                                    isEmpty: !hasMore
                                                  }
                                                });
                                                return [
                                                  2
                                                  /*return*/
                                                ];
                                            }
                                          });
                                        });
                                      }, "mutation processor event");
                                    }));
                                    if (!isNode3) {
                                      subscriptions.push(dataSubsObservable.subscribe(function(_a5) {
                                        var _b4 = __read10(_a5, 3), _transformerMutationType = _b4[0], modelDefinition = _b4[1], item = _b4[2];
                                        return _this4.runningProcesses.add(function() {
                                          return __awaiter3(_this4, void 0, void 0, function() {
                                            var modelConstructor, model;
                                            var _this5 = this;
                                            return __generator3(this, function(_a6) {
                                              switch (_a6.label) {
                                                case 0:
                                                  modelConstructor = this.userModelClasses[modelDefinition.name];
                                                  model = this.modelInstanceCreator(modelConstructor, item);
                                                  return [4, this.storage.runExclusive(function(storage) {
                                                    return _this5.modelMerger.merge(storage, model, modelDefinition);
                                                  })];
                                                case 1:
                                                  _a6.sent();
                                                  return [
                                                    2
                                                    /*return*/
                                                  ];
                                              }
                                            });
                                          });
                                        }, "subscription dataSubsObservable event");
                                      }));
                                    }
                                    return [3, 11];
                                  case 10:
                                    if (!online) {
                                      this.online = online;
                                      observer.next({
                                        type: ControlMessage.SYNC_ENGINE_NETWORK_STATUS,
                                        data: {
                                          active: this.online
                                        }
                                      });
                                      subscriptions.forEach(function(sub) {
                                        return sub.unsubscribe();
                                      });
                                      subscriptions = [];
                                    }
                                    _b3.label = 11;
                                  case 11:
                                    doneStarting();
                                    return [
                                      2
                                      /*return*/
                                    ];
                                }
                              });
                            });
                          }, "datastore connectivity event")];
                        });
                      });
                    });
                  });
                  this.storage.observe(null, null, ownSymbol).filter(function(_a3) {
                    var model = _a3.model;
                    var modelDefinition = _this2.getModelDefinition(model);
                    return modelDefinition.syncable === true;
                  }).subscribe({
                    next: function(_a3) {
                      var opType = _a3.opType, model = _a3.model, element = _a3.element, condition = _a3.condition;
                      return __awaiter3(_this2, void 0, void 0, function() {
                        var _this3 = this;
                        return __generator3(this, function(_b2) {
                          return [2, this.runningProcesses.add(function() {
                            return __awaiter3(_this3, void 0, void 0, function() {
                              var namespace, MutationEventConstructor, modelDefinition, graphQLCondition, mutationEvent;
                              return __generator3(this, function(_a4) {
                                switch (_a4.label) {
                                  case 0:
                                    namespace = this.schema.namespaces[this.namespaceResolver(model)];
                                    MutationEventConstructor = this.modelClasses["MutationEvent"];
                                    modelDefinition = this.getModelDefinition(model);
                                    graphQLCondition = predicateToGraphQLCondition(condition, modelDefinition);
                                    mutationEvent = createMutationInstanceFromModelOperation(namespace.relationships, this.getModelDefinition(model), opType, model, element, graphQLCondition, MutationEventConstructor, this.modelInstanceCreator);
                                    return [4, this.outbox.enqueue(this.storage, mutationEvent)];
                                  case 1:
                                    _a4.sent();
                                    observer.next({
                                      type: ControlMessage.SYNC_ENGINE_OUTBOX_MUTATION_ENQUEUED,
                                      data: {
                                        model,
                                        element
                                      }
                                    });
                                    observer.next({
                                      type: ControlMessage.SYNC_ENGINE_OUTBOX_STATUS,
                                      data: {
                                        isEmpty: false
                                      }
                                    });
                                    return [4, startPromise];
                                  case 2:
                                    _a4.sent();
                                    if (this.online) {
                                      this.mutationsProcessor.resume();
                                    }
                                    return [
                                      2
                                      /*return*/
                                    ];
                                }
                              });
                            });
                          }, "storage event")];
                        });
                      });
                    }
                  });
                  observer.next({
                    type: ControlMessage.SYNC_ENGINE_STORAGE_SUBSCRIBED
                  });
                  return [4, this.outbox.peek(this.storage)];
                case 4:
                  hasMutationsInOutbox = _a2.sent() === void 0;
                  observer.next({
                    type: ControlMessage.SYNC_ENGINE_OUTBOX_STATUS,
                    data: {
                      isEmpty: hasMutationsInOutbox
                    }
                  });
                  return [4, startPromise];
                case 5:
                  _a2.sent();
                  observer.next({
                    type: ControlMessage.SYNC_ENGINE_READY
                  });
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }, "sync start");
      });
    };
    SyncEngine2.prototype.getModelsMetadataWithNextFullSync = function(currentTimeStamp) {
      return __awaiter3(this, void 0, void 0, function() {
        var modelLastSync, _a2;
        var _this = this;
        return __generator3(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              _a2 = Map.bind;
              return [4, this.runningProcesses.add(function() {
                return _this.getModelsMetadata();
              }, "sync/index getModelsMetadataWithNextFullSync")];
            case 1:
              modelLastSync = new (_a2.apply(Map, [void 0, _b2.sent().map(function(_a3) {
                var namespace = _a3.namespace, model = _a3.model, lastSync = _a3.lastSync, lastFullSync = _a3.lastFullSync, fullSyncInterval = _a3.fullSyncInterval, lastSyncPredicate = _a3.lastSyncPredicate;
                var nextFullSync = lastFullSync + fullSyncInterval;
                var syncFrom = !lastFullSync || nextFullSync < currentTimeStamp ? 0 : lastSync;
                return [
                  _this.schema.namespaces[namespace].models[model],
                  [namespace, syncFrom]
                ];
              })]))();
              return [2, modelLastSync];
          }
        });
      });
    };
    SyncEngine2.prototype.syncQueriesObservable = function() {
      var _this = this;
      if (!this.online) {
        return bundle_esm_default.of();
      }
      return new bundle_esm_default(function(observer) {
        var syncQueriesSubscription;
        _this.runningProcesses.isOpen && _this.runningProcesses.add(function(onTerminate) {
          return __awaiter3(_this, void 0, void 0, function() {
            var terminated, _loop_1, this_1;
            var _this2 = this;
            return __generator3(this, function(_a2) {
              switch (_a2.label) {
                case 0:
                  terminated = false;
                  _loop_1 = function() {
                    var count, modelLastSync, paginatingModels, lastFullSyncStartedAt, syncInterval, start, syncDuration, lastStartedAt, msNextFullSync;
                    return __generator3(this, function(_a3) {
                      switch (_a3.label) {
                        case 0:
                          count = /* @__PURE__ */ new WeakMap();
                          return [4, this_1.getModelsMetadataWithNextFullSync(Date.now())];
                        case 1:
                          modelLastSync = _a3.sent();
                          paginatingModels = new Set(modelLastSync.keys());
                          return [4, new Promise(function(resolve, reject) {
                            if (!_this2.runningProcesses.isOpen)
                              resolve();
                            onTerminate.then(function() {
                              return resolve();
                            });
                            syncQueriesSubscription = _this2.syncQueriesProcessor.start(modelLastSync).subscribe({
                              next: function(_a4) {
                                var namespace = _a4.namespace, modelDefinition = _a4.modelDefinition, items = _a4.items, done = _a4.done, startedAt = _a4.startedAt, isFullSync = _a4.isFullSync;
                                return __awaiter3(_this2, void 0, void 0, function() {
                                  var modelConstructor, modelName, modelMetadata_1, lastFullSync, fullSyncInterval, counts;
                                  var _this3 = this;
                                  return __generator3(this, function(_b2) {
                                    switch (_b2.label) {
                                      case 0:
                                        modelConstructor = this.userModelClasses[modelDefinition.name];
                                        if (!count.has(modelConstructor)) {
                                          count.set(modelConstructor, {
                                            new: 0,
                                            updated: 0,
                                            deleted: 0
                                          });
                                          start = getNow();
                                          lastStartedAt = lastStartedAt === void 0 ? startedAt : Math.max(lastStartedAt, startedAt);
                                        }
                                        return [4, this.storage.runExclusive(function(storage) {
                                          return __awaiter3(_this3, void 0, void 0, function() {
                                            var idsInOutbox, oneByOne, page, opTypeCount, oneByOne_1, oneByOne_1_1, item, opType, e_1_1, _a5, _b3, _c, counts2;
                                            var e_1, _d;
                                            return __generator3(this, function(_e) {
                                              switch (_e.label) {
                                                case 0:
                                                  return [4, this.outbox.getModelIds(storage)];
                                                case 1:
                                                  idsInOutbox = _e.sent();
                                                  oneByOne = [];
                                                  page = items.filter(function(item2) {
                                                    var itemId = getIdentifierValue(modelDefinition, item2);
                                                    if (!idsInOutbox.has(itemId)) {
                                                      return true;
                                                    }
                                                    oneByOne.push(item2);
                                                    return false;
                                                  });
                                                  opTypeCount = [];
                                                  _e.label = 2;
                                                case 2:
                                                  _e.trys.push([2, 7, 8, 9]);
                                                  oneByOne_1 = __values4(oneByOne), oneByOne_1_1 = oneByOne_1.next();
                                                  _e.label = 3;
                                                case 3:
                                                  if (!!oneByOne_1_1.done)
                                                    return [3, 6];
                                                  item = oneByOne_1_1.value;
                                                  return [4, this.modelMerger.merge(storage, item, modelDefinition)];
                                                case 4:
                                                  opType = _e.sent();
                                                  if (opType !== void 0) {
                                                    opTypeCount.push([item, opType]);
                                                  }
                                                  _e.label = 5;
                                                case 5:
                                                  oneByOne_1_1 = oneByOne_1.next();
                                                  return [3, 3];
                                                case 6:
                                                  return [3, 9];
                                                case 7:
                                                  e_1_1 = _e.sent();
                                                  e_1 = { error: e_1_1 };
                                                  return [3, 9];
                                                case 8:
                                                  try {
                                                    if (oneByOne_1_1 && !oneByOne_1_1.done && (_d = oneByOne_1.return))
                                                      _d.call(oneByOne_1);
                                                  } finally {
                                                    if (e_1)
                                                      throw e_1.error;
                                                  }
                                                  return [
                                                    7
                                                    /*endfinally*/
                                                  ];
                                                case 9:
                                                  _b3 = (_a5 = opTypeCount.push).apply;
                                                  _c = [opTypeCount];
                                                  return [4, this.modelMerger.mergePage(storage, modelConstructor, page, modelDefinition)];
                                                case 10:
                                                  _b3.apply(_a5, _c.concat([__spread.apply(void 0, [_e.sent()])]));
                                                  counts2 = count.get(modelConstructor);
                                                  opTypeCount.forEach(function(_a6) {
                                                    var _b4 = __read10(_a6, 2), opType2 = _b4[1];
                                                    switch (opType2) {
                                                      case OpType.INSERT:
                                                        counts2.new++;
                                                        break;
                                                      case OpType.UPDATE:
                                                        counts2.updated++;
                                                        break;
                                                      case OpType.DELETE:
                                                        counts2.deleted++;
                                                        break;
                                                      default:
                                                        throw new Error("Invalid opType " + opType2);
                                                    }
                                                  });
                                                  return [
                                                    2
                                                    /*return*/
                                                  ];
                                              }
                                            });
                                          });
                                        })];
                                      case 1:
                                        _b2.sent();
                                        if (!done)
                                          return [3, 4];
                                        modelName = modelDefinition.name;
                                        return [4, this.getModelMetadata(namespace, modelName)];
                                      case 2:
                                        modelMetadata_1 = _b2.sent();
                                        lastFullSync = modelMetadata_1.lastFullSync, fullSyncInterval = modelMetadata_1.fullSyncInterval;
                                        syncInterval = fullSyncInterval;
                                        lastFullSyncStartedAt = lastFullSyncStartedAt === void 0 ? lastFullSync : Math.max(lastFullSyncStartedAt, isFullSync ? startedAt : lastFullSync);
                                        modelMetadata_1 = this.modelClasses.ModelMetadata.copyOf(modelMetadata_1, function(draft) {
                                          draft.lastSync = startedAt;
                                          draft.lastFullSync = isFullSync ? startedAt : modelMetadata_1.lastFullSync;
                                        });
                                        return [4, this.storage.save(modelMetadata_1, void 0, ownSymbol)];
                                      case 3:
                                        _b2.sent();
                                        counts = count.get(modelConstructor);
                                        this.modelSyncedStatus.set(modelConstructor, true);
                                        observer.next({
                                          type: ControlMessage.SYNC_ENGINE_MODEL_SYNCED,
                                          data: {
                                            model: modelConstructor,
                                            isFullSync,
                                            isDeltaSync: !isFullSync,
                                            counts
                                          }
                                        });
                                        paginatingModels.delete(modelDefinition);
                                        if (paginatingModels.size === 0) {
                                          syncDuration = getNow() - start;
                                          resolve();
                                          observer.next({
                                            type: ControlMessage.SYNC_ENGINE_SYNC_QUERIES_READY
                                          });
                                          syncQueriesSubscription.unsubscribe();
                                        }
                                        _b2.label = 4;
                                      case 4:
                                        return [
                                          2
                                          /*return*/
                                        ];
                                    }
                                  });
                                });
                              },
                              error: function(error) {
                                observer.error(error);
                              }
                            });
                            observer.next({
                              type: ControlMessage.SYNC_ENGINE_SYNC_QUERIES_STARTED,
                              data: {
                                models: Array.from(paginatingModels).map(function(_a4) {
                                  var name = _a4.name;
                                  return name;
                                })
                              }
                            });
                          })];
                        case 2:
                          _a3.sent();
                          if (!lastFullSyncStartedAt) {
                            msNextFullSync = syncInterval - syncDuration;
                          } else {
                            msNextFullSync = lastFullSyncStartedAt + syncInterval - (lastStartedAt + syncDuration);
                          }
                          logger50.debug("Next fullSync in " + msNextFullSync / 1e3 + " seconds. (" + new Date(Date.now() + msNextFullSync) + ")");
                          return [4, this_1.runningProcesses.add(function(onTerminate2) {
                            return __awaiter3(_this2, void 0, void 0, function() {
                              var sleepTimer, unsleep, sleep;
                              var _this3 = this;
                              return __generator3(this, function(_a4) {
                                sleep = new Promise(function(_unsleep) {
                                  unsleep = _unsleep;
                                  sleepTimer = setTimeout(unsleep, msNextFullSync);
                                });
                                onTerminate2.then(function() {
                                  terminated = true;
                                  _this3.syncQueriesObservableStartSleeping();
                                  unsleep();
                                });
                                this.unsleepSyncQueriesObservable = unsleep;
                                this.syncQueriesObservableStartSleeping();
                                return [2, sleep];
                              });
                            });
                          }, "syncQueriesObservable sleep")];
                        case 3:
                          _a3.sent();
                          this_1.unsleepSyncQueriesObservable = null;
                          this_1.waitForSleepState = new Promise(function(resolve) {
                            _this2.syncQueriesObservableStartSleeping = resolve;
                          });
                          return [
                            2
                            /*return*/
                          ];
                      }
                    });
                  };
                  this_1 = this;
                  _a2.label = 1;
                case 1:
                  if (!(!observer.closed && !terminated))
                    return [3, 3];
                  return [5, _loop_1()];
                case 2:
                  _a2.sent();
                  return [3, 1];
                case 3:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }, "syncQueriesObservable main");
      });
    };
    SyncEngine2.prototype.disconnectionHandler = function() {
      var _this = this;
      return function(msg) {
        if (CONTROL_MSG.CONNECTION_CLOSED === msg || CONTROL_MSG.TIMEOUT_DISCONNECT === msg) {
          _this.datastoreConnectivity.socketDisconnected();
        }
      };
    };
    SyncEngine2.prototype.unsubscribeConnectivity = function() {
      this.datastoreConnectivity.unsubscribe();
    };
    SyncEngine2.prototype.stop = function() {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              logger50.debug("stopping sync engine");
              this.unsubscribeConnectivity();
              this.stopDisruptionListener && this.stopDisruptionListener();
              return [4, this.mutationsProcessor.stop()];
            case 1:
              _a2.sent();
              return [4, this.subscriptionsProcessor.stop()];
            case 2:
              _a2.sent();
              return [4, this.datastoreConnectivity.stop()];
            case 3:
              _a2.sent();
              return [4, this.syncQueriesProcessor.stop()];
            case 4:
              _a2.sent();
              return [4, this.runningProcesses.close()];
            case 5:
              _a2.sent();
              return [4, this.runningProcesses.open()];
            case 6:
              _a2.sent();
              logger50.debug("sync engine stopped and ready to restart");
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    SyncEngine2.prototype.setupModels = function(params) {
      return __awaiter3(this, void 0, void 0, function() {
        var fullSyncInterval, ModelMetadataConstructor, models, savedModel, promises, result, _a2, _b2, modelMetadata, modelName, e_2_1;
        var e_2, _c;
        var _this = this;
        return __generator3(this, function(_d) {
          switch (_d.label) {
            case 0:
              fullSyncInterval = params.fullSyncInterval;
              ModelMetadataConstructor = this.modelClasses.ModelMetadata;
              models = [];
              Object.values(this.schema.namespaces).forEach(function(namespace) {
                Object.values(namespace.models).filter(function(_a3) {
                  var syncable = _a3.syncable;
                  return syncable;
                }).forEach(function(model) {
                  models.push([namespace.name, model]);
                  if (namespace.name === USER) {
                    var modelConstructor = _this.userModelClasses[model.name];
                    _this.modelSyncedStatus.set(modelConstructor, false);
                  }
                });
              });
              promises = models.map(function(_a3) {
                var _b3 = __read10(_a3, 2), namespace = _b3[0], model = _b3[1];
                return __awaiter3(_this, void 0, void 0, function() {
                  var modelMetadata2, syncPredicate, lastSyncPredicate, prevSyncPredicate, syncPredicateUpdated_1;
                  var _c2, _d2, _e, _f;
                  return __generator3(this, function(_g) {
                    switch (_g.label) {
                      case 0:
                        return [4, this.getModelMetadata(namespace, model.name)];
                      case 1:
                        modelMetadata2 = _g.sent();
                        syncPredicate = ModelPredicateCreator.getPredicates(this.syncPredicates.get(model), false);
                        lastSyncPredicate = syncPredicate ? JSON.stringify(syncPredicate) : null;
                        if (!(modelMetadata2 === void 0))
                          return [3, 3];
                        return [4, this.storage.save(this.modelInstanceCreator(ModelMetadataConstructor, {
                          model: model.name,
                          namespace,
                          lastSync: null,
                          fullSyncInterval,
                          lastFullSync: null,
                          lastSyncPredicate
                        }), void 0, ownSymbol)];
                      case 2:
                        _c2 = __read10.apply(void 0, [_g.sent(), 1]), _d2 = __read10(_c2[0], 1), savedModel = _d2[0];
                        return [3, 5];
                      case 3:
                        prevSyncPredicate = modelMetadata2.lastSyncPredicate ? modelMetadata2.lastSyncPredicate : null;
                        syncPredicateUpdated_1 = prevSyncPredicate !== lastSyncPredicate;
                        return [4, this.storage.save(ModelMetadataConstructor.copyOf(modelMetadata2, function(draft) {
                          draft.fullSyncInterval = fullSyncInterval;
                          if (syncPredicateUpdated_1) {
                            draft.lastSync = null;
                            draft.lastFullSync = null;
                            draft.lastSyncPredicate = lastSyncPredicate;
                          }
                        }))];
                      case 4:
                        _e = __read10.apply(void 0, [_g.sent(), 1]), _f = __read10(_e[0], 1), savedModel = _f[0];
                        _g.label = 5;
                      case 5:
                        return [2, savedModel];
                    }
                  });
                });
              });
              result = {};
              _d.label = 1;
            case 1:
              _d.trys.push([1, 6, 7, 8]);
              return [4, Promise.all(promises)];
            case 2:
              _a2 = __values4.apply(void 0, [_d.sent()]), _b2 = _a2.next();
              _d.label = 3;
            case 3:
              if (!!_b2.done)
                return [3, 5];
              modelMetadata = _b2.value;
              modelName = modelMetadata.model;
              result[modelName] = modelMetadata;
              _d.label = 4;
            case 4:
              _b2 = _a2.next();
              return [3, 3];
            case 5:
              return [3, 8];
            case 6:
              e_2_1 = _d.sent();
              e_2 = { error: e_2_1 };
              return [3, 8];
            case 7:
              try {
                if (_b2 && !_b2.done && (_c = _a2.return))
                  _c.call(_a2);
              } finally {
                if (e_2)
                  throw e_2.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 8:
              return [2, result];
          }
        });
      });
    };
    SyncEngine2.prototype.getModelsMetadata = function() {
      return __awaiter3(this, void 0, void 0, function() {
        var ModelMetadata, modelsMetadata;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              ModelMetadata = this.modelClasses.ModelMetadata;
              return [4, this.storage.query(ModelMetadata)];
            case 1:
              modelsMetadata = _a2.sent();
              return [2, modelsMetadata];
          }
        });
      });
    };
    SyncEngine2.prototype.getModelMetadata = function(namespace, model) {
      return __awaiter3(this, void 0, void 0, function() {
        var ModelMetadata, predicate, _a2, modelMetadata;
        return __generator3(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              ModelMetadata = this.modelClasses.ModelMetadata;
              predicate = ModelPredicateCreator.createFromAST(this.schema.namespaces[SYNC].models[ModelMetadata.name], { and: [{ namespace: { eq: namespace } }, { model: { eq: model } }] });
              return [4, this.storage.query(ModelMetadata, predicate, {
                page: 0,
                limit: 1
              })];
            case 1:
              _a2 = __read10.apply(void 0, [_b2.sent(), 1]), modelMetadata = _a2[0];
              return [2, modelMetadata];
          }
        });
      });
    };
    SyncEngine2.prototype.getModelDefinition = function(modelConstructor) {
      var namespaceName = this.namespaceResolver(modelConstructor);
      var modelDefinition = this.schema.namespaces[namespaceName].models[modelConstructor.name];
      return modelDefinition;
    };
    SyncEngine2.getNamespace = function() {
      var namespace = {
        name: SYNC,
        relationships: {},
        enums: {
          OperationType: {
            name: "OperationType",
            values: ["CREATE", "UPDATE", "DELETE"]
          }
        },
        nonModels: {},
        models: {
          MutationEvent: {
            name: "MutationEvent",
            pluralName: "MutationEvents",
            syncable: false,
            fields: {
              id: {
                name: "id",
                type: "ID",
                isRequired: true,
                isArray: false
              },
              model: {
                name: "model",
                type: "String",
                isRequired: true,
                isArray: false
              },
              data: {
                name: "data",
                type: "String",
                isRequired: true,
                isArray: false
              },
              modelId: {
                name: "modelId",
                type: "String",
                isRequired: true,
                isArray: false
              },
              operation: {
                name: "operation",
                type: {
                  enum: "Operationtype"
                },
                isArray: false,
                isRequired: true
              },
              condition: {
                name: "condition",
                type: "String",
                isArray: false,
                isRequired: true
              }
            }
          },
          ModelMetadata: {
            name: "ModelMetadata",
            pluralName: "ModelsMetadata",
            syncable: false,
            fields: {
              id: {
                name: "id",
                type: "ID",
                isRequired: true,
                isArray: false
              },
              namespace: {
                name: "namespace",
                type: "String",
                isRequired: true,
                isArray: false
              },
              model: {
                name: "model",
                type: "String",
                isRequired: true,
                isArray: false
              },
              lastSync: {
                name: "lastSync",
                type: "Int",
                isRequired: false,
                isArray: false
              },
              lastFullSync: {
                name: "lastFullSync",
                type: "Int",
                isRequired: false,
                isArray: false
              },
              fullSyncInterval: {
                name: "fullSyncInterval",
                type: "Int",
                isRequired: true,
                isArray: false
              },
              lastSyncPredicate: {
                name: "lastSyncPredicate",
                type: "String",
                isRequired: false,
                isArray: false
              }
            }
          }
        }
      };
      return namespace;
    };
    SyncEngine2.prototype.startDisruptionListener = function() {
      var _this = this;
      return Hub.listen("api", function(data) {
        if (data.source === "PubSub" && data.payload.event === CONNECTION_STATE_CHANGE) {
          var connectionState = data.payload.data.connectionState;
          switch (connectionState) {
            case ConnectionState.ConnectionDisrupted:
              _this.connectionDisrupted = true;
              break;
            case ConnectionState.Connected:
              if (_this.connectionDisrupted) {
                _this.scheduleSync();
              }
              _this.connectionDisrupted = false;
              break;
          }
        }
      });
    };
    SyncEngine2.prototype.scheduleSync = function() {
      var _this = this;
      return this.runningProcesses.isOpen && this.runningProcesses.add(function() {
        return _this.waitForSleepState.then(function() {
          _this.unsleepSyncQueriesObservable();
        });
      });
    };
    return SyncEngine2;
  }()
);

// node_modules/@aws-amplify/datastore/lib-esm/predicates/next.js
var ops = __spread(comparisonKeys);
var predicateInternalsMap = /* @__PURE__ */ new Map();
var registerPredicateInternals = function(condition, key) {
  var finalKey = key || new PredicateInternalsKey();
  predicateInternalsMap.set(finalKey, condition);
  return finalKey;
};
var internals = function(key) {
  if (!predicateInternalsMap.has(key)) {
    throw new Error("Invalid predicate. Terminate your predicate with a valid condition (e.g., `p => p.field.eq('value')`) or pass `Predicates.ALL`.");
  }
  return predicateInternalsMap.get(key);
};
var negations = {
  and: "or",
  or: "and",
  not: "and",
  eq: "ne",
  ne: "eq",
  gt: "le",
  ge: "lt",
  lt: "ge",
  le: "gt",
  contains: "notContains",
  notContains: "contains"
};
var FieldCondition = (
  /** @class */
  function() {
    function FieldCondition2(field, operator, operands) {
      this.field = field;
      this.operator = operator;
      this.operands = operands;
      this.validate();
    }
    FieldCondition2.prototype.copy = function(extract) {
      return [
        new FieldCondition2(this.field, this.operator, __spread(this.operands)),
        void 0
      ];
    };
    FieldCondition2.prototype.toAST = function() {
      var _a2, _b2;
      return _a2 = {}, _a2[this.field] = (_b2 = {}, _b2[this.operator] = this.operator === "between" ? [this.operands[0], this.operands[1]] : this.operands[0], _b2), _a2;
    };
    FieldCondition2.prototype.negated = function(model) {
      if (this.operator === "between") {
        return new GroupCondition(model, void 0, void 0, "or", [
          new FieldCondition2(this.field, "lt", [this.operands[0]]),
          new FieldCondition2(this.field, "gt", [this.operands[1]])
        ]);
      } else if (this.operator === "beginsWith") {
        return new GroupCondition(model, void 0, void 0, "not", [
          new FieldCondition2(this.field, "beginsWith", [this.operands[0]])
        ]);
      } else {
        return new FieldCondition2(this.field, negations[this.operator], this.operands);
      }
    };
    FieldCondition2.prototype.fetch = function(storage) {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          return [2, Promise.reject("No implementation needed [yet].")];
        });
      });
    };
    FieldCondition2.prototype.matches = function(item) {
      return __awaiter3(this, void 0, void 0, function() {
        var v2, operations, operation, result;
        var _this = this;
        return __generator3(this, function(_a2) {
          v2 = item[this.field];
          operations = {
            eq: function() {
              return v2 === _this.operands[0];
            },
            ne: function() {
              return v2 !== _this.operands[0];
            },
            gt: function() {
              return v2 > _this.operands[0];
            },
            ge: function() {
              return v2 >= _this.operands[0];
            },
            lt: function() {
              return v2 < _this.operands[0];
            },
            le: function() {
              return v2 <= _this.operands[0];
            },
            contains: function() {
              return (v2 === null || v2 === void 0 ? void 0 : v2.indexOf(_this.operands[0])) > -1;
            },
            notContains: function() {
              return !v2 ? true : v2.indexOf(_this.operands[0]) === -1;
            },
            beginsWith: function() {
              return v2 === null || v2 === void 0 ? void 0 : v2.startsWith(_this.operands[0]);
            },
            between: function() {
              return v2 >= _this.operands[0] && v2 <= _this.operands[1];
            }
          };
          operation = operations[this.operator];
          if (operation) {
            result = operation();
            return [2, result];
          } else {
            throw new Error("Invalid operator given: " + this.operator);
          }
          return [
            2
            /*return*/
          ];
        });
      });
    };
    FieldCondition2.prototype.validate = function() {
      var _this = this;
      var argumentCount = function(count) {
        var argsClause = count === 1 ? "argument is" : "arguments are";
        return function() {
          if (_this.operands.length !== count) {
            return "Exactly " + count + " " + argsClause + " required.";
          }
        };
      };
      var validations = {
        eq: argumentCount(1),
        ne: argumentCount(1),
        gt: argumentCount(1),
        ge: argumentCount(1),
        lt: argumentCount(1),
        le: argumentCount(1),
        contains: argumentCount(1),
        notContains: argumentCount(1),
        beginsWith: argumentCount(1),
        between: function() {
          return argumentCount(2)() || (_this.operands[0] > _this.operands[1] ? "The first argument must be less than or equal to the second argument." : null);
        }
      };
      var validate3 = validations[this.operator];
      if (validate3) {
        var e = validate3();
        if (typeof e === "string")
          throw new Error("Incorrect usage of `" + this.operator + "()`: " + e);
      } else {
        throw new Error("Non-existent operator: `" + this.operator + "()`");
      }
    };
    return FieldCondition2;
  }()
);
var getGroupId = function() {
  var seed = 1;
  return function() {
    return "group_" + seed++;
  };
}();
var GroupCondition = (
  /** @class */
  function() {
    function GroupCondition2(model, field, relationshipType, operator, operands, isOptimized) {
      if (isOptimized === void 0) {
        isOptimized = false;
      }
      this.model = model;
      this.field = field;
      this.relationshipType = relationshipType;
      this.operator = operator;
      this.operands = operands;
      this.isOptimized = isOptimized;
      this.groupId = getGroupId();
    }
    GroupCondition2.prototype.copy = function(extract) {
      var copied = new GroupCondition2(this.model, this.field, this.relationshipType, this.operator, []);
      var extractedCopy = extract === this ? copied : void 0;
      this.operands.forEach(function(o2) {
        var _a2 = __read10(o2.copy(extract), 2), operandCopy = _a2[0], extractedFromOperand = _a2[1];
        copied.operands.push(operandCopy);
        extractedCopy = extractedCopy || extractedFromOperand;
      });
      return [copied, extractedCopy];
    };
    GroupCondition2.prototype.withFieldConditionsOnly = function(negate2) {
      var _this = this;
      var negateChildren = negate2 !== (this.operator === "not");
      return new GroupCondition2(this.model, void 0, void 0, negate2 ? negations[this.operator] : this.operator, this.operands.filter(function(o2) {
        return o2 instanceof FieldCondition;
      }).map(function(o2) {
        return negateChildren ? o2.negated(_this.model) : o2;
      }));
    };
    GroupCondition2.prototype.optimized = function(preserveNode) {
      var _this = this;
      if (preserveNode === void 0) {
        preserveNode = true;
      }
      var operands = this.operands.map(function(o2) {
        return o2 instanceof GroupCondition2 ? o2.optimized(_this.operator === "not") : o2;
      });
      if (!preserveNode && ["and", "or"].includes(this.operator) && !this.field && operands.length === 1) {
        var operand = operands[0];
        if (operand instanceof FieldCondition) {
          if (operand.operator !== "between") {
            return operand;
          }
        } else {
          return operand;
        }
      }
      return new GroupCondition2(this.model, this.field, this.relationshipType, this.operator, operands, true);
    };
    GroupCondition2.prototype.fetch = function(storage, breadcrumb, negate2) {
      if (breadcrumb === void 0) {
        breadcrumb = [];
      }
      if (negate2 === void 0) {
        negate2 = false;
      }
      return __awaiter3(this, void 0, void 0, function() {
        var resultGroups, operator, negateChildren, groups, conditions, groups_1, groups_1_1, g2, relatives, relationship, allJoinConditions, relatives_1, relatives_1_1, relative, relativeConditions, i2, predicate, _a2, _b2, e_1_1, predicate, _c, _d, _e, _f, getPKValue, resultIndex, resultGroups_1, resultGroups_1_1, group, intersectWith, _g, _h, k2, resultGroups_2, resultGroups_2_1, group, group_1, group_1_1, item;
        var e_1, _j, e_2, _k, _l, e_3, _m, e_4, _o, e_5, _p, e_6, _q;
        var _this = this;
        return __generator3(this, function(_r) {
          switch (_r.label) {
            case 0:
              if (!this.isOptimized) {
                return [2, this.optimized().fetch(storage)];
              }
              resultGroups = [];
              operator = negate2 ? negations[this.operator] : this.operator;
              negateChildren = negate2 !== (this.operator === "not");
              groups = this.operands.filter(function(op) {
                return op instanceof GroupCondition2;
              });
              conditions = this.operands.filter(function(op) {
                return op instanceof FieldCondition;
              });
              _r.label = 1;
            case 1:
              _r.trys.push([1, 10, 11, 12]);
              groups_1 = __values4(groups), groups_1_1 = groups_1.next();
              _r.label = 2;
            case 2:
              if (!!groups_1_1.done)
                return [3, 9];
              g2 = groups_1_1.value;
              return [4, g2.fetch(storage, __spread(breadcrumb, [this.groupId]), negateChildren)];
            case 3:
              relatives = _r.sent();
              if (relatives.length === 0) {
                if (operator === "and") {
                  return [2, []];
                }
                resultGroups.push([]);
                return [3, 8];
              }
              if (!g2.field)
                return [3, 7];
              relationship = ModelRelationship.from(this.model, g2.field);
              if (!relationship)
                return [3, 5];
              allJoinConditions = [];
              try {
                for (relatives_1 = (e_2 = void 0, __values4(relatives)), relatives_1_1 = relatives_1.next(); !relatives_1_1.done; relatives_1_1 = relatives_1.next()) {
                  relative = relatives_1_1.value;
                  relativeConditions = [];
                  for (i2 = 0; i2 < relationship.localJoinFields.length; i2++) {
                    relativeConditions.push((_l = {}, _l[relationship.localJoinFields[i2]] = {
                      eq: relative[relationship.remoteJoinFields[i2]]
                    }, _l));
                  }
                  allJoinConditions.push({ and: relativeConditions });
                }
              } catch (e_2_1) {
                e_2 = { error: e_2_1 };
              } finally {
                try {
                  if (relatives_1_1 && !relatives_1_1.done && (_k = relatives_1.return))
                    _k.call(relatives_1);
                } finally {
                  if (e_2)
                    throw e_2.error;
                }
              }
              predicate = ModelPredicateCreator.createFromAST(this.model.schema, {
                or: allJoinConditions
              });
              _b2 = (_a2 = resultGroups).push;
              return [4, storage.query(this.model.builder, predicate)];
            case 4:
              _b2.apply(_a2, [_r.sent()]);
              return [3, 6];
            case 5:
              throw new Error("Missing field metadata.");
            case 6:
              return [3, 8];
            case 7:
              resultGroups.push(relatives);
              _r.label = 8;
            case 8:
              groups_1_1 = groups_1.next();
              return [3, 2];
            case 9:
              return [3, 12];
            case 10:
              e_1_1 = _r.sent();
              e_1 = { error: e_1_1 };
              return [3, 12];
            case 11:
              try {
                if (groups_1_1 && !groups_1_1.done && (_j = groups_1.return))
                  _j.call(groups_1);
              } finally {
                if (e_1)
                  throw e_1.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 12:
              if (!(conditions.length > 0))
                return [3, 14];
              predicate = this.withFieldConditionsOnly(negateChildren).toStoragePredicate();
              _d = (_c = resultGroups).push;
              return [4, storage.query(this.model.builder, predicate)];
            case 13:
              _d.apply(_c, [_r.sent()]);
              return [3, 16];
            case 14:
              if (!(conditions.length === 0 && resultGroups.length === 0))
                return [3, 16];
              _f = (_e = resultGroups).push;
              return [4, storage.query(this.model.builder)];
            case 15:
              _f.apply(_e, [_r.sent()]);
              _r.label = 16;
            case 16:
              getPKValue = function(item2) {
                return JSON.stringify(_this.model.pkField.map(function(name) {
                  return item2[name];
                }));
              };
              if (operator === "and") {
                if (resultGroups.length === 0) {
                  return [2, []];
                }
                try {
                  for (resultGroups_1 = __values4(resultGroups), resultGroups_1_1 = resultGroups_1.next(); !resultGroups_1_1.done; resultGroups_1_1 = resultGroups_1.next()) {
                    group = resultGroups_1_1.value;
                    if (resultIndex === void 0) {
                      resultIndex = new Map(group.map(function(item2) {
                        return [getPKValue(item2), item2];
                      }));
                    } else {
                      intersectWith = new Map(group.map(function(item2) {
                        return [getPKValue(item2), item2];
                      }));
                      try {
                        for (_g = (e_4 = void 0, __values4(resultIndex.keys())), _h = _g.next(); !_h.done; _h = _g.next()) {
                          k2 = _h.value;
                          if (!intersectWith.has(k2)) {
                            resultIndex.delete(k2);
                          }
                        }
                      } catch (e_4_1) {
                        e_4 = { error: e_4_1 };
                      } finally {
                        try {
                          if (_h && !_h.done && (_o = _g.return))
                            _o.call(_g);
                        } finally {
                          if (e_4)
                            throw e_4.error;
                        }
                      }
                    }
                  }
                } catch (e_3_1) {
                  e_3 = { error: e_3_1 };
                } finally {
                  try {
                    if (resultGroups_1_1 && !resultGroups_1_1.done && (_m = resultGroups_1.return))
                      _m.call(resultGroups_1);
                  } finally {
                    if (e_3)
                      throw e_3.error;
                  }
                }
              } else if (operator === "or" || operator === "not") {
                resultIndex = /* @__PURE__ */ new Map();
                try {
                  for (resultGroups_2 = __values4(resultGroups), resultGroups_2_1 = resultGroups_2.next(); !resultGroups_2_1.done; resultGroups_2_1 = resultGroups_2.next()) {
                    group = resultGroups_2_1.value;
                    try {
                      for (group_1 = (e_6 = void 0, __values4(group)), group_1_1 = group_1.next(); !group_1_1.done; group_1_1 = group_1.next()) {
                        item = group_1_1.value;
                        resultIndex.set(getPKValue(item), item);
                      }
                    } catch (e_6_1) {
                      e_6 = { error: e_6_1 };
                    } finally {
                      try {
                        if (group_1_1 && !group_1_1.done && (_q = group_1.return))
                          _q.call(group_1);
                      } finally {
                        if (e_6)
                          throw e_6.error;
                      }
                    }
                  }
                } catch (e_5_1) {
                  e_5 = { error: e_5_1 };
                } finally {
                  try {
                    if (resultGroups_2_1 && !resultGroups_2_1.done && (_p = resultGroups_2.return))
                      _p.call(resultGroups_2);
                  } finally {
                    if (e_5)
                      throw e_5.error;
                  }
                }
              }
              return [2, Array.from((resultIndex === null || resultIndex === void 0 ? void 0 : resultIndex.values()) || [])];
          }
        });
      });
    };
    GroupCondition2.prototype.matches = function(item, ignoreFieldName) {
      if (ignoreFieldName === void 0) {
        ignoreFieldName = false;
      }
      var e_7, _a2;
      return __awaiter3(this, void 0, void 0, function() {
        var itemToCheck, _b2, itemToCheck_1, itemToCheck_1_1, singleItem, e_7_1;
        return __generator3(this, function(_c) {
          switch (_c.label) {
            case 0:
              if (!(this.field && !ignoreFieldName))
                return [3, 2];
              return [4, item[this.field]];
            case 1:
              _b2 = _c.sent();
              return [3, 3];
            case 2:
              _b2 = item;
              _c.label = 3;
            case 3:
              itemToCheck = _b2;
              if (!itemToCheck) {
                return [2, false];
              }
              if (!(this.relationshipType === "HAS_MANY" && typeof itemToCheck[Symbol.asyncIterator] === "function"))
                return [3, 17];
              _c.label = 4;
            case 4:
              _c.trys.push([4, 10, 11, 16]);
              itemToCheck_1 = __asyncValues(itemToCheck);
              _c.label = 5;
            case 5:
              return [4, itemToCheck_1.next()];
            case 6:
              if (!(itemToCheck_1_1 = _c.sent(), !itemToCheck_1_1.done))
                return [3, 9];
              singleItem = itemToCheck_1_1.value;
              return [4, this.matches(singleItem, true)];
            case 7:
              if (_c.sent()) {
                return [2, true];
              }
              _c.label = 8;
            case 8:
              return [3, 5];
            case 9:
              return [3, 16];
            case 10:
              e_7_1 = _c.sent();
              e_7 = { error: e_7_1 };
              return [3, 16];
            case 11:
              _c.trys.push([11, , 14, 15]);
              if (!(itemToCheck_1_1 && !itemToCheck_1_1.done && (_a2 = itemToCheck_1.return)))
                return [3, 13];
              return [4, _a2.call(itemToCheck_1)];
            case 12:
              _c.sent();
              _c.label = 13;
            case 13:
              return [3, 15];
            case 14:
              if (e_7)
                throw e_7.error;
              return [
                7
                /*endfinally*/
              ];
            case 15:
              return [
                7
                /*endfinally*/
              ];
            case 16:
              return [2, false];
            case 17:
              if (!(this.operator === "or"))
                return [3, 18];
              return [2, asyncSome(this.operands, function(c2) {
                return c2.matches(itemToCheck);
              })];
            case 18:
              if (!(this.operator === "and"))
                return [3, 19];
              return [2, asyncEvery(this.operands, function(c2) {
                return c2.matches(itemToCheck);
              })];
            case 19:
              if (!(this.operator === "not"))
                return [3, 21];
              if (this.operands.length !== 1) {
                throw new Error("Invalid arguments! `not()` accepts exactly one predicate expression.");
              }
              return [4, this.operands[0].matches(itemToCheck)];
            case 20:
              return [2, !_c.sent()];
            case 21:
              throw new Error("Invalid group operator!");
          }
        });
      });
    };
    GroupCondition2.prototype.toAST = function() {
      var _a2;
      if (this.field)
        throw new Error("Nested type conditions are not supported!");
      return _a2 = {}, _a2[this.operator] = this.operands.map(function(operand) {
        return operand.toAST();
      }), _a2;
    };
    GroupCondition2.prototype.toStoragePredicate = function() {
      return ModelPredicateCreator.createFromAST(this.model.schema, this.toAST());
    };
    GroupCondition2.prototype.toJSON = function() {
      return __assign7(__assign7({}, this), { model: this.model.schema.name });
    };
    return GroupCondition2;
  }()
);
function recursivePredicateFor(ModelType, allowRecursion, field, query, tail) {
  if (allowRecursion === void 0) {
    allowRecursion = true;
  }
  var starter = new GroupCondition(ModelType, field, void 0, "and", []);
  var baseCondition = query && tail ? query : starter;
  var tailCondition = query && tail ? tail : starter;
  var link = {};
  registerPredicateInternals(baseCondition, link);
  var copyLink = function() {
    var _a2 = __read10(baseCondition.copy(tailCondition), 2), query2 = _a2[0], newTail = _a2[1];
    var newLink = recursivePredicateFor(ModelType, allowRecursion, void 0, query2, newTail);
    return { query: query2, newTail, newLink };
  };
  ["and", "or"].forEach(function(op) {
    link[op] = function(builder) {
      var _a2 = copyLink(), query2 = _a2.query, newTail = _a2.newTail;
      var childConditions = builder(recursivePredicateFor(ModelType, allowRecursion));
      if (!Array.isArray(childConditions)) {
        throw new Error("Invalid predicate. `" + op + "` groups must return an array of child conditions.");
      }
      newTail === null || newTail === void 0 ? void 0 : newTail.operands.push(new GroupCondition(ModelType, field, void 0, op, childConditions.map(function(c2) {
        return internals(c2);
      })));
      return registerPredicateInternals(query2);
    };
  });
  link.not = function(builder) {
    var _a2 = copyLink(), query2 = _a2.query, newTail = _a2.newTail;
    newTail === null || newTail === void 0 ? void 0 : newTail.operands.push(new GroupCondition(ModelType, field, void 0, "not", [
      internals(builder(recursivePredicateFor(ModelType, allowRecursion)))
    ]));
    return registerPredicateInternals(query2);
  };
  var _loop_1 = function(fieldName2) {
    Object.defineProperty(link, fieldName2, {
      enumerable: true,
      get: function() {
        var def = ModelType.schema.allFields[fieldName2];
        if (!def.association) {
          return ops.reduce(function(fieldMatcher, operator) {
            var _a3;
            return __assign7(__assign7({}, fieldMatcher), (_a3 = {}, _a3[operator] = function() {
              var operands = [];
              for (var _i = 0; _i < arguments.length; _i++) {
                operands[_i] = arguments[_i];
              }
              var _a4 = copyLink(), query2 = _a4.query, newTail = _a4.newTail;
              var normalizedOperands = operands.map(function(o2) {
                return o2 === void 0 ? null : o2;
              });
              newTail === null || newTail === void 0 ? void 0 : newTail.operands.push(new FieldCondition(fieldName2, operator, normalizedOperands));
              return registerPredicateInternals(query2);
            }, _a3));
          }, {});
        } else {
          if (!allowRecursion) {
            throw new Error("Predication on releated models is not supported in this context.");
          } else if (def.association.connectionType === "BELONGS_TO" || def.association.connectionType === "HAS_ONE" || def.association.connectionType === "HAS_MANY") {
            var relatedMeta = def.type.modelConstructor;
            if (!relatedMeta) {
              throw new Error("Related model metadata is missing. This is a bug! Please report it.");
            }
            var _a2 = __read10(baseCondition.copy(tailCondition), 2), newquery = _a2[0], oldtail = _a2[1];
            var newtail = new GroupCondition(relatedMeta, fieldName2, def.association.connectionType, "and", []);
            oldtail.operands.push(newtail);
            var newlink = recursivePredicateFor(relatedMeta, allowRecursion, void 0, newquery, newtail);
            return newlink;
          } else {
            throw new Error("Related model definition doesn't have a typedef. This is a bug! Please report it.");
          }
        }
      }
    });
  };
  for (var fieldName in ModelType.schema.allFields) {
    _loop_1(fieldName);
  }
  return link;
}
function predicateFor(ModelType) {
  return recursivePredicateFor(ModelType, false);
}

// node_modules/@aws-amplify/datastore/lib-esm/datastore/datastore.js
sn(true);
T();
var logger51 = new ConsoleLogger("DataStore");
var ulid2 = monotonicUlidFactory(Date.now());
var isNode4 = browserOrNode().isNode;
var SETTING_SCHEMA_VERSION = "schemaVersion";
var schema;
var modelNamespaceMap = /* @__PURE__ */ new WeakMap();
var modelPatchesMap = /* @__PURE__ */ new WeakMap();
var getModelDefinition = function(modelConstructor) {
  var namespace = modelNamespaceMap.get(modelConstructor);
  var definition = namespace ? schema.namespaces[namespace].models[modelConstructor.name] : void 0;
  return definition;
};
var isValidModelConstructor = function(obj) {
  return isModelConstructor(obj) && modelNamespaceMap.has(obj);
};
var namespaceResolver = function(modelConstructor) {
  var resolver = modelNamespaceMap.get(modelConstructor);
  if (!resolver) {
    throw new Error("Namespace Resolver for '" + modelConstructor.name + "' not found! This is probably a bug in '@amplify-js/datastore'.");
  }
  return resolver;
};
var buildSeedPredicate = function(modelConstructor) {
  if (!modelConstructor)
    throw new Error("Missing modelConstructor");
  var modelSchema = getModelDefinition(modelConstructor);
  if (!modelSchema)
    throw new Error("Missing modelSchema");
  var pks = extractPrimaryKeyFieldNames(modelSchema);
  if (!pks)
    throw new Error("Could not determine PK");
  return recursivePredicateFor({
    builder: modelConstructor,
    schema: modelSchema,
    pkField: pks
  });
};
var syncClasses;
var userClasses;
var dataStoreClasses;
var storageClasses;
var ModelAttachment;
(function(ModelAttachment2) {
  ModelAttachment2["Detached"] = "Detached";
  ModelAttachment2["DataStore"] = "DataStore";
  ModelAttachment2["API"] = "API";
})(ModelAttachment || (ModelAttachment = {}));
var attachedModelInstances = /* @__PURE__ */ new WeakMap();
function attached(result, attachment) {
  if (Array.isArray(result)) {
    result.map(function(record) {
      return attached(record, attachment);
    });
  } else {
    result && attachedModelInstances.set(result, attachment);
  }
  return result;
}
var checkSchemaInitialized = function() {
  if (schema === void 0) {
    var message = "Schema is not initialized. DataStore will not function as expected. This could happen if you have multiple versions of DataStore installed. Please see https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js/#check-for-duplicate-versions";
    logger51.error(message);
    throw new Error(message);
  }
};
var instancesMetadata = /* @__PURE__ */ new WeakSet();
function modelInstanceCreator(modelConstructor, init) {
  instancesMetadata.add(init);
  return new modelConstructor(init);
}
var initPatches = /* @__PURE__ */ new WeakMap();
var AsyncItem = (
  /** @class */
  function(_super) {
    __extends3(AsyncItem2, _super);
    function AsyncItem2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    return AsyncItem2;
  }(Promise)
);
var AsyncCollection = (
  /** @class */
  function() {
    function AsyncCollection2(values) {
      this.values = values;
    }
    AsyncCollection2.prototype[Symbol.asyncIterator] = function() {
      var _this = this;
      var values;
      var index = 0;
      return {
        next: function() {
          return __awaiter3(_this, void 0, void 0, function() {
            var result;
            return __generator3(this, function(_a2) {
              switch (_a2.label) {
                case 0:
                  if (!!values)
                    return [3, 2];
                  return [4, this.values];
                case 1:
                  values = _a2.sent();
                  _a2.label = 2;
                case 2:
                  if (index < values.length) {
                    result = {
                      value: values[index],
                      done: false
                    };
                    index++;
                    return [2, result];
                  }
                  return [2, {
                    value: null,
                    done: true
                  }];
              }
            });
          });
        }
      };
    };
    AsyncCollection2.prototype.toArray = function(_a2) {
      var _b2 = (_a2 === void 0 ? {} : _a2).max, max = _b2 === void 0 ? Number.MAX_SAFE_INTEGER : _b2;
      var e_6, _c;
      return __awaiter3(this, void 0, void 0, function() {
        var output, i2, _d, _e, element, e_6_1;
        return __generator3(this, function(_f) {
          switch (_f.label) {
            case 0:
              output = [];
              i2 = 0;
              _f.label = 1;
            case 1:
              _f.trys.push([1, 6, 7, 12]);
              _d = __asyncValues(this);
              _f.label = 2;
            case 2:
              return [4, _d.next()];
            case 3:
              if (!(_e = _f.sent(), !_e.done))
                return [3, 5];
              element = _e.value;
              if (i2 < max) {
                output.push(element);
                i2++;
              } else {
                return [3, 5];
              }
              _f.label = 4;
            case 4:
              return [3, 2];
            case 5:
              return [3, 12];
            case 6:
              e_6_1 = _f.sent();
              e_6 = { error: e_6_1 };
              return [3, 12];
            case 7:
              _f.trys.push([7, , 10, 11]);
              if (!(_e && !_e.done && (_c = _d.return)))
                return [3, 9];
              return [4, _c.call(_d)];
            case 8:
              _f.sent();
              _f.label = 9;
            case 9:
              return [3, 11];
            case 10:
              if (e_6)
                throw e_6.error;
              return [
                7
                /*endfinally*/
              ];
            case 11:
              return [
                7
                /*endfinally*/
              ];
            case 12:
              return [2, output];
          }
        });
      });
    };
    return AsyncCollection2;
  }()
);
function isQueryOne(obj) {
  return typeof obj === "string";
}
function defaultConflictHandler(conflictData) {
  var localModel = conflictData.localModel, modelConstructor = conflictData.modelConstructor, remoteModel = conflictData.remoteModel;
  var _version = remoteModel._version;
  return modelInstanceCreator(modelConstructor, __assign7(__assign7({}, localModel), { _version }));
}
function defaultErrorHandler(error) {
  logger51.warn(error);
}
function getModelConstructorByModelName(namespaceName, modelName) {
  var result;
  switch (namespaceName) {
    case DATASTORE:
      result = dataStoreClasses[modelName];
      break;
    case USER:
      result = userClasses[modelName];
      break;
    case SYNC:
      result = syncClasses[modelName];
      break;
    case STORAGE:
      result = storageClasses[modelName];
      break;
    default:
      throw new Error("Invalid namespace: " + namespaceName);
  }
  if (isValidModelConstructor(result)) {
    return result;
  } else {
    var msg = "Model name is not valid for namespace. modelName: " + modelName + ", namespace: " + namespaceName;
    logger51.error(msg);
    throw new Error(msg);
  }
}
function checkSchemaVersion(storage, version3) {
  return __awaiter3(this, void 0, void 0, function() {
    var Setting, modelDefinition;
    var _this = this;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          Setting = dataStoreClasses.Setting;
          modelDefinition = schema.namespaces[DATASTORE].models.Setting;
          return [4, storage.runExclusive(function(s2) {
            return __awaiter3(_this, void 0, void 0, function() {
              var _a3, schemaVersionSetting, storedValue;
              return __generator3(this, function(_b2) {
                switch (_b2.label) {
                  case 0:
                    return [4, s2.query(Setting, ModelPredicateCreator.createFromAST(modelDefinition, {
                      and: { key: { eq: SETTING_SCHEMA_VERSION } }
                    }), { page: 0, limit: 1 })];
                  case 1:
                    _a3 = __read10.apply(void 0, [_b2.sent(), 1]), schemaVersionSetting = _a3[0];
                    if (!(schemaVersionSetting !== void 0 && schemaVersionSetting.value !== void 0))
                      return [3, 4];
                    storedValue = JSON.parse(schemaVersionSetting.value);
                    if (!(storedValue !== version3))
                      return [3, 3];
                    return [4, s2.clear(false)];
                  case 2:
                    _b2.sent();
                    _b2.label = 3;
                  case 3:
                    return [3, 6];
                  case 4:
                    return [4, s2.save(modelInstanceCreator(Setting, {
                      key: SETTING_SCHEMA_VERSION,
                      value: JSON.stringify(version3)
                    }))];
                  case 5:
                    _b2.sent();
                    _b2.label = 6;
                  case 6:
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          })];
        case 1:
          _a2.sent();
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
var syncSubscription;
var DataStoreState;
(function(DataStoreState2) {
  DataStoreState2["NotRunning"] = "Not Running";
  DataStoreState2["Starting"] = "Starting";
  DataStoreState2["Running"] = "Running";
  DataStoreState2["Stopping"] = "Stopping";
  DataStoreState2["Clearing"] = "Clearing";
})(DataStoreState || (DataStoreState = {}));
var DataStore = (
  /** @class */
  function() {
    function DataStore2() {
      var _this = this;
      this.Auth = Auth;
      this.InternalAPI = InternalAPI;
      this.Cache = BrowserStorageCache;
      this.amplifyConfig = {};
      this.syncPredicates = /* @__PURE__ */ new WeakMap();
      this.amplifyContext = {
        Auth: this.Auth,
        InternalAPI: this.InternalAPI,
        Cache: this.Cache
      };
      this.runningProcesses = new BackgroundProcessManager();
      this.state = DataStoreState.NotRunning;
      this.start = function() {
        return __awaiter3(_this, void 0, void 0, function() {
          var _this2 = this;
          return __generator3(this, function(_a2) {
            return [2, this.runningProcesses.add(function() {
              return __awaiter3(_this2, void 0, void 0, function() {
                var aws_appsync_graphqlEndpoint, _a3, fullSyncIntervalInMilliseconds;
                var _this3 = this;
                return __generator3(this, function(_b2) {
                  switch (_b2.label) {
                    case 0:
                      this.state = DataStoreState.Starting;
                      if (!(this.initialized === void 0))
                        return [3, 1];
                      logger51.debug("Starting DataStore");
                      this.initialized = new Promise(function(res, rej) {
                        _this3.initResolve = res;
                        _this3.initReject = rej;
                      });
                      return [3, 3];
                    case 1:
                      return [4, this.initialized];
                    case 2:
                      _b2.sent();
                      return [
                        2
                        /*return*/
                      ];
                    case 3:
                      this.storage = new ExclusiveStorage(schema, namespaceResolver, getModelConstructorByModelName, modelInstanceCreator, this.storageAdapter, this.sessionId);
                      return [4, this.storage.init()];
                    case 4:
                      _b2.sent();
                      checkSchemaInitialized();
                      return [4, checkSchemaVersion(this.storage, schema.version)];
                    case 5:
                      _b2.sent();
                      aws_appsync_graphqlEndpoint = this.amplifyConfig.aws_appsync_graphqlEndpoint;
                      if (!aws_appsync_graphqlEndpoint)
                        return [3, 7];
                      logger51.debug("GraphQL endpoint available", aws_appsync_graphqlEndpoint);
                      _a3 = this;
                      return [4, this.processSyncExpressions()];
                    case 6:
                      _a3.syncPredicates = _b2.sent();
                      this.sync = new SyncEngine(schema, namespaceResolver, syncClasses, userClasses, this.storage, modelInstanceCreator, this.conflictHandler, this.errorHandler, this.syncPredicates, this.amplifyConfig, this.authModeStrategy, this.amplifyContext, this.connectivityMonitor);
                      fullSyncIntervalInMilliseconds = this.fullSyncInterval * 1e3 * 60;
                      syncSubscription = this.sync.start({ fullSyncInterval: fullSyncIntervalInMilliseconds }).subscribe({
                        next: function(_a4) {
                          var type = _a4.type, data = _a4.data;
                          var readyType = isNode4 ? ControlMessage.SYNC_ENGINE_SYNC_QUERIES_READY : ControlMessage.SYNC_ENGINE_STORAGE_SUBSCRIBED;
                          if (type === readyType) {
                            _this3.initResolve();
                          }
                          Hub.dispatch("datastore", {
                            event: type,
                            data
                          });
                        },
                        error: function(err) {
                          logger51.warn("Sync error", err);
                          _this3.initReject();
                        }
                      });
                      return [3, 8];
                    case 7:
                      logger51.warn("Data won't be synchronized. No GraphQL endpoint configured. Did you forget `Amplify.configure(awsconfig)`?", {
                        config: this.amplifyConfig
                      });
                      this.initResolve();
                      _b2.label = 8;
                    case 8:
                      return [4, this.initialized];
                    case 9:
                      _b2.sent();
                      this.state = DataStoreState.Running;
                      return [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, "datastore start").catch(this.handleAddProcError("DataStore.start()"))];
          });
        });
      };
      this.query = function(modelConstructor, identifierOrCriteria, paginationProducer) {
        return __awaiter3(_this, void 0, void 0, function() {
          var _this2 = this;
          return __generator3(this, function(_a2) {
            return [2, this.runningProcesses.add(function() {
              return __awaiter3(_this2, void 0, void 0, function() {
                var result, msg, modelDefinition, pagination, keyFields, msg, predicate, predicate, seedPredicate, predicate, returnOne;
                var _a3;
                var _b2;
                return __generator3(this, function(_c) {
                  switch (_c.label) {
                    case 0:
                      return [4, this.start()];
                    case 1:
                      _c.sent();
                      if (!this.storage) {
                        throw new Error("No storage to query");
                      }
                      if (!isValidModelConstructor(modelConstructor)) {
                        msg = "Constructor is not for a valid model";
                        logger51.error(msg, { modelConstructor });
                        throw new Error(msg);
                      }
                      if (typeof identifierOrCriteria === "string") {
                        if (paginationProducer !== void 0) {
                          logger51.warn("Pagination is ignored when querying by id");
                        }
                      }
                      modelDefinition = getModelDefinition(modelConstructor);
                      if (!modelDefinition) {
                        throw new Error("Invalid model definition provided!");
                      }
                      pagination = this.processPagination(modelDefinition, paginationProducer);
                      keyFields = extractPrimaryKeyFieldNames(modelDefinition);
                      if (!isQueryOne(identifierOrCriteria))
                        return [3, 3];
                      if (keyFields.length > 1) {
                        msg = errorMessages.queryByPkWithCompositeKeyPresent;
                        logger51.error(msg, { keyFields });
                        throw new Error(msg);
                      }
                      predicate = ModelPredicateCreator.createFromFlatEqualities(modelDefinition, (_a3 = {}, _a3[keyFields[0]] = identifierOrCriteria, _a3));
                      return [4, this.storage.query(modelConstructor, predicate, pagination)];
                    case 2:
                      result = _c.sent();
                      return [3, 9];
                    case 3:
                      if (!isIdentifierObject(identifierOrCriteria, modelDefinition))
                        return [3, 5];
                      predicate = ModelPredicateCreator.createForPk(modelDefinition, identifierOrCriteria);
                      return [4, this.storage.query(modelConstructor, predicate, pagination)];
                    case 4:
                      result = _c.sent();
                      return [3, 9];
                    case 5:
                      if (!(!identifierOrCriteria || isPredicatesAll(identifierOrCriteria)))
                        return [3, 7];
                      return [4, (_b2 = this.storage) === null || _b2 === void 0 ? void 0 : _b2.query(modelConstructor, void 0, pagination)];
                    case 6:
                      result = _c.sent();
                      return [3, 9];
                    case 7:
                      seedPredicate = recursivePredicateFor({
                        builder: modelConstructor,
                        schema: modelDefinition,
                        pkField: extractPrimaryKeyFieldNames(modelDefinition)
                      });
                      predicate = internals(identifierOrCriteria(seedPredicate));
                      return [4, predicate.fetch(this.storage)];
                    case 8:
                      result = _c.sent();
                      result = inMemoryPagination(result, pagination);
                      _c.label = 9;
                    case 9:
                      returnOne = isQueryOne(identifierOrCriteria) || isIdentifierObject(identifierOrCriteria, modelDefinition);
                      return [2, attached(returnOne ? result[0] : result, ModelAttachment.DataStore)];
                  }
                });
              });
            }, "datastore query").catch(this.handleAddProcError("DataStore.query()"))];
          });
        });
      };
      this.save = function(model, condition) {
        return __awaiter3(_this, void 0, void 0, function() {
          var _this2 = this;
          return __generator3(this, function(_a2) {
            return [2, this.runningProcesses.add(function() {
              return __awaiter3(_this2, void 0, void 0, function() {
                var updatedPatchesTuple, initPatchesTuple, patchesTuple, modelConstructor, msg, modelDefinition, modelMeta, producedCondition, _a3, savedModel;
                var _this3 = this;
                return __generator3(this, function(_b2) {
                  switch (_b2.label) {
                    case 0:
                      return [4, this.start()];
                    case 1:
                      _b2.sent();
                      if (!this.storage) {
                        throw new Error("No storage to save to");
                      }
                      updatedPatchesTuple = modelPatchesMap.get(model);
                      initPatchesTuple = initPatches.has(model) ? [initPatches.get(model), {}] : void 0;
                      patchesTuple = updatedPatchesTuple || initPatchesTuple;
                      modelConstructor = model ? model.constructor : void 0;
                      if (!isValidModelConstructor(modelConstructor)) {
                        msg = "Object is not an instance of a valid model";
                        logger51.error(msg, { model });
                        throw new Error(msg);
                      }
                      modelDefinition = getModelDefinition(modelConstructor);
                      if (!modelDefinition) {
                        throw new Error("Model Definition could not be found for model");
                      }
                      modelMeta = {
                        builder: modelConstructor,
                        schema: modelDefinition,
                        pkField: extractPrimaryKeyFieldNames(modelDefinition)
                      };
                      return [4, this.storage.runExclusive(function(s2) {
                        return __awaiter3(_this3, void 0, void 0, function() {
                          var nonHasManyRelationships, nonHasManyRelationships_1, nonHasManyRelationships_1_1, relationship, queryObject, related, e_7_1;
                          var e_7, _a4;
                          var _b3;
                          return __generator3(this, function(_c) {
                            switch (_c.label) {
                              case 0:
                                nonHasManyRelationships = ModelRelationship.allFrom(modelMeta).filter(function(r2) {
                                  return r2.type === "BELONGS_TO";
                                });
                                _c.label = 1;
                              case 1:
                                _c.trys.push([1, 6, 7, 8]);
                                nonHasManyRelationships_1 = __values4(nonHasManyRelationships), nonHasManyRelationships_1_1 = nonHasManyRelationships_1.next();
                                _c.label = 2;
                              case 2:
                                if (!!nonHasManyRelationships_1_1.done)
                                  return [3, 5];
                                relationship = nonHasManyRelationships_1_1.value;
                                queryObject = relationship.createRemoteQueryObject(model);
                                if (!(queryObject !== null))
                                  return [3, 4];
                                return [4, s2.query(relationship.remoteModelConstructor, ModelPredicateCreator.createFromFlatEqualities(relationship.remoteDefinition, queryObject))];
                              case 3:
                                related = _c.sent();
                                if (related.length === 0) {
                                  throw new Error([
                                    "Data integrity error. You tried to save a " + modelDefinition.name + " (" + JSON.stringify(model) + ")",
                                    'but the instance assigned to the "' + relationship.field + '" property',
                                    "does not exist in the local database. If you're trying to create the related",
                                    '"' + ((_b3 = relationship.remoteDefinition) === null || _b3 === void 0 ? void 0 : _b3.name) + '", you must save it independently first.'
                                  ].join(" "));
                                }
                                _c.label = 4;
                              case 4:
                                nonHasManyRelationships_1_1 = nonHasManyRelationships_1.next();
                                return [3, 2];
                              case 5:
                                return [3, 8];
                              case 6:
                                e_7_1 = _c.sent();
                                e_7 = { error: e_7_1 };
                                return [3, 8];
                              case 7:
                                try {
                                  if (nonHasManyRelationships_1_1 && !nonHasManyRelationships_1_1.done && (_a4 = nonHasManyRelationships_1.return))
                                    _a4.call(nonHasManyRelationships_1);
                                } finally {
                                  if (e_7)
                                    throw e_7.error;
                                }
                                return [
                                  7
                                  /*endfinally*/
                                ];
                              case 8:
                                return [
                                  2
                                  /*return*/
                                ];
                            }
                          });
                        });
                      })];
                    case 2:
                      _b2.sent();
                      producedCondition = condition ? internals(condition(predicateFor(modelMeta))).toStoragePredicate() : void 0;
                      return [4, this.storage.runExclusive(function(s2) {
                        return __awaiter3(_this3, void 0, void 0, function() {
                          var saved;
                          return __generator3(this, function(_a4) {
                            switch (_a4.label) {
                              case 0:
                                return [4, s2.save(model, producedCondition, void 0, patchesTuple)];
                              case 1:
                                saved = _a4.sent();
                                return [2, s2.query(modelConstructor, ModelPredicateCreator.createForPk(modelDefinition, model))];
                            }
                          });
                        });
                      })];
                    case 3:
                      _a3 = __read10.apply(void 0, [_b2.sent(), 1]), savedModel = _a3[0];
                      return [2, attached(savedModel, ModelAttachment.DataStore)];
                  }
                });
              });
            }, "datastore save").catch(this.handleAddProcError("DataStore.save()"))];
          });
        });
      };
      this.setConflictHandler = function(config) {
        var configDataStore = config.DataStore;
        var conflictHandlerIsDefault = function() {
          return _this.conflictHandler === defaultConflictHandler;
        };
        if (configDataStore && configDataStore.conflictHandler) {
          return configDataStore.conflictHandler;
        }
        if (conflictHandlerIsDefault() && config.conflictHandler) {
          return config.conflictHandler;
        }
        return _this.conflictHandler || defaultConflictHandler;
      };
      this.setErrorHandler = function(config) {
        var configDataStore = config.DataStore;
        var errorHandlerIsDefault = function() {
          return _this.errorHandler === defaultErrorHandler;
        };
        if (configDataStore && configDataStore.errorHandler) {
          return configDataStore.errorHandler;
        }
        if (errorHandlerIsDefault() && config.errorHandler) {
          return config.errorHandler;
        }
        return _this.errorHandler || defaultErrorHandler;
      };
      this.delete = function(modelOrConstructor, identifierOrCriteria) {
        return __awaiter3(_this, void 0, void 0, function() {
          var _this2 = this;
          return __generator3(this, function(_a2) {
            return [2, this.runningProcesses.add(function() {
              return __awaiter3(_this2, void 0, void 0, function() {
                var condition, msg, modelConstructor, msg, modelDefinition, keyFields, msg, msg, _a3, deleted, model, modelConstructor, msg, modelDefinition, pkPredicate, msg, _b2, _c, deleted;
                var _d;
                return __generator3(this, function(_e) {
                  switch (_e.label) {
                    case 0:
                      return [4, this.start()];
                    case 1:
                      _e.sent();
                      if (!this.storage) {
                        throw new Error("No storage to delete from");
                      }
                      if (!modelOrConstructor) {
                        msg = "Model or Model Constructor required";
                        logger51.error(msg, { modelOrConstructor });
                        throw new Error(msg);
                      }
                      if (!isValidModelConstructor(modelOrConstructor))
                        return [3, 3];
                      modelConstructor = modelOrConstructor;
                      if (!identifierOrCriteria) {
                        msg = "Id to delete or criteria required. Do you want to delete all? Pass Predicates.ALL";
                        logger51.error(msg, { identifierOrCriteria });
                        throw new Error(msg);
                      }
                      modelDefinition = getModelDefinition(modelConstructor);
                      if (!modelDefinition) {
                        throw new Error("Could not find model definition for modelConstructor.");
                      }
                      if (typeof identifierOrCriteria === "string") {
                        keyFields = extractPrimaryKeyFieldNames(modelDefinition);
                        if (keyFields.length > 1) {
                          msg = errorMessages.deleteByPkWithCompositeKeyPresent;
                          logger51.error(msg, { keyFields });
                          throw new Error(msg);
                        }
                        condition = ModelPredicateCreator.createFromFlatEqualities(modelDefinition, (_d = {}, _d[keyFields[0]] = identifierOrCriteria, _d));
                      } else {
                        if (isIdentifierObject(identifierOrCriteria, modelDefinition)) {
                          condition = ModelPredicateCreator.createForPk(modelDefinition, identifierOrCriteria);
                        } else {
                          condition = internals(identifierOrCriteria(predicateFor({
                            builder: modelConstructor,
                            schema: modelDefinition,
                            pkField: extractPrimaryKeyFieldNames(modelDefinition)
                          }))).toStoragePredicate();
                        }
                        if (!condition || !ModelPredicateCreator.isValidPredicate(condition)) {
                          msg = "Criteria required. Do you want to delete all? Pass Predicates.ALL";
                          logger51.error(msg, { condition });
                          throw new Error(msg);
                        }
                      }
                      return [4, this.storage.delete(modelConstructor, condition)];
                    case 2:
                      _a3 = __read10.apply(void 0, [_e.sent(), 1]), deleted = _a3[0];
                      return [2, attached(deleted, ModelAttachment.DataStore)];
                    case 3:
                      model = modelOrConstructor;
                      modelConstructor = Object.getPrototypeOf(model || {}).constructor;
                      if (!isValidModelConstructor(modelConstructor)) {
                        msg = "Object is not an instance of a valid model";
                        logger51.error(msg, { model });
                        throw new Error(msg);
                      }
                      modelDefinition = getModelDefinition(modelConstructor);
                      if (!modelDefinition) {
                        throw new Error("Could not find model definition for modelConstructor.");
                      }
                      pkPredicate = ModelPredicateCreator.createForPk(modelDefinition, model);
                      if (identifierOrCriteria) {
                        if (typeof identifierOrCriteria !== "function") {
                          msg = "Invalid criteria";
                          logger51.error(msg, { identifierOrCriteria });
                          throw new Error(msg);
                        }
                        condition = internals(identifierOrCriteria(predicateFor({
                          builder: modelConstructor,
                          schema: modelDefinition,
                          pkField: extractPrimaryKeyFieldNames(modelDefinition)
                        }))).toStoragePredicate();
                      } else {
                        condition = pkPredicate;
                      }
                      return [4, this.storage.delete(model, condition)];
                    case 4:
                      _b2 = __read10.apply(void 0, [_e.sent(), 1]), _c = __read10(_b2[0], 1), deleted = _c[0];
                      return [2, attached(deleted, ModelAttachment.DataStore)];
                  }
                });
              });
            }, "datastore delete").catch(this.handleAddProcError("DataStore.delete()"))];
          });
        });
      };
      this.observe = function(modelOrConstructor, identifierOrCriteria) {
        var executivePredicate;
        var modelConstructor = modelOrConstructor && isValidModelConstructor(modelOrConstructor) ? modelOrConstructor : void 0;
        if (modelOrConstructor && modelConstructor === void 0) {
          var model = modelOrConstructor;
          var modelConstructor_1 = model && Object.getPrototypeOf(model).constructor;
          if (isValidModelConstructor(modelConstructor_1)) {
            if (identifierOrCriteria) {
              logger51.warn("idOrCriteria is ignored when using a model instance", {
                model,
                identifierOrCriteria
              });
            }
            return _this.observe(modelConstructor_1, model.id);
          } else {
            var msg = "The model is not an instance of a PersistentModelConstructor";
            logger51.error(msg, { model });
            throw new Error(msg);
          }
        }
        if (identifierOrCriteria && modelConstructor && isIdentifierObject(identifierOrCriteria, getModelDefinition(modelConstructor))) {
          var msg = errorMessages.observeWithObjectLiteral;
          logger51.error(msg, { objectLiteral: identifierOrCriteria });
          throw new Error(msg);
        }
        if (identifierOrCriteria !== void 0 && modelConstructor === void 0) {
          var msg = "Cannot provide criteria without a modelConstructor";
          logger51.error(msg, identifierOrCriteria);
          throw new Error(msg);
        }
        if (modelConstructor && !isValidModelConstructor(modelConstructor)) {
          var msg = "Constructor is not for a valid model";
          logger51.error(msg, { modelConstructor });
          throw new Error(msg);
        }
        if (modelConstructor && typeof identifierOrCriteria === "string") {
          var buildIdPredicate = function(seed) {
            return seed.id.eq(identifierOrCriteria);
          };
          executivePredicate = internals(buildIdPredicate(buildSeedPredicate(modelConstructor)));
        } else if (modelConstructor && typeof identifierOrCriteria === "function") {
          executivePredicate = internals(identifierOrCriteria(buildSeedPredicate(modelConstructor)));
        }
        return new bundle_esm_default(function(observer) {
          var source;
          _this.runningProcesses.add(function() {
            return __awaiter3(_this, void 0, void 0, function() {
              var _this2 = this;
              return __generator3(this, function(_a2) {
                switch (_a2.label) {
                  case 0:
                    return [4, this.start()];
                  case 1:
                    _a2.sent();
                    source = this.storage.observe(modelConstructor).filter(function(_a3) {
                      var model2 = _a3.model;
                      return namespaceResolver(model2) === USER;
                    }).subscribe({
                      next: function(item) {
                        return _this2.runningProcesses.isOpen && _this2.runningProcesses.add(function() {
                          return __awaiter3(_this2, void 0, void 0, function() {
                            var message, modelDefinition, keyFields, primaryKeysAndValues, freshElement, _a3;
                            return __generator3(this, function(_b2) {
                              switch (_b2.label) {
                                case 0:
                                  message = item;
                                  if (!(item.opType !== "DELETE"))
                                    return [3, 2];
                                  modelDefinition = getModelDefinition(item.model);
                                  keyFields = extractPrimaryKeyFieldNames(modelDefinition);
                                  primaryKeysAndValues = extractPrimaryKeysAndValues(item.element, keyFields);
                                  return [4, this.query(item.model, primaryKeysAndValues)];
                                case 1:
                                  freshElement = _b2.sent();
                                  message = __assign7(__assign7({}, message), { element: freshElement });
                                  _b2.label = 2;
                                case 2:
                                  _a3 = !executivePredicate;
                                  if (_a3)
                                    return [3, 4];
                                  return [4, executivePredicate.matches(message.element)];
                                case 3:
                                  _a3 = _b2.sent();
                                  _b2.label = 4;
                                case 4:
                                  if (_a3) {
                                    observer.next(message);
                                  }
                                  return [
                                    2
                                    /*return*/
                                  ];
                              }
                            });
                          });
                        }, "datastore observe message handler");
                      },
                      error: function(err) {
                        return observer.error(err);
                      },
                      complete: function() {
                        return observer.complete();
                      }
                    });
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          }, "datastore observe observable initialization").catch(_this.handleAddProcError("DataStore.observe()")).catch(function(error) {
            observer.error(error);
          });
          return _this.runningProcesses.addCleaner(function() {
            return __awaiter3(_this, void 0, void 0, function() {
              return __generator3(this, function(_a2) {
                if (source) {
                  source.unsubscribe();
                }
                return [
                  2
                  /*return*/
                ];
              });
            });
          }, "DataStore.observe() cleanup");
        });
      };
      this.observeQuery = function(model, criteria, options) {
        return new bundle_esm_default(function(observer) {
          var items = /* @__PURE__ */ new Map();
          var itemsChanged = /* @__PURE__ */ new Map();
          var deletedItemIds = [];
          var handle;
          var executivePredicate;
          var generateAndEmitSnapshot = function() {
            var snapshot = generateSnapshot();
            emitSnapshot(snapshot);
          };
          var limitTimerRace = new DeferredCallbackResolver({
            callback: generateAndEmitSnapshot,
            errorHandler: observer.error,
            maxInterval: 2e3
          });
          var sort = (options || {}).sort;
          var sortOptions = sort ? { sort } : void 0;
          var modelDefinition = getModelDefinition(model);
          if (!modelDefinition) {
            throw new Error("Could not find model definition.");
          }
          if (model && typeof criteria === "function") {
            executivePredicate = internals(criteria(buildSeedPredicate(model)));
          } else if (isPredicatesAll(criteria)) {
            executivePredicate = void 0;
          }
          _this.runningProcesses.add(function() {
            return __awaiter3(_this, void 0, void 0, function() {
              var err_1;
              var _this2 = this;
              return __generator3(this, function(_a2) {
                switch (_a2.label) {
                  case 0:
                    _a2.trys.push([0, 2, , 3]);
                    return [4, this.query(model, criteria, sortOptions)];
                  case 1:
                    _a2.sent().forEach(function(item) {
                      var itemModelDefinition = getModelDefinition(model);
                      var idOrPk = getIdentifierValue(itemModelDefinition, item);
                      items.set(idOrPk, item);
                    });
                    handle = this.observe(model).subscribe(function(_a3) {
                      var element = _a3.element, model2 = _a3.model, opType = _a3.opType;
                      return _this2.runningProcesses.isOpen && _this2.runningProcesses.add(function() {
                        return __awaiter3(_this2, void 0, void 0, function() {
                          var itemModelDefinition, idOrPk, _a4, isSynced, limit;
                          var _b2, _c;
                          return __generator3(this, function(_d) {
                            switch (_d.label) {
                              case 0:
                                itemModelDefinition = getModelDefinition(model2);
                                idOrPk = getIdentifierValue(itemModelDefinition, element);
                                _a4 = executivePredicate;
                                if (!_a4)
                                  return [3, 2];
                                return [4, executivePredicate.matches(element)];
                              case 1:
                                _a4 = !_d.sent();
                                _d.label = 2;
                              case 2:
                                if (_a4) {
                                  if (opType === "UPDATE" && (items.has(idOrPk) || itemsChanged.has(idOrPk))) {
                                    deletedItemIds.push(idOrPk);
                                  } else {
                                    return [
                                      2
                                      /*return*/
                                    ];
                                  }
                                }
                                if (opType === "DELETE") {
                                  deletedItemIds.push(idOrPk);
                                } else {
                                  itemsChanged.set(idOrPk, element);
                                }
                                isSynced = (_c = (_b2 = this.sync) === null || _b2 === void 0 ? void 0 : _b2.getModelSyncedStatus(model2)) !== null && _c !== void 0 ? _c : false;
                                limit = itemsChanged.size - deletedItemIds.length >= this.syncPageSize;
                                if (limit || isSynced) {
                                  limitTimerRace.resolve();
                                }
                                limitTimerRace.start();
                                return [
                                  2
                                  /*return*/
                                ];
                            }
                          });
                        });
                      }, "handle observeQuery observed event");
                    });
                    generateAndEmitSnapshot();
                    return [3, 3];
                  case 2:
                    err_1 = _a2.sent();
                    observer.error(err_1);
                    return [3, 3];
                  case 3:
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          }, "datastore observequery startup").catch(_this.handleAddProcError("DataStore.observeQuery()")).catch(function(error) {
            observer.error(error);
          });
          var generateSnapshot = function() {
            var _a2, _b2;
            var isSynced = (_b2 = (_a2 = _this.sync) === null || _a2 === void 0 ? void 0 : _a2.getModelSyncedStatus(model)) !== null && _b2 !== void 0 ? _b2 : false;
            var itemsArray = __spread(Array.from(items.values()), Array.from(itemsChanged.values()));
            items.clear();
            itemsArray.forEach(function(item) {
              var itemModelDefinition = getModelDefinition(model);
              var idOrPk = getIdentifierValue(itemModelDefinition, item);
              items.set(idOrPk, item);
            });
            deletedItemIds.forEach(function(idOrPk) {
              return items.delete(idOrPk);
            });
            var snapshot = Array.from(items.values());
            if (options === null || options === void 0 ? void 0 : options.sort) {
              sortItems(snapshot);
            }
            return {
              items: snapshot,
              isSynced
            };
          };
          var emitSnapshot = function(snapshot) {
            observer.next(snapshot);
            itemsChanged.clear();
            deletedItemIds = [];
          };
          var sortItems = function(itemsToSort) {
            var modelDefinition2 = getModelDefinition(model);
            var pagination = _this.processPagination(modelDefinition2, options);
            var sortPredicates = ModelSortPredicateCreator.getPredicates(pagination.sort);
            if (sortPredicates.length) {
              var compareFn = sortCompareFunction(sortPredicates);
              itemsToSort.sort(compareFn);
            }
          };
          var hubCallback = function(_a2) {
            var payload = _a2.payload;
            var _b2;
            var event = payload.event, data = payload.data;
            if (event === ControlMessage.SYNC_ENGINE_MODEL_SYNCED && ((_b2 = data === null || data === void 0 ? void 0 : data.model) === null || _b2 === void 0 ? void 0 : _b2.name) === model.name) {
              generateAndEmitSnapshot();
              Hub.remove("datastore", hubCallback);
            }
          };
          Hub.listen("datastore", hubCallback);
          return _this.runningProcesses.addCleaner(function() {
            return __awaiter3(_this, void 0, void 0, function() {
              return __generator3(this, function(_a2) {
                if (handle) {
                  handle.unsubscribe();
                }
                return [
                  2
                  /*return*/
                ];
              });
            });
          }, "datastore observequery cleaner");
        });
      };
      this.configure = function(config) {
        if (config === void 0) {
          config = {};
        }
        _this.amplifyContext.Auth = _this.Auth;
        _this.amplifyContext.InternalAPI = _this.InternalAPI;
        _this.amplifyContext.Cache = _this.Cache;
        var configDataStore = config.DataStore, configAuthModeStrategyType = config.authModeStrategyType, configConflictHandler = config.conflictHandler, configErrorHandler = config.errorHandler, configMaxRecordsToSync = config.maxRecordsToSync, configSyncPageSize = config.syncPageSize, configFullSyncInterval = config.fullSyncInterval, configSyncExpressions = config.syncExpressions, configAuthProviders = config.authProviders, configStorageAdapter = config.storageAdapter, configFromAmplify = __rest2(config, ["DataStore", "authModeStrategyType", "conflictHandler", "errorHandler", "maxRecordsToSync", "syncPageSize", "fullSyncInterval", "syncExpressions", "authProviders", "storageAdapter"]);
        _this.amplifyConfig = __assign7(__assign7({}, configFromAmplify), _this.amplifyConfig);
        _this.conflictHandler = _this.setConflictHandler(config);
        _this.errorHandler = _this.setErrorHandler(config);
        var authModeStrategyType = configDataStore && configDataStore.authModeStrategyType || configAuthModeStrategyType || AuthModeStrategyType.DEFAULT;
        switch (authModeStrategyType) {
          case AuthModeStrategyType.MULTI_AUTH:
            _this.authModeStrategy = multiAuthStrategy(_this.amplifyContext);
            break;
          case AuthModeStrategyType.DEFAULT:
            _this.authModeStrategy = defaultAuthStrategy;
            break;
          default:
            _this.authModeStrategy = defaultAuthStrategy;
            break;
        }
        _this.amplifyConfig.authProviders = configDataStore && configDataStore.authProviders || configAuthProviders;
        _this.syncExpressions = configDataStore && configDataStore.syncExpressions || configSyncExpressions || _this.syncExpressions;
        _this.maxRecordsToSync = configDataStore && configDataStore.maxRecordsToSync || configMaxRecordsToSync || _this.maxRecordsToSync || 1e4;
        _this.amplifyConfig.maxRecordsToSync = _this.maxRecordsToSync;
        _this.syncPageSize = configDataStore && configDataStore.syncPageSize || configSyncPageSize || _this.syncPageSize || 1e3;
        _this.amplifyConfig.syncPageSize = _this.syncPageSize;
        _this.fullSyncInterval = configDataStore && configDataStore.fullSyncInterval || configFullSyncInterval || _this.fullSyncInterval || 24 * 60;
        _this.storageAdapter = configDataStore && configDataStore.storageAdapter || configStorageAdapter || _this.storageAdapter || void 0;
        _this.sessionId = _this.retrieveSessionId();
      };
    }
    DataStore2.prototype.getModuleName = function() {
      return "DataStore";
    };
    DataStore2.prototype.handleAddProcError = function(operation) {
      var _this = this;
      var handler = function(err) {
        if (err.message.startsWith("BackgroundManagerNotOpenError")) {
          throw new Error([
            "DataStoreStateError: Tried to execute `" + operation + '` while DataStore was "' + _this.state + '".',
            'This can only be done while DataStore is "Started" or "Stopped". To remedy:',
            "Ensure all calls to `stop()` and `clear()` have completed first.",
            "If this is not possible, retry the operation until it succeeds."
          ].join("\n"));
        } else {
          throw err;
        }
      };
      return handler;
    };
    DataStore2.prototype.clear = function() {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              checkSchemaInitialized();
              this.state = DataStoreState.Clearing;
              return [4, this.runningProcesses.close()];
            case 1:
              _a2.sent();
              if (!(this.storage === void 0))
                return [3, 3];
              this.storage = new ExclusiveStorage(schema, namespaceResolver, getModelConstructorByModelName, modelInstanceCreator, this.storageAdapter, this.sessionId);
              return [4, this.storage.init()];
            case 2:
              _a2.sent();
              _a2.label = 3;
            case 3:
              if (syncSubscription && !syncSubscription.closed) {
                syncSubscription.unsubscribe();
              }
              if (!this.sync)
                return [3, 5];
              return [4, this.sync.stop()];
            case 4:
              _a2.sent();
              _a2.label = 5;
            case 5:
              return [4, this.storage.clear()];
            case 6:
              _a2.sent();
              this.initialized = void 0;
              this.storage = void 0;
              this.sync = void 0;
              this.syncPredicates = /* @__PURE__ */ new WeakMap();
              return [4, this.runningProcesses.open()];
            case 7:
              _a2.sent();
              this.state = DataStoreState.NotRunning;
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    DataStore2.prototype.stop = function() {
      return __awaiter3(this, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              this.state = DataStoreState.Stopping;
              return [4, this.runningProcesses.close()];
            case 1:
              _a2.sent();
              if (syncSubscription && !syncSubscription.closed) {
                syncSubscription.unsubscribe();
              }
              if (!this.sync)
                return [3, 3];
              return [4, this.sync.stop()];
            case 2:
              _a2.sent();
              _a2.label = 3;
            case 3:
              this.initialized = void 0;
              this.sync = void 0;
              return [4, this.runningProcesses.open()];
            case 4:
              _a2.sent();
              this.state = DataStoreState.NotRunning;
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    DataStore2.prototype.processPagination = function(modelDefinition, paginationProducer) {
      var sortPredicate;
      var _a2 = paginationProducer || {}, limit = _a2.limit, page = _a2.page, sort = _a2.sort;
      if (limit === void 0 && page === void 0 && sort === void 0) {
        return void 0;
      }
      if (page !== void 0 && limit === void 0) {
        throw new Error("Limit is required when requesting a page");
      }
      if (page !== void 0) {
        if (typeof page !== "number") {
          throw new Error("Page should be a number");
        }
        if (page < 0) {
          throw new Error("Page can't be negative");
        }
      }
      if (limit !== void 0) {
        if (typeof limit !== "number") {
          throw new Error("Limit should be a number");
        }
        if (limit < 0) {
          throw new Error("Limit can't be negative");
        }
      }
      if (sort) {
        sortPredicate = ModelSortPredicateCreator.createFromExisting(modelDefinition, sort);
      }
      return {
        limit,
        page,
        sort: sortPredicate
      };
    };
    DataStore2.prototype.processSyncExpressions = function() {
      return __awaiter3(this, void 0, void 0, function() {
        var syncPredicates;
        var _this = this;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (!this.syncExpressions || !this.syncExpressions.length) {
                return [2, /* @__PURE__ */ new WeakMap()];
              }
              return [4, Promise.all(this.syncExpressions.map(function(syncExpression2) {
                return __awaiter3(_this, void 0, void 0, function() {
                  var _a3, modelConstructor, conditionProducer, modelDefinition, condition, predicate;
                  return __generator3(this, function(_b2) {
                    switch (_b2.label) {
                      case 0:
                        return [4, syncExpression2];
                      case 1:
                        _a3 = _b2.sent(), modelConstructor = _a3.modelConstructor, conditionProducer = _a3.conditionProducer;
                        modelDefinition = getModelDefinition(modelConstructor);
                        return [4, this.unwrapPromise(conditionProducer)];
                      case 2:
                        condition = _b2.sent();
                        if (isPredicatesAll(condition)) {
                          return [2, [modelDefinition, null]];
                        }
                        predicate = internals(condition(predicateFor({
                          builder: modelConstructor,
                          schema: modelDefinition,
                          pkField: extractPrimaryKeyFieldNames(modelDefinition)
                        }))).toStoragePredicate();
                        return [2, [modelDefinition, predicate]];
                    }
                  });
                });
              }))];
            case 1:
              syncPredicates = _a2.sent();
              return [2, this.weakMapFromEntries(syncPredicates)];
          }
        });
      });
    };
    DataStore2.prototype.unwrapPromise = function(conditionProducer) {
      return __awaiter3(this, void 0, void 0, function() {
        var condition, error_1;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 2, , 3]);
              return [4, conditionProducer()];
            case 1:
              condition = _a2.sent();
              return [2, condition || conditionProducer];
            case 2:
              error_1 = _a2.sent();
              if (error_1 instanceof TypeError) {
                return [2, conditionProducer];
              }
              throw error_1;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    DataStore2.prototype.weakMapFromEntries = function(entries) {
      return entries.reduce(function(map5, _a2) {
        var _b2 = __read10(_a2, 2), modelDefinition = _b2[0], predicate = _b2[1];
        if (map5.has(modelDefinition)) {
          var name_2 = modelDefinition.name;
          logger51.warn("You can only utilize one Sync Expression per model.\n          Subsequent sync expressions for the " + name_2 + " model will be ignored.");
          return map5;
        }
        if (predicate) {
          map5.set(modelDefinition, predicate);
        }
        return map5;
      }, /* @__PURE__ */ new WeakMap());
    };
    DataStore2.prototype.retrieveSessionId = function() {
      try {
        var sessionId = sessionStorage.getItem("datastoreSessionId");
        if (sessionId) {
          var aws_appsync_graphqlEndpoint = this.amplifyConfig.aws_appsync_graphqlEndpoint;
          var appSyncUrl = aws_appsync_graphqlEndpoint.split("/")[2];
          var _a2 = __read10(appSyncUrl.split("."), 1), appSyncId = _a2[0];
          return sessionId + "-" + appSyncId;
        }
      } catch (_b2) {
      }
      return void 0;
    };
    return DataStore2;
  }()
);
var instance = new DataStore();
Amplify.register(instance);

// node_modules/@aws-amplify/interactions/node_modules/tslib/tslib.es6.js
var extendStatics9 = function(d2, b2) {
  extendStatics9 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b3) {
    d3.__proto__ = b3;
  } || function(d3, b3) {
    for (var p2 in b3)
      if (b3.hasOwnProperty(p2))
        d3[p2] = b3[p2];
  };
  return extendStatics9(d2, b2);
};
function __extends11(d2, b2) {
  extendStatics9(d2, b2);
  function __() {
    this.constructor = d2;
  }
  d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
}
var __assign44 = function() {
  __assign44 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign44.apply(this, arguments);
};
function __awaiter68(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator69(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

// node_modules/@aws-amplify/interactions/lib-esm/Providers/InteractionsProvider.js
var logger52 = new ConsoleLogger("AbstractInteractionsProvider");
var AbstractInteractionsProvider = (
  /** @class */
  function() {
    function AbstractInteractionsProvider2(options) {
      if (options === void 0) {
        options = {};
      }
      this._config = options;
    }
    AbstractInteractionsProvider2.prototype.configure = function(config) {
      if (config === void 0) {
        config = {};
      }
      this._config = __assign44(__assign44({}, this._config), config);
      logger52.debug("configure " + this.getProviderName(), this._config);
      return this.options;
    };
    AbstractInteractionsProvider2.prototype.getCategory = function() {
      return "Interactions";
    };
    Object.defineProperty(AbstractInteractionsProvider2.prototype, "options", {
      get: function() {
        return __assign44({}, this._config);
      },
      enumerable: true,
      configurable: true
    });
    return AbstractInteractionsProvider2;
  }()
);

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-serde/dist-es/deserializerMiddleware.js
var deserializerMiddleware2 = function(options, deserializer) {
  return function(next, context) {
    return function(args) {
      return __awaiter3(void 0, void 0, void 0, function() {
        var response, parsed, error_1;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, next(args)];
            case 1:
              response = _a2.sent().response;
              _a2.label = 2;
            case 2:
              _a2.trys.push([2, 4, , 5]);
              return [4, deserializer(response, options)];
            case 3:
              parsed = _a2.sent();
              return [2, {
                response,
                output: parsed
              }];
            case 4:
              error_1 = _a2.sent();
              Object.defineProperty(error_1, "$response", {
                value: response
              });
              throw error_1;
            case 5:
              return [2];
          }
        });
      });
    };
  };
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-serde/dist-es/serializerMiddleware.js
var serializerMiddleware2 = function(options, serializer) {
  return function(next, context) {
    return function(args) {
      return __awaiter3(void 0, void 0, void 0, function() {
        var endpoint, request;
        var _a2;
        return __generator3(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              endpoint = ((_a2 = context.endpointV2) === null || _a2 === void 0 ? void 0 : _a2.url) && options.urlParser ? function() {
                return __awaiter3(void 0, void 0, void 0, function() {
                  return __generator3(this, function(_a3) {
                    return [2, options.urlParser(context.endpointV2.url)];
                  });
                });
              } : options.endpoint;
              if (!endpoint) {
                throw new Error("No valid endpoint provider available.");
              }
              return [4, serializer(args.input, __assign7(__assign7({}, options), { endpoint }))];
            case 1:
              request = _b2.sent();
              return [2, next(__assign7(__assign7({}, args), { request }))];
          }
        });
      });
    };
  };
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-serde/dist-es/serdePlugin.js
var deserializerMiddlewareOption2 = {
  name: "deserializerMiddleware",
  step: "deserialize",
  tags: ["DESERIALIZER"],
  override: true
};
var serializerMiddlewareOption2 = {
  name: "serializerMiddleware",
  step: "serialize",
  tags: ["SERIALIZER"],
  override: true
};
function getSerdePlugin2(config, serializer, deserializer) {
  return {
    applyToStack: function(commandStack) {
      commandStack.add(deserializerMiddleware2(config, deserializer), deserializerMiddlewareOption2);
      commandStack.add(serializerMiddleware2(config, serializer), serializerMiddlewareOption2);
    }
  };
}

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-stack/dist-es/MiddlewareStack.js
var constructStack2 = function() {
  var absoluteEntries = [];
  var relativeEntries = [];
  var entriesNameSet = /* @__PURE__ */ new Set();
  var sort = function(entries) {
    return entries.sort(function(a2, b2) {
      return stepWeights2[b2.step] - stepWeights2[a2.step] || priorityWeights2[b2.priority || "normal"] - priorityWeights2[a2.priority || "normal"];
    });
  };
  var removeByName = function(toRemove) {
    var isRemoved = false;
    var filterCb = function(entry) {
      if (entry.name && entry.name === toRemove) {
        isRemoved = true;
        entriesNameSet.delete(toRemove);
        return false;
      }
      return true;
    };
    absoluteEntries = absoluteEntries.filter(filterCb);
    relativeEntries = relativeEntries.filter(filterCb);
    return isRemoved;
  };
  var removeByReference = function(toRemove) {
    var isRemoved = false;
    var filterCb = function(entry) {
      if (entry.middleware === toRemove) {
        isRemoved = true;
        if (entry.name)
          entriesNameSet.delete(entry.name);
        return false;
      }
      return true;
    };
    absoluteEntries = absoluteEntries.filter(filterCb);
    relativeEntries = relativeEntries.filter(filterCb);
    return isRemoved;
  };
  var cloneTo = function(toStack) {
    absoluteEntries.forEach(function(entry) {
      toStack.add(entry.middleware, __assign7({}, entry));
    });
    relativeEntries.forEach(function(entry) {
      toStack.addRelativeTo(entry.middleware, __assign7({}, entry));
    });
    return toStack;
  };
  var expandRelativeMiddlewareList = function(from) {
    var expandedMiddlewareList = [];
    from.before.forEach(function(entry) {
      if (entry.before.length === 0 && entry.after.length === 0) {
        expandedMiddlewareList.push(entry);
      } else {
        expandedMiddlewareList.push.apply(expandedMiddlewareList, __spreadArray4([], __read10(expandRelativeMiddlewareList(entry)), false));
      }
    });
    expandedMiddlewareList.push(from);
    from.after.reverse().forEach(function(entry) {
      if (entry.before.length === 0 && entry.after.length === 0) {
        expandedMiddlewareList.push(entry);
      } else {
        expandedMiddlewareList.push.apply(expandedMiddlewareList, __spreadArray4([], __read10(expandRelativeMiddlewareList(entry)), false));
      }
    });
    return expandedMiddlewareList;
  };
  var getMiddlewareList = function(debug2) {
    if (debug2 === void 0) {
      debug2 = false;
    }
    var normalizedAbsoluteEntries = [];
    var normalizedRelativeEntries = [];
    var normalizedEntriesNameMap = {};
    absoluteEntries.forEach(function(entry) {
      var normalizedEntry = __assign7(__assign7({}, entry), { before: [], after: [] });
      if (normalizedEntry.name)
        normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
      normalizedAbsoluteEntries.push(normalizedEntry);
    });
    relativeEntries.forEach(function(entry) {
      var normalizedEntry = __assign7(__assign7({}, entry), { before: [], after: [] });
      if (normalizedEntry.name)
        normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
      normalizedRelativeEntries.push(normalizedEntry);
    });
    normalizedRelativeEntries.forEach(function(entry) {
      if (entry.toMiddleware) {
        var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
        if (toMiddleware === void 0) {
          if (debug2) {
            return;
          }
          throw new Error("".concat(entry.toMiddleware, " is not found when adding ").concat(entry.name || "anonymous", " middleware ").concat(entry.relation, " ").concat(entry.toMiddleware));
        }
        if (entry.relation === "after") {
          toMiddleware.after.push(entry);
        }
        if (entry.relation === "before") {
          toMiddleware.before.push(entry);
        }
      }
    });
    var mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce(function(wholeList, expendedMiddlewareList) {
      wholeList.push.apply(wholeList, __spreadArray4([], __read10(expendedMiddlewareList), false));
      return wholeList;
    }, []);
    return mainChain;
  };
  var stack = {
    add: function(middleware, options) {
      if (options === void 0) {
        options = {};
      }
      var name = options.name, override = options.override;
      var entry = __assign7({ step: "initialize", priority: "normal", middleware }, options);
      if (name) {
        if (entriesNameSet.has(name)) {
          if (!override)
            throw new Error("Duplicate middleware name '".concat(name, "'"));
          var toOverrideIndex = absoluteEntries.findIndex(function(entry2) {
            return entry2.name === name;
          });
          var toOverride = absoluteEntries[toOverrideIndex];
          if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) {
            throw new Error('"'.concat(name, '" middleware with ').concat(toOverride.priority, " priority in ").concat(toOverride.step, " step cannot be ") + "overridden by same-name middleware with ".concat(entry.priority, " priority in ").concat(entry.step, " step."));
          }
          absoluteEntries.splice(toOverrideIndex, 1);
        }
        entriesNameSet.add(name);
      }
      absoluteEntries.push(entry);
    },
    addRelativeTo: function(middleware, options) {
      var name = options.name, override = options.override;
      var entry = __assign7({ middleware }, options);
      if (name) {
        if (entriesNameSet.has(name)) {
          if (!override)
            throw new Error("Duplicate middleware name '".concat(name, "'"));
          var toOverrideIndex = relativeEntries.findIndex(function(entry2) {
            return entry2.name === name;
          });
          var toOverride = relativeEntries[toOverrideIndex];
          if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) {
            throw new Error('"'.concat(name, '" middleware ').concat(toOverride.relation, ' "').concat(toOverride.toMiddleware, '" middleware cannot be overridden ') + "by same-name middleware ".concat(entry.relation, ' "').concat(entry.toMiddleware, '" middleware.'));
          }
          relativeEntries.splice(toOverrideIndex, 1);
        }
        entriesNameSet.add(name);
      }
      relativeEntries.push(entry);
    },
    clone: function() {
      return cloneTo(constructStack2());
    },
    use: function(plugin) {
      plugin.applyToStack(stack);
    },
    remove: function(toRemove) {
      if (typeof toRemove === "string")
        return removeByName(toRemove);
      else
        return removeByReference(toRemove);
    },
    removeByTag: function(toRemove) {
      var isRemoved = false;
      var filterCb = function(entry) {
        var tags = entry.tags, name = entry.name;
        if (tags && tags.includes(toRemove)) {
          if (name)
            entriesNameSet.delete(name);
          isRemoved = true;
          return false;
        }
        return true;
      };
      absoluteEntries = absoluteEntries.filter(filterCb);
      relativeEntries = relativeEntries.filter(filterCb);
      return isRemoved;
    },
    concat: function(from) {
      var cloned = cloneTo(constructStack2());
      cloned.use(from);
      return cloned;
    },
    applyToStack: cloneTo,
    identify: function() {
      return getMiddlewareList(true).map(function(mw) {
        return mw.name + ": " + (mw.tags || []).join(",");
      });
    },
    resolve: function(handler, context) {
      var e_1, _a2;
      try {
        for (var _b2 = __values4(getMiddlewareList().map(function(entry) {
          return entry.middleware;
        }).reverse()), _c = _b2.next(); !_c.done; _c = _b2.next()) {
          var middleware = _c.value;
          handler = middleware(handler, context);
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (_c && !_c.done && (_a2 = _b2.return))
            _a2.call(_b2);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
      return handler;
    }
  };
  return stack;
};
var stepWeights2 = {
  initialize: 5,
  serialize: 4,
  build: 3,
  finalizeRequest: 2,
  deserialize: 1
};
var priorityWeights2 = {
  high: 3,
  normal: 2,
  low: 1
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/smithy-client/dist-es/client.js
var Client3 = function() {
  function Client5(config) {
    this.middlewareStack = constructStack2();
    this.config = config;
  }
  Client5.prototype.send = function(command, optionsOrCb, cb) {
    var options = typeof optionsOrCb !== "function" ? optionsOrCb : void 0;
    var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
    var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
    if (callback) {
      handler(command).then(function(result) {
        return callback(null, result.output);
      }, function(err) {
        return callback(err);
      }).catch(function() {
      });
    } else {
      return handler(command).then(function(result) {
        return result.output;
      });
    }
  };
  Client5.prototype.destroy = function() {
    if (this.config.requestHandler.destroy)
      this.config.requestHandler.destroy();
  };
  return Client5;
}();

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/smithy-client/dist-es/command.js
var Command2 = function() {
  function Command4() {
    this.middlewareStack = constructStack2();
  }
  return Command4;
}();

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/smithy-client/dist-es/constants.js
var SENSITIVE_STRING2 = "***SensitiveInformation***";

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/smithy-client/dist-es/parse-utils.js
var expectNumber = function(value) {
  if (value === null || value === void 0) {
    return void 0;
  }
  if (typeof value === "string") {
    var parsed = parseFloat(value);
    if (!Number.isNaN(parsed)) {
      if (String(parsed) !== String(value)) {
        logger53.warn(stackTraceWarning("Expected number but observed string: ".concat(value)));
      }
      return parsed;
    }
  }
  if (typeof value === "number") {
    return value;
  }
  throw new TypeError("Expected number, got ".concat(typeof value, ": ").concat(value));
};
var MAX_FLOAT = Math.ceil(Math.pow(2, 127) * (2 - Math.pow(2, -23)));
var expectLong = function(value) {
  if (value === null || value === void 0) {
    return void 0;
  }
  if (Number.isInteger(value) && !Number.isNaN(value)) {
    return value;
  }
  throw new TypeError("Expected integer, got ".concat(typeof value, ": ").concat(value));
};
var expectInt32 = function(value) {
  return expectSizedInt(value, 32);
};
var expectSizedInt = function(value, size) {
  var expected = expectLong(value);
  if (expected !== void 0 && castInt(expected, size) !== expected) {
    throw new TypeError("Expected ".concat(size, "-bit integer, got ").concat(value));
  }
  return expected;
};
var castInt = function(value, size) {
  switch (size) {
    case 32:
      return Int32Array.of(value)[0];
    case 16:
      return Int16Array.of(value)[0];
    case 8:
      return Int8Array.of(value)[0];
  }
};
var expectNonNull = function(value, location) {
  if (value === null || value === void 0) {
    if (location) {
      throw new TypeError("Expected a non-null value for ".concat(location));
    }
    throw new TypeError("Expected a non-null value");
  }
  return value;
};
var expectObject = function(value) {
  if (value === null || value === void 0) {
    return void 0;
  }
  if (typeof value === "object" && !Array.isArray(value)) {
    return value;
  }
  var receivedType = Array.isArray(value) ? "array" : typeof value;
  throw new TypeError("Expected object, got ".concat(receivedType, ": ").concat(value));
};
var expectString = function(value) {
  if (value === null || value === void 0) {
    return void 0;
  }
  if (typeof value === "string") {
    return value;
  }
  if (["boolean", "number", "bigint"].includes(typeof value)) {
    logger53.warn(stackTraceWarning("Expected string, got ".concat(typeof value, ": ").concat(value)));
    return String(value);
  }
  throw new TypeError("Expected string, got ".concat(typeof value, ": ").concat(value));
};
var limitedParseDouble = function(value) {
  if (typeof value == "string") {
    return parseFloatString(value);
  }
  return expectNumber(value);
};
var parseFloatString = function(value) {
  switch (value) {
    case "NaN":
      return NaN;
    case "Infinity":
      return Infinity;
    case "-Infinity":
      return -Infinity;
    default:
      throw new Error("Unable to parse float value: ".concat(value));
  }
};
var stackTraceWarning = function(message) {
  return String(new TypeError(message).stack || message).split("\n").slice(0, 5).filter(function(s2) {
    return !s2.includes("stackTraceWarning");
  }).join("\n");
};
var logger53 = {
  warn: console.warn
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/smithy-client/dist-es/date-utils.js
var RFC3339 = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?[zZ]$/);
var IMF_FIXDATE = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
var RFC_850_DATE = new RegExp(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d{2})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
var ASC_TIME = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( [1-9]|\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? (\d{4})$/);
var FIFTY_YEARS_IN_MILLIS = 50 * 365 * 24 * 60 * 60 * 1e3;

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/smithy-client/dist-es/exceptions.js
var ServiceException = function(_super) {
  __extends3(ServiceException3, _super);
  function ServiceException3(options) {
    var _this = _super.call(this, options.message) || this;
    Object.setPrototypeOf(_this, ServiceException3.prototype);
    _this.name = options.name;
    _this.$fault = options.$fault;
    _this.$metadata = options.$metadata;
    return _this;
  }
  return ServiceException3;
}(Error);
var decorateServiceException = function(exception, additions) {
  if (additions === void 0) {
    additions = {};
  }
  Object.entries(additions).filter(function(_a2) {
    var _b2 = __read10(_a2, 2), v2 = _b2[1];
    return v2 !== void 0;
  }).forEach(function(_a2) {
    var _b2 = __read10(_a2, 2), k2 = _b2[0], v2 = _b2[1];
    if (exception[k2] == void 0 || exception[k2] === "") {
      exception[k2] = v2;
    }
  });
  var message = exception.message || exception.Message || "UnknownError";
  exception.message = message;
  delete exception.Message;
  return exception;
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/smithy-client/dist-es/default-error-handler.js
var throwDefaultError = function(_a2) {
  var output = _a2.output, parsedBody = _a2.parsedBody, exceptionCtor = _a2.exceptionCtor, errorCode = _a2.errorCode;
  var $metadata = deserializeMetadata6(output);
  var statusCode = $metadata.httpStatusCode ? $metadata.httpStatusCode + "" : void 0;
  var response = new exceptionCtor({
    name: parsedBody.code || parsedBody.Code || errorCode || statusCode || "UnknowError",
    $fault: "client",
    $metadata
  });
  throw decorateServiceException(response, parsedBody);
};
var deserializeMetadata6 = function(output) {
  var _a2;
  return {
    httpStatusCode: output.statusCode,
    requestId: (_a2 = output.headers["x-amzn-requestid"]) !== null && _a2 !== void 0 ? _a2 : output.headers["x-amzn-request-id"],
    extendedRequestId: output.headers["x-amz-id-2"],
    cfId: output.headers["x-amz-cf-id"]
  };
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/smithy-client/dist-es/defaults-mode.js
var loadConfigsForDefaultMode = function(mode) {
  switch (mode) {
    case "standard":
      return {
        retryMode: "standard",
        connectionTimeout: 3100
      };
    case "in-region":
      return {
        retryMode: "standard",
        connectionTimeout: 1100
      };
    case "cross-region":
      return {
        retryMode: "standard",
        connectionTimeout: 3100
      };
    case "mobile":
      return {
        retryMode: "standard",
        connectionTimeout: 3e4
      };
    default:
      return {};
  }
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/smithy-client/dist-es/extended-encode-uri-component.js
function extendedEncodeURIComponent3(str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function(c2) {
    return "%" + c2.charCodeAt(0).toString(16).toUpperCase();
  });
}

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/smithy-client/dist-es/lazy-json.js
var StringWrapper2 = function() {
  var Class = Object.getPrototypeOf(this).constructor;
  var Constructor = Function.bind.apply(String, __spreadArray4([null], __read10(arguments), false));
  var instance2 = new Constructor();
  Object.setPrototypeOf(instance2, Class.prototype);
  return instance2;
};
StringWrapper2.prototype = Object.create(String.prototype, {
  constructor: {
    value: StringWrapper2,
    enumerable: false,
    writable: true,
    configurable: true
  }
});
Object.setPrototypeOf(StringWrapper2, String);
var LazyJsonString2 = function(_super) {
  __extends3(LazyJsonString4, _super);
  function LazyJsonString4() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  LazyJsonString4.prototype.deserializeJSON = function() {
    return JSON.parse(_super.prototype.toString.call(this));
  };
  LazyJsonString4.prototype.toJSON = function() {
    return _super.prototype.toString.call(this);
  };
  LazyJsonString4.fromObject = function(object) {
    if (object instanceof LazyJsonString4) {
      return object;
    } else if (object instanceof String || typeof object === "string") {
      return new LazyJsonString4(object);
    }
    return new LazyJsonString4(JSON.stringify(object));
  };
  return LazyJsonString4;
}(StringWrapper2);

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/smithy-client/dist-es/object-mapping.js
function map(arg0, arg1, arg2) {
  var e_1, _a2;
  var target;
  var filter;
  var instructions;
  if (typeof arg1 === "undefined" && typeof arg2 === "undefined") {
    target = {};
    instructions = arg0;
  } else {
    target = arg0;
    if (typeof arg1 === "function") {
      filter = arg1;
      instructions = arg2;
      return mapWithFilter(target, filter, instructions);
    } else {
      instructions = arg1;
    }
  }
  try {
    for (var _b2 = __values4(Object.keys(instructions)), _c = _b2.next(); !_c.done; _c = _b2.next()) {
      var key = _c.value;
      if (!Array.isArray(instructions[key])) {
        target[key] = instructions[key];
        continue;
      }
      var _d = __read10(instructions[key], 2), filter_1 = _d[0], value = _d[1];
      if (typeof value === "function") {
        var _value = void 0;
        var defaultFilterPassed = filter_1 === void 0 && (_value = value()) != null;
        var customFilterPassed = typeof filter_1 === "function" && !!filter_1(void 0) || typeof filter_1 !== "function" && !!filter_1;
        if (defaultFilterPassed) {
          target[key] = _value;
        } else if (customFilterPassed) {
          target[key] = value();
        }
      } else {
        var defaultFilterPassed = filter_1 === void 0 && value != null;
        var customFilterPassed = typeof filter_1 === "function" && !!filter_1(value) || typeof filter_1 !== "function" && !!filter_1;
        if (defaultFilterPassed || customFilterPassed) {
          target[key] = value;
        }
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_c && !_c.done && (_a2 = _b2.return))
        _a2.call(_b2);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return target;
}
var mapWithFilter = function(target, filter, instructions) {
  return map(target, Object.entries(instructions).reduce(function(_instructions, _a2) {
    var _b2 = __read10(_a2, 2), key = _b2[0], value = _b2[1];
    if (Array.isArray(value)) {
      _instructions[key] = value;
    } else {
      if (typeof value === "function") {
        _instructions[key] = [filter, value()];
      } else {
        _instructions[key] = [filter, value];
      }
    }
    return _instructions;
  }, {}));
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/smithy-client/dist-es/resolve-path.js
var resolvedPath = function(resolvedPath3, input, memberName, labelValueProvider, uriLabel, isGreedyLabel) {
  if (input != null && input[memberName] !== void 0) {
    var labelValue = labelValueProvider();
    if (labelValue.length <= 0) {
      throw new Error("Empty value provided for input HTTP label: " + memberName + ".");
    }
    resolvedPath3 = resolvedPath3.replace(uriLabel, isGreedyLabel ? labelValue.split("/").map(function(segment) {
      return extendedEncodeURIComponent3(segment);
    }).join("/") : extendedEncodeURIComponent3(labelValue));
  } else {
    throw new Error("No value provided for input HTTP label: " + memberName + ".");
  }
  return resolvedPath3;
};

// node_modules/@aws-sdk/client-lex-runtime-service/dist-es/models/LexRuntimeServiceServiceException.js
var LexRuntimeServiceServiceException = function(_super) {
  __extends3(LexRuntimeServiceServiceException2, _super);
  function LexRuntimeServiceServiceException2(options) {
    var _this = _super.call(this, options) || this;
    Object.setPrototypeOf(_this, LexRuntimeServiceServiceException2.prototype);
    return _this;
  }
  return LexRuntimeServiceServiceException2;
}(ServiceException);

// node_modules/@aws-sdk/client-lex-runtime-service/dist-es/models/models_0.js
var BadRequestException = function(_super) {
  __extends3(BadRequestException2, _super);
  function BadRequestException2(opts) {
    var _this = _super.call(this, __assign7({ name: "BadRequestException", $fault: "client" }, opts)) || this;
    _this.name = "BadRequestException";
    _this.$fault = "client";
    Object.setPrototypeOf(_this, BadRequestException2.prototype);
    return _this;
  }
  return BadRequestException2;
}(LexRuntimeServiceServiceException);
var ConflictException = function(_super) {
  __extends3(ConflictException3, _super);
  function ConflictException3(opts) {
    var _this = _super.call(this, __assign7({ name: "ConflictException", $fault: "client" }, opts)) || this;
    _this.name = "ConflictException";
    _this.$fault = "client";
    Object.setPrototypeOf(_this, ConflictException3.prototype);
    return _this;
  }
  return ConflictException3;
}(LexRuntimeServiceServiceException);
var InternalFailureException2 = function(_super) {
  __extends3(InternalFailureException3, _super);
  function InternalFailureException3(opts) {
    var _this = _super.call(this, __assign7({ name: "InternalFailureException", $fault: "server" }, opts)) || this;
    _this.name = "InternalFailureException";
    _this.$fault = "server";
    Object.setPrototypeOf(_this, InternalFailureException3.prototype);
    return _this;
  }
  return InternalFailureException3;
}(LexRuntimeServiceServiceException);
var LimitExceededException4 = function(_super) {
  __extends3(LimitExceededException5, _super);
  function LimitExceededException5(opts) {
    var _this = _super.call(this, __assign7({ name: "LimitExceededException", $fault: "client" }, opts)) || this;
    _this.name = "LimitExceededException";
    _this.$fault = "client";
    Object.setPrototypeOf(_this, LimitExceededException5.prototype);
    _this.retryAfterSeconds = opts.retryAfterSeconds;
    return _this;
  }
  return LimitExceededException5;
}(LexRuntimeServiceServiceException);
var NotFoundException = function(_super) {
  __extends3(NotFoundException2, _super);
  function NotFoundException2(opts) {
    var _this = _super.call(this, __assign7({ name: "NotFoundException", $fault: "client" }, opts)) || this;
    _this.name = "NotFoundException";
    _this.$fault = "client";
    Object.setPrototypeOf(_this, NotFoundException2.prototype);
    return _this;
  }
  return NotFoundException2;
}(LexRuntimeServiceServiceException);
var FulfillmentState;
(function(FulfillmentState2) {
  FulfillmentState2["FAILED"] = "Failed";
  FulfillmentState2["FULFILLED"] = "Fulfilled";
  FulfillmentState2["READY_FOR_FULFILLMENT"] = "ReadyForFulfillment";
})(FulfillmentState || (FulfillmentState = {}));
var MessageFormatType;
(function(MessageFormatType2) {
  MessageFormatType2["COMPOSITE"] = "Composite";
  MessageFormatType2["CUSTOM_PAYLOAD"] = "CustomPayload";
  MessageFormatType2["PLAIN_TEXT"] = "PlainText";
  MessageFormatType2["SSML"] = "SSML";
})(MessageFormatType || (MessageFormatType = {}));
var DialogActionType;
(function(DialogActionType2) {
  DialogActionType2["CLOSE"] = "Close";
  DialogActionType2["CONFIRM_INTENT"] = "ConfirmIntent";
  DialogActionType2["DELEGATE"] = "Delegate";
  DialogActionType2["ELICIT_INTENT"] = "ElicitIntent";
  DialogActionType2["ELICIT_SLOT"] = "ElicitSlot";
})(DialogActionType || (DialogActionType = {}));
var ConfirmationStatus;
(function(ConfirmationStatus2) {
  ConfirmationStatus2["CONFIRMED"] = "Confirmed";
  ConfirmationStatus2["DENIED"] = "Denied";
  ConfirmationStatus2["NONE"] = "None";
})(ConfirmationStatus || (ConfirmationStatus = {}));
var BadGatewayException = function(_super) {
  __extends3(BadGatewayException2, _super);
  function BadGatewayException2(opts) {
    var _this = _super.call(this, __assign7({ name: "BadGatewayException", $fault: "server" }, opts)) || this;
    _this.name = "BadGatewayException";
    _this.$fault = "server";
    Object.setPrototypeOf(_this, BadGatewayException2.prototype);
    _this.Message = opts.Message;
    return _this;
  }
  return BadGatewayException2;
}(LexRuntimeServiceServiceException);
var DependencyFailedException = function(_super) {
  __extends3(DependencyFailedException2, _super);
  function DependencyFailedException2(opts) {
    var _this = _super.call(this, __assign7({ name: "DependencyFailedException", $fault: "client" }, opts)) || this;
    _this.name = "DependencyFailedException";
    _this.$fault = "client";
    Object.setPrototypeOf(_this, DependencyFailedException2.prototype);
    _this.Message = opts.Message;
    return _this;
  }
  return DependencyFailedException2;
}(LexRuntimeServiceServiceException);
var LoopDetectedException = function(_super) {
  __extends3(LoopDetectedException2, _super);
  function LoopDetectedException2(opts) {
    var _this = _super.call(this, __assign7({ name: "LoopDetectedException", $fault: "server" }, opts)) || this;
    _this.name = "LoopDetectedException";
    _this.$fault = "server";
    Object.setPrototypeOf(_this, LoopDetectedException2.prototype);
    _this.Message = opts.Message;
    return _this;
  }
  return LoopDetectedException2;
}(LexRuntimeServiceServiceException);
var NotAcceptableException = function(_super) {
  __extends3(NotAcceptableException2, _super);
  function NotAcceptableException2(opts) {
    var _this = _super.call(this, __assign7({ name: "NotAcceptableException", $fault: "client" }, opts)) || this;
    _this.name = "NotAcceptableException";
    _this.$fault = "client";
    Object.setPrototypeOf(_this, NotAcceptableException2.prototype);
    return _this;
  }
  return NotAcceptableException2;
}(LexRuntimeServiceServiceException);
var DialogState;
(function(DialogState2) {
  DialogState2["CONFIRM_INTENT"] = "ConfirmIntent";
  DialogState2["ELICIT_INTENT"] = "ElicitIntent";
  DialogState2["ELICIT_SLOT"] = "ElicitSlot";
  DialogState2["FAILED"] = "Failed";
  DialogState2["FULFILLED"] = "Fulfilled";
  DialogState2["READY_FOR_FULFILLMENT"] = "ReadyForFulfillment";
})(DialogState || (DialogState = {}));
var RequestTimeoutException = function(_super) {
  __extends3(RequestTimeoutException2, _super);
  function RequestTimeoutException2(opts) {
    var _this = _super.call(this, __assign7({ name: "RequestTimeoutException", $fault: "client" }, opts)) || this;
    _this.name = "RequestTimeoutException";
    _this.$fault = "client";
    Object.setPrototypeOf(_this, RequestTimeoutException2.prototype);
    return _this;
  }
  return RequestTimeoutException2;
}(LexRuntimeServiceServiceException);
var UnsupportedMediaTypeException = function(_super) {
  __extends3(UnsupportedMediaTypeException2, _super);
  function UnsupportedMediaTypeException2(opts) {
    var _this = _super.call(this, __assign7({ name: "UnsupportedMediaTypeException", $fault: "client" }, opts)) || this;
    _this.name = "UnsupportedMediaTypeException";
    _this.$fault = "client";
    Object.setPrototypeOf(_this, UnsupportedMediaTypeException2.prototype);
    return _this;
  }
  return UnsupportedMediaTypeException2;
}(LexRuntimeServiceServiceException);
var ContentType;
(function(ContentType2) {
  ContentType2["GENERIC"] = "application/vnd.amazonaws.card.generic";
})(ContentType || (ContentType = {}));
var PostContentRequestFilterSensitiveLog = function(obj) {
  return __assign7(__assign7(__assign7(__assign7({}, obj), obj.sessionAttributes && { sessionAttributes: SENSITIVE_STRING2 }), obj.requestAttributes && { requestAttributes: SENSITIVE_STRING2 }), obj.activeContexts && { activeContexts: SENSITIVE_STRING2 });
};
var PostContentResponseFilterSensitiveLog = function(obj) {
  return __assign7(__assign7(__assign7(__assign7(__assign7({}, obj), obj.message && { message: SENSITIVE_STRING2 }), obj.encodedMessage && { encodedMessage: SENSITIVE_STRING2 }), obj.encodedInputTranscript && { encodedInputTranscript: SENSITIVE_STRING2 }), obj.activeContexts && { activeContexts: SENSITIVE_STRING2 });
};
var PostTextRequestFilterSensitiveLog = function(obj) {
  return __assign7(__assign7(__assign7(__assign7(__assign7({}, obj), obj.sessionAttributes && { sessionAttributes: SENSITIVE_STRING2 }), obj.requestAttributes && { requestAttributes: SENSITIVE_STRING2 }), obj.inputText && { inputText: SENSITIVE_STRING2 }), obj.activeContexts && { activeContexts: SENSITIVE_STRING2 });
};
var PredictedIntentFilterSensitiveLog = function(obj) {
  return __assign7(__assign7({}, obj), obj.slots && { slots: SENSITIVE_STRING2 });
};
var PostTextResponseFilterSensitiveLog = function(obj) {
  return __assign7(__assign7(__assign7(__assign7(__assign7(__assign7({}, obj), obj.alternativeIntents && {
    alternativeIntents: obj.alternativeIntents.map(function(item) {
      return PredictedIntentFilterSensitiveLog(item);
    })
  }), obj.slots && { slots: SENSITIVE_STRING2 }), obj.sessionAttributes && { sessionAttributes: SENSITIVE_STRING2 }), obj.message && { message: SENSITIVE_STRING2 }), obj.activeContexts && { activeContexts: SENSITIVE_STRING2 });
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/protocol-http/dist-es/httpRequest.js
var HttpRequest2 = function() {
  function HttpRequest4(options) {
    this.method = options.method || "GET";
    this.hostname = options.hostname || "localhost";
    this.port = options.port;
    this.query = options.query || {};
    this.headers = options.headers || {};
    this.body = options.body;
    this.protocol = options.protocol ? options.protocol.slice(-1) !== ":" ? "".concat(options.protocol, ":") : options.protocol : "https:";
    this.path = options.path ? options.path.charAt(0) !== "/" ? "/".concat(options.path) : options.path : "/";
  }
  HttpRequest4.isInstance = function(request) {
    if (!request)
      return false;
    var req = request;
    return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
  };
  HttpRequest4.prototype.clone = function() {
    var cloned = new HttpRequest4(__assign7(__assign7({}, this), { headers: __assign7({}, this.headers) }));
    if (cloned.query)
      cloned.query = cloneQuery3(cloned.query);
    return cloned;
  };
  return HttpRequest4;
}();
function cloneQuery3(query) {
  return Object.keys(query).reduce(function(carry, paramName) {
    var _a2;
    var param = query[paramName];
    return __assign7(__assign7({}, carry), (_a2 = {}, _a2[paramName] = Array.isArray(param) ? __spreadArray4([], __read10(param), false) : param, _a2));
  }, {});
}

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/protocol-http/dist-es/httpResponse.js
var HttpResponse2 = function() {
  function HttpResponse4(options) {
    this.statusCode = options.statusCode;
    this.headers = options.headers || {};
    this.body = options.body;
  }
  HttpResponse4.isInstance = function(response) {
    if (!response)
      return false;
    var resp = response;
    return typeof resp.statusCode === "number" && typeof resp.headers === "object";
  };
  return HttpResponse4;
}();

// node_modules/@aws-sdk/client-lex-runtime-service/dist-es/protocols/Aws_restJson1.js
var serializeAws_restJson1PostContentCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var _a2, hostname, _b2, protocol, port, basePath, headers, resolvedPath3, body;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port, basePath = _a2.path;
          headers = map2({}, isSerializableHeaderValue2, {
            "x-amz-content-sha256": "UNSIGNED-PAYLOAD",
            "content-type": input.contentType || "application/octet-stream",
            "x-amz-lex-session-attributes": [
              function() {
                return isSerializableHeaderValue2(input.sessionAttributes);
              },
              function() {
                return context.base64Encoder(Buffer.from(LazyJsonString2.fromObject(input.sessionAttributes)));
              }
            ],
            "x-amz-lex-request-attributes": [
              function() {
                return isSerializableHeaderValue2(input.requestAttributes);
              },
              function() {
                return context.base64Encoder(Buffer.from(LazyJsonString2.fromObject(input.requestAttributes)));
              }
            ],
            accept: input.accept,
            "x-amz-lex-active-contexts": [
              function() {
                return isSerializableHeaderValue2(input.activeContexts);
              },
              function() {
                return context.base64Encoder(Buffer.from(LazyJsonString2.fromObject(input.activeContexts)));
              }
            ]
          });
          resolvedPath3 = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bot/{botName}/alias/{botAlias}/user/{userId}/content";
          resolvedPath3 = resolvedPath(resolvedPath3, input, "botName", function() {
            return input.botName;
          }, "{botName}", false);
          resolvedPath3 = resolvedPath(resolvedPath3, input, "botAlias", function() {
            return input.botAlias;
          }, "{botAlias}", false);
          resolvedPath3 = resolvedPath(resolvedPath3, input, "userId", function() {
            return input.userId;
          }, "{userId}", false);
          if (input.inputStream !== void 0) {
            body = input.inputStream;
          }
          return [2, new HttpRequest2({
            protocol,
            hostname,
            port,
            method: "POST",
            headers,
            path: resolvedPath3,
            body
          })];
      }
    });
  });
};
var serializeAws_restJson1PostTextCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var _a2, hostname, _b2, protocol, port, basePath, headers, resolvedPath3, body;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port, basePath = _a2.path;
          headers = {
            "content-type": "application/json"
          };
          resolvedPath3 = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bot/{botName}/alias/{botAlias}/user/{userId}/text";
          resolvedPath3 = resolvedPath(resolvedPath3, input, "botName", function() {
            return input.botName;
          }, "{botName}", false);
          resolvedPath3 = resolvedPath(resolvedPath3, input, "botAlias", function() {
            return input.botAlias;
          }, "{botAlias}", false);
          resolvedPath3 = resolvedPath(resolvedPath3, input, "userId", function() {
            return input.userId;
          }, "{userId}", false);
          body = JSON.stringify(__assign7(__assign7(__assign7(__assign7({}, input.activeContexts != null && {
            activeContexts: serializeAws_restJson1ActiveContextsList(input.activeContexts, context)
          }), input.inputText != null && { inputText: input.inputText }), input.requestAttributes != null && {
            requestAttributes: serializeAws_restJson1StringMap(input.requestAttributes, context)
          }), input.sessionAttributes != null && {
            sessionAttributes: serializeAws_restJson1StringMap(input.sessionAttributes, context)
          }));
          return [2, new HttpRequest2({
            protocol,
            hostname,
            port,
            method: "POST",
            headers,
            path: resolvedPath3,
            body
          })];
      }
    });
  });
};
var deserializeAws_restJson1PostContentCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data;
    return __generator3(this, function(_a2) {
      if (output.statusCode !== 200 && output.statusCode >= 300) {
        return [2, deserializeAws_restJson1PostContentCommandError(output, context)];
      }
      contents = map2({
        $metadata: deserializeMetadata7(output),
        contentType: [, output.headers["content-type"]],
        intentName: [, output.headers["x-amz-lex-intent-name"]],
        nluIntentConfidence: [
          function() {
            return void 0 !== output.headers["x-amz-lex-nlu-intent-confidence"];
          },
          function() {
            return new LazyJsonString2(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-nlu-intent-confidence"])).toString("utf8"));
          }
        ],
        alternativeIntents: [
          function() {
            return void 0 !== output.headers["x-amz-lex-alternative-intents"];
          },
          function() {
            return new LazyJsonString2(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-alternative-intents"])).toString("utf8"));
          }
        ],
        slots: [
          function() {
            return void 0 !== output.headers["x-amz-lex-slots"];
          },
          function() {
            return new LazyJsonString2(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-slots"])).toString("utf8"));
          }
        ],
        sessionAttributes: [
          function() {
            return void 0 !== output.headers["x-amz-lex-session-attributes"];
          },
          function() {
            return new LazyJsonString2(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-session-attributes"])).toString("utf8"));
          }
        ],
        sentimentResponse: [, output.headers["x-amz-lex-sentiment"]],
        message: [, output.headers["x-amz-lex-message"]],
        encodedMessage: [, output.headers["x-amz-lex-encoded-message"]],
        messageFormat: [, output.headers["x-amz-lex-message-format"]],
        dialogState: [, output.headers["x-amz-lex-dialog-state"]],
        slotToElicit: [, output.headers["x-amz-lex-slot-to-elicit"]],
        inputTranscript: [, output.headers["x-amz-lex-input-transcript"]],
        encodedInputTranscript: [, output.headers["x-amz-lex-encoded-input-transcript"]],
        botVersion: [, output.headers["x-amz-lex-bot-version"]],
        sessionId: [, output.headers["x-amz-lex-session-id"]],
        activeContexts: [
          function() {
            return void 0 !== output.headers["x-amz-lex-active-contexts"];
          },
          function() {
            return new LazyJsonString2(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-active-contexts"])).toString("utf8"));
          }
        ]
      });
      data = output.body;
      contents.audioStream = data;
      return [2, contents];
    });
  });
};
var deserializeAws_restJson1PostContentCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, errorCode, _b2, parsedBody;
    var _c;
    return __generator3(this, function(_d) {
      switch (_d.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _c = {};
          return [4, parseErrorBody(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_c.body = _d.sent(), _c)]));
          errorCode = loadRestJsonErrorCode5(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "BadGatewayException":
              return [3, 2];
            case "com.amazonaws.lexruntimeservice#BadGatewayException":
              return [3, 2];
            case "BadRequestException":
              return [3, 4];
            case "com.amazonaws.lexruntimeservice#BadRequestException":
              return [3, 4];
            case "ConflictException":
              return [3, 6];
            case "com.amazonaws.lexruntimeservice#ConflictException":
              return [3, 6];
            case "DependencyFailedException":
              return [3, 8];
            case "com.amazonaws.lexruntimeservice#DependencyFailedException":
              return [3, 8];
            case "InternalFailureException":
              return [3, 10];
            case "com.amazonaws.lexruntimeservice#InternalFailureException":
              return [3, 10];
            case "LimitExceededException":
              return [3, 12];
            case "com.amazonaws.lexruntimeservice#LimitExceededException":
              return [3, 12];
            case "LoopDetectedException":
              return [3, 14];
            case "com.amazonaws.lexruntimeservice#LoopDetectedException":
              return [3, 14];
            case "NotAcceptableException":
              return [3, 16];
            case "com.amazonaws.lexruntimeservice#NotAcceptableException":
              return [3, 16];
            case "NotFoundException":
              return [3, 18];
            case "com.amazonaws.lexruntimeservice#NotFoundException":
              return [3, 18];
            case "RequestTimeoutException":
              return [3, 20];
            case "com.amazonaws.lexruntimeservice#RequestTimeoutException":
              return [3, 20];
            case "UnsupportedMediaTypeException":
              return [3, 22];
            case "com.amazonaws.lexruntimeservice#UnsupportedMediaTypeException":
              return [3, 22];
          }
          return [3, 24];
        case 2:
          return [4, deserializeAws_restJson1BadGatewayExceptionResponse(parsedOutput, context)];
        case 3:
          throw _d.sent();
        case 4:
          return [4, deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context)];
        case 5:
          throw _d.sent();
        case 6:
          return [4, deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)];
        case 7:
          throw _d.sent();
        case 8:
          return [4, deserializeAws_restJson1DependencyFailedExceptionResponse(parsedOutput, context)];
        case 9:
          throw _d.sent();
        case 10:
          return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
        case 11:
          throw _d.sent();
        case 12:
          return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
        case 13:
          throw _d.sent();
        case 14:
          return [4, deserializeAws_restJson1LoopDetectedExceptionResponse(parsedOutput, context)];
        case 15:
          throw _d.sent();
        case 16:
          return [4, deserializeAws_restJson1NotAcceptableExceptionResponse(parsedOutput, context)];
        case 17:
          throw _d.sent();
        case 18:
          return [4, deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context)];
        case 19:
          throw _d.sent();
        case 20:
          return [4, deserializeAws_restJson1RequestTimeoutExceptionResponse(parsedOutput, context)];
        case 21:
          throw _d.sent();
        case 22:
          return [4, deserializeAws_restJson1UnsupportedMediaTypeExceptionResponse(parsedOutput, context)];
        case 23:
          throw _d.sent();
        case 24:
          parsedBody = parsedOutput.body;
          throwDefaultError({
            output,
            parsedBody,
            exceptionCtor: LexRuntimeServiceServiceException,
            errorCode
          });
          _d.label = 25;
        case 25:
          return [2];
      }
    });
  });
};
var deserializeAws_restJson1PostTextCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, _a2, _b2;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2, deserializeAws_restJson1PostTextCommandError(output, context)];
          }
          contents = map2({
            $metadata: deserializeMetadata7(output)
          });
          _a2 = expectNonNull;
          _b2 = expectObject;
          return [4, parseBody6(output.body, context)];
        case 1:
          data = _a2.apply(void 0, [_b2.apply(void 0, [_c.sent()]), "body"]);
          if (data.activeContexts != null) {
            contents.activeContexts = deserializeAws_restJson1ActiveContextsList(data.activeContexts, context);
          }
          if (data.alternativeIntents != null) {
            contents.alternativeIntents = deserializeAws_restJson1IntentList(data.alternativeIntents, context);
          }
          if (data.botVersion != null) {
            contents.botVersion = expectString(data.botVersion);
          }
          if (data.dialogState != null) {
            contents.dialogState = expectString(data.dialogState);
          }
          if (data.intentName != null) {
            contents.intentName = expectString(data.intentName);
          }
          if (data.message != null) {
            contents.message = expectString(data.message);
          }
          if (data.messageFormat != null) {
            contents.messageFormat = expectString(data.messageFormat);
          }
          if (data.nluIntentConfidence != null) {
            contents.nluIntentConfidence = deserializeAws_restJson1IntentConfidence(data.nluIntentConfidence, context);
          }
          if (data.responseCard != null) {
            contents.responseCard = deserializeAws_restJson1ResponseCard(data.responseCard, context);
          }
          if (data.sentimentResponse != null) {
            contents.sentimentResponse = deserializeAws_restJson1SentimentResponse(data.sentimentResponse, context);
          }
          if (data.sessionAttributes != null) {
            contents.sessionAttributes = deserializeAws_restJson1StringMap(data.sessionAttributes, context);
          }
          if (data.sessionId != null) {
            contents.sessionId = expectString(data.sessionId);
          }
          if (data.slotToElicit != null) {
            contents.slotToElicit = expectString(data.slotToElicit);
          }
          if (data.slots != null) {
            contents.slots = deserializeAws_restJson1StringMap(data.slots, context);
          }
          return [2, contents];
      }
    });
  });
};
var deserializeAws_restJson1PostTextCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, errorCode, _b2, parsedBody;
    var _c;
    return __generator3(this, function(_d) {
      switch (_d.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _c = {};
          return [4, parseErrorBody(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_c.body = _d.sent(), _c)]));
          errorCode = loadRestJsonErrorCode5(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "BadGatewayException":
              return [3, 2];
            case "com.amazonaws.lexruntimeservice#BadGatewayException":
              return [3, 2];
            case "BadRequestException":
              return [3, 4];
            case "com.amazonaws.lexruntimeservice#BadRequestException":
              return [3, 4];
            case "ConflictException":
              return [3, 6];
            case "com.amazonaws.lexruntimeservice#ConflictException":
              return [3, 6];
            case "DependencyFailedException":
              return [3, 8];
            case "com.amazonaws.lexruntimeservice#DependencyFailedException":
              return [3, 8];
            case "InternalFailureException":
              return [3, 10];
            case "com.amazonaws.lexruntimeservice#InternalFailureException":
              return [3, 10];
            case "LimitExceededException":
              return [3, 12];
            case "com.amazonaws.lexruntimeservice#LimitExceededException":
              return [3, 12];
            case "LoopDetectedException":
              return [3, 14];
            case "com.amazonaws.lexruntimeservice#LoopDetectedException":
              return [3, 14];
            case "NotFoundException":
              return [3, 16];
            case "com.amazonaws.lexruntimeservice#NotFoundException":
              return [3, 16];
          }
          return [3, 18];
        case 2:
          return [4, deserializeAws_restJson1BadGatewayExceptionResponse(parsedOutput, context)];
        case 3:
          throw _d.sent();
        case 4:
          return [4, deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context)];
        case 5:
          throw _d.sent();
        case 6:
          return [4, deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)];
        case 7:
          throw _d.sent();
        case 8:
          return [4, deserializeAws_restJson1DependencyFailedExceptionResponse(parsedOutput, context)];
        case 9:
          throw _d.sent();
        case 10:
          return [4, deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)];
        case 11:
          throw _d.sent();
        case 12:
          return [4, deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)];
        case 13:
          throw _d.sent();
        case 14:
          return [4, deserializeAws_restJson1LoopDetectedExceptionResponse(parsedOutput, context)];
        case 15:
          throw _d.sent();
        case 16:
          return [4, deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context)];
        case 17:
          throw _d.sent();
        case 18:
          parsedBody = parsedOutput.body;
          throwDefaultError({
            output,
            parsedBody,
            exceptionCtor: LexRuntimeServiceServiceException,
            errorCode
          });
          _d.label = 19;
        case 19:
          return [2];
      }
    });
  });
};
var map2 = map;
var deserializeAws_restJson1BadGatewayExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, exception;
    return __generator3(this, function(_a2) {
      contents = map2({});
      data = parsedOutput.body;
      if (data.Message != null) {
        contents.Message = expectString(data.Message);
      }
      exception = new BadGatewayException(__assign7({ $metadata: deserializeMetadata7(parsedOutput) }, contents));
      return [2, decorateServiceException(exception, parsedOutput.body)];
    });
  });
};
var deserializeAws_restJson1BadRequestExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, exception;
    return __generator3(this, function(_a2) {
      contents = map2({});
      data = parsedOutput.body;
      if (data.message != null) {
        contents.message = expectString(data.message);
      }
      exception = new BadRequestException(__assign7({ $metadata: deserializeMetadata7(parsedOutput) }, contents));
      return [2, decorateServiceException(exception, parsedOutput.body)];
    });
  });
};
var deserializeAws_restJson1ConflictExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, exception;
    return __generator3(this, function(_a2) {
      contents = map2({});
      data = parsedOutput.body;
      if (data.message != null) {
        contents.message = expectString(data.message);
      }
      exception = new ConflictException(__assign7({ $metadata: deserializeMetadata7(parsedOutput) }, contents));
      return [2, decorateServiceException(exception, parsedOutput.body)];
    });
  });
};
var deserializeAws_restJson1DependencyFailedExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, exception;
    return __generator3(this, function(_a2) {
      contents = map2({});
      data = parsedOutput.body;
      if (data.Message != null) {
        contents.Message = expectString(data.Message);
      }
      exception = new DependencyFailedException(__assign7({ $metadata: deserializeMetadata7(parsedOutput) }, contents));
      return [2, decorateServiceException(exception, parsedOutput.body)];
    });
  });
};
var deserializeAws_restJson1InternalFailureExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, exception;
    return __generator3(this, function(_a2) {
      contents = map2({});
      data = parsedOutput.body;
      if (data.message != null) {
        contents.message = expectString(data.message);
      }
      exception = new InternalFailureException2(__assign7({ $metadata: deserializeMetadata7(parsedOutput) }, contents));
      return [2, decorateServiceException(exception, parsedOutput.body)];
    });
  });
};
var deserializeAws_restJson1LimitExceededExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, exception;
    return __generator3(this, function(_a2) {
      contents = map2({
        retryAfterSeconds: [, parsedOutput.headers["retry-after"]]
      });
      data = parsedOutput.body;
      if (data.message != null) {
        contents.message = expectString(data.message);
      }
      exception = new LimitExceededException4(__assign7({ $metadata: deserializeMetadata7(parsedOutput) }, contents));
      return [2, decorateServiceException(exception, parsedOutput.body)];
    });
  });
};
var deserializeAws_restJson1LoopDetectedExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, exception;
    return __generator3(this, function(_a2) {
      contents = map2({});
      data = parsedOutput.body;
      if (data.Message != null) {
        contents.Message = expectString(data.Message);
      }
      exception = new LoopDetectedException(__assign7({ $metadata: deserializeMetadata7(parsedOutput) }, contents));
      return [2, decorateServiceException(exception, parsedOutput.body)];
    });
  });
};
var deserializeAws_restJson1NotAcceptableExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, exception;
    return __generator3(this, function(_a2) {
      contents = map2({});
      data = parsedOutput.body;
      if (data.message != null) {
        contents.message = expectString(data.message);
      }
      exception = new NotAcceptableException(__assign7({ $metadata: deserializeMetadata7(parsedOutput) }, contents));
      return [2, decorateServiceException(exception, parsedOutput.body)];
    });
  });
};
var deserializeAws_restJson1NotFoundExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, exception;
    return __generator3(this, function(_a2) {
      contents = map2({});
      data = parsedOutput.body;
      if (data.message != null) {
        contents.message = expectString(data.message);
      }
      exception = new NotFoundException(__assign7({ $metadata: deserializeMetadata7(parsedOutput) }, contents));
      return [2, decorateServiceException(exception, parsedOutput.body)];
    });
  });
};
var deserializeAws_restJson1RequestTimeoutExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, exception;
    return __generator3(this, function(_a2) {
      contents = map2({});
      data = parsedOutput.body;
      if (data.message != null) {
        contents.message = expectString(data.message);
      }
      exception = new RequestTimeoutException(__assign7({ $metadata: deserializeMetadata7(parsedOutput) }, contents));
      return [2, decorateServiceException(exception, parsedOutput.body)];
    });
  });
};
var deserializeAws_restJson1UnsupportedMediaTypeExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, exception;
    return __generator3(this, function(_a2) {
      contents = map2({});
      data = parsedOutput.body;
      if (data.message != null) {
        contents.message = expectString(data.message);
      }
      exception = new UnsupportedMediaTypeException(__assign7({ $metadata: deserializeMetadata7(parsedOutput) }, contents));
      return [2, decorateServiceException(exception, parsedOutput.body)];
    });
  });
};
var serializeAws_restJson1ActiveContext = function(input, context) {
  return __assign7(__assign7(__assign7({}, input.name != null && { name: input.name }), input.parameters != null && {
    parameters: serializeAws_restJson1ActiveContextParametersMap(input.parameters, context)
  }), input.timeToLive != null && {
    timeToLive: serializeAws_restJson1ActiveContextTimeToLive(input.timeToLive, context)
  });
};
var serializeAws_restJson1ActiveContextParametersMap = function(input, context) {
  return Object.entries(input).reduce(function(acc, _a2) {
    var _b2;
    var _c = __read10(_a2, 2), key = _c[0], value = _c[1];
    if (value === null) {
      return acc;
    }
    return __assign7(__assign7({}, acc), (_b2 = {}, _b2[key] = value, _b2));
  }, {});
};
var serializeAws_restJson1ActiveContextsList = function(input, context) {
  return input.filter(function(e) {
    return e != null;
  }).map(function(entry) {
    return serializeAws_restJson1ActiveContext(entry, context);
  });
};
var serializeAws_restJson1ActiveContextTimeToLive = function(input, context) {
  return __assign7(__assign7({}, input.timeToLiveInSeconds != null && { timeToLiveInSeconds: input.timeToLiveInSeconds }), input.turnsToLive != null && { turnsToLive: input.turnsToLive });
};
var serializeAws_restJson1StringMap = function(input, context) {
  return Object.entries(input).reduce(function(acc, _a2) {
    var _b2;
    var _c = __read10(_a2, 2), key = _c[0], value = _c[1];
    if (value === null) {
      return acc;
    }
    return __assign7(__assign7({}, acc), (_b2 = {}, _b2[key] = value, _b2));
  }, {});
};
var deserializeAws_restJson1ActiveContext = function(output, context) {
  return {
    name: expectString(output.name),
    parameters: output.parameters != null ? deserializeAws_restJson1ActiveContextParametersMap(output.parameters, context) : void 0,
    timeToLive: output.timeToLive != null ? deserializeAws_restJson1ActiveContextTimeToLive(output.timeToLive, context) : void 0
  };
};
var deserializeAws_restJson1ActiveContextParametersMap = function(output, context) {
  return Object.entries(output).reduce(function(acc, _a2) {
    var _b2;
    var _c = __read10(_a2, 2), key = _c[0], value = _c[1];
    if (value === null) {
      return acc;
    }
    return __assign7(__assign7({}, acc), (_b2 = {}, _b2[key] = expectString(value), _b2));
  }, {});
};
var deserializeAws_restJson1ActiveContextsList = function(output, context) {
  var retVal = (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_restJson1ActiveContext(entry, context);
  });
  return retVal;
};
var deserializeAws_restJson1ActiveContextTimeToLive = function(output, context) {
  return {
    timeToLiveInSeconds: expectInt32(output.timeToLiveInSeconds),
    turnsToLive: expectInt32(output.turnsToLive)
  };
};
var deserializeAws_restJson1Button = function(output, context) {
  return {
    text: expectString(output.text),
    value: expectString(output.value)
  };
};
var deserializeAws_restJson1GenericAttachment = function(output, context) {
  return {
    attachmentLinkUrl: expectString(output.attachmentLinkUrl),
    buttons: output.buttons != null ? deserializeAws_restJson1listOfButtons(output.buttons, context) : void 0,
    imageUrl: expectString(output.imageUrl),
    subTitle: expectString(output.subTitle),
    title: expectString(output.title)
  };
};
var deserializeAws_restJson1genericAttachmentList = function(output, context) {
  var retVal = (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_restJson1GenericAttachment(entry, context);
  });
  return retVal;
};
var deserializeAws_restJson1IntentConfidence = function(output, context) {
  return {
    score: limitedParseDouble(output.score)
  };
};
var deserializeAws_restJson1IntentList = function(output, context) {
  var retVal = (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_restJson1PredictedIntent(entry, context);
  });
  return retVal;
};
var deserializeAws_restJson1listOfButtons = function(output, context) {
  var retVal = (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_restJson1Button(entry, context);
  });
  return retVal;
};
var deserializeAws_restJson1PredictedIntent = function(output, context) {
  return {
    intentName: expectString(output.intentName),
    nluIntentConfidence: output.nluIntentConfidence != null ? deserializeAws_restJson1IntentConfidence(output.nluIntentConfidence, context) : void 0,
    slots: output.slots != null ? deserializeAws_restJson1StringMap(output.slots, context) : void 0
  };
};
var deserializeAws_restJson1ResponseCard = function(output, context) {
  return {
    contentType: expectString(output.contentType),
    genericAttachments: output.genericAttachments != null ? deserializeAws_restJson1genericAttachmentList(output.genericAttachments, context) : void 0,
    version: expectString(output.version)
  };
};
var deserializeAws_restJson1SentimentResponse = function(output, context) {
  return {
    sentimentLabel: expectString(output.sentimentLabel),
    sentimentScore: expectString(output.sentimentScore)
  };
};
var deserializeAws_restJson1StringMap = function(output, context) {
  return Object.entries(output).reduce(function(acc, _a2) {
    var _b2;
    var _c = __read10(_a2, 2), key = _c[0], value = _c[1];
    if (value === null) {
      return acc;
    }
    return __assign7(__assign7({}, acc), (_b2 = {}, _b2[key] = expectString(value), _b2));
  }, {});
};
var deserializeMetadata7 = function(output) {
  var _a2, _b2;
  return {
    httpStatusCode: output.statusCode,
    requestId: (_b2 = (_a2 = output.headers["x-amzn-requestid"]) !== null && _a2 !== void 0 ? _a2 : output.headers["x-amzn-request-id"]) !== null && _b2 !== void 0 ? _b2 : output.headers["x-amz-request-id"],
    extendedRequestId: output.headers["x-amz-id-2"],
    cfId: output.headers["x-amz-cf-id"]
  };
};
var collectBody7 = function(streamBody, context) {
  if (streamBody === void 0) {
    streamBody = new Uint8Array();
  }
  if (streamBody instanceof Uint8Array) {
    return Promise.resolve(streamBody);
  }
  return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
var collectBodyString7 = function(streamBody, context) {
  return collectBody7(streamBody, context).then(function(body) {
    return context.utf8Encoder(body);
  });
};
var isSerializableHeaderValue2 = function(value) {
  return value !== void 0 && value !== null && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};
var parseBody6 = function(streamBody, context) {
  return collectBodyString7(streamBody, context).then(function(encoded) {
    if (encoded.length) {
      return JSON.parse(encoded);
    }
    return {};
  });
};
var parseErrorBody = function(errorBody, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var value;
    var _a2;
    return __generator3(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          return [4, parseBody6(errorBody, context)];
        case 1:
          value = _b2.sent();
          value.message = (_a2 = value.message) !== null && _a2 !== void 0 ? _a2 : value.Message;
          return [2, value];
      }
    });
  });
};
var loadRestJsonErrorCode5 = function(output, data) {
  var findKey = function(object, key) {
    return Object.keys(object).find(function(k2) {
      return k2.toLowerCase() === key.toLowerCase();
    });
  };
  var sanitizeErrorCode = function(rawValue) {
    var cleanValue = rawValue;
    if (typeof cleanValue === "number") {
      cleanValue = cleanValue.toString();
    }
    if (cleanValue.indexOf(",") >= 0) {
      cleanValue = cleanValue.split(",")[0];
    }
    if (cleanValue.indexOf(":") >= 0) {
      cleanValue = cleanValue.split(":")[0];
    }
    if (cleanValue.indexOf("#") >= 0) {
      cleanValue = cleanValue.split("#")[1];
    }
    return cleanValue;
  };
  var headerKey = findKey(output.headers, "x-amzn-errortype");
  if (headerKey !== void 0) {
    return sanitizeErrorCode(output.headers[headerKey]);
  }
  if (data.code !== void 0) {
    return sanitizeErrorCode(data.code);
  }
  if (data["__type"] !== void 0) {
    return sanitizeErrorCode(data["__type"]);
  }
};

// node_modules/@aws-sdk/client-lex-runtime-service/dist-es/commands/PostContentCommand.js
var PostContentCommand = function(_super) {
  __extends3(PostContentCommand2, _super);
  function PostContentCommand2(input) {
    var _this = _super.call(this) || this;
    _this.input = input;
    return _this;
  }
  PostContentCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
    this.middlewareStack.use(getSerdePlugin2(configuration, this.serialize, this.deserialize));
    var stack = clientStack.concat(this.middlewareStack);
    var logger64 = configuration.logger;
    var clientName = "LexRuntimeServiceClient";
    var commandName = "PostContentCommand";
    var handlerExecutionContext = {
      logger: logger64,
      clientName,
      commandName,
      inputFilterSensitiveLog: PostContentRequestFilterSensitiveLog,
      outputFilterSensitiveLog: PostContentResponseFilterSensitiveLog
    };
    var requestHandler = configuration.requestHandler;
    return stack.resolve(function(request) {
      return requestHandler.handle(request.request, options || {});
    }, handlerExecutionContext);
  };
  PostContentCommand2.prototype.serialize = function(input, context) {
    return serializeAws_restJson1PostContentCommand(input, context);
  };
  PostContentCommand2.prototype.deserialize = function(output, context) {
    return deserializeAws_restJson1PostContentCommand(output, context);
  };
  return PostContentCommand2;
}(Command2);

// node_modules/@aws-sdk/client-lex-runtime-service/dist-es/commands/PostTextCommand.js
var PostTextCommand = function(_super) {
  __extends3(PostTextCommand2, _super);
  function PostTextCommand2(input) {
    var _this = _super.call(this) || this;
    _this.input = input;
    return _this;
  }
  PostTextCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
    this.middlewareStack.use(getSerdePlugin2(configuration, this.serialize, this.deserialize));
    var stack = clientStack.concat(this.middlewareStack);
    var logger64 = configuration.logger;
    var clientName = "LexRuntimeServiceClient";
    var commandName = "PostTextCommand";
    var handlerExecutionContext = {
      logger: logger64,
      clientName,
      commandName,
      inputFilterSensitiveLog: PostTextRequestFilterSensitiveLog,
      outputFilterSensitiveLog: PostTextResponseFilterSensitiveLog
    };
    var requestHandler = configuration.requestHandler;
    return stack.resolve(function(request) {
      return requestHandler.handle(request.request, options || {});
    }, handlerExecutionContext);
  };
  PostTextCommand2.prototype.serialize = function(input, context) {
    return serializeAws_restJson1PostTextCommand(input, context);
  };
  PostTextCommand2.prototype.deserialize = function(output, context) {
    return deserializeAws_restJson1PostTextCommand(output, context);
  };
  return PostTextCommand2;
}(Command2);

// node_modules/@aws-sdk/util-config-provider/dist-es/booleanSelector.js
var SelectorType;
(function(SelectorType2) {
  SelectorType2["ENV"] = "env";
  SelectorType2["CONFIG"] = "shared config entry";
})(SelectorType || (SelectorType = {}));

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/config-resolver/dist-es/endpointsConfig/NodeUseDualstackEndpointConfigOptions.js
var DEFAULT_USE_DUALSTACK_ENDPOINT = false;

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/config-resolver/dist-es/endpointsConfig/NodeUseFipsEndpointConfigOptions.js
var DEFAULT_USE_FIPS_ENDPOINT = false;

// node_modules/@aws-sdk/util-middleware/dist-es/normalizeProvider.js
var normalizeProvider6 = function(input) {
  if (typeof input === "function")
    return input;
  var promisified = Promise.resolve(input);
  return function() {
    return promisified;
  };
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/config-resolver/dist-es/endpointsConfig/utils/getEndpointFromRegion.js
var getEndpointFromRegion = function(input) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var _a2, tls, region, dnsHostRegex, useDualstackEndpoint, useFipsEndpoint, hostname;
    var _b2;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          _a2 = input.tls, tls = _a2 === void 0 ? true : _a2;
          return [4, input.region()];
        case 1:
          region = _c.sent();
          dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
          if (!dnsHostRegex.test(region)) {
            throw new Error("Invalid region in client config");
          }
          return [4, input.useDualstackEndpoint()];
        case 2:
          useDualstackEndpoint = _c.sent();
          return [4, input.useFipsEndpoint()];
        case 3:
          useFipsEndpoint = _c.sent();
          return [4, input.regionInfoProvider(region, { useDualstackEndpoint, useFipsEndpoint })];
        case 4:
          hostname = ((_b2 = _c.sent()) !== null && _b2 !== void 0 ? _b2 : {}).hostname;
          if (!hostname) {
            throw new Error("Cannot resolve hostname from client config");
          }
          return [2, input.urlParser("".concat(tls ? "https:" : "http:", "//").concat(hostname))];
      }
    });
  });
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/config-resolver/dist-es/endpointsConfig/resolveEndpointsConfig.js
var resolveEndpointsConfig2 = function(input) {
  var _a2;
  var useDualstackEndpoint = normalizeProvider6(input.useDualstackEndpoint);
  var endpoint = input.endpoint, useFipsEndpoint = input.useFipsEndpoint, urlParser = input.urlParser;
  return __assign7(__assign7({}, input), { tls: (_a2 = input.tls) !== null && _a2 !== void 0 ? _a2 : true, endpoint: endpoint ? normalizeProvider6(typeof endpoint === "string" ? urlParser(endpoint) : endpoint) : function() {
    return getEndpointFromRegion(__assign7(__assign7({}, input), { useDualstackEndpoint, useFipsEndpoint }));
  }, isCustomEndpoint: !!endpoint, useDualstackEndpoint });
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/config-resolver/dist-es/regionConfig/isFipsRegion.js
var isFipsRegion2 = function(region) {
  return typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/config-resolver/dist-es/regionConfig/getRealRegion.js
var getRealRegion = function(region) {
  return isFipsRegion2(region) ? ["fips-aws-global", "aws-fips"].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/config-resolver/dist-es/regionConfig/resolveRegionConfig.js
var resolveRegionConfig2 = function(input) {
  var region = input.region, useFipsEndpoint = input.useFipsEndpoint;
  if (!region) {
    throw new Error("Region is missing");
  }
  return __assign7(__assign7({}, input), { region: function() {
    return __awaiter3(void 0, void 0, void 0, function() {
      var providedRegion;
      return __generator3(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            if (typeof region === "string") {
              return [2, getRealRegion(region)];
            }
            return [4, region()];
          case 1:
            providedRegion = _a2.sent();
            return [2, getRealRegion(providedRegion)];
        }
      });
    });
  }, useFipsEndpoint: function() {
    return __awaiter3(void 0, void 0, void 0, function() {
      var providedRegion, _a2;
      return __generator3(this, function(_b2) {
        switch (_b2.label) {
          case 0:
            if (!(typeof region === "string"))
              return [3, 1];
            _a2 = region;
            return [3, 3];
          case 1:
            return [4, region()];
          case 2:
            _a2 = _b2.sent();
            _b2.label = 3;
          case 3:
            providedRegion = _a2;
            if (isFipsRegion2(providedRegion)) {
              return [2, true];
            }
            return [2, typeof useFipsEndpoint === "boolean" ? Promise.resolve(useFipsEndpoint) : useFipsEndpoint()];
        }
      });
    });
  } });
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/config-resolver/dist-es/regionInfo/getHostnameFromVariants.js
var getHostnameFromVariants = function(variants, _a2) {
  var _b2;
  if (variants === void 0) {
    variants = [];
  }
  var useFipsEndpoint = _a2.useFipsEndpoint, useDualstackEndpoint = _a2.useDualstackEndpoint;
  return (_b2 = variants.find(function(_a3) {
    var tags = _a3.tags;
    return useFipsEndpoint === tags.includes("fips") && useDualstackEndpoint === tags.includes("dualstack");
  })) === null || _b2 === void 0 ? void 0 : _b2.hostname;
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/config-resolver/dist-es/regionInfo/getResolvedHostname.js
var getResolvedHostname = function(resolvedRegion, _a2) {
  var regionHostname = _a2.regionHostname, partitionHostname = _a2.partitionHostname;
  return regionHostname ? regionHostname : partitionHostname ? partitionHostname.replace("{region}", resolvedRegion) : void 0;
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/config-resolver/dist-es/regionInfo/getResolvedPartition.js
var getResolvedPartition = function(region, _a2) {
  var _b2;
  var partitionHash3 = _a2.partitionHash;
  return (_b2 = Object.keys(partitionHash3 || {}).find(function(key) {
    return partitionHash3[key].regions.includes(region);
  })) !== null && _b2 !== void 0 ? _b2 : "aws";
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/config-resolver/dist-es/regionInfo/getResolvedSigningRegion.js
var getResolvedSigningRegion = function(hostname, _a2) {
  var signingRegion = _a2.signingRegion, regionRegex = _a2.regionRegex, useFipsEndpoint = _a2.useFipsEndpoint;
  if (signingRegion) {
    return signingRegion;
  } else if (useFipsEndpoint) {
    var regionRegexJs = regionRegex.replace("\\\\", "\\").replace(/^\^/g, "\\.").replace(/\$$/g, "\\.");
    var regionRegexmatchArray = hostname.match(regionRegexJs);
    if (regionRegexmatchArray) {
      return regionRegexmatchArray[0].slice(1, -1);
    }
  }
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/config-resolver/dist-es/regionInfo/getRegionInfo.js
var getRegionInfo = function(region, _a2) {
  var _b2, _c, _d, _e, _f, _g;
  var _h = _a2.useFipsEndpoint, useFipsEndpoint = _h === void 0 ? false : _h, _j = _a2.useDualstackEndpoint, useDualstackEndpoint = _j === void 0 ? false : _j, signingService = _a2.signingService, regionHash3 = _a2.regionHash, partitionHash3 = _a2.partitionHash;
  var partition = getResolvedPartition(region, { partitionHash: partitionHash3 });
  var resolvedRegion = region in regionHash3 ? region : (_c = (_b2 = partitionHash3[partition]) === null || _b2 === void 0 ? void 0 : _b2.endpoint) !== null && _c !== void 0 ? _c : region;
  var hostnameOptions = { useFipsEndpoint, useDualstackEndpoint };
  var regionHostname = getHostnameFromVariants((_d = regionHash3[resolvedRegion]) === null || _d === void 0 ? void 0 : _d.variants, hostnameOptions);
  var partitionHostname = getHostnameFromVariants((_e = partitionHash3[partition]) === null || _e === void 0 ? void 0 : _e.variants, hostnameOptions);
  var hostname = getResolvedHostname(resolvedRegion, { regionHostname, partitionHostname });
  if (hostname === void 0) {
    throw new Error("Endpoint resolution failed for: ".concat({ resolvedRegion, useFipsEndpoint, useDualstackEndpoint }));
  }
  var signingRegion = getResolvedSigningRegion(hostname, {
    signingRegion: (_f = regionHash3[resolvedRegion]) === null || _f === void 0 ? void 0 : _f.signingRegion,
    regionRegex: partitionHash3[partition].regionRegex,
    useFipsEndpoint
  });
  return __assign7(__assign7({ partition, signingService, hostname }, signingRegion && { signingRegion }), ((_g = regionHash3[resolvedRegion]) === null || _g === void 0 ? void 0 : _g.signingService) && {
    signingService: regionHash3[resolvedRegion].signingService
  });
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-content-length/dist-es/index.js
var CONTENT_LENGTH_HEADER2 = "content-length";
function contentLengthMiddleware2(bodyLengthChecker) {
  var _this = this;
  return function(next) {
    return function(args) {
      return __awaiter3(_this, void 0, void 0, function() {
        var request, body, headers, length_1;
        var _a2;
        return __generator3(this, function(_b2) {
          request = args.request;
          if (HttpRequest2.isInstance(request)) {
            body = request.body, headers = request.headers;
            if (body && Object.keys(headers).map(function(str) {
              return str.toLowerCase();
            }).indexOf(CONTENT_LENGTH_HEADER2) === -1) {
              try {
                length_1 = bodyLengthChecker(body);
                request.headers = __assign7(__assign7({}, request.headers), (_a2 = {}, _a2[CONTENT_LENGTH_HEADER2] = String(length_1), _a2));
              } catch (error) {
              }
            }
          }
          return [2, next(__assign7(__assign7({}, args), { request }))];
        });
      });
    };
  };
}
var contentLengthMiddlewareOptions2 = {
  step: "build",
  tags: ["SET_CONTENT_LENGTH", "CONTENT_LENGTH"],
  name: "contentLengthMiddleware",
  override: true
};
var getContentLengthPlugin2 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(contentLengthMiddleware2(options.bodyLengthChecker), contentLengthMiddlewareOptions2);
    }
  };
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-host-header/dist-es/index.js
function resolveHostHeaderConfig6(input) {
  return input;
}
var hostHeaderMiddleware6 = function(options) {
  return function(next) {
    return function(args) {
      return __awaiter3(void 0, void 0, void 0, function() {
        var request, _a2, handlerProtocol;
        return __generator3(this, function(_b2) {
          if (!HttpRequest2.isInstance(args.request))
            return [2, next(args)];
          request = args.request;
          _a2 = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a2 === void 0 ? "" : _a2;
          if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
            delete request.headers["host"];
            request.headers[":authority"] = "";
          } else if (!request.headers["host"]) {
            request.headers["host"] = request.hostname;
          }
          return [2, next(args)];
        });
      });
    };
  };
};
var hostHeaderMiddlewareOptions6 = {
  name: "hostHeaderMiddleware",
  step: "build",
  priority: "low",
  tags: ["HOST"],
  override: true
};
var getHostHeaderPlugin6 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(hostHeaderMiddleware6(options), hostHeaderMiddlewareOptions6);
    }
  };
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-logger/dist-es/loggerMiddleware.js
var loggerMiddleware6 = function() {
  return function(next, context) {
    return function(args) {
      return __awaiter3(void 0, void 0, void 0, function() {
        var clientName, commandName, inputFilterSensitiveLog, logger64, outputFilterSensitiveLog, response, _a2, $metadata, outputWithoutMetadata;
        return __generator3(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger64 = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
              return [4, next(args)];
            case 1:
              response = _b2.sent();
              if (!logger64) {
                return [2, response];
              }
              if (typeof logger64.info === "function") {
                _a2 = response.output, $metadata = _a2.$metadata, outputWithoutMetadata = __rest2(_a2, ["$metadata"]);
                logger64.info({
                  clientName,
                  commandName,
                  input: inputFilterSensitiveLog(args.input),
                  output: outputFilterSensitiveLog(outputWithoutMetadata),
                  metadata: $metadata
                });
              }
              return [2, response];
          }
        });
      });
    };
  };
};
var loggerMiddlewareOptions6 = {
  name: "loggerMiddleware",
  tags: ["LOGGER"],
  step: "initialize",
  override: true
};
var getLoggerPlugin6 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(loggerMiddleware6(), loggerMiddlewareOptions6);
    }
  };
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-recursion-detection/dist-es/index.js
var TRACE_ID_HEADER_NAME = "X-Amzn-Trace-Id";
var ENV_LAMBDA_FUNCTION_NAME = "AWS_LAMBDA_FUNCTION_NAME";
var ENV_TRACE_ID = "_X_AMZN_TRACE_ID";
var recursionDetectionMiddleware = function(options) {
  return function(next) {
    return function(args) {
      return __awaiter3(void 0, void 0, void 0, function() {
        var request, functionName, traceId, nonEmptyString;
        return __generator3(this, function(_a2) {
          request = args.request;
          if (!HttpRequest2.isInstance(request) || options.runtime !== "node" || request.headers.hasOwnProperty(TRACE_ID_HEADER_NAME)) {
            return [2, next(args)];
          }
          functionName = process.env[ENV_LAMBDA_FUNCTION_NAME];
          traceId = process.env[ENV_TRACE_ID];
          nonEmptyString = function(str) {
            return typeof str === "string" && str.length > 0;
          };
          if (nonEmptyString(functionName) && nonEmptyString(traceId)) {
            request.headers[TRACE_ID_HEADER_NAME] = traceId;
          }
          return [2, next(__assign7(__assign7({}, args), { request }))];
        });
      });
    };
  };
};
var addRecursionDetectionMiddlewareOptions = {
  step: "build",
  tags: ["RECURSION_DETECTION"],
  name: "recursionDetectionMiddleware",
  override: true,
  priority: "low"
};
var getRecursionDetectionPlugin = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(recursionDetectionMiddleware(options), addRecursionDetectionMiddlewareOptions);
    }
  };
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-retry/dist-es/config.js
var RETRY_MODES;
(function(RETRY_MODES3) {
  RETRY_MODES3["STANDARD"] = "standard";
  RETRY_MODES3["ADAPTIVE"] = "adaptive";
})(RETRY_MODES || (RETRY_MODES = {}));
var DEFAULT_MAX_ATTEMPTS2 = 3;
var DEFAULT_RETRY_MODE2 = RETRY_MODES.STANDARD;

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/service-error-classification/dist-es/constants.js
var CLOCK_SKEW_ERROR_CODES3 = [
  "AuthFailure",
  "InvalidSignatureException",
  "RequestExpired",
  "RequestInTheFuture",
  "RequestTimeTooSkewed",
  "SignatureDoesNotMatch"
];
var THROTTLING_ERROR_CODES3 = [
  "BandwidthLimitExceeded",
  "EC2ThrottledException",
  "LimitExceededException",
  "PriorRequestNotComplete",
  "ProvisionedThroughputExceededException",
  "RequestLimitExceeded",
  "RequestThrottled",
  "RequestThrottledException",
  "SlowDown",
  "ThrottledException",
  "Throttling",
  "ThrottlingException",
  "TooManyRequestsException",
  "TransactionInProgressException"
];
var TRANSIENT_ERROR_CODES2 = ["AbortError", "TimeoutError", "RequestTimeout", "RequestTimeoutException"];
var TRANSIENT_ERROR_STATUS_CODES2 = [500, 502, 503, 504];
var NODEJS_TIMEOUT_ERROR_CODES = ["ECONNRESET", "EPIPE", "ETIMEDOUT"];

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/service-error-classification/dist-es/index.js
var isRetryableByTrait2 = function(error) {
  return error.$retryable !== void 0;
};
var isClockSkewError3 = function(error) {
  return CLOCK_SKEW_ERROR_CODES3.includes(error.name);
};
var isThrottlingError3 = function(error) {
  var _a2, _b2;
  return ((_a2 = error.$metadata) === null || _a2 === void 0 ? void 0 : _a2.httpStatusCode) === 429 || THROTTLING_ERROR_CODES3.includes(error.name) || ((_b2 = error.$retryable) === null || _b2 === void 0 ? void 0 : _b2.throttling) == true;
};
var isTransientError2 = function(error) {
  var _a2;
  return TRANSIENT_ERROR_CODES2.includes(error.name) || NODEJS_TIMEOUT_ERROR_CODES.includes((error === null || error === void 0 ? void 0 : error.code) || "") || TRANSIENT_ERROR_STATUS_CODES2.includes(((_a2 = error.$metadata) === null || _a2 === void 0 ? void 0 : _a2.httpStatusCode) || 0);
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-retry/dist-es/DefaultRateLimiter.js
var DefaultRateLimiter = function() {
  function DefaultRateLimiter3(options) {
    var _a2, _b2, _c, _d, _e;
    this.currentCapacity = 0;
    this.enabled = false;
    this.lastMaxRate = 0;
    this.measuredTxRate = 0;
    this.requestCount = 0;
    this.lastTimestamp = 0;
    this.timeWindow = 0;
    this.beta = (_a2 = options === null || options === void 0 ? void 0 : options.beta) !== null && _a2 !== void 0 ? _a2 : 0.7;
    this.minCapacity = (_b2 = options === null || options === void 0 ? void 0 : options.minCapacity) !== null && _b2 !== void 0 ? _b2 : 1;
    this.minFillRate = (_c = options === null || options === void 0 ? void 0 : options.minFillRate) !== null && _c !== void 0 ? _c : 0.5;
    this.scaleConstant = (_d = options === null || options === void 0 ? void 0 : options.scaleConstant) !== null && _d !== void 0 ? _d : 0.4;
    this.smooth = (_e = options === null || options === void 0 ? void 0 : options.smooth) !== null && _e !== void 0 ? _e : 0.8;
    var currentTimeInSeconds = this.getCurrentTimeInSeconds();
    this.lastThrottleTime = currentTimeInSeconds;
    this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds());
    this.fillRate = this.minFillRate;
    this.maxCapacity = this.minCapacity;
  }
  DefaultRateLimiter3.prototype.getCurrentTimeInSeconds = function() {
    return Date.now() / 1e3;
  };
  DefaultRateLimiter3.prototype.getSendToken = function() {
    return __awaiter3(this, void 0, void 0, function() {
      return __generator3(this, function(_a2) {
        return [2, this.acquireTokenBucket(1)];
      });
    });
  };
  DefaultRateLimiter3.prototype.acquireTokenBucket = function(amount) {
    return __awaiter3(this, void 0, void 0, function() {
      var delay_1;
      return __generator3(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            if (!this.enabled) {
              return [2];
            }
            this.refillTokenBucket();
            if (!(amount > this.currentCapacity))
              return [3, 2];
            delay_1 = (amount - this.currentCapacity) / this.fillRate * 1e3;
            return [4, new Promise(function(resolve) {
              return setTimeout(resolve, delay_1);
            })];
          case 1:
            _a2.sent();
            _a2.label = 2;
          case 2:
            this.currentCapacity = this.currentCapacity - amount;
            return [2];
        }
      });
    });
  };
  DefaultRateLimiter3.prototype.refillTokenBucket = function() {
    var timestamp = this.getCurrentTimeInSeconds();
    if (!this.lastTimestamp) {
      this.lastTimestamp = timestamp;
      return;
    }
    var fillAmount = (timestamp - this.lastTimestamp) * this.fillRate;
    this.currentCapacity = Math.min(this.maxCapacity, this.currentCapacity + fillAmount);
    this.lastTimestamp = timestamp;
  };
  DefaultRateLimiter3.prototype.updateClientSendingRate = function(response) {
    var calculatedRate;
    this.updateMeasuredRate();
    if (isThrottlingError3(response)) {
      var rateToUse = !this.enabled ? this.measuredTxRate : Math.min(this.measuredTxRate, this.fillRate);
      this.lastMaxRate = rateToUse;
      this.calculateTimeWindow();
      this.lastThrottleTime = this.getCurrentTimeInSeconds();
      calculatedRate = this.cubicThrottle(rateToUse);
      this.enableTokenBucket();
    } else {
      this.calculateTimeWindow();
      calculatedRate = this.cubicSuccess(this.getCurrentTimeInSeconds());
    }
    var newRate = Math.min(calculatedRate, 2 * this.measuredTxRate);
    this.updateTokenBucketRate(newRate);
  };
  DefaultRateLimiter3.prototype.calculateTimeWindow = function() {
    this.timeWindow = this.getPrecise(Math.pow(this.lastMaxRate * (1 - this.beta) / this.scaleConstant, 1 / 3));
  };
  DefaultRateLimiter3.prototype.cubicThrottle = function(rateToUse) {
    return this.getPrecise(rateToUse * this.beta);
  };
  DefaultRateLimiter3.prototype.cubicSuccess = function(timestamp) {
    return this.getPrecise(this.scaleConstant * Math.pow(timestamp - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
  };
  DefaultRateLimiter3.prototype.enableTokenBucket = function() {
    this.enabled = true;
  };
  DefaultRateLimiter3.prototype.updateTokenBucketRate = function(newRate) {
    this.refillTokenBucket();
    this.fillRate = Math.max(newRate, this.minFillRate);
    this.maxCapacity = Math.max(newRate, this.minCapacity);
    this.currentCapacity = Math.min(this.currentCapacity, this.maxCapacity);
  };
  DefaultRateLimiter3.prototype.updateMeasuredRate = function() {
    var t2 = this.getCurrentTimeInSeconds();
    var timeBucket = Math.floor(t2 * 2) / 2;
    this.requestCount++;
    if (timeBucket > this.lastTxRateBucket) {
      var currentRate = this.requestCount / (timeBucket - this.lastTxRateBucket);
      this.measuredTxRate = this.getPrecise(currentRate * this.smooth + this.measuredTxRate * (1 - this.smooth));
      this.requestCount = 0;
      this.lastTxRateBucket = timeBucket;
    }
  };
  DefaultRateLimiter3.prototype.getPrecise = function(num) {
    return parseFloat(num.toFixed(8));
  };
  return DefaultRateLimiter3;
}();

// node_modules/uuid/dist/esm-browser/rng.js
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}

// node_modules/uuid/dist/esm-browser/regex.js
var regex_default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

// node_modules/uuid/dist/esm-browser/validate.js
function validate2(uuid6) {
  return typeof uuid6 === "string" && regex_default.test(uuid6);
}
var validate_default = validate2;

// node_modules/uuid/dist/esm-browser/stringify.js
var byteToHex = [];
for (i2 = 0; i2 < 256; ++i2) {
  byteToHex.push((i2 + 256).toString(16).substr(1));
}
var i2;
function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var uuid6 = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
  if (!validate_default(uuid6)) {
    throw TypeError("Stringified UUID is invalid");
  }
  return uuid6;
}
var stringify_default = stringify;

// node_modules/uuid/dist/esm-browser/v4.js
function v42(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset = offset || 0;
    for (var i2 = 0; i2 < 16; ++i2) {
      buf[offset + i2] = rnds[i2];
    }
    return buf;
  }
  return stringify_default(rnds);
}
var v4_default = v42;

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-retry/dist-es/constants.js
var DEFAULT_RETRY_DELAY_BASE2 = 100;
var MAXIMUM_RETRY_DELAY2 = 20 * 1e3;
var THROTTLING_RETRY_DELAY_BASE2 = 500;
var INITIAL_RETRY_TOKENS2 = 500;
var RETRY_COST2 = 5;
var TIMEOUT_RETRY_COST2 = 10;
var NO_RETRY_INCREMENT2 = 1;
var INVOCATION_ID_HEADER2 = "amz-sdk-invocation-id";
var REQUEST_HEADER2 = "amz-sdk-request";

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-retry/dist-es/defaultRetryQuota.js
var getDefaultRetryQuota2 = function(initialRetryTokens, options) {
  var _a2, _b2, _c;
  var MAX_CAPACITY = initialRetryTokens;
  var noRetryIncrement = (_a2 = options === null || options === void 0 ? void 0 : options.noRetryIncrement) !== null && _a2 !== void 0 ? _a2 : NO_RETRY_INCREMENT2;
  var retryCost = (_b2 = options === null || options === void 0 ? void 0 : options.retryCost) !== null && _b2 !== void 0 ? _b2 : RETRY_COST2;
  var timeoutRetryCost = (_c = options === null || options === void 0 ? void 0 : options.timeoutRetryCost) !== null && _c !== void 0 ? _c : TIMEOUT_RETRY_COST2;
  var availableCapacity = initialRetryTokens;
  var getCapacityAmount = function(error) {
    return error.name === "TimeoutError" ? timeoutRetryCost : retryCost;
  };
  var hasRetryTokens = function(error) {
    return getCapacityAmount(error) <= availableCapacity;
  };
  var retrieveRetryTokens = function(error) {
    if (!hasRetryTokens(error)) {
      throw new Error("No retry token available");
    }
    var capacityAmount = getCapacityAmount(error);
    availableCapacity -= capacityAmount;
    return capacityAmount;
  };
  var releaseRetryTokens = function(capacityReleaseAmount) {
    availableCapacity += capacityReleaseAmount !== null && capacityReleaseAmount !== void 0 ? capacityReleaseAmount : noRetryIncrement;
    availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
  };
  return Object.freeze({
    hasRetryTokens,
    retrieveRetryTokens,
    releaseRetryTokens
  });
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-retry/dist-es/delayDecider.js
var defaultDelayDecider2 = function(delayBase, attempts) {
  return Math.floor(Math.min(MAXIMUM_RETRY_DELAY2, Math.random() * Math.pow(2, attempts) * delayBase));
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-retry/dist-es/retryDecider.js
var defaultRetryDecider2 = function(error) {
  if (!error) {
    return false;
  }
  return isRetryableByTrait2(error) || isClockSkewError3(error) || isThrottlingError3(error) || isTransientError2(error);
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-retry/dist-es/StandardRetryStrategy.js
var StandardRetryStrategy2 = function() {
  function StandardRetryStrategy4(maxAttemptsProvider, options) {
    var _a2, _b2, _c;
    this.maxAttemptsProvider = maxAttemptsProvider;
    this.mode = RETRY_MODES.STANDARD;
    this.retryDecider = (_a2 = options === null || options === void 0 ? void 0 : options.retryDecider) !== null && _a2 !== void 0 ? _a2 : defaultRetryDecider2;
    this.delayDecider = (_b2 = options === null || options === void 0 ? void 0 : options.delayDecider) !== null && _b2 !== void 0 ? _b2 : defaultDelayDecider2;
    this.retryQuota = (_c = options === null || options === void 0 ? void 0 : options.retryQuota) !== null && _c !== void 0 ? _c : getDefaultRetryQuota2(INITIAL_RETRY_TOKENS2);
  }
  StandardRetryStrategy4.prototype.shouldRetry = function(error, attempts, maxAttempts) {
    return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
  };
  StandardRetryStrategy4.prototype.getMaxAttempts = function() {
    return __awaiter3(this, void 0, void 0, function() {
      var maxAttempts, error_1;
      return __generator3(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            _a2.trys.push([0, 2, , 3]);
            return [4, this.maxAttemptsProvider()];
          case 1:
            maxAttempts = _a2.sent();
            return [3, 3];
          case 2:
            error_1 = _a2.sent();
            maxAttempts = DEFAULT_MAX_ATTEMPTS2;
            return [3, 3];
          case 3:
            return [2, maxAttempts];
        }
      });
    });
  };
  StandardRetryStrategy4.prototype.retry = function(next, args, options) {
    return __awaiter3(this, void 0, void 0, function() {
      var retryTokenAmount, attempts, totalDelay, maxAttempts, request, _loop_1, this_1, state_1;
      return __generator3(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            attempts = 0;
            totalDelay = 0;
            return [4, this.getMaxAttempts()];
          case 1:
            maxAttempts = _a2.sent();
            request = args.request;
            if (HttpRequest2.isInstance(request)) {
              request.headers[INVOCATION_ID_HEADER2] = v4_default();
            }
            _loop_1 = function() {
              var _b2, response, output, e_1, err, delayFromDecider, delayFromResponse, delay_1;
              return __generator3(this, function(_c) {
                switch (_c.label) {
                  case 0:
                    _c.trys.push([0, 4, , 7]);
                    if (HttpRequest2.isInstance(request)) {
                      request.headers[REQUEST_HEADER2] = "attempt=".concat(attempts + 1, "; max=").concat(maxAttempts);
                    }
                    if (!(options === null || options === void 0 ? void 0 : options.beforeRequest))
                      return [3, 2];
                    return [4, options.beforeRequest()];
                  case 1:
                    _c.sent();
                    _c.label = 2;
                  case 2:
                    return [4, next(args)];
                  case 3:
                    _b2 = _c.sent(), response = _b2.response, output = _b2.output;
                    if (options === null || options === void 0 ? void 0 : options.afterRequest) {
                      options.afterRequest(response);
                    }
                    this_1.retryQuota.releaseRetryTokens(retryTokenAmount);
                    output.$metadata.attempts = attempts + 1;
                    output.$metadata.totalRetryDelay = totalDelay;
                    return [2, { value: { response, output } }];
                  case 4:
                    e_1 = _c.sent();
                    err = asSdkError(e_1);
                    attempts++;
                    if (!this_1.shouldRetry(err, attempts, maxAttempts))
                      return [3, 6];
                    retryTokenAmount = this_1.retryQuota.retrieveRetryTokens(err);
                    delayFromDecider = this_1.delayDecider(isThrottlingError3(err) ? THROTTLING_RETRY_DELAY_BASE2 : DEFAULT_RETRY_DELAY_BASE2, attempts);
                    delayFromResponse = getDelayFromRetryAfterHeader(err.$response);
                    delay_1 = Math.max(delayFromResponse || 0, delayFromDecider);
                    totalDelay += delay_1;
                    return [4, new Promise(function(resolve) {
                      return setTimeout(resolve, delay_1);
                    })];
                  case 5:
                    _c.sent();
                    return [2, "continue"];
                  case 6:
                    if (!err.$metadata) {
                      err.$metadata = {};
                    }
                    err.$metadata.attempts = attempts;
                    err.$metadata.totalRetryDelay = totalDelay;
                    throw err;
                  case 7:
                    return [2];
                }
              });
            };
            this_1 = this;
            _a2.label = 2;
          case 2:
            if (false)
              return [3, 4];
            return [5, _loop_1()];
          case 3:
            state_1 = _a2.sent();
            if (typeof state_1 === "object")
              return [2, state_1.value];
            return [3, 2];
          case 4:
            return [2];
        }
      });
    });
  };
  return StandardRetryStrategy4;
}();
var getDelayFromRetryAfterHeader = function(response) {
  if (!HttpResponse2.isInstance(response))
    return;
  var retryAfterHeaderName = Object.keys(response.headers).find(function(key) {
    return key.toLowerCase() === "retry-after";
  });
  if (!retryAfterHeaderName)
    return;
  var retryAfter = response.headers[retryAfterHeaderName];
  var retryAfterSeconds = Number(retryAfter);
  if (!Number.isNaN(retryAfterSeconds))
    return retryAfterSeconds * 1e3;
  var retryAfterDate = new Date(retryAfter);
  return retryAfterDate.getTime() - Date.now();
};
var asSdkError = function(error) {
  if (error instanceof Error)
    return error;
  if (error instanceof Object)
    return Object.assign(new Error(), error);
  if (typeof error === "string")
    return new Error(error);
  return new Error("AWS SDK error wrapper for ".concat(error));
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-retry/dist-es/AdaptiveRetryStrategy.js
var AdaptiveRetryStrategy = function(_super) {
  __extends3(AdaptiveRetryStrategy3, _super);
  function AdaptiveRetryStrategy3(maxAttemptsProvider, options) {
    var _this = this;
    var _a2 = options !== null && options !== void 0 ? options : {}, rateLimiter = _a2.rateLimiter, superOptions = __rest2(_a2, ["rateLimiter"]);
    _this = _super.call(this, maxAttemptsProvider, superOptions) || this;
    _this.rateLimiter = rateLimiter !== null && rateLimiter !== void 0 ? rateLimiter : new DefaultRateLimiter();
    _this.mode = RETRY_MODES.ADAPTIVE;
    return _this;
  }
  AdaptiveRetryStrategy3.prototype.retry = function(next, args) {
    return __awaiter3(this, void 0, void 0, function() {
      var _this = this;
      return __generator3(this, function(_a2) {
        return [2, _super.prototype.retry.call(this, next, args, {
          beforeRequest: function() {
            return __awaiter3(_this, void 0, void 0, function() {
              return __generator3(this, function(_a3) {
                return [2, this.rateLimiter.getSendToken()];
              });
            });
          },
          afterRequest: function(response) {
            _this.rateLimiter.updateClientSendingRate(response);
          }
        })];
      });
    });
  };
  return AdaptiveRetryStrategy3;
}(StandardRetryStrategy2);

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-retry/dist-es/configurations.js
var resolveRetryConfig2 = function(input) {
  var _a2;
  var maxAttempts = normalizeProvider6((_a2 = input.maxAttempts) !== null && _a2 !== void 0 ? _a2 : DEFAULT_MAX_ATTEMPTS2);
  return __assign7(__assign7({}, input), { maxAttempts, retryStrategy: function() {
    return __awaiter3(void 0, void 0, void 0, function() {
      var retryMode;
      return __generator3(this, function(_a3) {
        switch (_a3.label) {
          case 0:
            if (input.retryStrategy) {
              return [2, input.retryStrategy];
            }
            return [4, normalizeProvider6(input.retryMode)()];
          case 1:
            retryMode = _a3.sent();
            if (retryMode === RETRY_MODES.ADAPTIVE) {
              return [2, new AdaptiveRetryStrategy(maxAttempts)];
            }
            return [2, new StandardRetryStrategy2(maxAttempts)];
        }
      });
    });
  } });
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-retry/dist-es/retryMiddleware.js
var retryMiddleware3 = function(options) {
  return function(next, context) {
    return function(args) {
      return __awaiter3(void 0, void 0, void 0, function() {
        var retryStrategy;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, options.retryStrategy()];
            case 1:
              retryStrategy = _a2.sent();
              if (retryStrategy === null || retryStrategy === void 0 ? void 0 : retryStrategy.mode)
                context.userAgent = __spreadArray4(__spreadArray4([], __read10(context.userAgent || []), false), [["cfg/retry-mode", retryStrategy.mode]], false);
              return [2, retryStrategy.retry(next, args)];
          }
        });
      });
    };
  };
};
var retryMiddlewareOptions2 = {
  name: "retryMiddleware",
  tags: ["RETRY"],
  step: "finalizeRequest",
  priority: "high",
  override: true
};
var getRetryPlugin2 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(retryMiddleware3(options), retryMiddlewareOptions2);
    }
  };
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/property-provider/dist-es/ProviderError.js
var ProviderError = function(_super) {
  __extends3(ProviderError4, _super);
  function ProviderError4(message, tryNextLink) {
    if (tryNextLink === void 0) {
      tryNextLink = true;
    }
    var _this = _super.call(this, message) || this;
    _this.tryNextLink = tryNextLink;
    _this.name = "ProviderError";
    Object.setPrototypeOf(_this, ProviderError4.prototype);
    return _this;
  }
  ProviderError4.from = function(error, tryNextLink) {
    if (tryNextLink === void 0) {
      tryNextLink = true;
    }
    return Object.assign(new this(error.message, tryNextLink), error);
  };
  return ProviderError4;
}(Error);

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/property-provider/dist-es/CredentialsProviderError.js
var CredentialsProviderError = function(_super) {
  __extends3(CredentialsProviderError4, _super);
  function CredentialsProviderError4(message, tryNextLink) {
    if (tryNextLink === void 0) {
      tryNextLink = true;
    }
    var _this = _super.call(this, message, tryNextLink) || this;
    _this.tryNextLink = tryNextLink;
    _this.name = "CredentialsProviderError";
    Object.setPrototypeOf(_this, CredentialsProviderError4.prototype);
    return _this;
  }
  return CredentialsProviderError4;
}(ProviderError);

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/property-provider/dist-es/TokenProviderError.js
var TokenProviderError = function(_super) {
  __extends3(TokenProviderError4, _super);
  function TokenProviderError4(message, tryNextLink) {
    if (tryNextLink === void 0) {
      tryNextLink = true;
    }
    var _this = _super.call(this, message, tryNextLink) || this;
    _this.tryNextLink = tryNextLink;
    _this.name = "TokenProviderError";
    Object.setPrototypeOf(_this, TokenProviderError4.prototype);
    return _this;
  }
  return TokenProviderError4;
}(ProviderError);

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/property-provider/dist-es/memoize.js
var memoize = function(provider, isExpired, requiresRefresh) {
  var resolved;
  var pending;
  var hasResult;
  var isConstant = false;
  var coalesceProvider = function() {
    return __awaiter3(void 0, void 0, void 0, function() {
      return __generator3(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            if (!pending) {
              pending = provider();
            }
            _a2.label = 1;
          case 1:
            _a2.trys.push([1, , 3, 4]);
            return [4, pending];
          case 2:
            resolved = _a2.sent();
            hasResult = true;
            isConstant = false;
            return [3, 4];
          case 3:
            pending = void 0;
            return [7];
          case 4:
            return [2, resolved];
        }
      });
    });
  };
  if (isExpired === void 0) {
    return function(options) {
      return __awaiter3(void 0, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh)))
                return [3, 2];
              return [4, coalesceProvider()];
            case 1:
              resolved = _a2.sent();
              _a2.label = 2;
            case 2:
              return [2, resolved];
          }
        });
      });
    };
  }
  return function(options) {
    return __awaiter3(void 0, void 0, void 0, function() {
      return __generator3(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh)))
              return [3, 2];
            return [4, coalesceProvider()];
          case 1:
            resolved = _a2.sent();
            _a2.label = 2;
          case 2:
            if (isConstant) {
              return [2, resolved];
            }
            if (requiresRefresh && !requiresRefresh(resolved)) {
              isConstant = true;
              return [2, resolved];
            }
            if (!isExpired(resolved))
              return [3, 4];
            return [4, coalesceProvider()];
          case 3:
            _a2.sent();
            return [2, resolved];
          case 4:
            return [2, resolved];
        }
      });
    });
  };
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/util-hex-encoding/dist-es/index.js
var SHORT_TO_HEX2 = {};
var HEX_TO_SHORT2 = {};
for (i2 = 0; i2 < 256; i2++) {
  encodedByte = i2.toString(16).toLowerCase();
  if (encodedByte.length === 1) {
    encodedByte = "0".concat(encodedByte);
  }
  SHORT_TO_HEX2[i2] = encodedByte;
  HEX_TO_SHORT2[encodedByte] = i2;
}
var encodedByte;
var i2;
function toHex2(bytes) {
  var out = "";
  for (var i2 = 0; i2 < bytes.byteLength; i2++) {
    out += SHORT_TO_HEX2[bytes[i2]];
  }
  return out;
}

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/signature-v4/dist-es/constants.js
var ALGORITHM_QUERY_PARAM3 = "X-Amz-Algorithm";
var CREDENTIAL_QUERY_PARAM3 = "X-Amz-Credential";
var AMZ_DATE_QUERY_PARAM3 = "X-Amz-Date";
var SIGNED_HEADERS_QUERY_PARAM3 = "X-Amz-SignedHeaders";
var EXPIRES_QUERY_PARAM3 = "X-Amz-Expires";
var SIGNATURE_QUERY_PARAM3 = "X-Amz-Signature";
var TOKEN_QUERY_PARAM3 = "X-Amz-Security-Token";
var AUTH_HEADER3 = "authorization";
var AMZ_DATE_HEADER3 = AMZ_DATE_QUERY_PARAM3.toLowerCase();
var DATE_HEADER2 = "date";
var GENERATED_HEADERS2 = [AUTH_HEADER3, AMZ_DATE_HEADER3, DATE_HEADER2];
var SIGNATURE_HEADER2 = SIGNATURE_QUERY_PARAM3.toLowerCase();
var SHA256_HEADER3 = "x-amz-content-sha256";
var TOKEN_HEADER3 = TOKEN_QUERY_PARAM3.toLowerCase();
var ALWAYS_UNSIGNABLE_HEADERS2 = {
  authorization: true,
  "cache-control": true,
  connection: true,
  expect: true,
  from: true,
  "keep-alive": true,
  "max-forwards": true,
  pragma: true,
  referer: true,
  te: true,
  trailer: true,
  "transfer-encoding": true,
  upgrade: true,
  "user-agent": true,
  "x-amzn-trace-id": true
};
var PROXY_HEADER_PATTERN2 = /^proxy-/;
var SEC_HEADER_PATTERN2 = /^sec-/;
var ALGORITHM_IDENTIFIER2 = "AWS4-HMAC-SHA256";
var EVENT_ALGORITHM_IDENTIFIER2 = "AWS4-HMAC-SHA256-PAYLOAD";
var UNSIGNED_PAYLOAD4 = "UNSIGNED-PAYLOAD";
var MAX_CACHE_SIZE2 = 50;
var KEY_TYPE_IDENTIFIER3 = "aws4_request";
var MAX_PRESIGNED_TTL2 = 60 * 60 * 24 * 7;

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/signature-v4/dist-es/credentialDerivation.js
var signingKeyCache2 = {};
var cacheQueue2 = [];
var createScope2 = function(shortDate, region, service) {
  return "".concat(shortDate, "/").concat(region, "/").concat(service, "/").concat(KEY_TYPE_IDENTIFIER3);
};
var getSigningKey3 = function(sha256Constructor, credentials, shortDate, region, service) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var credsHash, cacheKey, key, _a2, _b2, signable, e_1_1;
    var e_1, _c;
    return __generator3(this, function(_d) {
      switch (_d.label) {
        case 0:
          return [4, hmac2(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId)];
        case 1:
          credsHash = _d.sent();
          cacheKey = "".concat(shortDate, ":").concat(region, ":").concat(service, ":").concat(toHex2(credsHash), ":").concat(credentials.sessionToken);
          if (cacheKey in signingKeyCache2) {
            return [2, signingKeyCache2[cacheKey]];
          }
          cacheQueue2.push(cacheKey);
          while (cacheQueue2.length > MAX_CACHE_SIZE2) {
            delete signingKeyCache2[cacheQueue2.shift()];
          }
          key = "AWS4".concat(credentials.secretAccessKey);
          _d.label = 2;
        case 2:
          _d.trys.push([2, 7, 8, 9]);
          _a2 = __values4([shortDate, region, service, KEY_TYPE_IDENTIFIER3]), _b2 = _a2.next();
          _d.label = 3;
        case 3:
          if (!!_b2.done)
            return [3, 6];
          signable = _b2.value;
          return [4, hmac2(sha256Constructor, key, signable)];
        case 4:
          key = _d.sent();
          _d.label = 5;
        case 5:
          _b2 = _a2.next();
          return [3, 3];
        case 6:
          return [3, 9];
        case 7:
          e_1_1 = _d.sent();
          e_1 = { error: e_1_1 };
          return [3, 9];
        case 8:
          try {
            if (_b2 && !_b2.done && (_c = _a2.return))
              _c.call(_a2);
          } finally {
            if (e_1)
              throw e_1.error;
          }
          return [7];
        case 9:
          return [2, signingKeyCache2[cacheKey] = key];
      }
    });
  });
};
var hmac2 = function(ctor, secret, data) {
  var hash = new ctor(secret);
  hash.update(data);
  return hash.digest();
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/signature-v4/dist-es/getCanonicalHeaders.js
var getCanonicalHeaders3 = function(_a2, unsignableHeaders, signableHeaders) {
  var e_1, _b2;
  var headers = _a2.headers;
  var canonical = {};
  try {
    for (var _c = __values4(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()) {
      var headerName = _d.value;
      if (headers[headerName] == void 0) {
        continue;
      }
      var canonicalHeaderName = headerName.toLowerCase();
      if (canonicalHeaderName in ALWAYS_UNSIGNABLE_HEADERS2 || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || PROXY_HEADER_PATTERN2.test(canonicalHeaderName) || SEC_HEADER_PATTERN2.test(canonicalHeaderName)) {
        if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) {
          continue;
        }
      }
      canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_d && !_d.done && (_b2 = _c.return))
        _b2.call(_c);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return canonical;
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/util-uri-escape/dist-es/escape-uri.js
var escapeUri3 = function(uri) {
  return encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode4);
};
var hexEncode4 = function(c2) {
  return "%".concat(c2.charCodeAt(0).toString(16).toUpperCase());
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/signature-v4/dist-es/getCanonicalQuery.js
var getCanonicalQuery2 = function(_a2) {
  var e_1, _b2;
  var _c = _a2.query, query = _c === void 0 ? {} : _c;
  var keys = [];
  var serialized = {};
  var _loop_1 = function(key2) {
    if (key2.toLowerCase() === SIGNATURE_HEADER2) {
      return "continue";
    }
    keys.push(key2);
    var value = query[key2];
    if (typeof value === "string") {
      serialized[key2] = "".concat(escapeUri3(key2), "=").concat(escapeUri3(value));
    } else if (Array.isArray(value)) {
      serialized[key2] = value.slice(0).sort().reduce(function(encoded, value2) {
        return encoded.concat(["".concat(escapeUri3(key2), "=").concat(escapeUri3(value2))]);
      }, []).join("&");
    }
  };
  try {
    for (var _d = __values4(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()) {
      var key = _e.value;
      _loop_1(key);
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_e && !_e.done && (_b2 = _d.return))
        _b2.call(_d);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return keys.map(function(key2) {
    return serialized[key2];
  }).filter(function(serialized2) {
    return serialized2;
  }).join("&");
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/is-array-buffer/dist-es/index.js
var isArrayBuffer4 = function(arg) {
  return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/signature-v4/dist-es/getPayloadHash.js
var getPayloadHash2 = function(_a2, hashConstructor) {
  var headers = _a2.headers, body = _a2.body;
  return __awaiter3(void 0, void 0, void 0, function() {
    var _b2, _c, headerName, hashCtor, _d;
    var e_1, _e;
    return __generator3(this, function(_f) {
      switch (_f.label) {
        case 0:
          try {
            for (_b2 = __values4(Object.keys(headers)), _c = _b2.next(); !_c.done; _c = _b2.next()) {
              headerName = _c.value;
              if (headerName.toLowerCase() === SHA256_HEADER3) {
                return [2, headers[headerName]];
              }
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (_c && !_c.done && (_e = _b2.return))
                _e.call(_b2);
            } finally {
              if (e_1)
                throw e_1.error;
            }
          }
          if (!(body == void 0))
            return [3, 1];
          return [2, "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"];
        case 1:
          if (!(typeof body === "string" || ArrayBuffer.isView(body) || isArrayBuffer4(body)))
            return [3, 3];
          hashCtor = new hashConstructor();
          hashCtor.update(body);
          _d = toHex2;
          return [4, hashCtor.digest()];
        case 2:
          return [2, _d.apply(void 0, [_f.sent()])];
        case 3:
          return [2, UNSIGNED_PAYLOAD4];
      }
    });
  });
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/signature-v4/dist-es/headerUtil.js
var hasHeader2 = function(soughtHeader, headers) {
  var e_1, _a2;
  soughtHeader = soughtHeader.toLowerCase();
  try {
    for (var _b2 = __values4(Object.keys(headers)), _c = _b2.next(); !_c.done; _c = _b2.next()) {
      var headerName = _c.value;
      if (soughtHeader === headerName.toLowerCase()) {
        return true;
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_c && !_c.done && (_a2 = _b2.return))
        _a2.call(_b2);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return false;
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/signature-v4/dist-es/cloneRequest.js
var cloneRequest2 = function(_a2) {
  var headers = _a2.headers, query = _a2.query, rest = __rest2(_a2, ["headers", "query"]);
  return __assign7(__assign7({}, rest), { headers: __assign7({}, headers), query: query ? cloneQuery4(query) : void 0 });
};
var cloneQuery4 = function(query) {
  return Object.keys(query).reduce(function(carry, paramName) {
    var _a2;
    var param = query[paramName];
    return __assign7(__assign7({}, carry), (_a2 = {}, _a2[paramName] = Array.isArray(param) ? __spreadArray4([], __read10(param), false) : param, _a2));
  }, {});
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/signature-v4/dist-es/moveHeadersToQuery.js
var moveHeadersToQuery2 = function(request, options) {
  var e_1, _a2;
  var _b2;
  if (options === void 0) {
    options = {};
  }
  var _c = typeof request.clone === "function" ? request.clone() : cloneRequest2(request), headers = _c.headers, _d = _c.query, query = _d === void 0 ? {} : _d;
  try {
    for (var _e = __values4(Object.keys(headers)), _f = _e.next(); !_f.done; _f = _e.next()) {
      var name_1 = _f.value;
      var lname = name_1.toLowerCase();
      if (lname.slice(0, 6) === "x-amz-" && !((_b2 = options.unhoistableHeaders) === null || _b2 === void 0 ? void 0 : _b2.has(lname))) {
        query[name_1] = headers[name_1];
        delete headers[name_1];
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_f && !_f.done && (_a2 = _e.return))
        _a2.call(_e);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return __assign7(__assign7({}, request), { headers, query });
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/signature-v4/dist-es/prepareRequest.js
var prepareRequest2 = function(request) {
  var e_1, _a2;
  request = typeof request.clone === "function" ? request.clone() : cloneRequest2(request);
  try {
    for (var _b2 = __values4(Object.keys(request.headers)), _c = _b2.next(); !_c.done; _c = _b2.next()) {
      var headerName = _c.value;
      if (GENERATED_HEADERS2.indexOf(headerName.toLowerCase()) > -1) {
        delete request.headers[headerName];
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_c && !_c.done && (_a2 = _b2.return))
        _a2.call(_b2);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return request;
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/signature-v4/dist-es/utilDate.js
var iso86012 = function(time) {
  return toDate2(time).toISOString().replace(/\.\d{3}Z$/, "Z");
};
var toDate2 = function(time) {
  if (typeof time === "number") {
    return new Date(time * 1e3);
  }
  if (typeof time === "string") {
    if (Number(time)) {
      return new Date(Number(time) * 1e3);
    }
    return new Date(time);
  }
  return time;
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/signature-v4/dist-es/SignatureV4.js
var SignatureV42 = function() {
  function SignatureV44(_a2) {
    var applyChecksum = _a2.applyChecksum, credentials = _a2.credentials, region = _a2.region, service = _a2.service, sha256 = _a2.sha256, _b2 = _a2.uriEscapePath, uriEscapePath = _b2 === void 0 ? true : _b2;
    this.service = service;
    this.sha256 = sha256;
    this.uriEscapePath = uriEscapePath;
    this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
    this.regionProvider = normalizeProvider6(region);
    this.credentialProvider = normalizeProvider6(credentials);
  }
  SignatureV44.prototype.presign = function(originalRequest, options) {
    if (options === void 0) {
      options = {};
    }
    return __awaiter3(this, void 0, void 0, function() {
      var _a2, signingDate, _b2, expiresIn, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
      return __generator3(this, function(_l) {
        switch (_l.label) {
          case 0:
            _a2 = options.signingDate, signingDate = _a2 === void 0 ? /* @__PURE__ */ new Date() : _a2, _b2 = options.expiresIn, expiresIn = _b2 === void 0 ? 3600 : _b2, unsignableHeaders = options.unsignableHeaders, unhoistableHeaders = options.unhoistableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
            return [4, this.credentialProvider()];
          case 1:
            credentials = _l.sent();
            this.validateResolvedCredentials(credentials);
            if (!(signingRegion !== null && signingRegion !== void 0))
              return [3, 2];
            _c = signingRegion;
            return [3, 4];
          case 2:
            return [4, this.regionProvider()];
          case 3:
            _c = _l.sent();
            _l.label = 4;
          case 4:
            region = _c;
            _d = formatDate2(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
            if (expiresIn > MAX_PRESIGNED_TTL2) {
              return [2, Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")];
            }
            scope = createScope2(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
            request = moveHeadersToQuery2(prepareRequest2(originalRequest), { unhoistableHeaders });
            if (credentials.sessionToken) {
              request.query[TOKEN_QUERY_PARAM3] = credentials.sessionToken;
            }
            request.query[ALGORITHM_QUERY_PARAM3] = ALGORITHM_IDENTIFIER2;
            request.query[CREDENTIAL_QUERY_PARAM3] = "".concat(credentials.accessKeyId, "/").concat(scope);
            request.query[AMZ_DATE_QUERY_PARAM3] = longDate;
            request.query[EXPIRES_QUERY_PARAM3] = expiresIn.toString(10);
            canonicalHeaders = getCanonicalHeaders3(request, unsignableHeaders, signableHeaders);
            request.query[SIGNED_HEADERS_QUERY_PARAM3] = getCanonicalHeaderList2(canonicalHeaders);
            _e = request.query;
            _f = SIGNATURE_QUERY_PARAM3;
            _g = this.getSignature;
            _h = [
              longDate,
              scope,
              this.getSigningKey(credentials, region, shortDate, signingService)
            ];
            _j = this.createCanonicalRequest;
            _k = [request, canonicalHeaders];
            return [4, getPayloadHash2(originalRequest, this.sha256)];
          case 5:
            return [4, _g.apply(this, _h.concat([_j.apply(this, _k.concat([_l.sent()]))]))];
          case 6:
            _e[_f] = _l.sent();
            return [2, request];
        }
      });
    });
  };
  SignatureV44.prototype.sign = function(toSign, options) {
    return __awaiter3(this, void 0, void 0, function() {
      return __generator3(this, function(_a2) {
        if (typeof toSign === "string") {
          return [2, this.signString(toSign, options)];
        } else if (toSign.headers && toSign.payload) {
          return [2, this.signEvent(toSign, options)];
        } else {
          return [2, this.signRequest(toSign, options)];
        }
        return [2];
      });
    });
  };
  SignatureV44.prototype.signEvent = function(_a2, _b2) {
    var headers = _a2.headers, payload = _a2.payload;
    var _c = _b2.signingDate, signingDate = _c === void 0 ? /* @__PURE__ */ new Date() : _c, priorSignature = _b2.priorSignature, signingRegion = _b2.signingRegion, signingService = _b2.signingService;
    return __awaiter3(this, void 0, void 0, function() {
      var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
      return __generator3(this, function(_g) {
        switch (_g.label) {
          case 0:
            if (!(signingRegion !== null && signingRegion !== void 0))
              return [3, 1];
            _d = signingRegion;
            return [3, 3];
          case 1:
            return [4, this.regionProvider()];
          case 2:
            _d = _g.sent();
            _g.label = 3;
          case 3:
            region = _d;
            _e = formatDate2(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
            scope = createScope2(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
            return [4, getPayloadHash2({ headers: {}, body: payload }, this.sha256)];
          case 4:
            hashedPayload = _g.sent();
            hash = new this.sha256();
            hash.update(headers);
            _f = toHex2;
            return [4, hash.digest()];
          case 5:
            hashedHeaders = _f.apply(void 0, [_g.sent()]);
            stringToSign = [
              EVENT_ALGORITHM_IDENTIFIER2,
              longDate,
              scope,
              priorSignature,
              hashedHeaders,
              hashedPayload
            ].join("\n");
            return [2, this.signString(stringToSign, { signingDate, signingRegion: region, signingService })];
        }
      });
    });
  };
  SignatureV44.prototype.signString = function(stringToSign, _a2) {
    var _b2 = _a2 === void 0 ? {} : _a2, _c = _b2.signingDate, signingDate = _c === void 0 ? /* @__PURE__ */ new Date() : _c, signingRegion = _b2.signingRegion, signingService = _b2.signingService;
    return __awaiter3(this, void 0, void 0, function() {
      var credentials, region, _d, shortDate, hash, _e, _f, _g;
      return __generator3(this, function(_h) {
        switch (_h.label) {
          case 0:
            return [4, this.credentialProvider()];
          case 1:
            credentials = _h.sent();
            this.validateResolvedCredentials(credentials);
            if (!(signingRegion !== null && signingRegion !== void 0))
              return [3, 2];
            _d = signingRegion;
            return [3, 4];
          case 2:
            return [4, this.regionProvider()];
          case 3:
            _d = _h.sent();
            _h.label = 4;
          case 4:
            region = _d;
            shortDate = formatDate2(signingDate).shortDate;
            _f = (_e = this.sha256).bind;
            return [4, this.getSigningKey(credentials, region, shortDate, signingService)];
          case 5:
            hash = new (_f.apply(_e, [void 0, _h.sent()]))();
            hash.update(stringToSign);
            _g = toHex2;
            return [4, hash.digest()];
          case 6:
            return [2, _g.apply(void 0, [_h.sent()])];
        }
      });
    });
  };
  SignatureV44.prototype.signRequest = function(requestToSign, _a2) {
    var _b2 = _a2 === void 0 ? {} : _a2, _c = _b2.signingDate, signingDate = _c === void 0 ? /* @__PURE__ */ new Date() : _c, signableHeaders = _b2.signableHeaders, unsignableHeaders = _b2.unsignableHeaders, signingRegion = _b2.signingRegion, signingService = _b2.signingService;
    return __awaiter3(this, void 0, void 0, function() {
      var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
      return __generator3(this, function(_f) {
        switch (_f.label) {
          case 0:
            return [4, this.credentialProvider()];
          case 1:
            credentials = _f.sent();
            this.validateResolvedCredentials(credentials);
            if (!(signingRegion !== null && signingRegion !== void 0))
              return [3, 2];
            _d = signingRegion;
            return [3, 4];
          case 2:
            return [4, this.regionProvider()];
          case 3:
            _d = _f.sent();
            _f.label = 4;
          case 4:
            region = _d;
            request = prepareRequest2(requestToSign);
            _e = formatDate2(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
            scope = createScope2(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
            request.headers[AMZ_DATE_HEADER3] = longDate;
            if (credentials.sessionToken) {
              request.headers[TOKEN_HEADER3] = credentials.sessionToken;
            }
            return [4, getPayloadHash2(request, this.sha256)];
          case 5:
            payloadHash = _f.sent();
            if (!hasHeader2(SHA256_HEADER3, request.headers) && this.applyChecksum) {
              request.headers[SHA256_HEADER3] = payloadHash;
            }
            canonicalHeaders = getCanonicalHeaders3(request, unsignableHeaders, signableHeaders);
            return [4, this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))];
          case 6:
            signature = _f.sent();
            request.headers[AUTH_HEADER3] = "".concat(ALGORITHM_IDENTIFIER2, " ") + "Credential=".concat(credentials.accessKeyId, "/").concat(scope, ", ") + "SignedHeaders=".concat(getCanonicalHeaderList2(canonicalHeaders), ", ") + "Signature=".concat(signature);
            return [2, request];
        }
      });
    });
  };
  SignatureV44.prototype.createCanonicalRequest = function(request, canonicalHeaders, payloadHash) {
    var sortedHeaders = Object.keys(canonicalHeaders).sort();
    return "".concat(request.method, "\n").concat(this.getCanonicalPath(request), "\n").concat(getCanonicalQuery2(request), "\n").concat(sortedHeaders.map(function(name) {
      return "".concat(name, ":").concat(canonicalHeaders[name]);
    }).join("\n"), "\n\n").concat(sortedHeaders.join(";"), "\n").concat(payloadHash);
  };
  SignatureV44.prototype.createStringToSign = function(longDate, credentialScope, canonicalRequest) {
    return __awaiter3(this, void 0, void 0, function() {
      var hash, hashedRequest;
      return __generator3(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            hash = new this.sha256();
            hash.update(canonicalRequest);
            return [4, hash.digest()];
          case 1:
            hashedRequest = _a2.sent();
            return [2, "".concat(ALGORITHM_IDENTIFIER2, "\n").concat(longDate, "\n").concat(credentialScope, "\n").concat(toHex2(hashedRequest))];
        }
      });
    });
  };
  SignatureV44.prototype.getCanonicalPath = function(_a2) {
    var e_1, _b2;
    var path = _a2.path;
    if (this.uriEscapePath) {
      var normalizedPathSegments = [];
      try {
        for (var _c = __values4(path.split("/")), _d = _c.next(); !_d.done; _d = _c.next()) {
          var pathSegment = _d.value;
          if ((pathSegment === null || pathSegment === void 0 ? void 0 : pathSegment.length) === 0)
            continue;
          if (pathSegment === ".")
            continue;
          if (pathSegment === "..") {
            normalizedPathSegments.pop();
          } else {
            normalizedPathSegments.push(pathSegment);
          }
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (_d && !_d.done && (_b2 = _c.return))
            _b2.call(_c);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
      var normalizedPath = "".concat((path === null || path === void 0 ? void 0 : path.startsWith("/")) ? "/" : "").concat(normalizedPathSegments.join("/")).concat(normalizedPathSegments.length > 0 && (path === null || path === void 0 ? void 0 : path.endsWith("/")) ? "/" : "");
      var doubleEncoded = encodeURIComponent(normalizedPath);
      return doubleEncoded.replace(/%2F/g, "/");
    }
    return path;
  };
  SignatureV44.prototype.getSignature = function(longDate, credentialScope, keyPromise, canonicalRequest) {
    return __awaiter3(this, void 0, void 0, function() {
      var stringToSign, hash, _a2, _b2, _c;
      return __generator3(this, function(_d) {
        switch (_d.label) {
          case 0:
            return [4, this.createStringToSign(longDate, credentialScope, canonicalRequest)];
          case 1:
            stringToSign = _d.sent();
            _b2 = (_a2 = this.sha256).bind;
            return [4, keyPromise];
          case 2:
            hash = new (_b2.apply(_a2, [void 0, _d.sent()]))();
            hash.update(stringToSign);
            _c = toHex2;
            return [4, hash.digest()];
          case 3:
            return [2, _c.apply(void 0, [_d.sent()])];
        }
      });
    });
  };
  SignatureV44.prototype.getSigningKey = function(credentials, region, shortDate, service) {
    return getSigningKey3(this.sha256, credentials, shortDate, region, service || this.service);
  };
  SignatureV44.prototype.validateResolvedCredentials = function(credentials) {
    if (typeof credentials !== "object" || typeof credentials.accessKeyId !== "string" || typeof credentials.secretAccessKey !== "string") {
      throw new Error("Resolved credential object is not valid");
    }
  };
  return SignatureV44;
}();
var formatDate2 = function(now) {
  var longDate = iso86012(now).replace(/[\-:]/g, "");
  return {
    longDate,
    shortDate: longDate.slice(0, 8)
  };
};
var getCanonicalHeaderList2 = function(headers) {
  return Object.keys(headers).sort().join(";");
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-signing/dist-es/configurations.js
var CREDENTIAL_EXPIRE_WINDOW = 3e5;
var resolveAwsAuthConfig6 = function(input) {
  var normalizedCreds = input.credentials ? normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
  var _a2 = input.signingEscapePath, signingEscapePath = _a2 === void 0 ? true : _a2, _b2 = input.systemClockOffset, systemClockOffset = _b2 === void 0 ? input.systemClockOffset || 0 : _b2, sha256 = input.sha256;
  var signer;
  if (input.signer) {
    signer = normalizeProvider6(input.signer);
  } else if (input.regionInfoProvider) {
    signer = function() {
      return normalizeProvider6(input.region)().then(function(region) {
        return __awaiter3(void 0, void 0, void 0, function() {
          var _a3, _b3, _c;
          var _d;
          return __generator3(this, function(_e) {
            switch (_e.label) {
              case 0:
                _b3 = (_a3 = input).regionInfoProvider;
                _c = [region];
                _d = {};
                return [4, input.useFipsEndpoint()];
              case 1:
                _d.useFipsEndpoint = _e.sent();
                return [4, input.useDualstackEndpoint()];
              case 2:
                return [4, _b3.apply(_a3, _c.concat([(_d.useDualstackEndpoint = _e.sent(), _d)]))];
              case 3:
                return [2, [
                  _e.sent() || {},
                  region
                ]];
            }
          });
        });
      }).then(function(_a3) {
        var _b3 = __read10(_a3, 2), regionInfo = _b3[0], region = _b3[1];
        var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
        input.signingRegion = input.signingRegion || signingRegion || region;
        input.signingName = input.signingName || signingService || input.serviceId;
        var params = __assign7(__assign7({}, input), { credentials: normalizedCreds, region: input.signingRegion, service: input.signingName, sha256, uriEscapePath: signingEscapePath });
        var SignerCtor = input.signerConstructor || SignatureV42;
        return new SignerCtor(params);
      });
    };
  } else {
    signer = function(authScheme) {
      return __awaiter3(void 0, void 0, void 0, function() {
        var signingRegion, signingService, params, SignerCtor;
        return __generator3(this, function(_a3) {
          if (!authScheme) {
            throw new Error("Unexpected empty auth scheme config");
          }
          signingRegion = authScheme.signingScope;
          signingService = authScheme.signingName;
          input.signingRegion = input.signingRegion || signingRegion;
          input.signingName = input.signingName || signingService || input.serviceId;
          params = __assign7(__assign7({}, input), { credentials: normalizedCreds, region: input.signingRegion, service: input.signingName, sha256, uriEscapePath: signingEscapePath });
          SignerCtor = input.signerConstructor || SignatureV42;
          return [2, new SignerCtor(params)];
        });
      });
    };
  }
  return __assign7(__assign7({}, input), { systemClockOffset, signingEscapePath, credentials: normalizedCreds, signer });
};
var normalizeCredentialProvider = function(credentials) {
  if (typeof credentials === "function") {
    return memoize(credentials, function(credentials2) {
      return credentials2.expiration !== void 0 && credentials2.expiration.getTime() - Date.now() < CREDENTIAL_EXPIRE_WINDOW;
    }, function(credentials2) {
      return credentials2.expiration !== void 0;
    });
  }
  return normalizeProvider6(credentials);
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-signing/dist-es/utils/getSkewCorrectedDate.js
var getSkewCorrectedDate7 = function(systemClockOffset) {
  return new Date(Date.now() + systemClockOffset);
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-signing/dist-es/utils/isClockSkewed.js
var isClockSkewed7 = function(clockTime, systemClockOffset) {
  return Math.abs(getSkewCorrectedDate7(systemClockOffset).getTime() - clockTime) >= 3e5;
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-signing/dist-es/utils/getUpdatedSystemClockOffset.js
var getUpdatedSystemClockOffset2 = function(clockTime, currentSystemClockOffset) {
  var clockTimeInMs = Date.parse(clockTime);
  if (isClockSkewed7(clockTimeInMs, currentSystemClockOffset)) {
    return clockTimeInMs - Date.now();
  }
  return currentSystemClockOffset;
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-signing/dist-es/middleware.js
var awsAuthMiddleware6 = function(options) {
  return function(next, context) {
    return function(args) {
      var _a2, _b2, _c;
      return __awaiter3(this, void 0, void 0, function() {
        var authScheme, signer, output, _d, _e, dateHeader;
        var _f;
        return __generator3(this, function(_g) {
          switch (_g.label) {
            case 0:
              if (!HttpRequest2.isInstance(args.request))
                return [2, next(args)];
              authScheme = (_c = (_b2 = (_a2 = context.endpointV2) === null || _a2 === void 0 ? void 0 : _a2.properties) === null || _b2 === void 0 ? void 0 : _b2.authSchemes) === null || _c === void 0 ? void 0 : _c[0];
              return [4, options.signer(authScheme)];
            case 1:
              signer = _g.sent();
              _d = next;
              _e = [__assign7({}, args)];
              _f = {};
              return [4, signer.sign(args.request, {
                signingDate: getSkewCorrectedDate7(options.systemClockOffset),
                signingRegion: context["signing_region"],
                signingService: context["signing_service"]
              })];
            case 2:
              return [4, _d.apply(void 0, [__assign7.apply(void 0, _e.concat([(_f.request = _g.sent(), _f)]))]).catch(function(error) {
                var _a3;
                var serverTime = (_a3 = error.ServerTime) !== null && _a3 !== void 0 ? _a3 : getDateHeader2(error.$response);
                if (serverTime) {
                  options.systemClockOffset = getUpdatedSystemClockOffset2(serverTime, options.systemClockOffset);
                }
                throw error;
              })];
            case 3:
              output = _g.sent();
              dateHeader = getDateHeader2(output.response);
              if (dateHeader) {
                options.systemClockOffset = getUpdatedSystemClockOffset2(dateHeader, options.systemClockOffset);
              }
              return [2, output];
          }
        });
      });
    };
  };
};
var getDateHeader2 = function(response) {
  var _a2, _b2, _c;
  return HttpResponse2.isInstance(response) ? (_b2 = (_a2 = response.headers) === null || _a2 === void 0 ? void 0 : _a2.date) !== null && _b2 !== void 0 ? _b2 : (_c = response.headers) === null || _c === void 0 ? void 0 : _c.Date : void 0;
};
var awsAuthMiddlewareOptions6 = {
  name: "awsAuthMiddleware",
  tags: ["SIGNATURE", "AWSAUTH"],
  relation: "after",
  toMiddleware: "retryMiddleware",
  override: true
};
var getAwsAuthPlugin6 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.addRelativeTo(awsAuthMiddleware6(options), awsAuthMiddlewareOptions6);
    }
  };
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-user-agent/dist-es/configurations.js
function resolveUserAgentConfig6(input) {
  return __assign7(__assign7({}, input), { customUserAgent: typeof input.customUserAgent === "string" ? [[input.customUserAgent]] : input.customUserAgent });
}

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-user-agent/dist-es/constants.js
var USER_AGENT6 = "user-agent";
var X_AMZ_USER_AGENT6 = "x-amz-user-agent";
var SPACE6 = " ";
var UA_ESCAPE_REGEX6 = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/middleware-user-agent/dist-es/user-agent-middleware.js
var userAgentMiddleware7 = function(options) {
  return function(next, context) {
    return function(args) {
      return __awaiter3(void 0, void 0, void 0, function() {
        var request, headers, userAgent2, defaultUserAgent8, customUserAgent, sdkUserAgentValue, normalUAValue;
        var _a2, _b2;
        return __generator3(this, function(_c) {
          switch (_c.label) {
            case 0:
              request = args.request;
              if (!HttpRequest2.isInstance(request))
                return [2, next(args)];
              headers = request.headers;
              userAgent2 = ((_a2 = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a2 === void 0 ? void 0 : _a2.map(escapeUserAgent6)) || [];
              return [4, options.defaultUserAgentProvider()];
            case 1:
              defaultUserAgent8 = _c.sent().map(escapeUserAgent6);
              customUserAgent = ((_b2 = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b2 === void 0 ? void 0 : _b2.map(escapeUserAgent6)) || [];
              sdkUserAgentValue = __spreadArray4(__spreadArray4(__spreadArray4([], __read10(defaultUserAgent8), false), __read10(userAgent2), false), __read10(customUserAgent), false).join(SPACE6);
              normalUAValue = __spreadArray4(__spreadArray4([], __read10(defaultUserAgent8.filter(function(section) {
                return section.startsWith("aws-sdk-");
              })), false), __read10(customUserAgent), false).join(SPACE6);
              if (options.runtime !== "browser") {
                if (normalUAValue) {
                  headers[X_AMZ_USER_AGENT6] = headers[X_AMZ_USER_AGENT6] ? "".concat(headers[USER_AGENT6], " ").concat(normalUAValue) : normalUAValue;
                }
                headers[USER_AGENT6] = sdkUserAgentValue;
              } else {
                headers[X_AMZ_USER_AGENT6] = sdkUserAgentValue;
              }
              return [2, next(__assign7(__assign7({}, args), { request }))];
          }
        });
      });
    };
  };
};
var escapeUserAgent6 = function(_a2) {
  var _b2 = __read10(_a2, 2), name = _b2[0], version3 = _b2[1];
  var prefixSeparatorIndex = name.indexOf("/");
  var prefix = name.substring(0, prefixSeparatorIndex);
  var uaName = name.substring(prefixSeparatorIndex + 1);
  if (prefix === "api") {
    uaName = uaName.toLowerCase();
  }
  return [prefix, uaName, version3].filter(function(item) {
    return item && item.length > 0;
  }).map(function(item) {
    return item === null || item === void 0 ? void 0 : item.replace(UA_ESCAPE_REGEX6, "_");
  }).join("/");
};
var getUserAgentMiddlewareOptions6 = {
  name: "getUserAgentMiddleware",
  step: "build",
  priority: "low",
  tags: ["SET_USER_AGENT", "USER_AGENT"],
  override: true
};
var getUserAgentPlugin6 = function(config) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(userAgentMiddleware7(config), getUserAgentMiddlewareOptions6);
    }
  };
};

// node_modules/@aws-sdk/client-lex-runtime-service/package.json
var package_default6 = {
  name: "@aws-sdk/client-lex-runtime-service",
  description: "AWS SDK for JavaScript Lex Runtime Service Client for Node.js, Browser and React Native",
  version: "3.186.2",
  scripts: {
    build: "concurrently 'yarn:build:cjs' 'yarn:build:es' 'yarn:build:types'",
    "build:cjs": "tsc -p tsconfig.cjs.json",
    "build:docs": "typedoc",
    "build:es": "tsc -p tsconfig.es.json",
    "build:include:deps": "lerna run --scope $npm_package_name --include-dependencies build",
    "build:types": "tsc -p tsconfig.types.json",
    "build:types:downlevel": "downlevel-dts dist-types dist-types/ts3.4",
    clean: "rimraf ./dist-* && rimraf *.tsbuildinfo",
    test: "yarn test:unit",
    "test:unit": "ts-mocha test/**/*.spec.ts"
  },
  main: "./dist-cjs/index.js",
  types: "./dist-types/index.d.ts",
  module: "./dist-es/index.js",
  sideEffects: false,
  dependencies: {
    "@aws-crypto/sha256-browser": "2.0.0",
    "@aws-crypto/sha256-js": "2.0.0",
    "@aws-sdk/client-sts": "3.186.2",
    "@aws-sdk/config-resolver": "3.186.0",
    "@aws-sdk/credential-provider-node": "3.186.0",
    "@aws-sdk/fetch-http-handler": "3.186.0",
    "@aws-sdk/hash-node": "3.186.0",
    "@aws-sdk/invalid-dependency": "3.186.0",
    "@aws-sdk/middleware-content-length": "3.186.0",
    "@aws-sdk/middleware-host-header": "3.186.0",
    "@aws-sdk/middleware-logger": "3.186.0",
    "@aws-sdk/middleware-recursion-detection": "3.186.0",
    "@aws-sdk/middleware-retry": "3.186.0",
    "@aws-sdk/middleware-serde": "3.186.0",
    "@aws-sdk/middleware-signing": "3.186.0",
    "@aws-sdk/middleware-stack": "3.186.0",
    "@aws-sdk/middleware-user-agent": "3.186.0",
    "@aws-sdk/node-config-provider": "3.186.0",
    "@aws-sdk/node-http-handler": "3.186.0",
    "@aws-sdk/protocol-http": "3.186.0",
    "@aws-sdk/smithy-client": "3.186.0",
    "@aws-sdk/types": "3.186.0",
    "@aws-sdk/url-parser": "3.186.0",
    "@aws-sdk/util-base64-browser": "3.186.0",
    "@aws-sdk/util-base64-node": "3.186.0",
    "@aws-sdk/util-body-length-browser": "3.186.0",
    "@aws-sdk/util-body-length-node": "3.186.0",
    "@aws-sdk/util-defaults-mode-browser": "3.186.0",
    "@aws-sdk/util-defaults-mode-node": "3.186.0",
    "@aws-sdk/util-user-agent-browser": "3.186.0",
    "@aws-sdk/util-user-agent-node": "3.186.0",
    "@aws-sdk/util-utf8-browser": "3.186.0",
    "@aws-sdk/util-utf8-node": "3.186.0",
    tslib: "^2.3.1"
  },
  devDependencies: {
    "@aws-sdk/service-client-documentation-generator": "3.186.0",
    "@tsconfig/recommended": "1.0.1",
    "@types/chai": "^4.2.11",
    "@types/mocha": "^8.0.4",
    "@types/node": "^12.7.5",
    concurrently: "7.0.0",
    "downlevel-dts": "0.10.1",
    rimraf: "3.0.2",
    typedoc: "0.19.2",
    typescript: "~4.6.2"
  },
  overrides: {
    typedoc: {
      typescript: "~4.6.2"
    }
  },
  engines: {
    node: ">=12.0.0"
  },
  typesVersions: {
    "<4.0": {
      "dist-types/*": [
        "dist-types/ts3.4/*"
      ]
    }
  },
  files: [
    "dist-*"
  ],
  author: {
    name: "AWS SDK for JavaScript Team",
    url: "https://aws.amazon.com/javascript/"
  },
  license: "Apache-2.0",
  browser: {
    "./dist-es/runtimeConfig": "./dist-es/runtimeConfig.browser"
  },
  "react-native": {
    "./dist-es/runtimeConfig": "./dist-es/runtimeConfig.native"
  },
  homepage: "https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-lex-runtime-service",
  repository: {
    type: "git",
    url: "https://github.com/aws/aws-sdk-js-v3.git",
    directory: "clients/client-lex-runtime-service"
  }
};

// node_modules/@aws-sdk/client-lex-runtime-service/dist-es/runtimeConfig.browser.js
var import_sha256_browser6 = __toESM(require_build38());

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/querystring-builder/dist-es/index.js
function buildQueryString2(query) {
  var e_1, _a2;
  var parts = [];
  try {
    for (var _b2 = __values4(Object.keys(query).sort()), _c = _b2.next(); !_c.done; _c = _b2.next()) {
      var key = _c.value;
      var value = query[key];
      key = escapeUri3(key);
      if (Array.isArray(value)) {
        for (var i2 = 0, iLen = value.length; i2 < iLen; i2++) {
          parts.push("".concat(key, "=").concat(escapeUri3(value[i2])));
        }
      } else {
        var qsEntry = key;
        if (value || typeof value === "string") {
          qsEntry += "=".concat(escapeUri3(value));
        }
        parts.push(qsEntry);
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_c && !_c.done && (_a2 = _b2.return))
        _a2.call(_b2);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return parts.join("&");
}

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/fetch-http-handler/dist-es/request-timeout.js
function requestTimeout3(timeoutInMs) {
  if (timeoutInMs === void 0) {
    timeoutInMs = 0;
  }
  return new Promise(function(resolve, reject) {
    if (timeoutInMs) {
      setTimeout(function() {
        var timeoutError = new Error("Request did not complete within ".concat(timeoutInMs, " ms"));
        timeoutError.name = "TimeoutError";
        reject(timeoutError);
      }, timeoutInMs);
    }
  });
}

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/fetch-http-handler/dist-es/fetch-http-handler.js
var FetchHttpHandler2 = function() {
  function FetchHttpHandler4(options) {
    if (typeof options === "function") {
      this.configProvider = options().then(function(opts) {
        return opts || {};
      });
    } else {
      this.config = options !== null && options !== void 0 ? options : {};
      this.configProvider = Promise.resolve(this.config);
    }
  }
  FetchHttpHandler4.prototype.destroy = function() {
  };
  FetchHttpHandler4.prototype.handle = function(request, _a2) {
    var _b2 = _a2 === void 0 ? {} : _a2, abortSignal = _b2.abortSignal;
    return __awaiter3(this, void 0, void 0, function() {
      var _c, requestTimeoutInMs, abortError, path, queryString, port, method, url2, body, requestOptions, fetchRequest, raceOfPromises;
      return __generator3(this, function(_d) {
        switch (_d.label) {
          case 0:
            if (!!this.config)
              return [3, 2];
            _c = this;
            return [4, this.configProvider];
          case 1:
            _c.config = _d.sent();
            _d.label = 2;
          case 2:
            requestTimeoutInMs = this.config.requestTimeout;
            if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
              abortError = new Error("Request aborted");
              abortError.name = "AbortError";
              return [2, Promise.reject(abortError)];
            }
            path = request.path;
            if (request.query) {
              queryString = buildQueryString2(request.query);
              if (queryString) {
                path += "?".concat(queryString);
              }
            }
            port = request.port, method = request.method;
            url2 = "".concat(request.protocol, "//").concat(request.hostname).concat(port ? ":".concat(port) : "").concat(path);
            body = method === "GET" || method === "HEAD" ? void 0 : request.body;
            requestOptions = {
              body,
              headers: new Headers(request.headers),
              method
            };
            if (typeof AbortController !== "undefined") {
              requestOptions["signal"] = abortSignal;
            }
            fetchRequest = new Request(url2, requestOptions);
            raceOfPromises = [
              fetch(fetchRequest).then(function(response) {
                var e_1, _a3;
                var fetchHeaders = response.headers;
                var transformedHeaders = {};
                try {
                  for (var _b3 = __values4(fetchHeaders.entries()), _c2 = _b3.next(); !_c2.done; _c2 = _b3.next()) {
                    var pair = _c2.value;
                    transformedHeaders[pair[0]] = pair[1];
                  }
                } catch (e_1_1) {
                  e_1 = { error: e_1_1 };
                } finally {
                  try {
                    if (_c2 && !_c2.done && (_a3 = _b3.return))
                      _a3.call(_b3);
                  } finally {
                    if (e_1)
                      throw e_1.error;
                  }
                }
                var hasReadableStream = response.body !== void 0;
                if (!hasReadableStream) {
                  return response.blob().then(function(body2) {
                    return {
                      response: new HttpResponse2({
                        headers: transformedHeaders,
                        statusCode: response.status,
                        body: body2
                      })
                    };
                  });
                }
                return {
                  response: new HttpResponse2({
                    headers: transformedHeaders,
                    statusCode: response.status,
                    body: response.body
                  })
                };
              }),
              requestTimeout3(requestTimeoutInMs)
            ];
            if (abortSignal) {
              raceOfPromises.push(new Promise(function(resolve, reject) {
                abortSignal.onabort = function() {
                  var abortError2 = new Error("Request aborted");
                  abortError2.name = "AbortError";
                  reject(abortError2);
                };
              }));
            }
            return [2, Promise.race(raceOfPromises)];
        }
      });
    });
  };
  return FetchHttpHandler4;
}();

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/util-base64-browser/dist-es/index.js
var alphabetByEncoding2 = {};
var alphabetByValue2 = new Array(64);
for (i2 = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i2 + start <= limit; i2++) {
  char = String.fromCharCode(i2 + start);
  alphabetByEncoding2[char] = i2;
  alphabetByValue2[i2] = char;
}
var char;
var i2;
var start;
var limit;
for (i2 = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i2 + start <= limit; i2++) {
  char = String.fromCharCode(i2 + start);
  index = i2 + 26;
  alphabetByEncoding2[char] = index;
  alphabetByValue2[index] = char;
}
var char;
var index;
var i2;
var start;
var limit;
for (i2 = 0; i2 < 10; i2++) {
  alphabetByEncoding2[i2.toString(10)] = i2 + 52;
  char = i2.toString(10);
  index = i2 + 52;
  alphabetByEncoding2[char] = index;
  alphabetByValue2[index] = char;
}
var char;
var index;
var i2;
alphabetByEncoding2["+"] = 62;
alphabetByValue2[62] = "+";
alphabetByEncoding2["/"] = 63;
alphabetByValue2[63] = "/";
var bitsPerLetter2 = 6;
var bitsPerByte2 = 8;
var maxLetterValue2 = 63;
function fromBase642(input) {
  var totalByteLength = input.length / 4 * 3;
  if (input.slice(-2) === "==") {
    totalByteLength -= 2;
  } else if (input.slice(-1) === "=") {
    totalByteLength--;
  }
  var out = new ArrayBuffer(totalByteLength);
  var dataView = new DataView(out);
  for (var i2 = 0; i2 < input.length; i2 += 4) {
    var bits = 0;
    var bitLength = 0;
    for (var j2 = i2, limit = i2 + 3; j2 <= limit; j2++) {
      if (input[j2] !== "=") {
        if (!(input[j2] in alphabetByEncoding2)) {
          throw new TypeError("Invalid character ".concat(input[j2], " in base64 string."));
        }
        bits |= alphabetByEncoding2[input[j2]] << (limit - j2) * bitsPerLetter2;
        bitLength += bitsPerLetter2;
      } else {
        bits >>= bitsPerLetter2;
      }
    }
    var chunkOffset = i2 / 4 * 3;
    bits >>= bitLength % bitsPerByte2;
    var byteLength2 = Math.floor(bitLength / bitsPerByte2);
    for (var k2 = 0; k2 < byteLength2; k2++) {
      var offset = (byteLength2 - k2 - 1) * bitsPerByte2;
      dataView.setUint8(chunkOffset + k2, (bits & 255 << offset) >> offset);
    }
  }
  return new Uint8Array(out);
}
function toBase642(input) {
  var str = "";
  for (var i2 = 0; i2 < input.length; i2 += 3) {
    var bits = 0;
    var bitLength = 0;
    for (var j2 = i2, limit = Math.min(i2 + 3, input.length); j2 < limit; j2++) {
      bits |= input[j2] << (limit - j2 - 1) * bitsPerByte2;
      bitLength += bitsPerByte2;
    }
    var bitClusterCount = Math.ceil(bitLength / bitsPerLetter2);
    bits <<= bitClusterCount * bitsPerLetter2 - bitLength;
    for (var k2 = 1; k2 <= bitClusterCount; k2++) {
      var offset = (bitClusterCount - k2) * bitsPerLetter2;
      str += alphabetByValue2[(bits & maxLetterValue2 << offset) >> offset];
    }
    str += "==".slice(0, 4 - bitClusterCount);
  }
  return str;
}

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/fetch-http-handler/dist-es/stream-collector.js
var streamCollector2 = function(stream) {
  if (typeof Blob === "function" && stream instanceof Blob) {
    return collectBlob2(stream);
  }
  return collectStream2(stream);
};
function collectBlob2(blob) {
  return __awaiter3(this, void 0, void 0, function() {
    var base64, arrayBuffer;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, readToBase642(blob)];
        case 1:
          base64 = _a2.sent();
          arrayBuffer = fromBase642(base64);
          return [2, new Uint8Array(arrayBuffer)];
      }
    });
  });
}
function collectStream2(stream) {
  return __awaiter3(this, void 0, void 0, function() {
    var res, reader, isDone, _a2, done, value, prior;
    return __generator3(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          res = new Uint8Array(0);
          reader = stream.getReader();
          isDone = false;
          _b2.label = 1;
        case 1:
          if (!!isDone)
            return [3, 3];
          return [4, reader.read()];
        case 2:
          _a2 = _b2.sent(), done = _a2.done, value = _a2.value;
          if (value) {
            prior = res;
            res = new Uint8Array(prior.length + value.length);
            res.set(prior);
            res.set(value, prior.length);
          }
          isDone = done;
          return [3, 1];
        case 3:
          return [2, res];
      }
    });
  });
}
function readToBase642(blob) {
  return new Promise(function(resolve, reject) {
    var reader = new FileReader();
    reader.onloadend = function() {
      var _a2;
      if (reader.readyState !== 2) {
        return reject(new Error("Reader aborted too early"));
      }
      var result = (_a2 = reader.result) !== null && _a2 !== void 0 ? _a2 : "";
      var commaIndex = result.indexOf(",");
      var dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
      resolve(result.substring(dataOffset));
    };
    reader.onabort = function() {
      return reject(new Error("Read aborted"));
    };
    reader.onerror = function() {
      return reject(reader.error);
    };
    reader.readAsDataURL(blob);
  });
}

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/invalid-dependency/dist-es/invalidProvider.js
var invalidProvider2 = function(message) {
  return function() {
    return Promise.reject(message);
  };
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/util-body-length-browser/dist-es/calculateBodyLength.js
var calculateBodyLength2 = function(body) {
  if (typeof body === "string") {
    var len = body.length;
    for (var i2 = len - 1; i2 >= 0; i2--) {
      var code = body.charCodeAt(i2);
      if (code > 127 && code <= 2047)
        len++;
      else if (code > 2047 && code <= 65535)
        len += 2;
      if (code >= 56320 && code <= 57343)
        i2--;
    }
    return len;
  } else if (typeof body.byteLength === "number") {
    return body.byteLength;
  } else if (typeof body.size === "number") {
    return body.size;
  }
  throw new Error("Body Length computation failed for ".concat(body));
};

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/util-user-agent-browser/dist-es/index.js
var defaultUserAgent6 = function(_a2) {
  var serviceId = _a2.serviceId, clientVersion = _a2.clientVersion;
  return function() {
    return __awaiter3(void 0, void 0, void 0, function() {
      var parsedUA, sections;
      var _a3, _b2, _c, _d, _e, _f, _g;
      return __generator3(this, function(_h) {
        parsedUA = typeof window !== "undefined" && ((_a3 = window === null || window === void 0 ? void 0 : window.navigator) === null || _a3 === void 0 ? void 0 : _a3.userAgent) ? bowser_default.parse(window.navigator.userAgent) : void 0;
        sections = [
          ["aws-sdk-js", clientVersion],
          ["os/".concat(((_b2 = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b2 === void 0 ? void 0 : _b2.name) || "other"), (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version],
          ["lang/js"],
          ["md/browser", "".concat((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown", "_").concat((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")]
        ];
        if (serviceId) {
          sections.push(["api/".concat(serviceId), clientVersion]);
        }
        return [2, sections];
      });
    });
  };
};

// node_modules/@aws-sdk/client-lex-runtime-service/dist-es/runtimeConfig.browser.js
init_dist_es3();

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/querystring-parser/dist-es/index.js
function parseQueryString2(querystring) {
  var e_1, _a2;
  var query = {};
  querystring = querystring.replace(/^\?/, "");
  if (querystring) {
    try {
      for (var _b2 = __values4(querystring.split("&")), _c = _b2.next(); !_c.done; _c = _b2.next()) {
        var pair = _c.value;
        var _d = __read10(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
        key = decodeURIComponent(key);
        if (value) {
          value = decodeURIComponent(value);
        }
        if (!(key in query)) {
          query[key] = value;
        } else if (Array.isArray(query[key])) {
          query[key].push(value);
        } else {
          query[key] = [query[key], value];
        }
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (_c && !_c.done && (_a2 = _b2.return))
          _a2.call(_b2);
      } finally {
        if (e_1)
          throw e_1.error;
      }
    }
  }
  return query;
}

// node_modules/@aws-sdk/client-lex-runtime-service/node_modules/@aws-sdk/url-parser/dist-es/index.js
var parseUrl2 = function(url2) {
  if (typeof url2 === "string") {
    return parseUrl2(new URL(url2));
  }
  var _a2 = url2, hostname = _a2.hostname, pathname = _a2.pathname, port = _a2.port, protocol = _a2.protocol, search = _a2.search;
  var query;
  if (search) {
    query = parseQueryString2(search);
  }
  return {
    hostname,
    port: port ? parseInt(port) : void 0,
    protocol,
    path: pathname,
    query
  };
};

// node_modules/@aws-sdk/client-lex-runtime-service/dist-es/endpoints.js
var regionHash = {
  "us-east-1": {
    variants: [
      {
        hostname: "runtime-fips.lex.us-east-1.amazonaws.com",
        tags: ["fips"]
      }
    ]
  },
  "us-gov-west-1": {
    variants: [
      {
        hostname: "runtime-fips.lex.us-gov-west-1.amazonaws.com",
        tags: ["fips"]
      }
    ]
  },
  "us-west-2": {
    variants: [
      {
        hostname: "runtime-fips.lex.us-west-2.amazonaws.com",
        tags: ["fips"]
      }
    ]
  }
};
var partitionHash = {
  aws: {
    regions: [
      "af-south-1",
      "ap-east-1",
      "ap-northeast-1",
      "ap-northeast-2",
      "ap-northeast-3",
      "ap-south-1",
      "ap-southeast-1",
      "ap-southeast-2",
      "ap-southeast-3",
      "ca-central-1",
      "eu-central-1",
      "eu-north-1",
      "eu-south-1",
      "eu-west-1",
      "eu-west-2",
      "eu-west-3",
      "me-central-1",
      "me-south-1",
      "sa-east-1",
      "us-east-1",
      "us-east-1-fips",
      "us-east-2",
      "us-west-1",
      "us-west-2",
      "us-west-2-fips"
    ],
    regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
    variants: [
      {
        hostname: "runtime.lex.{region}.amazonaws.com",
        tags: []
      },
      {
        hostname: "runtime-fips.lex.{region}.amazonaws.com",
        tags: ["fips"]
      },
      {
        hostname: "runtime.lex-fips.{region}.api.aws",
        tags: ["dualstack", "fips"]
      },
      {
        hostname: "runtime.lex.{region}.api.aws",
        tags: ["dualstack"]
      }
    ]
  },
  "aws-cn": {
    regions: ["cn-north-1", "cn-northwest-1"],
    regionRegex: "^cn\\-\\w+\\-\\d+$",
    variants: [
      {
        hostname: "runtime.lex.{region}.amazonaws.com.cn",
        tags: []
      },
      {
        hostname: "runtime.lex-fips.{region}.amazonaws.com.cn",
        tags: ["fips"]
      },
      {
        hostname: "runtime.lex-fips.{region}.api.amazonwebservices.com.cn",
        tags: ["dualstack", "fips"]
      },
      {
        hostname: "runtime.lex.{region}.api.amazonwebservices.com.cn",
        tags: ["dualstack"]
      }
    ]
  },
  "aws-iso": {
    regions: ["us-iso-east-1", "us-iso-west-1"],
    regionRegex: "^us\\-iso\\-\\w+\\-\\d+$",
    variants: [
      {
        hostname: "runtime.lex.{region}.c2s.ic.gov",
        tags: []
      },
      {
        hostname: "runtime.lex-fips.{region}.c2s.ic.gov",
        tags: ["fips"]
      }
    ]
  },
  "aws-iso-b": {
    regions: ["us-isob-east-1"],
    regionRegex: "^us\\-isob\\-\\w+\\-\\d+$",
    variants: [
      {
        hostname: "runtime.lex.{region}.sc2s.sgov.gov",
        tags: []
      },
      {
        hostname: "runtime.lex-fips.{region}.sc2s.sgov.gov",
        tags: ["fips"]
      }
    ]
  },
  "aws-us-gov": {
    regions: ["us-gov-east-1", "us-gov-west-1", "us-gov-west-1-fips"],
    regionRegex: "^us\\-gov\\-\\w+\\-\\d+$",
    variants: [
      {
        hostname: "runtime.lex.{region}.amazonaws.com",
        tags: []
      },
      {
        hostname: "runtime-fips.lex.{region}.amazonaws.com",
        tags: ["fips"]
      },
      {
        hostname: "runtime.lex-fips.{region}.api.aws",
        tags: ["dualstack", "fips"]
      },
      {
        hostname: "runtime.lex.{region}.api.aws",
        tags: ["dualstack"]
      }
    ]
  }
};
var defaultRegionInfoProvider6 = function(region, options) {
  return __awaiter3(void 0, void 0, void 0, function() {
    return __generator3(this, function(_a2) {
      return [2, getRegionInfo(region, __assign7(__assign7({}, options), { signingService: "lex", regionHash, partitionHash }))];
    });
  });
};

// node_modules/@aws-sdk/client-lex-runtime-service/dist-es/runtimeConfig.shared.js
var getRuntimeConfig = function(config) {
  var _a2, _b2, _c, _d, _e;
  return {
    apiVersion: "2016-11-28",
    disableHostPrefix: (_a2 = config === null || config === void 0 ? void 0 : config.disableHostPrefix) !== null && _a2 !== void 0 ? _a2 : false,
    logger: (_b2 = config === null || config === void 0 ? void 0 : config.logger) !== null && _b2 !== void 0 ? _b2 : {},
    regionInfoProvider: (_c = config === null || config === void 0 ? void 0 : config.regionInfoProvider) !== null && _c !== void 0 ? _c : defaultRegionInfoProvider6,
    serviceId: (_d = config === null || config === void 0 ? void 0 : config.serviceId) !== null && _d !== void 0 ? _d : "Lex Runtime Service",
    urlParser: (_e = config === null || config === void 0 ? void 0 : config.urlParser) !== null && _e !== void 0 ? _e : parseUrl2
  };
};

// node_modules/@aws-sdk/util-defaults-mode-browser/node_modules/@aws-sdk/property-provider/dist-es/ProviderError.js
var ProviderError2 = function(_super) {
  __extends3(ProviderError4, _super);
  function ProviderError4(message, tryNextLink) {
    if (tryNextLink === void 0) {
      tryNextLink = true;
    }
    var _this = _super.call(this, message) || this;
    _this.tryNextLink = tryNextLink;
    _this.name = "ProviderError";
    Object.setPrototypeOf(_this, ProviderError4.prototype);
    return _this;
  }
  ProviderError4.from = function(error, tryNextLink) {
    if (tryNextLink === void 0) {
      tryNextLink = true;
    }
    return Object.assign(new this(error.message, tryNextLink), error);
  };
  return ProviderError4;
}(Error);

// node_modules/@aws-sdk/util-defaults-mode-browser/node_modules/@aws-sdk/property-provider/dist-es/CredentialsProviderError.js
var CredentialsProviderError2 = function(_super) {
  __extends3(CredentialsProviderError4, _super);
  function CredentialsProviderError4(message, tryNextLink) {
    if (tryNextLink === void 0) {
      tryNextLink = true;
    }
    var _this = _super.call(this, message, tryNextLink) || this;
    _this.tryNextLink = tryNextLink;
    _this.name = "CredentialsProviderError";
    Object.setPrototypeOf(_this, CredentialsProviderError4.prototype);
    return _this;
  }
  return CredentialsProviderError4;
}(ProviderError2);

// node_modules/@aws-sdk/util-defaults-mode-browser/node_modules/@aws-sdk/property-provider/dist-es/TokenProviderError.js
var TokenProviderError2 = function(_super) {
  __extends3(TokenProviderError4, _super);
  function TokenProviderError4(message, tryNextLink) {
    if (tryNextLink === void 0) {
      tryNextLink = true;
    }
    var _this = _super.call(this, message, tryNextLink) || this;
    _this.tryNextLink = tryNextLink;
    _this.name = "TokenProviderError";
    Object.setPrototypeOf(_this, TokenProviderError4.prototype);
    return _this;
  }
  return TokenProviderError4;
}(ProviderError2);

// node_modules/@aws-sdk/util-defaults-mode-browser/node_modules/@aws-sdk/property-provider/dist-es/memoize.js
var memoize2 = function(provider, isExpired, requiresRefresh) {
  var resolved;
  var pending;
  var hasResult;
  var isConstant = false;
  var coalesceProvider = function() {
    return __awaiter3(void 0, void 0, void 0, function() {
      return __generator3(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            if (!pending) {
              pending = provider();
            }
            _a2.label = 1;
          case 1:
            _a2.trys.push([1, , 3, 4]);
            return [4, pending];
          case 2:
            resolved = _a2.sent();
            hasResult = true;
            isConstant = false;
            return [3, 4];
          case 3:
            pending = void 0;
            return [7];
          case 4:
            return [2, resolved];
        }
      });
    });
  };
  if (isExpired === void 0) {
    return function(options) {
      return __awaiter3(void 0, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh)))
                return [3, 2];
              return [4, coalesceProvider()];
            case 1:
              resolved = _a2.sent();
              _a2.label = 2;
            case 2:
              return [2, resolved];
          }
        });
      });
    };
  }
  return function(options) {
    return __awaiter3(void 0, void 0, void 0, function() {
      return __generator3(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh)))
              return [3, 2];
            return [4, coalesceProvider()];
          case 1:
            resolved = _a2.sent();
            _a2.label = 2;
          case 2:
            if (isConstant) {
              return [2, resolved];
            }
            if (requiresRefresh && !requiresRefresh(resolved)) {
              isConstant = true;
              return [2, resolved];
            }
            if (!isExpired(resolved))
              return [3, 4];
            return [4, coalesceProvider()];
          case 3:
            _a2.sent();
            return [2, resolved];
          case 4:
            return [2, resolved];
        }
      });
    });
  };
};

// node_modules/@aws-sdk/util-defaults-mode-browser/dist-es/constants.js
var DEFAULTS_MODE_OPTIONS = ["in-region", "cross-region", "mobile", "standard", "legacy"];

// node_modules/@aws-sdk/util-defaults-mode-browser/dist-es/resolveDefaultsModeConfig.js
var resolveDefaultsModeConfig = function(_a2) {
  var _b2 = _a2 === void 0 ? {} : _a2, defaultsMode = _b2.defaultsMode;
  return memoize2(function() {
    return __awaiter3(void 0, void 0, void 0, function() {
      var mode, _a3;
      return __generator3(this, function(_b3) {
        switch (_b3.label) {
          case 0:
            if (!(typeof defaultsMode === "function"))
              return [3, 2];
            return [4, defaultsMode()];
          case 1:
            _a3 = _b3.sent();
            return [3, 3];
          case 2:
            _a3 = defaultsMode;
            _b3.label = 3;
          case 3:
            mode = _a3;
            switch (mode === null || mode === void 0 ? void 0 : mode.toLowerCase()) {
              case "auto":
                return [2, Promise.resolve(isMobileBrowser() ? "mobile" : "standard")];
              case "mobile":
              case "in-region":
              case "cross-region":
              case "standard":
              case "legacy":
                return [2, Promise.resolve(mode === null || mode === void 0 ? void 0 : mode.toLocaleLowerCase())];
              case void 0:
                return [2, Promise.resolve("legacy")];
              default:
                throw new Error('Invalid parameter for "defaultsMode", expect '.concat(DEFAULTS_MODE_OPTIONS.join(", "), ", got ").concat(mode));
            }
            return [2];
        }
      });
    });
  });
};
var isMobileBrowser = function() {
  var _a2, _b2;
  var parsedUA = typeof window !== "undefined" && ((_a2 = window === null || window === void 0 ? void 0 : window.navigator) === null || _a2 === void 0 ? void 0 : _a2.userAgent) ? bowser_default.parse(window.navigator.userAgent) : void 0;
  var platform = (_b2 = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.platform) === null || _b2 === void 0 ? void 0 : _b2.type;
  return platform === "tablet" || platform === "mobile";
};

// node_modules/@aws-sdk/client-lex-runtime-service/dist-es/runtimeConfig.browser.js
var getRuntimeConfig2 = function(config) {
  var _a2, _b2, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
  var defaultsMode = resolveDefaultsModeConfig(config);
  var defaultConfigProvider = function() {
    return defaultsMode().then(loadConfigsForDefaultMode);
  };
  var clientSharedValues = getRuntimeConfig(config);
  return __assign7(__assign7(__assign7({}, clientSharedValues), config), { runtime: "browser", defaultsMode, base64Decoder: (_a2 = config === null || config === void 0 ? void 0 : config.base64Decoder) !== null && _a2 !== void 0 ? _a2 : fromBase642, base64Encoder: (_b2 = config === null || config === void 0 ? void 0 : config.base64Encoder) !== null && _b2 !== void 0 ? _b2 : toBase642, bodyLengthChecker: (_c = config === null || config === void 0 ? void 0 : config.bodyLengthChecker) !== null && _c !== void 0 ? _c : calculateBodyLength2, credentialDefaultProvider: (_d = config === null || config === void 0 ? void 0 : config.credentialDefaultProvider) !== null && _d !== void 0 ? _d : function(_2) {
    return function() {
      return Promise.reject(new Error("Credential is missing"));
    };
  }, defaultUserAgentProvider: (_e = config === null || config === void 0 ? void 0 : config.defaultUserAgentProvider) !== null && _e !== void 0 ? _e : defaultUserAgent6({ serviceId: clientSharedValues.serviceId, clientVersion: package_default6.version }), maxAttempts: (_f = config === null || config === void 0 ? void 0 : config.maxAttempts) !== null && _f !== void 0 ? _f : DEFAULT_MAX_ATTEMPTS2, region: (_g = config === null || config === void 0 ? void 0 : config.region) !== null && _g !== void 0 ? _g : invalidProvider2("Region is missing"), requestHandler: (_h = config === null || config === void 0 ? void 0 : config.requestHandler) !== null && _h !== void 0 ? _h : new FetchHttpHandler2(defaultConfigProvider), retryMode: (_j = config === null || config === void 0 ? void 0 : config.retryMode) !== null && _j !== void 0 ? _j : function() {
    return __awaiter3(void 0, void 0, void 0, function() {
      return __generator3(this, function(_a3) {
        switch (_a3.label) {
          case 0:
            return [4, defaultConfigProvider()];
          case 1:
            return [2, _a3.sent().retryMode || DEFAULT_RETRY_MODE2];
        }
      });
    });
  }, sha256: (_k = config === null || config === void 0 ? void 0 : config.sha256) !== null && _k !== void 0 ? _k : import_sha256_browser6.Sha256, streamCollector: (_l = config === null || config === void 0 ? void 0 : config.streamCollector) !== null && _l !== void 0 ? _l : streamCollector2, useDualstackEndpoint: (_m = config === null || config === void 0 ? void 0 : config.useDualstackEndpoint) !== null && _m !== void 0 ? _m : function() {
    return Promise.resolve(DEFAULT_USE_DUALSTACK_ENDPOINT);
  }, useFipsEndpoint: (_o = config === null || config === void 0 ? void 0 : config.useFipsEndpoint) !== null && _o !== void 0 ? _o : function() {
    return Promise.resolve(DEFAULT_USE_FIPS_ENDPOINT);
  }, utf8Decoder: (_p = config === null || config === void 0 ? void 0 : config.utf8Decoder) !== null && _p !== void 0 ? _p : fromUtf827, utf8Encoder: (_q = config === null || config === void 0 ? void 0 : config.utf8Encoder) !== null && _q !== void 0 ? _q : toUtf825 });
};

// node_modules/@aws-sdk/client-lex-runtime-service/dist-es/LexRuntimeServiceClient.js
var LexRuntimeServiceClient = function(_super) {
  __extends3(LexRuntimeServiceClient2, _super);
  function LexRuntimeServiceClient2(configuration) {
    var _this = this;
    var _config_0 = getRuntimeConfig2(configuration);
    var _config_1 = resolveRegionConfig2(_config_0);
    var _config_2 = resolveEndpointsConfig2(_config_1);
    var _config_3 = resolveRetryConfig2(_config_2);
    var _config_4 = resolveHostHeaderConfig6(_config_3);
    var _config_5 = resolveAwsAuthConfig6(_config_4);
    var _config_6 = resolveUserAgentConfig6(_config_5);
    _this = _super.call(this, _config_6) || this;
    _this.config = _config_6;
    _this.middlewareStack.use(getRetryPlugin2(_this.config));
    _this.middlewareStack.use(getContentLengthPlugin2(_this.config));
    _this.middlewareStack.use(getHostHeaderPlugin6(_this.config));
    _this.middlewareStack.use(getLoggerPlugin6(_this.config));
    _this.middlewareStack.use(getRecursionDetectionPlugin(_this.config));
    _this.middlewareStack.use(getAwsAuthPlugin6(_this.config));
    _this.middlewareStack.use(getUserAgentPlugin6(_this.config));
    return _this;
  }
  LexRuntimeServiceClient2.prototype.destroy = function() {
    _super.prototype.destroy.call(this);
  };
  return LexRuntimeServiceClient2;
}(Client3);

// node_modules/fflate/esm/browser.js
var u8 = Uint8Array;
var u16 = Uint16Array;
var u32 = Uint32Array;
var fleb = new u8([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  /* unused */
  0,
  0,
  /* impossible */
  0
]);
var fdeb = new u8([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  /* unused */
  0,
  0
]);
var clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
var freb = function(eb, start) {
  var b2 = new u16(31);
  for (var i2 = 0; i2 < 31; ++i2) {
    b2[i2] = start += 1 << eb[i2 - 1];
  }
  var r2 = new u32(b2[30]);
  for (var i2 = 1; i2 < 30; ++i2) {
    for (var j2 = b2[i2]; j2 < b2[i2 + 1]; ++j2) {
      r2[j2] = j2 - b2[i2] << 5 | i2;
    }
  }
  return [b2, r2];
};
var _a = freb(fleb, 2);
var fl = _a[0];
var revfl = _a[1];
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0);
var fd = _b[0];
var revfd = _b[1];
var rev = new u16(32768);
for (i2 = 0; i2 < 32768; ++i2) {
  x2 = (i2 & 43690) >>> 1 | (i2 & 21845) << 1;
  x2 = (x2 & 52428) >>> 2 | (x2 & 13107) << 2;
  x2 = (x2 & 61680) >>> 4 | (x2 & 3855) << 4;
  rev[i2] = ((x2 & 65280) >>> 8 | (x2 & 255) << 8) >>> 1;
}
var x2;
var i2;
var flt = new u8(288);
for (i2 = 0; i2 < 144; ++i2)
  flt[i2] = 8;
var i2;
for (i2 = 144; i2 < 256; ++i2)
  flt[i2] = 9;
var i2;
for (i2 = 256; i2 < 280; ++i2)
  flt[i2] = 7;
var i2;
for (i2 = 280; i2 < 288; ++i2)
  flt[i2] = 8;
var i2;
var fdt = new u8(32);
for (i2 = 0; i2 < 32; ++i2)
  fdt[i2] = 5;
var i2;
var et = /* @__PURE__ */ new u8(0);
var td = typeof TextDecoder != "undefined" && /* @__PURE__ */ new TextDecoder();
var tds = 0;
try {
  td.decode(et, { stream: true });
  tds = 1;
} catch (e) {
}

// node_modules/@aws-amplify/interactions/lib-esm/Providers/AWSLexProviderHelper/utils.js
var convert = function(stream) {
  return __awaiter68(void 0, void 0, void 0, function() {
    return __generator69(this, function(_a2) {
      if (stream instanceof Blob || stream instanceof ReadableStream) {
        return [2, new Response(stream).arrayBuffer().then(function(buffer) {
          return new Uint8Array(buffer);
        })];
      } else {
        return [2, Promise.reject("Invalid content type")];
      }
      return [
        2
        /*return*/
      ];
    });
  });
};

// node_modules/@aws-amplify/interactions/lib-esm/Providers/AWSLexProvider.js
var logger54 = new ConsoleLogger("AWSLexProvider");
var AWSLexProvider = (
  /** @class */
  function(_super) {
    __extends11(AWSLexProvider2, _super);
    function AWSLexProvider2(options) {
      if (options === void 0) {
        options = {};
      }
      var _this = _super.call(this, options) || this;
      _this._botsCompleteCallback = {};
      return _this;
    }
    AWSLexProvider2.prototype.getProviderName = function() {
      return "AWSLexProvider";
    };
    AWSLexProvider2.prototype.configure = function(config) {
      if (config === void 0) {
        config = {};
      }
      var propertiesToTest = ["name", "alias", "region"];
      Object.keys(config).forEach(function(botKey) {
        var botConfig = config[botKey];
        if (!propertiesToTest.every(function(x2) {
          return x2 in botConfig;
        })) {
          throw new Error("invalid bot configuration");
        }
      });
      return _super.prototype.configure.call(this, config);
    };
    AWSLexProvider2.prototype.reportBotStatus = function(data, botname) {
      var _this = this;
      logger54.debug("postContent state", data.dialogState);
      if (data.dialogState === "ReadyForFulfillment" || data.dialogState === "Fulfilled") {
        if (typeof this._botsCompleteCallback[botname] === "function") {
          setTimeout(function() {
            return _this._botsCompleteCallback[botname](null, data);
          }, 0);
        }
        if (this._config && typeof this._config[botname].onComplete === "function") {
          setTimeout(function() {
            return _this._config[botname].onComplete(null, data);
          }, 0);
        }
      }
      if (data.dialogState === "Failed") {
        if (typeof this._botsCompleteCallback[botname] === "function") {
          setTimeout(function() {
            return _this._botsCompleteCallback[botname]("Bot conversation failed");
          }, 0);
        }
        if (this._config && typeof this._config[botname].onComplete === "function") {
          setTimeout(function() {
            return _this._config[botname].onComplete("Bot conversation failed");
          }, 0);
        }
      }
    };
    AWSLexProvider2.prototype.sendMessage = function(botname, message) {
      return __awaiter68(this, void 0, void 0, function() {
        var credentials, error_1, params, postTextCommand, data, err_1, content, messageType, inputStream, _a2, postContentCommand, data, audioArray, _b2, response, err_2;
        return __generator69(this, function(_c) {
          switch (_c.label) {
            case 0:
              if (!this._config[botname]) {
                return [2, Promise.reject("Bot " + botname + " does not exist")];
              }
              _c.label = 1;
            case 1:
              _c.trys.push([1, 3, , 4]);
              return [4, Credentials.get()];
            case 2:
              credentials = _c.sent();
              return [3, 4];
            case 3:
              error_1 = _c.sent();
              return [2, Promise.reject("No credentials")];
            case 4:
              this.lexRuntimeServiceClient = new LexRuntimeServiceClient({
                region: this._config[botname].region,
                credentials,
                customUserAgent: getAmplifyUserAgentObject()
              });
              if (!(typeof message === "string"))
                return [3, 9];
              params = {
                botAlias: this._config[botname].alias,
                botName: botname,
                inputText: message,
                userId: credentials.identityId
              };
              logger54.debug("postText to lex", message);
              _c.label = 5;
            case 5:
              _c.trys.push([5, 7, , 8]);
              postTextCommand = new PostTextCommand(params);
              return [4, this.lexRuntimeServiceClient.send(postTextCommand)];
            case 6:
              data = _c.sent();
              this.reportBotStatus(data, botname);
              return [2, data];
            case 7:
              err_1 = _c.sent();
              return [2, Promise.reject(err_1)];
            case 8:
              return [3, 21];
            case 9:
              content = message.content, messageType = message.options.messageType;
              if (!(messageType === "voice"))
                return [3, 13];
              if (typeof content !== "object") {
                return [2, Promise.reject("invalid content type")];
              }
              if (!(content instanceof Uint8Array))
                return [3, 10];
              _a2 = content;
              return [3, 12];
            case 10:
              return [4, convert(content)];
            case 11:
              _a2 = _c.sent();
              _c.label = 12;
            case 12:
              inputStream = _a2;
              params = {
                botAlias: this._config[botname].alias,
                botName: botname,
                contentType: "audio/x-l16; sample-rate=16000; channel-count=1",
                userId: credentials.identityId,
                accept: "audio/mpeg",
                inputStream
              };
              return [3, 14];
            case 13:
              if (typeof content !== "string")
                return [2, Promise.reject("invalid content type")];
              params = {
                botAlias: this._config[botname].alias,
                botName: botname,
                contentType: "text/plain; charset=utf-8",
                inputStream: content,
                userId: credentials.identityId,
                accept: "audio/mpeg"
              };
              _c.label = 14;
            case 14:
              logger54.debug("postContent to lex", message);
              _c.label = 15;
            case 15:
              _c.trys.push([15, 20, , 21]);
              postContentCommand = new PostContentCommand(params);
              return [4, this.lexRuntimeServiceClient.send(postContentCommand)];
            case 16:
              data = _c.sent();
              if (!data.audioStream)
                return [3, 18];
              return [4, convert(data.audioStream)];
            case 17:
              _b2 = _c.sent();
              return [3, 19];
            case 18:
              _b2 = void 0;
              _c.label = 19;
            case 19:
              audioArray = _b2;
              response = __assign44(__assign44({}, data), { audioStream: audioArray });
              this.reportBotStatus(response, botname);
              return [2, response];
            case 20:
              err_2 = _c.sent();
              return [2, Promise.reject(err_2)];
            case 21:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AWSLexProvider2.prototype.onComplete = function(botname, callback) {
      if (!this._config[botname]) {
        throw new Error("Bot " + botname + " does not exist");
      }
      this._botsCompleteCallback[botname] = callback;
    };
    return AWSLexProvider2;
  }(AbstractInteractionsProvider)
);

// node_modules/@aws-amplify/interactions/lib-esm/Interactions.js
var logger55 = new ConsoleLogger("Interactions");
var InteractionsClass = (
  /** @class */
  function() {
    function InteractionsClass2(options) {
      if (options === void 0) {
        options = {};
      }
      this._options = options;
      logger55.debug("Interactions Options", this._options);
      this._pluggables = {};
    }
    InteractionsClass2.prototype.getModuleName = function() {
      return "Interactions";
    };
    InteractionsClass2.prototype.configure = function(options) {
      var _this = this;
      var opt = options ? options.Interactions || options : {};
      logger55.debug("configure Interactions", { opt });
      this._options = __assign44(__assign44({ bots: {} }, opt), opt.Interactions);
      var aws_bots_config = this._options.aws_bots_config;
      var bots_config = this._options.bots;
      if (!Object.keys(bots_config).length && aws_bots_config) {
        if (Array.isArray(aws_bots_config)) {
          aws_bots_config.forEach(function(bot) {
            _this._options.bots[bot.name] = bot;
          });
        }
      }
      Object.keys(bots_config).forEach(function(botKey) {
        var _a2;
        var bot = bots_config[botKey];
        var providerName = bot.providerName || "AWSLexProvider";
        if (!_this._pluggables.AWSLexProvider && providerName === "AWSLexProvider") {
          _this._pluggables.AWSLexProvider = new AWSLexProvider();
        }
        if (_this._pluggables[providerName]) {
          _this._pluggables[providerName].configure((_a2 = {}, _a2[bot.name] = bot, _a2));
        } else {
          logger55.debug("bot " + bot.name + " was not configured as " + providerName + " provider was not found");
        }
      });
      return this._options;
    };
    InteractionsClass2.prototype.addPluggable = function(pluggable) {
      var _this = this;
      if (pluggable && pluggable.getCategory() === "Interactions") {
        if (!this._pluggables[pluggable.getProviderName()]) {
          Object.keys(this._options.bots).filter(function(botKey) {
            return _this._options.bots[botKey].providerName === pluggable.getProviderName();
          }).forEach(function(botKey) {
            var _a2;
            var bot = _this._options.bots[botKey];
            pluggable.configure((_a2 = {}, _a2[bot.name] = bot, _a2));
          });
          this._pluggables[pluggable.getProviderName()] = pluggable;
          return;
        } else {
          throw new Error("Pluggable " + pluggable.getProviderName() + " already plugged");
        }
      }
    };
    InteractionsClass2.prototype.send = function(botname, message) {
      return __awaiter68(this, void 0, void 0, function() {
        var botProvider;
        return __generator69(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (!this._options.bots || !this._options.bots[botname]) {
                return [2, Promise.reject("Bot " + botname + " does not exist")];
              }
              botProvider = this._options.bots[botname].providerName || "AWSLexProvider";
              if (!this._pluggables[botProvider]) {
                return [2, Promise.reject("Bot " + botProvider + " does not have valid pluggin did you try addPluggable first?")];
              }
              return [4, this._pluggables[botProvider].sendMessage(botname, message)];
            case 1:
              return [2, _a2.sent()];
          }
        });
      });
    };
    InteractionsClass2.prototype.onComplete = function(botname, callback) {
      if (!this._options.bots || !this._options.bots[botname]) {
        throw new Error("Bot " + botname + " does not exist");
      }
      var botProvider = this._options.bots[botname].providerName || "AWSLexProvider";
      if (!this._pluggables[botProvider]) {
        throw new Error("Bot " + botProvider + " does not have valid pluggin did you try addPluggable first?");
      }
      this._pluggables[botProvider].onComplete(botname, callback);
    };
    return InteractionsClass2;
  }()
);
var Interactions = new InteractionsClass();
Amplify.register(Interactions);

// node_modules/@aws-amplify/notifications/lib-esm/InAppMessaging/InAppMessaging.js
var import_flatten = __toESM(require_flatten());

// node_modules/@aws-amplify/notifications/lib-esm/common/AWSPinpointProviderCommon/index.js
var import_uuid8 = __toESM(require_uuid5());
var AWSPinpointProviderCommon = (
  /** @class */
  function() {
    function AWSPinpointProviderCommon2(logger64) {
      var _this = this;
      var _a2;
      this.config = {};
      this.endpointInitialized = false;
      this.initialized = false;
      this.identifyUser = function(userId, userInfo) {
        return __awaiter3(_this, void 0, void 0, function() {
          var err_1;
          return __generator3(this, function(_a3) {
            switch (_a3.label) {
              case 0:
                if (!!this.initialized)
                  return [3, 2];
                return [4, this.init()];
              case 1:
                _a3.sent();
                _a3.label = 2;
              case 2:
                _a3.trys.push([2, 4, , 5]);
                return [4, this.updateEndpoint(userId, userInfo)];
              case 3:
                _a3.sent();
                return [3, 5];
              case 4:
                err_1 = _a3.sent();
                this.logger.error("Error identifying user", err_1);
                throw err_1;
              case 5:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      this.init = function() {
        return __awaiter3(_this, void 0, void 0, function() {
          var _a3, endpointId, storage, providerName, _b2, err_2;
          return __generator3(this, function(_c) {
            switch (_c.label) {
              case 0:
                _a3 = this.config, endpointId = _a3.endpointId, storage = _a3.storage;
                providerName = this.getProviderName();
                _c.label = 1;
              case 1:
                _c.trys.push([1, 6, , 7]);
                if (!(typeof storage.sync === "function"))
                  return [3, 3];
                return [4, storage.sync()];
              case 2:
                _c.sent();
                _c.label = 3;
              case 3:
                if (!!endpointId)
                  return [3, 5];
                _b2 = this.config;
                return [4, this.getEndpointId()];
              case 4:
                _b2.endpointId = _c.sent();
                _c.label = 5;
              case 5:
                this.initialized = true;
                return [3, 7];
              case 6:
                err_2 = _c.sent();
                this.logger.error("Failed to initialize " + providerName, err_2);
                return [3, 7];
              case 7:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      this.getUserAgentValue = function() {
        var customUserAgentDetails;
        if (_this.getSubCategory() === "PushNotification") {
          customUserAgentDetails = {
            category: Category.PushNotification,
            action: PushNotificationAction.None
          };
        } else {
          customUserAgentDetails = {
            category: Category.InAppMessaging,
            action: InAppMessagingAction.None
          };
        }
        return getAmplifyUserAgent(customUserAgentDetails);
      };
      this.recordAnalyticsEvent = function(event) {
        return __awaiter3(_this, void 0, void 0, function() {
          var _a3, _b2, appId, credentials, endpointId, region, input, err_3;
          var _c, _d;
          return __generator3(this, function(_e) {
            switch (_e.label) {
              case 0:
                _a3 = this.config;
                return [4, this.getCredentials()];
              case 1:
                _a3.credentials = _e.sent();
                this.assertNotEmptyConfiguration();
                _b2 = this.config, appId = _b2.appId, credentials = _b2.credentials, endpointId = _b2.endpointId, region = _b2.region;
                _e.label = 2;
              case 2:
                _e.trys.push([2, 4, , 5]);
                input = {
                  ApplicationId: appId,
                  EventsRequest: {
                    BatchItem: (_c = {}, _c[endpointId] = {
                      Endpoint: {},
                      Events: (_d = {}, _d[(0, import_uuid8.v4)()] = event, _d)
                    }, _c)
                  }
                };
                this.logger.debug("recording analytics event");
                return [4, putEvents({ credentials, region, userAgentValue: this.getUserAgentValue() }, input)];
              case 3:
                _e.sent();
                return [3, 5];
              case 4:
                err_3 = _e.sent();
                this.logger.error("Error recording analytics event", err_3);
                throw err_3;
              case 5:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      this.updateEndpoint = function(userId, userInfo) {
        if (userId === void 0) {
          userId = null;
        }
        if (userInfo === void 0) {
          userInfo = null;
        }
        return __awaiter3(_this, void 0, void 0, function() {
          var credentials, credentialsUpdated, _a3, appId, endpointId, _b2, endpointInfo, region, _c, address, attributes, demographic, location_1, metrics, optOut, _d, appVersion, make, model, platform, version3, input, err_4;
          var _this2 = this;
          var _e;
          return __generator3(this, function(_f) {
            switch (_f.label) {
              case 0:
                return [4, this.getCredentials()];
              case 1:
                credentials = _f.sent();
                credentialsUpdated = !this.config.credentials || Object.keys(credentials).some(function(key) {
                  return credentials[key] !== _this2.config.credentials[key];
                });
                if (this.endpointInitialized && !credentialsUpdated && !userId && !userInfo) {
                  return [
                    2
                    /*return*/
                  ];
                }
                this.config.credentials = credentials;
                this.assertNotEmptyConfiguration();
                _a3 = this.config, appId = _a3.appId, endpointId = _a3.endpointId, _b2 = _a3.endpointInfo, endpointInfo = _b2 === void 0 ? {} : _b2, region = _a3.region;
                _f.label = 2;
              case 2:
                _f.trys.push([2, 4, , 5]);
                _c = userInfo !== null && userInfo !== void 0 ? userInfo : {}, address = _c.address, attributes = _c.attributes, demographic = _c.demographic, location_1 = _c.location, metrics = _c.metrics, optOut = _c.optOut;
                _d = this.clientInfo, appVersion = _d.appVersion, make = _d.make, model = _d.model, platform = _d.platform, version3 = _d.version;
                input = {
                  ApplicationId: appId,
                  EndpointId: endpointId,
                  EndpointRequest: {
                    RequestId: (0, import_uuid8.v4)(),
                    EffectiveDate: (/* @__PURE__ */ new Date()).toISOString(),
                    ChannelType: endpointInfo.channelType,
                    Address: address !== null && address !== void 0 ? address : endpointInfo.address,
                    Attributes: __assign7(__assign7({}, endpointInfo.attributes), attributes),
                    Demographic: __assign7({ AppVersion: appVersion, Make: make, Model: model, ModelVersion: version3, Platform: platform }, transferKeyToUpperCase(__assign7(__assign7({}, endpointInfo.demographic), demographic))),
                    Location: transferKeyToUpperCase(__assign7(__assign7({}, endpointInfo.location), location_1)),
                    Metrics: __assign7(__assign7({}, endpointInfo.metrics), metrics),
                    OptOut: optOut !== null && optOut !== void 0 ? optOut : endpointInfo.optOut,
                    User: {
                      UserId: (_e = userId !== null && userId !== void 0 ? userId : endpointInfo.userId) !== null && _e !== void 0 ? _e : credentials.identityId,
                      UserAttributes: attributes !== null && attributes !== void 0 ? attributes : endpointInfo.userAttributes
                    }
                  }
                };
                this.logger.debug("updating endpoint");
                return [4, updateEndpoint({ credentials, region, userAgentValue: this.getUserAgentValue() }, input)];
              case 3:
                _f.sent();
                this.endpointInitialized = true;
                return [3, 5];
              case 4:
                err_4 = _f.sent();
                throw err_4;
              case 5:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      this.getEndpointId = function() {
        return __awaiter3(_this, void 0, void 0, function() {
          var appId, cacheKey, cachedEndpointId, endpointId, ttl, expiration;
          return __generator3(this, function(_a3) {
            switch (_a3.label) {
              case 0:
                appId = this.config.appId;
                cacheKey = this.getSubCategory() === "PushNotification" ? this.getProviderName() + "_" + appId : this.getSubCategory() + ":" + this.getProviderName() + ":" + appId;
                return [4, BrowserStorageCache.getItem(cacheKey)];
              case 1:
                cachedEndpointId = _a3.sent();
                if (cachedEndpointId) {
                  return [2, cachedEndpointId];
                }
                endpointId = (0, import_uuid8.v4)();
                ttl = 1e3 * 60 * 60 * 24 * 365 * 100;
                expiration = (/* @__PURE__ */ new Date()).getTime() + ttl;
                BrowserStorageCache.setItem(cacheKey, endpointId, {
                  expires: expiration,
                  priority: 1
                });
                return [2, endpointId];
            }
          });
        });
      };
      this.getCredentials = function() {
        return __awaiter3(_this, void 0, void 0, function() {
          var credentials, err_5;
          return __generator3(this, function(_a3) {
            switch (_a3.label) {
              case 0:
                _a3.trys.push([0, 2, , 3]);
                return [4, Credentials.get()];
              case 1:
                credentials = _a3.sent();
                if (!credentials) {
                  this.logger.debug("no credentials found");
                  return [2, null];
                }
                return [2, Credentials.shear(credentials)];
              case 2:
                err_5 = _a3.sent();
                this.logger.error("Error getting credentials:", err_5);
                return [2, null];
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      this.assertNotEmptyConfiguration = function() {
        var _a3 = _this.config, appId = _a3.appId, credentials = _a3.credentials, region = _a3.region;
        if (!appId || !credentials || !region) {
          throw new Error("One or more of credentials, appId or region is not configured");
        }
      };
      this.config = { storage: new StorageHelper().getStorage() };
      this.clientInfo = (_a2 = ClientDevice.clientInfo()) !== null && _a2 !== void 0 ? _a2 : {};
      this.logger = logger64;
    }
    AWSPinpointProviderCommon2.prototype.getCategory = function() {
      return AWSPinpointProviderCommon2.category;
    };
    AWSPinpointProviderCommon2.prototype.getProviderName = function() {
      return AWSPinpointProviderCommon2.providerName;
    };
    AWSPinpointProviderCommon2.prototype.configure = function(config) {
      if (config === void 0) {
        config = {};
      }
      this.config = __assign7(__assign7({}, this.config), config);
      this.logger.debug("configure " + this.getProviderName() + this.getSubCategory() + "Provider", this.config);
      return this.config;
    };
    AWSPinpointProviderCommon2.category = "Notifications";
    AWSPinpointProviderCommon2.providerName = "AWSPinpoint";
    return AWSPinpointProviderCommon2;
  }()
);
var AWSPinpointProviderCommon_default = AWSPinpointProviderCommon;

// node_modules/@aws-amplify/notifications/lib-esm/common/constants.js
var AMPLIFY_SYMBOL9 = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";

// node_modules/@aws-amplify/notifications/lib-esm/common/eventListeners/index.js
var eventListeners = {};
var notifyEventListeners = function(type) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  var _a2;
  (_a2 = eventListeners[type]) === null || _a2 === void 0 ? void 0 : _a2.forEach(function(listener2) {
    listener2.handleEvent.apply(listener2, __spread(args));
  });
};
var addEventListener = function(type, handler) {
  if (!eventListeners[type]) {
    eventListeners[type] = /* @__PURE__ */ new Set();
  }
  var listener2 = {
    handleEvent: handler,
    remove: function() {
      eventListeners[type].delete(listener2);
    }
  };
  eventListeners[type].add(listener2);
  return listener2;
};

// node_modules/@aws-amplify/notifications/lib-esm/InAppMessaging/SessionTracker/SessionTracker.js
var import_noop = __toESM(require_noop());
var hidden;
var visibilityChange;
var isBrowser2 = browserOrNode().isBrowser;
if (isBrowser2 && document) {
  if (typeof document.hidden !== "undefined") {
    hidden = "hidden";
    visibilityChange = "visibilitychange";
  } else if (typeof document["msHidden"] !== "undefined") {
    hidden = "msHidden";
    visibilityChange = "msvisibilitychange";
  } else if (typeof document["webkitHidden"] !== "undefined") {
    hidden = "webkitHidden";
    visibilityChange = "webkitvisibilitychange";
  }
}
var logger56 = new ConsoleLogger("InAppMessagingSessionTracker");
var SessionTracker2 = (
  /** @class */
  function() {
    function SessionTracker3(sessionStateChangeHandler) {
      var _this = this;
      if (sessionStateChangeHandler === void 0) {
        sessionStateChangeHandler = import_noop.default;
      }
      this.start = function() {
        if (isBrowser2) {
          document === null || document === void 0 ? void 0 : document.addEventListener(visibilityChange, _this.visibilityChangeHandler);
        }
        return _this.getSessionState();
      };
      this.end = function() {
        if (isBrowser2) {
          document === null || document === void 0 ? void 0 : document.removeEventListener(visibilityChange, _this.visibilityChangeHandler);
        }
        return _this.getSessionState();
      };
      this.getSessionState = function() {
        if (isBrowser2 && document && !document[hidden]) {
          return "started";
        }
        return "ended";
      };
      this.visibilityChangeHandler = function() {
        if (!isBrowser2 || !document) {
          return;
        }
        if (document[hidden]) {
          logger56.debug("App is now hidden");
          _this.sessionStateChangeHandler("ended");
        } else {
          logger56.debug("App is now visible");
          _this.sessionStateChangeHandler("started");
        }
      };
      this.sessionStateChangeHandler = sessionStateChangeHandler;
    }
    return SessionTracker3;
  }()
);
var SessionTracker_default = SessionTracker2;

// node_modules/@aws-amplify/notifications/lib-esm/InAppMessaging/SessionTracker/index.js
var SessionTracker_default2 = SessionTracker_default;

// node_modules/@aws-amplify/notifications/lib-esm/InAppMessaging/types.js
var InAppMessageInteractionEvent;
(function(InAppMessageInteractionEvent2) {
  InAppMessageInteractionEvent2["MESSAGE_RECEIVED"] = "MESSAGE_RECEIVED_EVENT";
  InAppMessageInteractionEvent2["MESSAGE_DISPLAYED"] = "MESSAGE_DISPLAYED_EVENT";
  InAppMessageInteractionEvent2["MESSAGE_DISMISSED"] = "MESSAGE_DISMISSED_EVENT";
  InAppMessageInteractionEvent2["MESSAGE_ACTION_TAKEN"] = "MESSAGE_ACTION_TAKEN_EVENT";
})(InAppMessageInteractionEvent || (InAppMessageInteractionEvent = {}));

// node_modules/@aws-amplify/notifications/lib-esm/InAppMessaging/Providers/AWSPinpointProvider/types.js
var AWSPinpointMessageEvent;
(function(AWSPinpointMessageEvent2) {
  AWSPinpointMessageEvent2["MESSAGE_DISPLAYED"] = "_inapp.message_displayed";
  AWSPinpointMessageEvent2["MESSAGE_DISMISSED"] = "_inapp.message_dismissed";
  AWSPinpointMessageEvent2["MESSAGE_ACTION_TAKEN"] = "_inapp.message_clicked";
})(AWSPinpointMessageEvent || (AWSPinpointMessageEvent = {}));

// node_modules/@aws-amplify/notifications/lib-esm/InAppMessaging/Providers/AWSPinpointProvider/utils.js
var import_isEmpty3 = __toESM(require_isEmpty());
var DELIVERY_TYPE = "IN_APP_MESSAGE";
var eventNameMemo = {};
var eventAttributesMemo = {};
var eventMetricsMemo = {};
var logger57 = new ConsoleLogger("InAppMessaging.AWSPinpointProvider");
var dispatchInAppMessagingEvent = function(event, data, message) {
  Hub.dispatch("inAppMessaging", { event, data, message }, "InAppMessaging", AMPLIFY_SYMBOL9);
};
var recordAnalyticsEvent = function(event, message) {
  if (Amplify.Analytics && typeof Amplify.Analytics.record === "function") {
    var id = message.id, metadata = message.metadata;
    Amplify.Analytics.record({
      name: event,
      attributes: {
        campaign_id: id,
        delivery_type: DELIVERY_TYPE,
        treatment_id: metadata === null || metadata === void 0 ? void 0 : metadata.treatmentId
      }
    });
  } else {
    logger57.debug("Analytics module is not registered into Amplify");
  }
};
var getStartOfDay = function() {
  var now = /* @__PURE__ */ new Date();
  now.setHours(0, 0, 0, 0);
  return now.toISOString();
};
var matchesEventType = function(_a2, _b2) {
  var CampaignId = _a2.CampaignId, Schedule = _a2.Schedule;
  var eventType = _b2.name;
  var _c;
  var EventType = ((_c = Schedule === null || Schedule === void 0 ? void 0 : Schedule.EventFilter) === null || _c === void 0 ? void 0 : _c.Dimensions).EventType;
  var memoKey = CampaignId + ":" + eventType;
  if (!eventNameMemo.hasOwnProperty(memoKey)) {
    eventNameMemo[memoKey] = !!(EventType === null || EventType === void 0 ? void 0 : EventType.Values.includes(eventType));
  }
  return eventNameMemo[memoKey];
};
var matchesAttributes = function(_a2, _b2) {
  var CampaignId = _a2.CampaignId, Schedule = _a2.Schedule;
  var attributes = _b2.attributes;
  var _c;
  var Attributes = ((_c = Schedule === null || Schedule === void 0 ? void 0 : Schedule.EventFilter) === null || _c === void 0 ? void 0 : _c.Dimensions).Attributes;
  if ((0, import_isEmpty3.default)(Attributes)) {
    return true;
  }
  if ((0, import_isEmpty3.default)(attributes)) {
    return false;
  }
  var memoKey = CampaignId + ":" + JSON.stringify(attributes);
  if (!eventAttributesMemo.hasOwnProperty(memoKey)) {
    eventAttributesMemo[memoKey] = Object.entries(Attributes).every(function(_a3) {
      var _b3 = __read10(_a3, 2), key = _b3[0], Values = _b3[1].Values;
      return Values.includes(attributes[key]);
    });
  }
  return eventAttributesMemo[memoKey];
};
var matchesMetrics = function(_a2, _b2) {
  var CampaignId = _a2.CampaignId, Schedule = _a2.Schedule;
  var metrics = _b2.metrics;
  var _c;
  var Metrics2 = ((_c = Schedule === null || Schedule === void 0 ? void 0 : Schedule.EventFilter) === null || _c === void 0 ? void 0 : _c.Dimensions).Metrics;
  if ((0, import_isEmpty3.default)(Metrics2)) {
    return true;
  }
  if ((0, import_isEmpty3.default)(metrics)) {
    return false;
  }
  var memoKey = CampaignId + ":" + JSON.stringify(metrics);
  if (!eventMetricsMemo.hasOwnProperty(memoKey)) {
    eventMetricsMemo[memoKey] = Object.entries(Metrics2).every(function(_a3) {
      var _b3 = __read10(_a3, 2), key = _b3[0], _c2 = _b3[1], ComparisonOperator = _c2.ComparisonOperator, Value = _c2.Value;
      var compare = getComparator(ComparisonOperator);
      return compare ? compare(Value, metrics[key]) : false;
    });
  }
  return eventMetricsMemo[memoKey];
};
var getComparator = function(operator) {
  switch (operator) {
    case "EQUAL":
      return function(metricsVal, eventVal) {
        return metricsVal === eventVal;
      };
    case "GREATER_THAN":
      return function(metricsVal, eventVal) {
        return metricsVal < eventVal;
      };
    case "GREATER_THAN_OR_EQUAL":
      return function(metricsVal, eventVal) {
        return metricsVal <= eventVal;
      };
    case "LESS_THAN":
      return function(metricsVal, eventVal) {
        return metricsVal > eventVal;
      };
    case "LESS_THAN_OR_EQUAL":
      return function(metricsVal, eventVal) {
        return metricsVal >= eventVal;
      };
    default:
      return null;
  }
};
var isBeforeEndDate = function(_a2) {
  var Schedule = _a2.Schedule;
  if (!(Schedule === null || Schedule === void 0 ? void 0 : Schedule.EndDate)) {
    return true;
  }
  return /* @__PURE__ */ new Date() < new Date(Schedule.EndDate);
};
var clearMemo = function() {
  eventNameMemo = {};
  eventAttributesMemo = {};
  eventMetricsMemo = {};
};
var interpretLayout = function(layout) {
  if (layout === "MOBILE_FEED") {
    return "MODAL";
  }
  if (layout === "OVERLAYS") {
    return "FULL_SCREEN";
  }
  return layout;
};
var extractContent = function(_a2) {
  var message = _a2.InAppMessage;
  var _b2, _c;
  return (_c = (_b2 = message === null || message === void 0 ? void 0 : message.Content) === null || _b2 === void 0 ? void 0 : _b2.map(function(content) {
    var BackgroundColor = content.BackgroundColor, BodyConfig = content.BodyConfig, HeaderConfig = content.HeaderConfig, ImageUrl = content.ImageUrl, PrimaryBtn = content.PrimaryBtn, SecondaryBtn = content.SecondaryBtn;
    var defaultPrimaryButton = PrimaryBtn === null || PrimaryBtn === void 0 ? void 0 : PrimaryBtn.DefaultConfig;
    var defaultSecondaryButton = SecondaryBtn === null || SecondaryBtn === void 0 ? void 0 : SecondaryBtn.DefaultConfig;
    var extractedContent = {};
    if (BackgroundColor) {
      extractedContent.container = {
        style: {
          backgroundColor: BackgroundColor
        }
      };
    }
    if (HeaderConfig) {
      extractedContent.header = {
        content: HeaderConfig.Header,
        style: {
          color: HeaderConfig.TextColor,
          textAlign: HeaderConfig.Alignment.toLowerCase()
        }
      };
    }
    if (BodyConfig) {
      extractedContent.body = {
        content: BodyConfig.Body,
        style: {
          color: BodyConfig.TextColor,
          textAlign: BodyConfig.Alignment.toLowerCase()
        }
      };
    }
    if (ImageUrl) {
      extractedContent.image = {
        src: ImageUrl
      };
    }
    if (defaultPrimaryButton) {
      extractedContent.primaryButton = {
        title: defaultPrimaryButton.Text,
        action: defaultPrimaryButton.ButtonAction,
        url: defaultPrimaryButton.Link,
        style: {
          backgroundColor: defaultPrimaryButton.BackgroundColor,
          borderRadius: defaultPrimaryButton.BorderRadius,
          color: defaultPrimaryButton.TextColor
        }
      };
    }
    if (defaultSecondaryButton) {
      extractedContent.secondaryButton = {
        title: defaultSecondaryButton.Text,
        action: defaultSecondaryButton.ButtonAction,
        url: defaultSecondaryButton.Link,
        style: {
          backgroundColor: defaultSecondaryButton.BackgroundColor,
          borderRadius: defaultSecondaryButton.BorderRadius,
          color: defaultSecondaryButton.TextColor
        }
      };
    }
    return extractedContent;
  })) !== null && _c !== void 0 ? _c : [];
};
var extractMetadata = function(_a2) {
  var InAppMessage = _a2.InAppMessage, Priority = _a2.Priority, Schedule = _a2.Schedule, TreatmentId = _a2.TreatmentId;
  return {
    customData: InAppMessage === null || InAppMessage === void 0 ? void 0 : InAppMessage.CustomConfig,
    endDate: Schedule === null || Schedule === void 0 ? void 0 : Schedule.EndDate,
    priority: Priority,
    treatmentId: TreatmentId
  };
};

// node_modules/@aws-amplify/notifications/lib-esm/InAppMessaging/Providers/AWSPinpointProvider/index.js
var MESSAGE_DAILY_COUNT_KEY = "pinpointProvider_inAppMessages_dailyCount";
var MESSAGE_TOTAL_COUNT_KEY = "pinpointProvider_inAppMessages_totalCount";
var AWSPinpointProvider2 = (
  /** @class */
  function(_super) {
    __extends3(AWSPinpointProvider3, _super);
    function AWSPinpointProvider3() {
      var _this = _super.call(this, logger57) || this;
      _this.configured = false;
      _this.configure = function(config) {
        if (config === void 0) {
          config = {};
        }
        _this.config = __assign7(__assign7({}, _super.prototype.configure.call(_this, config)), { endpointInfo: { channelType: "IN_APP" } });
        if (!_this.configured) {
          _this.sessionTracker = new SessionTracker_default2(_this.sessionStateChangeHandler);
          _this.sessionTracker.start();
          addEventListener(InAppMessageInteractionEvent.MESSAGE_DISPLAYED, function(message) {
            _this.recordMessageEvent(message, AWSPinpointMessageEvent.MESSAGE_DISPLAYED);
          });
          addEventListener(InAppMessageInteractionEvent.MESSAGE_DISMISSED, function(message) {
            _this.recordMessageEvent(message, AWSPinpointMessageEvent.MESSAGE_DISMISSED);
          });
          addEventListener(InAppMessageInteractionEvent.MESSAGE_ACTION_TAKEN, function(message) {
            _this.recordMessageEvent(message, AWSPinpointMessageEvent.MESSAGE_ACTION_TAKEN);
          });
        }
        _this.configured = true;
        dispatchInAppMessagingEvent("pinpointProvider_configured", null);
        return _this.config;
      };
      _this.getInAppMessages = function() {
        return __awaiter3(_this, void 0, void 0, function() {
          var _a2, appId, credentials, endpointId, region, input, response, messages, err_1;
          return __generator3(this, function(_b2) {
            switch (_b2.label) {
              case 0:
                if (!!this.initialized)
                  return [3, 2];
                return [4, this.init()];
              case 1:
                _b2.sent();
                _b2.label = 2;
              case 2:
                clearMemo();
                _b2.label = 3;
              case 3:
                _b2.trys.push([3, 6, , 7]);
                return [4, this.updateEndpoint()];
              case 4:
                _b2.sent();
                _a2 = this.config, appId = _a2.appId, credentials = _a2.credentials, endpointId = _a2.endpointId, region = _a2.region;
                input = {
                  ApplicationId: appId,
                  EndpointId: endpointId
                };
                this.logger.debug("getting in-app messages");
                return [4, getInAppMessages({ credentials, region }, input)];
              case 5:
                response = _b2.sent();
                messages = response.InAppMessagesResponse.InAppMessageCampaigns;
                dispatchInAppMessagingEvent("getInAppMessages", messages);
                return [2, messages];
              case 6:
                err_1 = _b2.sent();
                this.logger.error("Error getting in-app messages", err_1);
                throw err_1;
              case 7:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      _this.processInAppMessages = function(messages, event) {
        return __awaiter3(_this, void 0, void 0, function() {
          var highestPrioritySeen;
          var _this2 = this;
          return __generator3(this, function(_a2) {
            switch (_a2.label) {
              case 0:
                if (!!this.initialized)
                  return [3, 2];
                return [4, this.init()];
              case 1:
                _a2.sent();
                _a2.label = 2;
              case 2:
                return [2, this.normalizeMessages(messages.reduce(function(acc, message) {
                  var messageQualifies = matchesEventType(message, event) && matchesAttributes(message, event) && matchesMetrics(message, event) && isBeforeEndDate(message) && _this2.isBelowCap(message);
                  if (messageQualifies) {
                    if (!highestPrioritySeen) {
                      if (message.Priority) {
                        highestPrioritySeen = message.Priority;
                        return [message];
                      } else {
                        acc.push(message);
                      }
                    } else if (message.Priority) {
                      if (message.Priority < highestPrioritySeen) {
                        highestPrioritySeen = message.Priority;
                        return [message];
                      } else if (message.Priority === highestPrioritySeen) {
                        acc.push(message);
                      }
                    }
                  }
                  return acc;
                }, []))];
            }
          });
        });
      };
      _this.sessionStateChangeHandler = function(state) {
        if (state === "started") {
          _this.sessionMessageCountMap = {};
        }
      };
      _this.isBelowCap = function(_a2) {
        var CampaignId = _a2.CampaignId, SessionCap = _a2.SessionCap, DailyCap = _a2.DailyCap, TotalCap = _a2.TotalCap;
        var _b2 = _this.getMessageCounts(CampaignId), sessionCount = _b2.sessionCount, dailyCount = _b2.dailyCount, totalCount = _b2.totalCount;
        return (!SessionCap || sessionCount < SessionCap) && (!DailyCap || dailyCount < DailyCap) && (!TotalCap || totalCount < TotalCap);
      };
      _this.getSessionCount = function(messageId) {
        return _this.sessionMessageCountMap[messageId] || 0;
      };
      _this.getDailyCount = function() {
        var storage = _this.config.storage;
        var today = getStartOfDay();
        var item = storage.getItem(MESSAGE_DAILY_COUNT_KEY);
        var counter = item ? JSON.parse(item) : { count: 0, lastCountTimestamp: today };
        return counter.lastCountTimestamp === today ? counter.count : 0;
      };
      _this.getTotalCountMap = function() {
        var storage = _this.config.storage;
        var item = storage.getItem(MESSAGE_TOTAL_COUNT_KEY);
        return item ? JSON.parse(item) : {};
      };
      _this.getTotalCount = function(messageId) {
        var countMap = _this.getTotalCountMap();
        return countMap[messageId] || 0;
      };
      _this.getMessageCounts = function(messageId) {
        try {
          return {
            sessionCount: _this.getSessionCount(messageId),
            dailyCount: _this.getDailyCount(),
            totalCount: _this.getTotalCount(messageId)
          };
        } catch (err) {
          _this.logger.error("Failed to get message counts from storage", err);
        }
      };
      _this.setSessionCount = function(messageId, count) {
        _this.sessionMessageCountMap[messageId] = count;
      };
      _this.setDailyCount = function(count) {
        var storage = _this.config.storage;
        var dailyCount = {
          count,
          lastCountTimestamp: getStartOfDay()
        };
        try {
          storage.setItem(MESSAGE_DAILY_COUNT_KEY, JSON.stringify(dailyCount));
        } catch (err) {
          _this.logger.error("Failed to save daily message count to storage", err);
        }
      };
      _this.setTotalCountMap = function(countMap) {
        var storage = _this.config.storage;
        try {
          storage.setItem(MESSAGE_TOTAL_COUNT_KEY, JSON.stringify(countMap));
        } catch (err) {
          _this.logger.error("Failed to save total count to storage", err);
        }
      };
      _this.setTotalCount = function(messageId, count) {
        var _a2;
        var updatedMap = __assign7(__assign7({}, _this.getTotalCountMap()), (_a2 = {}, _a2[messageId] = count, _a2));
        _this.setTotalCountMap(updatedMap);
      };
      _this.incrementCounts = function(messageId) {
        return __awaiter3(_this, void 0, void 0, function() {
          var _a2, sessionCount, dailyCount, totalCount;
          return __generator3(this, function(_b2) {
            _a2 = this.getMessageCounts(messageId), sessionCount = _a2.sessionCount, dailyCount = _a2.dailyCount, totalCount = _a2.totalCount;
            this.setSessionCount(messageId, sessionCount + 1);
            this.setDailyCount(dailyCount + 1);
            this.setTotalCount(messageId, totalCount + 1);
            return [
              2
              /*return*/
            ];
          });
        });
      };
      _this.normalizeMessages = function(messages) {
        return messages.map(function(message) {
          var CampaignId = message.CampaignId, InAppMessage = message.InAppMessage;
          return {
            id: CampaignId,
            content: extractContent(message),
            layout: interpretLayout(InAppMessage.Layout),
            metadata: extractMetadata(message)
          };
        });
      };
      _this.recordMessageEvent = function(message, event) {
        return __awaiter3(_this, void 0, void 0, function() {
          return __generator3(this, function(_a2) {
            switch (_a2.label) {
              case 0:
                if (!!this.initialized)
                  return [3, 2];
                return [4, this.init()];
              case 1:
                _a2.sent();
                _a2.label = 2;
              case 2:
                recordAnalyticsEvent(event, message);
                if (!(event === AWSPinpointMessageEvent.MESSAGE_DISPLAYED))
                  return [3, 4];
                return [4, this.incrementCounts(message.id)];
              case 3:
                _a2.sent();
                _a2.label = 4;
              case 4:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      _this.sessionMessageCountMap = {};
      return _this;
    }
    AWSPinpointProvider3.prototype.getSubCategory = function() {
      return AWSPinpointProvider3.subCategory;
    };
    AWSPinpointProvider3.subCategory = "InAppMessaging";
    return AWSPinpointProvider3;
  }(AWSPinpointProviderCommon_default)
);
var AWSPinpointProvider_default = AWSPinpointProvider2;

// node_modules/@aws-amplify/notifications/lib-esm/InAppMessaging/InAppMessaging.js
var STORAGE_KEY_SUFFIX = "_inAppMessages";
var logger58 = new ConsoleLogger("Notifications.InAppMessaging");
var InAppMessaging = (
  /** @class */
  function() {
    function InAppMessaging2() {
      var _this = this;
      this.config = {};
      this.listeningForAnalyticEvents = false;
      this.pluggables = [];
      this.storageSynced = false;
      this.configure = function(_a2) {
        if (_a2 === void 0) {
          _a2 = {};
        }
        var _b2 = _a2.listenForAnalyticsEvents, listenForAnalyticsEvents = _b2 === void 0 ? true : _b2, config = __rest2(_a2, ["listenForAnalyticsEvents"]);
        _this.config = __assign7(__assign7({}, _this.config), config);
        logger58.debug("configure InAppMessaging", _this.config);
        _this.pluggables.forEach(function(pluggable) {
          pluggable.configure(_this.config[pluggable.getProviderName()]);
        });
        if (_this.pluggables.length === 0) {
          _this.addPluggable(new AWSPinpointProvider_default());
        }
        if (listenForAnalyticsEvents && !_this.listeningForAnalyticEvents) {
          Hub.listen("analytics", _this.analyticsListener);
          _this.listeningForAnalyticEvents = true;
        }
        return _this.config;
      };
      this.getPluggable = function(providerName) {
        var _a2;
        var pluggable = (_a2 = _this.pluggables.find(function(pluggable2) {
          return pluggable2.getProviderName() === providerName;
        })) !== null && _a2 !== void 0 ? _a2 : null;
        if (!pluggable) {
          logger58.debug("No plugin found with name " + providerName);
        }
        return pluggable;
      };
      this.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategory() === "Notifications" && pluggable.getSubCategory() === "InAppMessaging") {
          if (_this.getPluggable(pluggable.getProviderName())) {
            throw new Error("Pluggable " + pluggable.getProviderName() + " has already been added.");
          }
          _this.pluggables.push(pluggable);
          pluggable.configure(_this.config[pluggable.getProviderName()]);
        }
      };
      this.removePluggable = function(providerName) {
        var index = _this.pluggables.findIndex(function(pluggable) {
          return pluggable.getProviderName() === providerName;
        });
        if (index === -1) {
          logger58.debug("No plugin found with name " + providerName);
        } else {
          _this.pluggables.splice(index, 1);
        }
      };
      this.syncMessages = function() {
        return Promise.all(_this.pluggables.map(function(pluggable) {
          return __awaiter3(_this, void 0, void 0, function() {
            var messages, key, err_1;
            return __generator3(this, function(_a2) {
              switch (_a2.label) {
                case 0:
                  _a2.trys.push([0, 3, , 4]);
                  return [4, pluggable.getInAppMessages()];
                case 1:
                  messages = _a2.sent();
                  key = "" + pluggable.getProviderName() + STORAGE_KEY_SUFFIX;
                  return [4, this.setMessages(key, messages)];
                case 2:
                  _a2.sent();
                  return [3, 4];
                case 3:
                  err_1 = _a2.sent();
                  logger58.error("Failed to sync messages", err_1);
                  throw err_1;
                case 4:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }));
      };
      this.clearMessages = function() {
        return Promise.all(_this.pluggables.map(function(pluggable) {
          return __awaiter3(_this, void 0, void 0, function() {
            var key;
            return __generator3(this, function(_a2) {
              switch (_a2.label) {
                case 0:
                  key = "" + pluggable.getProviderName() + STORAGE_KEY_SUFFIX;
                  return [4, this.removeMessages(key)];
                case 1:
                  _a2.sent();
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }));
      };
      this.dispatchEvent = function(event) {
        return __awaiter3(_this, void 0, void 0, function() {
          var messages, flattenedMessages;
          var _this2 = this;
          return __generator3(this, function(_a2) {
            switch (_a2.label) {
              case 0:
                return [4, Promise.all(this.pluggables.map(function(pluggable) {
                  return __awaiter3(_this2, void 0, void 0, function() {
                    var key, messages2;
                    return __generator3(this, function(_a3) {
                      switch (_a3.label) {
                        case 0:
                          key = "" + pluggable.getProviderName() + STORAGE_KEY_SUFFIX;
                          return [4, this.getMessages(key)];
                        case 1:
                          messages2 = _a3.sent();
                          return [2, pluggable.processInAppMessages(messages2, event)];
                      }
                    });
                  });
                }))];
              case 1:
                messages = _a2.sent();
                flattenedMessages = (0, import_flatten.default)(messages);
                if (flattenedMessages.length) {
                  notifyEventListeners(InAppMessageInteractionEvent.MESSAGE_RECEIVED, this.conflictHandler(flattenedMessages));
                }
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      this.identifyUser = function(userId, userInfo) {
        return Promise.all(_this.pluggables.map(function(pluggable) {
          return __awaiter3(_this, void 0, void 0, function() {
            var err_2;
            return __generator3(this, function(_a2) {
              switch (_a2.label) {
                case 0:
                  _a2.trys.push([0, 2, , 3]);
                  return [4, pluggable.identifyUser(userId, userInfo)];
                case 1:
                  _a2.sent();
                  return [3, 3];
                case 2:
                  err_2 = _a2.sent();
                  logger58.error("Failed to identify user", err_2);
                  throw err_2;
                case 3:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }));
      };
      this.onMessageReceived = function(handler) {
        return addEventListener(InAppMessageInteractionEvent.MESSAGE_RECEIVED, handler);
      };
      this.onMessageDisplayed = function(handler) {
        return addEventListener(InAppMessageInteractionEvent.MESSAGE_DISPLAYED, handler);
      };
      this.onMessageDismissed = function(handler) {
        return addEventListener(InAppMessageInteractionEvent.MESSAGE_DISMISSED, handler);
      };
      this.onMessageActionTaken = function(handler) {
        return addEventListener(InAppMessageInteractionEvent.MESSAGE_ACTION_TAKEN, handler);
      };
      this.notifyMessageInteraction = function(message, type) {
        notifyEventListeners(type, message);
      };
      this.setConflictHandler = function(handler) {
        _this.conflictHandler = handler;
      };
      this.analyticsListener = function(_a2) {
        var payload = _a2.payload;
        var event = payload.event, data = payload.data;
        switch (event) {
          case "record": {
            _this.dispatchEvent(data);
            break;
          }
          default:
            break;
        }
      };
      this.syncStorage = function() {
        return __awaiter3(_this, void 0, void 0, function() {
          var storage, err_3;
          return __generator3(this, function(_a2) {
            switch (_a2.label) {
              case 0:
                storage = this.config.storage;
                _a2.label = 1;
              case 1:
                _a2.trys.push([1, 4, , 5]);
                if (!(typeof storage.sync === "function"))
                  return [3, 3];
                return [4, storage.sync()];
              case 2:
                _a2.sent();
                _a2.label = 3;
              case 3:
                this.storageSynced = true;
                return [3, 5];
              case 4:
                err_3 = _a2.sent();
                logger58.error("Failed to sync storage", err_3);
                return [3, 5];
              case 5:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      this.getMessages = function(key) {
        return __awaiter3(_this, void 0, void 0, function() {
          var storage, storedMessages, err_4;
          return __generator3(this, function(_a2) {
            switch (_a2.label) {
              case 0:
                _a2.trys.push([0, 3, , 4]);
                if (!!this.storageSynced)
                  return [3, 2];
                return [4, this.syncStorage()];
              case 1:
                _a2.sent();
                _a2.label = 2;
              case 2:
                storage = this.config.storage;
                storedMessages = storage.getItem(key);
                return [2, storedMessages ? JSON.parse(storedMessages) : []];
              case 3:
                err_4 = _a2.sent();
                logger58.error("Failed to retrieve in-app messages from storage", err_4);
                return [3, 4];
              case 4:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      this.setMessages = function(key, messages) {
        return __awaiter3(_this, void 0, void 0, function() {
          var storage, err_5;
          return __generator3(this, function(_a2) {
            switch (_a2.label) {
              case 0:
                if (!messages) {
                  return [
                    2
                    /*return*/
                  ];
                }
                _a2.label = 1;
              case 1:
                _a2.trys.push([1, 4, , 5]);
                if (!!this.storageSynced)
                  return [3, 3];
                return [4, this.syncStorage()];
              case 2:
                _a2.sent();
                _a2.label = 3;
              case 3:
                storage = this.config.storage;
                storage.setItem(key, JSON.stringify(messages));
                return [3, 5];
              case 4:
                err_5 = _a2.sent();
                logger58.error("Failed to store in-app messages", err_5);
                return [3, 5];
              case 5:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      this.removeMessages = function(key) {
        return __awaiter3(_this, void 0, void 0, function() {
          var storage, err_6;
          return __generator3(this, function(_a2) {
            switch (_a2.label) {
              case 0:
                _a2.trys.push([0, 3, , 4]);
                if (!!this.storageSynced)
                  return [3, 2];
                return [4, this.syncStorage()];
              case 1:
                _a2.sent();
                _a2.label = 2;
              case 2:
                storage = this.config.storage;
                storage.removeItem(key);
                return [3, 4];
              case 3:
                err_6 = _a2.sent();
                logger58.error("Failed to remove in-app messages from storage", err_6);
                return [3, 4];
              case 4:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      };
      this.defaultConflictHandler = function(messages) {
        var sorted = messages.sort(function(a2, b2) {
          var _a2, _b2;
          var endDateA = (_a2 = a2.metadata) === null || _a2 === void 0 ? void 0 : _a2.endDate;
          var endDateB = (_b2 = b2.metadata) === null || _b2 === void 0 ? void 0 : _b2.endDate;
          if (endDateA === endDateB) {
            return 0;
          }
          if (endDateA && !endDateB) {
            return -1;
          }
          if (!endDateA && endDateB) {
            return 1;
          }
          return new Date(endDateA) < new Date(endDateB) ? -1 : 1;
        });
        return sorted[0];
      };
      this.config = { storage: new StorageHelper().getStorage() };
      this.setConflictHandler(this.defaultConflictHandler);
    }
    InAppMessaging2.prototype.getModuleName = function() {
      return "InAppMessaging";
    };
    return InAppMessaging2;
  }()
);
var InAppMessaging_default = InAppMessaging;

// node_modules/@aws-amplify/notifications/lib-esm/PushNotification/PlatformNotSupportedError.js
var PlatformNotSupportedError = (
  /** @class */
  function(_super) {
    __extends3(PlatformNotSupportedError2, _super);
    function PlatformNotSupportedError2() {
      var _this = _super.call(this, "Function not supported on current platform") || this;
      _this.name = "PlatformNotSupportedError";
      return _this;
    }
    return PlatformNotSupportedError2;
  }(Error)
);
var PlatformNotSupportedError_default = PlatformNotSupportedError;

// node_modules/@aws-amplify/notifications/lib-esm/PushNotification/PushNotification.js
var PushNotification = (
  /** @class */
  function() {
    function PushNotification2() {
      var _this = this;
      this.configure = function(_2) {
        if (_2 === void 0) {
          _2 = {};
        }
        throw new PlatformNotSupportedError_default();
      };
      this.getPluggable = function(_2) {
        throw new PlatformNotSupportedError_default();
      };
      this.addPluggable = function(_2) {
        throw new PlatformNotSupportedError_default();
      };
      this.removePluggable = function() {
        throw new PlatformNotSupportedError_default();
      };
      this.enable = function() {
        throw new PlatformNotSupportedError_default();
      };
      this.identifyUser = function() {
        throw new PlatformNotSupportedError_default();
      };
      this.getLaunchNotification = function() {
        return __awaiter3(_this, void 0, void 0, function() {
          return __generator3(this, function(_a2) {
            throw new PlatformNotSupportedError_default();
          });
        });
      };
      this.getBadgeCount = function() {
        return __awaiter3(_this, void 0, void 0, function() {
          return __generator3(this, function(_a2) {
            throw new PlatformNotSupportedError_default();
          });
        });
      };
      this.setBadgeCount = function(_2) {
        throw new PlatformNotSupportedError_default();
      };
      this.getPermissionStatus = function() {
        return __awaiter3(_this, void 0, void 0, function() {
          return __generator3(this, function(_a2) {
            throw new PlatformNotSupportedError_default();
          });
        });
      };
      this.requestPermissions = function(_2) {
        return __awaiter3(_this, void 0, void 0, function() {
          return __generator3(this, function(_a2) {
            throw new PlatformNotSupportedError_default();
          });
        });
      };
      this.onNotificationReceivedInBackground = function(_2) {
        throw new PlatformNotSupportedError_default();
      };
      this.onNotificationReceivedInForeground = function(_2) {
        throw new PlatformNotSupportedError_default();
      };
      this.onTokenReceived = function(_2) {
        throw new PlatformNotSupportedError_default();
      };
      this.onNotificationOpened = function(_2) {
        throw new PlatformNotSupportedError_default();
      };
    }
    PushNotification2.prototype.getModuleName = function() {
      throw new PlatformNotSupportedError_default();
    };
    return PushNotification2;
  }()
);
var PushNotification_default = PushNotification;

// node_modules/@aws-amplify/notifications/lib-esm/Notifications.js
var logger59 = new ConsoleLogger("Notifications");
var NotificationsClass = (
  /** @class */
  function() {
    function NotificationsClass2() {
      var _this = this;
      this.config = {};
      this.configure = function(_a2) {
        var config = (_a2 === void 0 ? {} : _a2).Notifications;
        _this.config = __assign7(__assign7({}, _this.config), config);
        logger59.debug("configure Notifications", config);
        _this.inAppMessaging.configure(_this.config.InAppMessaging);
        if (_this.config.Push) {
          try {
            if (!_this.pushNotification) {
              _this.pushNotification = new PushNotification_default();
            }
            _this.pushNotification.configure(_this.config.Push);
          } catch (err) {
            logger59.error(err);
          }
        }
        return _this.config;
      };
      this.identifyUser = function(userId, userInfo) {
        var identifyFunctions = [];
        if (_this.inAppMessaging) {
          identifyFunctions.push(_this.inAppMessaging.identifyUser);
        }
        if (_this.pushNotification) {
          identifyFunctions.push(_this.pushNotification.identifyUser);
        }
        return Promise.all(identifyFunctions.map(function(identifyFunction) {
          return __awaiter3(_this, void 0, void 0, function() {
            var err_1;
            return __generator3(this, function(_a2) {
              switch (_a2.label) {
                case 0:
                  _a2.trys.push([0, 2, , 3]);
                  return [4, identifyFunction(userId, userInfo)];
                case 1:
                  _a2.sent();
                  return [3, 3];
                case 2:
                  err_1 = _a2.sent();
                  logger59.error("Failed to identify user", err_1);
                  throw err_1;
                case 3:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }));
      };
      this.inAppMessaging = new InAppMessaging_default();
    }
    NotificationsClass2.prototype.getModuleName = function() {
      return "Notifications";
    };
    Object.defineProperty(NotificationsClass2.prototype, "InAppMessaging", {
      get: function() {
        return this.inAppMessaging;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(NotificationsClass2.prototype, "Push", {
      get: function() {
        var _a2;
        return (_a2 = this.pushNotification) !== null && _a2 !== void 0 ? _a2 : {};
      },
      enumerable: true,
      configurable: true
    });
    return NotificationsClass2;
  }()
);
var Notifications = new NotificationsClass();
var Notifications_default = Notifications;
Amplify.register(Notifications);

// node_modules/@aws-amplify/predictions/node_modules/tslib/tslib.es6.js
var __assign45 = function() {
  __assign45 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign45.apply(this, arguments);
};
function __read36(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}
function __spread14() {
  for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
    ar = ar.concat(__read36(arguments[i2]));
  return ar;
}

// node_modules/@aws-amplify/predictions/lib-esm/Predictions.js
var logger60 = new ConsoleLogger("Predictions");
var PredictionsClass = (
  /** @class */
  function() {
    function PredictionsClass2(options) {
      this._options = options;
      this._convertPluggables = [];
      this._identifyPluggables = [];
      this._interpretPluggables = [];
    }
    PredictionsClass2.prototype.getModuleName = function() {
      return "Predictions";
    };
    PredictionsClass2.prototype.addPluggable = function(pluggable) {
      if (this.getPluggable(pluggable.getProviderName())) {
        throw new Error("Pluggable with name " + pluggable.getProviderName() + " has already been added.");
      }
      var pluggableAdded = false;
      if (this.implementsConvertPluggable(pluggable)) {
        this._convertPluggables.push(pluggable);
        pluggableAdded = true;
      }
      if (this.implementsIdentifyPluggable(pluggable)) {
        this._identifyPluggables.push(pluggable);
        pluggableAdded = true;
      }
      if (this.implementsInterpretPluggable(pluggable)) {
        this._interpretPluggables.push(pluggable);
        pluggableAdded = true;
      }
      if (pluggableAdded) {
        this.configurePluggable(pluggable);
      }
    };
    PredictionsClass2.prototype.getPluggable = function(providerName) {
      var pluggable = this.getAllProviders().find(function(pluggable2) {
        return pluggable2.getProviderName() === providerName;
      });
      if (pluggable === void 0) {
        logger60.debug("No plugin found with providerName=>", providerName);
        return null;
      } else
        return pluggable;
    };
    PredictionsClass2.prototype.removePluggable = function(providerName) {
      this._convertPluggables = this._convertPluggables.filter(function(pluggable) {
        return pluggable.getProviderName() !== providerName;
      });
      this._identifyPluggables = this._identifyPluggables.filter(function(pluggable) {
        return pluggable.getProviderName() !== providerName;
      });
      this._interpretPluggables = this._interpretPluggables.filter(function(pluggable) {
        return pluggable.getProviderName() !== providerName;
      });
      return;
    };
    PredictionsClass2.prototype.configure = function(options) {
      var _this = this;
      var predictionsConfig = options ? options.predictions || options : {};
      predictionsConfig = __assign45(__assign45({}, predictionsConfig), options);
      this._options = Object.assign({}, this._options, predictionsConfig);
      logger60.debug("configure Predictions", this._options);
      this.getAllProviders().forEach(function(pluggable) {
        return _this.configurePluggable(pluggable);
      });
    };
    PredictionsClass2.prototype.interpret = function(input, options) {
      var pluggableToExecute = this.getPluggableToExecute(this._interpretPluggables, options);
      return pluggableToExecute.interpret(input);
    };
    PredictionsClass2.prototype.convert = function(input, options) {
      var pluggableToExecute = this.getPluggableToExecute(this._convertPluggables, options);
      return pluggableToExecute.convert(input);
    };
    PredictionsClass2.prototype.identify = function(input, options) {
      var pluggableToExecute = this.getPluggableToExecute(this._identifyPluggables, options);
      return pluggableToExecute.identify(input);
    };
    PredictionsClass2.prototype.getPluggableToExecute = function(pluggables, providerOptions) {
      if (providerOptions && providerOptions.providerName) {
        return __spread14(pluggables).find(function(pluggable) {
          return pluggable.getProviderName() === providerOptions.providerName;
        });
      } else {
        if (pluggables.length === 1) {
          return pluggables[0];
        } else {
          throw new Error("More than one or no providers are configured, Either specify a provider name or configure exactly one provider");
        }
      }
    };
    PredictionsClass2.prototype.getAllProviders = function() {
      return __spread14(this._convertPluggables, this._identifyPluggables, this._interpretPluggables);
    };
    PredictionsClass2.prototype.configurePluggable = function(pluggable) {
      var categoryConfig = Object.assign(
        {},
        this._options["predictions"],
        // Parent predictions config for the top level provider
        this._options[pluggable.getCategory().toLowerCase()]
        // Actual category level config
      );
      pluggable.configure(categoryConfig);
    };
    PredictionsClass2.prototype.implementsConvertPluggable = function(obj) {
      return obj && typeof obj.convert === "function";
    };
    PredictionsClass2.prototype.implementsIdentifyPluggable = function(obj) {
      return obj && typeof obj.identify === "function";
    };
    PredictionsClass2.prototype.implementsInterpretPluggable = function(obj) {
      return obj && typeof obj.interpret === "function";
    };
    return PredictionsClass2;
  }()
);
var Predictions = new PredictionsClass({});
Amplify.register(Predictions);

// node_modules/aws-amplify/lib-esm/withSSRContext.js
var requiredModules = [
  // API cannot function without Auth
  Auth,
  // Auth cannot function without Credentials
  Credentials
];
var defaultModules = [API, Auth, instance];
function withSSRContext(context) {
  if (context === void 0) {
    context = {};
  }
  var _a2 = context.modules, modules = _a2 === void 0 ? defaultModules : _a2, req = context.req;
  if (modules.includes(instance)) {
    modules.push(InternalAPI);
  }
  var previousConfig = Amplify.configure();
  var amplify = new AmplifyClass();
  var storage = new UniversalStorage({ req });
  requiredModules.forEach(function(m2) {
    if (!modules.includes(m2)) {
      amplify.register(new m2.constructor());
    }
  });
  modules.forEach(function(m2) {
    amplify.register(new m2.constructor());
  });
  amplify.configure(__assign7(__assign7({}, previousConfig), { storage }));
  return amplify;
}

// node_modules/@aws-amplify/geo/node_modules/tslib/tslib.es6.js
var __assign46 = function() {
  __assign46 = Object.assign || function __assign47(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign46.apply(this, arguments);
};
function __awaiter69(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator70(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __read37(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}
function __spread15() {
  for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
    ar = ar.concat(__read37(arguments[i2]));
  return ar;
}

// node_modules/@aws-amplify/geo/lib-esm/Providers/AmazonLocationServiceProvider.js
var import_camelcase_keys = __toESM(require_camelcase_keys());

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-serde/dist-es/deserializerMiddleware.js
var deserializerMiddleware3 = function(options, deserializer) {
  return function(next, context) {
    return function(args) {
      return __awaiter3(void 0, void 0, void 0, function() {
        var response, parsed, error_1;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, next(args)];
            case 1:
              response = _a2.sent().response;
              _a2.label = 2;
            case 2:
              _a2.trys.push([2, 4, , 5]);
              return [4, deserializer(response, options)];
            case 3:
              parsed = _a2.sent();
              return [2, {
                response,
                output: parsed
              }];
            case 4:
              error_1 = _a2.sent();
              Object.defineProperty(error_1, "$response", {
                value: response
              });
              throw error_1;
            case 5:
              return [2];
          }
        });
      });
    };
  };
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-serde/dist-es/serializerMiddleware.js
var serializerMiddleware3 = function(options, serializer) {
  return function(next, context) {
    return function(args) {
      return __awaiter3(void 0, void 0, void 0, function() {
        var endpoint, request;
        var _a2;
        return __generator3(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              endpoint = ((_a2 = context.endpointV2) === null || _a2 === void 0 ? void 0 : _a2.url) && options.urlParser ? function() {
                return __awaiter3(void 0, void 0, void 0, function() {
                  return __generator3(this, function(_a3) {
                    return [2, options.urlParser(context.endpointV2.url)];
                  });
                });
              } : options.endpoint;
              if (!endpoint) {
                throw new Error("No valid endpoint provider available.");
              }
              return [4, serializer(args.input, __assign7(__assign7({}, options), { endpoint }))];
            case 1:
              request = _b2.sent();
              return [2, next(__assign7(__assign7({}, args), { request }))];
          }
        });
      });
    };
  };
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-serde/dist-es/serdePlugin.js
var deserializerMiddlewareOption3 = {
  name: "deserializerMiddleware",
  step: "deserialize",
  tags: ["DESERIALIZER"],
  override: true
};
var serializerMiddlewareOption3 = {
  name: "serializerMiddleware",
  step: "serialize",
  tags: ["SERIALIZER"],
  override: true
};
function getSerdePlugin3(config, serializer, deserializer) {
  return {
    applyToStack: function(commandStack) {
      commandStack.add(deserializerMiddleware3(config, deserializer), deserializerMiddlewareOption3);
      commandStack.add(serializerMiddleware3(config, serializer), serializerMiddlewareOption3);
    }
  };
}

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-stack/dist-es/MiddlewareStack.js
var constructStack3 = function() {
  var absoluteEntries = [];
  var relativeEntries = [];
  var entriesNameSet = /* @__PURE__ */ new Set();
  var sort = function(entries) {
    return entries.sort(function(a2, b2) {
      return stepWeights3[b2.step] - stepWeights3[a2.step] || priorityWeights3[b2.priority || "normal"] - priorityWeights3[a2.priority || "normal"];
    });
  };
  var removeByName = function(toRemove) {
    var isRemoved = false;
    var filterCb = function(entry) {
      if (entry.name && entry.name === toRemove) {
        isRemoved = true;
        entriesNameSet.delete(toRemove);
        return false;
      }
      return true;
    };
    absoluteEntries = absoluteEntries.filter(filterCb);
    relativeEntries = relativeEntries.filter(filterCb);
    return isRemoved;
  };
  var removeByReference = function(toRemove) {
    var isRemoved = false;
    var filterCb = function(entry) {
      if (entry.middleware === toRemove) {
        isRemoved = true;
        if (entry.name)
          entriesNameSet.delete(entry.name);
        return false;
      }
      return true;
    };
    absoluteEntries = absoluteEntries.filter(filterCb);
    relativeEntries = relativeEntries.filter(filterCb);
    return isRemoved;
  };
  var cloneTo = function(toStack) {
    absoluteEntries.forEach(function(entry) {
      toStack.add(entry.middleware, __assign7({}, entry));
    });
    relativeEntries.forEach(function(entry) {
      toStack.addRelativeTo(entry.middleware, __assign7({}, entry));
    });
    return toStack;
  };
  var expandRelativeMiddlewareList = function(from) {
    var expandedMiddlewareList = [];
    from.before.forEach(function(entry) {
      if (entry.before.length === 0 && entry.after.length === 0) {
        expandedMiddlewareList.push(entry);
      } else {
        expandedMiddlewareList.push.apply(expandedMiddlewareList, __spreadArray4([], __read10(expandRelativeMiddlewareList(entry)), false));
      }
    });
    expandedMiddlewareList.push(from);
    from.after.reverse().forEach(function(entry) {
      if (entry.before.length === 0 && entry.after.length === 0) {
        expandedMiddlewareList.push(entry);
      } else {
        expandedMiddlewareList.push.apply(expandedMiddlewareList, __spreadArray4([], __read10(expandRelativeMiddlewareList(entry)), false));
      }
    });
    return expandedMiddlewareList;
  };
  var getMiddlewareList = function(debug2) {
    if (debug2 === void 0) {
      debug2 = false;
    }
    var normalizedAbsoluteEntries = [];
    var normalizedRelativeEntries = [];
    var normalizedEntriesNameMap = {};
    absoluteEntries.forEach(function(entry) {
      var normalizedEntry = __assign7(__assign7({}, entry), { before: [], after: [] });
      if (normalizedEntry.name)
        normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
      normalizedAbsoluteEntries.push(normalizedEntry);
    });
    relativeEntries.forEach(function(entry) {
      var normalizedEntry = __assign7(__assign7({}, entry), { before: [], after: [] });
      if (normalizedEntry.name)
        normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
      normalizedRelativeEntries.push(normalizedEntry);
    });
    normalizedRelativeEntries.forEach(function(entry) {
      if (entry.toMiddleware) {
        var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
        if (toMiddleware === void 0) {
          if (debug2) {
            return;
          }
          throw new Error("".concat(entry.toMiddleware, " is not found when adding ").concat(entry.name || "anonymous", " middleware ").concat(entry.relation, " ").concat(entry.toMiddleware));
        }
        if (entry.relation === "after") {
          toMiddleware.after.push(entry);
        }
        if (entry.relation === "before") {
          toMiddleware.before.push(entry);
        }
      }
    });
    var mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce(function(wholeList, expendedMiddlewareList) {
      wholeList.push.apply(wholeList, __spreadArray4([], __read10(expendedMiddlewareList), false));
      return wholeList;
    }, []);
    return mainChain;
  };
  var stack = {
    add: function(middleware, options) {
      if (options === void 0) {
        options = {};
      }
      var name = options.name, override = options.override;
      var entry = __assign7({ step: "initialize", priority: "normal", middleware }, options);
      if (name) {
        if (entriesNameSet.has(name)) {
          if (!override)
            throw new Error("Duplicate middleware name '".concat(name, "'"));
          var toOverrideIndex = absoluteEntries.findIndex(function(entry2) {
            return entry2.name === name;
          });
          var toOverride = absoluteEntries[toOverrideIndex];
          if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) {
            throw new Error('"'.concat(name, '" middleware with ').concat(toOverride.priority, " priority in ").concat(toOverride.step, " step cannot be ") + "overridden by same-name middleware with ".concat(entry.priority, " priority in ").concat(entry.step, " step."));
          }
          absoluteEntries.splice(toOverrideIndex, 1);
        }
        entriesNameSet.add(name);
      }
      absoluteEntries.push(entry);
    },
    addRelativeTo: function(middleware, options) {
      var name = options.name, override = options.override;
      var entry = __assign7({ middleware }, options);
      if (name) {
        if (entriesNameSet.has(name)) {
          if (!override)
            throw new Error("Duplicate middleware name '".concat(name, "'"));
          var toOverrideIndex = relativeEntries.findIndex(function(entry2) {
            return entry2.name === name;
          });
          var toOverride = relativeEntries[toOverrideIndex];
          if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) {
            throw new Error('"'.concat(name, '" middleware ').concat(toOverride.relation, ' "').concat(toOverride.toMiddleware, '" middleware cannot be overridden ') + "by same-name middleware ".concat(entry.relation, ' "').concat(entry.toMiddleware, '" middleware.'));
          }
          relativeEntries.splice(toOverrideIndex, 1);
        }
        entriesNameSet.add(name);
      }
      relativeEntries.push(entry);
    },
    clone: function() {
      return cloneTo(constructStack3());
    },
    use: function(plugin) {
      plugin.applyToStack(stack);
    },
    remove: function(toRemove) {
      if (typeof toRemove === "string")
        return removeByName(toRemove);
      else
        return removeByReference(toRemove);
    },
    removeByTag: function(toRemove) {
      var isRemoved = false;
      var filterCb = function(entry) {
        var tags = entry.tags, name = entry.name;
        if (tags && tags.includes(toRemove)) {
          if (name)
            entriesNameSet.delete(name);
          isRemoved = true;
          return false;
        }
        return true;
      };
      absoluteEntries = absoluteEntries.filter(filterCb);
      relativeEntries = relativeEntries.filter(filterCb);
      return isRemoved;
    },
    concat: function(from) {
      var cloned = cloneTo(constructStack3());
      cloned.use(from);
      return cloned;
    },
    applyToStack: cloneTo,
    identify: function() {
      return getMiddlewareList(true).map(function(mw) {
        return mw.name + ": " + (mw.tags || []).join(",");
      });
    },
    resolve: function(handler, context) {
      var e_1, _a2;
      try {
        for (var _b2 = __values4(getMiddlewareList().map(function(entry) {
          return entry.middleware;
        }).reverse()), _c = _b2.next(); !_c.done; _c = _b2.next()) {
          var middleware = _c.value;
          handler = middleware(handler, context);
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (_c && !_c.done && (_a2 = _b2.return))
            _a2.call(_b2);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
      return handler;
    }
  };
  return stack;
};
var stepWeights3 = {
  initialize: 5,
  serialize: 4,
  build: 3,
  finalizeRequest: 2,
  deserialize: 1
};
var priorityWeights3 = {
  high: 3,
  normal: 2,
  low: 1
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/smithy-client/dist-es/client.js
var Client4 = function() {
  function Client5(config) {
    this.middlewareStack = constructStack3();
    this.config = config;
  }
  Client5.prototype.send = function(command, optionsOrCb, cb) {
    var options = typeof optionsOrCb !== "function" ? optionsOrCb : void 0;
    var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
    var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
    if (callback) {
      handler(command).then(function(result) {
        return callback(null, result.output);
      }, function(err) {
        return callback(err);
      }).catch(function() {
      });
    } else {
      return handler(command).then(function(result) {
        return result.output;
      });
    }
  };
  Client5.prototype.destroy = function() {
    if (this.config.requestHandler.destroy)
      this.config.requestHandler.destroy();
  };
  return Client5;
}();

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/smithy-client/dist-es/command.js
var Command3 = function() {
  function Command4() {
    this.middlewareStack = constructStack3();
  }
  return Command4;
}();

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/smithy-client/dist-es/constants.js
var SENSITIVE_STRING3 = "***SensitiveInformation***";

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/smithy-client/dist-es/parse-utils.js
var expectBoolean = function(value) {
  if (value === null || value === void 0) {
    return void 0;
  }
  if (typeof value === "number") {
    if (value === 0 || value === 1) {
      logger61.warn(stackTraceWarning2("Expected boolean, got ".concat(typeof value, ": ").concat(value)));
    }
    if (value === 0) {
      return false;
    }
    if (value === 1) {
      return true;
    }
  }
  if (typeof value === "string") {
    var lower = value.toLowerCase();
    if (lower === "false" || lower === "true") {
      logger61.warn(stackTraceWarning2("Expected boolean, got ".concat(typeof value, ": ").concat(value)));
    }
    if (lower === "false") {
      return false;
    }
    if (lower === "true") {
      return true;
    }
  }
  if (typeof value === "boolean") {
    return value;
  }
  throw new TypeError("Expected boolean, got ".concat(typeof value, ": ").concat(value));
};
var expectNumber2 = function(value) {
  if (value === null || value === void 0) {
    return void 0;
  }
  if (typeof value === "string") {
    var parsed = parseFloat(value);
    if (!Number.isNaN(parsed)) {
      if (String(parsed) !== String(value)) {
        logger61.warn(stackTraceWarning2("Expected number but observed string: ".concat(value)));
      }
      return parsed;
    }
  }
  if (typeof value === "number") {
    return value;
  }
  throw new TypeError("Expected number, got ".concat(typeof value, ": ").concat(value));
};
var MAX_FLOAT2 = Math.ceil(Math.pow(2, 127) * (2 - Math.pow(2, -23)));
var expectFloat32 = function(value) {
  var expected = expectNumber2(value);
  if (expected !== void 0 && !Number.isNaN(expected) && expected !== Infinity && expected !== -Infinity) {
    if (Math.abs(expected) > MAX_FLOAT2) {
      throw new TypeError("Expected 32-bit float, got ".concat(value));
    }
  }
  return expected;
};
var expectLong2 = function(value) {
  if (value === null || value === void 0) {
    return void 0;
  }
  if (Number.isInteger(value) && !Number.isNaN(value)) {
    return value;
  }
  throw new TypeError("Expected integer, got ".concat(typeof value, ": ").concat(value));
};
var expectInt322 = function(value) {
  return expectSizedInt2(value, 32);
};
var expectShort = function(value) {
  return expectSizedInt2(value, 16);
};
var expectByte = function(value) {
  return expectSizedInt2(value, 8);
};
var expectSizedInt2 = function(value, size) {
  var expected = expectLong2(value);
  if (expected !== void 0 && castInt2(expected, size) !== expected) {
    throw new TypeError("Expected ".concat(size, "-bit integer, got ").concat(value));
  }
  return expected;
};
var castInt2 = function(value, size) {
  switch (size) {
    case 32:
      return Int32Array.of(value)[0];
    case 16:
      return Int16Array.of(value)[0];
    case 8:
      return Int8Array.of(value)[0];
  }
};
var expectNonNull2 = function(value, location) {
  if (value === null || value === void 0) {
    if (location) {
      throw new TypeError("Expected a non-null value for ".concat(location));
    }
    throw new TypeError("Expected a non-null value");
  }
  return value;
};
var expectObject2 = function(value) {
  if (value === null || value === void 0) {
    return void 0;
  }
  if (typeof value === "object" && !Array.isArray(value)) {
    return value;
  }
  var receivedType = Array.isArray(value) ? "array" : typeof value;
  throw new TypeError("Expected object, got ".concat(receivedType, ": ").concat(value));
};
var expectString2 = function(value) {
  if (value === null || value === void 0) {
    return void 0;
  }
  if (typeof value === "string") {
    return value;
  }
  if (["boolean", "number", "bigint"].includes(typeof value)) {
    logger61.warn(stackTraceWarning2("Expected string, got ".concat(typeof value, ": ").concat(value)));
    return String(value);
  }
  throw new TypeError("Expected string, got ".concat(typeof value, ": ").concat(value));
};
var strictParseFloat322 = function(value) {
  if (typeof value == "string") {
    return expectFloat32(parseNumber(value));
  }
  return expectFloat32(value);
};
var NUMBER_REGEX = /(-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)|(-?Infinity)|(NaN)/g;
var parseNumber = function(value) {
  var matches2 = value.match(NUMBER_REGEX);
  if (matches2 === null || matches2[0].length !== value.length) {
    throw new TypeError("Expected real number, got implicit NaN");
  }
  return parseFloat(value);
};
var limitedParseDouble2 = function(value) {
  if (typeof value == "string") {
    return parseFloatString2(value);
  }
  return expectNumber2(value);
};
var parseFloatString2 = function(value) {
  switch (value) {
    case "NaN":
      return NaN;
    case "Infinity":
      return Infinity;
    case "-Infinity":
      return -Infinity;
    default:
      throw new Error("Unable to parse float value: ".concat(value));
  }
};
var strictParseShort2 = function(value) {
  if (typeof value === "string") {
    return expectShort(parseNumber(value));
  }
  return expectShort(value);
};
var strictParseByte2 = function(value) {
  if (typeof value === "string") {
    return expectByte(parseNumber(value));
  }
  return expectByte(value);
};
var stackTraceWarning2 = function(message) {
  return String(new TypeError(message).stack || message).split("\n").slice(0, 5).filter(function(s2) {
    return !s2.includes("stackTraceWarning");
  }).join("\n");
};
var logger61 = {
  warn: console.warn
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/smithy-client/dist-es/date-utils.js
var MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var RFC33392 = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?[zZ]$/);
var parseRfc3339DateTime = function(value) {
  if (value === null || value === void 0) {
    return void 0;
  }
  if (typeof value !== "string") {
    throw new TypeError("RFC-3339 date-times must be expressed as strings");
  }
  var match = RFC33392.exec(value);
  if (!match) {
    throw new TypeError("Invalid RFC-3339 date-time value");
  }
  var _a2 = __read10(match, 8), _2 = _a2[0], yearStr = _a2[1], monthStr = _a2[2], dayStr = _a2[3], hours = _a2[4], minutes = _a2[5], seconds = _a2[6], fractionalMilliseconds = _a2[7];
  var year = strictParseShort2(stripLeadingZeroes(yearStr));
  var month = parseDateValue(monthStr, "month", 1, 12);
  var day = parseDateValue(dayStr, "day", 1, 31);
  return buildDate(year, month, day, { hours, minutes, seconds, fractionalMilliseconds });
};
var IMF_FIXDATE2 = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
var RFC_850_DATE2 = new RegExp(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d{2})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
var ASC_TIME2 = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( [1-9]|\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? (\d{4})$/);
var buildDate = function(year, month, day, time) {
  var adjustedMonth = month - 1;
  validateDayOfMonth(year, adjustedMonth, day);
  return new Date(Date.UTC(year, adjustedMonth, day, parseDateValue(time.hours, "hour", 0, 23), parseDateValue(time.minutes, "minute", 0, 59), parseDateValue(time.seconds, "seconds", 0, 60), parseMilliseconds(time.fractionalMilliseconds)));
};
var FIFTY_YEARS_IN_MILLIS2 = 50 * 365 * 24 * 60 * 60 * 1e3;
var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var validateDayOfMonth = function(year, month, day) {
  var maxDays = DAYS_IN_MONTH[month];
  if (month === 1 && isLeapYear(year)) {
    maxDays = 29;
  }
  if (day > maxDays) {
    throw new TypeError("Invalid day for ".concat(MONTHS[month], " in ").concat(year, ": ").concat(day));
  }
};
var isLeapYear = function(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
};
var parseDateValue = function(value, type, lower, upper) {
  var dateVal = strictParseByte2(stripLeadingZeroes(value));
  if (dateVal < lower || dateVal > upper) {
    throw new TypeError("".concat(type, " must be between ").concat(lower, " and ").concat(upper, ", inclusive"));
  }
  return dateVal;
};
var parseMilliseconds = function(value) {
  if (value === null || value === void 0) {
    return 0;
  }
  return strictParseFloat322("0." + value) * 1e3;
};
var stripLeadingZeroes = function(value) {
  var idx = 0;
  while (idx < value.length - 1 && value.charAt(idx) === "0") {
    idx++;
  }
  if (idx === 0) {
    return value;
  }
  return value.slice(idx);
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/smithy-client/dist-es/exceptions.js
var ServiceException2 = function(_super) {
  __extends3(ServiceException3, _super);
  function ServiceException3(options) {
    var _this = _super.call(this, options.message) || this;
    Object.setPrototypeOf(_this, ServiceException3.prototype);
    _this.name = options.name;
    _this.$fault = options.$fault;
    _this.$metadata = options.$metadata;
    return _this;
  }
  return ServiceException3;
}(Error);
var decorateServiceException2 = function(exception, additions) {
  if (additions === void 0) {
    additions = {};
  }
  Object.entries(additions).filter(function(_a2) {
    var _b2 = __read10(_a2, 2), v2 = _b2[1];
    return v2 !== void 0;
  }).forEach(function(_a2) {
    var _b2 = __read10(_a2, 2), k2 = _b2[0], v2 = _b2[1];
    if (exception[k2] == void 0 || exception[k2] === "") {
      exception[k2] = v2;
    }
  });
  var message = exception.message || exception.Message || "UnknownError";
  exception.message = message;
  delete exception.Message;
  return exception;
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/smithy-client/dist-es/default-error-handler.js
var throwDefaultError2 = function(_a2) {
  var output = _a2.output, parsedBody = _a2.parsedBody, exceptionCtor = _a2.exceptionCtor, errorCode = _a2.errorCode;
  var $metadata = deserializeMetadata8(output);
  var statusCode = $metadata.httpStatusCode ? $metadata.httpStatusCode + "" : void 0;
  var response = new exceptionCtor({
    name: parsedBody.code || parsedBody.Code || errorCode || statusCode || "UnknowError",
    $fault: "client",
    $metadata
  });
  throw decorateServiceException2(response, parsedBody);
};
var deserializeMetadata8 = function(output) {
  var _a2;
  return {
    httpStatusCode: output.statusCode,
    requestId: (_a2 = output.headers["x-amzn-requestid"]) !== null && _a2 !== void 0 ? _a2 : output.headers["x-amzn-request-id"],
    extendedRequestId: output.headers["x-amz-id-2"],
    cfId: output.headers["x-amz-cf-id"]
  };
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/smithy-client/dist-es/defaults-mode.js
var loadConfigsForDefaultMode2 = function(mode) {
  switch (mode) {
    case "standard":
      return {
        retryMode: "standard",
        connectionTimeout: 3100
      };
    case "in-region":
      return {
        retryMode: "standard",
        connectionTimeout: 1100
      };
    case "cross-region":
      return {
        retryMode: "standard",
        connectionTimeout: 3100
      };
    case "mobile":
      return {
        retryMode: "standard",
        connectionTimeout: 3e4
      };
    default:
      return {};
  }
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/smithy-client/dist-es/extended-encode-uri-component.js
function extendedEncodeURIComponent4(str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function(c2) {
    return "%" + c2.charCodeAt(0).toString(16).toUpperCase();
  });
}

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/smithy-client/dist-es/lazy-json.js
var StringWrapper3 = function() {
  var Class = Object.getPrototypeOf(this).constructor;
  var Constructor = Function.bind.apply(String, __spreadArray4([null], __read10(arguments), false));
  var instance2 = new Constructor();
  Object.setPrototypeOf(instance2, Class.prototype);
  return instance2;
};
StringWrapper3.prototype = Object.create(String.prototype, {
  constructor: {
    value: StringWrapper3,
    enumerable: false,
    writable: true,
    configurable: true
  }
});
Object.setPrototypeOf(StringWrapper3, String);
var LazyJsonString3 = function(_super) {
  __extends3(LazyJsonString4, _super);
  function LazyJsonString4() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  LazyJsonString4.prototype.deserializeJSON = function() {
    return JSON.parse(_super.prototype.toString.call(this));
  };
  LazyJsonString4.prototype.toJSON = function() {
    return _super.prototype.toString.call(this);
  };
  LazyJsonString4.fromObject = function(object) {
    if (object instanceof LazyJsonString4) {
      return object;
    } else if (object instanceof String || typeof object === "string") {
      return new LazyJsonString4(object);
    }
    return new LazyJsonString4(JSON.stringify(object));
  };
  return LazyJsonString4;
}(StringWrapper3);

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/smithy-client/dist-es/object-mapping.js
function map3(arg0, arg1, arg2) {
  var e_1, _a2;
  var target;
  var filter;
  var instructions;
  if (typeof arg1 === "undefined" && typeof arg2 === "undefined") {
    target = {};
    instructions = arg0;
  } else {
    target = arg0;
    if (typeof arg1 === "function") {
      filter = arg1;
      instructions = arg2;
      return mapWithFilter2(target, filter, instructions);
    } else {
      instructions = arg1;
    }
  }
  try {
    for (var _b2 = __values4(Object.keys(instructions)), _c = _b2.next(); !_c.done; _c = _b2.next()) {
      var key = _c.value;
      if (!Array.isArray(instructions[key])) {
        target[key] = instructions[key];
        continue;
      }
      var _d = __read10(instructions[key], 2), filter_1 = _d[0], value = _d[1];
      if (typeof value === "function") {
        var _value = void 0;
        var defaultFilterPassed = filter_1 === void 0 && (_value = value()) != null;
        var customFilterPassed = typeof filter_1 === "function" && !!filter_1(void 0) || typeof filter_1 !== "function" && !!filter_1;
        if (defaultFilterPassed) {
          target[key] = _value;
        } else if (customFilterPassed) {
          target[key] = value();
        }
      } else {
        var defaultFilterPassed = filter_1 === void 0 && value != null;
        var customFilterPassed = typeof filter_1 === "function" && !!filter_1(value) || typeof filter_1 !== "function" && !!filter_1;
        if (defaultFilterPassed || customFilterPassed) {
          target[key] = value;
        }
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_c && !_c.done && (_a2 = _b2.return))
        _a2.call(_b2);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return target;
}
var mapWithFilter2 = function(target, filter, instructions) {
  return map3(target, Object.entries(instructions).reduce(function(_instructions, _a2) {
    var _b2 = __read10(_a2, 2), key = _b2[0], value = _b2[1];
    if (Array.isArray(value)) {
      _instructions[key] = value;
    } else {
      if (typeof value === "function") {
        _instructions[key] = [filter, value()];
      } else {
        _instructions[key] = [filter, value];
      }
    }
    return _instructions;
  }, {}));
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/smithy-client/dist-es/resolve-path.js
var resolvedPath2 = function(resolvedPath3, input, memberName, labelValueProvider, uriLabel, isGreedyLabel) {
  if (input != null && input[memberName] !== void 0) {
    var labelValue = labelValueProvider();
    if (labelValue.length <= 0) {
      throw new Error("Empty value provided for input HTTP label: " + memberName + ".");
    }
    resolvedPath3 = resolvedPath3.replace(uriLabel, isGreedyLabel ? labelValue.split("/").map(function(segment) {
      return extendedEncodeURIComponent4(segment);
    }).join("/") : extendedEncodeURIComponent4(labelValue));
  } else {
    throw new Error("No value provided for input HTTP label: " + memberName + ".");
  }
  return resolvedPath3;
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/smithy-client/dist-es/ser-utils.js
var serializeFloat = function(value) {
  if (value !== value) {
    return "NaN";
  }
  switch (value) {
    case Infinity:
      return "Infinity";
    case -Infinity:
      return "-Infinity";
    default:
      return value;
  }
};

// node_modules/@aws-sdk/client-location/dist-es/models/LocationServiceException.js
var LocationServiceException = function(_super) {
  __extends3(LocationServiceException2, _super);
  function LocationServiceException2(options) {
    var _this = _super.call(this, options) || this;
    Object.setPrototypeOf(_this, LocationServiceException2.prototype);
    return _this;
  }
  return LocationServiceException2;
}(ServiceException2);

// node_modules/@aws-sdk/client-location/dist-es/models/models_0.js
var AccessDeniedException = function(_super) {
  __extends3(AccessDeniedException2, _super);
  function AccessDeniedException2(opts) {
    var _this = _super.call(this, __assign7({ name: "AccessDeniedException", $fault: "client" }, opts)) || this;
    _this.name = "AccessDeniedException";
    _this.$fault = "client";
    Object.setPrototypeOf(_this, AccessDeniedException2.prototype);
    _this.Message = opts.Message;
    return _this;
  }
  return AccessDeniedException2;
}(LocationServiceException);
var ConflictException2 = function(_super) {
  __extends3(ConflictException3, _super);
  function ConflictException3(opts) {
    var _this = _super.call(this, __assign7({ name: "ConflictException", $fault: "client" }, opts)) || this;
    _this.name = "ConflictException";
    _this.$fault = "client";
    Object.setPrototypeOf(_this, ConflictException3.prototype);
    _this.Message = opts.Message;
    return _this;
  }
  return ConflictException3;
}(LocationServiceException);
var InternalServerException = function(_super) {
  __extends3(InternalServerException2, _super);
  function InternalServerException2(opts) {
    var _this = _super.call(this, __assign7({ name: "InternalServerException", $fault: "server" }, opts)) || this;
    _this.name = "InternalServerException";
    _this.$fault = "server";
    _this.$retryable = {};
    Object.setPrototypeOf(_this, InternalServerException2.prototype);
    _this.Message = opts.Message;
    return _this;
  }
  return InternalServerException2;
}(LocationServiceException);
var ResourceNotFoundException5 = function(_super) {
  __extends3(ResourceNotFoundException6, _super);
  function ResourceNotFoundException6(opts) {
    var _this = _super.call(this, __assign7({ name: "ResourceNotFoundException", $fault: "client" }, opts)) || this;
    _this.name = "ResourceNotFoundException";
    _this.$fault = "client";
    Object.setPrototypeOf(_this, ResourceNotFoundException6.prototype);
    _this.Message = opts.Message;
    return _this;
  }
  return ResourceNotFoundException6;
}(LocationServiceException);
var ServiceQuotaExceededException = function(_super) {
  __extends3(ServiceQuotaExceededException2, _super);
  function ServiceQuotaExceededException2(opts) {
    var _this = _super.call(this, __assign7({ name: "ServiceQuotaExceededException", $fault: "client" }, opts)) || this;
    _this.name = "ServiceQuotaExceededException";
    _this.$fault = "client";
    Object.setPrototypeOf(_this, ServiceQuotaExceededException2.prototype);
    _this.Message = opts.Message;
    return _this;
  }
  return ServiceQuotaExceededException2;
}(LocationServiceException);
var ThrottlingException = function(_super) {
  __extends3(ThrottlingException2, _super);
  function ThrottlingException2(opts) {
    var _this = _super.call(this, __assign7({ name: "ThrottlingException", $fault: "client" }, opts)) || this;
    _this.name = "ThrottlingException";
    _this.$fault = "client";
    _this.$retryable = {};
    Object.setPrototypeOf(_this, ThrottlingException2.prototype);
    _this.Message = opts.Message;
    return _this;
  }
  return ThrottlingException2;
}(LocationServiceException);
var ValidationException = function(_super) {
  __extends3(ValidationException2, _super);
  function ValidationException2(opts) {
    var _this = _super.call(this, __assign7({ name: "ValidationException", $fault: "client" }, opts)) || this;
    _this.name = "ValidationException";
    _this.$fault = "client";
    Object.setPrototypeOf(_this, ValidationException2.prototype);
    _this.Message = opts.Message;
    _this.Reason = opts.Reason;
    _this.FieldList = opts.FieldList;
    return _this;
  }
  return ValidationException2;
}(LocationServiceException);
var BatchDeleteGeofenceRequestFilterSensitiveLog = function(obj) {
  return __assign7({}, obj);
};
var BatchDeleteGeofenceResponseFilterSensitiveLog = function(obj) {
  return __assign7({}, obj);
};
var GeofenceGeometryFilterSensitiveLog = function(obj) {
  return __assign7(__assign7(__assign7({}, obj), obj.Polygon && { Polygon: obj.Polygon.map(function(item) {
    return SENSITIVE_STRING3;
  }) }), obj.Circle && { Circle: SENSITIVE_STRING3 });
};
var BatchPutGeofenceRequestEntryFilterSensitiveLog = function(obj) {
  return __assign7(__assign7({}, obj), obj.Geometry && { Geometry: GeofenceGeometryFilterSensitiveLog(obj.Geometry) });
};
var BatchPutGeofenceRequestFilterSensitiveLog = function(obj) {
  return __assign7(__assign7({}, obj), obj.Entries && { Entries: obj.Entries.map(function(item) {
    return BatchPutGeofenceRequestEntryFilterSensitiveLog(item);
  }) });
};
var BatchPutGeofenceResponseFilterSensitiveLog = function(obj) {
  return __assign7({}, obj);
};
var GetGeofenceRequestFilterSensitiveLog = function(obj) {
  return __assign7({}, obj);
};
var GetGeofenceResponseFilterSensitiveLog = function(obj) {
  return __assign7(__assign7({}, obj), obj.Geometry && { Geometry: GeofenceGeometryFilterSensitiveLog(obj.Geometry) });
};
var ListGeofencesRequestFilterSensitiveLog = function(obj) {
  return __assign7({}, obj);
};
var ListGeofenceResponseEntryFilterSensitiveLog = function(obj) {
  return __assign7(__assign7({}, obj), obj.Geometry && { Geometry: GeofenceGeometryFilterSensitiveLog(obj.Geometry) });
};
var ListGeofencesResponseFilterSensitiveLog = function(obj) {
  return __assign7(__assign7({}, obj), obj.Entries && { Entries: obj.Entries.map(function(item) {
    return ListGeofenceResponseEntryFilterSensitiveLog(item);
  }) });
};
var GetPlaceRequestFilterSensitiveLog = function(obj) {
  return __assign7({}, obj);
};
var PlaceGeometryFilterSensitiveLog = function(obj) {
  return __assign7(__assign7({}, obj), obj.Point && { Point: SENSITIVE_STRING3 });
};
var PlaceFilterSensitiveLog = function(obj) {
  return __assign7(__assign7({}, obj), obj.Geometry && { Geometry: PlaceGeometryFilterSensitiveLog(obj.Geometry) });
};
var GetPlaceResponseFilterSensitiveLog = function(obj) {
  return __assign7(__assign7({}, obj), obj.Place && { Place: PlaceFilterSensitiveLog(obj.Place) });
};
var SearchPlaceIndexForPositionRequestFilterSensitiveLog = function(obj) {
  return __assign7(__assign7({}, obj), obj.Position && { Position: SENSITIVE_STRING3 });
};
var SearchForPositionResultFilterSensitiveLog = function(obj) {
  return __assign7(__assign7({}, obj), obj.Place && { Place: PlaceFilterSensitiveLog(obj.Place) });
};
var SearchPlaceIndexForPositionSummaryFilterSensitiveLog = function(obj) {
  return __assign7(__assign7({}, obj), obj.Position && { Position: SENSITIVE_STRING3 });
};
var SearchPlaceIndexForPositionResponseFilterSensitiveLog = function(obj) {
  return __assign7(__assign7(__assign7({}, obj), obj.Summary && { Summary: SearchPlaceIndexForPositionSummaryFilterSensitiveLog(obj.Summary) }), obj.Results && { Results: obj.Results.map(function(item) {
    return SearchForPositionResultFilterSensitiveLog(item);
  }) });
};
var SearchPlaceIndexForSuggestionsRequestFilterSensitiveLog = function(obj) {
  return __assign7(__assign7(__assign7(__assign7({}, obj), obj.Text && { Text: SENSITIVE_STRING3 }), obj.BiasPosition && { BiasPosition: SENSITIVE_STRING3 }), obj.FilterBBox && { FilterBBox: SENSITIVE_STRING3 });
};
var SearchPlaceIndexForSuggestionsSummaryFilterSensitiveLog = function(obj) {
  return __assign7(__assign7(__assign7(__assign7({}, obj), obj.Text && { Text: SENSITIVE_STRING3 }), obj.BiasPosition && { BiasPosition: SENSITIVE_STRING3 }), obj.FilterBBox && { FilterBBox: SENSITIVE_STRING3 });
};
var SearchPlaceIndexForSuggestionsResponseFilterSensitiveLog = function(obj) {
  return __assign7(__assign7({}, obj), obj.Summary && { Summary: SearchPlaceIndexForSuggestionsSummaryFilterSensitiveLog(obj.Summary) });
};
var SearchPlaceIndexForTextRequestFilterSensitiveLog = function(obj) {
  return __assign7(__assign7(__assign7(__assign7({}, obj), obj.Text && { Text: SENSITIVE_STRING3 }), obj.BiasPosition && { BiasPosition: SENSITIVE_STRING3 }), obj.FilterBBox && { FilterBBox: SENSITIVE_STRING3 });
};
var SearchForTextResultFilterSensitiveLog = function(obj) {
  return __assign7(__assign7({}, obj), obj.Place && { Place: PlaceFilterSensitiveLog(obj.Place) });
};
var SearchPlaceIndexForTextSummaryFilterSensitiveLog = function(obj) {
  return __assign7(__assign7(__assign7(__assign7(__assign7({}, obj), obj.Text && { Text: SENSITIVE_STRING3 }), obj.BiasPosition && { BiasPosition: SENSITIVE_STRING3 }), obj.FilterBBox && { FilterBBox: SENSITIVE_STRING3 }), obj.ResultBBox && { ResultBBox: SENSITIVE_STRING3 });
};
var SearchPlaceIndexForTextResponseFilterSensitiveLog = function(obj) {
  return __assign7(__assign7(__assign7({}, obj), obj.Summary && { Summary: SearchPlaceIndexForTextSummaryFilterSensitiveLog(obj.Summary) }), obj.Results && { Results: obj.Results.map(function(item) {
    return SearchForTextResultFilterSensitiveLog(item);
  }) });
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/protocol-http/dist-es/httpRequest.js
var HttpRequest3 = function() {
  function HttpRequest4(options) {
    this.method = options.method || "GET";
    this.hostname = options.hostname || "localhost";
    this.port = options.port;
    this.query = options.query || {};
    this.headers = options.headers || {};
    this.body = options.body;
    this.protocol = options.protocol ? options.protocol.slice(-1) !== ":" ? "".concat(options.protocol, ":") : options.protocol : "https:";
    this.path = options.path ? options.path.charAt(0) !== "/" ? "/".concat(options.path) : options.path : "/";
  }
  HttpRequest4.isInstance = function(request) {
    if (!request)
      return false;
    var req = request;
    return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
  };
  HttpRequest4.prototype.clone = function() {
    var cloned = new HttpRequest4(__assign7(__assign7({}, this), { headers: __assign7({}, this.headers) }));
    if (cloned.query)
      cloned.query = cloneQuery5(cloned.query);
    return cloned;
  };
  return HttpRequest4;
}();
function cloneQuery5(query) {
  return Object.keys(query).reduce(function(carry, paramName) {
    var _a2;
    var param = query[paramName];
    return __assign7(__assign7({}, carry), (_a2 = {}, _a2[paramName] = Array.isArray(param) ? __spreadArray4([], __read10(param), false) : param, _a2));
  }, {});
}

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/protocol-http/dist-es/httpResponse.js
var HttpResponse3 = function() {
  function HttpResponse4(options) {
    this.statusCode = options.statusCode;
    this.headers = options.headers || {};
    this.body = options.body;
  }
  HttpResponse4.isInstance = function(response) {
    if (!response)
      return false;
    var resp = response;
    return typeof resp.statusCode === "number" && typeof resp.headers === "object";
  };
  return HttpResponse4;
}();

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/protocol-http/dist-es/isValidHostname.js
function isValidHostname(hostname) {
  var hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
  return hostPattern.test(hostname);
}

// node_modules/@aws-sdk/client-location/dist-es/protocols/Aws_restJson1.js
var serializeAws_restJson1BatchDeleteGeofenceCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var _a2, hostname, _b2, protocol, port, basePath, headers, resolvedPath3, body, resolvedHostname;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port, basePath = _a2.path;
          headers = {
            "content-type": "application/json"
          };
          resolvedPath3 = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/delete-geofences";
          resolvedPath3 = resolvedPath2(resolvedPath3, input, "CollectionName", function() {
            return input.CollectionName;
          }, "{CollectionName}", false);
          body = JSON.stringify(__assign7({}, input.GeofenceIds != null && { GeofenceIds: serializeAws_restJson1IdList(input.GeofenceIds, context) }));
          return [4, context.endpoint()];
        case 2:
          resolvedHostname = _c.sent().hostname;
          if (context.disableHostPrefix !== true) {
            resolvedHostname = "geofencing." + resolvedHostname;
            if (!isValidHostname(resolvedHostname)) {
              throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
            }
          }
          return [2, new HttpRequest3({
            protocol,
            hostname: resolvedHostname,
            port,
            method: "POST",
            headers,
            path: resolvedPath3,
            body
          })];
      }
    });
  });
};
var serializeAws_restJson1BatchPutGeofenceCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var _a2, hostname, _b2, protocol, port, basePath, headers, resolvedPath3, body, resolvedHostname;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port, basePath = _a2.path;
          headers = {
            "content-type": "application/json"
          };
          resolvedPath3 = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/put-geofences";
          resolvedPath3 = resolvedPath2(resolvedPath3, input, "CollectionName", function() {
            return input.CollectionName;
          }, "{CollectionName}", false);
          body = JSON.stringify(__assign7({}, input.Entries != null && {
            Entries: serializeAws_restJson1BatchPutGeofenceRequestEntryList(input.Entries, context)
          }));
          return [4, context.endpoint()];
        case 2:
          resolvedHostname = _c.sent().hostname;
          if (context.disableHostPrefix !== true) {
            resolvedHostname = "geofencing." + resolvedHostname;
            if (!isValidHostname(resolvedHostname)) {
              throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
            }
          }
          return [2, new HttpRequest3({
            protocol,
            hostname: resolvedHostname,
            port,
            method: "POST",
            headers,
            path: resolvedPath3,
            body
          })];
      }
    });
  });
};
var serializeAws_restJson1GetGeofenceCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var _a2, hostname, _b2, protocol, port, basePath, headers, resolvedPath3, body, resolvedHostname;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port, basePath = _a2.path;
          headers = {};
          resolvedPath3 = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/geofences/{GeofenceId}";
          resolvedPath3 = resolvedPath2(resolvedPath3, input, "CollectionName", function() {
            return input.CollectionName;
          }, "{CollectionName}", false);
          resolvedPath3 = resolvedPath2(resolvedPath3, input, "GeofenceId", function() {
            return input.GeofenceId;
          }, "{GeofenceId}", false);
          return [4, context.endpoint()];
        case 2:
          resolvedHostname = _c.sent().hostname;
          if (context.disableHostPrefix !== true) {
            resolvedHostname = "geofencing." + resolvedHostname;
            if (!isValidHostname(resolvedHostname)) {
              throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
            }
          }
          return [2, new HttpRequest3({
            protocol,
            hostname: resolvedHostname,
            port,
            method: "GET",
            headers,
            path: resolvedPath3,
            body
          })];
      }
    });
  });
};
var serializeAws_restJson1GetPlaceCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var _a2, hostname, _b2, protocol, port, basePath, headers, resolvedPath3, query, body, resolvedHostname;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port, basePath = _a2.path;
          headers = {};
          resolvedPath3 = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}/places/{PlaceId}";
          resolvedPath3 = resolvedPath2(resolvedPath3, input, "IndexName", function() {
            return input.IndexName;
          }, "{IndexName}", false);
          resolvedPath3 = resolvedPath2(resolvedPath3, input, "PlaceId", function() {
            return input.PlaceId;
          }, "{PlaceId}", false);
          query = map4({
            language: [, input.Language]
          });
          return [4, context.endpoint()];
        case 2:
          resolvedHostname = _c.sent().hostname;
          if (context.disableHostPrefix !== true) {
            resolvedHostname = "places." + resolvedHostname;
            if (!isValidHostname(resolvedHostname)) {
              throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
            }
          }
          return [2, new HttpRequest3({
            protocol,
            hostname: resolvedHostname,
            port,
            method: "GET",
            headers,
            path: resolvedPath3,
            query,
            body
          })];
      }
    });
  });
};
var serializeAws_restJson1ListGeofencesCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var _a2, hostname, _b2, protocol, port, basePath, headers, resolvedPath3, body, resolvedHostname;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port, basePath = _a2.path;
          headers = {
            "content-type": "application/json"
          };
          resolvedPath3 = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/list-geofences";
          resolvedPath3 = resolvedPath2(resolvedPath3, input, "CollectionName", function() {
            return input.CollectionName;
          }, "{CollectionName}", false);
          body = JSON.stringify(__assign7(__assign7({}, input.MaxResults != null && { MaxResults: input.MaxResults }), input.NextToken != null && { NextToken: input.NextToken }));
          return [4, context.endpoint()];
        case 2:
          resolvedHostname = _c.sent().hostname;
          if (context.disableHostPrefix !== true) {
            resolvedHostname = "geofencing." + resolvedHostname;
            if (!isValidHostname(resolvedHostname)) {
              throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
            }
          }
          return [2, new HttpRequest3({
            protocol,
            hostname: resolvedHostname,
            port,
            method: "POST",
            headers,
            path: resolvedPath3,
            body
          })];
      }
    });
  });
};
var serializeAws_restJson1SearchPlaceIndexForPositionCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var _a2, hostname, _b2, protocol, port, basePath, headers, resolvedPath3, body, resolvedHostname;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port, basePath = _a2.path;
          headers = {
            "content-type": "application/json"
          };
          resolvedPath3 = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}/search/position";
          resolvedPath3 = resolvedPath2(resolvedPath3, input, "IndexName", function() {
            return input.IndexName;
          }, "{IndexName}", false);
          body = JSON.stringify(__assign7(__assign7(__assign7({}, input.Language != null && { Language: input.Language }), input.MaxResults != null && { MaxResults: input.MaxResults }), input.Position != null && { Position: serializeAws_restJson1Position(input.Position, context) }));
          return [4, context.endpoint()];
        case 2:
          resolvedHostname = _c.sent().hostname;
          if (context.disableHostPrefix !== true) {
            resolvedHostname = "places." + resolvedHostname;
            if (!isValidHostname(resolvedHostname)) {
              throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
            }
          }
          return [2, new HttpRequest3({
            protocol,
            hostname: resolvedHostname,
            port,
            method: "POST",
            headers,
            path: resolvedPath3,
            body
          })];
      }
    });
  });
};
var serializeAws_restJson1SearchPlaceIndexForSuggestionsCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var _a2, hostname, _b2, protocol, port, basePath, headers, resolvedPath3, body, resolvedHostname;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port, basePath = _a2.path;
          headers = {
            "content-type": "application/json"
          };
          resolvedPath3 = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}/search/suggestions";
          resolvedPath3 = resolvedPath2(resolvedPath3, input, "IndexName", function() {
            return input.IndexName;
          }, "{IndexName}", false);
          body = JSON.stringify(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7({}, input.BiasPosition != null && { BiasPosition: serializeAws_restJson1Position(input.BiasPosition, context) }), input.FilterBBox != null && { FilterBBox: serializeAws_restJson1BoundingBox(input.FilterBBox, context) }), input.FilterCountries != null && {
            FilterCountries: serializeAws_restJson1CountryCodeList(input.FilterCountries, context)
          }), input.Language != null && { Language: input.Language }), input.MaxResults != null && { MaxResults: input.MaxResults }), input.Text != null && { Text: input.Text }));
          return [4, context.endpoint()];
        case 2:
          resolvedHostname = _c.sent().hostname;
          if (context.disableHostPrefix !== true) {
            resolvedHostname = "places." + resolvedHostname;
            if (!isValidHostname(resolvedHostname)) {
              throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
            }
          }
          return [2, new HttpRequest3({
            protocol,
            hostname: resolvedHostname,
            port,
            method: "POST",
            headers,
            path: resolvedPath3,
            body
          })];
      }
    });
  });
};
var serializeAws_restJson1SearchPlaceIndexForTextCommand = function(input, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var _a2, hostname, _b2, protocol, port, basePath, headers, resolvedPath3, body, resolvedHostname;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          return [4, context.endpoint()];
        case 1:
          _a2 = _c.sent(), hostname = _a2.hostname, _b2 = _a2.protocol, protocol = _b2 === void 0 ? "https" : _b2, port = _a2.port, basePath = _a2.path;
          headers = {
            "content-type": "application/json"
          };
          resolvedPath3 = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}/search/text";
          resolvedPath3 = resolvedPath2(resolvedPath3, input, "IndexName", function() {
            return input.IndexName;
          }, "{IndexName}", false);
          body = JSON.stringify(__assign7(__assign7(__assign7(__assign7(__assign7(__assign7({}, input.BiasPosition != null && { BiasPosition: serializeAws_restJson1Position(input.BiasPosition, context) }), input.FilterBBox != null && { FilterBBox: serializeAws_restJson1BoundingBox(input.FilterBBox, context) }), input.FilterCountries != null && {
            FilterCountries: serializeAws_restJson1CountryCodeList(input.FilterCountries, context)
          }), input.Language != null && { Language: input.Language }), input.MaxResults != null && { MaxResults: input.MaxResults }), input.Text != null && { Text: input.Text }));
          return [4, context.endpoint()];
        case 2:
          resolvedHostname = _c.sent().hostname;
          if (context.disableHostPrefix !== true) {
            resolvedHostname = "places." + resolvedHostname;
            if (!isValidHostname(resolvedHostname)) {
              throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
            }
          }
          return [2, new HttpRequest3({
            protocol,
            hostname: resolvedHostname,
            port,
            method: "POST",
            headers,
            path: resolvedPath3,
            body
          })];
      }
    });
  });
};
var deserializeAws_restJson1BatchDeleteGeofenceCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, _a2, _b2;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2, deserializeAws_restJson1BatchDeleteGeofenceCommandError(output, context)];
          }
          contents = map4({
            $metadata: deserializeMetadata9(output)
          });
          _a2 = expectNonNull2;
          _b2 = expectObject2;
          return [4, parseBody7(output.body, context)];
        case 1:
          data = _a2.apply(void 0, [_b2.apply(void 0, [_c.sent()]), "body"]);
          if (data.Errors != null) {
            contents.Errors = deserializeAws_restJson1BatchDeleteGeofenceErrorList(data.Errors, context);
          }
          return [2, contents];
      }
    });
  });
};
var deserializeAws_restJson1BatchDeleteGeofenceCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, errorCode, _b2, parsedBody;
    var _c;
    return __generator3(this, function(_d) {
      switch (_d.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _c = {};
          return [4, parseErrorBody2(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_c.body = _d.sent(), _c)]));
          errorCode = loadRestJsonErrorCode6(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "AccessDeniedException":
              return [3, 2];
            case "com.amazonaws.location#AccessDeniedException":
              return [3, 2];
            case "InternalServerException":
              return [3, 4];
            case "com.amazonaws.location#InternalServerException":
              return [3, 4];
            case "ResourceNotFoundException":
              return [3, 6];
            case "com.amazonaws.location#ResourceNotFoundException":
              return [3, 6];
            case "ThrottlingException":
              return [3, 8];
            case "com.amazonaws.location#ThrottlingException":
              return [3, 8];
            case "ValidationException":
              return [3, 10];
            case "com.amazonaws.location#ValidationException":
              return [3, 10];
          }
          return [3, 12];
        case 2:
          return [4, deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)];
        case 3:
          throw _d.sent();
        case 4:
          return [4, deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)];
        case 5:
          throw _d.sent();
        case 6:
          return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
        case 7:
          throw _d.sent();
        case 8:
          return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
        case 9:
          throw _d.sent();
        case 10:
          return [4, deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)];
        case 11:
          throw _d.sent();
        case 12:
          parsedBody = parsedOutput.body;
          throwDefaultError2({
            output,
            parsedBody,
            exceptionCtor: LocationServiceException,
            errorCode
          });
          _d.label = 13;
        case 13:
          return [2];
      }
    });
  });
};
var deserializeAws_restJson1BatchPutGeofenceCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, _a2, _b2;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2, deserializeAws_restJson1BatchPutGeofenceCommandError(output, context)];
          }
          contents = map4({
            $metadata: deserializeMetadata9(output)
          });
          _a2 = expectNonNull2;
          _b2 = expectObject2;
          return [4, parseBody7(output.body, context)];
        case 1:
          data = _a2.apply(void 0, [_b2.apply(void 0, [_c.sent()]), "body"]);
          if (data.Errors != null) {
            contents.Errors = deserializeAws_restJson1BatchPutGeofenceErrorList(data.Errors, context);
          }
          if (data.Successes != null) {
            contents.Successes = deserializeAws_restJson1BatchPutGeofenceSuccessList(data.Successes, context);
          }
          return [2, contents];
      }
    });
  });
};
var deserializeAws_restJson1BatchPutGeofenceCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, errorCode, _b2, parsedBody;
    var _c;
    return __generator3(this, function(_d) {
      switch (_d.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _c = {};
          return [4, parseErrorBody2(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_c.body = _d.sent(), _c)]));
          errorCode = loadRestJsonErrorCode6(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "AccessDeniedException":
              return [3, 2];
            case "com.amazonaws.location#AccessDeniedException":
              return [3, 2];
            case "InternalServerException":
              return [3, 4];
            case "com.amazonaws.location#InternalServerException":
              return [3, 4];
            case "ResourceNotFoundException":
              return [3, 6];
            case "com.amazonaws.location#ResourceNotFoundException":
              return [3, 6];
            case "ThrottlingException":
              return [3, 8];
            case "com.amazonaws.location#ThrottlingException":
              return [3, 8];
            case "ValidationException":
              return [3, 10];
            case "com.amazonaws.location#ValidationException":
              return [3, 10];
          }
          return [3, 12];
        case 2:
          return [4, deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)];
        case 3:
          throw _d.sent();
        case 4:
          return [4, deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)];
        case 5:
          throw _d.sent();
        case 6:
          return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
        case 7:
          throw _d.sent();
        case 8:
          return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
        case 9:
          throw _d.sent();
        case 10:
          return [4, deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)];
        case 11:
          throw _d.sent();
        case 12:
          parsedBody = parsedOutput.body;
          throwDefaultError2({
            output,
            parsedBody,
            exceptionCtor: LocationServiceException,
            errorCode
          });
          _d.label = 13;
        case 13:
          return [2];
      }
    });
  });
};
var deserializeAws_restJson1GetGeofenceCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, _a2, _b2;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2, deserializeAws_restJson1GetGeofenceCommandError(output, context)];
          }
          contents = map4({
            $metadata: deserializeMetadata9(output)
          });
          _a2 = expectNonNull2;
          _b2 = expectObject2;
          return [4, parseBody7(output.body, context)];
        case 1:
          data = _a2.apply(void 0, [_b2.apply(void 0, [_c.sent()]), "body"]);
          if (data.CreateTime != null) {
            contents.CreateTime = expectNonNull2(parseRfc3339DateTime(data.CreateTime));
          }
          if (data.GeofenceId != null) {
            contents.GeofenceId = expectString2(data.GeofenceId);
          }
          if (data.Geometry != null) {
            contents.Geometry = deserializeAws_restJson1GeofenceGeometry(data.Geometry, context);
          }
          if (data.Status != null) {
            contents.Status = expectString2(data.Status);
          }
          if (data.UpdateTime != null) {
            contents.UpdateTime = expectNonNull2(parseRfc3339DateTime(data.UpdateTime));
          }
          return [2, contents];
      }
    });
  });
};
var deserializeAws_restJson1GetGeofenceCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, errorCode, _b2, parsedBody;
    var _c;
    return __generator3(this, function(_d) {
      switch (_d.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _c = {};
          return [4, parseErrorBody2(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_c.body = _d.sent(), _c)]));
          errorCode = loadRestJsonErrorCode6(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "AccessDeniedException":
              return [3, 2];
            case "com.amazonaws.location#AccessDeniedException":
              return [3, 2];
            case "InternalServerException":
              return [3, 4];
            case "com.amazonaws.location#InternalServerException":
              return [3, 4];
            case "ResourceNotFoundException":
              return [3, 6];
            case "com.amazonaws.location#ResourceNotFoundException":
              return [3, 6];
            case "ThrottlingException":
              return [3, 8];
            case "com.amazonaws.location#ThrottlingException":
              return [3, 8];
            case "ValidationException":
              return [3, 10];
            case "com.amazonaws.location#ValidationException":
              return [3, 10];
          }
          return [3, 12];
        case 2:
          return [4, deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)];
        case 3:
          throw _d.sent();
        case 4:
          return [4, deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)];
        case 5:
          throw _d.sent();
        case 6:
          return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
        case 7:
          throw _d.sent();
        case 8:
          return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
        case 9:
          throw _d.sent();
        case 10:
          return [4, deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)];
        case 11:
          throw _d.sent();
        case 12:
          parsedBody = parsedOutput.body;
          throwDefaultError2({
            output,
            parsedBody,
            exceptionCtor: LocationServiceException,
            errorCode
          });
          _d.label = 13;
        case 13:
          return [2];
      }
    });
  });
};
var deserializeAws_restJson1GetPlaceCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, _a2, _b2;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2, deserializeAws_restJson1GetPlaceCommandError(output, context)];
          }
          contents = map4({
            $metadata: deserializeMetadata9(output)
          });
          _a2 = expectNonNull2;
          _b2 = expectObject2;
          return [4, parseBody7(output.body, context)];
        case 1:
          data = _a2.apply(void 0, [_b2.apply(void 0, [_c.sent()]), "body"]);
          if (data.Place != null) {
            contents.Place = deserializeAws_restJson1Place(data.Place, context);
          }
          return [2, contents];
      }
    });
  });
};
var deserializeAws_restJson1GetPlaceCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, errorCode, _b2, parsedBody;
    var _c;
    return __generator3(this, function(_d) {
      switch (_d.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _c = {};
          return [4, parseErrorBody2(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_c.body = _d.sent(), _c)]));
          errorCode = loadRestJsonErrorCode6(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "AccessDeniedException":
              return [3, 2];
            case "com.amazonaws.location#AccessDeniedException":
              return [3, 2];
            case "InternalServerException":
              return [3, 4];
            case "com.amazonaws.location#InternalServerException":
              return [3, 4];
            case "ResourceNotFoundException":
              return [3, 6];
            case "com.amazonaws.location#ResourceNotFoundException":
              return [3, 6];
            case "ThrottlingException":
              return [3, 8];
            case "com.amazonaws.location#ThrottlingException":
              return [3, 8];
            case "ValidationException":
              return [3, 10];
            case "com.amazonaws.location#ValidationException":
              return [3, 10];
          }
          return [3, 12];
        case 2:
          return [4, deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)];
        case 3:
          throw _d.sent();
        case 4:
          return [4, deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)];
        case 5:
          throw _d.sent();
        case 6:
          return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
        case 7:
          throw _d.sent();
        case 8:
          return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
        case 9:
          throw _d.sent();
        case 10:
          return [4, deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)];
        case 11:
          throw _d.sent();
        case 12:
          parsedBody = parsedOutput.body;
          throwDefaultError2({
            output,
            parsedBody,
            exceptionCtor: LocationServiceException,
            errorCode
          });
          _d.label = 13;
        case 13:
          return [2];
      }
    });
  });
};
var deserializeAws_restJson1ListGeofencesCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, _a2, _b2;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2, deserializeAws_restJson1ListGeofencesCommandError(output, context)];
          }
          contents = map4({
            $metadata: deserializeMetadata9(output)
          });
          _a2 = expectNonNull2;
          _b2 = expectObject2;
          return [4, parseBody7(output.body, context)];
        case 1:
          data = _a2.apply(void 0, [_b2.apply(void 0, [_c.sent()]), "body"]);
          if (data.Entries != null) {
            contents.Entries = deserializeAws_restJson1ListGeofenceResponseEntryList(data.Entries, context);
          }
          if (data.NextToken != null) {
            contents.NextToken = expectString2(data.NextToken);
          }
          return [2, contents];
      }
    });
  });
};
var deserializeAws_restJson1ListGeofencesCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, errorCode, _b2, parsedBody;
    var _c;
    return __generator3(this, function(_d) {
      switch (_d.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _c = {};
          return [4, parseErrorBody2(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_c.body = _d.sent(), _c)]));
          errorCode = loadRestJsonErrorCode6(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "AccessDeniedException":
              return [3, 2];
            case "com.amazonaws.location#AccessDeniedException":
              return [3, 2];
            case "InternalServerException":
              return [3, 4];
            case "com.amazonaws.location#InternalServerException":
              return [3, 4];
            case "ResourceNotFoundException":
              return [3, 6];
            case "com.amazonaws.location#ResourceNotFoundException":
              return [3, 6];
            case "ThrottlingException":
              return [3, 8];
            case "com.amazonaws.location#ThrottlingException":
              return [3, 8];
            case "ValidationException":
              return [3, 10];
            case "com.amazonaws.location#ValidationException":
              return [3, 10];
          }
          return [3, 12];
        case 2:
          return [4, deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)];
        case 3:
          throw _d.sent();
        case 4:
          return [4, deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)];
        case 5:
          throw _d.sent();
        case 6:
          return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
        case 7:
          throw _d.sent();
        case 8:
          return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
        case 9:
          throw _d.sent();
        case 10:
          return [4, deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)];
        case 11:
          throw _d.sent();
        case 12:
          parsedBody = parsedOutput.body;
          throwDefaultError2({
            output,
            parsedBody,
            exceptionCtor: LocationServiceException,
            errorCode
          });
          _d.label = 13;
        case 13:
          return [2];
      }
    });
  });
};
var deserializeAws_restJson1SearchPlaceIndexForPositionCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, _a2, _b2;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2, deserializeAws_restJson1SearchPlaceIndexForPositionCommandError(output, context)];
          }
          contents = map4({
            $metadata: deserializeMetadata9(output)
          });
          _a2 = expectNonNull2;
          _b2 = expectObject2;
          return [4, parseBody7(output.body, context)];
        case 1:
          data = _a2.apply(void 0, [_b2.apply(void 0, [_c.sent()]), "body"]);
          if (data.Results != null) {
            contents.Results = deserializeAws_restJson1SearchForPositionResultList(data.Results, context);
          }
          if (data.Summary != null) {
            contents.Summary = deserializeAws_restJson1SearchPlaceIndexForPositionSummary(data.Summary, context);
          }
          return [2, contents];
      }
    });
  });
};
var deserializeAws_restJson1SearchPlaceIndexForPositionCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, errorCode, _b2, parsedBody;
    var _c;
    return __generator3(this, function(_d) {
      switch (_d.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _c = {};
          return [4, parseErrorBody2(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_c.body = _d.sent(), _c)]));
          errorCode = loadRestJsonErrorCode6(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "AccessDeniedException":
              return [3, 2];
            case "com.amazonaws.location#AccessDeniedException":
              return [3, 2];
            case "InternalServerException":
              return [3, 4];
            case "com.amazonaws.location#InternalServerException":
              return [3, 4];
            case "ResourceNotFoundException":
              return [3, 6];
            case "com.amazonaws.location#ResourceNotFoundException":
              return [3, 6];
            case "ThrottlingException":
              return [3, 8];
            case "com.amazonaws.location#ThrottlingException":
              return [3, 8];
            case "ValidationException":
              return [3, 10];
            case "com.amazonaws.location#ValidationException":
              return [3, 10];
          }
          return [3, 12];
        case 2:
          return [4, deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)];
        case 3:
          throw _d.sent();
        case 4:
          return [4, deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)];
        case 5:
          throw _d.sent();
        case 6:
          return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
        case 7:
          throw _d.sent();
        case 8:
          return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
        case 9:
          throw _d.sent();
        case 10:
          return [4, deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)];
        case 11:
          throw _d.sent();
        case 12:
          parsedBody = parsedOutput.body;
          throwDefaultError2({
            output,
            parsedBody,
            exceptionCtor: LocationServiceException,
            errorCode
          });
          _d.label = 13;
        case 13:
          return [2];
      }
    });
  });
};
var deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, _a2, _b2;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2, deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommandError(output, context)];
          }
          contents = map4({
            $metadata: deserializeMetadata9(output)
          });
          _a2 = expectNonNull2;
          _b2 = expectObject2;
          return [4, parseBody7(output.body, context)];
        case 1:
          data = _a2.apply(void 0, [_b2.apply(void 0, [_c.sent()]), "body"]);
          if (data.Results != null) {
            contents.Results = deserializeAws_restJson1SearchForSuggestionsResultList(data.Results, context);
          }
          if (data.Summary != null) {
            contents.Summary = deserializeAws_restJson1SearchPlaceIndexForSuggestionsSummary(data.Summary, context);
          }
          return [2, contents];
      }
    });
  });
};
var deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, errorCode, _b2, parsedBody;
    var _c;
    return __generator3(this, function(_d) {
      switch (_d.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _c = {};
          return [4, parseErrorBody2(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_c.body = _d.sent(), _c)]));
          errorCode = loadRestJsonErrorCode6(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "AccessDeniedException":
              return [3, 2];
            case "com.amazonaws.location#AccessDeniedException":
              return [3, 2];
            case "InternalServerException":
              return [3, 4];
            case "com.amazonaws.location#InternalServerException":
              return [3, 4];
            case "ResourceNotFoundException":
              return [3, 6];
            case "com.amazonaws.location#ResourceNotFoundException":
              return [3, 6];
            case "ThrottlingException":
              return [3, 8];
            case "com.amazonaws.location#ThrottlingException":
              return [3, 8];
            case "ValidationException":
              return [3, 10];
            case "com.amazonaws.location#ValidationException":
              return [3, 10];
          }
          return [3, 12];
        case 2:
          return [4, deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)];
        case 3:
          throw _d.sent();
        case 4:
          return [4, deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)];
        case 5:
          throw _d.sent();
        case 6:
          return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
        case 7:
          throw _d.sent();
        case 8:
          return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
        case 9:
          throw _d.sent();
        case 10:
          return [4, deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)];
        case 11:
          throw _d.sent();
        case 12:
          parsedBody = parsedOutput.body;
          throwDefaultError2({
            output,
            parsedBody,
            exceptionCtor: LocationServiceException,
            errorCode
          });
          _d.label = 13;
        case 13:
          return [2];
      }
    });
  });
};
var deserializeAws_restJson1SearchPlaceIndexForTextCommand = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, _a2, _b2;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2, deserializeAws_restJson1SearchPlaceIndexForTextCommandError(output, context)];
          }
          contents = map4({
            $metadata: deserializeMetadata9(output)
          });
          _a2 = expectNonNull2;
          _b2 = expectObject2;
          return [4, parseBody7(output.body, context)];
        case 1:
          data = _a2.apply(void 0, [_b2.apply(void 0, [_c.sent()]), "body"]);
          if (data.Results != null) {
            contents.Results = deserializeAws_restJson1SearchForTextResultList(data.Results, context);
          }
          if (data.Summary != null) {
            contents.Summary = deserializeAws_restJson1SearchPlaceIndexForTextSummary(data.Summary, context);
          }
          return [2, contents];
      }
    });
  });
};
var deserializeAws_restJson1SearchPlaceIndexForTextCommandError = function(output, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var parsedOutput, _a2, errorCode, _b2, parsedBody;
    var _c;
    return __generator3(this, function(_d) {
      switch (_d.label) {
        case 0:
          _a2 = [__assign7({}, output)];
          _c = {};
          return [4, parseErrorBody2(output.body, context)];
        case 1:
          parsedOutput = __assign7.apply(void 0, _a2.concat([(_c.body = _d.sent(), _c)]));
          errorCode = loadRestJsonErrorCode6(output, parsedOutput.body);
          _b2 = errorCode;
          switch (_b2) {
            case "AccessDeniedException":
              return [3, 2];
            case "com.amazonaws.location#AccessDeniedException":
              return [3, 2];
            case "InternalServerException":
              return [3, 4];
            case "com.amazonaws.location#InternalServerException":
              return [3, 4];
            case "ResourceNotFoundException":
              return [3, 6];
            case "com.amazonaws.location#ResourceNotFoundException":
              return [3, 6];
            case "ThrottlingException":
              return [3, 8];
            case "com.amazonaws.location#ThrottlingException":
              return [3, 8];
            case "ValidationException":
              return [3, 10];
            case "com.amazonaws.location#ValidationException":
              return [3, 10];
          }
          return [3, 12];
        case 2:
          return [4, deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)];
        case 3:
          throw _d.sent();
        case 4:
          return [4, deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)];
        case 5:
          throw _d.sent();
        case 6:
          return [4, deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)];
        case 7:
          throw _d.sent();
        case 8:
          return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
        case 9:
          throw _d.sent();
        case 10:
          return [4, deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)];
        case 11:
          throw _d.sent();
        case 12:
          parsedBody = parsedOutput.body;
          throwDefaultError2({
            output,
            parsedBody,
            exceptionCtor: LocationServiceException,
            errorCode
          });
          _d.label = 13;
        case 13:
          return [2];
      }
    });
  });
};
var map4 = map3;
var deserializeAws_restJson1AccessDeniedExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, exception;
    return __generator3(this, function(_a2) {
      contents = map4({});
      data = parsedOutput.body;
      if (data.message != null) {
        contents.Message = expectString2(data.message);
      }
      exception = new AccessDeniedException(__assign7({ $metadata: deserializeMetadata9(parsedOutput) }, contents));
      return [2, decorateServiceException2(exception, parsedOutput.body)];
    });
  });
};
var deserializeAws_restJson1InternalServerExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, exception;
    return __generator3(this, function(_a2) {
      contents = map4({});
      data = parsedOutput.body;
      if (data.message != null) {
        contents.Message = expectString2(data.message);
      }
      exception = new InternalServerException(__assign7({ $metadata: deserializeMetadata9(parsedOutput) }, contents));
      return [2, decorateServiceException2(exception, parsedOutput.body)];
    });
  });
};
var deserializeAws_restJson1ResourceNotFoundExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, exception;
    return __generator3(this, function(_a2) {
      contents = map4({});
      data = parsedOutput.body;
      if (data.message != null) {
        contents.Message = expectString2(data.message);
      }
      exception = new ResourceNotFoundException5(__assign7({ $metadata: deserializeMetadata9(parsedOutput) }, contents));
      return [2, decorateServiceException2(exception, parsedOutput.body)];
    });
  });
};
var deserializeAws_restJson1ThrottlingExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, exception;
    return __generator3(this, function(_a2) {
      contents = map4({});
      data = parsedOutput.body;
      if (data.message != null) {
        contents.Message = expectString2(data.message);
      }
      exception = new ThrottlingException(__assign7({ $metadata: deserializeMetadata9(parsedOutput) }, contents));
      return [2, decorateServiceException2(exception, parsedOutput.body)];
    });
  });
};
var deserializeAws_restJson1ValidationExceptionResponse = function(parsedOutput, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var contents, data, exception;
    return __generator3(this, function(_a2) {
      contents = map4({});
      data = parsedOutput.body;
      if (data.fieldList != null) {
        contents.FieldList = deserializeAws_restJson1ValidationExceptionFieldList(data.fieldList, context);
      }
      if (data.message != null) {
        contents.Message = expectString2(data.message);
      }
      if (data.reason != null) {
        contents.Reason = expectString2(data.reason);
      }
      exception = new ValidationException(__assign7({ $metadata: deserializeMetadata9(parsedOutput) }, contents));
      return [2, decorateServiceException2(exception, parsedOutput.body)];
    });
  });
};
var serializeAws_restJson1BatchPutGeofenceRequestEntry = function(input, context) {
  return __assign7(__assign7({}, input.GeofenceId != null && { GeofenceId: input.GeofenceId }), input.Geometry != null && { Geometry: serializeAws_restJson1GeofenceGeometry(input.Geometry, context) });
};
var serializeAws_restJson1BatchPutGeofenceRequestEntryList = function(input, context) {
  return input.filter(function(e) {
    return e != null;
  }).map(function(entry) {
    return serializeAws_restJson1BatchPutGeofenceRequestEntry(entry, context);
  });
};
var serializeAws_restJson1BoundingBox = function(input, context) {
  return input.filter(function(e) {
    return e != null;
  }).map(function(entry) {
    return serializeFloat(entry);
  });
};
var serializeAws_restJson1Circle = function(input, context) {
  return __assign7(__assign7({}, input.Center != null && { Center: serializeAws_restJson1Position(input.Center, context) }), input.Radius != null && { Radius: serializeFloat(input.Radius) });
};
var serializeAws_restJson1CountryCodeList = function(input, context) {
  return input.filter(function(e) {
    return e != null;
  }).map(function(entry) {
    return entry;
  });
};
var serializeAws_restJson1GeofenceGeometry = function(input, context) {
  return __assign7(__assign7({}, input.Circle != null && { Circle: serializeAws_restJson1Circle(input.Circle, context) }), input.Polygon != null && { Polygon: serializeAws_restJson1LinearRings(input.Polygon, context) });
};
var serializeAws_restJson1IdList = function(input, context) {
  return input.filter(function(e) {
    return e != null;
  }).map(function(entry) {
    return entry;
  });
};
var serializeAws_restJson1LinearRing = function(input, context) {
  return input.filter(function(e) {
    return e != null;
  }).map(function(entry) {
    return serializeAws_restJson1Position(entry, context);
  });
};
var serializeAws_restJson1LinearRings = function(input, context) {
  return input.filter(function(e) {
    return e != null;
  }).map(function(entry) {
    return serializeAws_restJson1LinearRing(entry, context);
  });
};
var serializeAws_restJson1Position = function(input, context) {
  return input.filter(function(e) {
    return e != null;
  }).map(function(entry) {
    return serializeFloat(entry);
  });
};
var deserializeAws_restJson1BatchDeleteGeofenceError = function(output, context) {
  return {
    Error: output.Error != null ? deserializeAws_restJson1BatchItemError(output.Error, context) : void 0,
    GeofenceId: expectString2(output.GeofenceId)
  };
};
var deserializeAws_restJson1BatchDeleteGeofenceErrorList = function(output, context) {
  var retVal = (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_restJson1BatchDeleteGeofenceError(entry, context);
  });
  return retVal;
};
var deserializeAws_restJson1BatchItemError = function(output, context) {
  return {
    Code: expectString2(output.Code),
    Message: expectString2(output.Message)
  };
};
var deserializeAws_restJson1BatchPutGeofenceError = function(output, context) {
  return {
    Error: output.Error != null ? deserializeAws_restJson1BatchItemError(output.Error, context) : void 0,
    GeofenceId: expectString2(output.GeofenceId)
  };
};
var deserializeAws_restJson1BatchPutGeofenceErrorList = function(output, context) {
  var retVal = (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_restJson1BatchPutGeofenceError(entry, context);
  });
  return retVal;
};
var deserializeAws_restJson1BatchPutGeofenceSuccess = function(output, context) {
  return {
    CreateTime: output.CreateTime != null ? expectNonNull2(parseRfc3339DateTime(output.CreateTime)) : void 0,
    GeofenceId: expectString2(output.GeofenceId),
    UpdateTime: output.UpdateTime != null ? expectNonNull2(parseRfc3339DateTime(output.UpdateTime)) : void 0
  };
};
var deserializeAws_restJson1BatchPutGeofenceSuccessList = function(output, context) {
  var retVal = (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_restJson1BatchPutGeofenceSuccess(entry, context);
  });
  return retVal;
};
var deserializeAws_restJson1BoundingBox = function(output, context) {
  var retVal = (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return limitedParseDouble2(entry);
  });
  return retVal;
};
var deserializeAws_restJson1Circle = function(output, context) {
  return {
    Center: output.Center != null ? deserializeAws_restJson1Position(output.Center, context) : void 0,
    Radius: limitedParseDouble2(output.Radius)
  };
};
var deserializeAws_restJson1CountryCodeList = function(output, context) {
  var retVal = (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return expectString2(entry);
  });
  return retVal;
};
var deserializeAws_restJson1GeofenceGeometry = function(output, context) {
  return {
    Circle: output.Circle != null ? deserializeAws_restJson1Circle(output.Circle, context) : void 0,
    Polygon: output.Polygon != null ? deserializeAws_restJson1LinearRings(output.Polygon, context) : void 0
  };
};
var deserializeAws_restJson1LinearRing = function(output, context) {
  var retVal = (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_restJson1Position(entry, context);
  });
  return retVal;
};
var deserializeAws_restJson1LinearRings = function(output, context) {
  var retVal = (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_restJson1LinearRing(entry, context);
  });
  return retVal;
};
var deserializeAws_restJson1ListGeofenceResponseEntry = function(output, context) {
  return {
    CreateTime: output.CreateTime != null ? expectNonNull2(parseRfc3339DateTime(output.CreateTime)) : void 0,
    GeofenceId: expectString2(output.GeofenceId),
    Geometry: output.Geometry != null ? deserializeAws_restJson1GeofenceGeometry(output.Geometry, context) : void 0,
    Status: expectString2(output.Status),
    UpdateTime: output.UpdateTime != null ? expectNonNull2(parseRfc3339DateTime(output.UpdateTime)) : void 0
  };
};
var deserializeAws_restJson1ListGeofenceResponseEntryList = function(output, context) {
  var retVal = (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_restJson1ListGeofenceResponseEntry(entry, context);
  });
  return retVal;
};
var deserializeAws_restJson1Place = function(output, context) {
  return {
    AddressNumber: expectString2(output.AddressNumber),
    Country: expectString2(output.Country),
    Geometry: output.Geometry != null ? deserializeAws_restJson1PlaceGeometry(output.Geometry, context) : void 0,
    Interpolated: expectBoolean(output.Interpolated),
    Label: expectString2(output.Label),
    Municipality: expectString2(output.Municipality),
    Neighborhood: expectString2(output.Neighborhood),
    PostalCode: expectString2(output.PostalCode),
    Region: expectString2(output.Region),
    Street: expectString2(output.Street),
    SubRegion: expectString2(output.SubRegion),
    TimeZone: output.TimeZone != null ? deserializeAws_restJson1TimeZone(output.TimeZone, context) : void 0,
    UnitNumber: expectString2(output.UnitNumber),
    UnitType: expectString2(output.UnitType)
  };
};
var deserializeAws_restJson1PlaceGeometry = function(output, context) {
  return {
    Point: output.Point != null ? deserializeAws_restJson1Position(output.Point, context) : void 0
  };
};
var deserializeAws_restJson1Position = function(output, context) {
  var retVal = (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return limitedParseDouble2(entry);
  });
  return retVal;
};
var deserializeAws_restJson1SearchForPositionResult = function(output, context) {
  return {
    Distance: limitedParseDouble2(output.Distance),
    Place: output.Place != null ? deserializeAws_restJson1Place(output.Place, context) : void 0,
    PlaceId: expectString2(output.PlaceId)
  };
};
var deserializeAws_restJson1SearchForPositionResultList = function(output, context) {
  var retVal = (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_restJson1SearchForPositionResult(entry, context);
  });
  return retVal;
};
var deserializeAws_restJson1SearchForSuggestionsResult = function(output, context) {
  return {
    PlaceId: expectString2(output.PlaceId),
    Text: expectString2(output.Text)
  };
};
var deserializeAws_restJson1SearchForSuggestionsResultList = function(output, context) {
  var retVal = (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_restJson1SearchForSuggestionsResult(entry, context);
  });
  return retVal;
};
var deserializeAws_restJson1SearchForTextResult = function(output, context) {
  return {
    Distance: limitedParseDouble2(output.Distance),
    Place: output.Place != null ? deserializeAws_restJson1Place(output.Place, context) : void 0,
    PlaceId: expectString2(output.PlaceId),
    Relevance: limitedParseDouble2(output.Relevance)
  };
};
var deserializeAws_restJson1SearchForTextResultList = function(output, context) {
  var retVal = (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_restJson1SearchForTextResult(entry, context);
  });
  return retVal;
};
var deserializeAws_restJson1SearchPlaceIndexForPositionSummary = function(output, context) {
  return {
    DataSource: expectString2(output.DataSource),
    Language: expectString2(output.Language),
    MaxResults: expectInt322(output.MaxResults),
    Position: output.Position != null ? deserializeAws_restJson1Position(output.Position, context) : void 0
  };
};
var deserializeAws_restJson1SearchPlaceIndexForSuggestionsSummary = function(output, context) {
  return {
    BiasPosition: output.BiasPosition != null ? deserializeAws_restJson1Position(output.BiasPosition, context) : void 0,
    DataSource: expectString2(output.DataSource),
    FilterBBox: output.FilterBBox != null ? deserializeAws_restJson1BoundingBox(output.FilterBBox, context) : void 0,
    FilterCountries: output.FilterCountries != null ? deserializeAws_restJson1CountryCodeList(output.FilterCountries, context) : void 0,
    Language: expectString2(output.Language),
    MaxResults: expectInt322(output.MaxResults),
    Text: expectString2(output.Text)
  };
};
var deserializeAws_restJson1SearchPlaceIndexForTextSummary = function(output, context) {
  return {
    BiasPosition: output.BiasPosition != null ? deserializeAws_restJson1Position(output.BiasPosition, context) : void 0,
    DataSource: expectString2(output.DataSource),
    FilterBBox: output.FilterBBox != null ? deserializeAws_restJson1BoundingBox(output.FilterBBox, context) : void 0,
    FilterCountries: output.FilterCountries != null ? deserializeAws_restJson1CountryCodeList(output.FilterCountries, context) : void 0,
    Language: expectString2(output.Language),
    MaxResults: expectInt322(output.MaxResults),
    ResultBBox: output.ResultBBox != null ? deserializeAws_restJson1BoundingBox(output.ResultBBox, context) : void 0,
    Text: expectString2(output.Text)
  };
};
var deserializeAws_restJson1TimeZone = function(output, context) {
  return {
    Name: expectString2(output.Name),
    Offset: expectInt322(output.Offset)
  };
};
var deserializeAws_restJson1ValidationExceptionField = function(output, context) {
  return {
    Message: expectString2(output.message),
    Name: expectString2(output.name)
  };
};
var deserializeAws_restJson1ValidationExceptionFieldList = function(output, context) {
  var retVal = (output || []).filter(function(e) {
    return e != null;
  }).map(function(entry) {
    if (entry === null) {
      return null;
    }
    return deserializeAws_restJson1ValidationExceptionField(entry, context);
  });
  return retVal;
};
var deserializeMetadata9 = function(output) {
  var _a2, _b2;
  return {
    httpStatusCode: output.statusCode,
    requestId: (_b2 = (_a2 = output.headers["x-amzn-requestid"]) !== null && _a2 !== void 0 ? _a2 : output.headers["x-amzn-request-id"]) !== null && _b2 !== void 0 ? _b2 : output.headers["x-amz-request-id"],
    extendedRequestId: output.headers["x-amz-id-2"],
    cfId: output.headers["x-amz-cf-id"]
  };
};
var collectBody8 = function(streamBody, context) {
  if (streamBody === void 0) {
    streamBody = new Uint8Array();
  }
  if (streamBody instanceof Uint8Array) {
    return Promise.resolve(streamBody);
  }
  return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
var collectBodyString8 = function(streamBody, context) {
  return collectBody8(streamBody, context).then(function(body) {
    return context.utf8Encoder(body);
  });
};
var parseBody7 = function(streamBody, context) {
  return collectBodyString8(streamBody, context).then(function(encoded) {
    if (encoded.length) {
      return JSON.parse(encoded);
    }
    return {};
  });
};
var parseErrorBody2 = function(errorBody, context) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var value;
    var _a2;
    return __generator3(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          return [4, parseBody7(errorBody, context)];
        case 1:
          value = _b2.sent();
          value.message = (_a2 = value.message) !== null && _a2 !== void 0 ? _a2 : value.Message;
          return [2, value];
      }
    });
  });
};
var loadRestJsonErrorCode6 = function(output, data) {
  var findKey = function(object, key) {
    return Object.keys(object).find(function(k2) {
      return k2.toLowerCase() === key.toLowerCase();
    });
  };
  var sanitizeErrorCode = function(rawValue) {
    var cleanValue = rawValue;
    if (typeof cleanValue === "number") {
      cleanValue = cleanValue.toString();
    }
    if (cleanValue.indexOf(",") >= 0) {
      cleanValue = cleanValue.split(",")[0];
    }
    if (cleanValue.indexOf(":") >= 0) {
      cleanValue = cleanValue.split(":")[0];
    }
    if (cleanValue.indexOf("#") >= 0) {
      cleanValue = cleanValue.split("#")[1];
    }
    return cleanValue;
  };
  var headerKey = findKey(output.headers, "x-amzn-errortype");
  if (headerKey !== void 0) {
    return sanitizeErrorCode(output.headers[headerKey]);
  }
  if (data.code !== void 0) {
    return sanitizeErrorCode(data.code);
  }
  if (data["__type"] !== void 0) {
    return sanitizeErrorCode(data["__type"]);
  }
};

// node_modules/@aws-sdk/client-location/dist-es/commands/BatchDeleteGeofenceCommand.js
var BatchDeleteGeofenceCommand = function(_super) {
  __extends3(BatchDeleteGeofenceCommand2, _super);
  function BatchDeleteGeofenceCommand2(input) {
    var _this = _super.call(this) || this;
    _this.input = input;
    return _this;
  }
  BatchDeleteGeofenceCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
    this.middlewareStack.use(getSerdePlugin3(configuration, this.serialize, this.deserialize));
    var stack = clientStack.concat(this.middlewareStack);
    var logger64 = configuration.logger;
    var clientName = "LocationClient";
    var commandName = "BatchDeleteGeofenceCommand";
    var handlerExecutionContext = {
      logger: logger64,
      clientName,
      commandName,
      inputFilterSensitiveLog: BatchDeleteGeofenceRequestFilterSensitiveLog,
      outputFilterSensitiveLog: BatchDeleteGeofenceResponseFilterSensitiveLog
    };
    var requestHandler = configuration.requestHandler;
    return stack.resolve(function(request) {
      return requestHandler.handle(request.request, options || {});
    }, handlerExecutionContext);
  };
  BatchDeleteGeofenceCommand2.prototype.serialize = function(input, context) {
    return serializeAws_restJson1BatchDeleteGeofenceCommand(input, context);
  };
  BatchDeleteGeofenceCommand2.prototype.deserialize = function(output, context) {
    return deserializeAws_restJson1BatchDeleteGeofenceCommand(output, context);
  };
  return BatchDeleteGeofenceCommand2;
}(Command3);

// node_modules/@aws-sdk/client-location/dist-es/commands/BatchPutGeofenceCommand.js
var BatchPutGeofenceCommand = function(_super) {
  __extends3(BatchPutGeofenceCommand2, _super);
  function BatchPutGeofenceCommand2(input) {
    var _this = _super.call(this) || this;
    _this.input = input;
    return _this;
  }
  BatchPutGeofenceCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
    this.middlewareStack.use(getSerdePlugin3(configuration, this.serialize, this.deserialize));
    var stack = clientStack.concat(this.middlewareStack);
    var logger64 = configuration.logger;
    var clientName = "LocationClient";
    var commandName = "BatchPutGeofenceCommand";
    var handlerExecutionContext = {
      logger: logger64,
      clientName,
      commandName,
      inputFilterSensitiveLog: BatchPutGeofenceRequestFilterSensitiveLog,
      outputFilterSensitiveLog: BatchPutGeofenceResponseFilterSensitiveLog
    };
    var requestHandler = configuration.requestHandler;
    return stack.resolve(function(request) {
      return requestHandler.handle(request.request, options || {});
    }, handlerExecutionContext);
  };
  BatchPutGeofenceCommand2.prototype.serialize = function(input, context) {
    return serializeAws_restJson1BatchPutGeofenceCommand(input, context);
  };
  BatchPutGeofenceCommand2.prototype.deserialize = function(output, context) {
    return deserializeAws_restJson1BatchPutGeofenceCommand(output, context);
  };
  return BatchPutGeofenceCommand2;
}(Command3);

// node_modules/@aws-sdk/client-location/dist-es/commands/GetGeofenceCommand.js
var GetGeofenceCommand = function(_super) {
  __extends3(GetGeofenceCommand2, _super);
  function GetGeofenceCommand2(input) {
    var _this = _super.call(this) || this;
    _this.input = input;
    return _this;
  }
  GetGeofenceCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
    this.middlewareStack.use(getSerdePlugin3(configuration, this.serialize, this.deserialize));
    var stack = clientStack.concat(this.middlewareStack);
    var logger64 = configuration.logger;
    var clientName = "LocationClient";
    var commandName = "GetGeofenceCommand";
    var handlerExecutionContext = {
      logger: logger64,
      clientName,
      commandName,
      inputFilterSensitiveLog: GetGeofenceRequestFilterSensitiveLog,
      outputFilterSensitiveLog: GetGeofenceResponseFilterSensitiveLog
    };
    var requestHandler = configuration.requestHandler;
    return stack.resolve(function(request) {
      return requestHandler.handle(request.request, options || {});
    }, handlerExecutionContext);
  };
  GetGeofenceCommand2.prototype.serialize = function(input, context) {
    return serializeAws_restJson1GetGeofenceCommand(input, context);
  };
  GetGeofenceCommand2.prototype.deserialize = function(output, context) {
    return deserializeAws_restJson1GetGeofenceCommand(output, context);
  };
  return GetGeofenceCommand2;
}(Command3);

// node_modules/@aws-sdk/client-location/dist-es/commands/GetPlaceCommand.js
var GetPlaceCommand = function(_super) {
  __extends3(GetPlaceCommand2, _super);
  function GetPlaceCommand2(input) {
    var _this = _super.call(this) || this;
    _this.input = input;
    return _this;
  }
  GetPlaceCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
    this.middlewareStack.use(getSerdePlugin3(configuration, this.serialize, this.deserialize));
    var stack = clientStack.concat(this.middlewareStack);
    var logger64 = configuration.logger;
    var clientName = "LocationClient";
    var commandName = "GetPlaceCommand";
    var handlerExecutionContext = {
      logger: logger64,
      clientName,
      commandName,
      inputFilterSensitiveLog: GetPlaceRequestFilterSensitiveLog,
      outputFilterSensitiveLog: GetPlaceResponseFilterSensitiveLog
    };
    var requestHandler = configuration.requestHandler;
    return stack.resolve(function(request) {
      return requestHandler.handle(request.request, options || {});
    }, handlerExecutionContext);
  };
  GetPlaceCommand2.prototype.serialize = function(input, context) {
    return serializeAws_restJson1GetPlaceCommand(input, context);
  };
  GetPlaceCommand2.prototype.deserialize = function(output, context) {
    return deserializeAws_restJson1GetPlaceCommand(output, context);
  };
  return GetPlaceCommand2;
}(Command3);

// node_modules/@aws-sdk/client-location/dist-es/commands/ListGeofencesCommand.js
var ListGeofencesCommand = function(_super) {
  __extends3(ListGeofencesCommand2, _super);
  function ListGeofencesCommand2(input) {
    var _this = _super.call(this) || this;
    _this.input = input;
    return _this;
  }
  ListGeofencesCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
    this.middlewareStack.use(getSerdePlugin3(configuration, this.serialize, this.deserialize));
    var stack = clientStack.concat(this.middlewareStack);
    var logger64 = configuration.logger;
    var clientName = "LocationClient";
    var commandName = "ListGeofencesCommand";
    var handlerExecutionContext = {
      logger: logger64,
      clientName,
      commandName,
      inputFilterSensitiveLog: ListGeofencesRequestFilterSensitiveLog,
      outputFilterSensitiveLog: ListGeofencesResponseFilterSensitiveLog
    };
    var requestHandler = configuration.requestHandler;
    return stack.resolve(function(request) {
      return requestHandler.handle(request.request, options || {});
    }, handlerExecutionContext);
  };
  ListGeofencesCommand2.prototype.serialize = function(input, context) {
    return serializeAws_restJson1ListGeofencesCommand(input, context);
  };
  ListGeofencesCommand2.prototype.deserialize = function(output, context) {
    return deserializeAws_restJson1ListGeofencesCommand(output, context);
  };
  return ListGeofencesCommand2;
}(Command3);

// node_modules/@aws-sdk/client-location/dist-es/commands/SearchPlaceIndexForPositionCommand.js
var SearchPlaceIndexForPositionCommand = function(_super) {
  __extends3(SearchPlaceIndexForPositionCommand2, _super);
  function SearchPlaceIndexForPositionCommand2(input) {
    var _this = _super.call(this) || this;
    _this.input = input;
    return _this;
  }
  SearchPlaceIndexForPositionCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
    this.middlewareStack.use(getSerdePlugin3(configuration, this.serialize, this.deserialize));
    var stack = clientStack.concat(this.middlewareStack);
    var logger64 = configuration.logger;
    var clientName = "LocationClient";
    var commandName = "SearchPlaceIndexForPositionCommand";
    var handlerExecutionContext = {
      logger: logger64,
      clientName,
      commandName,
      inputFilterSensitiveLog: SearchPlaceIndexForPositionRequestFilterSensitiveLog,
      outputFilterSensitiveLog: SearchPlaceIndexForPositionResponseFilterSensitiveLog
    };
    var requestHandler = configuration.requestHandler;
    return stack.resolve(function(request) {
      return requestHandler.handle(request.request, options || {});
    }, handlerExecutionContext);
  };
  SearchPlaceIndexForPositionCommand2.prototype.serialize = function(input, context) {
    return serializeAws_restJson1SearchPlaceIndexForPositionCommand(input, context);
  };
  SearchPlaceIndexForPositionCommand2.prototype.deserialize = function(output, context) {
    return deserializeAws_restJson1SearchPlaceIndexForPositionCommand(output, context);
  };
  return SearchPlaceIndexForPositionCommand2;
}(Command3);

// node_modules/@aws-sdk/client-location/dist-es/commands/SearchPlaceIndexForSuggestionsCommand.js
var SearchPlaceIndexForSuggestionsCommand = function(_super) {
  __extends3(SearchPlaceIndexForSuggestionsCommand2, _super);
  function SearchPlaceIndexForSuggestionsCommand2(input) {
    var _this = _super.call(this) || this;
    _this.input = input;
    return _this;
  }
  SearchPlaceIndexForSuggestionsCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
    this.middlewareStack.use(getSerdePlugin3(configuration, this.serialize, this.deserialize));
    var stack = clientStack.concat(this.middlewareStack);
    var logger64 = configuration.logger;
    var clientName = "LocationClient";
    var commandName = "SearchPlaceIndexForSuggestionsCommand";
    var handlerExecutionContext = {
      logger: logger64,
      clientName,
      commandName,
      inputFilterSensitiveLog: SearchPlaceIndexForSuggestionsRequestFilterSensitiveLog,
      outputFilterSensitiveLog: SearchPlaceIndexForSuggestionsResponseFilterSensitiveLog
    };
    var requestHandler = configuration.requestHandler;
    return stack.resolve(function(request) {
      return requestHandler.handle(request.request, options || {});
    }, handlerExecutionContext);
  };
  SearchPlaceIndexForSuggestionsCommand2.prototype.serialize = function(input, context) {
    return serializeAws_restJson1SearchPlaceIndexForSuggestionsCommand(input, context);
  };
  SearchPlaceIndexForSuggestionsCommand2.prototype.deserialize = function(output, context) {
    return deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommand(output, context);
  };
  return SearchPlaceIndexForSuggestionsCommand2;
}(Command3);

// node_modules/@aws-sdk/client-location/dist-es/commands/SearchPlaceIndexForTextCommand.js
var SearchPlaceIndexForTextCommand = function(_super) {
  __extends3(SearchPlaceIndexForTextCommand2, _super);
  function SearchPlaceIndexForTextCommand2(input) {
    var _this = _super.call(this) || this;
    _this.input = input;
    return _this;
  }
  SearchPlaceIndexForTextCommand2.prototype.resolveMiddleware = function(clientStack, configuration, options) {
    this.middlewareStack.use(getSerdePlugin3(configuration, this.serialize, this.deserialize));
    var stack = clientStack.concat(this.middlewareStack);
    var logger64 = configuration.logger;
    var clientName = "LocationClient";
    var commandName = "SearchPlaceIndexForTextCommand";
    var handlerExecutionContext = {
      logger: logger64,
      clientName,
      commandName,
      inputFilterSensitiveLog: SearchPlaceIndexForTextRequestFilterSensitiveLog,
      outputFilterSensitiveLog: SearchPlaceIndexForTextResponseFilterSensitiveLog
    };
    var requestHandler = configuration.requestHandler;
    return stack.resolve(function(request) {
      return requestHandler.handle(request.request, options || {});
    }, handlerExecutionContext);
  };
  SearchPlaceIndexForTextCommand2.prototype.serialize = function(input, context) {
    return serializeAws_restJson1SearchPlaceIndexForTextCommand(input, context);
  };
  SearchPlaceIndexForTextCommand2.prototype.deserialize = function(output, context) {
    return deserializeAws_restJson1SearchPlaceIndexForTextCommand(output, context);
  };
  return SearchPlaceIndexForTextCommand2;
}(Command3);

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/config-resolver/dist-es/endpointsConfig/NodeUseDualstackEndpointConfigOptions.js
var DEFAULT_USE_DUALSTACK_ENDPOINT2 = false;

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/config-resolver/dist-es/endpointsConfig/NodeUseFipsEndpointConfigOptions.js
var DEFAULT_USE_FIPS_ENDPOINT2 = false;

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/config-resolver/dist-es/endpointsConfig/utils/getEndpointFromRegion.js
var getEndpointFromRegion2 = function(input) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var _a2, tls, region, dnsHostRegex, useDualstackEndpoint, useFipsEndpoint, hostname;
    var _b2;
    return __generator3(this, function(_c) {
      switch (_c.label) {
        case 0:
          _a2 = input.tls, tls = _a2 === void 0 ? true : _a2;
          return [4, input.region()];
        case 1:
          region = _c.sent();
          dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
          if (!dnsHostRegex.test(region)) {
            throw new Error("Invalid region in client config");
          }
          return [4, input.useDualstackEndpoint()];
        case 2:
          useDualstackEndpoint = _c.sent();
          return [4, input.useFipsEndpoint()];
        case 3:
          useFipsEndpoint = _c.sent();
          return [4, input.regionInfoProvider(region, { useDualstackEndpoint, useFipsEndpoint })];
        case 4:
          hostname = ((_b2 = _c.sent()) !== null && _b2 !== void 0 ? _b2 : {}).hostname;
          if (!hostname) {
            throw new Error("Cannot resolve hostname from client config");
          }
          return [2, input.urlParser("".concat(tls ? "https:" : "http:", "//").concat(hostname))];
      }
    });
  });
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/config-resolver/dist-es/endpointsConfig/resolveEndpointsConfig.js
var resolveEndpointsConfig3 = function(input) {
  var _a2;
  var useDualstackEndpoint = normalizeProvider6(input.useDualstackEndpoint);
  var endpoint = input.endpoint, useFipsEndpoint = input.useFipsEndpoint, urlParser = input.urlParser;
  return __assign7(__assign7({}, input), { tls: (_a2 = input.tls) !== null && _a2 !== void 0 ? _a2 : true, endpoint: endpoint ? normalizeProvider6(typeof endpoint === "string" ? urlParser(endpoint) : endpoint) : function() {
    return getEndpointFromRegion2(__assign7(__assign7({}, input), { useDualstackEndpoint, useFipsEndpoint }));
  }, isCustomEndpoint: !!endpoint, useDualstackEndpoint });
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/config-resolver/dist-es/regionConfig/isFipsRegion.js
var isFipsRegion3 = function(region) {
  return typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/config-resolver/dist-es/regionConfig/getRealRegion.js
var getRealRegion2 = function(region) {
  return isFipsRegion3(region) ? ["fips-aws-global", "aws-fips"].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/config-resolver/dist-es/regionConfig/resolveRegionConfig.js
var resolveRegionConfig3 = function(input) {
  var region = input.region, useFipsEndpoint = input.useFipsEndpoint;
  if (!region) {
    throw new Error("Region is missing");
  }
  return __assign7(__assign7({}, input), { region: function() {
    return __awaiter3(void 0, void 0, void 0, function() {
      var providedRegion;
      return __generator3(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            if (typeof region === "string") {
              return [2, getRealRegion2(region)];
            }
            return [4, region()];
          case 1:
            providedRegion = _a2.sent();
            return [2, getRealRegion2(providedRegion)];
        }
      });
    });
  }, useFipsEndpoint: function() {
    return __awaiter3(void 0, void 0, void 0, function() {
      var providedRegion, _a2;
      return __generator3(this, function(_b2) {
        switch (_b2.label) {
          case 0:
            if (!(typeof region === "string"))
              return [3, 1];
            _a2 = region;
            return [3, 3];
          case 1:
            return [4, region()];
          case 2:
            _a2 = _b2.sent();
            _b2.label = 3;
          case 3:
            providedRegion = _a2;
            if (isFipsRegion3(providedRegion)) {
              return [2, true];
            }
            return [2, typeof useFipsEndpoint === "boolean" ? Promise.resolve(useFipsEndpoint) : useFipsEndpoint()];
        }
      });
    });
  } });
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/config-resolver/dist-es/regionInfo/getHostnameFromVariants.js
var getHostnameFromVariants2 = function(variants, _a2) {
  var _b2;
  if (variants === void 0) {
    variants = [];
  }
  var useFipsEndpoint = _a2.useFipsEndpoint, useDualstackEndpoint = _a2.useDualstackEndpoint;
  return (_b2 = variants.find(function(_a3) {
    var tags = _a3.tags;
    return useFipsEndpoint === tags.includes("fips") && useDualstackEndpoint === tags.includes("dualstack");
  })) === null || _b2 === void 0 ? void 0 : _b2.hostname;
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/config-resolver/dist-es/regionInfo/getResolvedHostname.js
var getResolvedHostname2 = function(resolvedRegion, _a2) {
  var regionHostname = _a2.regionHostname, partitionHostname = _a2.partitionHostname;
  return regionHostname ? regionHostname : partitionHostname ? partitionHostname.replace("{region}", resolvedRegion) : void 0;
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/config-resolver/dist-es/regionInfo/getResolvedPartition.js
var getResolvedPartition2 = function(region, _a2) {
  var _b2;
  var partitionHash3 = _a2.partitionHash;
  return (_b2 = Object.keys(partitionHash3 || {}).find(function(key) {
    return partitionHash3[key].regions.includes(region);
  })) !== null && _b2 !== void 0 ? _b2 : "aws";
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/config-resolver/dist-es/regionInfo/getResolvedSigningRegion.js
var getResolvedSigningRegion2 = function(hostname, _a2) {
  var signingRegion = _a2.signingRegion, regionRegex = _a2.regionRegex, useFipsEndpoint = _a2.useFipsEndpoint;
  if (signingRegion) {
    return signingRegion;
  } else if (useFipsEndpoint) {
    var regionRegexJs = regionRegex.replace("\\\\", "\\").replace(/^\^/g, "\\.").replace(/\$$/g, "\\.");
    var regionRegexmatchArray = hostname.match(regionRegexJs);
    if (regionRegexmatchArray) {
      return regionRegexmatchArray[0].slice(1, -1);
    }
  }
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/config-resolver/dist-es/regionInfo/getRegionInfo.js
var getRegionInfo2 = function(region, _a2) {
  var _b2, _c, _d, _e, _f, _g;
  var _h = _a2.useFipsEndpoint, useFipsEndpoint = _h === void 0 ? false : _h, _j = _a2.useDualstackEndpoint, useDualstackEndpoint = _j === void 0 ? false : _j, signingService = _a2.signingService, regionHash3 = _a2.regionHash, partitionHash3 = _a2.partitionHash;
  var partition = getResolvedPartition2(region, { partitionHash: partitionHash3 });
  var resolvedRegion = region in regionHash3 ? region : (_c = (_b2 = partitionHash3[partition]) === null || _b2 === void 0 ? void 0 : _b2.endpoint) !== null && _c !== void 0 ? _c : region;
  var hostnameOptions = { useFipsEndpoint, useDualstackEndpoint };
  var regionHostname = getHostnameFromVariants2((_d = regionHash3[resolvedRegion]) === null || _d === void 0 ? void 0 : _d.variants, hostnameOptions);
  var partitionHostname = getHostnameFromVariants2((_e = partitionHash3[partition]) === null || _e === void 0 ? void 0 : _e.variants, hostnameOptions);
  var hostname = getResolvedHostname2(resolvedRegion, { regionHostname, partitionHostname });
  if (hostname === void 0) {
    throw new Error("Endpoint resolution failed for: ".concat({ resolvedRegion, useFipsEndpoint, useDualstackEndpoint }));
  }
  var signingRegion = getResolvedSigningRegion2(hostname, {
    signingRegion: (_f = regionHash3[resolvedRegion]) === null || _f === void 0 ? void 0 : _f.signingRegion,
    regionRegex: partitionHash3[partition].regionRegex,
    useFipsEndpoint
  });
  return __assign7(__assign7({ partition, signingService, hostname }, signingRegion && { signingRegion }), ((_g = regionHash3[resolvedRegion]) === null || _g === void 0 ? void 0 : _g.signingService) && {
    signingService: regionHash3[resolvedRegion].signingService
  });
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-content-length/dist-es/index.js
var CONTENT_LENGTH_HEADER3 = "content-length";
function contentLengthMiddleware3(bodyLengthChecker) {
  var _this = this;
  return function(next) {
    return function(args) {
      return __awaiter3(_this, void 0, void 0, function() {
        var request, body, headers, length_1;
        var _a2;
        return __generator3(this, function(_b2) {
          request = args.request;
          if (HttpRequest3.isInstance(request)) {
            body = request.body, headers = request.headers;
            if (body && Object.keys(headers).map(function(str) {
              return str.toLowerCase();
            }).indexOf(CONTENT_LENGTH_HEADER3) === -1) {
              try {
                length_1 = bodyLengthChecker(body);
                request.headers = __assign7(__assign7({}, request.headers), (_a2 = {}, _a2[CONTENT_LENGTH_HEADER3] = String(length_1), _a2));
              } catch (error) {
              }
            }
          }
          return [2, next(__assign7(__assign7({}, args), { request }))];
        });
      });
    };
  };
}
var contentLengthMiddlewareOptions3 = {
  step: "build",
  tags: ["SET_CONTENT_LENGTH", "CONTENT_LENGTH"],
  name: "contentLengthMiddleware",
  override: true
};
var getContentLengthPlugin3 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(contentLengthMiddleware3(options.bodyLengthChecker), contentLengthMiddlewareOptions3);
    }
  };
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-host-header/dist-es/index.js
function resolveHostHeaderConfig7(input) {
  return input;
}
var hostHeaderMiddleware7 = function(options) {
  return function(next) {
    return function(args) {
      return __awaiter3(void 0, void 0, void 0, function() {
        var request, _a2, handlerProtocol;
        return __generator3(this, function(_b2) {
          if (!HttpRequest3.isInstance(args.request))
            return [2, next(args)];
          request = args.request;
          _a2 = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a2 === void 0 ? "" : _a2;
          if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
            delete request.headers["host"];
            request.headers[":authority"] = "";
          } else if (!request.headers["host"]) {
            request.headers["host"] = request.hostname;
          }
          return [2, next(args)];
        });
      });
    };
  };
};
var hostHeaderMiddlewareOptions7 = {
  name: "hostHeaderMiddleware",
  step: "build",
  priority: "low",
  tags: ["HOST"],
  override: true
};
var getHostHeaderPlugin7 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(hostHeaderMiddleware7(options), hostHeaderMiddlewareOptions7);
    }
  };
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-logger/dist-es/loggerMiddleware.js
var loggerMiddleware7 = function() {
  return function(next, context) {
    return function(args) {
      return __awaiter3(void 0, void 0, void 0, function() {
        var clientName, commandName, inputFilterSensitiveLog, logger64, outputFilterSensitiveLog, response, _a2, $metadata, outputWithoutMetadata;
        return __generator3(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger64 = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
              return [4, next(args)];
            case 1:
              response = _b2.sent();
              if (!logger64) {
                return [2, response];
              }
              if (typeof logger64.info === "function") {
                _a2 = response.output, $metadata = _a2.$metadata, outputWithoutMetadata = __rest2(_a2, ["$metadata"]);
                logger64.info({
                  clientName,
                  commandName,
                  input: inputFilterSensitiveLog(args.input),
                  output: outputFilterSensitiveLog(outputWithoutMetadata),
                  metadata: $metadata
                });
              }
              return [2, response];
          }
        });
      });
    };
  };
};
var loggerMiddlewareOptions7 = {
  name: "loggerMiddleware",
  tags: ["LOGGER"],
  step: "initialize",
  override: true
};
var getLoggerPlugin7 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(loggerMiddleware7(), loggerMiddlewareOptions7);
    }
  };
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-recursion-detection/dist-es/index.js
var TRACE_ID_HEADER_NAME2 = "X-Amzn-Trace-Id";
var ENV_LAMBDA_FUNCTION_NAME2 = "AWS_LAMBDA_FUNCTION_NAME";
var ENV_TRACE_ID2 = "_X_AMZN_TRACE_ID";
var recursionDetectionMiddleware2 = function(options) {
  return function(next) {
    return function(args) {
      return __awaiter3(void 0, void 0, void 0, function() {
        var request, functionName, traceId, nonEmptyString;
        return __generator3(this, function(_a2) {
          request = args.request;
          if (!HttpRequest3.isInstance(request) || options.runtime !== "node" || request.headers.hasOwnProperty(TRACE_ID_HEADER_NAME2)) {
            return [2, next(args)];
          }
          functionName = process.env[ENV_LAMBDA_FUNCTION_NAME2];
          traceId = process.env[ENV_TRACE_ID2];
          nonEmptyString = function(str) {
            return typeof str === "string" && str.length > 0;
          };
          if (nonEmptyString(functionName) && nonEmptyString(traceId)) {
            request.headers[TRACE_ID_HEADER_NAME2] = traceId;
          }
          return [2, next(__assign7(__assign7({}, args), { request }))];
        });
      });
    };
  };
};
var addRecursionDetectionMiddlewareOptions2 = {
  step: "build",
  tags: ["RECURSION_DETECTION"],
  name: "recursionDetectionMiddleware",
  override: true,
  priority: "low"
};
var getRecursionDetectionPlugin2 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(recursionDetectionMiddleware2(options), addRecursionDetectionMiddlewareOptions2);
    }
  };
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-retry/dist-es/config.js
var RETRY_MODES2;
(function(RETRY_MODES3) {
  RETRY_MODES3["STANDARD"] = "standard";
  RETRY_MODES3["ADAPTIVE"] = "adaptive";
})(RETRY_MODES2 || (RETRY_MODES2 = {}));
var DEFAULT_MAX_ATTEMPTS3 = 3;
var DEFAULT_RETRY_MODE3 = RETRY_MODES2.STANDARD;

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/service-error-classification/dist-es/constants.js
var CLOCK_SKEW_ERROR_CODES4 = [
  "AuthFailure",
  "InvalidSignatureException",
  "RequestExpired",
  "RequestInTheFuture",
  "RequestTimeTooSkewed",
  "SignatureDoesNotMatch"
];
var THROTTLING_ERROR_CODES4 = [
  "BandwidthLimitExceeded",
  "EC2ThrottledException",
  "LimitExceededException",
  "PriorRequestNotComplete",
  "ProvisionedThroughputExceededException",
  "RequestLimitExceeded",
  "RequestThrottled",
  "RequestThrottledException",
  "SlowDown",
  "ThrottledException",
  "Throttling",
  "ThrottlingException",
  "TooManyRequestsException",
  "TransactionInProgressException"
];
var TRANSIENT_ERROR_CODES3 = ["AbortError", "TimeoutError", "RequestTimeout", "RequestTimeoutException"];
var TRANSIENT_ERROR_STATUS_CODES3 = [500, 502, 503, 504];
var NODEJS_TIMEOUT_ERROR_CODES2 = ["ECONNRESET", "EPIPE", "ETIMEDOUT"];

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/service-error-classification/dist-es/index.js
var isRetryableByTrait3 = function(error) {
  return error.$retryable !== void 0;
};
var isClockSkewError4 = function(error) {
  return CLOCK_SKEW_ERROR_CODES4.includes(error.name);
};
var isThrottlingError4 = function(error) {
  var _a2, _b2;
  return ((_a2 = error.$metadata) === null || _a2 === void 0 ? void 0 : _a2.httpStatusCode) === 429 || THROTTLING_ERROR_CODES4.includes(error.name) || ((_b2 = error.$retryable) === null || _b2 === void 0 ? void 0 : _b2.throttling) == true;
};
var isTransientError3 = function(error) {
  var _a2;
  return TRANSIENT_ERROR_CODES3.includes(error.name) || NODEJS_TIMEOUT_ERROR_CODES2.includes((error === null || error === void 0 ? void 0 : error.code) || "") || TRANSIENT_ERROR_STATUS_CODES3.includes(((_a2 = error.$metadata) === null || _a2 === void 0 ? void 0 : _a2.httpStatusCode) || 0);
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-retry/dist-es/DefaultRateLimiter.js
var DefaultRateLimiter2 = function() {
  function DefaultRateLimiter3(options) {
    var _a2, _b2, _c, _d, _e;
    this.currentCapacity = 0;
    this.enabled = false;
    this.lastMaxRate = 0;
    this.measuredTxRate = 0;
    this.requestCount = 0;
    this.lastTimestamp = 0;
    this.timeWindow = 0;
    this.beta = (_a2 = options === null || options === void 0 ? void 0 : options.beta) !== null && _a2 !== void 0 ? _a2 : 0.7;
    this.minCapacity = (_b2 = options === null || options === void 0 ? void 0 : options.minCapacity) !== null && _b2 !== void 0 ? _b2 : 1;
    this.minFillRate = (_c = options === null || options === void 0 ? void 0 : options.minFillRate) !== null && _c !== void 0 ? _c : 0.5;
    this.scaleConstant = (_d = options === null || options === void 0 ? void 0 : options.scaleConstant) !== null && _d !== void 0 ? _d : 0.4;
    this.smooth = (_e = options === null || options === void 0 ? void 0 : options.smooth) !== null && _e !== void 0 ? _e : 0.8;
    var currentTimeInSeconds = this.getCurrentTimeInSeconds();
    this.lastThrottleTime = currentTimeInSeconds;
    this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds());
    this.fillRate = this.minFillRate;
    this.maxCapacity = this.minCapacity;
  }
  DefaultRateLimiter3.prototype.getCurrentTimeInSeconds = function() {
    return Date.now() / 1e3;
  };
  DefaultRateLimiter3.prototype.getSendToken = function() {
    return __awaiter3(this, void 0, void 0, function() {
      return __generator3(this, function(_a2) {
        return [2, this.acquireTokenBucket(1)];
      });
    });
  };
  DefaultRateLimiter3.prototype.acquireTokenBucket = function(amount) {
    return __awaiter3(this, void 0, void 0, function() {
      var delay_1;
      return __generator3(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            if (!this.enabled) {
              return [2];
            }
            this.refillTokenBucket();
            if (!(amount > this.currentCapacity))
              return [3, 2];
            delay_1 = (amount - this.currentCapacity) / this.fillRate * 1e3;
            return [4, new Promise(function(resolve) {
              return setTimeout(resolve, delay_1);
            })];
          case 1:
            _a2.sent();
            _a2.label = 2;
          case 2:
            this.currentCapacity = this.currentCapacity - amount;
            return [2];
        }
      });
    });
  };
  DefaultRateLimiter3.prototype.refillTokenBucket = function() {
    var timestamp = this.getCurrentTimeInSeconds();
    if (!this.lastTimestamp) {
      this.lastTimestamp = timestamp;
      return;
    }
    var fillAmount = (timestamp - this.lastTimestamp) * this.fillRate;
    this.currentCapacity = Math.min(this.maxCapacity, this.currentCapacity + fillAmount);
    this.lastTimestamp = timestamp;
  };
  DefaultRateLimiter3.prototype.updateClientSendingRate = function(response) {
    var calculatedRate;
    this.updateMeasuredRate();
    if (isThrottlingError4(response)) {
      var rateToUse = !this.enabled ? this.measuredTxRate : Math.min(this.measuredTxRate, this.fillRate);
      this.lastMaxRate = rateToUse;
      this.calculateTimeWindow();
      this.lastThrottleTime = this.getCurrentTimeInSeconds();
      calculatedRate = this.cubicThrottle(rateToUse);
      this.enableTokenBucket();
    } else {
      this.calculateTimeWindow();
      calculatedRate = this.cubicSuccess(this.getCurrentTimeInSeconds());
    }
    var newRate = Math.min(calculatedRate, 2 * this.measuredTxRate);
    this.updateTokenBucketRate(newRate);
  };
  DefaultRateLimiter3.prototype.calculateTimeWindow = function() {
    this.timeWindow = this.getPrecise(Math.pow(this.lastMaxRate * (1 - this.beta) / this.scaleConstant, 1 / 3));
  };
  DefaultRateLimiter3.prototype.cubicThrottle = function(rateToUse) {
    return this.getPrecise(rateToUse * this.beta);
  };
  DefaultRateLimiter3.prototype.cubicSuccess = function(timestamp) {
    return this.getPrecise(this.scaleConstant * Math.pow(timestamp - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
  };
  DefaultRateLimiter3.prototype.enableTokenBucket = function() {
    this.enabled = true;
  };
  DefaultRateLimiter3.prototype.updateTokenBucketRate = function(newRate) {
    this.refillTokenBucket();
    this.fillRate = Math.max(newRate, this.minFillRate);
    this.maxCapacity = Math.max(newRate, this.minCapacity);
    this.currentCapacity = Math.min(this.currentCapacity, this.maxCapacity);
  };
  DefaultRateLimiter3.prototype.updateMeasuredRate = function() {
    var t2 = this.getCurrentTimeInSeconds();
    var timeBucket = Math.floor(t2 * 2) / 2;
    this.requestCount++;
    if (timeBucket > this.lastTxRateBucket) {
      var currentRate = this.requestCount / (timeBucket - this.lastTxRateBucket);
      this.measuredTxRate = this.getPrecise(currentRate * this.smooth + this.measuredTxRate * (1 - this.smooth));
      this.requestCount = 0;
      this.lastTxRateBucket = timeBucket;
    }
  };
  DefaultRateLimiter3.prototype.getPrecise = function(num) {
    return parseFloat(num.toFixed(8));
  };
  return DefaultRateLimiter3;
}();

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-retry/dist-es/constants.js
var DEFAULT_RETRY_DELAY_BASE3 = 100;
var MAXIMUM_RETRY_DELAY3 = 20 * 1e3;
var THROTTLING_RETRY_DELAY_BASE3 = 500;
var INITIAL_RETRY_TOKENS3 = 500;
var RETRY_COST3 = 5;
var TIMEOUT_RETRY_COST3 = 10;
var NO_RETRY_INCREMENT3 = 1;
var INVOCATION_ID_HEADER3 = "amz-sdk-invocation-id";
var REQUEST_HEADER3 = "amz-sdk-request";

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-retry/dist-es/defaultRetryQuota.js
var getDefaultRetryQuota3 = function(initialRetryTokens, options) {
  var _a2, _b2, _c;
  var MAX_CAPACITY = initialRetryTokens;
  var noRetryIncrement = (_a2 = options === null || options === void 0 ? void 0 : options.noRetryIncrement) !== null && _a2 !== void 0 ? _a2 : NO_RETRY_INCREMENT3;
  var retryCost = (_b2 = options === null || options === void 0 ? void 0 : options.retryCost) !== null && _b2 !== void 0 ? _b2 : RETRY_COST3;
  var timeoutRetryCost = (_c = options === null || options === void 0 ? void 0 : options.timeoutRetryCost) !== null && _c !== void 0 ? _c : TIMEOUT_RETRY_COST3;
  var availableCapacity = initialRetryTokens;
  var getCapacityAmount = function(error) {
    return error.name === "TimeoutError" ? timeoutRetryCost : retryCost;
  };
  var hasRetryTokens = function(error) {
    return getCapacityAmount(error) <= availableCapacity;
  };
  var retrieveRetryTokens = function(error) {
    if (!hasRetryTokens(error)) {
      throw new Error("No retry token available");
    }
    var capacityAmount = getCapacityAmount(error);
    availableCapacity -= capacityAmount;
    return capacityAmount;
  };
  var releaseRetryTokens = function(capacityReleaseAmount) {
    availableCapacity += capacityReleaseAmount !== null && capacityReleaseAmount !== void 0 ? capacityReleaseAmount : noRetryIncrement;
    availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
  };
  return Object.freeze({
    hasRetryTokens,
    retrieveRetryTokens,
    releaseRetryTokens
  });
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-retry/dist-es/delayDecider.js
var defaultDelayDecider3 = function(delayBase, attempts) {
  return Math.floor(Math.min(MAXIMUM_RETRY_DELAY3, Math.random() * Math.pow(2, attempts) * delayBase));
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-retry/dist-es/retryDecider.js
var defaultRetryDecider3 = function(error) {
  if (!error) {
    return false;
  }
  return isRetryableByTrait3(error) || isClockSkewError4(error) || isThrottlingError4(error) || isTransientError3(error);
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-retry/dist-es/StandardRetryStrategy.js
var StandardRetryStrategy3 = function() {
  function StandardRetryStrategy4(maxAttemptsProvider, options) {
    var _a2, _b2, _c;
    this.maxAttemptsProvider = maxAttemptsProvider;
    this.mode = RETRY_MODES2.STANDARD;
    this.retryDecider = (_a2 = options === null || options === void 0 ? void 0 : options.retryDecider) !== null && _a2 !== void 0 ? _a2 : defaultRetryDecider3;
    this.delayDecider = (_b2 = options === null || options === void 0 ? void 0 : options.delayDecider) !== null && _b2 !== void 0 ? _b2 : defaultDelayDecider3;
    this.retryQuota = (_c = options === null || options === void 0 ? void 0 : options.retryQuota) !== null && _c !== void 0 ? _c : getDefaultRetryQuota3(INITIAL_RETRY_TOKENS3);
  }
  StandardRetryStrategy4.prototype.shouldRetry = function(error, attempts, maxAttempts) {
    return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
  };
  StandardRetryStrategy4.prototype.getMaxAttempts = function() {
    return __awaiter3(this, void 0, void 0, function() {
      var maxAttempts, error_1;
      return __generator3(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            _a2.trys.push([0, 2, , 3]);
            return [4, this.maxAttemptsProvider()];
          case 1:
            maxAttempts = _a2.sent();
            return [3, 3];
          case 2:
            error_1 = _a2.sent();
            maxAttempts = DEFAULT_MAX_ATTEMPTS3;
            return [3, 3];
          case 3:
            return [2, maxAttempts];
        }
      });
    });
  };
  StandardRetryStrategy4.prototype.retry = function(next, args, options) {
    return __awaiter3(this, void 0, void 0, function() {
      var retryTokenAmount, attempts, totalDelay, maxAttempts, request, _loop_1, this_1, state_1;
      return __generator3(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            attempts = 0;
            totalDelay = 0;
            return [4, this.getMaxAttempts()];
          case 1:
            maxAttempts = _a2.sent();
            request = args.request;
            if (HttpRequest3.isInstance(request)) {
              request.headers[INVOCATION_ID_HEADER3] = v4_default();
            }
            _loop_1 = function() {
              var _b2, response, output, e_1, err, delayFromDecider, delayFromResponse, delay_1;
              return __generator3(this, function(_c) {
                switch (_c.label) {
                  case 0:
                    _c.trys.push([0, 4, , 7]);
                    if (HttpRequest3.isInstance(request)) {
                      request.headers[REQUEST_HEADER3] = "attempt=".concat(attempts + 1, "; max=").concat(maxAttempts);
                    }
                    if (!(options === null || options === void 0 ? void 0 : options.beforeRequest))
                      return [3, 2];
                    return [4, options.beforeRequest()];
                  case 1:
                    _c.sent();
                    _c.label = 2;
                  case 2:
                    return [4, next(args)];
                  case 3:
                    _b2 = _c.sent(), response = _b2.response, output = _b2.output;
                    if (options === null || options === void 0 ? void 0 : options.afterRequest) {
                      options.afterRequest(response);
                    }
                    this_1.retryQuota.releaseRetryTokens(retryTokenAmount);
                    output.$metadata.attempts = attempts + 1;
                    output.$metadata.totalRetryDelay = totalDelay;
                    return [2, { value: { response, output } }];
                  case 4:
                    e_1 = _c.sent();
                    err = asSdkError2(e_1);
                    attempts++;
                    if (!this_1.shouldRetry(err, attempts, maxAttempts))
                      return [3, 6];
                    retryTokenAmount = this_1.retryQuota.retrieveRetryTokens(err);
                    delayFromDecider = this_1.delayDecider(isThrottlingError4(err) ? THROTTLING_RETRY_DELAY_BASE3 : DEFAULT_RETRY_DELAY_BASE3, attempts);
                    delayFromResponse = getDelayFromRetryAfterHeader2(err.$response);
                    delay_1 = Math.max(delayFromResponse || 0, delayFromDecider);
                    totalDelay += delay_1;
                    return [4, new Promise(function(resolve) {
                      return setTimeout(resolve, delay_1);
                    })];
                  case 5:
                    _c.sent();
                    return [2, "continue"];
                  case 6:
                    if (!err.$metadata) {
                      err.$metadata = {};
                    }
                    err.$metadata.attempts = attempts;
                    err.$metadata.totalRetryDelay = totalDelay;
                    throw err;
                  case 7:
                    return [2];
                }
              });
            };
            this_1 = this;
            _a2.label = 2;
          case 2:
            if (false)
              return [3, 4];
            return [5, _loop_1()];
          case 3:
            state_1 = _a2.sent();
            if (typeof state_1 === "object")
              return [2, state_1.value];
            return [3, 2];
          case 4:
            return [2];
        }
      });
    });
  };
  return StandardRetryStrategy4;
}();
var getDelayFromRetryAfterHeader2 = function(response) {
  if (!HttpResponse3.isInstance(response))
    return;
  var retryAfterHeaderName = Object.keys(response.headers).find(function(key) {
    return key.toLowerCase() === "retry-after";
  });
  if (!retryAfterHeaderName)
    return;
  var retryAfter = response.headers[retryAfterHeaderName];
  var retryAfterSeconds = Number(retryAfter);
  if (!Number.isNaN(retryAfterSeconds))
    return retryAfterSeconds * 1e3;
  var retryAfterDate = new Date(retryAfter);
  return retryAfterDate.getTime() - Date.now();
};
var asSdkError2 = function(error) {
  if (error instanceof Error)
    return error;
  if (error instanceof Object)
    return Object.assign(new Error(), error);
  if (typeof error === "string")
    return new Error(error);
  return new Error("AWS SDK error wrapper for ".concat(error));
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-retry/dist-es/AdaptiveRetryStrategy.js
var AdaptiveRetryStrategy2 = function(_super) {
  __extends3(AdaptiveRetryStrategy3, _super);
  function AdaptiveRetryStrategy3(maxAttemptsProvider, options) {
    var _this = this;
    var _a2 = options !== null && options !== void 0 ? options : {}, rateLimiter = _a2.rateLimiter, superOptions = __rest2(_a2, ["rateLimiter"]);
    _this = _super.call(this, maxAttemptsProvider, superOptions) || this;
    _this.rateLimiter = rateLimiter !== null && rateLimiter !== void 0 ? rateLimiter : new DefaultRateLimiter2();
    _this.mode = RETRY_MODES2.ADAPTIVE;
    return _this;
  }
  AdaptiveRetryStrategy3.prototype.retry = function(next, args) {
    return __awaiter3(this, void 0, void 0, function() {
      var _this = this;
      return __generator3(this, function(_a2) {
        return [2, _super.prototype.retry.call(this, next, args, {
          beforeRequest: function() {
            return __awaiter3(_this, void 0, void 0, function() {
              return __generator3(this, function(_a3) {
                return [2, this.rateLimiter.getSendToken()];
              });
            });
          },
          afterRequest: function(response) {
            _this.rateLimiter.updateClientSendingRate(response);
          }
        })];
      });
    });
  };
  return AdaptiveRetryStrategy3;
}(StandardRetryStrategy3);

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-retry/dist-es/configurations.js
var resolveRetryConfig3 = function(input) {
  var _a2;
  var maxAttempts = normalizeProvider6((_a2 = input.maxAttempts) !== null && _a2 !== void 0 ? _a2 : DEFAULT_MAX_ATTEMPTS3);
  return __assign7(__assign7({}, input), { maxAttempts, retryStrategy: function() {
    return __awaiter3(void 0, void 0, void 0, function() {
      var retryMode;
      return __generator3(this, function(_a3) {
        switch (_a3.label) {
          case 0:
            if (input.retryStrategy) {
              return [2, input.retryStrategy];
            }
            return [4, normalizeProvider6(input.retryMode)()];
          case 1:
            retryMode = _a3.sent();
            if (retryMode === RETRY_MODES2.ADAPTIVE) {
              return [2, new AdaptiveRetryStrategy2(maxAttempts)];
            }
            return [2, new StandardRetryStrategy3(maxAttempts)];
        }
      });
    });
  } });
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-retry/dist-es/retryMiddleware.js
var retryMiddleware4 = function(options) {
  return function(next, context) {
    return function(args) {
      return __awaiter3(void 0, void 0, void 0, function() {
        var retryStrategy;
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, options.retryStrategy()];
            case 1:
              retryStrategy = _a2.sent();
              if (retryStrategy === null || retryStrategy === void 0 ? void 0 : retryStrategy.mode)
                context.userAgent = __spreadArray4(__spreadArray4([], __read10(context.userAgent || []), false), [["cfg/retry-mode", retryStrategy.mode]], false);
              return [2, retryStrategy.retry(next, args)];
          }
        });
      });
    };
  };
};
var retryMiddlewareOptions3 = {
  name: "retryMiddleware",
  tags: ["RETRY"],
  step: "finalizeRequest",
  priority: "high",
  override: true
};
var getRetryPlugin3 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(retryMiddleware4(options), retryMiddlewareOptions3);
    }
  };
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/property-provider/dist-es/ProviderError.js
var ProviderError3 = function(_super) {
  __extends3(ProviderError4, _super);
  function ProviderError4(message, tryNextLink) {
    if (tryNextLink === void 0) {
      tryNextLink = true;
    }
    var _this = _super.call(this, message) || this;
    _this.tryNextLink = tryNextLink;
    _this.name = "ProviderError";
    Object.setPrototypeOf(_this, ProviderError4.prototype);
    return _this;
  }
  ProviderError4.from = function(error, tryNextLink) {
    if (tryNextLink === void 0) {
      tryNextLink = true;
    }
    return Object.assign(new this(error.message, tryNextLink), error);
  };
  return ProviderError4;
}(Error);

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/property-provider/dist-es/CredentialsProviderError.js
var CredentialsProviderError3 = function(_super) {
  __extends3(CredentialsProviderError4, _super);
  function CredentialsProviderError4(message, tryNextLink) {
    if (tryNextLink === void 0) {
      tryNextLink = true;
    }
    var _this = _super.call(this, message, tryNextLink) || this;
    _this.tryNextLink = tryNextLink;
    _this.name = "CredentialsProviderError";
    Object.setPrototypeOf(_this, CredentialsProviderError4.prototype);
    return _this;
  }
  return CredentialsProviderError4;
}(ProviderError3);

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/property-provider/dist-es/TokenProviderError.js
var TokenProviderError3 = function(_super) {
  __extends3(TokenProviderError4, _super);
  function TokenProviderError4(message, tryNextLink) {
    if (tryNextLink === void 0) {
      tryNextLink = true;
    }
    var _this = _super.call(this, message, tryNextLink) || this;
    _this.tryNextLink = tryNextLink;
    _this.name = "TokenProviderError";
    Object.setPrototypeOf(_this, TokenProviderError4.prototype);
    return _this;
  }
  return TokenProviderError4;
}(ProviderError3);

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/property-provider/dist-es/memoize.js
var memoize3 = function(provider, isExpired, requiresRefresh) {
  var resolved;
  var pending;
  var hasResult;
  var isConstant = false;
  var coalesceProvider = function() {
    return __awaiter3(void 0, void 0, void 0, function() {
      return __generator3(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            if (!pending) {
              pending = provider();
            }
            _a2.label = 1;
          case 1:
            _a2.trys.push([1, , 3, 4]);
            return [4, pending];
          case 2:
            resolved = _a2.sent();
            hasResult = true;
            isConstant = false;
            return [3, 4];
          case 3:
            pending = void 0;
            return [7];
          case 4:
            return [2, resolved];
        }
      });
    });
  };
  if (isExpired === void 0) {
    return function(options) {
      return __awaiter3(void 0, void 0, void 0, function() {
        return __generator3(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh)))
                return [3, 2];
              return [4, coalesceProvider()];
            case 1:
              resolved = _a2.sent();
              _a2.label = 2;
            case 2:
              return [2, resolved];
          }
        });
      });
    };
  }
  return function(options) {
    return __awaiter3(void 0, void 0, void 0, function() {
      return __generator3(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh)))
              return [3, 2];
            return [4, coalesceProvider()];
          case 1:
            resolved = _a2.sent();
            _a2.label = 2;
          case 2:
            if (isConstant) {
              return [2, resolved];
            }
            if (requiresRefresh && !requiresRefresh(resolved)) {
              isConstant = true;
              return [2, resolved];
            }
            if (!isExpired(resolved))
              return [3, 4];
            return [4, coalesceProvider()];
          case 3:
            _a2.sent();
            return [2, resolved];
          case 4:
            return [2, resolved];
        }
      });
    });
  };
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/util-hex-encoding/dist-es/index.js
var SHORT_TO_HEX3 = {};
var HEX_TO_SHORT3 = {};
for (i2 = 0; i2 < 256; i2++) {
  encodedByte = i2.toString(16).toLowerCase();
  if (encodedByte.length === 1) {
    encodedByte = "0".concat(encodedByte);
  }
  SHORT_TO_HEX3[i2] = encodedByte;
  HEX_TO_SHORT3[encodedByte] = i2;
}
var encodedByte;
var i2;
function toHex3(bytes) {
  var out = "";
  for (var i2 = 0; i2 < bytes.byteLength; i2++) {
    out += SHORT_TO_HEX3[bytes[i2]];
  }
  return out;
}

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/signature-v4/dist-es/constants.js
var ALGORITHM_QUERY_PARAM4 = "X-Amz-Algorithm";
var CREDENTIAL_QUERY_PARAM4 = "X-Amz-Credential";
var AMZ_DATE_QUERY_PARAM4 = "X-Amz-Date";
var SIGNED_HEADERS_QUERY_PARAM4 = "X-Amz-SignedHeaders";
var EXPIRES_QUERY_PARAM4 = "X-Amz-Expires";
var SIGNATURE_QUERY_PARAM4 = "X-Amz-Signature";
var TOKEN_QUERY_PARAM4 = "X-Amz-Security-Token";
var AUTH_HEADER4 = "authorization";
var AMZ_DATE_HEADER4 = AMZ_DATE_QUERY_PARAM4.toLowerCase();
var DATE_HEADER3 = "date";
var GENERATED_HEADERS3 = [AUTH_HEADER4, AMZ_DATE_HEADER4, DATE_HEADER3];
var SIGNATURE_HEADER3 = SIGNATURE_QUERY_PARAM4.toLowerCase();
var SHA256_HEADER4 = "x-amz-content-sha256";
var TOKEN_HEADER4 = TOKEN_QUERY_PARAM4.toLowerCase();
var ALWAYS_UNSIGNABLE_HEADERS3 = {
  authorization: true,
  "cache-control": true,
  connection: true,
  expect: true,
  from: true,
  "keep-alive": true,
  "max-forwards": true,
  pragma: true,
  referer: true,
  te: true,
  trailer: true,
  "transfer-encoding": true,
  upgrade: true,
  "user-agent": true,
  "x-amzn-trace-id": true
};
var PROXY_HEADER_PATTERN3 = /^proxy-/;
var SEC_HEADER_PATTERN3 = /^sec-/;
var ALGORITHM_IDENTIFIER3 = "AWS4-HMAC-SHA256";
var EVENT_ALGORITHM_IDENTIFIER3 = "AWS4-HMAC-SHA256-PAYLOAD";
var UNSIGNED_PAYLOAD5 = "UNSIGNED-PAYLOAD";
var MAX_CACHE_SIZE3 = 50;
var KEY_TYPE_IDENTIFIER4 = "aws4_request";
var MAX_PRESIGNED_TTL3 = 60 * 60 * 24 * 7;

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/signature-v4/dist-es/credentialDerivation.js
var signingKeyCache3 = {};
var cacheQueue3 = [];
var createScope3 = function(shortDate, region, service) {
  return "".concat(shortDate, "/").concat(region, "/").concat(service, "/").concat(KEY_TYPE_IDENTIFIER4);
};
var getSigningKey4 = function(sha256Constructor, credentials, shortDate, region, service) {
  return __awaiter3(void 0, void 0, void 0, function() {
    var credsHash, cacheKey, key, _a2, _b2, signable, e_1_1;
    var e_1, _c;
    return __generator3(this, function(_d) {
      switch (_d.label) {
        case 0:
          return [4, hmac3(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId)];
        case 1:
          credsHash = _d.sent();
          cacheKey = "".concat(shortDate, ":").concat(region, ":").concat(service, ":").concat(toHex3(credsHash), ":").concat(credentials.sessionToken);
          if (cacheKey in signingKeyCache3) {
            return [2, signingKeyCache3[cacheKey]];
          }
          cacheQueue3.push(cacheKey);
          while (cacheQueue3.length > MAX_CACHE_SIZE3) {
            delete signingKeyCache3[cacheQueue3.shift()];
          }
          key = "AWS4".concat(credentials.secretAccessKey);
          _d.label = 2;
        case 2:
          _d.trys.push([2, 7, 8, 9]);
          _a2 = __values4([shortDate, region, service, KEY_TYPE_IDENTIFIER4]), _b2 = _a2.next();
          _d.label = 3;
        case 3:
          if (!!_b2.done)
            return [3, 6];
          signable = _b2.value;
          return [4, hmac3(sha256Constructor, key, signable)];
        case 4:
          key = _d.sent();
          _d.label = 5;
        case 5:
          _b2 = _a2.next();
          return [3, 3];
        case 6:
          return [3, 9];
        case 7:
          e_1_1 = _d.sent();
          e_1 = { error: e_1_1 };
          return [3, 9];
        case 8:
          try {
            if (_b2 && !_b2.done && (_c = _a2.return))
              _c.call(_a2);
          } finally {
            if (e_1)
              throw e_1.error;
          }
          return [7];
        case 9:
          return [2, signingKeyCache3[cacheKey] = key];
      }
    });
  });
};
var hmac3 = function(ctor, secret, data) {
  var hash = new ctor(secret);
  hash.update(data);
  return hash.digest();
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/signature-v4/dist-es/getCanonicalHeaders.js
var getCanonicalHeaders4 = function(_a2, unsignableHeaders, signableHeaders) {
  var e_1, _b2;
  var headers = _a2.headers;
  var canonical = {};
  try {
    for (var _c = __values4(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()) {
      var headerName = _d.value;
      if (headers[headerName] == void 0) {
        continue;
      }
      var canonicalHeaderName = headerName.toLowerCase();
      if (canonicalHeaderName in ALWAYS_UNSIGNABLE_HEADERS3 || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || PROXY_HEADER_PATTERN3.test(canonicalHeaderName) || SEC_HEADER_PATTERN3.test(canonicalHeaderName)) {
        if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) {
          continue;
        }
      }
      canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_d && !_d.done && (_b2 = _c.return))
        _b2.call(_c);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return canonical;
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/util-uri-escape/dist-es/escape-uri.js
var escapeUri4 = function(uri) {
  return encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode5);
};
var hexEncode5 = function(c2) {
  return "%".concat(c2.charCodeAt(0).toString(16).toUpperCase());
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/signature-v4/dist-es/getCanonicalQuery.js
var getCanonicalQuery3 = function(_a2) {
  var e_1, _b2;
  var _c = _a2.query, query = _c === void 0 ? {} : _c;
  var keys = [];
  var serialized = {};
  var _loop_1 = function(key2) {
    if (key2.toLowerCase() === SIGNATURE_HEADER3) {
      return "continue";
    }
    keys.push(key2);
    var value = query[key2];
    if (typeof value === "string") {
      serialized[key2] = "".concat(escapeUri4(key2), "=").concat(escapeUri4(value));
    } else if (Array.isArray(value)) {
      serialized[key2] = value.slice(0).sort().reduce(function(encoded, value2) {
        return encoded.concat(["".concat(escapeUri4(key2), "=").concat(escapeUri4(value2))]);
      }, []).join("&");
    }
  };
  try {
    for (var _d = __values4(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()) {
      var key = _e.value;
      _loop_1(key);
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_e && !_e.done && (_b2 = _d.return))
        _b2.call(_d);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return keys.map(function(key2) {
    return serialized[key2];
  }).filter(function(serialized2) {
    return serialized2;
  }).join("&");
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/is-array-buffer/dist-es/index.js
var isArrayBuffer5 = function(arg) {
  return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/signature-v4/dist-es/getPayloadHash.js
var getPayloadHash3 = function(_a2, hashConstructor) {
  var headers = _a2.headers, body = _a2.body;
  return __awaiter3(void 0, void 0, void 0, function() {
    var _b2, _c, headerName, hashCtor, _d;
    var e_1, _e;
    return __generator3(this, function(_f) {
      switch (_f.label) {
        case 0:
          try {
            for (_b2 = __values4(Object.keys(headers)), _c = _b2.next(); !_c.done; _c = _b2.next()) {
              headerName = _c.value;
              if (headerName.toLowerCase() === SHA256_HEADER4) {
                return [2, headers[headerName]];
              }
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (_c && !_c.done && (_e = _b2.return))
                _e.call(_b2);
            } finally {
              if (e_1)
                throw e_1.error;
            }
          }
          if (!(body == void 0))
            return [3, 1];
          return [2, "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"];
        case 1:
          if (!(typeof body === "string" || ArrayBuffer.isView(body) || isArrayBuffer5(body)))
            return [3, 3];
          hashCtor = new hashConstructor();
          hashCtor.update(body);
          _d = toHex3;
          return [4, hashCtor.digest()];
        case 2:
          return [2, _d.apply(void 0, [_f.sent()])];
        case 3:
          return [2, UNSIGNED_PAYLOAD5];
      }
    });
  });
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/signature-v4/dist-es/headerUtil.js
var hasHeader3 = function(soughtHeader, headers) {
  var e_1, _a2;
  soughtHeader = soughtHeader.toLowerCase();
  try {
    for (var _b2 = __values4(Object.keys(headers)), _c = _b2.next(); !_c.done; _c = _b2.next()) {
      var headerName = _c.value;
      if (soughtHeader === headerName.toLowerCase()) {
        return true;
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_c && !_c.done && (_a2 = _b2.return))
        _a2.call(_b2);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return false;
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/signature-v4/dist-es/cloneRequest.js
var cloneRequest3 = function(_a2) {
  var headers = _a2.headers, query = _a2.query, rest = __rest2(_a2, ["headers", "query"]);
  return __assign7(__assign7({}, rest), { headers: __assign7({}, headers), query: query ? cloneQuery6(query) : void 0 });
};
var cloneQuery6 = function(query) {
  return Object.keys(query).reduce(function(carry, paramName) {
    var _a2;
    var param = query[paramName];
    return __assign7(__assign7({}, carry), (_a2 = {}, _a2[paramName] = Array.isArray(param) ? __spreadArray4([], __read10(param), false) : param, _a2));
  }, {});
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/signature-v4/dist-es/moveHeadersToQuery.js
var moveHeadersToQuery3 = function(request, options) {
  var e_1, _a2;
  var _b2;
  if (options === void 0) {
    options = {};
  }
  var _c = typeof request.clone === "function" ? request.clone() : cloneRequest3(request), headers = _c.headers, _d = _c.query, query = _d === void 0 ? {} : _d;
  try {
    for (var _e = __values4(Object.keys(headers)), _f = _e.next(); !_f.done; _f = _e.next()) {
      var name_1 = _f.value;
      var lname = name_1.toLowerCase();
      if (lname.slice(0, 6) === "x-amz-" && !((_b2 = options.unhoistableHeaders) === null || _b2 === void 0 ? void 0 : _b2.has(lname))) {
        query[name_1] = headers[name_1];
        delete headers[name_1];
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_f && !_f.done && (_a2 = _e.return))
        _a2.call(_e);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return __assign7(__assign7({}, request), { headers, query });
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/signature-v4/dist-es/prepareRequest.js
var prepareRequest3 = function(request) {
  var e_1, _a2;
  request = typeof request.clone === "function" ? request.clone() : cloneRequest3(request);
  try {
    for (var _b2 = __values4(Object.keys(request.headers)), _c = _b2.next(); !_c.done; _c = _b2.next()) {
      var headerName = _c.value;
      if (GENERATED_HEADERS3.indexOf(headerName.toLowerCase()) > -1) {
        delete request.headers[headerName];
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_c && !_c.done && (_a2 = _b2.return))
        _a2.call(_b2);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return request;
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/signature-v4/dist-es/utilDate.js
var iso86013 = function(time) {
  return toDate3(time).toISOString().replace(/\.\d{3}Z$/, "Z");
};
var toDate3 = function(time) {
  if (typeof time === "number") {
    return new Date(time * 1e3);
  }
  if (typeof time === "string") {
    if (Number(time)) {
      return new Date(Number(time) * 1e3);
    }
    return new Date(time);
  }
  return time;
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/signature-v4/dist-es/SignatureV4.js
var SignatureV43 = function() {
  function SignatureV44(_a2) {
    var applyChecksum = _a2.applyChecksum, credentials = _a2.credentials, region = _a2.region, service = _a2.service, sha256 = _a2.sha256, _b2 = _a2.uriEscapePath, uriEscapePath = _b2 === void 0 ? true : _b2;
    this.service = service;
    this.sha256 = sha256;
    this.uriEscapePath = uriEscapePath;
    this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
    this.regionProvider = normalizeProvider6(region);
    this.credentialProvider = normalizeProvider6(credentials);
  }
  SignatureV44.prototype.presign = function(originalRequest, options) {
    if (options === void 0) {
      options = {};
    }
    return __awaiter3(this, void 0, void 0, function() {
      var _a2, signingDate, _b2, expiresIn, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
      return __generator3(this, function(_l) {
        switch (_l.label) {
          case 0:
            _a2 = options.signingDate, signingDate = _a2 === void 0 ? /* @__PURE__ */ new Date() : _a2, _b2 = options.expiresIn, expiresIn = _b2 === void 0 ? 3600 : _b2, unsignableHeaders = options.unsignableHeaders, unhoistableHeaders = options.unhoistableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
            return [4, this.credentialProvider()];
          case 1:
            credentials = _l.sent();
            this.validateResolvedCredentials(credentials);
            if (!(signingRegion !== null && signingRegion !== void 0))
              return [3, 2];
            _c = signingRegion;
            return [3, 4];
          case 2:
            return [4, this.regionProvider()];
          case 3:
            _c = _l.sent();
            _l.label = 4;
          case 4:
            region = _c;
            _d = formatDate3(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
            if (expiresIn > MAX_PRESIGNED_TTL3) {
              return [2, Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")];
            }
            scope = createScope3(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
            request = moveHeadersToQuery3(prepareRequest3(originalRequest), { unhoistableHeaders });
            if (credentials.sessionToken) {
              request.query[TOKEN_QUERY_PARAM4] = credentials.sessionToken;
            }
            request.query[ALGORITHM_QUERY_PARAM4] = ALGORITHM_IDENTIFIER3;
            request.query[CREDENTIAL_QUERY_PARAM4] = "".concat(credentials.accessKeyId, "/").concat(scope);
            request.query[AMZ_DATE_QUERY_PARAM4] = longDate;
            request.query[EXPIRES_QUERY_PARAM4] = expiresIn.toString(10);
            canonicalHeaders = getCanonicalHeaders4(request, unsignableHeaders, signableHeaders);
            request.query[SIGNED_HEADERS_QUERY_PARAM4] = getCanonicalHeaderList3(canonicalHeaders);
            _e = request.query;
            _f = SIGNATURE_QUERY_PARAM4;
            _g = this.getSignature;
            _h = [
              longDate,
              scope,
              this.getSigningKey(credentials, region, shortDate, signingService)
            ];
            _j = this.createCanonicalRequest;
            _k = [request, canonicalHeaders];
            return [4, getPayloadHash3(originalRequest, this.sha256)];
          case 5:
            return [4, _g.apply(this, _h.concat([_j.apply(this, _k.concat([_l.sent()]))]))];
          case 6:
            _e[_f] = _l.sent();
            return [2, request];
        }
      });
    });
  };
  SignatureV44.prototype.sign = function(toSign, options) {
    return __awaiter3(this, void 0, void 0, function() {
      return __generator3(this, function(_a2) {
        if (typeof toSign === "string") {
          return [2, this.signString(toSign, options)];
        } else if (toSign.headers && toSign.payload) {
          return [2, this.signEvent(toSign, options)];
        } else {
          return [2, this.signRequest(toSign, options)];
        }
        return [2];
      });
    });
  };
  SignatureV44.prototype.signEvent = function(_a2, _b2) {
    var headers = _a2.headers, payload = _a2.payload;
    var _c = _b2.signingDate, signingDate = _c === void 0 ? /* @__PURE__ */ new Date() : _c, priorSignature = _b2.priorSignature, signingRegion = _b2.signingRegion, signingService = _b2.signingService;
    return __awaiter3(this, void 0, void 0, function() {
      var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
      return __generator3(this, function(_g) {
        switch (_g.label) {
          case 0:
            if (!(signingRegion !== null && signingRegion !== void 0))
              return [3, 1];
            _d = signingRegion;
            return [3, 3];
          case 1:
            return [4, this.regionProvider()];
          case 2:
            _d = _g.sent();
            _g.label = 3;
          case 3:
            region = _d;
            _e = formatDate3(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
            scope = createScope3(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
            return [4, getPayloadHash3({ headers: {}, body: payload }, this.sha256)];
          case 4:
            hashedPayload = _g.sent();
            hash = new this.sha256();
            hash.update(headers);
            _f = toHex3;
            return [4, hash.digest()];
          case 5:
            hashedHeaders = _f.apply(void 0, [_g.sent()]);
            stringToSign = [
              EVENT_ALGORITHM_IDENTIFIER3,
              longDate,
              scope,
              priorSignature,
              hashedHeaders,
              hashedPayload
            ].join("\n");
            return [2, this.signString(stringToSign, { signingDate, signingRegion: region, signingService })];
        }
      });
    });
  };
  SignatureV44.prototype.signString = function(stringToSign, _a2) {
    var _b2 = _a2 === void 0 ? {} : _a2, _c = _b2.signingDate, signingDate = _c === void 0 ? /* @__PURE__ */ new Date() : _c, signingRegion = _b2.signingRegion, signingService = _b2.signingService;
    return __awaiter3(this, void 0, void 0, function() {
      var credentials, region, _d, shortDate, hash, _e, _f, _g;
      return __generator3(this, function(_h) {
        switch (_h.label) {
          case 0:
            return [4, this.credentialProvider()];
          case 1:
            credentials = _h.sent();
            this.validateResolvedCredentials(credentials);
            if (!(signingRegion !== null && signingRegion !== void 0))
              return [3, 2];
            _d = signingRegion;
            return [3, 4];
          case 2:
            return [4, this.regionProvider()];
          case 3:
            _d = _h.sent();
            _h.label = 4;
          case 4:
            region = _d;
            shortDate = formatDate3(signingDate).shortDate;
            _f = (_e = this.sha256).bind;
            return [4, this.getSigningKey(credentials, region, shortDate, signingService)];
          case 5:
            hash = new (_f.apply(_e, [void 0, _h.sent()]))();
            hash.update(stringToSign);
            _g = toHex3;
            return [4, hash.digest()];
          case 6:
            return [2, _g.apply(void 0, [_h.sent()])];
        }
      });
    });
  };
  SignatureV44.prototype.signRequest = function(requestToSign, _a2) {
    var _b2 = _a2 === void 0 ? {} : _a2, _c = _b2.signingDate, signingDate = _c === void 0 ? /* @__PURE__ */ new Date() : _c, signableHeaders = _b2.signableHeaders, unsignableHeaders = _b2.unsignableHeaders, signingRegion = _b2.signingRegion, signingService = _b2.signingService;
    return __awaiter3(this, void 0, void 0, function() {
      var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
      return __generator3(this, function(_f) {
        switch (_f.label) {
          case 0:
            return [4, this.credentialProvider()];
          case 1:
            credentials = _f.sent();
            this.validateResolvedCredentials(credentials);
            if (!(signingRegion !== null && signingRegion !== void 0))
              return [3, 2];
            _d = signingRegion;
            return [3, 4];
          case 2:
            return [4, this.regionProvider()];
          case 3:
            _d = _f.sent();
            _f.label = 4;
          case 4:
            region = _d;
            request = prepareRequest3(requestToSign);
            _e = formatDate3(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
            scope = createScope3(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
            request.headers[AMZ_DATE_HEADER4] = longDate;
            if (credentials.sessionToken) {
              request.headers[TOKEN_HEADER4] = credentials.sessionToken;
            }
            return [4, getPayloadHash3(request, this.sha256)];
          case 5:
            payloadHash = _f.sent();
            if (!hasHeader3(SHA256_HEADER4, request.headers) && this.applyChecksum) {
              request.headers[SHA256_HEADER4] = payloadHash;
            }
            canonicalHeaders = getCanonicalHeaders4(request, unsignableHeaders, signableHeaders);
            return [4, this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))];
          case 6:
            signature = _f.sent();
            request.headers[AUTH_HEADER4] = "".concat(ALGORITHM_IDENTIFIER3, " ") + "Credential=".concat(credentials.accessKeyId, "/").concat(scope, ", ") + "SignedHeaders=".concat(getCanonicalHeaderList3(canonicalHeaders), ", ") + "Signature=".concat(signature);
            return [2, request];
        }
      });
    });
  };
  SignatureV44.prototype.createCanonicalRequest = function(request, canonicalHeaders, payloadHash) {
    var sortedHeaders = Object.keys(canonicalHeaders).sort();
    return "".concat(request.method, "\n").concat(this.getCanonicalPath(request), "\n").concat(getCanonicalQuery3(request), "\n").concat(sortedHeaders.map(function(name) {
      return "".concat(name, ":").concat(canonicalHeaders[name]);
    }).join("\n"), "\n\n").concat(sortedHeaders.join(";"), "\n").concat(payloadHash);
  };
  SignatureV44.prototype.createStringToSign = function(longDate, credentialScope, canonicalRequest) {
    return __awaiter3(this, void 0, void 0, function() {
      var hash, hashedRequest;
      return __generator3(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            hash = new this.sha256();
            hash.update(canonicalRequest);
            return [4, hash.digest()];
          case 1:
            hashedRequest = _a2.sent();
            return [2, "".concat(ALGORITHM_IDENTIFIER3, "\n").concat(longDate, "\n").concat(credentialScope, "\n").concat(toHex3(hashedRequest))];
        }
      });
    });
  };
  SignatureV44.prototype.getCanonicalPath = function(_a2) {
    var e_1, _b2;
    var path = _a2.path;
    if (this.uriEscapePath) {
      var normalizedPathSegments = [];
      try {
        for (var _c = __values4(path.split("/")), _d = _c.next(); !_d.done; _d = _c.next()) {
          var pathSegment = _d.value;
          if ((pathSegment === null || pathSegment === void 0 ? void 0 : pathSegment.length) === 0)
            continue;
          if (pathSegment === ".")
            continue;
          if (pathSegment === "..") {
            normalizedPathSegments.pop();
          } else {
            normalizedPathSegments.push(pathSegment);
          }
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (_d && !_d.done && (_b2 = _c.return))
            _b2.call(_c);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
      var normalizedPath = "".concat((path === null || path === void 0 ? void 0 : path.startsWith("/")) ? "/" : "").concat(normalizedPathSegments.join("/")).concat(normalizedPathSegments.length > 0 && (path === null || path === void 0 ? void 0 : path.endsWith("/")) ? "/" : "");
      var doubleEncoded = encodeURIComponent(normalizedPath);
      return doubleEncoded.replace(/%2F/g, "/");
    }
    return path;
  };
  SignatureV44.prototype.getSignature = function(longDate, credentialScope, keyPromise, canonicalRequest) {
    return __awaiter3(this, void 0, void 0, function() {
      var stringToSign, hash, _a2, _b2, _c;
      return __generator3(this, function(_d) {
        switch (_d.label) {
          case 0:
            return [4, this.createStringToSign(longDate, credentialScope, canonicalRequest)];
          case 1:
            stringToSign = _d.sent();
            _b2 = (_a2 = this.sha256).bind;
            return [4, keyPromise];
          case 2:
            hash = new (_b2.apply(_a2, [void 0, _d.sent()]))();
            hash.update(stringToSign);
            _c = toHex3;
            return [4, hash.digest()];
          case 3:
            return [2, _c.apply(void 0, [_d.sent()])];
        }
      });
    });
  };
  SignatureV44.prototype.getSigningKey = function(credentials, region, shortDate, service) {
    return getSigningKey4(this.sha256, credentials, shortDate, region, service || this.service);
  };
  SignatureV44.prototype.validateResolvedCredentials = function(credentials) {
    if (typeof credentials !== "object" || typeof credentials.accessKeyId !== "string" || typeof credentials.secretAccessKey !== "string") {
      throw new Error("Resolved credential object is not valid");
    }
  };
  return SignatureV44;
}();
var formatDate3 = function(now) {
  var longDate = iso86013(now).replace(/[\-:]/g, "");
  return {
    longDate,
    shortDate: longDate.slice(0, 8)
  };
};
var getCanonicalHeaderList3 = function(headers) {
  return Object.keys(headers).sort().join(";");
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-signing/dist-es/configurations.js
var CREDENTIAL_EXPIRE_WINDOW2 = 3e5;
var resolveAwsAuthConfig7 = function(input) {
  var normalizedCreds = input.credentials ? normalizeCredentialProvider2(input.credentials) : input.credentialDefaultProvider(input);
  var _a2 = input.signingEscapePath, signingEscapePath = _a2 === void 0 ? true : _a2, _b2 = input.systemClockOffset, systemClockOffset = _b2 === void 0 ? input.systemClockOffset || 0 : _b2, sha256 = input.sha256;
  var signer;
  if (input.signer) {
    signer = normalizeProvider6(input.signer);
  } else if (input.regionInfoProvider) {
    signer = function() {
      return normalizeProvider6(input.region)().then(function(region) {
        return __awaiter3(void 0, void 0, void 0, function() {
          var _a3, _b3, _c;
          var _d;
          return __generator3(this, function(_e) {
            switch (_e.label) {
              case 0:
                _b3 = (_a3 = input).regionInfoProvider;
                _c = [region];
                _d = {};
                return [4, input.useFipsEndpoint()];
              case 1:
                _d.useFipsEndpoint = _e.sent();
                return [4, input.useDualstackEndpoint()];
              case 2:
                return [4, _b3.apply(_a3, _c.concat([(_d.useDualstackEndpoint = _e.sent(), _d)]))];
              case 3:
                return [2, [
                  _e.sent() || {},
                  region
                ]];
            }
          });
        });
      }).then(function(_a3) {
        var _b3 = __read10(_a3, 2), regionInfo = _b3[0], region = _b3[1];
        var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
        input.signingRegion = input.signingRegion || signingRegion || region;
        input.signingName = input.signingName || signingService || input.serviceId;
        var params = __assign7(__assign7({}, input), { credentials: normalizedCreds, region: input.signingRegion, service: input.signingName, sha256, uriEscapePath: signingEscapePath });
        var SignerCtor = input.signerConstructor || SignatureV43;
        return new SignerCtor(params);
      });
    };
  } else {
    signer = function(authScheme) {
      return __awaiter3(void 0, void 0, void 0, function() {
        var signingRegion, signingService, params, SignerCtor;
        return __generator3(this, function(_a3) {
          if (!authScheme) {
            throw new Error("Unexpected empty auth scheme config");
          }
          signingRegion = authScheme.signingScope;
          signingService = authScheme.signingName;
          input.signingRegion = input.signingRegion || signingRegion;
          input.signingName = input.signingName || signingService || input.serviceId;
          params = __assign7(__assign7({}, input), { credentials: normalizedCreds, region: input.signingRegion, service: input.signingName, sha256, uriEscapePath: signingEscapePath });
          SignerCtor = input.signerConstructor || SignatureV43;
          return [2, new SignerCtor(params)];
        });
      });
    };
  }
  return __assign7(__assign7({}, input), { systemClockOffset, signingEscapePath, credentials: normalizedCreds, signer });
};
var normalizeCredentialProvider2 = function(credentials) {
  if (typeof credentials === "function") {
    return memoize3(credentials, function(credentials2) {
      return credentials2.expiration !== void 0 && credentials2.expiration.getTime() - Date.now() < CREDENTIAL_EXPIRE_WINDOW2;
    }, function(credentials2) {
      return credentials2.expiration !== void 0;
    });
  }
  return normalizeProvider6(credentials);
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-signing/dist-es/utils/getSkewCorrectedDate.js
var getSkewCorrectedDate8 = function(systemClockOffset) {
  return new Date(Date.now() + systemClockOffset);
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-signing/dist-es/utils/isClockSkewed.js
var isClockSkewed8 = function(clockTime, systemClockOffset) {
  return Math.abs(getSkewCorrectedDate8(systemClockOffset).getTime() - clockTime) >= 3e5;
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-signing/dist-es/utils/getUpdatedSystemClockOffset.js
var getUpdatedSystemClockOffset3 = function(clockTime, currentSystemClockOffset) {
  var clockTimeInMs = Date.parse(clockTime);
  if (isClockSkewed8(clockTimeInMs, currentSystemClockOffset)) {
    return clockTimeInMs - Date.now();
  }
  return currentSystemClockOffset;
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-signing/dist-es/middleware.js
var awsAuthMiddleware7 = function(options) {
  return function(next, context) {
    return function(args) {
      var _a2, _b2, _c;
      return __awaiter3(this, void 0, void 0, function() {
        var authScheme, signer, output, _d, _e, dateHeader;
        var _f;
        return __generator3(this, function(_g) {
          switch (_g.label) {
            case 0:
              if (!HttpRequest3.isInstance(args.request))
                return [2, next(args)];
              authScheme = (_c = (_b2 = (_a2 = context.endpointV2) === null || _a2 === void 0 ? void 0 : _a2.properties) === null || _b2 === void 0 ? void 0 : _b2.authSchemes) === null || _c === void 0 ? void 0 : _c[0];
              return [4, options.signer(authScheme)];
            case 1:
              signer = _g.sent();
              _d = next;
              _e = [__assign7({}, args)];
              _f = {};
              return [4, signer.sign(args.request, {
                signingDate: getSkewCorrectedDate8(options.systemClockOffset),
                signingRegion: context["signing_region"],
                signingService: context["signing_service"]
              })];
            case 2:
              return [4, _d.apply(void 0, [__assign7.apply(void 0, _e.concat([(_f.request = _g.sent(), _f)]))]).catch(function(error) {
                var _a3;
                var serverTime = (_a3 = error.ServerTime) !== null && _a3 !== void 0 ? _a3 : getDateHeader3(error.$response);
                if (serverTime) {
                  options.systemClockOffset = getUpdatedSystemClockOffset3(serverTime, options.systemClockOffset);
                }
                throw error;
              })];
            case 3:
              output = _g.sent();
              dateHeader = getDateHeader3(output.response);
              if (dateHeader) {
                options.systemClockOffset = getUpdatedSystemClockOffset3(dateHeader, options.systemClockOffset);
              }
              return [2, output];
          }
        });
      });
    };
  };
};
var getDateHeader3 = function(response) {
  var _a2, _b2, _c;
  return HttpResponse3.isInstance(response) ? (_b2 = (_a2 = response.headers) === null || _a2 === void 0 ? void 0 : _a2.date) !== null && _b2 !== void 0 ? _b2 : (_c = response.headers) === null || _c === void 0 ? void 0 : _c.Date : void 0;
};
var awsAuthMiddlewareOptions7 = {
  name: "awsAuthMiddleware",
  tags: ["SIGNATURE", "AWSAUTH"],
  relation: "after",
  toMiddleware: "retryMiddleware",
  override: true
};
var getAwsAuthPlugin7 = function(options) {
  return {
    applyToStack: function(clientStack) {
      clientStack.addRelativeTo(awsAuthMiddleware7(options), awsAuthMiddlewareOptions7);
    }
  };
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-user-agent/dist-es/configurations.js
function resolveUserAgentConfig7(input) {
  return __assign7(__assign7({}, input), { customUserAgent: typeof input.customUserAgent === "string" ? [[input.customUserAgent]] : input.customUserAgent });
}

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-user-agent/dist-es/constants.js
var USER_AGENT7 = "user-agent";
var X_AMZ_USER_AGENT7 = "x-amz-user-agent";
var SPACE7 = " ";
var UA_ESCAPE_REGEX7 = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/middleware-user-agent/dist-es/user-agent-middleware.js
var userAgentMiddleware8 = function(options) {
  return function(next, context) {
    return function(args) {
      return __awaiter3(void 0, void 0, void 0, function() {
        var request, headers, userAgent2, defaultUserAgent8, customUserAgent, sdkUserAgentValue, normalUAValue;
        var _a2, _b2;
        return __generator3(this, function(_c) {
          switch (_c.label) {
            case 0:
              request = args.request;
              if (!HttpRequest3.isInstance(request))
                return [2, next(args)];
              headers = request.headers;
              userAgent2 = ((_a2 = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a2 === void 0 ? void 0 : _a2.map(escapeUserAgent7)) || [];
              return [4, options.defaultUserAgentProvider()];
            case 1:
              defaultUserAgent8 = _c.sent().map(escapeUserAgent7);
              customUserAgent = ((_b2 = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b2 === void 0 ? void 0 : _b2.map(escapeUserAgent7)) || [];
              sdkUserAgentValue = __spreadArray4(__spreadArray4(__spreadArray4([], __read10(defaultUserAgent8), false), __read10(userAgent2), false), __read10(customUserAgent), false).join(SPACE7);
              normalUAValue = __spreadArray4(__spreadArray4([], __read10(defaultUserAgent8.filter(function(section) {
                return section.startsWith("aws-sdk-");
              })), false), __read10(customUserAgent), false).join(SPACE7);
              if (options.runtime !== "browser") {
                if (normalUAValue) {
                  headers[X_AMZ_USER_AGENT7] = headers[X_AMZ_USER_AGENT7] ? "".concat(headers[USER_AGENT7], " ").concat(normalUAValue) : normalUAValue;
                }
                headers[USER_AGENT7] = sdkUserAgentValue;
              } else {
                headers[X_AMZ_USER_AGENT7] = sdkUserAgentValue;
              }
              return [2, next(__assign7(__assign7({}, args), { request }))];
          }
        });
      });
    };
  };
};
var escapeUserAgent7 = function(_a2) {
  var _b2 = __read10(_a2, 2), name = _b2[0], version3 = _b2[1];
  var prefixSeparatorIndex = name.indexOf("/");
  var prefix = name.substring(0, prefixSeparatorIndex);
  var uaName = name.substring(prefixSeparatorIndex + 1);
  if (prefix === "api") {
    uaName = uaName.toLowerCase();
  }
  return [prefix, uaName, version3].filter(function(item) {
    return item && item.length > 0;
  }).map(function(item) {
    return item === null || item === void 0 ? void 0 : item.replace(UA_ESCAPE_REGEX7, "_");
  }).join("/");
};
var getUserAgentMiddlewareOptions7 = {
  name: "getUserAgentMiddleware",
  step: "build",
  priority: "low",
  tags: ["SET_USER_AGENT", "USER_AGENT"],
  override: true
};
var getUserAgentPlugin7 = function(config) {
  return {
    applyToStack: function(clientStack) {
      clientStack.add(userAgentMiddleware8(config), getUserAgentMiddlewareOptions7);
    }
  };
};

// node_modules/@aws-sdk/client-location/package.json
var package_default7 = {
  name: "@aws-sdk/client-location",
  description: "AWS SDK for JavaScript Location Client for Node.js, Browser and React Native",
  version: "3.186.2",
  scripts: {
    build: "concurrently 'yarn:build:cjs' 'yarn:build:es' 'yarn:build:types'",
    "build:cjs": "tsc -p tsconfig.cjs.json",
    "build:docs": "typedoc",
    "build:es": "tsc -p tsconfig.es.json",
    "build:include:deps": "lerna run --scope $npm_package_name --include-dependencies build",
    "build:types": "tsc -p tsconfig.types.json",
    "build:types:downlevel": "downlevel-dts dist-types dist-types/ts3.4",
    clean: "rimraf ./dist-* && rimraf *.tsbuildinfo"
  },
  main: "./dist-cjs/index.js",
  types: "./dist-types/index.d.ts",
  module: "./dist-es/index.js",
  sideEffects: false,
  dependencies: {
    "@aws-crypto/sha256-browser": "2.0.0",
    "@aws-crypto/sha256-js": "2.0.0",
    "@aws-sdk/client-sts": "3.186.2",
    "@aws-sdk/config-resolver": "3.186.0",
    "@aws-sdk/credential-provider-node": "3.186.0",
    "@aws-sdk/fetch-http-handler": "3.186.0",
    "@aws-sdk/hash-node": "3.186.0",
    "@aws-sdk/invalid-dependency": "3.186.0",
    "@aws-sdk/middleware-content-length": "3.186.0",
    "@aws-sdk/middleware-host-header": "3.186.0",
    "@aws-sdk/middleware-logger": "3.186.0",
    "@aws-sdk/middleware-recursion-detection": "3.186.0",
    "@aws-sdk/middleware-retry": "3.186.0",
    "@aws-sdk/middleware-serde": "3.186.0",
    "@aws-sdk/middleware-signing": "3.186.0",
    "@aws-sdk/middleware-stack": "3.186.0",
    "@aws-sdk/middleware-user-agent": "3.186.0",
    "@aws-sdk/node-config-provider": "3.186.0",
    "@aws-sdk/node-http-handler": "3.186.0",
    "@aws-sdk/protocol-http": "3.186.0",
    "@aws-sdk/smithy-client": "3.186.0",
    "@aws-sdk/types": "3.186.0",
    "@aws-sdk/url-parser": "3.186.0",
    "@aws-sdk/util-base64-browser": "3.186.0",
    "@aws-sdk/util-base64-node": "3.186.0",
    "@aws-sdk/util-body-length-browser": "3.186.0",
    "@aws-sdk/util-body-length-node": "3.186.0",
    "@aws-sdk/util-defaults-mode-browser": "3.186.0",
    "@aws-sdk/util-defaults-mode-node": "3.186.0",
    "@aws-sdk/util-user-agent-browser": "3.186.0",
    "@aws-sdk/util-user-agent-node": "3.186.0",
    "@aws-sdk/util-utf8-browser": "3.186.0",
    "@aws-sdk/util-utf8-node": "3.186.0",
    tslib: "^2.3.1"
  },
  devDependencies: {
    "@aws-sdk/service-client-documentation-generator": "3.186.0",
    "@tsconfig/recommended": "1.0.1",
    "@types/node": "^12.7.5",
    concurrently: "7.0.0",
    "downlevel-dts": "0.10.1",
    rimraf: "3.0.2",
    typedoc: "0.19.2",
    typescript: "~4.6.2"
  },
  overrides: {
    typedoc: {
      typescript: "~4.6.2"
    }
  },
  engines: {
    node: ">=12.0.0"
  },
  typesVersions: {
    "<4.0": {
      "dist-types/*": [
        "dist-types/ts3.4/*"
      ]
    }
  },
  files: [
    "dist-*"
  ],
  author: {
    name: "AWS SDK for JavaScript Team",
    url: "https://aws.amazon.com/javascript/"
  },
  license: "Apache-2.0",
  browser: {
    "./dist-es/runtimeConfig": "./dist-es/runtimeConfig.browser"
  },
  "react-native": {
    "./dist-es/runtimeConfig": "./dist-es/runtimeConfig.native"
  },
  homepage: "https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-location",
  repository: {
    type: "git",
    url: "https://github.com/aws/aws-sdk-js-v3.git",
    directory: "clients/client-location"
  }
};

// node_modules/@aws-sdk/client-location/dist-es/runtimeConfig.browser.js
var import_sha256_browser7 = __toESM(require_build43());

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/querystring-builder/dist-es/index.js
function buildQueryString3(query) {
  var e_1, _a2;
  var parts = [];
  try {
    for (var _b2 = __values4(Object.keys(query).sort()), _c = _b2.next(); !_c.done; _c = _b2.next()) {
      var key = _c.value;
      var value = query[key];
      key = escapeUri4(key);
      if (Array.isArray(value)) {
        for (var i2 = 0, iLen = value.length; i2 < iLen; i2++) {
          parts.push("".concat(key, "=").concat(escapeUri4(value[i2])));
        }
      } else {
        var qsEntry = key;
        if (value || typeof value === "string") {
          qsEntry += "=".concat(escapeUri4(value));
        }
        parts.push(qsEntry);
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_c && !_c.done && (_a2 = _b2.return))
        _a2.call(_b2);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return parts.join("&");
}

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/fetch-http-handler/dist-es/request-timeout.js
function requestTimeout4(timeoutInMs) {
  if (timeoutInMs === void 0) {
    timeoutInMs = 0;
  }
  return new Promise(function(resolve, reject) {
    if (timeoutInMs) {
      setTimeout(function() {
        var timeoutError = new Error("Request did not complete within ".concat(timeoutInMs, " ms"));
        timeoutError.name = "TimeoutError";
        reject(timeoutError);
      }, timeoutInMs);
    }
  });
}

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/fetch-http-handler/dist-es/fetch-http-handler.js
var FetchHttpHandler3 = function() {
  function FetchHttpHandler4(options) {
    if (typeof options === "function") {
      this.configProvider = options().then(function(opts) {
        return opts || {};
      });
    } else {
      this.config = options !== null && options !== void 0 ? options : {};
      this.configProvider = Promise.resolve(this.config);
    }
  }
  FetchHttpHandler4.prototype.destroy = function() {
  };
  FetchHttpHandler4.prototype.handle = function(request, _a2) {
    var _b2 = _a2 === void 0 ? {} : _a2, abortSignal = _b2.abortSignal;
    return __awaiter3(this, void 0, void 0, function() {
      var _c, requestTimeoutInMs, abortError, path, queryString, port, method, url2, body, requestOptions, fetchRequest, raceOfPromises;
      return __generator3(this, function(_d) {
        switch (_d.label) {
          case 0:
            if (!!this.config)
              return [3, 2];
            _c = this;
            return [4, this.configProvider];
          case 1:
            _c.config = _d.sent();
            _d.label = 2;
          case 2:
            requestTimeoutInMs = this.config.requestTimeout;
            if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
              abortError = new Error("Request aborted");
              abortError.name = "AbortError";
              return [2, Promise.reject(abortError)];
            }
            path = request.path;
            if (request.query) {
              queryString = buildQueryString3(request.query);
              if (queryString) {
                path += "?".concat(queryString);
              }
            }
            port = request.port, method = request.method;
            url2 = "".concat(request.protocol, "//").concat(request.hostname).concat(port ? ":".concat(port) : "").concat(path);
            body = method === "GET" || method === "HEAD" ? void 0 : request.body;
            requestOptions = {
              body,
              headers: new Headers(request.headers),
              method
            };
            if (typeof AbortController !== "undefined") {
              requestOptions["signal"] = abortSignal;
            }
            fetchRequest = new Request(url2, requestOptions);
            raceOfPromises = [
              fetch(fetchRequest).then(function(response) {
                var e_1, _a3;
                var fetchHeaders = response.headers;
                var transformedHeaders = {};
                try {
                  for (var _b3 = __values4(fetchHeaders.entries()), _c2 = _b3.next(); !_c2.done; _c2 = _b3.next()) {
                    var pair = _c2.value;
                    transformedHeaders[pair[0]] = pair[1];
                  }
                } catch (e_1_1) {
                  e_1 = { error: e_1_1 };
                } finally {
                  try {
                    if (_c2 && !_c2.done && (_a3 = _b3.return))
                      _a3.call(_b3);
                  } finally {
                    if (e_1)
                      throw e_1.error;
                  }
                }
                var hasReadableStream = response.body !== void 0;
                if (!hasReadableStream) {
                  return response.blob().then(function(body2) {
                    return {
                      response: new HttpResponse3({
                        headers: transformedHeaders,
                        statusCode: response.status,
                        body: body2
                      })
                    };
                  });
                }
                return {
                  response: new HttpResponse3({
                    headers: transformedHeaders,
                    statusCode: response.status,
                    body: response.body
                  })
                };
              }),
              requestTimeout4(requestTimeoutInMs)
            ];
            if (abortSignal) {
              raceOfPromises.push(new Promise(function(resolve, reject) {
                abortSignal.onabort = function() {
                  var abortError2 = new Error("Request aborted");
                  abortError2.name = "AbortError";
                  reject(abortError2);
                };
              }));
            }
            return [2, Promise.race(raceOfPromises)];
        }
      });
    });
  };
  return FetchHttpHandler4;
}();

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/util-base64-browser/dist-es/index.js
var alphabetByEncoding3 = {};
var alphabetByValue3 = new Array(64);
for (i2 = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i2 + start <= limit; i2++) {
  char = String.fromCharCode(i2 + start);
  alphabetByEncoding3[char] = i2;
  alphabetByValue3[i2] = char;
}
var char;
var i2;
var start;
var limit;
for (i2 = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i2 + start <= limit; i2++) {
  char = String.fromCharCode(i2 + start);
  index = i2 + 26;
  alphabetByEncoding3[char] = index;
  alphabetByValue3[index] = char;
}
var char;
var index;
var i2;
var start;
var limit;
for (i2 = 0; i2 < 10; i2++) {
  alphabetByEncoding3[i2.toString(10)] = i2 + 52;
  char = i2.toString(10);
  index = i2 + 52;
  alphabetByEncoding3[char] = index;
  alphabetByValue3[index] = char;
}
var char;
var index;
var i2;
alphabetByEncoding3["+"] = 62;
alphabetByValue3[62] = "+";
alphabetByEncoding3["/"] = 63;
alphabetByValue3[63] = "/";
var bitsPerLetter3 = 6;
var bitsPerByte3 = 8;
var maxLetterValue3 = 63;
function fromBase643(input) {
  var totalByteLength = input.length / 4 * 3;
  if (input.slice(-2) === "==") {
    totalByteLength -= 2;
  } else if (input.slice(-1) === "=") {
    totalByteLength--;
  }
  var out = new ArrayBuffer(totalByteLength);
  var dataView = new DataView(out);
  for (var i2 = 0; i2 < input.length; i2 += 4) {
    var bits = 0;
    var bitLength = 0;
    for (var j2 = i2, limit = i2 + 3; j2 <= limit; j2++) {
      if (input[j2] !== "=") {
        if (!(input[j2] in alphabetByEncoding3)) {
          throw new TypeError("Invalid character ".concat(input[j2], " in base64 string."));
        }
        bits |= alphabetByEncoding3[input[j2]] << (limit - j2) * bitsPerLetter3;
        bitLength += bitsPerLetter3;
      } else {
        bits >>= bitsPerLetter3;
      }
    }
    var chunkOffset = i2 / 4 * 3;
    bits >>= bitLength % bitsPerByte3;
    var byteLength2 = Math.floor(bitLength / bitsPerByte3);
    for (var k2 = 0; k2 < byteLength2; k2++) {
      var offset = (byteLength2 - k2 - 1) * bitsPerByte3;
      dataView.setUint8(chunkOffset + k2, (bits & 255 << offset) >> offset);
    }
  }
  return new Uint8Array(out);
}
function toBase643(input) {
  var str = "";
  for (var i2 = 0; i2 < input.length; i2 += 3) {
    var bits = 0;
    var bitLength = 0;
    for (var j2 = i2, limit = Math.min(i2 + 3, input.length); j2 < limit; j2++) {
      bits |= input[j2] << (limit - j2 - 1) * bitsPerByte3;
      bitLength += bitsPerByte3;
    }
    var bitClusterCount = Math.ceil(bitLength / bitsPerLetter3);
    bits <<= bitClusterCount * bitsPerLetter3 - bitLength;
    for (var k2 = 1; k2 <= bitClusterCount; k2++) {
      var offset = (bitClusterCount - k2) * bitsPerLetter3;
      str += alphabetByValue3[(bits & maxLetterValue3 << offset) >> offset];
    }
    str += "==".slice(0, 4 - bitClusterCount);
  }
  return str;
}

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/fetch-http-handler/dist-es/stream-collector.js
var streamCollector3 = function(stream) {
  if (typeof Blob === "function" && stream instanceof Blob) {
    return collectBlob3(stream);
  }
  return collectStream3(stream);
};
function collectBlob3(blob) {
  return __awaiter3(this, void 0, void 0, function() {
    var base64, arrayBuffer;
    return __generator3(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, readToBase643(blob)];
        case 1:
          base64 = _a2.sent();
          arrayBuffer = fromBase643(base64);
          return [2, new Uint8Array(arrayBuffer)];
      }
    });
  });
}
function collectStream3(stream) {
  return __awaiter3(this, void 0, void 0, function() {
    var res, reader, isDone, _a2, done, value, prior;
    return __generator3(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          res = new Uint8Array(0);
          reader = stream.getReader();
          isDone = false;
          _b2.label = 1;
        case 1:
          if (!!isDone)
            return [3, 3];
          return [4, reader.read()];
        case 2:
          _a2 = _b2.sent(), done = _a2.done, value = _a2.value;
          if (value) {
            prior = res;
            res = new Uint8Array(prior.length + value.length);
            res.set(prior);
            res.set(value, prior.length);
          }
          isDone = done;
          return [3, 1];
        case 3:
          return [2, res];
      }
    });
  });
}
function readToBase643(blob) {
  return new Promise(function(resolve, reject) {
    var reader = new FileReader();
    reader.onloadend = function() {
      var _a2;
      if (reader.readyState !== 2) {
        return reject(new Error("Reader aborted too early"));
      }
      var result = (_a2 = reader.result) !== null && _a2 !== void 0 ? _a2 : "";
      var commaIndex = result.indexOf(",");
      var dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
      resolve(result.substring(dataOffset));
    };
    reader.onabort = function() {
      return reject(new Error("Read aborted"));
    };
    reader.onerror = function() {
      return reject(reader.error);
    };
    reader.readAsDataURL(blob);
  });
}

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/invalid-dependency/dist-es/invalidProvider.js
var invalidProvider3 = function(message) {
  return function() {
    return Promise.reject(message);
  };
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/util-body-length-browser/dist-es/calculateBodyLength.js
var calculateBodyLength3 = function(body) {
  if (typeof body === "string") {
    var len = body.length;
    for (var i2 = len - 1; i2 >= 0; i2--) {
      var code = body.charCodeAt(i2);
      if (code > 127 && code <= 2047)
        len++;
      else if (code > 2047 && code <= 65535)
        len += 2;
      if (code >= 56320 && code <= 57343)
        i2--;
    }
    return len;
  } else if (typeof body.byteLength === "number") {
    return body.byteLength;
  } else if (typeof body.size === "number") {
    return body.size;
  }
  throw new Error("Body Length computation failed for ".concat(body));
};

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/util-user-agent-browser/dist-es/index.js
var defaultUserAgent7 = function(_a2) {
  var serviceId = _a2.serviceId, clientVersion = _a2.clientVersion;
  return function() {
    return __awaiter3(void 0, void 0, void 0, function() {
      var parsedUA, sections;
      var _a3, _b2, _c, _d, _e, _f, _g;
      return __generator3(this, function(_h) {
        parsedUA = typeof window !== "undefined" && ((_a3 = window === null || window === void 0 ? void 0 : window.navigator) === null || _a3 === void 0 ? void 0 : _a3.userAgent) ? bowser_default.parse(window.navigator.userAgent) : void 0;
        sections = [
          ["aws-sdk-js", clientVersion],
          ["os/".concat(((_b2 = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b2 === void 0 ? void 0 : _b2.name) || "other"), (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version],
          ["lang/js"],
          ["md/browser", "".concat((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown", "_").concat((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")]
        ];
        if (serviceId) {
          sections.push(["api/".concat(serviceId), clientVersion]);
        }
        return [2, sections];
      });
    });
  };
};

// node_modules/@aws-sdk/client-location/dist-es/runtimeConfig.browser.js
init_dist_es4();

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/querystring-parser/dist-es/index.js
function parseQueryString3(querystring) {
  var e_1, _a2;
  var query = {};
  querystring = querystring.replace(/^\?/, "");
  if (querystring) {
    try {
      for (var _b2 = __values4(querystring.split("&")), _c = _b2.next(); !_c.done; _c = _b2.next()) {
        var pair = _c.value;
        var _d = __read10(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
        key = decodeURIComponent(key);
        if (value) {
          value = decodeURIComponent(value);
        }
        if (!(key in query)) {
          query[key] = value;
        } else if (Array.isArray(query[key])) {
          query[key].push(value);
        } else {
          query[key] = [query[key], value];
        }
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (_c && !_c.done && (_a2 = _b2.return))
          _a2.call(_b2);
      } finally {
        if (e_1)
          throw e_1.error;
      }
    }
  }
  return query;
}

// node_modules/@aws-sdk/client-location/node_modules/@aws-sdk/url-parser/dist-es/index.js
var parseUrl3 = function(url2) {
  if (typeof url2 === "string") {
    return parseUrl3(new URL(url2));
  }
  var _a2 = url2, hostname = _a2.hostname, pathname = _a2.pathname, port = _a2.port, protocol = _a2.protocol, search = _a2.search;
  var query;
  if (search) {
    query = parseQueryString3(search);
  }
  return {
    hostname,
    port: port ? parseInt(port) : void 0,
    protocol,
    path: pathname,
    query
  };
};

// node_modules/@aws-sdk/client-location/dist-es/endpoints.js
var regionHash2 = {};
var partitionHash2 = {
  aws: {
    regions: [
      "af-south-1",
      "ap-east-1",
      "ap-northeast-1",
      "ap-northeast-2",
      "ap-northeast-3",
      "ap-south-1",
      "ap-southeast-1",
      "ap-southeast-2",
      "ap-southeast-3",
      "ca-central-1",
      "eu-central-1",
      "eu-north-1",
      "eu-south-1",
      "eu-west-1",
      "eu-west-2",
      "eu-west-3",
      "me-central-1",
      "me-south-1",
      "sa-east-1",
      "us-east-1",
      "us-east-2",
      "us-west-1",
      "us-west-2"
    ],
    regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
    variants: [
      {
        hostname: "geo.{region}.amazonaws.com",
        tags: []
      },
      {
        hostname: "geo-fips.{region}.amazonaws.com",
        tags: ["fips"]
      },
      {
        hostname: "geo-fips.{region}.api.aws",
        tags: ["dualstack", "fips"]
      },
      {
        hostname: "geo.{region}.api.aws",
        tags: ["dualstack"]
      }
    ]
  },
  "aws-cn": {
    regions: ["cn-north-1", "cn-northwest-1"],
    regionRegex: "^cn\\-\\w+\\-\\d+$",
    variants: [
      {
        hostname: "geo.{region}.amazonaws.com.cn",
        tags: []
      },
      {
        hostname: "geo-fips.{region}.amazonaws.com.cn",
        tags: ["fips"]
      },
      {
        hostname: "geo-fips.{region}.api.amazonwebservices.com.cn",
        tags: ["dualstack", "fips"]
      },
      {
        hostname: "geo.{region}.api.amazonwebservices.com.cn",
        tags: ["dualstack"]
      }
    ]
  },
  "aws-iso": {
    regions: ["us-iso-east-1", "us-iso-west-1"],
    regionRegex: "^us\\-iso\\-\\w+\\-\\d+$",
    variants: [
      {
        hostname: "geo.{region}.c2s.ic.gov",
        tags: []
      },
      {
        hostname: "geo-fips.{region}.c2s.ic.gov",
        tags: ["fips"]
      }
    ]
  },
  "aws-iso-b": {
    regions: ["us-isob-east-1"],
    regionRegex: "^us\\-isob\\-\\w+\\-\\d+$",
    variants: [
      {
        hostname: "geo.{region}.sc2s.sgov.gov",
        tags: []
      },
      {
        hostname: "geo-fips.{region}.sc2s.sgov.gov",
        tags: ["fips"]
      }
    ]
  },
  "aws-us-gov": {
    regions: ["us-gov-east-1", "us-gov-west-1"],
    regionRegex: "^us\\-gov\\-\\w+\\-\\d+$",
    variants: [
      {
        hostname: "geo.{region}.amazonaws.com",
        tags: []
      },
      {
        hostname: "geo-fips.{region}.amazonaws.com",
        tags: ["fips"]
      },
      {
        hostname: "geo-fips.{region}.api.aws",
        tags: ["dualstack", "fips"]
      },
      {
        hostname: "geo.{region}.api.aws",
        tags: ["dualstack"]
      }
    ]
  }
};
var defaultRegionInfoProvider7 = function(region, options) {
  return __awaiter3(void 0, void 0, void 0, function() {
    return __generator3(this, function(_a2) {
      return [2, getRegionInfo2(region, __assign7(__assign7({}, options), { signingService: "geo", regionHash: regionHash2, partitionHash: partitionHash2 }))];
    });
  });
};

// node_modules/@aws-sdk/client-location/dist-es/runtimeConfig.shared.js
var getRuntimeConfig3 = function(config) {
  var _a2, _b2, _c, _d, _e;
  return {
    apiVersion: "2020-11-19",
    disableHostPrefix: (_a2 = config === null || config === void 0 ? void 0 : config.disableHostPrefix) !== null && _a2 !== void 0 ? _a2 : false,
    logger: (_b2 = config === null || config === void 0 ? void 0 : config.logger) !== null && _b2 !== void 0 ? _b2 : {},
    regionInfoProvider: (_c = config === null || config === void 0 ? void 0 : config.regionInfoProvider) !== null && _c !== void 0 ? _c : defaultRegionInfoProvider7,
    serviceId: (_d = config === null || config === void 0 ? void 0 : config.serviceId) !== null && _d !== void 0 ? _d : "Location",
    urlParser: (_e = config === null || config === void 0 ? void 0 : config.urlParser) !== null && _e !== void 0 ? _e : parseUrl3
  };
};

// node_modules/@aws-sdk/client-location/dist-es/runtimeConfig.browser.js
var getRuntimeConfig4 = function(config) {
  var _a2, _b2, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
  var defaultsMode = resolveDefaultsModeConfig(config);
  var defaultConfigProvider = function() {
    return defaultsMode().then(loadConfigsForDefaultMode2);
  };
  var clientSharedValues = getRuntimeConfig3(config);
  return __assign7(__assign7(__assign7({}, clientSharedValues), config), { runtime: "browser", defaultsMode, base64Decoder: (_a2 = config === null || config === void 0 ? void 0 : config.base64Decoder) !== null && _a2 !== void 0 ? _a2 : fromBase643, base64Encoder: (_b2 = config === null || config === void 0 ? void 0 : config.base64Encoder) !== null && _b2 !== void 0 ? _b2 : toBase643, bodyLengthChecker: (_c = config === null || config === void 0 ? void 0 : config.bodyLengthChecker) !== null && _c !== void 0 ? _c : calculateBodyLength3, credentialDefaultProvider: (_d = config === null || config === void 0 ? void 0 : config.credentialDefaultProvider) !== null && _d !== void 0 ? _d : function(_2) {
    return function() {
      return Promise.reject(new Error("Credential is missing"));
    };
  }, defaultUserAgentProvider: (_e = config === null || config === void 0 ? void 0 : config.defaultUserAgentProvider) !== null && _e !== void 0 ? _e : defaultUserAgent7({ serviceId: clientSharedValues.serviceId, clientVersion: package_default7.version }), maxAttempts: (_f = config === null || config === void 0 ? void 0 : config.maxAttempts) !== null && _f !== void 0 ? _f : DEFAULT_MAX_ATTEMPTS3, region: (_g = config === null || config === void 0 ? void 0 : config.region) !== null && _g !== void 0 ? _g : invalidProvider3("Region is missing"), requestHandler: (_h = config === null || config === void 0 ? void 0 : config.requestHandler) !== null && _h !== void 0 ? _h : new FetchHttpHandler3(defaultConfigProvider), retryMode: (_j = config === null || config === void 0 ? void 0 : config.retryMode) !== null && _j !== void 0 ? _j : function() {
    return __awaiter3(void 0, void 0, void 0, function() {
      return __generator3(this, function(_a3) {
        switch (_a3.label) {
          case 0:
            return [4, defaultConfigProvider()];
          case 1:
            return [2, _a3.sent().retryMode || DEFAULT_RETRY_MODE3];
        }
      });
    });
  }, sha256: (_k = config === null || config === void 0 ? void 0 : config.sha256) !== null && _k !== void 0 ? _k : import_sha256_browser7.Sha256, streamCollector: (_l = config === null || config === void 0 ? void 0 : config.streamCollector) !== null && _l !== void 0 ? _l : streamCollector3, useDualstackEndpoint: (_m = config === null || config === void 0 ? void 0 : config.useDualstackEndpoint) !== null && _m !== void 0 ? _m : function() {
    return Promise.resolve(DEFAULT_USE_DUALSTACK_ENDPOINT2);
  }, useFipsEndpoint: (_o = config === null || config === void 0 ? void 0 : config.useFipsEndpoint) !== null && _o !== void 0 ? _o : function() {
    return Promise.resolve(DEFAULT_USE_FIPS_ENDPOINT2);
  }, utf8Decoder: (_p = config === null || config === void 0 ? void 0 : config.utf8Decoder) !== null && _p !== void 0 ? _p : fromUtf830, utf8Encoder: (_q = config === null || config === void 0 ? void 0 : config.utf8Encoder) !== null && _q !== void 0 ? _q : toUtf828 });
};

// node_modules/@aws-sdk/client-location/dist-es/LocationClient.js
var LocationClient = function(_super) {
  __extends3(LocationClient2, _super);
  function LocationClient2(configuration) {
    var _this = this;
    var _config_0 = getRuntimeConfig4(configuration);
    var _config_1 = resolveRegionConfig3(_config_0);
    var _config_2 = resolveEndpointsConfig3(_config_1);
    var _config_3 = resolveRetryConfig3(_config_2);
    var _config_4 = resolveHostHeaderConfig7(_config_3);
    var _config_5 = resolveAwsAuthConfig7(_config_4);
    var _config_6 = resolveUserAgentConfig7(_config_5);
    _this = _super.call(this, _config_6) || this;
    _this.config = _config_6;
    _this.middlewareStack.use(getRetryPlugin3(_this.config));
    _this.middlewareStack.use(getContentLengthPlugin3(_this.config));
    _this.middlewareStack.use(getHostHeaderPlugin7(_this.config));
    _this.middlewareStack.use(getLoggerPlugin7(_this.config));
    _this.middlewareStack.use(getRecursionDetectionPlugin2(_this.config));
    _this.middlewareStack.use(getAwsAuthPlugin7(_this.config));
    _this.middlewareStack.use(getUserAgentPlugin7(_this.config));
    return _this;
  }
  LocationClient2.prototype.destroy = function() {
    _super.prototype.destroy.call(this);
  };
  return LocationClient2;
}(Client4);

// node_modules/@turf/helpers/dist/es/index.js
var earthRadius = 63710088e-1;
var factors = {
  centimeters: earthRadius * 100,
  centimetres: earthRadius * 100,
  degrees: earthRadius / 111325,
  feet: earthRadius * 3.28084,
  inches: earthRadius * 39.37,
  kilometers: earthRadius / 1e3,
  kilometres: earthRadius / 1e3,
  meters: earthRadius,
  metres: earthRadius,
  miles: earthRadius / 1609.344,
  millimeters: earthRadius * 1e3,
  millimetres: earthRadius * 1e3,
  nauticalmiles: earthRadius / 1852,
  radians: 1,
  yards: earthRadius * 1.0936
};
var unitsFactors = {
  centimeters: 100,
  centimetres: 100,
  degrees: 1 / 111325,
  feet: 3.28084,
  inches: 39.37,
  kilometers: 1 / 1e3,
  kilometres: 1 / 1e3,
  meters: 1,
  metres: 1,
  miles: 1 / 1609.344,
  millimeters: 1e3,
  millimetres: 1e3,
  nauticalmiles: 1 / 1852,
  radians: 1 / earthRadius,
  yards: 1.0936133
};

// node_modules/@turf/invariant/dist/es/index.js
function getCoords(coords) {
  if (Array.isArray(coords)) {
    return coords;
  }
  if (coords.type === "Feature") {
    if (coords.geometry !== null) {
      return coords.geometry.coordinates;
    }
  } else {
    if (coords.coordinates) {
      return coords.coordinates;
    }
  }
  throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}

// node_modules/@turf/boolean-clockwise/dist/es/index.js
function booleanClockwise(line) {
  var ring = getCoords(line);
  var sum = 0;
  var i2 = 1;
  var prev;
  var cur;
  while (i2 < ring.length) {
    prev = cur || ring[0];
    cur = ring[i2];
    sum += (cur[0] - prev[0]) * (cur[1] + prev[1]);
    i2++;
  }
  return sum > 0;
}

// node_modules/@aws-amplify/geo/lib-esm/util.js
function validateCoordinates(lng, lat) {
  if (!Number.isFinite(lng) || !Number.isFinite(lat)) {
    throw new Error("Invalid coordinates: [" + lng + "," + lat + "]");
  }
  if (lat < -90 || 90 < lat) {
    throw new Error("Latitude must be between -90 and 90 degrees inclusive.");
  } else if (lng < -180 || 180 < lng) {
    throw new Error("Longitude must be between -180 and 180 degrees inclusive.");
  }
}
function validateGeofenceId(geofenceId) {
  var geofenceIdRegex = /^[-._\p{L}\p{N}]+$/iu;
  if (!geofenceIdRegex.test(geofenceId)) {
    throw new Error("Invalid geofenceId: '" + geofenceId + "' - IDs can only contain alphanumeric characters, hyphens, underscores and periods.");
  }
}
function validateLinearRing(linearRing, geofenceId) {
  var errorPrefix = geofenceId ? geofenceId + ": " : "";
  if (linearRing.length < 4) {
    throw new Error(errorPrefix + "LinearRing must contain 4 or more coordinates.");
  }
  var badCoordinates = [];
  linearRing.forEach(function(coordinates) {
    try {
      validateCoordinates(coordinates[0], coordinates[1]);
    } catch (error) {
      badCoordinates.push({ coordinates, error: error.message });
    }
  });
  if (badCoordinates.length > 0) {
    throw new Error(errorPrefix + "One or more of the coordinates in the Polygon LinearRing are not valid: " + JSON.stringify(badCoordinates));
  }
  var _a2 = __read37(linearRing[0], 2), lngA = _a2[0], latA = _a2[1];
  var _b2 = __read37(linearRing[linearRing.length - 1], 2), lngB = _b2[0], latB = _b2[1];
  if (lngA !== lngB || latA !== latB) {
    throw new Error(errorPrefix + "LinearRing's first and last coordinates are not the same");
  }
  if (booleanClockwise(linearRing)) {
    throw new Error(errorPrefix + "LinearRing coordinates must be wound counterclockwise");
  }
}
function validatePolygon(polygon, geofenceId) {
  var errorPrefix = geofenceId ? geofenceId + ": " : "";
  if (!Array.isArray(polygon)) {
    throw new Error(errorPrefix + "Polygon is of incorrect structure. It should be an array of LinearRings");
  }
  if (polygon.length < 1) {
    throw new Error(errorPrefix + "Polygon must have a single LinearRing array.");
  }
  if (polygon.length > 1) {
    throw new Error(errorPrefix + "Polygon must have a single LinearRing array. Note: We do not currently support polygons with holes, multipolygons, polygons that are wound clockwise, or that cross the antimeridian.");
  }
  var verticesCount = polygon.reduce(function(prev, linearRing) {
    return prev + linearRing.length;
  }, 0);
  if (verticesCount > 1e3) {
    throw new Error(errorPrefix + "Polygon has more than the maximum 1000 vertices.");
  }
  polygon.forEach(function(linearRing) {
    validateLinearRing(linearRing, geofenceId);
  });
}
function validateGeofencesInput(geofences) {
  var geofenceIds = {};
  geofences.forEach(function(geofence) {
    if (!geofence.geofenceId) {
      throw new Error("Geofence '" + geofence + "' is missing geofenceId");
    }
    var geofenceId = geofence.geofenceId;
    validateGeofenceId(geofenceId);
    if (geofenceIds[geofenceId]) {
      throw new Error("Duplicate geofenceId: " + geofenceId);
    } else {
      geofenceIds[geofenceId] = true;
    }
    if (!geofence.geometry) {
      throw new Error("Geofence '" + geofenceId + "' is missing geometry");
    }
    var geometry = geofence.geometry;
    if (!geometry.polygon) {
      throw new Error("Geofence '" + geofenceId + "' is missing geometry.polygon");
    }
    var polygon = geometry.polygon;
    try {
      validatePolygon(polygon, geofenceId);
    } catch (error) {
      if (error.message.includes("Polygon has more than the maximum 1000 vertices.")) {
        throw new Error("Geofence '" + geofenceId + "' has more than the maximum of 1000 vertices");
      }
    }
    var _a2 = __read37(polygon, 1), linearRing = _a2[0];
    validateLinearRing(linearRing, geofenceId);
  });
}
function mapSearchOptions(options, locationServiceInput) {
  var locationServiceModifiedInput = __assign46({}, locationServiceInput);
  locationServiceModifiedInput.FilterCountries = options.countries;
  locationServiceModifiedInput.MaxResults = options.maxResults;
  if (options.searchIndexName) {
    locationServiceModifiedInput.IndexName = options.searchIndexName;
  }
  if (options["biasPosition"] && options["searchAreaConstraints"]) {
    throw new Error("BiasPosition and SearchAreaConstraints are mutually exclusive, please remove one or the other from the options object");
  }
  if (options["biasPosition"]) {
    locationServiceModifiedInput.BiasPosition = options["biasPosition"];
  }
  if (options["searchAreaConstraints"]) {
    locationServiceModifiedInput.FilterBBox = options["searchAreaConstraints"];
  }
  return locationServiceModifiedInput;
}

// node_modules/@aws-amplify/geo/lib-esm/Providers/AmazonLocationServiceProvider.js
var logger62 = new ConsoleLogger("AmazonLocationServiceProvider");
var AmazonLocationServiceProvider = (
  /** @class */
  function() {
    function AmazonLocationServiceProvider2(config) {
      this._config = config ? config : {};
      logger62.debug("Geo Options", this._config);
    }
    AmazonLocationServiceProvider2.prototype.getCategory = function() {
      return AmazonLocationServiceProvider2.CATEGORY;
    };
    AmazonLocationServiceProvider2.prototype.getProviderName = function() {
      return AmazonLocationServiceProvider2.PROVIDER_NAME;
    };
    AmazonLocationServiceProvider2.prototype.configure = function(config) {
      logger62.debug("configure Amazon Location Service Provider", config);
      if (!config)
        return this._config;
      this._config = Object.assign({}, this._config, config);
      return this._config;
    };
    AmazonLocationServiceProvider2.prototype.getAvailableMaps = function() {
      this._verifyMapResources();
      var mapStyles = [];
      var availableMaps = this._config.maps.items;
      var region = this._config.region;
      for (var mapName in availableMaps) {
        var style = availableMaps[mapName].style;
        mapStyles.push({ mapName, style, region });
      }
      return mapStyles;
    };
    AmazonLocationServiceProvider2.prototype.getDefaultMap = function() {
      this._verifyMapResources();
      var mapName = this._config.maps.default;
      var style = this._config.maps.items[mapName].style;
      var region = this._config.region;
      return { mapName, style, region };
    };
    AmazonLocationServiceProvider2.prototype.searchByText = function(text, options) {
      return __awaiter69(this, void 0, void 0, function() {
        var credentialsOK, locationServiceInput, client, command, response, error_1, PascalResults, results;
        return __generator70(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this._ensureCredentials()];
            case 1:
              credentialsOK = _a2.sent();
              if (!credentialsOK) {
                throw new Error("No credentials");
              }
              this._verifySearchIndex(options === null || options === void 0 ? void 0 : options.searchIndexName);
              locationServiceInput = {
                Text: text,
                IndexName: this._config.search_indices.default
              };
              if (options) {
                locationServiceInput = __assign46(__assign46({}, locationServiceInput), mapSearchOptions(options, locationServiceInput));
              }
              client = new LocationClient({
                credentials: this._config.credentials,
                region: this._config.region,
                customUserAgent: getAmplifyUserAgentObject()
              });
              command = new SearchPlaceIndexForTextCommand(locationServiceInput);
              _a2.label = 2;
            case 2:
              _a2.trys.push([2, 4, , 5]);
              return [4, client.send(command)];
            case 3:
              response = _a2.sent();
              return [3, 5];
            case 4:
              error_1 = _a2.sent();
              logger62.debug(error_1);
              throw error_1;
            case 5:
              PascalResults = response.Results.map(function(result) {
                return result.Place;
              });
              results = (0, import_camelcase_keys.default)(PascalResults, {
                deep: true
              });
              return [2, results];
          }
        });
      });
    };
    AmazonLocationServiceProvider2.prototype.searchForSuggestions = function(text, options) {
      return __awaiter69(this, void 0, void 0, function() {
        var credentialsOK, locationServiceInput, client, command, response, error_2, results;
        return __generator70(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this._ensureCredentials()];
            case 1:
              credentialsOK = _a2.sent();
              if (!credentialsOK) {
                throw new Error("No credentials");
              }
              this._verifySearchIndex(options === null || options === void 0 ? void 0 : options.searchIndexName);
              locationServiceInput = {
                Text: text,
                IndexName: this._config.search_indices.default
              };
              if (options) {
                locationServiceInput = __assign46(__assign46({}, locationServiceInput), mapSearchOptions(options, locationServiceInput));
              }
              client = new LocationClient({
                credentials: this._config.credentials,
                region: this._config.region,
                customUserAgent: getAmplifyUserAgentObject()
              });
              command = new SearchPlaceIndexForSuggestionsCommand(locationServiceInput);
              _a2.label = 2;
            case 2:
              _a2.trys.push([2, 4, , 5]);
              return [4, client.send(command)];
            case 3:
              response = _a2.sent();
              return [3, 5];
            case 4:
              error_2 = _a2.sent();
              logger62.debug(error_2);
              throw error_2;
            case 5:
              results = response.Results.map(function(result) {
                return {
                  text: result.Text,
                  placeId: result.PlaceId
                };
              });
              return [2, results];
          }
        });
      });
    };
    AmazonLocationServiceProvider2.prototype._verifyPlaceId = function(placeId) {
      if (placeId.length === 0) {
        var errorString = "PlaceId cannot be an empty string.";
        logger62.debug(errorString);
        throw new Error(errorString);
      }
    };
    AmazonLocationServiceProvider2.prototype.searchByPlaceId = function(placeId, options) {
      return __awaiter69(this, void 0, void 0, function() {
        var credentialsOK, client, searchByPlaceIdInput, command, response, error_3, place;
        return __generator70(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this._ensureCredentials()];
            case 1:
              credentialsOK = _a2.sent();
              if (!credentialsOK) {
                throw new Error("No credentials");
              }
              this._verifySearchIndex(options === null || options === void 0 ? void 0 : options.searchIndexName);
              this._verifyPlaceId(placeId);
              client = new LocationClient({
                credentials: this._config.credentials,
                region: this._config.region,
                customUserAgent: getAmplifyUserAgentObject()
              });
              searchByPlaceIdInput = {
                PlaceId: placeId,
                IndexName: (options === null || options === void 0 ? void 0 : options.searchIndexName) || this._config.search_indices.default
              };
              command = new GetPlaceCommand(searchByPlaceIdInput);
              _a2.label = 2;
            case 2:
              _a2.trys.push([2, 4, , 5]);
              return [4, client.send(command)];
            case 3:
              response = _a2.sent();
              return [3, 5];
            case 4:
              error_3 = _a2.sent();
              logger62.debug(error_3);
              throw error_3;
            case 5:
              place = response.Place;
              if (place) {
                return [2, (0, import_camelcase_keys.default)(place, { deep: true })];
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AmazonLocationServiceProvider2.prototype.searchByCoordinates = function(coordinates, options) {
      return __awaiter69(this, void 0, void 0, function() {
        var credentialsOK, locationServiceInput, client, command, response, error_4, PascalResults, results;
        return __generator70(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this._ensureCredentials()];
            case 1:
              credentialsOK = _a2.sent();
              if (!credentialsOK) {
                throw new Error("No credentials");
              }
              this._verifySearchIndex(options === null || options === void 0 ? void 0 : options.searchIndexName);
              locationServiceInput = {
                Position: coordinates,
                IndexName: this._config.search_indices.default
              };
              if (options) {
                if (options.searchIndexName) {
                  locationServiceInput.IndexName = options.searchIndexName;
                }
                locationServiceInput.MaxResults = options.maxResults;
              }
              client = new LocationClient({
                credentials: this._config.credentials,
                region: this._config.region,
                customUserAgent: getAmplifyUserAgentObject()
              });
              command = new SearchPlaceIndexForPositionCommand(locationServiceInput);
              _a2.label = 2;
            case 2:
              _a2.trys.push([2, 4, , 5]);
              return [4, client.send(command)];
            case 3:
              response = _a2.sent();
              return [3, 5];
            case 4:
              error_4 = _a2.sent();
              logger62.debug(error_4);
              throw error_4;
            case 5:
              PascalResults = response.Results.map(function(result) {
                return result.Place;
              });
              results = (0, import_camelcase_keys.default)(PascalResults[0], {
                deep: true
              });
              return [2, results];
          }
        });
      });
    };
    AmazonLocationServiceProvider2.prototype.saveGeofences = function(geofences, options) {
      return __awaiter69(this, void 0, void 0, function() {
        var credentialsOK, PascalGeofences, results, geofenceBatches, apiLimit;
        var _this = this;
        return __generator70(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (geofences.length < 1) {
                throw new Error("Geofence input array is empty");
              }
              return [4, this._ensureCredentials()];
            case 1:
              credentialsOK = _a2.sent();
              if (!credentialsOK) {
                throw new Error("No credentials");
              }
              try {
                this._verifyGeofenceCollections(options === null || options === void 0 ? void 0 : options.collectionName);
              } catch (error) {
                logger62.debug(error);
                throw error;
              }
              validateGeofencesInput(geofences);
              PascalGeofences = geofences.map(function(_a3) {
                var geofenceId = _a3.geofenceId, polygon = _a3.geometry.polygon;
                return {
                  GeofenceId: geofenceId,
                  Geometry: {
                    Polygon: polygon
                  }
                };
              });
              results = {
                successes: [],
                errors: []
              };
              geofenceBatches = [];
              while (PascalGeofences.length > 0) {
                apiLimit = 10;
                geofenceBatches.push(PascalGeofences.splice(0, apiLimit));
              }
              return [4, Promise.all(geofenceBatches.map(function(batch) {
                return __awaiter69(_this, void 0, void 0, function() {
                  var response, error_5;
                  return __generator70(this, function(_a3) {
                    switch (_a3.label) {
                      case 0:
                        _a3.trys.push([0, 2, , 3]);
                        return [4, this._AmazonLocationServiceBatchPutGeofenceCall(batch, (options === null || options === void 0 ? void 0 : options.collectionName) || this._config.geofenceCollections.default)];
                      case 1:
                        response = _a3.sent();
                        return [3, 3];
                      case 2:
                        error_5 = _a3.sent();
                        batch.forEach(function(geofence) {
                          results.errors.push({
                            geofenceId: geofence.GeofenceId,
                            error: {
                              code: "APIConnectionError",
                              message: error_5.message
                            }
                          });
                        });
                        return [
                          2
                          /*return*/
                        ];
                      case 3:
                        response.Successes.forEach(function(success) {
                          var GeofenceId = success.GeofenceId, CreateTime = success.CreateTime, UpdateTime = success.UpdateTime;
                          results.successes.push({
                            geofenceId: GeofenceId,
                            createTime: CreateTime,
                            updateTime: UpdateTime
                          });
                        });
                        response.Errors.forEach(function(error) {
                          var _a4 = error.Error, Code = _a4.Code, Message = _a4.Message, GeofenceId = error.GeofenceId;
                          results.errors.push({
                            error: {
                              code: Code,
                              message: Message
                            },
                            geofenceId: GeofenceId
                          });
                        });
                        return [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }))];
            case 2:
              _a2.sent();
              return [2, results];
          }
        });
      });
    };
    AmazonLocationServiceProvider2.prototype.getGeofence = function(geofenceId, options) {
      return __awaiter69(this, void 0, void 0, function() {
        var credentialsOK, client, commandInput, command, response, error_6, GeofenceId, CreateTime, UpdateTime, Status, Geometry, geofence;
        return __generator70(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this._ensureCredentials()];
            case 1:
              credentialsOK = _a2.sent();
              if (!credentialsOK) {
                throw new Error("No credentials");
              }
              try {
                this._verifyGeofenceCollections(options === null || options === void 0 ? void 0 : options.collectionName);
              } catch (error) {
                logger62.debug(error);
                throw error;
              }
              validateGeofenceId(geofenceId);
              client = new LocationClient({
                credentials: this._config.credentials,
                region: this._config.region,
                customUserAgent: getAmplifyUserAgentObject()
              });
              commandInput = {
                GeofenceId: geofenceId,
                CollectionName: (options === null || options === void 0 ? void 0 : options.collectionName) || this._config.geofenceCollections.default
              };
              command = new GetGeofenceCommand(commandInput);
              _a2.label = 2;
            case 2:
              _a2.trys.push([2, 4, , 5]);
              return [4, client.send(command)];
            case 3:
              response = _a2.sent();
              return [3, 5];
            case 4:
              error_6 = _a2.sent();
              logger62.debug(error_6);
              throw error_6;
            case 5:
              GeofenceId = response.GeofenceId, CreateTime = response.CreateTime, UpdateTime = response.UpdateTime, Status = response.Status, Geometry = response.Geometry;
              geofence = {
                createTime: CreateTime,
                geofenceId: GeofenceId,
                geometry: {
                  polygon: Geometry.Polygon
                },
                status: Status,
                updateTime: UpdateTime
              };
              return [2, geofence];
          }
        });
      });
    };
    AmazonLocationServiceProvider2.prototype.listGeofences = function(options) {
      return __awaiter69(this, void 0, void 0, function() {
        var credentialsOK, client, listGeofencesInput, command, response, error_7, NextToken, Entries, results;
        return __generator70(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, this._ensureCredentials()];
            case 1:
              credentialsOK = _a2.sent();
              if (!credentialsOK) {
                throw new Error("No credentials");
              }
              try {
                this._verifyGeofenceCollections(options === null || options === void 0 ? void 0 : options.collectionName);
              } catch (error) {
                logger62.debug(error);
                throw error;
              }
              client = new LocationClient({
                credentials: this._config.credentials,
                region: this._config.region,
                customUserAgent: getAmplifyUserAgentObject()
              });
              listGeofencesInput = {
                NextToken: options === null || options === void 0 ? void 0 : options.nextToken,
                CollectionName: (options === null || options === void 0 ? void 0 : options.collectionName) || this._config.geofenceCollections.default
              };
              command = new ListGeofencesCommand(listGeofencesInput);
              _a2.label = 2;
            case 2:
              _a2.trys.push([2, 4, , 5]);
              return [4, client.send(command)];
            case 3:
              response = _a2.sent();
              return [3, 5];
            case 4:
              error_7 = _a2.sent();
              logger62.debug(error_7);
              throw error_7;
            case 5:
              NextToken = response.NextToken, Entries = response.Entries;
              results = {
                entries: Entries.map(function(_a3) {
                  var GeofenceId = _a3.GeofenceId, CreateTime = _a3.CreateTime, UpdateTime = _a3.UpdateTime, Status = _a3.Status, Polygon = _a3.Geometry.Polygon;
                  return {
                    geofenceId: GeofenceId,
                    createTime: CreateTime,
                    updateTime: UpdateTime,
                    status: Status,
                    geometry: {
                      polygon: Polygon
                    }
                  };
                }),
                nextToken: NextToken
              };
              return [2, results];
          }
        });
      });
    };
    AmazonLocationServiceProvider2.prototype.deleteGeofences = function(geofenceIds, options) {
      return __awaiter69(this, void 0, void 0, function() {
        var credentialsOK, badGeofenceIds, results, geofenceIdBatches, count;
        var _this = this;
        return __generator70(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (geofenceIds.length < 1) {
                throw new Error("GeofenceId input array is empty");
              }
              return [4, this._ensureCredentials()];
            case 1:
              credentialsOK = _a2.sent();
              if (!credentialsOK) {
                throw new Error("No credentials");
              }
              this._verifyGeofenceCollections(options === null || options === void 0 ? void 0 : options.collectionName);
              badGeofenceIds = geofenceIds.filter(function(geofenceId) {
                try {
                  validateGeofenceId(geofenceId);
                } catch (error) {
                  return true;
                }
              });
              if (badGeofenceIds.length > 0) {
                throw new Error("Invalid geofence ids: " + badGeofenceIds.join(", "));
              }
              results = {
                successes: [],
                errors: []
              };
              geofenceIdBatches = [];
              count = 0;
              while (count < geofenceIds.length) {
                geofenceIdBatches.push(geofenceIds.slice(count, count += 10));
              }
              return [4, Promise.all(geofenceIdBatches.map(function(batch) {
                return __awaiter69(_this, void 0, void 0, function() {
                  var response, error_8, badGeofenceIds2;
                  var _a3;
                  return __generator70(this, function(_b2) {
                    switch (_b2.label) {
                      case 0:
                        _b2.trys.push([0, 2, , 3]);
                        return [4, this._AmazonLocationServiceBatchDeleteGeofenceCall(batch, (options === null || options === void 0 ? void 0 : options.collectionName) || this._config.geofenceCollections.default)];
                      case 1:
                        response = _b2.sent();
                        return [3, 3];
                      case 2:
                        error_8 = _b2.sent();
                        batch.forEach(function(geofenceId) {
                          var errorObject = {
                            geofenceId,
                            error: {
                              code: error_8.message,
                              message: error_8.message
                            }
                          };
                          results.errors.push(errorObject);
                        });
                        return [
                          2
                          /*return*/
                        ];
                      case 3:
                        badGeofenceIds2 = response.Errors.map(function(_a4) {
                          var geofenceId = _a4.geofenceId;
                          return geofenceId;
                        });
                        (_a3 = results.successes).push.apply(_a3, __spread15(batch.filter(function(Id) {
                          return !badGeofenceIds2.includes(Id);
                        })));
                        return [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }))];
            case 2:
              _a2.sent();
              return [2, results];
          }
        });
      });
    };
    AmazonLocationServiceProvider2.prototype._ensureCredentials = function() {
      return __awaiter69(this, void 0, void 0, function() {
        var credentials, cred, error_9;
        return __generator70(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              _a2.trys.push([0, 2, , 3]);
              return [4, Credentials.get()];
            case 1:
              credentials = _a2.sent();
              if (!credentials)
                return [2, false];
              cred = Credentials.shear(credentials);
              logger62.debug("Set credentials for storage. Credentials are:", cred);
              this._config.credentials = cred;
              return [2, true];
            case 2:
              error_9 = _a2.sent();
              logger62.debug("Ensure credentials error. Credentials are:", error_9);
              return [2, false];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    AmazonLocationServiceProvider2.prototype._verifyMapResources = function() {
      if (!this._config.maps) {
        var errorString = "No map resources found in amplify config, run 'amplify add geo' to create one and run `amplify push` after";
        logger62.debug(errorString);
        throw new Error(errorString);
      }
      if (!this._config.maps.default) {
        var errorString = "No default map resource found in amplify config, run 'amplify add geo' to create one and run `amplify push` after";
        logger62.debug(errorString);
        throw new Error(errorString);
      }
    };
    AmazonLocationServiceProvider2.prototype._verifySearchIndex = function(optionalSearchIndex) {
      if ((!this._config.search_indices || !this._config.search_indices.default) && !optionalSearchIndex) {
        var errorString = "No Search Index found in amplify config, please run `amplify add geo` to create one and run `amplify push` after.";
        logger62.debug(errorString);
        throw new Error(errorString);
      }
    };
    AmazonLocationServiceProvider2.prototype._verifyGeofenceCollections = function(optionalGeofenceCollectionName) {
      if ((!this._config.geofenceCollections || !this._config.geofenceCollections.default) && !optionalGeofenceCollectionName) {
        var errorString = "No Geofence Collections found, please run `amplify add geo` to create one and run `amplify push` after.";
        logger62.debug(errorString);
        throw new Error(errorString);
      }
    };
    AmazonLocationServiceProvider2.prototype._AmazonLocationServiceBatchPutGeofenceCall = function(PascalGeofences, collectionName) {
      return __awaiter69(this, void 0, void 0, function() {
        var geofenceInput, client, command, response, error_10;
        return __generator70(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              geofenceInput = {
                Entries: PascalGeofences,
                CollectionName: collectionName || this._config.geofenceCollections.default
              };
              client = new LocationClient({
                credentials: this._config.credentials,
                region: this._config.region,
                customUserAgent: getAmplifyUserAgentObject()
              });
              command = new BatchPutGeofenceCommand(geofenceInput);
              _a2.label = 1;
            case 1:
              _a2.trys.push([1, 3, , 4]);
              return [4, client.send(command)];
            case 2:
              response = _a2.sent();
              return [3, 4];
            case 3:
              error_10 = _a2.sent();
              throw error_10;
            case 4:
              return [2, response];
          }
        });
      });
    };
    AmazonLocationServiceProvider2.prototype._AmazonLocationServiceBatchDeleteGeofenceCall = function(geofenceIds, collectionName) {
      return __awaiter69(this, void 0, void 0, function() {
        var deleteGeofencesInput, client, command, response, error_11;
        return __generator70(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              deleteGeofencesInput = {
                GeofenceIds: geofenceIds,
                CollectionName: collectionName || this._config.geofenceCollections.default
              };
              client = new LocationClient({
                credentials: this._config.credentials,
                region: this._config.region,
                customUserAgent: getAmplifyUserAgentObject()
              });
              command = new BatchDeleteGeofenceCommand(deleteGeofencesInput);
              _a2.label = 1;
            case 1:
              _a2.trys.push([1, 3, , 4]);
              return [4, client.send(command)];
            case 2:
              response = _a2.sent();
              return [3, 4];
            case 3:
              error_11 = _a2.sent();
              throw error_11;
            case 4:
              return [2, response];
          }
        });
      });
    };
    AmazonLocationServiceProvider2.CATEGORY = "Geo";
    AmazonLocationServiceProvider2.PROVIDER_NAME = "AmazonLocationService";
    return AmazonLocationServiceProvider2;
  }()
);

// node_modules/@aws-amplify/geo/lib-esm/Geo.js
var logger63 = new ConsoleLogger("Geo");
var DEFAULT_PROVIDER2 = "AmazonLocationService";
var GeoClass = (
  /** @class */
  function() {
    function GeoClass2() {
      this._config = {};
      this._pluggables = [];
      logger63.debug("Geo Options", this._config);
    }
    GeoClass2.prototype.getModuleName = function() {
      return GeoClass2.MODULE;
    };
    GeoClass2.prototype.addPluggable = function(pluggable) {
      if (pluggable && pluggable.getCategory() === "Geo") {
        this._pluggables.push(pluggable);
        var config = pluggable.configure(this._config[pluggable.getProviderName()]);
        return config;
      }
    };
    GeoClass2.prototype.getPluggable = function(providerName) {
      var pluggable = this._pluggables.find(function(pluggable2) {
        return pluggable2.getProviderName() === providerName;
      });
      if (pluggable === void 0) {
        logger63.debug("No plugin found with providerName", providerName);
        throw new Error("No plugin found in Geo for the provider");
      } else
        return pluggable;
    };
    GeoClass2.prototype.removePluggable = function(providerName) {
      this._pluggables = this._pluggables.filter(function(pluggable) {
        return pluggable.getProviderName() !== providerName;
      });
      return;
    };
    GeoClass2.prototype.configure = function(config) {
      var _this = this;
      logger63.debug("configure Geo");
      if (!config)
        return this._config;
      var amplifyConfig = parseAWSExports(config);
      this._config = Object.assign({}, this._config, amplifyConfig.Geo, config);
      this._pluggables.forEach(function(pluggable) {
        pluggable.configure(_this._config[pluggable.getProviderName()]);
      });
      if (this._pluggables.length === 0) {
        this.addPluggable(new AmazonLocationServiceProvider());
      }
      return this._config;
    };
    GeoClass2.prototype.getAvailableMaps = function(provider) {
      if (provider === void 0) {
        provider = DEFAULT_PROVIDER2;
      }
      var prov = this.getPluggable(provider);
      return prov.getAvailableMaps();
    };
    GeoClass2.prototype.getDefaultMap = function(provider) {
      if (provider === void 0) {
        provider = DEFAULT_PROVIDER2;
      }
      var prov = this.getPluggable(provider);
      return prov.getDefaultMap();
    };
    GeoClass2.prototype.searchByText = function(text, options) {
      return __awaiter69(this, void 0, void 0, function() {
        var _a2, providerName, prov, error_1;
        return __generator70(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              _a2 = (options || {}).providerName, providerName = _a2 === void 0 ? DEFAULT_PROVIDER2 : _a2;
              prov = this.getPluggable(providerName);
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 3, , 4]);
              return [4, prov.searchByText(text, options)];
            case 2:
              return [2, _b2.sent()];
            case 3:
              error_1 = _b2.sent();
              logger63.debug(error_1);
              throw error_1;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    GeoClass2.prototype.searchForSuggestions = function(text, options) {
      return __awaiter69(this, void 0, void 0, function() {
        var _a2, providerName, prov, error_2;
        return __generator70(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              _a2 = (options || {}).providerName, providerName = _a2 === void 0 ? DEFAULT_PROVIDER2 : _a2;
              prov = this.getPluggable(providerName);
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 3, , 4]);
              return [4, prov.searchForSuggestions(text, options)];
            case 2:
              return [2, _b2.sent()];
            case 3:
              error_2 = _b2.sent();
              logger63.debug(error_2);
              throw error_2;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    GeoClass2.prototype.searchByPlaceId = function(placeId, options) {
      return __awaiter69(this, void 0, void 0, function() {
        var providerName, prov, error_3;
        return __generator70(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              providerName = DEFAULT_PROVIDER2;
              prov = this.getPluggable(providerName);
              _a2.label = 1;
            case 1:
              _a2.trys.push([1, 3, , 4]);
              return [4, prov.searchByPlaceId(placeId, options)];
            case 2:
              return [2, _a2.sent()];
            case 3:
              error_3 = _a2.sent();
              logger63.debug(error_3);
              throw error_3;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    GeoClass2.prototype.searchByCoordinates = function(coordinates, options) {
      return __awaiter69(this, void 0, void 0, function() {
        var _a2, providerName, prov, _b2, lng, lat, error_4;
        return __generator70(this, function(_c) {
          switch (_c.label) {
            case 0:
              _a2 = (options || {}).providerName, providerName = _a2 === void 0 ? DEFAULT_PROVIDER2 : _a2;
              prov = this.getPluggable(providerName);
              _b2 = __read37(coordinates, 2), lng = _b2[0], lat = _b2[1];
              _c.label = 1;
            case 1:
              _c.trys.push([1, 3, , 4]);
              validateCoordinates(lng, lat);
              return [4, prov.searchByCoordinates(coordinates, options)];
            case 2:
              return [2, _c.sent()];
            case 3:
              error_4 = _c.sent();
              logger63.debug(error_4);
              throw error_4;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    GeoClass2.prototype.saveGeofences = function(geofences, options) {
      return __awaiter69(this, void 0, void 0, function() {
        var _a2, providerName, prov, geofenceInputArray, error_5;
        return __generator70(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              _a2 = (options || {}).providerName, providerName = _a2 === void 0 ? DEFAULT_PROVIDER2 : _a2;
              prov = this.getPluggable(providerName);
              if (!Array.isArray(geofences)) {
                geofenceInputArray = [geofences];
              } else {
                geofenceInputArray = geofences;
              }
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 3, , 4]);
              return [4, prov.saveGeofences(geofenceInputArray, options)];
            case 2:
              return [2, _b2.sent()];
            case 3:
              error_5 = _b2.sent();
              logger63.debug(error_5);
              throw error_5;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    GeoClass2.prototype.getGeofence = function(geofenceId, options) {
      return __awaiter69(this, void 0, void 0, function() {
        var _a2, providerName, prov, error_6;
        return __generator70(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              _a2 = (options || {}).providerName, providerName = _a2 === void 0 ? DEFAULT_PROVIDER2 : _a2;
              prov = this.getPluggable(providerName);
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 3, , 4]);
              return [4, prov.getGeofence(geofenceId, options)];
            case 2:
              return [2, _b2.sent()];
            case 3:
              error_6 = _b2.sent();
              logger63.debug(error_6);
              throw error_6;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    GeoClass2.prototype.listGeofences = function(options) {
      return __awaiter69(this, void 0, void 0, function() {
        var _a2, providerName, prov, error_7;
        return __generator70(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              _a2 = (options || {}).providerName, providerName = _a2 === void 0 ? DEFAULT_PROVIDER2 : _a2;
              prov = this.getPluggable(providerName);
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 3, , 4]);
              return [4, prov.listGeofences(options)];
            case 2:
              return [2, _b2.sent()];
            case 3:
              error_7 = _b2.sent();
              logger63.debug(error_7);
              throw error_7;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    GeoClass2.prototype.deleteGeofences = function(geofenceIds, options) {
      return __awaiter69(this, void 0, void 0, function() {
        var _a2, providerName, prov, geofenceIdsInputArray, error_8;
        return __generator70(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              _a2 = (options || {}).providerName, providerName = _a2 === void 0 ? DEFAULT_PROVIDER2 : _a2;
              prov = this.getPluggable(providerName);
              if (!Array.isArray(geofenceIds)) {
                geofenceIdsInputArray = [geofenceIds];
              } else {
                geofenceIdsInputArray = geofenceIds;
              }
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 3, , 4]);
              return [4, prov.deleteGeofences(geofenceIdsInputArray, options)];
            case 2:
              return [2, _b2.sent()];
            case 3:
              error_8 = _b2.sent();
              logger63.debug(error_8);
              throw error_8;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    GeoClass2.MODULE = "Geo";
    return GeoClass2;
  }()
);
var Geo = new GeoClass();
Amplify.register(Geo);

export {
  ConsoleLogger,
  Amplify,
  ClientDevice,
  Hub,
  I18n2 as I18n,
  dist_es_exports,
  init_dist_es,
  Signer,
  __values4 as __values,
  __read10 as __read,
  dist_es_exports2,
  init_dist_es2,
  bowser_default,
  AWSCloudWatchProvider,
  ServiceWorkerClass,
  BrowserStorageCache,
  AWSPinpointProvider,
  Analytics,
  AWSKinesisProvider,
  AWSKinesisFirehoseProvider,
  AmazonPersonalizeProvider,
  require_build27 as require_build,
  require_build28 as require_build2,
  Auth,
  Storage,
  StorageInstance,
  APIClass,
  API,
  graphqlOperation,
  Predicates,
  SortDirection,
  AuthModeStrategyType,
  syncExpression,
  PubSub,
  instance,
  v4_default,
  Interactions,
  Notifications_default,
  Predictions,
  withSSRContext,
  Geo
};
/*! Bundled license information:

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

cookie/index.js:
  (*!
   * cookie
   * Copyright(c) 2012-2014 Roman Shtylman
   * Copyright(c) 2015 Douglas Christopher Wilson
   * MIT Licensed
   *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

ieee754/index.js:
  (*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> *)

buffer/index.js:
  (*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <http://feross.org>
   * @license  MIT
   *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

js-cookie/src/js.cookie.js:
  (*!
   * JavaScript Cookie v2.2.1
   * https://github.com/js-cookie/js-cookie
   *
   * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
   * Released under the MIT license
   *)

punycode/punycode.js:
  (*! https://mths.be/punycode v1.3.2 by @mathias *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

@aws-amplify/core/lib-esm/Util/Mutex.js:
  (*!
   * The MIT License (MIT)
   *
   * Copyright (c) 2016 Christian Speckner <cnspeckn@googlemail.com>
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to deal
   * in the Software without restriction, including without limitation the rights
   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in
   * all copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
   * THE SOFTWARE.
   *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

bowser/src/bowser.js:
  (*!
   * Bowser - a browser detector
   * https://github.com/lancedikson/bowser
   * MIT License | (c) Dustin Diaz 2012-2015
   * MIT License | (c) Denis Demchenko 2015-2019
   *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

amazon-cognito-identity-js/es/AuthenticationDetails.js:
  (*!
   * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
   * SPDX-License-Identifier: Apache-2.0
   *)

amazon-cognito-identity-js/es/AuthenticationHelper.js:
  (*!
   * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
   * SPDX-License-Identifier: Apache-2.0
   *)

amazon-cognito-identity-js/es/CognitoJwtToken.js:
  (*!
   * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
   * SPDX-License-Identifier: Apache-2.0
   *)

amazon-cognito-identity-js/es/CognitoAccessToken.js:
  (*!
   * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
   * SPDX-License-Identifier: Apache-2.0
   *)

amazon-cognito-identity-js/es/CognitoIdToken.js:
  (*!
   * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
   * SPDX-License-Identifier: Apache-2.0
   *)

amazon-cognito-identity-js/es/CognitoRefreshToken.js:
  (*!
   * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
   * SPDX-License-Identifier: Apache-2.0
   *)

amazon-cognito-identity-js/es/Platform/index.js:
  (*!
   * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
   * SPDX-License-Identifier: Apache-2.0
   *)

amazon-cognito-identity-js/es/CognitoUserSession.js:
  (*!
   * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
   * SPDX-License-Identifier: Apache-2.0
   *)

amazon-cognito-identity-js/es/DateHelper.js:
  (*!
   * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
   * SPDX-License-Identifier: Apache-2.0
   *)

amazon-cognito-identity-js/es/CognitoUserAttribute.js:
  (*!
   * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
   * SPDX-License-Identifier: Apache-2.0
   *)

amazon-cognito-identity-js/es/StorageHelper.js:
  (*!
   * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
   * SPDX-License-Identifier: Apache-2.0
   *)

amazon-cognito-identity-js/es/CognitoUser.js:
  (*!
   * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
   * SPDX-License-Identifier: Apache-2.0
   *)

amazon-cognito-identity-js/es/CognitoUserPool.js:
  (*!
   * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
   * SPDX-License-Identifier: Apache-2.0
   *)

amazon-cognito-identity-js/es/index.js:
  (*!
   * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
   * SPDX-License-Identifier: Apache-2.0
   *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)
*/
//# sourceMappingURL=chunk-GY7KB467.js.map
